import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import type * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  bytea: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "agent_model_pricing" */
export type AgentModelPricing = {
  __typename?: 'agentModelPricing';
  cachedInputCostPerMillion: Scalars['numeric']['output'];
  createdAt: Scalars['timestamptz']['output'];
  currency: Scalars['String']['output'];
  inputCostPerMillion: Scalars['numeric']['output'];
  markupMultiplier: Scalars['numeric']['output'];
  model: Scalars['String']['output'];
  outputCostPerMillion: Scalars['numeric']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "agent_model_pricing" */
export type AgentModelPricing_Aggregate = {
  __typename?: 'agentModelPricing_aggregate';
  aggregate?: Maybe<AgentModelPricing_Aggregate_Fields>;
  nodes: Array<AgentModelPricing>;
};

/** aggregate fields of "agent_model_pricing" */
export type AgentModelPricing_Aggregate_Fields = {
  __typename?: 'agentModelPricing_aggregate_fields';
  avg?: Maybe<AgentModelPricing_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AgentModelPricing_Max_Fields>;
  min?: Maybe<AgentModelPricing_Min_Fields>;
  stddev?: Maybe<AgentModelPricing_Stddev_Fields>;
  stddev_pop?: Maybe<AgentModelPricing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AgentModelPricing_Stddev_Samp_Fields>;
  sum?: Maybe<AgentModelPricing_Sum_Fields>;
  var_pop?: Maybe<AgentModelPricing_Var_Pop_Fields>;
  var_samp?: Maybe<AgentModelPricing_Var_Samp_Fields>;
  variance?: Maybe<AgentModelPricing_Variance_Fields>;
};


/** aggregate fields of "agent_model_pricing" */
export type AgentModelPricing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AgentModelPricing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AgentModelPricing_Avg_Fields = {
  __typename?: 'agentModelPricing_avg_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  inputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  markupMultiplier?: Maybe<Scalars['Float']['output']>;
  outputCostPerMillion?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agent_model_pricing". All fields are combined with a logical 'AND'. */
export type AgentModelPricing_Bool_Exp = {
  _and?: InputMaybe<Array<AgentModelPricing_Bool_Exp>>;
  _not?: InputMaybe<AgentModelPricing_Bool_Exp>;
  _or?: InputMaybe<Array<AgentModelPricing_Bool_Exp>>;
  cachedInputCostPerMillion?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  inputCostPerMillion?: InputMaybe<Numeric_Comparison_Exp>;
  markupMultiplier?: InputMaybe<Numeric_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  outputCostPerMillion?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "agent_model_pricing" */
export enum AgentModelPricing_Constraint {
  /** unique or primary key constraint on columns "model" */
  agent_model_pricing_pkey = 'agent_model_pricing_pkey'
}

/** input type for incrementing numeric columns in table "agent_model_pricing" */
export type AgentModelPricing_Inc_Input = {
  cachedInputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  inputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  markupMultiplier?: InputMaybe<Scalars['numeric']['input']>;
  outputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "agent_model_pricing" */
export type AgentModelPricing_Insert_Input = {
  cachedInputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  inputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  markupMultiplier?: InputMaybe<Scalars['numeric']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type AgentModelPricing_Max_Fields = {
  __typename?: 'agentModelPricing_max_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  inputCostPerMillion?: Maybe<Scalars['numeric']['output']>;
  markupMultiplier?: Maybe<Scalars['numeric']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputCostPerMillion?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type AgentModelPricing_Min_Fields = {
  __typename?: 'agentModelPricing_min_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  inputCostPerMillion?: Maybe<Scalars['numeric']['output']>;
  markupMultiplier?: Maybe<Scalars['numeric']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputCostPerMillion?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "agent_model_pricing" */
export type AgentModelPricing_Mutation_Response = {
  __typename?: 'agentModelPricing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AgentModelPricing>;
};

/** on_conflict condition type for table "agent_model_pricing" */
export type AgentModelPricing_On_Conflict = {
  constraint: AgentModelPricing_Constraint;
  update_columns?: Array<AgentModelPricing_Update_Column>;
  where?: InputMaybe<AgentModelPricing_Bool_Exp>;
};

/** Ordering options when selecting data from "agent_model_pricing". */
export type AgentModelPricing_Order_By = {
  cachedInputCostPerMillion?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  inputCostPerMillion?: InputMaybe<Order_By>;
  markupMultiplier?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  outputCostPerMillion?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent_model_pricing */
export type AgentModelPricing_Pk_Columns_Input = {
  model: Scalars['String']['input'];
};

/** select columns of table "agent_model_pricing" */
export enum AgentModelPricing_Select_Column {
  /** column name */
  cachedInputCostPerMillion = 'cachedInputCostPerMillion',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  currency = 'currency',
  /** column name */
  inputCostPerMillion = 'inputCostPerMillion',
  /** column name */
  markupMultiplier = 'markupMultiplier',
  /** column name */
  model = 'model',
  /** column name */
  outputCostPerMillion = 'outputCostPerMillion',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "agent_model_pricing" */
export type AgentModelPricing_Set_Input = {
  cachedInputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  inputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  markupMultiplier?: InputMaybe<Scalars['numeric']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type AgentModelPricing_Stddev_Fields = {
  __typename?: 'agentModelPricing_stddev_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  inputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  markupMultiplier?: Maybe<Scalars['Float']['output']>;
  outputCostPerMillion?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AgentModelPricing_Stddev_Pop_Fields = {
  __typename?: 'agentModelPricing_stddev_pop_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  inputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  markupMultiplier?: Maybe<Scalars['Float']['output']>;
  outputCostPerMillion?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AgentModelPricing_Stddev_Samp_Fields = {
  __typename?: 'agentModelPricing_stddev_samp_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  inputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  markupMultiplier?: Maybe<Scalars['Float']['output']>;
  outputCostPerMillion?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "agentModelPricing" */
export type AgentModelPricing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AgentModelPricing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentModelPricing_Stream_Cursor_Value_Input = {
  cachedInputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  inputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  markupMultiplier?: InputMaybe<Scalars['numeric']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outputCostPerMillion?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type AgentModelPricing_Sum_Fields = {
  __typename?: 'agentModelPricing_sum_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['numeric']['output']>;
  inputCostPerMillion?: Maybe<Scalars['numeric']['output']>;
  markupMultiplier?: Maybe<Scalars['numeric']['output']>;
  outputCostPerMillion?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "agent_model_pricing" */
export enum AgentModelPricing_Update_Column {
  /** column name */
  cachedInputCostPerMillion = 'cachedInputCostPerMillion',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  currency = 'currency',
  /** column name */
  inputCostPerMillion = 'inputCostPerMillion',
  /** column name */
  markupMultiplier = 'markupMultiplier',
  /** column name */
  model = 'model',
  /** column name */
  outputCostPerMillion = 'outputCostPerMillion',
  /** column name */
  updatedAt = 'updatedAt'
}

export type AgentModelPricing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AgentModelPricing_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgentModelPricing_Set_Input>;
  /** filter the rows which have to be updated */
  where: AgentModelPricing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AgentModelPricing_Var_Pop_Fields = {
  __typename?: 'agentModelPricing_var_pop_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  inputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  markupMultiplier?: Maybe<Scalars['Float']['output']>;
  outputCostPerMillion?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AgentModelPricing_Var_Samp_Fields = {
  __typename?: 'agentModelPricing_var_samp_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  inputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  markupMultiplier?: Maybe<Scalars['Float']['output']>;
  outputCostPerMillion?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AgentModelPricing_Variance_Fields = {
  __typename?: 'agentModelPricing_variance_fields';
  cachedInputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  inputCostPerMillion?: Maybe<Scalars['Float']['output']>;
  markupMultiplier?: Maybe<Scalars['Float']['output']>;
  outputCostPerMillion?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "agent_skills_tenant_user" */
export type AgentSkillsTenantUser = {
  __typename?: 'agentSkillsTenantUser';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  creatorId?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isCurated: Scalars['Boolean']['output'];
  mcpPromptName?: Maybe<Scalars['String']['output']>;
  mcpServerName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  projectId?: Maybe<Scalars['uuid']['output']>;
  sourceType: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  useWhen?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "agent_skills_tenant_user" */
export type AgentSkillsTenantUser_Aggregate = {
  __typename?: 'agentSkillsTenantUser_aggregate';
  aggregate?: Maybe<AgentSkillsTenantUser_Aggregate_Fields>;
  nodes: Array<AgentSkillsTenantUser>;
};

/** aggregate fields of "agent_skills_tenant_user" */
export type AgentSkillsTenantUser_Aggregate_Fields = {
  __typename?: 'agentSkillsTenantUser_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AgentSkillsTenantUser_Max_Fields>;
  min?: Maybe<AgentSkillsTenantUser_Min_Fields>;
};


/** aggregate fields of "agent_skills_tenant_user" */
export type AgentSkillsTenantUser_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AgentSkillsTenantUser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "agent_skills_tenant_user". All fields are combined with a logical 'AND'. */
export type AgentSkillsTenantUser_Bool_Exp = {
  _and?: InputMaybe<Array<AgentSkillsTenantUser_Bool_Exp>>;
  _not?: InputMaybe<AgentSkillsTenantUser_Bool_Exp>;
  _or?: InputMaybe<Array<AgentSkillsTenantUser_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  creatorId?: InputMaybe<Uuid_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isCurated?: InputMaybe<Boolean_Comparison_Exp>;
  mcpPromptName?: InputMaybe<String_Comparison_Exp>;
  mcpServerName?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  sourceType?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  useWhen?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "agent_skills_tenant_user" */
export enum AgentSkillsTenantUser_Constraint {
  /** unique or primary key constraint on columns "id" */
  agent_skills_tenant_user_pkey = 'agent_skills_tenant_user_pkey'
}

/** input type for inserting data into table "agent_skills_tenant_user" */
export type AgentSkillsTenantUser_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  creatorId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCurated?: InputMaybe<Scalars['Boolean']['input']>;
  mcpPromptName?: InputMaybe<Scalars['String']['input']>;
  mcpServerName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  useWhen?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AgentSkillsTenantUser_Max_Fields = {
  __typename?: 'agentSkillsTenantUser_max_fields';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  creatorId?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mcpPromptName?: Maybe<Scalars['String']['output']>;
  mcpServerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  useWhen?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AgentSkillsTenantUser_Min_Fields = {
  __typename?: 'agentSkillsTenantUser_min_fields';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  creatorId?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mcpPromptName?: Maybe<Scalars['String']['output']>;
  mcpServerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  useWhen?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "agent_skills_tenant_user" */
export type AgentSkillsTenantUser_Mutation_Response = {
  __typename?: 'agentSkillsTenantUser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AgentSkillsTenantUser>;
};

/** on_conflict condition type for table "agent_skills_tenant_user" */
export type AgentSkillsTenantUser_On_Conflict = {
  constraint: AgentSkillsTenantUser_Constraint;
  update_columns?: Array<AgentSkillsTenantUser_Update_Column>;
  where?: InputMaybe<AgentSkillsTenantUser_Bool_Exp>;
};

/** Ordering options when selecting data from "agent_skills_tenant_user". */
export type AgentSkillsTenantUser_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  creatorId?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isCurated?: InputMaybe<Order_By>;
  mcpPromptName?: InputMaybe<Order_By>;
  mcpServerName?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  sourceType?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  useWhen?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent_skills_tenant_user */
export type AgentSkillsTenantUser_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agent_skills_tenant_user" */
export enum AgentSkillsTenantUser_Select_Column {
  /** column name */
  body = 'body',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  creatorId = 'creatorId',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  isCurated = 'isCurated',
  /** column name */
  mcpPromptName = 'mcpPromptName',
  /** column name */
  mcpServerName = 'mcpServerName',
  /** column name */
  name = 'name',
  /** column name */
  projectId = 'projectId',
  /** column name */
  sourceType = 'sourceType',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  useWhen = 'useWhen',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "agent_skills_tenant_user" */
export type AgentSkillsTenantUser_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  creatorId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCurated?: InputMaybe<Scalars['Boolean']['input']>;
  mcpPromptName?: InputMaybe<Scalars['String']['input']>;
  mcpServerName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  useWhen?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "agentSkillsTenantUser" */
export type AgentSkillsTenantUser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AgentSkillsTenantUser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentSkillsTenantUser_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  creatorId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCurated?: InputMaybe<Scalars['Boolean']['input']>;
  mcpPromptName?: InputMaybe<Scalars['String']['input']>;
  mcpServerName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  useWhen?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "agent_skills_tenant_user" */
export enum AgentSkillsTenantUser_Update_Column {
  /** column name */
  body = 'body',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  creatorId = 'creatorId',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  isCurated = 'isCurated',
  /** column name */
  mcpPromptName = 'mcpPromptName',
  /** column name */
  mcpServerName = 'mcpServerName',
  /** column name */
  name = 'name',
  /** column name */
  projectId = 'projectId',
  /** column name */
  sourceType = 'sourceType',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  useWhen = 'useWhen',
  /** column name */
  userId = 'userId'
}

export type AgentSkillsTenantUser_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgentSkillsTenantUser_Set_Input>;
  /** filter the rows which have to be updated */
  where: AgentSkillsTenantUser_Bool_Exp;
};

/** columns and relationships of "agent_usage_budget_status" */
export type AgentUsageBudgetStatus = {
  __typename?: 'agentUsageBudgetStatus';
  capAmount?: Maybe<Scalars['numeric']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  pctUsed?: Maybe<Scalars['numeric']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  spendCurrentMonth?: Maybe<Scalars['numeric']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "agent_usage_budget_status" */
export type AgentUsageBudgetStatus_Aggregate = {
  __typename?: 'agentUsageBudgetStatus_aggregate';
  aggregate?: Maybe<AgentUsageBudgetStatus_Aggregate_Fields>;
  nodes: Array<AgentUsageBudgetStatus>;
};

/** aggregate fields of "agent_usage_budget_status" */
export type AgentUsageBudgetStatus_Aggregate_Fields = {
  __typename?: 'agentUsageBudgetStatus_aggregate_fields';
  avg?: Maybe<AgentUsageBudgetStatus_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AgentUsageBudgetStatus_Max_Fields>;
  min?: Maybe<AgentUsageBudgetStatus_Min_Fields>;
  stddev?: Maybe<AgentUsageBudgetStatus_Stddev_Fields>;
  stddev_pop?: Maybe<AgentUsageBudgetStatus_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AgentUsageBudgetStatus_Stddev_Samp_Fields>;
  sum?: Maybe<AgentUsageBudgetStatus_Sum_Fields>;
  var_pop?: Maybe<AgentUsageBudgetStatus_Var_Pop_Fields>;
  var_samp?: Maybe<AgentUsageBudgetStatus_Var_Samp_Fields>;
  variance?: Maybe<AgentUsageBudgetStatus_Variance_Fields>;
};


/** aggregate fields of "agent_usage_budget_status" */
export type AgentUsageBudgetStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AgentUsageBudgetStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AgentUsageBudgetStatus_Avg_Fields = {
  __typename?: 'agentUsageBudgetStatus_avg_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
  pctUsed?: Maybe<Scalars['Float']['output']>;
  spendCurrentMonth?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agent_usage_budget_status". All fields are combined with a logical 'AND'. */
export type AgentUsageBudgetStatus_Bool_Exp = {
  _and?: InputMaybe<Array<AgentUsageBudgetStatus_Bool_Exp>>;
  _not?: InputMaybe<AgentUsageBudgetStatus_Bool_Exp>;
  _or?: InputMaybe<Array<AgentUsageBudgetStatus_Bool_Exp>>;
  capAmount?: InputMaybe<Numeric_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  pctUsed?: InputMaybe<Numeric_Comparison_Exp>;
  period?: InputMaybe<String_Comparison_Exp>;
  spendCurrentMonth?: InputMaybe<Numeric_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type AgentUsageBudgetStatus_Max_Fields = {
  __typename?: 'agentUsageBudgetStatus_max_fields';
  capAmount?: Maybe<Scalars['numeric']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  pctUsed?: Maybe<Scalars['numeric']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  spendCurrentMonth?: Maybe<Scalars['numeric']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AgentUsageBudgetStatus_Min_Fields = {
  __typename?: 'agentUsageBudgetStatus_min_fields';
  capAmount?: Maybe<Scalars['numeric']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  pctUsed?: Maybe<Scalars['numeric']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  spendCurrentMonth?: Maybe<Scalars['numeric']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "agent_usage_budget_status". */
export type AgentUsageBudgetStatus_Order_By = {
  capAmount?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  pctUsed?: InputMaybe<Order_By>;
  period?: InputMaybe<Order_By>;
  spendCurrentMonth?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
};

/** select columns of table "agent_usage_budget_status" */
export enum AgentUsageBudgetStatus_Select_Column {
  /** column name */
  capAmount = 'capAmount',
  /** column name */
  currency = 'currency',
  /** column name */
  pctUsed = 'pctUsed',
  /** column name */
  period = 'period',
  /** column name */
  spendCurrentMonth = 'spendCurrentMonth',
  /** column name */
  tenantId = 'tenantId'
}

/** aggregate stddev on columns */
export type AgentUsageBudgetStatus_Stddev_Fields = {
  __typename?: 'agentUsageBudgetStatus_stddev_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
  pctUsed?: Maybe<Scalars['Float']['output']>;
  spendCurrentMonth?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AgentUsageBudgetStatus_Stddev_Pop_Fields = {
  __typename?: 'agentUsageBudgetStatus_stddev_pop_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
  pctUsed?: Maybe<Scalars['Float']['output']>;
  spendCurrentMonth?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AgentUsageBudgetStatus_Stddev_Samp_Fields = {
  __typename?: 'agentUsageBudgetStatus_stddev_samp_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
  pctUsed?: Maybe<Scalars['Float']['output']>;
  spendCurrentMonth?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "agentUsageBudgetStatus" */
export type AgentUsageBudgetStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AgentUsageBudgetStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentUsageBudgetStatus_Stream_Cursor_Value_Input = {
  capAmount?: InputMaybe<Scalars['numeric']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  pctUsed?: InputMaybe<Scalars['numeric']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  spendCurrentMonth?: InputMaybe<Scalars['numeric']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type AgentUsageBudgetStatus_Sum_Fields = {
  __typename?: 'agentUsageBudgetStatus_sum_fields';
  capAmount?: Maybe<Scalars['numeric']['output']>;
  pctUsed?: Maybe<Scalars['numeric']['output']>;
  spendCurrentMonth?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type AgentUsageBudgetStatus_Var_Pop_Fields = {
  __typename?: 'agentUsageBudgetStatus_var_pop_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
  pctUsed?: Maybe<Scalars['Float']['output']>;
  spendCurrentMonth?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AgentUsageBudgetStatus_Var_Samp_Fields = {
  __typename?: 'agentUsageBudgetStatus_var_samp_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
  pctUsed?: Maybe<Scalars['Float']['output']>;
  spendCurrentMonth?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AgentUsageBudgetStatus_Variance_Fields = {
  __typename?: 'agentUsageBudgetStatus_variance_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
  pctUsed?: Maybe<Scalars['Float']['output']>;
  spendCurrentMonth?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "agent_usage_daily" */
export type AgentUsageDaily = {
  __typename?: 'agentUsageDaily';
  feature?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['bigint']['output']>;
  inputTokensCached?: Maybe<Scalars['bigint']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  outputTokens?: Maybe<Scalars['bigint']['output']>;
  requestCount?: Maybe<Scalars['bigint']['output']>;
  sessionCount?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['bigint']['output']>;
  usageDate?: Maybe<Scalars['date']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "agent_usage_daily" */
export type AgentUsageDaily_Aggregate = {
  __typename?: 'agentUsageDaily_aggregate';
  aggregate?: Maybe<AgentUsageDaily_Aggregate_Fields>;
  nodes: Array<AgentUsageDaily>;
};

/** aggregate fields of "agent_usage_daily" */
export type AgentUsageDaily_Aggregate_Fields = {
  __typename?: 'agentUsageDaily_aggregate_fields';
  avg?: Maybe<AgentUsageDaily_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AgentUsageDaily_Max_Fields>;
  min?: Maybe<AgentUsageDaily_Min_Fields>;
  stddev?: Maybe<AgentUsageDaily_Stddev_Fields>;
  stddev_pop?: Maybe<AgentUsageDaily_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AgentUsageDaily_Stddev_Samp_Fields>;
  sum?: Maybe<AgentUsageDaily_Sum_Fields>;
  var_pop?: Maybe<AgentUsageDaily_Var_Pop_Fields>;
  var_samp?: Maybe<AgentUsageDaily_Var_Samp_Fields>;
  variance?: Maybe<AgentUsageDaily_Variance_Fields>;
};


/** aggregate fields of "agent_usage_daily" */
export type AgentUsageDaily_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AgentUsageDaily_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AgentUsageDaily_Avg_Fields = {
  __typename?: 'agentUsageDaily_avg_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  sessionCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agent_usage_daily". All fields are combined with a logical 'AND'. */
export type AgentUsageDaily_Bool_Exp = {
  _and?: InputMaybe<Array<AgentUsageDaily_Bool_Exp>>;
  _not?: InputMaybe<AgentUsageDaily_Bool_Exp>;
  _or?: InputMaybe<Array<AgentUsageDaily_Bool_Exp>>;
  feature?: InputMaybe<String_Comparison_Exp>;
  inputTokens?: InputMaybe<Bigint_Comparison_Exp>;
  inputTokensCached?: InputMaybe<Bigint_Comparison_Exp>;
  markedUpPrice?: InputMaybe<Numeric_Comparison_Exp>;
  outputTokens?: InputMaybe<Bigint_Comparison_Exp>;
  requestCount?: InputMaybe<Bigint_Comparison_Exp>;
  sessionCount?: InputMaybe<Bigint_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  totalTokens?: InputMaybe<Bigint_Comparison_Exp>;
  usageDate?: InputMaybe<Date_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type AgentUsageDaily_Max_Fields = {
  __typename?: 'agentUsageDaily_max_fields';
  feature?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['bigint']['output']>;
  inputTokensCached?: Maybe<Scalars['bigint']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  outputTokens?: Maybe<Scalars['bigint']['output']>;
  requestCount?: Maybe<Scalars['bigint']['output']>;
  sessionCount?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['bigint']['output']>;
  usageDate?: Maybe<Scalars['date']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AgentUsageDaily_Min_Fields = {
  __typename?: 'agentUsageDaily_min_fields';
  feature?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['bigint']['output']>;
  inputTokensCached?: Maybe<Scalars['bigint']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  outputTokens?: Maybe<Scalars['bigint']['output']>;
  requestCount?: Maybe<Scalars['bigint']['output']>;
  sessionCount?: Maybe<Scalars['bigint']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['bigint']['output']>;
  usageDate?: Maybe<Scalars['date']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "agent_usage_daily". */
export type AgentUsageDaily_Order_By = {
  feature?: InputMaybe<Order_By>;
  inputTokens?: InputMaybe<Order_By>;
  inputTokensCached?: InputMaybe<Order_By>;
  markedUpPrice?: InputMaybe<Order_By>;
  outputTokens?: InputMaybe<Order_By>;
  requestCount?: InputMaybe<Order_By>;
  sessionCount?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  totalTokens?: InputMaybe<Order_By>;
  usageDate?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "agent_usage_daily" */
export enum AgentUsageDaily_Select_Column {
  /** column name */
  feature = 'feature',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  inputTokensCached = 'inputTokensCached',
  /** column name */
  markedUpPrice = 'markedUpPrice',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  requestCount = 'requestCount',
  /** column name */
  sessionCount = 'sessionCount',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  totalTokens = 'totalTokens',
  /** column name */
  usageDate = 'usageDate',
  /** column name */
  userId = 'userId'
}

/** aggregate stddev on columns */
export type AgentUsageDaily_Stddev_Fields = {
  __typename?: 'agentUsageDaily_stddev_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  sessionCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AgentUsageDaily_Stddev_Pop_Fields = {
  __typename?: 'agentUsageDaily_stddev_pop_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  sessionCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AgentUsageDaily_Stddev_Samp_Fields = {
  __typename?: 'agentUsageDaily_stddev_samp_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  sessionCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "agentUsageDaily" */
export type AgentUsageDaily_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AgentUsageDaily_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentUsageDaily_Stream_Cursor_Value_Input = {
  feature?: InputMaybe<Scalars['String']['input']>;
  inputTokens?: InputMaybe<Scalars['bigint']['input']>;
  inputTokensCached?: InputMaybe<Scalars['bigint']['input']>;
  markedUpPrice?: InputMaybe<Scalars['numeric']['input']>;
  outputTokens?: InputMaybe<Scalars['bigint']['input']>;
  requestCount?: InputMaybe<Scalars['bigint']['input']>;
  sessionCount?: InputMaybe<Scalars['bigint']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  totalTokens?: InputMaybe<Scalars['bigint']['input']>;
  usageDate?: InputMaybe<Scalars['date']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type AgentUsageDaily_Sum_Fields = {
  __typename?: 'agentUsageDaily_sum_fields';
  inputTokens?: Maybe<Scalars['bigint']['output']>;
  inputTokensCached?: Maybe<Scalars['bigint']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  outputTokens?: Maybe<Scalars['bigint']['output']>;
  requestCount?: Maybe<Scalars['bigint']['output']>;
  sessionCount?: Maybe<Scalars['bigint']['output']>;
  totalTokens?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type AgentUsageDaily_Var_Pop_Fields = {
  __typename?: 'agentUsageDaily_var_pop_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  sessionCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AgentUsageDaily_Var_Samp_Fields = {
  __typename?: 'agentUsageDaily_var_samp_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  sessionCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AgentUsageDaily_Variance_Fields = {
  __typename?: 'agentUsageDaily_variance_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  sessionCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "agent_usage_request" */
export type AgentUsageRequest = {
  __typename?: 'agentUsageRequest';
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  inputTokensCached?: Maybe<Scalars['Int']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  requestId?: Maybe<Scalars['uuid']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userResponseRating?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "agent_usage_request" */
export type AgentUsageRequest_Aggregate = {
  __typename?: 'agentUsageRequest_aggregate';
  aggregate?: Maybe<AgentUsageRequest_Aggregate_Fields>;
  nodes: Array<AgentUsageRequest>;
};

/** aggregate fields of "agent_usage_request" */
export type AgentUsageRequest_Aggregate_Fields = {
  __typename?: 'agentUsageRequest_aggregate_fields';
  avg?: Maybe<AgentUsageRequest_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AgentUsageRequest_Max_Fields>;
  min?: Maybe<AgentUsageRequest_Min_Fields>;
  stddev?: Maybe<AgentUsageRequest_Stddev_Fields>;
  stddev_pop?: Maybe<AgentUsageRequest_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AgentUsageRequest_Stddev_Samp_Fields>;
  sum?: Maybe<AgentUsageRequest_Sum_Fields>;
  var_pop?: Maybe<AgentUsageRequest_Var_Pop_Fields>;
  var_samp?: Maybe<AgentUsageRequest_Var_Samp_Fields>;
  variance?: Maybe<AgentUsageRequest_Variance_Fields>;
};


/** aggregate fields of "agent_usage_request" */
export type AgentUsageRequest_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AgentUsageRequest_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AgentUsageRequest_Avg_Fields = {
  __typename?: 'agentUsageRequest_avg_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agent_usage_request". All fields are combined with a logical 'AND'. */
export type AgentUsageRequest_Bool_Exp = {
  _and?: InputMaybe<Array<AgentUsageRequest_Bool_Exp>>;
  _not?: InputMaybe<AgentUsageRequest_Bool_Exp>;
  _or?: InputMaybe<Array<AgentUsageRequest_Bool_Exp>>;
  completedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  feature?: InputMaybe<String_Comparison_Exp>;
  inputTokens?: InputMaybe<Int_Comparison_Exp>;
  inputTokensCached?: InputMaybe<Int_Comparison_Exp>;
  markedUpPrice?: InputMaybe<Numeric_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  outputTokens?: InputMaybe<Int_Comparison_Exp>;
  requestId?: InputMaybe<Uuid_Comparison_Exp>;
  sessionId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  totalTokens?: InputMaybe<Int_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  userResponseRating?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type AgentUsageRequest_Max_Fields = {
  __typename?: 'agentUsageRequest_max_fields';
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  inputTokensCached?: Maybe<Scalars['Int']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  requestId?: Maybe<Scalars['uuid']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userResponseRating?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type AgentUsageRequest_Min_Fields = {
  __typename?: 'agentUsageRequest_min_fields';
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  inputTokensCached?: Maybe<Scalars['Int']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  requestId?: Maybe<Scalars['uuid']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userResponseRating?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "agent_usage_request". */
export type AgentUsageRequest_Order_By = {
  completedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  errorMessage?: InputMaybe<Order_By>;
  feature?: InputMaybe<Order_By>;
  inputTokens?: InputMaybe<Order_By>;
  inputTokensCached?: InputMaybe<Order_By>;
  markedUpPrice?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  outputTokens?: InputMaybe<Order_By>;
  requestId?: InputMaybe<Order_By>;
  sessionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  totalTokens?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  userResponseRating?: InputMaybe<Order_By>;
};

/** select columns of table "agent_usage_request" */
export enum AgentUsageRequest_Select_Column {
  /** column name */
  completedAt = 'completedAt',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  feature = 'feature',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  inputTokensCached = 'inputTokensCached',
  /** column name */
  markedUpPrice = 'markedUpPrice',
  /** column name */
  model = 'model',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  requestId = 'requestId',
  /** column name */
  sessionId = 'sessionId',
  /** column name */
  status = 'status',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  totalTokens = 'totalTokens',
  /** column name */
  userId = 'userId',
  /** column name */
  userResponseRating = 'userResponseRating'
}

/** aggregate stddev on columns */
export type AgentUsageRequest_Stddev_Fields = {
  __typename?: 'agentUsageRequest_stddev_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AgentUsageRequest_Stddev_Pop_Fields = {
  __typename?: 'agentUsageRequest_stddev_pop_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AgentUsageRequest_Stddev_Samp_Fields = {
  __typename?: 'agentUsageRequest_stddev_samp_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "agentUsageRequest" */
export type AgentUsageRequest_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AgentUsageRequest_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentUsageRequest_Stream_Cursor_Value_Input = {
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  inputTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokensCached?: InputMaybe<Scalars['Int']['input']>;
  markedUpPrice?: InputMaybe<Scalars['numeric']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outputTokens?: InputMaybe<Scalars['Int']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  sessionId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  totalTokens?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userResponseRating?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type AgentUsageRequest_Sum_Fields = {
  __typename?: 'agentUsageRequest_sum_fields';
  inputTokens?: Maybe<Scalars['Int']['output']>;
  inputTokensCached?: Maybe<Scalars['Int']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  userResponseRating?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type AgentUsageRequest_Var_Pop_Fields = {
  __typename?: 'agentUsageRequest_var_pop_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AgentUsageRequest_Var_Samp_Fields = {
  __typename?: 'agentUsageRequest_var_samp_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AgentUsageRequest_Variance_Fields = {
  __typename?: 'agentUsageRequest_variance_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "agent_usage_session" */
export type AgentUsageSession = {
  __typename?: 'agentUsageSession';
  feature?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['bigint']['output']>;
  inputTokensCached?: Maybe<Scalars['bigint']['output']>;
  lastActivityAt?: Maybe<Scalars['timestamptz']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  outputTokens?: Maybe<Scalars['bigint']['output']>;
  requestCount?: Maybe<Scalars['bigint']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "agent_usage_session" */
export type AgentUsageSession_Aggregate = {
  __typename?: 'agentUsageSession_aggregate';
  aggregate?: Maybe<AgentUsageSession_Aggregate_Fields>;
  nodes: Array<AgentUsageSession>;
};

/** aggregate fields of "agent_usage_session" */
export type AgentUsageSession_Aggregate_Fields = {
  __typename?: 'agentUsageSession_aggregate_fields';
  avg?: Maybe<AgentUsageSession_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AgentUsageSession_Max_Fields>;
  min?: Maybe<AgentUsageSession_Min_Fields>;
  stddev?: Maybe<AgentUsageSession_Stddev_Fields>;
  stddev_pop?: Maybe<AgentUsageSession_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AgentUsageSession_Stddev_Samp_Fields>;
  sum?: Maybe<AgentUsageSession_Sum_Fields>;
  var_pop?: Maybe<AgentUsageSession_Var_Pop_Fields>;
  var_samp?: Maybe<AgentUsageSession_Var_Samp_Fields>;
  variance?: Maybe<AgentUsageSession_Variance_Fields>;
};


/** aggregate fields of "agent_usage_session" */
export type AgentUsageSession_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AgentUsageSession_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AgentUsageSession_Avg_Fields = {
  __typename?: 'agentUsageSession_avg_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agent_usage_session". All fields are combined with a logical 'AND'. */
export type AgentUsageSession_Bool_Exp = {
  _and?: InputMaybe<Array<AgentUsageSession_Bool_Exp>>;
  _not?: InputMaybe<AgentUsageSession_Bool_Exp>;
  _or?: InputMaybe<Array<AgentUsageSession_Bool_Exp>>;
  feature?: InputMaybe<String_Comparison_Exp>;
  inputTokens?: InputMaybe<Bigint_Comparison_Exp>;
  inputTokensCached?: InputMaybe<Bigint_Comparison_Exp>;
  lastActivityAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  markedUpPrice?: InputMaybe<Numeric_Comparison_Exp>;
  outputTokens?: InputMaybe<Bigint_Comparison_Exp>;
  requestCount?: InputMaybe<Bigint_Comparison_Exp>;
  sessionId?: InputMaybe<Uuid_Comparison_Exp>;
  startedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  totalTokens?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type AgentUsageSession_Max_Fields = {
  __typename?: 'agentUsageSession_max_fields';
  feature?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['bigint']['output']>;
  inputTokensCached?: Maybe<Scalars['bigint']['output']>;
  lastActivityAt?: Maybe<Scalars['timestamptz']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  outputTokens?: Maybe<Scalars['bigint']['output']>;
  requestCount?: Maybe<Scalars['bigint']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AgentUsageSession_Min_Fields = {
  __typename?: 'agentUsageSession_min_fields';
  feature?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['bigint']['output']>;
  inputTokensCached?: Maybe<Scalars['bigint']['output']>;
  lastActivityAt?: Maybe<Scalars['timestamptz']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  outputTokens?: Maybe<Scalars['bigint']['output']>;
  requestCount?: Maybe<Scalars['bigint']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "agent_usage_session". */
export type AgentUsageSession_Order_By = {
  feature?: InputMaybe<Order_By>;
  inputTokens?: InputMaybe<Order_By>;
  inputTokensCached?: InputMaybe<Order_By>;
  lastActivityAt?: InputMaybe<Order_By>;
  markedUpPrice?: InputMaybe<Order_By>;
  outputTokens?: InputMaybe<Order_By>;
  requestCount?: InputMaybe<Order_By>;
  sessionId?: InputMaybe<Order_By>;
  startedAt?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  totalTokens?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "agent_usage_session" */
export enum AgentUsageSession_Select_Column {
  /** column name */
  feature = 'feature',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  inputTokensCached = 'inputTokensCached',
  /** column name */
  lastActivityAt = 'lastActivityAt',
  /** column name */
  markedUpPrice = 'markedUpPrice',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  requestCount = 'requestCount',
  /** column name */
  sessionId = 'sessionId',
  /** column name */
  startedAt = 'startedAt',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  totalTokens = 'totalTokens',
  /** column name */
  userId = 'userId'
}

/** aggregate stddev on columns */
export type AgentUsageSession_Stddev_Fields = {
  __typename?: 'agentUsageSession_stddev_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AgentUsageSession_Stddev_Pop_Fields = {
  __typename?: 'agentUsageSession_stddev_pop_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AgentUsageSession_Stddev_Samp_Fields = {
  __typename?: 'agentUsageSession_stddev_samp_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "agentUsageSession" */
export type AgentUsageSession_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AgentUsageSession_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentUsageSession_Stream_Cursor_Value_Input = {
  feature?: InputMaybe<Scalars['String']['input']>;
  inputTokens?: InputMaybe<Scalars['bigint']['input']>;
  inputTokensCached?: InputMaybe<Scalars['bigint']['input']>;
  lastActivityAt?: InputMaybe<Scalars['timestamptz']['input']>;
  markedUpPrice?: InputMaybe<Scalars['numeric']['input']>;
  outputTokens?: InputMaybe<Scalars['bigint']['input']>;
  requestCount?: InputMaybe<Scalars['bigint']['input']>;
  sessionId?: InputMaybe<Scalars['uuid']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  totalTokens?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type AgentUsageSession_Sum_Fields = {
  __typename?: 'agentUsageSession_sum_fields';
  inputTokens?: Maybe<Scalars['bigint']['output']>;
  inputTokensCached?: Maybe<Scalars['bigint']['output']>;
  markedUpPrice?: Maybe<Scalars['numeric']['output']>;
  outputTokens?: Maybe<Scalars['bigint']['output']>;
  requestCount?: Maybe<Scalars['bigint']['output']>;
  totalTokens?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type AgentUsageSession_Var_Pop_Fields = {
  __typename?: 'agentUsageSession_var_pop_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AgentUsageSession_Var_Samp_Fields = {
  __typename?: 'agentUsageSession_var_samp_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AgentUsageSession_Variance_Fields = {
  __typename?: 'agentUsageSession_variance_fields';
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  markedUpPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
};

export type AlreadySeen_FlowGuide_Args = {
  p_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "application_source" */
export type ApplicationSource = {
  __typename?: 'applicationSource';
  applicationId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  sourceId: Scalars['uuid']['output'];
};

/** aggregated selection of "application_source" */
export type ApplicationSource_Aggregate = {
  __typename?: 'applicationSource_aggregate';
  aggregate?: Maybe<ApplicationSource_Aggregate_Fields>;
  nodes: Array<ApplicationSource>;
};

/** aggregate fields of "application_source" */
export type ApplicationSource_Aggregate_Fields = {
  __typename?: 'applicationSource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ApplicationSource_Max_Fields>;
  min?: Maybe<ApplicationSource_Min_Fields>;
};


/** aggregate fields of "application_source" */
export type ApplicationSource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationSource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "application_source". All fields are combined with a logical 'AND'. */
export type ApplicationSource_Bool_Exp = {
  _and?: InputMaybe<Array<ApplicationSource_Bool_Exp>>;
  _not?: InputMaybe<ApplicationSource_Bool_Exp>;
  _or?: InputMaybe<Array<ApplicationSource_Bool_Exp>>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sourceId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "application_source" */
export enum ApplicationSource_Constraint {
  /** unique or primary key constraint on columns "application_id", "source_id" */
  application_source_application_id_source_id_key = 'application_source_application_id_source_id_key',
  /** unique or primary key constraint on columns "id" */
  application_source_pkey = 'application_source_pkey'
}

/** input type for inserting data into table "application_source" */
export type ApplicationSource_Insert_Input = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ApplicationSource_Max_Fields = {
  __typename?: 'applicationSource_max_fields';
  applicationId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ApplicationSource_Min_Fields = {
  __typename?: 'applicationSource_min_fields';
  applicationId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "application_source" */
export type ApplicationSource_Mutation_Response = {
  __typename?: 'applicationSource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ApplicationSource>;
};

/** on_conflict condition type for table "application_source" */
export type ApplicationSource_On_Conflict = {
  constraint: ApplicationSource_Constraint;
  update_columns?: Array<ApplicationSource_Update_Column>;
  where?: InputMaybe<ApplicationSource_Bool_Exp>;
};

/** Ordering options when selecting data from "application_source". */
export type ApplicationSource_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sourceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: application_source */
export type ApplicationSource_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "application_source" */
export enum ApplicationSource_Select_Column {
  /** column name */
  applicationId = 'applicationId',
  /** column name */
  id = 'id',
  /** column name */
  sourceId = 'sourceId'
}

/** input type for updating data in table "application_source" */
export type ApplicationSource_Set_Input = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "applicationSource" */
export type ApplicationSource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApplicationSource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationSource_Stream_Cursor_Value_Input = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "application_source" */
export enum ApplicationSource_Update_Column {
  /** column name */
  applicationId = 'applicationId',
  /** column name */
  id = 'id',
  /** column name */
  sourceId = 'sourceId'
}

export type ApplicationSource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApplicationSource_Set_Input>;
  /** filter the rows which have to be updated */
  where: ApplicationSource_Bool_Exp;
};

/** columns and relationships of "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict = {
  __typename?: 'benchmarkGroupingVerdict';
  code?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['float8']['output']>;
  evidence?: Maybe<Scalars['jsonb']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  material?: Maybe<BenchmarkInventoryMaterial>;
  materialId: Scalars['uuid']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  producedAt: Scalars['timestamptz']['output'];
  requiresReview: Scalars['Boolean']['output'];
  /** An object relationship */
  snapshot?: Maybe<BenchmarkSnapshot>;
  snapshotId: Scalars['bigint']['output'];
  source: Scalars['String']['output'];
};


/** columns and relationships of "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdictEvidenceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Aggregate = {
  __typename?: 'benchmarkGroupingVerdict_aggregate';
  aggregate?: Maybe<BenchmarkGroupingVerdict_Aggregate_Fields>;
  nodes: Array<BenchmarkGroupingVerdict>;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp = {
  avg?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Var_Samp>;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Avg = {
  arguments: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Bool_And = {
  arguments: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Bool_Or = {
  arguments: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Corr = {
  arguments: BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Corr_Arguments = {
  X: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Max = {
  arguments: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Min = {
  arguments: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Sum = {
  arguments: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Var_Samp = {
  arguments: BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Aggregate_Fields = {
  __typename?: 'benchmarkGroupingVerdict_aggregate_fields';
  avg?: Maybe<BenchmarkGroupingVerdict_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BenchmarkGroupingVerdict_Max_Fields>;
  min?: Maybe<BenchmarkGroupingVerdict_Min_Fields>;
  stddev?: Maybe<BenchmarkGroupingVerdict_Stddev_Fields>;
  stddev_pop?: Maybe<BenchmarkGroupingVerdict_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BenchmarkGroupingVerdict_Stddev_Samp_Fields>;
  sum?: Maybe<BenchmarkGroupingVerdict_Sum_Fields>;
  var_pop?: Maybe<BenchmarkGroupingVerdict_Var_Pop_Fields>;
  var_samp?: Maybe<BenchmarkGroupingVerdict_Var_Samp_Fields>;
  variance?: Maybe<BenchmarkGroupingVerdict_Variance_Fields>;
};


/** aggregate fields of "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Aggregate_Order_By = {
  avg?: InputMaybe<BenchmarkGroupingVerdict_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<BenchmarkGroupingVerdict_Max_Order_By>;
  min?: InputMaybe<BenchmarkGroupingVerdict_Min_Order_By>;
  stddev?: InputMaybe<BenchmarkGroupingVerdict_Stddev_Order_By>;
  stddev_pop?: InputMaybe<BenchmarkGroupingVerdict_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<BenchmarkGroupingVerdict_Stddev_Samp_Order_By>;
  sum?: InputMaybe<BenchmarkGroupingVerdict_Sum_Order_By>;
  var_pop?: InputMaybe<BenchmarkGroupingVerdict_Var_Pop_Order_By>;
  var_samp?: InputMaybe<BenchmarkGroupingVerdict_Var_Samp_Order_By>;
  variance?: InputMaybe<BenchmarkGroupingVerdict_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BenchmarkGroupingVerdict_Append_Input = {
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Arr_Rel_Insert_Input = {
  data: Array<BenchmarkGroupingVerdict_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<BenchmarkGroupingVerdict_On_Conflict>;
};

/** aggregate avg on columns */
export type BenchmarkGroupingVerdict_Avg_Fields = {
  __typename?: 'benchmarkGroupingVerdict_avg_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Avg_Order_By = {
  confidence?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "benchmark_grouping_verdict". All fields are combined with a logical 'AND'. */
export type BenchmarkGroupingVerdict_Bool_Exp = {
  _and?: InputMaybe<Array<BenchmarkGroupingVerdict_Bool_Exp>>;
  _not?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  _or?: InputMaybe<Array<BenchmarkGroupingVerdict_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  confidence?: InputMaybe<Float8_Comparison_Exp>;
  evidence?: InputMaybe<Jsonb_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  modelId?: InputMaybe<String_Comparison_Exp>;
  producedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  requiresReview?: InputMaybe<Boolean_Comparison_Exp>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Constraint {
  /** unique or primary key constraint on columns "snapshot_id", "material_id", "source" */
  benchmark_grouping_verdict_pkey = 'benchmark_grouping_verdict_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BenchmarkGroupingVerdict_Delete_At_Path_Input = {
  evidence?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BenchmarkGroupingVerdict_Delete_Elem_Input = {
  evidence?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BenchmarkGroupingVerdict_Delete_Key_Input = {
  evidence?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Inc_Input = {
  confidence?: InputMaybe<Scalars['float8']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['float8']['input']>;
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Obj_Rel_Insert_Input>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  producedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requiresReview?: InputMaybe<Scalars['Boolean']['input']>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Obj_Rel_Insert_Input>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BenchmarkGroupingVerdict_Max_Fields = {
  __typename?: 'benchmarkGroupingVerdict_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['float8']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  producedAt?: Maybe<Scalars['timestamptz']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  producedAt?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type BenchmarkGroupingVerdict_Min_Fields = {
  __typename?: 'benchmarkGroupingVerdict_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['float8']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  producedAt?: Maybe<Scalars['timestamptz']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  producedAt?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Mutation_Response = {
  __typename?: 'benchmarkGroupingVerdict_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BenchmarkGroupingVerdict>;
};

/** on_conflict condition type for table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_On_Conflict = {
  constraint: BenchmarkGroupingVerdict_Constraint;
  update_columns?: Array<BenchmarkGroupingVerdict_Update_Column>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};

/** Ordering options when selecting data from "benchmark_grouping_verdict". */
export type BenchmarkGroupingVerdict_Order_By = {
  code?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  evidence?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Order_By>;
  materialId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  producedAt?: InputMaybe<Order_By>;
  requiresReview?: InputMaybe<Order_By>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: benchmark_grouping_verdict */
export type BenchmarkGroupingVerdict_Pk_Columns_Input = {
  materialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
  source: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BenchmarkGroupingVerdict_Prepend_Input = {
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column {
  /** column name */
  code = 'code',
  /** column name */
  confidence = 'confidence',
  /** column name */
  evidence = 'evidence',
  /** column name */
  label = 'label',
  /** column name */
  materialId = 'materialId',
  /** column name */
  modelId = 'modelId',
  /** column name */
  producedAt = 'producedAt',
  /** column name */
  requiresReview = 'requiresReview',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  source = 'source'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_avg_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  confidence = 'confidence'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_bool_and_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  requiresReview = 'requiresReview'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_bool_or_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  requiresReview = 'requiresReview'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_corr_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  confidence = 'confidence'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  confidence = 'confidence'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_max_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  confidence = 'confidence'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_min_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  confidence = 'confidence'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  confidence = 'confidence'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_sum_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  confidence = 'confidence'
}

/** select "benchmarkGroupingVerdict_aggregate_bool_exp_var_samp_arguments_columns" columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Select_Column_BenchmarkGroupingVerdict_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  confidence = 'confidence'
}

/** input type for updating data in table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['float8']['input']>;
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  producedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requiresReview?: InputMaybe<Scalars['Boolean']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type BenchmarkGroupingVerdict_Stddev_Fields = {
  __typename?: 'benchmarkGroupingVerdict_stddev_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Stddev_Order_By = {
  confidence?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type BenchmarkGroupingVerdict_Stddev_Pop_Fields = {
  __typename?: 'benchmarkGroupingVerdict_stddev_pop_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Stddev_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type BenchmarkGroupingVerdict_Stddev_Samp_Fields = {
  __typename?: 'benchmarkGroupingVerdict_stddev_samp_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Stddev_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "benchmarkGroupingVerdict" */
export type BenchmarkGroupingVerdict_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BenchmarkGroupingVerdict_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BenchmarkGroupingVerdict_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['float8']['input']>;
  evidence?: InputMaybe<Scalars['jsonb']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  producedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requiresReview?: InputMaybe<Scalars['Boolean']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type BenchmarkGroupingVerdict_Sum_Fields = {
  __typename?: 'benchmarkGroupingVerdict_sum_fields';
  confidence?: Maybe<Scalars['float8']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Sum_Order_By = {
  confidence?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** update columns of table "benchmark_grouping_verdict" */
export enum BenchmarkGroupingVerdict_Update_Column {
  /** column name */
  code = 'code',
  /** column name */
  confidence = 'confidence',
  /** column name */
  evidence = 'evidence',
  /** column name */
  label = 'label',
  /** column name */
  materialId = 'materialId',
  /** column name */
  modelId = 'modelId',
  /** column name */
  producedAt = 'producedAt',
  /** column name */
  requiresReview = 'requiresReview',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  source = 'source'
}

export type BenchmarkGroupingVerdict_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BenchmarkGroupingVerdict_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BenchmarkGroupingVerdict_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BenchmarkGroupingVerdict_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BenchmarkGroupingVerdict_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BenchmarkGroupingVerdict_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BenchmarkGroupingVerdict_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BenchmarkGroupingVerdict_Set_Input>;
  /** filter the rows which have to be updated */
  where: BenchmarkGroupingVerdict_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BenchmarkGroupingVerdict_Var_Pop_Fields = {
  __typename?: 'benchmarkGroupingVerdict_var_pop_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Var_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type BenchmarkGroupingVerdict_Var_Samp_Fields = {
  __typename?: 'benchmarkGroupingVerdict_var_samp_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Var_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type BenchmarkGroupingVerdict_Variance_Fields = {
  __typename?: 'benchmarkGroupingVerdict_variance_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "benchmark_grouping_verdict" */
export type BenchmarkGroupingVerdict_Variance_Order_By = {
  confidence?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial = {
  __typename?: 'benchmarkInventoryMaterial';
  bimFamily?: Maybe<Scalars['String']['output']>;
  bimProperties?: Maybe<Scalars['jsonb']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  classBuildingPart?: Maybe<Scalars['String']['output']>;
  classCode?: Maybe<Scalars['String']['output']>;
  classCodeId?: Maybe<Scalars['Int']['output']>;
  classLabel?: Maybe<Scalars['String']['output']>;
  classLevel1Code?: Maybe<Scalars['String']['output']>;
  classPath?: Maybe<Array<Scalars['String']['output']>>;
  classSystem?: Maybe<Scalars['String']['output']>;
  classificationConflicts?: Maybe<Scalars['jsonb']['output']>;
  classifications?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doubleCountRisk: Scalars['Boolean']['output'];
  epdDatasources: Array<Scalars['String']['output']>;
  epdDeclarationOwner?: Maybe<Scalars['String']['output']>;
  epdDeclaredUnit?: Maybe<Scalars['String']['output']>;
  epdDeclaredValue?: Maybe<Scalars['float8']['output']>;
  epdDeprecated?: Maybe<Scalars['Boolean']['output']>;
  epdExpectedLife?: Maybe<Scalars['Int']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Int']['output']>;
  epdFaulty?: Maybe<Scalars['Boolean']['output']>;
  epdId?: Maybe<Scalars['uuid']['output']>;
  epdInternalId?: Maybe<Scalars['uuid']['output']>;
  epdIsConstruction?: Maybe<Scalars['Boolean']['output']>;
  epdIsCustom?: Maybe<Scalars['Boolean']['output']>;
  epdMass?: Maybe<Scalars['float8']['output']>;
  epdMassUnit?: Maybe<Scalars['String']['output']>;
  epdMaterialCategory?: Maybe<Scalars['String']['output']>;
  epdName?: Maybe<Scalars['String']['output']>;
  epdNewestVersion?: Maybe<Scalars['Boolean']['output']>;
  epdStandard?: Maybe<Scalars['String']['output']>;
  epdType?: Maybe<Scalars['String']['output']>;
  epdVersion?: Maybe<Scalars['String']['output']>;
  epdVersionNumber?: Maybe<Scalars['Int']['output']>;
  excludedReason?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  groupingVerdicts: Array<BenchmarkGroupingVerdict>;
  /** An aggregate relationship */
  groupingVerdicts_aggregate: BenchmarkGroupingVerdict_Aggregate;
  /** An object relationship */
  gwp?: Maybe<VMaterialGwp>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  includeMapping: Scalars['Boolean']['output'];
  isAutoMapping: Scalars['Boolean']['output'];
  isMapped: Scalars['Boolean']['output'];
  isRecycled: Scalars['Boolean']['output'];
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  lifetimeYears?: Maybe<Scalars['Int']['output']>;
  mappingFactor?: Maybe<Scalars['float8']['output']>;
  materialCount?: Maybe<Scalars['Int']['output']>;
  materialId: Scalars['uuid']['output'];
  materialIdentifier?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  materialMappings: Array<BenchmarkMaterialMapping>;
  /** An aggregate relationship */
  materialMappings_aggregate: BenchmarkMaterialMapping_Aggregate;
  materialSource?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  moduleStatus?: Maybe<Scalars['jsonb']['output']>;
  normArea?: Maybe<Scalars['float8']['output']>;
  normPeriod?: Maybe<Scalars['Int']['output']>;
  numberOfReplacements?: Maybe<Scalars['Int']['output']>;
  originalCaptured?: Maybe<Scalars['Boolean']['output']>;
  originalQuantities?: Maybe<Scalars['jsonb']['output']>;
  preferredUnit?: Maybe<Scalars['String']['output']>;
  preferredValue?: Maybe<Scalars['float8']['output']>;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  projectState?: Maybe<BenchmarkProjectState>;
  provenanceChanges?: Maybe<Scalars['jsonb']['output']>;
  quantities?: Maybe<Scalars['jsonb']['output']>;
  rowKind: Scalars['String']['output'];
  /** An object relationship */
  snapshot?: Maybe<BenchmarkSnapshot>;
  snapshotId: Scalars['bigint']['output'];
  sourceChanged?: Maybe<Scalars['Boolean']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  status?: Maybe<VMaterialStatus>;
  tags: Array<Scalars['String']['output']>;
  transportSources: Array<Scalars['String']['output']>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
  typeMappedKinds: Array<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
  unrecognisedParams?: Maybe<Scalars['jsonb']['output']>;
  valueChanged?: Maybe<Scalars['Boolean']['output']>;
  wastePercentage?: Maybe<Scalars['float8']['output']>;
  weightKg?: Maybe<Scalars['float8']['output']>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialBimPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialClassificationConflictsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialClassificationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialGroupingVerdictsArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkGroupingVerdict_Order_By>>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialGroupingVerdicts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkGroupingVerdict_Order_By>>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialMaterialMappingsArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkMaterialMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkMaterialMapping_Order_By>>;
  where?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialMaterialMappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkMaterialMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkMaterialMapping_Order_By>>;
  where?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialModuleStatusArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialOriginalQuantitiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialProvenanceChangesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialQuantitiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterialUnrecognisedParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Aggregate = {
  __typename?: 'benchmarkInventoryMaterial_aggregate';
  aggregate?: Maybe<BenchmarkInventoryMaterial_Aggregate_Fields>;
  nodes: Array<BenchmarkInventoryMaterial>;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp = {
  avg?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Var_Samp>;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Avg = {
  arguments: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Bool_And = {
  arguments: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Bool_Or = {
  arguments: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Corr = {
  arguments: BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Corr_Arguments = {
  X: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Max = {
  arguments: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Min = {
  arguments: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Sum = {
  arguments: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Var_Samp = {
  arguments: BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Aggregate_Fields = {
  __typename?: 'benchmarkInventoryMaterial_aggregate_fields';
  avg?: Maybe<BenchmarkInventoryMaterial_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BenchmarkInventoryMaterial_Max_Fields>;
  min?: Maybe<BenchmarkInventoryMaterial_Min_Fields>;
  stddev?: Maybe<BenchmarkInventoryMaterial_Stddev_Fields>;
  stddev_pop?: Maybe<BenchmarkInventoryMaterial_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BenchmarkInventoryMaterial_Stddev_Samp_Fields>;
  sum?: Maybe<BenchmarkInventoryMaterial_Sum_Fields>;
  var_pop?: Maybe<BenchmarkInventoryMaterial_Var_Pop_Fields>;
  var_samp?: Maybe<BenchmarkInventoryMaterial_Var_Samp_Fields>;
  variance?: Maybe<BenchmarkInventoryMaterial_Variance_Fields>;
};


/** aggregate fields of "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Aggregate_Order_By = {
  avg?: InputMaybe<BenchmarkInventoryMaterial_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<BenchmarkInventoryMaterial_Max_Order_By>;
  min?: InputMaybe<BenchmarkInventoryMaterial_Min_Order_By>;
  stddev?: InputMaybe<BenchmarkInventoryMaterial_Stddev_Order_By>;
  stddev_pop?: InputMaybe<BenchmarkInventoryMaterial_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<BenchmarkInventoryMaterial_Stddev_Samp_Order_By>;
  sum?: InputMaybe<BenchmarkInventoryMaterial_Sum_Order_By>;
  var_pop?: InputMaybe<BenchmarkInventoryMaterial_Var_Pop_Order_By>;
  var_samp?: InputMaybe<BenchmarkInventoryMaterial_Var_Samp_Order_By>;
  variance?: InputMaybe<BenchmarkInventoryMaterial_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BenchmarkInventoryMaterial_Append_Input = {
  bimProperties?: InputMaybe<Scalars['jsonb']['input']>;
  classificationConflicts?: InputMaybe<Scalars['jsonb']['input']>;
  classifications?: InputMaybe<Scalars['jsonb']['input']>;
  moduleStatus?: InputMaybe<Scalars['jsonb']['input']>;
  originalQuantities?: InputMaybe<Scalars['jsonb']['input']>;
  provenanceChanges?: InputMaybe<Scalars['jsonb']['input']>;
  quantities?: InputMaybe<Scalars['jsonb']['input']>;
  unrecognisedParams?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Arr_Rel_Insert_Input = {
  data: Array<BenchmarkInventoryMaterial_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<BenchmarkInventoryMaterial_On_Conflict>;
};

/** aggregate avg on columns */
export type BenchmarkInventoryMaterial_Avg_Fields = {
  __typename?: 'benchmarkInventoryMaterial_avg_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Avg_Order_By = {
  classCodeId?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "benchmark_inventory_material". All fields are combined with a logical 'AND'. */
export type BenchmarkInventoryMaterial_Bool_Exp = {
  _and?: InputMaybe<Array<BenchmarkInventoryMaterial_Bool_Exp>>;
  _not?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  _or?: InputMaybe<Array<BenchmarkInventoryMaterial_Bool_Exp>>;
  bimFamily?: InputMaybe<String_Comparison_Exp>;
  bimProperties?: InputMaybe<Jsonb_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  classBuildingPart?: InputMaybe<String_Comparison_Exp>;
  classCode?: InputMaybe<String_Comparison_Exp>;
  classCodeId?: InputMaybe<Int_Comparison_Exp>;
  classLabel?: InputMaybe<String_Comparison_Exp>;
  classLevel1Code?: InputMaybe<String_Comparison_Exp>;
  classPath?: InputMaybe<String_Array_Comparison_Exp>;
  classSystem?: InputMaybe<String_Comparison_Exp>;
  classificationConflicts?: InputMaybe<Jsonb_Comparison_Exp>;
  classifications?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  doubleCountRisk?: InputMaybe<Boolean_Comparison_Exp>;
  epdDatasources?: InputMaybe<String_Array_Comparison_Exp>;
  epdDeclarationOwner?: InputMaybe<String_Comparison_Exp>;
  epdDeclaredUnit?: InputMaybe<String_Comparison_Exp>;
  epdDeclaredValue?: InputMaybe<Float8_Comparison_Exp>;
  epdDeprecated?: InputMaybe<Boolean_Comparison_Exp>;
  epdExpectedLife?: InputMaybe<Int_Comparison_Exp>;
  epdExpectedLifespan?: InputMaybe<Int_Comparison_Exp>;
  epdFaulty?: InputMaybe<Boolean_Comparison_Exp>;
  epdId?: InputMaybe<Uuid_Comparison_Exp>;
  epdInternalId?: InputMaybe<Uuid_Comparison_Exp>;
  epdIsConstruction?: InputMaybe<Boolean_Comparison_Exp>;
  epdIsCustom?: InputMaybe<Boolean_Comparison_Exp>;
  epdMass?: InputMaybe<Float8_Comparison_Exp>;
  epdMassUnit?: InputMaybe<String_Comparison_Exp>;
  epdMaterialCategory?: InputMaybe<String_Comparison_Exp>;
  epdName?: InputMaybe<String_Comparison_Exp>;
  epdNewestVersion?: InputMaybe<Boolean_Comparison_Exp>;
  epdStandard?: InputMaybe<String_Comparison_Exp>;
  epdType?: InputMaybe<String_Comparison_Exp>;
  epdVersion?: InputMaybe<String_Comparison_Exp>;
  epdVersionNumber?: InputMaybe<Int_Comparison_Exp>;
  excludedReason?: InputMaybe<String_Comparison_Exp>;
  groupingVerdicts?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  groupingVerdicts_aggregate?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp>;
  gwp?: InputMaybe<VMaterialGwp_Bool_Exp>;
  gwpA1a3?: InputMaybe<Float8_Comparison_Exp>;
  gwpA4?: InputMaybe<Float8_Comparison_Exp>;
  gwpA5?: InputMaybe<Float8_Comparison_Exp>;
  gwpB1?: InputMaybe<Float8_Comparison_Exp>;
  gwpB2?: InputMaybe<Float8_Comparison_Exp>;
  gwpB3?: InputMaybe<Float8_Comparison_Exp>;
  gwpB4?: InputMaybe<Float8_Comparison_Exp>;
  gwpB5?: InputMaybe<Float8_Comparison_Exp>;
  gwpB6?: InputMaybe<Float8_Comparison_Exp>;
  gwpB7?: InputMaybe<Float8_Comparison_Exp>;
  gwpC1?: InputMaybe<Float8_Comparison_Exp>;
  gwpC2?: InputMaybe<Float8_Comparison_Exp>;
  gwpC3?: InputMaybe<Float8_Comparison_Exp>;
  gwpC4?: InputMaybe<Float8_Comparison_Exp>;
  gwpD?: InputMaybe<Float8_Comparison_Exp>;
  includeMapping?: InputMaybe<Boolean_Comparison_Exp>;
  isAutoMapping?: InputMaybe<Boolean_Comparison_Exp>;
  isMapped?: InputMaybe<Boolean_Comparison_Exp>;
  isRecycled?: InputMaybe<Boolean_Comparison_Exp>;
  lifetimeOffset?: InputMaybe<Int_Comparison_Exp>;
  lifetimeYears?: InputMaybe<Int_Comparison_Exp>;
  mappingFactor?: InputMaybe<Float8_Comparison_Exp>;
  materialCount?: InputMaybe<Int_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  materialIdentifier?: InputMaybe<String_Comparison_Exp>;
  materialMappings?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  materialMappings_aggregate?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp>;
  materialSource?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  moduleStatus?: InputMaybe<Jsonb_Comparison_Exp>;
  normArea?: InputMaybe<Float8_Comparison_Exp>;
  normPeriod?: InputMaybe<Int_Comparison_Exp>;
  numberOfReplacements?: InputMaybe<Int_Comparison_Exp>;
  originalCaptured?: InputMaybe<Boolean_Comparison_Exp>;
  originalQuantities?: InputMaybe<Jsonb_Comparison_Exp>;
  preferredUnit?: InputMaybe<String_Comparison_Exp>;
  preferredValue?: InputMaybe<Float8_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  projectState?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  provenanceChanges?: InputMaybe<Jsonb_Comparison_Exp>;
  quantities?: InputMaybe<Jsonb_Comparison_Exp>;
  rowKind?: InputMaybe<String_Comparison_Exp>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
  sourceChanged?: InputMaybe<Boolean_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<VMaterialStatus_Bool_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  transportSources?: InputMaybe<String_Array_Comparison_Exp>;
  typeIdentifier?: InputMaybe<String_Comparison_Exp>;
  typeMappedKinds?: InputMaybe<String_Array_Comparison_Exp>;
  typeMaterialIdentifier?: InputMaybe<String_Comparison_Exp>;
  unrecognisedParams?: InputMaybe<Jsonb_Comparison_Exp>;
  valueChanged?: InputMaybe<Boolean_Comparison_Exp>;
  wastePercentage?: InputMaybe<Float8_Comparison_Exp>;
  weightKg?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Constraint {
  /** unique or primary key constraint on columns "snapshot_id", "material_id" */
  benchmark_inventory_material_pkey = 'benchmark_inventory_material_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BenchmarkInventoryMaterial_Delete_At_Path_Input = {
  bimProperties?: InputMaybe<Array<Scalars['String']['input']>>;
  classificationConflicts?: InputMaybe<Array<Scalars['String']['input']>>;
  classifications?: InputMaybe<Array<Scalars['String']['input']>>;
  moduleStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  originalQuantities?: InputMaybe<Array<Scalars['String']['input']>>;
  provenanceChanges?: InputMaybe<Array<Scalars['String']['input']>>;
  quantities?: InputMaybe<Array<Scalars['String']['input']>>;
  unrecognisedParams?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BenchmarkInventoryMaterial_Delete_Elem_Input = {
  bimProperties?: InputMaybe<Scalars['Int']['input']>;
  classificationConflicts?: InputMaybe<Scalars['Int']['input']>;
  classifications?: InputMaybe<Scalars['Int']['input']>;
  moduleStatus?: InputMaybe<Scalars['Int']['input']>;
  originalQuantities?: InputMaybe<Scalars['Int']['input']>;
  provenanceChanges?: InputMaybe<Scalars['Int']['input']>;
  quantities?: InputMaybe<Scalars['Int']['input']>;
  unrecognisedParams?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BenchmarkInventoryMaterial_Delete_Key_Input = {
  bimProperties?: InputMaybe<Scalars['String']['input']>;
  classificationConflicts?: InputMaybe<Scalars['String']['input']>;
  classifications?: InputMaybe<Scalars['String']['input']>;
  moduleStatus?: InputMaybe<Scalars['String']['input']>;
  originalQuantities?: InputMaybe<Scalars['String']['input']>;
  provenanceChanges?: InputMaybe<Scalars['String']['input']>;
  quantities?: InputMaybe<Scalars['String']['input']>;
  unrecognisedParams?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Inc_Input = {
  classCodeId?: InputMaybe<Scalars['Int']['input']>;
  epdDeclaredValue?: InputMaybe<Scalars['float8']['input']>;
  epdExpectedLife?: InputMaybe<Scalars['Int']['input']>;
  epdExpectedLifespan?: InputMaybe<Scalars['Int']['input']>;
  epdMass?: InputMaybe<Scalars['float8']['input']>;
  epdVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  gwpA1a3?: InputMaybe<Scalars['float8']['input']>;
  gwpA4?: InputMaybe<Scalars['float8']['input']>;
  gwpA5?: InputMaybe<Scalars['float8']['input']>;
  gwpB1?: InputMaybe<Scalars['float8']['input']>;
  gwpB2?: InputMaybe<Scalars['float8']['input']>;
  gwpB3?: InputMaybe<Scalars['float8']['input']>;
  gwpB4?: InputMaybe<Scalars['float8']['input']>;
  gwpB5?: InputMaybe<Scalars['float8']['input']>;
  gwpB6?: InputMaybe<Scalars['float8']['input']>;
  gwpB7?: InputMaybe<Scalars['float8']['input']>;
  gwpC1?: InputMaybe<Scalars['float8']['input']>;
  gwpC2?: InputMaybe<Scalars['float8']['input']>;
  gwpC3?: InputMaybe<Scalars['float8']['input']>;
  gwpC4?: InputMaybe<Scalars['float8']['input']>;
  gwpD?: InputMaybe<Scalars['float8']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  lifetimeYears?: InputMaybe<Scalars['Int']['input']>;
  mappingFactor?: InputMaybe<Scalars['float8']['input']>;
  materialCount?: InputMaybe<Scalars['Int']['input']>;
  normArea?: InputMaybe<Scalars['float8']['input']>;
  normPeriod?: InputMaybe<Scalars['Int']['input']>;
  numberOfReplacements?: InputMaybe<Scalars['Int']['input']>;
  preferredValue?: InputMaybe<Scalars['float8']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  wastePercentage?: InputMaybe<Scalars['float8']['input']>;
  weightKg?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Insert_Input = {
  bimProperties?: InputMaybe<Scalars['jsonb']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  classBuildingPart?: InputMaybe<Scalars['String']['input']>;
  classCode?: InputMaybe<Scalars['String']['input']>;
  classCodeId?: InputMaybe<Scalars['Int']['input']>;
  classLabel?: InputMaybe<Scalars['String']['input']>;
  classLevel1Code?: InputMaybe<Scalars['String']['input']>;
  classPath?: InputMaybe<Array<Scalars['String']['input']>>;
  classSystem?: InputMaybe<Scalars['String']['input']>;
  classificationConflicts?: InputMaybe<Scalars['jsonb']['input']>;
  classifications?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  doubleCountRisk?: InputMaybe<Scalars['Boolean']['input']>;
  epdDatasources?: InputMaybe<Array<Scalars['String']['input']>>;
  epdDeclarationOwner?: InputMaybe<Scalars['String']['input']>;
  epdDeclaredUnit?: InputMaybe<Scalars['String']['input']>;
  epdDeclaredValue?: InputMaybe<Scalars['float8']['input']>;
  epdDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  epdExpectedLife?: InputMaybe<Scalars['Int']['input']>;
  epdExpectedLifespan?: InputMaybe<Scalars['Int']['input']>;
  epdFaulty?: InputMaybe<Scalars['Boolean']['input']>;
  epdId?: InputMaybe<Scalars['uuid']['input']>;
  epdInternalId?: InputMaybe<Scalars['uuid']['input']>;
  epdIsConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  epdIsCustom?: InputMaybe<Scalars['Boolean']['input']>;
  epdMass?: InputMaybe<Scalars['float8']['input']>;
  epdMassUnit?: InputMaybe<Scalars['String']['input']>;
  epdMaterialCategory?: InputMaybe<Scalars['String']['input']>;
  epdName?: InputMaybe<Scalars['String']['input']>;
  epdNewestVersion?: InputMaybe<Scalars['Boolean']['input']>;
  epdStandard?: InputMaybe<Scalars['String']['input']>;
  epdType?: InputMaybe<Scalars['String']['input']>;
  epdVersion?: InputMaybe<Scalars['String']['input']>;
  epdVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  excludedReason?: InputMaybe<Scalars['String']['input']>;
  groupingVerdicts?: InputMaybe<BenchmarkGroupingVerdict_Arr_Rel_Insert_Input>;
  gwp?: InputMaybe<VMaterialGwp_Obj_Rel_Insert_Input>;
  gwpA1a3?: InputMaybe<Scalars['float8']['input']>;
  gwpA4?: InputMaybe<Scalars['float8']['input']>;
  gwpA5?: InputMaybe<Scalars['float8']['input']>;
  gwpB1?: InputMaybe<Scalars['float8']['input']>;
  gwpB2?: InputMaybe<Scalars['float8']['input']>;
  gwpB3?: InputMaybe<Scalars['float8']['input']>;
  gwpB4?: InputMaybe<Scalars['float8']['input']>;
  gwpB5?: InputMaybe<Scalars['float8']['input']>;
  gwpB6?: InputMaybe<Scalars['float8']['input']>;
  gwpB7?: InputMaybe<Scalars['float8']['input']>;
  gwpC1?: InputMaybe<Scalars['float8']['input']>;
  gwpC2?: InputMaybe<Scalars['float8']['input']>;
  gwpC3?: InputMaybe<Scalars['float8']['input']>;
  gwpC4?: InputMaybe<Scalars['float8']['input']>;
  gwpD?: InputMaybe<Scalars['float8']['input']>;
  includeMapping?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoMapping?: InputMaybe<Scalars['Boolean']['input']>;
  isMapped?: InputMaybe<Scalars['Boolean']['input']>;
  isRecycled?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  lifetimeYears?: InputMaybe<Scalars['Int']['input']>;
  mappingFactor?: InputMaybe<Scalars['float8']['input']>;
  materialCount?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialIdentifier?: InputMaybe<Scalars['String']['input']>;
  materialMappings?: InputMaybe<BenchmarkMaterialMapping_Arr_Rel_Insert_Input>;
  materialSource?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  moduleStatus?: InputMaybe<Scalars['jsonb']['input']>;
  normArea?: InputMaybe<Scalars['float8']['input']>;
  normPeriod?: InputMaybe<Scalars['Int']['input']>;
  numberOfReplacements?: InputMaybe<Scalars['Int']['input']>;
  originalCaptured?: InputMaybe<Scalars['Boolean']['input']>;
  originalQuantities?: InputMaybe<Scalars['jsonb']['input']>;
  preferredUnit?: InputMaybe<Scalars['String']['input']>;
  preferredValue?: InputMaybe<Scalars['float8']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectState?: InputMaybe<BenchmarkProjectState_Obj_Rel_Insert_Input>;
  provenanceChanges?: InputMaybe<Scalars['jsonb']['input']>;
  quantities?: InputMaybe<Scalars['jsonb']['input']>;
  rowKind?: InputMaybe<Scalars['String']['input']>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Obj_Rel_Insert_Input>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  sourceChanged?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VMaterialStatus_Obj_Rel_Insert_Input>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  transportSources?: InputMaybe<Array<Scalars['String']['input']>>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
  typeMappedKinds?: InputMaybe<Array<Scalars['String']['input']>>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
  unrecognisedParams?: InputMaybe<Scalars['jsonb']['input']>;
  valueChanged?: InputMaybe<Scalars['Boolean']['input']>;
  wastePercentage?: InputMaybe<Scalars['float8']['input']>;
  weightKg?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type BenchmarkInventoryMaterial_Max_Fields = {
  __typename?: 'benchmarkInventoryMaterial_max_fields';
  bimFamily?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  classBuildingPart?: Maybe<Scalars['String']['output']>;
  classCode?: Maybe<Scalars['String']['output']>;
  classCodeId?: Maybe<Scalars['Int']['output']>;
  classLabel?: Maybe<Scalars['String']['output']>;
  classLevel1Code?: Maybe<Scalars['String']['output']>;
  classPath?: Maybe<Array<Scalars['String']['output']>>;
  classSystem?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  epdDatasources?: Maybe<Array<Scalars['String']['output']>>;
  epdDeclarationOwner?: Maybe<Scalars['String']['output']>;
  epdDeclaredUnit?: Maybe<Scalars['String']['output']>;
  epdDeclaredValue?: Maybe<Scalars['float8']['output']>;
  epdExpectedLife?: Maybe<Scalars['Int']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Int']['output']>;
  epdId?: Maybe<Scalars['uuid']['output']>;
  epdInternalId?: Maybe<Scalars['uuid']['output']>;
  epdMass?: Maybe<Scalars['float8']['output']>;
  epdMassUnit?: Maybe<Scalars['String']['output']>;
  epdMaterialCategory?: Maybe<Scalars['String']['output']>;
  epdName?: Maybe<Scalars['String']['output']>;
  epdStandard?: Maybe<Scalars['String']['output']>;
  epdType?: Maybe<Scalars['String']['output']>;
  epdVersion?: Maybe<Scalars['String']['output']>;
  epdVersionNumber?: Maybe<Scalars['Int']['output']>;
  excludedReason?: Maybe<Scalars['String']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  lifetimeYears?: Maybe<Scalars['Int']['output']>;
  mappingFactor?: Maybe<Scalars['float8']['output']>;
  materialCount?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialIdentifier?: Maybe<Scalars['String']['output']>;
  materialSource?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  normArea?: Maybe<Scalars['float8']['output']>;
  normPeriod?: Maybe<Scalars['Int']['output']>;
  numberOfReplacements?: Maybe<Scalars['Int']['output']>;
  preferredUnit?: Maybe<Scalars['String']['output']>;
  preferredValue?: Maybe<Scalars['float8']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  rowKind?: Maybe<Scalars['String']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  transportSources?: Maybe<Array<Scalars['String']['output']>>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
  typeMappedKinds?: Maybe<Array<Scalars['String']['output']>>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
  wastePercentage?: Maybe<Scalars['float8']['output']>;
  weightKg?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Max_Order_By = {
  bimFamily?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  classBuildingPart?: InputMaybe<Order_By>;
  classCode?: InputMaybe<Order_By>;
  classCodeId?: InputMaybe<Order_By>;
  classLabel?: InputMaybe<Order_By>;
  classLevel1Code?: InputMaybe<Order_By>;
  classPath?: InputMaybe<Order_By>;
  classSystem?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  epdDatasources?: InputMaybe<Order_By>;
  epdDeclarationOwner?: InputMaybe<Order_By>;
  epdDeclaredUnit?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdId?: InputMaybe<Order_By>;
  epdInternalId?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdMassUnit?: InputMaybe<Order_By>;
  epdMaterialCategory?: InputMaybe<Order_By>;
  epdName?: InputMaybe<Order_By>;
  epdStandard?: InputMaybe<Order_By>;
  epdType?: InputMaybe<Order_By>;
  epdVersion?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  excludedReason?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  materialIdentifier?: InputMaybe<Order_By>;
  materialSource?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredUnit?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  rowKind?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  transportSources?: InputMaybe<Order_By>;
  typeIdentifier?: InputMaybe<Order_By>;
  typeMappedKinds?: InputMaybe<Order_By>;
  typeMaterialIdentifier?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type BenchmarkInventoryMaterial_Min_Fields = {
  __typename?: 'benchmarkInventoryMaterial_min_fields';
  bimFamily?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  classBuildingPart?: Maybe<Scalars['String']['output']>;
  classCode?: Maybe<Scalars['String']['output']>;
  classCodeId?: Maybe<Scalars['Int']['output']>;
  classLabel?: Maybe<Scalars['String']['output']>;
  classLevel1Code?: Maybe<Scalars['String']['output']>;
  classPath?: Maybe<Array<Scalars['String']['output']>>;
  classSystem?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  epdDatasources?: Maybe<Array<Scalars['String']['output']>>;
  epdDeclarationOwner?: Maybe<Scalars['String']['output']>;
  epdDeclaredUnit?: Maybe<Scalars['String']['output']>;
  epdDeclaredValue?: Maybe<Scalars['float8']['output']>;
  epdExpectedLife?: Maybe<Scalars['Int']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Int']['output']>;
  epdId?: Maybe<Scalars['uuid']['output']>;
  epdInternalId?: Maybe<Scalars['uuid']['output']>;
  epdMass?: Maybe<Scalars['float8']['output']>;
  epdMassUnit?: Maybe<Scalars['String']['output']>;
  epdMaterialCategory?: Maybe<Scalars['String']['output']>;
  epdName?: Maybe<Scalars['String']['output']>;
  epdStandard?: Maybe<Scalars['String']['output']>;
  epdType?: Maybe<Scalars['String']['output']>;
  epdVersion?: Maybe<Scalars['String']['output']>;
  epdVersionNumber?: Maybe<Scalars['Int']['output']>;
  excludedReason?: Maybe<Scalars['String']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  lifetimeYears?: Maybe<Scalars['Int']['output']>;
  mappingFactor?: Maybe<Scalars['float8']['output']>;
  materialCount?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialIdentifier?: Maybe<Scalars['String']['output']>;
  materialSource?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  normArea?: Maybe<Scalars['float8']['output']>;
  normPeriod?: Maybe<Scalars['Int']['output']>;
  numberOfReplacements?: Maybe<Scalars['Int']['output']>;
  preferredUnit?: Maybe<Scalars['String']['output']>;
  preferredValue?: Maybe<Scalars['float8']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  rowKind?: Maybe<Scalars['String']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  transportSources?: Maybe<Array<Scalars['String']['output']>>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
  typeMappedKinds?: Maybe<Array<Scalars['String']['output']>>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
  wastePercentage?: Maybe<Scalars['float8']['output']>;
  weightKg?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Min_Order_By = {
  bimFamily?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  classBuildingPart?: InputMaybe<Order_By>;
  classCode?: InputMaybe<Order_By>;
  classCodeId?: InputMaybe<Order_By>;
  classLabel?: InputMaybe<Order_By>;
  classLevel1Code?: InputMaybe<Order_By>;
  classPath?: InputMaybe<Order_By>;
  classSystem?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  epdDatasources?: InputMaybe<Order_By>;
  epdDeclarationOwner?: InputMaybe<Order_By>;
  epdDeclaredUnit?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdId?: InputMaybe<Order_By>;
  epdInternalId?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdMassUnit?: InputMaybe<Order_By>;
  epdMaterialCategory?: InputMaybe<Order_By>;
  epdName?: InputMaybe<Order_By>;
  epdStandard?: InputMaybe<Order_By>;
  epdType?: InputMaybe<Order_By>;
  epdVersion?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  excludedReason?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  materialIdentifier?: InputMaybe<Order_By>;
  materialSource?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredUnit?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  rowKind?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  transportSources?: InputMaybe<Order_By>;
  typeIdentifier?: InputMaybe<Order_By>;
  typeMappedKinds?: InputMaybe<Order_By>;
  typeMaterialIdentifier?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Mutation_Response = {
  __typename?: 'benchmarkInventoryMaterial_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BenchmarkInventoryMaterial>;
};

/** input type for inserting object relation for remote table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Obj_Rel_Insert_Input = {
  data: BenchmarkInventoryMaterial_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BenchmarkInventoryMaterial_On_Conflict>;
};

/** on_conflict condition type for table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_On_Conflict = {
  constraint: BenchmarkInventoryMaterial_Constraint;
  update_columns?: Array<BenchmarkInventoryMaterial_Update_Column>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};

/** Ordering options when selecting data from "benchmark_inventory_material". */
export type BenchmarkInventoryMaterial_Order_By = {
  bimFamily?: InputMaybe<Order_By>;
  bimProperties?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  classBuildingPart?: InputMaybe<Order_By>;
  classCode?: InputMaybe<Order_By>;
  classCodeId?: InputMaybe<Order_By>;
  classLabel?: InputMaybe<Order_By>;
  classLevel1Code?: InputMaybe<Order_By>;
  classPath?: InputMaybe<Order_By>;
  classSystem?: InputMaybe<Order_By>;
  classificationConflicts?: InputMaybe<Order_By>;
  classifications?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doubleCountRisk?: InputMaybe<Order_By>;
  epdDatasources?: InputMaybe<Order_By>;
  epdDeclarationOwner?: InputMaybe<Order_By>;
  epdDeclaredUnit?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdDeprecated?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdFaulty?: InputMaybe<Order_By>;
  epdId?: InputMaybe<Order_By>;
  epdInternalId?: InputMaybe<Order_By>;
  epdIsConstruction?: InputMaybe<Order_By>;
  epdIsCustom?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdMassUnit?: InputMaybe<Order_By>;
  epdMaterialCategory?: InputMaybe<Order_By>;
  epdName?: InputMaybe<Order_By>;
  epdNewestVersion?: InputMaybe<Order_By>;
  epdStandard?: InputMaybe<Order_By>;
  epdType?: InputMaybe<Order_By>;
  epdVersion?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  excludedReason?: InputMaybe<Order_By>;
  groupingVerdicts_aggregate?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Order_By>;
  gwp?: InputMaybe<VMaterialGwp_Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  includeMapping?: InputMaybe<Order_By>;
  isAutoMapping?: InputMaybe<Order_By>;
  isMapped?: InputMaybe<Order_By>;
  isRecycled?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  materialIdentifier?: InputMaybe<Order_By>;
  materialMappings_aggregate?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Order_By>;
  materialSource?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  moduleStatus?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  originalCaptured?: InputMaybe<Order_By>;
  originalQuantities?: InputMaybe<Order_By>;
  preferredUnit?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectState?: InputMaybe<BenchmarkProjectState_Order_By>;
  provenanceChanges?: InputMaybe<Order_By>;
  quantities?: InputMaybe<Order_By>;
  rowKind?: InputMaybe<Order_By>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  sourceChanged?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  status?: InputMaybe<VMaterialStatus_Order_By>;
  tags?: InputMaybe<Order_By>;
  transportSources?: InputMaybe<Order_By>;
  typeIdentifier?: InputMaybe<Order_By>;
  typeMappedKinds?: InputMaybe<Order_By>;
  typeMaterialIdentifier?: InputMaybe<Order_By>;
  unrecognisedParams?: InputMaybe<Order_By>;
  valueChanged?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** primary key columns input for table: benchmark_inventory_material */
export type BenchmarkInventoryMaterial_Pk_Columns_Input = {
  materialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BenchmarkInventoryMaterial_Prepend_Input = {
  bimProperties?: InputMaybe<Scalars['jsonb']['input']>;
  classificationConflicts?: InputMaybe<Scalars['jsonb']['input']>;
  classifications?: InputMaybe<Scalars['jsonb']['input']>;
  moduleStatus?: InputMaybe<Scalars['jsonb']['input']>;
  originalQuantities?: InputMaybe<Scalars['jsonb']['input']>;
  provenanceChanges?: InputMaybe<Scalars['jsonb']['input']>;
  quantities?: InputMaybe<Scalars['jsonb']['input']>;
  unrecognisedParams?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column {
  /** column name */
  bimFamily = 'bimFamily',
  /** column name */
  bimProperties = 'bimProperties',
  /** column name */
  category = 'category',
  /** column name */
  classBuildingPart = 'classBuildingPart',
  /** column name */
  classCode = 'classCode',
  /** column name */
  classCodeId = 'classCodeId',
  /** column name */
  classLabel = 'classLabel',
  /** column name */
  classLevel1Code = 'classLevel1Code',
  /** column name */
  classPath = 'classPath',
  /** column name */
  classSystem = 'classSystem',
  /** column name */
  classificationConflicts = 'classificationConflicts',
  /** column name */
  classifications = 'classifications',
  /** column name */
  description = 'description',
  /** column name */
  doubleCountRisk = 'doubleCountRisk',
  /** column name */
  epdDatasources = 'epdDatasources',
  /** column name */
  epdDeclarationOwner = 'epdDeclarationOwner',
  /** column name */
  epdDeclaredUnit = 'epdDeclaredUnit',
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdDeprecated = 'epdDeprecated',
  /** column name */
  epdExpectedLife = 'epdExpectedLife',
  /** column name */
  epdExpectedLifespan = 'epdExpectedLifespan',
  /** column name */
  epdFaulty = 'epdFaulty',
  /** column name */
  epdId = 'epdId',
  /** column name */
  epdInternalId = 'epdInternalId',
  /** column name */
  epdIsConstruction = 'epdIsConstruction',
  /** column name */
  epdIsCustom = 'epdIsCustom',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  epdMassUnit = 'epdMassUnit',
  /** column name */
  epdMaterialCategory = 'epdMaterialCategory',
  /** column name */
  epdName = 'epdName',
  /** column name */
  epdNewestVersion = 'epdNewestVersion',
  /** column name */
  epdStandard = 'epdStandard',
  /** column name */
  epdType = 'epdType',
  /** column name */
  epdVersion = 'epdVersion',
  /** column name */
  epdVersionNumber = 'epdVersionNumber',
  /** column name */
  excludedReason = 'excludedReason',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  includeMapping = 'includeMapping',
  /** column name */
  isAutoMapping = 'isAutoMapping',
  /** column name */
  isMapped = 'isMapped',
  /** column name */
  isRecycled = 'isRecycled',
  /** column name */
  lifetimeOffset = 'lifetimeOffset',
  /** column name */
  lifetimeYears = 'lifetimeYears',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  materialCount = 'materialCount',
  /** column name */
  materialId = 'materialId',
  /** column name */
  materialIdentifier = 'materialIdentifier',
  /** column name */
  materialSource = 'materialSource',
  /** column name */
  model = 'model',
  /** column name */
  moduleStatus = 'moduleStatus',
  /** column name */
  normArea = 'normArea',
  /** column name */
  normPeriod = 'normPeriod',
  /** column name */
  numberOfReplacements = 'numberOfReplacements',
  /** column name */
  originalCaptured = 'originalCaptured',
  /** column name */
  originalQuantities = 'originalQuantities',
  /** column name */
  preferredUnit = 'preferredUnit',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  projectId = 'projectId',
  /** column name */
  provenanceChanges = 'provenanceChanges',
  /** column name */
  quantities = 'quantities',
  /** column name */
  rowKind = 'rowKind',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  sourceChanged = 'sourceChanged',
  /** column name */
  stage = 'stage',
  /** column name */
  tags = 'tags',
  /** column name */
  transportSources = 'transportSources',
  /** column name */
  typeIdentifier = 'typeIdentifier',
  /** column name */
  typeMappedKinds = 'typeMappedKinds',
  /** column name */
  typeMaterialIdentifier = 'typeMaterialIdentifier',
  /** column name */
  unrecognisedParams = 'unrecognisedParams',
  /** column name */
  valueChanged = 'valueChanged',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_avg_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  normArea = 'normArea',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_bool_and_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  doubleCountRisk = 'doubleCountRisk',
  /** column name */
  epdDeprecated = 'epdDeprecated',
  /** column name */
  epdFaulty = 'epdFaulty',
  /** column name */
  epdIsConstruction = 'epdIsConstruction',
  /** column name */
  epdIsCustom = 'epdIsCustom',
  /** column name */
  epdNewestVersion = 'epdNewestVersion',
  /** column name */
  includeMapping = 'includeMapping',
  /** column name */
  isAutoMapping = 'isAutoMapping',
  /** column name */
  isMapped = 'isMapped',
  /** column name */
  isRecycled = 'isRecycled',
  /** column name */
  originalCaptured = 'originalCaptured',
  /** column name */
  sourceChanged = 'sourceChanged',
  /** column name */
  valueChanged = 'valueChanged'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_bool_or_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  doubleCountRisk = 'doubleCountRisk',
  /** column name */
  epdDeprecated = 'epdDeprecated',
  /** column name */
  epdFaulty = 'epdFaulty',
  /** column name */
  epdIsConstruction = 'epdIsConstruction',
  /** column name */
  epdIsCustom = 'epdIsCustom',
  /** column name */
  epdNewestVersion = 'epdNewestVersion',
  /** column name */
  includeMapping = 'includeMapping',
  /** column name */
  isAutoMapping = 'isAutoMapping',
  /** column name */
  isMapped = 'isMapped',
  /** column name */
  isRecycled = 'isRecycled',
  /** column name */
  originalCaptured = 'originalCaptured',
  /** column name */
  sourceChanged = 'sourceChanged',
  /** column name */
  valueChanged = 'valueChanged'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_corr_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  normArea = 'normArea',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  normArea = 'normArea',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_max_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  normArea = 'normArea',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_min_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  normArea = 'normArea',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  normArea = 'normArea',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_sum_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  normArea = 'normArea',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** select "benchmarkInventoryMaterial_aggregate_bool_exp_var_samp_arguments_columns" columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Select_Column_BenchmarkInventoryMaterial_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  normArea = 'normArea',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** input type for updating data in table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Set_Input = {
  bimProperties?: InputMaybe<Scalars['jsonb']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  classBuildingPart?: InputMaybe<Scalars['String']['input']>;
  classCode?: InputMaybe<Scalars['String']['input']>;
  classCodeId?: InputMaybe<Scalars['Int']['input']>;
  classLabel?: InputMaybe<Scalars['String']['input']>;
  classLevel1Code?: InputMaybe<Scalars['String']['input']>;
  classPath?: InputMaybe<Array<Scalars['String']['input']>>;
  classSystem?: InputMaybe<Scalars['String']['input']>;
  classificationConflicts?: InputMaybe<Scalars['jsonb']['input']>;
  classifications?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  doubleCountRisk?: InputMaybe<Scalars['Boolean']['input']>;
  epdDatasources?: InputMaybe<Array<Scalars['String']['input']>>;
  epdDeclarationOwner?: InputMaybe<Scalars['String']['input']>;
  epdDeclaredUnit?: InputMaybe<Scalars['String']['input']>;
  epdDeclaredValue?: InputMaybe<Scalars['float8']['input']>;
  epdDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  epdExpectedLife?: InputMaybe<Scalars['Int']['input']>;
  epdExpectedLifespan?: InputMaybe<Scalars['Int']['input']>;
  epdFaulty?: InputMaybe<Scalars['Boolean']['input']>;
  epdId?: InputMaybe<Scalars['uuid']['input']>;
  epdInternalId?: InputMaybe<Scalars['uuid']['input']>;
  epdIsConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  epdIsCustom?: InputMaybe<Scalars['Boolean']['input']>;
  epdMass?: InputMaybe<Scalars['float8']['input']>;
  epdMassUnit?: InputMaybe<Scalars['String']['input']>;
  epdMaterialCategory?: InputMaybe<Scalars['String']['input']>;
  epdName?: InputMaybe<Scalars['String']['input']>;
  epdNewestVersion?: InputMaybe<Scalars['Boolean']['input']>;
  epdStandard?: InputMaybe<Scalars['String']['input']>;
  epdType?: InputMaybe<Scalars['String']['input']>;
  epdVersion?: InputMaybe<Scalars['String']['input']>;
  epdVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  excludedReason?: InputMaybe<Scalars['String']['input']>;
  gwpA1a3?: InputMaybe<Scalars['float8']['input']>;
  gwpA4?: InputMaybe<Scalars['float8']['input']>;
  gwpA5?: InputMaybe<Scalars['float8']['input']>;
  gwpB1?: InputMaybe<Scalars['float8']['input']>;
  gwpB2?: InputMaybe<Scalars['float8']['input']>;
  gwpB3?: InputMaybe<Scalars['float8']['input']>;
  gwpB4?: InputMaybe<Scalars['float8']['input']>;
  gwpB5?: InputMaybe<Scalars['float8']['input']>;
  gwpB6?: InputMaybe<Scalars['float8']['input']>;
  gwpB7?: InputMaybe<Scalars['float8']['input']>;
  gwpC1?: InputMaybe<Scalars['float8']['input']>;
  gwpC2?: InputMaybe<Scalars['float8']['input']>;
  gwpC3?: InputMaybe<Scalars['float8']['input']>;
  gwpC4?: InputMaybe<Scalars['float8']['input']>;
  gwpD?: InputMaybe<Scalars['float8']['input']>;
  includeMapping?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoMapping?: InputMaybe<Scalars['Boolean']['input']>;
  isMapped?: InputMaybe<Scalars['Boolean']['input']>;
  isRecycled?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  lifetimeYears?: InputMaybe<Scalars['Int']['input']>;
  mappingFactor?: InputMaybe<Scalars['float8']['input']>;
  materialCount?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialIdentifier?: InputMaybe<Scalars['String']['input']>;
  materialSource?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  moduleStatus?: InputMaybe<Scalars['jsonb']['input']>;
  normArea?: InputMaybe<Scalars['float8']['input']>;
  normPeriod?: InputMaybe<Scalars['Int']['input']>;
  numberOfReplacements?: InputMaybe<Scalars['Int']['input']>;
  originalCaptured?: InputMaybe<Scalars['Boolean']['input']>;
  originalQuantities?: InputMaybe<Scalars['jsonb']['input']>;
  preferredUnit?: InputMaybe<Scalars['String']['input']>;
  preferredValue?: InputMaybe<Scalars['float8']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  provenanceChanges?: InputMaybe<Scalars['jsonb']['input']>;
  quantities?: InputMaybe<Scalars['jsonb']['input']>;
  rowKind?: InputMaybe<Scalars['String']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  sourceChanged?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  transportSources?: InputMaybe<Array<Scalars['String']['input']>>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
  typeMappedKinds?: InputMaybe<Array<Scalars['String']['input']>>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
  unrecognisedParams?: InputMaybe<Scalars['jsonb']['input']>;
  valueChanged?: InputMaybe<Scalars['Boolean']['input']>;
  wastePercentage?: InputMaybe<Scalars['float8']['input']>;
  weightKg?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type BenchmarkInventoryMaterial_Stddev_Fields = {
  __typename?: 'benchmarkInventoryMaterial_stddev_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Stddev_Order_By = {
  classCodeId?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type BenchmarkInventoryMaterial_Stddev_Pop_Fields = {
  __typename?: 'benchmarkInventoryMaterial_stddev_pop_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Stddev_Pop_Order_By = {
  classCodeId?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type BenchmarkInventoryMaterial_Stddev_Samp_Fields = {
  __typename?: 'benchmarkInventoryMaterial_stddev_samp_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Stddev_Samp_Order_By = {
  classCodeId?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "benchmarkInventoryMaterial" */
export type BenchmarkInventoryMaterial_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BenchmarkInventoryMaterial_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BenchmarkInventoryMaterial_Stream_Cursor_Value_Input = {
  bimFamily?: InputMaybe<Scalars['String']['input']>;
  bimProperties?: InputMaybe<Scalars['jsonb']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  classBuildingPart?: InputMaybe<Scalars['String']['input']>;
  classCode?: InputMaybe<Scalars['String']['input']>;
  classCodeId?: InputMaybe<Scalars['Int']['input']>;
  classLabel?: InputMaybe<Scalars['String']['input']>;
  classLevel1Code?: InputMaybe<Scalars['String']['input']>;
  classPath?: InputMaybe<Array<Scalars['String']['input']>>;
  classSystem?: InputMaybe<Scalars['String']['input']>;
  classificationConflicts?: InputMaybe<Scalars['jsonb']['input']>;
  classifications?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  doubleCountRisk?: InputMaybe<Scalars['Boolean']['input']>;
  epdDatasources?: InputMaybe<Array<Scalars['String']['input']>>;
  epdDeclarationOwner?: InputMaybe<Scalars['String']['input']>;
  epdDeclaredUnit?: InputMaybe<Scalars['String']['input']>;
  epdDeclaredValue?: InputMaybe<Scalars['float8']['input']>;
  epdDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  epdExpectedLife?: InputMaybe<Scalars['Int']['input']>;
  epdExpectedLifespan?: InputMaybe<Scalars['Int']['input']>;
  epdFaulty?: InputMaybe<Scalars['Boolean']['input']>;
  epdId?: InputMaybe<Scalars['uuid']['input']>;
  epdInternalId?: InputMaybe<Scalars['uuid']['input']>;
  epdIsConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  epdIsCustom?: InputMaybe<Scalars['Boolean']['input']>;
  epdMass?: InputMaybe<Scalars['float8']['input']>;
  epdMassUnit?: InputMaybe<Scalars['String']['input']>;
  epdMaterialCategory?: InputMaybe<Scalars['String']['input']>;
  epdName?: InputMaybe<Scalars['String']['input']>;
  epdNewestVersion?: InputMaybe<Scalars['Boolean']['input']>;
  epdStandard?: InputMaybe<Scalars['String']['input']>;
  epdType?: InputMaybe<Scalars['String']['input']>;
  epdVersion?: InputMaybe<Scalars['String']['input']>;
  epdVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  excludedReason?: InputMaybe<Scalars['String']['input']>;
  gwpA1a3?: InputMaybe<Scalars['float8']['input']>;
  gwpA4?: InputMaybe<Scalars['float8']['input']>;
  gwpA5?: InputMaybe<Scalars['float8']['input']>;
  gwpB1?: InputMaybe<Scalars['float8']['input']>;
  gwpB2?: InputMaybe<Scalars['float8']['input']>;
  gwpB3?: InputMaybe<Scalars['float8']['input']>;
  gwpB4?: InputMaybe<Scalars['float8']['input']>;
  gwpB5?: InputMaybe<Scalars['float8']['input']>;
  gwpB6?: InputMaybe<Scalars['float8']['input']>;
  gwpB7?: InputMaybe<Scalars['float8']['input']>;
  gwpC1?: InputMaybe<Scalars['float8']['input']>;
  gwpC2?: InputMaybe<Scalars['float8']['input']>;
  gwpC3?: InputMaybe<Scalars['float8']['input']>;
  gwpC4?: InputMaybe<Scalars['float8']['input']>;
  gwpD?: InputMaybe<Scalars['float8']['input']>;
  includeMapping?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoMapping?: InputMaybe<Scalars['Boolean']['input']>;
  isMapped?: InputMaybe<Scalars['Boolean']['input']>;
  isRecycled?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  lifetimeYears?: InputMaybe<Scalars['Int']['input']>;
  mappingFactor?: InputMaybe<Scalars['float8']['input']>;
  materialCount?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialIdentifier?: InputMaybe<Scalars['String']['input']>;
  materialSource?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  moduleStatus?: InputMaybe<Scalars['jsonb']['input']>;
  normArea?: InputMaybe<Scalars['float8']['input']>;
  normPeriod?: InputMaybe<Scalars['Int']['input']>;
  numberOfReplacements?: InputMaybe<Scalars['Int']['input']>;
  originalCaptured?: InputMaybe<Scalars['Boolean']['input']>;
  originalQuantities?: InputMaybe<Scalars['jsonb']['input']>;
  preferredUnit?: InputMaybe<Scalars['String']['input']>;
  preferredValue?: InputMaybe<Scalars['float8']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  provenanceChanges?: InputMaybe<Scalars['jsonb']['input']>;
  quantities?: InputMaybe<Scalars['jsonb']['input']>;
  rowKind?: InputMaybe<Scalars['String']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  sourceChanged?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  transportSources?: InputMaybe<Array<Scalars['String']['input']>>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
  typeMappedKinds?: InputMaybe<Array<Scalars['String']['input']>>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
  unrecognisedParams?: InputMaybe<Scalars['jsonb']['input']>;
  valueChanged?: InputMaybe<Scalars['Boolean']['input']>;
  wastePercentage?: InputMaybe<Scalars['float8']['input']>;
  weightKg?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type BenchmarkInventoryMaterial_Sum_Fields = {
  __typename?: 'benchmarkInventoryMaterial_sum_fields';
  classCodeId?: Maybe<Scalars['Int']['output']>;
  epdDeclaredValue?: Maybe<Scalars['float8']['output']>;
  epdExpectedLife?: Maybe<Scalars['Int']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Int']['output']>;
  epdMass?: Maybe<Scalars['float8']['output']>;
  epdVersionNumber?: Maybe<Scalars['Int']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  lifetimeYears?: Maybe<Scalars['Int']['output']>;
  mappingFactor?: Maybe<Scalars['float8']['output']>;
  materialCount?: Maybe<Scalars['Int']['output']>;
  normArea?: Maybe<Scalars['float8']['output']>;
  normPeriod?: Maybe<Scalars['Int']['output']>;
  numberOfReplacements?: Maybe<Scalars['Int']['output']>;
  preferredValue?: Maybe<Scalars['float8']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  wastePercentage?: Maybe<Scalars['float8']['output']>;
  weightKg?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Sum_Order_By = {
  classCodeId?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** update columns of table "benchmark_inventory_material" */
export enum BenchmarkInventoryMaterial_Update_Column {
  /** column name */
  bimProperties = 'bimProperties',
  /** column name */
  category = 'category',
  /** column name */
  classBuildingPart = 'classBuildingPart',
  /** column name */
  classCode = 'classCode',
  /** column name */
  classCodeId = 'classCodeId',
  /** column name */
  classLabel = 'classLabel',
  /** column name */
  classLevel1Code = 'classLevel1Code',
  /** column name */
  classPath = 'classPath',
  /** column name */
  classSystem = 'classSystem',
  /** column name */
  classificationConflicts = 'classificationConflicts',
  /** column name */
  classifications = 'classifications',
  /** column name */
  description = 'description',
  /** column name */
  doubleCountRisk = 'doubleCountRisk',
  /** column name */
  epdDatasources = 'epdDatasources',
  /** column name */
  epdDeclarationOwner = 'epdDeclarationOwner',
  /** column name */
  epdDeclaredUnit = 'epdDeclaredUnit',
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdDeprecated = 'epdDeprecated',
  /** column name */
  epdExpectedLife = 'epdExpectedLife',
  /** column name */
  epdExpectedLifespan = 'epdExpectedLifespan',
  /** column name */
  epdFaulty = 'epdFaulty',
  /** column name */
  epdId = 'epdId',
  /** column name */
  epdInternalId = 'epdInternalId',
  /** column name */
  epdIsConstruction = 'epdIsConstruction',
  /** column name */
  epdIsCustom = 'epdIsCustom',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  epdMassUnit = 'epdMassUnit',
  /** column name */
  epdMaterialCategory = 'epdMaterialCategory',
  /** column name */
  epdName = 'epdName',
  /** column name */
  epdNewestVersion = 'epdNewestVersion',
  /** column name */
  epdStandard = 'epdStandard',
  /** column name */
  epdType = 'epdType',
  /** column name */
  epdVersion = 'epdVersion',
  /** column name */
  epdVersionNumber = 'epdVersionNumber',
  /** column name */
  excludedReason = 'excludedReason',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  includeMapping = 'includeMapping',
  /** column name */
  isAutoMapping = 'isAutoMapping',
  /** column name */
  isMapped = 'isMapped',
  /** column name */
  isRecycled = 'isRecycled',
  /** column name */
  lifetimeOffset = 'lifetimeOffset',
  /** column name */
  lifetimeYears = 'lifetimeYears',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  materialCount = 'materialCount',
  /** column name */
  materialId = 'materialId',
  /** column name */
  materialIdentifier = 'materialIdentifier',
  /** column name */
  materialSource = 'materialSource',
  /** column name */
  model = 'model',
  /** column name */
  moduleStatus = 'moduleStatus',
  /** column name */
  normArea = 'normArea',
  /** column name */
  normPeriod = 'normPeriod',
  /** column name */
  numberOfReplacements = 'numberOfReplacements',
  /** column name */
  originalCaptured = 'originalCaptured',
  /** column name */
  originalQuantities = 'originalQuantities',
  /** column name */
  preferredUnit = 'preferredUnit',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  projectId = 'projectId',
  /** column name */
  provenanceChanges = 'provenanceChanges',
  /** column name */
  quantities = 'quantities',
  /** column name */
  rowKind = 'rowKind',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  sourceChanged = 'sourceChanged',
  /** column name */
  stage = 'stage',
  /** column name */
  tags = 'tags',
  /** column name */
  transportSources = 'transportSources',
  /** column name */
  typeIdentifier = 'typeIdentifier',
  /** column name */
  typeMappedKinds = 'typeMappedKinds',
  /** column name */
  typeMaterialIdentifier = 'typeMaterialIdentifier',
  /** column name */
  unrecognisedParams = 'unrecognisedParams',
  /** column name */
  valueChanged = 'valueChanged',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

export type BenchmarkInventoryMaterial_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BenchmarkInventoryMaterial_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BenchmarkInventoryMaterial_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BenchmarkInventoryMaterial_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BenchmarkInventoryMaterial_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BenchmarkInventoryMaterial_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BenchmarkInventoryMaterial_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BenchmarkInventoryMaterial_Set_Input>;
  /** filter the rows which have to be updated */
  where: BenchmarkInventoryMaterial_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BenchmarkInventoryMaterial_Var_Pop_Fields = {
  __typename?: 'benchmarkInventoryMaterial_var_pop_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Var_Pop_Order_By = {
  classCodeId?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type BenchmarkInventoryMaterial_Var_Samp_Fields = {
  __typename?: 'benchmarkInventoryMaterial_var_samp_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Var_Samp_Order_By = {
  classCodeId?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type BenchmarkInventoryMaterial_Variance_Fields = {
  __typename?: 'benchmarkInventoryMaterial_variance_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "benchmark_inventory_material" */
export type BenchmarkInventoryMaterial_Variance_Order_By = {
  classCodeId?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  materialCount?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** columns and relationships of "benchmark_material_mapping" */
export type BenchmarkMaterialMapping = {
  __typename?: 'benchmarkMaterialMapping';
  amount?: Maybe<Scalars['float8']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['float8']['output']>;
  constructionName?: Maybe<Scalars['String']['output']>;
  declaredUnit?: Maybe<Scalars['String']['output']>;
  epdId?: Maybe<Scalars['uuid']['output']>;
  epdName?: Maybe<Scalars['String']['output']>;
  expectedLifespan?: Maybe<Scalars['Int']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  knownIssues: Array<Scalars['String']['output']>;
  layerIndex: Scalars['Int']['output'];
  /** An object relationship */
  material?: Maybe<BenchmarkInventoryMaterial>;
  parentMaterialId: Scalars['uuid']['output'];
  projectId: Scalars['uuid']['output'];
  quantitiesDerived?: Maybe<Scalars['Boolean']['output']>;
  snapshotId: Scalars['bigint']['output'];
};

/** aggregated selection of "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Aggregate = {
  __typename?: 'benchmarkMaterialMapping_aggregate';
  aggregate?: Maybe<BenchmarkMaterialMapping_Aggregate_Fields>;
  nodes: Array<BenchmarkMaterialMapping>;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp = {
  avg?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<BenchmarkMaterialMapping_Aggregate_Bool_Exp_Var_Samp>;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Avg = {
  arguments: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Bool_And = {
  arguments: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Bool_Or = {
  arguments: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Corr = {
  arguments: BenchmarkMaterialMapping_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Corr_Arguments = {
  X: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<BenchmarkMaterialMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: BenchmarkMaterialMapping_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Max = {
  arguments: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Min = {
  arguments: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Sum = {
  arguments: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkMaterialMapping_Aggregate_Bool_Exp_Var_Samp = {
  arguments: BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Aggregate_Fields = {
  __typename?: 'benchmarkMaterialMapping_aggregate_fields';
  avg?: Maybe<BenchmarkMaterialMapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BenchmarkMaterialMapping_Max_Fields>;
  min?: Maybe<BenchmarkMaterialMapping_Min_Fields>;
  stddev?: Maybe<BenchmarkMaterialMapping_Stddev_Fields>;
  stddev_pop?: Maybe<BenchmarkMaterialMapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BenchmarkMaterialMapping_Stddev_Samp_Fields>;
  sum?: Maybe<BenchmarkMaterialMapping_Sum_Fields>;
  var_pop?: Maybe<BenchmarkMaterialMapping_Var_Pop_Fields>;
  var_samp?: Maybe<BenchmarkMaterialMapping_Var_Samp_Fields>;
  variance?: Maybe<BenchmarkMaterialMapping_Variance_Fields>;
};


/** aggregate fields of "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BenchmarkMaterialMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Aggregate_Order_By = {
  avg?: InputMaybe<BenchmarkMaterialMapping_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<BenchmarkMaterialMapping_Max_Order_By>;
  min?: InputMaybe<BenchmarkMaterialMapping_Min_Order_By>;
  stddev?: InputMaybe<BenchmarkMaterialMapping_Stddev_Order_By>;
  stddev_pop?: InputMaybe<BenchmarkMaterialMapping_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<BenchmarkMaterialMapping_Stddev_Samp_Order_By>;
  sum?: InputMaybe<BenchmarkMaterialMapping_Sum_Order_By>;
  var_pop?: InputMaybe<BenchmarkMaterialMapping_Var_Pop_Order_By>;
  var_samp?: InputMaybe<BenchmarkMaterialMapping_Var_Samp_Order_By>;
  variance?: InputMaybe<BenchmarkMaterialMapping_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Arr_Rel_Insert_Input = {
  data: Array<BenchmarkMaterialMapping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<BenchmarkMaterialMapping_On_Conflict>;
};

/** aggregate avg on columns */
export type BenchmarkMaterialMapping_Avg_Fields = {
  __typename?: 'benchmarkMaterialMapping_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['Float']['output']>;
  expectedLifespan?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  layerIndex?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "benchmark_material_mapping". All fields are combined with a logical 'AND'. */
export type BenchmarkMaterialMapping_Bool_Exp = {
  _and?: InputMaybe<Array<BenchmarkMaterialMapping_Bool_Exp>>;
  _not?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
  _or?: InputMaybe<Array<BenchmarkMaterialMapping_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  amountPerConstructionUnit?: InputMaybe<Float8_Comparison_Exp>;
  constructionName?: InputMaybe<String_Comparison_Exp>;
  declaredUnit?: InputMaybe<String_Comparison_Exp>;
  epdId?: InputMaybe<Uuid_Comparison_Exp>;
  epdName?: InputMaybe<String_Comparison_Exp>;
  expectedLifespan?: InputMaybe<Int_Comparison_Exp>;
  gwpA1a3?: InputMaybe<Float8_Comparison_Exp>;
  gwpA4?: InputMaybe<Float8_Comparison_Exp>;
  gwpA5?: InputMaybe<Float8_Comparison_Exp>;
  gwpB1?: InputMaybe<Float8_Comparison_Exp>;
  gwpB2?: InputMaybe<Float8_Comparison_Exp>;
  gwpB3?: InputMaybe<Float8_Comparison_Exp>;
  gwpB4?: InputMaybe<Float8_Comparison_Exp>;
  gwpB5?: InputMaybe<Float8_Comparison_Exp>;
  gwpB6?: InputMaybe<Float8_Comparison_Exp>;
  gwpB7?: InputMaybe<Float8_Comparison_Exp>;
  gwpC1?: InputMaybe<Float8_Comparison_Exp>;
  gwpC2?: InputMaybe<Float8_Comparison_Exp>;
  gwpC3?: InputMaybe<Float8_Comparison_Exp>;
  gwpC4?: InputMaybe<Float8_Comparison_Exp>;
  gwpD?: InputMaybe<Float8_Comparison_Exp>;
  knownIssues?: InputMaybe<String_Array_Comparison_Exp>;
  layerIndex?: InputMaybe<Int_Comparison_Exp>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  parentMaterialId?: InputMaybe<Uuid_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  quantitiesDerived?: InputMaybe<Boolean_Comparison_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Constraint {
  /** unique or primary key constraint on columns "snapshot_id", "parent_material_id", "layer_index" */
  benchmark_material_mapping_pkey = 'benchmark_material_mapping_pkey'
}

/** input type for incrementing numeric columns in table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  amountPerConstructionUnit?: InputMaybe<Scalars['float8']['input']>;
  expectedLifespan?: InputMaybe<Scalars['Int']['input']>;
  gwpA1a3?: InputMaybe<Scalars['float8']['input']>;
  gwpA4?: InputMaybe<Scalars['float8']['input']>;
  gwpA5?: InputMaybe<Scalars['float8']['input']>;
  gwpB1?: InputMaybe<Scalars['float8']['input']>;
  gwpB2?: InputMaybe<Scalars['float8']['input']>;
  gwpB3?: InputMaybe<Scalars['float8']['input']>;
  gwpB4?: InputMaybe<Scalars['float8']['input']>;
  gwpB5?: InputMaybe<Scalars['float8']['input']>;
  gwpB6?: InputMaybe<Scalars['float8']['input']>;
  gwpB7?: InputMaybe<Scalars['float8']['input']>;
  gwpC1?: InputMaybe<Scalars['float8']['input']>;
  gwpC2?: InputMaybe<Scalars['float8']['input']>;
  gwpC3?: InputMaybe<Scalars['float8']['input']>;
  gwpC4?: InputMaybe<Scalars['float8']['input']>;
  gwpD?: InputMaybe<Scalars['float8']['input']>;
  layerIndex?: InputMaybe<Scalars['Int']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Insert_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  amountPerConstructionUnit?: InputMaybe<Scalars['float8']['input']>;
  constructionName?: InputMaybe<Scalars['String']['input']>;
  declaredUnit?: InputMaybe<Scalars['String']['input']>;
  epdId?: InputMaybe<Scalars['uuid']['input']>;
  epdName?: InputMaybe<Scalars['String']['input']>;
  expectedLifespan?: InputMaybe<Scalars['Int']['input']>;
  gwpA1a3?: InputMaybe<Scalars['float8']['input']>;
  gwpA4?: InputMaybe<Scalars['float8']['input']>;
  gwpA5?: InputMaybe<Scalars['float8']['input']>;
  gwpB1?: InputMaybe<Scalars['float8']['input']>;
  gwpB2?: InputMaybe<Scalars['float8']['input']>;
  gwpB3?: InputMaybe<Scalars['float8']['input']>;
  gwpB4?: InputMaybe<Scalars['float8']['input']>;
  gwpB5?: InputMaybe<Scalars['float8']['input']>;
  gwpB6?: InputMaybe<Scalars['float8']['input']>;
  gwpB7?: InputMaybe<Scalars['float8']['input']>;
  gwpC1?: InputMaybe<Scalars['float8']['input']>;
  gwpC2?: InputMaybe<Scalars['float8']['input']>;
  gwpC3?: InputMaybe<Scalars['float8']['input']>;
  gwpC4?: InputMaybe<Scalars['float8']['input']>;
  gwpD?: InputMaybe<Scalars['float8']['input']>;
  knownIssues?: InputMaybe<Array<Scalars['String']['input']>>;
  layerIndex?: InputMaybe<Scalars['Int']['input']>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Obj_Rel_Insert_Input>;
  parentMaterialId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  quantitiesDerived?: InputMaybe<Scalars['Boolean']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type BenchmarkMaterialMapping_Max_Fields = {
  __typename?: 'benchmarkMaterialMapping_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['float8']['output']>;
  constructionName?: Maybe<Scalars['String']['output']>;
  declaredUnit?: Maybe<Scalars['String']['output']>;
  epdId?: Maybe<Scalars['uuid']['output']>;
  epdName?: Maybe<Scalars['String']['output']>;
  expectedLifespan?: Maybe<Scalars['Int']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  knownIssues?: Maybe<Array<Scalars['String']['output']>>;
  layerIndex?: Maybe<Scalars['Int']['output']>;
  parentMaterialId?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  constructionName?: InputMaybe<Order_By>;
  declaredUnit?: InputMaybe<Order_By>;
  epdId?: InputMaybe<Order_By>;
  epdName?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  knownIssues?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  parentMaterialId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type BenchmarkMaterialMapping_Min_Fields = {
  __typename?: 'benchmarkMaterialMapping_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['float8']['output']>;
  constructionName?: Maybe<Scalars['String']['output']>;
  declaredUnit?: Maybe<Scalars['String']['output']>;
  epdId?: Maybe<Scalars['uuid']['output']>;
  epdName?: Maybe<Scalars['String']['output']>;
  expectedLifespan?: Maybe<Scalars['Int']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  knownIssues?: Maybe<Array<Scalars['String']['output']>>;
  layerIndex?: Maybe<Scalars['Int']['output']>;
  parentMaterialId?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  constructionName?: InputMaybe<Order_By>;
  declaredUnit?: InputMaybe<Order_By>;
  epdId?: InputMaybe<Order_By>;
  epdName?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  knownIssues?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  parentMaterialId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Mutation_Response = {
  __typename?: 'benchmarkMaterialMapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BenchmarkMaterialMapping>;
};

/** on_conflict condition type for table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_On_Conflict = {
  constraint: BenchmarkMaterialMapping_Constraint;
  update_columns?: Array<BenchmarkMaterialMapping_Update_Column>;
  where?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
};

/** Ordering options when selecting data from "benchmark_material_mapping". */
export type BenchmarkMaterialMapping_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  constructionName?: InputMaybe<Order_By>;
  declaredUnit?: InputMaybe<Order_By>;
  epdId?: InputMaybe<Order_By>;
  epdName?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  knownIssues?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Order_By>;
  parentMaterialId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  quantitiesDerived?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: benchmark_material_mapping */
export type BenchmarkMaterialMapping_Pk_Columns_Input = {
  layerIndex: Scalars['Int']['input'];
  parentMaterialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};

/** select columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  constructionName = 'constructionName',
  /** column name */
  declaredUnit = 'declaredUnit',
  /** column name */
  epdId = 'epdId',
  /** column name */
  epdName = 'epdName',
  /** column name */
  expectedLifespan = 'expectedLifespan',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  knownIssues = 'knownIssues',
  /** column name */
  layerIndex = 'layerIndex',
  /** column name */
  parentMaterialId = 'parentMaterialId',
  /** column name */
  projectId = 'projectId',
  /** column name */
  quantitiesDerived = 'quantitiesDerived',
  /** column name */
  snapshotId = 'snapshotId'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_avg_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_bool_and_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  quantitiesDerived = 'quantitiesDerived'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_bool_or_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  quantitiesDerived = 'quantitiesDerived'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_corr_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_max_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_min_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_sum_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD'
}

/** select "benchmarkMaterialMapping_aggregate_bool_exp_var_samp_arguments_columns" columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Select_Column_BenchmarkMaterialMapping_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD'
}

/** input type for updating data in table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Set_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  amountPerConstructionUnit?: InputMaybe<Scalars['float8']['input']>;
  constructionName?: InputMaybe<Scalars['String']['input']>;
  declaredUnit?: InputMaybe<Scalars['String']['input']>;
  epdId?: InputMaybe<Scalars['uuid']['input']>;
  epdName?: InputMaybe<Scalars['String']['input']>;
  expectedLifespan?: InputMaybe<Scalars['Int']['input']>;
  gwpA1a3?: InputMaybe<Scalars['float8']['input']>;
  gwpA4?: InputMaybe<Scalars['float8']['input']>;
  gwpA5?: InputMaybe<Scalars['float8']['input']>;
  gwpB1?: InputMaybe<Scalars['float8']['input']>;
  gwpB2?: InputMaybe<Scalars['float8']['input']>;
  gwpB3?: InputMaybe<Scalars['float8']['input']>;
  gwpB4?: InputMaybe<Scalars['float8']['input']>;
  gwpB5?: InputMaybe<Scalars['float8']['input']>;
  gwpB6?: InputMaybe<Scalars['float8']['input']>;
  gwpB7?: InputMaybe<Scalars['float8']['input']>;
  gwpC1?: InputMaybe<Scalars['float8']['input']>;
  gwpC2?: InputMaybe<Scalars['float8']['input']>;
  gwpC3?: InputMaybe<Scalars['float8']['input']>;
  gwpC4?: InputMaybe<Scalars['float8']['input']>;
  gwpD?: InputMaybe<Scalars['float8']['input']>;
  knownIssues?: InputMaybe<Array<Scalars['String']['input']>>;
  layerIndex?: InputMaybe<Scalars['Int']['input']>;
  parentMaterialId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  quantitiesDerived?: InputMaybe<Scalars['Boolean']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type BenchmarkMaterialMapping_Stddev_Fields = {
  __typename?: 'benchmarkMaterialMapping_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['Float']['output']>;
  expectedLifespan?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  layerIndex?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type BenchmarkMaterialMapping_Stddev_Pop_Fields = {
  __typename?: 'benchmarkMaterialMapping_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['Float']['output']>;
  expectedLifespan?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  layerIndex?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type BenchmarkMaterialMapping_Stddev_Samp_Fields = {
  __typename?: 'benchmarkMaterialMapping_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['Float']['output']>;
  expectedLifespan?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  layerIndex?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "benchmarkMaterialMapping" */
export type BenchmarkMaterialMapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BenchmarkMaterialMapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BenchmarkMaterialMapping_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  amountPerConstructionUnit?: InputMaybe<Scalars['float8']['input']>;
  constructionName?: InputMaybe<Scalars['String']['input']>;
  declaredUnit?: InputMaybe<Scalars['String']['input']>;
  epdId?: InputMaybe<Scalars['uuid']['input']>;
  epdName?: InputMaybe<Scalars['String']['input']>;
  expectedLifespan?: InputMaybe<Scalars['Int']['input']>;
  gwpA1a3?: InputMaybe<Scalars['float8']['input']>;
  gwpA4?: InputMaybe<Scalars['float8']['input']>;
  gwpA5?: InputMaybe<Scalars['float8']['input']>;
  gwpB1?: InputMaybe<Scalars['float8']['input']>;
  gwpB2?: InputMaybe<Scalars['float8']['input']>;
  gwpB3?: InputMaybe<Scalars['float8']['input']>;
  gwpB4?: InputMaybe<Scalars['float8']['input']>;
  gwpB5?: InputMaybe<Scalars['float8']['input']>;
  gwpB6?: InputMaybe<Scalars['float8']['input']>;
  gwpB7?: InputMaybe<Scalars['float8']['input']>;
  gwpC1?: InputMaybe<Scalars['float8']['input']>;
  gwpC2?: InputMaybe<Scalars['float8']['input']>;
  gwpC3?: InputMaybe<Scalars['float8']['input']>;
  gwpC4?: InputMaybe<Scalars['float8']['input']>;
  gwpD?: InputMaybe<Scalars['float8']['input']>;
  knownIssues?: InputMaybe<Array<Scalars['String']['input']>>;
  layerIndex?: InputMaybe<Scalars['Int']['input']>;
  parentMaterialId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  quantitiesDerived?: InputMaybe<Scalars['Boolean']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type BenchmarkMaterialMapping_Sum_Fields = {
  __typename?: 'benchmarkMaterialMapping_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['float8']['output']>;
  expectedLifespan?: Maybe<Scalars['Int']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  layerIndex?: Maybe<Scalars['Int']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** update columns of table "benchmark_material_mapping" */
export enum BenchmarkMaterialMapping_Update_Column {
  /** column name */
  amount = 'amount',
  /** column name */
  amountPerConstructionUnit = 'amountPerConstructionUnit',
  /** column name */
  constructionName = 'constructionName',
  /** column name */
  declaredUnit = 'declaredUnit',
  /** column name */
  epdId = 'epdId',
  /** column name */
  epdName = 'epdName',
  /** column name */
  expectedLifespan = 'expectedLifespan',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  knownIssues = 'knownIssues',
  /** column name */
  layerIndex = 'layerIndex',
  /** column name */
  parentMaterialId = 'parentMaterialId',
  /** column name */
  projectId = 'projectId',
  /** column name */
  quantitiesDerived = 'quantitiesDerived',
  /** column name */
  snapshotId = 'snapshotId'
}

export type BenchmarkMaterialMapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BenchmarkMaterialMapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BenchmarkMaterialMapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: BenchmarkMaterialMapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BenchmarkMaterialMapping_Var_Pop_Fields = {
  __typename?: 'benchmarkMaterialMapping_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['Float']['output']>;
  expectedLifespan?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  layerIndex?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type BenchmarkMaterialMapping_Var_Samp_Fields = {
  __typename?: 'benchmarkMaterialMapping_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['Float']['output']>;
  expectedLifespan?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  layerIndex?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type BenchmarkMaterialMapping_Variance_Fields = {
  __typename?: 'benchmarkMaterialMapping_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amountPerConstructionUnit?: Maybe<Scalars['Float']['output']>;
  expectedLifespan?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  layerIndex?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "benchmark_material_mapping" */
export type BenchmarkMaterialMapping_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  amountPerConstructionUnit?: InputMaybe<Order_By>;
  expectedLifespan?: InputMaybe<Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  layerIndex?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** columns and relationships of "benchmark_project_state" */
export type BenchmarkProjectState = {
  __typename?: 'benchmarkProjectState';
  buildingType?: Maybe<Scalars['String']['output']>;
  calculationType?: Maybe<Scalars['String']['output']>;
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  declaredFloors?: Maybe<Scalars['Int']['output']>;
  fetchedAt: Scalars['timestamptz']['output'];
  httpStatus?: Maybe<Scalars['Int']['output']>;
  includedStages: Array<Scalars['String']['output']>;
  ingestCompletedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  intensity?: Maybe<VProjectIntensity>;
  materialPct?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  materials: Array<BenchmarkInventoryMaterial>;
  /** An aggregate relationship */
  materials_aggregate: BenchmarkInventoryMaterial_Aggregate;
  name?: Maybe<Scalars['String']['output']>;
  payloadSha256?: Maybe<Scalars['bytea']['output']>;
  /** An object relationship */
  project?: Maybe<Project>;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  snapshot?: Maybe<BenchmarkSnapshot>;
  snapshotId: Scalars['bigint']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['uuid']['output'];
  totalArea?: Maybe<Scalars['float8']['output']>;
  transportPct?: Maybe<Scalars['Int']['output']>;
  typology?: Maybe<Scalars['String']['output']>;
  usesDefaultEmissions?: Maybe<Scalars['Boolean']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "benchmark_project_state" */
export type BenchmarkProjectStateMaterialsArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkInventoryMaterial_Order_By>>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};


/** columns and relationships of "benchmark_project_state" */
export type BenchmarkProjectStateMaterials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkInventoryMaterial_Order_By>>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};

/** aggregated selection of "benchmark_project_state" */
export type BenchmarkProjectState_Aggregate = {
  __typename?: 'benchmarkProjectState_aggregate';
  aggregate?: Maybe<BenchmarkProjectState_Aggregate_Fields>;
  nodes: Array<BenchmarkProjectState>;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp = {
  avg?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp_Var_Samp>;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Avg = {
  arguments: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Bool_And = {
  arguments: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Bool_Or = {
  arguments: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Corr = {
  arguments: BenchmarkProjectState_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Corr_Arguments = {
  X: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<BenchmarkProjectState_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: BenchmarkProjectState_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Max = {
  arguments: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Min = {
  arguments: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Sum = {
  arguments: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type BenchmarkProjectState_Aggregate_Bool_Exp_Var_Samp = {
  arguments: BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "benchmark_project_state" */
export type BenchmarkProjectState_Aggregate_Fields = {
  __typename?: 'benchmarkProjectState_aggregate_fields';
  avg?: Maybe<BenchmarkProjectState_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BenchmarkProjectState_Max_Fields>;
  min?: Maybe<BenchmarkProjectState_Min_Fields>;
  stddev?: Maybe<BenchmarkProjectState_Stddev_Fields>;
  stddev_pop?: Maybe<BenchmarkProjectState_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BenchmarkProjectState_Stddev_Samp_Fields>;
  sum?: Maybe<BenchmarkProjectState_Sum_Fields>;
  var_pop?: Maybe<BenchmarkProjectState_Var_Pop_Fields>;
  var_samp?: Maybe<BenchmarkProjectState_Var_Samp_Fields>;
  variance?: Maybe<BenchmarkProjectState_Variance_Fields>;
};


/** aggregate fields of "benchmark_project_state" */
export type BenchmarkProjectState_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BenchmarkProjectState_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "benchmark_project_state" */
export type BenchmarkProjectState_Aggregate_Order_By = {
  avg?: InputMaybe<BenchmarkProjectState_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<BenchmarkProjectState_Max_Order_By>;
  min?: InputMaybe<BenchmarkProjectState_Min_Order_By>;
  stddev?: InputMaybe<BenchmarkProjectState_Stddev_Order_By>;
  stddev_pop?: InputMaybe<BenchmarkProjectState_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<BenchmarkProjectState_Stddev_Samp_Order_By>;
  sum?: InputMaybe<BenchmarkProjectState_Sum_Order_By>;
  var_pop?: InputMaybe<BenchmarkProjectState_Var_Pop_Order_By>;
  var_samp?: InputMaybe<BenchmarkProjectState_Var_Samp_Order_By>;
  variance?: InputMaybe<BenchmarkProjectState_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "benchmark_project_state" */
export type BenchmarkProjectState_Arr_Rel_Insert_Input = {
  data: Array<BenchmarkProjectState_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<BenchmarkProjectState_On_Conflict>;
};

/** aggregate avg on columns */
export type BenchmarkProjectState_Avg_Fields = {
  __typename?: 'benchmarkProjectState_avg_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  declaredFloors?: Maybe<Scalars['Float']['output']>;
  httpStatus?: Maybe<Scalars['Float']['output']>;
  materialPct?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  transportPct?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Avg_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "benchmark_project_state". All fields are combined with a logical 'AND'. */
export type BenchmarkProjectState_Bool_Exp = {
  _and?: InputMaybe<Array<BenchmarkProjectState_Bool_Exp>>;
  _not?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  _or?: InputMaybe<Array<BenchmarkProjectState_Bool_Exp>>;
  buildingType?: InputMaybe<String_Comparison_Exp>;
  calculationType?: InputMaybe<String_Comparison_Exp>;
  considerationPeriod?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  declaredFloors?: InputMaybe<Int_Comparison_Exp>;
  fetchedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  httpStatus?: InputMaybe<Int_Comparison_Exp>;
  includedStages?: InputMaybe<String_Array_Comparison_Exp>;
  ingestCompletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  intensity?: InputMaybe<VProjectIntensity_Bool_Exp>;
  materialPct?: InputMaybe<Int_Comparison_Exp>;
  materials?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  materials_aggregate?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payloadSha256?: InputMaybe<Bytea_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  totalArea?: InputMaybe<Float8_Comparison_Exp>;
  transportPct?: InputMaybe<Int_Comparison_Exp>;
  typology?: InputMaybe<String_Comparison_Exp>;
  usesDefaultEmissions?: InputMaybe<Boolean_Comparison_Exp>;
  yearOfConstruction?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "benchmark_project_state" */
export enum BenchmarkProjectState_Constraint {
  /** unique or primary key constraint on columns "project_id", "snapshot_id" */
  benchmark_project_state_pkey = 'benchmark_project_state_pkey'
}

/** input type for incrementing numeric columns in table "benchmark_project_state" */
export type BenchmarkProjectState_Inc_Input = {
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  declaredFloors?: InputMaybe<Scalars['Int']['input']>;
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  materialPct?: InputMaybe<Scalars['Int']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  totalArea?: InputMaybe<Scalars['float8']['input']>;
  transportPct?: InputMaybe<Scalars['Int']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "benchmark_project_state" */
export type BenchmarkProjectState_Insert_Input = {
  buildingType?: InputMaybe<Scalars['String']['input']>;
  calculationType?: InputMaybe<Scalars['String']['input']>;
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  declaredFloors?: InputMaybe<Scalars['Int']['input']>;
  fetchedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  includedStages?: InputMaybe<Array<Scalars['String']['input']>>;
  ingestCompletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  intensity?: InputMaybe<VProjectIntensity_Obj_Rel_Insert_Input>;
  materialPct?: InputMaybe<Scalars['Int']['input']>;
  materials?: InputMaybe<BenchmarkInventoryMaterial_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  payloadSha256?: InputMaybe<Scalars['bytea']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Obj_Rel_Insert_Input>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  totalArea?: InputMaybe<Scalars['float8']['input']>;
  transportPct?: InputMaybe<Scalars['Int']['input']>;
  typology?: InputMaybe<Scalars['String']['input']>;
  usesDefaultEmissions?: InputMaybe<Scalars['Boolean']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type BenchmarkProjectState_Max_Fields = {
  __typename?: 'benchmarkProjectState_max_fields';
  buildingType?: Maybe<Scalars['String']['output']>;
  calculationType?: Maybe<Scalars['String']['output']>;
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  declaredFloors?: Maybe<Scalars['Int']['output']>;
  fetchedAt?: Maybe<Scalars['timestamptz']['output']>;
  httpStatus?: Maybe<Scalars['Int']['output']>;
  includedStages?: Maybe<Array<Scalars['String']['output']>>;
  ingestCompletedAt?: Maybe<Scalars['timestamptz']['output']>;
  materialPct?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalArea?: Maybe<Scalars['float8']['output']>;
  transportPct?: Maybe<Scalars['Int']['output']>;
  typology?: Maybe<Scalars['String']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Max_Order_By = {
  buildingType?: InputMaybe<Order_By>;
  calculationType?: InputMaybe<Order_By>;
  considerationPeriod?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  fetchedAt?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  includedStages?: InputMaybe<Order_By>;
  ingestCompletedAt?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  typology?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type BenchmarkProjectState_Min_Fields = {
  __typename?: 'benchmarkProjectState_min_fields';
  buildingType?: Maybe<Scalars['String']['output']>;
  calculationType?: Maybe<Scalars['String']['output']>;
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  declaredFloors?: Maybe<Scalars['Int']['output']>;
  fetchedAt?: Maybe<Scalars['timestamptz']['output']>;
  httpStatus?: Maybe<Scalars['Int']['output']>;
  includedStages?: Maybe<Array<Scalars['String']['output']>>;
  ingestCompletedAt?: Maybe<Scalars['timestamptz']['output']>;
  materialPct?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalArea?: Maybe<Scalars['float8']['output']>;
  transportPct?: Maybe<Scalars['Int']['output']>;
  typology?: Maybe<Scalars['String']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Min_Order_By = {
  buildingType?: InputMaybe<Order_By>;
  calculationType?: InputMaybe<Order_By>;
  considerationPeriod?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  fetchedAt?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  includedStages?: InputMaybe<Order_By>;
  ingestCompletedAt?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  typology?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "benchmark_project_state" */
export type BenchmarkProjectState_Mutation_Response = {
  __typename?: 'benchmarkProjectState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BenchmarkProjectState>;
};

/** input type for inserting object relation for remote table "benchmark_project_state" */
export type BenchmarkProjectState_Obj_Rel_Insert_Input = {
  data: BenchmarkProjectState_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BenchmarkProjectState_On_Conflict>;
};

/** on_conflict condition type for table "benchmark_project_state" */
export type BenchmarkProjectState_On_Conflict = {
  constraint: BenchmarkProjectState_Constraint;
  update_columns?: Array<BenchmarkProjectState_Update_Column>;
  where?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
};

/** Ordering options when selecting data from "benchmark_project_state". */
export type BenchmarkProjectState_Order_By = {
  buildingType?: InputMaybe<Order_By>;
  calculationType?: InputMaybe<Order_By>;
  considerationPeriod?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  fetchedAt?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  includedStages?: InputMaybe<Order_By>;
  ingestCompletedAt?: InputMaybe<Order_By>;
  intensity?: InputMaybe<VProjectIntensity_Order_By>;
  materialPct?: InputMaybe<Order_By>;
  materials_aggregate?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  payloadSha256?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  typology?: InputMaybe<Order_By>;
  usesDefaultEmissions?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** primary key columns input for table: benchmark_project_state */
export type BenchmarkProjectState_Pk_Columns_Input = {
  projectId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};

/** select columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column {
  /** column name */
  buildingType = 'buildingType',
  /** column name */
  calculationType = 'calculationType',
  /** column name */
  considerationPeriod = 'considerationPeriod',
  /** column name */
  country = 'country',
  /** column name */
  declaredFloors = 'declaredFloors',
  /** column name */
  fetchedAt = 'fetchedAt',
  /** column name */
  httpStatus = 'httpStatus',
  /** column name */
  includedStages = 'includedStages',
  /** column name */
  ingestCompletedAt = 'ingestCompletedAt',
  /** column name */
  materialPct = 'materialPct',
  /** column name */
  name = 'name',
  /** column name */
  payloadSha256 = 'payloadSha256',
  /** column name */
  projectId = 'projectId',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  status = 'status',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  totalArea = 'totalArea',
  /** column name */
  transportPct = 'transportPct',
  /** column name */
  typology = 'typology',
  /** column name */
  usesDefaultEmissions = 'usesDefaultEmissions',
  /** column name */
  yearOfConstruction = 'yearOfConstruction'
}

/** select "benchmarkProjectState_aggregate_bool_exp_avg_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  totalArea = 'totalArea'
}

/** select "benchmarkProjectState_aggregate_bool_exp_bool_and_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  usesDefaultEmissions = 'usesDefaultEmissions'
}

/** select "benchmarkProjectState_aggregate_bool_exp_bool_or_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  usesDefaultEmissions = 'usesDefaultEmissions'
}

/** select "benchmarkProjectState_aggregate_bool_exp_corr_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  totalArea = 'totalArea'
}

/** select "benchmarkProjectState_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  totalArea = 'totalArea'
}

/** select "benchmarkProjectState_aggregate_bool_exp_max_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  totalArea = 'totalArea'
}

/** select "benchmarkProjectState_aggregate_bool_exp_min_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  totalArea = 'totalArea'
}

/** select "benchmarkProjectState_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  totalArea = 'totalArea'
}

/** select "benchmarkProjectState_aggregate_bool_exp_sum_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  totalArea = 'totalArea'
}

/** select "benchmarkProjectState_aggregate_bool_exp_var_samp_arguments_columns" columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Select_Column_BenchmarkProjectState_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  totalArea = 'totalArea'
}

/** input type for updating data in table "benchmark_project_state" */
export type BenchmarkProjectState_Set_Input = {
  buildingType?: InputMaybe<Scalars['String']['input']>;
  calculationType?: InputMaybe<Scalars['String']['input']>;
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  declaredFloors?: InputMaybe<Scalars['Int']['input']>;
  fetchedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  includedStages?: InputMaybe<Array<Scalars['String']['input']>>;
  ingestCompletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  materialPct?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payloadSha256?: InputMaybe<Scalars['bytea']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  totalArea?: InputMaybe<Scalars['float8']['input']>;
  transportPct?: InputMaybe<Scalars['Int']['input']>;
  typology?: InputMaybe<Scalars['String']['input']>;
  usesDefaultEmissions?: InputMaybe<Scalars['Boolean']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type BenchmarkProjectState_Stddev_Fields = {
  __typename?: 'benchmarkProjectState_stddev_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  declaredFloors?: Maybe<Scalars['Float']['output']>;
  httpStatus?: Maybe<Scalars['Float']['output']>;
  materialPct?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  transportPct?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Stddev_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type BenchmarkProjectState_Stddev_Pop_Fields = {
  __typename?: 'benchmarkProjectState_stddev_pop_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  declaredFloors?: Maybe<Scalars['Float']['output']>;
  httpStatus?: Maybe<Scalars['Float']['output']>;
  materialPct?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  transportPct?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Stddev_Pop_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type BenchmarkProjectState_Stddev_Samp_Fields = {
  __typename?: 'benchmarkProjectState_stddev_samp_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  declaredFloors?: Maybe<Scalars['Float']['output']>;
  httpStatus?: Maybe<Scalars['Float']['output']>;
  materialPct?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  transportPct?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Stddev_Samp_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "benchmarkProjectState" */
export type BenchmarkProjectState_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BenchmarkProjectState_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BenchmarkProjectState_Stream_Cursor_Value_Input = {
  buildingType?: InputMaybe<Scalars['String']['input']>;
  calculationType?: InputMaybe<Scalars['String']['input']>;
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  declaredFloors?: InputMaybe<Scalars['Int']['input']>;
  fetchedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  includedStages?: InputMaybe<Array<Scalars['String']['input']>>;
  ingestCompletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  materialPct?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payloadSha256?: InputMaybe<Scalars['bytea']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  totalArea?: InputMaybe<Scalars['float8']['input']>;
  transportPct?: InputMaybe<Scalars['Int']['input']>;
  typology?: InputMaybe<Scalars['String']['input']>;
  usesDefaultEmissions?: InputMaybe<Scalars['Boolean']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type BenchmarkProjectState_Sum_Fields = {
  __typename?: 'benchmarkProjectState_sum_fields';
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  declaredFloors?: Maybe<Scalars['Int']['output']>;
  httpStatus?: Maybe<Scalars['Int']['output']>;
  materialPct?: Maybe<Scalars['Int']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  totalArea?: Maybe<Scalars['float8']['output']>;
  transportPct?: Maybe<Scalars['Int']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Sum_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** update columns of table "benchmark_project_state" */
export enum BenchmarkProjectState_Update_Column {
  /** column name */
  buildingType = 'buildingType',
  /** column name */
  calculationType = 'calculationType',
  /** column name */
  considerationPeriod = 'considerationPeriod',
  /** column name */
  country = 'country',
  /** column name */
  declaredFloors = 'declaredFloors',
  /** column name */
  fetchedAt = 'fetchedAt',
  /** column name */
  httpStatus = 'httpStatus',
  /** column name */
  includedStages = 'includedStages',
  /** column name */
  ingestCompletedAt = 'ingestCompletedAt',
  /** column name */
  materialPct = 'materialPct',
  /** column name */
  name = 'name',
  /** column name */
  payloadSha256 = 'payloadSha256',
  /** column name */
  projectId = 'projectId',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  status = 'status',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  totalArea = 'totalArea',
  /** column name */
  transportPct = 'transportPct',
  /** column name */
  typology = 'typology',
  /** column name */
  usesDefaultEmissions = 'usesDefaultEmissions',
  /** column name */
  yearOfConstruction = 'yearOfConstruction'
}

export type BenchmarkProjectState_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BenchmarkProjectState_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BenchmarkProjectState_Set_Input>;
  /** filter the rows which have to be updated */
  where: BenchmarkProjectState_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BenchmarkProjectState_Var_Pop_Fields = {
  __typename?: 'benchmarkProjectState_var_pop_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  declaredFloors?: Maybe<Scalars['Float']['output']>;
  httpStatus?: Maybe<Scalars['Float']['output']>;
  materialPct?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  transportPct?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Var_Pop_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type BenchmarkProjectState_Var_Samp_Fields = {
  __typename?: 'benchmarkProjectState_var_samp_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  declaredFloors?: Maybe<Scalars['Float']['output']>;
  httpStatus?: Maybe<Scalars['Float']['output']>;
  materialPct?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  transportPct?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Var_Samp_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type BenchmarkProjectState_Variance_Fields = {
  __typename?: 'benchmarkProjectState_variance_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  declaredFloors?: Maybe<Scalars['Float']['output']>;
  httpStatus?: Maybe<Scalars['Float']['output']>;
  materialPct?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  transportPct?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "benchmark_project_state" */
export type BenchmarkProjectState_Variance_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  declaredFloors?: InputMaybe<Order_By>;
  httpStatus?: InputMaybe<Order_By>;
  materialPct?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
  transportPct?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** columns and relationships of "benchmark_snapshot" */
export type BenchmarkSnapshot = {
  __typename?: 'benchmarkSnapshot';
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  groupingVerdicts: Array<BenchmarkGroupingVerdict>;
  /** An aggregate relationship */
  groupingVerdicts_aggregate: BenchmarkGroupingVerdict_Aggregate;
  /** An array relationship */
  materials: Array<BenchmarkInventoryMaterial>;
  /** An aggregate relationship */
  materials_aggregate: BenchmarkInventoryMaterial_Aggregate;
  /** An array relationship */
  projectStates: Array<BenchmarkProjectState>;
  /** An aggregate relationship */
  projectStates_aggregate: BenchmarkProjectState_Aggregate;
  snapshotId: Scalars['bigint']['output'];
  source: Scalars['String']['output'];
  startedAt: Scalars['timestamptz']['output'];
  toolVersion?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "benchmark_snapshot" */
export type BenchmarkSnapshotGroupingVerdictsArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkGroupingVerdict_Order_By>>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};


/** columns and relationships of "benchmark_snapshot" */
export type BenchmarkSnapshotGroupingVerdicts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkGroupingVerdict_Order_By>>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};


/** columns and relationships of "benchmark_snapshot" */
export type BenchmarkSnapshotMaterialsArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkInventoryMaterial_Order_By>>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};


/** columns and relationships of "benchmark_snapshot" */
export type BenchmarkSnapshotMaterials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkInventoryMaterial_Order_By>>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};


/** columns and relationships of "benchmark_snapshot" */
export type BenchmarkSnapshotProjectStatesArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkProjectState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkProjectState_Order_By>>;
  where?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
};


/** columns and relationships of "benchmark_snapshot" */
export type BenchmarkSnapshotProjectStates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkProjectState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkProjectState_Order_By>>;
  where?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
};

/** aggregated selection of "benchmark_snapshot" */
export type BenchmarkSnapshot_Aggregate = {
  __typename?: 'benchmarkSnapshot_aggregate';
  aggregate?: Maybe<BenchmarkSnapshot_Aggregate_Fields>;
  nodes: Array<BenchmarkSnapshot>;
};

/** aggregate fields of "benchmark_snapshot" */
export type BenchmarkSnapshot_Aggregate_Fields = {
  __typename?: 'benchmarkSnapshot_aggregate_fields';
  avg?: Maybe<BenchmarkSnapshot_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BenchmarkSnapshot_Max_Fields>;
  min?: Maybe<BenchmarkSnapshot_Min_Fields>;
  stddev?: Maybe<BenchmarkSnapshot_Stddev_Fields>;
  stddev_pop?: Maybe<BenchmarkSnapshot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BenchmarkSnapshot_Stddev_Samp_Fields>;
  sum?: Maybe<BenchmarkSnapshot_Sum_Fields>;
  var_pop?: Maybe<BenchmarkSnapshot_Var_Pop_Fields>;
  var_samp?: Maybe<BenchmarkSnapshot_Var_Samp_Fields>;
  variance?: Maybe<BenchmarkSnapshot_Variance_Fields>;
};


/** aggregate fields of "benchmark_snapshot" */
export type BenchmarkSnapshot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BenchmarkSnapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type BenchmarkSnapshot_Avg_Fields = {
  __typename?: 'benchmarkSnapshot_avg_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "benchmark_snapshot". All fields are combined with a logical 'AND'. */
export type BenchmarkSnapshot_Bool_Exp = {
  _and?: InputMaybe<Array<BenchmarkSnapshot_Bool_Exp>>;
  _not?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
  _or?: InputMaybe<Array<BenchmarkSnapshot_Bool_Exp>>;
  finishedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  groupingVerdicts?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
  groupingVerdicts_aggregate?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Bool_Exp>;
  materials?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  materials_aggregate?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Bool_Exp>;
  projectStates?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  projectStates_aggregate?: InputMaybe<BenchmarkProjectState_Aggregate_Bool_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  startedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  toolVersion?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "benchmark_snapshot" */
export enum BenchmarkSnapshot_Constraint {
  /** unique or primary key constraint on columns "snapshot_id" */
  benchmark_snapshot_pkey = 'benchmark_snapshot_pkey'
}

/** input type for incrementing numeric columns in table "benchmark_snapshot" */
export type BenchmarkSnapshot_Inc_Input = {
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "benchmark_snapshot" */
export type BenchmarkSnapshot_Insert_Input = {
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  groupingVerdicts?: InputMaybe<BenchmarkGroupingVerdict_Arr_Rel_Insert_Input>;
  materials?: InputMaybe<BenchmarkInventoryMaterial_Arr_Rel_Insert_Input>;
  projectStates?: InputMaybe<BenchmarkProjectState_Arr_Rel_Insert_Input>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  toolVersion?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BenchmarkSnapshot_Max_Fields = {
  __typename?: 'benchmarkSnapshot_max_fields';
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  toolVersion?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BenchmarkSnapshot_Min_Fields = {
  __typename?: 'benchmarkSnapshot_min_fields';
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  toolVersion?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "benchmark_snapshot" */
export type BenchmarkSnapshot_Mutation_Response = {
  __typename?: 'benchmarkSnapshot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BenchmarkSnapshot>;
};

/** input type for inserting object relation for remote table "benchmark_snapshot" */
export type BenchmarkSnapshot_Obj_Rel_Insert_Input = {
  data: BenchmarkSnapshot_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BenchmarkSnapshot_On_Conflict>;
};

/** on_conflict condition type for table "benchmark_snapshot" */
export type BenchmarkSnapshot_On_Conflict = {
  constraint: BenchmarkSnapshot_Constraint;
  update_columns?: Array<BenchmarkSnapshot_Update_Column>;
  where?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
};

/** Ordering options when selecting data from "benchmark_snapshot". */
export type BenchmarkSnapshot_Order_By = {
  finishedAt?: InputMaybe<Order_By>;
  groupingVerdicts_aggregate?: InputMaybe<BenchmarkGroupingVerdict_Aggregate_Order_By>;
  materials_aggregate?: InputMaybe<BenchmarkInventoryMaterial_Aggregate_Order_By>;
  projectStates_aggregate?: InputMaybe<BenchmarkProjectState_Aggregate_Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  startedAt?: InputMaybe<Order_By>;
  toolVersion?: InputMaybe<Order_By>;
};

/** primary key columns input for table: benchmark_snapshot */
export type BenchmarkSnapshot_Pk_Columns_Input = {
  snapshotId: Scalars['bigint']['input'];
};

/** select columns of table "benchmark_snapshot" */
export enum BenchmarkSnapshot_Select_Column {
  /** column name */
  finishedAt = 'finishedAt',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  source = 'source',
  /** column name */
  startedAt = 'startedAt',
  /** column name */
  toolVersion = 'toolVersion'
}

/** input type for updating data in table "benchmark_snapshot" */
export type BenchmarkSnapshot_Set_Input = {
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  toolVersion?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type BenchmarkSnapshot_Stddev_Fields = {
  __typename?: 'benchmarkSnapshot_stddev_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type BenchmarkSnapshot_Stddev_Pop_Fields = {
  __typename?: 'benchmarkSnapshot_stddev_pop_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type BenchmarkSnapshot_Stddev_Samp_Fields = {
  __typename?: 'benchmarkSnapshot_stddev_samp_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "benchmarkSnapshot" */
export type BenchmarkSnapshot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BenchmarkSnapshot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BenchmarkSnapshot_Stream_Cursor_Value_Input = {
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  toolVersion?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type BenchmarkSnapshot_Sum_Fields = {
  __typename?: 'benchmarkSnapshot_sum_fields';
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "benchmark_snapshot" */
export enum BenchmarkSnapshot_Update_Column {
  /** column name */
  finishedAt = 'finishedAt',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  source = 'source',
  /** column name */
  startedAt = 'startedAt',
  /** column name */
  toolVersion = 'toolVersion'
}

export type BenchmarkSnapshot_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BenchmarkSnapshot_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BenchmarkSnapshot_Set_Input>;
  /** filter the rows which have to be updated */
  where: BenchmarkSnapshot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BenchmarkSnapshot_Var_Pop_Fields = {
  __typename?: 'benchmarkSnapshot_var_pop_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type BenchmarkSnapshot_Var_Samp_Fields = {
  __typename?: 'benchmarkSnapshot_var_samp_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type BenchmarkSnapshot_Variance_Fields = {
  __typename?: 'benchmarkSnapshot_variance_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "building_area_type" */
export type BuildingAreaType = {
  __typename?: 'buildingAreaType';
  value: Scalars['String']['output'];
};

/** aggregated selection of "building_area_type" */
export type BuildingAreaType_Aggregate = {
  __typename?: 'buildingAreaType_aggregate';
  aggregate?: Maybe<BuildingAreaType_Aggregate_Fields>;
  nodes: Array<BuildingAreaType>;
};

/** aggregate fields of "building_area_type" */
export type BuildingAreaType_Aggregate_Fields = {
  __typename?: 'buildingAreaType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<BuildingAreaType_Max_Fields>;
  min?: Maybe<BuildingAreaType_Min_Fields>;
};


/** aggregate fields of "building_area_type" */
export type BuildingAreaType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BuildingAreaType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "building_area_type". All fields are combined with a logical 'AND'. */
export type BuildingAreaType_Bool_Exp = {
  _and?: InputMaybe<Array<BuildingAreaType_Bool_Exp>>;
  _not?: InputMaybe<BuildingAreaType_Bool_Exp>;
  _or?: InputMaybe<Array<BuildingAreaType_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "building_area_type" */
export enum BuildingAreaType_Constraint {
  /** unique or primary key constraint on columns "value" */
  building_area_type_pkey = 'building_area_type_pkey'
}

export enum BuildingAreaType_Enum {
  above_ground = 'above_ground',
  below_ground = 'below_ground'
}

/** Boolean expression to compare columns of type "buildingAreaType_enum". All fields are combined with logical 'AND'. */
export type BuildingAreaType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<BuildingAreaType_Enum>;
  _in?: InputMaybe<Array<BuildingAreaType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BuildingAreaType_Enum>;
  _nin?: InputMaybe<Array<BuildingAreaType_Enum>>;
};

/** input type for inserting data into table "building_area_type" */
export type BuildingAreaType_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BuildingAreaType_Max_Fields = {
  __typename?: 'buildingAreaType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BuildingAreaType_Min_Fields = {
  __typename?: 'buildingAreaType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "building_area_type" */
export type BuildingAreaType_Mutation_Response = {
  __typename?: 'buildingAreaType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BuildingAreaType>;
};

/** on_conflict condition type for table "building_area_type" */
export type BuildingAreaType_On_Conflict = {
  constraint: BuildingAreaType_Constraint;
  update_columns?: Array<BuildingAreaType_Update_Column>;
  where?: InputMaybe<BuildingAreaType_Bool_Exp>;
};

/** Ordering options when selecting data from "building_area_type". */
export type BuildingAreaType_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: building_area_type */
export type BuildingAreaType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "building_area_type" */
export enum BuildingAreaType_Select_Column {
  /** column name */
  value = 'value'
}

/** input type for updating data in table "building_area_type" */
export type BuildingAreaType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "buildingAreaType" */
export type BuildingAreaType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BuildingAreaType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BuildingAreaType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "building_area_type" */
export enum BuildingAreaType_Update_Column {
  /** column name */
  value = 'value'
}

export type BuildingAreaType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BuildingAreaType_Set_Input>;
  /** filter the rows which have to be updated */
  where: BuildingAreaType_Bool_Exp;
};

/** columns and relationships of "building_part" */
export type BuildingPart = {
  __typename?: 'buildingPart';
  /** An array relationship */
  classificationCodes: Array<ClassificationCode>;
  /** An aggregate relationship */
  classificationCodes_aggregate: ClassificationCode_Aggregate;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  parent_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "building_part" */
export type BuildingPartClassificationCodesArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCode_Order_By>>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};


/** columns and relationships of "building_part" */
export type BuildingPartClassificationCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCode_Order_By>>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};

/** columns and relationships of "building_part_lifetime_source" */
export type BuildingPartLifetimeSource = {
  __typename?: 'buildingPartLifetimeSource';
  country?: Maybe<Country_Enum>;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An array relationship */
  serviceLifetimes: Array<BuildingPartServiceLifetime>;
  /** An aggregate relationship */
  serviceLifetimes_aggregate: BuildingPartServiceLifetime_Aggregate;
  source?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "building_part_lifetime_source" */
export type BuildingPartLifetimeSourceServiceLifetimesArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartServiceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartServiceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
};


/** columns and relationships of "building_part_lifetime_source" */
export type BuildingPartLifetimeSourceServiceLifetimes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartServiceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartServiceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
};

/** aggregated selection of "building_part_lifetime_source" */
export type BuildingPartLifetimeSource_Aggregate = {
  __typename?: 'buildingPartLifetimeSource_aggregate';
  aggregate?: Maybe<BuildingPartLifetimeSource_Aggregate_Fields>;
  nodes: Array<BuildingPartLifetimeSource>;
};

/** aggregate fields of "building_part_lifetime_source" */
export type BuildingPartLifetimeSource_Aggregate_Fields = {
  __typename?: 'buildingPartLifetimeSource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<BuildingPartLifetimeSource_Max_Fields>;
  min?: Maybe<BuildingPartLifetimeSource_Min_Fields>;
};


/** aggregate fields of "building_part_lifetime_source" */
export type BuildingPartLifetimeSource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BuildingPartLifetimeSource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "building_part_lifetime_source". All fields are combined with a logical 'AND'. */
export type BuildingPartLifetimeSource_Bool_Exp = {
  _and?: InputMaybe<Array<BuildingPartLifetimeSource_Bool_Exp>>;
  _not?: InputMaybe<BuildingPartLifetimeSource_Bool_Exp>;
  _or?: InputMaybe<Array<BuildingPartLifetimeSource_Bool_Exp>>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  serviceLifetimes?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
  serviceLifetimes_aggregate?: InputMaybe<BuildingPartServiceLifetime_Aggregate_Bool_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "building_part_lifetime_source" */
export enum BuildingPartLifetimeSource_Constraint {
  /** unique or primary key constraint on columns "label" */
  lifetime_table_label_key = 'lifetime_table_label_key',
  /** unique or primary key constraint on columns "id" */
  lifetime_table_pkey1 = 'lifetime_table_pkey1'
}

/** input type for inserting data into table "building_part_lifetime_source" */
export type BuildingPartLifetimeSource_Insert_Input = {
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  serviceLifetimes?: InputMaybe<BuildingPartServiceLifetime_Arr_Rel_Insert_Input>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BuildingPartLifetimeSource_Max_Fields = {
  __typename?: 'buildingPartLifetimeSource_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BuildingPartLifetimeSource_Min_Fields = {
  __typename?: 'buildingPartLifetimeSource_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "building_part_lifetime_source" */
export type BuildingPartLifetimeSource_Mutation_Response = {
  __typename?: 'buildingPartLifetimeSource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BuildingPartLifetimeSource>;
};

/** input type for inserting object relation for remote table "building_part_lifetime_source" */
export type BuildingPartLifetimeSource_Obj_Rel_Insert_Input = {
  data: BuildingPartLifetimeSource_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BuildingPartLifetimeSource_On_Conflict>;
};

/** on_conflict condition type for table "building_part_lifetime_source" */
export type BuildingPartLifetimeSource_On_Conflict = {
  constraint: BuildingPartLifetimeSource_Constraint;
  update_columns?: Array<BuildingPartLifetimeSource_Update_Column>;
  where?: InputMaybe<BuildingPartLifetimeSource_Bool_Exp>;
};

/** Ordering options when selecting data from "building_part_lifetime_source". */
export type BuildingPartLifetimeSource_Order_By = {
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  serviceLifetimes_aggregate?: InputMaybe<BuildingPartServiceLifetime_Aggregate_Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: building_part_lifetime_source */
export type BuildingPartLifetimeSource_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "building_part_lifetime_source" */
export enum BuildingPartLifetimeSource_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  source = 'source'
}

/** input type for updating data in table "building_part_lifetime_source" */
export type BuildingPartLifetimeSource_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "buildingPartLifetimeSource" */
export type BuildingPartLifetimeSource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BuildingPartLifetimeSource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BuildingPartLifetimeSource_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "building_part_lifetime_source" */
export enum BuildingPartLifetimeSource_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  source = 'source'
}

export type BuildingPartLifetimeSource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BuildingPartLifetimeSource_Set_Input>;
  /** filter the rows which have to be updated */
  where: BuildingPartLifetimeSource_Bool_Exp;
};

/** columns and relationships of "building_part_maintenance_lifetime" */
export type BuildingPartMaintenanceLifetime = {
  __typename?: 'buildingPartMaintenanceLifetime';
  building_element_classification_code_mapping_id?: Maybe<Scalars['uuid']['output']>;
  building_element_id: Scalars['uuid']['output'];
  building_part_id?: Maybe<Scalars['uuid']['output']>;
  classification_code_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  lifetime_average?: Maybe<Scalars['Int']['output']>;
  lifetime_high?: Maybe<Scalars['Int']['output']>;
  lifetime_low?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "building_part_maintenance_lifetime" */
export type BuildingPartMaintenanceLifetime_Aggregate = {
  __typename?: 'buildingPartMaintenanceLifetime_aggregate';
  aggregate?: Maybe<BuildingPartMaintenanceLifetime_Aggregate_Fields>;
  nodes: Array<BuildingPartMaintenanceLifetime>;
};

/** aggregate fields of "building_part_maintenance_lifetime" */
export type BuildingPartMaintenanceLifetime_Aggregate_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_aggregate_fields';
  avg?: Maybe<BuildingPartMaintenanceLifetime_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BuildingPartMaintenanceLifetime_Max_Fields>;
  min?: Maybe<BuildingPartMaintenanceLifetime_Min_Fields>;
  stddev?: Maybe<BuildingPartMaintenanceLifetime_Stddev_Fields>;
  stddev_pop?: Maybe<BuildingPartMaintenanceLifetime_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BuildingPartMaintenanceLifetime_Stddev_Samp_Fields>;
  sum?: Maybe<BuildingPartMaintenanceLifetime_Sum_Fields>;
  var_pop?: Maybe<BuildingPartMaintenanceLifetime_Var_Pop_Fields>;
  var_samp?: Maybe<BuildingPartMaintenanceLifetime_Var_Samp_Fields>;
  variance?: Maybe<BuildingPartMaintenanceLifetime_Variance_Fields>;
};


/** aggregate fields of "building_part_maintenance_lifetime" */
export type BuildingPartMaintenanceLifetime_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type BuildingPartMaintenanceLifetime_Avg_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_avg_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
  lifetime_average?: Maybe<Scalars['Float']['output']>;
  lifetime_high?: Maybe<Scalars['Float']['output']>;
  lifetime_low?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "building_part_maintenance_lifetime". All fields are combined with a logical 'AND'. */
export type BuildingPartMaintenanceLifetime_Bool_Exp = {
  _and?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Bool_Exp>>;
  _not?: InputMaybe<BuildingPartMaintenanceLifetime_Bool_Exp>;
  _or?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Bool_Exp>>;
  building_element_classification_code_mapping_id?: InputMaybe<Uuid_Comparison_Exp>;
  building_element_id?: InputMaybe<Uuid_Comparison_Exp>;
  building_part_id?: InputMaybe<Uuid_Comparison_Exp>;
  classification_code_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lifetime_average?: InputMaybe<Int_Comparison_Exp>;
  lifetime_high?: InputMaybe<Int_Comparison_Exp>;
  lifetime_low?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "building_part_maintenance_lifetime" */
export enum BuildingPartMaintenanceLifetime_Constraint {
  /** unique or primary key constraint on columns "id" */
  building_part_maintenance_lifetime_mapping_pkey = 'building_part_maintenance_lifetime_mapping_pkey'
}

/** input type for incrementing numeric columns in table "building_part_maintenance_lifetime" */
export type BuildingPartMaintenanceLifetime_Inc_Input = {
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  lifetime_average?: InputMaybe<Scalars['Int']['input']>;
  lifetime_high?: InputMaybe<Scalars['Int']['input']>;
  lifetime_low?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "building_part_maintenance_lifetime" */
export type BuildingPartMaintenanceLifetime_Insert_Input = {
  building_element_classification_code_mapping_id?: InputMaybe<Scalars['uuid']['input']>;
  building_element_id?: InputMaybe<Scalars['uuid']['input']>;
  building_part_id?: InputMaybe<Scalars['uuid']['input']>;
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lifetime_average?: InputMaybe<Scalars['Int']['input']>;
  lifetime_high?: InputMaybe<Scalars['Int']['input']>;
  lifetime_low?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type BuildingPartMaintenanceLifetime_Max_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_max_fields';
  building_element_classification_code_mapping_id?: Maybe<Scalars['uuid']['output']>;
  building_element_id?: Maybe<Scalars['uuid']['output']>;
  building_part_id?: Maybe<Scalars['uuid']['output']>;
  classification_code_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lifetime_average?: Maybe<Scalars['Int']['output']>;
  lifetime_high?: Maybe<Scalars['Int']['output']>;
  lifetime_low?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type BuildingPartMaintenanceLifetime_Min_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_min_fields';
  building_element_classification_code_mapping_id?: Maybe<Scalars['uuid']['output']>;
  building_element_id?: Maybe<Scalars['uuid']['output']>;
  building_part_id?: Maybe<Scalars['uuid']['output']>;
  classification_code_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lifetime_average?: Maybe<Scalars['Int']['output']>;
  lifetime_high?: Maybe<Scalars['Int']['output']>;
  lifetime_low?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "building_part_maintenance_lifetime" */
export type BuildingPartMaintenanceLifetime_Mutation_Response = {
  __typename?: 'buildingPartMaintenanceLifetime_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BuildingPartMaintenanceLifetime>;
};

/** on_conflict condition type for table "building_part_maintenance_lifetime" */
export type BuildingPartMaintenanceLifetime_On_Conflict = {
  constraint: BuildingPartMaintenanceLifetime_Constraint;
  update_columns?: Array<BuildingPartMaintenanceLifetime_Update_Column>;
  where?: InputMaybe<BuildingPartMaintenanceLifetime_Bool_Exp>;
};

/** Ordering options when selecting data from "building_part_maintenance_lifetime". */
export type BuildingPartMaintenanceLifetime_Order_By = {
  building_element_classification_code_mapping_id?: InputMaybe<Order_By>;
  building_element_id?: InputMaybe<Order_By>;
  building_part_id?: InputMaybe<Order_By>;
  classification_code_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lifetime_average?: InputMaybe<Order_By>;
  lifetime_high?: InputMaybe<Order_By>;
  lifetime_low?: InputMaybe<Order_By>;
};

/** primary key columns input for table: building_part_maintenance_lifetime */
export type BuildingPartMaintenanceLifetime_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "building_part_maintenance_lifetime" */
export enum BuildingPartMaintenanceLifetime_Select_Column {
  /** column name */
  building_element_classification_code_mapping_id = 'building_element_classification_code_mapping_id',
  /** column name */
  building_element_id = 'building_element_id',
  /** column name */
  building_part_id = 'building_part_id',
  /** column name */
  classification_code_id = 'classification_code_id',
  /** column name */
  id = 'id',
  /** column name */
  lifetime_average = 'lifetime_average',
  /** column name */
  lifetime_high = 'lifetime_high',
  /** column name */
  lifetime_low = 'lifetime_low'
}

/** input type for updating data in table "building_part_maintenance_lifetime" */
export type BuildingPartMaintenanceLifetime_Set_Input = {
  building_element_classification_code_mapping_id?: InputMaybe<Scalars['uuid']['input']>;
  building_element_id?: InputMaybe<Scalars['uuid']['input']>;
  building_part_id?: InputMaybe<Scalars['uuid']['input']>;
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lifetime_average?: InputMaybe<Scalars['Int']['input']>;
  lifetime_high?: InputMaybe<Scalars['Int']['input']>;
  lifetime_low?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type BuildingPartMaintenanceLifetime_Stddev_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_stddev_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
  lifetime_average?: Maybe<Scalars['Float']['output']>;
  lifetime_high?: Maybe<Scalars['Float']['output']>;
  lifetime_low?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type BuildingPartMaintenanceLifetime_Stddev_Pop_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_stddev_pop_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
  lifetime_average?: Maybe<Scalars['Float']['output']>;
  lifetime_high?: Maybe<Scalars['Float']['output']>;
  lifetime_low?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type BuildingPartMaintenanceLifetime_Stddev_Samp_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_stddev_samp_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
  lifetime_average?: Maybe<Scalars['Float']['output']>;
  lifetime_high?: Maybe<Scalars['Float']['output']>;
  lifetime_low?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buildingPartMaintenanceLifetime" */
export type BuildingPartMaintenanceLifetime_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BuildingPartMaintenanceLifetime_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BuildingPartMaintenanceLifetime_Stream_Cursor_Value_Input = {
  building_element_classification_code_mapping_id?: InputMaybe<Scalars['uuid']['input']>;
  building_element_id?: InputMaybe<Scalars['uuid']['input']>;
  building_part_id?: InputMaybe<Scalars['uuid']['input']>;
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lifetime_average?: InputMaybe<Scalars['Int']['input']>;
  lifetime_high?: InputMaybe<Scalars['Int']['input']>;
  lifetime_low?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type BuildingPartMaintenanceLifetime_Sum_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_sum_fields';
  classification_code_id?: Maybe<Scalars['Int']['output']>;
  lifetime_average?: Maybe<Scalars['Int']['output']>;
  lifetime_high?: Maybe<Scalars['Int']['output']>;
  lifetime_low?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "building_part_maintenance_lifetime" */
export enum BuildingPartMaintenanceLifetime_Update_Column {
  /** column name */
  building_element_classification_code_mapping_id = 'building_element_classification_code_mapping_id',
  /** column name */
  building_element_id = 'building_element_id',
  /** column name */
  building_part_id = 'building_part_id',
  /** column name */
  classification_code_id = 'classification_code_id',
  /** column name */
  id = 'id',
  /** column name */
  lifetime_average = 'lifetime_average',
  /** column name */
  lifetime_high = 'lifetime_high',
  /** column name */
  lifetime_low = 'lifetime_low'
}

export type BuildingPartMaintenanceLifetime_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BuildingPartMaintenanceLifetime_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BuildingPartMaintenanceLifetime_Set_Input>;
  /** filter the rows which have to be updated */
  where: BuildingPartMaintenanceLifetime_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BuildingPartMaintenanceLifetime_Var_Pop_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_var_pop_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
  lifetime_average?: Maybe<Scalars['Float']['output']>;
  lifetime_high?: Maybe<Scalars['Float']['output']>;
  lifetime_low?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type BuildingPartMaintenanceLifetime_Var_Samp_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_var_samp_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
  lifetime_average?: Maybe<Scalars['Float']['output']>;
  lifetime_high?: Maybe<Scalars['Float']['output']>;
  lifetime_low?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type BuildingPartMaintenanceLifetime_Variance_Fields = {
  __typename?: 'buildingPartMaintenanceLifetime_variance_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
  lifetime_average?: Maybe<Scalars['Float']['output']>;
  lifetime_high?: Maybe<Scalars['Float']['output']>;
  lifetime_low?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "building_part_service_lifetime" */
export type BuildingPartServiceLifetime = {
  __typename?: 'buildingPartServiceLifetime';
  /** An object relationship */
  buildingElementClassificationCodeMapping?: Maybe<Building_Element_Classification_Code_Mapping>;
  buildingElementClassificationCodeMappingId?: Maybe<Scalars['uuid']['output']>;
  buildingElementId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  buildingElementMaterialCategoryMappings: Array<Building_Element_Material_Category_Mapping>;
  /** An aggregate relationship */
  buildingElementMaterialCategoryMappings_aggregate: Building_Element_Material_Category_Mapping_Aggregate;
  /** An object relationship */
  buildingPart?: Maybe<BuildingPart>;
  buildingPartId?: Maybe<Scalars['uuid']['output']>;
  buildingPartLifetimeSourceId: Scalars['uuid']['output'];
  /** An object relationship */
  classificationCode?: Maybe<ClassificationCode>;
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  lifetimeAverage: Scalars['Int']['output'];
  lifetimeHigh?: Maybe<Scalars['Int']['output']>;
  lifetimeLow?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  source: BuildingPartLifetimeSource;
};


/** columns and relationships of "building_part_service_lifetime" */
export type BuildingPartServiceLifetimeBuildingElementMaterialCategoryMappingsArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};


/** columns and relationships of "building_part_service_lifetime" */
export type BuildingPartServiceLifetimeBuildingElementMaterialCategoryMappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};

/** aggregated selection of "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Aggregate = {
  __typename?: 'buildingPartServiceLifetime_aggregate';
  aggregate?: Maybe<BuildingPartServiceLifetime_Aggregate_Fields>;
  nodes: Array<BuildingPartServiceLifetime>;
};

export type BuildingPartServiceLifetime_Aggregate_Bool_Exp = {
  count?: InputMaybe<BuildingPartServiceLifetime_Aggregate_Bool_Exp_Count>;
};

export type BuildingPartServiceLifetime_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<BuildingPartServiceLifetime_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Aggregate_Fields = {
  __typename?: 'buildingPartServiceLifetime_aggregate_fields';
  avg?: Maybe<BuildingPartServiceLifetime_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BuildingPartServiceLifetime_Max_Fields>;
  min?: Maybe<BuildingPartServiceLifetime_Min_Fields>;
  stddev?: Maybe<BuildingPartServiceLifetime_Stddev_Fields>;
  stddev_pop?: Maybe<BuildingPartServiceLifetime_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BuildingPartServiceLifetime_Stddev_Samp_Fields>;
  sum?: Maybe<BuildingPartServiceLifetime_Sum_Fields>;
  var_pop?: Maybe<BuildingPartServiceLifetime_Var_Pop_Fields>;
  var_samp?: Maybe<BuildingPartServiceLifetime_Var_Samp_Fields>;
  variance?: Maybe<BuildingPartServiceLifetime_Variance_Fields>;
};


/** aggregate fields of "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BuildingPartServiceLifetime_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Aggregate_Order_By = {
  avg?: InputMaybe<BuildingPartServiceLifetime_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<BuildingPartServiceLifetime_Max_Order_By>;
  min?: InputMaybe<BuildingPartServiceLifetime_Min_Order_By>;
  stddev?: InputMaybe<BuildingPartServiceLifetime_Stddev_Order_By>;
  stddev_pop?: InputMaybe<BuildingPartServiceLifetime_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<BuildingPartServiceLifetime_Stddev_Samp_Order_By>;
  sum?: InputMaybe<BuildingPartServiceLifetime_Sum_Order_By>;
  var_pop?: InputMaybe<BuildingPartServiceLifetime_Var_Pop_Order_By>;
  var_samp?: InputMaybe<BuildingPartServiceLifetime_Var_Samp_Order_By>;
  variance?: InputMaybe<BuildingPartServiceLifetime_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Arr_Rel_Insert_Input = {
  data: Array<BuildingPartServiceLifetime_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<BuildingPartServiceLifetime_On_Conflict>;
};

/** aggregate avg on columns */
export type BuildingPartServiceLifetime_Avg_Fields = {
  __typename?: 'buildingPartServiceLifetime_avg_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetimeAverage?: Maybe<Scalars['Float']['output']>;
  lifetimeHigh?: Maybe<Scalars['Float']['output']>;
  lifetimeLow?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Avg_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "building_part_service_lifetime". All fields are combined with a logical 'AND'. */
export type BuildingPartServiceLifetime_Bool_Exp = {
  _and?: InputMaybe<Array<BuildingPartServiceLifetime_Bool_Exp>>;
  _not?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
  _or?: InputMaybe<Array<BuildingPartServiceLifetime_Bool_Exp>>;
  buildingElementClassificationCodeMapping?: InputMaybe<Building_Element_Classification_Code_Mapping_Bool_Exp>;
  buildingElementClassificationCodeMappingId?: InputMaybe<Uuid_Comparison_Exp>;
  buildingElementId?: InputMaybe<Uuid_Comparison_Exp>;
  buildingElementMaterialCategoryMappings?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
  buildingElementMaterialCategoryMappings_aggregate?: InputMaybe<Building_Element_Material_Category_Mapping_Aggregate_Bool_Exp>;
  buildingPart?: InputMaybe<BuildingPart_Bool_Exp>;
  buildingPartId?: InputMaybe<Uuid_Comparison_Exp>;
  buildingPartLifetimeSourceId?: InputMaybe<Uuid_Comparison_Exp>;
  classificationCode?: InputMaybe<ClassificationCode_Bool_Exp>;
  classificationCodeId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lifetimeAverage?: InputMaybe<Int_Comparison_Exp>;
  lifetimeHigh?: InputMaybe<Int_Comparison_Exp>;
  lifetimeLow?: InputMaybe<Int_Comparison_Exp>;
  source?: InputMaybe<BuildingPartLifetimeSource_Bool_Exp>;
};

/** unique or primary key constraints on table "building_part_service_lifetime" */
export enum BuildingPartServiceLifetime_Constraint {
  /** unique or primary key constraint on columns "id" */
  lifetime_table_pkey = 'lifetime_table_pkey'
}

/** input type for incrementing numeric columns in table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Inc_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  lifetimeAverage?: InputMaybe<Scalars['Int']['input']>;
  lifetimeHigh?: InputMaybe<Scalars['Int']['input']>;
  lifetimeLow?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Insert_Input = {
  buildingElementClassificationCodeMapping?: InputMaybe<Building_Element_Classification_Code_Mapping_Obj_Rel_Insert_Input>;
  buildingElementClassificationCodeMappingId?: InputMaybe<Scalars['uuid']['input']>;
  buildingElementId?: InputMaybe<Scalars['uuid']['input']>;
  buildingElementMaterialCategoryMappings?: InputMaybe<Building_Element_Material_Category_Mapping_Arr_Rel_Insert_Input>;
  buildingPart?: InputMaybe<BuildingPart_Obj_Rel_Insert_Input>;
  buildingPartId?: InputMaybe<Scalars['uuid']['input']>;
  buildingPartLifetimeSourceId?: InputMaybe<Scalars['uuid']['input']>;
  classificationCode?: InputMaybe<ClassificationCode_Obj_Rel_Insert_Input>;
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lifetimeAverage?: InputMaybe<Scalars['Int']['input']>;
  lifetimeHigh?: InputMaybe<Scalars['Int']['input']>;
  lifetimeLow?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<BuildingPartLifetimeSource_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type BuildingPartServiceLifetime_Max_Fields = {
  __typename?: 'buildingPartServiceLifetime_max_fields';
  buildingElementClassificationCodeMappingId?: Maybe<Scalars['uuid']['output']>;
  buildingElementId?: Maybe<Scalars['uuid']['output']>;
  buildingPartId?: Maybe<Scalars['uuid']['output']>;
  buildingPartLifetimeSourceId?: Maybe<Scalars['uuid']['output']>;
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lifetimeAverage?: Maybe<Scalars['Int']['output']>;
  lifetimeHigh?: Maybe<Scalars['Int']['output']>;
  lifetimeLow?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Max_Order_By = {
  buildingElementClassificationCodeMappingId?: InputMaybe<Order_By>;
  buildingElementId?: InputMaybe<Order_By>;
  buildingPartId?: InputMaybe<Order_By>;
  buildingPartLifetimeSourceId?: InputMaybe<Order_By>;
  classificationCodeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type BuildingPartServiceLifetime_Min_Fields = {
  __typename?: 'buildingPartServiceLifetime_min_fields';
  buildingElementClassificationCodeMappingId?: Maybe<Scalars['uuid']['output']>;
  buildingElementId?: Maybe<Scalars['uuid']['output']>;
  buildingPartId?: Maybe<Scalars['uuid']['output']>;
  buildingPartLifetimeSourceId?: Maybe<Scalars['uuid']['output']>;
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lifetimeAverage?: Maybe<Scalars['Int']['output']>;
  lifetimeHigh?: Maybe<Scalars['Int']['output']>;
  lifetimeLow?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Min_Order_By = {
  buildingElementClassificationCodeMappingId?: InputMaybe<Order_By>;
  buildingElementId?: InputMaybe<Order_By>;
  buildingPartId?: InputMaybe<Order_By>;
  buildingPartLifetimeSourceId?: InputMaybe<Order_By>;
  classificationCodeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Mutation_Response = {
  __typename?: 'buildingPartServiceLifetime_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BuildingPartServiceLifetime>;
};

/** on_conflict condition type for table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_On_Conflict = {
  constraint: BuildingPartServiceLifetime_Constraint;
  update_columns?: Array<BuildingPartServiceLifetime_Update_Column>;
  where?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
};

/** Ordering options when selecting data from "building_part_service_lifetime". */
export type BuildingPartServiceLifetime_Order_By = {
  buildingElementClassificationCodeMapping?: InputMaybe<Building_Element_Classification_Code_Mapping_Order_By>;
  buildingElementClassificationCodeMappingId?: InputMaybe<Order_By>;
  buildingElementId?: InputMaybe<Order_By>;
  buildingElementMaterialCategoryMappings_aggregate?: InputMaybe<Building_Element_Material_Category_Mapping_Aggregate_Order_By>;
  buildingPart?: InputMaybe<BuildingPart_Order_By>;
  buildingPartId?: InputMaybe<Order_By>;
  buildingPartLifetimeSourceId?: InputMaybe<Order_By>;
  classificationCode?: InputMaybe<ClassificationCode_Order_By>;
  classificationCodeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
  source?: InputMaybe<BuildingPartLifetimeSource_Order_By>;
};

/** primary key columns input for table: building_part_service_lifetime */
export type BuildingPartServiceLifetime_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "building_part_service_lifetime" */
export enum BuildingPartServiceLifetime_Select_Column {
  /** column name */
  buildingElementClassificationCodeMappingId = 'buildingElementClassificationCodeMappingId',
  /** column name */
  buildingElementId = 'buildingElementId',
  /** column name */
  buildingPartId = 'buildingPartId',
  /** column name */
  buildingPartLifetimeSourceId = 'buildingPartLifetimeSourceId',
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  id = 'id',
  /** column name */
  lifetimeAverage = 'lifetimeAverage',
  /** column name */
  lifetimeHigh = 'lifetimeHigh',
  /** column name */
  lifetimeLow = 'lifetimeLow'
}

/** input type for updating data in table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Set_Input = {
  buildingElementClassificationCodeMappingId?: InputMaybe<Scalars['uuid']['input']>;
  buildingElementId?: InputMaybe<Scalars['uuid']['input']>;
  buildingPartId?: InputMaybe<Scalars['uuid']['input']>;
  buildingPartLifetimeSourceId?: InputMaybe<Scalars['uuid']['input']>;
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lifetimeAverage?: InputMaybe<Scalars['Int']['input']>;
  lifetimeHigh?: InputMaybe<Scalars['Int']['input']>;
  lifetimeLow?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type BuildingPartServiceLifetime_Stddev_Fields = {
  __typename?: 'buildingPartServiceLifetime_stddev_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetimeAverage?: Maybe<Scalars['Float']['output']>;
  lifetimeHigh?: Maybe<Scalars['Float']['output']>;
  lifetimeLow?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Stddev_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type BuildingPartServiceLifetime_Stddev_Pop_Fields = {
  __typename?: 'buildingPartServiceLifetime_stddev_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetimeAverage?: Maybe<Scalars['Float']['output']>;
  lifetimeHigh?: Maybe<Scalars['Float']['output']>;
  lifetimeLow?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Stddev_Pop_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type BuildingPartServiceLifetime_Stddev_Samp_Fields = {
  __typename?: 'buildingPartServiceLifetime_stddev_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetimeAverage?: Maybe<Scalars['Float']['output']>;
  lifetimeHigh?: Maybe<Scalars['Float']['output']>;
  lifetimeLow?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Stddev_Samp_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "buildingPartServiceLifetime" */
export type BuildingPartServiceLifetime_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BuildingPartServiceLifetime_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BuildingPartServiceLifetime_Stream_Cursor_Value_Input = {
  buildingElementClassificationCodeMappingId?: InputMaybe<Scalars['uuid']['input']>;
  buildingElementId?: InputMaybe<Scalars['uuid']['input']>;
  buildingPartId?: InputMaybe<Scalars['uuid']['input']>;
  buildingPartLifetimeSourceId?: InputMaybe<Scalars['uuid']['input']>;
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lifetimeAverage?: InputMaybe<Scalars['Int']['input']>;
  lifetimeHigh?: InputMaybe<Scalars['Int']['input']>;
  lifetimeLow?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type BuildingPartServiceLifetime_Sum_Fields = {
  __typename?: 'buildingPartServiceLifetime_sum_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  lifetimeAverage?: Maybe<Scalars['Int']['output']>;
  lifetimeHigh?: Maybe<Scalars['Int']['output']>;
  lifetimeLow?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Sum_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** update columns of table "building_part_service_lifetime" */
export enum BuildingPartServiceLifetime_Update_Column {
  /** column name */
  buildingElementClassificationCodeMappingId = 'buildingElementClassificationCodeMappingId',
  /** column name */
  buildingElementId = 'buildingElementId',
  /** column name */
  buildingPartId = 'buildingPartId',
  /** column name */
  buildingPartLifetimeSourceId = 'buildingPartLifetimeSourceId',
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  id = 'id',
  /** column name */
  lifetimeAverage = 'lifetimeAverage',
  /** column name */
  lifetimeHigh = 'lifetimeHigh',
  /** column name */
  lifetimeLow = 'lifetimeLow'
}

export type BuildingPartServiceLifetime_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BuildingPartServiceLifetime_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BuildingPartServiceLifetime_Set_Input>;
  /** filter the rows which have to be updated */
  where: BuildingPartServiceLifetime_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BuildingPartServiceLifetime_Var_Pop_Fields = {
  __typename?: 'buildingPartServiceLifetime_var_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetimeAverage?: Maybe<Scalars['Float']['output']>;
  lifetimeHigh?: Maybe<Scalars['Float']['output']>;
  lifetimeLow?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Var_Pop_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type BuildingPartServiceLifetime_Var_Samp_Fields = {
  __typename?: 'buildingPartServiceLifetime_var_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetimeAverage?: Maybe<Scalars['Float']['output']>;
  lifetimeHigh?: Maybe<Scalars['Float']['output']>;
  lifetimeLow?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Var_Samp_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type BuildingPartServiceLifetime_Variance_Fields = {
  __typename?: 'buildingPartServiceLifetime_variance_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetimeAverage?: Maybe<Scalars['Float']['output']>;
  lifetimeHigh?: Maybe<Scalars['Float']['output']>;
  lifetimeLow?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "building_part_service_lifetime" */
export type BuildingPartServiceLifetime_Variance_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  lifetimeAverage?: InputMaybe<Order_By>;
  lifetimeHigh?: InputMaybe<Order_By>;
  lifetimeLow?: InputMaybe<Order_By>;
};

/** aggregated selection of "building_part" */
export type BuildingPart_Aggregate = {
  __typename?: 'buildingPart_aggregate';
  aggregate?: Maybe<BuildingPart_Aggregate_Fields>;
  nodes: Array<BuildingPart>;
};

/** aggregate fields of "building_part" */
export type BuildingPart_Aggregate_Fields = {
  __typename?: 'buildingPart_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<BuildingPart_Max_Fields>;
  min?: Maybe<BuildingPart_Min_Fields>;
};


/** aggregate fields of "building_part" */
export type BuildingPart_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BuildingPart_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "building_part". All fields are combined with a logical 'AND'. */
export type BuildingPart_Bool_Exp = {
  _and?: InputMaybe<Array<BuildingPart_Bool_Exp>>;
  _not?: InputMaybe<BuildingPart_Bool_Exp>;
  _or?: InputMaybe<Array<BuildingPart_Bool_Exp>>;
  classificationCodes?: InputMaybe<ClassificationCode_Bool_Exp>;
  classificationCodes_aggregate?: InputMaybe<ClassificationCode_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "building_part" */
export enum BuildingPart_Constraint {
  /** unique or primary key constraint on columns "id" */
  building_part_pkey = 'building_part_pkey'
}

/** input type for inserting data into table "building_part" */
export type BuildingPart_Insert_Input = {
  classificationCodes?: InputMaybe<ClassificationCode_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type BuildingPart_Max_Fields = {
  __typename?: 'buildingPart_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type BuildingPart_Min_Fields = {
  __typename?: 'buildingPart_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "building_part" */
export type BuildingPart_Mutation_Response = {
  __typename?: 'buildingPart_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BuildingPart>;
};

/** input type for inserting object relation for remote table "building_part" */
export type BuildingPart_Obj_Rel_Insert_Input = {
  data: BuildingPart_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BuildingPart_On_Conflict>;
};

/** on_conflict condition type for table "building_part" */
export type BuildingPart_On_Conflict = {
  constraint: BuildingPart_Constraint;
  update_columns?: Array<BuildingPart_Update_Column>;
  where?: InputMaybe<BuildingPart_Bool_Exp>;
};

/** Ordering options when selecting data from "building_part". */
export type BuildingPart_Order_By = {
  classificationCodes_aggregate?: InputMaybe<ClassificationCode_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: building_part */
export type BuildingPart_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "building_part" */
export enum BuildingPart_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  parent_id = 'parent_id'
}

/** input type for updating data in table "building_part" */
export type BuildingPart_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "buildingPart" */
export type BuildingPart_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BuildingPart_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BuildingPart_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "building_part" */
export enum BuildingPart_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  parent_id = 'parent_id'
}

export type BuildingPart_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BuildingPart_Set_Input>;
  /** filter the rows which have to be updated */
  where: BuildingPart_Bool_Exp;
};

/** columns and relationships of "building_type" */
export type BuildingType = {
  __typename?: 'buildingType';
  code?: Maybe<Scalars['String']['output']>;
  country: Country_Enum;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  parent?: Maybe<BuildingType>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "building_type" */
export type BuildingType_Aggregate = {
  __typename?: 'buildingType_aggregate';
  aggregate?: Maybe<BuildingType_Aggregate_Fields>;
  nodes: Array<BuildingType>;
};

/** aggregate fields of "building_type" */
export type BuildingType_Aggregate_Fields = {
  __typename?: 'buildingType_aggregate_fields';
  avg?: Maybe<BuildingType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BuildingType_Max_Fields>;
  min?: Maybe<BuildingType_Min_Fields>;
  stddev?: Maybe<BuildingType_Stddev_Fields>;
  stddev_pop?: Maybe<BuildingType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BuildingType_Stddev_Samp_Fields>;
  sum?: Maybe<BuildingType_Sum_Fields>;
  var_pop?: Maybe<BuildingType_Var_Pop_Fields>;
  var_samp?: Maybe<BuildingType_Var_Samp_Fields>;
  variance?: Maybe<BuildingType_Variance_Fields>;
};


/** aggregate fields of "building_type" */
export type BuildingType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BuildingType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type BuildingType_Avg_Fields = {
  __typename?: 'buildingType_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "building_type". All fields are combined with a logical 'AND'. */
export type BuildingType_Bool_Exp = {
  _and?: InputMaybe<Array<BuildingType_Bool_Exp>>;
  _not?: InputMaybe<BuildingType_Bool_Exp>;
  _or?: InputMaybe<Array<BuildingType_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  parent?: InputMaybe<BuildingType_Bool_Exp>;
  parentId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "building_type" */
export enum BuildingType_Constraint {
  /** unique or primary key constraint on columns "id" */
  building_type_pkey = 'building_type_pkey'
}

/** input type for incrementing numeric columns in table "building_type" */
export type BuildingType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "building_type" */
export type BuildingType_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<BuildingType_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type BuildingType_Max_Fields = {
  __typename?: 'buildingType_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type BuildingType_Min_Fields = {
  __typename?: 'buildingType_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "building_type" */
export type BuildingType_Mutation_Response = {
  __typename?: 'buildingType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BuildingType>;
};

/** input type for inserting object relation for remote table "building_type" */
export type BuildingType_Obj_Rel_Insert_Input = {
  data: BuildingType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BuildingType_On_Conflict>;
};

/** on_conflict condition type for table "building_type" */
export type BuildingType_On_Conflict = {
  constraint: BuildingType_Constraint;
  update_columns?: Array<BuildingType_Update_Column>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};

/** Ordering options when selecting data from "building_type". */
export type BuildingType_Order_By = {
  code?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  parent?: InputMaybe<BuildingType_Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: building_type */
export type BuildingType_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "building_type" */
export enum BuildingType_Select_Column {
  /** column name */
  code = 'code',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  parentId = 'parentId'
}

/** input type for updating data in table "building_type" */
export type BuildingType_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type BuildingType_Stddev_Fields = {
  __typename?: 'buildingType_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type BuildingType_Stddev_Pop_Fields = {
  __typename?: 'buildingType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type BuildingType_Stddev_Samp_Fields = {
  __typename?: 'buildingType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buildingType" */
export type BuildingType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BuildingType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BuildingType_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type BuildingType_Sum_Fields = {
  __typename?: 'buildingType_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "building_type" */
export enum BuildingType_Update_Column {
  /** column name */
  code = 'code',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  parentId = 'parentId'
}

export type BuildingType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BuildingType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BuildingType_Set_Input>;
  /** filter the rows which have to be updated */
  where: BuildingType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BuildingType_Var_Pop_Fields = {
  __typename?: 'buildingType_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type BuildingType_Var_Samp_Fields = {
  __typename?: 'buildingType_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type BuildingType_Variance_Fields = {
  __typename?: 'buildingType_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "building_element" */
export type Building_Element = {
  __typename?: 'building_element';
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An array relationship */
  materialCategoryMappings: Array<Building_Element_Material_Category_Mapping>;
  /** An aggregate relationship */
  materialCategoryMappings_aggregate: Building_Element_Material_Category_Mapping_Aggregate;
};


/** columns and relationships of "building_element" */
export type Building_ElementMaterialCategoryMappingsArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};


/** columns and relationships of "building_element" */
export type Building_ElementMaterialCategoryMappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};

/** aggregated selection of "building_element" */
export type Building_Element_Aggregate = {
  __typename?: 'building_element_aggregate';
  aggregate?: Maybe<Building_Element_Aggregate_Fields>;
  nodes: Array<Building_Element>;
};

/** aggregate fields of "building_element" */
export type Building_Element_Aggregate_Fields = {
  __typename?: 'building_element_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Building_Element_Max_Fields>;
  min?: Maybe<Building_Element_Min_Fields>;
};


/** aggregate fields of "building_element" */
export type Building_Element_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Building_Element_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "building_element". All fields are combined with a logical 'AND'. */
export type Building_Element_Bool_Exp = {
  _and?: InputMaybe<Array<Building_Element_Bool_Exp>>;
  _not?: InputMaybe<Building_Element_Bool_Exp>;
  _or?: InputMaybe<Array<Building_Element_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  materialCategoryMappings?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
  materialCategoryMappings_aggregate?: InputMaybe<Building_Element_Material_Category_Mapping_Aggregate_Bool_Exp>;
};

/** columns and relationships of "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping = {
  __typename?: 'building_element_classification_code_mapping';
  /** An object relationship */
  buildingElement?: Maybe<Building_Element>;
  building_element_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  classificationCode: ClassificationCode;
  classification_code_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_Aggregate = {
  __typename?: 'building_element_classification_code_mapping_aggregate';
  aggregate?: Maybe<Building_Element_Classification_Code_Mapping_Aggregate_Fields>;
  nodes: Array<Building_Element_Classification_Code_Mapping>;
};

/** aggregate fields of "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_Aggregate_Fields = {
  __typename?: 'building_element_classification_code_mapping_aggregate_fields';
  avg?: Maybe<Building_Element_Classification_Code_Mapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Building_Element_Classification_Code_Mapping_Max_Fields>;
  min?: Maybe<Building_Element_Classification_Code_Mapping_Min_Fields>;
  stddev?: Maybe<Building_Element_Classification_Code_Mapping_Stddev_Fields>;
  stddev_pop?: Maybe<Building_Element_Classification_Code_Mapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Building_Element_Classification_Code_Mapping_Stddev_Samp_Fields>;
  sum?: Maybe<Building_Element_Classification_Code_Mapping_Sum_Fields>;
  var_pop?: Maybe<Building_Element_Classification_Code_Mapping_Var_Pop_Fields>;
  var_samp?: Maybe<Building_Element_Classification_Code_Mapping_Var_Samp_Fields>;
  variance?: Maybe<Building_Element_Classification_Code_Mapping_Variance_Fields>;
};


/** aggregate fields of "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Building_Element_Classification_Code_Mapping_Avg_Fields = {
  __typename?: 'building_element_classification_code_mapping_avg_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "building_element_classification_code_mapping". All fields are combined with a logical 'AND'. */
export type Building_Element_Classification_Code_Mapping_Bool_Exp = {
  _and?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Bool_Exp>>;
  _not?: InputMaybe<Building_Element_Classification_Code_Mapping_Bool_Exp>;
  _or?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Bool_Exp>>;
  buildingElement?: InputMaybe<Building_Element_Bool_Exp>;
  building_element_id?: InputMaybe<Uuid_Comparison_Exp>;
  classificationCode?: InputMaybe<ClassificationCode_Bool_Exp>;
  classification_code_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "building_element_classification_code_mapping" */
export enum Building_Element_Classification_Code_Mapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  building_element_classification_code_mapping_pkey = 'building_element_classification_code_mapping_pkey'
}

/** input type for incrementing numeric columns in table "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_Inc_Input = {
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_Insert_Input = {
  buildingElement?: InputMaybe<Building_Element_Obj_Rel_Insert_Input>;
  building_element_id?: InputMaybe<Scalars['uuid']['input']>;
  classificationCode?: InputMaybe<ClassificationCode_Obj_Rel_Insert_Input>;
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Building_Element_Classification_Code_Mapping_Max_Fields = {
  __typename?: 'building_element_classification_code_mapping_max_fields';
  building_element_id?: Maybe<Scalars['uuid']['output']>;
  classification_code_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Building_Element_Classification_Code_Mapping_Min_Fields = {
  __typename?: 'building_element_classification_code_mapping_min_fields';
  building_element_id?: Maybe<Scalars['uuid']['output']>;
  classification_code_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_Mutation_Response = {
  __typename?: 'building_element_classification_code_mapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Building_Element_Classification_Code_Mapping>;
};

/** input type for inserting object relation for remote table "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_Obj_Rel_Insert_Input = {
  data: Building_Element_Classification_Code_Mapping_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Building_Element_Classification_Code_Mapping_On_Conflict>;
};

/** on_conflict condition type for table "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_On_Conflict = {
  constraint: Building_Element_Classification_Code_Mapping_Constraint;
  update_columns?: Array<Building_Element_Classification_Code_Mapping_Update_Column>;
  where?: InputMaybe<Building_Element_Classification_Code_Mapping_Bool_Exp>;
};

/** Ordering options when selecting data from "building_element_classification_code_mapping". */
export type Building_Element_Classification_Code_Mapping_Order_By = {
  buildingElement?: InputMaybe<Building_Element_Order_By>;
  building_element_id?: InputMaybe<Order_By>;
  classificationCode?: InputMaybe<ClassificationCode_Order_By>;
  classification_code_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: building_element_classification_code_mapping */
export type Building_Element_Classification_Code_Mapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "building_element_classification_code_mapping" */
export enum Building_Element_Classification_Code_Mapping_Select_Column {
  /** column name */
  building_element_id = 'building_element_id',
  /** column name */
  classification_code_id = 'classification_code_id',
  /** column name */
  id = 'id'
}

/** input type for updating data in table "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_Set_Input = {
  building_element_id?: InputMaybe<Scalars['uuid']['input']>;
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Building_Element_Classification_Code_Mapping_Stddev_Fields = {
  __typename?: 'building_element_classification_code_mapping_stddev_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Building_Element_Classification_Code_Mapping_Stddev_Pop_Fields = {
  __typename?: 'building_element_classification_code_mapping_stddev_pop_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Building_Element_Classification_Code_Mapping_Stddev_Samp_Fields = {
  __typename?: 'building_element_classification_code_mapping_stddev_samp_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "building_element_classification_code_mapping" */
export type Building_Element_Classification_Code_Mapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Building_Element_Classification_Code_Mapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Building_Element_Classification_Code_Mapping_Stream_Cursor_Value_Input = {
  building_element_id?: InputMaybe<Scalars['uuid']['input']>;
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Building_Element_Classification_Code_Mapping_Sum_Fields = {
  __typename?: 'building_element_classification_code_mapping_sum_fields';
  classification_code_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "building_element_classification_code_mapping" */
export enum Building_Element_Classification_Code_Mapping_Update_Column {
  /** column name */
  building_element_id = 'building_element_id',
  /** column name */
  classification_code_id = 'classification_code_id',
  /** column name */
  id = 'id'
}

export type Building_Element_Classification_Code_Mapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Building_Element_Classification_Code_Mapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Building_Element_Classification_Code_Mapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: Building_Element_Classification_Code_Mapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Building_Element_Classification_Code_Mapping_Var_Pop_Fields = {
  __typename?: 'building_element_classification_code_mapping_var_pop_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Building_Element_Classification_Code_Mapping_Var_Samp_Fields = {
  __typename?: 'building_element_classification_code_mapping_var_samp_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Building_Element_Classification_Code_Mapping_Variance_Fields = {
  __typename?: 'building_element_classification_code_mapping_variance_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "building_element" */
export enum Building_Element_Constraint {
  /** unique or primary key constraint on columns "label" */
  building_element_label_key = 'building_element_label_key',
  /** unique or primary key constraint on columns "id" */
  building_element_pkey = 'building_element_pkey'
}

/** input type for inserting data into table "building_element" */
export type Building_Element_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  materialCategoryMappings?: InputMaybe<Building_Element_Material_Category_Mapping_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping = {
  __typename?: 'building_element_material_category_mapping';
  building_element_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  materialCategory: MaterialCategory;
  material_category_id: Scalars['String']['output'];
};

/** aggregated selection of "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Aggregate = {
  __typename?: 'building_element_material_category_mapping_aggregate';
  aggregate?: Maybe<Building_Element_Material_Category_Mapping_Aggregate_Fields>;
  nodes: Array<Building_Element_Material_Category_Mapping>;
};

export type Building_Element_Material_Category_Mapping_Aggregate_Bool_Exp = {
  count?: InputMaybe<Building_Element_Material_Category_Mapping_Aggregate_Bool_Exp_Count>;
};

export type Building_Element_Material_Category_Mapping_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Aggregate_Fields = {
  __typename?: 'building_element_material_category_mapping_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Building_Element_Material_Category_Mapping_Max_Fields>;
  min?: Maybe<Building_Element_Material_Category_Mapping_Min_Fields>;
};


/** aggregate fields of "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Building_Element_Material_Category_Mapping_Max_Order_By>;
  min?: InputMaybe<Building_Element_Material_Category_Mapping_Min_Order_By>;
};

/** input type for inserting array relation for remote table "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Arr_Rel_Insert_Input = {
  data: Array<Building_Element_Material_Category_Mapping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Building_Element_Material_Category_Mapping_On_Conflict>;
};

/** Boolean expression to filter rows from the table "building_element_material_category_mapping". All fields are combined with a logical 'AND'. */
export type Building_Element_Material_Category_Mapping_Bool_Exp = {
  _and?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Bool_Exp>>;
  _not?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
  _or?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Bool_Exp>>;
  building_element_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  materialCategory?: InputMaybe<MaterialCategory_Bool_Exp>;
  material_category_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "building_element_material_category_mapping" */
export enum Building_Element_Material_Category_Mapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  building_element_material_category_mapping_pkey = 'building_element_material_category_mapping_pkey'
}

/** input type for inserting data into table "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Insert_Input = {
  building_element_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialCategory?: InputMaybe<MaterialCategory_Obj_Rel_Insert_Input>;
  material_category_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Building_Element_Material_Category_Mapping_Max_Fields = {
  __typename?: 'building_element_material_category_mapping_max_fields';
  building_element_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  material_category_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Max_Order_By = {
  building_element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  material_category_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Building_Element_Material_Category_Mapping_Min_Fields = {
  __typename?: 'building_element_material_category_mapping_min_fields';
  building_element_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  material_category_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Min_Order_By = {
  building_element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  material_category_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Mutation_Response = {
  __typename?: 'building_element_material_category_mapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Building_Element_Material_Category_Mapping>;
};

/** on_conflict condition type for table "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_On_Conflict = {
  constraint: Building_Element_Material_Category_Mapping_Constraint;
  update_columns?: Array<Building_Element_Material_Category_Mapping_Update_Column>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};

/** Ordering options when selecting data from "building_element_material_category_mapping". */
export type Building_Element_Material_Category_Mapping_Order_By = {
  building_element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  materialCategory?: InputMaybe<MaterialCategory_Order_By>;
  material_category_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: building_element_material_category_mapping */
export type Building_Element_Material_Category_Mapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "building_element_material_category_mapping" */
export enum Building_Element_Material_Category_Mapping_Select_Column {
  /** column name */
  building_element_id = 'building_element_id',
  /** column name */
  id = 'id',
  /** column name */
  material_category_id = 'material_category_id'
}

/** input type for updating data in table "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Set_Input = {
  building_element_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  material_category_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "building_element_material_category_mapping" */
export type Building_Element_Material_Category_Mapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Building_Element_Material_Category_Mapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Building_Element_Material_Category_Mapping_Stream_Cursor_Value_Input = {
  building_element_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  material_category_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "building_element_material_category_mapping" */
export enum Building_Element_Material_Category_Mapping_Update_Column {
  /** column name */
  building_element_id = 'building_element_id',
  /** column name */
  id = 'id',
  /** column name */
  material_category_id = 'material_category_id'
}

export type Building_Element_Material_Category_Mapping_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Building_Element_Material_Category_Mapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: Building_Element_Material_Category_Mapping_Bool_Exp;
};

/** aggregate max on columns */
export type Building_Element_Max_Fields = {
  __typename?: 'building_element_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Building_Element_Min_Fields = {
  __typename?: 'building_element_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "building_element" */
export type Building_Element_Mutation_Response = {
  __typename?: 'building_element_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Building_Element>;
};

/** input type for inserting object relation for remote table "building_element" */
export type Building_Element_Obj_Rel_Insert_Input = {
  data: Building_Element_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Building_Element_On_Conflict>;
};

/** on_conflict condition type for table "building_element" */
export type Building_Element_On_Conflict = {
  constraint: Building_Element_Constraint;
  update_columns?: Array<Building_Element_Update_Column>;
  where?: InputMaybe<Building_Element_Bool_Exp>;
};

/** Ordering options when selecting data from "building_element". */
export type Building_Element_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  materialCategoryMappings_aggregate?: InputMaybe<Building_Element_Material_Category_Mapping_Aggregate_Order_By>;
};

/** primary key columns input for table: building_element */
export type Building_Element_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "building_element" */
export enum Building_Element_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

/** input type for updating data in table "building_element" */
export type Building_Element_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "building_element" */
export type Building_Element_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Building_Element_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Building_Element_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "building_element" */
export enum Building_Element_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

export type Building_Element_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Building_Element_Set_Input>;
  /** filter the rows which have to be updated */
  where: Building_Element_Bool_Exp;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']['input']>;
  _gt?: InputMaybe<Scalars['bytea']['input']>;
  _gte?: InputMaybe<Scalars['bytea']['input']>;
  _in?: InputMaybe<Array<Scalars['bytea']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bytea']['input']>;
  _lte?: InputMaybe<Scalars['bytea']['input']>;
  _neq?: InputMaybe<Scalars['bytea']['input']>;
  _nin?: InputMaybe<Array<Scalars['bytea']['input']>>;
};

/** columns and relationships of "calculation_type" */
export type CalculationType = {
  __typename?: 'calculationType';
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  country: Country_Enum;
  /** An array relationship */
  epdDatasources: Array<CalculationTypeEpdDatasource>;
  /** An aggregate relationship */
  epdDatasources_aggregate: CalculationTypeEpdDatasource_Aggregate;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  /** An array relationship */
  specialConditionTypes: Array<SpecialConditionTypeCalculationType>;
  /** An aggregate relationship */
  specialConditionTypes_aggregate: SpecialConditionTypeCalculationType_Aggregate;
  /** An array relationship */
  stages: Array<Calculation_Type_Stage>;
  /** An aggregate relationship */
  stages_aggregate: Calculation_Type_Stage_Aggregate;
  threshold?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  thresholdByBuildingType: Array<CalculationTypeThresholdByBuildingType>;
  /** An aggregate relationship */
  thresholdByBuildingType_aggregate: CalculationTypeThresholdByBuildingType_Aggregate;
  /** An object relationship */
  thresholdIndicator: IndicatorTypeMapping;
  thresholdIndicatorTypeMappingId: Scalars['uuid']['output'];
  /** An object relationship */
  variant?: Maybe<CalculationTypeVariant>;
};


/** columns and relationships of "calculation_type" */
export type CalculationTypeEpdDatasourcesArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeEpdDatasource_Order_By>>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};


/** columns and relationships of "calculation_type" */
export type CalculationTypeEpdDatasources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeEpdDatasource_Order_By>>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};


/** columns and relationships of "calculation_type" */
export type CalculationTypeSpecialConditionTypesArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeCalculationType_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};


/** columns and relationships of "calculation_type" */
export type CalculationTypeSpecialConditionTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeCalculationType_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};


/** columns and relationships of "calculation_type" */
export type CalculationTypeStagesArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Type_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Calculation_Type_Stage_Order_By>>;
  where?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
};


/** columns and relationships of "calculation_type" */
export type CalculationTypeStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Type_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Calculation_Type_Stage_Order_By>>;
  where?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
};


/** columns and relationships of "calculation_type" */
export type CalculationTypeThresholdByBuildingTypeArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Order_By>>;
  where?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
};


/** columns and relationships of "calculation_type" */
export type CalculationTypeThresholdByBuildingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Order_By>>;
  where?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
};

/** columns and relationships of "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource = {
  __typename?: 'calculationTypeEpdDatasource';
  /** An object relationship */
  calculationType: CalculationType;
  calculationTypeId: Scalars['Int']['output'];
  /** An object relationship */
  epdDatasource: EpdDatasource;
  epdDatasourceId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Aggregate = {
  __typename?: 'calculationTypeEpdDatasource_aggregate';
  aggregate?: Maybe<CalculationTypeEpdDatasource_Aggregate_Fields>;
  nodes: Array<CalculationTypeEpdDatasource>;
};

export type CalculationTypeEpdDatasource_Aggregate_Bool_Exp = {
  count?: InputMaybe<CalculationTypeEpdDatasource_Aggregate_Bool_Exp_Count>;
};

export type CalculationTypeEpdDatasource_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Aggregate_Fields = {
  __typename?: 'calculationTypeEpdDatasource_aggregate_fields';
  avg?: Maybe<CalculationTypeEpdDatasource_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CalculationTypeEpdDatasource_Max_Fields>;
  min?: Maybe<CalculationTypeEpdDatasource_Min_Fields>;
  stddev?: Maybe<CalculationTypeEpdDatasource_Stddev_Fields>;
  stddev_pop?: Maybe<CalculationTypeEpdDatasource_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CalculationTypeEpdDatasource_Stddev_Samp_Fields>;
  sum?: Maybe<CalculationTypeEpdDatasource_Sum_Fields>;
  var_pop?: Maybe<CalculationTypeEpdDatasource_Var_Pop_Fields>;
  var_samp?: Maybe<CalculationTypeEpdDatasource_Var_Samp_Fields>;
  variance?: Maybe<CalculationTypeEpdDatasource_Variance_Fields>;
};


/** aggregate fields of "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Aggregate_Order_By = {
  avg?: InputMaybe<CalculationTypeEpdDatasource_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CalculationTypeEpdDatasource_Max_Order_By>;
  min?: InputMaybe<CalculationTypeEpdDatasource_Min_Order_By>;
  stddev?: InputMaybe<CalculationTypeEpdDatasource_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CalculationTypeEpdDatasource_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CalculationTypeEpdDatasource_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CalculationTypeEpdDatasource_Sum_Order_By>;
  var_pop?: InputMaybe<CalculationTypeEpdDatasource_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CalculationTypeEpdDatasource_Var_Samp_Order_By>;
  variance?: InputMaybe<CalculationTypeEpdDatasource_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Arr_Rel_Insert_Input = {
  data: Array<CalculationTypeEpdDatasource_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CalculationTypeEpdDatasource_On_Conflict>;
};

/** aggregate avg on columns */
export type CalculationTypeEpdDatasource_Avg_Fields = {
  __typename?: 'calculationTypeEpdDatasource_avg_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Avg_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "calculation_type_epd_datasource". All fields are combined with a logical 'AND'. */
export type CalculationTypeEpdDatasource_Bool_Exp = {
  _and?: InputMaybe<Array<CalculationTypeEpdDatasource_Bool_Exp>>;
  _not?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
  _or?: InputMaybe<Array<CalculationTypeEpdDatasource_Bool_Exp>>;
  calculationType?: InputMaybe<CalculationType_Bool_Exp>;
  calculationTypeId?: InputMaybe<Int_Comparison_Exp>;
  epdDatasource?: InputMaybe<EpdDatasource_Bool_Exp>;
  epdDatasourceId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "calculation_type_epd_datasource" */
export enum CalculationTypeEpdDatasource_Constraint {
  /** unique or primary key constraint on columns "epd_datasource_id", "calculation_type_id" */
  calculation_type_epd_datasource_pkey = 'calculation_type_epd_datasource_pkey'
}

/** input type for incrementing numeric columns in table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Inc_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Insert_Input = {
  calculationType?: InputMaybe<CalculationType_Obj_Rel_Insert_Input>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  epdDatasource?: InputMaybe<EpdDatasource_Obj_Rel_Insert_Input>;
  epdDatasourceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type CalculationTypeEpdDatasource_Max_Fields = {
  __typename?: 'calculationTypeEpdDatasource_max_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  epdDatasourceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Max_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  epdDatasourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CalculationTypeEpdDatasource_Min_Fields = {
  __typename?: 'calculationTypeEpdDatasource_min_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  epdDatasourceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Min_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  epdDatasourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Mutation_Response = {
  __typename?: 'calculationTypeEpdDatasource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CalculationTypeEpdDatasource>;
};

/** on_conflict condition type for table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_On_Conflict = {
  constraint: CalculationTypeEpdDatasource_Constraint;
  update_columns?: Array<CalculationTypeEpdDatasource_Update_Column>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};

/** Ordering options when selecting data from "calculation_type_epd_datasource". */
export type CalculationTypeEpdDatasource_Order_By = {
  calculationType?: InputMaybe<CalculationType_Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  epdDatasource?: InputMaybe<EpdDatasource_Order_By>;
  epdDatasourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: calculation_type_epd_datasource */
export type CalculationTypeEpdDatasource_Pk_Columns_Input = {
  calculationTypeId: Scalars['Int']['input'];
  epdDatasourceId: Scalars['uuid']['input'];
};

/** select columns of table "calculation_type_epd_datasource" */
export enum CalculationTypeEpdDatasource_Select_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  epdDatasourceId = 'epdDatasourceId',
  /** column name */
  id = 'id'
}

/** input type for updating data in table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Set_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  epdDatasourceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type CalculationTypeEpdDatasource_Stddev_Fields = {
  __typename?: 'calculationTypeEpdDatasource_stddev_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Stddev_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CalculationTypeEpdDatasource_Stddev_Pop_Fields = {
  __typename?: 'calculationTypeEpdDatasource_stddev_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Stddev_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CalculationTypeEpdDatasource_Stddev_Samp_Fields = {
  __typename?: 'calculationTypeEpdDatasource_stddev_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Stddev_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "calculationTypeEpdDatasource" */
export type CalculationTypeEpdDatasource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CalculationTypeEpdDatasource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CalculationTypeEpdDatasource_Stream_Cursor_Value_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  epdDatasourceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type CalculationTypeEpdDatasource_Sum_Fields = {
  __typename?: 'calculationTypeEpdDatasource_sum_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Sum_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "calculation_type_epd_datasource" */
export enum CalculationTypeEpdDatasource_Update_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  epdDatasourceId = 'epdDatasourceId',
  /** column name */
  id = 'id'
}

export type CalculationTypeEpdDatasource_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CalculationTypeEpdDatasource_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalculationTypeEpdDatasource_Set_Input>;
  /** filter the rows which have to be updated */
  where: CalculationTypeEpdDatasource_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CalculationTypeEpdDatasource_Var_Pop_Fields = {
  __typename?: 'calculationTypeEpdDatasource_var_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Var_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CalculationTypeEpdDatasource_Var_Samp_Fields = {
  __typename?: 'calculationTypeEpdDatasource_var_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Var_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CalculationTypeEpdDatasource_Variance_Fields = {
  __typename?: 'calculationTypeEpdDatasource_variance_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "calculation_type_epd_datasource" */
export type CalculationTypeEpdDatasource_Variance_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType = {
  __typename?: 'calculationTypeThresholdByBuildingType';
  buildingTypeId: Scalars['Int']['output'];
  /** An object relationship */
  calculationType: CalculationType;
  calculationTypeId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  installationThreshold?: Maybe<Scalars['numeric']['output']>;
  maxTotalArea?: Maybe<Scalars['numeric']['output']>;
  threshold?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Aggregate = {
  __typename?: 'calculationTypeThresholdByBuildingType_aggregate';
  aggregate?: Maybe<CalculationTypeThresholdByBuildingType_Aggregate_Fields>;
  nodes: Array<CalculationTypeThresholdByBuildingType>;
};

export type CalculationTypeThresholdByBuildingType_Aggregate_Bool_Exp = {
  count?: InputMaybe<CalculationTypeThresholdByBuildingType_Aggregate_Bool_Exp_Count>;
};

export type CalculationTypeThresholdByBuildingType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Aggregate_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_aggregate_fields';
  avg?: Maybe<CalculationTypeThresholdByBuildingType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CalculationTypeThresholdByBuildingType_Max_Fields>;
  min?: Maybe<CalculationTypeThresholdByBuildingType_Min_Fields>;
  stddev?: Maybe<CalculationTypeThresholdByBuildingType_Stddev_Fields>;
  stddev_pop?: Maybe<CalculationTypeThresholdByBuildingType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CalculationTypeThresholdByBuildingType_Stddev_Samp_Fields>;
  sum?: Maybe<CalculationTypeThresholdByBuildingType_Sum_Fields>;
  var_pop?: Maybe<CalculationTypeThresholdByBuildingType_Var_Pop_Fields>;
  var_samp?: Maybe<CalculationTypeThresholdByBuildingType_Var_Samp_Fields>;
  variance?: Maybe<CalculationTypeThresholdByBuildingType_Variance_Fields>;
};


/** aggregate fields of "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Aggregate_Order_By = {
  avg?: InputMaybe<CalculationTypeThresholdByBuildingType_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CalculationTypeThresholdByBuildingType_Max_Order_By>;
  min?: InputMaybe<CalculationTypeThresholdByBuildingType_Min_Order_By>;
  stddev?: InputMaybe<CalculationTypeThresholdByBuildingType_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CalculationTypeThresholdByBuildingType_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CalculationTypeThresholdByBuildingType_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CalculationTypeThresholdByBuildingType_Sum_Order_By>;
  var_pop?: InputMaybe<CalculationTypeThresholdByBuildingType_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CalculationTypeThresholdByBuildingType_Var_Samp_Order_By>;
  variance?: InputMaybe<CalculationTypeThresholdByBuildingType_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Arr_Rel_Insert_Input = {
  data: Array<CalculationTypeThresholdByBuildingType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CalculationTypeThresholdByBuildingType_On_Conflict>;
};

/** aggregate avg on columns */
export type CalculationTypeThresholdByBuildingType_Avg_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_avg_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  installationThreshold?: Maybe<Scalars['Float']['output']>;
  maxTotalArea?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Avg_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "calculation_type_threshold_by_building_type". All fields are combined with a logical 'AND'. */
export type CalculationTypeThresholdByBuildingType_Bool_Exp = {
  _and?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Bool_Exp>>;
  _not?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
  _or?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Bool_Exp>>;
  buildingTypeId?: InputMaybe<Int_Comparison_Exp>;
  calculationType?: InputMaybe<CalculationType_Bool_Exp>;
  calculationTypeId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installationThreshold?: InputMaybe<Numeric_Comparison_Exp>;
  maxTotalArea?: InputMaybe<Numeric_Comparison_Exp>;
  threshold?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "calculation_type_threshold_by_building_type" */
export enum CalculationTypeThresholdByBuildingType_Constraint {
  /** unique or primary key constraint on columns "id" */
  calculation_type_building_type_pkey = 'calculation_type_building_type_pkey'
}

/** input type for incrementing numeric columns in table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Inc_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  installationThreshold?: InputMaybe<Scalars['numeric']['input']>;
  maxTotalArea?: InputMaybe<Scalars['numeric']['input']>;
  threshold?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Insert_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  calculationType?: InputMaybe<CalculationType_Obj_Rel_Insert_Input>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installationThreshold?: InputMaybe<Scalars['numeric']['input']>;
  maxTotalArea?: InputMaybe<Scalars['numeric']['input']>;
  threshold?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type CalculationTypeThresholdByBuildingType_Max_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_max_fields';
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installationThreshold?: Maybe<Scalars['numeric']['output']>;
  maxTotalArea?: Maybe<Scalars['numeric']['output']>;
  threshold?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Max_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CalculationTypeThresholdByBuildingType_Min_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_min_fields';
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installationThreshold?: Maybe<Scalars['numeric']['output']>;
  maxTotalArea?: Maybe<Scalars['numeric']['output']>;
  threshold?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Min_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Mutation_Response = {
  __typename?: 'calculationTypeThresholdByBuildingType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CalculationTypeThresholdByBuildingType>;
};

/** on_conflict condition type for table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_On_Conflict = {
  constraint: CalculationTypeThresholdByBuildingType_Constraint;
  update_columns?: Array<CalculationTypeThresholdByBuildingType_Update_Column>;
  where?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
};

/** Ordering options when selecting data from "calculation_type_threshold_by_building_type". */
export type CalculationTypeThresholdByBuildingType_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationType?: InputMaybe<CalculationType_Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** primary key columns input for table: calculation_type_threshold_by_building_type */
export type CalculationTypeThresholdByBuildingType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "calculation_type_threshold_by_building_type" */
export enum CalculationTypeThresholdByBuildingType_Select_Column {
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  installationThreshold = 'installationThreshold',
  /** column name */
  maxTotalArea = 'maxTotalArea',
  /** column name */
  threshold = 'threshold'
}

/** input type for updating data in table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Set_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installationThreshold?: InputMaybe<Scalars['numeric']['input']>;
  maxTotalArea?: InputMaybe<Scalars['numeric']['input']>;
  threshold?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type CalculationTypeThresholdByBuildingType_Stddev_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_stddev_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  installationThreshold?: Maybe<Scalars['Float']['output']>;
  maxTotalArea?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Stddev_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CalculationTypeThresholdByBuildingType_Stddev_Pop_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_stddev_pop_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  installationThreshold?: Maybe<Scalars['Float']['output']>;
  maxTotalArea?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Stddev_Pop_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CalculationTypeThresholdByBuildingType_Stddev_Samp_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_stddev_samp_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  installationThreshold?: Maybe<Scalars['Float']['output']>;
  maxTotalArea?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Stddev_Samp_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "calculationTypeThresholdByBuildingType" */
export type CalculationTypeThresholdByBuildingType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CalculationTypeThresholdByBuildingType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CalculationTypeThresholdByBuildingType_Stream_Cursor_Value_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installationThreshold?: InputMaybe<Scalars['numeric']['input']>;
  maxTotalArea?: InputMaybe<Scalars['numeric']['input']>;
  threshold?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type CalculationTypeThresholdByBuildingType_Sum_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_sum_fields';
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  installationThreshold?: Maybe<Scalars['numeric']['output']>;
  maxTotalArea?: Maybe<Scalars['numeric']['output']>;
  threshold?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Sum_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** update columns of table "calculation_type_threshold_by_building_type" */
export enum CalculationTypeThresholdByBuildingType_Update_Column {
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  installationThreshold = 'installationThreshold',
  /** column name */
  maxTotalArea = 'maxTotalArea',
  /** column name */
  threshold = 'threshold'
}

export type CalculationTypeThresholdByBuildingType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CalculationTypeThresholdByBuildingType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalculationTypeThresholdByBuildingType_Set_Input>;
  /** filter the rows which have to be updated */
  where: CalculationTypeThresholdByBuildingType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CalculationTypeThresholdByBuildingType_Var_Pop_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_var_pop_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  installationThreshold?: Maybe<Scalars['Float']['output']>;
  maxTotalArea?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Var_Pop_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CalculationTypeThresholdByBuildingType_Var_Samp_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_var_samp_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  installationThreshold?: Maybe<Scalars['Float']['output']>;
  maxTotalArea?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Var_Samp_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CalculationTypeThresholdByBuildingType_Variance_Fields = {
  __typename?: 'calculationTypeThresholdByBuildingType_variance_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  installationThreshold?: Maybe<Scalars['Float']['output']>;
  maxTotalArea?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "calculation_type_threshold_by_building_type" */
export type CalculationTypeThresholdByBuildingType_Variance_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  installationThreshold?: InputMaybe<Order_By>;
  maxTotalArea?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** columns and relationships of "calculation_type_variant" */
export type CalculationTypeVariant = {
  __typename?: 'calculationTypeVariant';
  calculationTypeId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  variant: Scalars['String']['output'];
};

/** aggregated selection of "calculation_type_variant" */
export type CalculationTypeVariant_Aggregate = {
  __typename?: 'calculationTypeVariant_aggregate';
  aggregate?: Maybe<CalculationTypeVariant_Aggregate_Fields>;
  nodes: Array<CalculationTypeVariant>;
};

/** aggregate fields of "calculation_type_variant" */
export type CalculationTypeVariant_Aggregate_Fields = {
  __typename?: 'calculationTypeVariant_aggregate_fields';
  avg?: Maybe<CalculationTypeVariant_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CalculationTypeVariant_Max_Fields>;
  min?: Maybe<CalculationTypeVariant_Min_Fields>;
  stddev?: Maybe<CalculationTypeVariant_Stddev_Fields>;
  stddev_pop?: Maybe<CalculationTypeVariant_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CalculationTypeVariant_Stddev_Samp_Fields>;
  sum?: Maybe<CalculationTypeVariant_Sum_Fields>;
  var_pop?: Maybe<CalculationTypeVariant_Var_Pop_Fields>;
  var_samp?: Maybe<CalculationTypeVariant_Var_Samp_Fields>;
  variance?: Maybe<CalculationTypeVariant_Variance_Fields>;
};


/** aggregate fields of "calculation_type_variant" */
export type CalculationTypeVariant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CalculationTypeVariant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type CalculationTypeVariant_Avg_Fields = {
  __typename?: 'calculationTypeVariant_avg_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "calculation_type_variant". All fields are combined with a logical 'AND'. */
export type CalculationTypeVariant_Bool_Exp = {
  _and?: InputMaybe<Array<CalculationTypeVariant_Bool_Exp>>;
  _not?: InputMaybe<CalculationTypeVariant_Bool_Exp>;
  _or?: InputMaybe<Array<CalculationTypeVariant_Bool_Exp>>;
  calculationTypeId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  variant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "calculation_type_variant" */
export enum CalculationTypeVariant_Constraint {
  /** unique or primary key constraint on columns "calculation_type_id" */
  calculation_type_variant_calculation_type_id_key = 'calculation_type_variant_calculation_type_id_key',
  /** unique or primary key constraint on columns "id" */
  calculation_type_variant_pkey = 'calculation_type_variant_pkey'
}

/** input type for incrementing numeric columns in table "calculation_type_variant" */
export type CalculationTypeVariant_Inc_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "calculation_type_variant" */
export type CalculationTypeVariant_Insert_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CalculationTypeVariant_Max_Fields = {
  __typename?: 'calculationTypeVariant_max_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CalculationTypeVariant_Min_Fields = {
  __typename?: 'calculationTypeVariant_min_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "calculation_type_variant" */
export type CalculationTypeVariant_Mutation_Response = {
  __typename?: 'calculationTypeVariant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CalculationTypeVariant>;
};

/** input type for inserting object relation for remote table "calculation_type_variant" */
export type CalculationTypeVariant_Obj_Rel_Insert_Input = {
  data: CalculationTypeVariant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CalculationTypeVariant_On_Conflict>;
};

/** on_conflict condition type for table "calculation_type_variant" */
export type CalculationTypeVariant_On_Conflict = {
  constraint: CalculationTypeVariant_Constraint;
  update_columns?: Array<CalculationTypeVariant_Update_Column>;
  where?: InputMaybe<CalculationTypeVariant_Bool_Exp>;
};

/** Ordering options when selecting data from "calculation_type_variant". */
export type CalculationTypeVariant_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  variant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: calculation_type_variant */
export type CalculationTypeVariant_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "calculation_type_variant" */
export enum CalculationTypeVariant_Select_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  variant = 'variant'
}

/** input type for updating data in table "calculation_type_variant" */
export type CalculationTypeVariant_Set_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type CalculationTypeVariant_Stddev_Fields = {
  __typename?: 'calculationTypeVariant_stddev_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type CalculationTypeVariant_Stddev_Pop_Fields = {
  __typename?: 'calculationTypeVariant_stddev_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type CalculationTypeVariant_Stddev_Samp_Fields = {
  __typename?: 'calculationTypeVariant_stddev_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "calculationTypeVariant" */
export type CalculationTypeVariant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CalculationTypeVariant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CalculationTypeVariant_Stream_Cursor_Value_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type CalculationTypeVariant_Sum_Fields = {
  __typename?: 'calculationTypeVariant_sum_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "calculation_type_variant" */
export enum CalculationTypeVariant_Update_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  variant = 'variant'
}

export type CalculationTypeVariant_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CalculationTypeVariant_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalculationTypeVariant_Set_Input>;
  /** filter the rows which have to be updated */
  where: CalculationTypeVariant_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CalculationTypeVariant_Var_Pop_Fields = {
  __typename?: 'calculationTypeVariant_var_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type CalculationTypeVariant_Var_Samp_Fields = {
  __typename?: 'calculationTypeVariant_var_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type CalculationTypeVariant_Variance_Fields = {
  __typename?: 'calculationTypeVariant_variance_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "calculation_type" */
export type CalculationType_Aggregate = {
  __typename?: 'calculationType_aggregate';
  aggregate?: Maybe<CalculationType_Aggregate_Fields>;
  nodes: Array<CalculationType>;
};

export type CalculationType_Aggregate_Bool_Exp = {
  count?: InputMaybe<CalculationType_Aggregate_Bool_Exp_Count>;
};

export type CalculationType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CalculationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CalculationType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "calculation_type" */
export type CalculationType_Aggregate_Fields = {
  __typename?: 'calculationType_aggregate_fields';
  avg?: Maybe<CalculationType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CalculationType_Max_Fields>;
  min?: Maybe<CalculationType_Min_Fields>;
  stddev?: Maybe<CalculationType_Stddev_Fields>;
  stddev_pop?: Maybe<CalculationType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CalculationType_Stddev_Samp_Fields>;
  sum?: Maybe<CalculationType_Sum_Fields>;
  var_pop?: Maybe<CalculationType_Var_Pop_Fields>;
  var_samp?: Maybe<CalculationType_Var_Samp_Fields>;
  variance?: Maybe<CalculationType_Variance_Fields>;
};


/** aggregate fields of "calculation_type" */
export type CalculationType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CalculationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "calculation_type" */
export type CalculationType_Aggregate_Order_By = {
  avg?: InputMaybe<CalculationType_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CalculationType_Max_Order_By>;
  min?: InputMaybe<CalculationType_Min_Order_By>;
  stddev?: InputMaybe<CalculationType_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CalculationType_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CalculationType_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CalculationType_Sum_Order_By>;
  var_pop?: InputMaybe<CalculationType_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CalculationType_Var_Samp_Order_By>;
  variance?: InputMaybe<CalculationType_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "calculation_type" */
export type CalculationType_Arr_Rel_Insert_Input = {
  data: Array<CalculationType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CalculationType_On_Conflict>;
};

/** aggregate avg on columns */
export type CalculationType_Avg_Fields = {
  __typename?: 'calculationType_avg_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "calculation_type" */
export type CalculationType_Avg_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "calculation_type". All fields are combined with a logical 'AND'. */
export type CalculationType_Bool_Exp = {
  _and?: InputMaybe<Array<CalculationType_Bool_Exp>>;
  _not?: InputMaybe<CalculationType_Bool_Exp>;
  _or?: InputMaybe<Array<CalculationType_Bool_Exp>>;
  considerationPeriod?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  epdDatasources?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
  epdDatasources_aggregate?: InputMaybe<CalculationTypeEpdDatasource_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  specialConditionTypes?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
  specialConditionTypes_aggregate?: InputMaybe<SpecialConditionTypeCalculationType_Aggregate_Bool_Exp>;
  stages?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
  stages_aggregate?: InputMaybe<Calculation_Type_Stage_Aggregate_Bool_Exp>;
  threshold?: InputMaybe<Numeric_Comparison_Exp>;
  thresholdByBuildingType?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
  thresholdByBuildingType_aggregate?: InputMaybe<CalculationTypeThresholdByBuildingType_Aggregate_Bool_Exp>;
  thresholdIndicator?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
  thresholdIndicatorTypeMappingId?: InputMaybe<Uuid_Comparison_Exp>;
  variant?: InputMaybe<CalculationTypeVariant_Bool_Exp>;
};

/** unique or primary key constraints on table "calculation_type" */
export enum CalculationType_Constraint {
  /** unique or primary key constraint on columns "id" */
  calculation_type_pkey = 'calculation_type_pkey'
}

/** input type for incrementing numeric columns in table "calculation_type" */
export type CalculationType_Inc_Input = {
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "calculation_type" */
export type CalculationType_Insert_Input = {
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  epdDatasources?: InputMaybe<CalculationTypeEpdDatasource_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  specialConditionTypes?: InputMaybe<SpecialConditionTypeCalculationType_Arr_Rel_Insert_Input>;
  stages?: InputMaybe<Calculation_Type_Stage_Arr_Rel_Insert_Input>;
  threshold?: InputMaybe<Scalars['numeric']['input']>;
  thresholdByBuildingType?: InputMaybe<CalculationTypeThresholdByBuildingType_Arr_Rel_Insert_Input>;
  thresholdIndicator?: InputMaybe<IndicatorTypeMapping_Obj_Rel_Insert_Input>;
  thresholdIndicatorTypeMappingId?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<CalculationTypeVariant_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type CalculationType_Max_Fields = {
  __typename?: 'calculationType_max_fields';
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['numeric']['output']>;
  thresholdIndicatorTypeMappingId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "calculation_type" */
export type CalculationType_Max_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
  thresholdIndicatorTypeMappingId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CalculationType_Min_Fields = {
  __typename?: 'calculationType_min_fields';
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['numeric']['output']>;
  thresholdIndicatorTypeMappingId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "calculation_type" */
export type CalculationType_Min_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
  thresholdIndicatorTypeMappingId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "calculation_type" */
export type CalculationType_Mutation_Response = {
  __typename?: 'calculationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CalculationType>;
};

/** input type for inserting object relation for remote table "calculation_type" */
export type CalculationType_Obj_Rel_Insert_Input = {
  data: CalculationType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CalculationType_On_Conflict>;
};

/** on_conflict condition type for table "calculation_type" */
export type CalculationType_On_Conflict = {
  constraint: CalculationType_Constraint;
  update_columns?: Array<CalculationType_Update_Column>;
  where?: InputMaybe<CalculationType_Bool_Exp>;
};

/** Ordering options when selecting data from "calculation_type". */
export type CalculationType_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  epdDatasources_aggregate?: InputMaybe<CalculationTypeEpdDatasource_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  specialConditionTypes_aggregate?: InputMaybe<SpecialConditionTypeCalculationType_Aggregate_Order_By>;
  stages_aggregate?: InputMaybe<Calculation_Type_Stage_Aggregate_Order_By>;
  threshold?: InputMaybe<Order_By>;
  thresholdByBuildingType_aggregate?: InputMaybe<CalculationTypeThresholdByBuildingType_Aggregate_Order_By>;
  thresholdIndicator?: InputMaybe<IndicatorTypeMapping_Order_By>;
  thresholdIndicatorTypeMappingId?: InputMaybe<Order_By>;
  variant?: InputMaybe<CalculationTypeVariant_Order_By>;
};

/** primary key columns input for table: calculation_type */
export type CalculationType_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "calculation_type" */
export enum CalculationType_Select_Column {
  /** column name */
  considerationPeriod = 'considerationPeriod',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  threshold = 'threshold',
  /** column name */
  thresholdIndicatorTypeMappingId = 'thresholdIndicatorTypeMappingId'
}

/** input type for updating data in table "calculation_type" */
export type CalculationType_Set_Input = {
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['numeric']['input']>;
  thresholdIndicatorTypeMappingId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type CalculationType_Stddev_Fields = {
  __typename?: 'calculationType_stddev_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "calculation_type" */
export type CalculationType_Stddev_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CalculationType_Stddev_Pop_Fields = {
  __typename?: 'calculationType_stddev_pop_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "calculation_type" */
export type CalculationType_Stddev_Pop_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CalculationType_Stddev_Samp_Fields = {
  __typename?: 'calculationType_stddev_samp_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "calculation_type" */
export type CalculationType_Stddev_Samp_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "calculationType" */
export type CalculationType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CalculationType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CalculationType_Stream_Cursor_Value_Input = {
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['numeric']['input']>;
  thresholdIndicatorTypeMappingId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type CalculationType_Sum_Fields = {
  __typename?: 'calculationType_sum_fields';
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "calculation_type" */
export type CalculationType_Sum_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** update columns of table "calculation_type" */
export enum CalculationType_Update_Column {
  /** column name */
  considerationPeriod = 'considerationPeriod',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  threshold = 'threshold',
  /** column name */
  thresholdIndicatorTypeMappingId = 'thresholdIndicatorTypeMappingId'
}

export type CalculationType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CalculationType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalculationType_Set_Input>;
  /** filter the rows which have to be updated */
  where: CalculationType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CalculationType_Var_Pop_Fields = {
  __typename?: 'calculationType_var_pop_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "calculation_type" */
export type CalculationType_Var_Pop_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CalculationType_Var_Samp_Fields = {
  __typename?: 'calculationType_var_samp_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "calculation_type" */
export type CalculationType_Var_Samp_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CalculationType_Variance_Fields = {
  __typename?: 'calculationType_variance_fields';
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "calculation_type" */
export type CalculationType_Variance_Order_By = {
  considerationPeriod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** columns and relationships of "calculation_type_stage" */
export type Calculation_Type_Stage = {
  __typename?: 'calculation_type_stage';
  calculation_type_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  stage: Stage;
  stageId: Scalars['Int']['output'];
};

/** aggregated selection of "calculation_type_stage" */
export type Calculation_Type_Stage_Aggregate = {
  __typename?: 'calculation_type_stage_aggregate';
  aggregate?: Maybe<Calculation_Type_Stage_Aggregate_Fields>;
  nodes: Array<Calculation_Type_Stage>;
};

export type Calculation_Type_Stage_Aggregate_Bool_Exp = {
  count?: InputMaybe<Calculation_Type_Stage_Aggregate_Bool_Exp_Count>;
};

export type Calculation_Type_Stage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Calculation_Type_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "calculation_type_stage" */
export type Calculation_Type_Stage_Aggregate_Fields = {
  __typename?: 'calculation_type_stage_aggregate_fields';
  avg?: Maybe<Calculation_Type_Stage_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Calculation_Type_Stage_Max_Fields>;
  min?: Maybe<Calculation_Type_Stage_Min_Fields>;
  stddev?: Maybe<Calculation_Type_Stage_Stddev_Fields>;
  stddev_pop?: Maybe<Calculation_Type_Stage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Calculation_Type_Stage_Stddev_Samp_Fields>;
  sum?: Maybe<Calculation_Type_Stage_Sum_Fields>;
  var_pop?: Maybe<Calculation_Type_Stage_Var_Pop_Fields>;
  var_samp?: Maybe<Calculation_Type_Stage_Var_Samp_Fields>;
  variance?: Maybe<Calculation_Type_Stage_Variance_Fields>;
};


/** aggregate fields of "calculation_type_stage" */
export type Calculation_Type_Stage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Calculation_Type_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "calculation_type_stage" */
export type Calculation_Type_Stage_Aggregate_Order_By = {
  avg?: InputMaybe<Calculation_Type_Stage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Calculation_Type_Stage_Max_Order_By>;
  min?: InputMaybe<Calculation_Type_Stage_Min_Order_By>;
  stddev?: InputMaybe<Calculation_Type_Stage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Calculation_Type_Stage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Calculation_Type_Stage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Calculation_Type_Stage_Sum_Order_By>;
  var_pop?: InputMaybe<Calculation_Type_Stage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Calculation_Type_Stage_Var_Samp_Order_By>;
  variance?: InputMaybe<Calculation_Type_Stage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "calculation_type_stage" */
export type Calculation_Type_Stage_Arr_Rel_Insert_Input = {
  data: Array<Calculation_Type_Stage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Calculation_Type_Stage_On_Conflict>;
};

/** aggregate avg on columns */
export type Calculation_Type_Stage_Avg_Fields = {
  __typename?: 'calculation_type_stage_avg_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Avg_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "calculation_type_stage". All fields are combined with a logical 'AND'. */
export type Calculation_Type_Stage_Bool_Exp = {
  _and?: InputMaybe<Array<Calculation_Type_Stage_Bool_Exp>>;
  _not?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Calculation_Type_Stage_Bool_Exp>>;
  calculation_type_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  stage?: InputMaybe<Stage_Bool_Exp>;
  stageId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "calculation_type_stage" */
export enum Calculation_Type_Stage_Constraint {
  /** unique or primary key constraint on columns "id" */
  calculation_type_stage_pkey = 'calculation_type_stage_pkey',
  /** unique or primary key constraint on columns "stage_id", "calculation_type_id" */
  calculation_type_stage_stage_id_calculation_type_id_key = 'calculation_type_stage_stage_id_calculation_type_id_key'
}

/** input type for incrementing numeric columns in table "calculation_type_stage" */
export type Calculation_Type_Stage_Inc_Input = {
  calculation_type_id?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "calculation_type_stage" */
export type Calculation_Type_Stage_Insert_Input = {
  calculation_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stage?: InputMaybe<Stage_Obj_Rel_Insert_Input>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Calculation_Type_Stage_Max_Fields = {
  __typename?: 'calculation_type_stage_max_fields';
  calculation_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Max_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Calculation_Type_Stage_Min_Fields = {
  __typename?: 'calculation_type_stage_min_fields';
  calculation_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Min_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "calculation_type_stage" */
export type Calculation_Type_Stage_Mutation_Response = {
  __typename?: 'calculation_type_stage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Calculation_Type_Stage>;
};

/** on_conflict condition type for table "calculation_type_stage" */
export type Calculation_Type_Stage_On_Conflict = {
  constraint: Calculation_Type_Stage_Constraint;
  update_columns?: Array<Calculation_Type_Stage_Update_Column>;
  where?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
};

/** Ordering options when selecting data from "calculation_type_stage". */
export type Calculation_Type_Stage_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Stage_Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: calculation_type_stage */
export type Calculation_Type_Stage_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "calculation_type_stage" */
export enum Calculation_Type_Stage_Select_Column {
  /** column name */
  calculation_type_id = 'calculation_type_id',
  /** column name */
  id = 'id',
  /** column name */
  stageId = 'stageId'
}

/** input type for updating data in table "calculation_type_stage" */
export type Calculation_Type_Stage_Set_Input = {
  calculation_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Calculation_Type_Stage_Stddev_Fields = {
  __typename?: 'calculation_type_stage_stddev_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Stddev_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Calculation_Type_Stage_Stddev_Pop_Fields = {
  __typename?: 'calculation_type_stage_stddev_pop_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Stddev_Pop_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Calculation_Type_Stage_Stddev_Samp_Fields = {
  __typename?: 'calculation_type_stage_stddev_samp_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Stddev_Samp_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "calculation_type_stage" */
export type Calculation_Type_Stage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Calculation_Type_Stage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Calculation_Type_Stage_Stream_Cursor_Value_Input = {
  calculation_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Calculation_Type_Stage_Sum_Fields = {
  __typename?: 'calculation_type_stage_sum_fields';
  calculation_type_id?: Maybe<Scalars['Int']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Sum_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** update columns of table "calculation_type_stage" */
export enum Calculation_Type_Stage_Update_Column {
  /** column name */
  calculation_type_id = 'calculation_type_id',
  /** column name */
  id = 'id',
  /** column name */
  stageId = 'stageId'
}

export type Calculation_Type_Stage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Calculation_Type_Stage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Calculation_Type_Stage_Set_Input>;
  /** filter the rows which have to be updated */
  where: Calculation_Type_Stage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Calculation_Type_Stage_Var_Pop_Fields = {
  __typename?: 'calculation_type_stage_var_pop_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Var_Pop_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Calculation_Type_Stage_Var_Samp_Fields = {
  __typename?: 'calculation_type_stage_var_samp_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Var_Samp_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Calculation_Type_Stage_Variance_Fields = {
  __typename?: 'calculation_type_stage_variance_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "calculation_type_stage" */
export type Calculation_Type_Stage_Variance_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** columns and relationships of "classification_code" */
export type ClassificationCode = {
  __typename?: 'classificationCode';
  /** An object relationship */
  buildingPart?: Maybe<BuildingPart>;
  buildingPartId?: Maybe<Scalars['uuid']['output']>;
  classificationObjectClassId?: Maybe<Scalars['uuid']['output']>;
  classificationTypeId: Scalars['uuid']['output'];
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  englishLabel: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Prioritized translated label based on order of languages in token. See _label for original label */
  label?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  objectClass?: Maybe<ClassificationObjectClass>;
  /** An object relationship */
  parent?: Maybe<ClassificationCode>;
  parentId?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  translation: Array<ClassificationCodeTranslation>;
  /** An aggregate relationship */
  translation_aggregate: ClassificationCodeTranslation_Aggregate;
  /** An object relationship */
  type: ClassificationType;
};


/** columns and relationships of "classification_code" */
export type ClassificationCodeTranslationArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTranslation_Order_By>>;
  where?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
};


/** columns and relationships of "classification_code" */
export type ClassificationCodeTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTranslation_Order_By>>;
  where?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
};

/** columns and relationships of "classification_code_translation" */
export type ClassificationCodeTranslation = {
  __typename?: 'classificationCodeTranslation';
  /** An object relationship */
  classificationCode: ClassificationCode;
  classificationCodeId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
};

/** aggregated selection of "classification_code_translation" */
export type ClassificationCodeTranslation_Aggregate = {
  __typename?: 'classificationCodeTranslation_aggregate';
  aggregate?: Maybe<ClassificationCodeTranslation_Aggregate_Fields>;
  nodes: Array<ClassificationCodeTranslation>;
};

export type ClassificationCodeTranslation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClassificationCodeTranslation_Aggregate_Bool_Exp_Count>;
};

export type ClassificationCodeTranslation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassificationCodeTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classification_code_translation" */
export type ClassificationCodeTranslation_Aggregate_Fields = {
  __typename?: 'classificationCodeTranslation_aggregate_fields';
  avg?: Maybe<ClassificationCodeTranslation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ClassificationCodeTranslation_Max_Fields>;
  min?: Maybe<ClassificationCodeTranslation_Min_Fields>;
  stddev?: Maybe<ClassificationCodeTranslation_Stddev_Fields>;
  stddev_pop?: Maybe<ClassificationCodeTranslation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClassificationCodeTranslation_Stddev_Samp_Fields>;
  sum?: Maybe<ClassificationCodeTranslation_Sum_Fields>;
  var_pop?: Maybe<ClassificationCodeTranslation_Var_Pop_Fields>;
  var_samp?: Maybe<ClassificationCodeTranslation_Var_Samp_Fields>;
  variance?: Maybe<ClassificationCodeTranslation_Variance_Fields>;
};


/** aggregate fields of "classification_code_translation" */
export type ClassificationCodeTranslation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassificationCodeTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "classification_code_translation" */
export type ClassificationCodeTranslation_Aggregate_Order_By = {
  avg?: InputMaybe<ClassificationCodeTranslation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassificationCodeTranslation_Max_Order_By>;
  min?: InputMaybe<ClassificationCodeTranslation_Min_Order_By>;
  stddev?: InputMaybe<ClassificationCodeTranslation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ClassificationCodeTranslation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ClassificationCodeTranslation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ClassificationCodeTranslation_Sum_Order_By>;
  var_pop?: InputMaybe<ClassificationCodeTranslation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ClassificationCodeTranslation_Var_Samp_Order_By>;
  variance?: InputMaybe<ClassificationCodeTranslation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "classification_code_translation" */
export type ClassificationCodeTranslation_Arr_Rel_Insert_Input = {
  data: Array<ClassificationCodeTranslation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassificationCodeTranslation_On_Conflict>;
};

/** aggregate avg on columns */
export type ClassificationCodeTranslation_Avg_Fields = {
  __typename?: 'classificationCodeTranslation_avg_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Avg_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "classification_code_translation". All fields are combined with a logical 'AND'. */
export type ClassificationCodeTranslation_Bool_Exp = {
  _and?: InputMaybe<Array<ClassificationCodeTranslation_Bool_Exp>>;
  _not?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
  _or?: InputMaybe<Array<ClassificationCodeTranslation_Bool_Exp>>;
  classificationCode?: InputMaybe<ClassificationCode_Bool_Exp>;
  classificationCodeId?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "classification_code_translation" */
export enum ClassificationCodeTranslation_Constraint {
  /** unique or primary key constraint on columns "id" */
  classification_code_translation_pkey = 'classification_code_translation_pkey'
}

/** input type for incrementing numeric columns in table "classification_code_translation" */
export type ClassificationCodeTranslation_Inc_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "classification_code_translation" */
export type ClassificationCodeTranslation_Insert_Input = {
  classificationCode?: InputMaybe<ClassificationCode_Obj_Rel_Insert_Input>;
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ClassificationCodeTranslation_Max_Fields = {
  __typename?: 'classificationCodeTranslation_max_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Max_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassificationCodeTranslation_Min_Fields = {
  __typename?: 'classificationCodeTranslation_min_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Min_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classification_code_translation" */
export type ClassificationCodeTranslation_Mutation_Response = {
  __typename?: 'classificationCodeTranslation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassificationCodeTranslation>;
};

/** on_conflict condition type for table "classification_code_translation" */
export type ClassificationCodeTranslation_On_Conflict = {
  constraint: ClassificationCodeTranslation_Constraint;
  update_columns?: Array<ClassificationCodeTranslation_Update_Column>;
  where?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
};

/** Ordering options when selecting data from "classification_code_translation". */
export type ClassificationCodeTranslation_Order_By = {
  classificationCode?: InputMaybe<ClassificationCode_Order_By>;
  classificationCodeId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classification_code_translation */
export type ClassificationCodeTranslation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "classification_code_translation" */
export enum ClassificationCodeTranslation_Select_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode'
}

/** input type for updating data in table "classification_code_translation" */
export type ClassificationCodeTranslation_Set_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ClassificationCodeTranslation_Stddev_Fields = {
  __typename?: 'classificationCodeTranslation_stddev_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Stddev_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ClassificationCodeTranslation_Stddev_Pop_Fields = {
  __typename?: 'classificationCodeTranslation_stddev_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Stddev_Pop_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ClassificationCodeTranslation_Stddev_Samp_Fields = {
  __typename?: 'classificationCodeTranslation_stddev_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Stddev_Samp_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "classificationCodeTranslation" */
export type ClassificationCodeTranslation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassificationCodeTranslation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassificationCodeTranslation_Stream_Cursor_Value_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ClassificationCodeTranslation_Sum_Fields = {
  __typename?: 'classificationCodeTranslation_sum_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Sum_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
};

/** update columns of table "classification_code_translation" */
export enum ClassificationCodeTranslation_Update_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode'
}

export type ClassificationCodeTranslation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClassificationCodeTranslation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassificationCodeTranslation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassificationCodeTranslation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClassificationCodeTranslation_Var_Pop_Fields = {
  __typename?: 'classificationCodeTranslation_var_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Var_Pop_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ClassificationCodeTranslation_Var_Samp_Fields = {
  __typename?: 'classificationCodeTranslation_var_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Var_Samp_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ClassificationCodeTranslation_Variance_Fields = {
  __typename?: 'classificationCodeTranslation_variance_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "classification_code_translation" */
export type ClassificationCodeTranslation_Variance_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "classification_type_country" */
export type ClassificationCodeTypeCountry = {
  __typename?: 'classificationCodeTypeCountry';
  /** An object relationship */
  classificationType: ClassificationType;
  classificationTypeId: Scalars['uuid']['output'];
  country: Country_Enum;
  id: Scalars['uuid']['output'];
  isDefault: Scalars['Boolean']['output'];
};

/** aggregated selection of "classification_type_country" */
export type ClassificationCodeTypeCountry_Aggregate = {
  __typename?: 'classificationCodeTypeCountry_aggregate';
  aggregate?: Maybe<ClassificationCodeTypeCountry_Aggregate_Fields>;
  nodes: Array<ClassificationCodeTypeCountry>;
};

export type ClassificationCodeTypeCountry_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Count>;
};

export type ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Bool_And = {
  arguments: ClassificationCodeTypeCountry_Select_Column_ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ClassificationCodeTypeCountry_Select_Column_ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassificationCodeTypeCountry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classification_type_country" */
export type ClassificationCodeTypeCountry_Aggregate_Fields = {
  __typename?: 'classificationCodeTypeCountry_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ClassificationCodeTypeCountry_Max_Fields>;
  min?: Maybe<ClassificationCodeTypeCountry_Min_Fields>;
};


/** aggregate fields of "classification_type_country" */
export type ClassificationCodeTypeCountry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassificationCodeTypeCountry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "classification_type_country" */
export type ClassificationCodeTypeCountry_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassificationCodeTypeCountry_Max_Order_By>;
  min?: InputMaybe<ClassificationCodeTypeCountry_Min_Order_By>;
};

/** input type for inserting array relation for remote table "classification_type_country" */
export type ClassificationCodeTypeCountry_Arr_Rel_Insert_Input = {
  data: Array<ClassificationCodeTypeCountry_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassificationCodeTypeCountry_On_Conflict>;
};

/** Boolean expression to filter rows from the table "classification_type_country". All fields are combined with a logical 'AND'. */
export type ClassificationCodeTypeCountry_Bool_Exp = {
  _and?: InputMaybe<Array<ClassificationCodeTypeCountry_Bool_Exp>>;
  _not?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
  _or?: InputMaybe<Array<ClassificationCodeTypeCountry_Bool_Exp>>;
  classificationType?: InputMaybe<ClassificationType_Bool_Exp>;
  classificationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "classification_type_country" */
export enum ClassificationCodeTypeCountry_Constraint {
  /** unique or primary key constraint on columns "country", "classification_type_id" */
  country_classification_code_t_country_classification_code_t_key = 'country_classification_code_t_country_classification_code_t_key',
  /** unique or primary key constraint on columns "id" */
  country_classification_code_type_pkey = 'country_classification_code_type_pkey'
}

/** input type for inserting data into table "classification_type_country" */
export type ClassificationCodeTypeCountry_Insert_Input = {
  classificationType?: InputMaybe<ClassificationType_Obj_Rel_Insert_Input>;
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type ClassificationCodeTypeCountry_Max_Fields = {
  __typename?: 'classificationCodeTypeCountry_max_fields';
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "classification_type_country" */
export type ClassificationCodeTypeCountry_Max_Order_By = {
  classificationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassificationCodeTypeCountry_Min_Fields = {
  __typename?: 'classificationCodeTypeCountry_min_fields';
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "classification_type_country" */
export type ClassificationCodeTypeCountry_Min_Order_By = {
  classificationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classification_type_country" */
export type ClassificationCodeTypeCountry_Mutation_Response = {
  __typename?: 'classificationCodeTypeCountry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassificationCodeTypeCountry>;
};

/** on_conflict condition type for table "classification_type_country" */
export type ClassificationCodeTypeCountry_On_Conflict = {
  constraint: ClassificationCodeTypeCountry_Constraint;
  update_columns?: Array<ClassificationCodeTypeCountry_Update_Column>;
  where?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
};

/** Ordering options when selecting data from "classification_type_country". */
export type ClassificationCodeTypeCountry_Order_By = {
  classificationType?: InputMaybe<ClassificationType_Order_By>;
  classificationTypeId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classification_type_country */
export type ClassificationCodeTypeCountry_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "classification_type_country" */
export enum ClassificationCodeTypeCountry_Select_Column {
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  isDefault = 'isDefault'
}

/** select "classificationCodeTypeCountry_aggregate_bool_exp_bool_and_arguments_columns" columns of table "classification_type_country" */
export enum ClassificationCodeTypeCountry_Select_Column_ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** select "classificationCodeTypeCountry_aggregate_bool_exp_bool_or_arguments_columns" columns of table "classification_type_country" */
export enum ClassificationCodeTypeCountry_Select_Column_ClassificationCodeTypeCountry_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** input type for updating data in table "classification_type_country" */
export type ClassificationCodeTypeCountry_Set_Input = {
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "classificationCodeTypeCountry" */
export type ClassificationCodeTypeCountry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassificationCodeTypeCountry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassificationCodeTypeCountry_Stream_Cursor_Value_Input = {
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "classification_type_country" */
export enum ClassificationCodeTypeCountry_Update_Column {
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  isDefault = 'isDefault'
}

export type ClassificationCodeTypeCountry_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassificationCodeTypeCountry_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassificationCodeTypeCountry_Bool_Exp;
};

/** aggregated selection of "classification_code" */
export type ClassificationCode_Aggregate = {
  __typename?: 'classificationCode_aggregate';
  aggregate?: Maybe<ClassificationCode_Aggregate_Fields>;
  nodes: Array<ClassificationCode>;
};

export type ClassificationCode_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClassificationCode_Aggregate_Bool_Exp_Count>;
};

export type ClassificationCode_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationCode_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classification_code" */
export type ClassificationCode_Aggregate_Fields = {
  __typename?: 'classificationCode_aggregate_fields';
  avg?: Maybe<ClassificationCode_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ClassificationCode_Max_Fields>;
  min?: Maybe<ClassificationCode_Min_Fields>;
  stddev?: Maybe<ClassificationCode_Stddev_Fields>;
  stddev_pop?: Maybe<ClassificationCode_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClassificationCode_Stddev_Samp_Fields>;
  sum?: Maybe<ClassificationCode_Sum_Fields>;
  var_pop?: Maybe<ClassificationCode_Var_Pop_Fields>;
  var_samp?: Maybe<ClassificationCode_Var_Samp_Fields>;
  variance?: Maybe<ClassificationCode_Variance_Fields>;
};


/** aggregate fields of "classification_code" */
export type ClassificationCode_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "classification_code" */
export type ClassificationCode_Aggregate_Order_By = {
  avg?: InputMaybe<ClassificationCode_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassificationCode_Max_Order_By>;
  min?: InputMaybe<ClassificationCode_Min_Order_By>;
  stddev?: InputMaybe<ClassificationCode_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ClassificationCode_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ClassificationCode_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ClassificationCode_Sum_Order_By>;
  var_pop?: InputMaybe<ClassificationCode_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ClassificationCode_Var_Samp_Order_By>;
  variance?: InputMaybe<ClassificationCode_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "classification_code" */
export type ClassificationCode_Arr_Rel_Insert_Input = {
  data: Array<ClassificationCode_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassificationCode_On_Conflict>;
};

/** aggregate avg on columns */
export type ClassificationCode_Avg_Fields = {
  __typename?: 'classificationCode_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "classification_code" */
export type ClassificationCode_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "classification_code". All fields are combined with a logical 'AND'. */
export type ClassificationCode_Bool_Exp = {
  _and?: InputMaybe<Array<ClassificationCode_Bool_Exp>>;
  _not?: InputMaybe<ClassificationCode_Bool_Exp>;
  _or?: InputMaybe<Array<ClassificationCode_Bool_Exp>>;
  buildingPart?: InputMaybe<BuildingPart_Bool_Exp>;
  buildingPartId?: InputMaybe<Uuid_Comparison_Exp>;
  classificationObjectClassId?: InputMaybe<Uuid_Comparison_Exp>;
  classificationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  englishLabel?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  objectClass?: InputMaybe<ClassificationObjectClass_Bool_Exp>;
  parent?: InputMaybe<ClassificationCode_Bool_Exp>;
  parentId?: InputMaybe<Int_Comparison_Exp>;
  translation?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
  translation_aggregate?: InputMaybe<ClassificationCodeTranslation_Aggregate_Bool_Exp>;
  type?: InputMaybe<ClassificationType_Bool_Exp>;
};

/** unique or primary key constraints on table "classification_code" */
export enum ClassificationCode_Constraint {
  /** unique or primary key constraint on columns "id" */
  classification_code_pkey = 'classification_code_pkey'
}

/** input type for incrementing numeric columns in table "classification_code" */
export type ClassificationCode_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "classification_code" */
export type ClassificationCode_Insert_Input = {
  buildingPart?: InputMaybe<BuildingPart_Obj_Rel_Insert_Input>;
  buildingPartId?: InputMaybe<Scalars['uuid']['input']>;
  classificationObjectClassId?: InputMaybe<Scalars['uuid']['input']>;
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  englishLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  objectClass?: InputMaybe<ClassificationObjectClass_Obj_Rel_Insert_Input>;
  parent?: InputMaybe<ClassificationCode_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  translation?: InputMaybe<ClassificationCodeTranslation_Arr_Rel_Insert_Input>;
  type?: InputMaybe<ClassificationType_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ClassificationCode_Max_Fields = {
  __typename?: 'classificationCode_max_fields';
  buildingPartId?: Maybe<Scalars['uuid']['output']>;
  classificationObjectClassId?: Maybe<Scalars['uuid']['output']>;
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  englishLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Prioritized translated label based on order of languages in token. See _label for original label */
  label?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "classification_code" */
export type ClassificationCode_Max_Order_By = {
  buildingPartId?: InputMaybe<Order_By>;
  classificationObjectClassId?: InputMaybe<Order_By>;
  classificationTypeId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  englishLabel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassificationCode_Min_Fields = {
  __typename?: 'classificationCode_min_fields';
  buildingPartId?: Maybe<Scalars['uuid']['output']>;
  classificationObjectClassId?: Maybe<Scalars['uuid']['output']>;
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  englishLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Prioritized translated label based on order of languages in token. See _label for original label */
  label?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "classification_code" */
export type ClassificationCode_Min_Order_By = {
  buildingPartId?: InputMaybe<Order_By>;
  classificationObjectClassId?: InputMaybe<Order_By>;
  classificationTypeId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  englishLabel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classification_code" */
export type ClassificationCode_Mutation_Response = {
  __typename?: 'classificationCode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassificationCode>;
};

/** input type for inserting object relation for remote table "classification_code" */
export type ClassificationCode_Obj_Rel_Insert_Input = {
  data: ClassificationCode_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassificationCode_On_Conflict>;
};

/** on_conflict condition type for table "classification_code" */
export type ClassificationCode_On_Conflict = {
  constraint: ClassificationCode_Constraint;
  update_columns?: Array<ClassificationCode_Update_Column>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};

/** Ordering options when selecting data from "classification_code". */
export type ClassificationCode_Order_By = {
  buildingPart?: InputMaybe<BuildingPart_Order_By>;
  buildingPartId?: InputMaybe<Order_By>;
  classificationObjectClassId?: InputMaybe<Order_By>;
  classificationTypeId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  englishLabel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  objectClass?: InputMaybe<ClassificationObjectClass_Order_By>;
  parent?: InputMaybe<ClassificationCode_Order_By>;
  parentId?: InputMaybe<Order_By>;
  translation_aggregate?: InputMaybe<ClassificationCodeTranslation_Aggregate_Order_By>;
  type?: InputMaybe<ClassificationType_Order_By>;
};

/** primary key columns input for table: classification_code */
export type ClassificationCode_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "classification_code" */
export enum ClassificationCode_Select_Column {
  /** column name */
  buildingPartId = 'buildingPartId',
  /** column name */
  classificationObjectClassId = 'classificationObjectClassId',
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  code = 'code',
  /** column name */
  description = 'description',
  /** column name */
  englishLabel = 'englishLabel',
  /** column name */
  id = 'id',
  /** column name */
  parentId = 'parentId'
}

/** input type for updating data in table "classification_code" */
export type ClassificationCode_Set_Input = {
  buildingPartId?: InputMaybe<Scalars['uuid']['input']>;
  classificationObjectClassId?: InputMaybe<Scalars['uuid']['input']>;
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  englishLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ClassificationCode_Stddev_Fields = {
  __typename?: 'classificationCode_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "classification_code" */
export type ClassificationCode_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ClassificationCode_Stddev_Pop_Fields = {
  __typename?: 'classificationCode_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "classification_code" */
export type ClassificationCode_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ClassificationCode_Stddev_Samp_Fields = {
  __typename?: 'classificationCode_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "classification_code" */
export type ClassificationCode_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "classificationCode" */
export type ClassificationCode_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassificationCode_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassificationCode_Stream_Cursor_Value_Input = {
  buildingPartId?: InputMaybe<Scalars['uuid']['input']>;
  classificationObjectClassId?: InputMaybe<Scalars['uuid']['input']>;
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  englishLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ClassificationCode_Sum_Fields = {
  __typename?: 'classificationCode_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "classification_code" */
export type ClassificationCode_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** update columns of table "classification_code" */
export enum ClassificationCode_Update_Column {
  /** column name */
  buildingPartId = 'buildingPartId',
  /** column name */
  classificationObjectClassId = 'classificationObjectClassId',
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  code = 'code',
  /** column name */
  description = 'description',
  /** column name */
  englishLabel = 'englishLabel',
  /** column name */
  id = 'id',
  /** column name */
  parentId = 'parentId'
}

export type ClassificationCode_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClassificationCode_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassificationCode_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassificationCode_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClassificationCode_Var_Pop_Fields = {
  __typename?: 'classificationCode_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "classification_code" */
export type ClassificationCode_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ClassificationCode_Var_Samp_Fields = {
  __typename?: 'classificationCode_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "classification_code" */
export type ClassificationCode_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ClassificationCode_Variance_Fields = {
  __typename?: 'classificationCode_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "classification_code" */
export type ClassificationCode_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** columns and relationships of "classification_object_class" */
export type ClassificationObjectClass = {
  __typename?: 'classificationObjectClass';
  /** An array relationship */
  classificationCodes: Array<ClassificationCode>;
  /** An aggregate relationship */
  classificationCodes_aggregate: ClassificationCode_Aggregate;
  code: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  translation: Array<ClassificationObjectClassTranslation>;
  /** An aggregate relationship */
  translation_aggregate: ClassificationObjectClassTranslation_Aggregate;
};


/** columns and relationships of "classification_object_class" */
export type ClassificationObjectClassClassificationCodesArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCode_Order_By>>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};


/** columns and relationships of "classification_object_class" */
export type ClassificationObjectClassClassificationCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCode_Order_By>>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};


/** columns and relationships of "classification_object_class" */
export type ClassificationObjectClassTranslationArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassTranslation_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
};


/** columns and relationships of "classification_object_class" */
export type ClassificationObjectClassTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassTranslation_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
};

/** columns and relationships of "classification_object_class_parameter" */
export type ClassificationObjectClassParameter = {
  __typename?: 'classificationObjectClassParameter';
  classificationTypeId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  isDefault: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Aggregate = {
  __typename?: 'classificationObjectClassParameter_aggregate';
  aggregate?: Maybe<ClassificationObjectClassParameter_Aggregate_Fields>;
  nodes: Array<ClassificationObjectClassParameter>;
};

export type ClassificationObjectClassParameter_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ClassificationObjectClassParameter_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ClassificationObjectClassParameter_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ClassificationObjectClassParameter_Aggregate_Bool_Exp_Count>;
};

export type ClassificationObjectClassParameter_Aggregate_Bool_Exp_Bool_And = {
  arguments: ClassificationObjectClassParameter_Select_Column_ClassificationObjectClassParameter_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClassificationObjectClassParameter_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ClassificationObjectClassParameter_Select_Column_ClassificationObjectClassParameter_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClassificationObjectClassParameter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassificationObjectClassParameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Aggregate_Fields = {
  __typename?: 'classificationObjectClassParameter_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ClassificationObjectClassParameter_Max_Fields>;
  min?: Maybe<ClassificationObjectClassParameter_Min_Fields>;
};


/** aggregate fields of "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassificationObjectClassParameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassificationObjectClassParameter_Max_Order_By>;
  min?: InputMaybe<ClassificationObjectClassParameter_Min_Order_By>;
};

/** input type for inserting array relation for remote table "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Arr_Rel_Insert_Input = {
  data: Array<ClassificationObjectClassParameter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassificationObjectClassParameter_On_Conflict>;
};

/** Boolean expression to filter rows from the table "classification_object_class_parameter". All fields are combined with a logical 'AND'. */
export type ClassificationObjectClassParameter_Bool_Exp = {
  _and?: InputMaybe<Array<ClassificationObjectClassParameter_Bool_Exp>>;
  _not?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
  _or?: InputMaybe<Array<ClassificationObjectClassParameter_Bool_Exp>>;
  classificationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "classification_object_class_parameter" */
export enum ClassificationObjectClassParameter_Constraint {
  /** unique or primary key constraint on columns "value", "classification_type_id" */
  classification_object_class_parameter_classification_type_id_va = 'classification_object_class_parameter_classification_type_id_va',
  /** unique or primary key constraint on columns "id" */
  classification_object_class_parameter_pkey = 'classification_object_class_parameter_pkey'
}

/** input type for inserting data into table "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Insert_Input = {
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ClassificationObjectClassParameter_Max_Fields = {
  __typename?: 'classificationObjectClassParameter_max_fields';
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Max_Order_By = {
  classificationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassificationObjectClassParameter_Min_Fields = {
  __typename?: 'classificationObjectClassParameter_min_fields';
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Min_Order_By = {
  classificationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Mutation_Response = {
  __typename?: 'classificationObjectClassParameter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassificationObjectClassParameter>;
};

/** on_conflict condition type for table "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_On_Conflict = {
  constraint: ClassificationObjectClassParameter_Constraint;
  update_columns?: Array<ClassificationObjectClassParameter_Update_Column>;
  where?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
};

/** Ordering options when selecting data from "classification_object_class_parameter". */
export type ClassificationObjectClassParameter_Order_By = {
  classificationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classification_object_class_parameter */
export type ClassificationObjectClassParameter_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "classification_object_class_parameter" */
export enum ClassificationObjectClassParameter_Select_Column {
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  value = 'value'
}

/** select "classificationObjectClassParameter_aggregate_bool_exp_bool_and_arguments_columns" columns of table "classification_object_class_parameter" */
export enum ClassificationObjectClassParameter_Select_Column_ClassificationObjectClassParameter_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** select "classificationObjectClassParameter_aggregate_bool_exp_bool_or_arguments_columns" columns of table "classification_object_class_parameter" */
export enum ClassificationObjectClassParameter_Select_Column_ClassificationObjectClassParameter_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** input type for updating data in table "classification_object_class_parameter" */
export type ClassificationObjectClassParameter_Set_Input = {
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "classificationObjectClassParameter" */
export type ClassificationObjectClassParameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassificationObjectClassParameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassificationObjectClassParameter_Stream_Cursor_Value_Input = {
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "classification_object_class_parameter" */
export enum ClassificationObjectClassParameter_Update_Column {
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  value = 'value'
}

export type ClassificationObjectClassParameter_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassificationObjectClassParameter_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassificationObjectClassParameter_Bool_Exp;
};

/** columns and relationships of "classification_object_class_translation" */
export type ClassificationObjectClassTranslation = {
  __typename?: 'classificationObjectClassTranslation';
  classificationObjectClassId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  languageCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Aggregate = {
  __typename?: 'classificationObjectClassTranslation_aggregate';
  aggregate?: Maybe<ClassificationObjectClassTranslation_Aggregate_Fields>;
  nodes: Array<ClassificationObjectClassTranslation>;
};

export type ClassificationObjectClassTranslation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClassificationObjectClassTranslation_Aggregate_Bool_Exp_Count>;
};

export type ClassificationObjectClassTranslation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassificationObjectClassTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Aggregate_Fields = {
  __typename?: 'classificationObjectClassTranslation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ClassificationObjectClassTranslation_Max_Fields>;
  min?: Maybe<ClassificationObjectClassTranslation_Min_Fields>;
};


/** aggregate fields of "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassificationObjectClassTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassificationObjectClassTranslation_Max_Order_By>;
  min?: InputMaybe<ClassificationObjectClassTranslation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Arr_Rel_Insert_Input = {
  data: Array<ClassificationObjectClassTranslation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassificationObjectClassTranslation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "classification_object_class_translation". All fields are combined with a logical 'AND'. */
export type ClassificationObjectClassTranslation_Bool_Exp = {
  _and?: InputMaybe<Array<ClassificationObjectClassTranslation_Bool_Exp>>;
  _not?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
  _or?: InputMaybe<Array<ClassificationObjectClassTranslation_Bool_Exp>>;
  classificationObjectClassId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "classification_object_class_translation" */
export enum ClassificationObjectClassTranslation_Constraint {
  /** unique or primary key constraint on columns "language_code", "name" */
  classification_object_class_translation_name_language_code_key = 'classification_object_class_translation_name_language_code_key',
  /** unique or primary key constraint on columns "id" */
  classification_object_class_translation_pkey = 'classification_object_class_translation_pkey'
}

/** input type for inserting data into table "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Insert_Input = {
  classificationObjectClassId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ClassificationObjectClassTranslation_Max_Fields = {
  __typename?: 'classificationObjectClassTranslation_max_fields';
  classificationObjectClassId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Max_Order_By = {
  classificationObjectClassId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassificationObjectClassTranslation_Min_Fields = {
  __typename?: 'classificationObjectClassTranslation_min_fields';
  classificationObjectClassId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Min_Order_By = {
  classificationObjectClassId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Mutation_Response = {
  __typename?: 'classificationObjectClassTranslation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassificationObjectClassTranslation>;
};

/** on_conflict condition type for table "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_On_Conflict = {
  constraint: ClassificationObjectClassTranslation_Constraint;
  update_columns?: Array<ClassificationObjectClassTranslation_Update_Column>;
  where?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
};

/** Ordering options when selecting data from "classification_object_class_translation". */
export type ClassificationObjectClassTranslation_Order_By = {
  classificationObjectClassId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classification_object_class_translation */
export type ClassificationObjectClassTranslation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "classification_object_class_translation" */
export enum ClassificationObjectClassTranslation_Select_Column {
  /** column name */
  classificationObjectClassId = 'classificationObjectClassId',
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  name = 'name'
}

/** input type for updating data in table "classification_object_class_translation" */
export type ClassificationObjectClassTranslation_Set_Input = {
  classificationObjectClassId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "classificationObjectClassTranslation" */
export type ClassificationObjectClassTranslation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassificationObjectClassTranslation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassificationObjectClassTranslation_Stream_Cursor_Value_Input = {
  classificationObjectClassId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "classification_object_class_translation" */
export enum ClassificationObjectClassTranslation_Update_Column {
  /** column name */
  classificationObjectClassId = 'classificationObjectClassId',
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  name = 'name'
}

export type ClassificationObjectClassTranslation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassificationObjectClassTranslation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassificationObjectClassTranslation_Bool_Exp;
};

/** aggregated selection of "classification_object_class" */
export type ClassificationObjectClass_Aggregate = {
  __typename?: 'classificationObjectClass_aggregate';
  aggregate?: Maybe<ClassificationObjectClass_Aggregate_Fields>;
  nodes: Array<ClassificationObjectClass>;
};

/** aggregate fields of "classification_object_class" */
export type ClassificationObjectClass_Aggregate_Fields = {
  __typename?: 'classificationObjectClass_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ClassificationObjectClass_Max_Fields>;
  min?: Maybe<ClassificationObjectClass_Min_Fields>;
};


/** aggregate fields of "classification_object_class" */
export type ClassificationObjectClass_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassificationObjectClass_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "classification_object_class". All fields are combined with a logical 'AND'. */
export type ClassificationObjectClass_Bool_Exp = {
  _and?: InputMaybe<Array<ClassificationObjectClass_Bool_Exp>>;
  _not?: InputMaybe<ClassificationObjectClass_Bool_Exp>;
  _or?: InputMaybe<Array<ClassificationObjectClass_Bool_Exp>>;
  classificationCodes?: InputMaybe<ClassificationCode_Bool_Exp>;
  classificationCodes_aggregate?: InputMaybe<ClassificationCode_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  translation?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
  translation_aggregate?: InputMaybe<ClassificationObjectClassTranslation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "classification_object_class" */
export enum ClassificationObjectClass_Constraint {
  /** unique or primary key constraint on columns "id" */
  classification_object_class_pkey = 'classification_object_class_pkey'
}

/** input type for inserting data into table "classification_object_class" */
export type ClassificationObjectClass_Insert_Input = {
  classificationCodes?: InputMaybe<ClassificationCode_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<ClassificationObjectClassTranslation_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ClassificationObjectClass_Max_Fields = {
  __typename?: 'classificationObjectClass_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ClassificationObjectClass_Min_Fields = {
  __typename?: 'classificationObjectClass_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "classification_object_class" */
export type ClassificationObjectClass_Mutation_Response = {
  __typename?: 'classificationObjectClass_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassificationObjectClass>;
};

/** input type for inserting object relation for remote table "classification_object_class" */
export type ClassificationObjectClass_Obj_Rel_Insert_Input = {
  data: ClassificationObjectClass_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassificationObjectClass_On_Conflict>;
};

/** on_conflict condition type for table "classification_object_class" */
export type ClassificationObjectClass_On_Conflict = {
  constraint: ClassificationObjectClass_Constraint;
  update_columns?: Array<ClassificationObjectClass_Update_Column>;
  where?: InputMaybe<ClassificationObjectClass_Bool_Exp>;
};

/** Ordering options when selecting data from "classification_object_class". */
export type ClassificationObjectClass_Order_By = {
  classificationCodes_aggregate?: InputMaybe<ClassificationCode_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  translation_aggregate?: InputMaybe<ClassificationObjectClassTranslation_Aggregate_Order_By>;
};

/** primary key columns input for table: classification_object_class */
export type ClassificationObjectClass_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "classification_object_class" */
export enum ClassificationObjectClass_Select_Column {
  /** column name */
  code = 'code',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name'
}

/** input type for updating data in table "classification_object_class" */
export type ClassificationObjectClass_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "classificationObjectClass" */
export type ClassificationObjectClass_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassificationObjectClass_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassificationObjectClass_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "classification_object_class" */
export enum ClassificationObjectClass_Update_Column {
  /** column name */
  code = 'code',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name'
}

export type ClassificationObjectClass_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassificationObjectClass_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassificationObjectClass_Bool_Exp;
};

/** columns and relationships of "classification_type" */
export type ClassificationType = {
  __typename?: 'classificationType';
  /** An array relationship */
  classificationObjectClassParameter: Array<ClassificationObjectClassParameter>;
  /** An aggregate relationship */
  classificationObjectClassParameter_aggregate: ClassificationObjectClassParameter_Aggregate;
  id: Scalars['uuid']['output'];
  longName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  parameters: Array<ClassificationTypeAttribute>;
  /** An aggregate relationship */
  parameters_aggregate: ClassificationTypeAttribute_Aggregate;
  shortName: Scalars['String']['output'];
  /** An array relationship */
  typeByCountry: Array<ClassificationCodeTypeCountry>;
  /** An aggregate relationship */
  typeByCountry_aggregate: ClassificationCodeTypeCountry_Aggregate;
};


/** columns and relationships of "classification_type" */
export type ClassificationTypeClassificationObjectClassParameterArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassParameter_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
};


/** columns and relationships of "classification_type" */
export type ClassificationTypeClassificationObjectClassParameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassParameter_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
};


/** columns and relationships of "classification_type" */
export type ClassificationTypeParametersArgs = {
  distinct_on?: InputMaybe<Array<ClassificationTypeAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationTypeAttribute_Order_By>>;
  where?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
};


/** columns and relationships of "classification_type" */
export type ClassificationTypeParameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationTypeAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationTypeAttribute_Order_By>>;
  where?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
};


/** columns and relationships of "classification_type" */
export type ClassificationTypeTypeByCountryArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTypeCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTypeCountry_Order_By>>;
  where?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
};


/** columns and relationships of "classification_type" */
export type ClassificationTypeTypeByCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTypeCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTypeCountry_Order_By>>;
  where?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
};

/** columns and relationships of "classification_type_parameter" */
export type ClassificationTypeAttribute = {
  __typename?: 'classificationTypeAttribute';
  classificationTypeId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  isDefault: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "classification_type_parameter" */
export type ClassificationTypeAttribute_Aggregate = {
  __typename?: 'classificationTypeAttribute_aggregate';
  aggregate?: Maybe<ClassificationTypeAttribute_Aggregate_Fields>;
  nodes: Array<ClassificationTypeAttribute>;
};

export type ClassificationTypeAttribute_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ClassificationTypeAttribute_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ClassificationTypeAttribute_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ClassificationTypeAttribute_Aggregate_Bool_Exp_Count>;
};

export type ClassificationTypeAttribute_Aggregate_Bool_Exp_Bool_And = {
  arguments: ClassificationTypeAttribute_Select_Column_ClassificationTypeAttribute_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClassificationTypeAttribute_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ClassificationTypeAttribute_Select_Column_ClassificationTypeAttribute_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClassificationTypeAttribute_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassificationTypeAttribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classification_type_parameter" */
export type ClassificationTypeAttribute_Aggregate_Fields = {
  __typename?: 'classificationTypeAttribute_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ClassificationTypeAttribute_Max_Fields>;
  min?: Maybe<ClassificationTypeAttribute_Min_Fields>;
};


/** aggregate fields of "classification_type_parameter" */
export type ClassificationTypeAttribute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassificationTypeAttribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "classification_type_parameter" */
export type ClassificationTypeAttribute_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassificationTypeAttribute_Max_Order_By>;
  min?: InputMaybe<ClassificationTypeAttribute_Min_Order_By>;
};

/** input type for inserting array relation for remote table "classification_type_parameter" */
export type ClassificationTypeAttribute_Arr_Rel_Insert_Input = {
  data: Array<ClassificationTypeAttribute_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassificationTypeAttribute_On_Conflict>;
};

/** Boolean expression to filter rows from the table "classification_type_parameter". All fields are combined with a logical 'AND'. */
export type ClassificationTypeAttribute_Bool_Exp = {
  _and?: InputMaybe<Array<ClassificationTypeAttribute_Bool_Exp>>;
  _not?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
  _or?: InputMaybe<Array<ClassificationTypeAttribute_Bool_Exp>>;
  classificationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "classification_type_parameter" */
export enum ClassificationTypeAttribute_Constraint {
  /** unique or primary key constraint on columns "id" */
  classification_type_attribute_pkey = 'classification_type_attribute_pkey',
  /** unique or primary key constraint on columns "value", "classification_type_id" */
  classification_type_parameter_classification_type_id_value_key = 'classification_type_parameter_classification_type_id_value_key'
}

/** input type for inserting data into table "classification_type_parameter" */
export type ClassificationTypeAttribute_Insert_Input = {
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ClassificationTypeAttribute_Max_Fields = {
  __typename?: 'classificationTypeAttribute_max_fields';
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "classification_type_parameter" */
export type ClassificationTypeAttribute_Max_Order_By = {
  classificationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassificationTypeAttribute_Min_Fields = {
  __typename?: 'classificationTypeAttribute_min_fields';
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "classification_type_parameter" */
export type ClassificationTypeAttribute_Min_Order_By = {
  classificationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classification_type_parameter" */
export type ClassificationTypeAttribute_Mutation_Response = {
  __typename?: 'classificationTypeAttribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassificationTypeAttribute>;
};

/** on_conflict condition type for table "classification_type_parameter" */
export type ClassificationTypeAttribute_On_Conflict = {
  constraint: ClassificationTypeAttribute_Constraint;
  update_columns?: Array<ClassificationTypeAttribute_Update_Column>;
  where?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
};

/** Ordering options when selecting data from "classification_type_parameter". */
export type ClassificationTypeAttribute_Order_By = {
  classificationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classification_type_parameter */
export type ClassificationTypeAttribute_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "classification_type_parameter" */
export enum ClassificationTypeAttribute_Select_Column {
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  value = 'value'
}

/** select "classificationTypeAttribute_aggregate_bool_exp_bool_and_arguments_columns" columns of table "classification_type_parameter" */
export enum ClassificationTypeAttribute_Select_Column_ClassificationTypeAttribute_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** select "classificationTypeAttribute_aggregate_bool_exp_bool_or_arguments_columns" columns of table "classification_type_parameter" */
export enum ClassificationTypeAttribute_Select_Column_ClassificationTypeAttribute_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** input type for updating data in table "classification_type_parameter" */
export type ClassificationTypeAttribute_Set_Input = {
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "classificationTypeAttribute" */
export type ClassificationTypeAttribute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassificationTypeAttribute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassificationTypeAttribute_Stream_Cursor_Value_Input = {
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "classification_type_parameter" */
export enum ClassificationTypeAttribute_Update_Column {
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  value = 'value'
}

export type ClassificationTypeAttribute_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassificationTypeAttribute_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassificationTypeAttribute_Bool_Exp;
};

/** aggregated selection of "classification_type" */
export type ClassificationType_Aggregate = {
  __typename?: 'classificationType_aggregate';
  aggregate?: Maybe<ClassificationType_Aggregate_Fields>;
  nodes: Array<ClassificationType>;
};

/** aggregate fields of "classification_type" */
export type ClassificationType_Aggregate_Fields = {
  __typename?: 'classificationType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ClassificationType_Max_Fields>;
  min?: Maybe<ClassificationType_Min_Fields>;
};


/** aggregate fields of "classification_type" */
export type ClassificationType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassificationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "classification_type". All fields are combined with a logical 'AND'. */
export type ClassificationType_Bool_Exp = {
  _and?: InputMaybe<Array<ClassificationType_Bool_Exp>>;
  _not?: InputMaybe<ClassificationType_Bool_Exp>;
  _or?: InputMaybe<Array<ClassificationType_Bool_Exp>>;
  classificationObjectClassParameter?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
  classificationObjectClassParameter_aggregate?: InputMaybe<ClassificationObjectClassParameter_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  longName?: InputMaybe<String_Comparison_Exp>;
  parameters?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
  parameters_aggregate?: InputMaybe<ClassificationTypeAttribute_Aggregate_Bool_Exp>;
  shortName?: InputMaybe<String_Comparison_Exp>;
  typeByCountry?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
  typeByCountry_aggregate?: InputMaybe<ClassificationCodeTypeCountry_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "classification_type" */
export enum ClassificationType_Constraint {
  /** unique or primary key constraint on columns "id" */
  classification_code_type_pkey = 'classification_code_type_pkey'
}

/** input type for inserting data into table "classification_type" */
export type ClassificationType_Insert_Input = {
  classificationObjectClassParameter?: InputMaybe<ClassificationObjectClassParameter_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<ClassificationTypeAttribute_Arr_Rel_Insert_Input>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  typeByCountry?: InputMaybe<ClassificationCodeTypeCountry_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ClassificationType_Max_Fields = {
  __typename?: 'classificationType_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ClassificationType_Min_Fields = {
  __typename?: 'classificationType_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "classification_type" */
export type ClassificationType_Mutation_Response = {
  __typename?: 'classificationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassificationType>;
};

/** input type for inserting object relation for remote table "classification_type" */
export type ClassificationType_Obj_Rel_Insert_Input = {
  data: ClassificationType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassificationType_On_Conflict>;
};

/** on_conflict condition type for table "classification_type" */
export type ClassificationType_On_Conflict = {
  constraint: ClassificationType_Constraint;
  update_columns?: Array<ClassificationType_Update_Column>;
  where?: InputMaybe<ClassificationType_Bool_Exp>;
};

/** Ordering options when selecting data from "classification_type". */
export type ClassificationType_Order_By = {
  classificationObjectClassParameter_aggregate?: InputMaybe<ClassificationObjectClassParameter_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  longName?: InputMaybe<Order_By>;
  parameters_aggregate?: InputMaybe<ClassificationTypeAttribute_Aggregate_Order_By>;
  shortName?: InputMaybe<Order_By>;
  typeByCountry_aggregate?: InputMaybe<ClassificationCodeTypeCountry_Aggregate_Order_By>;
};

/** primary key columns input for table: classification_type */
export type ClassificationType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "classification_type" */
export enum ClassificationType_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  longName = 'longName',
  /** column name */
  shortName = 'shortName'
}

/** input type for updating data in table "classification_type" */
export type ClassificationType_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "classificationType" */
export type ClassificationType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassificationType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassificationType_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "classification_type" */
export enum ClassificationType_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  longName = 'longName',
  /** column name */
  shortName = 'shortName'
}

export type ClassificationType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassificationType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassificationType_Bool_Exp;
};

/** columns and relationships of "component_object_phase" */
export type ComponentObjectPhase = {
  __typename?: 'componentObjectPhase';
  value: Scalars['String']['output'];
};

/** aggregated selection of "component_object_phase" */
export type ComponentObjectPhase_Aggregate = {
  __typename?: 'componentObjectPhase_aggregate';
  aggregate?: Maybe<ComponentObjectPhase_Aggregate_Fields>;
  nodes: Array<ComponentObjectPhase>;
};

/** aggregate fields of "component_object_phase" */
export type ComponentObjectPhase_Aggregate_Fields = {
  __typename?: 'componentObjectPhase_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ComponentObjectPhase_Max_Fields>;
  min?: Maybe<ComponentObjectPhase_Min_Fields>;
};


/** aggregate fields of "component_object_phase" */
export type ComponentObjectPhase_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ComponentObjectPhase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "component_object_phase". All fields are combined with a logical 'AND'. */
export type ComponentObjectPhase_Bool_Exp = {
  _and?: InputMaybe<Array<ComponentObjectPhase_Bool_Exp>>;
  _not?: InputMaybe<ComponentObjectPhase_Bool_Exp>;
  _or?: InputMaybe<Array<ComponentObjectPhase_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "component_object_phase" */
export enum ComponentObjectPhase_Constraint {
  /** unique or primary key constraint on columns "value" */
  component_object_phase_pkey = 'component_object_phase_pkey'
}

/** input type for inserting data into table "component_object_phase" */
export type ComponentObjectPhase_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ComponentObjectPhase_Max_Fields = {
  __typename?: 'componentObjectPhase_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ComponentObjectPhase_Min_Fields = {
  __typename?: 'componentObjectPhase_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "component_object_phase" */
export type ComponentObjectPhase_Mutation_Response = {
  __typename?: 'componentObjectPhase_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ComponentObjectPhase>;
};

/** on_conflict condition type for table "component_object_phase" */
export type ComponentObjectPhase_On_Conflict = {
  constraint: ComponentObjectPhase_Constraint;
  update_columns?: Array<ComponentObjectPhase_Update_Column>;
  where?: InputMaybe<ComponentObjectPhase_Bool_Exp>;
};

/** Ordering options when selecting data from "component_object_phase". */
export type ComponentObjectPhase_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: component_object_phase */
export type ComponentObjectPhase_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "component_object_phase" */
export enum ComponentObjectPhase_Select_Column {
  /** column name */
  value = 'value'
}

/** input type for updating data in table "component_object_phase" */
export type ComponentObjectPhase_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "componentObjectPhase" */
export type ComponentObjectPhase_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ComponentObjectPhase_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ComponentObjectPhase_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "component_object_phase" */
export enum ComponentObjectPhase_Update_Column {
  /** column name */
  value = 'value'
}

export type ComponentObjectPhase_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ComponentObjectPhase_Set_Input>;
  /** filter the rows which have to be updated */
  where: ComponentObjectPhase_Bool_Exp;
};

/** columns and relationships of "construction" */
export type Construction = {
  __typename?: 'construction';
  /** An object relationship */
  buildUpTemplate?: Maybe<ConstructionBuildUpTemplate>;
  buildUpTemplateId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  category: MaterialCategory;
  categoryId: Scalars['String']['output'];
  /** An object relationship */
  constructionCategory?: Maybe<ConstructionCategory>;
  constructionCategoryId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  countries: Array<ConstructionCountry>;
  /** An aggregate relationship */
  countries_aggregate: ConstructionCountry_Aggregate;
  createdAt: Scalars['timestamp']['output'];
  createdBy: Scalars['uuid']['output'];
  /** An object relationship */
  declaredUnit: DeclaredUnit;
  declaredUnitId: Scalars['uuid']['output'];
  deprecated: Scalars['Boolean']['output'];
  /** A computed field that returns a translated description based on languages in token with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  descriptions: Array<ConstructionDescription>;
  /** An aggregate relationship */
  descriptions_aggregate: ConstructionDescription_Aggregate;
  faulty: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  inhomogeneousLayers: Array<ConstructionInhomogeneousLayer>;
  /** An aggregate relationship */
  inhomogeneousLayers_aggregate: ConstructionInhomogeneousLayer_Aggregate;
  internalId: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  /** A computed field, that recursively lists all categories used on construction from material and inhomogeneous layers */
  materialCategories?: Maybe<Array<MaterialCategory>>;
  /** An array relationship */
  materials: Array<ConstructionMaterial>;
  /** An aggregate relationship */
  materials_aggregate: ConstructionMaterial_Aggregate;
  /** A computed field that returns a translated name based on languages in token with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  names: Array<ConstructionName>;
  /** An aggregate relationship */
  names_aggregate: ConstructionName_Aggregate;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Scalars['uuid']['output'];
  version: Scalars['Int']['output'];
};


/** columns and relationships of "construction" */
export type ConstructionCountriesArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCountry_Order_By>>;
  where?: InputMaybe<ConstructionCountry_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCountry_Order_By>>;
  where?: InputMaybe<ConstructionCountry_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionDescriptionsArgs = {
  distinct_on?: InputMaybe<Array<ConstructionDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionDescription_Order_By>>;
  where?: InputMaybe<ConstructionDescription_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionDescriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionDescription_Order_By>>;
  where?: InputMaybe<ConstructionDescription_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionInhomogeneousLayersArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayer_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionInhomogeneousLayers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayer_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionMaterialCategoriesArgs = {
  distinct_on?: InputMaybe<Array<MaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialCategory_Order_By>>;
  where?: InputMaybe<MaterialCategory_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionMaterialsArgs = {
  distinct_on?: InputMaybe<Array<ConstructionMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionMaterial_Order_By>>;
  where?: InputMaybe<ConstructionMaterial_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionMaterials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionMaterial_Order_By>>;
  where?: InputMaybe<ConstructionMaterial_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionNamesArgs = {
  distinct_on?: InputMaybe<Array<ConstructionName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionName_Order_By>>;
  where?: InputMaybe<ConstructionName_Bool_Exp>;
};


/** columns and relationships of "construction" */
export type ConstructionNames_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionName_Order_By>>;
  where?: InputMaybe<ConstructionName_Bool_Exp>;
};

/** columns and relationships of "construction_build_up_part" */
export type ConstructionBuildUpPart = {
  __typename?: 'constructionBuildUpPart';
  /** Translated hint, in the order of x-hasura-languages with fallback to English */
  hint?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  /** An array relationship */
  materialCategories: Array<ConstructionBuildUpPartMaterialCategory>;
  /** An aggregate relationship */
  materialCategories_aggregate: ConstructionBuildUpPartMaterialCategory_Aggregate;
  /** Translated name, in the order of x-hasura-languages with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  /** An object relationship */
  template: ConstructionBuildUpTemplate;
  templateId: Scalars['String']['output'];
  /** An array relationship */
  translations: Array<ConstructionBuildUpPartTranslation>;
  /** An aggregate relationship */
  translations_aggregate: ConstructionBuildUpPartTranslation_Aggregate;
};


/** columns and relationships of "construction_build_up_part" */
export type ConstructionBuildUpPartMaterialCategoriesArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
};


/** columns and relationships of "construction_build_up_part" */
export type ConstructionBuildUpPartMaterialCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
};


/** columns and relationships of "construction_build_up_part" */
export type ConstructionBuildUpPartTranslationsArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
};


/** columns and relationships of "construction_build_up_part" */
export type ConstructionBuildUpPartTranslations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
};

/** columns and relationships of "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory = {
  __typename?: 'constructionBuildUpPartMaterialCategory';
  /** An object relationship */
  materialCategory: MaterialCategory;
  materialCategoryId: Scalars['String']['output'];
  /** An object relationship */
  part?: Maybe<ConstructionBuildUpPart>;
  partKey: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
};

/** aggregated selection of "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Aggregate = {
  __typename?: 'constructionBuildUpPartMaterialCategory_aggregate';
  aggregate?: Maybe<ConstructionBuildUpPartMaterialCategory_Aggregate_Fields>;
  nodes: Array<ConstructionBuildUpPartMaterialCategory>;
};

export type ConstructionBuildUpPartMaterialCategory_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Aggregate_Bool_Exp_Count>;
};

export type ConstructionBuildUpPartMaterialCategory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Aggregate_Fields = {
  __typename?: 'constructionBuildUpPartMaterialCategory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionBuildUpPartMaterialCategory_Max_Fields>;
  min?: Maybe<ConstructionBuildUpPartMaterialCategory_Min_Fields>;
};


/** aggregate fields of "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Max_Order_By>;
  min?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Min_Order_By>;
};

/** input type for inserting array relation for remote table "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Arr_Rel_Insert_Input = {
  data: Array<ConstructionBuildUpPartMaterialCategory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionBuildUpPartMaterialCategory_On_Conflict>;
};

/** Boolean expression to filter rows from the table "construction_build_up_part_material_category". All fields are combined with a logical 'AND'. */
export type ConstructionBuildUpPartMaterialCategory_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Bool_Exp>>;
  _not?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Bool_Exp>>;
  materialCategory?: InputMaybe<MaterialCategory_Bool_Exp>;
  materialCategoryId?: InputMaybe<String_Comparison_Exp>;
  part?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
  partKey?: InputMaybe<String_Comparison_Exp>;
  templateId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_build_up_part_material_category" */
export enum ConstructionBuildUpPartMaterialCategory_Constraint {
  /** unique or primary key constraint on columns "template_id", "material_category_id", "part_key" */
  construction_build_up_part_material_category_pkey = 'construction_build_up_part_material_category_pkey'
}

/** input type for inserting data into table "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Insert_Input = {
  materialCategory?: InputMaybe<MaterialCategory_Obj_Rel_Insert_Input>;
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  part?: InputMaybe<ConstructionBuildUpPart_Obj_Rel_Insert_Input>;
  partKey?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ConstructionBuildUpPartMaterialCategory_Max_Fields = {
  __typename?: 'constructionBuildUpPartMaterialCategory_max_fields';
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  partKey?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Max_Order_By = {
  materialCategoryId?: InputMaybe<Order_By>;
  partKey?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionBuildUpPartMaterialCategory_Min_Fields = {
  __typename?: 'constructionBuildUpPartMaterialCategory_min_fields';
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  partKey?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Min_Order_By = {
  materialCategoryId?: InputMaybe<Order_By>;
  partKey?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Mutation_Response = {
  __typename?: 'constructionBuildUpPartMaterialCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionBuildUpPartMaterialCategory>;
};

/** on_conflict condition type for table "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_On_Conflict = {
  constraint: ConstructionBuildUpPartMaterialCategory_Constraint;
  update_columns?: Array<ConstructionBuildUpPartMaterialCategory_Update_Column>;
  where?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_build_up_part_material_category". */
export type ConstructionBuildUpPartMaterialCategory_Order_By = {
  materialCategory?: InputMaybe<MaterialCategory_Order_By>;
  materialCategoryId?: InputMaybe<Order_By>;
  part?: InputMaybe<ConstructionBuildUpPart_Order_By>;
  partKey?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_build_up_part_material_category */
export type ConstructionBuildUpPartMaterialCategory_Pk_Columns_Input = {
  materialCategoryId: Scalars['String']['input'];
  partKey: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

/** select columns of table "construction_build_up_part_material_category" */
export enum ConstructionBuildUpPartMaterialCategory_Select_Column {
  /** column name */
  materialCategoryId = 'materialCategoryId',
  /** column name */
  partKey = 'partKey',
  /** column name */
  templateId = 'templateId'
}

/** input type for updating data in table "construction_build_up_part_material_category" */
export type ConstructionBuildUpPartMaterialCategory_Set_Input = {
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  partKey?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "constructionBuildUpPartMaterialCategory" */
export type ConstructionBuildUpPartMaterialCategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionBuildUpPartMaterialCategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionBuildUpPartMaterialCategory_Stream_Cursor_Value_Input = {
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  partKey?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "construction_build_up_part_material_category" */
export enum ConstructionBuildUpPartMaterialCategory_Update_Column {
  /** column name */
  materialCategoryId = 'materialCategoryId',
  /** column name */
  partKey = 'partKey',
  /** column name */
  templateId = 'templateId'
}

export type ConstructionBuildUpPartMaterialCategory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionBuildUpPartMaterialCategory_Bool_Exp;
};

/** columns and relationships of "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation = {
  __typename?: 'constructionBuildUpPartTranslation';
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  language: Language;
  languageCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  part?: Maybe<ConstructionBuildUpPart>;
  partKey: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  translationSource: Scalars['String']['output'];
};

/** aggregated selection of "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Aggregate = {
  __typename?: 'constructionBuildUpPartTranslation_aggregate';
  aggregate?: Maybe<ConstructionBuildUpPartTranslation_Aggregate_Fields>;
  nodes: Array<ConstructionBuildUpPartTranslation>;
};

export type ConstructionBuildUpPartTranslation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionBuildUpPartTranslation_Aggregate_Bool_Exp_Count>;
};

export type ConstructionBuildUpPartTranslation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Aggregate_Fields = {
  __typename?: 'constructionBuildUpPartTranslation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionBuildUpPartTranslation_Max_Fields>;
  min?: Maybe<ConstructionBuildUpPartTranslation_Min_Fields>;
};


/** aggregate fields of "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionBuildUpPartTranslation_Max_Order_By>;
  min?: InputMaybe<ConstructionBuildUpPartTranslation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Arr_Rel_Insert_Input = {
  data: Array<ConstructionBuildUpPartTranslation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionBuildUpPartTranslation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "construction_build_up_part_translation". All fields are combined with a logical 'AND'. */
export type ConstructionBuildUpPartTranslation_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Bool_Exp>>;
  _not?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Bool_Exp>>;
  hint?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<Language_Bool_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  part?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
  partKey?: InputMaybe<String_Comparison_Exp>;
  templateId?: InputMaybe<String_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_build_up_part_translation" */
export enum ConstructionBuildUpPartTranslation_Constraint {
  /** unique or primary key constraint on columns "template_id", "part_key", "language_code" */
  construction_build_up_part_tr_template_id_part_key_language_key = 'construction_build_up_part_tr_template_id_part_key_language_key',
  /** unique or primary key constraint on columns "id" */
  construction_build_up_part_translation_pkey = 'construction_build_up_part_translation_pkey'
}

/** input type for inserting data into table "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Insert_Input = {
  hint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Language_Obj_Rel_Insert_Input>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  part?: InputMaybe<ConstructionBuildUpPart_Obj_Rel_Insert_Input>;
  partKey?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ConstructionBuildUpPartTranslation_Max_Fields = {
  __typename?: 'constructionBuildUpPartTranslation_max_fields';
  hint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partKey?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Max_Order_By = {
  hint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partKey?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionBuildUpPartTranslation_Min_Fields = {
  __typename?: 'constructionBuildUpPartTranslation_min_fields';
  hint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partKey?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Min_Order_By = {
  hint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partKey?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Mutation_Response = {
  __typename?: 'constructionBuildUpPartTranslation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionBuildUpPartTranslation>;
};

/** on_conflict condition type for table "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_On_Conflict = {
  constraint: ConstructionBuildUpPartTranslation_Constraint;
  update_columns?: Array<ConstructionBuildUpPartTranslation_Update_Column>;
  where?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_build_up_part_translation". */
export type ConstructionBuildUpPartTranslation_Order_By = {
  hint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Language_Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  part?: InputMaybe<ConstructionBuildUpPart_Order_By>;
  partKey?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_build_up_part_translation */
export type ConstructionBuildUpPartTranslation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_build_up_part_translation" */
export enum ConstructionBuildUpPartTranslation_Select_Column {
  /** column name */
  hint = 'hint',
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  name = 'name',
  /** column name */
  partKey = 'partKey',
  /** column name */
  templateId = 'templateId',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "construction_build_up_part_translation" */
export type ConstructionBuildUpPartTranslation_Set_Input = {
  hint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partKey?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "constructionBuildUpPartTranslation" */
export type ConstructionBuildUpPartTranslation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionBuildUpPartTranslation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionBuildUpPartTranslation_Stream_Cursor_Value_Input = {
  hint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partKey?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "construction_build_up_part_translation" */
export enum ConstructionBuildUpPartTranslation_Update_Column {
  /** column name */
  hint = 'hint',
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  name = 'name',
  /** column name */
  partKey = 'partKey',
  /** column name */
  templateId = 'templateId',
  /** column name */
  translationSource = 'translationSource'
}

export type ConstructionBuildUpPartTranslation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionBuildUpPartTranslation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionBuildUpPartTranslation_Bool_Exp;
};

/** aggregated selection of "construction_build_up_part" */
export type ConstructionBuildUpPart_Aggregate = {
  __typename?: 'constructionBuildUpPart_aggregate';
  aggregate?: Maybe<ConstructionBuildUpPart_Aggregate_Fields>;
  nodes: Array<ConstructionBuildUpPart>;
};

export type ConstructionBuildUpPart_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ConstructionBuildUpPart_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ConstructionBuildUpPart_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ConstructionBuildUpPart_Aggregate_Bool_Exp_Count>;
};

export type ConstructionBuildUpPart_Aggregate_Bool_Exp_Bool_And = {
  arguments: ConstructionBuildUpPart_Select_Column_ConstructionBuildUpPart_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ConstructionBuildUpPart_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ConstructionBuildUpPart_Select_Column_ConstructionBuildUpPart_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ConstructionBuildUpPart_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionBuildUpPart_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_build_up_part" */
export type ConstructionBuildUpPart_Aggregate_Fields = {
  __typename?: 'constructionBuildUpPart_aggregate_fields';
  avg?: Maybe<ConstructionBuildUpPart_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionBuildUpPart_Max_Fields>;
  min?: Maybe<ConstructionBuildUpPart_Min_Fields>;
  stddev?: Maybe<ConstructionBuildUpPart_Stddev_Fields>;
  stddev_pop?: Maybe<ConstructionBuildUpPart_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConstructionBuildUpPart_Stddev_Samp_Fields>;
  sum?: Maybe<ConstructionBuildUpPart_Sum_Fields>;
  var_pop?: Maybe<ConstructionBuildUpPart_Var_Pop_Fields>;
  var_samp?: Maybe<ConstructionBuildUpPart_Var_Samp_Fields>;
  variance?: Maybe<ConstructionBuildUpPart_Variance_Fields>;
};


/** aggregate fields of "construction_build_up_part" */
export type ConstructionBuildUpPart_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionBuildUpPart_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Aggregate_Order_By = {
  avg?: InputMaybe<ConstructionBuildUpPart_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionBuildUpPart_Max_Order_By>;
  min?: InputMaybe<ConstructionBuildUpPart_Min_Order_By>;
  stddev?: InputMaybe<ConstructionBuildUpPart_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ConstructionBuildUpPart_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ConstructionBuildUpPart_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ConstructionBuildUpPart_Sum_Order_By>;
  var_pop?: InputMaybe<ConstructionBuildUpPart_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ConstructionBuildUpPart_Var_Samp_Order_By>;
  variance?: InputMaybe<ConstructionBuildUpPart_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "construction_build_up_part" */
export type ConstructionBuildUpPart_Arr_Rel_Insert_Input = {
  data: Array<ConstructionBuildUpPart_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionBuildUpPart_On_Conflict>;
};

/** aggregate avg on columns */
export type ConstructionBuildUpPart_Avg_Fields = {
  __typename?: 'constructionBuildUpPart_avg_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Avg_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_build_up_part". All fields are combined with a logical 'AND'. */
export type ConstructionBuildUpPart_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionBuildUpPart_Bool_Exp>>;
  _not?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionBuildUpPart_Bool_Exp>>;
  hint?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  materialCategories?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
  materialCategories_aggregate?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  required?: InputMaybe<Boolean_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  template?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
  templateId?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
  translations_aggregate?: InputMaybe<ConstructionBuildUpPartTranslation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "construction_build_up_part" */
export enum ConstructionBuildUpPart_Constraint {
  /** unique or primary key constraint on columns "key", "template_id" */
  construction_build_up_part_pkey = 'construction_build_up_part_pkey',
  /** unique or primary key constraint on columns "sort_order", "template_id" */
  construction_build_up_part_template_sort_order_key = 'construction_build_up_part_template_sort_order_key'
}

/** input type for incrementing numeric columns in table "construction_build_up_part" */
export type ConstructionBuildUpPart_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "construction_build_up_part" */
export type ConstructionBuildUpPart_Insert_Input = {
  key?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  materialCategories?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Arr_Rel_Insert_Input>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  template?: InputMaybe<ConstructionBuildUpTemplate_Obj_Rel_Insert_Input>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<ConstructionBuildUpPartTranslation_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ConstructionBuildUpPart_Max_Fields = {
  __typename?: 'constructionBuildUpPart_max_fields';
  /** Translated hint, in the order of x-hasura-languages with fallback to English */
  hint?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  /** Translated name, in the order of x-hasura-languages with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Max_Order_By = {
  key?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionBuildUpPart_Min_Fields = {
  __typename?: 'constructionBuildUpPart_min_fields';
  /** Translated hint, in the order of x-hasura-languages with fallback to English */
  hint?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  /** Translated name, in the order of x-hasura-languages with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Min_Order_By = {
  key?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_build_up_part" */
export type ConstructionBuildUpPart_Mutation_Response = {
  __typename?: 'constructionBuildUpPart_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionBuildUpPart>;
};

/** input type for inserting object relation for remote table "construction_build_up_part" */
export type ConstructionBuildUpPart_Obj_Rel_Insert_Input = {
  data: ConstructionBuildUpPart_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionBuildUpPart_On_Conflict>;
};

/** on_conflict condition type for table "construction_build_up_part" */
export type ConstructionBuildUpPart_On_Conflict = {
  constraint: ConstructionBuildUpPart_Constraint;
  update_columns?: Array<ConstructionBuildUpPart_Update_Column>;
  where?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_build_up_part". */
export type ConstructionBuildUpPart_Order_By = {
  hint?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  materialCategories_aggregate?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  required?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  template?: InputMaybe<ConstructionBuildUpTemplate_Order_By>;
  templateId?: InputMaybe<Order_By>;
  translations_aggregate?: InputMaybe<ConstructionBuildUpPartTranslation_Aggregate_Order_By>;
};

/** primary key columns input for table: construction_build_up_part */
export type ConstructionBuildUpPart_Pk_Columns_Input = {
  key: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

/** select columns of table "construction_build_up_part" */
export enum ConstructionBuildUpPart_Select_Column {
  /** column name */
  key = 'key',
  /** column name */
  kind = 'kind',
  /** column name */
  required = 'required',
  /** column name */
  sortOrder = 'sortOrder',
  /** column name */
  templateId = 'templateId'
}

/** select "constructionBuildUpPart_aggregate_bool_exp_bool_and_arguments_columns" columns of table "construction_build_up_part" */
export enum ConstructionBuildUpPart_Select_Column_ConstructionBuildUpPart_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  required = 'required'
}

/** select "constructionBuildUpPart_aggregate_bool_exp_bool_or_arguments_columns" columns of table "construction_build_up_part" */
export enum ConstructionBuildUpPart_Select_Column_ConstructionBuildUpPart_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  required = 'required'
}

/** input type for updating data in table "construction_build_up_part" */
export type ConstructionBuildUpPart_Set_Input = {
  key?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ConstructionBuildUpPart_Stddev_Fields = {
  __typename?: 'constructionBuildUpPart_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Stddev_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ConstructionBuildUpPart_Stddev_Pop_Fields = {
  __typename?: 'constructionBuildUpPart_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Stddev_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ConstructionBuildUpPart_Stddev_Samp_Fields = {
  __typename?: 'constructionBuildUpPart_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Stddev_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "constructionBuildUpPart" */
export type ConstructionBuildUpPart_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionBuildUpPart_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionBuildUpPart_Stream_Cursor_Value_Input = {
  key?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ConstructionBuildUpPart_Sum_Fields = {
  __typename?: 'constructionBuildUpPart_sum_fields';
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Sum_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** update columns of table "construction_build_up_part" */
export enum ConstructionBuildUpPart_Update_Column {
  /** column name */
  key = 'key',
  /** column name */
  kind = 'kind',
  /** column name */
  required = 'required',
  /** column name */
  sortOrder = 'sortOrder',
  /** column name */
  templateId = 'templateId'
}

export type ConstructionBuildUpPart_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConstructionBuildUpPart_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionBuildUpPart_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionBuildUpPart_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConstructionBuildUpPart_Var_Pop_Fields = {
  __typename?: 'constructionBuildUpPart_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Var_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ConstructionBuildUpPart_Var_Samp_Fields = {
  __typename?: 'constructionBuildUpPart_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Var_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ConstructionBuildUpPart_Variance_Fields = {
  __typename?: 'constructionBuildUpPart_variance_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "construction_build_up_part" */
export type ConstructionBuildUpPart_Variance_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** columns and relationships of "construction_build_up_template" */
export type ConstructionBuildUpTemplate = {
  __typename?: 'constructionBuildUpTemplate';
  /** An object relationship */
  constructionCategory: ConstructionCategory;
  constructionCategoryId: Scalars['String']['output'];
  /** Translated description, in the order of x-hasura-languages with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  /** Translated name, in the order of x-hasura-languages with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  parts: Array<ConstructionBuildUpPart>;
  /** An aggregate relationship */
  parts_aggregate: ConstructionBuildUpPart_Aggregate;
  sortOrder: Scalars['Int']['output'];
  /** An array relationship */
  translations: Array<ConstructionBuildUpTemplateTranslation>;
  /** An aggregate relationship */
  translations_aggregate: ConstructionBuildUpTemplateTranslation_Aggregate;
};


/** columns and relationships of "construction_build_up_template" */
export type ConstructionBuildUpTemplatePartsArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPart_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
};


/** columns and relationships of "construction_build_up_template" */
export type ConstructionBuildUpTemplateParts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPart_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
};


/** columns and relationships of "construction_build_up_template" */
export type ConstructionBuildUpTemplateTranslationsArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
};


/** columns and relationships of "construction_build_up_template" */
export type ConstructionBuildUpTemplateTranslations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
};

/** columns and relationships of "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation = {
  __typename?: 'constructionBuildUpTemplateTranslation';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  language: Language;
  languageCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  template: ConstructionBuildUpTemplate;
  templateId: Scalars['String']['output'];
  translationSource: Scalars['String']['output'];
};

/** aggregated selection of "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Aggregate = {
  __typename?: 'constructionBuildUpTemplateTranslation_aggregate';
  aggregate?: Maybe<ConstructionBuildUpTemplateTranslation_Aggregate_Fields>;
  nodes: Array<ConstructionBuildUpTemplateTranslation>;
};

export type ConstructionBuildUpTemplateTranslation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionBuildUpTemplateTranslation_Aggregate_Bool_Exp_Count>;
};

export type ConstructionBuildUpTemplateTranslation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Aggregate_Fields = {
  __typename?: 'constructionBuildUpTemplateTranslation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionBuildUpTemplateTranslation_Max_Fields>;
  min?: Maybe<ConstructionBuildUpTemplateTranslation_Min_Fields>;
};


/** aggregate fields of "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionBuildUpTemplateTranslation_Max_Order_By>;
  min?: InputMaybe<ConstructionBuildUpTemplateTranslation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Arr_Rel_Insert_Input = {
  data: Array<ConstructionBuildUpTemplateTranslation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionBuildUpTemplateTranslation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "construction_build_up_template_translation". All fields are combined with a logical 'AND'. */
export type ConstructionBuildUpTemplateTranslation_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Bool_Exp>>;
  _not?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<Language_Bool_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  template?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
  templateId?: InputMaybe<String_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_build_up_template_translation" */
export enum ConstructionBuildUpTemplateTranslation_Constraint {
  /** unique or primary key constraint on columns "template_id", "language_code" */
  construction_build_up_template_tr_template_id_language_code_key = 'construction_build_up_template_tr_template_id_language_code_key',
  /** unique or primary key constraint on columns "id" */
  construction_build_up_template_translation_pkey = 'construction_build_up_template_translation_pkey'
}

/** input type for inserting data into table "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Language_Obj_Rel_Insert_Input>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<ConstructionBuildUpTemplate_Obj_Rel_Insert_Input>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ConstructionBuildUpTemplateTranslation_Max_Fields = {
  __typename?: 'constructionBuildUpTemplateTranslation_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionBuildUpTemplateTranslation_Min_Fields = {
  __typename?: 'constructionBuildUpTemplateTranslation_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Mutation_Response = {
  __typename?: 'constructionBuildUpTemplateTranslation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionBuildUpTemplateTranslation>;
};

/** on_conflict condition type for table "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_On_Conflict = {
  constraint: ConstructionBuildUpTemplateTranslation_Constraint;
  update_columns?: Array<ConstructionBuildUpTemplateTranslation_Update_Column>;
  where?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_build_up_template_translation". */
export type ConstructionBuildUpTemplateTranslation_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Language_Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  template?: InputMaybe<ConstructionBuildUpTemplate_Order_By>;
  templateId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_build_up_template_translation */
export type ConstructionBuildUpTemplateTranslation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_build_up_template_translation" */
export enum ConstructionBuildUpTemplateTranslation_Select_Column {
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  name = 'name',
  /** column name */
  templateId = 'templateId',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "construction_build_up_template_translation" */
export type ConstructionBuildUpTemplateTranslation_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "constructionBuildUpTemplateTranslation" */
export type ConstructionBuildUpTemplateTranslation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionBuildUpTemplateTranslation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionBuildUpTemplateTranslation_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "construction_build_up_template_translation" */
export enum ConstructionBuildUpTemplateTranslation_Update_Column {
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  name = 'name',
  /** column name */
  templateId = 'templateId',
  /** column name */
  translationSource = 'translationSource'
}

export type ConstructionBuildUpTemplateTranslation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionBuildUpTemplateTranslation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionBuildUpTemplateTranslation_Bool_Exp;
};

/** aggregated selection of "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Aggregate = {
  __typename?: 'constructionBuildUpTemplate_aggregate';
  aggregate?: Maybe<ConstructionBuildUpTemplate_Aggregate_Fields>;
  nodes: Array<ConstructionBuildUpTemplate>;
};

export type ConstructionBuildUpTemplate_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Count>;
};

export type ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Bool_And = {
  arguments: ConstructionBuildUpTemplate_Select_Column_ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ConstructionBuildUpTemplate_Select_Column_ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionBuildUpTemplate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Aggregate_Fields = {
  __typename?: 'constructionBuildUpTemplate_aggregate_fields';
  avg?: Maybe<ConstructionBuildUpTemplate_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionBuildUpTemplate_Max_Fields>;
  min?: Maybe<ConstructionBuildUpTemplate_Min_Fields>;
  stddev?: Maybe<ConstructionBuildUpTemplate_Stddev_Fields>;
  stddev_pop?: Maybe<ConstructionBuildUpTemplate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConstructionBuildUpTemplate_Stddev_Samp_Fields>;
  sum?: Maybe<ConstructionBuildUpTemplate_Sum_Fields>;
  var_pop?: Maybe<ConstructionBuildUpTemplate_Var_Pop_Fields>;
  var_samp?: Maybe<ConstructionBuildUpTemplate_Var_Samp_Fields>;
  variance?: Maybe<ConstructionBuildUpTemplate_Variance_Fields>;
};


/** aggregate fields of "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionBuildUpTemplate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Aggregate_Order_By = {
  avg?: InputMaybe<ConstructionBuildUpTemplate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionBuildUpTemplate_Max_Order_By>;
  min?: InputMaybe<ConstructionBuildUpTemplate_Min_Order_By>;
  stddev?: InputMaybe<ConstructionBuildUpTemplate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ConstructionBuildUpTemplate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ConstructionBuildUpTemplate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ConstructionBuildUpTemplate_Sum_Order_By>;
  var_pop?: InputMaybe<ConstructionBuildUpTemplate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ConstructionBuildUpTemplate_Var_Samp_Order_By>;
  variance?: InputMaybe<ConstructionBuildUpTemplate_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Arr_Rel_Insert_Input = {
  data: Array<ConstructionBuildUpTemplate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionBuildUpTemplate_On_Conflict>;
};

/** aggregate avg on columns */
export type ConstructionBuildUpTemplate_Avg_Fields = {
  __typename?: 'constructionBuildUpTemplate_avg_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Avg_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_build_up_template". All fields are combined with a logical 'AND'. */
export type ConstructionBuildUpTemplate_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionBuildUpTemplate_Bool_Exp>>;
  _not?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionBuildUpTemplate_Bool_Exp>>;
  constructionCategory?: InputMaybe<ConstructionCategory_Bool_Exp>;
  constructionCategoryId?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parts?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
  parts_aggregate?: InputMaybe<ConstructionBuildUpPart_Aggregate_Bool_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  translations?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
  translations_aggregate?: InputMaybe<ConstructionBuildUpTemplateTranslation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "construction_build_up_template" */
export enum ConstructionBuildUpTemplate_Constraint {
  /** unique or primary key constraint on columns "sort_order", "construction_category_id" */
  construction_build_up_template_category_sort_order_key = 'construction_build_up_template_category_sort_order_key',
  /** unique or primary key constraint on columns "construction_category_id" */
  construction_build_up_template_one_default_per_category = 'construction_build_up_template_one_default_per_category',
  /** unique or primary key constraint on columns "id" */
  construction_build_up_template_pkey = 'construction_build_up_template_pkey'
}

/** input type for incrementing numeric columns in table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Insert_Input = {
  constructionCategory?: InputMaybe<ConstructionCategory_Obj_Rel_Insert_Input>;
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  parts?: InputMaybe<ConstructionBuildUpPart_Arr_Rel_Insert_Input>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<ConstructionBuildUpTemplateTranslation_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ConstructionBuildUpTemplate_Max_Fields = {
  __typename?: 'constructionBuildUpTemplate_max_fields';
  constructionCategoryId?: Maybe<Scalars['String']['output']>;
  /** Translated description, in the order of x-hasura-languages with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Translated name, in the order of x-hasura-languages with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Max_Order_By = {
  constructionCategoryId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionBuildUpTemplate_Min_Fields = {
  __typename?: 'constructionBuildUpTemplate_min_fields';
  constructionCategoryId?: Maybe<Scalars['String']['output']>;
  /** Translated description, in the order of x-hasura-languages with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Translated name, in the order of x-hasura-languages with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Min_Order_By = {
  constructionCategoryId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Mutation_Response = {
  __typename?: 'constructionBuildUpTemplate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionBuildUpTemplate>;
};

/** input type for inserting object relation for remote table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Obj_Rel_Insert_Input = {
  data: ConstructionBuildUpTemplate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionBuildUpTemplate_On_Conflict>;
};

/** on_conflict condition type for table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_On_Conflict = {
  constraint: ConstructionBuildUpTemplate_Constraint;
  update_columns?: Array<ConstructionBuildUpTemplate_Update_Column>;
  where?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_build_up_template". */
export type ConstructionBuildUpTemplate_Order_By = {
  constructionCategory?: InputMaybe<ConstructionCategory_Order_By>;
  constructionCategoryId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parts_aggregate?: InputMaybe<ConstructionBuildUpPart_Aggregate_Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  translations_aggregate?: InputMaybe<ConstructionBuildUpTemplateTranslation_Aggregate_Order_By>;
};

/** primary key columns input for table: construction_build_up_template */
export type ConstructionBuildUpTemplate_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "construction_build_up_template" */
export enum ConstructionBuildUpTemplate_Select_Column {
  /** column name */
  constructionCategoryId = 'constructionCategoryId',
  /** column name */
  id = 'id',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  sortOrder = 'sortOrder'
}

/** select "constructionBuildUpTemplate_aggregate_bool_exp_bool_and_arguments_columns" columns of table "construction_build_up_template" */
export enum ConstructionBuildUpTemplate_Select_Column_ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** select "constructionBuildUpTemplate_aggregate_bool_exp_bool_or_arguments_columns" columns of table "construction_build_up_template" */
export enum ConstructionBuildUpTemplate_Select_Column_ConstructionBuildUpTemplate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** input type for updating data in table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Set_Input = {
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ConstructionBuildUpTemplate_Stddev_Fields = {
  __typename?: 'constructionBuildUpTemplate_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Stddev_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ConstructionBuildUpTemplate_Stddev_Pop_Fields = {
  __typename?: 'constructionBuildUpTemplate_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Stddev_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ConstructionBuildUpTemplate_Stddev_Samp_Fields = {
  __typename?: 'constructionBuildUpTemplate_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Stddev_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "constructionBuildUpTemplate" */
export type ConstructionBuildUpTemplate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionBuildUpTemplate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionBuildUpTemplate_Stream_Cursor_Value_Input = {
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ConstructionBuildUpTemplate_Sum_Fields = {
  __typename?: 'constructionBuildUpTemplate_sum_fields';
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Sum_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** update columns of table "construction_build_up_template" */
export enum ConstructionBuildUpTemplate_Update_Column {
  /** column name */
  constructionCategoryId = 'constructionCategoryId',
  /** column name */
  id = 'id',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  sortOrder = 'sortOrder'
}

export type ConstructionBuildUpTemplate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConstructionBuildUpTemplate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionBuildUpTemplate_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionBuildUpTemplate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConstructionBuildUpTemplate_Var_Pop_Fields = {
  __typename?: 'constructionBuildUpTemplate_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Var_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ConstructionBuildUpTemplate_Var_Samp_Fields = {
  __typename?: 'constructionBuildUpTemplate_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Var_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ConstructionBuildUpTemplate_Variance_Fields = {
  __typename?: 'constructionBuildUpTemplate_variance_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "construction_build_up_template" */
export type ConstructionBuildUpTemplate_Variance_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** columns and relationships of "construction_category" */
export type ConstructionCategory = {
  __typename?: 'constructionCategory';
  /** An array relationship */
  buildUpTemplates: Array<ConstructionBuildUpTemplate>;
  /** An aggregate relationship */
  buildUpTemplates_aggregate: ConstructionBuildUpTemplate_Aggregate;
  defaultUnitId?: Maybe<Scalars['Int']['output']>;
  /** Translated description, in the order of x-hasura-languages with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Translated name, in the order of x-hasura-languages with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  /** Translated label of side A, in the order of x-hasura-languages with fallback to English */
  sideALabel?: Maybe<Scalars['String']['output']>;
  /** Translated label of side B, in the order of x-hasura-languages with fallback to English */
  sideBLabel?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  /** An array relationship */
  translations: Array<ConstructionCategoryTranslation>;
  /** An aggregate relationship */
  translations_aggregate: ConstructionCategoryTranslation_Aggregate;
  /** An array relationship */
  units: Array<ConstructionCategoryUnit>;
  /** An aggregate relationship */
  units_aggregate: ConstructionCategoryUnit_Aggregate;
};


/** columns and relationships of "construction_category" */
export type ConstructionCategoryBuildUpTemplatesArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplate_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
};


/** columns and relationships of "construction_category" */
export type ConstructionCategoryBuildUpTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplate_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
};


/** columns and relationships of "construction_category" */
export type ConstructionCategoryTranslationsArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryTranslation_Order_By>>;
  where?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
};


/** columns and relationships of "construction_category" */
export type ConstructionCategoryTranslations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryTranslation_Order_By>>;
  where?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
};


/** columns and relationships of "construction_category" */
export type ConstructionCategoryUnitsArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryUnit_Order_By>>;
  where?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
};


/** columns and relationships of "construction_category" */
export type ConstructionCategoryUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryUnit_Order_By>>;
  where?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
};

/** columns and relationships of "construction_category_translation" */
export type ConstructionCategoryTranslation = {
  __typename?: 'constructionCategoryTranslation';
  /** An object relationship */
  constructionCategory: ConstructionCategory;
  constructionCategoryId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  language: Language;
  languageCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sideALabel?: Maybe<Scalars['String']['output']>;
  sideBLabel?: Maybe<Scalars['String']['output']>;
  translationSource: Scalars['String']['output'];
};

/** aggregated selection of "construction_category_translation" */
export type ConstructionCategoryTranslation_Aggregate = {
  __typename?: 'constructionCategoryTranslation_aggregate';
  aggregate?: Maybe<ConstructionCategoryTranslation_Aggregate_Fields>;
  nodes: Array<ConstructionCategoryTranslation>;
};

export type ConstructionCategoryTranslation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionCategoryTranslation_Aggregate_Bool_Exp_Count>;
};

export type ConstructionCategoryTranslation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionCategoryTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_category_translation" */
export type ConstructionCategoryTranslation_Aggregate_Fields = {
  __typename?: 'constructionCategoryTranslation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionCategoryTranslation_Max_Fields>;
  min?: Maybe<ConstructionCategoryTranslation_Min_Fields>;
};


/** aggregate fields of "construction_category_translation" */
export type ConstructionCategoryTranslation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionCategoryTranslation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_category_translation" */
export type ConstructionCategoryTranslation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionCategoryTranslation_Max_Order_By>;
  min?: InputMaybe<ConstructionCategoryTranslation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "construction_category_translation" */
export type ConstructionCategoryTranslation_Arr_Rel_Insert_Input = {
  data: Array<ConstructionCategoryTranslation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionCategoryTranslation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "construction_category_translation". All fields are combined with a logical 'AND'. */
export type ConstructionCategoryTranslation_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionCategoryTranslation_Bool_Exp>>;
  _not?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionCategoryTranslation_Bool_Exp>>;
  constructionCategory?: InputMaybe<ConstructionCategory_Bool_Exp>;
  constructionCategoryId?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<Language_Bool_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sideALabel?: InputMaybe<String_Comparison_Exp>;
  sideBLabel?: InputMaybe<String_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_category_translation" */
export enum ConstructionCategoryTranslation_Constraint {
  /** unique or primary key constraint on columns "construction_category_id", "language_code" */
  construction_category_transla_construction_category_id_lang_key = 'construction_category_transla_construction_category_id_lang_key',
  /** unique or primary key constraint on columns "id" */
  construction_category_translation_pkey = 'construction_category_translation_pkey'
}

/** input type for inserting data into table "construction_category_translation" */
export type ConstructionCategoryTranslation_Insert_Input = {
  constructionCategory?: InputMaybe<ConstructionCategory_Obj_Rel_Insert_Input>;
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Language_Obj_Rel_Insert_Input>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sideALabel?: InputMaybe<Scalars['String']['input']>;
  sideBLabel?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ConstructionCategoryTranslation_Max_Fields = {
  __typename?: 'constructionCategoryTranslation_max_fields';
  constructionCategoryId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sideALabel?: Maybe<Scalars['String']['output']>;
  sideBLabel?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "construction_category_translation" */
export type ConstructionCategoryTranslation_Max_Order_By = {
  constructionCategoryId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sideALabel?: InputMaybe<Order_By>;
  sideBLabel?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionCategoryTranslation_Min_Fields = {
  __typename?: 'constructionCategoryTranslation_min_fields';
  constructionCategoryId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sideALabel?: Maybe<Scalars['String']['output']>;
  sideBLabel?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "construction_category_translation" */
export type ConstructionCategoryTranslation_Min_Order_By = {
  constructionCategoryId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sideALabel?: InputMaybe<Order_By>;
  sideBLabel?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_category_translation" */
export type ConstructionCategoryTranslation_Mutation_Response = {
  __typename?: 'constructionCategoryTranslation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionCategoryTranslation>;
};

/** on_conflict condition type for table "construction_category_translation" */
export type ConstructionCategoryTranslation_On_Conflict = {
  constraint: ConstructionCategoryTranslation_Constraint;
  update_columns?: Array<ConstructionCategoryTranslation_Update_Column>;
  where?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_category_translation". */
export type ConstructionCategoryTranslation_Order_By = {
  constructionCategory?: InputMaybe<ConstructionCategory_Order_By>;
  constructionCategoryId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Language_Order_By>;
  languageCode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sideALabel?: InputMaybe<Order_By>;
  sideBLabel?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_category_translation */
export type ConstructionCategoryTranslation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_category_translation" */
export enum ConstructionCategoryTranslation_Select_Column {
  /** column name */
  constructionCategoryId = 'constructionCategoryId',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  name = 'name',
  /** column name */
  sideALabel = 'sideALabel',
  /** column name */
  sideBLabel = 'sideBLabel',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "construction_category_translation" */
export type ConstructionCategoryTranslation_Set_Input = {
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sideALabel?: InputMaybe<Scalars['String']['input']>;
  sideBLabel?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "constructionCategoryTranslation" */
export type ConstructionCategoryTranslation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionCategoryTranslation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionCategoryTranslation_Stream_Cursor_Value_Input = {
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sideALabel?: InputMaybe<Scalars['String']['input']>;
  sideBLabel?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "construction_category_translation" */
export enum ConstructionCategoryTranslation_Update_Column {
  /** column name */
  constructionCategoryId = 'constructionCategoryId',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  name = 'name',
  /** column name */
  sideALabel = 'sideALabel',
  /** column name */
  sideBLabel = 'sideBLabel',
  /** column name */
  translationSource = 'translationSource'
}

export type ConstructionCategoryTranslation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionCategoryTranslation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionCategoryTranslation_Bool_Exp;
};

/** columns and relationships of "construction_category_unit" */
export type ConstructionCategoryUnit = {
  __typename?: 'constructionCategoryUnit';
  /** An object relationship */
  constructionCategory: ConstructionCategory;
  constructionCategoryId: Scalars['String']['output'];
  /** An object relationship */
  unit: Unit;
  unitId: Scalars['Int']['output'];
};

/** aggregated selection of "construction_category_unit" */
export type ConstructionCategoryUnit_Aggregate = {
  __typename?: 'constructionCategoryUnit_aggregate';
  aggregate?: Maybe<ConstructionCategoryUnit_Aggregate_Fields>;
  nodes: Array<ConstructionCategoryUnit>;
};

export type ConstructionCategoryUnit_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionCategoryUnit_Aggregate_Bool_Exp_Count>;
};

export type ConstructionCategoryUnit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionCategoryUnit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_category_unit" */
export type ConstructionCategoryUnit_Aggregate_Fields = {
  __typename?: 'constructionCategoryUnit_aggregate_fields';
  avg?: Maybe<ConstructionCategoryUnit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionCategoryUnit_Max_Fields>;
  min?: Maybe<ConstructionCategoryUnit_Min_Fields>;
  stddev?: Maybe<ConstructionCategoryUnit_Stddev_Fields>;
  stddev_pop?: Maybe<ConstructionCategoryUnit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConstructionCategoryUnit_Stddev_Samp_Fields>;
  sum?: Maybe<ConstructionCategoryUnit_Sum_Fields>;
  var_pop?: Maybe<ConstructionCategoryUnit_Var_Pop_Fields>;
  var_samp?: Maybe<ConstructionCategoryUnit_Var_Samp_Fields>;
  variance?: Maybe<ConstructionCategoryUnit_Variance_Fields>;
};


/** aggregate fields of "construction_category_unit" */
export type ConstructionCategoryUnit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionCategoryUnit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_category_unit" */
export type ConstructionCategoryUnit_Aggregate_Order_By = {
  avg?: InputMaybe<ConstructionCategoryUnit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionCategoryUnit_Max_Order_By>;
  min?: InputMaybe<ConstructionCategoryUnit_Min_Order_By>;
  stddev?: InputMaybe<ConstructionCategoryUnit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ConstructionCategoryUnit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ConstructionCategoryUnit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ConstructionCategoryUnit_Sum_Order_By>;
  var_pop?: InputMaybe<ConstructionCategoryUnit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ConstructionCategoryUnit_Var_Samp_Order_By>;
  variance?: InputMaybe<ConstructionCategoryUnit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "construction_category_unit" */
export type ConstructionCategoryUnit_Arr_Rel_Insert_Input = {
  data: Array<ConstructionCategoryUnit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionCategoryUnit_On_Conflict>;
};

/** aggregate avg on columns */
export type ConstructionCategoryUnit_Avg_Fields = {
  __typename?: 'constructionCategoryUnit_avg_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Avg_Order_By = {
  unitId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_category_unit". All fields are combined with a logical 'AND'. */
export type ConstructionCategoryUnit_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionCategoryUnit_Bool_Exp>>;
  _not?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionCategoryUnit_Bool_Exp>>;
  constructionCategory?: InputMaybe<ConstructionCategory_Bool_Exp>;
  constructionCategoryId?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unitId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_category_unit" */
export enum ConstructionCategoryUnit_Constraint {
  /** unique or primary key constraint on columns "unit_id", "construction_category_id" */
  construction_category_unit_pkey = 'construction_category_unit_pkey'
}

/** input type for incrementing numeric columns in table "construction_category_unit" */
export type ConstructionCategoryUnit_Inc_Input = {
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "construction_category_unit" */
export type ConstructionCategoryUnit_Insert_Input = {
  constructionCategory?: InputMaybe<ConstructionCategory_Obj_Rel_Insert_Input>;
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ConstructionCategoryUnit_Max_Fields = {
  __typename?: 'constructionCategoryUnit_max_fields';
  constructionCategoryId?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Max_Order_By = {
  constructionCategoryId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionCategoryUnit_Min_Fields = {
  __typename?: 'constructionCategoryUnit_min_fields';
  constructionCategoryId?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Min_Order_By = {
  constructionCategoryId?: InputMaybe<Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_category_unit" */
export type ConstructionCategoryUnit_Mutation_Response = {
  __typename?: 'constructionCategoryUnit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionCategoryUnit>;
};

/** on_conflict condition type for table "construction_category_unit" */
export type ConstructionCategoryUnit_On_Conflict = {
  constraint: ConstructionCategoryUnit_Constraint;
  update_columns?: Array<ConstructionCategoryUnit_Update_Column>;
  where?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_category_unit". */
export type ConstructionCategoryUnit_Order_By = {
  constructionCategory?: InputMaybe<ConstructionCategory_Order_By>;
  constructionCategoryId?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_category_unit */
export type ConstructionCategoryUnit_Pk_Columns_Input = {
  constructionCategoryId: Scalars['String']['input'];
  unitId: Scalars['Int']['input'];
};

/** select columns of table "construction_category_unit" */
export enum ConstructionCategoryUnit_Select_Column {
  /** column name */
  constructionCategoryId = 'constructionCategoryId',
  /** column name */
  unitId = 'unitId'
}

/** input type for updating data in table "construction_category_unit" */
export type ConstructionCategoryUnit_Set_Input = {
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ConstructionCategoryUnit_Stddev_Fields = {
  __typename?: 'constructionCategoryUnit_stddev_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Stddev_Order_By = {
  unitId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ConstructionCategoryUnit_Stddev_Pop_Fields = {
  __typename?: 'constructionCategoryUnit_stddev_pop_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Stddev_Pop_Order_By = {
  unitId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ConstructionCategoryUnit_Stddev_Samp_Fields = {
  __typename?: 'constructionCategoryUnit_stddev_samp_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Stddev_Samp_Order_By = {
  unitId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "constructionCategoryUnit" */
export type ConstructionCategoryUnit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionCategoryUnit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionCategoryUnit_Stream_Cursor_Value_Input = {
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ConstructionCategoryUnit_Sum_Fields = {
  __typename?: 'constructionCategoryUnit_sum_fields';
  unitId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Sum_Order_By = {
  unitId?: InputMaybe<Order_By>;
};

/** update columns of table "construction_category_unit" */
export enum ConstructionCategoryUnit_Update_Column {
  /** column name */
  constructionCategoryId = 'constructionCategoryId',
  /** column name */
  unitId = 'unitId'
}

export type ConstructionCategoryUnit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConstructionCategoryUnit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionCategoryUnit_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionCategoryUnit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConstructionCategoryUnit_Var_Pop_Fields = {
  __typename?: 'constructionCategoryUnit_var_pop_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Var_Pop_Order_By = {
  unitId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ConstructionCategoryUnit_Var_Samp_Fields = {
  __typename?: 'constructionCategoryUnit_var_samp_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Var_Samp_Order_By = {
  unitId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ConstructionCategoryUnit_Variance_Fields = {
  __typename?: 'constructionCategoryUnit_variance_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "construction_category_unit" */
export type ConstructionCategoryUnit_Variance_Order_By = {
  unitId?: InputMaybe<Order_By>;
};

/** aggregated selection of "construction_category" */
export type ConstructionCategory_Aggregate = {
  __typename?: 'constructionCategory_aggregate';
  aggregate?: Maybe<ConstructionCategory_Aggregate_Fields>;
  nodes: Array<ConstructionCategory>;
};

/** aggregate fields of "construction_category" */
export type ConstructionCategory_Aggregate_Fields = {
  __typename?: 'constructionCategory_aggregate_fields';
  avg?: Maybe<ConstructionCategory_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionCategory_Max_Fields>;
  min?: Maybe<ConstructionCategory_Min_Fields>;
  stddev?: Maybe<ConstructionCategory_Stddev_Fields>;
  stddev_pop?: Maybe<ConstructionCategory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConstructionCategory_Stddev_Samp_Fields>;
  sum?: Maybe<ConstructionCategory_Sum_Fields>;
  var_pop?: Maybe<ConstructionCategory_Var_Pop_Fields>;
  var_samp?: Maybe<ConstructionCategory_Var_Samp_Fields>;
  variance?: Maybe<ConstructionCategory_Variance_Fields>;
};


/** aggregate fields of "construction_category" */
export type ConstructionCategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ConstructionCategory_Avg_Fields = {
  __typename?: 'constructionCategory_avg_fields';
  defaultUnitId?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "construction_category". All fields are combined with a logical 'AND'. */
export type ConstructionCategory_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionCategory_Bool_Exp>>;
  _not?: InputMaybe<ConstructionCategory_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionCategory_Bool_Exp>>;
  buildUpTemplates?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
  buildUpTemplates_aggregate?: InputMaybe<ConstructionBuildUpTemplate_Aggregate_Bool_Exp>;
  defaultUnitId?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sideALabel?: InputMaybe<String_Comparison_Exp>;
  sideBLabel?: InputMaybe<String_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  translations?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
  translations_aggregate?: InputMaybe<ConstructionCategoryTranslation_Aggregate_Bool_Exp>;
  units?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
  units_aggregate?: InputMaybe<ConstructionCategoryUnit_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "construction_category" */
export enum ConstructionCategory_Constraint {
  /** unique or primary key constraint on columns "id" */
  construction_category_pkey = 'construction_category_pkey'
}

/** input type for incrementing numeric columns in table "construction_category" */
export type ConstructionCategory_Inc_Input = {
  defaultUnitId?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "construction_category" */
export type ConstructionCategory_Insert_Input = {
  buildUpTemplates?: InputMaybe<ConstructionBuildUpTemplate_Arr_Rel_Insert_Input>;
  defaultUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<ConstructionCategoryTranslation_Arr_Rel_Insert_Input>;
  units?: InputMaybe<ConstructionCategoryUnit_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ConstructionCategory_Max_Fields = {
  __typename?: 'constructionCategory_max_fields';
  defaultUnitId?: Maybe<Scalars['Int']['output']>;
  /** Translated description, in the order of x-hasura-languages with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Translated name, in the order of x-hasura-languages with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  /** Translated label of side A, in the order of x-hasura-languages with fallback to English */
  sideALabel?: Maybe<Scalars['String']['output']>;
  /** Translated label of side B, in the order of x-hasura-languages with fallback to English */
  sideBLabel?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type ConstructionCategory_Min_Fields = {
  __typename?: 'constructionCategory_min_fields';
  defaultUnitId?: Maybe<Scalars['Int']['output']>;
  /** Translated description, in the order of x-hasura-languages with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Translated name, in the order of x-hasura-languages with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  /** Translated label of side A, in the order of x-hasura-languages with fallback to English */
  sideALabel?: Maybe<Scalars['String']['output']>;
  /** Translated label of side B, in the order of x-hasura-languages with fallback to English */
  sideBLabel?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "construction_category" */
export type ConstructionCategory_Mutation_Response = {
  __typename?: 'constructionCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionCategory>;
};

/** input type for inserting object relation for remote table "construction_category" */
export type ConstructionCategory_Obj_Rel_Insert_Input = {
  data: ConstructionCategory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionCategory_On_Conflict>;
};

/** on_conflict condition type for table "construction_category" */
export type ConstructionCategory_On_Conflict = {
  constraint: ConstructionCategory_Constraint;
  update_columns?: Array<ConstructionCategory_Update_Column>;
  where?: InputMaybe<ConstructionCategory_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_category". */
export type ConstructionCategory_Order_By = {
  buildUpTemplates_aggregate?: InputMaybe<ConstructionBuildUpTemplate_Aggregate_Order_By>;
  defaultUnitId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sideALabel?: InputMaybe<Order_By>;
  sideBLabel?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  translations_aggregate?: InputMaybe<ConstructionCategoryTranslation_Aggregate_Order_By>;
  units_aggregate?: InputMaybe<ConstructionCategoryUnit_Aggregate_Order_By>;
};

/** primary key columns input for table: construction_category */
export type ConstructionCategory_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "construction_category" */
export enum ConstructionCategory_Select_Column {
  /** column name */
  defaultUnitId = 'defaultUnitId',
  /** column name */
  id = 'id',
  /** column name */
  sortOrder = 'sortOrder'
}

/** input type for updating data in table "construction_category" */
export type ConstructionCategory_Set_Input = {
  defaultUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ConstructionCategory_Stddev_Fields = {
  __typename?: 'constructionCategory_stddev_fields';
  defaultUnitId?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ConstructionCategory_Stddev_Pop_Fields = {
  __typename?: 'constructionCategory_stddev_pop_fields';
  defaultUnitId?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ConstructionCategory_Stddev_Samp_Fields = {
  __typename?: 'constructionCategory_stddev_samp_fields';
  defaultUnitId?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "constructionCategory" */
export type ConstructionCategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionCategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionCategory_Stream_Cursor_Value_Input = {
  defaultUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ConstructionCategory_Sum_Fields = {
  __typename?: 'constructionCategory_sum_fields';
  defaultUnitId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "construction_category" */
export enum ConstructionCategory_Update_Column {
  /** column name */
  defaultUnitId = 'defaultUnitId',
  /** column name */
  id = 'id',
  /** column name */
  sortOrder = 'sortOrder'
}

export type ConstructionCategory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConstructionCategory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionCategory_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionCategory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConstructionCategory_Var_Pop_Fields = {
  __typename?: 'constructionCategory_var_pop_fields';
  defaultUnitId?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ConstructionCategory_Var_Samp_Fields = {
  __typename?: 'constructionCategory_var_samp_fields';
  defaultUnitId?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ConstructionCategory_Variance_Fields = {
  __typename?: 'constructionCategory_variance_fields';
  defaultUnitId?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "construction_country" */
export type ConstructionCountry = {
  __typename?: 'constructionCountry';
  /** An object relationship */
  construction: Construction;
  constructionId: Scalars['uuid']['output'];
  country: Country_Enum;
};

/** aggregated selection of "construction_country" */
export type ConstructionCountry_Aggregate = {
  __typename?: 'constructionCountry_aggregate';
  aggregate?: Maybe<ConstructionCountry_Aggregate_Fields>;
  nodes: Array<ConstructionCountry>;
};

export type ConstructionCountry_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionCountry_Aggregate_Bool_Exp_Count>;
};

export type ConstructionCountry_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionCountry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionCountry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_country" */
export type ConstructionCountry_Aggregate_Fields = {
  __typename?: 'constructionCountry_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionCountry_Max_Fields>;
  min?: Maybe<ConstructionCountry_Min_Fields>;
};


/** aggregate fields of "construction_country" */
export type ConstructionCountry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionCountry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_country" */
export type ConstructionCountry_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionCountry_Max_Order_By>;
  min?: InputMaybe<ConstructionCountry_Min_Order_By>;
};

/** input type for inserting array relation for remote table "construction_country" */
export type ConstructionCountry_Arr_Rel_Insert_Input = {
  data: Array<ConstructionCountry_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionCountry_On_Conflict>;
};

/** Boolean expression to filter rows from the table "construction_country". All fields are combined with a logical 'AND'. */
export type ConstructionCountry_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionCountry_Bool_Exp>>;
  _not?: InputMaybe<ConstructionCountry_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionCountry_Bool_Exp>>;
  construction?: InputMaybe<Construction_Bool_Exp>;
  constructionId?: InputMaybe<Uuid_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_country" */
export enum ConstructionCountry_Constraint {
  /** unique or primary key constraint on columns "country", "construction_id" */
  construction_country_pkey = 'construction_country_pkey'
}

/** input type for inserting data into table "construction_country" */
export type ConstructionCountry_Insert_Input = {
  construction?: InputMaybe<Construction_Obj_Rel_Insert_Input>;
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Country_Enum>;
};

/** aggregate max on columns */
export type ConstructionCountry_Max_Fields = {
  __typename?: 'constructionCountry_max_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "construction_country" */
export type ConstructionCountry_Max_Order_By = {
  constructionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionCountry_Min_Fields = {
  __typename?: 'constructionCountry_min_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "construction_country" */
export type ConstructionCountry_Min_Order_By = {
  constructionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_country" */
export type ConstructionCountry_Mutation_Response = {
  __typename?: 'constructionCountry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionCountry>;
};

/** on_conflict condition type for table "construction_country" */
export type ConstructionCountry_On_Conflict = {
  constraint: ConstructionCountry_Constraint;
  update_columns?: Array<ConstructionCountry_Update_Column>;
  where?: InputMaybe<ConstructionCountry_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_country". */
export type ConstructionCountry_Order_By = {
  construction?: InputMaybe<Construction_Order_By>;
  constructionId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_country */
export type ConstructionCountry_Pk_Columns_Input = {
  constructionId: Scalars['uuid']['input'];
  country: Country_Enum;
};

/** select columns of table "construction_country" */
export enum ConstructionCountry_Select_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  country = 'country'
}

/** input type for updating data in table "construction_country" */
export type ConstructionCountry_Set_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Country_Enum>;
};

/** Streaming cursor of the table "constructionCountry" */
export type ConstructionCountry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionCountry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionCountry_Stream_Cursor_Value_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Country_Enum>;
};

/** update columns of table "construction_country" */
export enum ConstructionCountry_Update_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  country = 'country'
}

export type ConstructionCountry_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionCountry_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionCountry_Bool_Exp;
};

/** columns and relationships of "construction_description" */
export type ConstructionDescription = {
  __typename?: 'constructionDescription';
  constructionId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  translationSource: Scalars['String']['output'];
};

/** aggregated selection of "construction_description" */
export type ConstructionDescription_Aggregate = {
  __typename?: 'constructionDescription_aggregate';
  aggregate?: Maybe<ConstructionDescription_Aggregate_Fields>;
  nodes: Array<ConstructionDescription>;
};

export type ConstructionDescription_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionDescription_Aggregate_Bool_Exp_Count>;
};

export type ConstructionDescription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionDescription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionDescription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_description" */
export type ConstructionDescription_Aggregate_Fields = {
  __typename?: 'constructionDescription_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionDescription_Max_Fields>;
  min?: Maybe<ConstructionDescription_Min_Fields>;
};


/** aggregate fields of "construction_description" */
export type ConstructionDescription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionDescription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_description" */
export type ConstructionDescription_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionDescription_Max_Order_By>;
  min?: InputMaybe<ConstructionDescription_Min_Order_By>;
};

/** input type for inserting array relation for remote table "construction_description" */
export type ConstructionDescription_Arr_Rel_Insert_Input = {
  data: Array<ConstructionDescription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionDescription_On_Conflict>;
};

/** Boolean expression to filter rows from the table "construction_description". All fields are combined with a logical 'AND'. */
export type ConstructionDescription_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionDescription_Bool_Exp>>;
  _not?: InputMaybe<ConstructionDescription_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionDescription_Bool_Exp>>;
  constructionId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_description" */
export enum ConstructionDescription_Constraint {
  /** unique or primary key constraint on columns "language_code", "construction_id" */
  construction_description_language_code_construction_id_key = 'construction_description_language_code_construction_id_key',
  /** unique or primary key constraint on columns "id" */
  construction_description_pkey = 'construction_description_pkey'
}

/** input type for inserting data into table "construction_description" */
export type ConstructionDescription_Insert_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ConstructionDescription_Max_Fields = {
  __typename?: 'constructionDescription_max_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "construction_description" */
export type ConstructionDescription_Max_Order_By = {
  constructionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionDescription_Min_Fields = {
  __typename?: 'constructionDescription_min_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "construction_description" */
export type ConstructionDescription_Min_Order_By = {
  constructionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_description" */
export type ConstructionDescription_Mutation_Response = {
  __typename?: 'constructionDescription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionDescription>;
};

/** on_conflict condition type for table "construction_description" */
export type ConstructionDescription_On_Conflict = {
  constraint: ConstructionDescription_Constraint;
  update_columns?: Array<ConstructionDescription_Update_Column>;
  where?: InputMaybe<ConstructionDescription_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_description". */
export type ConstructionDescription_Order_By = {
  constructionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_description */
export type ConstructionDescription_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_description" */
export enum ConstructionDescription_Select_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "construction_description" */
export type ConstructionDescription_Set_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "constructionDescription" */
export type ConstructionDescription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionDescription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionDescription_Stream_Cursor_Value_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "construction_description" */
export enum ConstructionDescription_Update_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  translationSource = 'translationSource'
}

export type ConstructionDescription_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionDescription_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionDescription_Bool_Exp;
};

/** columns and relationships of "construction_fork" */
export type ConstructionFork = {
  __typename?: 'constructionFork';
  constructionId: Scalars['uuid']['output'];
  constructionInternalId: Scalars['String']['output'];
  createdBy: Scalars['uuid']['output'];
  parentConstructionId: Scalars['uuid']['output'];
  tenantId: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "construction_fork" */
export type ConstructionFork_Aggregate = {
  __typename?: 'constructionFork_aggregate';
  aggregate?: Maybe<ConstructionFork_Aggregate_Fields>;
  nodes: Array<ConstructionFork>;
};

/** aggregate fields of "construction_fork" */
export type ConstructionFork_Aggregate_Fields = {
  __typename?: 'constructionFork_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionFork_Max_Fields>;
  min?: Maybe<ConstructionFork_Min_Fields>;
};


/** aggregate fields of "construction_fork" */
export type ConstructionFork_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionFork_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "construction_fork". All fields are combined with a logical 'AND'. */
export type ConstructionFork_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionFork_Bool_Exp>>;
  _not?: InputMaybe<ConstructionFork_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionFork_Bool_Exp>>;
  constructionId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionInternalId?: InputMaybe<String_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  parentConstructionId?: InputMaybe<Uuid_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedBy?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_fork" */
export enum ConstructionFork_Constraint {
  /** unique or primary key constraint on columns "construction_id", "parent_construction_id" */
  construction_fork_pkey = 'construction_fork_pkey'
}

/** input type for inserting data into table "construction_fork" */
export type ConstructionFork_Insert_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  constructionInternalId?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  parentConstructionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ConstructionFork_Max_Fields = {
  __typename?: 'constructionFork_max_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
  constructionInternalId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  parentConstructionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ConstructionFork_Min_Fields = {
  __typename?: 'constructionFork_min_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
  constructionInternalId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  parentConstructionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "construction_fork" */
export type ConstructionFork_Mutation_Response = {
  __typename?: 'constructionFork_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionFork>;
};

/** on_conflict condition type for table "construction_fork" */
export type ConstructionFork_On_Conflict = {
  constraint: ConstructionFork_Constraint;
  update_columns?: Array<ConstructionFork_Update_Column>;
  where?: InputMaybe<ConstructionFork_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_fork". */
export type ConstructionFork_Order_By = {
  constructionId?: InputMaybe<Order_By>;
  constructionInternalId?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  parentConstructionId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_fork */
export type ConstructionFork_Pk_Columns_Input = {
  constructionId: Scalars['uuid']['input'];
  parentConstructionId: Scalars['uuid']['input'];
};

/** select columns of table "construction_fork" */
export enum ConstructionFork_Select_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  constructionInternalId = 'constructionInternalId',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  parentConstructionId = 'parentConstructionId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedBy = 'updatedBy'
}

/** input type for updating data in table "construction_fork" */
export type ConstructionFork_Set_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  constructionInternalId?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  parentConstructionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "constructionFork" */
export type ConstructionFork_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionFork_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionFork_Stream_Cursor_Value_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  constructionInternalId?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  parentConstructionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "construction_fork" */
export enum ConstructionFork_Update_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  constructionInternalId = 'constructionInternalId',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  parentConstructionId = 'parentConstructionId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedBy = 'updatedBy'
}

export type ConstructionFork_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionFork_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionFork_Bool_Exp;
};

/** columns and relationships of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer = {
  __typename?: 'constructionInhomogeneousLayer';
  amount: Scalars['numeric']['output'];
  buildUpPartKey?: Maybe<Scalars['String']['output']>;
  constructionId: Scalars['uuid']['output'];
  constructionSortingId: Scalars['uuid']['output'];
  /** A computed field that returns a translated description based on languages in token with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  descriptions: Array<ConstructionInhomogenousLayerDescription>;
  /** An aggregate relationship */
  descriptions_aggregate: ConstructionInhomogenousLayerDescription_Aggregate;
  height?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  length?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  materials: Array<ConstructionInhomogeneousLayerMaterial>;
  /** An aggregate relationship */
  materials_aggregate: ConstructionInhomogeneousLayerMaterial_Aggregate;
  /** A computed field that returns a translated name based on languages in token with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  names: Array<ConstructionInhomogenousLayerName>;
  /** An aggregate relationship */
  names_aggregate: ConstructionInhomogenousLayerName_Aggregate;
  percentage: Scalars['numeric']['output'];
  /** An object relationship */
  sorting: ConstructionSorting;
  thickness?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayerDescriptionsArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
};


/** columns and relationships of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayerDescriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
};


/** columns and relationships of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayerMaterialsArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
};


/** columns and relationships of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayerMaterials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
};


/** columns and relationships of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayerNamesArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerName_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
};


/** columns and relationships of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayerNames_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerName_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
};

/** columns and relationships of "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial = {
  __typename?: 'constructionInhomogeneousLayerMaterial';
  amount: Scalars['numeric']['output'];
  ccSpacing?: Maybe<Scalars['numeric']['output']>;
  constructionInhomogeneousLayerId: Scalars['uuid']['output'];
  constructionSortingId: Scalars['uuid']['output'];
  count?: Maybe<Scalars['numeric']['output']>;
  elementWidth?: Maybe<Scalars['numeric']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['numeric']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  length?: Maybe<Scalars['numeric']['output']>;
  lifetime: Scalars['Int']['output'];
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  material?: Maybe<Material>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage: Scalars['numeric']['output'];
  /** An object relationship */
  sorting: ConstructionSorting;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Aggregate = {
  __typename?: 'constructionInhomogeneousLayerMaterial_aggregate';
  aggregate?: Maybe<ConstructionInhomogeneousLayerMaterial_Aggregate_Fields>;
  nodes: Array<ConstructionInhomogeneousLayerMaterial>;
};

export type ConstructionInhomogeneousLayerMaterial_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Aggregate_Bool_Exp_Count>;
};

export type ConstructionInhomogeneousLayerMaterial_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Aggregate_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_aggregate_fields';
  avg?: Maybe<ConstructionInhomogeneousLayerMaterial_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionInhomogeneousLayerMaterial_Max_Fields>;
  min?: Maybe<ConstructionInhomogeneousLayerMaterial_Min_Fields>;
  stddev?: Maybe<ConstructionInhomogeneousLayerMaterial_Stddev_Fields>;
  stddev_pop?: Maybe<ConstructionInhomogeneousLayerMaterial_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConstructionInhomogeneousLayerMaterial_Stddev_Samp_Fields>;
  sum?: Maybe<ConstructionInhomogeneousLayerMaterial_Sum_Fields>;
  var_pop?: Maybe<ConstructionInhomogeneousLayerMaterial_Var_Pop_Fields>;
  var_samp?: Maybe<ConstructionInhomogeneousLayerMaterial_Var_Samp_Fields>;
  variance?: Maybe<ConstructionInhomogeneousLayerMaterial_Variance_Fields>;
};


/** aggregate fields of "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Aggregate_Order_By = {
  avg?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Max_Order_By>;
  min?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Min_Order_By>;
  stddev?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Sum_Order_By>;
  var_pop?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Var_Samp_Order_By>;
  variance?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Arr_Rel_Insert_Input = {
  data: Array<ConstructionInhomogeneousLayerMaterial_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionInhomogeneousLayerMaterial_On_Conflict>;
};

/** aggregate avg on columns */
export type ConstructionInhomogeneousLayerMaterial_Avg_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_inhomogeneous_layer_material". All fields are combined with a logical 'AND'. */
export type ConstructionInhomogeneousLayerMaterial_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Bool_Exp>>;
  _not?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ccSpacing?: InputMaybe<Numeric_Comparison_Exp>;
  constructionInhomogeneousLayerId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSortingId?: InputMaybe<Uuid_Comparison_Exp>;
  count?: InputMaybe<Numeric_Comparison_Exp>;
  elementWidth?: InputMaybe<Numeric_Comparison_Exp>;
  epdDeclaredThickness?: InputMaybe<Numeric_Comparison_Exp>;
  height?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  length?: InputMaybe<Numeric_Comparison_Exp>;
  lifetime?: InputMaybe<Int_Comparison_Exp>;
  lifetimeOffset?: InputMaybe<Int_Comparison_Exp>;
  material?: InputMaybe<Material_Bool_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  percentage?: InputMaybe<Numeric_Comparison_Exp>;
  sorting?: InputMaybe<ConstructionSorting_Bool_Exp>;
  thickness?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_inhomogeneous_layer_material" */
export enum ConstructionInhomogeneousLayerMaterial_Constraint {
  /** unique or primary key constraint on columns "id" */
  construction_inhomogeneous_layer_material_pkey = 'construction_inhomogeneous_layer_material_pkey'
}

/** input type for incrementing numeric columns in table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  ccSpacing?: InputMaybe<Scalars['numeric']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  elementWidth?: InputMaybe<Scalars['numeric']['input']>;
  epdDeclaredThickness?: InputMaybe<Scalars['numeric']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  ccSpacing?: InputMaybe<Scalars['numeric']['input']>;
  constructionInhomogeneousLayerId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSortingId?: InputMaybe<Scalars['uuid']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  elementWidth?: InputMaybe<Scalars['numeric']['input']>;
  epdDeclaredThickness?: InputMaybe<Scalars['numeric']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  material?: InputMaybe<Material_Obj_Rel_Insert_Input>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  sorting?: InputMaybe<ConstructionSorting_Obj_Rel_Insert_Input>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type ConstructionInhomogeneousLayerMaterial_Max_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  ccSpacing?: Maybe<Scalars['numeric']['output']>;
  constructionInhomogeneousLayerId?: Maybe<Scalars['uuid']['output']>;
  constructionSortingId?: Maybe<Scalars['uuid']['output']>;
  count?: Maybe<Scalars['numeric']['output']>;
  elementWidth?: Maybe<Scalars['numeric']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['numeric']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  constructionInhomogeneousLayerId?: InputMaybe<Order_By>;
  constructionSortingId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionInhomogeneousLayerMaterial_Min_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  ccSpacing?: Maybe<Scalars['numeric']['output']>;
  constructionInhomogeneousLayerId?: Maybe<Scalars['uuid']['output']>;
  constructionSortingId?: Maybe<Scalars['uuid']['output']>;
  count?: Maybe<Scalars['numeric']['output']>;
  elementWidth?: Maybe<Scalars['numeric']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['numeric']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  constructionInhomogeneousLayerId?: InputMaybe<Order_By>;
  constructionSortingId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Mutation_Response = {
  __typename?: 'constructionInhomogeneousLayerMaterial_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionInhomogeneousLayerMaterial>;
};

/** on_conflict condition type for table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_On_Conflict = {
  constraint: ConstructionInhomogeneousLayerMaterial_Constraint;
  update_columns?: Array<ConstructionInhomogeneousLayerMaterial_Update_Column>;
  where?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_inhomogeneous_layer_material". */
export type ConstructionInhomogeneousLayerMaterial_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  constructionInhomogeneousLayerId?: InputMaybe<Order_By>;
  constructionSortingId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  material?: InputMaybe<Material_Order_By>;
  materialId?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  sorting?: InputMaybe<ConstructionSorting_Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_inhomogeneous_layer_material */
export type ConstructionInhomogeneousLayerMaterial_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_inhomogeneous_layer_material" */
export enum ConstructionInhomogeneousLayerMaterial_Select_Column {
  /** column name */
  amount = 'amount',
  /** column name */
  ccSpacing = 'ccSpacing',
  /** column name */
  constructionInhomogeneousLayerId = 'constructionInhomogeneousLayerId',
  /** column name */
  constructionSortingId = 'constructionSortingId',
  /** column name */
  count = 'count',
  /** column name */
  elementWidth = 'elementWidth',
  /** column name */
  epdDeclaredThickness = 'epdDeclaredThickness',
  /** column name */
  height = 'height',
  /** column name */
  id = 'id',
  /** column name */
  length = 'length',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  lifetimeOffset = 'lifetimeOffset',
  /** column name */
  materialId = 'materialId',
  /** column name */
  mode = 'mode',
  /** column name */
  name = 'name',
  /** column name */
  percentage = 'percentage',
  /** column name */
  thickness = 'thickness'
}

/** input type for updating data in table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  ccSpacing?: InputMaybe<Scalars['numeric']['input']>;
  constructionInhomogeneousLayerId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSortingId?: InputMaybe<Scalars['uuid']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  elementWidth?: InputMaybe<Scalars['numeric']['input']>;
  epdDeclaredThickness?: InputMaybe<Scalars['numeric']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type ConstructionInhomogeneousLayerMaterial_Stddev_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ConstructionInhomogeneousLayerMaterial_Stddev_Pop_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ConstructionInhomogeneousLayerMaterial_Stddev_Samp_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "constructionInhomogeneousLayerMaterial" */
export type ConstructionInhomogeneousLayerMaterial_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionInhomogeneousLayerMaterial_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionInhomogeneousLayerMaterial_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  ccSpacing?: InputMaybe<Scalars['numeric']['input']>;
  constructionInhomogeneousLayerId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSortingId?: InputMaybe<Scalars['uuid']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  elementWidth?: InputMaybe<Scalars['numeric']['input']>;
  epdDeclaredThickness?: InputMaybe<Scalars['numeric']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type ConstructionInhomogeneousLayerMaterial_Sum_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  ccSpacing?: Maybe<Scalars['numeric']['output']>;
  count?: Maybe<Scalars['numeric']['output']>;
  elementWidth?: Maybe<Scalars['numeric']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['numeric']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** update columns of table "construction_inhomogeneous_layer_material" */
export enum ConstructionInhomogeneousLayerMaterial_Update_Column {
  /** column name */
  amount = 'amount',
  /** column name */
  ccSpacing = 'ccSpacing',
  /** column name */
  constructionInhomogeneousLayerId = 'constructionInhomogeneousLayerId',
  /** column name */
  constructionSortingId = 'constructionSortingId',
  /** column name */
  count = 'count',
  /** column name */
  elementWidth = 'elementWidth',
  /** column name */
  epdDeclaredThickness = 'epdDeclaredThickness',
  /** column name */
  height = 'height',
  /** column name */
  id = 'id',
  /** column name */
  length = 'length',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  lifetimeOffset = 'lifetimeOffset',
  /** column name */
  materialId = 'materialId',
  /** column name */
  mode = 'mode',
  /** column name */
  name = 'name',
  /** column name */
  percentage = 'percentage',
  /** column name */
  thickness = 'thickness'
}

export type ConstructionInhomogeneousLayerMaterial_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionInhomogeneousLayerMaterial_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConstructionInhomogeneousLayerMaterial_Var_Pop_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ConstructionInhomogeneousLayerMaterial_Var_Samp_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ConstructionInhomogeneousLayerMaterial_Variance_Fields = {
  __typename?: 'constructionInhomogeneousLayerMaterial_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "construction_inhomogeneous_layer_material" */
export type ConstructionInhomogeneousLayerMaterial_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregated selection of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Aggregate = {
  __typename?: 'constructionInhomogeneousLayer_aggregate';
  aggregate?: Maybe<ConstructionInhomogeneousLayer_Aggregate_Fields>;
  nodes: Array<ConstructionInhomogeneousLayer>;
};

export type ConstructionInhomogeneousLayer_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionInhomogeneousLayer_Aggregate_Bool_Exp_Count>;
};

export type ConstructionInhomogeneousLayer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionInhomogeneousLayer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Aggregate_Fields = {
  __typename?: 'constructionInhomogeneousLayer_aggregate_fields';
  avg?: Maybe<ConstructionInhomogeneousLayer_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionInhomogeneousLayer_Max_Fields>;
  min?: Maybe<ConstructionInhomogeneousLayer_Min_Fields>;
  stddev?: Maybe<ConstructionInhomogeneousLayer_Stddev_Fields>;
  stddev_pop?: Maybe<ConstructionInhomogeneousLayer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConstructionInhomogeneousLayer_Stddev_Samp_Fields>;
  sum?: Maybe<ConstructionInhomogeneousLayer_Sum_Fields>;
  var_pop?: Maybe<ConstructionInhomogeneousLayer_Var_Pop_Fields>;
  var_samp?: Maybe<ConstructionInhomogeneousLayer_Var_Samp_Fields>;
  variance?: Maybe<ConstructionInhomogeneousLayer_Variance_Fields>;
};


/** aggregate fields of "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionInhomogeneousLayer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Aggregate_Order_By = {
  avg?: InputMaybe<ConstructionInhomogeneousLayer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionInhomogeneousLayer_Max_Order_By>;
  min?: InputMaybe<ConstructionInhomogeneousLayer_Min_Order_By>;
  stddev?: InputMaybe<ConstructionInhomogeneousLayer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ConstructionInhomogeneousLayer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ConstructionInhomogeneousLayer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ConstructionInhomogeneousLayer_Sum_Order_By>;
  var_pop?: InputMaybe<ConstructionInhomogeneousLayer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ConstructionInhomogeneousLayer_Var_Samp_Order_By>;
  variance?: InputMaybe<ConstructionInhomogeneousLayer_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Arr_Rel_Insert_Input = {
  data: Array<ConstructionInhomogeneousLayer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionInhomogeneousLayer_On_Conflict>;
};

/** aggregate avg on columns */
export type ConstructionInhomogeneousLayer_Avg_Fields = {
  __typename?: 'constructionInhomogeneousLayer_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_inhomogeneous_layer". All fields are combined with a logical 'AND'. */
export type ConstructionInhomogeneousLayer_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionInhomogeneousLayer_Bool_Exp>>;
  _not?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionInhomogeneousLayer_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  buildUpPartKey?: InputMaybe<String_Comparison_Exp>;
  constructionId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSortingId?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  descriptions?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
  descriptions_aggregate?: InputMaybe<ConstructionInhomogenousLayerDescription_Aggregate_Bool_Exp>;
  height?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  length?: InputMaybe<Numeric_Comparison_Exp>;
  materials?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
  materials_aggregate?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  names?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
  names_aggregate?: InputMaybe<ConstructionInhomogenousLayerName_Aggregate_Bool_Exp>;
  percentage?: InputMaybe<Numeric_Comparison_Exp>;
  sorting?: InputMaybe<ConstructionSorting_Bool_Exp>;
  thickness?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_inhomogeneous_layer" */
export enum ConstructionInhomogeneousLayer_Constraint {
  /** unique or primary key constraint on columns "id" */
  construction_inhomogeneous_layer_pkey = 'construction_inhomogeneous_layer_pkey'
}

/** input type for incrementing numeric columns in table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildUpPartKey?: InputMaybe<Scalars['String']['input']>;
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSortingId?: InputMaybe<Scalars['uuid']['input']>;
  descriptions?: InputMaybe<ConstructionInhomogenousLayerDescription_Arr_Rel_Insert_Input>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  materials?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Arr_Rel_Insert_Input>;
  names?: InputMaybe<ConstructionInhomogenousLayerName_Arr_Rel_Insert_Input>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  sorting?: InputMaybe<ConstructionSorting_Obj_Rel_Insert_Input>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type ConstructionInhomogeneousLayer_Max_Fields = {
  __typename?: 'constructionInhomogeneousLayer_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  buildUpPartKey?: Maybe<Scalars['String']['output']>;
  constructionId?: Maybe<Scalars['uuid']['output']>;
  constructionSortingId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field that returns a translated description based on languages in token with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  /** A computed field that returns a translated name based on languages in token with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildUpPartKey?: InputMaybe<Order_By>;
  constructionId?: InputMaybe<Order_By>;
  constructionSortingId?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionInhomogeneousLayer_Min_Fields = {
  __typename?: 'constructionInhomogeneousLayer_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  buildUpPartKey?: Maybe<Scalars['String']['output']>;
  constructionId?: Maybe<Scalars['uuid']['output']>;
  constructionSortingId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field that returns a translated description based on languages in token with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  /** A computed field that returns a translated name based on languages in token with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildUpPartKey?: InputMaybe<Order_By>;
  constructionId?: InputMaybe<Order_By>;
  constructionSortingId?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Mutation_Response = {
  __typename?: 'constructionInhomogeneousLayer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionInhomogeneousLayer>;
};

/** on_conflict condition type for table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_On_Conflict = {
  constraint: ConstructionInhomogeneousLayer_Constraint;
  update_columns?: Array<ConstructionInhomogeneousLayer_Update_Column>;
  where?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_inhomogeneous_layer". */
export type ConstructionInhomogeneousLayer_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildUpPartKey?: InputMaybe<Order_By>;
  constructionId?: InputMaybe<Order_By>;
  constructionSortingId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  descriptions_aggregate?: InputMaybe<ConstructionInhomogenousLayerDescription_Aggregate_Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  materials_aggregate?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  names_aggregate?: InputMaybe<ConstructionInhomogenousLayerName_Aggregate_Order_By>;
  percentage?: InputMaybe<Order_By>;
  sorting?: InputMaybe<ConstructionSorting_Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_inhomogeneous_layer */
export type ConstructionInhomogeneousLayer_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_inhomogeneous_layer" */
export enum ConstructionInhomogeneousLayer_Select_Column {
  /** column name */
  amount = 'amount',
  /** column name */
  buildUpPartKey = 'buildUpPartKey',
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  constructionSortingId = 'constructionSortingId',
  /** column name */
  height = 'height',
  /** column name */
  id = 'id',
  /** column name */
  length = 'length',
  /** column name */
  percentage = 'percentage',
  /** column name */
  thickness = 'thickness'
}

/** input type for updating data in table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildUpPartKey?: InputMaybe<Scalars['String']['input']>;
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSortingId?: InputMaybe<Scalars['uuid']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type ConstructionInhomogeneousLayer_Stddev_Fields = {
  __typename?: 'constructionInhomogeneousLayer_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ConstructionInhomogeneousLayer_Stddev_Pop_Fields = {
  __typename?: 'constructionInhomogeneousLayer_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ConstructionInhomogeneousLayer_Stddev_Samp_Fields = {
  __typename?: 'constructionInhomogeneousLayer_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "constructionInhomogeneousLayer" */
export type ConstructionInhomogeneousLayer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionInhomogeneousLayer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionInhomogeneousLayer_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildUpPartKey?: InputMaybe<Scalars['String']['input']>;
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSortingId?: InputMaybe<Scalars['uuid']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type ConstructionInhomogeneousLayer_Sum_Fields = {
  __typename?: 'constructionInhomogeneousLayer_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** update columns of table "construction_inhomogeneous_layer" */
export enum ConstructionInhomogeneousLayer_Update_Column {
  /** column name */
  amount = 'amount',
  /** column name */
  buildUpPartKey = 'buildUpPartKey',
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  constructionSortingId = 'constructionSortingId',
  /** column name */
  height = 'height',
  /** column name */
  id = 'id',
  /** column name */
  length = 'length',
  /** column name */
  percentage = 'percentage',
  /** column name */
  thickness = 'thickness'
}

export type ConstructionInhomogeneousLayer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConstructionInhomogeneousLayer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionInhomogeneousLayer_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionInhomogeneousLayer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConstructionInhomogeneousLayer_Var_Pop_Fields = {
  __typename?: 'constructionInhomogeneousLayer_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ConstructionInhomogeneousLayer_Var_Samp_Fields = {
  __typename?: 'constructionInhomogeneousLayer_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ConstructionInhomogeneousLayer_Variance_Fields = {
  __typename?: 'constructionInhomogeneousLayer_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "construction_inhomogeneous_layer" */
export type ConstructionInhomogeneousLayer_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** columns and relationships of "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription = {
  __typename?: 'constructionInhomogenousLayerDescription';
  constructionInhomogenousLayerId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  translationSource: Scalars['String']['output'];
};

/** aggregated selection of "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Aggregate = {
  __typename?: 'constructionInhomogenousLayerDescription_aggregate';
  aggregate?: Maybe<ConstructionInhomogenousLayerDescription_Aggregate_Fields>;
  nodes: Array<ConstructionInhomogenousLayerDescription>;
};

export type ConstructionInhomogenousLayerDescription_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionInhomogenousLayerDescription_Aggregate_Bool_Exp_Count>;
};

export type ConstructionInhomogenousLayerDescription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Aggregate_Fields = {
  __typename?: 'constructionInhomogenousLayerDescription_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionInhomogenousLayerDescription_Max_Fields>;
  min?: Maybe<ConstructionInhomogenousLayerDescription_Min_Fields>;
};


/** aggregate fields of "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionInhomogenousLayerDescription_Max_Order_By>;
  min?: InputMaybe<ConstructionInhomogenousLayerDescription_Min_Order_By>;
};

/** input type for inserting array relation for remote table "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Arr_Rel_Insert_Input = {
  data: Array<ConstructionInhomogenousLayerDescription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionInhomogenousLayerDescription_On_Conflict>;
};

/** Boolean expression to filter rows from the table "construction_inhomogenous_layer_description". All fields are combined with a logical 'AND'. */
export type ConstructionInhomogenousLayerDescription_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Bool_Exp>>;
  _not?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Bool_Exp>>;
  constructionInhomogenousLayerId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_inhomogenous_layer_description" */
export enum ConstructionInhomogenousLayerDescription_Constraint {
  /** unique or primary key constraint on columns "construction_inhomogenous_layer_id", "language_code" */
  construction_inhomogenous_lay_language_code_construction_i_key1 = 'construction_inhomogenous_lay_language_code_construction_i_key1',
  /** unique or primary key constraint on columns "id" */
  construction_inhomogenous_layer_description_pkey = 'construction_inhomogenous_layer_description_pkey'
}

/** input type for inserting data into table "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Insert_Input = {
  constructionInhomogenousLayerId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ConstructionInhomogenousLayerDescription_Max_Fields = {
  __typename?: 'constructionInhomogenousLayerDescription_max_fields';
  constructionInhomogenousLayerId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Max_Order_By = {
  constructionInhomogenousLayerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionInhomogenousLayerDescription_Min_Fields = {
  __typename?: 'constructionInhomogenousLayerDescription_min_fields';
  constructionInhomogenousLayerId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Min_Order_By = {
  constructionInhomogenousLayerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Mutation_Response = {
  __typename?: 'constructionInhomogenousLayerDescription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionInhomogenousLayerDescription>;
};

/** on_conflict condition type for table "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_On_Conflict = {
  constraint: ConstructionInhomogenousLayerDescription_Constraint;
  update_columns?: Array<ConstructionInhomogenousLayerDescription_Update_Column>;
  where?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_inhomogenous_layer_description". */
export type ConstructionInhomogenousLayerDescription_Order_By = {
  constructionInhomogenousLayerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_inhomogenous_layer_description */
export type ConstructionInhomogenousLayerDescription_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_inhomogenous_layer_description" */
export enum ConstructionInhomogenousLayerDescription_Select_Column {
  /** column name */
  constructionInhomogenousLayerId = 'constructionInhomogenousLayerId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "construction_inhomogenous_layer_description" */
export type ConstructionInhomogenousLayerDescription_Set_Input = {
  constructionInhomogenousLayerId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "constructionInhomogenousLayerDescription" */
export type ConstructionInhomogenousLayerDescription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionInhomogenousLayerDescription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionInhomogenousLayerDescription_Stream_Cursor_Value_Input = {
  constructionInhomogenousLayerId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "construction_inhomogenous_layer_description" */
export enum ConstructionInhomogenousLayerDescription_Update_Column {
  /** column name */
  constructionInhomogenousLayerId = 'constructionInhomogenousLayerId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  translationSource = 'translationSource'
}

export type ConstructionInhomogenousLayerDescription_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionInhomogenousLayerDescription_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionInhomogenousLayerDescription_Bool_Exp;
};

/** columns and relationships of "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName = {
  __typename?: 'constructionInhomogenousLayerName';
  constructionInhomogenousLayerId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  translationSource: Scalars['String']['output'];
};

/** aggregated selection of "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Aggregate = {
  __typename?: 'constructionInhomogenousLayerName_aggregate';
  aggregate?: Maybe<ConstructionInhomogenousLayerName_Aggregate_Fields>;
  nodes: Array<ConstructionInhomogenousLayerName>;
};

export type ConstructionInhomogenousLayerName_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionInhomogenousLayerName_Aggregate_Bool_Exp_Count>;
};

export type ConstructionInhomogenousLayerName_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionInhomogenousLayerName_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Aggregate_Fields = {
  __typename?: 'constructionInhomogenousLayerName_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionInhomogenousLayerName_Max_Fields>;
  min?: Maybe<ConstructionInhomogenousLayerName_Min_Fields>;
};


/** aggregate fields of "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionInhomogenousLayerName_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionInhomogenousLayerName_Max_Order_By>;
  min?: InputMaybe<ConstructionInhomogenousLayerName_Min_Order_By>;
};

/** input type for inserting array relation for remote table "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Arr_Rel_Insert_Input = {
  data: Array<ConstructionInhomogenousLayerName_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionInhomogenousLayerName_On_Conflict>;
};

/** Boolean expression to filter rows from the table "construction_inhomogenous_layer_name". All fields are combined with a logical 'AND'. */
export type ConstructionInhomogenousLayerName_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionInhomogenousLayerName_Bool_Exp>>;
  _not?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionInhomogenousLayerName_Bool_Exp>>;
  constructionInhomogenousLayerId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_inhomogenous_layer_name" */
export enum ConstructionInhomogenousLayerName_Constraint {
  /** unique or primary key constraint on columns "construction_inhomogenous_layer_id", "language_code" */
  construction_inhomogenous_lay_language_code_construction_in_key = 'construction_inhomogenous_lay_language_code_construction_in_key',
  /** unique or primary key constraint on columns "id" */
  construction_inhomogenous_layer_name_pkey = 'construction_inhomogenous_layer_name_pkey'
}

/** input type for inserting data into table "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Insert_Input = {
  constructionInhomogenousLayerId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ConstructionInhomogenousLayerName_Max_Fields = {
  __typename?: 'constructionInhomogenousLayerName_max_fields';
  constructionInhomogenousLayerId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Max_Order_By = {
  constructionInhomogenousLayerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionInhomogenousLayerName_Min_Fields = {
  __typename?: 'constructionInhomogenousLayerName_min_fields';
  constructionInhomogenousLayerId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Min_Order_By = {
  constructionInhomogenousLayerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Mutation_Response = {
  __typename?: 'constructionInhomogenousLayerName_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionInhomogenousLayerName>;
};

/** on_conflict condition type for table "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_On_Conflict = {
  constraint: ConstructionInhomogenousLayerName_Constraint;
  update_columns?: Array<ConstructionInhomogenousLayerName_Update_Column>;
  where?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_inhomogenous_layer_name". */
export type ConstructionInhomogenousLayerName_Order_By = {
  constructionInhomogenousLayerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_inhomogenous_layer_name */
export type ConstructionInhomogenousLayerName_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_inhomogenous_layer_name" */
export enum ConstructionInhomogenousLayerName_Select_Column {
  /** column name */
  constructionInhomogenousLayerId = 'constructionInhomogenousLayerId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "construction_inhomogenous_layer_name" */
export type ConstructionInhomogenousLayerName_Set_Input = {
  constructionInhomogenousLayerId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "constructionInhomogenousLayerName" */
export type ConstructionInhomogenousLayerName_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionInhomogenousLayerName_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionInhomogenousLayerName_Stream_Cursor_Value_Input = {
  constructionInhomogenousLayerId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "construction_inhomogenous_layer_name" */
export enum ConstructionInhomogenousLayerName_Update_Column {
  /** column name */
  constructionInhomogenousLayerId = 'constructionInhomogenousLayerId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  translationSource = 'translationSource'
}

export type ConstructionInhomogenousLayerName_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionInhomogenousLayerName_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionInhomogenousLayerName_Bool_Exp;
};

/** columns and relationships of "construction_material" */
export type ConstructionMaterial = {
  __typename?: 'constructionMaterial';
  amount: Scalars['numeric']['output'];
  buildUpPartKey?: Maybe<Scalars['String']['output']>;
  ccSpacing?: Maybe<Scalars['numeric']['output']>;
  constructionId: Scalars['uuid']['output'];
  constructionSortingId: Scalars['uuid']['output'];
  count?: Maybe<Scalars['numeric']['output']>;
  elementWidth?: Maybe<Scalars['numeric']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['numeric']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  length?: Maybe<Scalars['numeric']['output']>;
  lifetime: Scalars['Int']['output'];
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  material?: Maybe<Material>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage: Scalars['numeric']['output'];
  /** An object relationship */
  sorting: ConstructionSorting;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "construction_material" */
export type ConstructionMaterial_Aggregate = {
  __typename?: 'constructionMaterial_aggregate';
  aggregate?: Maybe<ConstructionMaterial_Aggregate_Fields>;
  nodes: Array<ConstructionMaterial>;
};

export type ConstructionMaterial_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionMaterial_Aggregate_Bool_Exp_Count>;
};

export type ConstructionMaterial_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionMaterial_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionMaterial_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_material" */
export type ConstructionMaterial_Aggregate_Fields = {
  __typename?: 'constructionMaterial_aggregate_fields';
  avg?: Maybe<ConstructionMaterial_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionMaterial_Max_Fields>;
  min?: Maybe<ConstructionMaterial_Min_Fields>;
  stddev?: Maybe<ConstructionMaterial_Stddev_Fields>;
  stddev_pop?: Maybe<ConstructionMaterial_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConstructionMaterial_Stddev_Samp_Fields>;
  sum?: Maybe<ConstructionMaterial_Sum_Fields>;
  var_pop?: Maybe<ConstructionMaterial_Var_Pop_Fields>;
  var_samp?: Maybe<ConstructionMaterial_Var_Samp_Fields>;
  variance?: Maybe<ConstructionMaterial_Variance_Fields>;
};


/** aggregate fields of "construction_material" */
export type ConstructionMaterial_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionMaterial_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_material" */
export type ConstructionMaterial_Aggregate_Order_By = {
  avg?: InputMaybe<ConstructionMaterial_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionMaterial_Max_Order_By>;
  min?: InputMaybe<ConstructionMaterial_Min_Order_By>;
  stddev?: InputMaybe<ConstructionMaterial_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ConstructionMaterial_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ConstructionMaterial_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ConstructionMaterial_Sum_Order_By>;
  var_pop?: InputMaybe<ConstructionMaterial_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ConstructionMaterial_Var_Samp_Order_By>;
  variance?: InputMaybe<ConstructionMaterial_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "construction_material" */
export type ConstructionMaterial_Arr_Rel_Insert_Input = {
  data: Array<ConstructionMaterial_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionMaterial_On_Conflict>;
};

/** aggregate avg on columns */
export type ConstructionMaterial_Avg_Fields = {
  __typename?: 'constructionMaterial_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "construction_material" */
export type ConstructionMaterial_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "construction_material". All fields are combined with a logical 'AND'. */
export type ConstructionMaterial_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionMaterial_Bool_Exp>>;
  _not?: InputMaybe<ConstructionMaterial_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionMaterial_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  buildUpPartKey?: InputMaybe<String_Comparison_Exp>;
  ccSpacing?: InputMaybe<Numeric_Comparison_Exp>;
  constructionId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSortingId?: InputMaybe<Uuid_Comparison_Exp>;
  count?: InputMaybe<Numeric_Comparison_Exp>;
  elementWidth?: InputMaybe<Numeric_Comparison_Exp>;
  epdDeclaredThickness?: InputMaybe<Numeric_Comparison_Exp>;
  height?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  length?: InputMaybe<Numeric_Comparison_Exp>;
  lifetime?: InputMaybe<Int_Comparison_Exp>;
  lifetimeOffset?: InputMaybe<Int_Comparison_Exp>;
  material?: InputMaybe<Material_Bool_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  percentage?: InputMaybe<Numeric_Comparison_Exp>;
  sorting?: InputMaybe<ConstructionSorting_Bool_Exp>;
  thickness?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_material" */
export enum ConstructionMaterial_Constraint {
  /** unique or primary key constraint on columns "id" */
  construction_material_pkey = 'construction_material_pkey'
}

/** input type for incrementing numeric columns in table "construction_material" */
export type ConstructionMaterial_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  ccSpacing?: InputMaybe<Scalars['numeric']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  elementWidth?: InputMaybe<Scalars['numeric']['input']>;
  epdDeclaredThickness?: InputMaybe<Scalars['numeric']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "construction_material" */
export type ConstructionMaterial_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildUpPartKey?: InputMaybe<Scalars['String']['input']>;
  ccSpacing?: InputMaybe<Scalars['numeric']['input']>;
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSortingId?: InputMaybe<Scalars['uuid']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  elementWidth?: InputMaybe<Scalars['numeric']['input']>;
  epdDeclaredThickness?: InputMaybe<Scalars['numeric']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  material?: InputMaybe<Material_Obj_Rel_Insert_Input>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  sorting?: InputMaybe<ConstructionSorting_Obj_Rel_Insert_Input>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type ConstructionMaterial_Max_Fields = {
  __typename?: 'constructionMaterial_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  buildUpPartKey?: Maybe<Scalars['String']['output']>;
  ccSpacing?: Maybe<Scalars['numeric']['output']>;
  constructionId?: Maybe<Scalars['uuid']['output']>;
  constructionSortingId?: Maybe<Scalars['uuid']['output']>;
  count?: Maybe<Scalars['numeric']['output']>;
  elementWidth?: Maybe<Scalars['numeric']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['numeric']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "construction_material" */
export type ConstructionMaterial_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildUpPartKey?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  constructionId?: InputMaybe<Order_By>;
  constructionSortingId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionMaterial_Min_Fields = {
  __typename?: 'constructionMaterial_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  buildUpPartKey?: Maybe<Scalars['String']['output']>;
  ccSpacing?: Maybe<Scalars['numeric']['output']>;
  constructionId?: Maybe<Scalars['uuid']['output']>;
  constructionSortingId?: Maybe<Scalars['uuid']['output']>;
  count?: Maybe<Scalars['numeric']['output']>;
  elementWidth?: Maybe<Scalars['numeric']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['numeric']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "construction_material" */
export type ConstructionMaterial_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildUpPartKey?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  constructionId?: InputMaybe<Order_By>;
  constructionSortingId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_material" */
export type ConstructionMaterial_Mutation_Response = {
  __typename?: 'constructionMaterial_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionMaterial>;
};

/** on_conflict condition type for table "construction_material" */
export type ConstructionMaterial_On_Conflict = {
  constraint: ConstructionMaterial_Constraint;
  update_columns?: Array<ConstructionMaterial_Update_Column>;
  where?: InputMaybe<ConstructionMaterial_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_material". */
export type ConstructionMaterial_Order_By = {
  amount?: InputMaybe<Order_By>;
  buildUpPartKey?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  constructionId?: InputMaybe<Order_By>;
  constructionSortingId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  material?: InputMaybe<Material_Order_By>;
  materialId?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  sorting?: InputMaybe<ConstructionSorting_Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_material */
export type ConstructionMaterial_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_material" */
export enum ConstructionMaterial_Select_Column {
  /** column name */
  amount = 'amount',
  /** column name */
  buildUpPartKey = 'buildUpPartKey',
  /** column name */
  ccSpacing = 'ccSpacing',
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  constructionSortingId = 'constructionSortingId',
  /** column name */
  count = 'count',
  /** column name */
  elementWidth = 'elementWidth',
  /** column name */
  epdDeclaredThickness = 'epdDeclaredThickness',
  /** column name */
  height = 'height',
  /** column name */
  id = 'id',
  /** column name */
  length = 'length',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  lifetimeOffset = 'lifetimeOffset',
  /** column name */
  materialId = 'materialId',
  /** column name */
  mode = 'mode',
  /** column name */
  name = 'name',
  /** column name */
  percentage = 'percentage',
  /** column name */
  thickness = 'thickness'
}

/** input type for updating data in table "construction_material" */
export type ConstructionMaterial_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildUpPartKey?: InputMaybe<Scalars['String']['input']>;
  ccSpacing?: InputMaybe<Scalars['numeric']['input']>;
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSortingId?: InputMaybe<Scalars['uuid']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  elementWidth?: InputMaybe<Scalars['numeric']['input']>;
  epdDeclaredThickness?: InputMaybe<Scalars['numeric']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type ConstructionMaterial_Stddev_Fields = {
  __typename?: 'constructionMaterial_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "construction_material" */
export type ConstructionMaterial_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ConstructionMaterial_Stddev_Pop_Fields = {
  __typename?: 'constructionMaterial_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "construction_material" */
export type ConstructionMaterial_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ConstructionMaterial_Stddev_Samp_Fields = {
  __typename?: 'constructionMaterial_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "construction_material" */
export type ConstructionMaterial_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "constructionMaterial" */
export type ConstructionMaterial_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionMaterial_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionMaterial_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  buildUpPartKey?: InputMaybe<Scalars['String']['input']>;
  ccSpacing?: InputMaybe<Scalars['numeric']['input']>;
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSortingId?: InputMaybe<Scalars['uuid']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  elementWidth?: InputMaybe<Scalars['numeric']['input']>;
  epdDeclaredThickness?: InputMaybe<Scalars['numeric']['input']>;
  height?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['numeric']['input']>;
  thickness?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type ConstructionMaterial_Sum_Fields = {
  __typename?: 'constructionMaterial_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  ccSpacing?: Maybe<Scalars['numeric']['output']>;
  count?: Maybe<Scalars['numeric']['output']>;
  elementWidth?: Maybe<Scalars['numeric']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['numeric']['output']>;
  height?: Maybe<Scalars['numeric']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['numeric']['output']>;
  thickness?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "construction_material" */
export type ConstructionMaterial_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** update columns of table "construction_material" */
export enum ConstructionMaterial_Update_Column {
  /** column name */
  amount = 'amount',
  /** column name */
  buildUpPartKey = 'buildUpPartKey',
  /** column name */
  ccSpacing = 'ccSpacing',
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  constructionSortingId = 'constructionSortingId',
  /** column name */
  count = 'count',
  /** column name */
  elementWidth = 'elementWidth',
  /** column name */
  epdDeclaredThickness = 'epdDeclaredThickness',
  /** column name */
  height = 'height',
  /** column name */
  id = 'id',
  /** column name */
  length = 'length',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  lifetimeOffset = 'lifetimeOffset',
  /** column name */
  materialId = 'materialId',
  /** column name */
  mode = 'mode',
  /** column name */
  name = 'name',
  /** column name */
  percentage = 'percentage',
  /** column name */
  thickness = 'thickness'
}

export type ConstructionMaterial_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConstructionMaterial_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionMaterial_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionMaterial_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConstructionMaterial_Var_Pop_Fields = {
  __typename?: 'constructionMaterial_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "construction_material" */
export type ConstructionMaterial_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ConstructionMaterial_Var_Samp_Fields = {
  __typename?: 'constructionMaterial_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "construction_material" */
export type ConstructionMaterial_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ConstructionMaterial_Variance_Fields = {
  __typename?: 'constructionMaterial_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  ccSpacing?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  elementWidth?: Maybe<Scalars['Float']['output']>;
  epdDeclaredThickness?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  thickness?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "construction_material" */
export type ConstructionMaterial_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  ccSpacing?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  elementWidth?: InputMaybe<Order_By>;
  epdDeclaredThickness?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  thickness?: InputMaybe<Order_By>;
};

/** columns and relationships of "construction_name" */
export type ConstructionName = {
  __typename?: 'constructionName';
  constructionId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  translationSource: Scalars['String']['output'];
};

/** aggregated selection of "construction_name" */
export type ConstructionName_Aggregate = {
  __typename?: 'constructionName_aggregate';
  aggregate?: Maybe<ConstructionName_Aggregate_Fields>;
  nodes: Array<ConstructionName>;
};

export type ConstructionName_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionName_Aggregate_Bool_Exp_Count>;
};

export type ConstructionName_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionName_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionName_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "construction_name" */
export type ConstructionName_Aggregate_Fields = {
  __typename?: 'constructionName_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionName_Max_Fields>;
  min?: Maybe<ConstructionName_Min_Fields>;
};


/** aggregate fields of "construction_name" */
export type ConstructionName_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionName_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "construction_name" */
export type ConstructionName_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionName_Max_Order_By>;
  min?: InputMaybe<ConstructionName_Min_Order_By>;
};

/** input type for inserting array relation for remote table "construction_name" */
export type ConstructionName_Arr_Rel_Insert_Input = {
  data: Array<ConstructionName_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionName_On_Conflict>;
};

/** Boolean expression to filter rows from the table "construction_name". All fields are combined with a logical 'AND'. */
export type ConstructionName_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionName_Bool_Exp>>;
  _not?: InputMaybe<ConstructionName_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionName_Bool_Exp>>;
  constructionId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_name" */
export enum ConstructionName_Constraint {
  /** unique or primary key constraint on columns "language_code", "construction_id" */
  construction_name_language_code_construction_id_key = 'construction_name_language_code_construction_id_key',
  /** unique or primary key constraint on columns "id" */
  construction_name_pkey = 'construction_name_pkey'
}

/** input type for inserting data into table "construction_name" */
export type ConstructionName_Insert_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ConstructionName_Max_Fields = {
  __typename?: 'constructionName_max_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "construction_name" */
export type ConstructionName_Max_Order_By = {
  constructionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionName_Min_Fields = {
  __typename?: 'constructionName_min_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "construction_name" */
export type ConstructionName_Min_Order_By = {
  constructionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "construction_name" */
export type ConstructionName_Mutation_Response = {
  __typename?: 'constructionName_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionName>;
};

/** on_conflict condition type for table "construction_name" */
export type ConstructionName_On_Conflict = {
  constraint: ConstructionName_Constraint;
  update_columns?: Array<ConstructionName_Update_Column>;
  where?: InputMaybe<ConstructionName_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_name". */
export type ConstructionName_Order_By = {
  constructionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_name */
export type ConstructionName_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_name" */
export enum ConstructionName_Select_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "construction_name" */
export type ConstructionName_Set_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "constructionName" */
export type ConstructionName_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionName_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionName_Stream_Cursor_Value_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "construction_name" */
export enum ConstructionName_Update_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  translationSource = 'translationSource'
}

export type ConstructionName_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionName_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionName_Bool_Exp;
};

/** columns and relationships of "construction_sorting" */
export type ConstructionSorting = {
  __typename?: 'constructionSorting';
  constructionId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Int']['output'];
};

/** aggregated selection of "construction_sorting" */
export type ConstructionSorting_Aggregate = {
  __typename?: 'constructionSorting_aggregate';
  aggregate?: Maybe<ConstructionSorting_Aggregate_Fields>;
  nodes: Array<ConstructionSorting>;
};

/** aggregate fields of "construction_sorting" */
export type ConstructionSorting_Aggregate_Fields = {
  __typename?: 'constructionSorting_aggregate_fields';
  avg?: Maybe<ConstructionSorting_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionSorting_Max_Fields>;
  min?: Maybe<ConstructionSorting_Min_Fields>;
  stddev?: Maybe<ConstructionSorting_Stddev_Fields>;
  stddev_pop?: Maybe<ConstructionSorting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConstructionSorting_Stddev_Samp_Fields>;
  sum?: Maybe<ConstructionSorting_Sum_Fields>;
  var_pop?: Maybe<ConstructionSorting_Var_Pop_Fields>;
  var_samp?: Maybe<ConstructionSorting_Var_Samp_Fields>;
  variance?: Maybe<ConstructionSorting_Variance_Fields>;
};


/** aggregate fields of "construction_sorting" */
export type ConstructionSorting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionSorting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ConstructionSorting_Avg_Fields = {
  __typename?: 'constructionSorting_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "construction_sorting". All fields are combined with a logical 'AND'. */
export type ConstructionSorting_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionSorting_Bool_Exp>>;
  _not?: InputMaybe<ConstructionSorting_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionSorting_Bool_Exp>>;
  constructionId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction_sorting" */
export enum ConstructionSorting_Constraint {
  /** unique or primary key constraint on columns "index", "construction_id" */
  construction_sorting_index_construction_id_key = 'construction_sorting_index_construction_id_key',
  /** unique or primary key constraint on columns "id" */
  construction_sorting_pkey = 'construction_sorting_pkey'
}

/** input type for incrementing numeric columns in table "construction_sorting" */
export type ConstructionSorting_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "construction_sorting" */
export type ConstructionSorting_Insert_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ConstructionSorting_Max_Fields = {
  __typename?: 'constructionSorting_max_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type ConstructionSorting_Min_Fields = {
  __typename?: 'constructionSorting_min_fields';
  constructionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "construction_sorting" */
export type ConstructionSorting_Mutation_Response = {
  __typename?: 'constructionSorting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionSorting>;
};

/** input type for inserting object relation for remote table "construction_sorting" */
export type ConstructionSorting_Obj_Rel_Insert_Input = {
  data: ConstructionSorting_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionSorting_On_Conflict>;
};

/** on_conflict condition type for table "construction_sorting" */
export type ConstructionSorting_On_Conflict = {
  constraint: ConstructionSorting_Constraint;
  update_columns?: Array<ConstructionSorting_Update_Column>;
  where?: InputMaybe<ConstructionSorting_Bool_Exp>;
};

/** Ordering options when selecting data from "construction_sorting". */
export type ConstructionSorting_Order_By = {
  constructionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction_sorting */
export type ConstructionSorting_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction_sorting" */
export enum ConstructionSorting_Select_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  id = 'id',
  /** column name */
  index = 'index'
}

/** input type for updating data in table "construction_sorting" */
export type ConstructionSorting_Set_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ConstructionSorting_Stddev_Fields = {
  __typename?: 'constructionSorting_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ConstructionSorting_Stddev_Pop_Fields = {
  __typename?: 'constructionSorting_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ConstructionSorting_Stddev_Samp_Fields = {
  __typename?: 'constructionSorting_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "constructionSorting" */
export type ConstructionSorting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionSorting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionSorting_Stream_Cursor_Value_Input = {
  constructionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ConstructionSorting_Sum_Fields = {
  __typename?: 'constructionSorting_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "construction_sorting" */
export enum ConstructionSorting_Update_Column {
  /** column name */
  constructionId = 'constructionId',
  /** column name */
  id = 'id',
  /** column name */
  index = 'index'
}

export type ConstructionSorting_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConstructionSorting_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionSorting_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionSorting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConstructionSorting_Var_Pop_Fields = {
  __typename?: 'constructionSorting_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ConstructionSorting_Var_Samp_Fields = {
  __typename?: 'constructionSorting_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ConstructionSorting_Variance_Fields = {
  __typename?: 'constructionSorting_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "construction" */
export type Construction_Aggregate = {
  __typename?: 'construction_aggregate';
  aggregate?: Maybe<Construction_Aggregate_Fields>;
  nodes: Array<Construction>;
};

/** aggregate fields of "construction" */
export type Construction_Aggregate_Fields = {
  __typename?: 'construction_aggregate_fields';
  avg?: Maybe<Construction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Construction_Max_Fields>;
  min?: Maybe<Construction_Min_Fields>;
  stddev?: Maybe<Construction_Stddev_Fields>;
  stddev_pop?: Maybe<Construction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Construction_Stddev_Samp_Fields>;
  sum?: Maybe<Construction_Sum_Fields>;
  var_pop?: Maybe<Construction_Var_Pop_Fields>;
  var_samp?: Maybe<Construction_Var_Samp_Fields>;
  variance?: Maybe<Construction_Variance_Fields>;
};


/** aggregate fields of "construction" */
export type Construction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Construction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Construction_Avg_Fields = {
  __typename?: 'construction_avg_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "construction". All fields are combined with a logical 'AND'. */
export type Construction_Bool_Exp = {
  _and?: InputMaybe<Array<Construction_Bool_Exp>>;
  _not?: InputMaybe<Construction_Bool_Exp>;
  _or?: InputMaybe<Array<Construction_Bool_Exp>>;
  buildUpTemplate?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
  buildUpTemplateId?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<MaterialCategory_Bool_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  constructionCategory?: InputMaybe<ConstructionCategory_Bool_Exp>;
  constructionCategoryId?: InputMaybe<String_Comparison_Exp>;
  countries?: InputMaybe<ConstructionCountry_Bool_Exp>;
  countries_aggregate?: InputMaybe<ConstructionCountry_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  declaredUnit?: InputMaybe<DeclaredUnit_Bool_Exp>;
  declaredUnitId?: InputMaybe<Uuid_Comparison_Exp>;
  deprecated?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  descriptions?: InputMaybe<ConstructionDescription_Bool_Exp>;
  descriptions_aggregate?: InputMaybe<ConstructionDescription_Aggregate_Bool_Exp>;
  faulty?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inhomogeneousLayers?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
  inhomogeneousLayers_aggregate?: InputMaybe<ConstructionInhomogeneousLayer_Aggregate_Bool_Exp>;
  internalId?: InputMaybe<String_Comparison_Exp>;
  isCustom?: InputMaybe<Boolean_Comparison_Exp>;
  isPublic?: InputMaybe<Boolean_Comparison_Exp>;
  materialCategories?: InputMaybe<MaterialCategory_Bool_Exp>;
  materials?: InputMaybe<ConstructionMaterial_Bool_Exp>;
  materials_aggregate?: InputMaybe<ConstructionMaterial_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  names?: InputMaybe<ConstructionName_Bool_Exp>;
  names_aggregate?: InputMaybe<ConstructionName_Aggregate_Bool_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedBy?: InputMaybe<Uuid_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "construction" */
export enum Construction_Constraint {
  /** unique or primary key constraint on columns "internal_id", "version" */
  construction_internal_id_version_key = 'construction_internal_id_version_key',
  /** unique or primary key constraint on columns "id" */
  construction_pkey = 'construction_pkey'
}

/** input type for incrementing numeric columns in table "construction" */
export type Construction_Inc_Input = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "construction" */
export type Construction_Insert_Input = {
  buildUpTemplate?: InputMaybe<ConstructionBuildUpTemplate_Obj_Rel_Insert_Input>;
  buildUpTemplateId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<MaterialCategory_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  constructionCategory?: InputMaybe<ConstructionCategory_Obj_Rel_Insert_Input>;
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<ConstructionCountry_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  declaredUnit?: InputMaybe<DeclaredUnit_Obj_Rel_Insert_Input>;
  declaredUnitId?: InputMaybe<Scalars['uuid']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  descriptions?: InputMaybe<ConstructionDescription_Arr_Rel_Insert_Input>;
  faulty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inhomogeneousLayers?: InputMaybe<ConstructionInhomogeneousLayer_Arr_Rel_Insert_Input>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  materials?: InputMaybe<ConstructionMaterial_Arr_Rel_Insert_Input>;
  names?: InputMaybe<ConstructionName_Arr_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Construction_Max_Fields = {
  __typename?: 'construction_max_fields';
  buildUpTemplateId?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  constructionCategoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  declaredUnitId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field that returns a translated description based on languages in token with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internalId?: Maybe<Scalars['String']['output']>;
  /** A computed field that returns a translated name based on languages in token with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Construction_Min_Fields = {
  __typename?: 'construction_min_fields';
  buildUpTemplateId?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  constructionCategoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  declaredUnitId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field that returns a translated description based on languages in token with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internalId?: Maybe<Scalars['String']['output']>;
  /** A computed field that returns a translated name based on languages in token with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "construction" */
export type Construction_Mutation_Response = {
  __typename?: 'construction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Construction>;
};

/** input type for inserting object relation for remote table "construction" */
export type Construction_Obj_Rel_Insert_Input = {
  data: Construction_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Construction_On_Conflict>;
};

/** on_conflict condition type for table "construction" */
export type Construction_On_Conflict = {
  constraint: Construction_Constraint;
  update_columns?: Array<Construction_Update_Column>;
  where?: InputMaybe<Construction_Bool_Exp>;
};

/** Ordering options when selecting data from "construction". */
export type Construction_Order_By = {
  buildUpTemplate?: InputMaybe<ConstructionBuildUpTemplate_Order_By>;
  buildUpTemplateId?: InputMaybe<Order_By>;
  category?: InputMaybe<MaterialCategory_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  constructionCategory?: InputMaybe<ConstructionCategory_Order_By>;
  constructionCategoryId?: InputMaybe<Order_By>;
  countries_aggregate?: InputMaybe<ConstructionCountry_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  declaredUnit?: InputMaybe<DeclaredUnit_Order_By>;
  declaredUnitId?: InputMaybe<Order_By>;
  deprecated?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  descriptions_aggregate?: InputMaybe<ConstructionDescription_Aggregate_Order_By>;
  faulty?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inhomogeneousLayers_aggregate?: InputMaybe<ConstructionInhomogeneousLayer_Aggregate_Order_By>;
  internalId?: InputMaybe<Order_By>;
  isCustom?: InputMaybe<Order_By>;
  isPublic?: InputMaybe<Order_By>;
  materialCategories_aggregate?: InputMaybe<MaterialCategory_Aggregate_Order_By>;
  materials_aggregate?: InputMaybe<ConstructionMaterial_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  names_aggregate?: InputMaybe<ConstructionName_Aggregate_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: construction */
export type Construction_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "construction" */
export enum Construction_Select_Column {
  /** column name */
  buildUpTemplateId = 'buildUpTemplateId',
  /** column name */
  categoryId = 'categoryId',
  /** column name */
  constructionCategoryId = 'constructionCategoryId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  declaredUnitId = 'declaredUnitId',
  /** column name */
  deprecated = 'deprecated',
  /** column name */
  faulty = 'faulty',
  /** column name */
  id = 'id',
  /** column name */
  internalId = 'internalId',
  /** column name */
  isCustom = 'isCustom',
  /** column name */
  isPublic = 'isPublic',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  updatedBy = 'updatedBy',
  /** column name */
  version = 'version'
}

/** input type for updating data in table "construction" */
export type Construction_Set_Input = {
  buildUpTemplateId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  declaredUnitId?: InputMaybe<Scalars['uuid']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  faulty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Construction_Stddev_Fields = {
  __typename?: 'construction_stddev_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Construction_Stddev_Pop_Fields = {
  __typename?: 'construction_stddev_pop_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Construction_Stddev_Samp_Fields = {
  __typename?: 'construction_stddev_samp_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "construction" */
export type Construction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Construction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Construction_Stream_Cursor_Value_Input = {
  buildUpTemplateId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  constructionCategoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  declaredUnitId?: InputMaybe<Scalars['uuid']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  faulty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Construction_Sum_Fields = {
  __typename?: 'construction_sum_fields';
  version?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "construction" */
export enum Construction_Update_Column {
  /** column name */
  buildUpTemplateId = 'buildUpTemplateId',
  /** column name */
  categoryId = 'categoryId',
  /** column name */
  constructionCategoryId = 'constructionCategoryId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  declaredUnitId = 'declaredUnitId',
  /** column name */
  deprecated = 'deprecated',
  /** column name */
  faulty = 'faulty',
  /** column name */
  id = 'id',
  /** column name */
  internalId = 'internalId',
  /** column name */
  isCustom = 'isCustom',
  /** column name */
  isPublic = 'isPublic',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  updatedBy = 'updatedBy',
  /** column name */
  version = 'version'
}

export type Construction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Construction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Construction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Construction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Construction_Var_Pop_Fields = {
  __typename?: 'construction_var_pop_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Construction_Var_Samp_Fields = {
  __typename?: 'construction_var_samp_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Construction_Variance_Fields = {
  __typename?: 'construction_variance_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "country" */
export type Country = {
  __typename?: 'country';
  value: Scalars['String']['output'];
};

/** columns and relationships of "country_config" */
export type CountryConfig = {
  __typename?: 'countryConfig';
  /** An object relationship */
  calculationType?: Maybe<CalculationType>;
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  country: Country_Enum;
  id: Scalars['bigint']['output'];
  installationFields: Array<Scalars['String']['output']>;
  useStageDefaultEmission: Scalars['Boolean']['output'];
  useStageDefaultEmissionByStage: Scalars['Boolean']['output'];
  wasteSortingMaterialListDefaultExpand: Scalars['Boolean']['output'];
};

/** aggregated selection of "country_config" */
export type CountryConfig_Aggregate = {
  __typename?: 'countryConfig_aggregate';
  aggregate?: Maybe<CountryConfig_Aggregate_Fields>;
  nodes: Array<CountryConfig>;
};

/** aggregate fields of "country_config" */
export type CountryConfig_Aggregate_Fields = {
  __typename?: 'countryConfig_aggregate_fields';
  avg?: Maybe<CountryConfig_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CountryConfig_Max_Fields>;
  min?: Maybe<CountryConfig_Min_Fields>;
  stddev?: Maybe<CountryConfig_Stddev_Fields>;
  stddev_pop?: Maybe<CountryConfig_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CountryConfig_Stddev_Samp_Fields>;
  sum?: Maybe<CountryConfig_Sum_Fields>;
  var_pop?: Maybe<CountryConfig_Var_Pop_Fields>;
  var_samp?: Maybe<CountryConfig_Var_Samp_Fields>;
  variance?: Maybe<CountryConfig_Variance_Fields>;
};


/** aggregate fields of "country_config" */
export type CountryConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CountryConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type CountryConfig_Avg_Fields = {
  __typename?: 'countryConfig_avg_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "country_config". All fields are combined with a logical 'AND'. */
export type CountryConfig_Bool_Exp = {
  _and?: InputMaybe<Array<CountryConfig_Bool_Exp>>;
  _not?: InputMaybe<CountryConfig_Bool_Exp>;
  _or?: InputMaybe<Array<CountryConfig_Bool_Exp>>;
  calculationType?: InputMaybe<CalculationType_Bool_Exp>;
  calculationTypeId?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  installationFields?: InputMaybe<String_Array_Comparison_Exp>;
  useStageDefaultEmission?: InputMaybe<Boolean_Comparison_Exp>;
  useStageDefaultEmissionByStage?: InputMaybe<Boolean_Comparison_Exp>;
  wasteSortingMaterialListDefaultExpand?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "country_config" */
export enum CountryConfig_Constraint {
  /** unique or primary key constraint on columns "country", "calculation_type_id" */
  country_config_country_calc_type_notnull_ux = 'country_config_country_calc_type_notnull_ux',
  /** unique or primary key constraint on columns "country", "calculation_type_id" */
  country_config_country_calculation_type_id_key = 'country_config_country_calculation_type_id_key',
  /** unique or primary key constraint on columns "country" */
  country_config_country_null_calc_type_ux = 'country_config_country_null_calc_type_ux',
  /** unique or primary key constraint on columns "id" */
  country_config_pkey = 'country_config_pkey'
}

/** input type for incrementing numeric columns in table "country_config" */
export type CountryConfig_Inc_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "country_config" */
export type CountryConfig_Insert_Input = {
  calculationType?: InputMaybe<CalculationType_Obj_Rel_Insert_Input>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  installationFields?: InputMaybe<Array<Scalars['String']['input']>>;
  useStageDefaultEmission?: InputMaybe<Scalars['Boolean']['input']>;
  useStageDefaultEmissionByStage?: InputMaybe<Scalars['Boolean']['input']>;
  wasteSortingMaterialListDefaultExpand?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type CountryConfig_Max_Fields = {
  __typename?: 'countryConfig_max_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  installationFields?: Maybe<Array<Scalars['String']['output']>>;
};

/** aggregate min on columns */
export type CountryConfig_Min_Fields = {
  __typename?: 'countryConfig_min_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  installationFields?: Maybe<Array<Scalars['String']['output']>>;
};

/** response of any mutation on the table "country_config" */
export type CountryConfig_Mutation_Response = {
  __typename?: 'countryConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CountryConfig>;
};

/** input type for inserting object relation for remote table "country_config" */
export type CountryConfig_Obj_Rel_Insert_Input = {
  data: CountryConfig_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CountryConfig_On_Conflict>;
};

/** on_conflict condition type for table "country_config" */
export type CountryConfig_On_Conflict = {
  constraint: CountryConfig_Constraint;
  update_columns?: Array<CountryConfig_Update_Column>;
  where?: InputMaybe<CountryConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "country_config". */
export type CountryConfig_Order_By = {
  calculationType?: InputMaybe<CalculationType_Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installationFields?: InputMaybe<Order_By>;
  useStageDefaultEmission?: InputMaybe<Order_By>;
  useStageDefaultEmissionByStage?: InputMaybe<Order_By>;
  wasteSortingMaterialListDefaultExpand?: InputMaybe<Order_By>;
};

/** primary key columns input for table: country_config */
export type CountryConfig_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "country_config" */
export enum CountryConfig_Select_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  installationFields = 'installationFields',
  /** column name */
  useStageDefaultEmission = 'useStageDefaultEmission',
  /** column name */
  useStageDefaultEmissionByStage = 'useStageDefaultEmissionByStage',
  /** column name */
  wasteSortingMaterialListDefaultExpand = 'wasteSortingMaterialListDefaultExpand'
}

/** input type for updating data in table "country_config" */
export type CountryConfig_Set_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  installationFields?: InputMaybe<Array<Scalars['String']['input']>>;
  useStageDefaultEmission?: InputMaybe<Scalars['Boolean']['input']>;
  useStageDefaultEmissionByStage?: InputMaybe<Scalars['Boolean']['input']>;
  wasteSortingMaterialListDefaultExpand?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type CountryConfig_Stddev_Fields = {
  __typename?: 'countryConfig_stddev_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type CountryConfig_Stddev_Pop_Fields = {
  __typename?: 'countryConfig_stddev_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type CountryConfig_Stddev_Samp_Fields = {
  __typename?: 'countryConfig_stddev_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "countryConfig" */
export type CountryConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CountryConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CountryConfig_Stream_Cursor_Value_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  installationFields?: InputMaybe<Array<Scalars['String']['input']>>;
  useStageDefaultEmission?: InputMaybe<Scalars['Boolean']['input']>;
  useStageDefaultEmissionByStage?: InputMaybe<Scalars['Boolean']['input']>;
  wasteSortingMaterialListDefaultExpand?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type CountryConfig_Sum_Fields = {
  __typename?: 'countryConfig_sum_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "country_config" */
export enum CountryConfig_Update_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  installationFields = 'installationFields',
  /** column name */
  useStageDefaultEmission = 'useStageDefaultEmission',
  /** column name */
  useStageDefaultEmissionByStage = 'useStageDefaultEmissionByStage',
  /** column name */
  wasteSortingMaterialListDefaultExpand = 'wasteSortingMaterialListDefaultExpand'
}

export type CountryConfig_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CountryConfig_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CountryConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: CountryConfig_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CountryConfig_Var_Pop_Fields = {
  __typename?: 'countryConfig_var_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type CountryConfig_Var_Samp_Fields = {
  __typename?: 'countryConfig_var_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type CountryConfig_Variance_Fields = {
  __typename?: 'countryConfig_variance_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "country" */
export type Country_Aggregate = {
  __typename?: 'country_aggregate';
  aggregate?: Maybe<Country_Aggregate_Fields>;
  nodes: Array<Country>;
};

/** aggregate fields of "country" */
export type Country_Aggregate_Fields = {
  __typename?: 'country_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Country_Max_Fields>;
  min?: Maybe<Country_Min_Fields>;
};


/** aggregate fields of "country" */
export type Country_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type Country_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Bool_Exp>>;
  _not?: InputMaybe<Country_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "country" */
export enum Country_Constraint {
  /** unique or primary key constraint on columns "value" */
  country_pkey = 'country_pkey'
}

export enum Country_Enum {
  DENMARK = 'DENMARK',
  FAROE_ISLAND = 'FAROE_ISLAND',
  FINLAND = 'FINLAND',
  FRANCE = 'FRANCE',
  GERMANY = 'GERMANY',
  GREENLAND = 'GREENLAND',
  ICELAND = 'ICELAND',
  IRELAND = 'IRELAND',
  ITALY = 'ITALY',
  NETHERLANDS = 'NETHERLANDS',
  NORWAY = 'NORWAY',
  SPAIN = 'SPAIN',
  SWEDEN = 'SWEDEN',
  UNITED_KINGDOM = 'UNITED_KINGDOM'
}

/** Boolean expression to compare columns of type "country_enum". All fields are combined with logical 'AND'. */
export type Country_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Country_Enum>;
  _in?: InputMaybe<Array<Country_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Country_Enum>;
  _nin?: InputMaybe<Array<Country_Enum>>;
};

/** input type for inserting data into table "country" */
export type Country_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Country_Max_Fields = {
  __typename?: 'country_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Country_Min_Fields = {
  __typename?: 'country_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "country" */
export type Country_Mutation_Response = {
  __typename?: 'country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Country>;
};

/** on_conflict condition type for table "country" */
export type Country_On_Conflict = {
  constraint: Country_Constraint;
  update_columns?: Array<Country_Update_Column>;
  where?: InputMaybe<Country_Bool_Exp>;
};

/** Ordering options when selecting data from "country". */
export type Country_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: country */
export type Country_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "country" */
export enum Country_Select_Column {
  /** column name */
  value = 'value'
}

/** input type for updating data in table "country" */
export type Country_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "country" */
export type Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "country" */
export enum Country_Update_Column {
  /** column name */
  value = 'value'
}

export type Country_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Country_Set_Input>;
  /** filter the rows which have to be updated */
  where: Country_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "declared_unit" */
export type DeclaredUnit = {
  __typename?: 'declaredUnit';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  unit: Unit;
  unitId: Scalars['Int']['output'];
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "declared_unit" */
export type DeclaredUnit_Aggregate = {
  __typename?: 'declaredUnit_aggregate';
  aggregate?: Maybe<DeclaredUnit_Aggregate_Fields>;
  nodes: Array<DeclaredUnit>;
};

/** aggregate fields of "declared_unit" */
export type DeclaredUnit_Aggregate_Fields = {
  __typename?: 'declaredUnit_aggregate_fields';
  avg?: Maybe<DeclaredUnit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<DeclaredUnit_Max_Fields>;
  min?: Maybe<DeclaredUnit_Min_Fields>;
  stddev?: Maybe<DeclaredUnit_Stddev_Fields>;
  stddev_pop?: Maybe<DeclaredUnit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DeclaredUnit_Stddev_Samp_Fields>;
  sum?: Maybe<DeclaredUnit_Sum_Fields>;
  var_pop?: Maybe<DeclaredUnit_Var_Pop_Fields>;
  var_samp?: Maybe<DeclaredUnit_Var_Samp_Fields>;
  variance?: Maybe<DeclaredUnit_Variance_Fields>;
};


/** aggregate fields of "declared_unit" */
export type DeclaredUnit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DeclaredUnit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type DeclaredUnit_Avg_Fields = {
  __typename?: 'declaredUnit_avg_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "declared_unit". All fields are combined with a logical 'AND'. */
export type DeclaredUnit_Bool_Exp = {
  _and?: InputMaybe<Array<DeclaredUnit_Bool_Exp>>;
  _not?: InputMaybe<DeclaredUnit_Bool_Exp>;
  _or?: InputMaybe<Array<DeclaredUnit_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unitId?: InputMaybe<Int_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "declared_unit" */
export enum DeclaredUnit_Constraint {
  /** unique or primary key constraint on columns "id" */
  material_declared_unit_pkey = 'material_declared_unit_pkey'
}

/** input type for incrementing numeric columns in table "declared_unit" */
export type DeclaredUnit_Inc_Input = {
  unitId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "declared_unit" */
export type DeclaredUnit_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type DeclaredUnit_Max_Fields = {
  __typename?: 'declaredUnit_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type DeclaredUnit_Min_Fields = {
  __typename?: 'declaredUnit_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "declared_unit" */
export type DeclaredUnit_Mutation_Response = {
  __typename?: 'declaredUnit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DeclaredUnit>;
};

/** input type for inserting object relation for remote table "declared_unit" */
export type DeclaredUnit_Obj_Rel_Insert_Input = {
  data: DeclaredUnit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DeclaredUnit_On_Conflict>;
};

/** on_conflict condition type for table "declared_unit" */
export type DeclaredUnit_On_Conflict = {
  constraint: DeclaredUnit_Constraint;
  update_columns?: Array<DeclaredUnit_Update_Column>;
  where?: InputMaybe<DeclaredUnit_Bool_Exp>;
};

/** Ordering options when selecting data from "declared_unit". */
export type DeclaredUnit_Order_By = {
  id?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unitId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: declared_unit */
export type DeclaredUnit_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "declared_unit" */
export enum DeclaredUnit_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  unitId = 'unitId',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "declared_unit" */
export type DeclaredUnit_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type DeclaredUnit_Stddev_Fields = {
  __typename?: 'declaredUnit_stddev_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type DeclaredUnit_Stddev_Pop_Fields = {
  __typename?: 'declaredUnit_stddev_pop_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type DeclaredUnit_Stddev_Samp_Fields = {
  __typename?: 'declaredUnit_stddev_samp_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "declaredUnit" */
export type DeclaredUnit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DeclaredUnit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DeclaredUnit_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type DeclaredUnit_Sum_Fields = {
  __typename?: 'declaredUnit_sum_fields';
  unitId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "declared_unit" */
export enum DeclaredUnit_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  unitId = 'unitId',
  /** column name */
  value = 'value'
}

export type DeclaredUnit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DeclaredUnit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DeclaredUnit_Set_Input>;
  /** filter the rows which have to be updated */
  where: DeclaredUnit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DeclaredUnit_Var_Pop_Fields = {
  __typename?: 'declaredUnit_var_pop_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type DeclaredUnit_Var_Samp_Fields = {
  __typename?: 'declaredUnit_var_samp_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type DeclaredUnit_Variance_Fields = {
  __typename?: 'declaredUnit_variance_fields';
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "denominator_unit" */
export type DenominatorUnit = {
  __typename?: 'denominatorUnit';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  numerator: Unit;
  numeratorUnitId: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
};

/** aggregated selection of "denominator_unit" */
export type DenominatorUnit_Aggregate = {
  __typename?: 'denominatorUnit_aggregate';
  aggregate?: Maybe<DenominatorUnit_Aggregate_Fields>;
  nodes: Array<DenominatorUnit>;
};

/** aggregate fields of "denominator_unit" */
export type DenominatorUnit_Aggregate_Fields = {
  __typename?: 'denominatorUnit_aggregate_fields';
  avg?: Maybe<DenominatorUnit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<DenominatorUnit_Max_Fields>;
  min?: Maybe<DenominatorUnit_Min_Fields>;
  stddev?: Maybe<DenominatorUnit_Stddev_Fields>;
  stddev_pop?: Maybe<DenominatorUnit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DenominatorUnit_Stddev_Samp_Fields>;
  sum?: Maybe<DenominatorUnit_Sum_Fields>;
  var_pop?: Maybe<DenominatorUnit_Var_Pop_Fields>;
  var_samp?: Maybe<DenominatorUnit_Var_Samp_Fields>;
  variance?: Maybe<DenominatorUnit_Variance_Fields>;
};


/** aggregate fields of "denominator_unit" */
export type DenominatorUnit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DenominatorUnit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type DenominatorUnit_Avg_Fields = {
  __typename?: 'denominatorUnit_avg_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numeratorUnitId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "denominator_unit". All fields are combined with a logical 'AND'. */
export type DenominatorUnit_Bool_Exp = {
  _and?: InputMaybe<Array<DenominatorUnit_Bool_Exp>>;
  _not?: InputMaybe<DenominatorUnit_Bool_Exp>;
  _or?: InputMaybe<Array<DenominatorUnit_Bool_Exp>>;
  denominatorUnitId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  numerator?: InputMaybe<Unit_Bool_Exp>;
  numeratorUnitId?: InputMaybe<Int_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "denominator_unit" */
export enum DenominatorUnit_Constraint {
  /** unique or primary key constraint on columns "id" */
  emission_unit_id_key = 'emission_unit_id_key',
  /** unique or primary key constraint on columns "id" */
  emission_unit_pkey = 'emission_unit_pkey'
}

/** input type for incrementing numeric columns in table "denominator_unit" */
export type DenominatorUnit_Inc_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  numeratorUnitId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "denominator_unit" */
export type DenominatorUnit_Insert_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  numerator?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  numeratorUnitId?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type DenominatorUnit_Max_Fields = {
  __typename?: 'denominatorUnit_max_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  numeratorUnitId?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type DenominatorUnit_Min_Fields = {
  __typename?: 'denominatorUnit_min_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  numeratorUnitId?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "denominator_unit" */
export type DenominatorUnit_Mutation_Response = {
  __typename?: 'denominatorUnit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DenominatorUnit>;
};

/** input type for inserting object relation for remote table "denominator_unit" */
export type DenominatorUnit_Obj_Rel_Insert_Input = {
  data: DenominatorUnit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DenominatorUnit_On_Conflict>;
};

/** on_conflict condition type for table "denominator_unit" */
export type DenominatorUnit_On_Conflict = {
  constraint: DenominatorUnit_Constraint;
  update_columns?: Array<DenominatorUnit_Update_Column>;
  where?: InputMaybe<DenominatorUnit_Bool_Exp>;
};

/** Ordering options when selecting data from "denominator_unit". */
export type DenominatorUnit_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  numerator?: InputMaybe<Unit_Order_By>;
  numeratorUnitId?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
};

/** primary key columns input for table: denominator_unit */
export type DenominatorUnit_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "denominator_unit" */
export enum DenominatorUnit_Select_Column {
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  numeratorUnitId = 'numeratorUnitId',
  /** column name */
  unit = 'unit'
}

/** input type for updating data in table "denominator_unit" */
export type DenominatorUnit_Set_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  numeratorUnitId?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type DenominatorUnit_Stddev_Fields = {
  __typename?: 'denominatorUnit_stddev_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numeratorUnitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type DenominatorUnit_Stddev_Pop_Fields = {
  __typename?: 'denominatorUnit_stddev_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numeratorUnitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type DenominatorUnit_Stddev_Samp_Fields = {
  __typename?: 'denominatorUnit_stddev_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numeratorUnitId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "denominatorUnit" */
export type DenominatorUnit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DenominatorUnit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DenominatorUnit_Stream_Cursor_Value_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  numeratorUnitId?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type DenominatorUnit_Sum_Fields = {
  __typename?: 'denominatorUnit_sum_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  numeratorUnitId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "denominator_unit" */
export enum DenominatorUnit_Update_Column {
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  numeratorUnitId = 'numeratorUnitId',
  /** column name */
  unit = 'unit'
}

export type DenominatorUnit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DenominatorUnit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DenominatorUnit_Set_Input>;
  /** filter the rows which have to be updated */
  where: DenominatorUnit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DenominatorUnit_Var_Pop_Fields = {
  __typename?: 'denominatorUnit_var_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numeratorUnitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type DenominatorUnit_Var_Samp_Fields = {
  __typename?: 'denominatorUnit_var_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numeratorUnitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type DenominatorUnit_Variance_Fields = {
  __typename?: 'denominatorUnit_variance_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numeratorUnitId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "distance_unit" */
export type Distance_Unit = {
  __typename?: 'distance_unit';
  value: Scalars['String']['output'];
};

/** aggregated selection of "distance_unit" */
export type Distance_Unit_Aggregate = {
  __typename?: 'distance_unit_aggregate';
  aggregate?: Maybe<Distance_Unit_Aggregate_Fields>;
  nodes: Array<Distance_Unit>;
};

/** aggregate fields of "distance_unit" */
export type Distance_Unit_Aggregate_Fields = {
  __typename?: 'distance_unit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Distance_Unit_Max_Fields>;
  min?: Maybe<Distance_Unit_Min_Fields>;
};


/** aggregate fields of "distance_unit" */
export type Distance_Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Distance_Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "distance_unit". All fields are combined with a logical 'AND'. */
export type Distance_Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Distance_Unit_Bool_Exp>>;
  _not?: InputMaybe<Distance_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Distance_Unit_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "distance_unit" */
export enum Distance_Unit_Constraint {
  /** unique or primary key constraint on columns "value" */
  enum_distance_unit_pkey = 'enum_distance_unit_pkey'
}

export enum Distance_Unit_Enum {
  km = 'km'
}

/** Boolean expression to compare columns of type "distance_unit_enum". All fields are combined with logical 'AND'. */
export type Distance_Unit_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Distance_Unit_Enum>;
  _in?: InputMaybe<Array<Distance_Unit_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Distance_Unit_Enum>;
  _nin?: InputMaybe<Array<Distance_Unit_Enum>>;
};

/** input type for inserting data into table "distance_unit" */
export type Distance_Unit_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Distance_Unit_Max_Fields = {
  __typename?: 'distance_unit_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Distance_Unit_Min_Fields = {
  __typename?: 'distance_unit_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "distance_unit" */
export type Distance_Unit_Mutation_Response = {
  __typename?: 'distance_unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Distance_Unit>;
};

/** on_conflict condition type for table "distance_unit" */
export type Distance_Unit_On_Conflict = {
  constraint: Distance_Unit_Constraint;
  update_columns?: Array<Distance_Unit_Update_Column>;
  where?: InputMaybe<Distance_Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "distance_unit". */
export type Distance_Unit_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: distance_unit */
export type Distance_Unit_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "distance_unit" */
export enum Distance_Unit_Select_Column {
  /** column name */
  value = 'value'
}

/** input type for updating data in table "distance_unit" */
export type Distance_Unit_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "distance_unit" */
export type Distance_Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Distance_Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Distance_Unit_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "distance_unit" */
export enum Distance_Unit_Update_Column {
  /** column name */
  value = 'value'
}

export type Distance_Unit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Distance_Unit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Distance_Unit_Bool_Exp;
};

/** columns and relationships of "emission_factor_source_type" */
export type EmissionFactorSourceType = {
  __typename?: 'emissionFactorSourceType';
  /** An object relationship */
  emissionFactorSource: Emission_Factor_Source;
  emissionFactorSourceId: Scalars['uuid']['output'];
  emissionFactorType: Emission_Factor_Type_Enum;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  installationInputDenominatorUnit?: Maybe<DenominatorUnit>;
  /** An object relationship */
  installationInputIndicatorType?: Maybe<IndicatorType>;
  installationInputIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  /** An object relationship */
  operationalInputDenominatorUnit?: Maybe<DenominatorUnit>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  operationalInputIndicatorType?: Maybe<IndicatorType>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "emission_factor_source_type" */
export type EmissionFactorSourceType_Aggregate = {
  __typename?: 'emissionFactorSourceType_aggregate';
  aggregate?: Maybe<EmissionFactorSourceType_Aggregate_Fields>;
  nodes: Array<EmissionFactorSourceType>;
};

export type EmissionFactorSourceType_Aggregate_Bool_Exp = {
  count?: InputMaybe<EmissionFactorSourceType_Aggregate_Bool_Exp_Count>;
};

export type EmissionFactorSourceType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EmissionFactorSourceType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "emission_factor_source_type" */
export type EmissionFactorSourceType_Aggregate_Fields = {
  __typename?: 'emissionFactorSourceType_aggregate_fields';
  avg?: Maybe<EmissionFactorSourceType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EmissionFactorSourceType_Max_Fields>;
  min?: Maybe<EmissionFactorSourceType_Min_Fields>;
  stddev?: Maybe<EmissionFactorSourceType_Stddev_Fields>;
  stddev_pop?: Maybe<EmissionFactorSourceType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EmissionFactorSourceType_Stddev_Samp_Fields>;
  sum?: Maybe<EmissionFactorSourceType_Sum_Fields>;
  var_pop?: Maybe<EmissionFactorSourceType_Var_Pop_Fields>;
  var_samp?: Maybe<EmissionFactorSourceType_Var_Samp_Fields>;
  variance?: Maybe<EmissionFactorSourceType_Variance_Fields>;
};


/** aggregate fields of "emission_factor_source_type" */
export type EmissionFactorSourceType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EmissionFactorSourceType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Aggregate_Order_By = {
  avg?: InputMaybe<EmissionFactorSourceType_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EmissionFactorSourceType_Max_Order_By>;
  min?: InputMaybe<EmissionFactorSourceType_Min_Order_By>;
  stddev?: InputMaybe<EmissionFactorSourceType_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EmissionFactorSourceType_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EmissionFactorSourceType_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EmissionFactorSourceType_Sum_Order_By>;
  var_pop?: InputMaybe<EmissionFactorSourceType_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EmissionFactorSourceType_Var_Samp_Order_By>;
  variance?: InputMaybe<EmissionFactorSourceType_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "emission_factor_source_type" */
export type EmissionFactorSourceType_Arr_Rel_Insert_Input = {
  data: Array<EmissionFactorSourceType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EmissionFactorSourceType_On_Conflict>;
};

/** aggregate avg on columns */
export type EmissionFactorSourceType_Avg_Fields = {
  __typename?: 'emissionFactorSourceType_avg_fields';
  installationInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Avg_Order_By = {
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "emission_factor_source_type". All fields are combined with a logical 'AND'. */
export type EmissionFactorSourceType_Bool_Exp = {
  _and?: InputMaybe<Array<EmissionFactorSourceType_Bool_Exp>>;
  _not?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
  _or?: InputMaybe<Array<EmissionFactorSourceType_Bool_Exp>>;
  emissionFactorSource?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
  emissionFactorSourceId?: InputMaybe<Uuid_Comparison_Exp>;
  emissionFactorType?: InputMaybe<Emission_Factor_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installationInputDenominatorUnit?: InputMaybe<DenominatorUnit_Bool_Exp>;
  installationInputIndicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  installationInputIndicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
  installationInputdenominatorUnitId?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  operationalInputDenominatorUnit?: InputMaybe<DenominatorUnit_Bool_Exp>;
  operationalInputDenominatorUnitId?: InputMaybe<Int_Comparison_Exp>;
  operationalInputIndicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  operationalInputIndicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "emission_factor_source_type" */
export enum EmissionFactorSourceType_Constraint {
  /** unique or primary key constraint on columns "emission_factor_type", "emission_factor_source_id" */
  emission_factor_source_type_emission_factor_type_emission_facto = 'emission_factor_source_type_emission_factor_type_emission_facto',
  /** unique or primary key constraint on columns "id" */
  emission_factor_source_type_pkey = 'emission_factor_source_type_pkey'
}

/** input type for incrementing numeric columns in table "emission_factor_source_type" */
export type EmissionFactorSourceType_Inc_Input = {
  installationInputIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  installationInputdenominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  operationalInputDenominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  operationalInputIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "emission_factor_source_type" */
export type EmissionFactorSourceType_Insert_Input = {
  emissionFactorSource?: InputMaybe<Emission_Factor_Source_Obj_Rel_Insert_Input>;
  emissionFactorSourceId?: InputMaybe<Scalars['uuid']['input']>;
  emissionFactorType?: InputMaybe<Emission_Factor_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installationInputDenominatorUnit?: InputMaybe<DenominatorUnit_Obj_Rel_Insert_Input>;
  installationInputIndicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  installationInputIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  installationInputdenominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  operationalInputDenominatorUnit?: InputMaybe<DenominatorUnit_Obj_Rel_Insert_Input>;
  operationalInputDenominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  operationalInputIndicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  operationalInputIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type EmissionFactorSourceType_Max_Fields = {
  __typename?: 'emissionFactorSourceType_max_fields';
  emissionFactorSourceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installationInputIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Int']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Max_Order_By = {
  emissionFactorSourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EmissionFactorSourceType_Min_Fields = {
  __typename?: 'emissionFactorSourceType_min_fields';
  emissionFactorSourceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installationInputIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Int']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Min_Order_By = {
  emissionFactorSourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "emission_factor_source_type" */
export type EmissionFactorSourceType_Mutation_Response = {
  __typename?: 'emissionFactorSourceType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmissionFactorSourceType>;
};

/** input type for inserting object relation for remote table "emission_factor_source_type" */
export type EmissionFactorSourceType_Obj_Rel_Insert_Input = {
  data: EmissionFactorSourceType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EmissionFactorSourceType_On_Conflict>;
};

/** on_conflict condition type for table "emission_factor_source_type" */
export type EmissionFactorSourceType_On_Conflict = {
  constraint: EmissionFactorSourceType_Constraint;
  update_columns?: Array<EmissionFactorSourceType_Update_Column>;
  where?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
};

/** Ordering options when selecting data from "emission_factor_source_type". */
export type EmissionFactorSourceType_Order_By = {
  emissionFactorSource?: InputMaybe<Emission_Factor_Source_Order_By>;
  emissionFactorSourceId?: InputMaybe<Order_By>;
  emissionFactorType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installationInputDenominatorUnit?: InputMaybe<DenominatorUnit_Order_By>;
  installationInputIndicatorType?: InputMaybe<IndicatorType_Order_By>;
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  operationalInputDenominatorUnit?: InputMaybe<DenominatorUnit_Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorType?: InputMaybe<IndicatorType_Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: emission_factor_source_type */
export type EmissionFactorSourceType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "emission_factor_source_type" */
export enum EmissionFactorSourceType_Select_Column {
  /** column name */
  emissionFactorSourceId = 'emissionFactorSourceId',
  /** column name */
  emissionFactorType = 'emissionFactorType',
  /** column name */
  id = 'id',
  /** column name */
  installationInputIndicatorTypeId = 'installationInputIndicatorTypeId',
  /** column name */
  installationInputdenominatorUnitId = 'installationInputdenominatorUnitId',
  /** column name */
  label = 'label',
  /** column name */
  operationalInputDenominatorUnitId = 'operationalInputDenominatorUnitId',
  /** column name */
  operationalInputIndicatorTypeId = 'operationalInputIndicatorTypeId'
}

/** input type for updating data in table "emission_factor_source_type" */
export type EmissionFactorSourceType_Set_Input = {
  emissionFactorSourceId?: InputMaybe<Scalars['uuid']['input']>;
  emissionFactorType?: InputMaybe<Emission_Factor_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installationInputIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  installationInputdenominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  operationalInputDenominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  operationalInputIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type EmissionFactorSourceType_Stddev_Fields = {
  __typename?: 'emissionFactorSourceType_stddev_fields';
  installationInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Stddev_Order_By = {
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EmissionFactorSourceType_Stddev_Pop_Fields = {
  __typename?: 'emissionFactorSourceType_stddev_pop_fields';
  installationInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Stddev_Pop_Order_By = {
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EmissionFactorSourceType_Stddev_Samp_Fields = {
  __typename?: 'emissionFactorSourceType_stddev_samp_fields';
  installationInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Stddev_Samp_Order_By = {
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "emissionFactorSourceType" */
export type EmissionFactorSourceType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EmissionFactorSourceType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EmissionFactorSourceType_Stream_Cursor_Value_Input = {
  emissionFactorSourceId?: InputMaybe<Scalars['uuid']['input']>;
  emissionFactorType?: InputMaybe<Emission_Factor_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installationInputIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  installationInputdenominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  operationalInputDenominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  operationalInputIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type EmissionFactorSourceType_Sum_Fields = {
  __typename?: 'emissionFactorSourceType_sum_fields';
  installationInputIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Int']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Int']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Sum_Order_By = {
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "emission_factor_source_type" */
export enum EmissionFactorSourceType_Update_Column {
  /** column name */
  emissionFactorSourceId = 'emissionFactorSourceId',
  /** column name */
  emissionFactorType = 'emissionFactorType',
  /** column name */
  id = 'id',
  /** column name */
  installationInputIndicatorTypeId = 'installationInputIndicatorTypeId',
  /** column name */
  installationInputdenominatorUnitId = 'installationInputdenominatorUnitId',
  /** column name */
  label = 'label',
  /** column name */
  operationalInputDenominatorUnitId = 'operationalInputDenominatorUnitId',
  /** column name */
  operationalInputIndicatorTypeId = 'operationalInputIndicatorTypeId'
}

export type EmissionFactorSourceType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EmissionFactorSourceType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmissionFactorSourceType_Set_Input>;
  /** filter the rows which have to be updated */
  where: EmissionFactorSourceType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EmissionFactorSourceType_Var_Pop_Fields = {
  __typename?: 'emissionFactorSourceType_var_pop_fields';
  installationInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Var_Pop_Order_By = {
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EmissionFactorSourceType_Var_Samp_Fields = {
  __typename?: 'emissionFactorSourceType_var_samp_fields';
  installationInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Var_Samp_Order_By = {
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EmissionFactorSourceType_Variance_Fields = {
  __typename?: 'emissionFactorSourceType_variance_fields';
  installationInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  installationInputdenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputDenominatorUnitId?: Maybe<Scalars['Float']['output']>;
  operationalInputIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "emission_factor_source_type" */
export type EmissionFactorSourceType_Variance_Order_By = {
  installationInputIndicatorTypeId?: InputMaybe<Order_By>;
  installationInputdenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputDenominatorUnitId?: InputMaybe<Order_By>;
  operationalInputIndicatorTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "emission_factor" */
export type Emission_Factor = {
  __typename?: 'emission_factor';
  emission: Scalars['numeric']['output'];
  /** An object relationship */
  emissionFactorSourceType?: Maybe<EmissionFactorSourceType>;
  /** An object relationship */
  emission_factor_source: Emission_Factor_Source;
  emission_factor_source_id: Scalars['uuid']['output'];
  emission_factor_type: Emission_Factor_Type_Enum;
  /** An array relationship */
  fromIndicatorTypeMultiplier: Array<IndicatorTypeMultiplier>;
  /** An aggregate relationship */
  fromIndicatorTypeMultiplier_aggregate: IndicatorTypeMultiplier_Aggregate;
  /** An object relationship */
  indicatorType: IndicatorType;
  indicatorTypeId: Scalars['Int']['output'];
  /** An array relationship */
  toIndicatorTypeMultiplier: Array<IndicatorTypeMultiplier>;
  /** An aggregate relationship */
  toIndicatorTypeMultiplier_aggregate: IndicatorTypeMultiplier_Aggregate;
  year: Scalars['Int']['output'];
};


/** columns and relationships of "emission_factor" */
export type Emission_FactorFromIndicatorTypeMultiplierArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMultiplier_Order_By>>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};


/** columns and relationships of "emission_factor" */
export type Emission_FactorFromIndicatorTypeMultiplier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMultiplier_Order_By>>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};


/** columns and relationships of "emission_factor" */
export type Emission_FactorToIndicatorTypeMultiplierArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMultiplier_Order_By>>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};


/** columns and relationships of "emission_factor" */
export type Emission_FactorToIndicatorTypeMultiplier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMultiplier_Order_By>>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};

/** aggregated selection of "emission_factor" */
export type Emission_Factor_Aggregate = {
  __typename?: 'emission_factor_aggregate';
  aggregate?: Maybe<Emission_Factor_Aggregate_Fields>;
  nodes: Array<Emission_Factor>;
};

export type Emission_Factor_Aggregate_Bool_Exp = {
  count?: InputMaybe<Emission_Factor_Aggregate_Bool_Exp_Count>;
};

export type Emission_Factor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Emission_Factor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emission_Factor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "emission_factor" */
export type Emission_Factor_Aggregate_Fields = {
  __typename?: 'emission_factor_aggregate_fields';
  avg?: Maybe<Emission_Factor_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Emission_Factor_Max_Fields>;
  min?: Maybe<Emission_Factor_Min_Fields>;
  stddev?: Maybe<Emission_Factor_Stddev_Fields>;
  stddev_pop?: Maybe<Emission_Factor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Emission_Factor_Stddev_Samp_Fields>;
  sum?: Maybe<Emission_Factor_Sum_Fields>;
  var_pop?: Maybe<Emission_Factor_Var_Pop_Fields>;
  var_samp?: Maybe<Emission_Factor_Var_Samp_Fields>;
  variance?: Maybe<Emission_Factor_Variance_Fields>;
};


/** aggregate fields of "emission_factor" */
export type Emission_Factor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emission_Factor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "emission_factor" */
export type Emission_Factor_Aggregate_Order_By = {
  avg?: InputMaybe<Emission_Factor_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Emission_Factor_Max_Order_By>;
  min?: InputMaybe<Emission_Factor_Min_Order_By>;
  stddev?: InputMaybe<Emission_Factor_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Emission_Factor_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Emission_Factor_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Emission_Factor_Sum_Order_By>;
  var_pop?: InputMaybe<Emission_Factor_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Emission_Factor_Var_Samp_Order_By>;
  variance?: InputMaybe<Emission_Factor_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "emission_factor" */
export type Emission_Factor_Arr_Rel_Insert_Input = {
  data: Array<Emission_Factor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Emission_Factor_On_Conflict>;
};

/** aggregate avg on columns */
export type Emission_Factor_Avg_Fields = {
  __typename?: 'emission_factor_avg_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "emission_factor" */
export type Emission_Factor_Avg_Order_By = {
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "emission_factor". All fields are combined with a logical 'AND'. */
export type Emission_Factor_Bool_Exp = {
  _and?: InputMaybe<Array<Emission_Factor_Bool_Exp>>;
  _not?: InputMaybe<Emission_Factor_Bool_Exp>;
  _or?: InputMaybe<Array<Emission_Factor_Bool_Exp>>;
  emission?: InputMaybe<Numeric_Comparison_Exp>;
  emissionFactorSourceType?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
  emission_factor_source?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
  emission_factor_source_id?: InputMaybe<Uuid_Comparison_Exp>;
  emission_factor_type?: InputMaybe<Emission_Factor_Type_Enum_Comparison_Exp>;
  fromIndicatorTypeMultiplier?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
  fromIndicatorTypeMultiplier_aggregate?: InputMaybe<IndicatorTypeMultiplier_Aggregate_Bool_Exp>;
  indicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  indicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
  toIndicatorTypeMultiplier?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
  toIndicatorTypeMultiplier_aggregate?: InputMaybe<IndicatorTypeMultiplier_Aggregate_Bool_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "emission_factor" */
export enum Emission_Factor_Constraint {
  /** unique or primary key constraint on columns "emission_factor_type", "emission_factor_source_id", "year" */
  emission_factor_pkey = 'emission_factor_pkey'
}

/** input type for incrementing numeric columns in table "emission_factor" */
export type Emission_Factor_Inc_Input = {
  emission?: InputMaybe<Scalars['numeric']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "emission_factor" */
export type Emission_Factor_Insert_Input = {
  emission?: InputMaybe<Scalars['numeric']['input']>;
  emissionFactorSourceType?: InputMaybe<EmissionFactorSourceType_Obj_Rel_Insert_Input>;
  emission_factor_source?: InputMaybe<Emission_Factor_Source_Obj_Rel_Insert_Input>;
  emission_factor_source_id?: InputMaybe<Scalars['uuid']['input']>;
  emission_factor_type?: InputMaybe<Emission_Factor_Type_Enum>;
  fromIndicatorTypeMultiplier?: InputMaybe<IndicatorTypeMultiplier_Arr_Rel_Insert_Input>;
  indicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  toIndicatorTypeMultiplier?: InputMaybe<IndicatorTypeMultiplier_Arr_Rel_Insert_Input>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Emission_Factor_Max_Fields = {
  __typename?: 'emission_factor_max_fields';
  emission?: Maybe<Scalars['numeric']['output']>;
  emission_factor_source_id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "emission_factor" */
export type Emission_Factor_Max_Order_By = {
  emission?: InputMaybe<Order_By>;
  emission_factor_source_id?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Emission_Factor_Min_Fields = {
  __typename?: 'emission_factor_min_fields';
  emission?: Maybe<Scalars['numeric']['output']>;
  emission_factor_source_id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "emission_factor" */
export type Emission_Factor_Min_Order_By = {
  emission?: InputMaybe<Order_By>;
  emission_factor_source_id?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "emission_factor" */
export type Emission_Factor_Mutation_Response = {
  __typename?: 'emission_factor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Emission_Factor>;
};

/** on_conflict condition type for table "emission_factor" */
export type Emission_Factor_On_Conflict = {
  constraint: Emission_Factor_Constraint;
  update_columns?: Array<Emission_Factor_Update_Column>;
  where?: InputMaybe<Emission_Factor_Bool_Exp>;
};

/** Ordering options when selecting data from "emission_factor". */
export type Emission_Factor_Order_By = {
  emission?: InputMaybe<Order_By>;
  emissionFactorSourceType?: InputMaybe<EmissionFactorSourceType_Order_By>;
  emission_factor_source?: InputMaybe<Emission_Factor_Source_Order_By>;
  emission_factor_source_id?: InputMaybe<Order_By>;
  emission_factor_type?: InputMaybe<Order_By>;
  fromIndicatorTypeMultiplier_aggregate?: InputMaybe<IndicatorTypeMultiplier_Aggregate_Order_By>;
  indicatorType?: InputMaybe<IndicatorType_Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  toIndicatorTypeMultiplier_aggregate?: InputMaybe<IndicatorTypeMultiplier_Aggregate_Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: emission_factor */
export type Emission_Factor_Pk_Columns_Input = {
  emission_factor_source_id: Scalars['uuid']['input'];
  emission_factor_type: Emission_Factor_Type_Enum;
  year: Scalars['Int']['input'];
};

/** select columns of table "emission_factor" */
export enum Emission_Factor_Select_Column {
  /** column name */
  emission = 'emission',
  /** column name */
  emission_factor_source_id = 'emission_factor_source_id',
  /** column name */
  emission_factor_type = 'emission_factor_type',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  year = 'year'
}

/** input type for updating data in table "emission_factor" */
export type Emission_Factor_Set_Input = {
  emission?: InputMaybe<Scalars['numeric']['input']>;
  emission_factor_source_id?: InputMaybe<Scalars['uuid']['input']>;
  emission_factor_type?: InputMaybe<Emission_Factor_Type_Enum>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "emission_factor_source" */
export type Emission_Factor_Source = {
  __typename?: 'emission_factor_source';
  country?: Maybe<Country_Enum>;
  /** An array relationship */
  emissionFactorTypes: Array<EmissionFactorSourceType>;
  /** An aggregate relationship */
  emissionFactorTypes_aggregate: EmissionFactorSourceType_Aggregate;
  /** An array relationship */
  emissionFactors: Array<Emission_Factor>;
  /** An aggregate relationship */
  emissionFactors_aggregate: Emission_Factor_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


/** columns and relationships of "emission_factor_source" */
export type Emission_Factor_SourceEmissionFactorTypesArgs = {
  distinct_on?: InputMaybe<Array<EmissionFactorSourceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmissionFactorSourceType_Order_By>>;
  where?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
};


/** columns and relationships of "emission_factor_source" */
export type Emission_Factor_SourceEmissionFactorTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EmissionFactorSourceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmissionFactorSourceType_Order_By>>;
  where?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
};


/** columns and relationships of "emission_factor_source" */
export type Emission_Factor_SourceEmissionFactorsArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Order_By>>;
  where?: InputMaybe<Emission_Factor_Bool_Exp>;
};


/** columns and relationships of "emission_factor_source" */
export type Emission_Factor_SourceEmissionFactors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Order_By>>;
  where?: InputMaybe<Emission_Factor_Bool_Exp>;
};

/** aggregated selection of "emission_factor_source" */
export type Emission_Factor_Source_Aggregate = {
  __typename?: 'emission_factor_source_aggregate';
  aggregate?: Maybe<Emission_Factor_Source_Aggregate_Fields>;
  nodes: Array<Emission_Factor_Source>;
};

/** aggregate fields of "emission_factor_source" */
export type Emission_Factor_Source_Aggregate_Fields = {
  __typename?: 'emission_factor_source_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Emission_Factor_Source_Max_Fields>;
  min?: Maybe<Emission_Factor_Source_Min_Fields>;
};


/** aggregate fields of "emission_factor_source" */
export type Emission_Factor_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emission_Factor_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "emission_factor_source". All fields are combined with a logical 'AND'. */
export type Emission_Factor_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Emission_Factor_Source_Bool_Exp>>;
  _not?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Emission_Factor_Source_Bool_Exp>>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  emissionFactorTypes?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
  emissionFactorTypes_aggregate?: InputMaybe<EmissionFactorSourceType_Aggregate_Bool_Exp>;
  emissionFactors?: InputMaybe<Emission_Factor_Bool_Exp>;
  emissionFactors_aggregate?: InputMaybe<Emission_Factor_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "emission_factor_source" */
export enum Emission_Factor_Source_Constraint {
  /** unique or primary key constraint on columns "id" */
  emission_factor_source_pkey = 'emission_factor_source_pkey'
}

/** input type for inserting data into table "emission_factor_source" */
export type Emission_Factor_Source_Insert_Input = {
  country?: InputMaybe<Country_Enum>;
  emissionFactorTypes?: InputMaybe<EmissionFactorSourceType_Arr_Rel_Insert_Input>;
  emissionFactors?: InputMaybe<Emission_Factor_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Emission_Factor_Source_Max_Fields = {
  __typename?: 'emission_factor_source_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Emission_Factor_Source_Min_Fields = {
  __typename?: 'emission_factor_source_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "emission_factor_source" */
export type Emission_Factor_Source_Mutation_Response = {
  __typename?: 'emission_factor_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Emission_Factor_Source>;
};

/** input type for inserting object relation for remote table "emission_factor_source" */
export type Emission_Factor_Source_Obj_Rel_Insert_Input = {
  data: Emission_Factor_Source_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Emission_Factor_Source_On_Conflict>;
};

/** on_conflict condition type for table "emission_factor_source" */
export type Emission_Factor_Source_On_Conflict = {
  constraint: Emission_Factor_Source_Constraint;
  update_columns?: Array<Emission_Factor_Source_Update_Column>;
  where?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "emission_factor_source". */
export type Emission_Factor_Source_Order_By = {
  country?: InputMaybe<Order_By>;
  emissionFactorTypes_aggregate?: InputMaybe<EmissionFactorSourceType_Aggregate_Order_By>;
  emissionFactors_aggregate?: InputMaybe<Emission_Factor_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: emission_factor_source */
export type Emission_Factor_Source_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "emission_factor_source" */
export enum Emission_Factor_Source_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  url = 'url'
}

/** input type for updating data in table "emission_factor_source" */
export type Emission_Factor_Source_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "emission_factor_source" */
export type Emission_Factor_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emission_Factor_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emission_Factor_Source_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "emission_factor_source" */
export enum Emission_Factor_Source_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  url = 'url'
}

export type Emission_Factor_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Emission_Factor_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Emission_Factor_Source_Bool_Exp;
};

/** aggregate stddev on columns */
export type Emission_Factor_Stddev_Fields = {
  __typename?: 'emission_factor_stddev_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "emission_factor" */
export type Emission_Factor_Stddev_Order_By = {
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Emission_Factor_Stddev_Pop_Fields = {
  __typename?: 'emission_factor_stddev_pop_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "emission_factor" */
export type Emission_Factor_Stddev_Pop_Order_By = {
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Emission_Factor_Stddev_Samp_Fields = {
  __typename?: 'emission_factor_stddev_samp_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "emission_factor" */
export type Emission_Factor_Stddev_Samp_Order_By = {
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "emission_factor" */
export type Emission_Factor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emission_Factor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emission_Factor_Stream_Cursor_Value_Input = {
  emission?: InputMaybe<Scalars['numeric']['input']>;
  emission_factor_source_id?: InputMaybe<Scalars['uuid']['input']>;
  emission_factor_type?: InputMaybe<Emission_Factor_Type_Enum>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Emission_Factor_Sum_Fields = {
  __typename?: 'emission_factor_sum_fields';
  emission?: Maybe<Scalars['numeric']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "emission_factor" */
export type Emission_Factor_Sum_Order_By = {
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "emission_factor_type" */
export type Emission_Factor_Type = {
  __typename?: 'emission_factor_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "emission_factor_type" */
export type Emission_Factor_Type_Aggregate = {
  __typename?: 'emission_factor_type_aggregate';
  aggregate?: Maybe<Emission_Factor_Type_Aggregate_Fields>;
  nodes: Array<Emission_Factor_Type>;
};

/** aggregate fields of "emission_factor_type" */
export type Emission_Factor_Type_Aggregate_Fields = {
  __typename?: 'emission_factor_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Emission_Factor_Type_Max_Fields>;
  min?: Maybe<Emission_Factor_Type_Min_Fields>;
};


/** aggregate fields of "emission_factor_type" */
export type Emission_Factor_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emission_Factor_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "emission_factor_type". All fields are combined with a logical 'AND'. */
export type Emission_Factor_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Emission_Factor_Type_Bool_Exp>>;
  _not?: InputMaybe<Emission_Factor_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Emission_Factor_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "emission_factor_type" */
export enum Emission_Factor_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  emission_factor_type_pkey = 'emission_factor_type_pkey'
}

export enum Emission_Factor_Type_Enum {
  BIODIESEL = 'BIODIESEL',
  BLACK_OIL = 'BLACK_OIL',
  DIESEL = 'DIESEL',
  DISTRICT_HEATING = 'DISTRICT_HEATING',
  EARTH_MOVED = 'EARTH_MOVED',
  ELECTRICITY = 'ELECTRICITY',
  EXPORTED_ELECTRICITY = 'EXPORTED_ELECTRICITY',
  GAS = 'GAS',
  GASOLINE = 'GASOLINE',
  HEATING = 'HEATING',
  LEGACY = 'LEGACY',
  LINE_GAS = 'LINE_GAS',
  METHANE = 'METHANE',
  WASTAGE = 'WASTAGE'
}

/** Boolean expression to compare columns of type "emission_factor_type_enum". All fields are combined with logical 'AND'. */
export type Emission_Factor_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Emission_Factor_Type_Enum>;
  _in?: InputMaybe<Array<Emission_Factor_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Emission_Factor_Type_Enum>;
  _nin?: InputMaybe<Array<Emission_Factor_Type_Enum>>;
};

/** input type for inserting data into table "emission_factor_type" */
export type Emission_Factor_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Emission_Factor_Type_Max_Fields = {
  __typename?: 'emission_factor_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Emission_Factor_Type_Min_Fields = {
  __typename?: 'emission_factor_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "emission_factor_type" */
export type Emission_Factor_Type_Mutation_Response = {
  __typename?: 'emission_factor_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Emission_Factor_Type>;
};

/** on_conflict condition type for table "emission_factor_type" */
export type Emission_Factor_Type_On_Conflict = {
  constraint: Emission_Factor_Type_Constraint;
  update_columns?: Array<Emission_Factor_Type_Update_Column>;
  where?: InputMaybe<Emission_Factor_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "emission_factor_type". */
export type Emission_Factor_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: emission_factor_type */
export type Emission_Factor_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "emission_factor_type" */
export enum Emission_Factor_Type_Select_Column {
  /** column name */
  value = 'value'
}

/** input type for updating data in table "emission_factor_type" */
export type Emission_Factor_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "emission_factor_type" */
export type Emission_Factor_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emission_Factor_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emission_Factor_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "emission_factor_type" */
export enum Emission_Factor_Type_Update_Column {
  /** column name */
  value = 'value'
}

export type Emission_Factor_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Emission_Factor_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Emission_Factor_Type_Bool_Exp;
};

/** update columns of table "emission_factor" */
export enum Emission_Factor_Update_Column {
  /** column name */
  emission = 'emission',
  /** column name */
  emission_factor_source_id = 'emission_factor_source_id',
  /** column name */
  emission_factor_type = 'emission_factor_type',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  year = 'year'
}

export type Emission_Factor_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Emission_Factor_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Emission_Factor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Emission_Factor_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Emission_Factor_Var_Pop_Fields = {
  __typename?: 'emission_factor_var_pop_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "emission_factor" */
export type Emission_Factor_Var_Pop_Order_By = {
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Emission_Factor_Var_Samp_Fields = {
  __typename?: 'emission_factor_var_samp_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "emission_factor" */
export type Emission_Factor_Var_Samp_Order_By = {
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Emission_Factor_Variance_Fields = {
  __typename?: 'emission_factor_variance_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "emission_factor" */
export type Emission_Factor_Variance_Order_By = {
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "enum_collection_type" */
export type EnumCollectionType = {
  __typename?: 'enumCollectionType';
  description: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_collection_type" */
export type EnumCollectionType_Aggregate = {
  __typename?: 'enumCollectionType_aggregate';
  aggregate?: Maybe<EnumCollectionType_Aggregate_Fields>;
  nodes: Array<EnumCollectionType>;
};

/** aggregate fields of "enum_collection_type" */
export type EnumCollectionType_Aggregate_Fields = {
  __typename?: 'enumCollectionType_aggregate_fields';
  avg?: Maybe<EnumCollectionType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EnumCollectionType_Max_Fields>;
  min?: Maybe<EnumCollectionType_Min_Fields>;
  stddev?: Maybe<EnumCollectionType_Stddev_Fields>;
  stddev_pop?: Maybe<EnumCollectionType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EnumCollectionType_Stddev_Samp_Fields>;
  sum?: Maybe<EnumCollectionType_Sum_Fields>;
  var_pop?: Maybe<EnumCollectionType_Var_Pop_Fields>;
  var_samp?: Maybe<EnumCollectionType_Var_Samp_Fields>;
  variance?: Maybe<EnumCollectionType_Variance_Fields>;
};


/** aggregate fields of "enum_collection_type" */
export type EnumCollectionType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EnumCollectionType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type EnumCollectionType_Avg_Fields = {
  __typename?: 'enumCollectionType_avg_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "enum_collection_type". All fields are combined with a logical 'AND'. */
export type EnumCollectionType_Bool_Exp = {
  _and?: InputMaybe<Array<EnumCollectionType_Bool_Exp>>;
  _not?: InputMaybe<EnumCollectionType_Bool_Exp>;
  _or?: InputMaybe<Array<EnumCollectionType_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_collection_type" */
export enum EnumCollectionType_Constraint {
  /** unique or primary key constraint on columns "value" */
  enum_collection_type_pkey = 'enum_collection_type_pkey'
}

/** input type for incrementing numeric columns in table "enum_collection_type" */
export type EnumCollectionType_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "enum_collection_type" */
export type EnumCollectionType_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EnumCollectionType_Max_Fields = {
  __typename?: 'enumCollectionType_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EnumCollectionType_Min_Fields = {
  __typename?: 'enumCollectionType_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_collection_type" */
export type EnumCollectionType_Mutation_Response = {
  __typename?: 'enumCollectionType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EnumCollectionType>;
};

/** input type for inserting object relation for remote table "enum_collection_type" */
export type EnumCollectionType_Obj_Rel_Insert_Input = {
  data: EnumCollectionType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EnumCollectionType_On_Conflict>;
};

/** on_conflict condition type for table "enum_collection_type" */
export type EnumCollectionType_On_Conflict = {
  constraint: EnumCollectionType_Constraint;
  update_columns?: Array<EnumCollectionType_Update_Column>;
  where?: InputMaybe<EnumCollectionType_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_collection_type". */
export type EnumCollectionType_Order_By = {
  description?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_collection_type */
export type EnumCollectionType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_collection_type" */
export enum EnumCollectionType_Select_Column {
  /** column name */
  description = 'description',
  /** column name */
  sortOrder = 'sortOrder',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "enum_collection_type" */
export type EnumCollectionType_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type EnumCollectionType_Stddev_Fields = {
  __typename?: 'enumCollectionType_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type EnumCollectionType_Stddev_Pop_Fields = {
  __typename?: 'enumCollectionType_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type EnumCollectionType_Stddev_Samp_Fields = {
  __typename?: 'enumCollectionType_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "enumCollectionType" */
export type EnumCollectionType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EnumCollectionType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EnumCollectionType_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type EnumCollectionType_Sum_Fields = {
  __typename?: 'enumCollectionType_sum_fields';
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "enum_collection_type" */
export enum EnumCollectionType_Update_Column {
  /** column name */
  description = 'description',
  /** column name */
  sortOrder = 'sortOrder',
  /** column name */
  value = 'value'
}

export type EnumCollectionType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EnumCollectionType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EnumCollectionType_Set_Input>;
  /** filter the rows which have to be updated */
  where: EnumCollectionType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EnumCollectionType_Var_Pop_Fields = {
  __typename?: 'enumCollectionType_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type EnumCollectionType_Var_Samp_Fields = {
  __typename?: 'enumCollectionType_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EnumCollectionType_Variance_Fields = {
  __typename?: 'enumCollectionType_variance_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "epd_datasource" */
export type EpdDatasource = {
  __typename?: 'epdDatasource';
  /** An array relationship */
  calculationTypes: Array<CalculationTypeEpdDatasource>;
  /** An aggregate relationship */
  calculationTypes_aggregate: CalculationTypeEpdDatasource_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


/** columns and relationships of "epd_datasource" */
export type EpdDatasourceCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeEpdDatasource_Order_By>>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};


/** columns and relationships of "epd_datasource" */
export type EpdDatasourceCalculationTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeEpdDatasource_Order_By>>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};

/** aggregated selection of "epd_datasource" */
export type EpdDatasource_Aggregate = {
  __typename?: 'epdDatasource_aggregate';
  aggregate?: Maybe<EpdDatasource_Aggregate_Fields>;
  nodes: Array<EpdDatasource>;
};

/** aggregate fields of "epd_datasource" */
export type EpdDatasource_Aggregate_Fields = {
  __typename?: 'epdDatasource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<EpdDatasource_Max_Fields>;
  min?: Maybe<EpdDatasource_Min_Fields>;
};


/** aggregate fields of "epd_datasource" */
export type EpdDatasource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EpdDatasource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "epd_datasource". All fields are combined with a logical 'AND'. */
export type EpdDatasource_Bool_Exp = {
  _and?: InputMaybe<Array<EpdDatasource_Bool_Exp>>;
  _not?: InputMaybe<EpdDatasource_Bool_Exp>;
  _or?: InputMaybe<Array<EpdDatasource_Bool_Exp>>;
  calculationTypes?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
  calculationTypes_aggregate?: InputMaybe<CalculationTypeEpdDatasource_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "epd_datasource" */
export enum EpdDatasource_Constraint {
  /** unique or primary key constraint on columns "id" */
  epd_datasource_pkey = 'epd_datasource_pkey'
}

/** input type for inserting data into table "epd_datasource" */
export type EpdDatasource_Insert_Input = {
  calculationTypes?: InputMaybe<CalculationTypeEpdDatasource_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EpdDatasource_Max_Fields = {
  __typename?: 'epdDatasource_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EpdDatasource_Min_Fields = {
  __typename?: 'epdDatasource_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "epd_datasource" */
export type EpdDatasource_Mutation_Response = {
  __typename?: 'epdDatasource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EpdDatasource>;
};

/** input type for inserting object relation for remote table "epd_datasource" */
export type EpdDatasource_Obj_Rel_Insert_Input = {
  data: EpdDatasource_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EpdDatasource_On_Conflict>;
};

/** on_conflict condition type for table "epd_datasource" */
export type EpdDatasource_On_Conflict = {
  constraint: EpdDatasource_Constraint;
  update_columns?: Array<EpdDatasource_Update_Column>;
  where?: InputMaybe<EpdDatasource_Bool_Exp>;
};

/** Ordering options when selecting data from "epd_datasource". */
export type EpdDatasource_Order_By = {
  calculationTypes_aggregate?: InputMaybe<CalculationTypeEpdDatasource_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: epd_datasource */
export type EpdDatasource_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "epd_datasource" */
export enum EpdDatasource_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  url = 'url'
}

/** input type for updating data in table "epd_datasource" */
export type EpdDatasource_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "epdDatasource" */
export type EpdDatasource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EpdDatasource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EpdDatasource_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "epd_datasource" */
export enum EpdDatasource_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  url = 'url'
}

export type EpdDatasource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EpdDatasource_Set_Input>;
  /** filter the rows which have to be updated */
  where: EpdDatasource_Bool_Exp;
};

/** columns and relationships of "epd_owner" */
export type EpdOwner = {
  __typename?: 'epdOwner';
  /** An array relationship */
  aliases: Array<EpdOwnerAlias>;
  /** An aggregate relationship */
  aliases_aggregate: EpdOwnerAlias_Aggregate;
  city?: Maybe<Scalars['String']['output']>;
  cosmosOwnerId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country_Enum>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "epd_owner" */
export type EpdOwnerAliasesArgs = {
  distinct_on?: InputMaybe<Array<EpdOwnerAlias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwnerAlias_Order_By>>;
  where?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
};


/** columns and relationships of "epd_owner" */
export type EpdOwnerAliases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdOwnerAlias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwnerAlias_Order_By>>;
  where?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
};

/** columns and relationships of "epd_owner_alias" */
export type EpdOwnerAlias = {
  __typename?: 'epdOwnerAlias';
  aliasKind: Scalars['String']['output'];
  aliasValue: Scalars['String']['output'];
  confirmedAt?: Maybe<Scalars['timestamptz']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  owner: EpdOwner;
  ownerId: Scalars['uuid']['output'];
};

/** aggregated selection of "epd_owner_alias" */
export type EpdOwnerAlias_Aggregate = {
  __typename?: 'epdOwnerAlias_aggregate';
  aggregate?: Maybe<EpdOwnerAlias_Aggregate_Fields>;
  nodes: Array<EpdOwnerAlias>;
};

export type EpdOwnerAlias_Aggregate_Bool_Exp = {
  count?: InputMaybe<EpdOwnerAlias_Aggregate_Bool_Exp_Count>;
};

export type EpdOwnerAlias_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EpdOwnerAlias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "epd_owner_alias" */
export type EpdOwnerAlias_Aggregate_Fields = {
  __typename?: 'epdOwnerAlias_aggregate_fields';
  avg?: Maybe<EpdOwnerAlias_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EpdOwnerAlias_Max_Fields>;
  min?: Maybe<EpdOwnerAlias_Min_Fields>;
  stddev?: Maybe<EpdOwnerAlias_Stddev_Fields>;
  stddev_pop?: Maybe<EpdOwnerAlias_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EpdOwnerAlias_Stddev_Samp_Fields>;
  sum?: Maybe<EpdOwnerAlias_Sum_Fields>;
  var_pop?: Maybe<EpdOwnerAlias_Var_Pop_Fields>;
  var_samp?: Maybe<EpdOwnerAlias_Var_Samp_Fields>;
  variance?: Maybe<EpdOwnerAlias_Variance_Fields>;
};


/** aggregate fields of "epd_owner_alias" */
export type EpdOwnerAlias_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EpdOwnerAlias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "epd_owner_alias" */
export type EpdOwnerAlias_Aggregate_Order_By = {
  avg?: InputMaybe<EpdOwnerAlias_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EpdOwnerAlias_Max_Order_By>;
  min?: InputMaybe<EpdOwnerAlias_Min_Order_By>;
  stddev?: InputMaybe<EpdOwnerAlias_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EpdOwnerAlias_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EpdOwnerAlias_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EpdOwnerAlias_Sum_Order_By>;
  var_pop?: InputMaybe<EpdOwnerAlias_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EpdOwnerAlias_Var_Samp_Order_By>;
  variance?: InputMaybe<EpdOwnerAlias_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "epd_owner_alias" */
export type EpdOwnerAlias_Arr_Rel_Insert_Input = {
  data: Array<EpdOwnerAlias_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EpdOwnerAlias_On_Conflict>;
};

/** aggregate avg on columns */
export type EpdOwnerAlias_Avg_Fields = {
  __typename?: 'epdOwnerAlias_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "epd_owner_alias". All fields are combined with a logical 'AND'. */
export type EpdOwnerAlias_Bool_Exp = {
  _and?: InputMaybe<Array<EpdOwnerAlias_Bool_Exp>>;
  _not?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
  _or?: InputMaybe<Array<EpdOwnerAlias_Bool_Exp>>;
  aliasKind?: InputMaybe<String_Comparison_Exp>;
  aliasValue?: InputMaybe<String_Comparison_Exp>;
  confirmedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  confirmedBy?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  owner?: InputMaybe<EpdOwner_Bool_Exp>;
  ownerId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "epd_owner_alias" */
export enum EpdOwnerAlias_Constraint {
  /** unique or primary key constraint on columns "alias_value", "alias_kind" */
  epd_owner_alias_kind_value_key = 'epd_owner_alias_kind_value_key',
  /** unique or primary key constraint on columns "id" */
  epd_owner_alias_pkey = 'epd_owner_alias_pkey'
}

/** input type for inserting data into table "epd_owner_alias" */
export type EpdOwnerAlias_Insert_Input = {
  aliasKind?: InputMaybe<Scalars['String']['input']>;
  aliasValue?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  owner?: InputMaybe<EpdOwner_Obj_Rel_Insert_Input>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type EpdOwnerAlias_Max_Fields = {
  __typename?: 'epdOwnerAlias_max_fields';
  aliasKind?: Maybe<Scalars['String']['output']>;
  aliasValue?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['timestamptz']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Max_Order_By = {
  aliasKind?: InputMaybe<Order_By>;
  aliasValue?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  confirmedBy?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ownerId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EpdOwnerAlias_Min_Fields = {
  __typename?: 'epdOwnerAlias_min_fields';
  aliasKind?: Maybe<Scalars['String']['output']>;
  aliasValue?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['timestamptz']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Min_Order_By = {
  aliasKind?: InputMaybe<Order_By>;
  aliasValue?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  confirmedBy?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ownerId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "epd_owner_alias" */
export type EpdOwnerAlias_Mutation_Response = {
  __typename?: 'epdOwnerAlias_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EpdOwnerAlias>;
};

/** on_conflict condition type for table "epd_owner_alias" */
export type EpdOwnerAlias_On_Conflict = {
  constraint: EpdOwnerAlias_Constraint;
  update_columns?: Array<EpdOwnerAlias_Update_Column>;
  where?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
};

/** Ordering options when selecting data from "epd_owner_alias". */
export type EpdOwnerAlias_Order_By = {
  aliasKind?: InputMaybe<Order_By>;
  aliasValue?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  confirmedBy?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<EpdOwner_Order_By>;
  ownerId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: epd_owner_alias */
export type EpdOwnerAlias_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "epd_owner_alias" */
export enum EpdOwnerAlias_Select_Column {
  /** column name */
  aliasKind = 'aliasKind',
  /** column name */
  aliasValue = 'aliasValue',
  /** column name */
  confirmedAt = 'confirmedAt',
  /** column name */
  confirmedBy = 'confirmedBy',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  ownerId = 'ownerId'
}

/** input type for updating data in table "epd_owner_alias" */
export type EpdOwnerAlias_Set_Input = {
  aliasKind?: InputMaybe<Scalars['String']['input']>;
  aliasValue?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type EpdOwnerAlias_Stddev_Fields = {
  __typename?: 'epdOwnerAlias_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EpdOwnerAlias_Stddev_Pop_Fields = {
  __typename?: 'epdOwnerAlias_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EpdOwnerAlias_Stddev_Samp_Fields = {
  __typename?: 'epdOwnerAlias_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "epdOwnerAlias" */
export type EpdOwnerAlias_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EpdOwnerAlias_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EpdOwnerAlias_Stream_Cursor_Value_Input = {
  aliasKind?: InputMaybe<Scalars['String']['input']>;
  aliasValue?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type EpdOwnerAlias_Sum_Fields = {
  __typename?: 'epdOwnerAlias_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "epd_owner_alias" */
export enum EpdOwnerAlias_Update_Column {
  /** column name */
  aliasKind = 'aliasKind',
  /** column name */
  aliasValue = 'aliasValue',
  /** column name */
  confirmedAt = 'confirmedAt',
  /** column name */
  confirmedBy = 'confirmedBy',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  ownerId = 'ownerId'
}

export type EpdOwnerAlias_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EpdOwnerAlias_Set_Input>;
  /** filter the rows which have to be updated */
  where: EpdOwnerAlias_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EpdOwnerAlias_Var_Pop_Fields = {
  __typename?: 'epdOwnerAlias_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EpdOwnerAlias_Var_Samp_Fields = {
  __typename?: 'epdOwnerAlias_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EpdOwnerAlias_Variance_Fields = {
  __typename?: 'epdOwnerAlias_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "epd_owner_alias" */
export type EpdOwnerAlias_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregated selection of "epd_owner" */
export type EpdOwner_Aggregate = {
  __typename?: 'epdOwner_aggregate';
  aggregate?: Maybe<EpdOwner_Aggregate_Fields>;
  nodes: Array<EpdOwner>;
};

/** aggregate fields of "epd_owner" */
export type EpdOwner_Aggregate_Fields = {
  __typename?: 'epdOwner_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<EpdOwner_Max_Fields>;
  min?: Maybe<EpdOwner_Min_Fields>;
};


/** aggregate fields of "epd_owner" */
export type EpdOwner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EpdOwner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "epd_owner". All fields are combined with a logical 'AND'. */
export type EpdOwner_Bool_Exp = {
  _and?: InputMaybe<Array<EpdOwner_Bool_Exp>>;
  _not?: InputMaybe<EpdOwner_Bool_Exp>;
  _or?: InputMaybe<Array<EpdOwner_Bool_Exp>>;
  aliases?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
  aliases_aggregate?: InputMaybe<EpdOwnerAlias_Aggregate_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  cosmosOwnerId?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  streetNumber?: InputMaybe<String_Comparison_Exp>;
  vatNumber?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "epd_owner" */
export enum EpdOwner_Constraint {
  /** unique or primary key constraint on columns "cosmos_owner_id" */
  epd_owner_cosmos_owner_id_key = 'epd_owner_cosmos_owner_id_key',
  /** unique or primary key constraint on columns "id" */
  epd_owner_pkey = 'epd_owner_pkey'
}

/** input type for inserting data into table "epd_owner" */
export type EpdOwner_Insert_Input = {
  aliases?: InputMaybe<EpdOwnerAlias_Arr_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']['input']>;
  cosmosOwnerId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Enum>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EpdOwner_Max_Fields = {
  __typename?: 'epdOwner_max_fields';
  city?: Maybe<Scalars['String']['output']>;
  cosmosOwnerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EpdOwner_Min_Fields = {
  __typename?: 'epdOwner_min_fields';
  city?: Maybe<Scalars['String']['output']>;
  cosmosOwnerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "epd_owner" */
export type EpdOwner_Mutation_Response = {
  __typename?: 'epdOwner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EpdOwner>;
};

/** input type for inserting object relation for remote table "epd_owner" */
export type EpdOwner_Obj_Rel_Insert_Input = {
  data: EpdOwner_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EpdOwner_On_Conflict>;
};

/** on_conflict condition type for table "epd_owner" */
export type EpdOwner_On_Conflict = {
  constraint: EpdOwner_Constraint;
  update_columns?: Array<EpdOwner_Update_Column>;
  where?: InputMaybe<EpdOwner_Bool_Exp>;
};

/** Ordering options when selecting data from "epd_owner". */
export type EpdOwner_Order_By = {
  aliases_aggregate?: InputMaybe<EpdOwnerAlias_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  cosmosOwnerId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  streetNumber?: InputMaybe<Order_By>;
  vatNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: epd_owner */
export type EpdOwner_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "epd_owner" */
export enum EpdOwner_Select_Column {
  /** column name */
  city = 'city',
  /** column name */
  cosmosOwnerId = 'cosmosOwnerId',
  /** column name */
  country = 'country',
  /** column name */
  email = 'email',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  phoneNumber = 'phoneNumber',
  /** column name */
  postalCode = 'postalCode',
  /** column name */
  street = 'street',
  /** column name */
  streetNumber = 'streetNumber',
  /** column name */
  vatNumber = 'vatNumber'
}

/** input type for updating data in table "epd_owner" */
export type EpdOwner_Set_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  cosmosOwnerId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Enum>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "epdOwner" */
export type EpdOwner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EpdOwner_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EpdOwner_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  cosmosOwnerId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Enum>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "epd_owner" */
export enum EpdOwner_Update_Column {
  /** column name */
  city = 'city',
  /** column name */
  cosmosOwnerId = 'cosmosOwnerId',
  /** column name */
  country = 'country',
  /** column name */
  email = 'email',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  phoneNumber = 'phoneNumber',
  /** column name */
  postalCode = 'postalCode',
  /** column name */
  street = 'street',
  /** column name */
  streetNumber = 'streetNumber',
  /** column name */
  vatNumber = 'vatNumber'
}

export type EpdOwner_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EpdOwner_Set_Input>;
  /** filter the rows which have to be updated */
  where: EpdOwner_Bool_Exp;
};

/** columns and relationships of "epd_product_industry" */
export type EpdProductIndustry = {
  __typename?: 'epdProductIndustry';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** aggregated selection of "epd_product_industry" */
export type EpdProductIndustry_Aggregate = {
  __typename?: 'epdProductIndustry_aggregate';
  aggregate?: Maybe<EpdProductIndustry_Aggregate_Fields>;
  nodes: Array<EpdProductIndustry>;
};

/** aggregate fields of "epd_product_industry" */
export type EpdProductIndustry_Aggregate_Fields = {
  __typename?: 'epdProductIndustry_aggregate_fields';
  avg?: Maybe<EpdProductIndustry_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EpdProductIndustry_Max_Fields>;
  min?: Maybe<EpdProductIndustry_Min_Fields>;
  stddev?: Maybe<EpdProductIndustry_Stddev_Fields>;
  stddev_pop?: Maybe<EpdProductIndustry_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EpdProductIndustry_Stddev_Samp_Fields>;
  sum?: Maybe<EpdProductIndustry_Sum_Fields>;
  var_pop?: Maybe<EpdProductIndustry_Var_Pop_Fields>;
  var_samp?: Maybe<EpdProductIndustry_Var_Samp_Fields>;
  variance?: Maybe<EpdProductIndustry_Variance_Fields>;
};


/** aggregate fields of "epd_product_industry" */
export type EpdProductIndustry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EpdProductIndustry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type EpdProductIndustry_Avg_Fields = {
  __typename?: 'epdProductIndustry_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "epd_product_industry". All fields are combined with a logical 'AND'. */
export type EpdProductIndustry_Bool_Exp = {
  _and?: InputMaybe<Array<EpdProductIndustry_Bool_Exp>>;
  _not?: InputMaybe<EpdProductIndustry_Bool_Exp>;
  _or?: InputMaybe<Array<EpdProductIndustry_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "epd_product_industry" */
export enum EpdProductIndustry_Constraint {
  /** unique or primary key constraint on columns "id" */
  epd_product_industry_pkey = 'epd_product_industry_pkey'
}

/** input type for incrementing numeric columns in table "epd_product_industry" */
export type EpdProductIndustry_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "epd_product_industry" */
export type EpdProductIndustry_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EpdProductIndustry_Max_Fields = {
  __typename?: 'epdProductIndustry_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EpdProductIndustry_Min_Fields = {
  __typename?: 'epdProductIndustry_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "epd_product_industry" */
export type EpdProductIndustry_Mutation_Response = {
  __typename?: 'epdProductIndustry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EpdProductIndustry>;
};

/** input type for inserting object relation for remote table "epd_product_industry" */
export type EpdProductIndustry_Obj_Rel_Insert_Input = {
  data: EpdProductIndustry_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EpdProductIndustry_On_Conflict>;
};

/** on_conflict condition type for table "epd_product_industry" */
export type EpdProductIndustry_On_Conflict = {
  constraint: EpdProductIndustry_Constraint;
  update_columns?: Array<EpdProductIndustry_Update_Column>;
  where?: InputMaybe<EpdProductIndustry_Bool_Exp>;
};

/** Ordering options when selecting data from "epd_product_industry". */
export type EpdProductIndustry_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
};

/** primary key columns input for table: epd_product_industry */
export type EpdProductIndustry_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "epd_product_industry" */
export enum EpdProductIndustry_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

/** input type for updating data in table "epd_product_industry" */
export type EpdProductIndustry_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type EpdProductIndustry_Stddev_Fields = {
  __typename?: 'epdProductIndustry_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type EpdProductIndustry_Stddev_Pop_Fields = {
  __typename?: 'epdProductIndustry_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type EpdProductIndustry_Stddev_Samp_Fields = {
  __typename?: 'epdProductIndustry_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "epdProductIndustry" */
export type EpdProductIndustry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EpdProductIndustry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EpdProductIndustry_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type EpdProductIndustry_Sum_Fields = {
  __typename?: 'epdProductIndustry_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "epd_product_industry" */
export enum EpdProductIndustry_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

export type EpdProductIndustry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EpdProductIndustry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EpdProductIndustry_Set_Input>;
  /** filter the rows which have to be updated */
  where: EpdProductIndustry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EpdProductIndustry_Var_Pop_Fields = {
  __typename?: 'epdProductIndustry_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type EpdProductIndustry_Var_Samp_Fields = {
  __typename?: 'epdProductIndustry_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EpdProductIndustry_Variance_Fields = {
  __typename?: 'epdProductIndustry_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "epd_specification_form" */
export type EpdSpecificationForm = {
  __typename?: 'epdSpecificationForm';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** aggregated selection of "epd_specification_form" */
export type EpdSpecificationForm_Aggregate = {
  __typename?: 'epdSpecificationForm_aggregate';
  aggregate?: Maybe<EpdSpecificationForm_Aggregate_Fields>;
  nodes: Array<EpdSpecificationForm>;
};

/** aggregate fields of "epd_specification_form" */
export type EpdSpecificationForm_Aggregate_Fields = {
  __typename?: 'epdSpecificationForm_aggregate_fields';
  avg?: Maybe<EpdSpecificationForm_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EpdSpecificationForm_Max_Fields>;
  min?: Maybe<EpdSpecificationForm_Min_Fields>;
  stddev?: Maybe<EpdSpecificationForm_Stddev_Fields>;
  stddev_pop?: Maybe<EpdSpecificationForm_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EpdSpecificationForm_Stddev_Samp_Fields>;
  sum?: Maybe<EpdSpecificationForm_Sum_Fields>;
  var_pop?: Maybe<EpdSpecificationForm_Var_Pop_Fields>;
  var_samp?: Maybe<EpdSpecificationForm_Var_Samp_Fields>;
  variance?: Maybe<EpdSpecificationForm_Variance_Fields>;
};


/** aggregate fields of "epd_specification_form" */
export type EpdSpecificationForm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EpdSpecificationForm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type EpdSpecificationForm_Avg_Fields = {
  __typename?: 'epdSpecificationForm_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "epd_specification_form". All fields are combined with a logical 'AND'. */
export type EpdSpecificationForm_Bool_Exp = {
  _and?: InputMaybe<Array<EpdSpecificationForm_Bool_Exp>>;
  _not?: InputMaybe<EpdSpecificationForm_Bool_Exp>;
  _or?: InputMaybe<Array<EpdSpecificationForm_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "epd_specification_form" */
export enum EpdSpecificationForm_Constraint {
  /** unique or primary key constraint on columns "id" */
  epd_specification_form_pkey = 'epd_specification_form_pkey'
}

/** input type for incrementing numeric columns in table "epd_specification_form" */
export type EpdSpecificationForm_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "epd_specification_form" */
export type EpdSpecificationForm_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EpdSpecificationForm_Max_Fields = {
  __typename?: 'epdSpecificationForm_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EpdSpecificationForm_Min_Fields = {
  __typename?: 'epdSpecificationForm_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "epd_specification_form" */
export type EpdSpecificationForm_Mutation_Response = {
  __typename?: 'epdSpecificationForm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EpdSpecificationForm>;
};

/** input type for inserting object relation for remote table "epd_specification_form" */
export type EpdSpecificationForm_Obj_Rel_Insert_Input = {
  data: EpdSpecificationForm_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EpdSpecificationForm_On_Conflict>;
};

/** on_conflict condition type for table "epd_specification_form" */
export type EpdSpecificationForm_On_Conflict = {
  constraint: EpdSpecificationForm_Constraint;
  update_columns?: Array<EpdSpecificationForm_Update_Column>;
  where?: InputMaybe<EpdSpecificationForm_Bool_Exp>;
};

/** Ordering options when selecting data from "epd_specification_form". */
export type EpdSpecificationForm_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
};

/** primary key columns input for table: epd_specification_form */
export type EpdSpecificationForm_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "epd_specification_form" */
export enum EpdSpecificationForm_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

/** input type for updating data in table "epd_specification_form" */
export type EpdSpecificationForm_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type EpdSpecificationForm_Stddev_Fields = {
  __typename?: 'epdSpecificationForm_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type EpdSpecificationForm_Stddev_Pop_Fields = {
  __typename?: 'epdSpecificationForm_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type EpdSpecificationForm_Stddev_Samp_Fields = {
  __typename?: 'epdSpecificationForm_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "epdSpecificationForm" */
export type EpdSpecificationForm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EpdSpecificationForm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EpdSpecificationForm_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type EpdSpecificationForm_Sum_Fields = {
  __typename?: 'epdSpecificationForm_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "epd_specification_form" */
export enum EpdSpecificationForm_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

export type EpdSpecificationForm_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EpdSpecificationForm_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EpdSpecificationForm_Set_Input>;
  /** filter the rows which have to be updated */
  where: EpdSpecificationForm_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EpdSpecificationForm_Var_Pop_Fields = {
  __typename?: 'epdSpecificationForm_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type EpdSpecificationForm_Var_Samp_Fields = {
  __typename?: 'epdSpecificationForm_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EpdSpecificationForm_Variance_Fields = {
  __typename?: 'epdSpecificationForm_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "flow_guide" */
export type FlowGuide = {
  __typename?: 'flowGuide';
  /** A computed field, executes function "flow_guide_is_seen" */
  alreadySeen?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  elementId: Scalars['String']['output'];
  /** An array relationship */
  flow_guide_views: Array<FlowGuideViews>;
  /** An aggregate relationship */
  flow_guide_views_aggregate: FlowGuideViews_Aggregate;
  id: Scalars['uuid']['output'];
  priority: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  viewName: Scalars['String']['output'];
};


/** columns and relationships of "flow_guide" */
export type FlowGuideAlreadySeenArgs = {
  args: AlreadySeen_FlowGuide_Args;
};


/** columns and relationships of "flow_guide" */
export type FlowGuideFlow_Guide_ViewsArgs = {
  distinct_on?: InputMaybe<Array<FlowGuideViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuideViews_Order_By>>;
  where?: InputMaybe<FlowGuideViews_Bool_Exp>;
};


/** columns and relationships of "flow_guide" */
export type FlowGuideFlow_Guide_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowGuideViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuideViews_Order_By>>;
  where?: InputMaybe<FlowGuideViews_Bool_Exp>;
};

/** columns and relationships of "flow_guide_views" */
export type FlowGuideViews = {
  __typename?: 'flowGuideViews';
  /** An object relationship */
  flow_guide: FlowGuide;
  guideId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "flow_guide_views" */
export type FlowGuideViews_Aggregate = {
  __typename?: 'flowGuideViews_aggregate';
  aggregate?: Maybe<FlowGuideViews_Aggregate_Fields>;
  nodes: Array<FlowGuideViews>;
};

export type FlowGuideViews_Aggregate_Bool_Exp = {
  count?: InputMaybe<FlowGuideViews_Aggregate_Bool_Exp_Count>;
};

export type FlowGuideViews_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<FlowGuideViews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FlowGuideViews_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "flow_guide_views" */
export type FlowGuideViews_Aggregate_Fields = {
  __typename?: 'flowGuideViews_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<FlowGuideViews_Max_Fields>;
  min?: Maybe<FlowGuideViews_Min_Fields>;
};


/** aggregate fields of "flow_guide_views" */
export type FlowGuideViews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FlowGuideViews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "flow_guide_views" */
export type FlowGuideViews_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<FlowGuideViews_Max_Order_By>;
  min?: InputMaybe<FlowGuideViews_Min_Order_By>;
};

/** input type for inserting array relation for remote table "flow_guide_views" */
export type FlowGuideViews_Arr_Rel_Insert_Input = {
  data: Array<FlowGuideViews_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<FlowGuideViews_On_Conflict>;
};

/** Boolean expression to filter rows from the table "flow_guide_views". All fields are combined with a logical 'AND'. */
export type FlowGuideViews_Bool_Exp = {
  _and?: InputMaybe<Array<FlowGuideViews_Bool_Exp>>;
  _not?: InputMaybe<FlowGuideViews_Bool_Exp>;
  _or?: InputMaybe<Array<FlowGuideViews_Bool_Exp>>;
  flow_guide?: InputMaybe<FlowGuide_Bool_Exp>;
  guideId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "flow_guide_views" */
export enum FlowGuideViews_Constraint {
  /** unique or primary key constraint on columns "user_id", "guide_id" */
  flow_guide_views_guide_id_user_id_key = 'flow_guide_views_guide_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  flow_guide_views_pkey = 'flow_guide_views_pkey'
}

/** input type for inserting data into table "flow_guide_views" */
export type FlowGuideViews_Insert_Input = {
  flow_guide?: InputMaybe<FlowGuide_Obj_Rel_Insert_Input>;
  guideId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type FlowGuideViews_Max_Fields = {
  __typename?: 'flowGuideViews_max_fields';
  guideId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "flow_guide_views" */
export type FlowGuideViews_Max_Order_By = {
  guideId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type FlowGuideViews_Min_Fields = {
  __typename?: 'flowGuideViews_min_fields';
  guideId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "flow_guide_views" */
export type FlowGuideViews_Min_Order_By = {
  guideId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "flow_guide_views" */
export type FlowGuideViews_Mutation_Response = {
  __typename?: 'flowGuideViews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FlowGuideViews>;
};

/** on_conflict condition type for table "flow_guide_views" */
export type FlowGuideViews_On_Conflict = {
  constraint: FlowGuideViews_Constraint;
  update_columns?: Array<FlowGuideViews_Update_Column>;
  where?: InputMaybe<FlowGuideViews_Bool_Exp>;
};

/** Ordering options when selecting data from "flow_guide_views". */
export type FlowGuideViews_Order_By = {
  flow_guide?: InputMaybe<FlowGuide_Order_By>;
  guideId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: flow_guide_views */
export type FlowGuideViews_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "flow_guide_views" */
export enum FlowGuideViews_Select_Column {
  /** column name */
  guideId = 'guideId',
  /** column name */
  id = 'id',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "flow_guide_views" */
export type FlowGuideViews_Set_Input = {
  guideId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "flowGuideViews" */
export type FlowGuideViews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FlowGuideViews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FlowGuideViews_Stream_Cursor_Value_Input = {
  guideId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "flow_guide_views" */
export enum FlowGuideViews_Update_Column {
  /** column name */
  guideId = 'guideId',
  /** column name */
  id = 'id',
  /** column name */
  userId = 'userId'
}

export type FlowGuideViews_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FlowGuideViews_Set_Input>;
  /** filter the rows which have to be updated */
  where: FlowGuideViews_Bool_Exp;
};

/** aggregated selection of "flow_guide" */
export type FlowGuide_Aggregate = {
  __typename?: 'flowGuide_aggregate';
  aggregate?: Maybe<FlowGuide_Aggregate_Fields>;
  nodes: Array<FlowGuide>;
};

/** aggregate fields of "flow_guide" */
export type FlowGuide_Aggregate_Fields = {
  __typename?: 'flowGuide_aggregate_fields';
  avg?: Maybe<FlowGuide_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<FlowGuide_Max_Fields>;
  min?: Maybe<FlowGuide_Min_Fields>;
  stddev?: Maybe<FlowGuide_Stddev_Fields>;
  stddev_pop?: Maybe<FlowGuide_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FlowGuide_Stddev_Samp_Fields>;
  sum?: Maybe<FlowGuide_Sum_Fields>;
  var_pop?: Maybe<FlowGuide_Var_Pop_Fields>;
  var_samp?: Maybe<FlowGuide_Var_Samp_Fields>;
  variance?: Maybe<FlowGuide_Variance_Fields>;
};


/** aggregate fields of "flow_guide" */
export type FlowGuide_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FlowGuide_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type FlowGuide_Avg_Fields = {
  __typename?: 'flowGuide_avg_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "flow_guide". All fields are combined with a logical 'AND'. */
export type FlowGuide_Bool_Exp = {
  _and?: InputMaybe<Array<FlowGuide_Bool_Exp>>;
  _not?: InputMaybe<FlowGuide_Bool_Exp>;
  _or?: InputMaybe<Array<FlowGuide_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  elementId?: InputMaybe<String_Comparison_Exp>;
  flow_guide_views?: InputMaybe<FlowGuideViews_Bool_Exp>;
  flow_guide_views_aggregate?: InputMaybe<FlowGuideViews_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  viewName?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "flow_guide" */
export enum FlowGuide_Constraint {
  /** unique or primary key constraint on columns "id" */
  flow_guide_pkey = 'flow_guide_pkey'
}

/** input type for incrementing numeric columns in table "flow_guide" */
export type FlowGuide_Inc_Input = {
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "flow_guide" */
export type FlowGuide_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  elementId?: InputMaybe<Scalars['String']['input']>;
  flow_guide_views?: InputMaybe<FlowGuideViews_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type FlowGuide_Max_Fields = {
  __typename?: 'flowGuide_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  elementId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  viewName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type FlowGuide_Min_Fields = {
  __typename?: 'flowGuide_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  elementId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  viewName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "flow_guide" */
export type FlowGuide_Mutation_Response = {
  __typename?: 'flowGuide_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FlowGuide>;
};

/** input type for inserting object relation for remote table "flow_guide" */
export type FlowGuide_Obj_Rel_Insert_Input = {
  data: FlowGuide_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FlowGuide_On_Conflict>;
};

/** on_conflict condition type for table "flow_guide" */
export type FlowGuide_On_Conflict = {
  constraint: FlowGuide_Constraint;
  update_columns?: Array<FlowGuide_Update_Column>;
  where?: InputMaybe<FlowGuide_Bool_Exp>;
};

/** Ordering options when selecting data from "flow_guide". */
export type FlowGuide_Order_By = {
  description?: InputMaybe<Order_By>;
  elementId?: InputMaybe<Order_By>;
  flow_guide_views_aggregate?: InputMaybe<FlowGuideViews_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  viewName?: InputMaybe<Order_By>;
};

/** primary key columns input for table: flow_guide */
export type FlowGuide_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "flow_guide" */
export enum FlowGuide_Select_Column {
  /** column name */
  description = 'description',
  /** column name */
  elementId = 'elementId',
  /** column name */
  id = 'id',
  /** column name */
  priority = 'priority',
  /** column name */
  title = 'title',
  /** column name */
  viewName = 'viewName'
}

/** input type for updating data in table "flow_guide" */
export type FlowGuide_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  elementId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type FlowGuide_Stddev_Fields = {
  __typename?: 'flowGuide_stddev_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type FlowGuide_Stddev_Pop_Fields = {
  __typename?: 'flowGuide_stddev_pop_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type FlowGuide_Stddev_Samp_Fields = {
  __typename?: 'flowGuide_stddev_samp_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "flowGuide" */
export type FlowGuide_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FlowGuide_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FlowGuide_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  elementId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type FlowGuide_Sum_Fields = {
  __typename?: 'flowGuide_sum_fields';
  priority?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "flow_guide" */
export enum FlowGuide_Update_Column {
  /** column name */
  description = 'description',
  /** column name */
  elementId = 'elementId',
  /** column name */
  id = 'id',
  /** column name */
  priority = 'priority',
  /** column name */
  title = 'title',
  /** column name */
  viewName = 'viewName'
}

export type FlowGuide_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FlowGuide_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FlowGuide_Set_Input>;
  /** filter the rows which have to be updated */
  where: FlowGuide_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FlowGuide_Var_Pop_Fields = {
  __typename?: 'flowGuide_var_pop_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type FlowGuide_Var_Samp_Fields = {
  __typename?: 'flowGuide_var_samp_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type FlowGuide_Variance_Fields = {
  __typename?: 'flowGuide_variance_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "indicator_source" */
export type IndicatorSource = {
  __typename?: 'indicatorSource';
  value: Scalars['String']['output'];
};

/** aggregated selection of "indicator_source" */
export type IndicatorSource_Aggregate = {
  __typename?: 'indicatorSource_aggregate';
  aggregate?: Maybe<IndicatorSource_Aggregate_Fields>;
  nodes: Array<IndicatorSource>;
};

/** aggregate fields of "indicator_source" */
export type IndicatorSource_Aggregate_Fields = {
  __typename?: 'indicatorSource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<IndicatorSource_Max_Fields>;
  min?: Maybe<IndicatorSource_Min_Fields>;
};


/** aggregate fields of "indicator_source" */
export type IndicatorSource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IndicatorSource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "indicator_source". All fields are combined with a logical 'AND'. */
export type IndicatorSource_Bool_Exp = {
  _and?: InputMaybe<Array<IndicatorSource_Bool_Exp>>;
  _not?: InputMaybe<IndicatorSource_Bool_Exp>;
  _or?: InputMaybe<Array<IndicatorSource_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "indicator_source" */
export enum IndicatorSource_Constraint {
  /** unique or primary key constraint on columns "value" */
  material_source_pkey = 'material_source_pkey'
}

export enum IndicatorSource_Enum {
  EPD = 'EPD',
  STANDARD_VALUES = 'STANDARD_VALUES'
}

/** Boolean expression to compare columns of type "indicatorSource_enum". All fields are combined with logical 'AND'. */
export type IndicatorSource_Enum_Comparison_Exp = {
  _eq?: InputMaybe<IndicatorSource_Enum>;
  _in?: InputMaybe<Array<IndicatorSource_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<IndicatorSource_Enum>;
  _nin?: InputMaybe<Array<IndicatorSource_Enum>>;
};

/** input type for inserting data into table "indicator_source" */
export type IndicatorSource_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type IndicatorSource_Max_Fields = {
  __typename?: 'indicatorSource_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type IndicatorSource_Min_Fields = {
  __typename?: 'indicatorSource_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "indicator_source" */
export type IndicatorSource_Mutation_Response = {
  __typename?: 'indicatorSource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IndicatorSource>;
};

/** on_conflict condition type for table "indicator_source" */
export type IndicatorSource_On_Conflict = {
  constraint: IndicatorSource_Constraint;
  update_columns?: Array<IndicatorSource_Update_Column>;
  where?: InputMaybe<IndicatorSource_Bool_Exp>;
};

/** Ordering options when selecting data from "indicator_source". */
export type IndicatorSource_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: indicator_source */
export type IndicatorSource_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "indicator_source" */
export enum IndicatorSource_Select_Column {
  /** column name */
  value = 'value'
}

/** input type for updating data in table "indicator_source" */
export type IndicatorSource_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "indicatorSource" */
export type IndicatorSource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IndicatorSource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IndicatorSource_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "indicator_source" */
export enum IndicatorSource_Update_Column {
  /** column name */
  value = 'value'
}

export type IndicatorSource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IndicatorSource_Set_Input>;
  /** filter the rows which have to be updated */
  where: IndicatorSource_Bool_Exp;
};

/** columns and relationships of "indicator_type" */
export type IndicatorType = {
  __typename?: 'indicatorType';
  id: Scalars['Int']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  identifier_label?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  indicator_type_mappings: Array<IndicatorTypeMapping>;
  /** An aggregate relationship */
  indicator_type_mappings_aggregate: IndicatorTypeMapping_Aggregate;
  label: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "indicator_type" */
export type IndicatorTypeIndicator_Type_MappingsArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMapping_Order_By>>;
  where?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
};


/** columns and relationships of "indicator_type" */
export type IndicatorTypeIndicator_Type_Mappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMapping_Order_By>>;
  where?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
};

/** columns and relationships of "indicator_type_mapping" */
export type IndicatorTypeMapping = {
  __typename?: 'indicatorTypeMapping';
  /** An array relationship */
  calculationType: Array<CalculationType>;
  /** An aggregate relationship */
  calculationType_aggregate: CalculationType_Aggregate;
  country: Country_Enum;
  /** An object relationship */
  denominatorUnit?: Maybe<DenominatorUnit>;
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indicatorType: IndicatorType;
  indicator_type_id: Scalars['Int']['output'];
};


/** columns and relationships of "indicator_type_mapping" */
export type IndicatorTypeMappingCalculationTypeArgs = {
  distinct_on?: InputMaybe<Array<CalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationType_Order_By>>;
  where?: InputMaybe<CalculationType_Bool_Exp>;
};


/** columns and relationships of "indicator_type_mapping" */
export type IndicatorTypeMappingCalculationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationType_Order_By>>;
  where?: InputMaybe<CalculationType_Bool_Exp>;
};

/** aggregated selection of "indicator_type_mapping" */
export type IndicatorTypeMapping_Aggregate = {
  __typename?: 'indicatorTypeMapping_aggregate';
  aggregate?: Maybe<IndicatorTypeMapping_Aggregate_Fields>;
  nodes: Array<IndicatorTypeMapping>;
};

export type IndicatorTypeMapping_Aggregate_Bool_Exp = {
  count?: InputMaybe<IndicatorTypeMapping_Aggregate_Bool_Exp_Count>;
};

export type IndicatorTypeMapping_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IndicatorTypeMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "indicator_type_mapping" */
export type IndicatorTypeMapping_Aggregate_Fields = {
  __typename?: 'indicatorTypeMapping_aggregate_fields';
  avg?: Maybe<IndicatorTypeMapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<IndicatorTypeMapping_Max_Fields>;
  min?: Maybe<IndicatorTypeMapping_Min_Fields>;
  stddev?: Maybe<IndicatorTypeMapping_Stddev_Fields>;
  stddev_pop?: Maybe<IndicatorTypeMapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<IndicatorTypeMapping_Stddev_Samp_Fields>;
  sum?: Maybe<IndicatorTypeMapping_Sum_Fields>;
  var_pop?: Maybe<IndicatorTypeMapping_Var_Pop_Fields>;
  var_samp?: Maybe<IndicatorTypeMapping_Var_Samp_Fields>;
  variance?: Maybe<IndicatorTypeMapping_Variance_Fields>;
};


/** aggregate fields of "indicator_type_mapping" */
export type IndicatorTypeMapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IndicatorTypeMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Aggregate_Order_By = {
  avg?: InputMaybe<IndicatorTypeMapping_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<IndicatorTypeMapping_Max_Order_By>;
  min?: InputMaybe<IndicatorTypeMapping_Min_Order_By>;
  stddev?: InputMaybe<IndicatorTypeMapping_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IndicatorTypeMapping_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IndicatorTypeMapping_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IndicatorTypeMapping_Sum_Order_By>;
  var_pop?: InputMaybe<IndicatorTypeMapping_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IndicatorTypeMapping_Var_Samp_Order_By>;
  variance?: InputMaybe<IndicatorTypeMapping_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "indicator_type_mapping" */
export type IndicatorTypeMapping_Arr_Rel_Insert_Input = {
  data: Array<IndicatorTypeMapping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IndicatorTypeMapping_On_Conflict>;
};

/** aggregate avg on columns */
export type IndicatorTypeMapping_Avg_Fields = {
  __typename?: 'indicatorTypeMapping_avg_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Avg_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "indicator_type_mapping". All fields are combined with a logical 'AND'. */
export type IndicatorTypeMapping_Bool_Exp = {
  _and?: InputMaybe<Array<IndicatorTypeMapping_Bool_Exp>>;
  _not?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
  _or?: InputMaybe<Array<IndicatorTypeMapping_Bool_Exp>>;
  calculationType?: InputMaybe<CalculationType_Bool_Exp>;
  calculationType_aggregate?: InputMaybe<CalculationType_Aggregate_Bool_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Bool_Exp>;
  denominator_unit_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  indicator_type_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "indicator_type_mapping" */
export enum IndicatorTypeMapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  indicator_type_country_pkey = 'indicator_type_country_pkey'
}

/** input type for incrementing numeric columns in table "indicator_type_mapping" */
export type IndicatorTypeMapping_Inc_Input = {
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "indicator_type_mapping" */
export type IndicatorTypeMapping_Insert_Input = {
  calculationType?: InputMaybe<CalculationType_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Country_Enum>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Obj_Rel_Insert_Input>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type IndicatorTypeMapping_Max_Fields = {
  __typename?: 'indicatorTypeMapping_max_fields';
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicator_type_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Max_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type IndicatorTypeMapping_Min_Fields = {
  __typename?: 'indicatorTypeMapping_min_fields';
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicator_type_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Min_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "indicator_type_mapping" */
export type IndicatorTypeMapping_Mutation_Response = {
  __typename?: 'indicatorTypeMapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IndicatorTypeMapping>;
};

/** input type for inserting object relation for remote table "indicator_type_mapping" */
export type IndicatorTypeMapping_Obj_Rel_Insert_Input = {
  data: IndicatorTypeMapping_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IndicatorTypeMapping_On_Conflict>;
};

/** on_conflict condition type for table "indicator_type_mapping" */
export type IndicatorTypeMapping_On_Conflict = {
  constraint: IndicatorTypeMapping_Constraint;
  update_columns?: Array<IndicatorTypeMapping_Update_Column>;
  where?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
};

/** Ordering options when selecting data from "indicator_type_mapping". */
export type IndicatorTypeMapping_Order_By = {
  calculationType_aggregate?: InputMaybe<CalculationType_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Order_By>;
  denominator_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicatorType?: InputMaybe<IndicatorType_Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: indicator_type_mapping */
export type IndicatorTypeMapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "indicator_type_mapping" */
export enum IndicatorTypeMapping_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  denominator_unit_id = 'denominator_unit_id',
  /** column name */
  id = 'id',
  /** column name */
  indicator_type_id = 'indicator_type_id'
}

/** input type for updating data in table "indicator_type_mapping" */
export type IndicatorTypeMapping_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type IndicatorTypeMapping_Stddev_Fields = {
  __typename?: 'indicatorTypeMapping_stddev_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Stddev_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type IndicatorTypeMapping_Stddev_Pop_Fields = {
  __typename?: 'indicatorTypeMapping_stddev_pop_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Stddev_Pop_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type IndicatorTypeMapping_Stddev_Samp_Fields = {
  __typename?: 'indicatorTypeMapping_stddev_samp_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Stddev_Samp_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "indicatorTypeMapping" */
export type IndicatorTypeMapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IndicatorTypeMapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IndicatorTypeMapping_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type IndicatorTypeMapping_Sum_Fields = {
  __typename?: 'indicatorTypeMapping_sum_fields';
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  indicator_type_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Sum_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "indicator_type_mapping" */
export enum IndicatorTypeMapping_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  denominator_unit_id = 'denominator_unit_id',
  /** column name */
  id = 'id',
  /** column name */
  indicator_type_id = 'indicator_type_id'
}

export type IndicatorTypeMapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IndicatorTypeMapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IndicatorTypeMapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: IndicatorTypeMapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type IndicatorTypeMapping_Var_Pop_Fields = {
  __typename?: 'indicatorTypeMapping_var_pop_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Var_Pop_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type IndicatorTypeMapping_Var_Samp_Fields = {
  __typename?: 'indicatorTypeMapping_var_samp_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Var_Samp_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type IndicatorTypeMapping_Variance_Fields = {
  __typename?: 'indicatorTypeMapping_variance_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "indicator_type_mapping" */
export type IndicatorTypeMapping_Variance_Order_By = {
  denominator_unit_id?: InputMaybe<Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "indicator_type_multiplier" */
export type IndicatorTypeMultiplier = {
  __typename?: 'indicatorTypeMultiplier';
  fromIndicatorTypeId: Scalars['Int']['output'];
  multiplier: Scalars['numeric']['output'];
  toIndicatorTypeId: Scalars['Int']['output'];
};

/** aggregated selection of "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Aggregate = {
  __typename?: 'indicatorTypeMultiplier_aggregate';
  aggregate?: Maybe<IndicatorTypeMultiplier_Aggregate_Fields>;
  nodes: Array<IndicatorTypeMultiplier>;
};

export type IndicatorTypeMultiplier_Aggregate_Bool_Exp = {
  count?: InputMaybe<IndicatorTypeMultiplier_Aggregate_Bool_Exp_Count>;
};

export type IndicatorTypeMultiplier_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Aggregate_Fields = {
  __typename?: 'indicatorTypeMultiplier_aggregate_fields';
  avg?: Maybe<IndicatorTypeMultiplier_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<IndicatorTypeMultiplier_Max_Fields>;
  min?: Maybe<IndicatorTypeMultiplier_Min_Fields>;
  stddev?: Maybe<IndicatorTypeMultiplier_Stddev_Fields>;
  stddev_pop?: Maybe<IndicatorTypeMultiplier_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<IndicatorTypeMultiplier_Stddev_Samp_Fields>;
  sum?: Maybe<IndicatorTypeMultiplier_Sum_Fields>;
  var_pop?: Maybe<IndicatorTypeMultiplier_Var_Pop_Fields>;
  var_samp?: Maybe<IndicatorTypeMultiplier_Var_Samp_Fields>;
  variance?: Maybe<IndicatorTypeMultiplier_Variance_Fields>;
};


/** aggregate fields of "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Aggregate_Order_By = {
  avg?: InputMaybe<IndicatorTypeMultiplier_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<IndicatorTypeMultiplier_Max_Order_By>;
  min?: InputMaybe<IndicatorTypeMultiplier_Min_Order_By>;
  stddev?: InputMaybe<IndicatorTypeMultiplier_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IndicatorTypeMultiplier_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IndicatorTypeMultiplier_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IndicatorTypeMultiplier_Sum_Order_By>;
  var_pop?: InputMaybe<IndicatorTypeMultiplier_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IndicatorTypeMultiplier_Var_Samp_Order_By>;
  variance?: InputMaybe<IndicatorTypeMultiplier_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Arr_Rel_Insert_Input = {
  data: Array<IndicatorTypeMultiplier_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IndicatorTypeMultiplier_On_Conflict>;
};

/** aggregate avg on columns */
export type IndicatorTypeMultiplier_Avg_Fields = {
  __typename?: 'indicatorTypeMultiplier_avg_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Avg_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "indicator_type_multiplier". All fields are combined with a logical 'AND'. */
export type IndicatorTypeMultiplier_Bool_Exp = {
  _and?: InputMaybe<Array<IndicatorTypeMultiplier_Bool_Exp>>;
  _not?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
  _or?: InputMaybe<Array<IndicatorTypeMultiplier_Bool_Exp>>;
  fromIndicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
  multiplier?: InputMaybe<Numeric_Comparison_Exp>;
  toIndicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "indicator_type_multiplier" */
export enum IndicatorTypeMultiplier_Constraint {
  /** unique or primary key constraint on columns "from_indicator_type_id" */
  indicator_type_multiplier_pkey = 'indicator_type_multiplier_pkey'
}

/** input type for incrementing numeric columns in table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Inc_Input = {
  fromIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
  toIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Insert_Input = {
  fromIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
  toIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type IndicatorTypeMultiplier_Max_Fields = {
  __typename?: 'indicatorTypeMultiplier_max_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
  multiplier?: Maybe<Scalars['numeric']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Max_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type IndicatorTypeMultiplier_Min_Fields = {
  __typename?: 'indicatorTypeMultiplier_min_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
  multiplier?: Maybe<Scalars['numeric']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Min_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Mutation_Response = {
  __typename?: 'indicatorTypeMultiplier_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IndicatorTypeMultiplier>;
};

/** on_conflict condition type for table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_On_Conflict = {
  constraint: IndicatorTypeMultiplier_Constraint;
  update_columns?: Array<IndicatorTypeMultiplier_Update_Column>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};

/** Ordering options when selecting data from "indicator_type_multiplier". */
export type IndicatorTypeMultiplier_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: indicator_type_multiplier */
export type IndicatorTypeMultiplier_Pk_Columns_Input = {
  fromIndicatorTypeId: Scalars['Int']['input'];
};

/** select columns of table "indicator_type_multiplier" */
export enum IndicatorTypeMultiplier_Select_Column {
  /** column name */
  fromIndicatorTypeId = 'fromIndicatorTypeId',
  /** column name */
  multiplier = 'multiplier',
  /** column name */
  toIndicatorTypeId = 'toIndicatorTypeId'
}

/** input type for updating data in table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Set_Input = {
  fromIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
  toIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type IndicatorTypeMultiplier_Stddev_Fields = {
  __typename?: 'indicatorTypeMultiplier_stddev_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Stddev_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type IndicatorTypeMultiplier_Stddev_Pop_Fields = {
  __typename?: 'indicatorTypeMultiplier_stddev_pop_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Stddev_Pop_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type IndicatorTypeMultiplier_Stddev_Samp_Fields = {
  __typename?: 'indicatorTypeMultiplier_stddev_samp_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Stddev_Samp_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "indicatorTypeMultiplier" */
export type IndicatorTypeMultiplier_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IndicatorTypeMultiplier_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IndicatorTypeMultiplier_Stream_Cursor_Value_Input = {
  fromIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
  toIndicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type IndicatorTypeMultiplier_Sum_Fields = {
  __typename?: 'indicatorTypeMultiplier_sum_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
  multiplier?: Maybe<Scalars['numeric']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Sum_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "indicator_type_multiplier" */
export enum IndicatorTypeMultiplier_Update_Column {
  /** column name */
  fromIndicatorTypeId = 'fromIndicatorTypeId',
  /** column name */
  multiplier = 'multiplier',
  /** column name */
  toIndicatorTypeId = 'toIndicatorTypeId'
}

export type IndicatorTypeMultiplier_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IndicatorTypeMultiplier_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IndicatorTypeMultiplier_Set_Input>;
  /** filter the rows which have to be updated */
  where: IndicatorTypeMultiplier_Bool_Exp;
};

/** aggregate var_pop on columns */
export type IndicatorTypeMultiplier_Var_Pop_Fields = {
  __typename?: 'indicatorTypeMultiplier_var_pop_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Var_Pop_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type IndicatorTypeMultiplier_Var_Samp_Fields = {
  __typename?: 'indicatorTypeMultiplier_var_samp_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Var_Samp_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type IndicatorTypeMultiplier_Variance_Fields = {
  __typename?: 'indicatorTypeMultiplier_variance_fields';
  fromIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  toIndicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "indicator_type_multiplier" */
export type IndicatorTypeMultiplier_Variance_Order_By = {
  fromIndicatorTypeId?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  toIndicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregated selection of "indicator_type" */
export type IndicatorType_Aggregate = {
  __typename?: 'indicatorType_aggregate';
  aggregate?: Maybe<IndicatorType_Aggregate_Fields>;
  nodes: Array<IndicatorType>;
};

/** aggregate fields of "indicator_type" */
export type IndicatorType_Aggregate_Fields = {
  __typename?: 'indicatorType_aggregate_fields';
  avg?: Maybe<IndicatorType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<IndicatorType_Max_Fields>;
  min?: Maybe<IndicatorType_Min_Fields>;
  stddev?: Maybe<IndicatorType_Stddev_Fields>;
  stddev_pop?: Maybe<IndicatorType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<IndicatorType_Stddev_Samp_Fields>;
  sum?: Maybe<IndicatorType_Sum_Fields>;
  var_pop?: Maybe<IndicatorType_Var_Pop_Fields>;
  var_samp?: Maybe<IndicatorType_Var_Samp_Fields>;
  variance?: Maybe<IndicatorType_Variance_Fields>;
};


/** aggregate fields of "indicator_type" */
export type IndicatorType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IndicatorType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type IndicatorType_Avg_Fields = {
  __typename?: 'indicatorType_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "indicator_type". All fields are combined with a logical 'AND'. */
export type IndicatorType_Bool_Exp = {
  _and?: InputMaybe<Array<IndicatorType_Bool_Exp>>;
  _not?: InputMaybe<IndicatorType_Bool_Exp>;
  _or?: InputMaybe<Array<IndicatorType_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  identifier?: InputMaybe<String_Comparison_Exp>;
  identifier_label?: InputMaybe<String_Comparison_Exp>;
  indicator_type_mappings?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
  indicator_type_mappings_aggregate?: InputMaybe<IndicatorTypeMapping_Aggregate_Bool_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "indicator_type" */
export enum IndicatorType_Constraint {
  /** unique or primary key constraint on columns "id" */
  indicator_type_pkey = 'indicator_type_pkey'
}

/** input type for incrementing numeric columns in table "indicator_type" */
export type IndicatorType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "indicator_type" */
export type IndicatorType_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifier_label?: InputMaybe<Scalars['String']['input']>;
  indicator_type_mappings?: InputMaybe<IndicatorTypeMapping_Arr_Rel_Insert_Input>;
  label?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type IndicatorType_Max_Fields = {
  __typename?: 'indicatorType_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  identifier_label?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type IndicatorType_Min_Fields = {
  __typename?: 'indicatorType_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  identifier_label?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "indicator_type" */
export type IndicatorType_Mutation_Response = {
  __typename?: 'indicatorType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IndicatorType>;
};

/** input type for inserting object relation for remote table "indicator_type" */
export type IndicatorType_Obj_Rel_Insert_Input = {
  data: IndicatorType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IndicatorType_On_Conflict>;
};

/** on_conflict condition type for table "indicator_type" */
export type IndicatorType_On_Conflict = {
  constraint: IndicatorType_Constraint;
  update_columns?: Array<IndicatorType_Update_Column>;
  where?: InputMaybe<IndicatorType_Bool_Exp>;
};

/** Ordering options when selecting data from "indicator_type". */
export type IndicatorType_Order_By = {
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  identifier_label?: InputMaybe<Order_By>;
  indicator_type_mappings_aggregate?: InputMaybe<IndicatorTypeMapping_Aggregate_Order_By>;
  label?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
};

/** primary key columns input for table: indicator_type */
export type IndicatorType_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "indicator_type" */
export enum IndicatorType_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  identifier = 'identifier',
  /** column name */
  identifier_label = 'identifier_label',
  /** column name */
  label = 'label',
  /** column name */
  unit = 'unit'
}

/** input type for updating data in table "indicator_type" */
export type IndicatorType_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifier_label?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type IndicatorType_Stddev_Fields = {
  __typename?: 'indicatorType_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type IndicatorType_Stddev_Pop_Fields = {
  __typename?: 'indicatorType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type IndicatorType_Stddev_Samp_Fields = {
  __typename?: 'indicatorType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "indicatorType" */
export type IndicatorType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IndicatorType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IndicatorType_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifier_label?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type IndicatorType_Sum_Fields = {
  __typename?: 'indicatorType_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "indicator_type" */
export enum IndicatorType_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  identifier = 'identifier',
  /** column name */
  identifier_label = 'identifier_label',
  /** column name */
  label = 'label',
  /** column name */
  unit = 'unit'
}

export type IndicatorType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IndicatorType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IndicatorType_Set_Input>;
  /** filter the rows which have to be updated */
  where: IndicatorType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type IndicatorType_Var_Pop_Fields = {
  __typename?: 'indicatorType_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type IndicatorType_Var_Samp_Fields = {
  __typename?: 'indicatorType_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type IndicatorType_Variance_Fields = {
  __typename?: 'indicatorType_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "installation_standard_value" */
export type Installation_Standard_Value = {
  __typename?: 'installation_standard_value';
  calculation_type_id: Scalars['Int']['output'];
  datasource_id: Scalars['uuid']['output'];
  declaration_number: Scalars['String']['output'];
  denominator_unit_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  material_category: Scalars['String']['output'];
  unit_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  weight: Scalars['numeric']['output'];
};

/** aggregated selection of "installation_standard_value" */
export type Installation_Standard_Value_Aggregate = {
  __typename?: 'installation_standard_value_aggregate';
  aggregate?: Maybe<Installation_Standard_Value_Aggregate_Fields>;
  nodes: Array<Installation_Standard_Value>;
};

/** aggregate fields of "installation_standard_value" */
export type Installation_Standard_Value_Aggregate_Fields = {
  __typename?: 'installation_standard_value_aggregate_fields';
  avg?: Maybe<Installation_Standard_Value_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Installation_Standard_Value_Max_Fields>;
  min?: Maybe<Installation_Standard_Value_Min_Fields>;
  stddev?: Maybe<Installation_Standard_Value_Stddev_Fields>;
  stddev_pop?: Maybe<Installation_Standard_Value_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Installation_Standard_Value_Stddev_Samp_Fields>;
  sum?: Maybe<Installation_Standard_Value_Sum_Fields>;
  var_pop?: Maybe<Installation_Standard_Value_Var_Pop_Fields>;
  var_samp?: Maybe<Installation_Standard_Value_Var_Samp_Fields>;
  variance?: Maybe<Installation_Standard_Value_Variance_Fields>;
};


/** aggregate fields of "installation_standard_value" */
export type Installation_Standard_Value_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Installation_Standard_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Installation_Standard_Value_Avg_Fields = {
  __typename?: 'installation_standard_value_avg_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  unit_id?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "installation_standard_value". All fields are combined with a logical 'AND'. */
export type Installation_Standard_Value_Bool_Exp = {
  _and?: InputMaybe<Array<Installation_Standard_Value_Bool_Exp>>;
  _not?: InputMaybe<Installation_Standard_Value_Bool_Exp>;
  _or?: InputMaybe<Array<Installation_Standard_Value_Bool_Exp>>;
  calculation_type_id?: InputMaybe<Int_Comparison_Exp>;
  datasource_id?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_number?: InputMaybe<String_Comparison_Exp>;
  denominator_unit_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  material_category?: InputMaybe<String_Comparison_Exp>;
  unit_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight?: InputMaybe<Numeric_Comparison_Exp>;
};

/** columns and relationships of "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type = {
  __typename?: 'installation_standard_value_building_type';
  building_type_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  installation_standard_value_id: Scalars['uuid']['output'];
};

/** aggregated selection of "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type_Aggregate = {
  __typename?: 'installation_standard_value_building_type_aggregate';
  aggregate?: Maybe<Installation_Standard_Value_Building_Type_Aggregate_Fields>;
  nodes: Array<Installation_Standard_Value_Building_Type>;
};

/** aggregate fields of "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type_Aggregate_Fields = {
  __typename?: 'installation_standard_value_building_type_aggregate_fields';
  avg?: Maybe<Installation_Standard_Value_Building_Type_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Installation_Standard_Value_Building_Type_Max_Fields>;
  min?: Maybe<Installation_Standard_Value_Building_Type_Min_Fields>;
  stddev?: Maybe<Installation_Standard_Value_Building_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Installation_Standard_Value_Building_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Installation_Standard_Value_Building_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Installation_Standard_Value_Building_Type_Sum_Fields>;
  var_pop?: Maybe<Installation_Standard_Value_Building_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Installation_Standard_Value_Building_Type_Var_Samp_Fields>;
  variance?: Maybe<Installation_Standard_Value_Building_Type_Variance_Fields>;
};


/** aggregate fields of "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Installation_Standard_Value_Building_Type_Avg_Fields = {
  __typename?: 'installation_standard_value_building_type_avg_fields';
  building_type_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "installation_standard_value_building_type". All fields are combined with a logical 'AND'. */
export type Installation_Standard_Value_Building_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Bool_Exp>>;
  _not?: InputMaybe<Installation_Standard_Value_Building_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Bool_Exp>>;
  building_type_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installation_standard_value_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "installation_standard_value_building_type" */
export enum Installation_Standard_Value_Building_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  installation_standard_value_building_type_pkey = 'installation_standard_value_building_type_pkey'
}

/** input type for incrementing numeric columns in table "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type_Inc_Input = {
  building_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type_Insert_Input = {
  building_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_standard_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Installation_Standard_Value_Building_Type_Max_Fields = {
  __typename?: 'installation_standard_value_building_type_max_fields';
  building_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installation_standard_value_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Installation_Standard_Value_Building_Type_Min_Fields = {
  __typename?: 'installation_standard_value_building_type_min_fields';
  building_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installation_standard_value_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type_Mutation_Response = {
  __typename?: 'installation_standard_value_building_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Installation_Standard_Value_Building_Type>;
};

/** on_conflict condition type for table "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type_On_Conflict = {
  constraint: Installation_Standard_Value_Building_Type_Constraint;
  update_columns?: Array<Installation_Standard_Value_Building_Type_Update_Column>;
  where?: InputMaybe<Installation_Standard_Value_Building_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "installation_standard_value_building_type". */
export type Installation_Standard_Value_Building_Type_Order_By = {
  building_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation_standard_value_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: installation_standard_value_building_type */
export type Installation_Standard_Value_Building_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "installation_standard_value_building_type" */
export enum Installation_Standard_Value_Building_Type_Select_Column {
  /** column name */
  building_type_id = 'building_type_id',
  /** column name */
  id = 'id',
  /** column name */
  installation_standard_value_id = 'installation_standard_value_id'
}

/** input type for updating data in table "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type_Set_Input = {
  building_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_standard_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Installation_Standard_Value_Building_Type_Stddev_Fields = {
  __typename?: 'installation_standard_value_building_type_stddev_fields';
  building_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Installation_Standard_Value_Building_Type_Stddev_Pop_Fields = {
  __typename?: 'installation_standard_value_building_type_stddev_pop_fields';
  building_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Installation_Standard_Value_Building_Type_Stddev_Samp_Fields = {
  __typename?: 'installation_standard_value_building_type_stddev_samp_fields';
  building_type_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "installation_standard_value_building_type" */
export type Installation_Standard_Value_Building_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Installation_Standard_Value_Building_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Installation_Standard_Value_Building_Type_Stream_Cursor_Value_Input = {
  building_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_standard_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Installation_Standard_Value_Building_Type_Sum_Fields = {
  __typename?: 'installation_standard_value_building_type_sum_fields';
  building_type_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "installation_standard_value_building_type" */
export enum Installation_Standard_Value_Building_Type_Update_Column {
  /** column name */
  building_type_id = 'building_type_id',
  /** column name */
  id = 'id',
  /** column name */
  installation_standard_value_id = 'installation_standard_value_id'
}

export type Installation_Standard_Value_Building_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Installation_Standard_Value_Building_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Installation_Standard_Value_Building_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Installation_Standard_Value_Building_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Installation_Standard_Value_Building_Type_Var_Pop_Fields = {
  __typename?: 'installation_standard_value_building_type_var_pop_fields';
  building_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Installation_Standard_Value_Building_Type_Var_Samp_Fields = {
  __typename?: 'installation_standard_value_building_type_var_samp_fields';
  building_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Installation_Standard_Value_Building_Type_Variance_Fields = {
  __typename?: 'installation_standard_value_building_type_variance_fields';
  building_type_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type = {
  __typename?: 'installation_standard_value_classification_type';
  classification_code_id: Scalars['Int']['output'];
  classification_type_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  installation_standard_value_id: Scalars['uuid']['output'];
};

/** aggregated selection of "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type_Aggregate = {
  __typename?: 'installation_standard_value_classification_type_aggregate';
  aggregate?: Maybe<Installation_Standard_Value_Classification_Type_Aggregate_Fields>;
  nodes: Array<Installation_Standard_Value_Classification_Type>;
};

/** aggregate fields of "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type_Aggregate_Fields = {
  __typename?: 'installation_standard_value_classification_type_aggregate_fields';
  avg?: Maybe<Installation_Standard_Value_Classification_Type_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Installation_Standard_Value_Classification_Type_Max_Fields>;
  min?: Maybe<Installation_Standard_Value_Classification_Type_Min_Fields>;
  stddev?: Maybe<Installation_Standard_Value_Classification_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Installation_Standard_Value_Classification_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Installation_Standard_Value_Classification_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Installation_Standard_Value_Classification_Type_Sum_Fields>;
  var_pop?: Maybe<Installation_Standard_Value_Classification_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Installation_Standard_Value_Classification_Type_Var_Samp_Fields>;
  variance?: Maybe<Installation_Standard_Value_Classification_Type_Variance_Fields>;
};


/** aggregate fields of "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Installation_Standard_Value_Classification_Type_Avg_Fields = {
  __typename?: 'installation_standard_value_classification_type_avg_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "installation_standard_value_classification_type". All fields are combined with a logical 'AND'. */
export type Installation_Standard_Value_Classification_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Bool_Exp>>;
  _not?: InputMaybe<Installation_Standard_Value_Classification_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Bool_Exp>>;
  classification_code_id?: InputMaybe<Int_Comparison_Exp>;
  classification_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installation_standard_value_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "installation_standard_value_classification_type" */
export enum Installation_Standard_Value_Classification_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  installation_standard_value_classification_type_pkey = 'installation_standard_value_classification_type_pkey'
}

/** input type for incrementing numeric columns in table "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type_Inc_Input = {
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type_Insert_Input = {
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  classification_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_standard_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Installation_Standard_Value_Classification_Type_Max_Fields = {
  __typename?: 'installation_standard_value_classification_type_max_fields';
  classification_code_id?: Maybe<Scalars['Int']['output']>;
  classification_type_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installation_standard_value_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Installation_Standard_Value_Classification_Type_Min_Fields = {
  __typename?: 'installation_standard_value_classification_type_min_fields';
  classification_code_id?: Maybe<Scalars['Int']['output']>;
  classification_type_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installation_standard_value_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type_Mutation_Response = {
  __typename?: 'installation_standard_value_classification_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Installation_Standard_Value_Classification_Type>;
};

/** on_conflict condition type for table "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type_On_Conflict = {
  constraint: Installation_Standard_Value_Classification_Type_Constraint;
  update_columns?: Array<Installation_Standard_Value_Classification_Type_Update_Column>;
  where?: InputMaybe<Installation_Standard_Value_Classification_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "installation_standard_value_classification_type". */
export type Installation_Standard_Value_Classification_Type_Order_By = {
  classification_code_id?: InputMaybe<Order_By>;
  classification_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation_standard_value_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: installation_standard_value_classification_type */
export type Installation_Standard_Value_Classification_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "installation_standard_value_classification_type" */
export enum Installation_Standard_Value_Classification_Type_Select_Column {
  /** column name */
  classification_code_id = 'classification_code_id',
  /** column name */
  classification_type_id = 'classification_type_id',
  /** column name */
  id = 'id',
  /** column name */
  installation_standard_value_id = 'installation_standard_value_id'
}

/** input type for updating data in table "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type_Set_Input = {
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  classification_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_standard_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Installation_Standard_Value_Classification_Type_Stddev_Fields = {
  __typename?: 'installation_standard_value_classification_type_stddev_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Installation_Standard_Value_Classification_Type_Stddev_Pop_Fields = {
  __typename?: 'installation_standard_value_classification_type_stddev_pop_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Installation_Standard_Value_Classification_Type_Stddev_Samp_Fields = {
  __typename?: 'installation_standard_value_classification_type_stddev_samp_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "installation_standard_value_classification_type" */
export type Installation_Standard_Value_Classification_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Installation_Standard_Value_Classification_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Installation_Standard_Value_Classification_Type_Stream_Cursor_Value_Input = {
  classification_code_id?: InputMaybe<Scalars['Int']['input']>;
  classification_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_standard_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Installation_Standard_Value_Classification_Type_Sum_Fields = {
  __typename?: 'installation_standard_value_classification_type_sum_fields';
  classification_code_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "installation_standard_value_classification_type" */
export enum Installation_Standard_Value_Classification_Type_Update_Column {
  /** column name */
  classification_code_id = 'classification_code_id',
  /** column name */
  classification_type_id = 'classification_type_id',
  /** column name */
  id = 'id',
  /** column name */
  installation_standard_value_id = 'installation_standard_value_id'
}

export type Installation_Standard_Value_Classification_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Installation_Standard_Value_Classification_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Installation_Standard_Value_Classification_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Installation_Standard_Value_Classification_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Installation_Standard_Value_Classification_Type_Var_Pop_Fields = {
  __typename?: 'installation_standard_value_classification_type_var_pop_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Installation_Standard_Value_Classification_Type_Var_Samp_Fields = {
  __typename?: 'installation_standard_value_classification_type_var_samp_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Installation_Standard_Value_Classification_Type_Variance_Fields = {
  __typename?: 'installation_standard_value_classification_type_variance_fields';
  classification_code_id?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "installation_standard_value" */
export enum Installation_Standard_Value_Constraint {
  /** unique or primary key constraint on columns "id" */
  installation_standard_value_pkey = 'installation_standard_value_pkey'
}

/** columns and relationships of "installation_standard_value_datasource" */
export type Installation_Standard_Value_Datasource = {
  __typename?: 'installation_standard_value_datasource';
  country: Country_Enum;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

/** aggregated selection of "installation_standard_value_datasource" */
export type Installation_Standard_Value_Datasource_Aggregate = {
  __typename?: 'installation_standard_value_datasource_aggregate';
  aggregate?: Maybe<Installation_Standard_Value_Datasource_Aggregate_Fields>;
  nodes: Array<Installation_Standard_Value_Datasource>;
};

/** aggregate fields of "installation_standard_value_datasource" */
export type Installation_Standard_Value_Datasource_Aggregate_Fields = {
  __typename?: 'installation_standard_value_datasource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Installation_Standard_Value_Datasource_Max_Fields>;
  min?: Maybe<Installation_Standard_Value_Datasource_Min_Fields>;
};


/** aggregate fields of "installation_standard_value_datasource" */
export type Installation_Standard_Value_Datasource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Installation_Standard_Value_Datasource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "installation_standard_value_datasource". All fields are combined with a logical 'AND'. */
export type Installation_Standard_Value_Datasource_Bool_Exp = {
  _and?: InputMaybe<Array<Installation_Standard_Value_Datasource_Bool_Exp>>;
  _not?: InputMaybe<Installation_Standard_Value_Datasource_Bool_Exp>;
  _or?: InputMaybe<Array<Installation_Standard_Value_Datasource_Bool_Exp>>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "installation_standard_value_datasource" */
export enum Installation_Standard_Value_Datasource_Constraint {
  /** unique or primary key constraint on columns "id" */
  installation_standard_value_datasource_pkey = 'installation_standard_value_datasource_pkey'
}

/** input type for inserting data into table "installation_standard_value_datasource" */
export type Installation_Standard_Value_Datasource_Insert_Input = {
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Installation_Standard_Value_Datasource_Max_Fields = {
  __typename?: 'installation_standard_value_datasource_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Installation_Standard_Value_Datasource_Min_Fields = {
  __typename?: 'installation_standard_value_datasource_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "installation_standard_value_datasource" */
export type Installation_Standard_Value_Datasource_Mutation_Response = {
  __typename?: 'installation_standard_value_datasource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Installation_Standard_Value_Datasource>;
};

/** on_conflict condition type for table "installation_standard_value_datasource" */
export type Installation_Standard_Value_Datasource_On_Conflict = {
  constraint: Installation_Standard_Value_Datasource_Constraint;
  update_columns?: Array<Installation_Standard_Value_Datasource_Update_Column>;
  where?: InputMaybe<Installation_Standard_Value_Datasource_Bool_Exp>;
};

/** Ordering options when selecting data from "installation_standard_value_datasource". */
export type Installation_Standard_Value_Datasource_Order_By = {
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
};

/** primary key columns input for table: installation_standard_value_datasource */
export type Installation_Standard_Value_Datasource_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "installation_standard_value_datasource" */
export enum Installation_Standard_Value_Datasource_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  link = 'link'
}

/** input type for updating data in table "installation_standard_value_datasource" */
export type Installation_Standard_Value_Datasource_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "installation_standard_value_datasource" */
export type Installation_Standard_Value_Datasource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Installation_Standard_Value_Datasource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Installation_Standard_Value_Datasource_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "installation_standard_value_datasource" */
export enum Installation_Standard_Value_Datasource_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  link = 'link'
}

export type Installation_Standard_Value_Datasource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Installation_Standard_Value_Datasource_Set_Input>;
  /** filter the rows which have to be updated */
  where: Installation_Standard_Value_Datasource_Bool_Exp;
};

/** columns and relationships of "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission = {
  __typename?: 'installation_standard_value_emission';
  emission: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  installation_standard_value_id: Scalars['uuid']['output'];
  stage_id: Scalars['Int']['output'];
};

/** aggregated selection of "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission_Aggregate = {
  __typename?: 'installation_standard_value_emission_aggregate';
  aggregate?: Maybe<Installation_Standard_Value_Emission_Aggregate_Fields>;
  nodes: Array<Installation_Standard_Value_Emission>;
};

/** aggregate fields of "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission_Aggregate_Fields = {
  __typename?: 'installation_standard_value_emission_aggregate_fields';
  avg?: Maybe<Installation_Standard_Value_Emission_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Installation_Standard_Value_Emission_Max_Fields>;
  min?: Maybe<Installation_Standard_Value_Emission_Min_Fields>;
  stddev?: Maybe<Installation_Standard_Value_Emission_Stddev_Fields>;
  stddev_pop?: Maybe<Installation_Standard_Value_Emission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Installation_Standard_Value_Emission_Stddev_Samp_Fields>;
  sum?: Maybe<Installation_Standard_Value_Emission_Sum_Fields>;
  var_pop?: Maybe<Installation_Standard_Value_Emission_Var_Pop_Fields>;
  var_samp?: Maybe<Installation_Standard_Value_Emission_Var_Samp_Fields>;
  variance?: Maybe<Installation_Standard_Value_Emission_Variance_Fields>;
};


/** aggregate fields of "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Installation_Standard_Value_Emission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Installation_Standard_Value_Emission_Avg_Fields = {
  __typename?: 'installation_standard_value_emission_avg_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  stage_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "installation_standard_value_emission". All fields are combined with a logical 'AND'. */
export type Installation_Standard_Value_Emission_Bool_Exp = {
  _and?: InputMaybe<Array<Installation_Standard_Value_Emission_Bool_Exp>>;
  _not?: InputMaybe<Installation_Standard_Value_Emission_Bool_Exp>;
  _or?: InputMaybe<Array<Installation_Standard_Value_Emission_Bool_Exp>>;
  emission?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installation_standard_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  stage_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "installation_standard_value_emission" */
export enum Installation_Standard_Value_Emission_Constraint {
  /** unique or primary key constraint on columns "id" */
  installation_standard_value_emission_pkey = 'installation_standard_value_emission_pkey'
}

/** input type for incrementing numeric columns in table "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission_Inc_Input = {
  emission?: InputMaybe<Scalars['numeric']['input']>;
  stage_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission_Insert_Input = {
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_standard_value_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Installation_Standard_Value_Emission_Max_Fields = {
  __typename?: 'installation_standard_value_emission_max_fields';
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installation_standard_value_id?: Maybe<Scalars['uuid']['output']>;
  stage_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Installation_Standard_Value_Emission_Min_Fields = {
  __typename?: 'installation_standard_value_emission_min_fields';
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installation_standard_value_id?: Maybe<Scalars['uuid']['output']>;
  stage_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission_Mutation_Response = {
  __typename?: 'installation_standard_value_emission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Installation_Standard_Value_Emission>;
};

/** on_conflict condition type for table "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission_On_Conflict = {
  constraint: Installation_Standard_Value_Emission_Constraint;
  update_columns?: Array<Installation_Standard_Value_Emission_Update_Column>;
  where?: InputMaybe<Installation_Standard_Value_Emission_Bool_Exp>;
};

/** Ordering options when selecting data from "installation_standard_value_emission". */
export type Installation_Standard_Value_Emission_Order_By = {
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation_standard_value_id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: installation_standard_value_emission */
export type Installation_Standard_Value_Emission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "installation_standard_value_emission" */
export enum Installation_Standard_Value_Emission_Select_Column {
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  installation_standard_value_id = 'installation_standard_value_id',
  /** column name */
  stage_id = 'stage_id'
}

/** input type for updating data in table "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission_Set_Input = {
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_standard_value_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Installation_Standard_Value_Emission_Stddev_Fields = {
  __typename?: 'installation_standard_value_emission_stddev_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  stage_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Installation_Standard_Value_Emission_Stddev_Pop_Fields = {
  __typename?: 'installation_standard_value_emission_stddev_pop_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  stage_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Installation_Standard_Value_Emission_Stddev_Samp_Fields = {
  __typename?: 'installation_standard_value_emission_stddev_samp_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  stage_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "installation_standard_value_emission" */
export type Installation_Standard_Value_Emission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Installation_Standard_Value_Emission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Installation_Standard_Value_Emission_Stream_Cursor_Value_Input = {
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_standard_value_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Installation_Standard_Value_Emission_Sum_Fields = {
  __typename?: 'installation_standard_value_emission_sum_fields';
  emission?: Maybe<Scalars['numeric']['output']>;
  stage_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "installation_standard_value_emission" */
export enum Installation_Standard_Value_Emission_Update_Column {
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  installation_standard_value_id = 'installation_standard_value_id',
  /** column name */
  stage_id = 'stage_id'
}

export type Installation_Standard_Value_Emission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Installation_Standard_Value_Emission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Installation_Standard_Value_Emission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Installation_Standard_Value_Emission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Installation_Standard_Value_Emission_Var_Pop_Fields = {
  __typename?: 'installation_standard_value_emission_var_pop_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  stage_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Installation_Standard_Value_Emission_Var_Samp_Fields = {
  __typename?: 'installation_standard_value_emission_var_samp_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  stage_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Installation_Standard_Value_Emission_Variance_Fields = {
  __typename?: 'installation_standard_value_emission_variance_fields';
  emission?: Maybe<Scalars['Float']['output']>;
  stage_id?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "installation_standard_value" */
export type Installation_Standard_Value_Inc_Input = {
  calculation_type_id?: InputMaybe<Scalars['Int']['input']>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  unit_id?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "installation_standard_value" */
export type Installation_Standard_Value_Insert_Input = {
  calculation_type_id?: InputMaybe<Scalars['Int']['input']>;
  datasource_id?: InputMaybe<Scalars['uuid']['input']>;
  declaration_number?: InputMaybe<Scalars['String']['input']>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  material_category?: InputMaybe<Scalars['String']['input']>;
  unit_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Installation_Standard_Value_Max_Fields = {
  __typename?: 'installation_standard_value_max_fields';
  calculation_type_id?: Maybe<Scalars['Int']['output']>;
  datasource_id?: Maybe<Scalars['uuid']['output']>;
  declaration_number?: Maybe<Scalars['String']['output']>;
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  material_category?: Maybe<Scalars['String']['output']>;
  unit_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Installation_Standard_Value_Min_Fields = {
  __typename?: 'installation_standard_value_min_fields';
  calculation_type_id?: Maybe<Scalars['Int']['output']>;
  datasource_id?: Maybe<Scalars['uuid']['output']>;
  declaration_number?: Maybe<Scalars['String']['output']>;
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  material_category?: Maybe<Scalars['String']['output']>;
  unit_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "installation_standard_value" */
export type Installation_Standard_Value_Mutation_Response = {
  __typename?: 'installation_standard_value_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Installation_Standard_Value>;
};

/** on_conflict condition type for table "installation_standard_value" */
export type Installation_Standard_Value_On_Conflict = {
  constraint: Installation_Standard_Value_Constraint;
  update_columns?: Array<Installation_Standard_Value_Update_Column>;
  where?: InputMaybe<Installation_Standard_Value_Bool_Exp>;
};

/** Ordering options when selecting data from "installation_standard_value". */
export type Installation_Standard_Value_Order_By = {
  calculation_type_id?: InputMaybe<Order_By>;
  datasource_id?: InputMaybe<Order_By>;
  declaration_number?: InputMaybe<Order_By>;
  denominator_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  material_category?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: installation_standard_value */
export type Installation_Standard_Value_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "installation_standard_value" */
export enum Installation_Standard_Value_Select_Column {
  /** column name */
  calculation_type_id = 'calculation_type_id',
  /** column name */
  datasource_id = 'datasource_id',
  /** column name */
  declaration_number = 'declaration_number',
  /** column name */
  denominator_unit_id = 'denominator_unit_id',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  material_category = 'material_category',
  /** column name */
  unit_id = 'unit_id',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  weight = 'weight'
}

/** input type for updating data in table "installation_standard_value" */
export type Installation_Standard_Value_Set_Input = {
  calculation_type_id?: InputMaybe<Scalars['Int']['input']>;
  datasource_id?: InputMaybe<Scalars['uuid']['input']>;
  declaration_number?: InputMaybe<Scalars['String']['input']>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  material_category?: InputMaybe<Scalars['String']['input']>;
  unit_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Installation_Standard_Value_Stddev_Fields = {
  __typename?: 'installation_standard_value_stddev_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  unit_id?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Installation_Standard_Value_Stddev_Pop_Fields = {
  __typename?: 'installation_standard_value_stddev_pop_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  unit_id?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Installation_Standard_Value_Stddev_Samp_Fields = {
  __typename?: 'installation_standard_value_stddev_samp_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  unit_id?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "installation_standard_value" */
export type Installation_Standard_Value_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Installation_Standard_Value_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Installation_Standard_Value_Stream_Cursor_Value_Input = {
  calculation_type_id?: InputMaybe<Scalars['Int']['input']>;
  datasource_id?: InputMaybe<Scalars['uuid']['input']>;
  declaration_number?: InputMaybe<Scalars['String']['input']>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  material_category?: InputMaybe<Scalars['String']['input']>;
  unit_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Installation_Standard_Value_Sum_Fields = {
  __typename?: 'installation_standard_value_sum_fields';
  calculation_type_id?: Maybe<Scalars['Int']['output']>;
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  unit_id?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "installation_standard_value" */
export enum Installation_Standard_Value_Update_Column {
  /** column name */
  calculation_type_id = 'calculation_type_id',
  /** column name */
  datasource_id = 'datasource_id',
  /** column name */
  declaration_number = 'declaration_number',
  /** column name */
  denominator_unit_id = 'denominator_unit_id',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  material_category = 'material_category',
  /** column name */
  unit_id = 'unit_id',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  weight = 'weight'
}

export type Installation_Standard_Value_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Installation_Standard_Value_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Installation_Standard_Value_Set_Input>;
  /** filter the rows which have to be updated */
  where: Installation_Standard_Value_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Installation_Standard_Value_Var_Pop_Fields = {
  __typename?: 'installation_standard_value_var_pop_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  unit_id?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Installation_Standard_Value_Var_Samp_Fields = {
  __typename?: 'installation_standard_value_var_samp_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  unit_id?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Installation_Standard_Value_Variance_Fields = {
  __typename?: 'installation_standard_value_variance_fields';
  calculation_type_id?: Maybe<Scalars['Float']['output']>;
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  unit_id?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the jsonpath return any item for the specified JSON value */
  _jsonb_path_exists?: InputMaybe<Scalars['String']['input']>;
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonb_path_match?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "language" */
export type Language = {
  __typename?: 'language';
  code: Scalars['String']['output'];
  country?: Maybe<Country_Enum>;
};

/** aggregated selection of "language" */
export type Language_Aggregate = {
  __typename?: 'language_aggregate';
  aggregate?: Maybe<Language_Aggregate_Fields>;
  nodes: Array<Language>;
};

/** aggregate fields of "language" */
export type Language_Aggregate_Fields = {
  __typename?: 'language_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Language_Max_Fields>;
  min?: Maybe<Language_Min_Fields>;
};


/** aggregate fields of "language" */
export type Language_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Language_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "language". All fields are combined with a logical 'AND'. */
export type Language_Bool_Exp = {
  _and?: InputMaybe<Array<Language_Bool_Exp>>;
  _not?: InputMaybe<Language_Bool_Exp>;
  _or?: InputMaybe<Array<Language_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "language" */
export enum Language_Constraint {
  /** unique or primary key constraint on columns "code" */
  language_pkey = 'language_pkey'
}

/** input type for inserting data into table "language" */
export type Language_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Enum>;
};

/** aggregate max on columns */
export type Language_Max_Fields = {
  __typename?: 'language_max_fields';
  code?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Language_Min_Fields = {
  __typename?: 'language_min_fields';
  code?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "language" */
export type Language_Mutation_Response = {
  __typename?: 'language_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Language>;
};

/** input type for inserting object relation for remote table "language" */
export type Language_Obj_Rel_Insert_Input = {
  data: Language_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Language_On_Conflict>;
};

/** on_conflict condition type for table "language" */
export type Language_On_Conflict = {
  constraint: Language_Constraint;
  update_columns?: Array<Language_Update_Column>;
  where?: InputMaybe<Language_Bool_Exp>;
};

/** Ordering options when selecting data from "language". */
export type Language_Order_By = {
  code?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
};

/** primary key columns input for table: language */
export type Language_Pk_Columns_Input = {
  code: Scalars['String']['input'];
};

/** select columns of table "language" */
export enum Language_Select_Column {
  /** column name */
  code = 'code',
  /** column name */
  country = 'country'
}

/** input type for updating data in table "language" */
export type Language_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Enum>;
};

/** Streaming cursor of the table "language" */
export type Language_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Language_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Language_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Enum>;
};

/** update columns of table "language" */
export enum Language_Update_Column {
  /** column name */
  code = 'code',
  /** column name */
  country = 'country'
}

export type Language_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Language_Set_Input>;
  /** filter the rows which have to be updated */
  where: Language_Bool_Exp;
};

/** columns and relationships of "lifetime_table" */
export type Lifetime_Table = {
  __typename?: 'lifetime_table';
  body: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

/** aggregated selection of "lifetime_table" */
export type Lifetime_Table_Aggregate = {
  __typename?: 'lifetime_table_aggregate';
  aggregate?: Maybe<Lifetime_Table_Aggregate_Fields>;
  nodes: Array<Lifetime_Table>;
};

/** aggregate fields of "lifetime_table" */
export type Lifetime_Table_Aggregate_Fields = {
  __typename?: 'lifetime_table_aggregate_fields';
  avg?: Maybe<Lifetime_Table_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lifetime_Table_Max_Fields>;
  min?: Maybe<Lifetime_Table_Min_Fields>;
  stddev?: Maybe<Lifetime_Table_Stddev_Fields>;
  stddev_pop?: Maybe<Lifetime_Table_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lifetime_Table_Stddev_Samp_Fields>;
  sum?: Maybe<Lifetime_Table_Sum_Fields>;
  var_pop?: Maybe<Lifetime_Table_Var_Pop_Fields>;
  var_samp?: Maybe<Lifetime_Table_Var_Samp_Fields>;
  variance?: Maybe<Lifetime_Table_Variance_Fields>;
};


/** aggregate fields of "lifetime_table" */
export type Lifetime_Table_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lifetime_Table_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Lifetime_Table_Avg_Fields = {
  __typename?: 'lifetime_table_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "lifetime_table". All fields are combined with a logical 'AND'. */
export type Lifetime_Table_Bool_Exp = {
  _and?: InputMaybe<Array<Lifetime_Table_Bool_Exp>>;
  _not?: InputMaybe<Lifetime_Table_Bool_Exp>;
  _or?: InputMaybe<Array<Lifetime_Table_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "lifetime_table" */
export enum Lifetime_Table_Constraint {
  /** unique or primary key constraint on columns "id" */
  lifetime_table_pkey2 = 'lifetime_table_pkey2'
}

/** input type for incrementing numeric columns in table "lifetime_table" */
export type Lifetime_Table_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "lifetime_table" */
export type Lifetime_Table_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Lifetime_Table_Max_Fields = {
  __typename?: 'lifetime_table_max_fields';
  body?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Lifetime_Table_Min_Fields = {
  __typename?: 'lifetime_table_min_fields';
  body?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "lifetime_table" */
export type Lifetime_Table_Mutation_Response = {
  __typename?: 'lifetime_table_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lifetime_Table>;
};

/** on_conflict condition type for table "lifetime_table" */
export type Lifetime_Table_On_Conflict = {
  constraint: Lifetime_Table_Constraint;
  update_columns?: Array<Lifetime_Table_Update_Column>;
  where?: InputMaybe<Lifetime_Table_Bool_Exp>;
};

/** Ordering options when selecting data from "lifetime_table". */
export type Lifetime_Table_Order_By = {
  body?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lifetime_table */
export type Lifetime_Table_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "lifetime_table" */
export enum Lifetime_Table_Select_Column {
  /** column name */
  body = 'body',
  /** column name */
  id = 'id'
}

/** input type for updating data in table "lifetime_table" */
export type Lifetime_Table_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Lifetime_Table_Stddev_Fields = {
  __typename?: 'lifetime_table_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Lifetime_Table_Stddev_Pop_Fields = {
  __typename?: 'lifetime_table_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Lifetime_Table_Stddev_Samp_Fields = {
  __typename?: 'lifetime_table_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "lifetime_table" */
export type Lifetime_Table_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lifetime_Table_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lifetime_Table_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Lifetime_Table_Sum_Fields = {
  __typename?: 'lifetime_table_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "lifetime_table" */
export enum Lifetime_Table_Update_Column {
  /** column name */
  body = 'body',
  /** column name */
  id = 'id'
}

export type Lifetime_Table_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lifetime_Table_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lifetime_Table_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lifetime_Table_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lifetime_Table_Var_Pop_Fields = {
  __typename?: 'lifetime_table_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Lifetime_Table_Var_Samp_Fields = {
  __typename?: 'lifetime_table_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Lifetime_Table_Variance_Fields = {
  __typename?: 'lifetime_table_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mapping_history" */
export type MappingHistory = {
  __typename?: 'mappingHistory';
  /** An object relationship */
  classificationCode?: Maybe<ClassificationCode>;
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialId: Scalars['uuid']['output'];
  materialIdentifier?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['uuid']['output'];
  quantity?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  quantityUnit?: Maybe<Unit>;
  quantityUnitId?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
  typeIdentifier?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "mapping_history_frequency" */
export type MappingHistoryFrequency = {
  __typename?: 'mappingHistoryFrequency';
  count?: Maybe<Scalars['bigint']['output']>;
  lastMappedAt?: Maybe<Scalars['timestamp']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  mostRecentLifetime?: Maybe<MappingHistoryMostRecentLifetime>;
  /** An object relationship */
  mostUsedLifetime?: Maybe<Mapping_History_Most_Used_Lifetime>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "mapping_history_frequency" */
export type MappingHistoryFrequency_Aggregate = {
  __typename?: 'mappingHistoryFrequency_aggregate';
  aggregate?: Maybe<MappingHistoryFrequency_Aggregate_Fields>;
  nodes: Array<MappingHistoryFrequency>;
};

/** aggregate fields of "mapping_history_frequency" */
export type MappingHistoryFrequency_Aggregate_Fields = {
  __typename?: 'mappingHistoryFrequency_aggregate_fields';
  avg?: Maybe<MappingHistoryFrequency_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MappingHistoryFrequency_Max_Fields>;
  min?: Maybe<MappingHistoryFrequency_Min_Fields>;
  stddev?: Maybe<MappingHistoryFrequency_Stddev_Fields>;
  stddev_pop?: Maybe<MappingHistoryFrequency_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MappingHistoryFrequency_Stddev_Samp_Fields>;
  sum?: Maybe<MappingHistoryFrequency_Sum_Fields>;
  var_pop?: Maybe<MappingHistoryFrequency_Var_Pop_Fields>;
  var_samp?: Maybe<MappingHistoryFrequency_Var_Samp_Fields>;
  variance?: Maybe<MappingHistoryFrequency_Variance_Fields>;
};


/** aggregate fields of "mapping_history_frequency" */
export type MappingHistoryFrequency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MappingHistoryFrequency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type MappingHistoryFrequency_Avg_Fields = {
  __typename?: 'mappingHistoryFrequency_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mapping_history_frequency". All fields are combined with a logical 'AND'. */
export type MappingHistoryFrequency_Bool_Exp = {
  _and?: InputMaybe<Array<MappingHistoryFrequency_Bool_Exp>>;
  _not?: InputMaybe<MappingHistoryFrequency_Bool_Exp>;
  _or?: InputMaybe<Array<MappingHistoryFrequency_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  lastMappedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  mostRecentLifetime?: InputMaybe<MappingHistoryMostRecentLifetime_Bool_Exp>;
  mostUsedLifetime?: InputMaybe<Mapping_History_Most_Used_Lifetime_Bool_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  typeMaterialIdentifier?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type MappingHistoryFrequency_Max_Fields = {
  __typename?: 'mappingHistoryFrequency_max_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  lastMappedAt?: Maybe<Scalars['timestamp']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MappingHistoryFrequency_Min_Fields = {
  __typename?: 'mappingHistoryFrequency_min_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  lastMappedAt?: Maybe<Scalars['timestamp']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mapping_history_frequency". */
export type MappingHistoryFrequency_Order_By = {
  count?: InputMaybe<Order_By>;
  lastMappedAt?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  mostRecentLifetime?: InputMaybe<MappingHistoryMostRecentLifetime_Order_By>;
  mostUsedLifetime?: InputMaybe<Mapping_History_Most_Used_Lifetime_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  typeMaterialIdentifier?: InputMaybe<Order_By>;
};

/** select columns of table "mapping_history_frequency" */
export enum MappingHistoryFrequency_Select_Column {
  /** column name */
  count = 'count',
  /** column name */
  lastMappedAt = 'lastMappedAt',
  /** column name */
  materialId = 'materialId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  typeMaterialIdentifier = 'typeMaterialIdentifier'
}

/** aggregate stddev on columns */
export type MappingHistoryFrequency_Stddev_Fields = {
  __typename?: 'mappingHistoryFrequency_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type MappingHistoryFrequency_Stddev_Pop_Fields = {
  __typename?: 'mappingHistoryFrequency_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type MappingHistoryFrequency_Stddev_Samp_Fields = {
  __typename?: 'mappingHistoryFrequency_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mappingHistoryFrequency" */
export type MappingHistoryFrequency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MappingHistoryFrequency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MappingHistoryFrequency_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  lastMappedAt?: InputMaybe<Scalars['timestamp']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MappingHistoryFrequency_Sum_Fields = {
  __typename?: 'mappingHistoryFrequency_sum_fields';
  count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type MappingHistoryFrequency_Var_Pop_Fields = {
  __typename?: 'mappingHistoryFrequency_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type MappingHistoryFrequency_Var_Samp_Fields = {
  __typename?: 'mappingHistoryFrequency_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type MappingHistoryFrequency_Variance_Fields = {
  __typename?: 'mappingHistoryFrequency_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mapping_history_most_recent_lifetime" */
export type MappingHistoryMostRecentLifetime = {
  __typename?: 'mappingHistoryMostRecentLifetime';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "mapping_history_most_recent_lifetime" */
export type MappingHistoryMostRecentLifetime_Aggregate = {
  __typename?: 'mappingHistoryMostRecentLifetime_aggregate';
  aggregate?: Maybe<MappingHistoryMostRecentLifetime_Aggregate_Fields>;
  nodes: Array<MappingHistoryMostRecentLifetime>;
};

/** aggregate fields of "mapping_history_most_recent_lifetime" */
export type MappingHistoryMostRecentLifetime_Aggregate_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_aggregate_fields';
  avg?: Maybe<MappingHistoryMostRecentLifetime_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MappingHistoryMostRecentLifetime_Max_Fields>;
  min?: Maybe<MappingHistoryMostRecentLifetime_Min_Fields>;
  stddev?: Maybe<MappingHistoryMostRecentLifetime_Stddev_Fields>;
  stddev_pop?: Maybe<MappingHistoryMostRecentLifetime_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MappingHistoryMostRecentLifetime_Stddev_Samp_Fields>;
  sum?: Maybe<MappingHistoryMostRecentLifetime_Sum_Fields>;
  var_pop?: Maybe<MappingHistoryMostRecentLifetime_Var_Pop_Fields>;
  var_samp?: Maybe<MappingHistoryMostRecentLifetime_Var_Samp_Fields>;
  variance?: Maybe<MappingHistoryMostRecentLifetime_Variance_Fields>;
};


/** aggregate fields of "mapping_history_most_recent_lifetime" */
export type MappingHistoryMostRecentLifetime_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type MappingHistoryMostRecentLifetime_Avg_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_avg_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mapping_history_most_recent_lifetime". All fields are combined with a logical 'AND'. */
export type MappingHistoryMostRecentLifetime_Bool_Exp = {
  _and?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Bool_Exp>>;
  _not?: InputMaybe<MappingHistoryMostRecentLifetime_Bool_Exp>;
  _or?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  lifetime?: InputMaybe<Int_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  typeMaterialIdentifier?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type MappingHistoryMostRecentLifetime_Max_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MappingHistoryMostRecentLifetime_Min_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mapping_history_most_recent_lifetime". */
export type MappingHistoryMostRecentLifetime_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  typeMaterialIdentifier?: InputMaybe<Order_By>;
};

/** select columns of table "mapping_history_most_recent_lifetime" */
export enum MappingHistoryMostRecentLifetime_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  materialId = 'materialId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  typeMaterialIdentifier = 'typeMaterialIdentifier'
}

/** aggregate stddev on columns */
export type MappingHistoryMostRecentLifetime_Stddev_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_stddev_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type MappingHistoryMostRecentLifetime_Stddev_Pop_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_stddev_pop_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type MappingHistoryMostRecentLifetime_Stddev_Samp_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_stddev_samp_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mappingHistoryMostRecentLifetime" */
export type MappingHistoryMostRecentLifetime_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MappingHistoryMostRecentLifetime_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MappingHistoryMostRecentLifetime_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MappingHistoryMostRecentLifetime_Sum_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_sum_fields';
  lifetime?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type MappingHistoryMostRecentLifetime_Var_Pop_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_var_pop_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type MappingHistoryMostRecentLifetime_Var_Samp_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_var_samp_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type MappingHistoryMostRecentLifetime_Variance_Fields = {
  __typename?: 'mappingHistoryMostRecentLifetime_variance_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "mapping_history" */
export type MappingHistory_Aggregate = {
  __typename?: 'mappingHistory_aggregate';
  aggregate?: Maybe<MappingHistory_Aggregate_Fields>;
  nodes: Array<MappingHistory>;
};

/** aggregate fields of "mapping_history" */
export type MappingHistory_Aggregate_Fields = {
  __typename?: 'mappingHistory_aggregate_fields';
  avg?: Maybe<MappingHistory_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MappingHistory_Max_Fields>;
  min?: Maybe<MappingHistory_Min_Fields>;
  stddev?: Maybe<MappingHistory_Stddev_Fields>;
  stddev_pop?: Maybe<MappingHistory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MappingHistory_Stddev_Samp_Fields>;
  sum?: Maybe<MappingHistory_Sum_Fields>;
  var_pop?: Maybe<MappingHistory_Var_Pop_Fields>;
  var_samp?: Maybe<MappingHistory_Var_Samp_Fields>;
  variance?: Maybe<MappingHistory_Variance_Fields>;
};


/** aggregate fields of "mapping_history" */
export type MappingHistory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MappingHistory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type MappingHistory_Avg_Fields = {
  __typename?: 'mappingHistory_avg_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityUnitId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mapping_history". All fields are combined with a logical 'AND'. */
export type MappingHistory_Bool_Exp = {
  _and?: InputMaybe<Array<MappingHistory_Bool_Exp>>;
  _not?: InputMaybe<MappingHistory_Bool_Exp>;
  _or?: InputMaybe<Array<MappingHistory_Bool_Exp>>;
  classificationCode?: InputMaybe<ClassificationCode_Bool_Exp>;
  classificationCodeId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lifetime?: InputMaybe<Int_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  materialIdentifier?: InputMaybe<String_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  quantityUnit?: InputMaybe<Unit_Bool_Exp>;
  quantityUnitId?: InputMaybe<Int_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  typeIdentifier?: InputMaybe<String_Comparison_Exp>;
  typeMaterialIdentifier?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mapping_history" */
export enum MappingHistory_Constraint {
  /** unique or primary key constraint on columns "id" */
  mapping_history_pkey = 'mapping_history_pkey'
}

/** input type for incrementing numeric columns in table "mapping_history" */
export type MappingHistory_Inc_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantityUnitId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mapping_history" */
export type MappingHistory_Insert_Input = {
  classificationCode?: InputMaybe<ClassificationCode_Obj_Rel_Insert_Input>;
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialIdentifier?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantityUnit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  quantityUnitId?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MappingHistory_Max_Fields = {
  __typename?: 'mappingHistory_max_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialIdentifier?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantityUnitId?: Maybe<Scalars['Int']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MappingHistory_Min_Fields = {
  __typename?: 'mappingHistory_min_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialIdentifier?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantityUnitId?: Maybe<Scalars['Int']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mapping_history" */
export type MappingHistory_Mutation_Response = {
  __typename?: 'mappingHistory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MappingHistory>;
};

/** on_conflict condition type for table "mapping_history" */
export type MappingHistory_On_Conflict = {
  constraint: MappingHistory_Constraint;
  update_columns?: Array<MappingHistory_Update_Column>;
  where?: InputMaybe<MappingHistory_Bool_Exp>;
};

/** Ordering options when selecting data from "mapping_history". */
export type MappingHistory_Order_By = {
  classificationCode?: InputMaybe<ClassificationCode_Order_By>;
  classificationCodeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  materialIdentifier?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantityUnit?: InputMaybe<Unit_Order_By>;
  quantityUnitId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  typeIdentifier?: InputMaybe<Order_By>;
  typeMaterialIdentifier?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mapping_history */
export type MappingHistory_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mapping_history" */
export enum MappingHistory_Select_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  materialId = 'materialId',
  /** column name */
  materialIdentifier = 'materialIdentifier',
  /** column name */
  projectId = 'projectId',
  /** column name */
  quantity = 'quantity',
  /** column name */
  quantityUnitId = 'quantityUnitId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  typeIdentifier = 'typeIdentifier',
  /** column name */
  typeMaterialIdentifier = 'typeMaterialIdentifier',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "mapping_history" */
export type MappingHistory_Set_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialIdentifier?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantityUnitId?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MappingHistory_Stddev_Fields = {
  __typename?: 'mappingHistory_stddev_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityUnitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type MappingHistory_Stddev_Pop_Fields = {
  __typename?: 'mappingHistory_stddev_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityUnitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type MappingHistory_Stddev_Samp_Fields = {
  __typename?: 'mappingHistory_stddev_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityUnitId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mappingHistory" */
export type MappingHistory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MappingHistory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MappingHistory_Stream_Cursor_Value_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialIdentifier?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantityUnitId?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MappingHistory_Sum_Fields = {
  __typename?: 'mappingHistory_sum_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantityUnitId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "mapping_history" */
export enum MappingHistory_Update_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  materialId = 'materialId',
  /** column name */
  materialIdentifier = 'materialIdentifier',
  /** column name */
  projectId = 'projectId',
  /** column name */
  quantity = 'quantity',
  /** column name */
  quantityUnitId = 'quantityUnitId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  typeIdentifier = 'typeIdentifier',
  /** column name */
  typeMaterialIdentifier = 'typeMaterialIdentifier',
  /** column name */
  userId = 'userId'
}

export type MappingHistory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MappingHistory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MappingHistory_Set_Input>;
  /** filter the rows which have to be updated */
  where: MappingHistory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MappingHistory_Var_Pop_Fields = {
  __typename?: 'mappingHistory_var_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityUnitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type MappingHistory_Var_Samp_Fields = {
  __typename?: 'mappingHistory_var_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityUnitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type MappingHistory_Variance_Fields = {
  __typename?: 'mappingHistory_variance_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityUnitId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mapping_history_most_used_lifetime" */
export type Mapping_History_Most_Used_Lifetime = {
  __typename?: 'mapping_history_most_used_lifetime';
  count?: Maybe<Scalars['bigint']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "mapping_history_most_used_lifetime" */
export type Mapping_History_Most_Used_Lifetime_Aggregate = {
  __typename?: 'mapping_history_most_used_lifetime_aggregate';
  aggregate?: Maybe<Mapping_History_Most_Used_Lifetime_Aggregate_Fields>;
  nodes: Array<Mapping_History_Most_Used_Lifetime>;
};

/** aggregate fields of "mapping_history_most_used_lifetime" */
export type Mapping_History_Most_Used_Lifetime_Aggregate_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_aggregate_fields';
  avg?: Maybe<Mapping_History_Most_Used_Lifetime_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mapping_History_Most_Used_Lifetime_Max_Fields>;
  min?: Maybe<Mapping_History_Most_Used_Lifetime_Min_Fields>;
  stddev?: Maybe<Mapping_History_Most_Used_Lifetime_Stddev_Fields>;
  stddev_pop?: Maybe<Mapping_History_Most_Used_Lifetime_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mapping_History_Most_Used_Lifetime_Stddev_Samp_Fields>;
  sum?: Maybe<Mapping_History_Most_Used_Lifetime_Sum_Fields>;
  var_pop?: Maybe<Mapping_History_Most_Used_Lifetime_Var_Pop_Fields>;
  var_samp?: Maybe<Mapping_History_Most_Used_Lifetime_Var_Samp_Fields>;
  variance?: Maybe<Mapping_History_Most_Used_Lifetime_Variance_Fields>;
};


/** aggregate fields of "mapping_history_most_used_lifetime" */
export type Mapping_History_Most_Used_Lifetime_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mapping_History_Most_Used_Lifetime_Avg_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mapping_history_most_used_lifetime". All fields are combined with a logical 'AND'. */
export type Mapping_History_Most_Used_Lifetime_Bool_Exp = {
  _and?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Bool_Exp>>;
  _not?: InputMaybe<Mapping_History_Most_Used_Lifetime_Bool_Exp>;
  _or?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  lifetime?: InputMaybe<Int_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  typeMaterialIdentifier?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mapping_History_Most_Used_Lifetime_Max_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_max_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mapping_History_Most_Used_Lifetime_Min_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_min_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mapping_history_most_used_lifetime". */
export type Mapping_History_Most_Used_Lifetime_Order_By = {
  count?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  typeMaterialIdentifier?: InputMaybe<Order_By>;
};

/** select columns of table "mapping_history_most_used_lifetime" */
export enum Mapping_History_Most_Used_Lifetime_Select_Column {
  /** column name */
  count = 'count',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  materialId = 'materialId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  typeMaterialIdentifier = 'typeMaterialIdentifier'
}

/** aggregate stddev on columns */
export type Mapping_History_Most_Used_Lifetime_Stddev_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mapping_History_Most_Used_Lifetime_Stddev_Pop_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mapping_History_Most_Used_Lifetime_Stddev_Samp_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mapping_history_most_used_lifetime" */
export type Mapping_History_Most_Used_Lifetime_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mapping_History_Most_Used_Lifetime_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mapping_History_Most_Used_Lifetime_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mapping_History_Most_Used_Lifetime_Sum_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_sum_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mapping_History_Most_Used_Lifetime_Var_Pop_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mapping_History_Most_Used_Lifetime_Var_Samp_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mapping_History_Most_Used_Lifetime_Variance_Fields = {
  __typename?: 'mapping_history_most_used_lifetime_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "material" */
export type Material = {
  __typename?: 'material';
  /** An object relationship */
  biogenicParams?: Maybe<MaterialBiogenicParams>;
  /** An object relationship */
  category: MaterialCategory;
  categoryId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Scalars['uuid']['output'];
  /** An object relationship */
  declaredUnit: DeclaredUnit;
  declaredUnitId: Scalars['uuid']['output'];
  deprecated: Scalars['Boolean']['output'];
  /** A computed field that returns a translated description based on languages in token with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  descriptions: Array<MaterialDescription>;
  /** An aggregate relationship */
  descriptions_aggregate: MaterialDescription_Aggregate;
  /** An array relationship */
  emissions: Array<MaterialStage>;
  /** An aggregate relationship */
  emissions_aggregate: MaterialStage_Aggregate;
  /** An object relationship */
  epd: MaterialEpd;
  faulty: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  internalId: Scalars['String']['output'];
  isPublic: Scalars['Boolean']['output'];
  lifetime: Scalars['Int']['output'];
  materialBiogenicParamsId?: Maybe<Scalars['uuid']['output']>;
  materialEpdId: Scalars['uuid']['output'];
  materialMassUnitId: Scalars['uuid']['output'];
  /** A computed field that returns a translated name based on languages in token with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  names: Array<MaterialName>;
  /** An aggregate relationship */
  names_aggregate: MaterialName_Aggregate;
  tenantId: Scalars['uuid']['output'];
  type: MaterialType_Enum;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
  validTo: Scalars['timestamptz']['output'];
  version: Scalars['Int']['output'];
  /** An object relationship */
  weightPerDeclaredUnit: WeightPerDeclaredUnit;
};


/** columns and relationships of "material" */
export type MaterialDescriptionsArgs = {
  distinct_on?: InputMaybe<Array<MaterialDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialDescription_Order_By>>;
  where?: InputMaybe<MaterialDescription_Bool_Exp>;
};


/** columns and relationships of "material" */
export type MaterialDescriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialDescription_Order_By>>;
  where?: InputMaybe<MaterialDescription_Bool_Exp>;
};


/** columns and relationships of "material" */
export type MaterialEmissionsArgs = {
  distinct_on?: InputMaybe<Array<MaterialStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStage_Order_By>>;
  where?: InputMaybe<MaterialStage_Bool_Exp>;
};


/** columns and relationships of "material" */
export type MaterialEmissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStage_Order_By>>;
  where?: InputMaybe<MaterialStage_Bool_Exp>;
};


/** columns and relationships of "material" */
export type MaterialNamesArgs = {
  distinct_on?: InputMaybe<Array<MaterialName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialName_Order_By>>;
  where?: InputMaybe<MaterialName_Bool_Exp>;
};


/** columns and relationships of "material" */
export type MaterialNames_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialName_Order_By>>;
  where?: InputMaybe<MaterialName_Bool_Exp>;
};

/** columns and relationships of "material_biogenic_params" */
export type MaterialBiogenicParams = {
  __typename?: 'materialBiogenicParams';
  id: Scalars['uuid']['output'];
  packaging: Scalars['numeric']['output'];
  product: Scalars['numeric']['output'];
};

/** aggregated selection of "material_biogenic_params" */
export type MaterialBiogenicParams_Aggregate = {
  __typename?: 'materialBiogenicParams_aggregate';
  aggregate?: Maybe<MaterialBiogenicParams_Aggregate_Fields>;
  nodes: Array<MaterialBiogenicParams>;
};

/** aggregate fields of "material_biogenic_params" */
export type MaterialBiogenicParams_Aggregate_Fields = {
  __typename?: 'materialBiogenicParams_aggregate_fields';
  avg?: Maybe<MaterialBiogenicParams_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialBiogenicParams_Max_Fields>;
  min?: Maybe<MaterialBiogenicParams_Min_Fields>;
  stddev?: Maybe<MaterialBiogenicParams_Stddev_Fields>;
  stddev_pop?: Maybe<MaterialBiogenicParams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MaterialBiogenicParams_Stddev_Samp_Fields>;
  sum?: Maybe<MaterialBiogenicParams_Sum_Fields>;
  var_pop?: Maybe<MaterialBiogenicParams_Var_Pop_Fields>;
  var_samp?: Maybe<MaterialBiogenicParams_Var_Samp_Fields>;
  variance?: Maybe<MaterialBiogenicParams_Variance_Fields>;
};


/** aggregate fields of "material_biogenic_params" */
export type MaterialBiogenicParams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialBiogenicParams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type MaterialBiogenicParams_Avg_Fields = {
  __typename?: 'materialBiogenicParams_avg_fields';
  packaging?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "material_biogenic_params". All fields are combined with a logical 'AND'. */
export type MaterialBiogenicParams_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialBiogenicParams_Bool_Exp>>;
  _not?: InputMaybe<MaterialBiogenicParams_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialBiogenicParams_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  packaging?: InputMaybe<Numeric_Comparison_Exp>;
  product?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_biogenic_params" */
export enum MaterialBiogenicParams_Constraint {
  /** unique or primary key constraint on columns "id" */
  material_biogenic_params_pkey = 'material_biogenic_params_pkey'
}

/** input type for incrementing numeric columns in table "material_biogenic_params" */
export type MaterialBiogenicParams_Inc_Input = {
  packaging?: InputMaybe<Scalars['numeric']['input']>;
  product?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "material_biogenic_params" */
export type MaterialBiogenicParams_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  packaging?: InputMaybe<Scalars['numeric']['input']>;
  product?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type MaterialBiogenicParams_Max_Fields = {
  __typename?: 'materialBiogenicParams_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  packaging?: Maybe<Scalars['numeric']['output']>;
  product?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type MaterialBiogenicParams_Min_Fields = {
  __typename?: 'materialBiogenicParams_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  packaging?: Maybe<Scalars['numeric']['output']>;
  product?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "material_biogenic_params" */
export type MaterialBiogenicParams_Mutation_Response = {
  __typename?: 'materialBiogenicParams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialBiogenicParams>;
};

/** input type for inserting object relation for remote table "material_biogenic_params" */
export type MaterialBiogenicParams_Obj_Rel_Insert_Input = {
  data: MaterialBiogenicParams_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialBiogenicParams_On_Conflict>;
};

/** on_conflict condition type for table "material_biogenic_params" */
export type MaterialBiogenicParams_On_Conflict = {
  constraint: MaterialBiogenicParams_Constraint;
  update_columns?: Array<MaterialBiogenicParams_Update_Column>;
  where?: InputMaybe<MaterialBiogenicParams_Bool_Exp>;
};

/** Ordering options when selecting data from "material_biogenic_params". */
export type MaterialBiogenicParams_Order_By = {
  id?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_biogenic_params */
export type MaterialBiogenicParams_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_biogenic_params" */
export enum MaterialBiogenicParams_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  packaging = 'packaging',
  /** column name */
  product = 'product'
}

/** input type for updating data in table "material_biogenic_params" */
export type MaterialBiogenicParams_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  packaging?: InputMaybe<Scalars['numeric']['input']>;
  product?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type MaterialBiogenicParams_Stddev_Fields = {
  __typename?: 'materialBiogenicParams_stddev_fields';
  packaging?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type MaterialBiogenicParams_Stddev_Pop_Fields = {
  __typename?: 'materialBiogenicParams_stddev_pop_fields';
  packaging?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type MaterialBiogenicParams_Stddev_Samp_Fields = {
  __typename?: 'materialBiogenicParams_stddev_samp_fields';
  packaging?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "materialBiogenicParams" */
export type MaterialBiogenicParams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialBiogenicParams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialBiogenicParams_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  packaging?: InputMaybe<Scalars['numeric']['input']>;
  product?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type MaterialBiogenicParams_Sum_Fields = {
  __typename?: 'materialBiogenicParams_sum_fields';
  packaging?: Maybe<Scalars['numeric']['output']>;
  product?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "material_biogenic_params" */
export enum MaterialBiogenicParams_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  packaging = 'packaging',
  /** column name */
  product = 'product'
}

export type MaterialBiogenicParams_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaterialBiogenicParams_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialBiogenicParams_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialBiogenicParams_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MaterialBiogenicParams_Var_Pop_Fields = {
  __typename?: 'materialBiogenicParams_var_pop_fields';
  packaging?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type MaterialBiogenicParams_Var_Samp_Fields = {
  __typename?: 'materialBiogenicParams_var_samp_fields';
  packaging?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type MaterialBiogenicParams_Variance_Fields = {
  __typename?: 'materialBiogenicParams_variance_fields';
  packaging?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "material_category" */
export type MaterialCategory = {
  __typename?: 'materialCategory';
  id: Scalars['String']['output'];
  /** A computed field that returns a translated category based on languages in token */
  label?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  translations: Array<TranslationCategory>;
  /** An aggregate relationship */
  translations_aggregate: TranslationCategory_Aggregate;
};


/** columns and relationships of "material_category" */
export type MaterialCategoryTranslationsArgs = {
  distinct_on?: InputMaybe<Array<TranslationCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationCategory_Order_By>>;
  where?: InputMaybe<TranslationCategory_Bool_Exp>;
};


/** columns and relationships of "material_category" */
export type MaterialCategoryTranslations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TranslationCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationCategory_Order_By>>;
  where?: InputMaybe<TranslationCategory_Bool_Exp>;
};

/** columns and relationships of "material_category_texture" */
export type MaterialCategoryTexture = {
  __typename?: 'materialCategoryTexture';
  materialCategoryId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** aggregated selection of "material_category_texture" */
export type MaterialCategoryTexture_Aggregate = {
  __typename?: 'materialCategoryTexture_aggregate';
  aggregate?: Maybe<MaterialCategoryTexture_Aggregate_Fields>;
  nodes: Array<MaterialCategoryTexture>;
};

/** aggregate fields of "material_category_texture" */
export type MaterialCategoryTexture_Aggregate_Fields = {
  __typename?: 'materialCategoryTexture_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialCategoryTexture_Max_Fields>;
  min?: Maybe<MaterialCategoryTexture_Min_Fields>;
};


/** aggregate fields of "material_category_texture" */
export type MaterialCategoryTexture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialCategoryTexture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "material_category_texture". All fields are combined with a logical 'AND'. */
export type MaterialCategoryTexture_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialCategoryTexture_Bool_Exp>>;
  _not?: InputMaybe<MaterialCategoryTexture_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialCategoryTexture_Bool_Exp>>;
  materialCategoryId?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_category_texture" */
export enum MaterialCategoryTexture_Constraint {
  /** unique or primary key constraint on columns "material_category_id" */
  material_category_texture_pkey = 'material_category_texture_pkey'
}

/** input type for inserting data into table "material_category_texture" */
export type MaterialCategoryTexture_Insert_Input = {
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MaterialCategoryTexture_Max_Fields = {
  __typename?: 'materialCategoryTexture_max_fields';
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MaterialCategoryTexture_Min_Fields = {
  __typename?: 'materialCategoryTexture_min_fields';
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "material_category_texture" */
export type MaterialCategoryTexture_Mutation_Response = {
  __typename?: 'materialCategoryTexture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialCategoryTexture>;
};

/** on_conflict condition type for table "material_category_texture" */
export type MaterialCategoryTexture_On_Conflict = {
  constraint: MaterialCategoryTexture_Constraint;
  update_columns?: Array<MaterialCategoryTexture_Update_Column>;
  where?: InputMaybe<MaterialCategoryTexture_Bool_Exp>;
};

/** Ordering options when selecting data from "material_category_texture". */
export type MaterialCategoryTexture_Order_By = {
  materialCategoryId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_category_texture */
export type MaterialCategoryTexture_Pk_Columns_Input = {
  materialCategoryId: Scalars['String']['input'];
};

/** select columns of table "material_category_texture" */
export enum MaterialCategoryTexture_Select_Column {
  /** column name */
  materialCategoryId = 'materialCategoryId',
  /** column name */
  url = 'url'
}

/** input type for updating data in table "material_category_texture" */
export type MaterialCategoryTexture_Set_Input = {
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "materialCategoryTexture" */
export type MaterialCategoryTexture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialCategoryTexture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialCategoryTexture_Stream_Cursor_Value_Input = {
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "material_category_texture" */
export enum MaterialCategoryTexture_Update_Column {
  /** column name */
  materialCategoryId = 'materialCategoryId',
  /** column name */
  url = 'url'
}

export type MaterialCategoryTexture_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialCategoryTexture_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialCategoryTexture_Bool_Exp;
};

/** aggregated selection of "material_category" */
export type MaterialCategory_Aggregate = {
  __typename?: 'materialCategory_aggregate';
  aggregate?: Maybe<MaterialCategory_Aggregate_Fields>;
  nodes: Array<MaterialCategory>;
};

/** aggregate fields of "material_category" */
export type MaterialCategory_Aggregate_Fields = {
  __typename?: 'materialCategory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialCategory_Max_Fields>;
  min?: Maybe<MaterialCategory_Min_Fields>;
};


/** aggregate fields of "material_category" */
export type MaterialCategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "material_category" */
export type MaterialCategory_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MaterialCategory_Max_Order_By>;
  min?: InputMaybe<MaterialCategory_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "material_category". All fields are combined with a logical 'AND'. */
export type MaterialCategory_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialCategory_Bool_Exp>>;
  _not?: InputMaybe<MaterialCategory_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialCategory_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<TranslationCategory_Bool_Exp>;
  translations_aggregate?: InputMaybe<TranslationCategory_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "material_category" */
export enum MaterialCategory_Constraint {
  /** unique or primary key constraint on columns "id" */
  material_category_pkey = 'material_category_pkey'
}

/** input type for inserting data into table "material_category" */
export type MaterialCategory_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<TranslationCategory_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type MaterialCategory_Max_Fields = {
  __typename?: 'materialCategory_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  /** A computed field that returns a translated category based on languages in token */
  label?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "material_category" */
export type MaterialCategory_Max_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MaterialCategory_Min_Fields = {
  __typename?: 'materialCategory_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  /** A computed field that returns a translated category based on languages in token */
  label?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "material_category" */
export type MaterialCategory_Min_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "material_category" */
export type MaterialCategory_Mutation_Response = {
  __typename?: 'materialCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialCategory>;
};

/** input type for inserting object relation for remote table "material_category" */
export type MaterialCategory_Obj_Rel_Insert_Input = {
  data: MaterialCategory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialCategory_On_Conflict>;
};

/** on_conflict condition type for table "material_category" */
export type MaterialCategory_On_Conflict = {
  constraint: MaterialCategory_Constraint;
  update_columns?: Array<MaterialCategory_Update_Column>;
  where?: InputMaybe<MaterialCategory_Bool_Exp>;
};

/** Ordering options when selecting data from "material_category". */
export type MaterialCategory_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  translations_aggregate?: InputMaybe<TranslationCategory_Aggregate_Order_By>;
};

/** primary key columns input for table: material_category */
export type MaterialCategory_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "material_category" */
export enum MaterialCategory_Select_Column {
  /** column name */
  id = 'id'
}

/** input type for updating data in table "material_category" */
export type MaterialCategory_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "materialCategory" */
export type MaterialCategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialCategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialCategory_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "material_category" */
export enum MaterialCategory_Update_Column {
  /** column name */
  id = 'id'
}

export type MaterialCategory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialCategory_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialCategory_Bool_Exp;
};

/** columns and relationships of "material_description" */
export type MaterialDescription = {
  __typename?: 'materialDescription';
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  materialId: Scalars['uuid']['output'];
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "material_description" */
export type MaterialDescription_Aggregate = {
  __typename?: 'materialDescription_aggregate';
  aggregate?: Maybe<MaterialDescription_Aggregate_Fields>;
  nodes: Array<MaterialDescription>;
};

export type MaterialDescription_Aggregate_Bool_Exp = {
  count?: InputMaybe<MaterialDescription_Aggregate_Bool_Exp_Count>;
};

export type MaterialDescription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MaterialDescription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MaterialDescription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "material_description" */
export type MaterialDescription_Aggregate_Fields = {
  __typename?: 'materialDescription_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialDescription_Max_Fields>;
  min?: Maybe<MaterialDescription_Min_Fields>;
};


/** aggregate fields of "material_description" */
export type MaterialDescription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialDescription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "material_description" */
export type MaterialDescription_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MaterialDescription_Max_Order_By>;
  min?: InputMaybe<MaterialDescription_Min_Order_By>;
};

/** input type for inserting array relation for remote table "material_description" */
export type MaterialDescription_Arr_Rel_Insert_Input = {
  data: Array<MaterialDescription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialDescription_On_Conflict>;
};

/** Boolean expression to filter rows from the table "material_description". All fields are combined with a logical 'AND'. */
export type MaterialDescription_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialDescription_Bool_Exp>>;
  _not?: InputMaybe<MaterialDescription_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialDescription_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_description" */
export enum MaterialDescription_Constraint {
  /** unique or primary key constraint on columns "material_id", "language_code" */
  material_description_language_code_material_id_key = 'material_description_language_code_material_id_key',
  /** unique or primary key constraint on columns "id" */
  material_description_pkey = 'material_description_pkey'
}

/** input type for inserting data into table "material_description" */
export type MaterialDescription_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MaterialDescription_Max_Fields = {
  __typename?: 'materialDescription_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "material_description" */
export type MaterialDescription_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MaterialDescription_Min_Fields = {
  __typename?: 'materialDescription_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "material_description" */
export type MaterialDescription_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "material_description" */
export type MaterialDescription_Mutation_Response = {
  __typename?: 'materialDescription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialDescription>;
};

/** on_conflict condition type for table "material_description" */
export type MaterialDescription_On_Conflict = {
  constraint: MaterialDescription_Constraint;
  update_columns?: Array<MaterialDescription_Update_Column>;
  where?: InputMaybe<MaterialDescription_Bool_Exp>;
};

/** Ordering options when selecting data from "material_description". */
export type MaterialDescription_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_description */
export type MaterialDescription_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_description" */
export enum MaterialDescription_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  materialId = 'materialId',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "material_description" */
export type MaterialDescription_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "materialDescription" */
export type MaterialDescription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialDescription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialDescription_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "material_description" */
export enum MaterialDescription_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  materialId = 'materialId',
  /** column name */
  translationSource = 'translationSource'
}

export type MaterialDescription_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialDescription_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialDescription_Bool_Exp;
};

/** columns and relationships of "material_emission_indicator" */
export type MaterialEmissionIndicator = {
  __typename?: 'materialEmissionIndicator';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indicatorType: IndicatorType;
  indicatorTypeId: Scalars['Int']['output'];
  materialEmissionId: Scalars['uuid']['output'];
  source: IndicatorSource_Enum;
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "material_emission_indicator" */
export type MaterialEmissionIndicator_Aggregate = {
  __typename?: 'materialEmissionIndicator_aggregate';
  aggregate?: Maybe<MaterialEmissionIndicator_Aggregate_Fields>;
  nodes: Array<MaterialEmissionIndicator>;
};

export type MaterialEmissionIndicator_Aggregate_Bool_Exp = {
  count?: InputMaybe<MaterialEmissionIndicator_Aggregate_Bool_Exp_Count>;
};

export type MaterialEmissionIndicator_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MaterialEmissionIndicator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "material_emission_indicator" */
export type MaterialEmissionIndicator_Aggregate_Fields = {
  __typename?: 'materialEmissionIndicator_aggregate_fields';
  avg?: Maybe<MaterialEmissionIndicator_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialEmissionIndicator_Max_Fields>;
  min?: Maybe<MaterialEmissionIndicator_Min_Fields>;
  stddev?: Maybe<MaterialEmissionIndicator_Stddev_Fields>;
  stddev_pop?: Maybe<MaterialEmissionIndicator_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MaterialEmissionIndicator_Stddev_Samp_Fields>;
  sum?: Maybe<MaterialEmissionIndicator_Sum_Fields>;
  var_pop?: Maybe<MaterialEmissionIndicator_Var_Pop_Fields>;
  var_samp?: Maybe<MaterialEmissionIndicator_Var_Samp_Fields>;
  variance?: Maybe<MaterialEmissionIndicator_Variance_Fields>;
};


/** aggregate fields of "material_emission_indicator" */
export type MaterialEmissionIndicator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialEmissionIndicator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Aggregate_Order_By = {
  avg?: InputMaybe<MaterialEmissionIndicator_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MaterialEmissionIndicator_Max_Order_By>;
  min?: InputMaybe<MaterialEmissionIndicator_Min_Order_By>;
  stddev?: InputMaybe<MaterialEmissionIndicator_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MaterialEmissionIndicator_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MaterialEmissionIndicator_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MaterialEmissionIndicator_Sum_Order_By>;
  var_pop?: InputMaybe<MaterialEmissionIndicator_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MaterialEmissionIndicator_Var_Samp_Order_By>;
  variance?: InputMaybe<MaterialEmissionIndicator_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "material_emission_indicator" */
export type MaterialEmissionIndicator_Arr_Rel_Insert_Input = {
  data: Array<MaterialEmissionIndicator_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialEmissionIndicator_On_Conflict>;
};

/** aggregate avg on columns */
export type MaterialEmissionIndicator_Avg_Fields = {
  __typename?: 'materialEmissionIndicator_avg_fields';
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Avg_Order_By = {
  indicatorTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "material_emission_indicator". All fields are combined with a logical 'AND'. */
export type MaterialEmissionIndicator_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialEmissionIndicator_Bool_Exp>>;
  _not?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialEmissionIndicator_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  indicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
  materialEmissionId?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<IndicatorSource_Enum_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_emission_indicator" */
export enum MaterialEmissionIndicator_Constraint {
  /** unique or primary key constraint on columns "indicator_type_id", "material_emission_id" */
  material_emission_indicator_material_emission_id_indicator__key = 'material_emission_indicator_material_emission_id_indicator__key',
  /** unique or primary key constraint on columns "id" */
  material_emission_indicator_pkey = 'material_emission_indicator_pkey'
}

/** input type for incrementing numeric columns in table "material_emission_indicator" */
export type MaterialEmissionIndicator_Inc_Input = {
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "material_emission_indicator" */
export type MaterialEmissionIndicator_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  materialEmissionId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<IndicatorSource_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type MaterialEmissionIndicator_Max_Fields = {
  __typename?: 'materialEmissionIndicator_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  materialEmissionId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  materialEmissionId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MaterialEmissionIndicator_Min_Fields = {
  __typename?: 'materialEmissionIndicator_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  materialEmissionId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  materialEmissionId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "material_emission_indicator" */
export type MaterialEmissionIndicator_Mutation_Response = {
  __typename?: 'materialEmissionIndicator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialEmissionIndicator>;
};

/** on_conflict condition type for table "material_emission_indicator" */
export type MaterialEmissionIndicator_On_Conflict = {
  constraint: MaterialEmissionIndicator_Constraint;
  update_columns?: Array<MaterialEmissionIndicator_Update_Column>;
  where?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
};

/** Ordering options when selecting data from "material_emission_indicator". */
export type MaterialEmissionIndicator_Order_By = {
  id?: InputMaybe<Order_By>;
  indicatorType?: InputMaybe<IndicatorType_Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  materialEmissionId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_emission_indicator */
export type MaterialEmissionIndicator_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_emission_indicator" */
export enum MaterialEmissionIndicator_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  materialEmissionId = 'materialEmissionId',
  /** column name */
  source = 'source',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "material_emission_indicator" */
export type MaterialEmissionIndicator_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  materialEmissionId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<IndicatorSource_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type MaterialEmissionIndicator_Stddev_Fields = {
  __typename?: 'materialEmissionIndicator_stddev_fields';
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Stddev_Order_By = {
  indicatorTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MaterialEmissionIndicator_Stddev_Pop_Fields = {
  __typename?: 'materialEmissionIndicator_stddev_pop_fields';
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Stddev_Pop_Order_By = {
  indicatorTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MaterialEmissionIndicator_Stddev_Samp_Fields = {
  __typename?: 'materialEmissionIndicator_stddev_samp_fields';
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Stddev_Samp_Order_By = {
  indicatorTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "materialEmissionIndicator" */
export type MaterialEmissionIndicator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialEmissionIndicator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialEmissionIndicator_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  materialEmissionId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<IndicatorSource_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type MaterialEmissionIndicator_Sum_Fields = {
  __typename?: 'materialEmissionIndicator_sum_fields';
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Sum_Order_By = {
  indicatorTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "material_emission_indicator" */
export enum MaterialEmissionIndicator_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  materialEmissionId = 'materialEmissionId',
  /** column name */
  source = 'source',
  /** column name */
  value = 'value'
}

export type MaterialEmissionIndicator_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaterialEmissionIndicator_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialEmissionIndicator_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialEmissionIndicator_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MaterialEmissionIndicator_Var_Pop_Fields = {
  __typename?: 'materialEmissionIndicator_var_pop_fields';
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Var_Pop_Order_By = {
  indicatorTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MaterialEmissionIndicator_Var_Samp_Fields = {
  __typename?: 'materialEmissionIndicator_var_samp_fields';
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Var_Samp_Order_By = {
  indicatorTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MaterialEmissionIndicator_Variance_Fields = {
  __typename?: 'materialEmissionIndicator_variance_fields';
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "material_emission_indicator" */
export type MaterialEmissionIndicator_Variance_Order_By = {
  indicatorTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "material_epd" */
export type MaterialEpd = {
  __typename?: 'materialEpd';
  /** An array relationship */
  datasources: Array<MaterialEpdDatasource>;
  /** An aggregate relationship */
  datasources_aggregate: MaterialEpdDatasource_Aggregate;
  declarationNumber?: Maybe<Scalars['String']['output']>;
  epdOwnerId: Scalars['uuid']['output'];
  epdProductIndustryId: Scalars['Int']['output'];
  epdSpecificationFormId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  owner: EpdOwner;
  /** An object relationship */
  productIndustry: EpdProductIndustry;
  publicationDate: Scalars['timestamptz']['output'];
  /** An object relationship */
  specificationForm: EpdSpecificationForm;
  /** An object relationship */
  urls?: Maybe<MaterialEpdUrl>;
  version: Scalars['String']['output'];
};


/** columns and relationships of "material_epd" */
export type MaterialEpdDatasourcesArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdDatasource_Order_By>>;
  where?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
};


/** columns and relationships of "material_epd" */
export type MaterialEpdDatasources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdDatasource_Order_By>>;
  where?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
};

/** columns and relationships of "material_epd_datasource" */
export type MaterialEpdDatasource = {
  __typename?: 'materialEpdDatasource';
  /** An object relationship */
  datasource: EpdDatasource;
  epdDatasourceId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  materialEpdId: Scalars['uuid']['output'];
};

/** aggregated selection of "material_epd_datasource" */
export type MaterialEpdDatasource_Aggregate = {
  __typename?: 'materialEpdDatasource_aggregate';
  aggregate?: Maybe<MaterialEpdDatasource_Aggregate_Fields>;
  nodes: Array<MaterialEpdDatasource>;
};

export type MaterialEpdDatasource_Aggregate_Bool_Exp = {
  count?: InputMaybe<MaterialEpdDatasource_Aggregate_Bool_Exp_Count>;
};

export type MaterialEpdDatasource_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MaterialEpdDatasource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "material_epd_datasource" */
export type MaterialEpdDatasource_Aggregate_Fields = {
  __typename?: 'materialEpdDatasource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialEpdDatasource_Max_Fields>;
  min?: Maybe<MaterialEpdDatasource_Min_Fields>;
};


/** aggregate fields of "material_epd_datasource" */
export type MaterialEpdDatasource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialEpdDatasource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "material_epd_datasource" */
export type MaterialEpdDatasource_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MaterialEpdDatasource_Max_Order_By>;
  min?: InputMaybe<MaterialEpdDatasource_Min_Order_By>;
};

/** input type for inserting array relation for remote table "material_epd_datasource" */
export type MaterialEpdDatasource_Arr_Rel_Insert_Input = {
  data: Array<MaterialEpdDatasource_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialEpdDatasource_On_Conflict>;
};

/** Boolean expression to filter rows from the table "material_epd_datasource". All fields are combined with a logical 'AND'. */
export type MaterialEpdDatasource_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialEpdDatasource_Bool_Exp>>;
  _not?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialEpdDatasource_Bool_Exp>>;
  datasource?: InputMaybe<EpdDatasource_Bool_Exp>;
  epdDatasourceId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  materialEpdId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_epd_datasource" */
export enum MaterialEpdDatasource_Constraint {
  /** unique or primary key constraint on columns "material_epd_id", "epd_datasource_id" */
  material_epd_datasource_material_epd_id_datasource_id_key = 'material_epd_datasource_material_epd_id_datasource_id_key',
  /** unique or primary key constraint on columns "id" */
  material_epd_datasource_pkey = 'material_epd_datasource_pkey'
}

/** input type for inserting data into table "material_epd_datasource" */
export type MaterialEpdDatasource_Insert_Input = {
  datasource?: InputMaybe<EpdDatasource_Obj_Rel_Insert_Input>;
  epdDatasourceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialEpdId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type MaterialEpdDatasource_Max_Fields = {
  __typename?: 'materialEpdDatasource_max_fields';
  epdDatasourceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialEpdId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "material_epd_datasource" */
export type MaterialEpdDatasource_Max_Order_By = {
  epdDatasourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  materialEpdId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MaterialEpdDatasource_Min_Fields = {
  __typename?: 'materialEpdDatasource_min_fields';
  epdDatasourceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialEpdId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "material_epd_datasource" */
export type MaterialEpdDatasource_Min_Order_By = {
  epdDatasourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  materialEpdId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "material_epd_datasource" */
export type MaterialEpdDatasource_Mutation_Response = {
  __typename?: 'materialEpdDatasource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialEpdDatasource>;
};

/** on_conflict condition type for table "material_epd_datasource" */
export type MaterialEpdDatasource_On_Conflict = {
  constraint: MaterialEpdDatasource_Constraint;
  update_columns?: Array<MaterialEpdDatasource_Update_Column>;
  where?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
};

/** Ordering options when selecting data from "material_epd_datasource". */
export type MaterialEpdDatasource_Order_By = {
  datasource?: InputMaybe<EpdDatasource_Order_By>;
  epdDatasourceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  materialEpdId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_epd_datasource */
export type MaterialEpdDatasource_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_epd_datasource" */
export enum MaterialEpdDatasource_Select_Column {
  /** column name */
  epdDatasourceId = 'epdDatasourceId',
  /** column name */
  id = 'id',
  /** column name */
  materialEpdId = 'materialEpdId'
}

/** input type for updating data in table "material_epd_datasource" */
export type MaterialEpdDatasource_Set_Input = {
  epdDatasourceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialEpdId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "materialEpdDatasource" */
export type MaterialEpdDatasource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialEpdDatasource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialEpdDatasource_Stream_Cursor_Value_Input = {
  epdDatasourceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialEpdId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "material_epd_datasource" */
export enum MaterialEpdDatasource_Update_Column {
  /** column name */
  epdDatasourceId = 'epdDatasourceId',
  /** column name */
  id = 'id',
  /** column name */
  materialEpdId = 'materialEpdId'
}

export type MaterialEpdDatasource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialEpdDatasource_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialEpdDatasource_Bool_Exp;
};

/** columns and relationships of "material_epd_url" */
export type MaterialEpdUrl = {
  __typename?: 'materialEpdUrl';
  documentation?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  materialEpdId: Scalars['uuid']['output'];
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "material_epd_url" */
export type MaterialEpdUrl_Aggregate = {
  __typename?: 'materialEpdUrl_aggregate';
  aggregate?: Maybe<MaterialEpdUrl_Aggregate_Fields>;
  nodes: Array<MaterialEpdUrl>;
};

/** aggregate fields of "material_epd_url" */
export type MaterialEpdUrl_Aggregate_Fields = {
  __typename?: 'materialEpdUrl_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialEpdUrl_Max_Fields>;
  min?: Maybe<MaterialEpdUrl_Min_Fields>;
};


/** aggregate fields of "material_epd_url" */
export type MaterialEpdUrl_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialEpdUrl_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "material_epd_url". All fields are combined with a logical 'AND'. */
export type MaterialEpdUrl_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialEpdUrl_Bool_Exp>>;
  _not?: InputMaybe<MaterialEpdUrl_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialEpdUrl_Bool_Exp>>;
  documentation?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  materialEpdId?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_epd_url" */
export enum MaterialEpdUrl_Constraint {
  /** unique or primary key constraint on columns "material_epd_id" */
  material_epd_url_material_epd_id_key = 'material_epd_url_material_epd_id_key',
  /** unique or primary key constraint on columns "id" */
  material_epd_url_pkey = 'material_epd_url_pkey'
}

/** input type for inserting data into table "material_epd_url" */
export type MaterialEpdUrl_Insert_Input = {
  documentation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialEpdId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MaterialEpdUrl_Max_Fields = {
  __typename?: 'materialEpdUrl_max_fields';
  documentation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialEpdId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MaterialEpdUrl_Min_Fields = {
  __typename?: 'materialEpdUrl_min_fields';
  documentation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialEpdId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "material_epd_url" */
export type MaterialEpdUrl_Mutation_Response = {
  __typename?: 'materialEpdUrl_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialEpdUrl>;
};

/** input type for inserting object relation for remote table "material_epd_url" */
export type MaterialEpdUrl_Obj_Rel_Insert_Input = {
  data: MaterialEpdUrl_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialEpdUrl_On_Conflict>;
};

/** on_conflict condition type for table "material_epd_url" */
export type MaterialEpdUrl_On_Conflict = {
  constraint: MaterialEpdUrl_Constraint;
  update_columns?: Array<MaterialEpdUrl_Update_Column>;
  where?: InputMaybe<MaterialEpdUrl_Bool_Exp>;
};

/** Ordering options when selecting data from "material_epd_url". */
export type MaterialEpdUrl_Order_By = {
  documentation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  materialEpdId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_epd_url */
export type MaterialEpdUrl_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_epd_url" */
export enum MaterialEpdUrl_Select_Column {
  /** column name */
  documentation = 'documentation',
  /** column name */
  id = 'id',
  /** column name */
  materialEpdId = 'materialEpdId',
  /** column name */
  source = 'source'
}

/** input type for updating data in table "material_epd_url" */
export type MaterialEpdUrl_Set_Input = {
  documentation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialEpdId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "materialEpdUrl" */
export type MaterialEpdUrl_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialEpdUrl_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialEpdUrl_Stream_Cursor_Value_Input = {
  documentation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialEpdId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "material_epd_url" */
export enum MaterialEpdUrl_Update_Column {
  /** column name */
  documentation = 'documentation',
  /** column name */
  id = 'id',
  /** column name */
  materialEpdId = 'materialEpdId',
  /** column name */
  source = 'source'
}

export type MaterialEpdUrl_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialEpdUrl_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialEpdUrl_Bool_Exp;
};

/** aggregated selection of "material_epd" */
export type MaterialEpd_Aggregate = {
  __typename?: 'materialEpd_aggregate';
  aggregate?: Maybe<MaterialEpd_Aggregate_Fields>;
  nodes: Array<MaterialEpd>;
};

/** aggregate fields of "material_epd" */
export type MaterialEpd_Aggregate_Fields = {
  __typename?: 'materialEpd_aggregate_fields';
  avg?: Maybe<MaterialEpd_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialEpd_Max_Fields>;
  min?: Maybe<MaterialEpd_Min_Fields>;
  stddev?: Maybe<MaterialEpd_Stddev_Fields>;
  stddev_pop?: Maybe<MaterialEpd_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MaterialEpd_Stddev_Samp_Fields>;
  sum?: Maybe<MaterialEpd_Sum_Fields>;
  var_pop?: Maybe<MaterialEpd_Var_Pop_Fields>;
  var_samp?: Maybe<MaterialEpd_Var_Samp_Fields>;
  variance?: Maybe<MaterialEpd_Variance_Fields>;
};


/** aggregate fields of "material_epd" */
export type MaterialEpd_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialEpd_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type MaterialEpd_Avg_Fields = {
  __typename?: 'materialEpd_avg_fields';
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "material_epd". All fields are combined with a logical 'AND'. */
export type MaterialEpd_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialEpd_Bool_Exp>>;
  _not?: InputMaybe<MaterialEpd_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialEpd_Bool_Exp>>;
  datasources?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
  datasources_aggregate?: InputMaybe<MaterialEpdDatasource_Aggregate_Bool_Exp>;
  declarationNumber?: InputMaybe<String_Comparison_Exp>;
  epdOwnerId?: InputMaybe<Uuid_Comparison_Exp>;
  epdProductIndustryId?: InputMaybe<Int_Comparison_Exp>;
  epdSpecificationFormId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  owner?: InputMaybe<EpdOwner_Bool_Exp>;
  productIndustry?: InputMaybe<EpdProductIndustry_Bool_Exp>;
  publicationDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  specificationForm?: InputMaybe<EpdSpecificationForm_Bool_Exp>;
  urls?: InputMaybe<MaterialEpdUrl_Bool_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_epd" */
export enum MaterialEpd_Constraint {
  /** unique or primary key constraint on columns "id" */
  material_epd_pkey = 'material_epd_pkey'
}

/** input type for incrementing numeric columns in table "material_epd" */
export type MaterialEpd_Inc_Input = {
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  epdSpecificationFormId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "material_epd" */
export type MaterialEpd_Insert_Input = {
  datasources?: InputMaybe<MaterialEpdDatasource_Arr_Rel_Insert_Input>;
  declarationNumber?: InputMaybe<Scalars['String']['input']>;
  epdOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  epdSpecificationFormId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  owner?: InputMaybe<EpdOwner_Obj_Rel_Insert_Input>;
  productIndustry?: InputMaybe<EpdProductIndustry_Obj_Rel_Insert_Input>;
  publicationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  specificationForm?: InputMaybe<EpdSpecificationForm_Obj_Rel_Insert_Input>;
  urls?: InputMaybe<MaterialEpdUrl_Obj_Rel_Insert_Input>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MaterialEpd_Max_Fields = {
  __typename?: 'materialEpd_max_fields';
  declarationNumber?: Maybe<Scalars['String']['output']>;
  epdOwnerId?: Maybe<Scalars['uuid']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Int']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationDate?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MaterialEpd_Min_Fields = {
  __typename?: 'materialEpd_min_fields';
  declarationNumber?: Maybe<Scalars['String']['output']>;
  epdOwnerId?: Maybe<Scalars['uuid']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Int']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publicationDate?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "material_epd" */
export type MaterialEpd_Mutation_Response = {
  __typename?: 'materialEpd_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialEpd>;
};

/** input type for inserting object relation for remote table "material_epd" */
export type MaterialEpd_Obj_Rel_Insert_Input = {
  data: MaterialEpd_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialEpd_On_Conflict>;
};

/** on_conflict condition type for table "material_epd" */
export type MaterialEpd_On_Conflict = {
  constraint: MaterialEpd_Constraint;
  update_columns?: Array<MaterialEpd_Update_Column>;
  where?: InputMaybe<MaterialEpd_Bool_Exp>;
};

/** Ordering options when selecting data from "material_epd". */
export type MaterialEpd_Order_By = {
  datasources_aggregate?: InputMaybe<MaterialEpdDatasource_Aggregate_Order_By>;
  declarationNumber?: InputMaybe<Order_By>;
  epdOwnerId?: InputMaybe<Order_By>;
  epdProductIndustryId?: InputMaybe<Order_By>;
  epdSpecificationFormId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<EpdOwner_Order_By>;
  productIndustry?: InputMaybe<EpdProductIndustry_Order_By>;
  publicationDate?: InputMaybe<Order_By>;
  specificationForm?: InputMaybe<EpdSpecificationForm_Order_By>;
  urls?: InputMaybe<MaterialEpdUrl_Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_epd */
export type MaterialEpd_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_epd" */
export enum MaterialEpd_Select_Column {
  /** column name */
  declarationNumber = 'declarationNumber',
  /** column name */
  epdOwnerId = 'epdOwnerId',
  /** column name */
  epdProductIndustryId = 'epdProductIndustryId',
  /** column name */
  epdSpecificationFormId = 'epdSpecificationFormId',
  /** column name */
  id = 'id',
  /** column name */
  publicationDate = 'publicationDate',
  /** column name */
  version = 'version'
}

/** input type for updating data in table "material_epd" */
export type MaterialEpd_Set_Input = {
  declarationNumber?: InputMaybe<Scalars['String']['input']>;
  epdOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  epdSpecificationFormId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MaterialEpd_Stddev_Fields = {
  __typename?: 'materialEpd_stddev_fields';
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type MaterialEpd_Stddev_Pop_Fields = {
  __typename?: 'materialEpd_stddev_pop_fields';
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type MaterialEpd_Stddev_Samp_Fields = {
  __typename?: 'materialEpd_stddev_samp_fields';
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "materialEpd" */
export type MaterialEpd_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialEpd_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialEpd_Stream_Cursor_Value_Input = {
  declarationNumber?: InputMaybe<Scalars['String']['input']>;
  epdOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  epdSpecificationFormId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  publicationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MaterialEpd_Sum_Fields = {
  __typename?: 'materialEpd_sum_fields';
  epdProductIndustryId?: Maybe<Scalars['Int']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "material_epd" */
export enum MaterialEpd_Update_Column {
  /** column name */
  declarationNumber = 'declarationNumber',
  /** column name */
  epdOwnerId = 'epdOwnerId',
  /** column name */
  epdProductIndustryId = 'epdProductIndustryId',
  /** column name */
  epdSpecificationFormId = 'epdSpecificationFormId',
  /** column name */
  id = 'id',
  /** column name */
  publicationDate = 'publicationDate',
  /** column name */
  version = 'version'
}

export type MaterialEpd_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaterialEpd_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialEpd_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialEpd_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MaterialEpd_Var_Pop_Fields = {
  __typename?: 'materialEpd_var_pop_fields';
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type MaterialEpd_Var_Samp_Fields = {
  __typename?: 'materialEpd_var_samp_fields';
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type MaterialEpd_Variance_Fields = {
  __typename?: 'materialEpd_variance_fields';
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
  epdSpecificationFormId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "material_fork" */
export type MaterialFork = {
  __typename?: 'materialFork';
  createdBy: Scalars['uuid']['output'];
  materialId: Scalars['uuid']['output'];
  materialInternalId: Scalars['String']['output'];
  parentMaterialId: Scalars['uuid']['output'];
  tenantId: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "material_fork" */
export type MaterialFork_Aggregate = {
  __typename?: 'materialFork_aggregate';
  aggregate?: Maybe<MaterialFork_Aggregate_Fields>;
  nodes: Array<MaterialFork>;
};

/** aggregate fields of "material_fork" */
export type MaterialFork_Aggregate_Fields = {
  __typename?: 'materialFork_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialFork_Max_Fields>;
  min?: Maybe<MaterialFork_Min_Fields>;
};


/** aggregate fields of "material_fork" */
export type MaterialFork_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialFork_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "material_fork". All fields are combined with a logical 'AND'. */
export type MaterialFork_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialFork_Bool_Exp>>;
  _not?: InputMaybe<MaterialFork_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialFork_Bool_Exp>>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  materialInternalId?: InputMaybe<String_Comparison_Exp>;
  parentMaterialId?: InputMaybe<Uuid_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedBy?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_fork" */
export enum MaterialFork_Constraint {
  /** unique or primary key constraint on columns "material_id", "parent_material_id" */
  material_fork_pkey = 'material_fork_pkey'
}

/** input type for inserting data into table "material_fork" */
export type MaterialFork_Insert_Input = {
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialInternalId?: InputMaybe<Scalars['String']['input']>;
  parentMaterialId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type MaterialFork_Max_Fields = {
  __typename?: 'materialFork_max_fields';
  createdBy?: Maybe<Scalars['uuid']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialInternalId?: Maybe<Scalars['String']['output']>;
  parentMaterialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type MaterialFork_Min_Fields = {
  __typename?: 'materialFork_min_fields';
  createdBy?: Maybe<Scalars['uuid']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialInternalId?: Maybe<Scalars['String']['output']>;
  parentMaterialId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "material_fork" */
export type MaterialFork_Mutation_Response = {
  __typename?: 'materialFork_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialFork>;
};

/** on_conflict condition type for table "material_fork" */
export type MaterialFork_On_Conflict = {
  constraint: MaterialFork_Constraint;
  update_columns?: Array<MaterialFork_Update_Column>;
  where?: InputMaybe<MaterialFork_Bool_Exp>;
};

/** Ordering options when selecting data from "material_fork". */
export type MaterialFork_Order_By = {
  createdBy?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  materialInternalId?: InputMaybe<Order_By>;
  parentMaterialId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_fork */
export type MaterialFork_Pk_Columns_Input = {
  materialId: Scalars['uuid']['input'];
  parentMaterialId: Scalars['uuid']['input'];
};

/** select columns of table "material_fork" */
export enum MaterialFork_Select_Column {
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  materialId = 'materialId',
  /** column name */
  materialInternalId = 'materialInternalId',
  /** column name */
  parentMaterialId = 'parentMaterialId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedBy = 'updatedBy'
}

/** input type for updating data in table "material_fork" */
export type MaterialFork_Set_Input = {
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialInternalId?: InputMaybe<Scalars['String']['input']>;
  parentMaterialId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "materialFork" */
export type MaterialFork_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialFork_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialFork_Stream_Cursor_Value_Input = {
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialInternalId?: InputMaybe<Scalars['String']['input']>;
  parentMaterialId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "material_fork" */
export enum MaterialFork_Update_Column {
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  materialId = 'materialId',
  /** column name */
  materialInternalId = 'materialInternalId',
  /** column name */
  parentMaterialId = 'parentMaterialId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedBy = 'updatedBy'
}

export type MaterialFork_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialFork_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialFork_Bool_Exp;
};

/** columns and relationships of "material_name" */
export type MaterialName = {
  __typename?: 'materialName';
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  materialId: Scalars['uuid']['output'];
  translationSource: Scalars['String']['output'];
};

/** aggregated selection of "material_name" */
export type MaterialName_Aggregate = {
  __typename?: 'materialName_aggregate';
  aggregate?: Maybe<MaterialName_Aggregate_Fields>;
  nodes: Array<MaterialName>;
};

export type MaterialName_Aggregate_Bool_Exp = {
  count?: InputMaybe<MaterialName_Aggregate_Bool_Exp_Count>;
};

export type MaterialName_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MaterialName_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MaterialName_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "material_name" */
export type MaterialName_Aggregate_Fields = {
  __typename?: 'materialName_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialName_Max_Fields>;
  min?: Maybe<MaterialName_Min_Fields>;
};


/** aggregate fields of "material_name" */
export type MaterialName_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialName_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "material_name" */
export type MaterialName_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MaterialName_Max_Order_By>;
  min?: InputMaybe<MaterialName_Min_Order_By>;
};

/** input type for inserting array relation for remote table "material_name" */
export type MaterialName_Arr_Rel_Insert_Input = {
  data: Array<MaterialName_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialName_On_Conflict>;
};

/** Boolean expression to filter rows from the table "material_name". All fields are combined with a logical 'AND'. */
export type MaterialName_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialName_Bool_Exp>>;
  _not?: InputMaybe<MaterialName_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialName_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_name" */
export enum MaterialName_Constraint {
  /** unique or primary key constraint on columns "material_id", "language_code" */
  material_name_language_code_material_id_key = 'material_name_language_code_material_id_key',
  /** unique or primary key constraint on columns "id" */
  material_name_pkey = 'material_name_pkey'
}

/** input type for inserting data into table "material_name" */
export type MaterialName_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MaterialName_Max_Fields = {
  __typename?: 'materialName_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "material_name" */
export type MaterialName_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MaterialName_Min_Fields = {
  __typename?: 'materialName_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "material_name" */
export type MaterialName_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "material_name" */
export type MaterialName_Mutation_Response = {
  __typename?: 'materialName_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialName>;
};

/** on_conflict condition type for table "material_name" */
export type MaterialName_On_Conflict = {
  constraint: MaterialName_Constraint;
  update_columns?: Array<MaterialName_Update_Column>;
  where?: InputMaybe<MaterialName_Bool_Exp>;
};

/** Ordering options when selecting data from "material_name". */
export type MaterialName_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_name */
export type MaterialName_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_name" */
export enum MaterialName_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  materialId = 'materialId',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "material_name" */
export type MaterialName_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "materialName" */
export type MaterialName_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialName_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialName_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "material_name" */
export enum MaterialName_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  materialId = 'materialId',
  /** column name */
  translationSource = 'translationSource'
}

export type MaterialName_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialName_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialName_Bool_Exp;
};

/** columns and relationships of "material_emission" */
export type MaterialStage = {
  __typename?: 'materialStage';
  id: Scalars['uuid']['output'];
  /** An array relationship */
  indicators: Array<MaterialEmissionIndicator>;
  /** An aggregate relationship */
  indicators_aggregate: MaterialEmissionIndicator_Aggregate;
  materialId: Scalars['uuid']['output'];
  /** An object relationship */
  stage: Stage;
  stageId: Scalars['Int']['output'];
};


/** columns and relationships of "material_emission" */
export type MaterialStageIndicatorsArgs = {
  distinct_on?: InputMaybe<Array<MaterialEmissionIndicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEmissionIndicator_Order_By>>;
  where?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
};


/** columns and relationships of "material_emission" */
export type MaterialStageIndicators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEmissionIndicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEmissionIndicator_Order_By>>;
  where?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
};

/** aggregated selection of "material_emission" */
export type MaterialStage_Aggregate = {
  __typename?: 'materialStage_aggregate';
  aggregate?: Maybe<MaterialStage_Aggregate_Fields>;
  nodes: Array<MaterialStage>;
};

export type MaterialStage_Aggregate_Bool_Exp = {
  count?: InputMaybe<MaterialStage_Aggregate_Bool_Exp_Count>;
};

export type MaterialStage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MaterialStage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MaterialStage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "material_emission" */
export type MaterialStage_Aggregate_Fields = {
  __typename?: 'materialStage_aggregate_fields';
  avg?: Maybe<MaterialStage_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialStage_Max_Fields>;
  min?: Maybe<MaterialStage_Min_Fields>;
  stddev?: Maybe<MaterialStage_Stddev_Fields>;
  stddev_pop?: Maybe<MaterialStage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MaterialStage_Stddev_Samp_Fields>;
  sum?: Maybe<MaterialStage_Sum_Fields>;
  var_pop?: Maybe<MaterialStage_Var_Pop_Fields>;
  var_samp?: Maybe<MaterialStage_Var_Samp_Fields>;
  variance?: Maybe<MaterialStage_Variance_Fields>;
};


/** aggregate fields of "material_emission" */
export type MaterialStage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialStage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "material_emission" */
export type MaterialStage_Aggregate_Order_By = {
  avg?: InputMaybe<MaterialStage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MaterialStage_Max_Order_By>;
  min?: InputMaybe<MaterialStage_Min_Order_By>;
  stddev?: InputMaybe<MaterialStage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MaterialStage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MaterialStage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MaterialStage_Sum_Order_By>;
  var_pop?: InputMaybe<MaterialStage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MaterialStage_Var_Samp_Order_By>;
  variance?: InputMaybe<MaterialStage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "material_emission" */
export type MaterialStage_Arr_Rel_Insert_Input = {
  data: Array<MaterialStage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialStage_On_Conflict>;
};

/** aggregate avg on columns */
export type MaterialStage_Avg_Fields = {
  __typename?: 'materialStage_avg_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "material_emission" */
export type MaterialStage_Avg_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "material_emission". All fields are combined with a logical 'AND'. */
export type MaterialStage_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialStage_Bool_Exp>>;
  _not?: InputMaybe<MaterialStage_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialStage_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicators?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
  indicators_aggregate?: InputMaybe<MaterialEmissionIndicator_Aggregate_Bool_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  stage?: InputMaybe<Stage_Bool_Exp>;
  stageId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_emission" */
export enum MaterialStage_Constraint {
  /** unique or primary key constraint on columns "id" */
  material_emission_pkey = 'material_emission_pkey',
  /** unique or primary key constraint on columns "stage_id", "material_id" */
  material_emission_stage_id_material_id_key = 'material_emission_stage_id_material_id_key'
}

/** input type for incrementing numeric columns in table "material_emission" */
export type MaterialStage_Inc_Input = {
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "material_emission" */
export type MaterialStage_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicators?: InputMaybe<MaterialEmissionIndicator_Arr_Rel_Insert_Input>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  stage?: InputMaybe<Stage_Obj_Rel_Insert_Input>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type MaterialStage_Max_Fields = {
  __typename?: 'materialStage_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "material_emission" */
export type MaterialStage_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MaterialStage_Min_Fields = {
  __typename?: 'materialStage_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "material_emission" */
export type MaterialStage_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "material_emission" */
export type MaterialStage_Mutation_Response = {
  __typename?: 'materialStage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialStage>;
};

/** on_conflict condition type for table "material_emission" */
export type MaterialStage_On_Conflict = {
  constraint: MaterialStage_Constraint;
  update_columns?: Array<MaterialStage_Update_Column>;
  where?: InputMaybe<MaterialStage_Bool_Exp>;
};

/** Ordering options when selecting data from "material_emission". */
export type MaterialStage_Order_By = {
  id?: InputMaybe<Order_By>;
  indicators_aggregate?: InputMaybe<MaterialEmissionIndicator_Aggregate_Order_By>;
  materialId?: InputMaybe<Order_By>;
  stage?: InputMaybe<Stage_Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_emission */
export type MaterialStage_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_emission" */
export enum MaterialStage_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  materialId = 'materialId',
  /** column name */
  stageId = 'stageId'
}

/** input type for updating data in table "material_emission" */
export type MaterialStage_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type MaterialStage_Stddev_Fields = {
  __typename?: 'materialStage_stddev_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "material_emission" */
export type MaterialStage_Stddev_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MaterialStage_Stddev_Pop_Fields = {
  __typename?: 'materialStage_stddev_pop_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "material_emission" */
export type MaterialStage_Stddev_Pop_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MaterialStage_Stddev_Samp_Fields = {
  __typename?: 'materialStage_stddev_samp_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "material_emission" */
export type MaterialStage_Stddev_Samp_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "materialStage" */
export type MaterialStage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialStage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialStage_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type MaterialStage_Sum_Fields = {
  __typename?: 'materialStage_sum_fields';
  stageId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "material_emission" */
export type MaterialStage_Sum_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** update columns of table "material_emission" */
export enum MaterialStage_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  materialId = 'materialId',
  /** column name */
  stageId = 'stageId'
}

export type MaterialStage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaterialStage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialStage_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialStage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MaterialStage_Var_Pop_Fields = {
  __typename?: 'materialStage_var_pop_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "material_emission" */
export type MaterialStage_Var_Pop_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MaterialStage_Var_Samp_Fields = {
  __typename?: 'materialStage_var_samp_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "material_emission" */
export type MaterialStage_Var_Samp_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MaterialStage_Variance_Fields = {
  __typename?: 'materialStage_variance_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "material_emission" */
export type MaterialStage_Variance_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** columns and relationships of "material_type" */
export type MaterialType = {
  __typename?: 'materialType';
  value: Scalars['String']['output'];
};

/** aggregated selection of "material_type" */
export type MaterialType_Aggregate = {
  __typename?: 'materialType_aggregate';
  aggregate?: Maybe<MaterialType_Aggregate_Fields>;
  nodes: Array<MaterialType>;
};

/** aggregate fields of "material_type" */
export type MaterialType_Aggregate_Fields = {
  __typename?: 'materialType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialType_Max_Fields>;
  min?: Maybe<MaterialType_Min_Fields>;
};


/** aggregate fields of "material_type" */
export type MaterialType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "material_type". All fields are combined with a logical 'AND'. */
export type MaterialType_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialType_Bool_Exp>>;
  _not?: InputMaybe<MaterialType_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialType_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_type" */
export enum MaterialType_Constraint {
  /** unique or primary key constraint on columns "value" */
  material_type_pkey = 'material_type_pkey'
}

export enum MaterialType_Enum {
  CUSTOM = 'CUSTOM',
  EPD = 'EPD'
}

/** Boolean expression to compare columns of type "materialType_enum". All fields are combined with logical 'AND'. */
export type MaterialType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<MaterialType_Enum>;
  _in?: InputMaybe<Array<MaterialType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<MaterialType_Enum>;
  _nin?: InputMaybe<Array<MaterialType_Enum>>;
};

/** input type for inserting data into table "material_type" */
export type MaterialType_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MaterialType_Max_Fields = {
  __typename?: 'materialType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MaterialType_Min_Fields = {
  __typename?: 'materialType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "material_type" */
export type MaterialType_Mutation_Response = {
  __typename?: 'materialType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialType>;
};

/** on_conflict condition type for table "material_type" */
export type MaterialType_On_Conflict = {
  constraint: MaterialType_Constraint;
  update_columns?: Array<MaterialType_Update_Column>;
  where?: InputMaybe<MaterialType_Bool_Exp>;
};

/** Ordering options when selecting data from "material_type". */
export type MaterialType_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_type */
export type MaterialType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "material_type" */
export enum MaterialType_Select_Column {
  /** column name */
  value = 'value'
}

/** input type for updating data in table "material_type" */
export type MaterialType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "materialType" */
export type MaterialType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "material_type" */
export enum MaterialType_Update_Column {
  /** column name */
  value = 'value'
}

export type MaterialType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialType_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialType_Bool_Exp;
};

/** columns and relationships of "material_waste_source" */
export type MaterialWasteSource = {
  __typename?: 'materialWasteSource';
  country: Country_Enum;
  /** An object relationship */
  denominatorUnit?: Maybe<DenominatorUnit>;
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indicatorType?: Maybe<IndicatorType>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  materialWasteTypes: Array<MaterialWasteType>;
  /** An aggregate relationship */
  materialWasteTypes_aggregate: MaterialWasteType_Aggregate;
  shortName?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "material_waste_source" */
export type MaterialWasteSourceMaterialWasteTypesArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteType_Order_By>>;
  where?: InputMaybe<MaterialWasteType_Bool_Exp>;
};


/** columns and relationships of "material_waste_source" */
export type MaterialWasteSourceMaterialWasteTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteType_Order_By>>;
  where?: InputMaybe<MaterialWasteType_Bool_Exp>;
};

/** aggregated selection of "material_waste_source" */
export type MaterialWasteSource_Aggregate = {
  __typename?: 'materialWasteSource_aggregate';
  aggregate?: Maybe<MaterialWasteSource_Aggregate_Fields>;
  nodes: Array<MaterialWasteSource>;
};

/** aggregate fields of "material_waste_source" */
export type MaterialWasteSource_Aggregate_Fields = {
  __typename?: 'materialWasteSource_aggregate_fields';
  avg?: Maybe<MaterialWasteSource_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialWasteSource_Max_Fields>;
  min?: Maybe<MaterialWasteSource_Min_Fields>;
  stddev?: Maybe<MaterialWasteSource_Stddev_Fields>;
  stddev_pop?: Maybe<MaterialWasteSource_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MaterialWasteSource_Stddev_Samp_Fields>;
  sum?: Maybe<MaterialWasteSource_Sum_Fields>;
  var_pop?: Maybe<MaterialWasteSource_Var_Pop_Fields>;
  var_samp?: Maybe<MaterialWasteSource_Var_Samp_Fields>;
  variance?: Maybe<MaterialWasteSource_Variance_Fields>;
};


/** aggregate fields of "material_waste_source" */
export type MaterialWasteSource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialWasteSource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type MaterialWasteSource_Avg_Fields = {
  __typename?: 'materialWasteSource_avg_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "material_waste_source". All fields are combined with a logical 'AND'. */
export type MaterialWasteSource_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialWasteSource_Bool_Exp>>;
  _not?: InputMaybe<MaterialWasteSource_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialWasteSource_Bool_Exp>>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Bool_Exp>;
  denominatorUnitId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  indicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
  materialWasteTypes?: InputMaybe<MaterialWasteType_Bool_Exp>;
  materialWasteTypes_aggregate?: InputMaybe<MaterialWasteType_Aggregate_Bool_Exp>;
  shortName?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  sourceName?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unitId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "material_waste_source" */
export enum MaterialWasteSource_Constraint {
  /** unique or primary key constraint on columns "id" */
  material_waste_source_pkey = 'material_waste_source_pkey'
}

/** input type for incrementing numeric columns in table "material_waste_source" */
export type MaterialWasteSource_Inc_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "material_waste_source" */
export type MaterialWasteSource_Insert_Input = {
  country?: InputMaybe<Country_Enum>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Obj_Rel_Insert_Input>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  materialWasteTypes?: InputMaybe<MaterialWasteType_Arr_Rel_Insert_Input>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type MaterialWasteSource_Max_Fields = {
  __typename?: 'materialWasteSource_max_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type MaterialWasteSource_Min_Fields = {
  __typename?: 'materialWasteSource_min_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "material_waste_source" */
export type MaterialWasteSource_Mutation_Response = {
  __typename?: 'materialWasteSource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialWasteSource>;
};

/** input type for inserting object relation for remote table "material_waste_source" */
export type MaterialWasteSource_Obj_Rel_Insert_Input = {
  data: MaterialWasteSource_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialWasteSource_On_Conflict>;
};

/** on_conflict condition type for table "material_waste_source" */
export type MaterialWasteSource_On_Conflict = {
  constraint: MaterialWasteSource_Constraint;
  update_columns?: Array<MaterialWasteSource_Update_Column>;
  where?: InputMaybe<MaterialWasteSource_Bool_Exp>;
};

/** Ordering options when selecting data from "material_waste_source". */
export type MaterialWasteSource_Order_By = {
  country?: InputMaybe<Order_By>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Order_By>;
  denominatorUnitId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicatorType?: InputMaybe<IndicatorType_Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  materialWasteTypes_aggregate?: InputMaybe<MaterialWasteType_Aggregate_Order_By>;
  shortName?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  sourceName?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unitId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: material_waste_source */
export type MaterialWasteSource_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_waste_source" */
export enum MaterialWasteSource_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  shortName = 'shortName',
  /** column name */
  source = 'source',
  /** column name */
  sourceName = 'sourceName',
  /** column name */
  unitId = 'unitId'
}

/** input type for updating data in table "material_waste_source" */
export type MaterialWasteSource_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type MaterialWasteSource_Stddev_Fields = {
  __typename?: 'materialWasteSource_stddev_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type MaterialWasteSource_Stddev_Pop_Fields = {
  __typename?: 'materialWasteSource_stddev_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type MaterialWasteSource_Stddev_Samp_Fields = {
  __typename?: 'materialWasteSource_stddev_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "materialWasteSource" */
export type MaterialWasteSource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialWasteSource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialWasteSource_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type MaterialWasteSource_Sum_Fields = {
  __typename?: 'materialWasteSource_sum_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "material_waste_source" */
export enum MaterialWasteSource_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  shortName = 'shortName',
  /** column name */
  source = 'source',
  /** column name */
  sourceName = 'sourceName',
  /** column name */
  unitId = 'unitId'
}

export type MaterialWasteSource_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaterialWasteSource_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialWasteSource_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialWasteSource_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MaterialWasteSource_Var_Pop_Fields = {
  __typename?: 'materialWasteSource_var_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type MaterialWasteSource_Var_Samp_Fields = {
  __typename?: 'materialWasteSource_var_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type MaterialWasteSource_Variance_Fields = {
  __typename?: 'materialWasteSource_variance_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "material_waste_type" */
export type MaterialWasteType = {
  __typename?: 'materialWasteType';
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  materialWasteSourceId: Scalars['uuid']['output'];
  value: Scalars['numeric']['output'];
  /** An object relationship */
  wasteSource: MaterialWasteSource;
};

/** aggregated selection of "material_waste_type" */
export type MaterialWasteType_Aggregate = {
  __typename?: 'materialWasteType_aggregate';
  aggregate?: Maybe<MaterialWasteType_Aggregate_Fields>;
  nodes: Array<MaterialWasteType>;
};

export type MaterialWasteType_Aggregate_Bool_Exp = {
  count?: InputMaybe<MaterialWasteType_Aggregate_Bool_Exp_Count>;
};

export type MaterialWasteType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MaterialWasteType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MaterialWasteType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "material_waste_type" */
export type MaterialWasteType_Aggregate_Fields = {
  __typename?: 'materialWasteType_aggregate_fields';
  avg?: Maybe<MaterialWasteType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialWasteType_Max_Fields>;
  min?: Maybe<MaterialWasteType_Min_Fields>;
  stddev?: Maybe<MaterialWasteType_Stddev_Fields>;
  stddev_pop?: Maybe<MaterialWasteType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MaterialWasteType_Stddev_Samp_Fields>;
  sum?: Maybe<MaterialWasteType_Sum_Fields>;
  var_pop?: Maybe<MaterialWasteType_Var_Pop_Fields>;
  var_samp?: Maybe<MaterialWasteType_Var_Samp_Fields>;
  variance?: Maybe<MaterialWasteType_Variance_Fields>;
};


/** aggregate fields of "material_waste_type" */
export type MaterialWasteType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MaterialWasteType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "material_waste_type" */
export type MaterialWasteType_Aggregate_Order_By = {
  avg?: InputMaybe<MaterialWasteType_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MaterialWasteType_Max_Order_By>;
  min?: InputMaybe<MaterialWasteType_Min_Order_By>;
  stddev?: InputMaybe<MaterialWasteType_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MaterialWasteType_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MaterialWasteType_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MaterialWasteType_Sum_Order_By>;
  var_pop?: InputMaybe<MaterialWasteType_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MaterialWasteType_Var_Samp_Order_By>;
  variance?: InputMaybe<MaterialWasteType_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "material_waste_type" */
export type MaterialWasteType_Arr_Rel_Insert_Input = {
  data: Array<MaterialWasteType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialWasteType_On_Conflict>;
};

/** aggregate avg on columns */
export type MaterialWasteType_Avg_Fields = {
  __typename?: 'materialWasteType_avg_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "material_waste_type" */
export type MaterialWasteType_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "material_waste_type". All fields are combined with a logical 'AND'. */
export type MaterialWasteType_Bool_Exp = {
  _and?: InputMaybe<Array<MaterialWasteType_Bool_Exp>>;
  _not?: InputMaybe<MaterialWasteType_Bool_Exp>;
  _or?: InputMaybe<Array<MaterialWasteType_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  materialCategoryId?: InputMaybe<String_Comparison_Exp>;
  materialWasteSourceId?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
  wasteSource?: InputMaybe<MaterialWasteSource_Bool_Exp>;
};

/** unique or primary key constraints on table "material_waste_type" */
export enum MaterialWasteType_Constraint {
  /** unique or primary key constraint on columns "id" */
  material_waste_pkey = 'material_waste_pkey'
}

/** input type for incrementing numeric columns in table "material_waste_type" */
export type MaterialWasteType_Inc_Input = {
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "material_waste_type" */
export type MaterialWasteType_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  materialWasteSourceId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
  wasteSource?: InputMaybe<MaterialWasteSource_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type MaterialWasteType_Max_Fields = {
  __typename?: 'materialWasteType_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  materialWasteSourceId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "material_waste_type" */
export type MaterialWasteType_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  materialCategoryId?: InputMaybe<Order_By>;
  materialWasteSourceId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MaterialWasteType_Min_Fields = {
  __typename?: 'materialWasteType_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  materialWasteSourceId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "material_waste_type" */
export type MaterialWasteType_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  materialCategoryId?: InputMaybe<Order_By>;
  materialWasteSourceId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "material_waste_type" */
export type MaterialWasteType_Mutation_Response = {
  __typename?: 'materialWasteType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialWasteType>;
};

/** input type for inserting object relation for remote table "material_waste_type" */
export type MaterialWasteType_Obj_Rel_Insert_Input = {
  data: MaterialWasteType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialWasteType_On_Conflict>;
};

/** on_conflict condition type for table "material_waste_type" */
export type MaterialWasteType_On_Conflict = {
  constraint: MaterialWasteType_Constraint;
  update_columns?: Array<MaterialWasteType_Update_Column>;
  where?: InputMaybe<MaterialWasteType_Bool_Exp>;
};

/** Ordering options when selecting data from "material_waste_type". */
export type MaterialWasteType_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  materialCategoryId?: InputMaybe<Order_By>;
  materialWasteSourceId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  wasteSource?: InputMaybe<MaterialWasteSource_Order_By>;
};

/** primary key columns input for table: material_waste_type */
export type MaterialWasteType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material_waste_type" */
export enum MaterialWasteType_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  materialCategoryId = 'materialCategoryId',
  /** column name */
  materialWasteSourceId = 'materialWasteSourceId',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "material_waste_type" */
export type MaterialWasteType_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  materialWasteSourceId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type MaterialWasteType_Stddev_Fields = {
  __typename?: 'materialWasteType_stddev_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "material_waste_type" */
export type MaterialWasteType_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MaterialWasteType_Stddev_Pop_Fields = {
  __typename?: 'materialWasteType_stddev_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "material_waste_type" */
export type MaterialWasteType_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MaterialWasteType_Stddev_Samp_Fields = {
  __typename?: 'materialWasteType_stddev_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "material_waste_type" */
export type MaterialWasteType_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "materialWasteType" */
export type MaterialWasteType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MaterialWasteType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialWasteType_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  materialWasteSourceId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type MaterialWasteType_Sum_Fields = {
  __typename?: 'materialWasteType_sum_fields';
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "material_waste_type" */
export type MaterialWasteType_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** update columns of table "material_waste_type" */
export enum MaterialWasteType_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  materialCategoryId = 'materialCategoryId',
  /** column name */
  materialWasteSourceId = 'materialWasteSourceId',
  /** column name */
  value = 'value'
}

export type MaterialWasteType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaterialWasteType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialWasteType_Set_Input>;
  /** filter the rows which have to be updated */
  where: MaterialWasteType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MaterialWasteType_Var_Pop_Fields = {
  __typename?: 'materialWasteType_var_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "material_waste_type" */
export type MaterialWasteType_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MaterialWasteType_Var_Samp_Fields = {
  __typename?: 'materialWasteType_var_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "material_waste_type" */
export type MaterialWasteType_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MaterialWasteType_Variance_Fields = {
  __typename?: 'materialWasteType_variance_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "material_waste_type" */
export type MaterialWasteType_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregated selection of "material" */
export type Material_Aggregate = {
  __typename?: 'material_aggregate';
  aggregate?: Maybe<Material_Aggregate_Fields>;
  nodes: Array<Material>;
};

/** aggregate fields of "material" */
export type Material_Aggregate_Fields = {
  __typename?: 'material_aggregate_fields';
  avg?: Maybe<Material_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Material_Max_Fields>;
  min?: Maybe<Material_Min_Fields>;
  stddev?: Maybe<Material_Stddev_Fields>;
  stddev_pop?: Maybe<Material_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Material_Stddev_Samp_Fields>;
  sum?: Maybe<Material_Sum_Fields>;
  var_pop?: Maybe<Material_Var_Pop_Fields>;
  var_samp?: Maybe<Material_Var_Samp_Fields>;
  variance?: Maybe<Material_Variance_Fields>;
};


/** aggregate fields of "material" */
export type Material_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Material_Avg_Fields = {
  __typename?: 'material_avg_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "material". All fields are combined with a logical 'AND'. */
export type Material_Bool_Exp = {
  _and?: InputMaybe<Array<Material_Bool_Exp>>;
  _not?: InputMaybe<Material_Bool_Exp>;
  _or?: InputMaybe<Array<Material_Bool_Exp>>;
  biogenicParams?: InputMaybe<MaterialBiogenicParams_Bool_Exp>;
  category?: InputMaybe<MaterialCategory_Bool_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  declaredUnit?: InputMaybe<DeclaredUnit_Bool_Exp>;
  declaredUnitId?: InputMaybe<Uuid_Comparison_Exp>;
  deprecated?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  descriptions?: InputMaybe<MaterialDescription_Bool_Exp>;
  descriptions_aggregate?: InputMaybe<MaterialDescription_Aggregate_Bool_Exp>;
  emissions?: InputMaybe<MaterialStage_Bool_Exp>;
  emissions_aggregate?: InputMaybe<MaterialStage_Aggregate_Bool_Exp>;
  epd?: InputMaybe<MaterialEpd_Bool_Exp>;
  faulty?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internalId?: InputMaybe<String_Comparison_Exp>;
  isPublic?: InputMaybe<Boolean_Comparison_Exp>;
  lifetime?: InputMaybe<Int_Comparison_Exp>;
  materialBiogenicParamsId?: InputMaybe<Uuid_Comparison_Exp>;
  materialEpdId?: InputMaybe<Uuid_Comparison_Exp>;
  materialMassUnitId?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  names?: InputMaybe<MaterialName_Bool_Exp>;
  names_aggregate?: InputMaybe<MaterialName_Aggregate_Bool_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<MaterialType_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedBy?: InputMaybe<Uuid_Comparison_Exp>;
  validTo?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
  weightPerDeclaredUnit?: InputMaybe<WeightPerDeclaredUnit_Bool_Exp>;
};

/** unique or primary key constraints on table "material" */
export enum Material_Constraint {
  /** unique or primary key constraint on columns "internal_id", "version" */
  material_internal_id_version_key = 'material_internal_id_version_key',
  /** unique or primary key constraint on columns "id" */
  material_pkey = 'material_pkey'
}

/** input type for incrementing numeric columns in table "material" */
export type Material_Inc_Input = {
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "material" */
export type Material_Insert_Input = {
  biogenicParams?: InputMaybe<MaterialBiogenicParams_Obj_Rel_Insert_Input>;
  category?: InputMaybe<MaterialCategory_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  declaredUnit?: InputMaybe<DeclaredUnit_Obj_Rel_Insert_Input>;
  declaredUnitId?: InputMaybe<Scalars['uuid']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  descriptions?: InputMaybe<MaterialDescription_Arr_Rel_Insert_Input>;
  emissions?: InputMaybe<MaterialStage_Arr_Rel_Insert_Input>;
  epd?: InputMaybe<MaterialEpd_Obj_Rel_Insert_Input>;
  faulty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  materialBiogenicParamsId?: InputMaybe<Scalars['uuid']['input']>;
  materialEpdId?: InputMaybe<Scalars['uuid']['input']>;
  materialMassUnitId?: InputMaybe<Scalars['uuid']['input']>;
  names?: InputMaybe<MaterialName_Arr_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<MaterialType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  validTo?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  weightPerDeclaredUnit?: InputMaybe<WeightPerDeclaredUnit_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Material_Max_Fields = {
  __typename?: 'material_max_fields';
  categoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  declaredUnitId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field that returns a translated description based on languages in token with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internalId?: Maybe<Scalars['String']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialBiogenicParamsId?: Maybe<Scalars['uuid']['output']>;
  materialEpdId?: Maybe<Scalars['uuid']['output']>;
  materialMassUnitId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field that returns a translated name based on languages in token with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
  validTo?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Material_Min_Fields = {
  __typename?: 'material_min_fields';
  categoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  declaredUnitId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field that returns a translated description based on languages in token with fallback to English */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internalId?: Maybe<Scalars['String']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
  materialBiogenicParamsId?: Maybe<Scalars['uuid']['output']>;
  materialEpdId?: Maybe<Scalars['uuid']['output']>;
  materialMassUnitId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field that returns a translated name based on languages in token with fallback to English */
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
  validTo?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "material" */
export type Material_Mutation_Response = {
  __typename?: 'material_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Material>;
};

/** input type for inserting object relation for remote table "material" */
export type Material_Obj_Rel_Insert_Input = {
  data: Material_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Material_On_Conflict>;
};

/** on_conflict condition type for table "material" */
export type Material_On_Conflict = {
  constraint: Material_Constraint;
  update_columns?: Array<Material_Update_Column>;
  where?: InputMaybe<Material_Bool_Exp>;
};

/** Ordering options when selecting data from "material". */
export type Material_Order_By = {
  biogenicParams?: InputMaybe<MaterialBiogenicParams_Order_By>;
  category?: InputMaybe<MaterialCategory_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  declaredUnit?: InputMaybe<DeclaredUnit_Order_By>;
  declaredUnitId?: InputMaybe<Order_By>;
  deprecated?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  descriptions_aggregate?: InputMaybe<MaterialDescription_Aggregate_Order_By>;
  emissions_aggregate?: InputMaybe<MaterialStage_Aggregate_Order_By>;
  epd?: InputMaybe<MaterialEpd_Order_By>;
  faulty?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internalId?: InputMaybe<Order_By>;
  isPublic?: InputMaybe<Order_By>;
  lifetime?: InputMaybe<Order_By>;
  materialBiogenicParamsId?: InputMaybe<Order_By>;
  materialEpdId?: InputMaybe<Order_By>;
  materialMassUnitId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  names_aggregate?: InputMaybe<MaterialName_Aggregate_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  validTo?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
  weightPerDeclaredUnit?: InputMaybe<WeightPerDeclaredUnit_Order_By>;
};

/** primary key columns input for table: material */
export type Material_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "material" */
export enum Material_Select_Column {
  /** column name */
  categoryId = 'categoryId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  declaredUnitId = 'declaredUnitId',
  /** column name */
  deprecated = 'deprecated',
  /** column name */
  faulty = 'faulty',
  /** column name */
  id = 'id',
  /** column name */
  internalId = 'internalId',
  /** column name */
  isPublic = 'isPublic',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  materialBiogenicParamsId = 'materialBiogenicParamsId',
  /** column name */
  materialEpdId = 'materialEpdId',
  /** column name */
  materialMassUnitId = 'materialMassUnitId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  updatedBy = 'updatedBy',
  /** column name */
  validTo = 'validTo',
  /** column name */
  version = 'version'
}

/** input type for updating data in table "material" */
export type Material_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  declaredUnitId?: InputMaybe<Scalars['uuid']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  faulty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  materialBiogenicParamsId?: InputMaybe<Scalars['uuid']['input']>;
  materialEpdId?: InputMaybe<Scalars['uuid']['input']>;
  materialMassUnitId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<MaterialType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  validTo?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Material_Stddev_Fields = {
  __typename?: 'material_stddev_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Material_Stddev_Pop_Fields = {
  __typename?: 'material_stddev_pop_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Material_Stddev_Samp_Fields = {
  __typename?: 'material_stddev_samp_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "material" */
export type Material_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Material_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Material_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  declaredUnitId?: InputMaybe<Scalars['uuid']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  faulty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  lifetime?: InputMaybe<Scalars['Int']['input']>;
  materialBiogenicParamsId?: InputMaybe<Scalars['uuid']['input']>;
  materialEpdId?: InputMaybe<Scalars['uuid']['input']>;
  materialMassUnitId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<MaterialType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  validTo?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Material_Sum_Fields = {
  __typename?: 'material_sum_fields';
  lifetime?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "material" */
export enum Material_Update_Column {
  /** column name */
  categoryId = 'categoryId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  declaredUnitId = 'declaredUnitId',
  /** column name */
  deprecated = 'deprecated',
  /** column name */
  faulty = 'faulty',
  /** column name */
  id = 'id',
  /** column name */
  internalId = 'internalId',
  /** column name */
  isPublic = 'isPublic',
  /** column name */
  lifetime = 'lifetime',
  /** column name */
  materialBiogenicParamsId = 'materialBiogenicParamsId',
  /** column name */
  materialEpdId = 'materialEpdId',
  /** column name */
  materialMassUnitId = 'materialMassUnitId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  updatedBy = 'updatedBy',
  /** column name */
  validTo = 'validTo',
  /** column name */
  version = 'version'
}

export type Material_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Material_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Material_Set_Input>;
  /** filter the rows which have to be updated */
  where: Material_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Material_Var_Pop_Fields = {
  __typename?: 'material_var_pop_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Material_Var_Samp_Fields = {
  __typename?: 'material_var_samp_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Material_Variance_Fields = {
  __typename?: 'material_variance_fields';
  lifetime?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mcp_connection" */
export type McpConnection = {
  __typename?: 'mcpConnection';
  clientFingerprint: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  scopes: Scalars['jsonb']['output'];
  tenantId: Scalars['uuid']['output'];
  userId: Scalars['String']['output'];
};


/** columns and relationships of "mcp_connection" */
export type McpConnectionScopesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "mcp_connection" */
export type McpConnection_Aggregate = {
  __typename?: 'mcpConnection_aggregate';
  aggregate?: Maybe<McpConnection_Aggregate_Fields>;
  nodes: Array<McpConnection>;
};

/** aggregate fields of "mcp_connection" */
export type McpConnection_Aggregate_Fields = {
  __typename?: 'mcpConnection_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<McpConnection_Max_Fields>;
  min?: Maybe<McpConnection_Min_Fields>;
};


/** aggregate fields of "mcp_connection" */
export type McpConnection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<McpConnection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type McpConnection_Append_Input = {
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "mcp_connection". All fields are combined with a logical 'AND'. */
export type McpConnection_Bool_Exp = {
  _and?: InputMaybe<Array<McpConnection_Bool_Exp>>;
  _not?: InputMaybe<McpConnection_Bool_Exp>;
  _or?: InputMaybe<Array<McpConnection_Bool_Exp>>;
  clientFingerprint?: InputMaybe<String_Comparison_Exp>;
  clientName?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  scopes?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mcp_connection" */
export enum McpConnection_Constraint {
  /** unique or primary key constraint on columns "id" */
  mcp_connection_pkey = 'mcp_connection_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type McpConnection_Delete_At_Path_Input = {
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type McpConnection_Delete_Elem_Input = {
  scopes?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type McpConnection_Delete_Key_Input = {
  scopes?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "mcp_connection" */
export type McpConnection_Insert_Input = {
  clientFingerprint?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type McpConnection_Max_Fields = {
  __typename?: 'mcpConnection_max_fields';
  clientFingerprint?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type McpConnection_Min_Fields = {
  __typename?: 'mcpConnection_min_fields';
  clientFingerprint?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mcp_connection" */
export type McpConnection_Mutation_Response = {
  __typename?: 'mcpConnection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<McpConnection>;
};

/** on_conflict condition type for table "mcp_connection" */
export type McpConnection_On_Conflict = {
  constraint: McpConnection_Constraint;
  update_columns?: Array<McpConnection_Update_Column>;
  where?: InputMaybe<McpConnection_Bool_Exp>;
};

/** Ordering options when selecting data from "mcp_connection". */
export type McpConnection_Order_By = {
  clientFingerprint?: InputMaybe<Order_By>;
  clientName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mcp_connection */
export type McpConnection_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type McpConnection_Prepend_Input = {
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "mcp_connection" */
export enum McpConnection_Select_Column {
  /** column name */
  clientFingerprint = 'clientFingerprint',
  /** column name */
  clientName = 'clientName',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  scopes = 'scopes',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "mcp_connection" */
export type McpConnection_Set_Input = {
  clientFingerprint?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mcpConnection" */
export type McpConnection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: McpConnection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type McpConnection_Stream_Cursor_Value_Input = {
  clientFingerprint?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mcp_connection" */
export enum McpConnection_Update_Column {
  /** column name */
  clientFingerprint = 'clientFingerprint',
  /** column name */
  clientName = 'clientName',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  scopes = 'scopes',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId'
}

export type McpConnection_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<McpConnection_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<McpConnection_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<McpConnection_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<McpConnection_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<McpConnection_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<McpConnection_Set_Input>;
  /** filter the rows which have to be updated */
  where: McpConnection_Bool_Exp;
};

/** columns and relationships of "mcp_tool_call" */
export type McpToolCall = {
  __typename?: 'mcpToolCall';
  clientFingerprint?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  durationMs: Scalars['Int']['output'];
  endpoint: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  ok: Scalars['Boolean']['output'];
  tenantId: Scalars['uuid']['output'];
  tool: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** aggregated selection of "mcp_tool_call" */
export type McpToolCall_Aggregate = {
  __typename?: 'mcpToolCall_aggregate';
  aggregate?: Maybe<McpToolCall_Aggregate_Fields>;
  nodes: Array<McpToolCall>;
};

/** aggregate fields of "mcp_tool_call" */
export type McpToolCall_Aggregate_Fields = {
  __typename?: 'mcpToolCall_aggregate_fields';
  avg?: Maybe<McpToolCall_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<McpToolCall_Max_Fields>;
  min?: Maybe<McpToolCall_Min_Fields>;
  stddev?: Maybe<McpToolCall_Stddev_Fields>;
  stddev_pop?: Maybe<McpToolCall_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<McpToolCall_Stddev_Samp_Fields>;
  sum?: Maybe<McpToolCall_Sum_Fields>;
  var_pop?: Maybe<McpToolCall_Var_Pop_Fields>;
  var_samp?: Maybe<McpToolCall_Var_Samp_Fields>;
  variance?: Maybe<McpToolCall_Variance_Fields>;
};


/** aggregate fields of "mcp_tool_call" */
export type McpToolCall_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<McpToolCall_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type McpToolCall_Avg_Fields = {
  __typename?: 'mcpToolCall_avg_fields';
  durationMs?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mcp_tool_call". All fields are combined with a logical 'AND'. */
export type McpToolCall_Bool_Exp = {
  _and?: InputMaybe<Array<McpToolCall_Bool_Exp>>;
  _not?: InputMaybe<McpToolCall_Bool_Exp>;
  _or?: InputMaybe<Array<McpToolCall_Bool_Exp>>;
  clientFingerprint?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  durationMs?: InputMaybe<Int_Comparison_Exp>;
  endpoint?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ok?: InputMaybe<Boolean_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  tool?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mcp_tool_call" */
export enum McpToolCall_Constraint {
  /** unique or primary key constraint on columns "id" */
  mcp_tool_call_pkey = 'mcp_tool_call_pkey'
}

/** input type for incrementing numeric columns in table "mcp_tool_call" */
export type McpToolCall_Inc_Input = {
  durationMs?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mcp_tool_call" */
export type McpToolCall_Insert_Input = {
  clientFingerprint?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ok?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type McpToolCall_Max_Fields = {
  __typename?: 'mcpToolCall_max_fields';
  clientFingerprint?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  tool?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type McpToolCall_Min_Fields = {
  __typename?: 'mcpToolCall_min_fields';
  clientFingerprint?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  tool?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mcp_tool_call" */
export type McpToolCall_Mutation_Response = {
  __typename?: 'mcpToolCall_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<McpToolCall>;
};

/** on_conflict condition type for table "mcp_tool_call" */
export type McpToolCall_On_Conflict = {
  constraint: McpToolCall_Constraint;
  update_columns?: Array<McpToolCall_Update_Column>;
  where?: InputMaybe<McpToolCall_Bool_Exp>;
};

/** Ordering options when selecting data from "mcp_tool_call". */
export type McpToolCall_Order_By = {
  clientFingerprint?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  durationMs?: InputMaybe<Order_By>;
  endpoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ok?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tool?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mcp_tool_call */
export type McpToolCall_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mcp_tool_call" */
export enum McpToolCall_Select_Column {
  /** column name */
  clientFingerprint = 'clientFingerprint',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  durationMs = 'durationMs',
  /** column name */
  endpoint = 'endpoint',
  /** column name */
  id = 'id',
  /** column name */
  ok = 'ok',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  tool = 'tool',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "mcp_tool_call" */
export type McpToolCall_Set_Input = {
  clientFingerprint?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ok?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type McpToolCall_Stddev_Fields = {
  __typename?: 'mcpToolCall_stddev_fields';
  durationMs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type McpToolCall_Stddev_Pop_Fields = {
  __typename?: 'mcpToolCall_stddev_pop_fields';
  durationMs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type McpToolCall_Stddev_Samp_Fields = {
  __typename?: 'mcpToolCall_stddev_samp_fields';
  durationMs?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mcpToolCall" */
export type McpToolCall_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: McpToolCall_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type McpToolCall_Stream_Cursor_Value_Input = {
  clientFingerprint?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ok?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type McpToolCall_Sum_Fields = {
  __typename?: 'mcpToolCall_sum_fields';
  durationMs?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "mcp_tool_call" */
export enum McpToolCall_Update_Column {
  /** column name */
  clientFingerprint = 'clientFingerprint',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  durationMs = 'durationMs',
  /** column name */
  endpoint = 'endpoint',
  /** column name */
  id = 'id',
  /** column name */
  ok = 'ok',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  tool = 'tool',
  /** column name */
  userId = 'userId'
}

export type McpToolCall_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<McpToolCall_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<McpToolCall_Set_Input>;
  /** filter the rows which have to be updated */
  where: McpToolCall_Bool_Exp;
};

/** aggregate var_pop on columns */
export type McpToolCall_Var_Pop_Fields = {
  __typename?: 'mcpToolCall_var_pop_fields';
  durationMs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type McpToolCall_Var_Samp_Fields = {
  __typename?: 'mcpToolCall_var_samp_fields';
  durationMs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type McpToolCall_Variance_Fields = {
  __typename?: 'mcpToolCall_variance_fields';
  durationMs?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "model" */
export type Model = {
  __typename?: 'model';
  country: Country_Enum;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "model" */
export type Model_Aggregate = {
  __typename?: 'model_aggregate';
  aggregate?: Maybe<Model_Aggregate_Fields>;
  nodes: Array<Model>;
};

/** aggregate fields of "model" */
export type Model_Aggregate_Fields = {
  __typename?: 'model_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Model_Max_Fields>;
  min?: Maybe<Model_Min_Fields>;
};


/** aggregate fields of "model" */
export type Model_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "model". All fields are combined with a logical 'AND'. */
export type Model_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Bool_Exp>>;
  _not?: InputMaybe<Model_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Bool_Exp>>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "model" */
export enum Model_Constraint {
  /** unique or primary key constraint on columns "country", "name" */
  model_country_name_key = 'model_country_name_key',
  /** unique or primary key constraint on columns "id" */
  model_pkey = 'model_pkey'
}

/** input type for inserting data into table "model" */
export type Model_Insert_Input = {
  country?: InputMaybe<Country_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Model_Max_Fields = {
  __typename?: 'model_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Model_Min_Fields = {
  __typename?: 'model_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "model" */
export type Model_Mutation_Response = {
  __typename?: 'model_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Model>;
};

/** on_conflict condition type for table "model" */
export type Model_On_Conflict = {
  constraint: Model_Constraint;
  update_columns?: Array<Model_Update_Column>;
  where?: InputMaybe<Model_Bool_Exp>;
};

/** Ordering options when selecting data from "model". */
export type Model_Order_By = {
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: model */
export type Model_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "model" */
export enum Model_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name'
}

/** input type for updating data in table "model" */
export type Model_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "model" */
export type Model_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "model" */
export enum Model_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name'
}

export type Model_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "agent_model_pricing" */
  delete_agentModelPricing?: Maybe<AgentModelPricing_Mutation_Response>;
  /** delete single row from the table: "agent_model_pricing" */
  delete_agentModelPricing_by_pk?: Maybe<AgentModelPricing>;
  /** delete data from the table: "agent_skills_tenant_user" */
  delete_agentSkillsTenantUser?: Maybe<AgentSkillsTenantUser_Mutation_Response>;
  /** delete single row from the table: "agent_skills_tenant_user" */
  delete_agentSkillsTenantUser_by_pk?: Maybe<AgentSkillsTenantUser>;
  /** delete data from the table: "application_source" */
  delete_applicationSource?: Maybe<ApplicationSource_Mutation_Response>;
  /** delete single row from the table: "application_source" */
  delete_applicationSource_by_pk?: Maybe<ApplicationSource>;
  /** delete data from the table: "benchmark_grouping_verdict" */
  delete_benchmarkGroupingVerdict?: Maybe<BenchmarkGroupingVerdict_Mutation_Response>;
  /** delete single row from the table: "benchmark_grouping_verdict" */
  delete_benchmarkGroupingVerdict_by_pk?: Maybe<BenchmarkGroupingVerdict>;
  /** delete data from the table: "benchmark_inventory_material" */
  delete_benchmarkInventoryMaterial?: Maybe<BenchmarkInventoryMaterial_Mutation_Response>;
  /** delete single row from the table: "benchmark_inventory_material" */
  delete_benchmarkInventoryMaterial_by_pk?: Maybe<BenchmarkInventoryMaterial>;
  /** delete data from the table: "benchmark_material_mapping" */
  delete_benchmarkMaterialMapping?: Maybe<BenchmarkMaterialMapping_Mutation_Response>;
  /** delete single row from the table: "benchmark_material_mapping" */
  delete_benchmarkMaterialMapping_by_pk?: Maybe<BenchmarkMaterialMapping>;
  /** delete data from the table: "benchmark_project_state" */
  delete_benchmarkProjectState?: Maybe<BenchmarkProjectState_Mutation_Response>;
  /** delete single row from the table: "benchmark_project_state" */
  delete_benchmarkProjectState_by_pk?: Maybe<BenchmarkProjectState>;
  /** delete data from the table: "benchmark_snapshot" */
  delete_benchmarkSnapshot?: Maybe<BenchmarkSnapshot_Mutation_Response>;
  /** delete single row from the table: "benchmark_snapshot" */
  delete_benchmarkSnapshot_by_pk?: Maybe<BenchmarkSnapshot>;
  /** delete data from the table: "building_area_type" */
  delete_buildingAreaType?: Maybe<BuildingAreaType_Mutation_Response>;
  /** delete single row from the table: "building_area_type" */
  delete_buildingAreaType_by_pk?: Maybe<BuildingAreaType>;
  /** delete data from the table: "building_part" */
  delete_buildingPart?: Maybe<BuildingPart_Mutation_Response>;
  /** delete data from the table: "building_part_lifetime_source" */
  delete_buildingPartLifetimeSource?: Maybe<BuildingPartLifetimeSource_Mutation_Response>;
  /** delete single row from the table: "building_part_lifetime_source" */
  delete_buildingPartLifetimeSource_by_pk?: Maybe<BuildingPartLifetimeSource>;
  /** delete data from the table: "building_part_maintenance_lifetime" */
  delete_buildingPartMaintenanceLifetime?: Maybe<BuildingPartMaintenanceLifetime_Mutation_Response>;
  /** delete single row from the table: "building_part_maintenance_lifetime" */
  delete_buildingPartMaintenanceLifetime_by_pk?: Maybe<BuildingPartMaintenanceLifetime>;
  /** delete data from the table: "building_part_service_lifetime" */
  delete_buildingPartServiceLifetime?: Maybe<BuildingPartServiceLifetime_Mutation_Response>;
  /** delete single row from the table: "building_part_service_lifetime" */
  delete_buildingPartServiceLifetime_by_pk?: Maybe<BuildingPartServiceLifetime>;
  /** delete single row from the table: "building_part" */
  delete_buildingPart_by_pk?: Maybe<BuildingPart>;
  /** delete data from the table: "building_type" */
  delete_buildingType?: Maybe<BuildingType_Mutation_Response>;
  /** delete single row from the table: "building_type" */
  delete_buildingType_by_pk?: Maybe<BuildingType>;
  /** delete data from the table: "building_element" */
  delete_building_element?: Maybe<Building_Element_Mutation_Response>;
  /** delete single row from the table: "building_element" */
  delete_building_element_by_pk?: Maybe<Building_Element>;
  /** delete data from the table: "building_element_classification_code_mapping" */
  delete_building_element_classification_code_mapping?: Maybe<Building_Element_Classification_Code_Mapping_Mutation_Response>;
  /** delete single row from the table: "building_element_classification_code_mapping" */
  delete_building_element_classification_code_mapping_by_pk?: Maybe<Building_Element_Classification_Code_Mapping>;
  /** delete data from the table: "building_element_material_category_mapping" */
  delete_building_element_material_category_mapping?: Maybe<Building_Element_Material_Category_Mapping_Mutation_Response>;
  /** delete single row from the table: "building_element_material_category_mapping" */
  delete_building_element_material_category_mapping_by_pk?: Maybe<Building_Element_Material_Category_Mapping>;
  /** delete data from the table: "calculation_type" */
  delete_calculationType?: Maybe<CalculationType_Mutation_Response>;
  /** delete data from the table: "calculation_type_epd_datasource" */
  delete_calculationTypeEpdDatasource?: Maybe<CalculationTypeEpdDatasource_Mutation_Response>;
  /** delete single row from the table: "calculation_type_epd_datasource" */
  delete_calculationTypeEpdDatasource_by_pk?: Maybe<CalculationTypeEpdDatasource>;
  /** delete data from the table: "calculation_type_threshold_by_building_type" */
  delete_calculationTypeThresholdByBuildingType?: Maybe<CalculationTypeThresholdByBuildingType_Mutation_Response>;
  /** delete single row from the table: "calculation_type_threshold_by_building_type" */
  delete_calculationTypeThresholdByBuildingType_by_pk?: Maybe<CalculationTypeThresholdByBuildingType>;
  /** delete data from the table: "calculation_type_variant" */
  delete_calculationTypeVariant?: Maybe<CalculationTypeVariant_Mutation_Response>;
  /** delete single row from the table: "calculation_type_variant" */
  delete_calculationTypeVariant_by_pk?: Maybe<CalculationTypeVariant>;
  /** delete single row from the table: "calculation_type" */
  delete_calculationType_by_pk?: Maybe<CalculationType>;
  /** delete data from the table: "calculation_type_stage" */
  delete_calculation_type_stage?: Maybe<Calculation_Type_Stage_Mutation_Response>;
  /** delete single row from the table: "calculation_type_stage" */
  delete_calculation_type_stage_by_pk?: Maybe<Calculation_Type_Stage>;
  /** delete data from the table: "classification_code" */
  delete_classificationCode?: Maybe<ClassificationCode_Mutation_Response>;
  /** delete data from the table: "classification_code_translation" */
  delete_classificationCodeTranslation?: Maybe<ClassificationCodeTranslation_Mutation_Response>;
  /** delete single row from the table: "classification_code_translation" */
  delete_classificationCodeTranslation_by_pk?: Maybe<ClassificationCodeTranslation>;
  /** delete data from the table: "classification_type_country" */
  delete_classificationCodeTypeCountry?: Maybe<ClassificationCodeTypeCountry_Mutation_Response>;
  /** delete single row from the table: "classification_type_country" */
  delete_classificationCodeTypeCountry_by_pk?: Maybe<ClassificationCodeTypeCountry>;
  /** delete single row from the table: "classification_code" */
  delete_classificationCode_by_pk?: Maybe<ClassificationCode>;
  /** delete data from the table: "classification_object_class" */
  delete_classificationObjectClass?: Maybe<ClassificationObjectClass_Mutation_Response>;
  /** delete data from the table: "classification_object_class_parameter" */
  delete_classificationObjectClassParameter?: Maybe<ClassificationObjectClassParameter_Mutation_Response>;
  /** delete single row from the table: "classification_object_class_parameter" */
  delete_classificationObjectClassParameter_by_pk?: Maybe<ClassificationObjectClassParameter>;
  /** delete data from the table: "classification_object_class_translation" */
  delete_classificationObjectClassTranslation?: Maybe<ClassificationObjectClassTranslation_Mutation_Response>;
  /** delete single row from the table: "classification_object_class_translation" */
  delete_classificationObjectClassTranslation_by_pk?: Maybe<ClassificationObjectClassTranslation>;
  /** delete single row from the table: "classification_object_class" */
  delete_classificationObjectClass_by_pk?: Maybe<ClassificationObjectClass>;
  /** delete data from the table: "classification_type" */
  delete_classificationType?: Maybe<ClassificationType_Mutation_Response>;
  /** delete data from the table: "classification_type_parameter" */
  delete_classificationTypeAttribute?: Maybe<ClassificationTypeAttribute_Mutation_Response>;
  /** delete single row from the table: "classification_type_parameter" */
  delete_classificationTypeAttribute_by_pk?: Maybe<ClassificationTypeAttribute>;
  /** delete single row from the table: "classification_type" */
  delete_classificationType_by_pk?: Maybe<ClassificationType>;
  /** delete data from the table: "component_object_phase" */
  delete_componentObjectPhase?: Maybe<ComponentObjectPhase_Mutation_Response>;
  /** delete single row from the table: "component_object_phase" */
  delete_componentObjectPhase_by_pk?: Maybe<ComponentObjectPhase>;
  /** delete data from the table: "construction" */
  delete_construction?: Maybe<Construction_Mutation_Response>;
  /** delete data from the table: "construction_build_up_part" */
  delete_constructionBuildUpPart?: Maybe<ConstructionBuildUpPart_Mutation_Response>;
  /** delete data from the table: "construction_build_up_part_material_category" */
  delete_constructionBuildUpPartMaterialCategory?: Maybe<ConstructionBuildUpPartMaterialCategory_Mutation_Response>;
  /** delete single row from the table: "construction_build_up_part_material_category" */
  delete_constructionBuildUpPartMaterialCategory_by_pk?: Maybe<ConstructionBuildUpPartMaterialCategory>;
  /** delete data from the table: "construction_build_up_part_translation" */
  delete_constructionBuildUpPartTranslation?: Maybe<ConstructionBuildUpPartTranslation_Mutation_Response>;
  /** delete single row from the table: "construction_build_up_part_translation" */
  delete_constructionBuildUpPartTranslation_by_pk?: Maybe<ConstructionBuildUpPartTranslation>;
  /** delete single row from the table: "construction_build_up_part" */
  delete_constructionBuildUpPart_by_pk?: Maybe<ConstructionBuildUpPart>;
  /** delete data from the table: "construction_build_up_template" */
  delete_constructionBuildUpTemplate?: Maybe<ConstructionBuildUpTemplate_Mutation_Response>;
  /** delete data from the table: "construction_build_up_template_translation" */
  delete_constructionBuildUpTemplateTranslation?: Maybe<ConstructionBuildUpTemplateTranslation_Mutation_Response>;
  /** delete single row from the table: "construction_build_up_template_translation" */
  delete_constructionBuildUpTemplateTranslation_by_pk?: Maybe<ConstructionBuildUpTemplateTranslation>;
  /** delete single row from the table: "construction_build_up_template" */
  delete_constructionBuildUpTemplate_by_pk?: Maybe<ConstructionBuildUpTemplate>;
  /** delete data from the table: "construction_category" */
  delete_constructionCategory?: Maybe<ConstructionCategory_Mutation_Response>;
  /** delete data from the table: "construction_category_translation" */
  delete_constructionCategoryTranslation?: Maybe<ConstructionCategoryTranslation_Mutation_Response>;
  /** delete single row from the table: "construction_category_translation" */
  delete_constructionCategoryTranslation_by_pk?: Maybe<ConstructionCategoryTranslation>;
  /** delete data from the table: "construction_category_unit" */
  delete_constructionCategoryUnit?: Maybe<ConstructionCategoryUnit_Mutation_Response>;
  /** delete single row from the table: "construction_category_unit" */
  delete_constructionCategoryUnit_by_pk?: Maybe<ConstructionCategoryUnit>;
  /** delete single row from the table: "construction_category" */
  delete_constructionCategory_by_pk?: Maybe<ConstructionCategory>;
  /** delete data from the table: "construction_country" */
  delete_constructionCountry?: Maybe<ConstructionCountry_Mutation_Response>;
  /** delete single row from the table: "construction_country" */
  delete_constructionCountry_by_pk?: Maybe<ConstructionCountry>;
  /** delete data from the table: "construction_description" */
  delete_constructionDescription?: Maybe<ConstructionDescription_Mutation_Response>;
  /** delete single row from the table: "construction_description" */
  delete_constructionDescription_by_pk?: Maybe<ConstructionDescription>;
  /** delete data from the table: "construction_fork" */
  delete_constructionFork?: Maybe<ConstructionFork_Mutation_Response>;
  /** delete single row from the table: "construction_fork" */
  delete_constructionFork_by_pk?: Maybe<ConstructionFork>;
  /** delete data from the table: "construction_inhomogeneous_layer" */
  delete_constructionInhomogeneousLayer?: Maybe<ConstructionInhomogeneousLayer_Mutation_Response>;
  /** delete data from the table: "construction_inhomogeneous_layer_material" */
  delete_constructionInhomogeneousLayerMaterial?: Maybe<ConstructionInhomogeneousLayerMaterial_Mutation_Response>;
  /** delete single row from the table: "construction_inhomogeneous_layer_material" */
  delete_constructionInhomogeneousLayerMaterial_by_pk?: Maybe<ConstructionInhomogeneousLayerMaterial>;
  /** delete single row from the table: "construction_inhomogeneous_layer" */
  delete_constructionInhomogeneousLayer_by_pk?: Maybe<ConstructionInhomogeneousLayer>;
  /** delete data from the table: "construction_inhomogenous_layer_description" */
  delete_constructionInhomogenousLayerDescription?: Maybe<ConstructionInhomogenousLayerDescription_Mutation_Response>;
  /** delete single row from the table: "construction_inhomogenous_layer_description" */
  delete_constructionInhomogenousLayerDescription_by_pk?: Maybe<ConstructionInhomogenousLayerDescription>;
  /** delete data from the table: "construction_inhomogenous_layer_name" */
  delete_constructionInhomogenousLayerName?: Maybe<ConstructionInhomogenousLayerName_Mutation_Response>;
  /** delete single row from the table: "construction_inhomogenous_layer_name" */
  delete_constructionInhomogenousLayerName_by_pk?: Maybe<ConstructionInhomogenousLayerName>;
  /** delete data from the table: "construction_material" */
  delete_constructionMaterial?: Maybe<ConstructionMaterial_Mutation_Response>;
  /** delete single row from the table: "construction_material" */
  delete_constructionMaterial_by_pk?: Maybe<ConstructionMaterial>;
  /** delete data from the table: "construction_name" */
  delete_constructionName?: Maybe<ConstructionName_Mutation_Response>;
  /** delete single row from the table: "construction_name" */
  delete_constructionName_by_pk?: Maybe<ConstructionName>;
  /** delete data from the table: "construction_sorting" */
  delete_constructionSorting?: Maybe<ConstructionSorting_Mutation_Response>;
  /** delete single row from the table: "construction_sorting" */
  delete_constructionSorting_by_pk?: Maybe<ConstructionSorting>;
  /** delete single row from the table: "construction" */
  delete_construction_by_pk?: Maybe<Construction>;
  /** delete data from the table: "country" */
  delete_country?: Maybe<Country_Mutation_Response>;
  /** delete data from the table: "country_config" */
  delete_countryConfig?: Maybe<CountryConfig_Mutation_Response>;
  /** delete single row from the table: "country_config" */
  delete_countryConfig_by_pk?: Maybe<CountryConfig>;
  /** delete single row from the table: "country" */
  delete_country_by_pk?: Maybe<Country>;
  /** delete data from the table: "declared_unit" */
  delete_declaredUnit?: Maybe<DeclaredUnit_Mutation_Response>;
  /** delete single row from the table: "declared_unit" */
  delete_declaredUnit_by_pk?: Maybe<DeclaredUnit>;
  /** delete data from the table: "denominator_unit" */
  delete_denominatorUnit?: Maybe<DenominatorUnit_Mutation_Response>;
  /** delete single row from the table: "denominator_unit" */
  delete_denominatorUnit_by_pk?: Maybe<DenominatorUnit>;
  /** delete data from the table: "distance_unit" */
  delete_distance_unit?: Maybe<Distance_Unit_Mutation_Response>;
  /** delete single row from the table: "distance_unit" */
  delete_distance_unit_by_pk?: Maybe<Distance_Unit>;
  /** delete data from the table: "emission_factor_source_type" */
  delete_emissionFactorSourceType?: Maybe<EmissionFactorSourceType_Mutation_Response>;
  /** delete single row from the table: "emission_factor_source_type" */
  delete_emissionFactorSourceType_by_pk?: Maybe<EmissionFactorSourceType>;
  /** delete data from the table: "emission_factor" */
  delete_emission_factor?: Maybe<Emission_Factor_Mutation_Response>;
  /** delete single row from the table: "emission_factor" */
  delete_emission_factor_by_pk?: Maybe<Emission_Factor>;
  /** delete data from the table: "emission_factor_source" */
  delete_emission_factor_source?: Maybe<Emission_Factor_Source_Mutation_Response>;
  /** delete single row from the table: "emission_factor_source" */
  delete_emission_factor_source_by_pk?: Maybe<Emission_Factor_Source>;
  /** delete data from the table: "emission_factor_type" */
  delete_emission_factor_type?: Maybe<Emission_Factor_Type_Mutation_Response>;
  /** delete single row from the table: "emission_factor_type" */
  delete_emission_factor_type_by_pk?: Maybe<Emission_Factor_Type>;
  /** delete data from the table: "enum_collection_type" */
  delete_enumCollectionType?: Maybe<EnumCollectionType_Mutation_Response>;
  /** delete single row from the table: "enum_collection_type" */
  delete_enumCollectionType_by_pk?: Maybe<EnumCollectionType>;
  /** delete data from the table: "epd_datasource" */
  delete_epdDatasource?: Maybe<EpdDatasource_Mutation_Response>;
  /** delete single row from the table: "epd_datasource" */
  delete_epdDatasource_by_pk?: Maybe<EpdDatasource>;
  /** delete data from the table: "epd_owner" */
  delete_epdOwner?: Maybe<EpdOwner_Mutation_Response>;
  /** delete data from the table: "epd_owner_alias" */
  delete_epdOwnerAlias?: Maybe<EpdOwnerAlias_Mutation_Response>;
  /** delete single row from the table: "epd_owner_alias" */
  delete_epdOwnerAlias_by_pk?: Maybe<EpdOwnerAlias>;
  /** delete single row from the table: "epd_owner" */
  delete_epdOwner_by_pk?: Maybe<EpdOwner>;
  /** delete data from the table: "epd_product_industry" */
  delete_epdProductIndustry?: Maybe<EpdProductIndustry_Mutation_Response>;
  /** delete single row from the table: "epd_product_industry" */
  delete_epdProductIndustry_by_pk?: Maybe<EpdProductIndustry>;
  /** delete data from the table: "epd_specification_form" */
  delete_epdSpecificationForm?: Maybe<EpdSpecificationForm_Mutation_Response>;
  /** delete single row from the table: "epd_specification_form" */
  delete_epdSpecificationForm_by_pk?: Maybe<EpdSpecificationForm>;
  /** delete data from the table: "flow_guide" */
  delete_flowGuide?: Maybe<FlowGuide_Mutation_Response>;
  /** delete data from the table: "flow_guide_views" */
  delete_flowGuideViews?: Maybe<FlowGuideViews_Mutation_Response>;
  /** delete single row from the table: "flow_guide_views" */
  delete_flowGuideViews_by_pk?: Maybe<FlowGuideViews>;
  /** delete single row from the table: "flow_guide" */
  delete_flowGuide_by_pk?: Maybe<FlowGuide>;
  /** delete data from the table: "indicator_source" */
  delete_indicatorSource?: Maybe<IndicatorSource_Mutation_Response>;
  /** delete single row from the table: "indicator_source" */
  delete_indicatorSource_by_pk?: Maybe<IndicatorSource>;
  /** delete data from the table: "indicator_type" */
  delete_indicatorType?: Maybe<IndicatorType_Mutation_Response>;
  /** delete data from the table: "indicator_type_mapping" */
  delete_indicatorTypeMapping?: Maybe<IndicatorTypeMapping_Mutation_Response>;
  /** delete single row from the table: "indicator_type_mapping" */
  delete_indicatorTypeMapping_by_pk?: Maybe<IndicatorTypeMapping>;
  /** delete data from the table: "indicator_type_multiplier" */
  delete_indicatorTypeMultiplier?: Maybe<IndicatorTypeMultiplier_Mutation_Response>;
  /** delete single row from the table: "indicator_type_multiplier" */
  delete_indicatorTypeMultiplier_by_pk?: Maybe<IndicatorTypeMultiplier>;
  /** delete single row from the table: "indicator_type" */
  delete_indicatorType_by_pk?: Maybe<IndicatorType>;
  /** delete data from the table: "installation_standard_value" */
  delete_installation_standard_value?: Maybe<Installation_Standard_Value_Mutation_Response>;
  /** delete data from the table: "installation_standard_value_building_type" */
  delete_installation_standard_value_building_type?: Maybe<Installation_Standard_Value_Building_Type_Mutation_Response>;
  /** delete single row from the table: "installation_standard_value_building_type" */
  delete_installation_standard_value_building_type_by_pk?: Maybe<Installation_Standard_Value_Building_Type>;
  /** delete single row from the table: "installation_standard_value" */
  delete_installation_standard_value_by_pk?: Maybe<Installation_Standard_Value>;
  /** delete data from the table: "installation_standard_value_classification_type" */
  delete_installation_standard_value_classification_type?: Maybe<Installation_Standard_Value_Classification_Type_Mutation_Response>;
  /** delete single row from the table: "installation_standard_value_classification_type" */
  delete_installation_standard_value_classification_type_by_pk?: Maybe<Installation_Standard_Value_Classification_Type>;
  /** delete data from the table: "installation_standard_value_datasource" */
  delete_installation_standard_value_datasource?: Maybe<Installation_Standard_Value_Datasource_Mutation_Response>;
  /** delete single row from the table: "installation_standard_value_datasource" */
  delete_installation_standard_value_datasource_by_pk?: Maybe<Installation_Standard_Value_Datasource>;
  /** delete data from the table: "installation_standard_value_emission" */
  delete_installation_standard_value_emission?: Maybe<Installation_Standard_Value_Emission_Mutation_Response>;
  /** delete single row from the table: "installation_standard_value_emission" */
  delete_installation_standard_value_emission_by_pk?: Maybe<Installation_Standard_Value_Emission>;
  /** delete data from the table: "language" */
  delete_language?: Maybe<Language_Mutation_Response>;
  /** delete single row from the table: "language" */
  delete_language_by_pk?: Maybe<Language>;
  /** delete data from the table: "lifetime_table" */
  delete_lifetime_table?: Maybe<Lifetime_Table_Mutation_Response>;
  /** delete single row from the table: "lifetime_table" */
  delete_lifetime_table_by_pk?: Maybe<Lifetime_Table>;
  /** delete data from the table: "mapping_history" */
  delete_mappingHistory?: Maybe<MappingHistory_Mutation_Response>;
  /** delete single row from the table: "mapping_history" */
  delete_mappingHistory_by_pk?: Maybe<MappingHistory>;
  /** delete data from the table: "material" */
  delete_material?: Maybe<Material_Mutation_Response>;
  /** delete data from the table: "material_biogenic_params" */
  delete_materialBiogenicParams?: Maybe<MaterialBiogenicParams_Mutation_Response>;
  /** delete single row from the table: "material_biogenic_params" */
  delete_materialBiogenicParams_by_pk?: Maybe<MaterialBiogenicParams>;
  /** delete data from the table: "material_category" */
  delete_materialCategory?: Maybe<MaterialCategory_Mutation_Response>;
  /** delete data from the table: "material_category_texture" */
  delete_materialCategoryTexture?: Maybe<MaterialCategoryTexture_Mutation_Response>;
  /** delete single row from the table: "material_category_texture" */
  delete_materialCategoryTexture_by_pk?: Maybe<MaterialCategoryTexture>;
  /** delete single row from the table: "material_category" */
  delete_materialCategory_by_pk?: Maybe<MaterialCategory>;
  /** delete data from the table: "material_description" */
  delete_materialDescription?: Maybe<MaterialDescription_Mutation_Response>;
  /** delete single row from the table: "material_description" */
  delete_materialDescription_by_pk?: Maybe<MaterialDescription>;
  /** delete data from the table: "material_emission_indicator" */
  delete_materialEmissionIndicator?: Maybe<MaterialEmissionIndicator_Mutation_Response>;
  /** delete single row from the table: "material_emission_indicator" */
  delete_materialEmissionIndicator_by_pk?: Maybe<MaterialEmissionIndicator>;
  /** delete data from the table: "material_epd" */
  delete_materialEpd?: Maybe<MaterialEpd_Mutation_Response>;
  /** delete data from the table: "material_epd_datasource" */
  delete_materialEpdDatasource?: Maybe<MaterialEpdDatasource_Mutation_Response>;
  /** delete single row from the table: "material_epd_datasource" */
  delete_materialEpdDatasource_by_pk?: Maybe<MaterialEpdDatasource>;
  /** delete data from the table: "material_epd_url" */
  delete_materialEpdUrl?: Maybe<MaterialEpdUrl_Mutation_Response>;
  /** delete single row from the table: "material_epd_url" */
  delete_materialEpdUrl_by_pk?: Maybe<MaterialEpdUrl>;
  /** delete single row from the table: "material_epd" */
  delete_materialEpd_by_pk?: Maybe<MaterialEpd>;
  /** delete data from the table: "material_fork" */
  delete_materialFork?: Maybe<MaterialFork_Mutation_Response>;
  /** delete single row from the table: "material_fork" */
  delete_materialFork_by_pk?: Maybe<MaterialFork>;
  /** delete data from the table: "material_name" */
  delete_materialName?: Maybe<MaterialName_Mutation_Response>;
  /** delete single row from the table: "material_name" */
  delete_materialName_by_pk?: Maybe<MaterialName>;
  /** delete data from the table: "material_emission" */
  delete_materialStage?: Maybe<MaterialStage_Mutation_Response>;
  /** delete single row from the table: "material_emission" */
  delete_materialStage_by_pk?: Maybe<MaterialStage>;
  /** delete data from the table: "material_type" */
  delete_materialType?: Maybe<MaterialType_Mutation_Response>;
  /** delete single row from the table: "material_type" */
  delete_materialType_by_pk?: Maybe<MaterialType>;
  /** delete data from the table: "material_waste_source" */
  delete_materialWasteSource?: Maybe<MaterialWasteSource_Mutation_Response>;
  /** delete single row from the table: "material_waste_source" */
  delete_materialWasteSource_by_pk?: Maybe<MaterialWasteSource>;
  /** delete data from the table: "material_waste_type" */
  delete_materialWasteType?: Maybe<MaterialWasteType_Mutation_Response>;
  /** delete single row from the table: "material_waste_type" */
  delete_materialWasteType_by_pk?: Maybe<MaterialWasteType>;
  /** delete single row from the table: "material" */
  delete_material_by_pk?: Maybe<Material>;
  /** delete data from the table: "mcp_connection" */
  delete_mcpConnection?: Maybe<McpConnection_Mutation_Response>;
  /** delete single row from the table: "mcp_connection" */
  delete_mcpConnection_by_pk?: Maybe<McpConnection>;
  /** delete data from the table: "mcp_tool_call" */
  delete_mcpToolCall?: Maybe<McpToolCall_Mutation_Response>;
  /** delete single row from the table: "mcp_tool_call" */
  delete_mcpToolCall_by_pk?: Maybe<McpToolCall>;
  /** delete data from the table: "model" */
  delete_model?: Maybe<Model_Mutation_Response>;
  /** delete single row from the table: "model" */
  delete_model_by_pk?: Maybe<Model>;
  /** delete data from the table: "project" */
  delete_project?: Maybe<Project_Mutation_Response>;
  /** delete data from the table: "project_building_area" */
  delete_projectBuildingArea?: Maybe<ProjectBuildingArea_Mutation_Response>;
  /** delete single row from the table: "project_building_area" */
  delete_projectBuildingArea_by_pk?: Maybe<ProjectBuildingArea>;
  /** delete data from the table: "project_calculation" */
  delete_projectCalculation?: Maybe<ProjectCalculation_Mutation_Response>;
  /** delete data from the table: "project_calculation_stage" */
  delete_projectCalculationStage?: Maybe<ProjectCalculationStage_Mutation_Response>;
  /** delete single row from the table: "project_calculation_stage" */
  delete_projectCalculationStage_by_pk?: Maybe<ProjectCalculationStage>;
  /** delete single row from the table: "project_calculation" */
  delete_projectCalculation_by_pk?: Maybe<ProjectCalculation>;
  /** delete data from the table: "project_component_mapping_type" */
  delete_projectComponentMappingType?: Maybe<ProjectComponentMappingType_Mutation_Response>;
  /** delete single row from the table: "project_component_mapping_type" */
  delete_projectComponentMappingType_by_pk?: Maybe<ProjectComponentMappingType>;
  /** delete data from the table: "project_dashboard_status" */
  delete_projectDashboardStatus?: Maybe<ProjectDashboardStatus_Mutation_Response>;
  /** delete single row from the table: "project_dashboard_status" */
  delete_projectDashboardStatus_by_pk?: Maybe<ProjectDashboardStatus>;
  /** delete data from the table: "project_emission_factor" */
  delete_projectEmissionFactor?: Maybe<ProjectEmissionFactor_Mutation_Response>;
  /** delete data from the table: "project_emission_factor_custom" */
  delete_projectEmissionFactorCustom?: Maybe<ProjectEmissionFactorCustom_Mutation_Response>;
  /** delete single row from the table: "project_emission_factor_custom" */
  delete_projectEmissionFactorCustom_by_pk?: Maybe<ProjectEmissionFactorCustom>;
  /** delete single row from the table: "project_emission_factor" */
  delete_projectEmissionFactor_by_pk?: Maybe<ProjectEmissionFactor>;
  /** delete data from the table: "project_installation" */
  delete_projectInstallation?: Maybe<ProjectInstallation_Mutation_Response>;
  /** delete single row from the table: "project_installation" */
  delete_projectInstallation_by_pk?: Maybe<ProjectInstallation>;
  /** delete data from the table: "project_location" */
  delete_projectLocation?: Maybe<ProjectLocation_Mutation_Response>;
  /** delete single row from the table: "project_location" */
  delete_projectLocation_by_pk?: Maybe<ProjectLocation>;
  /** delete data from the table: "project_material_classification_feedback" */
  delete_projectMaterialClassificationFeedback?: Maybe<ProjectMaterialClassificationFeedback_Mutation_Response>;
  /** delete single row from the table: "project_material_classification_feedback" */
  delete_projectMaterialClassificationFeedback_by_pk?: Maybe<ProjectMaterialClassificationFeedback>;
  /** delete data from the table: "project_material_classification_parameter" */
  delete_projectMaterialClassificationParameter?: Maybe<ProjectMaterialClassificationParameter_Mutation_Response>;
  /** delete single row from the table: "project_material_classification_parameter" */
  delete_projectMaterialClassificationParameter_by_pk?: Maybe<ProjectMaterialClassificationParameter>;
  /** delete data from the table: "project_membership" */
  delete_projectMembership?: Maybe<ProjectMembership_Mutation_Response>;
  /** delete single row from the table: "project_membership" */
  delete_projectMembership_by_pk?: Maybe<ProjectMembership>;
  /** delete data from the table: "project_model" */
  delete_projectModel?: Maybe<ProjectModel_Mutation_Response>;
  /** delete data from the table: "project_model_speckle_pin" */
  delete_projectModelSpecklePin?: Maybe<ProjectModelSpecklePin_Mutation_Response>;
  /** delete single row from the table: "project_model_speckle_pin" */
  delete_projectModelSpecklePin_by_pk?: Maybe<ProjectModelSpecklePin>;
  /** delete single row from the table: "project_model" */
  delete_projectModel_by_pk?: Maybe<ProjectModel>;
  /** delete data from the table: "project_operational" */
  delete_projectOperational?: Maybe<ProjectOperational_Mutation_Response>;
  /** delete single row from the table: "project_operational" */
  delete_projectOperational_by_pk?: Maybe<ProjectOperational>;
  /** delete data from the table: "project_reference_area" */
  delete_projectReferenceArea?: Maybe<ProjectReferenceArea_Mutation_Response>;
  /** delete single row from the table: "project_reference_area" */
  delete_projectReferenceArea_by_pk?: Maybe<ProjectReferenceArea>;
  /** delete data from the table: "project_revision" */
  delete_projectRevision?: Maybe<ProjectRevision_Mutation_Response>;
  /** delete single row from the table: "project_revision" */
  delete_projectRevision_by_pk?: Maybe<ProjectRevision>;
  /** delete data from the table: "project_special_condition_config" */
  delete_projectSpecialConditionConfig?: Maybe<ProjectSpecialConditionConfig_Mutation_Response>;
  /** delete single row from the table: "project_special_condition_config" */
  delete_projectSpecialConditionConfig_by_pk?: Maybe<ProjectSpecialConditionConfig>;
  /** delete data from the table: "project_special_condition_type_mapping" */
  delete_projectSpecialConditionTypeMapping?: Maybe<ProjectSpecialConditionTypeMapping_Mutation_Response>;
  /** delete single row from the table: "project_special_condition_type_mapping" */
  delete_projectSpecialConditionTypeMapping_by_pk?: Maybe<ProjectSpecialConditionTypeMapping>;
  /** delete data from the table: "project_speckle_copy" */
  delete_projectSpeckleCopy?: Maybe<ProjectSpeckleCopy_Mutation_Response>;
  /** delete data from the table: "project_speckle_copy_recent" */
  delete_projectSpeckleCopyRecent?: Maybe<ProjectSpeckleCopyRecent_Mutation_Response>;
  /** delete single row from the table: "project_speckle_copy" */
  delete_projectSpeckleCopy_by_pk?: Maybe<ProjectSpeckleCopy>;
  /** delete data from the table: "project_speckle_model_sync" */
  delete_projectSpeckleModelSync?: Maybe<ProjectSpeckleModelSync_Mutation_Response>;
  /** delete data from the table: "project_speckle_model_sync_recent" */
  delete_projectSpeckleModelSyncRecent?: Maybe<ProjectSpeckleModelSyncRecent_Mutation_Response>;
  /** delete single row from the table: "project_speckle_model_sync" */
  delete_projectSpeckleModelSync_by_pk?: Maybe<ProjectSpeckleModelSync>;
  /** delete data from the table: "project_speckle_parameter_config" */
  delete_projectSpeckleParameterConfig?: Maybe<ProjectSpeckleParameterConfig_Mutation_Response>;
  /** delete single row from the table: "project_speckle_parameter_config" */
  delete_projectSpeckleParameterConfig_by_pk?: Maybe<ProjectSpeckleParameterConfig>;
  /** delete data from the table: "project_standard_value_stage" */
  delete_projectStandardValueStage?: Maybe<ProjectStandardValueStage_Mutation_Response>;
  /** delete single row from the table: "project_standard_value_stage" */
  delete_projectStandardValueStage_by_pk?: Maybe<ProjectStandardValueStage>;
  /** delete data from the table: "project_status" */
  delete_projectStatus?: Maybe<ProjectStatus_Mutation_Response>;
  /** delete single row from the table: "project_status" */
  delete_projectStatus_by_pk?: Maybe<ProjectStatus>;
  /** delete data from the table: "project_transport_mapping_emission_factor" */
  delete_projectTransportMappingEmissionFactor?: Maybe<ProjectTransportMappingEmissionFactor_Mutation_Response>;
  /** delete single row from the table: "project_transport_mapping_emission_factor" */
  delete_projectTransportMappingEmissionFactor_by_pk?: Maybe<ProjectTransportMappingEmissionFactor>;
  /** delete data from the table: "project_version" */
  delete_projectVersion?: Maybe<ProjectVersion_Mutation_Response>;
  /** delete data from the table: "project_version_numbered" */
  delete_projectVersionNumbered?: Maybe<ProjectVersionNumbered_Mutation_Response>;
  /** delete single row from the table: "project_version" */
  delete_projectVersion_by_pk?: Maybe<ProjectVersion>;
  /** delete data from the table: "project_waste_mapping" */
  delete_projectWasteMapping?: Maybe<ProjectWasteMapping_Mutation_Response>;
  /** delete single row from the table: "project_waste_mapping" */
  delete_projectWasteMapping_by_pk?: Maybe<ProjectWasteMapping>;
  /** delete data from the table: "project_waste_type_custom" */
  delete_projectWasteTypeCustom?: Maybe<ProjectWasteTypeCustom_Mutation_Response>;
  /** delete single row from the table: "project_waste_type_custom" */
  delete_projectWasteTypeCustom_by_pk?: Maybe<ProjectWasteTypeCustom>;
  /** delete single row from the table: "project" */
  delete_project_by_pk?: Maybe<Project>;
  /** delete data from the table: "project_transport" */
  delete_project_transport?: Maybe<Project_Transport_Mutation_Response>;
  /** delete single row from the table: "project_transport" */
  delete_project_transport_by_pk?: Maybe<Project_Transport>;
  /** delete data from the table: "project_transport_default" */
  delete_project_transport_default?: Maybe<Project_Transport_Default_Mutation_Response>;
  /** delete single row from the table: "project_transport_default" */
  delete_project_transport_default_by_pk?: Maybe<Project_Transport_Default>;
  /** delete data from the table: "project_transport_mapping" */
  delete_project_transport_mapping?: Maybe<Project_Transport_Mapping_Mutation_Response>;
  /** delete single row from the table: "project_transport_mapping" */
  delete_project_transport_mapping_by_pk?: Maybe<Project_Transport_Mapping>;
  /** delete data from the table: "reference_area_type" */
  delete_referenceAreaType?: Maybe<ReferenceAreaType_Mutation_Response>;
  /** delete data from the table: "reference_area_type_calculation_type_mapping" */
  delete_referenceAreaTypeCalculationTypeMapping?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Mutation_Response>;
  /** delete single row from the table: "reference_area_type_calculation_type_mapping" */
  delete_referenceAreaTypeCalculationTypeMapping_by_pk?: Maybe<ReferenceAreaTypeCalculationTypeMapping>;
  /** delete single row from the table: "reference_area_type" */
  delete_referenceAreaType_by_pk?: Maybe<ReferenceAreaType>;
  /** delete data from the table: "report_building_type_mapping" */
  delete_reportBuildingTypeMapping?: Maybe<ReportBuildingTypeMapping_Mutation_Response>;
  /** delete single row from the table: "report_building_type_mapping" */
  delete_reportBuildingTypeMapping_by_pk?: Maybe<ReportBuildingTypeMapping>;
  /** delete data from the table: "report_classification_code_emission_mapping" */
  delete_reportClassificationCodeEmissionMapping?: Maybe<ReportClassificationCodeEmissionMapping_Mutation_Response>;
  /** delete single row from the table: "report_classification_code_emission_mapping" */
  delete_reportClassificationCodeEmissionMapping_by_pk?: Maybe<ReportClassificationCodeEmissionMapping>;
  /** delete data from the table: "report_load_bearing_element_amount_mapping" */
  delete_reportLoadBearingElementAmountMapping?: Maybe<ReportLoadBearingElementAmountMapping_Mutation_Response>;
  /** delete single row from the table: "report_load_bearing_element_amount_mapping" */
  delete_reportLoadBearingElementAmountMapping_by_pk?: Maybe<ReportLoadBearingElementAmountMapping>;
  /** delete data from the table: "report_load_bearing_element_emission_mapping" */
  delete_reportLoadBearingElementEmissionMapping?: Maybe<ReportLoadBearingElementEmissionMapping_Mutation_Response>;
  /** delete single row from the table: "report_load_bearing_element_emission_mapping" */
  delete_reportLoadBearingElementEmissionMapping_by_pk?: Maybe<ReportLoadBearingElementEmissionMapping>;
  /** delete data from the table: "report_structure" */
  delete_reportStructure?: Maybe<ReportStructure_Mutation_Response>;
  /** delete data from the table: "report_structure_calculation_types" */
  delete_reportStructureCalculationTypes?: Maybe<ReportStructureCalculationTypes_Mutation_Response>;
  /** delete single row from the table: "report_structure_calculation_types" */
  delete_reportStructureCalculationTypes_by_pk?: Maybe<ReportStructureCalculationTypes>;
  /** delete data from the table: "report_structure_classification_codes" */
  delete_reportStructureClassificationCodes?: Maybe<ReportStructureClassificationCodes_Mutation_Response>;
  /** delete single row from the table: "report_structure_classification_codes" */
  delete_reportStructureClassificationCodes_by_pk?: Maybe<ReportStructureClassificationCodes>;
  /** delete single row from the table: "report_structure" */
  delete_reportStructure_by_pk?: Maybe<ReportStructure>;
  /** delete data from the table: "reportfilesmetadata" */
  delete_reportfilesmetadata?: Maybe<Reportfilesmetadata_Mutation_Response>;
  /** delete single row from the table: "reportfilesmetadata" */
  delete_reportfilesmetadata_by_pk?: Maybe<Reportfilesmetadata>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "special_condition_type" */
  delete_specialConditionType?: Maybe<SpecialConditionType_Mutation_Response>;
  /** delete data from the table: "special_condition_type_calculation_type" */
  delete_specialConditionTypeCalculationType?: Maybe<SpecialConditionTypeCalculationType_Mutation_Response>;
  /** delete single row from the table: "special_condition_type_calculation_type" */
  delete_specialConditionTypeCalculationType_by_pk?: Maybe<SpecialConditionTypeCalculationType>;
  /** delete data from the table: "special_condition_type_input_parameter" */
  delete_specialConditionTypeInputParameter?: Maybe<SpecialConditionTypeInputParameter_Mutation_Response>;
  /** delete single row from the table: "special_condition_type_input_parameter" */
  delete_specialConditionTypeInputParameter_by_pk?: Maybe<SpecialConditionTypeInputParameter>;
  /** delete single row from the table: "special_condition_type" */
  delete_specialConditionType_by_pk?: Maybe<SpecialConditionType>;
  /** delete data from the table: "special_condition_type_category" */
  delete_special_condition_type_category?: Maybe<Special_Condition_Type_Category_Mutation_Response>;
  /** delete single row from the table: "special_condition_type_category" */
  delete_special_condition_type_category_by_pk?: Maybe<Special_Condition_Type_Category>;
  /** delete data from the table: "speckle_stream_model_ifc_upload" */
  delete_speckleStreamModelIfcUpload?: Maybe<SpeckleStreamModelIfcUpload_Mutation_Response>;
  /** delete data from the table: "speckle_stream_model_ifc_upload_recent" */
  delete_speckleStreamModelIfcUploadRecent?: Maybe<SpeckleStreamModelIfcUploadRecent_Mutation_Response>;
  /** delete single row from the table: "speckle_stream_model_ifc_upload" */
  delete_speckleStreamModelIfcUpload_by_pk?: Maybe<SpeckleStreamModelIfcUpload>;
  /** delete data from the table: "speckle_user_data" */
  delete_speckleUserData?: Maybe<SpeckleUserData_Mutation_Response>;
  /** delete single row from the table: "speckle_user_data" */
  delete_speckleUserData_by_pk?: Maybe<SpeckleUserData>;
  /** delete data from the table: "speckle_stream" */
  delete_speckle_stream?: Maybe<Speckle_Stream_Mutation_Response>;
  /** delete single row from the table: "speckle_stream" */
  delete_speckle_stream_by_pk?: Maybe<Speckle_Stream>;
  /** delete data from the table: "stage" */
  delete_stage?: Maybe<Stage_Mutation_Response>;
  /** delete data from the table: "stage_default_emission" */
  delete_stageDefaultEmission?: Maybe<StageDefaultEmission_Mutation_Response>;
  /** delete single row from the table: "stage_default_emission" */
  delete_stageDefaultEmission_by_pk?: Maybe<StageDefaultEmission>;
  /** delete single row from the table: "stage" */
  delete_stage_by_pk?: Maybe<Stage>;
  /** delete data from the table: "stage_default_emission_building_type" */
  delete_stage_default_emission_building_type?: Maybe<Stage_Default_Emission_Building_Type_Mutation_Response>;
  /** delete single row from the table: "stage_default_emission_building_type" */
  delete_stage_default_emission_building_type_by_pk?: Maybe<Stage_Default_Emission_Building_Type>;
  /** delete data from the table: "tenant_ai_budget" */
  delete_tenantAiBudget?: Maybe<TenantAiBudget_Mutation_Response>;
  /** delete single row from the table: "tenant_ai_budget" */
  delete_tenantAiBudget_by_pk?: Maybe<TenantAiBudget>;
  /** delete data from the table: "tenant_ai_credit_purchase" */
  delete_tenantAiCreditPurchase?: Maybe<TenantAiCreditPurchase_Mutation_Response>;
  /** delete single row from the table: "tenant_ai_credit_purchase" */
  delete_tenantAiCreditPurchase_by_pk?: Maybe<TenantAiCreditPurchase>;
  /** delete data from the table: "tenant_ai_payment" */
  delete_tenantAiPayment?: Maybe<TenantAiPayment_Mutation_Response>;
  /** delete single row from the table: "tenant_ai_payment" */
  delete_tenantAiPayment_by_pk?: Maybe<TenantAiPayment>;
  /** delete data from the table: "tenant_collection" */
  delete_tenantCollection?: Maybe<TenantCollection_Mutation_Response>;
  /** delete data from the table: "tenant_collection_item" */
  delete_tenantCollectionItem?: Maybe<TenantCollectionItem_Mutation_Response>;
  /** delete single row from the table: "tenant_collection_item" */
  delete_tenantCollectionItem_by_pk?: Maybe<TenantCollectionItem>;
  /** delete single row from the table: "tenant_collection" */
  delete_tenantCollection_by_pk?: Maybe<TenantCollection>;
  /** delete data from the table: "tenant_invoice" */
  delete_tenantInvoice?: Maybe<TenantInvoice_Mutation_Response>;
  /** delete single row from the table: "tenant_invoice" */
  delete_tenantInvoice_by_pk?: Maybe<TenantInvoice>;
  /** delete data from the table: "tenant_user_request_ai_usage" */
  delete_tenantUserRequestAiUsage?: Maybe<TenantUserRequestAiUsage_Mutation_Response>;
  /** delete single row from the table: "tenant_user_request_ai_usage" */
  delete_tenantUserRequestAiUsage_by_pk?: Maybe<TenantUserRequestAiUsage>;
  /** delete data from the table: "translation_category" */
  delete_translationCategory?: Maybe<TranslationCategory_Mutation_Response>;
  /** delete single row from the table: "translation_category" */
  delete_translationCategory_by_pk?: Maybe<TranslationCategory>;
  /** delete data from the table: "translation_source" */
  delete_translationSource?: Maybe<TranslationSource_Mutation_Response>;
  /** delete single row from the table: "translation_source" */
  delete_translationSource_by_pk?: Maybe<TranslationSource>;
  /** delete data from the table: "transport" */
  delete_transport?: Maybe<Transport_Mutation_Response>;
  /** delete data from the table: "transport_emission_factor" */
  delete_transportEmissionFactor?: Maybe<TransportEmissionFactor_Mutation_Response>;
  /** delete single row from the table: "transport_emission_factor" */
  delete_transportEmissionFactor_by_pk?: Maybe<TransportEmissionFactor>;
  /** delete data from the table: "transport_source" */
  delete_transportSource?: Maybe<TransportSource_Mutation_Response>;
  /** delete data from the table: "transport_source_calculation_type" */
  delete_transportSourceCalculationType?: Maybe<TransportSourceCalculationType_Mutation_Response>;
  /** delete single row from the table: "transport_source_calculation_type" */
  delete_transportSourceCalculationType_by_pk?: Maybe<TransportSourceCalculationType>;
  /** delete single row from the table: "transport_source" */
  delete_transportSource_by_pk?: Maybe<TransportSource>;
  /** delete single row from the table: "transport" */
  delete_transport_by_pk?: Maybe<Transport>;
  /** delete data from the table: "transport_standard_value" */
  delete_transport_standard_value?: Maybe<Transport_Standard_Value_Mutation_Response>;
  /** delete single row from the table: "transport_standard_value" */
  delete_transport_standard_value_by_pk?: Maybe<Transport_Standard_Value>;
  /** delete data from the table: "transport_type" */
  delete_transport_type?: Maybe<Transport_Type_Mutation_Response>;
  /** delete single row from the table: "transport_type" */
  delete_transport_type_by_pk?: Maybe<Transport_Type>;
  /** delete data from the table: "unit" */
  delete_unit?: Maybe<Unit_Mutation_Response>;
  /** delete single row from the table: "unit" */
  delete_unit_by_pk?: Maybe<Unit>;
  /** delete data from the table: "user_material_favorite" */
  delete_userMaterialFavorite?: Maybe<UserMaterialFavorite_Mutation_Response>;
  /** delete single row from the table: "user_material_favorite" */
  delete_userMaterialFavorite_by_pk?: Maybe<UserMaterialFavorite>;
  /** delete data from the table: "user_platform_review" */
  delete_userPlatformReview?: Maybe<UserPlatformReview_Mutation_Response>;
  /** delete single row from the table: "user_platform_review" */
  delete_userPlatformReview_by_pk?: Maybe<UserPlatformReview>;
  /** delete data from the table: "user_project_view" */
  delete_userProjectView?: Maybe<UserProjectView_Mutation_Response>;
  /** delete single row from the table: "user_project_view" */
  delete_userProjectView_by_pk?: Maybe<UserProjectView>;
  /** delete data from the table: "user_tutorial_view" */
  delete_userTutorialView?: Maybe<UserTutorialView_Mutation_Response>;
  /** delete single row from the table: "user_tutorial_view" */
  delete_userTutorialView_by_pk?: Maybe<UserTutorialView>;
  /** delete data from the table: "user_welcome_flow" */
  delete_userWelcomeFlow?: Maybe<UserWelcomeFlow_Mutation_Response>;
  /** delete data from the table: "user_welcome_flow_event" */
  delete_userWelcomeFlowEvent?: Maybe<UserWelcomeFlowEvent_Mutation_Response>;
  /** delete single row from the table: "user_welcome_flow_event" */
  delete_userWelcomeFlowEvent_by_pk?: Maybe<UserWelcomeFlowEvent>;
  /** delete single row from the table: "user_welcome_flow" */
  delete_userWelcomeFlow_by_pk?: Maybe<UserWelcomeFlow>;
  /** delete data from the table: "v_material_gwp" */
  delete_vMaterialGwp?: Maybe<VMaterialGwp_Mutation_Response>;
  /** delete data from the table: "v_material_status" */
  delete_vMaterialStatus?: Maybe<VMaterialStatus_Mutation_Response>;
  /** delete data from the table: "weight_per_declared_unit" */
  delete_weightPerDeclaredUnit?: Maybe<WeightPerDeclaredUnit_Mutation_Response>;
  /** delete single row from the table: "weight_per_declared_unit" */
  delete_weightPerDeclaredUnit_by_pk?: Maybe<WeightPerDeclaredUnit>;
  /** insert data into the table: "agent_model_pricing" */
  insert_agentModelPricing?: Maybe<AgentModelPricing_Mutation_Response>;
  /** insert a single row into the table: "agent_model_pricing" */
  insert_agentModelPricing_one?: Maybe<AgentModelPricing>;
  /** insert data into the table: "agent_skills_tenant_user" */
  insert_agentSkillsTenantUser?: Maybe<AgentSkillsTenantUser_Mutation_Response>;
  /** insert a single row into the table: "agent_skills_tenant_user" */
  insert_agentSkillsTenantUser_one?: Maybe<AgentSkillsTenantUser>;
  /** insert data into the table: "application_source" */
  insert_applicationSource?: Maybe<ApplicationSource_Mutation_Response>;
  /** insert a single row into the table: "application_source" */
  insert_applicationSource_one?: Maybe<ApplicationSource>;
  /** insert data into the table: "benchmark_grouping_verdict" */
  insert_benchmarkGroupingVerdict?: Maybe<BenchmarkGroupingVerdict_Mutation_Response>;
  /** insert a single row into the table: "benchmark_grouping_verdict" */
  insert_benchmarkGroupingVerdict_one?: Maybe<BenchmarkGroupingVerdict>;
  /** insert data into the table: "benchmark_inventory_material" */
  insert_benchmarkInventoryMaterial?: Maybe<BenchmarkInventoryMaterial_Mutation_Response>;
  /** insert a single row into the table: "benchmark_inventory_material" */
  insert_benchmarkInventoryMaterial_one?: Maybe<BenchmarkInventoryMaterial>;
  /** insert data into the table: "benchmark_material_mapping" */
  insert_benchmarkMaterialMapping?: Maybe<BenchmarkMaterialMapping_Mutation_Response>;
  /** insert a single row into the table: "benchmark_material_mapping" */
  insert_benchmarkMaterialMapping_one?: Maybe<BenchmarkMaterialMapping>;
  /** insert data into the table: "benchmark_project_state" */
  insert_benchmarkProjectState?: Maybe<BenchmarkProjectState_Mutation_Response>;
  /** insert a single row into the table: "benchmark_project_state" */
  insert_benchmarkProjectState_one?: Maybe<BenchmarkProjectState>;
  /** insert data into the table: "benchmark_snapshot" */
  insert_benchmarkSnapshot?: Maybe<BenchmarkSnapshot_Mutation_Response>;
  /** insert a single row into the table: "benchmark_snapshot" */
  insert_benchmarkSnapshot_one?: Maybe<BenchmarkSnapshot>;
  /** insert data into the table: "building_area_type" */
  insert_buildingAreaType?: Maybe<BuildingAreaType_Mutation_Response>;
  /** insert a single row into the table: "building_area_type" */
  insert_buildingAreaType_one?: Maybe<BuildingAreaType>;
  /** insert data into the table: "building_part" */
  insert_buildingPart?: Maybe<BuildingPart_Mutation_Response>;
  /** insert data into the table: "building_part_lifetime_source" */
  insert_buildingPartLifetimeSource?: Maybe<BuildingPartLifetimeSource_Mutation_Response>;
  /** insert a single row into the table: "building_part_lifetime_source" */
  insert_buildingPartLifetimeSource_one?: Maybe<BuildingPartLifetimeSource>;
  /** insert data into the table: "building_part_maintenance_lifetime" */
  insert_buildingPartMaintenanceLifetime?: Maybe<BuildingPartMaintenanceLifetime_Mutation_Response>;
  /** insert a single row into the table: "building_part_maintenance_lifetime" */
  insert_buildingPartMaintenanceLifetime_one?: Maybe<BuildingPartMaintenanceLifetime>;
  /** insert data into the table: "building_part_service_lifetime" */
  insert_buildingPartServiceLifetime?: Maybe<BuildingPartServiceLifetime_Mutation_Response>;
  /** insert a single row into the table: "building_part_service_lifetime" */
  insert_buildingPartServiceLifetime_one?: Maybe<BuildingPartServiceLifetime>;
  /** insert a single row into the table: "building_part" */
  insert_buildingPart_one?: Maybe<BuildingPart>;
  /** insert data into the table: "building_type" */
  insert_buildingType?: Maybe<BuildingType_Mutation_Response>;
  /** insert a single row into the table: "building_type" */
  insert_buildingType_one?: Maybe<BuildingType>;
  /** insert data into the table: "building_element" */
  insert_building_element?: Maybe<Building_Element_Mutation_Response>;
  /** insert data into the table: "building_element_classification_code_mapping" */
  insert_building_element_classification_code_mapping?: Maybe<Building_Element_Classification_Code_Mapping_Mutation_Response>;
  /** insert a single row into the table: "building_element_classification_code_mapping" */
  insert_building_element_classification_code_mapping_one?: Maybe<Building_Element_Classification_Code_Mapping>;
  /** insert data into the table: "building_element_material_category_mapping" */
  insert_building_element_material_category_mapping?: Maybe<Building_Element_Material_Category_Mapping_Mutation_Response>;
  /** insert a single row into the table: "building_element_material_category_mapping" */
  insert_building_element_material_category_mapping_one?: Maybe<Building_Element_Material_Category_Mapping>;
  /** insert a single row into the table: "building_element" */
  insert_building_element_one?: Maybe<Building_Element>;
  /** insert data into the table: "calculation_type" */
  insert_calculationType?: Maybe<CalculationType_Mutation_Response>;
  /** insert data into the table: "calculation_type_epd_datasource" */
  insert_calculationTypeEpdDatasource?: Maybe<CalculationTypeEpdDatasource_Mutation_Response>;
  /** insert a single row into the table: "calculation_type_epd_datasource" */
  insert_calculationTypeEpdDatasource_one?: Maybe<CalculationTypeEpdDatasource>;
  /** insert data into the table: "calculation_type_threshold_by_building_type" */
  insert_calculationTypeThresholdByBuildingType?: Maybe<CalculationTypeThresholdByBuildingType_Mutation_Response>;
  /** insert a single row into the table: "calculation_type_threshold_by_building_type" */
  insert_calculationTypeThresholdByBuildingType_one?: Maybe<CalculationTypeThresholdByBuildingType>;
  /** insert data into the table: "calculation_type_variant" */
  insert_calculationTypeVariant?: Maybe<CalculationTypeVariant_Mutation_Response>;
  /** insert a single row into the table: "calculation_type_variant" */
  insert_calculationTypeVariant_one?: Maybe<CalculationTypeVariant>;
  /** insert a single row into the table: "calculation_type" */
  insert_calculationType_one?: Maybe<CalculationType>;
  /** insert data into the table: "calculation_type_stage" */
  insert_calculation_type_stage?: Maybe<Calculation_Type_Stage_Mutation_Response>;
  /** insert a single row into the table: "calculation_type_stage" */
  insert_calculation_type_stage_one?: Maybe<Calculation_Type_Stage>;
  /** insert data into the table: "classification_code" */
  insert_classificationCode?: Maybe<ClassificationCode_Mutation_Response>;
  /** insert data into the table: "classification_code_translation" */
  insert_classificationCodeTranslation?: Maybe<ClassificationCodeTranslation_Mutation_Response>;
  /** insert a single row into the table: "classification_code_translation" */
  insert_classificationCodeTranslation_one?: Maybe<ClassificationCodeTranslation>;
  /** insert data into the table: "classification_type_country" */
  insert_classificationCodeTypeCountry?: Maybe<ClassificationCodeTypeCountry_Mutation_Response>;
  /** insert a single row into the table: "classification_type_country" */
  insert_classificationCodeTypeCountry_one?: Maybe<ClassificationCodeTypeCountry>;
  /** insert a single row into the table: "classification_code" */
  insert_classificationCode_one?: Maybe<ClassificationCode>;
  /** insert data into the table: "classification_object_class" */
  insert_classificationObjectClass?: Maybe<ClassificationObjectClass_Mutation_Response>;
  /** insert data into the table: "classification_object_class_parameter" */
  insert_classificationObjectClassParameter?: Maybe<ClassificationObjectClassParameter_Mutation_Response>;
  /** insert a single row into the table: "classification_object_class_parameter" */
  insert_classificationObjectClassParameter_one?: Maybe<ClassificationObjectClassParameter>;
  /** insert data into the table: "classification_object_class_translation" */
  insert_classificationObjectClassTranslation?: Maybe<ClassificationObjectClassTranslation_Mutation_Response>;
  /** insert a single row into the table: "classification_object_class_translation" */
  insert_classificationObjectClassTranslation_one?: Maybe<ClassificationObjectClassTranslation>;
  /** insert a single row into the table: "classification_object_class" */
  insert_classificationObjectClass_one?: Maybe<ClassificationObjectClass>;
  /** insert data into the table: "classification_type" */
  insert_classificationType?: Maybe<ClassificationType_Mutation_Response>;
  /** insert data into the table: "classification_type_parameter" */
  insert_classificationTypeAttribute?: Maybe<ClassificationTypeAttribute_Mutation_Response>;
  /** insert a single row into the table: "classification_type_parameter" */
  insert_classificationTypeAttribute_one?: Maybe<ClassificationTypeAttribute>;
  /** insert a single row into the table: "classification_type" */
  insert_classificationType_one?: Maybe<ClassificationType>;
  /** insert data into the table: "component_object_phase" */
  insert_componentObjectPhase?: Maybe<ComponentObjectPhase_Mutation_Response>;
  /** insert a single row into the table: "component_object_phase" */
  insert_componentObjectPhase_one?: Maybe<ComponentObjectPhase>;
  /** insert data into the table: "construction" */
  insert_construction?: Maybe<Construction_Mutation_Response>;
  /** insert data into the table: "construction_build_up_part" */
  insert_constructionBuildUpPart?: Maybe<ConstructionBuildUpPart_Mutation_Response>;
  /** insert data into the table: "construction_build_up_part_material_category" */
  insert_constructionBuildUpPartMaterialCategory?: Maybe<ConstructionBuildUpPartMaterialCategory_Mutation_Response>;
  /** insert a single row into the table: "construction_build_up_part_material_category" */
  insert_constructionBuildUpPartMaterialCategory_one?: Maybe<ConstructionBuildUpPartMaterialCategory>;
  /** insert data into the table: "construction_build_up_part_translation" */
  insert_constructionBuildUpPartTranslation?: Maybe<ConstructionBuildUpPartTranslation_Mutation_Response>;
  /** insert a single row into the table: "construction_build_up_part_translation" */
  insert_constructionBuildUpPartTranslation_one?: Maybe<ConstructionBuildUpPartTranslation>;
  /** insert a single row into the table: "construction_build_up_part" */
  insert_constructionBuildUpPart_one?: Maybe<ConstructionBuildUpPart>;
  /** insert data into the table: "construction_build_up_template" */
  insert_constructionBuildUpTemplate?: Maybe<ConstructionBuildUpTemplate_Mutation_Response>;
  /** insert data into the table: "construction_build_up_template_translation" */
  insert_constructionBuildUpTemplateTranslation?: Maybe<ConstructionBuildUpTemplateTranslation_Mutation_Response>;
  /** insert a single row into the table: "construction_build_up_template_translation" */
  insert_constructionBuildUpTemplateTranslation_one?: Maybe<ConstructionBuildUpTemplateTranslation>;
  /** insert a single row into the table: "construction_build_up_template" */
  insert_constructionBuildUpTemplate_one?: Maybe<ConstructionBuildUpTemplate>;
  /** insert data into the table: "construction_category" */
  insert_constructionCategory?: Maybe<ConstructionCategory_Mutation_Response>;
  /** insert data into the table: "construction_category_translation" */
  insert_constructionCategoryTranslation?: Maybe<ConstructionCategoryTranslation_Mutation_Response>;
  /** insert a single row into the table: "construction_category_translation" */
  insert_constructionCategoryTranslation_one?: Maybe<ConstructionCategoryTranslation>;
  /** insert data into the table: "construction_category_unit" */
  insert_constructionCategoryUnit?: Maybe<ConstructionCategoryUnit_Mutation_Response>;
  /** insert a single row into the table: "construction_category_unit" */
  insert_constructionCategoryUnit_one?: Maybe<ConstructionCategoryUnit>;
  /** insert a single row into the table: "construction_category" */
  insert_constructionCategory_one?: Maybe<ConstructionCategory>;
  /** insert data into the table: "construction_country" */
  insert_constructionCountry?: Maybe<ConstructionCountry_Mutation_Response>;
  /** insert a single row into the table: "construction_country" */
  insert_constructionCountry_one?: Maybe<ConstructionCountry>;
  /** insert data into the table: "construction_description" */
  insert_constructionDescription?: Maybe<ConstructionDescription_Mutation_Response>;
  /** insert a single row into the table: "construction_description" */
  insert_constructionDescription_one?: Maybe<ConstructionDescription>;
  /** insert data into the table: "construction_fork" */
  insert_constructionFork?: Maybe<ConstructionFork_Mutation_Response>;
  /** insert a single row into the table: "construction_fork" */
  insert_constructionFork_one?: Maybe<ConstructionFork>;
  /** insert data into the table: "construction_inhomogeneous_layer" */
  insert_constructionInhomogeneousLayer?: Maybe<ConstructionInhomogeneousLayer_Mutation_Response>;
  /** insert data into the table: "construction_inhomogeneous_layer_material" */
  insert_constructionInhomogeneousLayerMaterial?: Maybe<ConstructionInhomogeneousLayerMaterial_Mutation_Response>;
  /** insert a single row into the table: "construction_inhomogeneous_layer_material" */
  insert_constructionInhomogeneousLayerMaterial_one?: Maybe<ConstructionInhomogeneousLayerMaterial>;
  /** insert a single row into the table: "construction_inhomogeneous_layer" */
  insert_constructionInhomogeneousLayer_one?: Maybe<ConstructionInhomogeneousLayer>;
  /** insert data into the table: "construction_inhomogenous_layer_description" */
  insert_constructionInhomogenousLayerDescription?: Maybe<ConstructionInhomogenousLayerDescription_Mutation_Response>;
  /** insert a single row into the table: "construction_inhomogenous_layer_description" */
  insert_constructionInhomogenousLayerDescription_one?: Maybe<ConstructionInhomogenousLayerDescription>;
  /** insert data into the table: "construction_inhomogenous_layer_name" */
  insert_constructionInhomogenousLayerName?: Maybe<ConstructionInhomogenousLayerName_Mutation_Response>;
  /** insert a single row into the table: "construction_inhomogenous_layer_name" */
  insert_constructionInhomogenousLayerName_one?: Maybe<ConstructionInhomogenousLayerName>;
  /** insert data into the table: "construction_material" */
  insert_constructionMaterial?: Maybe<ConstructionMaterial_Mutation_Response>;
  /** insert a single row into the table: "construction_material" */
  insert_constructionMaterial_one?: Maybe<ConstructionMaterial>;
  /** insert data into the table: "construction_name" */
  insert_constructionName?: Maybe<ConstructionName_Mutation_Response>;
  /** insert a single row into the table: "construction_name" */
  insert_constructionName_one?: Maybe<ConstructionName>;
  /** insert data into the table: "construction_sorting" */
  insert_constructionSorting?: Maybe<ConstructionSorting_Mutation_Response>;
  /** insert a single row into the table: "construction_sorting" */
  insert_constructionSorting_one?: Maybe<ConstructionSorting>;
  /** insert a single row into the table: "construction" */
  insert_construction_one?: Maybe<Construction>;
  /** insert data into the table: "country" */
  insert_country?: Maybe<Country_Mutation_Response>;
  /** insert data into the table: "country_config" */
  insert_countryConfig?: Maybe<CountryConfig_Mutation_Response>;
  /** insert a single row into the table: "country_config" */
  insert_countryConfig_one?: Maybe<CountryConfig>;
  /** insert a single row into the table: "country" */
  insert_country_one?: Maybe<Country>;
  /** insert data into the table: "declared_unit" */
  insert_declaredUnit?: Maybe<DeclaredUnit_Mutation_Response>;
  /** insert a single row into the table: "declared_unit" */
  insert_declaredUnit_one?: Maybe<DeclaredUnit>;
  /** insert data into the table: "denominator_unit" */
  insert_denominatorUnit?: Maybe<DenominatorUnit_Mutation_Response>;
  /** insert a single row into the table: "denominator_unit" */
  insert_denominatorUnit_one?: Maybe<DenominatorUnit>;
  /** insert data into the table: "distance_unit" */
  insert_distance_unit?: Maybe<Distance_Unit_Mutation_Response>;
  /** insert a single row into the table: "distance_unit" */
  insert_distance_unit_one?: Maybe<Distance_Unit>;
  /** insert data into the table: "emission_factor_source_type" */
  insert_emissionFactorSourceType?: Maybe<EmissionFactorSourceType_Mutation_Response>;
  /** insert a single row into the table: "emission_factor_source_type" */
  insert_emissionFactorSourceType_one?: Maybe<EmissionFactorSourceType>;
  /** insert data into the table: "emission_factor" */
  insert_emission_factor?: Maybe<Emission_Factor_Mutation_Response>;
  /** insert a single row into the table: "emission_factor" */
  insert_emission_factor_one?: Maybe<Emission_Factor>;
  /** insert data into the table: "emission_factor_source" */
  insert_emission_factor_source?: Maybe<Emission_Factor_Source_Mutation_Response>;
  /** insert a single row into the table: "emission_factor_source" */
  insert_emission_factor_source_one?: Maybe<Emission_Factor_Source>;
  /** insert data into the table: "emission_factor_type" */
  insert_emission_factor_type?: Maybe<Emission_Factor_Type_Mutation_Response>;
  /** insert a single row into the table: "emission_factor_type" */
  insert_emission_factor_type_one?: Maybe<Emission_Factor_Type>;
  /** insert data into the table: "enum_collection_type" */
  insert_enumCollectionType?: Maybe<EnumCollectionType_Mutation_Response>;
  /** insert a single row into the table: "enum_collection_type" */
  insert_enumCollectionType_one?: Maybe<EnumCollectionType>;
  /** insert data into the table: "epd_datasource" */
  insert_epdDatasource?: Maybe<EpdDatasource_Mutation_Response>;
  /** insert a single row into the table: "epd_datasource" */
  insert_epdDatasource_one?: Maybe<EpdDatasource>;
  /** insert data into the table: "epd_owner" */
  insert_epdOwner?: Maybe<EpdOwner_Mutation_Response>;
  /** insert data into the table: "epd_owner_alias" */
  insert_epdOwnerAlias?: Maybe<EpdOwnerAlias_Mutation_Response>;
  /** insert a single row into the table: "epd_owner_alias" */
  insert_epdOwnerAlias_one?: Maybe<EpdOwnerAlias>;
  /** insert a single row into the table: "epd_owner" */
  insert_epdOwner_one?: Maybe<EpdOwner>;
  /** insert data into the table: "epd_product_industry" */
  insert_epdProductIndustry?: Maybe<EpdProductIndustry_Mutation_Response>;
  /** insert a single row into the table: "epd_product_industry" */
  insert_epdProductIndustry_one?: Maybe<EpdProductIndustry>;
  /** insert data into the table: "epd_specification_form" */
  insert_epdSpecificationForm?: Maybe<EpdSpecificationForm_Mutation_Response>;
  /** insert a single row into the table: "epd_specification_form" */
  insert_epdSpecificationForm_one?: Maybe<EpdSpecificationForm>;
  /** insert data into the table: "flow_guide" */
  insert_flowGuide?: Maybe<FlowGuide_Mutation_Response>;
  /** insert data into the table: "flow_guide_views" */
  insert_flowGuideViews?: Maybe<FlowGuideViews_Mutation_Response>;
  /** insert a single row into the table: "flow_guide_views" */
  insert_flowGuideViews_one?: Maybe<FlowGuideViews>;
  /** insert a single row into the table: "flow_guide" */
  insert_flowGuide_one?: Maybe<FlowGuide>;
  /** insert data into the table: "indicator_source" */
  insert_indicatorSource?: Maybe<IndicatorSource_Mutation_Response>;
  /** insert a single row into the table: "indicator_source" */
  insert_indicatorSource_one?: Maybe<IndicatorSource>;
  /** insert data into the table: "indicator_type" */
  insert_indicatorType?: Maybe<IndicatorType_Mutation_Response>;
  /** insert data into the table: "indicator_type_mapping" */
  insert_indicatorTypeMapping?: Maybe<IndicatorTypeMapping_Mutation_Response>;
  /** insert a single row into the table: "indicator_type_mapping" */
  insert_indicatorTypeMapping_one?: Maybe<IndicatorTypeMapping>;
  /** insert data into the table: "indicator_type_multiplier" */
  insert_indicatorTypeMultiplier?: Maybe<IndicatorTypeMultiplier_Mutation_Response>;
  /** insert a single row into the table: "indicator_type_multiplier" */
  insert_indicatorTypeMultiplier_one?: Maybe<IndicatorTypeMultiplier>;
  /** insert a single row into the table: "indicator_type" */
  insert_indicatorType_one?: Maybe<IndicatorType>;
  /** insert data into the table: "installation_standard_value" */
  insert_installation_standard_value?: Maybe<Installation_Standard_Value_Mutation_Response>;
  /** insert data into the table: "installation_standard_value_building_type" */
  insert_installation_standard_value_building_type?: Maybe<Installation_Standard_Value_Building_Type_Mutation_Response>;
  /** insert a single row into the table: "installation_standard_value_building_type" */
  insert_installation_standard_value_building_type_one?: Maybe<Installation_Standard_Value_Building_Type>;
  /** insert data into the table: "installation_standard_value_classification_type" */
  insert_installation_standard_value_classification_type?: Maybe<Installation_Standard_Value_Classification_Type_Mutation_Response>;
  /** insert a single row into the table: "installation_standard_value_classification_type" */
  insert_installation_standard_value_classification_type_one?: Maybe<Installation_Standard_Value_Classification_Type>;
  /** insert data into the table: "installation_standard_value_datasource" */
  insert_installation_standard_value_datasource?: Maybe<Installation_Standard_Value_Datasource_Mutation_Response>;
  /** insert a single row into the table: "installation_standard_value_datasource" */
  insert_installation_standard_value_datasource_one?: Maybe<Installation_Standard_Value_Datasource>;
  /** insert data into the table: "installation_standard_value_emission" */
  insert_installation_standard_value_emission?: Maybe<Installation_Standard_Value_Emission_Mutation_Response>;
  /** insert a single row into the table: "installation_standard_value_emission" */
  insert_installation_standard_value_emission_one?: Maybe<Installation_Standard_Value_Emission>;
  /** insert a single row into the table: "installation_standard_value" */
  insert_installation_standard_value_one?: Maybe<Installation_Standard_Value>;
  /** insert data into the table: "language" */
  insert_language?: Maybe<Language_Mutation_Response>;
  /** insert a single row into the table: "language" */
  insert_language_one?: Maybe<Language>;
  /** insert data into the table: "lifetime_table" */
  insert_lifetime_table?: Maybe<Lifetime_Table_Mutation_Response>;
  /** insert a single row into the table: "lifetime_table" */
  insert_lifetime_table_one?: Maybe<Lifetime_Table>;
  /** insert data into the table: "mapping_history" */
  insert_mappingHistory?: Maybe<MappingHistory_Mutation_Response>;
  /** insert a single row into the table: "mapping_history" */
  insert_mappingHistory_one?: Maybe<MappingHistory>;
  /** insert data into the table: "material" */
  insert_material?: Maybe<Material_Mutation_Response>;
  /** insert data into the table: "material_biogenic_params" */
  insert_materialBiogenicParams?: Maybe<MaterialBiogenicParams_Mutation_Response>;
  /** insert a single row into the table: "material_biogenic_params" */
  insert_materialBiogenicParams_one?: Maybe<MaterialBiogenicParams>;
  /** insert data into the table: "material_category" */
  insert_materialCategory?: Maybe<MaterialCategory_Mutation_Response>;
  /** insert data into the table: "material_category_texture" */
  insert_materialCategoryTexture?: Maybe<MaterialCategoryTexture_Mutation_Response>;
  /** insert a single row into the table: "material_category_texture" */
  insert_materialCategoryTexture_one?: Maybe<MaterialCategoryTexture>;
  /** insert a single row into the table: "material_category" */
  insert_materialCategory_one?: Maybe<MaterialCategory>;
  /** insert data into the table: "material_description" */
  insert_materialDescription?: Maybe<MaterialDescription_Mutation_Response>;
  /** insert a single row into the table: "material_description" */
  insert_materialDescription_one?: Maybe<MaterialDescription>;
  /** insert data into the table: "material_emission_indicator" */
  insert_materialEmissionIndicator?: Maybe<MaterialEmissionIndicator_Mutation_Response>;
  /** insert a single row into the table: "material_emission_indicator" */
  insert_materialEmissionIndicator_one?: Maybe<MaterialEmissionIndicator>;
  /** insert data into the table: "material_epd" */
  insert_materialEpd?: Maybe<MaterialEpd_Mutation_Response>;
  /** insert data into the table: "material_epd_datasource" */
  insert_materialEpdDatasource?: Maybe<MaterialEpdDatasource_Mutation_Response>;
  /** insert a single row into the table: "material_epd_datasource" */
  insert_materialEpdDatasource_one?: Maybe<MaterialEpdDatasource>;
  /** insert data into the table: "material_epd_url" */
  insert_materialEpdUrl?: Maybe<MaterialEpdUrl_Mutation_Response>;
  /** insert a single row into the table: "material_epd_url" */
  insert_materialEpdUrl_one?: Maybe<MaterialEpdUrl>;
  /** insert a single row into the table: "material_epd" */
  insert_materialEpd_one?: Maybe<MaterialEpd>;
  /** insert data into the table: "material_fork" */
  insert_materialFork?: Maybe<MaterialFork_Mutation_Response>;
  /** insert a single row into the table: "material_fork" */
  insert_materialFork_one?: Maybe<MaterialFork>;
  /** insert data into the table: "material_name" */
  insert_materialName?: Maybe<MaterialName_Mutation_Response>;
  /** insert a single row into the table: "material_name" */
  insert_materialName_one?: Maybe<MaterialName>;
  /** insert data into the table: "material_emission" */
  insert_materialStage?: Maybe<MaterialStage_Mutation_Response>;
  /** insert a single row into the table: "material_emission" */
  insert_materialStage_one?: Maybe<MaterialStage>;
  /** insert data into the table: "material_type" */
  insert_materialType?: Maybe<MaterialType_Mutation_Response>;
  /** insert a single row into the table: "material_type" */
  insert_materialType_one?: Maybe<MaterialType>;
  /** insert data into the table: "material_waste_source" */
  insert_materialWasteSource?: Maybe<MaterialWasteSource_Mutation_Response>;
  /** insert a single row into the table: "material_waste_source" */
  insert_materialWasteSource_one?: Maybe<MaterialWasteSource>;
  /** insert data into the table: "material_waste_type" */
  insert_materialWasteType?: Maybe<MaterialWasteType_Mutation_Response>;
  /** insert a single row into the table: "material_waste_type" */
  insert_materialWasteType_one?: Maybe<MaterialWasteType>;
  /** insert a single row into the table: "material" */
  insert_material_one?: Maybe<Material>;
  /** insert data into the table: "mcp_connection" */
  insert_mcpConnection?: Maybe<McpConnection_Mutation_Response>;
  /** insert a single row into the table: "mcp_connection" */
  insert_mcpConnection_one?: Maybe<McpConnection>;
  /** insert data into the table: "mcp_tool_call" */
  insert_mcpToolCall?: Maybe<McpToolCall_Mutation_Response>;
  /** insert a single row into the table: "mcp_tool_call" */
  insert_mcpToolCall_one?: Maybe<McpToolCall>;
  /** insert data into the table: "model" */
  insert_model?: Maybe<Model_Mutation_Response>;
  /** insert a single row into the table: "model" */
  insert_model_one?: Maybe<Model>;
  /** insert data into the table: "project" */
  insert_project?: Maybe<Project_Mutation_Response>;
  /** insert data into the table: "project_building_area" */
  insert_projectBuildingArea?: Maybe<ProjectBuildingArea_Mutation_Response>;
  /** insert a single row into the table: "project_building_area" */
  insert_projectBuildingArea_one?: Maybe<ProjectBuildingArea>;
  /** insert data into the table: "project_calculation" */
  insert_projectCalculation?: Maybe<ProjectCalculation_Mutation_Response>;
  /** insert data into the table: "project_calculation_stage" */
  insert_projectCalculationStage?: Maybe<ProjectCalculationStage_Mutation_Response>;
  /** insert a single row into the table: "project_calculation_stage" */
  insert_projectCalculationStage_one?: Maybe<ProjectCalculationStage>;
  /** insert a single row into the table: "project_calculation" */
  insert_projectCalculation_one?: Maybe<ProjectCalculation>;
  /** insert data into the table: "project_component_mapping_type" */
  insert_projectComponentMappingType?: Maybe<ProjectComponentMappingType_Mutation_Response>;
  /** insert a single row into the table: "project_component_mapping_type" */
  insert_projectComponentMappingType_one?: Maybe<ProjectComponentMappingType>;
  /** insert data into the table: "project_dashboard_status" */
  insert_projectDashboardStatus?: Maybe<ProjectDashboardStatus_Mutation_Response>;
  /** insert a single row into the table: "project_dashboard_status" */
  insert_projectDashboardStatus_one?: Maybe<ProjectDashboardStatus>;
  /** insert data into the table: "project_emission_factor" */
  insert_projectEmissionFactor?: Maybe<ProjectEmissionFactor_Mutation_Response>;
  /** insert data into the table: "project_emission_factor_custom" */
  insert_projectEmissionFactorCustom?: Maybe<ProjectEmissionFactorCustom_Mutation_Response>;
  /** insert a single row into the table: "project_emission_factor_custom" */
  insert_projectEmissionFactorCustom_one?: Maybe<ProjectEmissionFactorCustom>;
  /** insert a single row into the table: "project_emission_factor" */
  insert_projectEmissionFactor_one?: Maybe<ProjectEmissionFactor>;
  /** insert data into the table: "project_installation" */
  insert_projectInstallation?: Maybe<ProjectInstallation_Mutation_Response>;
  /** insert a single row into the table: "project_installation" */
  insert_projectInstallation_one?: Maybe<ProjectInstallation>;
  /** insert data into the table: "project_location" */
  insert_projectLocation?: Maybe<ProjectLocation_Mutation_Response>;
  /** insert a single row into the table: "project_location" */
  insert_projectLocation_one?: Maybe<ProjectLocation>;
  /** insert data into the table: "project_material_classification_feedback" */
  insert_projectMaterialClassificationFeedback?: Maybe<ProjectMaterialClassificationFeedback_Mutation_Response>;
  /** insert a single row into the table: "project_material_classification_feedback" */
  insert_projectMaterialClassificationFeedback_one?: Maybe<ProjectMaterialClassificationFeedback>;
  /** insert data into the table: "project_material_classification_parameter" */
  insert_projectMaterialClassificationParameter?: Maybe<ProjectMaterialClassificationParameter_Mutation_Response>;
  /** insert a single row into the table: "project_material_classification_parameter" */
  insert_projectMaterialClassificationParameter_one?: Maybe<ProjectMaterialClassificationParameter>;
  /** insert data into the table: "project_membership" */
  insert_projectMembership?: Maybe<ProjectMembership_Mutation_Response>;
  /** insert a single row into the table: "project_membership" */
  insert_projectMembership_one?: Maybe<ProjectMembership>;
  /** insert data into the table: "project_model" */
  insert_projectModel?: Maybe<ProjectModel_Mutation_Response>;
  /** insert data into the table: "project_model_speckle_pin" */
  insert_projectModelSpecklePin?: Maybe<ProjectModelSpecklePin_Mutation_Response>;
  /** insert a single row into the table: "project_model_speckle_pin" */
  insert_projectModelSpecklePin_one?: Maybe<ProjectModelSpecklePin>;
  /** insert a single row into the table: "project_model" */
  insert_projectModel_one?: Maybe<ProjectModel>;
  /** insert data into the table: "project_operational" */
  insert_projectOperational?: Maybe<ProjectOperational_Mutation_Response>;
  /** insert a single row into the table: "project_operational" */
  insert_projectOperational_one?: Maybe<ProjectOperational>;
  /** insert data into the table: "project_reference_area" */
  insert_projectReferenceArea?: Maybe<ProjectReferenceArea_Mutation_Response>;
  /** insert a single row into the table: "project_reference_area" */
  insert_projectReferenceArea_one?: Maybe<ProjectReferenceArea>;
  /** insert data into the table: "project_revision" */
  insert_projectRevision?: Maybe<ProjectRevision_Mutation_Response>;
  /** insert a single row into the table: "project_revision" */
  insert_projectRevision_one?: Maybe<ProjectRevision>;
  /** insert data into the table: "project_special_condition_config" */
  insert_projectSpecialConditionConfig?: Maybe<ProjectSpecialConditionConfig_Mutation_Response>;
  /** insert a single row into the table: "project_special_condition_config" */
  insert_projectSpecialConditionConfig_one?: Maybe<ProjectSpecialConditionConfig>;
  /** insert data into the table: "project_special_condition_type_mapping" */
  insert_projectSpecialConditionTypeMapping?: Maybe<ProjectSpecialConditionTypeMapping_Mutation_Response>;
  /** insert a single row into the table: "project_special_condition_type_mapping" */
  insert_projectSpecialConditionTypeMapping_one?: Maybe<ProjectSpecialConditionTypeMapping>;
  /** insert data into the table: "project_speckle_copy" */
  insert_projectSpeckleCopy?: Maybe<ProjectSpeckleCopy_Mutation_Response>;
  /** insert data into the table: "project_speckle_copy_recent" */
  insert_projectSpeckleCopyRecent?: Maybe<ProjectSpeckleCopyRecent_Mutation_Response>;
  /** insert a single row into the table: "project_speckle_copy_recent" */
  insert_projectSpeckleCopyRecent_one?: Maybe<ProjectSpeckleCopyRecent>;
  /** insert a single row into the table: "project_speckle_copy" */
  insert_projectSpeckleCopy_one?: Maybe<ProjectSpeckleCopy>;
  /** insert data into the table: "project_speckle_model_sync" */
  insert_projectSpeckleModelSync?: Maybe<ProjectSpeckleModelSync_Mutation_Response>;
  /** insert data into the table: "project_speckle_model_sync_recent" */
  insert_projectSpeckleModelSyncRecent?: Maybe<ProjectSpeckleModelSyncRecent_Mutation_Response>;
  /** insert a single row into the table: "project_speckle_model_sync_recent" */
  insert_projectSpeckleModelSyncRecent_one?: Maybe<ProjectSpeckleModelSyncRecent>;
  /** insert a single row into the table: "project_speckle_model_sync" */
  insert_projectSpeckleModelSync_one?: Maybe<ProjectSpeckleModelSync>;
  /** insert data into the table: "project_speckle_parameter_config" */
  insert_projectSpeckleParameterConfig?: Maybe<ProjectSpeckleParameterConfig_Mutation_Response>;
  /** insert a single row into the table: "project_speckle_parameter_config" */
  insert_projectSpeckleParameterConfig_one?: Maybe<ProjectSpeckleParameterConfig>;
  /** insert data into the table: "project_standard_value_stage" */
  insert_projectStandardValueStage?: Maybe<ProjectStandardValueStage_Mutation_Response>;
  /** insert a single row into the table: "project_standard_value_stage" */
  insert_projectStandardValueStage_one?: Maybe<ProjectStandardValueStage>;
  /** insert data into the table: "project_status" */
  insert_projectStatus?: Maybe<ProjectStatus_Mutation_Response>;
  /** insert a single row into the table: "project_status" */
  insert_projectStatus_one?: Maybe<ProjectStatus>;
  /** insert data into the table: "project_transport_mapping_emission_factor" */
  insert_projectTransportMappingEmissionFactor?: Maybe<ProjectTransportMappingEmissionFactor_Mutation_Response>;
  /** insert a single row into the table: "project_transport_mapping_emission_factor" */
  insert_projectTransportMappingEmissionFactor_one?: Maybe<ProjectTransportMappingEmissionFactor>;
  /** insert data into the table: "project_version" */
  insert_projectVersion?: Maybe<ProjectVersion_Mutation_Response>;
  /** insert data into the table: "project_version_numbered" */
  insert_projectVersionNumbered?: Maybe<ProjectVersionNumbered_Mutation_Response>;
  /** insert a single row into the table: "project_version_numbered" */
  insert_projectVersionNumbered_one?: Maybe<ProjectVersionNumbered>;
  /** insert a single row into the table: "project_version" */
  insert_projectVersion_one?: Maybe<ProjectVersion>;
  /** insert data into the table: "project_waste_mapping" */
  insert_projectWasteMapping?: Maybe<ProjectWasteMapping_Mutation_Response>;
  /** insert a single row into the table: "project_waste_mapping" */
  insert_projectWasteMapping_one?: Maybe<ProjectWasteMapping>;
  /** insert data into the table: "project_waste_type_custom" */
  insert_projectWasteTypeCustom?: Maybe<ProjectWasteTypeCustom_Mutation_Response>;
  /** insert a single row into the table: "project_waste_type_custom" */
  insert_projectWasteTypeCustom_one?: Maybe<ProjectWasteTypeCustom>;
  /** insert a single row into the table: "project" */
  insert_project_one?: Maybe<Project>;
  /** insert data into the table: "project_transport" */
  insert_project_transport?: Maybe<Project_Transport_Mutation_Response>;
  /** insert data into the table: "project_transport_default" */
  insert_project_transport_default?: Maybe<Project_Transport_Default_Mutation_Response>;
  /** insert a single row into the table: "project_transport_default" */
  insert_project_transport_default_one?: Maybe<Project_Transport_Default>;
  /** insert data into the table: "project_transport_mapping" */
  insert_project_transport_mapping?: Maybe<Project_Transport_Mapping_Mutation_Response>;
  /** insert a single row into the table: "project_transport_mapping" */
  insert_project_transport_mapping_one?: Maybe<Project_Transport_Mapping>;
  /** insert a single row into the table: "project_transport" */
  insert_project_transport_one?: Maybe<Project_Transport>;
  /** insert data into the table: "reference_area_type" */
  insert_referenceAreaType?: Maybe<ReferenceAreaType_Mutation_Response>;
  /** insert data into the table: "reference_area_type_calculation_type_mapping" */
  insert_referenceAreaTypeCalculationTypeMapping?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Mutation_Response>;
  /** insert a single row into the table: "reference_area_type_calculation_type_mapping" */
  insert_referenceAreaTypeCalculationTypeMapping_one?: Maybe<ReferenceAreaTypeCalculationTypeMapping>;
  /** insert a single row into the table: "reference_area_type" */
  insert_referenceAreaType_one?: Maybe<ReferenceAreaType>;
  /** insert data into the table: "report_building_type_mapping" */
  insert_reportBuildingTypeMapping?: Maybe<ReportBuildingTypeMapping_Mutation_Response>;
  /** insert a single row into the table: "report_building_type_mapping" */
  insert_reportBuildingTypeMapping_one?: Maybe<ReportBuildingTypeMapping>;
  /** insert data into the table: "report_classification_code_emission_mapping" */
  insert_reportClassificationCodeEmissionMapping?: Maybe<ReportClassificationCodeEmissionMapping_Mutation_Response>;
  /** insert a single row into the table: "report_classification_code_emission_mapping" */
  insert_reportClassificationCodeEmissionMapping_one?: Maybe<ReportClassificationCodeEmissionMapping>;
  /** insert data into the table: "report_load_bearing_element_amount_mapping" */
  insert_reportLoadBearingElementAmountMapping?: Maybe<ReportLoadBearingElementAmountMapping_Mutation_Response>;
  /** insert a single row into the table: "report_load_bearing_element_amount_mapping" */
  insert_reportLoadBearingElementAmountMapping_one?: Maybe<ReportLoadBearingElementAmountMapping>;
  /** insert data into the table: "report_load_bearing_element_emission_mapping" */
  insert_reportLoadBearingElementEmissionMapping?: Maybe<ReportLoadBearingElementEmissionMapping_Mutation_Response>;
  /** insert a single row into the table: "report_load_bearing_element_emission_mapping" */
  insert_reportLoadBearingElementEmissionMapping_one?: Maybe<ReportLoadBearingElementEmissionMapping>;
  /** insert data into the table: "report_structure" */
  insert_reportStructure?: Maybe<ReportStructure_Mutation_Response>;
  /** insert data into the table: "report_structure_calculation_types" */
  insert_reportStructureCalculationTypes?: Maybe<ReportStructureCalculationTypes_Mutation_Response>;
  /** insert a single row into the table: "report_structure_calculation_types" */
  insert_reportStructureCalculationTypes_one?: Maybe<ReportStructureCalculationTypes>;
  /** insert data into the table: "report_structure_classification_codes" */
  insert_reportStructureClassificationCodes?: Maybe<ReportStructureClassificationCodes_Mutation_Response>;
  /** insert a single row into the table: "report_structure_classification_codes" */
  insert_reportStructureClassificationCodes_one?: Maybe<ReportStructureClassificationCodes>;
  /** insert a single row into the table: "report_structure" */
  insert_reportStructure_one?: Maybe<ReportStructure>;
  /** insert data into the table: "reportfilesmetadata" */
  insert_reportfilesmetadata?: Maybe<Reportfilesmetadata_Mutation_Response>;
  /** insert a single row into the table: "reportfilesmetadata" */
  insert_reportfilesmetadata_one?: Maybe<Reportfilesmetadata>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "special_condition_type" */
  insert_specialConditionType?: Maybe<SpecialConditionType_Mutation_Response>;
  /** insert data into the table: "special_condition_type_calculation_type" */
  insert_specialConditionTypeCalculationType?: Maybe<SpecialConditionTypeCalculationType_Mutation_Response>;
  /** insert a single row into the table: "special_condition_type_calculation_type" */
  insert_specialConditionTypeCalculationType_one?: Maybe<SpecialConditionTypeCalculationType>;
  /** insert data into the table: "special_condition_type_input_parameter" */
  insert_specialConditionTypeInputParameter?: Maybe<SpecialConditionTypeInputParameter_Mutation_Response>;
  /** insert a single row into the table: "special_condition_type_input_parameter" */
  insert_specialConditionTypeInputParameter_one?: Maybe<SpecialConditionTypeInputParameter>;
  /** insert a single row into the table: "special_condition_type" */
  insert_specialConditionType_one?: Maybe<SpecialConditionType>;
  /** insert data into the table: "special_condition_type_category" */
  insert_special_condition_type_category?: Maybe<Special_Condition_Type_Category_Mutation_Response>;
  /** insert a single row into the table: "special_condition_type_category" */
  insert_special_condition_type_category_one?: Maybe<Special_Condition_Type_Category>;
  /** insert data into the table: "speckle_stream_model_ifc_upload" */
  insert_speckleStreamModelIfcUpload?: Maybe<SpeckleStreamModelIfcUpload_Mutation_Response>;
  /** insert data into the table: "speckle_stream_model_ifc_upload_recent" */
  insert_speckleStreamModelIfcUploadRecent?: Maybe<SpeckleStreamModelIfcUploadRecent_Mutation_Response>;
  /** insert a single row into the table: "speckle_stream_model_ifc_upload_recent" */
  insert_speckleStreamModelIfcUploadRecent_one?: Maybe<SpeckleStreamModelIfcUploadRecent>;
  /** insert a single row into the table: "speckle_stream_model_ifc_upload" */
  insert_speckleStreamModelIfcUpload_one?: Maybe<SpeckleStreamModelIfcUpload>;
  /** insert data into the table: "speckle_user_data" */
  insert_speckleUserData?: Maybe<SpeckleUserData_Mutation_Response>;
  /** insert a single row into the table: "speckle_user_data" */
  insert_speckleUserData_one?: Maybe<SpeckleUserData>;
  /** insert data into the table: "speckle_stream" */
  insert_speckle_stream?: Maybe<Speckle_Stream_Mutation_Response>;
  /** insert a single row into the table: "speckle_stream" */
  insert_speckle_stream_one?: Maybe<Speckle_Stream>;
  /** insert data into the table: "stage" */
  insert_stage?: Maybe<Stage_Mutation_Response>;
  /** insert data into the table: "stage_default_emission" */
  insert_stageDefaultEmission?: Maybe<StageDefaultEmission_Mutation_Response>;
  /** insert a single row into the table: "stage_default_emission" */
  insert_stageDefaultEmission_one?: Maybe<StageDefaultEmission>;
  /** insert data into the table: "stage_default_emission_building_type" */
  insert_stage_default_emission_building_type?: Maybe<Stage_Default_Emission_Building_Type_Mutation_Response>;
  /** insert a single row into the table: "stage_default_emission_building_type" */
  insert_stage_default_emission_building_type_one?: Maybe<Stage_Default_Emission_Building_Type>;
  /** insert a single row into the table: "stage" */
  insert_stage_one?: Maybe<Stage>;
  /** insert data into the table: "tenant_ai_budget" */
  insert_tenantAiBudget?: Maybe<TenantAiBudget_Mutation_Response>;
  /** insert a single row into the table: "tenant_ai_budget" */
  insert_tenantAiBudget_one?: Maybe<TenantAiBudget>;
  /** insert data into the table: "tenant_ai_credit_purchase" */
  insert_tenantAiCreditPurchase?: Maybe<TenantAiCreditPurchase_Mutation_Response>;
  /** insert a single row into the table: "tenant_ai_credit_purchase" */
  insert_tenantAiCreditPurchase_one?: Maybe<TenantAiCreditPurchase>;
  /** insert data into the table: "tenant_ai_payment" */
  insert_tenantAiPayment?: Maybe<TenantAiPayment_Mutation_Response>;
  /** insert a single row into the table: "tenant_ai_payment" */
  insert_tenantAiPayment_one?: Maybe<TenantAiPayment>;
  /** insert data into the table: "tenant_collection" */
  insert_tenantCollection?: Maybe<TenantCollection_Mutation_Response>;
  /** insert data into the table: "tenant_collection_item" */
  insert_tenantCollectionItem?: Maybe<TenantCollectionItem_Mutation_Response>;
  /** insert a single row into the table: "tenant_collection_item" */
  insert_tenantCollectionItem_one?: Maybe<TenantCollectionItem>;
  /** insert a single row into the table: "tenant_collection" */
  insert_tenantCollection_one?: Maybe<TenantCollection>;
  /** insert data into the table: "tenant_invoice" */
  insert_tenantInvoice?: Maybe<TenantInvoice_Mutation_Response>;
  /** insert a single row into the table: "tenant_invoice" */
  insert_tenantInvoice_one?: Maybe<TenantInvoice>;
  /** insert data into the table: "tenant_user_request_ai_usage" */
  insert_tenantUserRequestAiUsage?: Maybe<TenantUserRequestAiUsage_Mutation_Response>;
  /** insert a single row into the table: "tenant_user_request_ai_usage" */
  insert_tenantUserRequestAiUsage_one?: Maybe<TenantUserRequestAiUsage>;
  /** insert data into the table: "translation_category" */
  insert_translationCategory?: Maybe<TranslationCategory_Mutation_Response>;
  /** insert a single row into the table: "translation_category" */
  insert_translationCategory_one?: Maybe<TranslationCategory>;
  /** insert data into the table: "translation_source" */
  insert_translationSource?: Maybe<TranslationSource_Mutation_Response>;
  /** insert a single row into the table: "translation_source" */
  insert_translationSource_one?: Maybe<TranslationSource>;
  /** insert data into the table: "transport" */
  insert_transport?: Maybe<Transport_Mutation_Response>;
  /** insert data into the table: "transport_emission_factor" */
  insert_transportEmissionFactor?: Maybe<TransportEmissionFactor_Mutation_Response>;
  /** insert a single row into the table: "transport_emission_factor" */
  insert_transportEmissionFactor_one?: Maybe<TransportEmissionFactor>;
  /** insert data into the table: "transport_source" */
  insert_transportSource?: Maybe<TransportSource_Mutation_Response>;
  /** insert data into the table: "transport_source_calculation_type" */
  insert_transportSourceCalculationType?: Maybe<TransportSourceCalculationType_Mutation_Response>;
  /** insert a single row into the table: "transport_source_calculation_type" */
  insert_transportSourceCalculationType_one?: Maybe<TransportSourceCalculationType>;
  /** insert a single row into the table: "transport_source" */
  insert_transportSource_one?: Maybe<TransportSource>;
  /** insert a single row into the table: "transport" */
  insert_transport_one?: Maybe<Transport>;
  /** insert data into the table: "transport_standard_value" */
  insert_transport_standard_value?: Maybe<Transport_Standard_Value_Mutation_Response>;
  /** insert a single row into the table: "transport_standard_value" */
  insert_transport_standard_value_one?: Maybe<Transport_Standard_Value>;
  /** insert data into the table: "transport_type" */
  insert_transport_type?: Maybe<Transport_Type_Mutation_Response>;
  /** insert a single row into the table: "transport_type" */
  insert_transport_type_one?: Maybe<Transport_Type>;
  /** insert data into the table: "unit" */
  insert_unit?: Maybe<Unit_Mutation_Response>;
  /** insert a single row into the table: "unit" */
  insert_unit_one?: Maybe<Unit>;
  /** insert data into the table: "user_material_favorite" */
  insert_userMaterialFavorite?: Maybe<UserMaterialFavorite_Mutation_Response>;
  /** insert a single row into the table: "user_material_favorite" */
  insert_userMaterialFavorite_one?: Maybe<UserMaterialFavorite>;
  /** insert data into the table: "user_platform_review" */
  insert_userPlatformReview?: Maybe<UserPlatformReview_Mutation_Response>;
  /** insert a single row into the table: "user_platform_review" */
  insert_userPlatformReview_one?: Maybe<UserPlatformReview>;
  /** insert data into the table: "user_project_view" */
  insert_userProjectView?: Maybe<UserProjectView_Mutation_Response>;
  /** insert a single row into the table: "user_project_view" */
  insert_userProjectView_one?: Maybe<UserProjectView>;
  /** insert data into the table: "user_tutorial_view" */
  insert_userTutorialView?: Maybe<UserTutorialView_Mutation_Response>;
  /** insert a single row into the table: "user_tutorial_view" */
  insert_userTutorialView_one?: Maybe<UserTutorialView>;
  /** insert data into the table: "user_welcome_flow" */
  insert_userWelcomeFlow?: Maybe<UserWelcomeFlow_Mutation_Response>;
  /** insert data into the table: "user_welcome_flow_event" */
  insert_userWelcomeFlowEvent?: Maybe<UserWelcomeFlowEvent_Mutation_Response>;
  /** insert a single row into the table: "user_welcome_flow_event" */
  insert_userWelcomeFlowEvent_one?: Maybe<UserWelcomeFlowEvent>;
  /** insert a single row into the table: "user_welcome_flow" */
  insert_userWelcomeFlow_one?: Maybe<UserWelcomeFlow>;
  /** insert data into the table: "v_material_gwp" */
  insert_vMaterialGwp?: Maybe<VMaterialGwp_Mutation_Response>;
  /** insert a single row into the table: "v_material_gwp" */
  insert_vMaterialGwp_one?: Maybe<VMaterialGwp>;
  /** insert data into the table: "v_material_status" */
  insert_vMaterialStatus?: Maybe<VMaterialStatus_Mutation_Response>;
  /** insert a single row into the table: "v_material_status" */
  insert_vMaterialStatus_one?: Maybe<VMaterialStatus>;
  /** insert data into the table: "weight_per_declared_unit" */
  insert_weightPerDeclaredUnit?: Maybe<WeightPerDeclaredUnit_Mutation_Response>;
  /** insert a single row into the table: "weight_per_declared_unit" */
  insert_weightPerDeclaredUnit_one?: Maybe<WeightPerDeclaredUnit>;
  /** execute VOLATILE function "project_restore_copy_mappings" which returns "project_revision" */
  project_restore_copy_mappings: Array<ProjectRevision>;
  /** execute VOLATILE function "project_revision_save" which returns "project_revision" */
  project_revision_save: Array<ProjectRevision>;
  /** execute VOLATILE function "project_revision_save_frozen" which returns "project_revision" */
  project_revision_save_frozen: Array<ProjectRevision>;
  /** execute VOLATILE function "project_revision_switch" which returns "project_revision" */
  project_revision_switch: Array<ProjectRevision>;
  /** update data of the table: "agent_model_pricing" */
  update_agentModelPricing?: Maybe<AgentModelPricing_Mutation_Response>;
  /** update single row of the table: "agent_model_pricing" */
  update_agentModelPricing_by_pk?: Maybe<AgentModelPricing>;
  /** update multiples rows of table: "agent_model_pricing" */
  update_agentModelPricing_many?: Maybe<Array<Maybe<AgentModelPricing_Mutation_Response>>>;
  /** update data of the table: "agent_skills_tenant_user" */
  update_agentSkillsTenantUser?: Maybe<AgentSkillsTenantUser_Mutation_Response>;
  /** update single row of the table: "agent_skills_tenant_user" */
  update_agentSkillsTenantUser_by_pk?: Maybe<AgentSkillsTenantUser>;
  /** update multiples rows of table: "agent_skills_tenant_user" */
  update_agentSkillsTenantUser_many?: Maybe<Array<Maybe<AgentSkillsTenantUser_Mutation_Response>>>;
  /** update data of the table: "application_source" */
  update_applicationSource?: Maybe<ApplicationSource_Mutation_Response>;
  /** update single row of the table: "application_source" */
  update_applicationSource_by_pk?: Maybe<ApplicationSource>;
  /** update multiples rows of table: "application_source" */
  update_applicationSource_many?: Maybe<Array<Maybe<ApplicationSource_Mutation_Response>>>;
  /** update data of the table: "benchmark_grouping_verdict" */
  update_benchmarkGroupingVerdict?: Maybe<BenchmarkGroupingVerdict_Mutation_Response>;
  /** update single row of the table: "benchmark_grouping_verdict" */
  update_benchmarkGroupingVerdict_by_pk?: Maybe<BenchmarkGroupingVerdict>;
  /** update multiples rows of table: "benchmark_grouping_verdict" */
  update_benchmarkGroupingVerdict_many?: Maybe<Array<Maybe<BenchmarkGroupingVerdict_Mutation_Response>>>;
  /** update data of the table: "benchmark_inventory_material" */
  update_benchmarkInventoryMaterial?: Maybe<BenchmarkInventoryMaterial_Mutation_Response>;
  /** update single row of the table: "benchmark_inventory_material" */
  update_benchmarkInventoryMaterial_by_pk?: Maybe<BenchmarkInventoryMaterial>;
  /** update multiples rows of table: "benchmark_inventory_material" */
  update_benchmarkInventoryMaterial_many?: Maybe<Array<Maybe<BenchmarkInventoryMaterial_Mutation_Response>>>;
  /** update data of the table: "benchmark_material_mapping" */
  update_benchmarkMaterialMapping?: Maybe<BenchmarkMaterialMapping_Mutation_Response>;
  /** update single row of the table: "benchmark_material_mapping" */
  update_benchmarkMaterialMapping_by_pk?: Maybe<BenchmarkMaterialMapping>;
  /** update multiples rows of table: "benchmark_material_mapping" */
  update_benchmarkMaterialMapping_many?: Maybe<Array<Maybe<BenchmarkMaterialMapping_Mutation_Response>>>;
  /** update data of the table: "benchmark_project_state" */
  update_benchmarkProjectState?: Maybe<BenchmarkProjectState_Mutation_Response>;
  /** update single row of the table: "benchmark_project_state" */
  update_benchmarkProjectState_by_pk?: Maybe<BenchmarkProjectState>;
  /** update multiples rows of table: "benchmark_project_state" */
  update_benchmarkProjectState_many?: Maybe<Array<Maybe<BenchmarkProjectState_Mutation_Response>>>;
  /** update data of the table: "benchmark_snapshot" */
  update_benchmarkSnapshot?: Maybe<BenchmarkSnapshot_Mutation_Response>;
  /** update single row of the table: "benchmark_snapshot" */
  update_benchmarkSnapshot_by_pk?: Maybe<BenchmarkSnapshot>;
  /** update multiples rows of table: "benchmark_snapshot" */
  update_benchmarkSnapshot_many?: Maybe<Array<Maybe<BenchmarkSnapshot_Mutation_Response>>>;
  /** update data of the table: "building_area_type" */
  update_buildingAreaType?: Maybe<BuildingAreaType_Mutation_Response>;
  /** update single row of the table: "building_area_type" */
  update_buildingAreaType_by_pk?: Maybe<BuildingAreaType>;
  /** update multiples rows of table: "building_area_type" */
  update_buildingAreaType_many?: Maybe<Array<Maybe<BuildingAreaType_Mutation_Response>>>;
  /** update data of the table: "building_part" */
  update_buildingPart?: Maybe<BuildingPart_Mutation_Response>;
  /** update data of the table: "building_part_lifetime_source" */
  update_buildingPartLifetimeSource?: Maybe<BuildingPartLifetimeSource_Mutation_Response>;
  /** update single row of the table: "building_part_lifetime_source" */
  update_buildingPartLifetimeSource_by_pk?: Maybe<BuildingPartLifetimeSource>;
  /** update multiples rows of table: "building_part_lifetime_source" */
  update_buildingPartLifetimeSource_many?: Maybe<Array<Maybe<BuildingPartLifetimeSource_Mutation_Response>>>;
  /** update data of the table: "building_part_maintenance_lifetime" */
  update_buildingPartMaintenanceLifetime?: Maybe<BuildingPartMaintenanceLifetime_Mutation_Response>;
  /** update single row of the table: "building_part_maintenance_lifetime" */
  update_buildingPartMaintenanceLifetime_by_pk?: Maybe<BuildingPartMaintenanceLifetime>;
  /** update multiples rows of table: "building_part_maintenance_lifetime" */
  update_buildingPartMaintenanceLifetime_many?: Maybe<Array<Maybe<BuildingPartMaintenanceLifetime_Mutation_Response>>>;
  /** update data of the table: "building_part_service_lifetime" */
  update_buildingPartServiceLifetime?: Maybe<BuildingPartServiceLifetime_Mutation_Response>;
  /** update single row of the table: "building_part_service_lifetime" */
  update_buildingPartServiceLifetime_by_pk?: Maybe<BuildingPartServiceLifetime>;
  /** update multiples rows of table: "building_part_service_lifetime" */
  update_buildingPartServiceLifetime_many?: Maybe<Array<Maybe<BuildingPartServiceLifetime_Mutation_Response>>>;
  /** update single row of the table: "building_part" */
  update_buildingPart_by_pk?: Maybe<BuildingPart>;
  /** update multiples rows of table: "building_part" */
  update_buildingPart_many?: Maybe<Array<Maybe<BuildingPart_Mutation_Response>>>;
  /** update data of the table: "building_type" */
  update_buildingType?: Maybe<BuildingType_Mutation_Response>;
  /** update single row of the table: "building_type" */
  update_buildingType_by_pk?: Maybe<BuildingType>;
  /** update multiples rows of table: "building_type" */
  update_buildingType_many?: Maybe<Array<Maybe<BuildingType_Mutation_Response>>>;
  /** update data of the table: "building_element" */
  update_building_element?: Maybe<Building_Element_Mutation_Response>;
  /** update single row of the table: "building_element" */
  update_building_element_by_pk?: Maybe<Building_Element>;
  /** update data of the table: "building_element_classification_code_mapping" */
  update_building_element_classification_code_mapping?: Maybe<Building_Element_Classification_Code_Mapping_Mutation_Response>;
  /** update single row of the table: "building_element_classification_code_mapping" */
  update_building_element_classification_code_mapping_by_pk?: Maybe<Building_Element_Classification_Code_Mapping>;
  /** update multiples rows of table: "building_element_classification_code_mapping" */
  update_building_element_classification_code_mapping_many?: Maybe<Array<Maybe<Building_Element_Classification_Code_Mapping_Mutation_Response>>>;
  /** update multiples rows of table: "building_element" */
  update_building_element_many?: Maybe<Array<Maybe<Building_Element_Mutation_Response>>>;
  /** update data of the table: "building_element_material_category_mapping" */
  update_building_element_material_category_mapping?: Maybe<Building_Element_Material_Category_Mapping_Mutation_Response>;
  /** update single row of the table: "building_element_material_category_mapping" */
  update_building_element_material_category_mapping_by_pk?: Maybe<Building_Element_Material_Category_Mapping>;
  /** update multiples rows of table: "building_element_material_category_mapping" */
  update_building_element_material_category_mapping_many?: Maybe<Array<Maybe<Building_Element_Material_Category_Mapping_Mutation_Response>>>;
  /** update data of the table: "calculation_type" */
  update_calculationType?: Maybe<CalculationType_Mutation_Response>;
  /** update data of the table: "calculation_type_epd_datasource" */
  update_calculationTypeEpdDatasource?: Maybe<CalculationTypeEpdDatasource_Mutation_Response>;
  /** update single row of the table: "calculation_type_epd_datasource" */
  update_calculationTypeEpdDatasource_by_pk?: Maybe<CalculationTypeEpdDatasource>;
  /** update multiples rows of table: "calculation_type_epd_datasource" */
  update_calculationTypeEpdDatasource_many?: Maybe<Array<Maybe<CalculationTypeEpdDatasource_Mutation_Response>>>;
  /** update data of the table: "calculation_type_threshold_by_building_type" */
  update_calculationTypeThresholdByBuildingType?: Maybe<CalculationTypeThresholdByBuildingType_Mutation_Response>;
  /** update single row of the table: "calculation_type_threshold_by_building_type" */
  update_calculationTypeThresholdByBuildingType_by_pk?: Maybe<CalculationTypeThresholdByBuildingType>;
  /** update multiples rows of table: "calculation_type_threshold_by_building_type" */
  update_calculationTypeThresholdByBuildingType_many?: Maybe<Array<Maybe<CalculationTypeThresholdByBuildingType_Mutation_Response>>>;
  /** update data of the table: "calculation_type_variant" */
  update_calculationTypeVariant?: Maybe<CalculationTypeVariant_Mutation_Response>;
  /** update single row of the table: "calculation_type_variant" */
  update_calculationTypeVariant_by_pk?: Maybe<CalculationTypeVariant>;
  /** update multiples rows of table: "calculation_type_variant" */
  update_calculationTypeVariant_many?: Maybe<Array<Maybe<CalculationTypeVariant_Mutation_Response>>>;
  /** update single row of the table: "calculation_type" */
  update_calculationType_by_pk?: Maybe<CalculationType>;
  /** update multiples rows of table: "calculation_type" */
  update_calculationType_many?: Maybe<Array<Maybe<CalculationType_Mutation_Response>>>;
  /** update data of the table: "calculation_type_stage" */
  update_calculation_type_stage?: Maybe<Calculation_Type_Stage_Mutation_Response>;
  /** update single row of the table: "calculation_type_stage" */
  update_calculation_type_stage_by_pk?: Maybe<Calculation_Type_Stage>;
  /** update multiples rows of table: "calculation_type_stage" */
  update_calculation_type_stage_many?: Maybe<Array<Maybe<Calculation_Type_Stage_Mutation_Response>>>;
  /** update data of the table: "classification_code" */
  update_classificationCode?: Maybe<ClassificationCode_Mutation_Response>;
  /** update data of the table: "classification_code_translation" */
  update_classificationCodeTranslation?: Maybe<ClassificationCodeTranslation_Mutation_Response>;
  /** update single row of the table: "classification_code_translation" */
  update_classificationCodeTranslation_by_pk?: Maybe<ClassificationCodeTranslation>;
  /** update multiples rows of table: "classification_code_translation" */
  update_classificationCodeTranslation_many?: Maybe<Array<Maybe<ClassificationCodeTranslation_Mutation_Response>>>;
  /** update data of the table: "classification_type_country" */
  update_classificationCodeTypeCountry?: Maybe<ClassificationCodeTypeCountry_Mutation_Response>;
  /** update single row of the table: "classification_type_country" */
  update_classificationCodeTypeCountry_by_pk?: Maybe<ClassificationCodeTypeCountry>;
  /** update multiples rows of table: "classification_type_country" */
  update_classificationCodeTypeCountry_many?: Maybe<Array<Maybe<ClassificationCodeTypeCountry_Mutation_Response>>>;
  /** update single row of the table: "classification_code" */
  update_classificationCode_by_pk?: Maybe<ClassificationCode>;
  /** update multiples rows of table: "classification_code" */
  update_classificationCode_many?: Maybe<Array<Maybe<ClassificationCode_Mutation_Response>>>;
  /** update data of the table: "classification_object_class" */
  update_classificationObjectClass?: Maybe<ClassificationObjectClass_Mutation_Response>;
  /** update data of the table: "classification_object_class_parameter" */
  update_classificationObjectClassParameter?: Maybe<ClassificationObjectClassParameter_Mutation_Response>;
  /** update single row of the table: "classification_object_class_parameter" */
  update_classificationObjectClassParameter_by_pk?: Maybe<ClassificationObjectClassParameter>;
  /** update multiples rows of table: "classification_object_class_parameter" */
  update_classificationObjectClassParameter_many?: Maybe<Array<Maybe<ClassificationObjectClassParameter_Mutation_Response>>>;
  /** update data of the table: "classification_object_class_translation" */
  update_classificationObjectClassTranslation?: Maybe<ClassificationObjectClassTranslation_Mutation_Response>;
  /** update single row of the table: "classification_object_class_translation" */
  update_classificationObjectClassTranslation_by_pk?: Maybe<ClassificationObjectClassTranslation>;
  /** update multiples rows of table: "classification_object_class_translation" */
  update_classificationObjectClassTranslation_many?: Maybe<Array<Maybe<ClassificationObjectClassTranslation_Mutation_Response>>>;
  /** update single row of the table: "classification_object_class" */
  update_classificationObjectClass_by_pk?: Maybe<ClassificationObjectClass>;
  /** update multiples rows of table: "classification_object_class" */
  update_classificationObjectClass_many?: Maybe<Array<Maybe<ClassificationObjectClass_Mutation_Response>>>;
  /** update data of the table: "classification_type" */
  update_classificationType?: Maybe<ClassificationType_Mutation_Response>;
  /** update data of the table: "classification_type_parameter" */
  update_classificationTypeAttribute?: Maybe<ClassificationTypeAttribute_Mutation_Response>;
  /** update single row of the table: "classification_type_parameter" */
  update_classificationTypeAttribute_by_pk?: Maybe<ClassificationTypeAttribute>;
  /** update multiples rows of table: "classification_type_parameter" */
  update_classificationTypeAttribute_many?: Maybe<Array<Maybe<ClassificationTypeAttribute_Mutation_Response>>>;
  /** update single row of the table: "classification_type" */
  update_classificationType_by_pk?: Maybe<ClassificationType>;
  /** update multiples rows of table: "classification_type" */
  update_classificationType_many?: Maybe<Array<Maybe<ClassificationType_Mutation_Response>>>;
  /** update data of the table: "component_object_phase" */
  update_componentObjectPhase?: Maybe<ComponentObjectPhase_Mutation_Response>;
  /** update single row of the table: "component_object_phase" */
  update_componentObjectPhase_by_pk?: Maybe<ComponentObjectPhase>;
  /** update multiples rows of table: "component_object_phase" */
  update_componentObjectPhase_many?: Maybe<Array<Maybe<ComponentObjectPhase_Mutation_Response>>>;
  /** update data of the table: "construction" */
  update_construction?: Maybe<Construction_Mutation_Response>;
  /** update data of the table: "construction_build_up_part" */
  update_constructionBuildUpPart?: Maybe<ConstructionBuildUpPart_Mutation_Response>;
  /** update data of the table: "construction_build_up_part_material_category" */
  update_constructionBuildUpPartMaterialCategory?: Maybe<ConstructionBuildUpPartMaterialCategory_Mutation_Response>;
  /** update single row of the table: "construction_build_up_part_material_category" */
  update_constructionBuildUpPartMaterialCategory_by_pk?: Maybe<ConstructionBuildUpPartMaterialCategory>;
  /** update multiples rows of table: "construction_build_up_part_material_category" */
  update_constructionBuildUpPartMaterialCategory_many?: Maybe<Array<Maybe<ConstructionBuildUpPartMaterialCategory_Mutation_Response>>>;
  /** update data of the table: "construction_build_up_part_translation" */
  update_constructionBuildUpPartTranslation?: Maybe<ConstructionBuildUpPartTranslation_Mutation_Response>;
  /** update single row of the table: "construction_build_up_part_translation" */
  update_constructionBuildUpPartTranslation_by_pk?: Maybe<ConstructionBuildUpPartTranslation>;
  /** update multiples rows of table: "construction_build_up_part_translation" */
  update_constructionBuildUpPartTranslation_many?: Maybe<Array<Maybe<ConstructionBuildUpPartTranslation_Mutation_Response>>>;
  /** update single row of the table: "construction_build_up_part" */
  update_constructionBuildUpPart_by_pk?: Maybe<ConstructionBuildUpPart>;
  /** update multiples rows of table: "construction_build_up_part" */
  update_constructionBuildUpPart_many?: Maybe<Array<Maybe<ConstructionBuildUpPart_Mutation_Response>>>;
  /** update data of the table: "construction_build_up_template" */
  update_constructionBuildUpTemplate?: Maybe<ConstructionBuildUpTemplate_Mutation_Response>;
  /** update data of the table: "construction_build_up_template_translation" */
  update_constructionBuildUpTemplateTranslation?: Maybe<ConstructionBuildUpTemplateTranslation_Mutation_Response>;
  /** update single row of the table: "construction_build_up_template_translation" */
  update_constructionBuildUpTemplateTranslation_by_pk?: Maybe<ConstructionBuildUpTemplateTranslation>;
  /** update multiples rows of table: "construction_build_up_template_translation" */
  update_constructionBuildUpTemplateTranslation_many?: Maybe<Array<Maybe<ConstructionBuildUpTemplateTranslation_Mutation_Response>>>;
  /** update single row of the table: "construction_build_up_template" */
  update_constructionBuildUpTemplate_by_pk?: Maybe<ConstructionBuildUpTemplate>;
  /** update multiples rows of table: "construction_build_up_template" */
  update_constructionBuildUpTemplate_many?: Maybe<Array<Maybe<ConstructionBuildUpTemplate_Mutation_Response>>>;
  /** update data of the table: "construction_category" */
  update_constructionCategory?: Maybe<ConstructionCategory_Mutation_Response>;
  /** update data of the table: "construction_category_translation" */
  update_constructionCategoryTranslation?: Maybe<ConstructionCategoryTranslation_Mutation_Response>;
  /** update single row of the table: "construction_category_translation" */
  update_constructionCategoryTranslation_by_pk?: Maybe<ConstructionCategoryTranslation>;
  /** update multiples rows of table: "construction_category_translation" */
  update_constructionCategoryTranslation_many?: Maybe<Array<Maybe<ConstructionCategoryTranslation_Mutation_Response>>>;
  /** update data of the table: "construction_category_unit" */
  update_constructionCategoryUnit?: Maybe<ConstructionCategoryUnit_Mutation_Response>;
  /** update single row of the table: "construction_category_unit" */
  update_constructionCategoryUnit_by_pk?: Maybe<ConstructionCategoryUnit>;
  /** update multiples rows of table: "construction_category_unit" */
  update_constructionCategoryUnit_many?: Maybe<Array<Maybe<ConstructionCategoryUnit_Mutation_Response>>>;
  /** update single row of the table: "construction_category" */
  update_constructionCategory_by_pk?: Maybe<ConstructionCategory>;
  /** update multiples rows of table: "construction_category" */
  update_constructionCategory_many?: Maybe<Array<Maybe<ConstructionCategory_Mutation_Response>>>;
  /** update data of the table: "construction_country" */
  update_constructionCountry?: Maybe<ConstructionCountry_Mutation_Response>;
  /** update single row of the table: "construction_country" */
  update_constructionCountry_by_pk?: Maybe<ConstructionCountry>;
  /** update multiples rows of table: "construction_country" */
  update_constructionCountry_many?: Maybe<Array<Maybe<ConstructionCountry_Mutation_Response>>>;
  /** update data of the table: "construction_description" */
  update_constructionDescription?: Maybe<ConstructionDescription_Mutation_Response>;
  /** update single row of the table: "construction_description" */
  update_constructionDescription_by_pk?: Maybe<ConstructionDescription>;
  /** update multiples rows of table: "construction_description" */
  update_constructionDescription_many?: Maybe<Array<Maybe<ConstructionDescription_Mutation_Response>>>;
  /** update data of the table: "construction_fork" */
  update_constructionFork?: Maybe<ConstructionFork_Mutation_Response>;
  /** update single row of the table: "construction_fork" */
  update_constructionFork_by_pk?: Maybe<ConstructionFork>;
  /** update multiples rows of table: "construction_fork" */
  update_constructionFork_many?: Maybe<Array<Maybe<ConstructionFork_Mutation_Response>>>;
  /** update data of the table: "construction_inhomogeneous_layer" */
  update_constructionInhomogeneousLayer?: Maybe<ConstructionInhomogeneousLayer_Mutation_Response>;
  /** update data of the table: "construction_inhomogeneous_layer_material" */
  update_constructionInhomogeneousLayerMaterial?: Maybe<ConstructionInhomogeneousLayerMaterial_Mutation_Response>;
  /** update single row of the table: "construction_inhomogeneous_layer_material" */
  update_constructionInhomogeneousLayerMaterial_by_pk?: Maybe<ConstructionInhomogeneousLayerMaterial>;
  /** update multiples rows of table: "construction_inhomogeneous_layer_material" */
  update_constructionInhomogeneousLayerMaterial_many?: Maybe<Array<Maybe<ConstructionInhomogeneousLayerMaterial_Mutation_Response>>>;
  /** update single row of the table: "construction_inhomogeneous_layer" */
  update_constructionInhomogeneousLayer_by_pk?: Maybe<ConstructionInhomogeneousLayer>;
  /** update multiples rows of table: "construction_inhomogeneous_layer" */
  update_constructionInhomogeneousLayer_many?: Maybe<Array<Maybe<ConstructionInhomogeneousLayer_Mutation_Response>>>;
  /** update data of the table: "construction_inhomogenous_layer_description" */
  update_constructionInhomogenousLayerDescription?: Maybe<ConstructionInhomogenousLayerDescription_Mutation_Response>;
  /** update single row of the table: "construction_inhomogenous_layer_description" */
  update_constructionInhomogenousLayerDescription_by_pk?: Maybe<ConstructionInhomogenousLayerDescription>;
  /** update multiples rows of table: "construction_inhomogenous_layer_description" */
  update_constructionInhomogenousLayerDescription_many?: Maybe<Array<Maybe<ConstructionInhomogenousLayerDescription_Mutation_Response>>>;
  /** update data of the table: "construction_inhomogenous_layer_name" */
  update_constructionInhomogenousLayerName?: Maybe<ConstructionInhomogenousLayerName_Mutation_Response>;
  /** update single row of the table: "construction_inhomogenous_layer_name" */
  update_constructionInhomogenousLayerName_by_pk?: Maybe<ConstructionInhomogenousLayerName>;
  /** update multiples rows of table: "construction_inhomogenous_layer_name" */
  update_constructionInhomogenousLayerName_many?: Maybe<Array<Maybe<ConstructionInhomogenousLayerName_Mutation_Response>>>;
  /** update data of the table: "construction_material" */
  update_constructionMaterial?: Maybe<ConstructionMaterial_Mutation_Response>;
  /** update single row of the table: "construction_material" */
  update_constructionMaterial_by_pk?: Maybe<ConstructionMaterial>;
  /** update multiples rows of table: "construction_material" */
  update_constructionMaterial_many?: Maybe<Array<Maybe<ConstructionMaterial_Mutation_Response>>>;
  /** update data of the table: "construction_name" */
  update_constructionName?: Maybe<ConstructionName_Mutation_Response>;
  /** update single row of the table: "construction_name" */
  update_constructionName_by_pk?: Maybe<ConstructionName>;
  /** update multiples rows of table: "construction_name" */
  update_constructionName_many?: Maybe<Array<Maybe<ConstructionName_Mutation_Response>>>;
  /** update data of the table: "construction_sorting" */
  update_constructionSorting?: Maybe<ConstructionSorting_Mutation_Response>;
  /** update single row of the table: "construction_sorting" */
  update_constructionSorting_by_pk?: Maybe<ConstructionSorting>;
  /** update multiples rows of table: "construction_sorting" */
  update_constructionSorting_many?: Maybe<Array<Maybe<ConstructionSorting_Mutation_Response>>>;
  /** update single row of the table: "construction" */
  update_construction_by_pk?: Maybe<Construction>;
  /** update multiples rows of table: "construction" */
  update_construction_many?: Maybe<Array<Maybe<Construction_Mutation_Response>>>;
  /** update data of the table: "country" */
  update_country?: Maybe<Country_Mutation_Response>;
  /** update data of the table: "country_config" */
  update_countryConfig?: Maybe<CountryConfig_Mutation_Response>;
  /** update single row of the table: "country_config" */
  update_countryConfig_by_pk?: Maybe<CountryConfig>;
  /** update multiples rows of table: "country_config" */
  update_countryConfig_many?: Maybe<Array<Maybe<CountryConfig_Mutation_Response>>>;
  /** update single row of the table: "country" */
  update_country_by_pk?: Maybe<Country>;
  /** update multiples rows of table: "country" */
  update_country_many?: Maybe<Array<Maybe<Country_Mutation_Response>>>;
  /** update data of the table: "declared_unit" */
  update_declaredUnit?: Maybe<DeclaredUnit_Mutation_Response>;
  /** update single row of the table: "declared_unit" */
  update_declaredUnit_by_pk?: Maybe<DeclaredUnit>;
  /** update multiples rows of table: "declared_unit" */
  update_declaredUnit_many?: Maybe<Array<Maybe<DeclaredUnit_Mutation_Response>>>;
  /** update data of the table: "denominator_unit" */
  update_denominatorUnit?: Maybe<DenominatorUnit_Mutation_Response>;
  /** update single row of the table: "denominator_unit" */
  update_denominatorUnit_by_pk?: Maybe<DenominatorUnit>;
  /** update multiples rows of table: "denominator_unit" */
  update_denominatorUnit_many?: Maybe<Array<Maybe<DenominatorUnit_Mutation_Response>>>;
  /** update data of the table: "distance_unit" */
  update_distance_unit?: Maybe<Distance_Unit_Mutation_Response>;
  /** update single row of the table: "distance_unit" */
  update_distance_unit_by_pk?: Maybe<Distance_Unit>;
  /** update multiples rows of table: "distance_unit" */
  update_distance_unit_many?: Maybe<Array<Maybe<Distance_Unit_Mutation_Response>>>;
  /** update data of the table: "emission_factor_source_type" */
  update_emissionFactorSourceType?: Maybe<EmissionFactorSourceType_Mutation_Response>;
  /** update single row of the table: "emission_factor_source_type" */
  update_emissionFactorSourceType_by_pk?: Maybe<EmissionFactorSourceType>;
  /** update multiples rows of table: "emission_factor_source_type" */
  update_emissionFactorSourceType_many?: Maybe<Array<Maybe<EmissionFactorSourceType_Mutation_Response>>>;
  /** update data of the table: "emission_factor" */
  update_emission_factor?: Maybe<Emission_Factor_Mutation_Response>;
  /** update single row of the table: "emission_factor" */
  update_emission_factor_by_pk?: Maybe<Emission_Factor>;
  /** update multiples rows of table: "emission_factor" */
  update_emission_factor_many?: Maybe<Array<Maybe<Emission_Factor_Mutation_Response>>>;
  /** update data of the table: "emission_factor_source" */
  update_emission_factor_source?: Maybe<Emission_Factor_Source_Mutation_Response>;
  /** update single row of the table: "emission_factor_source" */
  update_emission_factor_source_by_pk?: Maybe<Emission_Factor_Source>;
  /** update multiples rows of table: "emission_factor_source" */
  update_emission_factor_source_many?: Maybe<Array<Maybe<Emission_Factor_Source_Mutation_Response>>>;
  /** update data of the table: "emission_factor_type" */
  update_emission_factor_type?: Maybe<Emission_Factor_Type_Mutation_Response>;
  /** update single row of the table: "emission_factor_type" */
  update_emission_factor_type_by_pk?: Maybe<Emission_Factor_Type>;
  /** update multiples rows of table: "emission_factor_type" */
  update_emission_factor_type_many?: Maybe<Array<Maybe<Emission_Factor_Type_Mutation_Response>>>;
  /** update data of the table: "enum_collection_type" */
  update_enumCollectionType?: Maybe<EnumCollectionType_Mutation_Response>;
  /** update single row of the table: "enum_collection_type" */
  update_enumCollectionType_by_pk?: Maybe<EnumCollectionType>;
  /** update multiples rows of table: "enum_collection_type" */
  update_enumCollectionType_many?: Maybe<Array<Maybe<EnumCollectionType_Mutation_Response>>>;
  /** update data of the table: "epd_datasource" */
  update_epdDatasource?: Maybe<EpdDatasource_Mutation_Response>;
  /** update single row of the table: "epd_datasource" */
  update_epdDatasource_by_pk?: Maybe<EpdDatasource>;
  /** update multiples rows of table: "epd_datasource" */
  update_epdDatasource_many?: Maybe<Array<Maybe<EpdDatasource_Mutation_Response>>>;
  /** update data of the table: "epd_owner" */
  update_epdOwner?: Maybe<EpdOwner_Mutation_Response>;
  /** update data of the table: "epd_owner_alias" */
  update_epdOwnerAlias?: Maybe<EpdOwnerAlias_Mutation_Response>;
  /** update single row of the table: "epd_owner_alias" */
  update_epdOwnerAlias_by_pk?: Maybe<EpdOwnerAlias>;
  /** update multiples rows of table: "epd_owner_alias" */
  update_epdOwnerAlias_many?: Maybe<Array<Maybe<EpdOwnerAlias_Mutation_Response>>>;
  /** update single row of the table: "epd_owner" */
  update_epdOwner_by_pk?: Maybe<EpdOwner>;
  /** update multiples rows of table: "epd_owner" */
  update_epdOwner_many?: Maybe<Array<Maybe<EpdOwner_Mutation_Response>>>;
  /** update data of the table: "epd_product_industry" */
  update_epdProductIndustry?: Maybe<EpdProductIndustry_Mutation_Response>;
  /** update single row of the table: "epd_product_industry" */
  update_epdProductIndustry_by_pk?: Maybe<EpdProductIndustry>;
  /** update multiples rows of table: "epd_product_industry" */
  update_epdProductIndustry_many?: Maybe<Array<Maybe<EpdProductIndustry_Mutation_Response>>>;
  /** update data of the table: "epd_specification_form" */
  update_epdSpecificationForm?: Maybe<EpdSpecificationForm_Mutation_Response>;
  /** update single row of the table: "epd_specification_form" */
  update_epdSpecificationForm_by_pk?: Maybe<EpdSpecificationForm>;
  /** update multiples rows of table: "epd_specification_form" */
  update_epdSpecificationForm_many?: Maybe<Array<Maybe<EpdSpecificationForm_Mutation_Response>>>;
  /** update data of the table: "flow_guide" */
  update_flowGuide?: Maybe<FlowGuide_Mutation_Response>;
  /** update data of the table: "flow_guide_views" */
  update_flowGuideViews?: Maybe<FlowGuideViews_Mutation_Response>;
  /** update single row of the table: "flow_guide_views" */
  update_flowGuideViews_by_pk?: Maybe<FlowGuideViews>;
  /** update multiples rows of table: "flow_guide_views" */
  update_flowGuideViews_many?: Maybe<Array<Maybe<FlowGuideViews_Mutation_Response>>>;
  /** update single row of the table: "flow_guide" */
  update_flowGuide_by_pk?: Maybe<FlowGuide>;
  /** update multiples rows of table: "flow_guide" */
  update_flowGuide_many?: Maybe<Array<Maybe<FlowGuide_Mutation_Response>>>;
  /** update data of the table: "indicator_source" */
  update_indicatorSource?: Maybe<IndicatorSource_Mutation_Response>;
  /** update single row of the table: "indicator_source" */
  update_indicatorSource_by_pk?: Maybe<IndicatorSource>;
  /** update multiples rows of table: "indicator_source" */
  update_indicatorSource_many?: Maybe<Array<Maybe<IndicatorSource_Mutation_Response>>>;
  /** update data of the table: "indicator_type" */
  update_indicatorType?: Maybe<IndicatorType_Mutation_Response>;
  /** update data of the table: "indicator_type_mapping" */
  update_indicatorTypeMapping?: Maybe<IndicatorTypeMapping_Mutation_Response>;
  /** update single row of the table: "indicator_type_mapping" */
  update_indicatorTypeMapping_by_pk?: Maybe<IndicatorTypeMapping>;
  /** update multiples rows of table: "indicator_type_mapping" */
  update_indicatorTypeMapping_many?: Maybe<Array<Maybe<IndicatorTypeMapping_Mutation_Response>>>;
  /** update data of the table: "indicator_type_multiplier" */
  update_indicatorTypeMultiplier?: Maybe<IndicatorTypeMultiplier_Mutation_Response>;
  /** update single row of the table: "indicator_type_multiplier" */
  update_indicatorTypeMultiplier_by_pk?: Maybe<IndicatorTypeMultiplier>;
  /** update multiples rows of table: "indicator_type_multiplier" */
  update_indicatorTypeMultiplier_many?: Maybe<Array<Maybe<IndicatorTypeMultiplier_Mutation_Response>>>;
  /** update single row of the table: "indicator_type" */
  update_indicatorType_by_pk?: Maybe<IndicatorType>;
  /** update multiples rows of table: "indicator_type" */
  update_indicatorType_many?: Maybe<Array<Maybe<IndicatorType_Mutation_Response>>>;
  /** update data of the table: "installation_standard_value" */
  update_installation_standard_value?: Maybe<Installation_Standard_Value_Mutation_Response>;
  /** update data of the table: "installation_standard_value_building_type" */
  update_installation_standard_value_building_type?: Maybe<Installation_Standard_Value_Building_Type_Mutation_Response>;
  /** update single row of the table: "installation_standard_value_building_type" */
  update_installation_standard_value_building_type_by_pk?: Maybe<Installation_Standard_Value_Building_Type>;
  /** update multiples rows of table: "installation_standard_value_building_type" */
  update_installation_standard_value_building_type_many?: Maybe<Array<Maybe<Installation_Standard_Value_Building_Type_Mutation_Response>>>;
  /** update single row of the table: "installation_standard_value" */
  update_installation_standard_value_by_pk?: Maybe<Installation_Standard_Value>;
  /** update data of the table: "installation_standard_value_classification_type" */
  update_installation_standard_value_classification_type?: Maybe<Installation_Standard_Value_Classification_Type_Mutation_Response>;
  /** update single row of the table: "installation_standard_value_classification_type" */
  update_installation_standard_value_classification_type_by_pk?: Maybe<Installation_Standard_Value_Classification_Type>;
  /** update multiples rows of table: "installation_standard_value_classification_type" */
  update_installation_standard_value_classification_type_many?: Maybe<Array<Maybe<Installation_Standard_Value_Classification_Type_Mutation_Response>>>;
  /** update data of the table: "installation_standard_value_datasource" */
  update_installation_standard_value_datasource?: Maybe<Installation_Standard_Value_Datasource_Mutation_Response>;
  /** update single row of the table: "installation_standard_value_datasource" */
  update_installation_standard_value_datasource_by_pk?: Maybe<Installation_Standard_Value_Datasource>;
  /** update multiples rows of table: "installation_standard_value_datasource" */
  update_installation_standard_value_datasource_many?: Maybe<Array<Maybe<Installation_Standard_Value_Datasource_Mutation_Response>>>;
  /** update data of the table: "installation_standard_value_emission" */
  update_installation_standard_value_emission?: Maybe<Installation_Standard_Value_Emission_Mutation_Response>;
  /** update single row of the table: "installation_standard_value_emission" */
  update_installation_standard_value_emission_by_pk?: Maybe<Installation_Standard_Value_Emission>;
  /** update multiples rows of table: "installation_standard_value_emission" */
  update_installation_standard_value_emission_many?: Maybe<Array<Maybe<Installation_Standard_Value_Emission_Mutation_Response>>>;
  /** update multiples rows of table: "installation_standard_value" */
  update_installation_standard_value_many?: Maybe<Array<Maybe<Installation_Standard_Value_Mutation_Response>>>;
  /** update data of the table: "language" */
  update_language?: Maybe<Language_Mutation_Response>;
  /** update single row of the table: "language" */
  update_language_by_pk?: Maybe<Language>;
  /** update multiples rows of table: "language" */
  update_language_many?: Maybe<Array<Maybe<Language_Mutation_Response>>>;
  /** update data of the table: "lifetime_table" */
  update_lifetime_table?: Maybe<Lifetime_Table_Mutation_Response>;
  /** update single row of the table: "lifetime_table" */
  update_lifetime_table_by_pk?: Maybe<Lifetime_Table>;
  /** update multiples rows of table: "lifetime_table" */
  update_lifetime_table_many?: Maybe<Array<Maybe<Lifetime_Table_Mutation_Response>>>;
  /** update data of the table: "mapping_history" */
  update_mappingHistory?: Maybe<MappingHistory_Mutation_Response>;
  /** update single row of the table: "mapping_history" */
  update_mappingHistory_by_pk?: Maybe<MappingHistory>;
  /** update multiples rows of table: "mapping_history" */
  update_mappingHistory_many?: Maybe<Array<Maybe<MappingHistory_Mutation_Response>>>;
  /** update data of the table: "material" */
  update_material?: Maybe<Material_Mutation_Response>;
  /** update data of the table: "material_biogenic_params" */
  update_materialBiogenicParams?: Maybe<MaterialBiogenicParams_Mutation_Response>;
  /** update single row of the table: "material_biogenic_params" */
  update_materialBiogenicParams_by_pk?: Maybe<MaterialBiogenicParams>;
  /** update multiples rows of table: "material_biogenic_params" */
  update_materialBiogenicParams_many?: Maybe<Array<Maybe<MaterialBiogenicParams_Mutation_Response>>>;
  /** update data of the table: "material_category" */
  update_materialCategory?: Maybe<MaterialCategory_Mutation_Response>;
  /** update data of the table: "material_category_texture" */
  update_materialCategoryTexture?: Maybe<MaterialCategoryTexture_Mutation_Response>;
  /** update single row of the table: "material_category_texture" */
  update_materialCategoryTexture_by_pk?: Maybe<MaterialCategoryTexture>;
  /** update multiples rows of table: "material_category_texture" */
  update_materialCategoryTexture_many?: Maybe<Array<Maybe<MaterialCategoryTexture_Mutation_Response>>>;
  /** update single row of the table: "material_category" */
  update_materialCategory_by_pk?: Maybe<MaterialCategory>;
  /** update multiples rows of table: "material_category" */
  update_materialCategory_many?: Maybe<Array<Maybe<MaterialCategory_Mutation_Response>>>;
  /** update data of the table: "material_description" */
  update_materialDescription?: Maybe<MaterialDescription_Mutation_Response>;
  /** update single row of the table: "material_description" */
  update_materialDescription_by_pk?: Maybe<MaterialDescription>;
  /** update multiples rows of table: "material_description" */
  update_materialDescription_many?: Maybe<Array<Maybe<MaterialDescription_Mutation_Response>>>;
  /** update data of the table: "material_emission_indicator" */
  update_materialEmissionIndicator?: Maybe<MaterialEmissionIndicator_Mutation_Response>;
  /** update single row of the table: "material_emission_indicator" */
  update_materialEmissionIndicator_by_pk?: Maybe<MaterialEmissionIndicator>;
  /** update multiples rows of table: "material_emission_indicator" */
  update_materialEmissionIndicator_many?: Maybe<Array<Maybe<MaterialEmissionIndicator_Mutation_Response>>>;
  /** update data of the table: "material_epd" */
  update_materialEpd?: Maybe<MaterialEpd_Mutation_Response>;
  /** update data of the table: "material_epd_datasource" */
  update_materialEpdDatasource?: Maybe<MaterialEpdDatasource_Mutation_Response>;
  /** update single row of the table: "material_epd_datasource" */
  update_materialEpdDatasource_by_pk?: Maybe<MaterialEpdDatasource>;
  /** update multiples rows of table: "material_epd_datasource" */
  update_materialEpdDatasource_many?: Maybe<Array<Maybe<MaterialEpdDatasource_Mutation_Response>>>;
  /** update data of the table: "material_epd_url" */
  update_materialEpdUrl?: Maybe<MaterialEpdUrl_Mutation_Response>;
  /** update single row of the table: "material_epd_url" */
  update_materialEpdUrl_by_pk?: Maybe<MaterialEpdUrl>;
  /** update multiples rows of table: "material_epd_url" */
  update_materialEpdUrl_many?: Maybe<Array<Maybe<MaterialEpdUrl_Mutation_Response>>>;
  /** update single row of the table: "material_epd" */
  update_materialEpd_by_pk?: Maybe<MaterialEpd>;
  /** update multiples rows of table: "material_epd" */
  update_materialEpd_many?: Maybe<Array<Maybe<MaterialEpd_Mutation_Response>>>;
  /** update data of the table: "material_fork" */
  update_materialFork?: Maybe<MaterialFork_Mutation_Response>;
  /** update single row of the table: "material_fork" */
  update_materialFork_by_pk?: Maybe<MaterialFork>;
  /** update multiples rows of table: "material_fork" */
  update_materialFork_many?: Maybe<Array<Maybe<MaterialFork_Mutation_Response>>>;
  /** update data of the table: "material_name" */
  update_materialName?: Maybe<MaterialName_Mutation_Response>;
  /** update single row of the table: "material_name" */
  update_materialName_by_pk?: Maybe<MaterialName>;
  /** update multiples rows of table: "material_name" */
  update_materialName_many?: Maybe<Array<Maybe<MaterialName_Mutation_Response>>>;
  /** update data of the table: "material_emission" */
  update_materialStage?: Maybe<MaterialStage_Mutation_Response>;
  /** update single row of the table: "material_emission" */
  update_materialStage_by_pk?: Maybe<MaterialStage>;
  /** update multiples rows of table: "material_emission" */
  update_materialStage_many?: Maybe<Array<Maybe<MaterialStage_Mutation_Response>>>;
  /** update data of the table: "material_type" */
  update_materialType?: Maybe<MaterialType_Mutation_Response>;
  /** update single row of the table: "material_type" */
  update_materialType_by_pk?: Maybe<MaterialType>;
  /** update multiples rows of table: "material_type" */
  update_materialType_many?: Maybe<Array<Maybe<MaterialType_Mutation_Response>>>;
  /** update data of the table: "material_waste_source" */
  update_materialWasteSource?: Maybe<MaterialWasteSource_Mutation_Response>;
  /** update single row of the table: "material_waste_source" */
  update_materialWasteSource_by_pk?: Maybe<MaterialWasteSource>;
  /** update multiples rows of table: "material_waste_source" */
  update_materialWasteSource_many?: Maybe<Array<Maybe<MaterialWasteSource_Mutation_Response>>>;
  /** update data of the table: "material_waste_type" */
  update_materialWasteType?: Maybe<MaterialWasteType_Mutation_Response>;
  /** update single row of the table: "material_waste_type" */
  update_materialWasteType_by_pk?: Maybe<MaterialWasteType>;
  /** update multiples rows of table: "material_waste_type" */
  update_materialWasteType_many?: Maybe<Array<Maybe<MaterialWasteType_Mutation_Response>>>;
  /** update single row of the table: "material" */
  update_material_by_pk?: Maybe<Material>;
  /** update multiples rows of table: "material" */
  update_material_many?: Maybe<Array<Maybe<Material_Mutation_Response>>>;
  /** update data of the table: "mcp_connection" */
  update_mcpConnection?: Maybe<McpConnection_Mutation_Response>;
  /** update single row of the table: "mcp_connection" */
  update_mcpConnection_by_pk?: Maybe<McpConnection>;
  /** update multiples rows of table: "mcp_connection" */
  update_mcpConnection_many?: Maybe<Array<Maybe<McpConnection_Mutation_Response>>>;
  /** update data of the table: "mcp_tool_call" */
  update_mcpToolCall?: Maybe<McpToolCall_Mutation_Response>;
  /** update single row of the table: "mcp_tool_call" */
  update_mcpToolCall_by_pk?: Maybe<McpToolCall>;
  /** update multiples rows of table: "mcp_tool_call" */
  update_mcpToolCall_many?: Maybe<Array<Maybe<McpToolCall_Mutation_Response>>>;
  /** update data of the table: "model" */
  update_model?: Maybe<Model_Mutation_Response>;
  /** update single row of the table: "model" */
  update_model_by_pk?: Maybe<Model>;
  /** update multiples rows of table: "model" */
  update_model_many?: Maybe<Array<Maybe<Model_Mutation_Response>>>;
  /** update data of the table: "project" */
  update_project?: Maybe<Project_Mutation_Response>;
  /** update data of the table: "project_building_area" */
  update_projectBuildingArea?: Maybe<ProjectBuildingArea_Mutation_Response>;
  /** update single row of the table: "project_building_area" */
  update_projectBuildingArea_by_pk?: Maybe<ProjectBuildingArea>;
  /** update multiples rows of table: "project_building_area" */
  update_projectBuildingArea_many?: Maybe<Array<Maybe<ProjectBuildingArea_Mutation_Response>>>;
  /** update data of the table: "project_calculation" */
  update_projectCalculation?: Maybe<ProjectCalculation_Mutation_Response>;
  /** update data of the table: "project_calculation_stage" */
  update_projectCalculationStage?: Maybe<ProjectCalculationStage_Mutation_Response>;
  /** update single row of the table: "project_calculation_stage" */
  update_projectCalculationStage_by_pk?: Maybe<ProjectCalculationStage>;
  /** update multiples rows of table: "project_calculation_stage" */
  update_projectCalculationStage_many?: Maybe<Array<Maybe<ProjectCalculationStage_Mutation_Response>>>;
  /** update single row of the table: "project_calculation" */
  update_projectCalculation_by_pk?: Maybe<ProjectCalculation>;
  /** update multiples rows of table: "project_calculation" */
  update_projectCalculation_many?: Maybe<Array<Maybe<ProjectCalculation_Mutation_Response>>>;
  /** update data of the table: "project_component_mapping_type" */
  update_projectComponentMappingType?: Maybe<ProjectComponentMappingType_Mutation_Response>;
  /** update single row of the table: "project_component_mapping_type" */
  update_projectComponentMappingType_by_pk?: Maybe<ProjectComponentMappingType>;
  /** update multiples rows of table: "project_component_mapping_type" */
  update_projectComponentMappingType_many?: Maybe<Array<Maybe<ProjectComponentMappingType_Mutation_Response>>>;
  /** update data of the table: "project_dashboard_status" */
  update_projectDashboardStatus?: Maybe<ProjectDashboardStatus_Mutation_Response>;
  /** update single row of the table: "project_dashboard_status" */
  update_projectDashboardStatus_by_pk?: Maybe<ProjectDashboardStatus>;
  /** update multiples rows of table: "project_dashboard_status" */
  update_projectDashboardStatus_many?: Maybe<Array<Maybe<ProjectDashboardStatus_Mutation_Response>>>;
  /** update data of the table: "project_emission_factor" */
  update_projectEmissionFactor?: Maybe<ProjectEmissionFactor_Mutation_Response>;
  /** update data of the table: "project_emission_factor_custom" */
  update_projectEmissionFactorCustom?: Maybe<ProjectEmissionFactorCustom_Mutation_Response>;
  /** update single row of the table: "project_emission_factor_custom" */
  update_projectEmissionFactorCustom_by_pk?: Maybe<ProjectEmissionFactorCustom>;
  /** update multiples rows of table: "project_emission_factor_custom" */
  update_projectEmissionFactorCustom_many?: Maybe<Array<Maybe<ProjectEmissionFactorCustom_Mutation_Response>>>;
  /** update single row of the table: "project_emission_factor" */
  update_projectEmissionFactor_by_pk?: Maybe<ProjectEmissionFactor>;
  /** update multiples rows of table: "project_emission_factor" */
  update_projectEmissionFactor_many?: Maybe<Array<Maybe<ProjectEmissionFactor_Mutation_Response>>>;
  /** update data of the table: "project_installation" */
  update_projectInstallation?: Maybe<ProjectInstallation_Mutation_Response>;
  /** update single row of the table: "project_installation" */
  update_projectInstallation_by_pk?: Maybe<ProjectInstallation>;
  /** update multiples rows of table: "project_installation" */
  update_projectInstallation_many?: Maybe<Array<Maybe<ProjectInstallation_Mutation_Response>>>;
  /** update data of the table: "project_location" */
  update_projectLocation?: Maybe<ProjectLocation_Mutation_Response>;
  /** update single row of the table: "project_location" */
  update_projectLocation_by_pk?: Maybe<ProjectLocation>;
  /** update multiples rows of table: "project_location" */
  update_projectLocation_many?: Maybe<Array<Maybe<ProjectLocation_Mutation_Response>>>;
  /** update data of the table: "project_material_classification_feedback" */
  update_projectMaterialClassificationFeedback?: Maybe<ProjectMaterialClassificationFeedback_Mutation_Response>;
  /** update single row of the table: "project_material_classification_feedback" */
  update_projectMaterialClassificationFeedback_by_pk?: Maybe<ProjectMaterialClassificationFeedback>;
  /** update multiples rows of table: "project_material_classification_feedback" */
  update_projectMaterialClassificationFeedback_many?: Maybe<Array<Maybe<ProjectMaterialClassificationFeedback_Mutation_Response>>>;
  /** update data of the table: "project_material_classification_parameter" */
  update_projectMaterialClassificationParameter?: Maybe<ProjectMaterialClassificationParameter_Mutation_Response>;
  /** update single row of the table: "project_material_classification_parameter" */
  update_projectMaterialClassificationParameter_by_pk?: Maybe<ProjectMaterialClassificationParameter>;
  /** update multiples rows of table: "project_material_classification_parameter" */
  update_projectMaterialClassificationParameter_many?: Maybe<Array<Maybe<ProjectMaterialClassificationParameter_Mutation_Response>>>;
  /** update data of the table: "project_membership" */
  update_projectMembership?: Maybe<ProjectMembership_Mutation_Response>;
  /** update single row of the table: "project_membership" */
  update_projectMembership_by_pk?: Maybe<ProjectMembership>;
  /** update multiples rows of table: "project_membership" */
  update_projectMembership_many?: Maybe<Array<Maybe<ProjectMembership_Mutation_Response>>>;
  /** update data of the table: "project_model" */
  update_projectModel?: Maybe<ProjectModel_Mutation_Response>;
  /** update data of the table: "project_model_speckle_pin" */
  update_projectModelSpecklePin?: Maybe<ProjectModelSpecklePin_Mutation_Response>;
  /** update single row of the table: "project_model_speckle_pin" */
  update_projectModelSpecklePin_by_pk?: Maybe<ProjectModelSpecklePin>;
  /** update multiples rows of table: "project_model_speckle_pin" */
  update_projectModelSpecklePin_many?: Maybe<Array<Maybe<ProjectModelSpecklePin_Mutation_Response>>>;
  /** update single row of the table: "project_model" */
  update_projectModel_by_pk?: Maybe<ProjectModel>;
  /** update multiples rows of table: "project_model" */
  update_projectModel_many?: Maybe<Array<Maybe<ProjectModel_Mutation_Response>>>;
  /** update data of the table: "project_operational" */
  update_projectOperational?: Maybe<ProjectOperational_Mutation_Response>;
  /** update single row of the table: "project_operational" */
  update_projectOperational_by_pk?: Maybe<ProjectOperational>;
  /** update multiples rows of table: "project_operational" */
  update_projectOperational_many?: Maybe<Array<Maybe<ProjectOperational_Mutation_Response>>>;
  /** update data of the table: "project_reference_area" */
  update_projectReferenceArea?: Maybe<ProjectReferenceArea_Mutation_Response>;
  /** update single row of the table: "project_reference_area" */
  update_projectReferenceArea_by_pk?: Maybe<ProjectReferenceArea>;
  /** update multiples rows of table: "project_reference_area" */
  update_projectReferenceArea_many?: Maybe<Array<Maybe<ProjectReferenceArea_Mutation_Response>>>;
  /** update data of the table: "project_revision" */
  update_projectRevision?: Maybe<ProjectRevision_Mutation_Response>;
  /** update single row of the table: "project_revision" */
  update_projectRevision_by_pk?: Maybe<ProjectRevision>;
  /** update multiples rows of table: "project_revision" */
  update_projectRevision_many?: Maybe<Array<Maybe<ProjectRevision_Mutation_Response>>>;
  /** update data of the table: "project_special_condition_config" */
  update_projectSpecialConditionConfig?: Maybe<ProjectSpecialConditionConfig_Mutation_Response>;
  /** update single row of the table: "project_special_condition_config" */
  update_projectSpecialConditionConfig_by_pk?: Maybe<ProjectSpecialConditionConfig>;
  /** update multiples rows of table: "project_special_condition_config" */
  update_projectSpecialConditionConfig_many?: Maybe<Array<Maybe<ProjectSpecialConditionConfig_Mutation_Response>>>;
  /** update data of the table: "project_special_condition_type_mapping" */
  update_projectSpecialConditionTypeMapping?: Maybe<ProjectSpecialConditionTypeMapping_Mutation_Response>;
  /** update single row of the table: "project_special_condition_type_mapping" */
  update_projectSpecialConditionTypeMapping_by_pk?: Maybe<ProjectSpecialConditionTypeMapping>;
  /** update multiples rows of table: "project_special_condition_type_mapping" */
  update_projectSpecialConditionTypeMapping_many?: Maybe<Array<Maybe<ProjectSpecialConditionTypeMapping_Mutation_Response>>>;
  /** update data of the table: "project_speckle_copy" */
  update_projectSpeckleCopy?: Maybe<ProjectSpeckleCopy_Mutation_Response>;
  /** update data of the table: "project_speckle_copy_recent" */
  update_projectSpeckleCopyRecent?: Maybe<ProjectSpeckleCopyRecent_Mutation_Response>;
  /** update multiples rows of table: "project_speckle_copy_recent" */
  update_projectSpeckleCopyRecent_many?: Maybe<Array<Maybe<ProjectSpeckleCopyRecent_Mutation_Response>>>;
  /** update single row of the table: "project_speckle_copy" */
  update_projectSpeckleCopy_by_pk?: Maybe<ProjectSpeckleCopy>;
  /** update multiples rows of table: "project_speckle_copy" */
  update_projectSpeckleCopy_many?: Maybe<Array<Maybe<ProjectSpeckleCopy_Mutation_Response>>>;
  /** update data of the table: "project_speckle_model_sync" */
  update_projectSpeckleModelSync?: Maybe<ProjectSpeckleModelSync_Mutation_Response>;
  /** update data of the table: "project_speckle_model_sync_recent" */
  update_projectSpeckleModelSyncRecent?: Maybe<ProjectSpeckleModelSyncRecent_Mutation_Response>;
  /** update multiples rows of table: "project_speckle_model_sync_recent" */
  update_projectSpeckleModelSyncRecent_many?: Maybe<Array<Maybe<ProjectSpeckleModelSyncRecent_Mutation_Response>>>;
  /** update single row of the table: "project_speckle_model_sync" */
  update_projectSpeckleModelSync_by_pk?: Maybe<ProjectSpeckleModelSync>;
  /** update multiples rows of table: "project_speckle_model_sync" */
  update_projectSpeckleModelSync_many?: Maybe<Array<Maybe<ProjectSpeckleModelSync_Mutation_Response>>>;
  /** update data of the table: "project_speckle_parameter_config" */
  update_projectSpeckleParameterConfig?: Maybe<ProjectSpeckleParameterConfig_Mutation_Response>;
  /** update single row of the table: "project_speckle_parameter_config" */
  update_projectSpeckleParameterConfig_by_pk?: Maybe<ProjectSpeckleParameterConfig>;
  /** update multiples rows of table: "project_speckle_parameter_config" */
  update_projectSpeckleParameterConfig_many?: Maybe<Array<Maybe<ProjectSpeckleParameterConfig_Mutation_Response>>>;
  /** update data of the table: "project_standard_value_stage" */
  update_projectStandardValueStage?: Maybe<ProjectStandardValueStage_Mutation_Response>;
  /** update single row of the table: "project_standard_value_stage" */
  update_projectStandardValueStage_by_pk?: Maybe<ProjectStandardValueStage>;
  /** update multiples rows of table: "project_standard_value_stage" */
  update_projectStandardValueStage_many?: Maybe<Array<Maybe<ProjectStandardValueStage_Mutation_Response>>>;
  /** update data of the table: "project_status" */
  update_projectStatus?: Maybe<ProjectStatus_Mutation_Response>;
  /** update single row of the table: "project_status" */
  update_projectStatus_by_pk?: Maybe<ProjectStatus>;
  /** update multiples rows of table: "project_status" */
  update_projectStatus_many?: Maybe<Array<Maybe<ProjectStatus_Mutation_Response>>>;
  /** update data of the table: "project_transport_mapping_emission_factor" */
  update_projectTransportMappingEmissionFactor?: Maybe<ProjectTransportMappingEmissionFactor_Mutation_Response>;
  /** update single row of the table: "project_transport_mapping_emission_factor" */
  update_projectTransportMappingEmissionFactor_by_pk?: Maybe<ProjectTransportMappingEmissionFactor>;
  /** update multiples rows of table: "project_transport_mapping_emission_factor" */
  update_projectTransportMappingEmissionFactor_many?: Maybe<Array<Maybe<ProjectTransportMappingEmissionFactor_Mutation_Response>>>;
  /** update data of the table: "project_version" */
  update_projectVersion?: Maybe<ProjectVersion_Mutation_Response>;
  /** update data of the table: "project_version_numbered" */
  update_projectVersionNumbered?: Maybe<ProjectVersionNumbered_Mutation_Response>;
  /** update multiples rows of table: "project_version_numbered" */
  update_projectVersionNumbered_many?: Maybe<Array<Maybe<ProjectVersionNumbered_Mutation_Response>>>;
  /** update single row of the table: "project_version" */
  update_projectVersion_by_pk?: Maybe<ProjectVersion>;
  /** update multiples rows of table: "project_version" */
  update_projectVersion_many?: Maybe<Array<Maybe<ProjectVersion_Mutation_Response>>>;
  /** update data of the table: "project_waste_mapping" */
  update_projectWasteMapping?: Maybe<ProjectWasteMapping_Mutation_Response>;
  /** update single row of the table: "project_waste_mapping" */
  update_projectWasteMapping_by_pk?: Maybe<ProjectWasteMapping>;
  /** update multiples rows of table: "project_waste_mapping" */
  update_projectWasteMapping_many?: Maybe<Array<Maybe<ProjectWasteMapping_Mutation_Response>>>;
  /** update data of the table: "project_waste_type_custom" */
  update_projectWasteTypeCustom?: Maybe<ProjectWasteTypeCustom_Mutation_Response>;
  /** update single row of the table: "project_waste_type_custom" */
  update_projectWasteTypeCustom_by_pk?: Maybe<ProjectWasteTypeCustom>;
  /** update multiples rows of table: "project_waste_type_custom" */
  update_projectWasteTypeCustom_many?: Maybe<Array<Maybe<ProjectWasteTypeCustom_Mutation_Response>>>;
  /** update single row of the table: "project" */
  update_project_by_pk?: Maybe<Project>;
  /** update multiples rows of table: "project" */
  update_project_many?: Maybe<Array<Maybe<Project_Mutation_Response>>>;
  /** update data of the table: "project_transport" */
  update_project_transport?: Maybe<Project_Transport_Mutation_Response>;
  /** update single row of the table: "project_transport" */
  update_project_transport_by_pk?: Maybe<Project_Transport>;
  /** update data of the table: "project_transport_default" */
  update_project_transport_default?: Maybe<Project_Transport_Default_Mutation_Response>;
  /** update single row of the table: "project_transport_default" */
  update_project_transport_default_by_pk?: Maybe<Project_Transport_Default>;
  /** update multiples rows of table: "project_transport_default" */
  update_project_transport_default_many?: Maybe<Array<Maybe<Project_Transport_Default_Mutation_Response>>>;
  /** update multiples rows of table: "project_transport" */
  update_project_transport_many?: Maybe<Array<Maybe<Project_Transport_Mutation_Response>>>;
  /** update data of the table: "project_transport_mapping" */
  update_project_transport_mapping?: Maybe<Project_Transport_Mapping_Mutation_Response>;
  /** update single row of the table: "project_transport_mapping" */
  update_project_transport_mapping_by_pk?: Maybe<Project_Transport_Mapping>;
  /** update multiples rows of table: "project_transport_mapping" */
  update_project_transport_mapping_many?: Maybe<Array<Maybe<Project_Transport_Mapping_Mutation_Response>>>;
  /** update data of the table: "reference_area_type" */
  update_referenceAreaType?: Maybe<ReferenceAreaType_Mutation_Response>;
  /** update data of the table: "reference_area_type_calculation_type_mapping" */
  update_referenceAreaTypeCalculationTypeMapping?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Mutation_Response>;
  /** update single row of the table: "reference_area_type_calculation_type_mapping" */
  update_referenceAreaTypeCalculationTypeMapping_by_pk?: Maybe<ReferenceAreaTypeCalculationTypeMapping>;
  /** update multiples rows of table: "reference_area_type_calculation_type_mapping" */
  update_referenceAreaTypeCalculationTypeMapping_many?: Maybe<Array<Maybe<ReferenceAreaTypeCalculationTypeMapping_Mutation_Response>>>;
  /** update single row of the table: "reference_area_type" */
  update_referenceAreaType_by_pk?: Maybe<ReferenceAreaType>;
  /** update multiples rows of table: "reference_area_type" */
  update_referenceAreaType_many?: Maybe<Array<Maybe<ReferenceAreaType_Mutation_Response>>>;
  /** update data of the table: "report_building_type_mapping" */
  update_reportBuildingTypeMapping?: Maybe<ReportBuildingTypeMapping_Mutation_Response>;
  /** update single row of the table: "report_building_type_mapping" */
  update_reportBuildingTypeMapping_by_pk?: Maybe<ReportBuildingTypeMapping>;
  /** update multiples rows of table: "report_building_type_mapping" */
  update_reportBuildingTypeMapping_many?: Maybe<Array<Maybe<ReportBuildingTypeMapping_Mutation_Response>>>;
  /** update data of the table: "report_classification_code_emission_mapping" */
  update_reportClassificationCodeEmissionMapping?: Maybe<ReportClassificationCodeEmissionMapping_Mutation_Response>;
  /** update single row of the table: "report_classification_code_emission_mapping" */
  update_reportClassificationCodeEmissionMapping_by_pk?: Maybe<ReportClassificationCodeEmissionMapping>;
  /** update multiples rows of table: "report_classification_code_emission_mapping" */
  update_reportClassificationCodeEmissionMapping_many?: Maybe<Array<Maybe<ReportClassificationCodeEmissionMapping_Mutation_Response>>>;
  /** update data of the table: "report_load_bearing_element_amount_mapping" */
  update_reportLoadBearingElementAmountMapping?: Maybe<ReportLoadBearingElementAmountMapping_Mutation_Response>;
  /** update single row of the table: "report_load_bearing_element_amount_mapping" */
  update_reportLoadBearingElementAmountMapping_by_pk?: Maybe<ReportLoadBearingElementAmountMapping>;
  /** update multiples rows of table: "report_load_bearing_element_amount_mapping" */
  update_reportLoadBearingElementAmountMapping_many?: Maybe<Array<Maybe<ReportLoadBearingElementAmountMapping_Mutation_Response>>>;
  /** update data of the table: "report_load_bearing_element_emission_mapping" */
  update_reportLoadBearingElementEmissionMapping?: Maybe<ReportLoadBearingElementEmissionMapping_Mutation_Response>;
  /** update single row of the table: "report_load_bearing_element_emission_mapping" */
  update_reportLoadBearingElementEmissionMapping_by_pk?: Maybe<ReportLoadBearingElementEmissionMapping>;
  /** update multiples rows of table: "report_load_bearing_element_emission_mapping" */
  update_reportLoadBearingElementEmissionMapping_many?: Maybe<Array<Maybe<ReportLoadBearingElementEmissionMapping_Mutation_Response>>>;
  /** update data of the table: "report_structure" */
  update_reportStructure?: Maybe<ReportStructure_Mutation_Response>;
  /** update data of the table: "report_structure_calculation_types" */
  update_reportStructureCalculationTypes?: Maybe<ReportStructureCalculationTypes_Mutation_Response>;
  /** update single row of the table: "report_structure_calculation_types" */
  update_reportStructureCalculationTypes_by_pk?: Maybe<ReportStructureCalculationTypes>;
  /** update multiples rows of table: "report_structure_calculation_types" */
  update_reportStructureCalculationTypes_many?: Maybe<Array<Maybe<ReportStructureCalculationTypes_Mutation_Response>>>;
  /** update data of the table: "report_structure_classification_codes" */
  update_reportStructureClassificationCodes?: Maybe<ReportStructureClassificationCodes_Mutation_Response>;
  /** update single row of the table: "report_structure_classification_codes" */
  update_reportStructureClassificationCodes_by_pk?: Maybe<ReportStructureClassificationCodes>;
  /** update multiples rows of table: "report_structure_classification_codes" */
  update_reportStructureClassificationCodes_many?: Maybe<Array<Maybe<ReportStructureClassificationCodes_Mutation_Response>>>;
  /** update single row of the table: "report_structure" */
  update_reportStructure_by_pk?: Maybe<ReportStructure>;
  /** update multiples rows of table: "report_structure" */
  update_reportStructure_many?: Maybe<Array<Maybe<ReportStructure_Mutation_Response>>>;
  /** update data of the table: "reportfilesmetadata" */
  update_reportfilesmetadata?: Maybe<Reportfilesmetadata_Mutation_Response>;
  /** update single row of the table: "reportfilesmetadata" */
  update_reportfilesmetadata_by_pk?: Maybe<Reportfilesmetadata>;
  /** update multiples rows of table: "reportfilesmetadata" */
  update_reportfilesmetadata_many?: Maybe<Array<Maybe<Reportfilesmetadata_Mutation_Response>>>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  update_roles_many?: Maybe<Array<Maybe<Roles_Mutation_Response>>>;
  /** update data of the table: "special_condition_type" */
  update_specialConditionType?: Maybe<SpecialConditionType_Mutation_Response>;
  /** update data of the table: "special_condition_type_calculation_type" */
  update_specialConditionTypeCalculationType?: Maybe<SpecialConditionTypeCalculationType_Mutation_Response>;
  /** update single row of the table: "special_condition_type_calculation_type" */
  update_specialConditionTypeCalculationType_by_pk?: Maybe<SpecialConditionTypeCalculationType>;
  /** update multiples rows of table: "special_condition_type_calculation_type" */
  update_specialConditionTypeCalculationType_many?: Maybe<Array<Maybe<SpecialConditionTypeCalculationType_Mutation_Response>>>;
  /** update data of the table: "special_condition_type_input_parameter" */
  update_specialConditionTypeInputParameter?: Maybe<SpecialConditionTypeInputParameter_Mutation_Response>;
  /** update single row of the table: "special_condition_type_input_parameter" */
  update_specialConditionTypeInputParameter_by_pk?: Maybe<SpecialConditionTypeInputParameter>;
  /** update multiples rows of table: "special_condition_type_input_parameter" */
  update_specialConditionTypeInputParameter_many?: Maybe<Array<Maybe<SpecialConditionTypeInputParameter_Mutation_Response>>>;
  /** update single row of the table: "special_condition_type" */
  update_specialConditionType_by_pk?: Maybe<SpecialConditionType>;
  /** update multiples rows of table: "special_condition_type" */
  update_specialConditionType_many?: Maybe<Array<Maybe<SpecialConditionType_Mutation_Response>>>;
  /** update data of the table: "special_condition_type_category" */
  update_special_condition_type_category?: Maybe<Special_Condition_Type_Category_Mutation_Response>;
  /** update single row of the table: "special_condition_type_category" */
  update_special_condition_type_category_by_pk?: Maybe<Special_Condition_Type_Category>;
  /** update multiples rows of table: "special_condition_type_category" */
  update_special_condition_type_category_many?: Maybe<Array<Maybe<Special_Condition_Type_Category_Mutation_Response>>>;
  /** update data of the table: "speckle_stream_model_ifc_upload" */
  update_speckleStreamModelIfcUpload?: Maybe<SpeckleStreamModelIfcUpload_Mutation_Response>;
  /** update data of the table: "speckle_stream_model_ifc_upload_recent" */
  update_speckleStreamModelIfcUploadRecent?: Maybe<SpeckleStreamModelIfcUploadRecent_Mutation_Response>;
  /** update multiples rows of table: "speckle_stream_model_ifc_upload_recent" */
  update_speckleStreamModelIfcUploadRecent_many?: Maybe<Array<Maybe<SpeckleStreamModelIfcUploadRecent_Mutation_Response>>>;
  /** update single row of the table: "speckle_stream_model_ifc_upload" */
  update_speckleStreamModelIfcUpload_by_pk?: Maybe<SpeckleStreamModelIfcUpload>;
  /** update multiples rows of table: "speckle_stream_model_ifc_upload" */
  update_speckleStreamModelIfcUpload_many?: Maybe<Array<Maybe<SpeckleStreamModelIfcUpload_Mutation_Response>>>;
  /** update data of the table: "speckle_user_data" */
  update_speckleUserData?: Maybe<SpeckleUserData_Mutation_Response>;
  /** update single row of the table: "speckle_user_data" */
  update_speckleUserData_by_pk?: Maybe<SpeckleUserData>;
  /** update multiples rows of table: "speckle_user_data" */
  update_speckleUserData_many?: Maybe<Array<Maybe<SpeckleUserData_Mutation_Response>>>;
  /** update data of the table: "speckle_stream" */
  update_speckle_stream?: Maybe<Speckle_Stream_Mutation_Response>;
  /** update single row of the table: "speckle_stream" */
  update_speckle_stream_by_pk?: Maybe<Speckle_Stream>;
  /** update multiples rows of table: "speckle_stream" */
  update_speckle_stream_many?: Maybe<Array<Maybe<Speckle_Stream_Mutation_Response>>>;
  /** update data of the table: "stage" */
  update_stage?: Maybe<Stage_Mutation_Response>;
  /** update data of the table: "stage_default_emission" */
  update_stageDefaultEmission?: Maybe<StageDefaultEmission_Mutation_Response>;
  /** update single row of the table: "stage_default_emission" */
  update_stageDefaultEmission_by_pk?: Maybe<StageDefaultEmission>;
  /** update multiples rows of table: "stage_default_emission" */
  update_stageDefaultEmission_many?: Maybe<Array<Maybe<StageDefaultEmission_Mutation_Response>>>;
  /** update single row of the table: "stage" */
  update_stage_by_pk?: Maybe<Stage>;
  /** update data of the table: "stage_default_emission_building_type" */
  update_stage_default_emission_building_type?: Maybe<Stage_Default_Emission_Building_Type_Mutation_Response>;
  /** update single row of the table: "stage_default_emission_building_type" */
  update_stage_default_emission_building_type_by_pk?: Maybe<Stage_Default_Emission_Building_Type>;
  /** update multiples rows of table: "stage_default_emission_building_type" */
  update_stage_default_emission_building_type_many?: Maybe<Array<Maybe<Stage_Default_Emission_Building_Type_Mutation_Response>>>;
  /** update multiples rows of table: "stage" */
  update_stage_many?: Maybe<Array<Maybe<Stage_Mutation_Response>>>;
  /** update data of the table: "tenant_ai_budget" */
  update_tenantAiBudget?: Maybe<TenantAiBudget_Mutation_Response>;
  /** update single row of the table: "tenant_ai_budget" */
  update_tenantAiBudget_by_pk?: Maybe<TenantAiBudget>;
  /** update multiples rows of table: "tenant_ai_budget" */
  update_tenantAiBudget_many?: Maybe<Array<Maybe<TenantAiBudget_Mutation_Response>>>;
  /** update data of the table: "tenant_ai_credit_purchase" */
  update_tenantAiCreditPurchase?: Maybe<TenantAiCreditPurchase_Mutation_Response>;
  /** update single row of the table: "tenant_ai_credit_purchase" */
  update_tenantAiCreditPurchase_by_pk?: Maybe<TenantAiCreditPurchase>;
  /** update multiples rows of table: "tenant_ai_credit_purchase" */
  update_tenantAiCreditPurchase_many?: Maybe<Array<Maybe<TenantAiCreditPurchase_Mutation_Response>>>;
  /** update data of the table: "tenant_ai_payment" */
  update_tenantAiPayment?: Maybe<TenantAiPayment_Mutation_Response>;
  /** update single row of the table: "tenant_ai_payment" */
  update_tenantAiPayment_by_pk?: Maybe<TenantAiPayment>;
  /** update multiples rows of table: "tenant_ai_payment" */
  update_tenantAiPayment_many?: Maybe<Array<Maybe<TenantAiPayment_Mutation_Response>>>;
  /** update data of the table: "tenant_collection" */
  update_tenantCollection?: Maybe<TenantCollection_Mutation_Response>;
  /** update data of the table: "tenant_collection_item" */
  update_tenantCollectionItem?: Maybe<TenantCollectionItem_Mutation_Response>;
  /** update single row of the table: "tenant_collection_item" */
  update_tenantCollectionItem_by_pk?: Maybe<TenantCollectionItem>;
  /** update multiples rows of table: "tenant_collection_item" */
  update_tenantCollectionItem_many?: Maybe<Array<Maybe<TenantCollectionItem_Mutation_Response>>>;
  /** update single row of the table: "tenant_collection" */
  update_tenantCollection_by_pk?: Maybe<TenantCollection>;
  /** update multiples rows of table: "tenant_collection" */
  update_tenantCollection_many?: Maybe<Array<Maybe<TenantCollection_Mutation_Response>>>;
  /** update data of the table: "tenant_invoice" */
  update_tenantInvoice?: Maybe<TenantInvoice_Mutation_Response>;
  /** update single row of the table: "tenant_invoice" */
  update_tenantInvoice_by_pk?: Maybe<TenantInvoice>;
  /** update multiples rows of table: "tenant_invoice" */
  update_tenantInvoice_many?: Maybe<Array<Maybe<TenantInvoice_Mutation_Response>>>;
  /** update data of the table: "tenant_user_request_ai_usage" */
  update_tenantUserRequestAiUsage?: Maybe<TenantUserRequestAiUsage_Mutation_Response>;
  /** update single row of the table: "tenant_user_request_ai_usage" */
  update_tenantUserRequestAiUsage_by_pk?: Maybe<TenantUserRequestAiUsage>;
  /** update multiples rows of table: "tenant_user_request_ai_usage" */
  update_tenantUserRequestAiUsage_many?: Maybe<Array<Maybe<TenantUserRequestAiUsage_Mutation_Response>>>;
  /** update data of the table: "translation_category" */
  update_translationCategory?: Maybe<TranslationCategory_Mutation_Response>;
  /** update single row of the table: "translation_category" */
  update_translationCategory_by_pk?: Maybe<TranslationCategory>;
  /** update multiples rows of table: "translation_category" */
  update_translationCategory_many?: Maybe<Array<Maybe<TranslationCategory_Mutation_Response>>>;
  /** update data of the table: "translation_source" */
  update_translationSource?: Maybe<TranslationSource_Mutation_Response>;
  /** update single row of the table: "translation_source" */
  update_translationSource_by_pk?: Maybe<TranslationSource>;
  /** update multiples rows of table: "translation_source" */
  update_translationSource_many?: Maybe<Array<Maybe<TranslationSource_Mutation_Response>>>;
  /** update data of the table: "transport" */
  update_transport?: Maybe<Transport_Mutation_Response>;
  /** update data of the table: "transport_emission_factor" */
  update_transportEmissionFactor?: Maybe<TransportEmissionFactor_Mutation_Response>;
  /** update single row of the table: "transport_emission_factor" */
  update_transportEmissionFactor_by_pk?: Maybe<TransportEmissionFactor>;
  /** update multiples rows of table: "transport_emission_factor" */
  update_transportEmissionFactor_many?: Maybe<Array<Maybe<TransportEmissionFactor_Mutation_Response>>>;
  /** update data of the table: "transport_source" */
  update_transportSource?: Maybe<TransportSource_Mutation_Response>;
  /** update data of the table: "transport_source_calculation_type" */
  update_transportSourceCalculationType?: Maybe<TransportSourceCalculationType_Mutation_Response>;
  /** update single row of the table: "transport_source_calculation_type" */
  update_transportSourceCalculationType_by_pk?: Maybe<TransportSourceCalculationType>;
  /** update multiples rows of table: "transport_source_calculation_type" */
  update_transportSourceCalculationType_many?: Maybe<Array<Maybe<TransportSourceCalculationType_Mutation_Response>>>;
  /** update single row of the table: "transport_source" */
  update_transportSource_by_pk?: Maybe<TransportSource>;
  /** update multiples rows of table: "transport_source" */
  update_transportSource_many?: Maybe<Array<Maybe<TransportSource_Mutation_Response>>>;
  /** update single row of the table: "transport" */
  update_transport_by_pk?: Maybe<Transport>;
  /** update multiples rows of table: "transport" */
  update_transport_many?: Maybe<Array<Maybe<Transport_Mutation_Response>>>;
  /** update data of the table: "transport_standard_value" */
  update_transport_standard_value?: Maybe<Transport_Standard_Value_Mutation_Response>;
  /** update single row of the table: "transport_standard_value" */
  update_transport_standard_value_by_pk?: Maybe<Transport_Standard_Value>;
  /** update multiples rows of table: "transport_standard_value" */
  update_transport_standard_value_many?: Maybe<Array<Maybe<Transport_Standard_Value_Mutation_Response>>>;
  /** update data of the table: "transport_type" */
  update_transport_type?: Maybe<Transport_Type_Mutation_Response>;
  /** update single row of the table: "transport_type" */
  update_transport_type_by_pk?: Maybe<Transport_Type>;
  /** update multiples rows of table: "transport_type" */
  update_transport_type_many?: Maybe<Array<Maybe<Transport_Type_Mutation_Response>>>;
  /** update data of the table: "unit" */
  update_unit?: Maybe<Unit_Mutation_Response>;
  /** update single row of the table: "unit" */
  update_unit_by_pk?: Maybe<Unit>;
  /** update multiples rows of table: "unit" */
  update_unit_many?: Maybe<Array<Maybe<Unit_Mutation_Response>>>;
  /** update data of the table: "user_material_favorite" */
  update_userMaterialFavorite?: Maybe<UserMaterialFavorite_Mutation_Response>;
  /** update single row of the table: "user_material_favorite" */
  update_userMaterialFavorite_by_pk?: Maybe<UserMaterialFavorite>;
  /** update multiples rows of table: "user_material_favorite" */
  update_userMaterialFavorite_many?: Maybe<Array<Maybe<UserMaterialFavorite_Mutation_Response>>>;
  /** update data of the table: "user_platform_review" */
  update_userPlatformReview?: Maybe<UserPlatformReview_Mutation_Response>;
  /** update single row of the table: "user_platform_review" */
  update_userPlatformReview_by_pk?: Maybe<UserPlatformReview>;
  /** update multiples rows of table: "user_platform_review" */
  update_userPlatformReview_many?: Maybe<Array<Maybe<UserPlatformReview_Mutation_Response>>>;
  /** update data of the table: "user_project_view" */
  update_userProjectView?: Maybe<UserProjectView_Mutation_Response>;
  /** update single row of the table: "user_project_view" */
  update_userProjectView_by_pk?: Maybe<UserProjectView>;
  /** update multiples rows of table: "user_project_view" */
  update_userProjectView_many?: Maybe<Array<Maybe<UserProjectView_Mutation_Response>>>;
  /** update data of the table: "user_tutorial_view" */
  update_userTutorialView?: Maybe<UserTutorialView_Mutation_Response>;
  /** update single row of the table: "user_tutorial_view" */
  update_userTutorialView_by_pk?: Maybe<UserTutorialView>;
  /** update multiples rows of table: "user_tutorial_view" */
  update_userTutorialView_many?: Maybe<Array<Maybe<UserTutorialView_Mutation_Response>>>;
  /** update data of the table: "user_welcome_flow" */
  update_userWelcomeFlow?: Maybe<UserWelcomeFlow_Mutation_Response>;
  /** update data of the table: "user_welcome_flow_event" */
  update_userWelcomeFlowEvent?: Maybe<UserWelcomeFlowEvent_Mutation_Response>;
  /** update single row of the table: "user_welcome_flow_event" */
  update_userWelcomeFlowEvent_by_pk?: Maybe<UserWelcomeFlowEvent>;
  /** update multiples rows of table: "user_welcome_flow_event" */
  update_userWelcomeFlowEvent_many?: Maybe<Array<Maybe<UserWelcomeFlowEvent_Mutation_Response>>>;
  /** update single row of the table: "user_welcome_flow" */
  update_userWelcomeFlow_by_pk?: Maybe<UserWelcomeFlow>;
  /** update multiples rows of table: "user_welcome_flow" */
  update_userWelcomeFlow_many?: Maybe<Array<Maybe<UserWelcomeFlow_Mutation_Response>>>;
  /** update data of the table: "v_material_gwp" */
  update_vMaterialGwp?: Maybe<VMaterialGwp_Mutation_Response>;
  /** update multiples rows of table: "v_material_gwp" */
  update_vMaterialGwp_many?: Maybe<Array<Maybe<VMaterialGwp_Mutation_Response>>>;
  /** update data of the table: "v_material_status" */
  update_vMaterialStatus?: Maybe<VMaterialStatus_Mutation_Response>;
  /** update multiples rows of table: "v_material_status" */
  update_vMaterialStatus_many?: Maybe<Array<Maybe<VMaterialStatus_Mutation_Response>>>;
  /** update data of the table: "weight_per_declared_unit" */
  update_weightPerDeclaredUnit?: Maybe<WeightPerDeclaredUnit_Mutation_Response>;
  /** update single row of the table: "weight_per_declared_unit" */
  update_weightPerDeclaredUnit_by_pk?: Maybe<WeightPerDeclaredUnit>;
  /** update multiples rows of table: "weight_per_declared_unit" */
  update_weightPerDeclaredUnit_many?: Maybe<Array<Maybe<WeightPerDeclaredUnit_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AgentModelPricingArgs = {
  where: AgentModelPricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AgentModelPricing_By_PkArgs = {
  model: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AgentSkillsTenantUserArgs = {
  where: AgentSkillsTenantUser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AgentSkillsTenantUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ApplicationSourceArgs = {
  where: ApplicationSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ApplicationSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkGroupingVerdictArgs = {
  where: BenchmarkGroupingVerdict_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkGroupingVerdict_By_PkArgs = {
  materialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
  source: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkInventoryMaterialArgs = {
  where: BenchmarkInventoryMaterial_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkInventoryMaterial_By_PkArgs = {
  materialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkMaterialMappingArgs = {
  where: BenchmarkMaterialMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkMaterialMapping_By_PkArgs = {
  layerIndex: Scalars['Int']['input'];
  parentMaterialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkProjectStateArgs = {
  where: BenchmarkProjectState_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkProjectState_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkSnapshotArgs = {
  where: BenchmarkSnapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BenchmarkSnapshot_By_PkArgs = {
  snapshotId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BuildingAreaTypeArgs = {
  where: BuildingAreaType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BuildingAreaType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BuildingPartArgs = {
  where: BuildingPart_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BuildingPartLifetimeSourceArgs = {
  where: BuildingPartLifetimeSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BuildingPartLifetimeSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BuildingPartMaintenanceLifetimeArgs = {
  where: BuildingPartMaintenanceLifetime_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BuildingPartMaintenanceLifetime_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BuildingPartServiceLifetimeArgs = {
  where: BuildingPartServiceLifetime_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BuildingPartServiceLifetime_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BuildingPart_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BuildingTypeArgs = {
  where: BuildingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BuildingType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Building_ElementArgs = {
  where: Building_Element_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Building_Element_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Building_Element_Classification_Code_MappingArgs = {
  where: Building_Element_Classification_Code_Mapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Building_Element_Classification_Code_Mapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Building_Element_Material_Category_MappingArgs = {
  where: Building_Element_Material_Category_Mapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Building_Element_Material_Category_Mapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CalculationTypeArgs = {
  where: CalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CalculationTypeEpdDatasourceArgs = {
  where: CalculationTypeEpdDatasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CalculationTypeEpdDatasource_By_PkArgs = {
  calculationTypeId: Scalars['Int']['input'];
  epdDatasourceId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CalculationTypeThresholdByBuildingTypeArgs = {
  where: CalculationTypeThresholdByBuildingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CalculationTypeThresholdByBuildingType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CalculationTypeVariantArgs = {
  where: CalculationTypeVariant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CalculationTypeVariant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CalculationType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Calculation_Type_StageArgs = {
  where: Calculation_Type_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Calculation_Type_Stage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClassificationCodeArgs = {
  where: ClassificationCode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ClassificationCodeTranslationArgs = {
  where: ClassificationCodeTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ClassificationCodeTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClassificationCodeTypeCountryArgs = {
  where: ClassificationCodeTypeCountry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ClassificationCodeTypeCountry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClassificationCode_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClassificationObjectClassArgs = {
  where: ClassificationObjectClass_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ClassificationObjectClassParameterArgs = {
  where: ClassificationObjectClassParameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ClassificationObjectClassParameter_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClassificationObjectClassTranslationArgs = {
  where: ClassificationObjectClassTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ClassificationObjectClassTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClassificationObjectClass_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClassificationTypeArgs = {
  where: ClassificationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ClassificationTypeAttributeArgs = {
  where: ClassificationTypeAttribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ClassificationTypeAttribute_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClassificationType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ComponentObjectPhaseArgs = {
  where: ComponentObjectPhase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ComponentObjectPhase_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionArgs = {
  where: Construction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpPartArgs = {
  where: ConstructionBuildUpPart_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpPartMaterialCategoryArgs = {
  where: ConstructionBuildUpPartMaterialCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpPartMaterialCategory_By_PkArgs = {
  materialCategoryId: Scalars['String']['input'];
  partKey: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpPartTranslationArgs = {
  where: ConstructionBuildUpPartTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpPartTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpPart_By_PkArgs = {
  key: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpTemplateArgs = {
  where: ConstructionBuildUpTemplate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpTemplateTranslationArgs = {
  where: ConstructionBuildUpTemplateTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpTemplateTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionBuildUpTemplate_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionCategoryArgs = {
  where: ConstructionCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionCategoryTranslationArgs = {
  where: ConstructionCategoryTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionCategoryTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionCategoryUnitArgs = {
  where: ConstructionCategoryUnit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionCategoryUnit_By_PkArgs = {
  constructionCategoryId: Scalars['String']['input'];
  unitId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionCategory_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionCountryArgs = {
  where: ConstructionCountry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionCountry_By_PkArgs = {
  constructionId: Scalars['uuid']['input'];
  country: Country_Enum;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionDescriptionArgs = {
  where: ConstructionDescription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionDescription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionForkArgs = {
  where: ConstructionFork_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionFork_By_PkArgs = {
  constructionId: Scalars['uuid']['input'];
  parentConstructionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionInhomogeneousLayerArgs = {
  where: ConstructionInhomogeneousLayer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionInhomogeneousLayerMaterialArgs = {
  where: ConstructionInhomogeneousLayerMaterial_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionInhomogeneousLayerMaterial_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionInhomogeneousLayer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionInhomogenousLayerDescriptionArgs = {
  where: ConstructionInhomogenousLayerDescription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionInhomogenousLayerDescription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionInhomogenousLayerNameArgs = {
  where: ConstructionInhomogenousLayerName_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionInhomogenousLayerName_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionMaterialArgs = {
  where: ConstructionMaterial_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionMaterial_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionNameArgs = {
  where: ConstructionName_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionName_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionSortingArgs = {
  where: ConstructionSorting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionSorting_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Construction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CountryArgs = {
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CountryConfigArgs = {
  where: CountryConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CountryConfig_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Country_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DeclaredUnitArgs = {
  where: DeclaredUnit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_DeclaredUnit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DenominatorUnitArgs = {
  where: DenominatorUnit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_DenominatorUnit_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Distance_UnitArgs = {
  where: Distance_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Distance_Unit_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EmissionFactorSourceTypeArgs = {
  where: EmissionFactorSourceType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EmissionFactorSourceType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Emission_FactorArgs = {
  where: Emission_Factor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Emission_Factor_By_PkArgs = {
  emission_factor_source_id: Scalars['uuid']['input'];
  emission_factor_type: Emission_Factor_Type_Enum;
  year: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Emission_Factor_SourceArgs = {
  where: Emission_Factor_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Emission_Factor_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Emission_Factor_TypeArgs = {
  where: Emission_Factor_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Emission_Factor_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EnumCollectionTypeArgs = {
  where: EnumCollectionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EnumCollectionType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EpdDatasourceArgs = {
  where: EpdDatasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EpdDatasource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EpdOwnerArgs = {
  where: EpdOwner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EpdOwnerAliasArgs = {
  where: EpdOwnerAlias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EpdOwnerAlias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EpdOwner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EpdProductIndustryArgs = {
  where: EpdProductIndustry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EpdProductIndustry_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EpdSpecificationFormArgs = {
  where: EpdSpecificationForm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EpdSpecificationForm_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FlowGuideArgs = {
  where: FlowGuide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FlowGuideViewsArgs = {
  where: FlowGuideViews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FlowGuideViews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FlowGuide_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IndicatorSourceArgs = {
  where: IndicatorSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_IndicatorSource_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IndicatorTypeArgs = {
  where: IndicatorType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_IndicatorTypeMappingArgs = {
  where: IndicatorTypeMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_IndicatorTypeMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IndicatorTypeMultiplierArgs = {
  where: IndicatorTypeMultiplier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_IndicatorTypeMultiplier_By_PkArgs = {
  fromIndicatorTypeId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IndicatorType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_ValueArgs = {
  where: Installation_Standard_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_Value_Building_TypeArgs = {
  where: Installation_Standard_Value_Building_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_Value_Building_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_Value_Classification_TypeArgs = {
  where: Installation_Standard_Value_Classification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_Value_Classification_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_Value_DatasourceArgs = {
  where: Installation_Standard_Value_Datasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_Value_Datasource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_Value_EmissionArgs = {
  where: Installation_Standard_Value_Emission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Installation_Standard_Value_Emission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LanguageArgs = {
  where: Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Language_By_PkArgs = {
  code: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lifetime_TableArgs = {
  where: Lifetime_Table_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lifetime_Table_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MappingHistoryArgs = {
  where: MappingHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MappingHistory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialArgs = {
  where: Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialBiogenicParamsArgs = {
  where: MaterialBiogenicParams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialBiogenicParams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialCategoryArgs = {
  where: MaterialCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialCategoryTextureArgs = {
  where: MaterialCategoryTexture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialCategoryTexture_By_PkArgs = {
  materialCategoryId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialCategory_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialDescriptionArgs = {
  where: MaterialDescription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialDescription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialEmissionIndicatorArgs = {
  where: MaterialEmissionIndicator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialEmissionIndicator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialEpdArgs = {
  where: MaterialEpd_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialEpdDatasourceArgs = {
  where: MaterialEpdDatasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialEpdDatasource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialEpdUrlArgs = {
  where: MaterialEpdUrl_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialEpdUrl_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialEpd_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialForkArgs = {
  where: MaterialFork_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialFork_By_PkArgs = {
  materialId: Scalars['uuid']['input'];
  parentMaterialId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialNameArgs = {
  where: MaterialName_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialName_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialStageArgs = {
  where: MaterialStage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialStage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialTypeArgs = {
  where: MaterialType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialWasteSourceArgs = {
  where: MaterialWasteSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialWasteSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialWasteTypeArgs = {
  where: MaterialWasteType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MaterialWasteType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Material_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_McpConnectionArgs = {
  where: McpConnection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_McpConnection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_McpToolCallArgs = {
  where: McpToolCall_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_McpToolCall_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ModelArgs = {
  where: Model_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectArgs = {
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectBuildingAreaArgs = {
  where: ProjectBuildingArea_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectBuildingArea_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectCalculationArgs = {
  where: ProjectCalculation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectCalculationStageArgs = {
  where: ProjectCalculationStage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectCalculationStage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectCalculation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectComponentMappingTypeArgs = {
  where: ProjectComponentMappingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectComponentMappingType_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectDashboardStatusArgs = {
  where: ProjectDashboardStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectDashboardStatus_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectEmissionFactorArgs = {
  where: ProjectEmissionFactor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectEmissionFactorCustomArgs = {
  where: ProjectEmissionFactorCustom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectEmissionFactorCustom_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectEmissionFactor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectInstallationArgs = {
  where: ProjectInstallation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectInstallation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectLocationArgs = {
  where: ProjectLocation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectLocation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectMaterialClassificationFeedbackArgs = {
  where: ProjectMaterialClassificationFeedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectMaterialClassificationFeedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectMaterialClassificationParameterArgs = {
  where: ProjectMaterialClassificationParameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectMaterialClassificationParameter_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectMembershipArgs = {
  where: ProjectMembership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectMembership_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectModelArgs = {
  where: ProjectModel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectModelSpecklePinArgs = {
  where: ProjectModelSpecklePin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectModelSpecklePin_By_PkArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectModel_By_PkArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
  revisionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectOperationalArgs = {
  where: ProjectOperational_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectOperational_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectReferenceAreaArgs = {
  where: ProjectReferenceArea_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectReferenceArea_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectRevisionArgs = {
  where: ProjectRevision_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectRevision_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpecialConditionConfigArgs = {
  where: ProjectSpecialConditionConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpecialConditionConfig_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
  revisionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpecialConditionTypeMappingArgs = {
  where: ProjectSpecialConditionTypeMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpecialConditionTypeMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpeckleCopyArgs = {
  where: ProjectSpeckleCopy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpeckleCopyRecentArgs = {
  where: ProjectSpeckleCopyRecent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpeckleCopy_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpeckleModelSyncArgs = {
  where: ProjectSpeckleModelSync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpeckleModelSyncRecentArgs = {
  where: ProjectSpeckleModelSyncRecent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpeckleModelSync_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpeckleParameterConfigArgs = {
  where: ProjectSpeckleParameterConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectSpeckleParameterConfig_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectStandardValueStageArgs = {
  where: ProjectStandardValueStage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectStandardValueStage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectStatusArgs = {
  where: ProjectStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectStatus_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectTransportMappingEmissionFactorArgs = {
  where: ProjectTransportMappingEmissionFactor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectTransportMappingEmissionFactor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectVersionArgs = {
  where: ProjectVersion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectVersionNumberedArgs = {
  where: ProjectVersionNumbered_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectVersion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectWasteMappingArgs = {
  where: ProjectWasteMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectWasteMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectWasteTypeCustomArgs = {
  where: ProjectWasteTypeCustom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectWasteTypeCustom_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_TransportArgs = {
  where: Project_Transport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Transport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Transport_DefaultArgs = {
  where: Project_Transport_Default_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Transport_Default_By_PkArgs = {
  project_transport_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Transport_MappingArgs = {
  where: Project_Transport_Mapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Transport_Mapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReferenceAreaTypeArgs = {
  where: ReferenceAreaType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ReferenceAreaTypeCalculationTypeMappingArgs = {
  where: ReferenceAreaTypeCalculationTypeMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ReferenceAreaTypeCalculationTypeMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReferenceAreaType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportBuildingTypeMappingArgs = {
  where: ReportBuildingTypeMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ReportBuildingTypeMapping_By_PkArgs = {
  buildingTypeId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportClassificationCodeEmissionMappingArgs = {
  where: ReportClassificationCodeEmissionMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ReportClassificationCodeEmissionMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportLoadBearingElementAmountMappingArgs = {
  where: ReportLoadBearingElementAmountMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ReportLoadBearingElementAmountMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportLoadBearingElementEmissionMappingArgs = {
  where: ReportLoadBearingElementEmissionMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ReportLoadBearingElementEmissionMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportStructureArgs = {
  where: ReportStructure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ReportStructureCalculationTypesArgs = {
  where: ReportStructureCalculationTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ReportStructureCalculationTypes_By_PkArgs = {
  calculationTypeId: Scalars['Int']['input'];
  reportStructureId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportStructureClassificationCodesArgs = {
  where: ReportStructureClassificationCodes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ReportStructureClassificationCodes_By_PkArgs = {
  classificationCodeId: Scalars['Int']['input'];
  reportStructureId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportStructure_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportfilesmetadataArgs = {
  where: Reportfilesmetadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reportfilesmetadata_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpecialConditionTypeArgs = {
  where: SpecialConditionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpecialConditionTypeCalculationTypeArgs = {
  where: SpecialConditionTypeCalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpecialConditionTypeCalculationType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpecialConditionTypeInputParameterArgs = {
  where: SpecialConditionTypeInputParameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpecialConditionTypeInputParameter_By_PkArgs = {
  specialConditionTypeCategoryId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpecialConditionType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Special_Condition_Type_CategoryArgs = {
  where: Special_Condition_Type_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Special_Condition_Type_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpeckleStreamModelIfcUploadArgs = {
  where: SpeckleStreamModelIfcUpload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpeckleStreamModelIfcUploadRecentArgs = {
  where: SpeckleStreamModelIfcUploadRecent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpeckleStreamModelIfcUpload_By_PkArgs = {
  speckleProjectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpeckleUserDataArgs = {
  where: SpeckleUserData_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SpeckleUserData_By_PkArgs = {
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Speckle_StreamArgs = {
  where: Speckle_Stream_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Speckle_Stream_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StageArgs = {
  where: Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StageDefaultEmissionArgs = {
  where: StageDefaultEmission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StageDefaultEmission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Stage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Stage_Default_Emission_Building_TypeArgs = {
  where: Stage_Default_Emission_Building_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stage_Default_Emission_Building_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TenantAiBudgetArgs = {
  where: TenantAiBudget_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TenantAiBudget_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TenantAiCreditPurchaseArgs = {
  where: TenantAiCreditPurchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TenantAiCreditPurchase_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TenantAiPaymentArgs = {
  where: TenantAiPayment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TenantAiPayment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TenantCollectionArgs = {
  where: TenantCollection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TenantCollectionItemArgs = {
  where: TenantCollectionItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TenantCollectionItem_By_PkArgs = {
  materialInternalId: Scalars['String']['input'];
  tenantCollectionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TenantCollection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TenantInvoiceArgs = {
  where: TenantInvoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TenantInvoice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TenantUserRequestAiUsageArgs = {
  where: TenantUserRequestAiUsage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TenantUserRequestAiUsage_By_PkArgs = {
  requestId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TranslationCategoryArgs = {
  where: TranslationCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TranslationCategory_By_PkArgs = {
  id: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TranslationSourceArgs = {
  where: TranslationSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TranslationSource_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TransportArgs = {
  where: Transport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TransportEmissionFactorArgs = {
  where: TransportEmissionFactor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TransportEmissionFactor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TransportSourceArgs = {
  where: TransportSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TransportSourceCalculationTypeArgs = {
  where: TransportSourceCalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TransportSourceCalculationType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TransportSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transport_Standard_ValueArgs = {
  where: Transport_Standard_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transport_Standard_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transport_TypeArgs = {
  where: Transport_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transport_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UnitArgs = {
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserMaterialFavoriteArgs = {
  where: UserMaterialFavorite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserMaterialFavorite_By_PkArgs = {
  materialInternalId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserPlatformReviewArgs = {
  where: UserPlatformReview_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserPlatformReview_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserProjectViewArgs = {
  where: UserProjectView_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserProjectView_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserTutorialViewArgs = {
  where: UserTutorialView_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserTutorialView_By_PkArgs = {
  externalId: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserWelcomeFlowArgs = {
  where: UserWelcomeFlow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserWelcomeFlowEventArgs = {
  where: UserWelcomeFlowEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserWelcomeFlowEvent_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserWelcomeFlow_By_PkArgs = {
  flowKey: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_VMaterialGwpArgs = {
  where: VMaterialGwp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VMaterialStatusArgs = {
  where: VMaterialStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_WeightPerDeclaredUnitArgs = {
  where: WeightPerDeclaredUnit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_WeightPerDeclaredUnit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_AgentModelPricingArgs = {
  objects: Array<AgentModelPricing_Insert_Input>;
  on_conflict?: InputMaybe<AgentModelPricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgentModelPricing_OneArgs = {
  object: AgentModelPricing_Insert_Input;
  on_conflict?: InputMaybe<AgentModelPricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgentSkillsTenantUserArgs = {
  objects: Array<AgentSkillsTenantUser_Insert_Input>;
  on_conflict?: InputMaybe<AgentSkillsTenantUser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgentSkillsTenantUser_OneArgs = {
  object: AgentSkillsTenantUser_Insert_Input;
  on_conflict?: InputMaybe<AgentSkillsTenantUser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApplicationSourceArgs = {
  objects: Array<ApplicationSource_Insert_Input>;
  on_conflict?: InputMaybe<ApplicationSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApplicationSource_OneArgs = {
  object: ApplicationSource_Insert_Input;
  on_conflict?: InputMaybe<ApplicationSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkGroupingVerdictArgs = {
  objects: Array<BenchmarkGroupingVerdict_Insert_Input>;
  on_conflict?: InputMaybe<BenchmarkGroupingVerdict_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkGroupingVerdict_OneArgs = {
  object: BenchmarkGroupingVerdict_Insert_Input;
  on_conflict?: InputMaybe<BenchmarkGroupingVerdict_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkInventoryMaterialArgs = {
  objects: Array<BenchmarkInventoryMaterial_Insert_Input>;
  on_conflict?: InputMaybe<BenchmarkInventoryMaterial_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkInventoryMaterial_OneArgs = {
  object: BenchmarkInventoryMaterial_Insert_Input;
  on_conflict?: InputMaybe<BenchmarkInventoryMaterial_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkMaterialMappingArgs = {
  objects: Array<BenchmarkMaterialMapping_Insert_Input>;
  on_conflict?: InputMaybe<BenchmarkMaterialMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkMaterialMapping_OneArgs = {
  object: BenchmarkMaterialMapping_Insert_Input;
  on_conflict?: InputMaybe<BenchmarkMaterialMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkProjectStateArgs = {
  objects: Array<BenchmarkProjectState_Insert_Input>;
  on_conflict?: InputMaybe<BenchmarkProjectState_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkProjectState_OneArgs = {
  object: BenchmarkProjectState_Insert_Input;
  on_conflict?: InputMaybe<BenchmarkProjectState_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkSnapshotArgs = {
  objects: Array<BenchmarkSnapshot_Insert_Input>;
  on_conflict?: InputMaybe<BenchmarkSnapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BenchmarkSnapshot_OneArgs = {
  object: BenchmarkSnapshot_Insert_Input;
  on_conflict?: InputMaybe<BenchmarkSnapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingAreaTypeArgs = {
  objects: Array<BuildingAreaType_Insert_Input>;
  on_conflict?: InputMaybe<BuildingAreaType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingAreaType_OneArgs = {
  object: BuildingAreaType_Insert_Input;
  on_conflict?: InputMaybe<BuildingAreaType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingPartArgs = {
  objects: Array<BuildingPart_Insert_Input>;
  on_conflict?: InputMaybe<BuildingPart_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingPartLifetimeSourceArgs = {
  objects: Array<BuildingPartLifetimeSource_Insert_Input>;
  on_conflict?: InputMaybe<BuildingPartLifetimeSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingPartLifetimeSource_OneArgs = {
  object: BuildingPartLifetimeSource_Insert_Input;
  on_conflict?: InputMaybe<BuildingPartLifetimeSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingPartMaintenanceLifetimeArgs = {
  objects: Array<BuildingPartMaintenanceLifetime_Insert_Input>;
  on_conflict?: InputMaybe<BuildingPartMaintenanceLifetime_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingPartMaintenanceLifetime_OneArgs = {
  object: BuildingPartMaintenanceLifetime_Insert_Input;
  on_conflict?: InputMaybe<BuildingPartMaintenanceLifetime_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingPartServiceLifetimeArgs = {
  objects: Array<BuildingPartServiceLifetime_Insert_Input>;
  on_conflict?: InputMaybe<BuildingPartServiceLifetime_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingPartServiceLifetime_OneArgs = {
  object: BuildingPartServiceLifetime_Insert_Input;
  on_conflict?: InputMaybe<BuildingPartServiceLifetime_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingPart_OneArgs = {
  object: BuildingPart_Insert_Input;
  on_conflict?: InputMaybe<BuildingPart_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingTypeArgs = {
  objects: Array<BuildingType_Insert_Input>;
  on_conflict?: InputMaybe<BuildingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingType_OneArgs = {
  object: BuildingType_Insert_Input;
  on_conflict?: InputMaybe<BuildingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Building_ElementArgs = {
  objects: Array<Building_Element_Insert_Input>;
  on_conflict?: InputMaybe<Building_Element_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Building_Element_Classification_Code_MappingArgs = {
  objects: Array<Building_Element_Classification_Code_Mapping_Insert_Input>;
  on_conflict?: InputMaybe<Building_Element_Classification_Code_Mapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Building_Element_Classification_Code_Mapping_OneArgs = {
  object: Building_Element_Classification_Code_Mapping_Insert_Input;
  on_conflict?: InputMaybe<Building_Element_Classification_Code_Mapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Building_Element_Material_Category_MappingArgs = {
  objects: Array<Building_Element_Material_Category_Mapping_Insert_Input>;
  on_conflict?: InputMaybe<Building_Element_Material_Category_Mapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Building_Element_Material_Category_Mapping_OneArgs = {
  object: Building_Element_Material_Category_Mapping_Insert_Input;
  on_conflict?: InputMaybe<Building_Element_Material_Category_Mapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Building_Element_OneArgs = {
  object: Building_Element_Insert_Input;
  on_conflict?: InputMaybe<Building_Element_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CalculationTypeArgs = {
  objects: Array<CalculationType_Insert_Input>;
  on_conflict?: InputMaybe<CalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CalculationTypeEpdDatasourceArgs = {
  objects: Array<CalculationTypeEpdDatasource_Insert_Input>;
  on_conflict?: InputMaybe<CalculationTypeEpdDatasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CalculationTypeEpdDatasource_OneArgs = {
  object: CalculationTypeEpdDatasource_Insert_Input;
  on_conflict?: InputMaybe<CalculationTypeEpdDatasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CalculationTypeThresholdByBuildingTypeArgs = {
  objects: Array<CalculationTypeThresholdByBuildingType_Insert_Input>;
  on_conflict?: InputMaybe<CalculationTypeThresholdByBuildingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CalculationTypeThresholdByBuildingType_OneArgs = {
  object: CalculationTypeThresholdByBuildingType_Insert_Input;
  on_conflict?: InputMaybe<CalculationTypeThresholdByBuildingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CalculationTypeVariantArgs = {
  objects: Array<CalculationTypeVariant_Insert_Input>;
  on_conflict?: InputMaybe<CalculationTypeVariant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CalculationTypeVariant_OneArgs = {
  object: CalculationTypeVariant_Insert_Input;
  on_conflict?: InputMaybe<CalculationTypeVariant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CalculationType_OneArgs = {
  object: CalculationType_Insert_Input;
  on_conflict?: InputMaybe<CalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Calculation_Type_StageArgs = {
  objects: Array<Calculation_Type_Stage_Insert_Input>;
  on_conflict?: InputMaybe<Calculation_Type_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Calculation_Type_Stage_OneArgs = {
  object: Calculation_Type_Stage_Insert_Input;
  on_conflict?: InputMaybe<Calculation_Type_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationCodeArgs = {
  objects: Array<ClassificationCode_Insert_Input>;
  on_conflict?: InputMaybe<ClassificationCode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationCodeTranslationArgs = {
  objects: Array<ClassificationCodeTranslation_Insert_Input>;
  on_conflict?: InputMaybe<ClassificationCodeTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationCodeTranslation_OneArgs = {
  object: ClassificationCodeTranslation_Insert_Input;
  on_conflict?: InputMaybe<ClassificationCodeTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationCodeTypeCountryArgs = {
  objects: Array<ClassificationCodeTypeCountry_Insert_Input>;
  on_conflict?: InputMaybe<ClassificationCodeTypeCountry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationCodeTypeCountry_OneArgs = {
  object: ClassificationCodeTypeCountry_Insert_Input;
  on_conflict?: InputMaybe<ClassificationCodeTypeCountry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationCode_OneArgs = {
  object: ClassificationCode_Insert_Input;
  on_conflict?: InputMaybe<ClassificationCode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationObjectClassArgs = {
  objects: Array<ClassificationObjectClass_Insert_Input>;
  on_conflict?: InputMaybe<ClassificationObjectClass_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationObjectClassParameterArgs = {
  objects: Array<ClassificationObjectClassParameter_Insert_Input>;
  on_conflict?: InputMaybe<ClassificationObjectClassParameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationObjectClassParameter_OneArgs = {
  object: ClassificationObjectClassParameter_Insert_Input;
  on_conflict?: InputMaybe<ClassificationObjectClassParameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationObjectClassTranslationArgs = {
  objects: Array<ClassificationObjectClassTranslation_Insert_Input>;
  on_conflict?: InputMaybe<ClassificationObjectClassTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationObjectClassTranslation_OneArgs = {
  object: ClassificationObjectClassTranslation_Insert_Input;
  on_conflict?: InputMaybe<ClassificationObjectClassTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationObjectClass_OneArgs = {
  object: ClassificationObjectClass_Insert_Input;
  on_conflict?: InputMaybe<ClassificationObjectClass_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationTypeArgs = {
  objects: Array<ClassificationType_Insert_Input>;
  on_conflict?: InputMaybe<ClassificationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationTypeAttributeArgs = {
  objects: Array<ClassificationTypeAttribute_Insert_Input>;
  on_conflict?: InputMaybe<ClassificationTypeAttribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationTypeAttribute_OneArgs = {
  object: ClassificationTypeAttribute_Insert_Input;
  on_conflict?: InputMaybe<ClassificationTypeAttribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassificationType_OneArgs = {
  object: ClassificationType_Insert_Input;
  on_conflict?: InputMaybe<ClassificationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ComponentObjectPhaseArgs = {
  objects: Array<ComponentObjectPhase_Insert_Input>;
  on_conflict?: InputMaybe<ComponentObjectPhase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ComponentObjectPhase_OneArgs = {
  object: ComponentObjectPhase_Insert_Input;
  on_conflict?: InputMaybe<ComponentObjectPhase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionArgs = {
  objects: Array<Construction_Insert_Input>;
  on_conflict?: InputMaybe<Construction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpPartArgs = {
  objects: Array<ConstructionBuildUpPart_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionBuildUpPart_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpPartMaterialCategoryArgs = {
  objects: Array<ConstructionBuildUpPartMaterialCategory_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionBuildUpPartMaterialCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpPartMaterialCategory_OneArgs = {
  object: ConstructionBuildUpPartMaterialCategory_Insert_Input;
  on_conflict?: InputMaybe<ConstructionBuildUpPartMaterialCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpPartTranslationArgs = {
  objects: Array<ConstructionBuildUpPartTranslation_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionBuildUpPartTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpPartTranslation_OneArgs = {
  object: ConstructionBuildUpPartTranslation_Insert_Input;
  on_conflict?: InputMaybe<ConstructionBuildUpPartTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpPart_OneArgs = {
  object: ConstructionBuildUpPart_Insert_Input;
  on_conflict?: InputMaybe<ConstructionBuildUpPart_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpTemplateArgs = {
  objects: Array<ConstructionBuildUpTemplate_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionBuildUpTemplate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpTemplateTranslationArgs = {
  objects: Array<ConstructionBuildUpTemplateTranslation_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionBuildUpTemplateTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpTemplateTranslation_OneArgs = {
  object: ConstructionBuildUpTemplateTranslation_Insert_Input;
  on_conflict?: InputMaybe<ConstructionBuildUpTemplateTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionBuildUpTemplate_OneArgs = {
  object: ConstructionBuildUpTemplate_Insert_Input;
  on_conflict?: InputMaybe<ConstructionBuildUpTemplate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionCategoryArgs = {
  objects: Array<ConstructionCategory_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionCategoryTranslationArgs = {
  objects: Array<ConstructionCategoryTranslation_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionCategoryTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionCategoryTranslation_OneArgs = {
  object: ConstructionCategoryTranslation_Insert_Input;
  on_conflict?: InputMaybe<ConstructionCategoryTranslation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionCategoryUnitArgs = {
  objects: Array<ConstructionCategoryUnit_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionCategoryUnit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionCategoryUnit_OneArgs = {
  object: ConstructionCategoryUnit_Insert_Input;
  on_conflict?: InputMaybe<ConstructionCategoryUnit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionCategory_OneArgs = {
  object: ConstructionCategory_Insert_Input;
  on_conflict?: InputMaybe<ConstructionCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionCountryArgs = {
  objects: Array<ConstructionCountry_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionCountry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionCountry_OneArgs = {
  object: ConstructionCountry_Insert_Input;
  on_conflict?: InputMaybe<ConstructionCountry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionDescriptionArgs = {
  objects: Array<ConstructionDescription_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionDescription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionDescription_OneArgs = {
  object: ConstructionDescription_Insert_Input;
  on_conflict?: InputMaybe<ConstructionDescription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionForkArgs = {
  objects: Array<ConstructionFork_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionFork_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionFork_OneArgs = {
  object: ConstructionFork_Insert_Input;
  on_conflict?: InputMaybe<ConstructionFork_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionInhomogeneousLayerArgs = {
  objects: Array<ConstructionInhomogeneousLayer_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionInhomogeneousLayer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionInhomogeneousLayerMaterialArgs = {
  objects: Array<ConstructionInhomogeneousLayerMaterial_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionInhomogeneousLayerMaterial_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionInhomogeneousLayerMaterial_OneArgs = {
  object: ConstructionInhomogeneousLayerMaterial_Insert_Input;
  on_conflict?: InputMaybe<ConstructionInhomogeneousLayerMaterial_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionInhomogeneousLayer_OneArgs = {
  object: ConstructionInhomogeneousLayer_Insert_Input;
  on_conflict?: InputMaybe<ConstructionInhomogeneousLayer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionInhomogenousLayerDescriptionArgs = {
  objects: Array<ConstructionInhomogenousLayerDescription_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionInhomogenousLayerDescription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionInhomogenousLayerDescription_OneArgs = {
  object: ConstructionInhomogenousLayerDescription_Insert_Input;
  on_conflict?: InputMaybe<ConstructionInhomogenousLayerDescription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionInhomogenousLayerNameArgs = {
  objects: Array<ConstructionInhomogenousLayerName_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionInhomogenousLayerName_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionInhomogenousLayerName_OneArgs = {
  object: ConstructionInhomogenousLayerName_Insert_Input;
  on_conflict?: InputMaybe<ConstructionInhomogenousLayerName_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionMaterialArgs = {
  objects: Array<ConstructionMaterial_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionMaterial_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionMaterial_OneArgs = {
  object: ConstructionMaterial_Insert_Input;
  on_conflict?: InputMaybe<ConstructionMaterial_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionNameArgs = {
  objects: Array<ConstructionName_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionName_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionName_OneArgs = {
  object: ConstructionName_Insert_Input;
  on_conflict?: InputMaybe<ConstructionName_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionSortingArgs = {
  objects: Array<ConstructionSorting_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionSorting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionSorting_OneArgs = {
  object: ConstructionSorting_Insert_Input;
  on_conflict?: InputMaybe<ConstructionSorting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Construction_OneArgs = {
  object: Construction_Insert_Input;
  on_conflict?: InputMaybe<Construction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountryArgs = {
  objects: Array<Country_Insert_Input>;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountryConfigArgs = {
  objects: Array<CountryConfig_Insert_Input>;
  on_conflict?: InputMaybe<CountryConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountryConfig_OneArgs = {
  object: CountryConfig_Insert_Input;
  on_conflict?: InputMaybe<CountryConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_OneArgs = {
  object: Country_Insert_Input;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DeclaredUnitArgs = {
  objects: Array<DeclaredUnit_Insert_Input>;
  on_conflict?: InputMaybe<DeclaredUnit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DeclaredUnit_OneArgs = {
  object: DeclaredUnit_Insert_Input;
  on_conflict?: InputMaybe<DeclaredUnit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DenominatorUnitArgs = {
  objects: Array<DenominatorUnit_Insert_Input>;
  on_conflict?: InputMaybe<DenominatorUnit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DenominatorUnit_OneArgs = {
  object: DenominatorUnit_Insert_Input;
  on_conflict?: InputMaybe<DenominatorUnit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Distance_UnitArgs = {
  objects: Array<Distance_Unit_Insert_Input>;
  on_conflict?: InputMaybe<Distance_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Distance_Unit_OneArgs = {
  object: Distance_Unit_Insert_Input;
  on_conflict?: InputMaybe<Distance_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EmissionFactorSourceTypeArgs = {
  objects: Array<EmissionFactorSourceType_Insert_Input>;
  on_conflict?: InputMaybe<EmissionFactorSourceType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EmissionFactorSourceType_OneArgs = {
  object: EmissionFactorSourceType_Insert_Input;
  on_conflict?: InputMaybe<EmissionFactorSourceType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emission_FactorArgs = {
  objects: Array<Emission_Factor_Insert_Input>;
  on_conflict?: InputMaybe<Emission_Factor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emission_Factor_OneArgs = {
  object: Emission_Factor_Insert_Input;
  on_conflict?: InputMaybe<Emission_Factor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emission_Factor_SourceArgs = {
  objects: Array<Emission_Factor_Source_Insert_Input>;
  on_conflict?: InputMaybe<Emission_Factor_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emission_Factor_Source_OneArgs = {
  object: Emission_Factor_Source_Insert_Input;
  on_conflict?: InputMaybe<Emission_Factor_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emission_Factor_TypeArgs = {
  objects: Array<Emission_Factor_Type_Insert_Input>;
  on_conflict?: InputMaybe<Emission_Factor_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emission_Factor_Type_OneArgs = {
  object: Emission_Factor_Type_Insert_Input;
  on_conflict?: InputMaybe<Emission_Factor_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EnumCollectionTypeArgs = {
  objects: Array<EnumCollectionType_Insert_Input>;
  on_conflict?: InputMaybe<EnumCollectionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EnumCollectionType_OneArgs = {
  object: EnumCollectionType_Insert_Input;
  on_conflict?: InputMaybe<EnumCollectionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdDatasourceArgs = {
  objects: Array<EpdDatasource_Insert_Input>;
  on_conflict?: InputMaybe<EpdDatasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdDatasource_OneArgs = {
  object: EpdDatasource_Insert_Input;
  on_conflict?: InputMaybe<EpdDatasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdOwnerArgs = {
  objects: Array<EpdOwner_Insert_Input>;
  on_conflict?: InputMaybe<EpdOwner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdOwnerAliasArgs = {
  objects: Array<EpdOwnerAlias_Insert_Input>;
  on_conflict?: InputMaybe<EpdOwnerAlias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdOwnerAlias_OneArgs = {
  object: EpdOwnerAlias_Insert_Input;
  on_conflict?: InputMaybe<EpdOwnerAlias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdOwner_OneArgs = {
  object: EpdOwner_Insert_Input;
  on_conflict?: InputMaybe<EpdOwner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdProductIndustryArgs = {
  objects: Array<EpdProductIndustry_Insert_Input>;
  on_conflict?: InputMaybe<EpdProductIndustry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdProductIndustry_OneArgs = {
  object: EpdProductIndustry_Insert_Input;
  on_conflict?: InputMaybe<EpdProductIndustry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdSpecificationFormArgs = {
  objects: Array<EpdSpecificationForm_Insert_Input>;
  on_conflict?: InputMaybe<EpdSpecificationForm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EpdSpecificationForm_OneArgs = {
  object: EpdSpecificationForm_Insert_Input;
  on_conflict?: InputMaybe<EpdSpecificationForm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FlowGuideArgs = {
  objects: Array<FlowGuide_Insert_Input>;
  on_conflict?: InputMaybe<FlowGuide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FlowGuideViewsArgs = {
  objects: Array<FlowGuideViews_Insert_Input>;
  on_conflict?: InputMaybe<FlowGuideViews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FlowGuideViews_OneArgs = {
  object: FlowGuideViews_Insert_Input;
  on_conflict?: InputMaybe<FlowGuideViews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FlowGuide_OneArgs = {
  object: FlowGuide_Insert_Input;
  on_conflict?: InputMaybe<FlowGuide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorSourceArgs = {
  objects: Array<IndicatorSource_Insert_Input>;
  on_conflict?: InputMaybe<IndicatorSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorSource_OneArgs = {
  object: IndicatorSource_Insert_Input;
  on_conflict?: InputMaybe<IndicatorSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorTypeArgs = {
  objects: Array<IndicatorType_Insert_Input>;
  on_conflict?: InputMaybe<IndicatorType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorTypeMappingArgs = {
  objects: Array<IndicatorTypeMapping_Insert_Input>;
  on_conflict?: InputMaybe<IndicatorTypeMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorTypeMapping_OneArgs = {
  object: IndicatorTypeMapping_Insert_Input;
  on_conflict?: InputMaybe<IndicatorTypeMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorTypeMultiplierArgs = {
  objects: Array<IndicatorTypeMultiplier_Insert_Input>;
  on_conflict?: InputMaybe<IndicatorTypeMultiplier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorTypeMultiplier_OneArgs = {
  object: IndicatorTypeMultiplier_Insert_Input;
  on_conflict?: InputMaybe<IndicatorTypeMultiplier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorType_OneArgs = {
  object: IndicatorType_Insert_Input;
  on_conflict?: InputMaybe<IndicatorType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_ValueArgs = {
  objects: Array<Installation_Standard_Value_Insert_Input>;
  on_conflict?: InputMaybe<Installation_Standard_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_Value_Building_TypeArgs = {
  objects: Array<Installation_Standard_Value_Building_Type_Insert_Input>;
  on_conflict?: InputMaybe<Installation_Standard_Value_Building_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_Value_Building_Type_OneArgs = {
  object: Installation_Standard_Value_Building_Type_Insert_Input;
  on_conflict?: InputMaybe<Installation_Standard_Value_Building_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_Value_Classification_TypeArgs = {
  objects: Array<Installation_Standard_Value_Classification_Type_Insert_Input>;
  on_conflict?: InputMaybe<Installation_Standard_Value_Classification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_Value_Classification_Type_OneArgs = {
  object: Installation_Standard_Value_Classification_Type_Insert_Input;
  on_conflict?: InputMaybe<Installation_Standard_Value_Classification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_Value_DatasourceArgs = {
  objects: Array<Installation_Standard_Value_Datasource_Insert_Input>;
  on_conflict?: InputMaybe<Installation_Standard_Value_Datasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_Value_Datasource_OneArgs = {
  object: Installation_Standard_Value_Datasource_Insert_Input;
  on_conflict?: InputMaybe<Installation_Standard_Value_Datasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_Value_EmissionArgs = {
  objects: Array<Installation_Standard_Value_Emission_Insert_Input>;
  on_conflict?: InputMaybe<Installation_Standard_Value_Emission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_Value_Emission_OneArgs = {
  object: Installation_Standard_Value_Emission_Insert_Input;
  on_conflict?: InputMaybe<Installation_Standard_Value_Emission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installation_Standard_Value_OneArgs = {
  object: Installation_Standard_Value_Insert_Input;
  on_conflict?: InputMaybe<Installation_Standard_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LanguageArgs = {
  objects: Array<Language_Insert_Input>;
  on_conflict?: InputMaybe<Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Language_OneArgs = {
  object: Language_Insert_Input;
  on_conflict?: InputMaybe<Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lifetime_TableArgs = {
  objects: Array<Lifetime_Table_Insert_Input>;
  on_conflict?: InputMaybe<Lifetime_Table_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lifetime_Table_OneArgs = {
  object: Lifetime_Table_Insert_Input;
  on_conflict?: InputMaybe<Lifetime_Table_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MappingHistoryArgs = {
  objects: Array<MappingHistory_Insert_Input>;
  on_conflict?: InputMaybe<MappingHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MappingHistory_OneArgs = {
  object: MappingHistory_Insert_Input;
  on_conflict?: InputMaybe<MappingHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialArgs = {
  objects: Array<Material_Insert_Input>;
  on_conflict?: InputMaybe<Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialBiogenicParamsArgs = {
  objects: Array<MaterialBiogenicParams_Insert_Input>;
  on_conflict?: InputMaybe<MaterialBiogenicParams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialBiogenicParams_OneArgs = {
  object: MaterialBiogenicParams_Insert_Input;
  on_conflict?: InputMaybe<MaterialBiogenicParams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialCategoryArgs = {
  objects: Array<MaterialCategory_Insert_Input>;
  on_conflict?: InputMaybe<MaterialCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialCategoryTextureArgs = {
  objects: Array<MaterialCategoryTexture_Insert_Input>;
  on_conflict?: InputMaybe<MaterialCategoryTexture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialCategoryTexture_OneArgs = {
  object: MaterialCategoryTexture_Insert_Input;
  on_conflict?: InputMaybe<MaterialCategoryTexture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialCategory_OneArgs = {
  object: MaterialCategory_Insert_Input;
  on_conflict?: InputMaybe<MaterialCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialDescriptionArgs = {
  objects: Array<MaterialDescription_Insert_Input>;
  on_conflict?: InputMaybe<MaterialDescription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialDescription_OneArgs = {
  object: MaterialDescription_Insert_Input;
  on_conflict?: InputMaybe<MaterialDescription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialEmissionIndicatorArgs = {
  objects: Array<MaterialEmissionIndicator_Insert_Input>;
  on_conflict?: InputMaybe<MaterialEmissionIndicator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialEmissionIndicator_OneArgs = {
  object: MaterialEmissionIndicator_Insert_Input;
  on_conflict?: InputMaybe<MaterialEmissionIndicator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialEpdArgs = {
  objects: Array<MaterialEpd_Insert_Input>;
  on_conflict?: InputMaybe<MaterialEpd_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialEpdDatasourceArgs = {
  objects: Array<MaterialEpdDatasource_Insert_Input>;
  on_conflict?: InputMaybe<MaterialEpdDatasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialEpdDatasource_OneArgs = {
  object: MaterialEpdDatasource_Insert_Input;
  on_conflict?: InputMaybe<MaterialEpdDatasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialEpdUrlArgs = {
  objects: Array<MaterialEpdUrl_Insert_Input>;
  on_conflict?: InputMaybe<MaterialEpdUrl_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialEpdUrl_OneArgs = {
  object: MaterialEpdUrl_Insert_Input;
  on_conflict?: InputMaybe<MaterialEpdUrl_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialEpd_OneArgs = {
  object: MaterialEpd_Insert_Input;
  on_conflict?: InputMaybe<MaterialEpd_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialForkArgs = {
  objects: Array<MaterialFork_Insert_Input>;
  on_conflict?: InputMaybe<MaterialFork_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialFork_OneArgs = {
  object: MaterialFork_Insert_Input;
  on_conflict?: InputMaybe<MaterialFork_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialNameArgs = {
  objects: Array<MaterialName_Insert_Input>;
  on_conflict?: InputMaybe<MaterialName_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialName_OneArgs = {
  object: MaterialName_Insert_Input;
  on_conflict?: InputMaybe<MaterialName_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialStageArgs = {
  objects: Array<MaterialStage_Insert_Input>;
  on_conflict?: InputMaybe<MaterialStage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialStage_OneArgs = {
  object: MaterialStage_Insert_Input;
  on_conflict?: InputMaybe<MaterialStage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialTypeArgs = {
  objects: Array<MaterialType_Insert_Input>;
  on_conflict?: InputMaybe<MaterialType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialType_OneArgs = {
  object: MaterialType_Insert_Input;
  on_conflict?: InputMaybe<MaterialType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialWasteSourceArgs = {
  objects: Array<MaterialWasteSource_Insert_Input>;
  on_conflict?: InputMaybe<MaterialWasteSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialWasteSource_OneArgs = {
  object: MaterialWasteSource_Insert_Input;
  on_conflict?: InputMaybe<MaterialWasteSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialWasteTypeArgs = {
  objects: Array<MaterialWasteType_Insert_Input>;
  on_conflict?: InputMaybe<MaterialWasteType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialWasteType_OneArgs = {
  object: MaterialWasteType_Insert_Input;
  on_conflict?: InputMaybe<MaterialWasteType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Material_OneArgs = {
  object: Material_Insert_Input;
  on_conflict?: InputMaybe<Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_McpConnectionArgs = {
  objects: Array<McpConnection_Insert_Input>;
  on_conflict?: InputMaybe<McpConnection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_McpConnection_OneArgs = {
  object: McpConnection_Insert_Input;
  on_conflict?: InputMaybe<McpConnection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_McpToolCallArgs = {
  objects: Array<McpToolCall_Insert_Input>;
  on_conflict?: InputMaybe<McpToolCall_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_McpToolCall_OneArgs = {
  object: McpToolCall_Insert_Input;
  on_conflict?: InputMaybe<McpToolCall_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ModelArgs = {
  objects: Array<Model_Insert_Input>;
  on_conflict?: InputMaybe<Model_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_OneArgs = {
  object: Model_Insert_Input;
  on_conflict?: InputMaybe<Model_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectArgs = {
  objects: Array<Project_Insert_Input>;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectBuildingAreaArgs = {
  objects: Array<ProjectBuildingArea_Insert_Input>;
  on_conflict?: InputMaybe<ProjectBuildingArea_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectBuildingArea_OneArgs = {
  object: ProjectBuildingArea_Insert_Input;
  on_conflict?: InputMaybe<ProjectBuildingArea_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectCalculationArgs = {
  objects: Array<ProjectCalculation_Insert_Input>;
  on_conflict?: InputMaybe<ProjectCalculation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectCalculationStageArgs = {
  objects: Array<ProjectCalculationStage_Insert_Input>;
  on_conflict?: InputMaybe<ProjectCalculationStage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectCalculationStage_OneArgs = {
  object: ProjectCalculationStage_Insert_Input;
  on_conflict?: InputMaybe<ProjectCalculationStage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectCalculation_OneArgs = {
  object: ProjectCalculation_Insert_Input;
  on_conflict?: InputMaybe<ProjectCalculation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectComponentMappingTypeArgs = {
  objects: Array<ProjectComponentMappingType_Insert_Input>;
  on_conflict?: InputMaybe<ProjectComponentMappingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectComponentMappingType_OneArgs = {
  object: ProjectComponentMappingType_Insert_Input;
  on_conflict?: InputMaybe<ProjectComponentMappingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectDashboardStatusArgs = {
  objects: Array<ProjectDashboardStatus_Insert_Input>;
  on_conflict?: InputMaybe<ProjectDashboardStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectDashboardStatus_OneArgs = {
  object: ProjectDashboardStatus_Insert_Input;
  on_conflict?: InputMaybe<ProjectDashboardStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectEmissionFactorArgs = {
  objects: Array<ProjectEmissionFactor_Insert_Input>;
  on_conflict?: InputMaybe<ProjectEmissionFactor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectEmissionFactorCustomArgs = {
  objects: Array<ProjectEmissionFactorCustom_Insert_Input>;
  on_conflict?: InputMaybe<ProjectEmissionFactorCustom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectEmissionFactorCustom_OneArgs = {
  object: ProjectEmissionFactorCustom_Insert_Input;
  on_conflict?: InputMaybe<ProjectEmissionFactorCustom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectEmissionFactor_OneArgs = {
  object: ProjectEmissionFactor_Insert_Input;
  on_conflict?: InputMaybe<ProjectEmissionFactor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectInstallationArgs = {
  objects: Array<ProjectInstallation_Insert_Input>;
  on_conflict?: InputMaybe<ProjectInstallation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectInstallation_OneArgs = {
  object: ProjectInstallation_Insert_Input;
  on_conflict?: InputMaybe<ProjectInstallation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectLocationArgs = {
  objects: Array<ProjectLocation_Insert_Input>;
  on_conflict?: InputMaybe<ProjectLocation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectLocation_OneArgs = {
  object: ProjectLocation_Insert_Input;
  on_conflict?: InputMaybe<ProjectLocation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectMaterialClassificationFeedbackArgs = {
  objects: Array<ProjectMaterialClassificationFeedback_Insert_Input>;
  on_conflict?: InputMaybe<ProjectMaterialClassificationFeedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectMaterialClassificationFeedback_OneArgs = {
  object: ProjectMaterialClassificationFeedback_Insert_Input;
  on_conflict?: InputMaybe<ProjectMaterialClassificationFeedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectMaterialClassificationParameterArgs = {
  objects: Array<ProjectMaterialClassificationParameter_Insert_Input>;
  on_conflict?: InputMaybe<ProjectMaterialClassificationParameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectMaterialClassificationParameter_OneArgs = {
  object: ProjectMaterialClassificationParameter_Insert_Input;
  on_conflict?: InputMaybe<ProjectMaterialClassificationParameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectMembershipArgs = {
  objects: Array<ProjectMembership_Insert_Input>;
  on_conflict?: InputMaybe<ProjectMembership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectMembership_OneArgs = {
  object: ProjectMembership_Insert_Input;
  on_conflict?: InputMaybe<ProjectMembership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectModelArgs = {
  objects: Array<ProjectModel_Insert_Input>;
  on_conflict?: InputMaybe<ProjectModel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectModelSpecklePinArgs = {
  objects: Array<ProjectModelSpecklePin_Insert_Input>;
  on_conflict?: InputMaybe<ProjectModelSpecklePin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectModelSpecklePin_OneArgs = {
  object: ProjectModelSpecklePin_Insert_Input;
  on_conflict?: InputMaybe<ProjectModelSpecklePin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectModel_OneArgs = {
  object: ProjectModel_Insert_Input;
  on_conflict?: InputMaybe<ProjectModel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectOperationalArgs = {
  objects: Array<ProjectOperational_Insert_Input>;
  on_conflict?: InputMaybe<ProjectOperational_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectOperational_OneArgs = {
  object: ProjectOperational_Insert_Input;
  on_conflict?: InputMaybe<ProjectOperational_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectReferenceAreaArgs = {
  objects: Array<ProjectReferenceArea_Insert_Input>;
  on_conflict?: InputMaybe<ProjectReferenceArea_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectReferenceArea_OneArgs = {
  object: ProjectReferenceArea_Insert_Input;
  on_conflict?: InputMaybe<ProjectReferenceArea_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectRevisionArgs = {
  objects: Array<ProjectRevision_Insert_Input>;
  on_conflict?: InputMaybe<ProjectRevision_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectRevision_OneArgs = {
  object: ProjectRevision_Insert_Input;
  on_conflict?: InputMaybe<ProjectRevision_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpecialConditionConfigArgs = {
  objects: Array<ProjectSpecialConditionConfig_Insert_Input>;
  on_conflict?: InputMaybe<ProjectSpecialConditionConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpecialConditionConfig_OneArgs = {
  object: ProjectSpecialConditionConfig_Insert_Input;
  on_conflict?: InputMaybe<ProjectSpecialConditionConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpecialConditionTypeMappingArgs = {
  objects: Array<ProjectSpecialConditionTypeMapping_Insert_Input>;
  on_conflict?: InputMaybe<ProjectSpecialConditionTypeMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpecialConditionTypeMapping_OneArgs = {
  object: ProjectSpecialConditionTypeMapping_Insert_Input;
  on_conflict?: InputMaybe<ProjectSpecialConditionTypeMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleCopyArgs = {
  objects: Array<ProjectSpeckleCopy_Insert_Input>;
  on_conflict?: InputMaybe<ProjectSpeckleCopy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleCopyRecentArgs = {
  objects: Array<ProjectSpeckleCopyRecent_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleCopyRecent_OneArgs = {
  object: ProjectSpeckleCopyRecent_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleCopy_OneArgs = {
  object: ProjectSpeckleCopy_Insert_Input;
  on_conflict?: InputMaybe<ProjectSpeckleCopy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleModelSyncArgs = {
  objects: Array<ProjectSpeckleModelSync_Insert_Input>;
  on_conflict?: InputMaybe<ProjectSpeckleModelSync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleModelSyncRecentArgs = {
  objects: Array<ProjectSpeckleModelSyncRecent_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleModelSyncRecent_OneArgs = {
  object: ProjectSpeckleModelSyncRecent_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleModelSync_OneArgs = {
  object: ProjectSpeckleModelSync_Insert_Input;
  on_conflict?: InputMaybe<ProjectSpeckleModelSync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleParameterConfigArgs = {
  objects: Array<ProjectSpeckleParameterConfig_Insert_Input>;
  on_conflict?: InputMaybe<ProjectSpeckleParameterConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectSpeckleParameterConfig_OneArgs = {
  object: ProjectSpeckleParameterConfig_Insert_Input;
  on_conflict?: InputMaybe<ProjectSpeckleParameterConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectStandardValueStageArgs = {
  objects: Array<ProjectStandardValueStage_Insert_Input>;
  on_conflict?: InputMaybe<ProjectStandardValueStage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectStandardValueStage_OneArgs = {
  object: ProjectStandardValueStage_Insert_Input;
  on_conflict?: InputMaybe<ProjectStandardValueStage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectStatusArgs = {
  objects: Array<ProjectStatus_Insert_Input>;
  on_conflict?: InputMaybe<ProjectStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectStatus_OneArgs = {
  object: ProjectStatus_Insert_Input;
  on_conflict?: InputMaybe<ProjectStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectTransportMappingEmissionFactorArgs = {
  objects: Array<ProjectTransportMappingEmissionFactor_Insert_Input>;
  on_conflict?: InputMaybe<ProjectTransportMappingEmissionFactor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectTransportMappingEmissionFactor_OneArgs = {
  object: ProjectTransportMappingEmissionFactor_Insert_Input;
  on_conflict?: InputMaybe<ProjectTransportMappingEmissionFactor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectVersionArgs = {
  objects: Array<ProjectVersion_Insert_Input>;
  on_conflict?: InputMaybe<ProjectVersion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectVersionNumberedArgs = {
  objects: Array<ProjectVersionNumbered_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectVersionNumbered_OneArgs = {
  object: ProjectVersionNumbered_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_ProjectVersion_OneArgs = {
  object: ProjectVersion_Insert_Input;
  on_conflict?: InputMaybe<ProjectVersion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectWasteMappingArgs = {
  objects: Array<ProjectWasteMapping_Insert_Input>;
  on_conflict?: InputMaybe<ProjectWasteMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectWasteMapping_OneArgs = {
  object: ProjectWasteMapping_Insert_Input;
  on_conflict?: InputMaybe<ProjectWasteMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectWasteTypeCustomArgs = {
  objects: Array<ProjectWasteTypeCustom_Insert_Input>;
  on_conflict?: InputMaybe<ProjectWasteTypeCustom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectWasteTypeCustom_OneArgs = {
  object: ProjectWasteTypeCustom_Insert_Input;
  on_conflict?: InputMaybe<ProjectWasteTypeCustom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_OneArgs = {
  object: Project_Insert_Input;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_TransportArgs = {
  objects: Array<Project_Transport_Insert_Input>;
  on_conflict?: InputMaybe<Project_Transport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Transport_DefaultArgs = {
  objects: Array<Project_Transport_Default_Insert_Input>;
  on_conflict?: InputMaybe<Project_Transport_Default_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Transport_Default_OneArgs = {
  object: Project_Transport_Default_Insert_Input;
  on_conflict?: InputMaybe<Project_Transport_Default_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Transport_MappingArgs = {
  objects: Array<Project_Transport_Mapping_Insert_Input>;
  on_conflict?: InputMaybe<Project_Transport_Mapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Transport_Mapping_OneArgs = {
  object: Project_Transport_Mapping_Insert_Input;
  on_conflict?: InputMaybe<Project_Transport_Mapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Transport_OneArgs = {
  object: Project_Transport_Insert_Input;
  on_conflict?: InputMaybe<Project_Transport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReferenceAreaTypeArgs = {
  objects: Array<ReferenceAreaType_Insert_Input>;
  on_conflict?: InputMaybe<ReferenceAreaType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReferenceAreaTypeCalculationTypeMappingArgs = {
  objects: Array<ReferenceAreaTypeCalculationTypeMapping_Insert_Input>;
  on_conflict?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReferenceAreaTypeCalculationTypeMapping_OneArgs = {
  object: ReferenceAreaTypeCalculationTypeMapping_Insert_Input;
  on_conflict?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReferenceAreaType_OneArgs = {
  object: ReferenceAreaType_Insert_Input;
  on_conflict?: InputMaybe<ReferenceAreaType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportBuildingTypeMappingArgs = {
  objects: Array<ReportBuildingTypeMapping_Insert_Input>;
  on_conflict?: InputMaybe<ReportBuildingTypeMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportBuildingTypeMapping_OneArgs = {
  object: ReportBuildingTypeMapping_Insert_Input;
  on_conflict?: InputMaybe<ReportBuildingTypeMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportClassificationCodeEmissionMappingArgs = {
  objects: Array<ReportClassificationCodeEmissionMapping_Insert_Input>;
  on_conflict?: InputMaybe<ReportClassificationCodeEmissionMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportClassificationCodeEmissionMapping_OneArgs = {
  object: ReportClassificationCodeEmissionMapping_Insert_Input;
  on_conflict?: InputMaybe<ReportClassificationCodeEmissionMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportLoadBearingElementAmountMappingArgs = {
  objects: Array<ReportLoadBearingElementAmountMapping_Insert_Input>;
  on_conflict?: InputMaybe<ReportLoadBearingElementAmountMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportLoadBearingElementAmountMapping_OneArgs = {
  object: ReportLoadBearingElementAmountMapping_Insert_Input;
  on_conflict?: InputMaybe<ReportLoadBearingElementAmountMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportLoadBearingElementEmissionMappingArgs = {
  objects: Array<ReportLoadBearingElementEmissionMapping_Insert_Input>;
  on_conflict?: InputMaybe<ReportLoadBearingElementEmissionMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportLoadBearingElementEmissionMapping_OneArgs = {
  object: ReportLoadBearingElementEmissionMapping_Insert_Input;
  on_conflict?: InputMaybe<ReportLoadBearingElementEmissionMapping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportStructureArgs = {
  objects: Array<ReportStructure_Insert_Input>;
  on_conflict?: InputMaybe<ReportStructure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportStructureCalculationTypesArgs = {
  objects: Array<ReportStructureCalculationTypes_Insert_Input>;
  on_conflict?: InputMaybe<ReportStructureCalculationTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportStructureCalculationTypes_OneArgs = {
  object: ReportStructureCalculationTypes_Insert_Input;
  on_conflict?: InputMaybe<ReportStructureCalculationTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportStructureClassificationCodesArgs = {
  objects: Array<ReportStructureClassificationCodes_Insert_Input>;
  on_conflict?: InputMaybe<ReportStructureClassificationCodes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportStructureClassificationCodes_OneArgs = {
  object: ReportStructureClassificationCodes_Insert_Input;
  on_conflict?: InputMaybe<ReportStructureClassificationCodes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportStructure_OneArgs = {
  object: ReportStructure_Insert_Input;
  on_conflict?: InputMaybe<ReportStructure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportfilesmetadataArgs = {
  objects: Array<Reportfilesmetadata_Insert_Input>;
  on_conflict?: InputMaybe<Reportfilesmetadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reportfilesmetadata_OneArgs = {
  object: Reportfilesmetadata_Insert_Input;
  on_conflict?: InputMaybe<Reportfilesmetadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpecialConditionTypeArgs = {
  objects: Array<SpecialConditionType_Insert_Input>;
  on_conflict?: InputMaybe<SpecialConditionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpecialConditionTypeCalculationTypeArgs = {
  objects: Array<SpecialConditionTypeCalculationType_Insert_Input>;
  on_conflict?: InputMaybe<SpecialConditionTypeCalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpecialConditionTypeCalculationType_OneArgs = {
  object: SpecialConditionTypeCalculationType_Insert_Input;
  on_conflict?: InputMaybe<SpecialConditionTypeCalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpecialConditionTypeInputParameterArgs = {
  objects: Array<SpecialConditionTypeInputParameter_Insert_Input>;
  on_conflict?: InputMaybe<SpecialConditionTypeInputParameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpecialConditionTypeInputParameter_OneArgs = {
  object: SpecialConditionTypeInputParameter_Insert_Input;
  on_conflict?: InputMaybe<SpecialConditionTypeInputParameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpecialConditionType_OneArgs = {
  object: SpecialConditionType_Insert_Input;
  on_conflict?: InputMaybe<SpecialConditionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Special_Condition_Type_CategoryArgs = {
  objects: Array<Special_Condition_Type_Category_Insert_Input>;
  on_conflict?: InputMaybe<Special_Condition_Type_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Special_Condition_Type_Category_OneArgs = {
  object: Special_Condition_Type_Category_Insert_Input;
  on_conflict?: InputMaybe<Special_Condition_Type_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpeckleStreamModelIfcUploadArgs = {
  objects: Array<SpeckleStreamModelIfcUpload_Insert_Input>;
  on_conflict?: InputMaybe<SpeckleStreamModelIfcUpload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpeckleStreamModelIfcUploadRecentArgs = {
  objects: Array<SpeckleStreamModelIfcUploadRecent_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_SpeckleStreamModelIfcUploadRecent_OneArgs = {
  object: SpeckleStreamModelIfcUploadRecent_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_SpeckleStreamModelIfcUpload_OneArgs = {
  object: SpeckleStreamModelIfcUpload_Insert_Input;
  on_conflict?: InputMaybe<SpeckleStreamModelIfcUpload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpeckleUserDataArgs = {
  objects: Array<SpeckleUserData_Insert_Input>;
  on_conflict?: InputMaybe<SpeckleUserData_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpeckleUserData_OneArgs = {
  object: SpeckleUserData_Insert_Input;
  on_conflict?: InputMaybe<SpeckleUserData_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Speckle_StreamArgs = {
  objects: Array<Speckle_Stream_Insert_Input>;
  on_conflict?: InputMaybe<Speckle_Stream_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Speckle_Stream_OneArgs = {
  object: Speckle_Stream_Insert_Input;
  on_conflict?: InputMaybe<Speckle_Stream_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StageArgs = {
  objects: Array<Stage_Insert_Input>;
  on_conflict?: InputMaybe<Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StageDefaultEmissionArgs = {
  objects: Array<StageDefaultEmission_Insert_Input>;
  on_conflict?: InputMaybe<StageDefaultEmission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StageDefaultEmission_OneArgs = {
  object: StageDefaultEmission_Insert_Input;
  on_conflict?: InputMaybe<StageDefaultEmission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stage_Default_Emission_Building_TypeArgs = {
  objects: Array<Stage_Default_Emission_Building_Type_Insert_Input>;
  on_conflict?: InputMaybe<Stage_Default_Emission_Building_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stage_Default_Emission_Building_Type_OneArgs = {
  object: Stage_Default_Emission_Building_Type_Insert_Input;
  on_conflict?: InputMaybe<Stage_Default_Emission_Building_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stage_OneArgs = {
  object: Stage_Insert_Input;
  on_conflict?: InputMaybe<Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantAiBudgetArgs = {
  objects: Array<TenantAiBudget_Insert_Input>;
  on_conflict?: InputMaybe<TenantAiBudget_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantAiBudget_OneArgs = {
  object: TenantAiBudget_Insert_Input;
  on_conflict?: InputMaybe<TenantAiBudget_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantAiCreditPurchaseArgs = {
  objects: Array<TenantAiCreditPurchase_Insert_Input>;
  on_conflict?: InputMaybe<TenantAiCreditPurchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantAiCreditPurchase_OneArgs = {
  object: TenantAiCreditPurchase_Insert_Input;
  on_conflict?: InputMaybe<TenantAiCreditPurchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantAiPaymentArgs = {
  objects: Array<TenantAiPayment_Insert_Input>;
  on_conflict?: InputMaybe<TenantAiPayment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantAiPayment_OneArgs = {
  object: TenantAiPayment_Insert_Input;
  on_conflict?: InputMaybe<TenantAiPayment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantCollectionArgs = {
  objects: Array<TenantCollection_Insert_Input>;
  on_conflict?: InputMaybe<TenantCollection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantCollectionItemArgs = {
  objects: Array<TenantCollectionItem_Insert_Input>;
  on_conflict?: InputMaybe<TenantCollectionItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantCollectionItem_OneArgs = {
  object: TenantCollectionItem_Insert_Input;
  on_conflict?: InputMaybe<TenantCollectionItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantCollection_OneArgs = {
  object: TenantCollection_Insert_Input;
  on_conflict?: InputMaybe<TenantCollection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantInvoiceArgs = {
  objects: Array<TenantInvoice_Insert_Input>;
  on_conflict?: InputMaybe<TenantInvoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantInvoice_OneArgs = {
  object: TenantInvoice_Insert_Input;
  on_conflict?: InputMaybe<TenantInvoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantUserRequestAiUsageArgs = {
  objects: Array<TenantUserRequestAiUsage_Insert_Input>;
  on_conflict?: InputMaybe<TenantUserRequestAiUsage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantUserRequestAiUsage_OneArgs = {
  object: TenantUserRequestAiUsage_Insert_Input;
  on_conflict?: InputMaybe<TenantUserRequestAiUsage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TranslationCategoryArgs = {
  objects: Array<TranslationCategory_Insert_Input>;
  on_conflict?: InputMaybe<TranslationCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TranslationCategory_OneArgs = {
  object: TranslationCategory_Insert_Input;
  on_conflict?: InputMaybe<TranslationCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TranslationSourceArgs = {
  objects: Array<TranslationSource_Insert_Input>;
  on_conflict?: InputMaybe<TranslationSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TranslationSource_OneArgs = {
  object: TranslationSource_Insert_Input;
  on_conflict?: InputMaybe<TranslationSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransportArgs = {
  objects: Array<Transport_Insert_Input>;
  on_conflict?: InputMaybe<Transport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransportEmissionFactorArgs = {
  objects: Array<TransportEmissionFactor_Insert_Input>;
  on_conflict?: InputMaybe<TransportEmissionFactor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransportEmissionFactor_OneArgs = {
  object: TransportEmissionFactor_Insert_Input;
  on_conflict?: InputMaybe<TransportEmissionFactor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransportSourceArgs = {
  objects: Array<TransportSource_Insert_Input>;
  on_conflict?: InputMaybe<TransportSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransportSourceCalculationTypeArgs = {
  objects: Array<TransportSourceCalculationType_Insert_Input>;
  on_conflict?: InputMaybe<TransportSourceCalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransportSourceCalculationType_OneArgs = {
  object: TransportSourceCalculationType_Insert_Input;
  on_conflict?: InputMaybe<TransportSourceCalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransportSource_OneArgs = {
  object: TransportSource_Insert_Input;
  on_conflict?: InputMaybe<TransportSource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transport_OneArgs = {
  object: Transport_Insert_Input;
  on_conflict?: InputMaybe<Transport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transport_Standard_ValueArgs = {
  objects: Array<Transport_Standard_Value_Insert_Input>;
  on_conflict?: InputMaybe<Transport_Standard_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transport_Standard_Value_OneArgs = {
  object: Transport_Standard_Value_Insert_Input;
  on_conflict?: InputMaybe<Transport_Standard_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transport_TypeArgs = {
  objects: Array<Transport_Type_Insert_Input>;
  on_conflict?: InputMaybe<Transport_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transport_Type_OneArgs = {
  object: Transport_Type_Insert_Input;
  on_conflict?: InputMaybe<Transport_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UnitArgs = {
  objects: Array<Unit_Insert_Input>;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_OneArgs = {
  object: Unit_Insert_Input;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserMaterialFavoriteArgs = {
  objects: Array<UserMaterialFavorite_Insert_Input>;
  on_conflict?: InputMaybe<UserMaterialFavorite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserMaterialFavorite_OneArgs = {
  object: UserMaterialFavorite_Insert_Input;
  on_conflict?: InputMaybe<UserMaterialFavorite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserPlatformReviewArgs = {
  objects: Array<UserPlatformReview_Insert_Input>;
  on_conflict?: InputMaybe<UserPlatformReview_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserPlatformReview_OneArgs = {
  object: UserPlatformReview_Insert_Input;
  on_conflict?: InputMaybe<UserPlatformReview_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserProjectViewArgs = {
  objects: Array<UserProjectView_Insert_Input>;
  on_conflict?: InputMaybe<UserProjectView_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserProjectView_OneArgs = {
  object: UserProjectView_Insert_Input;
  on_conflict?: InputMaybe<UserProjectView_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserTutorialViewArgs = {
  objects: Array<UserTutorialView_Insert_Input>;
  on_conflict?: InputMaybe<UserTutorialView_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserTutorialView_OneArgs = {
  object: UserTutorialView_Insert_Input;
  on_conflict?: InputMaybe<UserTutorialView_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserWelcomeFlowArgs = {
  objects: Array<UserWelcomeFlow_Insert_Input>;
  on_conflict?: InputMaybe<UserWelcomeFlow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserWelcomeFlowEventArgs = {
  objects: Array<UserWelcomeFlowEvent_Insert_Input>;
  on_conflict?: InputMaybe<UserWelcomeFlowEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserWelcomeFlowEvent_OneArgs = {
  object: UserWelcomeFlowEvent_Insert_Input;
  on_conflict?: InputMaybe<UserWelcomeFlowEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserWelcomeFlow_OneArgs = {
  object: UserWelcomeFlow_Insert_Input;
  on_conflict?: InputMaybe<UserWelcomeFlow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VMaterialGwpArgs = {
  objects: Array<VMaterialGwp_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VMaterialGwp_OneArgs = {
  object: VMaterialGwp_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VMaterialStatusArgs = {
  objects: Array<VMaterialStatus_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VMaterialStatus_OneArgs = {
  object: VMaterialStatus_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_WeightPerDeclaredUnitArgs = {
  objects: Array<WeightPerDeclaredUnit_Insert_Input>;
  on_conflict?: InputMaybe<WeightPerDeclaredUnit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WeightPerDeclaredUnit_OneArgs = {
  object: WeightPerDeclaredUnit_Insert_Input;
  on_conflict?: InputMaybe<WeightPerDeclaredUnit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootProject_Restore_Copy_MappingsArgs = {
  args: Project_Restore_Copy_Mappings_Args;
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootProject_Revision_SaveArgs = {
  args: Project_Revision_Save_Args;
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootProject_Revision_Save_FrozenArgs = {
  args: Project_Revision_Save_Frozen_Args;
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootProject_Revision_SwitchArgs = {
  args: Project_Revision_Switch_Args;
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_AgentModelPricingArgs = {
  _inc?: InputMaybe<AgentModelPricing_Inc_Input>;
  _set?: InputMaybe<AgentModelPricing_Set_Input>;
  where: AgentModelPricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AgentModelPricing_By_PkArgs = {
  _inc?: InputMaybe<AgentModelPricing_Inc_Input>;
  _set?: InputMaybe<AgentModelPricing_Set_Input>;
  pk_columns: AgentModelPricing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AgentModelPricing_ManyArgs = {
  updates: Array<AgentModelPricing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AgentSkillsTenantUserArgs = {
  _set?: InputMaybe<AgentSkillsTenantUser_Set_Input>;
  where: AgentSkillsTenantUser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AgentSkillsTenantUser_By_PkArgs = {
  _set?: InputMaybe<AgentSkillsTenantUser_Set_Input>;
  pk_columns: AgentSkillsTenantUser_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AgentSkillsTenantUser_ManyArgs = {
  updates: Array<AgentSkillsTenantUser_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationSourceArgs = {
  _set?: InputMaybe<ApplicationSource_Set_Input>;
  where: ApplicationSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationSource_By_PkArgs = {
  _set?: InputMaybe<ApplicationSource_Set_Input>;
  pk_columns: ApplicationSource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationSource_ManyArgs = {
  updates: Array<ApplicationSource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkGroupingVerdictArgs = {
  _append?: InputMaybe<BenchmarkGroupingVerdict_Append_Input>;
  _delete_at_path?: InputMaybe<BenchmarkGroupingVerdict_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<BenchmarkGroupingVerdict_Delete_Elem_Input>;
  _delete_key?: InputMaybe<BenchmarkGroupingVerdict_Delete_Key_Input>;
  _inc?: InputMaybe<BenchmarkGroupingVerdict_Inc_Input>;
  _prepend?: InputMaybe<BenchmarkGroupingVerdict_Prepend_Input>;
  _set?: InputMaybe<BenchmarkGroupingVerdict_Set_Input>;
  where: BenchmarkGroupingVerdict_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkGroupingVerdict_By_PkArgs = {
  _append?: InputMaybe<BenchmarkGroupingVerdict_Append_Input>;
  _delete_at_path?: InputMaybe<BenchmarkGroupingVerdict_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<BenchmarkGroupingVerdict_Delete_Elem_Input>;
  _delete_key?: InputMaybe<BenchmarkGroupingVerdict_Delete_Key_Input>;
  _inc?: InputMaybe<BenchmarkGroupingVerdict_Inc_Input>;
  _prepend?: InputMaybe<BenchmarkGroupingVerdict_Prepend_Input>;
  _set?: InputMaybe<BenchmarkGroupingVerdict_Set_Input>;
  pk_columns: BenchmarkGroupingVerdict_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkGroupingVerdict_ManyArgs = {
  updates: Array<BenchmarkGroupingVerdict_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkInventoryMaterialArgs = {
  _append?: InputMaybe<BenchmarkInventoryMaterial_Append_Input>;
  _delete_at_path?: InputMaybe<BenchmarkInventoryMaterial_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<BenchmarkInventoryMaterial_Delete_Elem_Input>;
  _delete_key?: InputMaybe<BenchmarkInventoryMaterial_Delete_Key_Input>;
  _inc?: InputMaybe<BenchmarkInventoryMaterial_Inc_Input>;
  _prepend?: InputMaybe<BenchmarkInventoryMaterial_Prepend_Input>;
  _set?: InputMaybe<BenchmarkInventoryMaterial_Set_Input>;
  where: BenchmarkInventoryMaterial_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkInventoryMaterial_By_PkArgs = {
  _append?: InputMaybe<BenchmarkInventoryMaterial_Append_Input>;
  _delete_at_path?: InputMaybe<BenchmarkInventoryMaterial_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<BenchmarkInventoryMaterial_Delete_Elem_Input>;
  _delete_key?: InputMaybe<BenchmarkInventoryMaterial_Delete_Key_Input>;
  _inc?: InputMaybe<BenchmarkInventoryMaterial_Inc_Input>;
  _prepend?: InputMaybe<BenchmarkInventoryMaterial_Prepend_Input>;
  _set?: InputMaybe<BenchmarkInventoryMaterial_Set_Input>;
  pk_columns: BenchmarkInventoryMaterial_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkInventoryMaterial_ManyArgs = {
  updates: Array<BenchmarkInventoryMaterial_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkMaterialMappingArgs = {
  _inc?: InputMaybe<BenchmarkMaterialMapping_Inc_Input>;
  _set?: InputMaybe<BenchmarkMaterialMapping_Set_Input>;
  where: BenchmarkMaterialMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkMaterialMapping_By_PkArgs = {
  _inc?: InputMaybe<BenchmarkMaterialMapping_Inc_Input>;
  _set?: InputMaybe<BenchmarkMaterialMapping_Set_Input>;
  pk_columns: BenchmarkMaterialMapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkMaterialMapping_ManyArgs = {
  updates: Array<BenchmarkMaterialMapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkProjectStateArgs = {
  _inc?: InputMaybe<BenchmarkProjectState_Inc_Input>;
  _set?: InputMaybe<BenchmarkProjectState_Set_Input>;
  where: BenchmarkProjectState_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkProjectState_By_PkArgs = {
  _inc?: InputMaybe<BenchmarkProjectState_Inc_Input>;
  _set?: InputMaybe<BenchmarkProjectState_Set_Input>;
  pk_columns: BenchmarkProjectState_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkProjectState_ManyArgs = {
  updates: Array<BenchmarkProjectState_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkSnapshotArgs = {
  _inc?: InputMaybe<BenchmarkSnapshot_Inc_Input>;
  _set?: InputMaybe<BenchmarkSnapshot_Set_Input>;
  where: BenchmarkSnapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkSnapshot_By_PkArgs = {
  _inc?: InputMaybe<BenchmarkSnapshot_Inc_Input>;
  _set?: InputMaybe<BenchmarkSnapshot_Set_Input>;
  pk_columns: BenchmarkSnapshot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BenchmarkSnapshot_ManyArgs = {
  updates: Array<BenchmarkSnapshot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingAreaTypeArgs = {
  _set?: InputMaybe<BuildingAreaType_Set_Input>;
  where: BuildingAreaType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingAreaType_By_PkArgs = {
  _set?: InputMaybe<BuildingAreaType_Set_Input>;
  pk_columns: BuildingAreaType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingAreaType_ManyArgs = {
  updates: Array<BuildingAreaType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartArgs = {
  _set?: InputMaybe<BuildingPart_Set_Input>;
  where: BuildingPart_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartLifetimeSourceArgs = {
  _set?: InputMaybe<BuildingPartLifetimeSource_Set_Input>;
  where: BuildingPartLifetimeSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartLifetimeSource_By_PkArgs = {
  _set?: InputMaybe<BuildingPartLifetimeSource_Set_Input>;
  pk_columns: BuildingPartLifetimeSource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartLifetimeSource_ManyArgs = {
  updates: Array<BuildingPartLifetimeSource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartMaintenanceLifetimeArgs = {
  _inc?: InputMaybe<BuildingPartMaintenanceLifetime_Inc_Input>;
  _set?: InputMaybe<BuildingPartMaintenanceLifetime_Set_Input>;
  where: BuildingPartMaintenanceLifetime_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartMaintenanceLifetime_By_PkArgs = {
  _inc?: InputMaybe<BuildingPartMaintenanceLifetime_Inc_Input>;
  _set?: InputMaybe<BuildingPartMaintenanceLifetime_Set_Input>;
  pk_columns: BuildingPartMaintenanceLifetime_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartMaintenanceLifetime_ManyArgs = {
  updates: Array<BuildingPartMaintenanceLifetime_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartServiceLifetimeArgs = {
  _inc?: InputMaybe<BuildingPartServiceLifetime_Inc_Input>;
  _set?: InputMaybe<BuildingPartServiceLifetime_Set_Input>;
  where: BuildingPartServiceLifetime_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartServiceLifetime_By_PkArgs = {
  _inc?: InputMaybe<BuildingPartServiceLifetime_Inc_Input>;
  _set?: InputMaybe<BuildingPartServiceLifetime_Set_Input>;
  pk_columns: BuildingPartServiceLifetime_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPartServiceLifetime_ManyArgs = {
  updates: Array<BuildingPartServiceLifetime_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPart_By_PkArgs = {
  _set?: InputMaybe<BuildingPart_Set_Input>;
  pk_columns: BuildingPart_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingPart_ManyArgs = {
  updates: Array<BuildingPart_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingTypeArgs = {
  _inc?: InputMaybe<BuildingType_Inc_Input>;
  _set?: InputMaybe<BuildingType_Set_Input>;
  where: BuildingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingType_By_PkArgs = {
  _inc?: InputMaybe<BuildingType_Inc_Input>;
  _set?: InputMaybe<BuildingType_Set_Input>;
  pk_columns: BuildingType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingType_ManyArgs = {
  updates: Array<BuildingType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Building_ElementArgs = {
  _set?: InputMaybe<Building_Element_Set_Input>;
  where: Building_Element_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Building_Element_By_PkArgs = {
  _set?: InputMaybe<Building_Element_Set_Input>;
  pk_columns: Building_Element_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Building_Element_Classification_Code_MappingArgs = {
  _inc?: InputMaybe<Building_Element_Classification_Code_Mapping_Inc_Input>;
  _set?: InputMaybe<Building_Element_Classification_Code_Mapping_Set_Input>;
  where: Building_Element_Classification_Code_Mapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Building_Element_Classification_Code_Mapping_By_PkArgs = {
  _inc?: InputMaybe<Building_Element_Classification_Code_Mapping_Inc_Input>;
  _set?: InputMaybe<Building_Element_Classification_Code_Mapping_Set_Input>;
  pk_columns: Building_Element_Classification_Code_Mapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Building_Element_Classification_Code_Mapping_ManyArgs = {
  updates: Array<Building_Element_Classification_Code_Mapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Building_Element_ManyArgs = {
  updates: Array<Building_Element_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Building_Element_Material_Category_MappingArgs = {
  _set?: InputMaybe<Building_Element_Material_Category_Mapping_Set_Input>;
  where: Building_Element_Material_Category_Mapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Building_Element_Material_Category_Mapping_By_PkArgs = {
  _set?: InputMaybe<Building_Element_Material_Category_Mapping_Set_Input>;
  pk_columns: Building_Element_Material_Category_Mapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Building_Element_Material_Category_Mapping_ManyArgs = {
  updates: Array<Building_Element_Material_Category_Mapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeArgs = {
  _inc?: InputMaybe<CalculationType_Inc_Input>;
  _set?: InputMaybe<CalculationType_Set_Input>;
  where: CalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeEpdDatasourceArgs = {
  _inc?: InputMaybe<CalculationTypeEpdDatasource_Inc_Input>;
  _set?: InputMaybe<CalculationTypeEpdDatasource_Set_Input>;
  where: CalculationTypeEpdDatasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeEpdDatasource_By_PkArgs = {
  _inc?: InputMaybe<CalculationTypeEpdDatasource_Inc_Input>;
  _set?: InputMaybe<CalculationTypeEpdDatasource_Set_Input>;
  pk_columns: CalculationTypeEpdDatasource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeEpdDatasource_ManyArgs = {
  updates: Array<CalculationTypeEpdDatasource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeThresholdByBuildingTypeArgs = {
  _inc?: InputMaybe<CalculationTypeThresholdByBuildingType_Inc_Input>;
  _set?: InputMaybe<CalculationTypeThresholdByBuildingType_Set_Input>;
  where: CalculationTypeThresholdByBuildingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeThresholdByBuildingType_By_PkArgs = {
  _inc?: InputMaybe<CalculationTypeThresholdByBuildingType_Inc_Input>;
  _set?: InputMaybe<CalculationTypeThresholdByBuildingType_Set_Input>;
  pk_columns: CalculationTypeThresholdByBuildingType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeThresholdByBuildingType_ManyArgs = {
  updates: Array<CalculationTypeThresholdByBuildingType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeVariantArgs = {
  _inc?: InputMaybe<CalculationTypeVariant_Inc_Input>;
  _set?: InputMaybe<CalculationTypeVariant_Set_Input>;
  where: CalculationTypeVariant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeVariant_By_PkArgs = {
  _inc?: InputMaybe<CalculationTypeVariant_Inc_Input>;
  _set?: InputMaybe<CalculationTypeVariant_Set_Input>;
  pk_columns: CalculationTypeVariant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationTypeVariant_ManyArgs = {
  updates: Array<CalculationTypeVariant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationType_By_PkArgs = {
  _inc?: InputMaybe<CalculationType_Inc_Input>;
  _set?: InputMaybe<CalculationType_Set_Input>;
  pk_columns: CalculationType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CalculationType_ManyArgs = {
  updates: Array<CalculationType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Calculation_Type_StageArgs = {
  _inc?: InputMaybe<Calculation_Type_Stage_Inc_Input>;
  _set?: InputMaybe<Calculation_Type_Stage_Set_Input>;
  where: Calculation_Type_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Calculation_Type_Stage_By_PkArgs = {
  _inc?: InputMaybe<Calculation_Type_Stage_Inc_Input>;
  _set?: InputMaybe<Calculation_Type_Stage_Set_Input>;
  pk_columns: Calculation_Type_Stage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Calculation_Type_Stage_ManyArgs = {
  updates: Array<Calculation_Type_Stage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationCodeArgs = {
  _inc?: InputMaybe<ClassificationCode_Inc_Input>;
  _set?: InputMaybe<ClassificationCode_Set_Input>;
  where: ClassificationCode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationCodeTranslationArgs = {
  _inc?: InputMaybe<ClassificationCodeTranslation_Inc_Input>;
  _set?: InputMaybe<ClassificationCodeTranslation_Set_Input>;
  where: ClassificationCodeTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationCodeTranslation_By_PkArgs = {
  _inc?: InputMaybe<ClassificationCodeTranslation_Inc_Input>;
  _set?: InputMaybe<ClassificationCodeTranslation_Set_Input>;
  pk_columns: ClassificationCodeTranslation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationCodeTranslation_ManyArgs = {
  updates: Array<ClassificationCodeTranslation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationCodeTypeCountryArgs = {
  _set?: InputMaybe<ClassificationCodeTypeCountry_Set_Input>;
  where: ClassificationCodeTypeCountry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationCodeTypeCountry_By_PkArgs = {
  _set?: InputMaybe<ClassificationCodeTypeCountry_Set_Input>;
  pk_columns: ClassificationCodeTypeCountry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationCodeTypeCountry_ManyArgs = {
  updates: Array<ClassificationCodeTypeCountry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationCode_By_PkArgs = {
  _inc?: InputMaybe<ClassificationCode_Inc_Input>;
  _set?: InputMaybe<ClassificationCode_Set_Input>;
  pk_columns: ClassificationCode_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationCode_ManyArgs = {
  updates: Array<ClassificationCode_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationObjectClassArgs = {
  _set?: InputMaybe<ClassificationObjectClass_Set_Input>;
  where: ClassificationObjectClass_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationObjectClassParameterArgs = {
  _set?: InputMaybe<ClassificationObjectClassParameter_Set_Input>;
  where: ClassificationObjectClassParameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationObjectClassParameter_By_PkArgs = {
  _set?: InputMaybe<ClassificationObjectClassParameter_Set_Input>;
  pk_columns: ClassificationObjectClassParameter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationObjectClassParameter_ManyArgs = {
  updates: Array<ClassificationObjectClassParameter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationObjectClassTranslationArgs = {
  _set?: InputMaybe<ClassificationObjectClassTranslation_Set_Input>;
  where: ClassificationObjectClassTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationObjectClassTranslation_By_PkArgs = {
  _set?: InputMaybe<ClassificationObjectClassTranslation_Set_Input>;
  pk_columns: ClassificationObjectClassTranslation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationObjectClassTranslation_ManyArgs = {
  updates: Array<ClassificationObjectClassTranslation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationObjectClass_By_PkArgs = {
  _set?: InputMaybe<ClassificationObjectClass_Set_Input>;
  pk_columns: ClassificationObjectClass_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationObjectClass_ManyArgs = {
  updates: Array<ClassificationObjectClass_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationTypeArgs = {
  _set?: InputMaybe<ClassificationType_Set_Input>;
  where: ClassificationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationTypeAttributeArgs = {
  _set?: InputMaybe<ClassificationTypeAttribute_Set_Input>;
  where: ClassificationTypeAttribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationTypeAttribute_By_PkArgs = {
  _set?: InputMaybe<ClassificationTypeAttribute_Set_Input>;
  pk_columns: ClassificationTypeAttribute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationTypeAttribute_ManyArgs = {
  updates: Array<ClassificationTypeAttribute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationType_By_PkArgs = {
  _set?: InputMaybe<ClassificationType_Set_Input>;
  pk_columns: ClassificationType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassificationType_ManyArgs = {
  updates: Array<ClassificationType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ComponentObjectPhaseArgs = {
  _set?: InputMaybe<ComponentObjectPhase_Set_Input>;
  where: ComponentObjectPhase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ComponentObjectPhase_By_PkArgs = {
  _set?: InputMaybe<ComponentObjectPhase_Set_Input>;
  pk_columns: ComponentObjectPhase_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ComponentObjectPhase_ManyArgs = {
  updates: Array<ComponentObjectPhase_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionArgs = {
  _inc?: InputMaybe<Construction_Inc_Input>;
  _set?: InputMaybe<Construction_Set_Input>;
  where: Construction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpPartArgs = {
  _inc?: InputMaybe<ConstructionBuildUpPart_Inc_Input>;
  _set?: InputMaybe<ConstructionBuildUpPart_Set_Input>;
  where: ConstructionBuildUpPart_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpPartMaterialCategoryArgs = {
  _set?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Set_Input>;
  where: ConstructionBuildUpPartMaterialCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpPartMaterialCategory_By_PkArgs = {
  _set?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Set_Input>;
  pk_columns: ConstructionBuildUpPartMaterialCategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpPartMaterialCategory_ManyArgs = {
  updates: Array<ConstructionBuildUpPartMaterialCategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpPartTranslationArgs = {
  _set?: InputMaybe<ConstructionBuildUpPartTranslation_Set_Input>;
  where: ConstructionBuildUpPartTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpPartTranslation_By_PkArgs = {
  _set?: InputMaybe<ConstructionBuildUpPartTranslation_Set_Input>;
  pk_columns: ConstructionBuildUpPartTranslation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpPartTranslation_ManyArgs = {
  updates: Array<ConstructionBuildUpPartTranslation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpPart_By_PkArgs = {
  _inc?: InputMaybe<ConstructionBuildUpPart_Inc_Input>;
  _set?: InputMaybe<ConstructionBuildUpPart_Set_Input>;
  pk_columns: ConstructionBuildUpPart_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpPart_ManyArgs = {
  updates: Array<ConstructionBuildUpPart_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpTemplateArgs = {
  _inc?: InputMaybe<ConstructionBuildUpTemplate_Inc_Input>;
  _set?: InputMaybe<ConstructionBuildUpTemplate_Set_Input>;
  where: ConstructionBuildUpTemplate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpTemplateTranslationArgs = {
  _set?: InputMaybe<ConstructionBuildUpTemplateTranslation_Set_Input>;
  where: ConstructionBuildUpTemplateTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpTemplateTranslation_By_PkArgs = {
  _set?: InputMaybe<ConstructionBuildUpTemplateTranslation_Set_Input>;
  pk_columns: ConstructionBuildUpTemplateTranslation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpTemplateTranslation_ManyArgs = {
  updates: Array<ConstructionBuildUpTemplateTranslation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpTemplate_By_PkArgs = {
  _inc?: InputMaybe<ConstructionBuildUpTemplate_Inc_Input>;
  _set?: InputMaybe<ConstructionBuildUpTemplate_Set_Input>;
  pk_columns: ConstructionBuildUpTemplate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionBuildUpTemplate_ManyArgs = {
  updates: Array<ConstructionBuildUpTemplate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCategoryArgs = {
  _inc?: InputMaybe<ConstructionCategory_Inc_Input>;
  _set?: InputMaybe<ConstructionCategory_Set_Input>;
  where: ConstructionCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCategoryTranslationArgs = {
  _set?: InputMaybe<ConstructionCategoryTranslation_Set_Input>;
  where: ConstructionCategoryTranslation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCategoryTranslation_By_PkArgs = {
  _set?: InputMaybe<ConstructionCategoryTranslation_Set_Input>;
  pk_columns: ConstructionCategoryTranslation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCategoryTranslation_ManyArgs = {
  updates: Array<ConstructionCategoryTranslation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCategoryUnitArgs = {
  _inc?: InputMaybe<ConstructionCategoryUnit_Inc_Input>;
  _set?: InputMaybe<ConstructionCategoryUnit_Set_Input>;
  where: ConstructionCategoryUnit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCategoryUnit_By_PkArgs = {
  _inc?: InputMaybe<ConstructionCategoryUnit_Inc_Input>;
  _set?: InputMaybe<ConstructionCategoryUnit_Set_Input>;
  pk_columns: ConstructionCategoryUnit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCategoryUnit_ManyArgs = {
  updates: Array<ConstructionCategoryUnit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCategory_By_PkArgs = {
  _inc?: InputMaybe<ConstructionCategory_Inc_Input>;
  _set?: InputMaybe<ConstructionCategory_Set_Input>;
  pk_columns: ConstructionCategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCategory_ManyArgs = {
  updates: Array<ConstructionCategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCountryArgs = {
  _set?: InputMaybe<ConstructionCountry_Set_Input>;
  where: ConstructionCountry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCountry_By_PkArgs = {
  _set?: InputMaybe<ConstructionCountry_Set_Input>;
  pk_columns: ConstructionCountry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionCountry_ManyArgs = {
  updates: Array<ConstructionCountry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionDescriptionArgs = {
  _set?: InputMaybe<ConstructionDescription_Set_Input>;
  where: ConstructionDescription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionDescription_By_PkArgs = {
  _set?: InputMaybe<ConstructionDescription_Set_Input>;
  pk_columns: ConstructionDescription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionDescription_ManyArgs = {
  updates: Array<ConstructionDescription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionForkArgs = {
  _set?: InputMaybe<ConstructionFork_Set_Input>;
  where: ConstructionFork_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionFork_By_PkArgs = {
  _set?: InputMaybe<ConstructionFork_Set_Input>;
  pk_columns: ConstructionFork_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionFork_ManyArgs = {
  updates: Array<ConstructionFork_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogeneousLayerArgs = {
  _inc?: InputMaybe<ConstructionInhomogeneousLayer_Inc_Input>;
  _set?: InputMaybe<ConstructionInhomogeneousLayer_Set_Input>;
  where: ConstructionInhomogeneousLayer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogeneousLayerMaterialArgs = {
  _inc?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Inc_Input>;
  _set?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Set_Input>;
  where: ConstructionInhomogeneousLayerMaterial_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogeneousLayerMaterial_By_PkArgs = {
  _inc?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Inc_Input>;
  _set?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Set_Input>;
  pk_columns: ConstructionInhomogeneousLayerMaterial_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogeneousLayerMaterial_ManyArgs = {
  updates: Array<ConstructionInhomogeneousLayerMaterial_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogeneousLayer_By_PkArgs = {
  _inc?: InputMaybe<ConstructionInhomogeneousLayer_Inc_Input>;
  _set?: InputMaybe<ConstructionInhomogeneousLayer_Set_Input>;
  pk_columns: ConstructionInhomogeneousLayer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogeneousLayer_ManyArgs = {
  updates: Array<ConstructionInhomogeneousLayer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogenousLayerDescriptionArgs = {
  _set?: InputMaybe<ConstructionInhomogenousLayerDescription_Set_Input>;
  where: ConstructionInhomogenousLayerDescription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogenousLayerDescription_By_PkArgs = {
  _set?: InputMaybe<ConstructionInhomogenousLayerDescription_Set_Input>;
  pk_columns: ConstructionInhomogenousLayerDescription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogenousLayerDescription_ManyArgs = {
  updates: Array<ConstructionInhomogenousLayerDescription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogenousLayerNameArgs = {
  _set?: InputMaybe<ConstructionInhomogenousLayerName_Set_Input>;
  where: ConstructionInhomogenousLayerName_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogenousLayerName_By_PkArgs = {
  _set?: InputMaybe<ConstructionInhomogenousLayerName_Set_Input>;
  pk_columns: ConstructionInhomogenousLayerName_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionInhomogenousLayerName_ManyArgs = {
  updates: Array<ConstructionInhomogenousLayerName_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionMaterialArgs = {
  _inc?: InputMaybe<ConstructionMaterial_Inc_Input>;
  _set?: InputMaybe<ConstructionMaterial_Set_Input>;
  where: ConstructionMaterial_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionMaterial_By_PkArgs = {
  _inc?: InputMaybe<ConstructionMaterial_Inc_Input>;
  _set?: InputMaybe<ConstructionMaterial_Set_Input>;
  pk_columns: ConstructionMaterial_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionMaterial_ManyArgs = {
  updates: Array<ConstructionMaterial_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionNameArgs = {
  _set?: InputMaybe<ConstructionName_Set_Input>;
  where: ConstructionName_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionName_By_PkArgs = {
  _set?: InputMaybe<ConstructionName_Set_Input>;
  pk_columns: ConstructionName_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionName_ManyArgs = {
  updates: Array<ConstructionName_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionSortingArgs = {
  _inc?: InputMaybe<ConstructionSorting_Inc_Input>;
  _set?: InputMaybe<ConstructionSorting_Set_Input>;
  where: ConstructionSorting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionSorting_By_PkArgs = {
  _inc?: InputMaybe<ConstructionSorting_Inc_Input>;
  _set?: InputMaybe<ConstructionSorting_Set_Input>;
  pk_columns: ConstructionSorting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionSorting_ManyArgs = {
  updates: Array<ConstructionSorting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Construction_By_PkArgs = {
  _inc?: InputMaybe<Construction_Inc_Input>;
  _set?: InputMaybe<Construction_Set_Input>;
  pk_columns: Construction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Construction_ManyArgs = {
  updates: Array<Construction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountryArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CountryConfigArgs = {
  _inc?: InputMaybe<CountryConfig_Inc_Input>;
  _set?: InputMaybe<CountryConfig_Set_Input>;
  where: CountryConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CountryConfig_By_PkArgs = {
  _inc?: InputMaybe<CountryConfig_Inc_Input>;
  _set?: InputMaybe<CountryConfig_Set_Input>;
  pk_columns: CountryConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CountryConfig_ManyArgs = {
  updates: Array<CountryConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Country_By_PkArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  pk_columns: Country_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Country_ManyArgs = {
  updates: Array<Country_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DeclaredUnitArgs = {
  _inc?: InputMaybe<DeclaredUnit_Inc_Input>;
  _set?: InputMaybe<DeclaredUnit_Set_Input>;
  where: DeclaredUnit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_DeclaredUnit_By_PkArgs = {
  _inc?: InputMaybe<DeclaredUnit_Inc_Input>;
  _set?: InputMaybe<DeclaredUnit_Set_Input>;
  pk_columns: DeclaredUnit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DeclaredUnit_ManyArgs = {
  updates: Array<DeclaredUnit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DenominatorUnitArgs = {
  _inc?: InputMaybe<DenominatorUnit_Inc_Input>;
  _set?: InputMaybe<DenominatorUnit_Set_Input>;
  where: DenominatorUnit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_DenominatorUnit_By_PkArgs = {
  _inc?: InputMaybe<DenominatorUnit_Inc_Input>;
  _set?: InputMaybe<DenominatorUnit_Set_Input>;
  pk_columns: DenominatorUnit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DenominatorUnit_ManyArgs = {
  updates: Array<DenominatorUnit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Distance_UnitArgs = {
  _set?: InputMaybe<Distance_Unit_Set_Input>;
  where: Distance_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Distance_Unit_By_PkArgs = {
  _set?: InputMaybe<Distance_Unit_Set_Input>;
  pk_columns: Distance_Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Distance_Unit_ManyArgs = {
  updates: Array<Distance_Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EmissionFactorSourceTypeArgs = {
  _inc?: InputMaybe<EmissionFactorSourceType_Inc_Input>;
  _set?: InputMaybe<EmissionFactorSourceType_Set_Input>;
  where: EmissionFactorSourceType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EmissionFactorSourceType_By_PkArgs = {
  _inc?: InputMaybe<EmissionFactorSourceType_Inc_Input>;
  _set?: InputMaybe<EmissionFactorSourceType_Set_Input>;
  pk_columns: EmissionFactorSourceType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EmissionFactorSourceType_ManyArgs = {
  updates: Array<EmissionFactorSourceType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Emission_FactorArgs = {
  _inc?: InputMaybe<Emission_Factor_Inc_Input>;
  _set?: InputMaybe<Emission_Factor_Set_Input>;
  where: Emission_Factor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Emission_Factor_By_PkArgs = {
  _inc?: InputMaybe<Emission_Factor_Inc_Input>;
  _set?: InputMaybe<Emission_Factor_Set_Input>;
  pk_columns: Emission_Factor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Emission_Factor_ManyArgs = {
  updates: Array<Emission_Factor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Emission_Factor_SourceArgs = {
  _set?: InputMaybe<Emission_Factor_Source_Set_Input>;
  where: Emission_Factor_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Emission_Factor_Source_By_PkArgs = {
  _set?: InputMaybe<Emission_Factor_Source_Set_Input>;
  pk_columns: Emission_Factor_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Emission_Factor_Source_ManyArgs = {
  updates: Array<Emission_Factor_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Emission_Factor_TypeArgs = {
  _set?: InputMaybe<Emission_Factor_Type_Set_Input>;
  where: Emission_Factor_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Emission_Factor_Type_By_PkArgs = {
  _set?: InputMaybe<Emission_Factor_Type_Set_Input>;
  pk_columns: Emission_Factor_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Emission_Factor_Type_ManyArgs = {
  updates: Array<Emission_Factor_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EnumCollectionTypeArgs = {
  _inc?: InputMaybe<EnumCollectionType_Inc_Input>;
  _set?: InputMaybe<EnumCollectionType_Set_Input>;
  where: EnumCollectionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EnumCollectionType_By_PkArgs = {
  _inc?: InputMaybe<EnumCollectionType_Inc_Input>;
  _set?: InputMaybe<EnumCollectionType_Set_Input>;
  pk_columns: EnumCollectionType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EnumCollectionType_ManyArgs = {
  updates: Array<EnumCollectionType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EpdDatasourceArgs = {
  _set?: InputMaybe<EpdDatasource_Set_Input>;
  where: EpdDatasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EpdDatasource_By_PkArgs = {
  _set?: InputMaybe<EpdDatasource_Set_Input>;
  pk_columns: EpdDatasource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EpdDatasource_ManyArgs = {
  updates: Array<EpdDatasource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EpdOwnerArgs = {
  _set?: InputMaybe<EpdOwner_Set_Input>;
  where: EpdOwner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EpdOwnerAliasArgs = {
  _set?: InputMaybe<EpdOwnerAlias_Set_Input>;
  where: EpdOwnerAlias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EpdOwnerAlias_By_PkArgs = {
  _set?: InputMaybe<EpdOwnerAlias_Set_Input>;
  pk_columns: EpdOwnerAlias_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EpdOwnerAlias_ManyArgs = {
  updates: Array<EpdOwnerAlias_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EpdOwner_By_PkArgs = {
  _set?: InputMaybe<EpdOwner_Set_Input>;
  pk_columns: EpdOwner_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EpdOwner_ManyArgs = {
  updates: Array<EpdOwner_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EpdProductIndustryArgs = {
  _inc?: InputMaybe<EpdProductIndustry_Inc_Input>;
  _set?: InputMaybe<EpdProductIndustry_Set_Input>;
  where: EpdProductIndustry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EpdProductIndustry_By_PkArgs = {
  _inc?: InputMaybe<EpdProductIndustry_Inc_Input>;
  _set?: InputMaybe<EpdProductIndustry_Set_Input>;
  pk_columns: EpdProductIndustry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EpdProductIndustry_ManyArgs = {
  updates: Array<EpdProductIndustry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EpdSpecificationFormArgs = {
  _inc?: InputMaybe<EpdSpecificationForm_Inc_Input>;
  _set?: InputMaybe<EpdSpecificationForm_Set_Input>;
  where: EpdSpecificationForm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EpdSpecificationForm_By_PkArgs = {
  _inc?: InputMaybe<EpdSpecificationForm_Inc_Input>;
  _set?: InputMaybe<EpdSpecificationForm_Set_Input>;
  pk_columns: EpdSpecificationForm_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EpdSpecificationForm_ManyArgs = {
  updates: Array<EpdSpecificationForm_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FlowGuideArgs = {
  _inc?: InputMaybe<FlowGuide_Inc_Input>;
  _set?: InputMaybe<FlowGuide_Set_Input>;
  where: FlowGuide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FlowGuideViewsArgs = {
  _set?: InputMaybe<FlowGuideViews_Set_Input>;
  where: FlowGuideViews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FlowGuideViews_By_PkArgs = {
  _set?: InputMaybe<FlowGuideViews_Set_Input>;
  pk_columns: FlowGuideViews_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FlowGuideViews_ManyArgs = {
  updates: Array<FlowGuideViews_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FlowGuide_By_PkArgs = {
  _inc?: InputMaybe<FlowGuide_Inc_Input>;
  _set?: InputMaybe<FlowGuide_Set_Input>;
  pk_columns: FlowGuide_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FlowGuide_ManyArgs = {
  updates: Array<FlowGuide_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorSourceArgs = {
  _set?: InputMaybe<IndicatorSource_Set_Input>;
  where: IndicatorSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorSource_By_PkArgs = {
  _set?: InputMaybe<IndicatorSource_Set_Input>;
  pk_columns: IndicatorSource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorSource_ManyArgs = {
  updates: Array<IndicatorSource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorTypeArgs = {
  _inc?: InputMaybe<IndicatorType_Inc_Input>;
  _set?: InputMaybe<IndicatorType_Set_Input>;
  where: IndicatorType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorTypeMappingArgs = {
  _inc?: InputMaybe<IndicatorTypeMapping_Inc_Input>;
  _set?: InputMaybe<IndicatorTypeMapping_Set_Input>;
  where: IndicatorTypeMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorTypeMapping_By_PkArgs = {
  _inc?: InputMaybe<IndicatorTypeMapping_Inc_Input>;
  _set?: InputMaybe<IndicatorTypeMapping_Set_Input>;
  pk_columns: IndicatorTypeMapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorTypeMapping_ManyArgs = {
  updates: Array<IndicatorTypeMapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorTypeMultiplierArgs = {
  _inc?: InputMaybe<IndicatorTypeMultiplier_Inc_Input>;
  _set?: InputMaybe<IndicatorTypeMultiplier_Set_Input>;
  where: IndicatorTypeMultiplier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorTypeMultiplier_By_PkArgs = {
  _inc?: InputMaybe<IndicatorTypeMultiplier_Inc_Input>;
  _set?: InputMaybe<IndicatorTypeMultiplier_Set_Input>;
  pk_columns: IndicatorTypeMultiplier_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorTypeMultiplier_ManyArgs = {
  updates: Array<IndicatorTypeMultiplier_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorType_By_PkArgs = {
  _inc?: InputMaybe<IndicatorType_Inc_Input>;
  _set?: InputMaybe<IndicatorType_Set_Input>;
  pk_columns: IndicatorType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorType_ManyArgs = {
  updates: Array<IndicatorType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_ValueArgs = {
  _inc?: InputMaybe<Installation_Standard_Value_Inc_Input>;
  _set?: InputMaybe<Installation_Standard_Value_Set_Input>;
  where: Installation_Standard_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Building_TypeArgs = {
  _inc?: InputMaybe<Installation_Standard_Value_Building_Type_Inc_Input>;
  _set?: InputMaybe<Installation_Standard_Value_Building_Type_Set_Input>;
  where: Installation_Standard_Value_Building_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Building_Type_By_PkArgs = {
  _inc?: InputMaybe<Installation_Standard_Value_Building_Type_Inc_Input>;
  _set?: InputMaybe<Installation_Standard_Value_Building_Type_Set_Input>;
  pk_columns: Installation_Standard_Value_Building_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Building_Type_ManyArgs = {
  updates: Array<Installation_Standard_Value_Building_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_By_PkArgs = {
  _inc?: InputMaybe<Installation_Standard_Value_Inc_Input>;
  _set?: InputMaybe<Installation_Standard_Value_Set_Input>;
  pk_columns: Installation_Standard_Value_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Classification_TypeArgs = {
  _inc?: InputMaybe<Installation_Standard_Value_Classification_Type_Inc_Input>;
  _set?: InputMaybe<Installation_Standard_Value_Classification_Type_Set_Input>;
  where: Installation_Standard_Value_Classification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Classification_Type_By_PkArgs = {
  _inc?: InputMaybe<Installation_Standard_Value_Classification_Type_Inc_Input>;
  _set?: InputMaybe<Installation_Standard_Value_Classification_Type_Set_Input>;
  pk_columns: Installation_Standard_Value_Classification_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Classification_Type_ManyArgs = {
  updates: Array<Installation_Standard_Value_Classification_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_DatasourceArgs = {
  _set?: InputMaybe<Installation_Standard_Value_Datasource_Set_Input>;
  where: Installation_Standard_Value_Datasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Datasource_By_PkArgs = {
  _set?: InputMaybe<Installation_Standard_Value_Datasource_Set_Input>;
  pk_columns: Installation_Standard_Value_Datasource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Datasource_ManyArgs = {
  updates: Array<Installation_Standard_Value_Datasource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_EmissionArgs = {
  _inc?: InputMaybe<Installation_Standard_Value_Emission_Inc_Input>;
  _set?: InputMaybe<Installation_Standard_Value_Emission_Set_Input>;
  where: Installation_Standard_Value_Emission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Emission_By_PkArgs = {
  _inc?: InputMaybe<Installation_Standard_Value_Emission_Inc_Input>;
  _set?: InputMaybe<Installation_Standard_Value_Emission_Set_Input>;
  pk_columns: Installation_Standard_Value_Emission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_Emission_ManyArgs = {
  updates: Array<Installation_Standard_Value_Emission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Installation_Standard_Value_ManyArgs = {
  updates: Array<Installation_Standard_Value_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LanguageArgs = {
  _set?: InputMaybe<Language_Set_Input>;
  where: Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Language_By_PkArgs = {
  _set?: InputMaybe<Language_Set_Input>;
  pk_columns: Language_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Language_ManyArgs = {
  updates: Array<Language_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lifetime_TableArgs = {
  _inc?: InputMaybe<Lifetime_Table_Inc_Input>;
  _set?: InputMaybe<Lifetime_Table_Set_Input>;
  where: Lifetime_Table_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lifetime_Table_By_PkArgs = {
  _inc?: InputMaybe<Lifetime_Table_Inc_Input>;
  _set?: InputMaybe<Lifetime_Table_Set_Input>;
  pk_columns: Lifetime_Table_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lifetime_Table_ManyArgs = {
  updates: Array<Lifetime_Table_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MappingHistoryArgs = {
  _inc?: InputMaybe<MappingHistory_Inc_Input>;
  _set?: InputMaybe<MappingHistory_Set_Input>;
  where: MappingHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MappingHistory_By_PkArgs = {
  _inc?: InputMaybe<MappingHistory_Inc_Input>;
  _set?: InputMaybe<MappingHistory_Set_Input>;
  pk_columns: MappingHistory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MappingHistory_ManyArgs = {
  updates: Array<MappingHistory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialArgs = {
  _inc?: InputMaybe<Material_Inc_Input>;
  _set?: InputMaybe<Material_Set_Input>;
  where: Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialBiogenicParamsArgs = {
  _inc?: InputMaybe<MaterialBiogenicParams_Inc_Input>;
  _set?: InputMaybe<MaterialBiogenicParams_Set_Input>;
  where: MaterialBiogenicParams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialBiogenicParams_By_PkArgs = {
  _inc?: InputMaybe<MaterialBiogenicParams_Inc_Input>;
  _set?: InputMaybe<MaterialBiogenicParams_Set_Input>;
  pk_columns: MaterialBiogenicParams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialBiogenicParams_ManyArgs = {
  updates: Array<MaterialBiogenicParams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialCategoryArgs = {
  _set?: InputMaybe<MaterialCategory_Set_Input>;
  where: MaterialCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialCategoryTextureArgs = {
  _set?: InputMaybe<MaterialCategoryTexture_Set_Input>;
  where: MaterialCategoryTexture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialCategoryTexture_By_PkArgs = {
  _set?: InputMaybe<MaterialCategoryTexture_Set_Input>;
  pk_columns: MaterialCategoryTexture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialCategoryTexture_ManyArgs = {
  updates: Array<MaterialCategoryTexture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialCategory_By_PkArgs = {
  _set?: InputMaybe<MaterialCategory_Set_Input>;
  pk_columns: MaterialCategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialCategory_ManyArgs = {
  updates: Array<MaterialCategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialDescriptionArgs = {
  _set?: InputMaybe<MaterialDescription_Set_Input>;
  where: MaterialDescription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialDescription_By_PkArgs = {
  _set?: InputMaybe<MaterialDescription_Set_Input>;
  pk_columns: MaterialDescription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialDescription_ManyArgs = {
  updates: Array<MaterialDescription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEmissionIndicatorArgs = {
  _inc?: InputMaybe<MaterialEmissionIndicator_Inc_Input>;
  _set?: InputMaybe<MaterialEmissionIndicator_Set_Input>;
  where: MaterialEmissionIndicator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEmissionIndicator_By_PkArgs = {
  _inc?: InputMaybe<MaterialEmissionIndicator_Inc_Input>;
  _set?: InputMaybe<MaterialEmissionIndicator_Set_Input>;
  pk_columns: MaterialEmissionIndicator_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEmissionIndicator_ManyArgs = {
  updates: Array<MaterialEmissionIndicator_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEpdArgs = {
  _inc?: InputMaybe<MaterialEpd_Inc_Input>;
  _set?: InputMaybe<MaterialEpd_Set_Input>;
  where: MaterialEpd_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEpdDatasourceArgs = {
  _set?: InputMaybe<MaterialEpdDatasource_Set_Input>;
  where: MaterialEpdDatasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEpdDatasource_By_PkArgs = {
  _set?: InputMaybe<MaterialEpdDatasource_Set_Input>;
  pk_columns: MaterialEpdDatasource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEpdDatasource_ManyArgs = {
  updates: Array<MaterialEpdDatasource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEpdUrlArgs = {
  _set?: InputMaybe<MaterialEpdUrl_Set_Input>;
  where: MaterialEpdUrl_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEpdUrl_By_PkArgs = {
  _set?: InputMaybe<MaterialEpdUrl_Set_Input>;
  pk_columns: MaterialEpdUrl_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEpdUrl_ManyArgs = {
  updates: Array<MaterialEpdUrl_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEpd_By_PkArgs = {
  _inc?: InputMaybe<MaterialEpd_Inc_Input>;
  _set?: InputMaybe<MaterialEpd_Set_Input>;
  pk_columns: MaterialEpd_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialEpd_ManyArgs = {
  updates: Array<MaterialEpd_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialForkArgs = {
  _set?: InputMaybe<MaterialFork_Set_Input>;
  where: MaterialFork_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialFork_By_PkArgs = {
  _set?: InputMaybe<MaterialFork_Set_Input>;
  pk_columns: MaterialFork_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialFork_ManyArgs = {
  updates: Array<MaterialFork_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialNameArgs = {
  _set?: InputMaybe<MaterialName_Set_Input>;
  where: MaterialName_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialName_By_PkArgs = {
  _set?: InputMaybe<MaterialName_Set_Input>;
  pk_columns: MaterialName_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialName_ManyArgs = {
  updates: Array<MaterialName_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialStageArgs = {
  _inc?: InputMaybe<MaterialStage_Inc_Input>;
  _set?: InputMaybe<MaterialStage_Set_Input>;
  where: MaterialStage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialStage_By_PkArgs = {
  _inc?: InputMaybe<MaterialStage_Inc_Input>;
  _set?: InputMaybe<MaterialStage_Set_Input>;
  pk_columns: MaterialStage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialStage_ManyArgs = {
  updates: Array<MaterialStage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialTypeArgs = {
  _set?: InputMaybe<MaterialType_Set_Input>;
  where: MaterialType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialType_By_PkArgs = {
  _set?: InputMaybe<MaterialType_Set_Input>;
  pk_columns: MaterialType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialType_ManyArgs = {
  updates: Array<MaterialType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialWasteSourceArgs = {
  _inc?: InputMaybe<MaterialWasteSource_Inc_Input>;
  _set?: InputMaybe<MaterialWasteSource_Set_Input>;
  where: MaterialWasteSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialWasteSource_By_PkArgs = {
  _inc?: InputMaybe<MaterialWasteSource_Inc_Input>;
  _set?: InputMaybe<MaterialWasteSource_Set_Input>;
  pk_columns: MaterialWasteSource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialWasteSource_ManyArgs = {
  updates: Array<MaterialWasteSource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialWasteTypeArgs = {
  _inc?: InputMaybe<MaterialWasteType_Inc_Input>;
  _set?: InputMaybe<MaterialWasteType_Set_Input>;
  where: MaterialWasteType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialWasteType_By_PkArgs = {
  _inc?: InputMaybe<MaterialWasteType_Inc_Input>;
  _set?: InputMaybe<MaterialWasteType_Set_Input>;
  pk_columns: MaterialWasteType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialWasteType_ManyArgs = {
  updates: Array<MaterialWasteType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Material_By_PkArgs = {
  _inc?: InputMaybe<Material_Inc_Input>;
  _set?: InputMaybe<Material_Set_Input>;
  pk_columns: Material_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Material_ManyArgs = {
  updates: Array<Material_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_McpConnectionArgs = {
  _append?: InputMaybe<McpConnection_Append_Input>;
  _delete_at_path?: InputMaybe<McpConnection_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<McpConnection_Delete_Elem_Input>;
  _delete_key?: InputMaybe<McpConnection_Delete_Key_Input>;
  _prepend?: InputMaybe<McpConnection_Prepend_Input>;
  _set?: InputMaybe<McpConnection_Set_Input>;
  where: McpConnection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_McpConnection_By_PkArgs = {
  _append?: InputMaybe<McpConnection_Append_Input>;
  _delete_at_path?: InputMaybe<McpConnection_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<McpConnection_Delete_Elem_Input>;
  _delete_key?: InputMaybe<McpConnection_Delete_Key_Input>;
  _prepend?: InputMaybe<McpConnection_Prepend_Input>;
  _set?: InputMaybe<McpConnection_Set_Input>;
  pk_columns: McpConnection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_McpConnection_ManyArgs = {
  updates: Array<McpConnection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_McpToolCallArgs = {
  _inc?: InputMaybe<McpToolCall_Inc_Input>;
  _set?: InputMaybe<McpToolCall_Set_Input>;
  where: McpToolCall_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_McpToolCall_By_PkArgs = {
  _inc?: InputMaybe<McpToolCall_Inc_Input>;
  _set?: InputMaybe<McpToolCall_Set_Input>;
  pk_columns: McpToolCall_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_McpToolCall_ManyArgs = {
  updates: Array<McpToolCall_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ModelArgs = {
  _set?: InputMaybe<Model_Set_Input>;
  where: Model_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_By_PkArgs = {
  _set?: InputMaybe<Model_Set_Input>;
  pk_columns: Model_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_ManyArgs = {
  updates: Array<Model_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectArgs = {
  _inc?: InputMaybe<Project_Inc_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectBuildingAreaArgs = {
  _inc?: InputMaybe<ProjectBuildingArea_Inc_Input>;
  _set?: InputMaybe<ProjectBuildingArea_Set_Input>;
  where: ProjectBuildingArea_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectBuildingArea_By_PkArgs = {
  _inc?: InputMaybe<ProjectBuildingArea_Inc_Input>;
  _set?: InputMaybe<ProjectBuildingArea_Set_Input>;
  pk_columns: ProjectBuildingArea_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectBuildingArea_ManyArgs = {
  updates: Array<ProjectBuildingArea_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectCalculationArgs = {
  _inc?: InputMaybe<ProjectCalculation_Inc_Input>;
  _set?: InputMaybe<ProjectCalculation_Set_Input>;
  where: ProjectCalculation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectCalculationStageArgs = {
  _inc?: InputMaybe<ProjectCalculationStage_Inc_Input>;
  _set?: InputMaybe<ProjectCalculationStage_Set_Input>;
  where: ProjectCalculationStage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectCalculationStage_By_PkArgs = {
  _inc?: InputMaybe<ProjectCalculationStage_Inc_Input>;
  _set?: InputMaybe<ProjectCalculationStage_Set_Input>;
  pk_columns: ProjectCalculationStage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectCalculationStage_ManyArgs = {
  updates: Array<ProjectCalculationStage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectCalculation_By_PkArgs = {
  _inc?: InputMaybe<ProjectCalculation_Inc_Input>;
  _set?: InputMaybe<ProjectCalculation_Set_Input>;
  pk_columns: ProjectCalculation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectCalculation_ManyArgs = {
  updates: Array<ProjectCalculation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectComponentMappingTypeArgs = {
  _set?: InputMaybe<ProjectComponentMappingType_Set_Input>;
  where: ProjectComponentMappingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectComponentMappingType_By_PkArgs = {
  _set?: InputMaybe<ProjectComponentMappingType_Set_Input>;
  pk_columns: ProjectComponentMappingType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectComponentMappingType_ManyArgs = {
  updates: Array<ProjectComponentMappingType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectDashboardStatusArgs = {
  _set?: InputMaybe<ProjectDashboardStatus_Set_Input>;
  where: ProjectDashboardStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectDashboardStatus_By_PkArgs = {
  _set?: InputMaybe<ProjectDashboardStatus_Set_Input>;
  pk_columns: ProjectDashboardStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectDashboardStatus_ManyArgs = {
  updates: Array<ProjectDashboardStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectEmissionFactorArgs = {
  _inc?: InputMaybe<ProjectEmissionFactor_Inc_Input>;
  _set?: InputMaybe<ProjectEmissionFactor_Set_Input>;
  where: ProjectEmissionFactor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectEmissionFactorCustomArgs = {
  _inc?: InputMaybe<ProjectEmissionFactorCustom_Inc_Input>;
  _set?: InputMaybe<ProjectEmissionFactorCustom_Set_Input>;
  where: ProjectEmissionFactorCustom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectEmissionFactorCustom_By_PkArgs = {
  _inc?: InputMaybe<ProjectEmissionFactorCustom_Inc_Input>;
  _set?: InputMaybe<ProjectEmissionFactorCustom_Set_Input>;
  pk_columns: ProjectEmissionFactorCustom_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectEmissionFactorCustom_ManyArgs = {
  updates: Array<ProjectEmissionFactorCustom_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectEmissionFactor_By_PkArgs = {
  _inc?: InputMaybe<ProjectEmissionFactor_Inc_Input>;
  _set?: InputMaybe<ProjectEmissionFactor_Set_Input>;
  pk_columns: ProjectEmissionFactor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectEmissionFactor_ManyArgs = {
  updates: Array<ProjectEmissionFactor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectInstallationArgs = {
  _set?: InputMaybe<ProjectInstallation_Set_Input>;
  where: ProjectInstallation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectInstallation_By_PkArgs = {
  _set?: InputMaybe<ProjectInstallation_Set_Input>;
  pk_columns: ProjectInstallation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectInstallation_ManyArgs = {
  updates: Array<ProjectInstallation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectLocationArgs = {
  _set?: InputMaybe<ProjectLocation_Set_Input>;
  where: ProjectLocation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectLocation_By_PkArgs = {
  _set?: InputMaybe<ProjectLocation_Set_Input>;
  pk_columns: ProjectLocation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectLocation_ManyArgs = {
  updates: Array<ProjectLocation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectMaterialClassificationFeedbackArgs = {
  _inc?: InputMaybe<ProjectMaterialClassificationFeedback_Inc_Input>;
  _set?: InputMaybe<ProjectMaterialClassificationFeedback_Set_Input>;
  where: ProjectMaterialClassificationFeedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectMaterialClassificationFeedback_By_PkArgs = {
  _inc?: InputMaybe<ProjectMaterialClassificationFeedback_Inc_Input>;
  _set?: InputMaybe<ProjectMaterialClassificationFeedback_Set_Input>;
  pk_columns: ProjectMaterialClassificationFeedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectMaterialClassificationFeedback_ManyArgs = {
  updates: Array<ProjectMaterialClassificationFeedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectMaterialClassificationParameterArgs = {
  _set?: InputMaybe<ProjectMaterialClassificationParameter_Set_Input>;
  where: ProjectMaterialClassificationParameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectMaterialClassificationParameter_By_PkArgs = {
  _set?: InputMaybe<ProjectMaterialClassificationParameter_Set_Input>;
  pk_columns: ProjectMaterialClassificationParameter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectMaterialClassificationParameter_ManyArgs = {
  updates: Array<ProjectMaterialClassificationParameter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectMembershipArgs = {
  _set?: InputMaybe<ProjectMembership_Set_Input>;
  where: ProjectMembership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectMembership_By_PkArgs = {
  _set?: InputMaybe<ProjectMembership_Set_Input>;
  pk_columns: ProjectMembership_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectMembership_ManyArgs = {
  updates: Array<ProjectMembership_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectModelArgs = {
  _set?: InputMaybe<ProjectModel_Set_Input>;
  where: ProjectModel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectModelSpecklePinArgs = {
  _set?: InputMaybe<ProjectModelSpecklePin_Set_Input>;
  where: ProjectModelSpecklePin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectModelSpecklePin_By_PkArgs = {
  _set?: InputMaybe<ProjectModelSpecklePin_Set_Input>;
  pk_columns: ProjectModelSpecklePin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectModelSpecklePin_ManyArgs = {
  updates: Array<ProjectModelSpecklePin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectModel_By_PkArgs = {
  _set?: InputMaybe<ProjectModel_Set_Input>;
  pk_columns: ProjectModel_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectModel_ManyArgs = {
  updates: Array<ProjectModel_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectOperationalArgs = {
  _set?: InputMaybe<ProjectOperational_Set_Input>;
  where: ProjectOperational_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectOperational_By_PkArgs = {
  _set?: InputMaybe<ProjectOperational_Set_Input>;
  pk_columns: ProjectOperational_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectOperational_ManyArgs = {
  updates: Array<ProjectOperational_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectReferenceAreaArgs = {
  _inc?: InputMaybe<ProjectReferenceArea_Inc_Input>;
  _set?: InputMaybe<ProjectReferenceArea_Set_Input>;
  where: ProjectReferenceArea_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectReferenceArea_By_PkArgs = {
  _inc?: InputMaybe<ProjectReferenceArea_Inc_Input>;
  _set?: InputMaybe<ProjectReferenceArea_Set_Input>;
  pk_columns: ProjectReferenceArea_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectReferenceArea_ManyArgs = {
  updates: Array<ProjectReferenceArea_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectRevisionArgs = {
  _inc?: InputMaybe<ProjectRevision_Inc_Input>;
  _set?: InputMaybe<ProjectRevision_Set_Input>;
  where: ProjectRevision_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectRevision_By_PkArgs = {
  _inc?: InputMaybe<ProjectRevision_Inc_Input>;
  _set?: InputMaybe<ProjectRevision_Set_Input>;
  pk_columns: ProjectRevision_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectRevision_ManyArgs = {
  updates: Array<ProjectRevision_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpecialConditionConfigArgs = {
  _set?: InputMaybe<ProjectSpecialConditionConfig_Set_Input>;
  where: ProjectSpecialConditionConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpecialConditionConfig_By_PkArgs = {
  _set?: InputMaybe<ProjectSpecialConditionConfig_Set_Input>;
  pk_columns: ProjectSpecialConditionConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpecialConditionConfig_ManyArgs = {
  updates: Array<ProjectSpecialConditionConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpecialConditionTypeMappingArgs = {
  _inc?: InputMaybe<ProjectSpecialConditionTypeMapping_Inc_Input>;
  _set?: InputMaybe<ProjectSpecialConditionTypeMapping_Set_Input>;
  where: ProjectSpecialConditionTypeMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpecialConditionTypeMapping_By_PkArgs = {
  _inc?: InputMaybe<ProjectSpecialConditionTypeMapping_Inc_Input>;
  _set?: InputMaybe<ProjectSpecialConditionTypeMapping_Set_Input>;
  pk_columns: ProjectSpecialConditionTypeMapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpecialConditionTypeMapping_ManyArgs = {
  updates: Array<ProjectSpecialConditionTypeMapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleCopyArgs = {
  _set?: InputMaybe<ProjectSpeckleCopy_Set_Input>;
  where: ProjectSpeckleCopy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleCopyRecentArgs = {
  _set?: InputMaybe<ProjectSpeckleCopyRecent_Set_Input>;
  where: ProjectSpeckleCopyRecent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleCopyRecent_ManyArgs = {
  updates: Array<ProjectSpeckleCopyRecent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleCopy_By_PkArgs = {
  _set?: InputMaybe<ProjectSpeckleCopy_Set_Input>;
  pk_columns: ProjectSpeckleCopy_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleCopy_ManyArgs = {
  updates: Array<ProjectSpeckleCopy_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleModelSyncArgs = {
  _inc?: InputMaybe<ProjectSpeckleModelSync_Inc_Input>;
  _set?: InputMaybe<ProjectSpeckleModelSync_Set_Input>;
  where: ProjectSpeckleModelSync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleModelSyncRecentArgs = {
  _inc?: InputMaybe<ProjectSpeckleModelSyncRecent_Inc_Input>;
  _set?: InputMaybe<ProjectSpeckleModelSyncRecent_Set_Input>;
  where: ProjectSpeckleModelSyncRecent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleModelSyncRecent_ManyArgs = {
  updates: Array<ProjectSpeckleModelSyncRecent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleModelSync_By_PkArgs = {
  _inc?: InputMaybe<ProjectSpeckleModelSync_Inc_Input>;
  _set?: InputMaybe<ProjectSpeckleModelSync_Set_Input>;
  pk_columns: ProjectSpeckleModelSync_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleModelSync_ManyArgs = {
  updates: Array<ProjectSpeckleModelSync_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleParameterConfigArgs = {
  _set?: InputMaybe<ProjectSpeckleParameterConfig_Set_Input>;
  where: ProjectSpeckleParameterConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleParameterConfig_By_PkArgs = {
  _set?: InputMaybe<ProjectSpeckleParameterConfig_Set_Input>;
  pk_columns: ProjectSpeckleParameterConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectSpeckleParameterConfig_ManyArgs = {
  updates: Array<ProjectSpeckleParameterConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectStandardValueStageArgs = {
  _set?: InputMaybe<ProjectStandardValueStage_Set_Input>;
  where: ProjectStandardValueStage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectStandardValueStage_By_PkArgs = {
  _set?: InputMaybe<ProjectStandardValueStage_Set_Input>;
  pk_columns: ProjectStandardValueStage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectStandardValueStage_ManyArgs = {
  updates: Array<ProjectStandardValueStage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectStatusArgs = {
  _inc?: InputMaybe<ProjectStatus_Inc_Input>;
  _set?: InputMaybe<ProjectStatus_Set_Input>;
  where: ProjectStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectStatus_By_PkArgs = {
  _inc?: InputMaybe<ProjectStatus_Inc_Input>;
  _set?: InputMaybe<ProjectStatus_Set_Input>;
  pk_columns: ProjectStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectStatus_ManyArgs = {
  updates: Array<ProjectStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectTransportMappingEmissionFactorArgs = {
  _set?: InputMaybe<ProjectTransportMappingEmissionFactor_Set_Input>;
  where: ProjectTransportMappingEmissionFactor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectTransportMappingEmissionFactor_By_PkArgs = {
  _set?: InputMaybe<ProjectTransportMappingEmissionFactor_Set_Input>;
  pk_columns: ProjectTransportMappingEmissionFactor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectTransportMappingEmissionFactor_ManyArgs = {
  updates: Array<ProjectTransportMappingEmissionFactor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectVersionArgs = {
  _append?: InputMaybe<ProjectVersion_Append_Input>;
  _delete_at_path?: InputMaybe<ProjectVersion_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ProjectVersion_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ProjectVersion_Delete_Key_Input>;
  _inc?: InputMaybe<ProjectVersion_Inc_Input>;
  _prepend?: InputMaybe<ProjectVersion_Prepend_Input>;
  _set?: InputMaybe<ProjectVersion_Set_Input>;
  where: ProjectVersion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectVersionNumberedArgs = {
  _append?: InputMaybe<ProjectVersionNumbered_Append_Input>;
  _delete_at_path?: InputMaybe<ProjectVersionNumbered_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ProjectVersionNumbered_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ProjectVersionNumbered_Delete_Key_Input>;
  _inc?: InputMaybe<ProjectVersionNumbered_Inc_Input>;
  _prepend?: InputMaybe<ProjectVersionNumbered_Prepend_Input>;
  _set?: InputMaybe<ProjectVersionNumbered_Set_Input>;
  where: ProjectVersionNumbered_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectVersionNumbered_ManyArgs = {
  updates: Array<ProjectVersionNumbered_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectVersion_By_PkArgs = {
  _append?: InputMaybe<ProjectVersion_Append_Input>;
  _delete_at_path?: InputMaybe<ProjectVersion_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ProjectVersion_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ProjectVersion_Delete_Key_Input>;
  _inc?: InputMaybe<ProjectVersion_Inc_Input>;
  _prepend?: InputMaybe<ProjectVersion_Prepend_Input>;
  _set?: InputMaybe<ProjectVersion_Set_Input>;
  pk_columns: ProjectVersion_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectVersion_ManyArgs = {
  updates: Array<ProjectVersion_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectWasteMappingArgs = {
  _inc?: InputMaybe<ProjectWasteMapping_Inc_Input>;
  _set?: InputMaybe<ProjectWasteMapping_Set_Input>;
  where: ProjectWasteMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectWasteMapping_By_PkArgs = {
  _inc?: InputMaybe<ProjectWasteMapping_Inc_Input>;
  _set?: InputMaybe<ProjectWasteMapping_Set_Input>;
  pk_columns: ProjectWasteMapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectWasteMapping_ManyArgs = {
  updates: Array<ProjectWasteMapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectWasteTypeCustomArgs = {
  _set?: InputMaybe<ProjectWasteTypeCustom_Set_Input>;
  where: ProjectWasteTypeCustom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectWasteTypeCustom_By_PkArgs = {
  _set?: InputMaybe<ProjectWasteTypeCustom_Set_Input>;
  pk_columns: ProjectWasteTypeCustom_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectWasteTypeCustom_ManyArgs = {
  updates: Array<ProjectWasteTypeCustom_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_By_PkArgs = {
  _inc?: InputMaybe<Project_Inc_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  pk_columns: Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ManyArgs = {
  updates: Array<Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_TransportArgs = {
  _inc?: InputMaybe<Project_Transport_Inc_Input>;
  _set?: InputMaybe<Project_Transport_Set_Input>;
  where: Project_Transport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Transport_By_PkArgs = {
  _inc?: InputMaybe<Project_Transport_Inc_Input>;
  _set?: InputMaybe<Project_Transport_Set_Input>;
  pk_columns: Project_Transport_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Transport_DefaultArgs = {
  _set?: InputMaybe<Project_Transport_Default_Set_Input>;
  where: Project_Transport_Default_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Transport_Default_By_PkArgs = {
  _set?: InputMaybe<Project_Transport_Default_Set_Input>;
  pk_columns: Project_Transport_Default_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Transport_Default_ManyArgs = {
  updates: Array<Project_Transport_Default_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Transport_ManyArgs = {
  updates: Array<Project_Transport_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Transport_MappingArgs = {
  _inc?: InputMaybe<Project_Transport_Mapping_Inc_Input>;
  _set?: InputMaybe<Project_Transport_Mapping_Set_Input>;
  where: Project_Transport_Mapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Transport_Mapping_By_PkArgs = {
  _inc?: InputMaybe<Project_Transport_Mapping_Inc_Input>;
  _set?: InputMaybe<Project_Transport_Mapping_Set_Input>;
  pk_columns: Project_Transport_Mapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Transport_Mapping_ManyArgs = {
  updates: Array<Project_Transport_Mapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReferenceAreaTypeArgs = {
  _inc?: InputMaybe<ReferenceAreaType_Inc_Input>;
  _set?: InputMaybe<ReferenceAreaType_Set_Input>;
  where: ReferenceAreaType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ReferenceAreaTypeCalculationTypeMappingArgs = {
  _inc?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Inc_Input>;
  _set?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Set_Input>;
  where: ReferenceAreaTypeCalculationTypeMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ReferenceAreaTypeCalculationTypeMapping_By_PkArgs = {
  _inc?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Inc_Input>;
  _set?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Set_Input>;
  pk_columns: ReferenceAreaTypeCalculationTypeMapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReferenceAreaTypeCalculationTypeMapping_ManyArgs = {
  updates: Array<ReferenceAreaTypeCalculationTypeMapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReferenceAreaType_By_PkArgs = {
  _inc?: InputMaybe<ReferenceAreaType_Inc_Input>;
  _set?: InputMaybe<ReferenceAreaType_Set_Input>;
  pk_columns: ReferenceAreaType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReferenceAreaType_ManyArgs = {
  updates: Array<ReferenceAreaType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportBuildingTypeMappingArgs = {
  _inc?: InputMaybe<ReportBuildingTypeMapping_Inc_Input>;
  _set?: InputMaybe<ReportBuildingTypeMapping_Set_Input>;
  where: ReportBuildingTypeMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ReportBuildingTypeMapping_By_PkArgs = {
  _inc?: InputMaybe<ReportBuildingTypeMapping_Inc_Input>;
  _set?: InputMaybe<ReportBuildingTypeMapping_Set_Input>;
  pk_columns: ReportBuildingTypeMapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReportBuildingTypeMapping_ManyArgs = {
  updates: Array<ReportBuildingTypeMapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportClassificationCodeEmissionMappingArgs = {
  _inc?: InputMaybe<ReportClassificationCodeEmissionMapping_Inc_Input>;
  _set?: InputMaybe<ReportClassificationCodeEmissionMapping_Set_Input>;
  where: ReportClassificationCodeEmissionMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ReportClassificationCodeEmissionMapping_By_PkArgs = {
  _inc?: InputMaybe<ReportClassificationCodeEmissionMapping_Inc_Input>;
  _set?: InputMaybe<ReportClassificationCodeEmissionMapping_Set_Input>;
  pk_columns: ReportClassificationCodeEmissionMapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReportClassificationCodeEmissionMapping_ManyArgs = {
  updates: Array<ReportClassificationCodeEmissionMapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportLoadBearingElementAmountMappingArgs = {
  _inc?: InputMaybe<ReportLoadBearingElementAmountMapping_Inc_Input>;
  _set?: InputMaybe<ReportLoadBearingElementAmountMapping_Set_Input>;
  where: ReportLoadBearingElementAmountMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ReportLoadBearingElementAmountMapping_By_PkArgs = {
  _inc?: InputMaybe<ReportLoadBearingElementAmountMapping_Inc_Input>;
  _set?: InputMaybe<ReportLoadBearingElementAmountMapping_Set_Input>;
  pk_columns: ReportLoadBearingElementAmountMapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReportLoadBearingElementAmountMapping_ManyArgs = {
  updates: Array<ReportLoadBearingElementAmountMapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportLoadBearingElementEmissionMappingArgs = {
  _inc?: InputMaybe<ReportLoadBearingElementEmissionMapping_Inc_Input>;
  _set?: InputMaybe<ReportLoadBearingElementEmissionMapping_Set_Input>;
  where: ReportLoadBearingElementEmissionMapping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ReportLoadBearingElementEmissionMapping_By_PkArgs = {
  _inc?: InputMaybe<ReportLoadBearingElementEmissionMapping_Inc_Input>;
  _set?: InputMaybe<ReportLoadBearingElementEmissionMapping_Set_Input>;
  pk_columns: ReportLoadBearingElementEmissionMapping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReportLoadBearingElementEmissionMapping_ManyArgs = {
  updates: Array<ReportLoadBearingElementEmissionMapping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportStructureArgs = {
  _inc?: InputMaybe<ReportStructure_Inc_Input>;
  _set?: InputMaybe<ReportStructure_Set_Input>;
  where: ReportStructure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ReportStructureCalculationTypesArgs = {
  _inc?: InputMaybe<ReportStructureCalculationTypes_Inc_Input>;
  _set?: InputMaybe<ReportStructureCalculationTypes_Set_Input>;
  where: ReportStructureCalculationTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ReportStructureCalculationTypes_By_PkArgs = {
  _inc?: InputMaybe<ReportStructureCalculationTypes_Inc_Input>;
  _set?: InputMaybe<ReportStructureCalculationTypes_Set_Input>;
  pk_columns: ReportStructureCalculationTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReportStructureCalculationTypes_ManyArgs = {
  updates: Array<ReportStructureCalculationTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportStructureClassificationCodesArgs = {
  _inc?: InputMaybe<ReportStructureClassificationCodes_Inc_Input>;
  _set?: InputMaybe<ReportStructureClassificationCodes_Set_Input>;
  where: ReportStructureClassificationCodes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ReportStructureClassificationCodes_By_PkArgs = {
  _inc?: InputMaybe<ReportStructureClassificationCodes_Inc_Input>;
  _set?: InputMaybe<ReportStructureClassificationCodes_Set_Input>;
  pk_columns: ReportStructureClassificationCodes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReportStructureClassificationCodes_ManyArgs = {
  updates: Array<ReportStructureClassificationCodes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportStructure_By_PkArgs = {
  _inc?: InputMaybe<ReportStructure_Inc_Input>;
  _set?: InputMaybe<ReportStructure_Set_Input>;
  pk_columns: ReportStructure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReportStructure_ManyArgs = {
  updates: Array<ReportStructure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportfilesmetadataArgs = {
  _inc?: InputMaybe<Reportfilesmetadata_Inc_Input>;
  _set?: InputMaybe<Reportfilesmetadata_Set_Input>;
  where: Reportfilesmetadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reportfilesmetadata_By_PkArgs = {
  _inc?: InputMaybe<Reportfilesmetadata_Inc_Input>;
  _set?: InputMaybe<Reportfilesmetadata_Set_Input>;
  pk_columns: Reportfilesmetadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reportfilesmetadata_ManyArgs = {
  updates: Array<Reportfilesmetadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _inc?: InputMaybe<Roles_Inc_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _inc?: InputMaybe<Roles_Inc_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgs = {
  updates: Array<Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialConditionTypeArgs = {
  _inc?: InputMaybe<SpecialConditionType_Inc_Input>;
  _set?: InputMaybe<SpecialConditionType_Set_Input>;
  where: SpecialConditionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialConditionTypeCalculationTypeArgs = {
  _inc?: InputMaybe<SpecialConditionTypeCalculationType_Inc_Input>;
  _set?: InputMaybe<SpecialConditionTypeCalculationType_Set_Input>;
  where: SpecialConditionTypeCalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialConditionTypeCalculationType_By_PkArgs = {
  _inc?: InputMaybe<SpecialConditionTypeCalculationType_Inc_Input>;
  _set?: InputMaybe<SpecialConditionTypeCalculationType_Set_Input>;
  pk_columns: SpecialConditionTypeCalculationType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialConditionTypeCalculationType_ManyArgs = {
  updates: Array<SpecialConditionTypeCalculationType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialConditionTypeInputParameterArgs = {
  _set?: InputMaybe<SpecialConditionTypeInputParameter_Set_Input>;
  where: SpecialConditionTypeInputParameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialConditionTypeInputParameter_By_PkArgs = {
  _set?: InputMaybe<SpecialConditionTypeInputParameter_Set_Input>;
  pk_columns: SpecialConditionTypeInputParameter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialConditionTypeInputParameter_ManyArgs = {
  updates: Array<SpecialConditionTypeInputParameter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialConditionType_By_PkArgs = {
  _inc?: InputMaybe<SpecialConditionType_Inc_Input>;
  _set?: InputMaybe<SpecialConditionType_Set_Input>;
  pk_columns: SpecialConditionType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialConditionType_ManyArgs = {
  updates: Array<SpecialConditionType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Special_Condition_Type_CategoryArgs = {
  _set?: InputMaybe<Special_Condition_Type_Category_Set_Input>;
  where: Special_Condition_Type_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Special_Condition_Type_Category_By_PkArgs = {
  _set?: InputMaybe<Special_Condition_Type_Category_Set_Input>;
  pk_columns: Special_Condition_Type_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Special_Condition_Type_Category_ManyArgs = {
  updates: Array<Special_Condition_Type_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpeckleStreamModelIfcUploadArgs = {
  _set?: InputMaybe<SpeckleStreamModelIfcUpload_Set_Input>;
  where: SpeckleStreamModelIfcUpload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpeckleStreamModelIfcUploadRecentArgs = {
  _set?: InputMaybe<SpeckleStreamModelIfcUploadRecent_Set_Input>;
  where: SpeckleStreamModelIfcUploadRecent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpeckleStreamModelIfcUploadRecent_ManyArgs = {
  updates: Array<SpeckleStreamModelIfcUploadRecent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpeckleStreamModelIfcUpload_By_PkArgs = {
  _set?: InputMaybe<SpeckleStreamModelIfcUpload_Set_Input>;
  pk_columns: SpeckleStreamModelIfcUpload_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SpeckleStreamModelIfcUpload_ManyArgs = {
  updates: Array<SpeckleStreamModelIfcUpload_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpeckleUserDataArgs = {
  _set?: InputMaybe<SpeckleUserData_Set_Input>;
  where: SpeckleUserData_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SpeckleUserData_By_PkArgs = {
  _set?: InputMaybe<SpeckleUserData_Set_Input>;
  pk_columns: SpeckleUserData_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SpeckleUserData_ManyArgs = {
  updates: Array<SpeckleUserData_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Speckle_StreamArgs = {
  _set?: InputMaybe<Speckle_Stream_Set_Input>;
  where: Speckle_Stream_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Speckle_Stream_By_PkArgs = {
  _set?: InputMaybe<Speckle_Stream_Set_Input>;
  pk_columns: Speckle_Stream_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Speckle_Stream_ManyArgs = {
  updates: Array<Speckle_Stream_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StageArgs = {
  _inc?: InputMaybe<Stage_Inc_Input>;
  _set?: InputMaybe<Stage_Set_Input>;
  where: Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StageDefaultEmissionArgs = {
  _inc?: InputMaybe<StageDefaultEmission_Inc_Input>;
  _set?: InputMaybe<StageDefaultEmission_Set_Input>;
  where: StageDefaultEmission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StageDefaultEmission_By_PkArgs = {
  _inc?: InputMaybe<StageDefaultEmission_Inc_Input>;
  _set?: InputMaybe<StageDefaultEmission_Set_Input>;
  pk_columns: StageDefaultEmission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StageDefaultEmission_ManyArgs = {
  updates: Array<StageDefaultEmission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_By_PkArgs = {
  _inc?: InputMaybe<Stage_Inc_Input>;
  _set?: InputMaybe<Stage_Set_Input>;
  pk_columns: Stage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_Default_Emission_Building_TypeArgs = {
  _inc?: InputMaybe<Stage_Default_Emission_Building_Type_Inc_Input>;
  _set?: InputMaybe<Stage_Default_Emission_Building_Type_Set_Input>;
  where: Stage_Default_Emission_Building_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_Default_Emission_Building_Type_By_PkArgs = {
  _inc?: InputMaybe<Stage_Default_Emission_Building_Type_Inc_Input>;
  _set?: InputMaybe<Stage_Default_Emission_Building_Type_Set_Input>;
  pk_columns: Stage_Default_Emission_Building_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_Default_Emission_Building_Type_ManyArgs = {
  updates: Array<Stage_Default_Emission_Building_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_ManyArgs = {
  updates: Array<Stage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantAiBudgetArgs = {
  _inc?: InputMaybe<TenantAiBudget_Inc_Input>;
  _set?: InputMaybe<TenantAiBudget_Set_Input>;
  where: TenantAiBudget_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TenantAiBudget_By_PkArgs = {
  _inc?: InputMaybe<TenantAiBudget_Inc_Input>;
  _set?: InputMaybe<TenantAiBudget_Set_Input>;
  pk_columns: TenantAiBudget_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TenantAiBudget_ManyArgs = {
  updates: Array<TenantAiBudget_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantAiCreditPurchaseArgs = {
  _inc?: InputMaybe<TenantAiCreditPurchase_Inc_Input>;
  _set?: InputMaybe<TenantAiCreditPurchase_Set_Input>;
  where: TenantAiCreditPurchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TenantAiCreditPurchase_By_PkArgs = {
  _inc?: InputMaybe<TenantAiCreditPurchase_Inc_Input>;
  _set?: InputMaybe<TenantAiCreditPurchase_Set_Input>;
  pk_columns: TenantAiCreditPurchase_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TenantAiCreditPurchase_ManyArgs = {
  updates: Array<TenantAiCreditPurchase_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantAiPaymentArgs = {
  _append?: InputMaybe<TenantAiPayment_Append_Input>;
  _delete_at_path?: InputMaybe<TenantAiPayment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<TenantAiPayment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<TenantAiPayment_Delete_Key_Input>;
  _inc?: InputMaybe<TenantAiPayment_Inc_Input>;
  _prepend?: InputMaybe<TenantAiPayment_Prepend_Input>;
  _set?: InputMaybe<TenantAiPayment_Set_Input>;
  where: TenantAiPayment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TenantAiPayment_By_PkArgs = {
  _append?: InputMaybe<TenantAiPayment_Append_Input>;
  _delete_at_path?: InputMaybe<TenantAiPayment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<TenantAiPayment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<TenantAiPayment_Delete_Key_Input>;
  _inc?: InputMaybe<TenantAiPayment_Inc_Input>;
  _prepend?: InputMaybe<TenantAiPayment_Prepend_Input>;
  _set?: InputMaybe<TenantAiPayment_Set_Input>;
  pk_columns: TenantAiPayment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TenantAiPayment_ManyArgs = {
  updates: Array<TenantAiPayment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantCollectionArgs = {
  _set?: InputMaybe<TenantCollection_Set_Input>;
  where: TenantCollection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TenantCollectionItemArgs = {
  _set?: InputMaybe<TenantCollectionItem_Set_Input>;
  where: TenantCollectionItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TenantCollectionItem_By_PkArgs = {
  _set?: InputMaybe<TenantCollectionItem_Set_Input>;
  pk_columns: TenantCollectionItem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TenantCollectionItem_ManyArgs = {
  updates: Array<TenantCollectionItem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantCollection_By_PkArgs = {
  _set?: InputMaybe<TenantCollection_Set_Input>;
  pk_columns: TenantCollection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TenantCollection_ManyArgs = {
  updates: Array<TenantCollection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantInvoiceArgs = {
  _inc?: InputMaybe<TenantInvoice_Inc_Input>;
  _set?: InputMaybe<TenantInvoice_Set_Input>;
  where: TenantInvoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TenantInvoice_By_PkArgs = {
  _inc?: InputMaybe<TenantInvoice_Inc_Input>;
  _set?: InputMaybe<TenantInvoice_Set_Input>;
  pk_columns: TenantInvoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TenantInvoice_ManyArgs = {
  updates: Array<TenantInvoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantUserRequestAiUsageArgs = {
  _inc?: InputMaybe<TenantUserRequestAiUsage_Inc_Input>;
  _set?: InputMaybe<TenantUserRequestAiUsage_Set_Input>;
  where: TenantUserRequestAiUsage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TenantUserRequestAiUsage_By_PkArgs = {
  _inc?: InputMaybe<TenantUserRequestAiUsage_Inc_Input>;
  _set?: InputMaybe<TenantUserRequestAiUsage_Set_Input>;
  pk_columns: TenantUserRequestAiUsage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TenantUserRequestAiUsage_ManyArgs = {
  updates: Array<TenantUserRequestAiUsage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TranslationCategoryArgs = {
  _set?: InputMaybe<TranslationCategory_Set_Input>;
  where: TranslationCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TranslationCategory_By_PkArgs = {
  _set?: InputMaybe<TranslationCategory_Set_Input>;
  pk_columns: TranslationCategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TranslationCategory_ManyArgs = {
  updates: Array<TranslationCategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TranslationSourceArgs = {
  _set?: InputMaybe<TranslationSource_Set_Input>;
  where: TranslationSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TranslationSource_By_PkArgs = {
  _set?: InputMaybe<TranslationSource_Set_Input>;
  pk_columns: TranslationSource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TranslationSource_ManyArgs = {
  updates: Array<TranslationSource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TransportArgs = {
  _inc?: InputMaybe<Transport_Inc_Input>;
  _set?: InputMaybe<Transport_Set_Input>;
  where: Transport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TransportEmissionFactorArgs = {
  _inc?: InputMaybe<TransportEmissionFactor_Inc_Input>;
  _set?: InputMaybe<TransportEmissionFactor_Set_Input>;
  where: TransportEmissionFactor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TransportEmissionFactor_By_PkArgs = {
  _inc?: InputMaybe<TransportEmissionFactor_Inc_Input>;
  _set?: InputMaybe<TransportEmissionFactor_Set_Input>;
  pk_columns: TransportEmissionFactor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TransportEmissionFactor_ManyArgs = {
  updates: Array<TransportEmissionFactor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TransportSourceArgs = {
  _set?: InputMaybe<TransportSource_Set_Input>;
  where: TransportSource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TransportSourceCalculationTypeArgs = {
  _inc?: InputMaybe<TransportSourceCalculationType_Inc_Input>;
  _set?: InputMaybe<TransportSourceCalculationType_Set_Input>;
  where: TransportSourceCalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TransportSourceCalculationType_By_PkArgs = {
  _inc?: InputMaybe<TransportSourceCalculationType_Inc_Input>;
  _set?: InputMaybe<TransportSourceCalculationType_Set_Input>;
  pk_columns: TransportSourceCalculationType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TransportSourceCalculationType_ManyArgs = {
  updates: Array<TransportSourceCalculationType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TransportSource_By_PkArgs = {
  _set?: InputMaybe<TransportSource_Set_Input>;
  pk_columns: TransportSource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TransportSource_ManyArgs = {
  updates: Array<TransportSource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transport_By_PkArgs = {
  _inc?: InputMaybe<Transport_Inc_Input>;
  _set?: InputMaybe<Transport_Set_Input>;
  pk_columns: Transport_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transport_ManyArgs = {
  updates: Array<Transport_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transport_Standard_ValueArgs = {
  _inc?: InputMaybe<Transport_Standard_Value_Inc_Input>;
  _set?: InputMaybe<Transport_Standard_Value_Set_Input>;
  where: Transport_Standard_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transport_Standard_Value_By_PkArgs = {
  _inc?: InputMaybe<Transport_Standard_Value_Inc_Input>;
  _set?: InputMaybe<Transport_Standard_Value_Set_Input>;
  pk_columns: Transport_Standard_Value_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transport_Standard_Value_ManyArgs = {
  updates: Array<Transport_Standard_Value_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transport_TypeArgs = {
  _set?: InputMaybe<Transport_Type_Set_Input>;
  where: Transport_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transport_Type_By_PkArgs = {
  _set?: InputMaybe<Transport_Type_Set_Input>;
  pk_columns: Transport_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transport_Type_ManyArgs = {
  updates: Array<Transport_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UnitArgs = {
  _inc?: InputMaybe<Unit_Inc_Input>;
  _set?: InputMaybe<Unit_Set_Input>;
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_By_PkArgs = {
  _inc?: InputMaybe<Unit_Inc_Input>;
  _set?: InputMaybe<Unit_Set_Input>;
  pk_columns: Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_ManyArgs = {
  updates: Array<Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserMaterialFavoriteArgs = {
  _set?: InputMaybe<UserMaterialFavorite_Set_Input>;
  where: UserMaterialFavorite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserMaterialFavorite_By_PkArgs = {
  _set?: InputMaybe<UserMaterialFavorite_Set_Input>;
  pk_columns: UserMaterialFavorite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserMaterialFavorite_ManyArgs = {
  updates: Array<UserMaterialFavorite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserPlatformReviewArgs = {
  _inc?: InputMaybe<UserPlatformReview_Inc_Input>;
  _set?: InputMaybe<UserPlatformReview_Set_Input>;
  where: UserPlatformReview_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserPlatformReview_By_PkArgs = {
  _inc?: InputMaybe<UserPlatformReview_Inc_Input>;
  _set?: InputMaybe<UserPlatformReview_Set_Input>;
  pk_columns: UserPlatformReview_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserPlatformReview_ManyArgs = {
  updates: Array<UserPlatformReview_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserProjectViewArgs = {
  _set?: InputMaybe<UserProjectView_Set_Input>;
  where: UserProjectView_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserProjectView_By_PkArgs = {
  _set?: InputMaybe<UserProjectView_Set_Input>;
  pk_columns: UserProjectView_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserProjectView_ManyArgs = {
  updates: Array<UserProjectView_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserTutorialViewArgs = {
  _set?: InputMaybe<UserTutorialView_Set_Input>;
  where: UserTutorialView_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserTutorialView_By_PkArgs = {
  _set?: InputMaybe<UserTutorialView_Set_Input>;
  pk_columns: UserTutorialView_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserTutorialView_ManyArgs = {
  updates: Array<UserTutorialView_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserWelcomeFlowArgs = {
  _set?: InputMaybe<UserWelcomeFlow_Set_Input>;
  where: UserWelcomeFlow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserWelcomeFlowEventArgs = {
  _inc?: InputMaybe<UserWelcomeFlowEvent_Inc_Input>;
  _set?: InputMaybe<UserWelcomeFlowEvent_Set_Input>;
  where: UserWelcomeFlowEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserWelcomeFlowEvent_By_PkArgs = {
  _inc?: InputMaybe<UserWelcomeFlowEvent_Inc_Input>;
  _set?: InputMaybe<UserWelcomeFlowEvent_Set_Input>;
  pk_columns: UserWelcomeFlowEvent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserWelcomeFlowEvent_ManyArgs = {
  updates: Array<UserWelcomeFlowEvent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserWelcomeFlow_By_PkArgs = {
  _set?: InputMaybe<UserWelcomeFlow_Set_Input>;
  pk_columns: UserWelcomeFlow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserWelcomeFlow_ManyArgs = {
  updates: Array<UserWelcomeFlow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VMaterialGwpArgs = {
  _inc?: InputMaybe<VMaterialGwp_Inc_Input>;
  _set?: InputMaybe<VMaterialGwp_Set_Input>;
  where: VMaterialGwp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VMaterialGwp_ManyArgs = {
  updates: Array<VMaterialGwp_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VMaterialStatusArgs = {
  _inc?: InputMaybe<VMaterialStatus_Inc_Input>;
  _set?: InputMaybe<VMaterialStatus_Set_Input>;
  where: VMaterialStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VMaterialStatus_ManyArgs = {
  updates: Array<VMaterialStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WeightPerDeclaredUnitArgs = {
  _inc?: InputMaybe<WeightPerDeclaredUnit_Inc_Input>;
  _set?: InputMaybe<WeightPerDeclaredUnit_Set_Input>;
  where: WeightPerDeclaredUnit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_WeightPerDeclaredUnit_By_PkArgs = {
  _inc?: InputMaybe<WeightPerDeclaredUnit_Inc_Input>;
  _set?: InputMaybe<WeightPerDeclaredUnit_Set_Input>;
  pk_columns: WeightPerDeclaredUnit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_WeightPerDeclaredUnit_ManyArgs = {
  updates: Array<WeightPerDeclaredUnit_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  asc = 'asc',
  /** in ascending order, nulls first */
  asc_nulls_first = 'asc_nulls_first',
  /** in ascending order, nulls last */
  asc_nulls_last = 'asc_nulls_last',
  /** in descending order, nulls first */
  desc = 'desc',
  /** in descending order, nulls first */
  desc_nulls_first = 'desc_nulls_first',
  /** in descending order, nulls last */
  desc_nulls_last = 'desc_nulls_last'
}

/** columns and relationships of "project" */
export type Project = {
  __typename?: 'project';
  /** An object relationship */
  activeRevision: ProjectRevision;
  activeRevisionId: Scalars['uuid']['output'];
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  builderName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  buildingAreas: Array<ProjectBuildingArea>;
  /** An aggregate relationship */
  buildingAreas_aggregate: ProjectBuildingArea_Aggregate;
  /** An object relationship */
  buildingType: BuildingType;
  buildingTypeId: Scalars['Int']['output'];
  /** An object relationship */
  calculation?: Maybe<ProjectCalculation>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedBy?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "project_is_favorite" */
  favorite?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  installation?: Maybe<ProjectInstallation>;
  lcaResponsibleName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  location?: Maybe<ProjectLocation>;
  /** An array relationship */
  memberships: Array<ProjectMembership>;
  /** An aggregate relationship */
  memberships_aggregate: ProjectMembership_Aggregate;
  /** An array relationship */
  models: Array<ProjectModel>;
  /** An aggregate relationship */
  models_aggregate: ProjectModel_Aggregate;
  name: Scalars['String']['output'];
  numberOfPeople?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  operational?: Maybe<ProjectOperational>;
  projectNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  projectStatus?: Maybe<ProjectStatus>;
  projectStatusId?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  referenceAreas: Array<ProjectReferenceArea>;
  /** An aggregate relationship */
  referenceAreas_aggregate: ProjectReferenceArea_Aggregate;
  /** An array relationship */
  revisions: Array<ProjectRevision>;
  /** An aggregate relationship */
  revisions_aggregate: ProjectRevision_Aggregate;
  /** A computed field, executes function "project_membership_role" */
  role?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sourceProject?: Maybe<Project>;
  sourceProjectId?: Maybe<Scalars['uuid']['output']>;
  sourceVersionId?: Maybe<Scalars['uuid']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  specialConditionConfig?: Maybe<ProjectSpecialConditionConfig>;
  /** An array relationship */
  specialConditionTypeMappings: Array<ProjectSpecialConditionTypeMapping>;
  /** An aggregate relationship */
  specialConditionTypeMappings_aggregate: ProjectSpecialConditionTypeMapping_Aggregate;
  /** An object relationship */
  speckleStream?: Maybe<Speckle_Stream>;
  speckleStreamId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  versions: Array<ProjectVersion>;
  /** An aggregate relationship */
  versions_aggregate: ProjectVersion_Aggregate;
  yearOfCommissioning: Scalars['Int']['output'];
  yearOfConstruction: Scalars['Int']['output'];
};


/** columns and relationships of "project" */
export type ProjectBuildingAreasArgs = {
  distinct_on?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectBuildingArea_Order_By>>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectBuildingAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectBuildingArea_Order_By>>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectMembershipsArgs = {
  distinct_on?: InputMaybe<Array<ProjectMembership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMembership_Order_By>>;
  where?: InputMaybe<ProjectMembership_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectMembership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMembership_Order_By>>;
  where?: InputMaybe<ProjectMembership_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectModelsArgs = {
  distinct_on?: InputMaybe<Array<ProjectModel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModel_Order_By>>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectModels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectModel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModel_Order_By>>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectReferenceAreasArgs = {
  distinct_on?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectReferenceArea_Order_By>>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectReferenceAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectReferenceArea_Order_By>>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectRevisionsArgs = {
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectRevisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectSpecialConditionTypeMappingsArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectSpecialConditionTypeMappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectVersionsArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersion_Order_By>>;
  where?: InputMaybe<ProjectVersion_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersion_Order_By>>;
  where?: InputMaybe<ProjectVersion_Bool_Exp>;
};

/** columns and relationships of "project_building_area" */
export type ProjectBuildingArea = {
  __typename?: 'projectBuildingArea';
  area: Scalars['numeric']['output'];
  buildingAreaType: BuildingAreaType_Enum;
  /** An object relationship */
  buildingType: BuildingType;
  buildingTypeId: Scalars['Int']['output'];
  createdAt: Scalars['timestamptz']['output'];
  floors: Scalars['Int']['output'];
  heatedArea: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_building_area" */
export type ProjectBuildingArea_Aggregate = {
  __typename?: 'projectBuildingArea_aggregate';
  aggregate?: Maybe<ProjectBuildingArea_Aggregate_Fields>;
  nodes: Array<ProjectBuildingArea>;
};

export type ProjectBuildingArea_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectBuildingArea_Aggregate_Bool_Exp_Count>;
};

export type ProjectBuildingArea_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_building_area" */
export type ProjectBuildingArea_Aggregate_Fields = {
  __typename?: 'projectBuildingArea_aggregate_fields';
  avg?: Maybe<ProjectBuildingArea_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectBuildingArea_Max_Fields>;
  min?: Maybe<ProjectBuildingArea_Min_Fields>;
  stddev?: Maybe<ProjectBuildingArea_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectBuildingArea_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectBuildingArea_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectBuildingArea_Sum_Fields>;
  var_pop?: Maybe<ProjectBuildingArea_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectBuildingArea_Var_Samp_Fields>;
  variance?: Maybe<ProjectBuildingArea_Variance_Fields>;
};


/** aggregate fields of "project_building_area" */
export type ProjectBuildingArea_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_building_area" */
export type ProjectBuildingArea_Aggregate_Order_By = {
  avg?: InputMaybe<ProjectBuildingArea_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectBuildingArea_Max_Order_By>;
  min?: InputMaybe<ProjectBuildingArea_Min_Order_By>;
  stddev?: InputMaybe<ProjectBuildingArea_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProjectBuildingArea_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProjectBuildingArea_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProjectBuildingArea_Sum_Order_By>;
  var_pop?: InputMaybe<ProjectBuildingArea_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProjectBuildingArea_Var_Samp_Order_By>;
  variance?: InputMaybe<ProjectBuildingArea_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_building_area" */
export type ProjectBuildingArea_Arr_Rel_Insert_Input = {
  data: Array<ProjectBuildingArea_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectBuildingArea_On_Conflict>;
};

/** aggregate avg on columns */
export type ProjectBuildingArea_Avg_Fields = {
  __typename?: 'projectBuildingArea_avg_fields';
  area?: Maybe<Scalars['Float']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  heatedArea?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_building_area" */
export type ProjectBuildingArea_Avg_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_building_area". All fields are combined with a logical 'AND'. */
export type ProjectBuildingArea_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectBuildingArea_Bool_Exp>>;
  _not?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectBuildingArea_Bool_Exp>>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  buildingAreaType?: InputMaybe<BuildingAreaType_Enum_Comparison_Exp>;
  buildingType?: InputMaybe<BuildingType_Bool_Exp>;
  buildingTypeId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  floors?: InputMaybe<Int_Comparison_Exp>;
  heatedArea?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_building_area" */
export enum ProjectBuildingArea_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_building_above_ground_pkey = 'project_building_above_ground_pkey',
  /** unique or primary key constraint on columns "revision_id", "project_id", "building_type_id", "building_area_type" */
  project_building_area_project_id_building_area_type_key = 'project_building_area_project_id_building_area_type_key'
}

/** input type for incrementing numeric columns in table "project_building_area" */
export type ProjectBuildingArea_Inc_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  floors?: InputMaybe<Scalars['Int']['input']>;
  heatedArea?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_building_area" */
export type ProjectBuildingArea_Insert_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  buildingAreaType?: InputMaybe<BuildingAreaType_Enum>;
  buildingType?: InputMaybe<BuildingType_Obj_Rel_Insert_Input>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  floors?: InputMaybe<Scalars['Int']['input']>;
  heatedArea?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectBuildingArea_Max_Fields = {
  __typename?: 'projectBuildingArea_max_fields';
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  floors?: Maybe<Scalars['Int']['output']>;
  heatedArea?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_building_area" */
export type ProjectBuildingArea_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectBuildingArea_Min_Fields = {
  __typename?: 'projectBuildingArea_min_fields';
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  floors?: Maybe<Scalars['Int']['output']>;
  heatedArea?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_building_area" */
export type ProjectBuildingArea_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_building_area" */
export type ProjectBuildingArea_Mutation_Response = {
  __typename?: 'projectBuildingArea_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectBuildingArea>;
};

/** on_conflict condition type for table "project_building_area" */
export type ProjectBuildingArea_On_Conflict = {
  constraint: ProjectBuildingArea_Constraint;
  update_columns?: Array<ProjectBuildingArea_Update_Column>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};

/** Ordering options when selecting data from "project_building_area". */
export type ProjectBuildingArea_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingAreaType?: InputMaybe<Order_By>;
  buildingType?: InputMaybe<BuildingType_Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_building_area */
export type ProjectBuildingArea_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_building_area" */
export enum ProjectBuildingArea_Select_Column {
  /** column name */
  area = 'area',
  /** column name */
  buildingAreaType = 'buildingAreaType',
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  floors = 'floors',
  /** column name */
  heatedArea = 'heatedArea',
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId'
}

/** input type for updating data in table "project_building_area" */
export type ProjectBuildingArea_Set_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  buildingAreaType?: InputMaybe<BuildingAreaType_Enum>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  floors?: InputMaybe<Scalars['Int']['input']>;
  heatedArea?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type ProjectBuildingArea_Stddev_Fields = {
  __typename?: 'projectBuildingArea_stddev_fields';
  area?: Maybe<Scalars['Float']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  heatedArea?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_building_area" */
export type ProjectBuildingArea_Stddev_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProjectBuildingArea_Stddev_Pop_Fields = {
  __typename?: 'projectBuildingArea_stddev_pop_fields';
  area?: Maybe<Scalars['Float']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  heatedArea?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_building_area" */
export type ProjectBuildingArea_Stddev_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProjectBuildingArea_Stddev_Samp_Fields = {
  __typename?: 'projectBuildingArea_stddev_samp_fields';
  area?: Maybe<Scalars['Float']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  heatedArea?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_building_area" */
export type ProjectBuildingArea_Stddev_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projectBuildingArea" */
export type ProjectBuildingArea_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectBuildingArea_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectBuildingArea_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  buildingAreaType?: InputMaybe<BuildingAreaType_Enum>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  floors?: InputMaybe<Scalars['Int']['input']>;
  heatedArea?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ProjectBuildingArea_Sum_Fields = {
  __typename?: 'projectBuildingArea_sum_fields';
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  floors?: Maybe<Scalars['Int']['output']>;
  heatedArea?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_building_area" */
export type ProjectBuildingArea_Sum_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
};

/** update columns of table "project_building_area" */
export enum ProjectBuildingArea_Update_Column {
  /** column name */
  area = 'area',
  /** column name */
  buildingAreaType = 'buildingAreaType',
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  floors = 'floors',
  /** column name */
  heatedArea = 'heatedArea',
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId'
}

export type ProjectBuildingArea_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectBuildingArea_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectBuildingArea_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectBuildingArea_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectBuildingArea_Var_Pop_Fields = {
  __typename?: 'projectBuildingArea_var_pop_fields';
  area?: Maybe<Scalars['Float']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  heatedArea?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_building_area" */
export type ProjectBuildingArea_Var_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProjectBuildingArea_Var_Samp_Fields = {
  __typename?: 'projectBuildingArea_var_samp_fields';
  area?: Maybe<Scalars['Float']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  heatedArea?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_building_area" */
export type ProjectBuildingArea_Var_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProjectBuildingArea_Variance_Fields = {
  __typename?: 'projectBuildingArea_variance_fields';
  area?: Maybe<Scalars['Float']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  heatedArea?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_building_area" */
export type ProjectBuildingArea_Variance_Order_By = {
  area?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  floors?: InputMaybe<Order_By>;
  heatedArea?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_calculation" */
export type ProjectCalculation = {
  __typename?: 'projectCalculation';
  /** An object relationship */
  calculationType: CalculationType;
  calculationTypeId: Scalars['Int']['output'];
  considerationPeriod: Scalars['Int']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  installationThresholdLimit?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  /** An array relationship */
  stages: Array<ProjectCalculationStage>;
  /** An aggregate relationship */
  stages_aggregate: ProjectCalculationStage_Aggregate;
  thresholdLimit: Scalars['numeric']['output'];
  useDefaultEmissions: Scalars['Boolean']['output'];
};


/** columns and relationships of "project_calculation" */
export type ProjectCalculationStagesArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculationStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculationStage_Order_By>>;
  where?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
};


/** columns and relationships of "project_calculation" */
export type ProjectCalculationStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculationStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculationStage_Order_By>>;
  where?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
};

/** columns and relationships of "project_calculation_stage" */
export type ProjectCalculationStage = {
  __typename?: 'projectCalculationStage';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  projectCalculation: ProjectCalculation;
  projectCalculationId: Scalars['uuid']['output'];
  /** An object relationship */
  stage: Stage;
  stageId: Scalars['Int']['output'];
};

/** aggregated selection of "project_calculation_stage" */
export type ProjectCalculationStage_Aggregate = {
  __typename?: 'projectCalculationStage_aggregate';
  aggregate?: Maybe<ProjectCalculationStage_Aggregate_Fields>;
  nodes: Array<ProjectCalculationStage>;
};

export type ProjectCalculationStage_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectCalculationStage_Aggregate_Bool_Exp_Count>;
};

export type ProjectCalculationStage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectCalculationStage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_calculation_stage" */
export type ProjectCalculationStage_Aggregate_Fields = {
  __typename?: 'projectCalculationStage_aggregate_fields';
  avg?: Maybe<ProjectCalculationStage_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectCalculationStage_Max_Fields>;
  min?: Maybe<ProjectCalculationStage_Min_Fields>;
  stddev?: Maybe<ProjectCalculationStage_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectCalculationStage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectCalculationStage_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectCalculationStage_Sum_Fields>;
  var_pop?: Maybe<ProjectCalculationStage_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectCalculationStage_Var_Samp_Fields>;
  variance?: Maybe<ProjectCalculationStage_Variance_Fields>;
};


/** aggregate fields of "project_calculation_stage" */
export type ProjectCalculationStage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectCalculationStage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_calculation_stage" */
export type ProjectCalculationStage_Aggregate_Order_By = {
  avg?: InputMaybe<ProjectCalculationStage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectCalculationStage_Max_Order_By>;
  min?: InputMaybe<ProjectCalculationStage_Min_Order_By>;
  stddev?: InputMaybe<ProjectCalculationStage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProjectCalculationStage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProjectCalculationStage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProjectCalculationStage_Sum_Order_By>;
  var_pop?: InputMaybe<ProjectCalculationStage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProjectCalculationStage_Var_Samp_Order_By>;
  variance?: InputMaybe<ProjectCalculationStage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_calculation_stage" */
export type ProjectCalculationStage_Arr_Rel_Insert_Input = {
  data: Array<ProjectCalculationStage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectCalculationStage_On_Conflict>;
};

/** aggregate avg on columns */
export type ProjectCalculationStage_Avg_Fields = {
  __typename?: 'projectCalculationStage_avg_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Avg_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_calculation_stage". All fields are combined with a logical 'AND'. */
export type ProjectCalculationStage_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectCalculationStage_Bool_Exp>>;
  _not?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectCalculationStage_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  projectCalculation?: InputMaybe<ProjectCalculation_Bool_Exp>;
  projectCalculationId?: InputMaybe<Uuid_Comparison_Exp>;
  stage?: InputMaybe<Stage_Bool_Exp>;
  stageId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_calculation_stage" */
export enum ProjectCalculationStage_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_calculation_stage_pkey = 'project_calculation_stage_pkey',
  /** unique or primary key constraint on columns "stage_id", "project_calculation_id" */
  project_calculation_stage_project_calculation_id_stage_id_key = 'project_calculation_stage_project_calculation_id_stage_id_key'
}

/** input type for incrementing numeric columns in table "project_calculation_stage" */
export type ProjectCalculationStage_Inc_Input = {
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_calculation_stage" */
export type ProjectCalculationStage_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectCalculation?: InputMaybe<ProjectCalculation_Obj_Rel_Insert_Input>;
  projectCalculationId?: InputMaybe<Scalars['uuid']['input']>;
  stage?: InputMaybe<Stage_Obj_Rel_Insert_Input>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ProjectCalculationStage_Max_Fields = {
  __typename?: 'projectCalculationStage_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectCalculationId?: Maybe<Scalars['uuid']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectCalculationId?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectCalculationStage_Min_Fields = {
  __typename?: 'projectCalculationStage_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectCalculationId?: Maybe<Scalars['uuid']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectCalculationId?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_calculation_stage" */
export type ProjectCalculationStage_Mutation_Response = {
  __typename?: 'projectCalculationStage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectCalculationStage>;
};

/** on_conflict condition type for table "project_calculation_stage" */
export type ProjectCalculationStage_On_Conflict = {
  constraint: ProjectCalculationStage_Constraint;
  update_columns?: Array<ProjectCalculationStage_Update_Column>;
  where?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
};

/** Ordering options when selecting data from "project_calculation_stage". */
export type ProjectCalculationStage_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectCalculation?: InputMaybe<ProjectCalculation_Order_By>;
  projectCalculationId?: InputMaybe<Order_By>;
  stage?: InputMaybe<Stage_Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_calculation_stage */
export type ProjectCalculationStage_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_calculation_stage" */
export enum ProjectCalculationStage_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  projectCalculationId = 'projectCalculationId',
  /** column name */
  stageId = 'stageId'
}

/** input type for updating data in table "project_calculation_stage" */
export type ProjectCalculationStage_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectCalculationId?: InputMaybe<Scalars['uuid']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ProjectCalculationStage_Stddev_Fields = {
  __typename?: 'projectCalculationStage_stddev_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Stddev_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProjectCalculationStage_Stddev_Pop_Fields = {
  __typename?: 'projectCalculationStage_stddev_pop_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Stddev_Pop_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProjectCalculationStage_Stddev_Samp_Fields = {
  __typename?: 'projectCalculationStage_stddev_samp_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Stddev_Samp_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projectCalculationStage" */
export type ProjectCalculationStage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectCalculationStage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectCalculationStage_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectCalculationId?: InputMaybe<Scalars['uuid']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ProjectCalculationStage_Sum_Fields = {
  __typename?: 'projectCalculationStage_sum_fields';
  stageId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Sum_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** update columns of table "project_calculation_stage" */
export enum ProjectCalculationStage_Update_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  projectCalculationId = 'projectCalculationId',
  /** column name */
  stageId = 'stageId'
}

export type ProjectCalculationStage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectCalculationStage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectCalculationStage_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectCalculationStage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectCalculationStage_Var_Pop_Fields = {
  __typename?: 'projectCalculationStage_var_pop_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Var_Pop_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProjectCalculationStage_Var_Samp_Fields = {
  __typename?: 'projectCalculationStage_var_samp_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Var_Samp_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProjectCalculationStage_Variance_Fields = {
  __typename?: 'projectCalculationStage_variance_fields';
  stageId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_calculation_stage" */
export type ProjectCalculationStage_Variance_Order_By = {
  stageId?: InputMaybe<Order_By>;
};

/** aggregated selection of "project_calculation" */
export type ProjectCalculation_Aggregate = {
  __typename?: 'projectCalculation_aggregate';
  aggregate?: Maybe<ProjectCalculation_Aggregate_Fields>;
  nodes: Array<ProjectCalculation>;
};

/** aggregate fields of "project_calculation" */
export type ProjectCalculation_Aggregate_Fields = {
  __typename?: 'projectCalculation_aggregate_fields';
  avg?: Maybe<ProjectCalculation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectCalculation_Max_Fields>;
  min?: Maybe<ProjectCalculation_Min_Fields>;
  stddev?: Maybe<ProjectCalculation_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectCalculation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectCalculation_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectCalculation_Sum_Fields>;
  var_pop?: Maybe<ProjectCalculation_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectCalculation_Var_Samp_Fields>;
  variance?: Maybe<ProjectCalculation_Variance_Fields>;
};


/** aggregate fields of "project_calculation" */
export type ProjectCalculation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectCalculation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ProjectCalculation_Avg_Fields = {
  __typename?: 'projectCalculation_avg_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  installationThresholdLimit?: Maybe<Scalars['Float']['output']>;
  thresholdLimit?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_calculation". All fields are combined with a logical 'AND'. */
export type ProjectCalculation_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectCalculation_Bool_Exp>>;
  _not?: InputMaybe<ProjectCalculation_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectCalculation_Bool_Exp>>;
  calculationType?: InputMaybe<CalculationType_Bool_Exp>;
  calculationTypeId?: InputMaybe<Int_Comparison_Exp>;
  considerationPeriod?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installationThresholdLimit?: InputMaybe<Numeric_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  stages?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
  stages_aggregate?: InputMaybe<ProjectCalculationStage_Aggregate_Bool_Exp>;
  thresholdLimit?: InputMaybe<Numeric_Comparison_Exp>;
  useDefaultEmissions?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_calculation" */
export enum ProjectCalculation_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_calculation_pkey = 'project_calculation_pkey',
  /** unique or primary key constraint on columns "revision_id", "project_id" */
  project_calculation_project_id_key = 'project_calculation_project_id_key'
}

/** input type for incrementing numeric columns in table "project_calculation" */
export type ProjectCalculation_Inc_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  installationThresholdLimit?: InputMaybe<Scalars['numeric']['input']>;
  thresholdLimit?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_calculation" */
export type ProjectCalculation_Insert_Input = {
  calculationType?: InputMaybe<CalculationType_Obj_Rel_Insert_Input>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installationThresholdLimit?: InputMaybe<Scalars['numeric']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  stages?: InputMaybe<ProjectCalculationStage_Arr_Rel_Insert_Input>;
  thresholdLimit?: InputMaybe<Scalars['numeric']['input']>;
  useDefaultEmissions?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type ProjectCalculation_Max_Fields = {
  __typename?: 'projectCalculation_max_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installationThresholdLimit?: Maybe<Scalars['numeric']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  thresholdLimit?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type ProjectCalculation_Min_Fields = {
  __typename?: 'projectCalculation_min_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installationThresholdLimit?: Maybe<Scalars['numeric']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  thresholdLimit?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "project_calculation" */
export type ProjectCalculation_Mutation_Response = {
  __typename?: 'projectCalculation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectCalculation>;
};

/** input type for inserting object relation for remote table "project_calculation" */
export type ProjectCalculation_Obj_Rel_Insert_Input = {
  data: ProjectCalculation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectCalculation_On_Conflict>;
};

/** on_conflict condition type for table "project_calculation" */
export type ProjectCalculation_On_Conflict = {
  constraint: ProjectCalculation_Constraint;
  update_columns?: Array<ProjectCalculation_Update_Column>;
  where?: InputMaybe<ProjectCalculation_Bool_Exp>;
};

/** Ordering options when selecting data from "project_calculation". */
export type ProjectCalculation_Order_By = {
  calculationType?: InputMaybe<CalculationType_Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  considerationPeriod?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installationThresholdLimit?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  stages_aggregate?: InputMaybe<ProjectCalculationStage_Aggregate_Order_By>;
  thresholdLimit?: InputMaybe<Order_By>;
  useDefaultEmissions?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_calculation */
export type ProjectCalculation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_calculation" */
export enum ProjectCalculation_Select_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  considerationPeriod = 'considerationPeriod',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  installationThresholdLimit = 'installationThresholdLimit',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  thresholdLimit = 'thresholdLimit',
  /** column name */
  useDefaultEmissions = 'useDefaultEmissions'
}

/** input type for updating data in table "project_calculation" */
export type ProjectCalculation_Set_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installationThresholdLimit?: InputMaybe<Scalars['numeric']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  thresholdLimit?: InputMaybe<Scalars['numeric']['input']>;
  useDefaultEmissions?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type ProjectCalculation_Stddev_Fields = {
  __typename?: 'projectCalculation_stddev_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  installationThresholdLimit?: Maybe<Scalars['Float']['output']>;
  thresholdLimit?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ProjectCalculation_Stddev_Pop_Fields = {
  __typename?: 'projectCalculation_stddev_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  installationThresholdLimit?: Maybe<Scalars['Float']['output']>;
  thresholdLimit?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ProjectCalculation_Stddev_Samp_Fields = {
  __typename?: 'projectCalculation_stddev_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  installationThresholdLimit?: Maybe<Scalars['Float']['output']>;
  thresholdLimit?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projectCalculation" */
export type ProjectCalculation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectCalculation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectCalculation_Stream_Cursor_Value_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  considerationPeriod?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installationThresholdLimit?: InputMaybe<Scalars['numeric']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  thresholdLimit?: InputMaybe<Scalars['numeric']['input']>;
  useDefaultEmissions?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type ProjectCalculation_Sum_Fields = {
  __typename?: 'projectCalculation_sum_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  considerationPeriod?: Maybe<Scalars['Int']['output']>;
  installationThresholdLimit?: Maybe<Scalars['numeric']['output']>;
  thresholdLimit?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "project_calculation" */
export enum ProjectCalculation_Update_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  considerationPeriod = 'considerationPeriod',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  installationThresholdLimit = 'installationThresholdLimit',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  thresholdLimit = 'thresholdLimit',
  /** column name */
  useDefaultEmissions = 'useDefaultEmissions'
}

export type ProjectCalculation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectCalculation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectCalculation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectCalculation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectCalculation_Var_Pop_Fields = {
  __typename?: 'projectCalculation_var_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  installationThresholdLimit?: Maybe<Scalars['Float']['output']>;
  thresholdLimit?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ProjectCalculation_Var_Samp_Fields = {
  __typename?: 'projectCalculation_var_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  installationThresholdLimit?: Maybe<Scalars['Float']['output']>;
  thresholdLimit?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ProjectCalculation_Variance_Fields = {
  __typename?: 'projectCalculation_variance_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  considerationPeriod?: Maybe<Scalars['Float']['output']>;
  installationThresholdLimit?: Maybe<Scalars['Float']['output']>;
  thresholdLimit?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "project_component_mapping_type" */
export type ProjectComponentMappingType = {
  __typename?: 'projectComponentMappingType';
  id: Scalars['String']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_component_mapping_type" */
export type ProjectComponentMappingType_Aggregate = {
  __typename?: 'projectComponentMappingType_aggregate';
  aggregate?: Maybe<ProjectComponentMappingType_Aggregate_Fields>;
  nodes: Array<ProjectComponentMappingType>;
};

/** aggregate fields of "project_component_mapping_type" */
export type ProjectComponentMappingType_Aggregate_Fields = {
  __typename?: 'projectComponentMappingType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectComponentMappingType_Max_Fields>;
  min?: Maybe<ProjectComponentMappingType_Min_Fields>;
};


/** aggregate fields of "project_component_mapping_type" */
export type ProjectComponentMappingType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectComponentMappingType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_component_mapping_type". All fields are combined with a logical 'AND'. */
export type ProjectComponentMappingType_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectComponentMappingType_Bool_Exp>>;
  _not?: InputMaybe<ProjectComponentMappingType_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectComponentMappingType_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_component_mapping_type" */
export enum ProjectComponentMappingType_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_component_mapping_type_pkey = 'project_component_mapping_type_pkey'
}

/** input type for inserting data into table "project_component_mapping_type" */
export type ProjectComponentMappingType_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectComponentMappingType_Max_Fields = {
  __typename?: 'projectComponentMappingType_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ProjectComponentMappingType_Min_Fields = {
  __typename?: 'projectComponentMappingType_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "project_component_mapping_type" */
export type ProjectComponentMappingType_Mutation_Response = {
  __typename?: 'projectComponentMappingType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectComponentMappingType>;
};

/** on_conflict condition type for table "project_component_mapping_type" */
export type ProjectComponentMappingType_On_Conflict = {
  constraint: ProjectComponentMappingType_Constraint;
  update_columns?: Array<ProjectComponentMappingType_Update_Column>;
  where?: InputMaybe<ProjectComponentMappingType_Bool_Exp>;
};

/** Ordering options when selecting data from "project_component_mapping_type". */
export type ProjectComponentMappingType_Order_By = {
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_component_mapping_type */
export type ProjectComponentMappingType_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "project_component_mapping_type" */
export enum ProjectComponentMappingType_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  model = 'model',
  /** column name */
  name = 'name',
  /** column name */
  projectId = 'projectId'
}

/** input type for updating data in table "project_component_mapping_type" */
export type ProjectComponentMappingType_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "projectComponentMappingType" */
export type ProjectComponentMappingType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectComponentMappingType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectComponentMappingType_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_component_mapping_type" */
export enum ProjectComponentMappingType_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  model = 'model',
  /** column name */
  name = 'name',
  /** column name */
  projectId = 'projectId'
}

export type ProjectComponentMappingType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectComponentMappingType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectComponentMappingType_Bool_Exp;
};

/** columns and relationships of "project_dashboard_status" */
export type ProjectDashboardStatus = {
  __typename?: 'projectDashboardStatus';
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  recalculatedAt: Scalars['timestamptz']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "project_dashboard_status" */
export type ProjectDashboardStatus_Aggregate = {
  __typename?: 'projectDashboardStatus_aggregate';
  aggregate?: Maybe<ProjectDashboardStatus_Aggregate_Fields>;
  nodes: Array<ProjectDashboardStatus>;
};

/** aggregate fields of "project_dashboard_status" */
export type ProjectDashboardStatus_Aggregate_Fields = {
  __typename?: 'projectDashboardStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectDashboardStatus_Max_Fields>;
  min?: Maybe<ProjectDashboardStatus_Min_Fields>;
};


/** aggregate fields of "project_dashboard_status" */
export type ProjectDashboardStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectDashboardStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_dashboard_status". All fields are combined with a logical 'AND'. */
export type ProjectDashboardStatus_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectDashboardStatus_Bool_Exp>>;
  _not?: InputMaybe<ProjectDashboardStatus_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectDashboardStatus_Bool_Exp>>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  recalculatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_dashboard_status" */
export enum ProjectDashboardStatus_Constraint {
  /** unique or primary key constraint on columns "project_id" */
  project_dashboard_status_pkey = 'project_dashboard_status_pkey'
}

/** input type for inserting data into table "project_dashboard_status" */
export type ProjectDashboardStatus_Insert_Input = {
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  recalculatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectDashboardStatus_Max_Fields = {
  __typename?: 'projectDashboardStatus_max_fields';
  projectId?: Maybe<Scalars['uuid']['output']>;
  recalculatedAt?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectDashboardStatus_Min_Fields = {
  __typename?: 'projectDashboardStatus_min_fields';
  projectId?: Maybe<Scalars['uuid']['output']>;
  recalculatedAt?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_dashboard_status" */
export type ProjectDashboardStatus_Mutation_Response = {
  __typename?: 'projectDashboardStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectDashboardStatus>;
};

/** on_conflict condition type for table "project_dashboard_status" */
export type ProjectDashboardStatus_On_Conflict = {
  constraint: ProjectDashboardStatus_Constraint;
  update_columns?: Array<ProjectDashboardStatus_Update_Column>;
  where?: InputMaybe<ProjectDashboardStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "project_dashboard_status". */
export type ProjectDashboardStatus_Order_By = {
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  recalculatedAt?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_dashboard_status */
export type ProjectDashboardStatus_Pk_Columns_Input = {
  projectId: Scalars['uuid']['input'];
};

/** select columns of table "project_dashboard_status" */
export enum ProjectDashboardStatus_Select_Column {
  /** column name */
  projectId = 'projectId',
  /** column name */
  recalculatedAt = 'recalculatedAt',
  /** column name */
  state = 'state'
}

/** input type for updating data in table "project_dashboard_status" */
export type ProjectDashboardStatus_Set_Input = {
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  recalculatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "projectDashboardStatus" */
export type ProjectDashboardStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectDashboardStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectDashboardStatus_Stream_Cursor_Value_Input = {
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  recalculatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_dashboard_status" */
export enum ProjectDashboardStatus_Update_Column {
  /** column name */
  projectId = 'projectId',
  /** column name */
  recalculatedAt = 'recalculatedAt',
  /** column name */
  state = 'state'
}

export type ProjectDashboardStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectDashboardStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectDashboardStatus_Bool_Exp;
};

/** columns and relationships of "project_emission_factor" */
export type ProjectEmissionFactor = {
  __typename?: 'projectEmissionFactor';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customEmissionFactor?: Maybe<ProjectEmissionFactorCustom>;
  customSourceId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  emissionFactorSource?: Maybe<Emission_Factor_Source>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  sourceId?: Maybe<Scalars['uuid']['output']>;
  type: Emission_Factor_Type_Enum;
  value: Scalars['numeric']['output'];
};

/** columns and relationships of "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom = {
  __typename?: 'projectEmissionFactorCustom';
  createdAt: Scalars['timestamptz']['output'];
  createdBy?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emissionValue: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  projectEmissionFactors: Array<ProjectEmissionFactor>;
  /** An aggregate relationship */
  projectEmissionFactors_aggregate: ProjectEmissionFactor_Aggregate;
  tenantId: Scalars['String']['output'];
  type: Emission_Factor_Type_Enum;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "project_emission_factor_custom" */
export type ProjectEmissionFactorCustomProjectEmissionFactorsArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};


/** columns and relationships of "project_emission_factor_custom" */
export type ProjectEmissionFactorCustomProjectEmissionFactors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};

/** aggregated selection of "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom_Aggregate = {
  __typename?: 'projectEmissionFactorCustom_aggregate';
  aggregate?: Maybe<ProjectEmissionFactorCustom_Aggregate_Fields>;
  nodes: Array<ProjectEmissionFactorCustom>;
};

/** aggregate fields of "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom_Aggregate_Fields = {
  __typename?: 'projectEmissionFactorCustom_aggregate_fields';
  avg?: Maybe<ProjectEmissionFactorCustom_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectEmissionFactorCustom_Max_Fields>;
  min?: Maybe<ProjectEmissionFactorCustom_Min_Fields>;
  stddev?: Maybe<ProjectEmissionFactorCustom_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectEmissionFactorCustom_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectEmissionFactorCustom_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectEmissionFactorCustom_Sum_Fields>;
  var_pop?: Maybe<ProjectEmissionFactorCustom_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectEmissionFactorCustom_Var_Samp_Fields>;
  variance?: Maybe<ProjectEmissionFactorCustom_Variance_Fields>;
};


/** aggregate fields of "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectEmissionFactorCustom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ProjectEmissionFactorCustom_Avg_Fields = {
  __typename?: 'projectEmissionFactorCustom_avg_fields';
  emissionValue?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_emission_factor_custom". All fields are combined with a logical 'AND'. */
export type ProjectEmissionFactorCustom_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectEmissionFactorCustom_Bool_Exp>>;
  _not?: InputMaybe<ProjectEmissionFactorCustom_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectEmissionFactorCustom_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  emissionValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projectEmissionFactors?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  projectEmissionFactors_aggregate?: InputMaybe<ProjectEmissionFactor_Aggregate_Bool_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Emission_Factor_Type_Enum_Comparison_Exp>;
  updatedBy?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_emission_factor_custom" */
export enum ProjectEmissionFactorCustom_Constraint {
  /** unique or primary key constraint on columns "emission_factor_type", "name", "tenant_id" */
  project_emission_factor_custo_tenant_id_name_emission_facto_key = 'project_emission_factor_custo_tenant_id_name_emission_facto_key',
  /** unique or primary key constraint on columns "id" */
  project_emission_factor_custom_pkey = 'project_emission_factor_custom_pkey'
}

/** input type for incrementing numeric columns in table "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom_Inc_Input = {
  emissionValue?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emissionValue?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectEmissionFactors?: InputMaybe<ProjectEmissionFactor_Arr_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Emission_Factor_Type_Enum>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectEmissionFactorCustom_Max_Fields = {
  __typename?: 'projectEmissionFactorCustom_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emissionValue?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ProjectEmissionFactorCustom_Min_Fields = {
  __typename?: 'projectEmissionFactorCustom_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emissionValue?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom_Mutation_Response = {
  __typename?: 'projectEmissionFactorCustom_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectEmissionFactorCustom>;
};

/** input type for inserting object relation for remote table "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom_Obj_Rel_Insert_Input = {
  data: ProjectEmissionFactorCustom_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectEmissionFactorCustom_On_Conflict>;
};

/** on_conflict condition type for table "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom_On_Conflict = {
  constraint: ProjectEmissionFactorCustom_Constraint;
  update_columns?: Array<ProjectEmissionFactorCustom_Update_Column>;
  where?: InputMaybe<ProjectEmissionFactorCustom_Bool_Exp>;
};

/** Ordering options when selecting data from "project_emission_factor_custom". */
export type ProjectEmissionFactorCustom_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  emissionValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectEmissionFactors_aggregate?: InputMaybe<ProjectEmissionFactor_Aggregate_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_emission_factor_custom */
export type ProjectEmissionFactorCustom_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_emission_factor_custom" */
export enum ProjectEmissionFactorCustom_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  description = 'description',
  /** column name */
  emissionValue = 'emissionValue',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  type = 'type',
  /** column name */
  updatedBy = 'updatedBy'
}

/** input type for updating data in table "project_emission_factor_custom" */
export type ProjectEmissionFactorCustom_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emissionValue?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Emission_Factor_Type_Enum>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type ProjectEmissionFactorCustom_Stddev_Fields = {
  __typename?: 'projectEmissionFactorCustom_stddev_fields';
  emissionValue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ProjectEmissionFactorCustom_Stddev_Pop_Fields = {
  __typename?: 'projectEmissionFactorCustom_stddev_pop_fields';
  emissionValue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ProjectEmissionFactorCustom_Stddev_Samp_Fields = {
  __typename?: 'projectEmissionFactorCustom_stddev_samp_fields';
  emissionValue?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projectEmissionFactorCustom" */
export type ProjectEmissionFactorCustom_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectEmissionFactorCustom_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectEmissionFactorCustom_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emissionValue?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Emission_Factor_Type_Enum>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ProjectEmissionFactorCustom_Sum_Fields = {
  __typename?: 'projectEmissionFactorCustom_sum_fields';
  emissionValue?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "project_emission_factor_custom" */
export enum ProjectEmissionFactorCustom_Update_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  description = 'description',
  /** column name */
  emissionValue = 'emissionValue',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  type = 'type',
  /** column name */
  updatedBy = 'updatedBy'
}

export type ProjectEmissionFactorCustom_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectEmissionFactorCustom_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectEmissionFactorCustom_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectEmissionFactorCustom_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectEmissionFactorCustom_Var_Pop_Fields = {
  __typename?: 'projectEmissionFactorCustom_var_pop_fields';
  emissionValue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ProjectEmissionFactorCustom_Var_Samp_Fields = {
  __typename?: 'projectEmissionFactorCustom_var_samp_fields';
  emissionValue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ProjectEmissionFactorCustom_Variance_Fields = {
  __typename?: 'projectEmissionFactorCustom_variance_fields';
  emissionValue?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "project_emission_factor" */
export type ProjectEmissionFactor_Aggregate = {
  __typename?: 'projectEmissionFactor_aggregate';
  aggregate?: Maybe<ProjectEmissionFactor_Aggregate_Fields>;
  nodes: Array<ProjectEmissionFactor>;
};

export type ProjectEmissionFactor_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectEmissionFactor_Aggregate_Bool_Exp_Count>;
};

export type ProjectEmissionFactor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_emission_factor" */
export type ProjectEmissionFactor_Aggregate_Fields = {
  __typename?: 'projectEmissionFactor_aggregate_fields';
  avg?: Maybe<ProjectEmissionFactor_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectEmissionFactor_Max_Fields>;
  min?: Maybe<ProjectEmissionFactor_Min_Fields>;
  stddev?: Maybe<ProjectEmissionFactor_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectEmissionFactor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectEmissionFactor_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectEmissionFactor_Sum_Fields>;
  var_pop?: Maybe<ProjectEmissionFactor_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectEmissionFactor_Var_Samp_Fields>;
  variance?: Maybe<ProjectEmissionFactor_Variance_Fields>;
};


/** aggregate fields of "project_emission_factor" */
export type ProjectEmissionFactor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_emission_factor" */
export type ProjectEmissionFactor_Aggregate_Order_By = {
  avg?: InputMaybe<ProjectEmissionFactor_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectEmissionFactor_Max_Order_By>;
  min?: InputMaybe<ProjectEmissionFactor_Min_Order_By>;
  stddev?: InputMaybe<ProjectEmissionFactor_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProjectEmissionFactor_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProjectEmissionFactor_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProjectEmissionFactor_Sum_Order_By>;
  var_pop?: InputMaybe<ProjectEmissionFactor_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProjectEmissionFactor_Var_Samp_Order_By>;
  variance?: InputMaybe<ProjectEmissionFactor_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_emission_factor" */
export type ProjectEmissionFactor_Arr_Rel_Insert_Input = {
  data: Array<ProjectEmissionFactor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectEmissionFactor_On_Conflict>;
};

/** aggregate avg on columns */
export type ProjectEmissionFactor_Avg_Fields = {
  __typename?: 'projectEmissionFactor_avg_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_emission_factor". All fields are combined with a logical 'AND'. */
export type ProjectEmissionFactor_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectEmissionFactor_Bool_Exp>>;
  _not?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectEmissionFactor_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customEmissionFactor?: InputMaybe<ProjectEmissionFactorCustom_Bool_Exp>;
  customSourceId?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  emissionFactorSource?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  sourceId?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Emission_Factor_Type_Enum_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_emission_factor" */
export enum ProjectEmissionFactor_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_emission_factor_pkey = 'project_emission_factor_pkey'
}

/** input type for incrementing numeric columns in table "project_emission_factor" */
export type ProjectEmissionFactor_Inc_Input = {
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_emission_factor" */
export type ProjectEmissionFactor_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customEmissionFactor?: InputMaybe<ProjectEmissionFactorCustom_Obj_Rel_Insert_Input>;
  customSourceId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emissionFactorSource?: InputMaybe<Emission_Factor_Source_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Emission_Factor_Type_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type ProjectEmissionFactor_Max_Fields = {
  __typename?: 'projectEmissionFactor_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customSourceId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  customSourceId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  sourceId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectEmissionFactor_Min_Fields = {
  __typename?: 'projectEmissionFactor_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customSourceId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  customSourceId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  sourceId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_emission_factor" */
export type ProjectEmissionFactor_Mutation_Response = {
  __typename?: 'projectEmissionFactor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectEmissionFactor>;
};

/** input type for inserting object relation for remote table "project_emission_factor" */
export type ProjectEmissionFactor_Obj_Rel_Insert_Input = {
  data: ProjectEmissionFactor_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectEmissionFactor_On_Conflict>;
};

/** on_conflict condition type for table "project_emission_factor" */
export type ProjectEmissionFactor_On_Conflict = {
  constraint: ProjectEmissionFactor_Constraint;
  update_columns?: Array<ProjectEmissionFactor_Update_Column>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};

/** Ordering options when selecting data from "project_emission_factor". */
export type ProjectEmissionFactor_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  customEmissionFactor?: InputMaybe<ProjectEmissionFactorCustom_Order_By>;
  customSourceId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  emissionFactorSource?: InputMaybe<Emission_Factor_Source_Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  sourceId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_emission_factor */
export type ProjectEmissionFactor_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_emission_factor" */
export enum ProjectEmissionFactor_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  customSourceId = 'customSourceId',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  sourceId = 'sourceId',
  /** column name */
  type = 'type',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "project_emission_factor" */
export type ProjectEmissionFactor_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customSourceId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Emission_Factor_Type_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type ProjectEmissionFactor_Stddev_Fields = {
  __typename?: 'projectEmissionFactor_stddev_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProjectEmissionFactor_Stddev_Pop_Fields = {
  __typename?: 'projectEmissionFactor_stddev_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProjectEmissionFactor_Stddev_Samp_Fields = {
  __typename?: 'projectEmissionFactor_stddev_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projectEmissionFactor" */
export type ProjectEmissionFactor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectEmissionFactor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectEmissionFactor_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customSourceId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Emission_Factor_Type_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type ProjectEmissionFactor_Sum_Fields = {
  __typename?: 'projectEmissionFactor_sum_fields';
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** update columns of table "project_emission_factor" */
export enum ProjectEmissionFactor_Update_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  customSourceId = 'customSourceId',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  sourceId = 'sourceId',
  /** column name */
  type = 'type',
  /** column name */
  value = 'value'
}

export type ProjectEmissionFactor_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectEmissionFactor_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectEmissionFactor_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectEmissionFactor_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectEmissionFactor_Var_Pop_Fields = {
  __typename?: 'projectEmissionFactor_var_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProjectEmissionFactor_Var_Samp_Fields = {
  __typename?: 'projectEmissionFactor_var_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProjectEmissionFactor_Variance_Fields = {
  __typename?: 'projectEmissionFactor_variance_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_emission_factor" */
export type ProjectEmissionFactor_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_installation" */
export type ProjectInstallation = {
  __typename?: 'projectInstallation';
  createdAt: Scalars['timestamp']['output'];
  /** An object relationship */
  earthMovedByMachinery?: Maybe<ProjectEmissionFactor>;
  earthMovedByMachineryId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  electricitySupply?: Maybe<ProjectEmissionFactor>;
  electricitySupplyId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  heatSupply?: Maybe<ProjectEmissionFactor>;
  heatSupplyId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  machineryFuel?: Maybe<ProjectEmissionFactor>;
  machineryFuelId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  wastageId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  wastagePercentage?: Maybe<ProjectEmissionFactor>;
};

/** aggregated selection of "project_installation" */
export type ProjectInstallation_Aggregate = {
  __typename?: 'projectInstallation_aggregate';
  aggregate?: Maybe<ProjectInstallation_Aggregate_Fields>;
  nodes: Array<ProjectInstallation>;
};

/** aggregate fields of "project_installation" */
export type ProjectInstallation_Aggregate_Fields = {
  __typename?: 'projectInstallation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectInstallation_Max_Fields>;
  min?: Maybe<ProjectInstallation_Min_Fields>;
};


/** aggregate fields of "project_installation" */
export type ProjectInstallation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectInstallation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_installation". All fields are combined with a logical 'AND'. */
export type ProjectInstallation_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectInstallation_Bool_Exp>>;
  _not?: InputMaybe<ProjectInstallation_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectInstallation_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  earthMovedByMachinery?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  earthMovedByMachineryId?: InputMaybe<Uuid_Comparison_Exp>;
  electricitySupply?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  electricitySupplyId?: InputMaybe<Uuid_Comparison_Exp>;
  heatSupply?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  heatSupplyId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  machineryFuel?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  machineryFuelId?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  wastageId?: InputMaybe<Uuid_Comparison_Exp>;
  wastagePercentage?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};

/** unique or primary key constraints on table "project_installation" */
export enum ProjectInstallation_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_installation_pkey = 'project_installation_pkey',
  /** unique or primary key constraint on columns "revision_id", "project_id" */
  project_installation_project_id_key = 'project_installation_project_id_key'
}

/** input type for inserting data into table "project_installation" */
export type ProjectInstallation_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  earthMovedByMachinery?: InputMaybe<ProjectEmissionFactor_Obj_Rel_Insert_Input>;
  earthMovedByMachineryId?: InputMaybe<Scalars['uuid']['input']>;
  electricitySupply?: InputMaybe<ProjectEmissionFactor_Obj_Rel_Insert_Input>;
  electricitySupplyId?: InputMaybe<Scalars['uuid']['input']>;
  heatSupply?: InputMaybe<ProjectEmissionFactor_Obj_Rel_Insert_Input>;
  heatSupplyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  machineryFuel?: InputMaybe<ProjectEmissionFactor_Obj_Rel_Insert_Input>;
  machineryFuelId?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  wastageId?: InputMaybe<Scalars['uuid']['input']>;
  wastagePercentage?: InputMaybe<ProjectEmissionFactor_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ProjectInstallation_Max_Fields = {
  __typename?: 'projectInstallation_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  earthMovedByMachineryId?: Maybe<Scalars['uuid']['output']>;
  electricitySupplyId?: Maybe<Scalars['uuid']['output']>;
  heatSupplyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  machineryFuelId?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  wastageId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ProjectInstallation_Min_Fields = {
  __typename?: 'projectInstallation_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  earthMovedByMachineryId?: Maybe<Scalars['uuid']['output']>;
  electricitySupplyId?: Maybe<Scalars['uuid']['output']>;
  heatSupplyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  machineryFuelId?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  wastageId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "project_installation" */
export type ProjectInstallation_Mutation_Response = {
  __typename?: 'projectInstallation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectInstallation>;
};

/** input type for inserting object relation for remote table "project_installation" */
export type ProjectInstallation_Obj_Rel_Insert_Input = {
  data: ProjectInstallation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectInstallation_On_Conflict>;
};

/** on_conflict condition type for table "project_installation" */
export type ProjectInstallation_On_Conflict = {
  constraint: ProjectInstallation_Constraint;
  update_columns?: Array<ProjectInstallation_Update_Column>;
  where?: InputMaybe<ProjectInstallation_Bool_Exp>;
};

/** Ordering options when selecting data from "project_installation". */
export type ProjectInstallation_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  earthMovedByMachinery?: InputMaybe<ProjectEmissionFactor_Order_By>;
  earthMovedByMachineryId?: InputMaybe<Order_By>;
  electricitySupply?: InputMaybe<ProjectEmissionFactor_Order_By>;
  electricitySupplyId?: InputMaybe<Order_By>;
  heatSupply?: InputMaybe<ProjectEmissionFactor_Order_By>;
  heatSupplyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  machineryFuel?: InputMaybe<ProjectEmissionFactor_Order_By>;
  machineryFuelId?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  wastageId?: InputMaybe<Order_By>;
  wastagePercentage?: InputMaybe<ProjectEmissionFactor_Order_By>;
};

/** primary key columns input for table: project_installation */
export type ProjectInstallation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_installation" */
export enum ProjectInstallation_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  earthMovedByMachineryId = 'earthMovedByMachineryId',
  /** column name */
  electricitySupplyId = 'electricitySupplyId',
  /** column name */
  heatSupplyId = 'heatSupplyId',
  /** column name */
  id = 'id',
  /** column name */
  machineryFuelId = 'machineryFuelId',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  wastageId = 'wastageId'
}

/** input type for updating data in table "project_installation" */
export type ProjectInstallation_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  earthMovedByMachineryId?: InputMaybe<Scalars['uuid']['input']>;
  electricitySupplyId?: InputMaybe<Scalars['uuid']['input']>;
  heatSupplyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  machineryFuelId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  wastageId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "projectInstallation" */
export type ProjectInstallation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectInstallation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectInstallation_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  earthMovedByMachineryId?: InputMaybe<Scalars['uuid']['input']>;
  electricitySupplyId?: InputMaybe<Scalars['uuid']['input']>;
  heatSupplyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  machineryFuelId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  wastageId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_installation" */
export enum ProjectInstallation_Update_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  earthMovedByMachineryId = 'earthMovedByMachineryId',
  /** column name */
  electricitySupplyId = 'electricitySupplyId',
  /** column name */
  heatSupplyId = 'heatSupplyId',
  /** column name */
  id = 'id',
  /** column name */
  machineryFuelId = 'machineryFuelId',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  wastageId = 'wastageId'
}

export type ProjectInstallation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectInstallation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectInstallation_Bool_Exp;
};

/** columns and relationships of "project_location" */
export type ProjectLocation = {
  __typename?: 'projectLocation';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  postalCode: Scalars['String']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
};

/** aggregated selection of "project_location" */
export type ProjectLocation_Aggregate = {
  __typename?: 'projectLocation_aggregate';
  aggregate?: Maybe<ProjectLocation_Aggregate_Fields>;
  nodes: Array<ProjectLocation>;
};

/** aggregate fields of "project_location" */
export type ProjectLocation_Aggregate_Fields = {
  __typename?: 'projectLocation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectLocation_Max_Fields>;
  min?: Maybe<ProjectLocation_Min_Fields>;
};


/** aggregate fields of "project_location" */
export type ProjectLocation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectLocation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_location". All fields are combined with a logical 'AND'. */
export type ProjectLocation_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectLocation_Bool_Exp>>;
  _not?: InputMaybe<ProjectLocation_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectLocation_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  streetNumber?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_location" */
export enum ProjectLocation_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_location_pkey = 'project_location_pkey',
  /** unique or primary key constraint on columns "revision_id", "project_id" */
  project_location_project_id_key = 'project_location_project_id_key'
}

/** input type for inserting data into table "project_location" */
export type ProjectLocation_Insert_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectLocation_Max_Fields = {
  __typename?: 'projectLocation_max_fields';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectLocation_Min_Fields = {
  __typename?: 'projectLocation_min_fields';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_location" */
export type ProjectLocation_Mutation_Response = {
  __typename?: 'projectLocation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectLocation>;
};

/** input type for inserting object relation for remote table "project_location" */
export type ProjectLocation_Obj_Rel_Insert_Input = {
  data: ProjectLocation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectLocation_On_Conflict>;
};

/** on_conflict condition type for table "project_location" */
export type ProjectLocation_On_Conflict = {
  constraint: ProjectLocation_Constraint;
  update_columns?: Array<ProjectLocation_Update_Column>;
  where?: InputMaybe<ProjectLocation_Bool_Exp>;
};

/** Ordering options when selecting data from "project_location". */
export type ProjectLocation_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  streetNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_location */
export type ProjectLocation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_location" */
export enum ProjectLocation_Select_Column {
  /** column name */
  city = 'city',
  /** column name */
  country = 'country',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  postalCode = 'postalCode',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  street = 'street',
  /** column name */
  streetNumber = 'streetNumber'
}

/** input type for updating data in table "project_location" */
export type ProjectLocation_Set_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "projectLocation" */
export type ProjectLocation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectLocation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectLocation_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_location" */
export enum ProjectLocation_Update_Column {
  /** column name */
  city = 'city',
  /** column name */
  country = 'country',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  postalCode = 'postalCode',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  street = 'street',
  /** column name */
  streetNumber = 'streetNumber'
}

export type ProjectLocation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectLocation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectLocation_Bool_Exp;
};

/** columns and relationships of "project_material_classification_feedback" */
export type ProjectMaterialClassificationFeedback = {
  __typename?: 'projectMaterialClassificationFeedback';
  classificationParam: Scalars['String']['output'];
  classificationSystem?: Maybe<Scalars['String']['output']>;
  confidenceScore?: Maybe<Scalars['numeric']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  inputString?: Maybe<Scalars['String']['output']>;
  materialId: Scalars['uuid']['output'];
  oldValue?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['uuid']['output'];
  proposedObjectClass?: Maybe<Scalars['String']['output']>;
  proposedValue?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['uuid']['output'];
  typeId?: Maybe<Scalars['String']['output']>;
  usedValue?: Maybe<Scalars['String']['output']>;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_material_classification_feedback" */
export type ProjectMaterialClassificationFeedback_Aggregate = {
  __typename?: 'projectMaterialClassificationFeedback_aggregate';
  aggregate?: Maybe<ProjectMaterialClassificationFeedback_Aggregate_Fields>;
  nodes: Array<ProjectMaterialClassificationFeedback>;
};

/** aggregate fields of "project_material_classification_feedback" */
export type ProjectMaterialClassificationFeedback_Aggregate_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_aggregate_fields';
  avg?: Maybe<ProjectMaterialClassificationFeedback_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectMaterialClassificationFeedback_Max_Fields>;
  min?: Maybe<ProjectMaterialClassificationFeedback_Min_Fields>;
  stddev?: Maybe<ProjectMaterialClassificationFeedback_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectMaterialClassificationFeedback_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectMaterialClassificationFeedback_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectMaterialClassificationFeedback_Sum_Fields>;
  var_pop?: Maybe<ProjectMaterialClassificationFeedback_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectMaterialClassificationFeedback_Var_Samp_Fields>;
  variance?: Maybe<ProjectMaterialClassificationFeedback_Variance_Fields>;
};


/** aggregate fields of "project_material_classification_feedback" */
export type ProjectMaterialClassificationFeedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ProjectMaterialClassificationFeedback_Avg_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_avg_fields';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_material_classification_feedback". All fields are combined with a logical 'AND'. */
export type ProjectMaterialClassificationFeedback_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Bool_Exp>>;
  _not?: InputMaybe<ProjectMaterialClassificationFeedback_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Bool_Exp>>;
  classificationParam?: InputMaybe<String_Comparison_Exp>;
  classificationSystem?: InputMaybe<String_Comparison_Exp>;
  confidenceScore?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inputString?: InputMaybe<String_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  oldValue?: InputMaybe<String_Comparison_Exp>;
  outcome?: InputMaybe<String_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  proposedObjectClass?: InputMaybe<String_Comparison_Exp>;
  proposedValue?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  typeId?: InputMaybe<String_Comparison_Exp>;
  usedValue?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_material_classification_feedback" */
export enum ProjectMaterialClassificationFeedback_Constraint {
  /** unique or primary key constraint on columns "id" */
  building_project_material_classification_feedback_pkey = 'building_project_material_classification_feedback_pkey'
}

/** input type for incrementing numeric columns in table "project_material_classification_feedback" */
export type ProjectMaterialClassificationFeedback_Inc_Input = {
  confidenceScore?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_material_classification_feedback" */
export type ProjectMaterialClassificationFeedback_Insert_Input = {
  classificationParam?: InputMaybe<Scalars['String']['input']>;
  classificationSystem?: InputMaybe<Scalars['String']['input']>;
  confidenceScore?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inputString?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  oldValue?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  proposedObjectClass?: InputMaybe<Scalars['String']['input']>;
  proposedValue?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  usedValue?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectMaterialClassificationFeedback_Max_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_max_fields';
  classificationParam?: Maybe<Scalars['String']['output']>;
  classificationSystem?: Maybe<Scalars['String']['output']>;
  confidenceScore?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inputString?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  proposedObjectClass?: Maybe<Scalars['String']['output']>;
  proposedValue?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  usedValue?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ProjectMaterialClassificationFeedback_Min_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_min_fields';
  classificationParam?: Maybe<Scalars['String']['output']>;
  classificationSystem?: Maybe<Scalars['String']['output']>;
  confidenceScore?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inputString?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  proposedObjectClass?: Maybe<Scalars['String']['output']>;
  proposedValue?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  usedValue?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "project_material_classification_feedback" */
export type ProjectMaterialClassificationFeedback_Mutation_Response = {
  __typename?: 'projectMaterialClassificationFeedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectMaterialClassificationFeedback>;
};

/** on_conflict condition type for table "project_material_classification_feedback" */
export type ProjectMaterialClassificationFeedback_On_Conflict = {
  constraint: ProjectMaterialClassificationFeedback_Constraint;
  update_columns?: Array<ProjectMaterialClassificationFeedback_Update_Column>;
  where?: InputMaybe<ProjectMaterialClassificationFeedback_Bool_Exp>;
};

/** Ordering options when selecting data from "project_material_classification_feedback". */
export type ProjectMaterialClassificationFeedback_Order_By = {
  classificationParam?: InputMaybe<Order_By>;
  classificationSystem?: InputMaybe<Order_By>;
  confidenceScore?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inputString?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  oldValue?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  proposedObjectClass?: InputMaybe<Order_By>;
  proposedValue?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  typeId?: InputMaybe<Order_By>;
  usedValue?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_material_classification_feedback */
export type ProjectMaterialClassificationFeedback_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_material_classification_feedback" */
export enum ProjectMaterialClassificationFeedback_Select_Column {
  /** column name */
  classificationParam = 'classificationParam',
  /** column name */
  classificationSystem = 'classificationSystem',
  /** column name */
  confidenceScore = 'confidenceScore',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  inputString = 'inputString',
  /** column name */
  materialId = 'materialId',
  /** column name */
  oldValue = 'oldValue',
  /** column name */
  outcome = 'outcome',
  /** column name */
  projectId = 'projectId',
  /** column name */
  proposedObjectClass = 'proposedObjectClass',
  /** column name */
  proposedValue = 'proposedValue',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  typeId = 'typeId',
  /** column name */
  usedValue = 'usedValue',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "project_material_classification_feedback" */
export type ProjectMaterialClassificationFeedback_Set_Input = {
  classificationParam?: InputMaybe<Scalars['String']['input']>;
  classificationSystem?: InputMaybe<Scalars['String']['input']>;
  confidenceScore?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inputString?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  oldValue?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  proposedObjectClass?: InputMaybe<Scalars['String']['input']>;
  proposedValue?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  usedValue?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type ProjectMaterialClassificationFeedback_Stddev_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_stddev_fields';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ProjectMaterialClassificationFeedback_Stddev_Pop_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_stddev_pop_fields';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ProjectMaterialClassificationFeedback_Stddev_Samp_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_stddev_samp_fields';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projectMaterialClassificationFeedback" */
export type ProjectMaterialClassificationFeedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectMaterialClassificationFeedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectMaterialClassificationFeedback_Stream_Cursor_Value_Input = {
  classificationParam?: InputMaybe<Scalars['String']['input']>;
  classificationSystem?: InputMaybe<Scalars['String']['input']>;
  confidenceScore?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inputString?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  oldValue?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  proposedObjectClass?: InputMaybe<Scalars['String']['input']>;
  proposedValue?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  usedValue?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ProjectMaterialClassificationFeedback_Sum_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_sum_fields';
  confidenceScore?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "project_material_classification_feedback" */
export enum ProjectMaterialClassificationFeedback_Update_Column {
  /** column name */
  classificationParam = 'classificationParam',
  /** column name */
  classificationSystem = 'classificationSystem',
  /** column name */
  confidenceScore = 'confidenceScore',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  inputString = 'inputString',
  /** column name */
  materialId = 'materialId',
  /** column name */
  oldValue = 'oldValue',
  /** column name */
  outcome = 'outcome',
  /** column name */
  projectId = 'projectId',
  /** column name */
  proposedObjectClass = 'proposedObjectClass',
  /** column name */
  proposedValue = 'proposedValue',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  typeId = 'typeId',
  /** column name */
  usedValue = 'usedValue',
  /** column name */
  userId = 'userId'
}

export type ProjectMaterialClassificationFeedback_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectMaterialClassificationFeedback_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectMaterialClassificationFeedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectMaterialClassificationFeedback_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectMaterialClassificationFeedback_Var_Pop_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_var_pop_fields';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ProjectMaterialClassificationFeedback_Var_Samp_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_var_samp_fields';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ProjectMaterialClassificationFeedback_Variance_Fields = {
  __typename?: 'projectMaterialClassificationFeedback_variance_fields';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "project_material_classification_parameter" */
export type ProjectMaterialClassificationParameter = {
  __typename?: 'projectMaterialClassificationParameter';
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  projectId: Scalars['uuid']['output'];
  projectMaterialId: Scalars['uuid']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "project_material_classification_parameter" */
export type ProjectMaterialClassificationParameter_Aggregate = {
  __typename?: 'projectMaterialClassificationParameter_aggregate';
  aggregate?: Maybe<ProjectMaterialClassificationParameter_Aggregate_Fields>;
  nodes: Array<ProjectMaterialClassificationParameter>;
};

/** aggregate fields of "project_material_classification_parameter" */
export type ProjectMaterialClassificationParameter_Aggregate_Fields = {
  __typename?: 'projectMaterialClassificationParameter_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectMaterialClassificationParameter_Max_Fields>;
  min?: Maybe<ProjectMaterialClassificationParameter_Min_Fields>;
};


/** aggregate fields of "project_material_classification_parameter" */
export type ProjectMaterialClassificationParameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectMaterialClassificationParameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_material_classification_parameter". All fields are combined with a logical 'AND'. */
export type ProjectMaterialClassificationParameter_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectMaterialClassificationParameter_Bool_Exp>>;
  _not?: InputMaybe<ProjectMaterialClassificationParameter_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectMaterialClassificationParameter_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  projectMaterialId?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_material_classification_parameter" */
export enum ProjectMaterialClassificationParameter_Constraint {
  /** unique or primary key constraint on columns "key", "project_id", "project_material_id" */
  project_material_classificati_project_id_project_material_i_key = 'project_material_classificati_project_id_project_material_i_key',
  /** unique or primary key constraint on columns "id" */
  project_material_classification_parameter_pkey = 'project_material_classification_parameter_pkey'
}

/** input type for inserting data into table "project_material_classification_parameter" */
export type ProjectMaterialClassificationParameter_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectMaterialId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectMaterialClassificationParameter_Max_Fields = {
  __typename?: 'projectMaterialClassificationParameter_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  projectMaterialId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectMaterialClassificationParameter_Min_Fields = {
  __typename?: 'projectMaterialClassificationParameter_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  projectMaterialId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_material_classification_parameter" */
export type ProjectMaterialClassificationParameter_Mutation_Response = {
  __typename?: 'projectMaterialClassificationParameter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectMaterialClassificationParameter>;
};

/** on_conflict condition type for table "project_material_classification_parameter" */
export type ProjectMaterialClassificationParameter_On_Conflict = {
  constraint: ProjectMaterialClassificationParameter_Constraint;
  update_columns?: Array<ProjectMaterialClassificationParameter_Update_Column>;
  where?: InputMaybe<ProjectMaterialClassificationParameter_Bool_Exp>;
};

/** Ordering options when selecting data from "project_material_classification_parameter". */
export type ProjectMaterialClassificationParameter_Order_By = {
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectMaterialId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_material_classification_parameter */
export type ProjectMaterialClassificationParameter_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_material_classification_parameter" */
export enum ProjectMaterialClassificationParameter_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  key = 'key',
  /** column name */
  projectId = 'projectId',
  /** column name */
  projectMaterialId = 'projectMaterialId',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "project_material_classification_parameter" */
export type ProjectMaterialClassificationParameter_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectMaterialId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "projectMaterialClassificationParameter" */
export type ProjectMaterialClassificationParameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectMaterialClassificationParameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectMaterialClassificationParameter_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectMaterialId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_material_classification_parameter" */
export enum ProjectMaterialClassificationParameter_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  key = 'key',
  /** column name */
  projectId = 'projectId',
  /** column name */
  projectMaterialId = 'projectMaterialId',
  /** column name */
  value = 'value'
}

export type ProjectMaterialClassificationParameter_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectMaterialClassificationParameter_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectMaterialClassificationParameter_Bool_Exp;
};

/** columns and relationships of "project_membership" */
export type ProjectMembership = {
  __typename?: 'projectMembership';
  buildingProjectId: Scalars['uuid']['output'];
  favorite: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  membershipRole: Roles;
  role: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** aggregated selection of "project_membership" */
export type ProjectMembership_Aggregate = {
  __typename?: 'projectMembership_aggregate';
  aggregate?: Maybe<ProjectMembership_Aggregate_Fields>;
  nodes: Array<ProjectMembership>;
};

export type ProjectMembership_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ProjectMembership_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ProjectMembership_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ProjectMembership_Aggregate_Bool_Exp_Count>;
};

export type ProjectMembership_Aggregate_Bool_Exp_Bool_And = {
  arguments: ProjectMembership_Select_Column_ProjectMembership_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectMembership_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProjectMembership_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ProjectMembership_Select_Column_ProjectMembership_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectMembership_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProjectMembership_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectMembership_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectMembership_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_membership" */
export type ProjectMembership_Aggregate_Fields = {
  __typename?: 'projectMembership_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectMembership_Max_Fields>;
  min?: Maybe<ProjectMembership_Min_Fields>;
};


/** aggregate fields of "project_membership" */
export type ProjectMembership_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectMembership_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_membership" */
export type ProjectMembership_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectMembership_Max_Order_By>;
  min?: InputMaybe<ProjectMembership_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_membership" */
export type ProjectMembership_Arr_Rel_Insert_Input = {
  data: Array<ProjectMembership_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectMembership_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_membership". All fields are combined with a logical 'AND'. */
export type ProjectMembership_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectMembership_Bool_Exp>>;
  _not?: InputMaybe<ProjectMembership_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectMembership_Bool_Exp>>;
  buildingProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  favorite?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  membershipRole?: InputMaybe<Roles_Bool_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_membership" */
export enum ProjectMembership_Constraint {
  /** unique or primary key constraint on columns "userId", "buildingProjectId" */
  building_project_memberships_buildingProjectId_userId_key = 'building_project_memberships_buildingProjectId_userId_key',
  /** unique or primary key constraint on columns "id" */
  building_project_memberships_pkey = 'building_project_memberships_pkey'
}

/** input type for inserting data into table "project_membership" */
export type ProjectMembership_Insert_Input = {
  buildingProjectId?: InputMaybe<Scalars['uuid']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  membershipRole?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectMembership_Max_Fields = {
  __typename?: 'projectMembership_max_fields';
  buildingProjectId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "project_membership" */
export type ProjectMembership_Max_Order_By = {
  buildingProjectId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectMembership_Min_Fields = {
  __typename?: 'projectMembership_min_fields';
  buildingProjectId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "project_membership" */
export type ProjectMembership_Min_Order_By = {
  buildingProjectId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_membership" */
export type ProjectMembership_Mutation_Response = {
  __typename?: 'projectMembership_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectMembership>;
};

/** on_conflict condition type for table "project_membership" */
export type ProjectMembership_On_Conflict = {
  constraint: ProjectMembership_Constraint;
  update_columns?: Array<ProjectMembership_Update_Column>;
  where?: InputMaybe<ProjectMembership_Bool_Exp>;
};

/** Ordering options when selecting data from "project_membership". */
export type ProjectMembership_Order_By = {
  buildingProjectId?: InputMaybe<Order_By>;
  favorite?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  membershipRole?: InputMaybe<Roles_Order_By>;
  role?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_membership */
export type ProjectMembership_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_membership" */
export enum ProjectMembership_Select_Column {
  /** column name */
  buildingProjectId = 'buildingProjectId',
  /** column name */
  favorite = 'favorite',
  /** column name */
  id = 'id',
  /** column name */
  role = 'role',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId'
}

/** select "projectMembership_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_membership" */
export enum ProjectMembership_Select_Column_ProjectMembership_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  favorite = 'favorite'
}

/** select "projectMembership_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_membership" */
export enum ProjectMembership_Select_Column_ProjectMembership_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  favorite = 'favorite'
}

/** input type for updating data in table "project_membership" */
export type ProjectMembership_Set_Input = {
  buildingProjectId?: InputMaybe<Scalars['uuid']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "projectMembership" */
export type ProjectMembership_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectMembership_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectMembership_Stream_Cursor_Value_Input = {
  buildingProjectId?: InputMaybe<Scalars['uuid']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_membership" */
export enum ProjectMembership_Update_Column {
  /** column name */
  buildingProjectId = 'buildingProjectId',
  /** column name */
  favorite = 'favorite',
  /** column name */
  id = 'id',
  /** column name */
  role = 'role',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId'
}

export type ProjectMembership_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectMembership_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectMembership_Bool_Exp;
};

/** columns and relationships of "project_model" */
export type ProjectModel = {
  __typename?: 'projectModel';
  active: Scalars['Boolean']['output'];
  commitId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  pulledAt?: Maybe<Scalars['timestamptz']['output']>;
  referencedObjectId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  speckleModelId?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "project_model_speckle_pin" */
export type ProjectModelSpecklePin = {
  __typename?: 'projectModelSpecklePin';
  asOf: Scalars['timestamptz']['output'];
  createdAt: Scalars['timestamptz']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  streamId: Scalars['String']['output'];
};

/** aggregated selection of "project_model_speckle_pin" */
export type ProjectModelSpecklePin_Aggregate = {
  __typename?: 'projectModelSpecklePin_aggregate';
  aggregate?: Maybe<ProjectModelSpecklePin_Aggregate_Fields>;
  nodes: Array<ProjectModelSpecklePin>;
};

/** aggregate fields of "project_model_speckle_pin" */
export type ProjectModelSpecklePin_Aggregate_Fields = {
  __typename?: 'projectModelSpecklePin_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectModelSpecklePin_Max_Fields>;
  min?: Maybe<ProjectModelSpecklePin_Min_Fields>;
};


/** aggregate fields of "project_model_speckle_pin" */
export type ProjectModelSpecklePin_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectModelSpecklePin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_model_speckle_pin". All fields are combined with a logical 'AND'. */
export type ProjectModelSpecklePin_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectModelSpecklePin_Bool_Exp>>;
  _not?: InputMaybe<ProjectModelSpecklePin_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectModelSpecklePin_Bool_Exp>>;
  asOf?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  streamId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_model_speckle_pin" */
export enum ProjectModelSpecklePin_Constraint {
  /** unique or primary key constraint on columns "project_id", "name" */
  project_model_speckle_pin_pkey = 'project_model_speckle_pin_pkey'
}

/** input type for inserting data into table "project_model_speckle_pin" */
export type ProjectModelSpecklePin_Insert_Input = {
  asOf?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  streamId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectModelSpecklePin_Max_Fields = {
  __typename?: 'projectModelSpecklePin_max_fields';
  asOf?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  streamId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectModelSpecklePin_Min_Fields = {
  __typename?: 'projectModelSpecklePin_min_fields';
  asOf?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  streamId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_model_speckle_pin" */
export type ProjectModelSpecklePin_Mutation_Response = {
  __typename?: 'projectModelSpecklePin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectModelSpecklePin>;
};

/** on_conflict condition type for table "project_model_speckle_pin" */
export type ProjectModelSpecklePin_On_Conflict = {
  constraint: ProjectModelSpecklePin_Constraint;
  update_columns?: Array<ProjectModelSpecklePin_Update_Column>;
  where?: InputMaybe<ProjectModelSpecklePin_Bool_Exp>;
};

/** Ordering options when selecting data from "project_model_speckle_pin". */
export type ProjectModelSpecklePin_Order_By = {
  asOf?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  streamId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_model_speckle_pin */
export type ProjectModelSpecklePin_Pk_Columns_Input = {
  name: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
};

/** select columns of table "project_model_speckle_pin" */
export enum ProjectModelSpecklePin_Select_Column {
  /** column name */
  asOf = 'asOf',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  name = 'name',
  /** column name */
  projectId = 'projectId',
  /** column name */
  streamId = 'streamId'
}

/** input type for updating data in table "project_model_speckle_pin" */
export type ProjectModelSpecklePin_Set_Input = {
  asOf?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  streamId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "projectModelSpecklePin" */
export type ProjectModelSpecklePin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectModelSpecklePin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectModelSpecklePin_Stream_Cursor_Value_Input = {
  asOf?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  streamId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_model_speckle_pin" */
export enum ProjectModelSpecklePin_Update_Column {
  /** column name */
  asOf = 'asOf',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  name = 'name',
  /** column name */
  projectId = 'projectId',
  /** column name */
  streamId = 'streamId'
}

export type ProjectModelSpecklePin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectModelSpecklePin_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectModelSpecklePin_Bool_Exp;
};

/** aggregated selection of "project_model" */
export type ProjectModel_Aggregate = {
  __typename?: 'projectModel_aggregate';
  aggregate?: Maybe<ProjectModel_Aggregate_Fields>;
  nodes: Array<ProjectModel>;
};

export type ProjectModel_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ProjectModel_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ProjectModel_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ProjectModel_Aggregate_Bool_Exp_Count>;
};

export type ProjectModel_Aggregate_Bool_Exp_Bool_And = {
  arguments: ProjectModel_Select_Column_ProjectModel_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectModel_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProjectModel_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ProjectModel_Select_Column_ProjectModel_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectModel_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProjectModel_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectModel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectModel_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_model" */
export type ProjectModel_Aggregate_Fields = {
  __typename?: 'projectModel_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectModel_Max_Fields>;
  min?: Maybe<ProjectModel_Min_Fields>;
};


/** aggregate fields of "project_model" */
export type ProjectModel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectModel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_model" */
export type ProjectModel_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectModel_Max_Order_By>;
  min?: InputMaybe<ProjectModel_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_model" */
export type ProjectModel_Arr_Rel_Insert_Input = {
  data: Array<ProjectModel_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectModel_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_model". All fields are combined with a logical 'AND'. */
export type ProjectModel_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectModel_Bool_Exp>>;
  _not?: InputMaybe<ProjectModel_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectModel_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  commitId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  pulledAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  referencedObjectId?: InputMaybe<String_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  speckleModelId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_model" */
export enum ProjectModel_Constraint {
  /** unique or primary key constraint on columns "revision_id", "project_id", "name" */
  project_model_project_id_name_key = 'project_model_project_id_name_key',
  /** unique or primary key constraint on columns "id", "revision_id", "project_id" */
  project_speckle_model_pkey = 'project_speckle_model_pkey'
}

/** input type for inserting data into table "project_model" */
export type ProjectModel_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  commitId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  pulledAt?: InputMaybe<Scalars['timestamptz']['input']>;
  referencedObjectId?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  speckleModelId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectModel_Max_Fields = {
  __typename?: 'projectModel_max_fields';
  commitId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  pulledAt?: Maybe<Scalars['timestamptz']['output']>;
  referencedObjectId?: Maybe<Scalars['String']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  speckleModelId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "project_model" */
export type ProjectModel_Max_Order_By = {
  commitId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  pulledAt?: InputMaybe<Order_By>;
  referencedObjectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  speckleModelId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectModel_Min_Fields = {
  __typename?: 'projectModel_min_fields';
  commitId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  pulledAt?: Maybe<Scalars['timestamptz']['output']>;
  referencedObjectId?: Maybe<Scalars['String']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  speckleModelId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "project_model" */
export type ProjectModel_Min_Order_By = {
  commitId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  pulledAt?: InputMaybe<Order_By>;
  referencedObjectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  speckleModelId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_model" */
export type ProjectModel_Mutation_Response = {
  __typename?: 'projectModel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectModel>;
};

/** on_conflict condition type for table "project_model" */
export type ProjectModel_On_Conflict = {
  constraint: ProjectModel_Constraint;
  update_columns?: Array<ProjectModel_Update_Column>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};

/** Ordering options when selecting data from "project_model". */
export type ProjectModel_Order_By = {
  active?: InputMaybe<Order_By>;
  commitId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  pulledAt?: InputMaybe<Order_By>;
  referencedObjectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  speckleModelId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_model */
export type ProjectModel_Pk_Columns_Input = {
  id: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
  revisionId: Scalars['uuid']['input'];
};

/** select columns of table "project_model" */
export enum ProjectModel_Select_Column {
  /** column name */
  active = 'active',
  /** column name */
  commitId = 'commitId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  projectId = 'projectId',
  /** column name */
  pulledAt = 'pulledAt',
  /** column name */
  referencedObjectId = 'referencedObjectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  speckleModelId = 'speckleModelId'
}

/** select "projectModel_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_model" */
export enum ProjectModel_Select_Column_ProjectModel_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  active = 'active'
}

/** select "projectModel_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_model" */
export enum ProjectModel_Select_Column_ProjectModel_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  active = 'active'
}

/** input type for updating data in table "project_model" */
export type ProjectModel_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  commitId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  pulledAt?: InputMaybe<Scalars['timestamptz']['input']>;
  referencedObjectId?: InputMaybe<Scalars['String']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  speckleModelId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "projectModel" */
export type ProjectModel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectModel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectModel_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  commitId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  pulledAt?: InputMaybe<Scalars['timestamptz']['input']>;
  referencedObjectId?: InputMaybe<Scalars['String']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  speckleModelId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_model" */
export enum ProjectModel_Update_Column {
  /** column name */
  active = 'active',
  /** column name */
  commitId = 'commitId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  projectId = 'projectId',
  /** column name */
  pulledAt = 'pulledAt',
  /** column name */
  referencedObjectId = 'referencedObjectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  speckleModelId = 'speckleModelId'
}

export type ProjectModel_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectModel_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectModel_Bool_Exp;
};

/** columns and relationships of "project_operational" */
export type ProjectOperational = {
  __typename?: 'projectOperational';
  createdAt: Scalars['timestamp']['output'];
  /** An object relationship */
  electricitySupply?: Maybe<ProjectEmissionFactor>;
  electricitySupplyId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  exportedElectricity?: Maybe<ProjectEmissionFactor>;
  exportedElectricityId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  heatSupply?: Maybe<ProjectEmissionFactor>;
  heatSupplyId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  validatedAt?: Maybe<Scalars['timestamptz']['output']>;
  validatedBy?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "project_operational" */
export type ProjectOperational_Aggregate = {
  __typename?: 'projectOperational_aggregate';
  aggregate?: Maybe<ProjectOperational_Aggregate_Fields>;
  nodes: Array<ProjectOperational>;
};

/** aggregate fields of "project_operational" */
export type ProjectOperational_Aggregate_Fields = {
  __typename?: 'projectOperational_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectOperational_Max_Fields>;
  min?: Maybe<ProjectOperational_Min_Fields>;
};


/** aggregate fields of "project_operational" */
export type ProjectOperational_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectOperational_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_operational". All fields are combined with a logical 'AND'. */
export type ProjectOperational_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectOperational_Bool_Exp>>;
  _not?: InputMaybe<ProjectOperational_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectOperational_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  electricitySupply?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  electricitySupplyId?: InputMaybe<Uuid_Comparison_Exp>;
  exportedElectricity?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  exportedElectricityId?: InputMaybe<Uuid_Comparison_Exp>;
  heatSupply?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  heatSupplyId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  validatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validatedBy?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_operational" */
export enum ProjectOperational_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_operational_pkey = 'project_operational_pkey',
  /** unique or primary key constraint on columns "revision_id", "project_id" */
  project_operational_project_id_key = 'project_operational_project_id_key'
}

/** input type for inserting data into table "project_operational" */
export type ProjectOperational_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  electricitySupply?: InputMaybe<ProjectEmissionFactor_Obj_Rel_Insert_Input>;
  electricitySupplyId?: InputMaybe<Scalars['uuid']['input']>;
  exportedElectricity?: InputMaybe<ProjectEmissionFactor_Obj_Rel_Insert_Input>;
  exportedElectricityId?: InputMaybe<Scalars['uuid']['input']>;
  heatSupply?: InputMaybe<ProjectEmissionFactor_Obj_Rel_Insert_Input>;
  heatSupplyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  validatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  validatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectOperational_Max_Fields = {
  __typename?: 'projectOperational_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  electricitySupplyId?: Maybe<Scalars['uuid']['output']>;
  exportedElectricityId?: Maybe<Scalars['uuid']['output']>;
  heatSupplyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  validatedAt?: Maybe<Scalars['timestamptz']['output']>;
  validatedBy?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectOperational_Min_Fields = {
  __typename?: 'projectOperational_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  electricitySupplyId?: Maybe<Scalars['uuid']['output']>;
  exportedElectricityId?: Maybe<Scalars['uuid']['output']>;
  heatSupplyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  validatedAt?: Maybe<Scalars['timestamptz']['output']>;
  validatedBy?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_operational" */
export type ProjectOperational_Mutation_Response = {
  __typename?: 'projectOperational_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectOperational>;
};

/** input type for inserting object relation for remote table "project_operational" */
export type ProjectOperational_Obj_Rel_Insert_Input = {
  data: ProjectOperational_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectOperational_On_Conflict>;
};

/** on_conflict condition type for table "project_operational" */
export type ProjectOperational_On_Conflict = {
  constraint: ProjectOperational_Constraint;
  update_columns?: Array<ProjectOperational_Update_Column>;
  where?: InputMaybe<ProjectOperational_Bool_Exp>;
};

/** Ordering options when selecting data from "project_operational". */
export type ProjectOperational_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  electricitySupply?: InputMaybe<ProjectEmissionFactor_Order_By>;
  electricitySupplyId?: InputMaybe<Order_By>;
  exportedElectricity?: InputMaybe<ProjectEmissionFactor_Order_By>;
  exportedElectricityId?: InputMaybe<Order_By>;
  heatSupply?: InputMaybe<ProjectEmissionFactor_Order_By>;
  heatSupplyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  validatedAt?: InputMaybe<Order_By>;
  validatedBy?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_operational */
export type ProjectOperational_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_operational" */
export enum ProjectOperational_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  electricitySupplyId = 'electricitySupplyId',
  /** column name */
  exportedElectricityId = 'exportedElectricityId',
  /** column name */
  heatSupplyId = 'heatSupplyId',
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  validatedAt = 'validatedAt',
  /** column name */
  validatedBy = 'validatedBy'
}

/** input type for updating data in table "project_operational" */
export type ProjectOperational_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  electricitySupplyId?: InputMaybe<Scalars['uuid']['input']>;
  exportedElectricityId?: InputMaybe<Scalars['uuid']['input']>;
  heatSupplyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  validatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  validatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "projectOperational" */
export type ProjectOperational_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectOperational_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectOperational_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  electricitySupplyId?: InputMaybe<Scalars['uuid']['input']>;
  exportedElectricityId?: InputMaybe<Scalars['uuid']['input']>;
  heatSupplyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  validatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  validatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_operational" */
export enum ProjectOperational_Update_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  electricitySupplyId = 'electricitySupplyId',
  /** column name */
  exportedElectricityId = 'exportedElectricityId',
  /** column name */
  heatSupplyId = 'heatSupplyId',
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  validatedAt = 'validatedAt',
  /** column name */
  validatedBy = 'validatedBy'
}

export type ProjectOperational_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectOperational_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectOperational_Bool_Exp;
};

/** columns and relationships of "project_reference_area" */
export type ProjectReferenceArea = {
  __typename?: 'projectReferenceArea';
  area: Scalars['numeric']['output'];
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  referenceAreaType: ReferenceAreaType;
  referenceAreaTypeKey: Scalars['String']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_reference_area" */
export type ProjectReferenceArea_Aggregate = {
  __typename?: 'projectReferenceArea_aggregate';
  aggregate?: Maybe<ProjectReferenceArea_Aggregate_Fields>;
  nodes: Array<ProjectReferenceArea>;
};

export type ProjectReferenceArea_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectReferenceArea_Aggregate_Bool_Exp_Count>;
};

export type ProjectReferenceArea_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_reference_area" */
export type ProjectReferenceArea_Aggregate_Fields = {
  __typename?: 'projectReferenceArea_aggregate_fields';
  avg?: Maybe<ProjectReferenceArea_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectReferenceArea_Max_Fields>;
  min?: Maybe<ProjectReferenceArea_Min_Fields>;
  stddev?: Maybe<ProjectReferenceArea_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectReferenceArea_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectReferenceArea_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectReferenceArea_Sum_Fields>;
  var_pop?: Maybe<ProjectReferenceArea_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectReferenceArea_Var_Samp_Fields>;
  variance?: Maybe<ProjectReferenceArea_Variance_Fields>;
};


/** aggregate fields of "project_reference_area" */
export type ProjectReferenceArea_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_reference_area" */
export type ProjectReferenceArea_Aggregate_Order_By = {
  avg?: InputMaybe<ProjectReferenceArea_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectReferenceArea_Max_Order_By>;
  min?: InputMaybe<ProjectReferenceArea_Min_Order_By>;
  stddev?: InputMaybe<ProjectReferenceArea_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProjectReferenceArea_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProjectReferenceArea_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProjectReferenceArea_Sum_Order_By>;
  var_pop?: InputMaybe<ProjectReferenceArea_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProjectReferenceArea_Var_Samp_Order_By>;
  variance?: InputMaybe<ProjectReferenceArea_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_reference_area" */
export type ProjectReferenceArea_Arr_Rel_Insert_Input = {
  data: Array<ProjectReferenceArea_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectReferenceArea_On_Conflict>;
};

/** aggregate avg on columns */
export type ProjectReferenceArea_Avg_Fields = {
  __typename?: 'projectReferenceArea_avg_fields';
  area?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Avg_Order_By = {
  area?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_reference_area". All fields are combined with a logical 'AND'. */
export type ProjectReferenceArea_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectReferenceArea_Bool_Exp>>;
  _not?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectReferenceArea_Bool_Exp>>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  referenceAreaType?: InputMaybe<ReferenceAreaType_Bool_Exp>;
  referenceAreaTypeKey?: InputMaybe<String_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_reference_area" */
export enum ProjectReferenceArea_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_reference_area_pkey = 'project_reference_area_pkey'
}

/** input type for incrementing numeric columns in table "project_reference_area" */
export type ProjectReferenceArea_Inc_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_reference_area" */
export type ProjectReferenceArea_Insert_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  referenceAreaType?: InputMaybe<ReferenceAreaType_Obj_Rel_Insert_Input>;
  referenceAreaTypeKey?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectReferenceArea_Max_Fields = {
  __typename?: 'projectReferenceArea_max_fields';
  area?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  referenceAreaTypeKey?: Maybe<Scalars['String']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  referenceAreaTypeKey?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectReferenceArea_Min_Fields = {
  __typename?: 'projectReferenceArea_min_fields';
  area?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  referenceAreaTypeKey?: Maybe<Scalars['String']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  referenceAreaTypeKey?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_reference_area" */
export type ProjectReferenceArea_Mutation_Response = {
  __typename?: 'projectReferenceArea_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectReferenceArea>;
};

/** on_conflict condition type for table "project_reference_area" */
export type ProjectReferenceArea_On_Conflict = {
  constraint: ProjectReferenceArea_Constraint;
  update_columns?: Array<ProjectReferenceArea_Update_Column>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};

/** Ordering options when selecting data from "project_reference_area". */
export type ProjectReferenceArea_Order_By = {
  area?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  referenceAreaType?: InputMaybe<ReferenceAreaType_Order_By>;
  referenceAreaTypeKey?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_reference_area */
export type ProjectReferenceArea_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_reference_area" */
export enum ProjectReferenceArea_Select_Column {
  /** column name */
  area = 'area',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  referenceAreaTypeKey = 'referenceAreaTypeKey',
  /** column name */
  revisionId = 'revisionId'
}

/** input type for updating data in table "project_reference_area" */
export type ProjectReferenceArea_Set_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  referenceAreaTypeKey?: InputMaybe<Scalars['String']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type ProjectReferenceArea_Stddev_Fields = {
  __typename?: 'projectReferenceArea_stddev_fields';
  area?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Stddev_Order_By = {
  area?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProjectReferenceArea_Stddev_Pop_Fields = {
  __typename?: 'projectReferenceArea_stddev_pop_fields';
  area?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Stddev_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProjectReferenceArea_Stddev_Samp_Fields = {
  __typename?: 'projectReferenceArea_stddev_samp_fields';
  area?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Stddev_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projectReferenceArea" */
export type ProjectReferenceArea_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectReferenceArea_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectReferenceArea_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  referenceAreaTypeKey?: InputMaybe<Scalars['String']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ProjectReferenceArea_Sum_Fields = {
  __typename?: 'projectReferenceArea_sum_fields';
  area?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Sum_Order_By = {
  area?: InputMaybe<Order_By>;
};

/** update columns of table "project_reference_area" */
export enum ProjectReferenceArea_Update_Column {
  /** column name */
  area = 'area',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  referenceAreaTypeKey = 'referenceAreaTypeKey',
  /** column name */
  revisionId = 'revisionId'
}

export type ProjectReferenceArea_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectReferenceArea_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectReferenceArea_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectReferenceArea_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectReferenceArea_Var_Pop_Fields = {
  __typename?: 'projectReferenceArea_var_pop_fields';
  area?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Var_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProjectReferenceArea_Var_Samp_Fields = {
  __typename?: 'projectReferenceArea_var_samp_fields';
  area?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Var_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProjectReferenceArea_Variance_Fields = {
  __typename?: 'projectReferenceArea_variance_fields';
  area?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_reference_area" */
export type ProjectReferenceArea_Variance_Order_By = {
  area?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_revision" */
export type ProjectRevision = {
  __typename?: 'projectRevision';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  builderName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  buildingAreas: Array<ProjectBuildingArea>;
  /** An aggregate relationship */
  buildingAreas_aggregate: ProjectBuildingArea_Aggregate;
  /** An object relationship */
  buildingType?: Maybe<BuildingType>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  calculation?: Maybe<ProjectCalculation>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['uuid']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedBy?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  emissionFactors: Array<ProjectEmissionFactor>;
  /** An aggregate relationship */
  emissionFactors_aggregate: ProjectEmissionFactor_Aggregate;
  frozenAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  installation?: Maybe<ProjectInstallation>;
  lcaResponsibleName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  location?: Maybe<ProjectLocation>;
  martenVersion: Scalars['Int']['output'];
  /** An array relationship */
  models: Array<ProjectModel>;
  /** An aggregate relationship */
  models_aggregate: ProjectModel_Aggregate;
  name: Scalars['String']['output'];
  numberOfPeople?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  operational?: Maybe<ProjectOperational>;
  parentRevisionId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  projectName?: Maybe<Scalars['String']['output']>;
  projectNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  projectStatus?: Maybe<ProjectStatus>;
  projectStatusId?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  referenceAreas: Array<ProjectReferenceArea>;
  /** An aggregate relationship */
  referenceAreas_aggregate: ProjectReferenceArea_Aggregate;
  /** An object relationship */
  specialConditionConfig?: Maybe<ProjectSpecialConditionConfig>;
  /** An array relationship */
  specialConditionTypeMappings: Array<ProjectSpecialConditionTypeMapping>;
  /** An aggregate relationship */
  specialConditionTypeMappings_aggregate: ProjectSpecialConditionTypeMapping_Aggregate;
  speckleStreamId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  standardValueStages: Array<ProjectStandardValueStage>;
  /** An aggregate relationship */
  standardValueStages_aggregate: ProjectStandardValueStage_Aggregate;
  tenantId: Scalars['String']['output'];
  /** An array relationship */
  transportDefaults: Array<Project_Transport_Default>;
  /** An aggregate relationship */
  transportDefaults_aggregate: Project_Transport_Default_Aggregate;
  /** An array relationship */
  transportMappings: Array<Project_Transport_Mapping>;
  /** An aggregate relationship */
  transportMappings_aggregate: Project_Transport_Mapping_Aggregate;
  /** An array relationship */
  transports: Array<Project_Transport>;
  /** An aggregate relationship */
  transports_aggregate: Project_Transport_Aggregate;
  versionNumber: Scalars['Int']['output'];
  /** An array relationship */
  wasteMappings: Array<ProjectWasteMapping>;
  /** An aggregate relationship */
  wasteMappings_aggregate: ProjectWasteMapping_Aggregate;
  /** An array relationship */
  wasteTypeCustoms: Array<ProjectWasteTypeCustom>;
  /** An aggregate relationship */
  wasteTypeCustoms_aggregate: ProjectWasteTypeCustom_Aggregate;
  yearOfCommissioning?: Maybe<Scalars['Int']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionBuildingAreasArgs = {
  distinct_on?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectBuildingArea_Order_By>>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionBuildingAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectBuildingArea_Order_By>>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionEmissionFactorsArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionEmissionFactors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionModelsArgs = {
  distinct_on?: InputMaybe<Array<ProjectModel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModel_Order_By>>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionModels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectModel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModel_Order_By>>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionReferenceAreasArgs = {
  distinct_on?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectReferenceArea_Order_By>>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionReferenceAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectReferenceArea_Order_By>>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionSpecialConditionTypeMappingsArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionSpecialConditionTypeMappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionStandardValueStagesArgs = {
  distinct_on?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStandardValueStage_Order_By>>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionStandardValueStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStandardValueStage_Order_By>>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionTransportDefaultsArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Default_Order_By>>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionTransportDefaults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Default_Order_By>>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionTransportMappingsArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Mapping_Order_By>>;
  where?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionTransportMappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Mapping_Order_By>>;
  where?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionTransportsArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Order_By>>;
  where?: InputMaybe<Project_Transport_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionTransports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Order_By>>;
  where?: InputMaybe<Project_Transport_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionWasteMappingsArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteMapping_Order_By>>;
  where?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionWasteMappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteMapping_Order_By>>;
  where?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionWasteTypeCustomsArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteTypeCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteTypeCustom_Order_By>>;
  where?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
};


/** columns and relationships of "project_revision" */
export type ProjectRevisionWasteTypeCustoms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteTypeCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteTypeCustom_Order_By>>;
  where?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
};

/** aggregated selection of "project_revision" */
export type ProjectRevision_Aggregate = {
  __typename?: 'projectRevision_aggregate';
  aggregate?: Maybe<ProjectRevision_Aggregate_Fields>;
  nodes: Array<ProjectRevision>;
};

export type ProjectRevision_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectRevision_Aggregate_Bool_Exp_Count>;
};

export type ProjectRevision_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectRevision_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_revision" */
export type ProjectRevision_Aggregate_Fields = {
  __typename?: 'projectRevision_aggregate_fields';
  avg?: Maybe<ProjectRevision_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectRevision_Max_Fields>;
  min?: Maybe<ProjectRevision_Min_Fields>;
  stddev?: Maybe<ProjectRevision_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectRevision_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectRevision_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectRevision_Sum_Fields>;
  var_pop?: Maybe<ProjectRevision_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectRevision_Var_Samp_Fields>;
  variance?: Maybe<ProjectRevision_Variance_Fields>;
};


/** aggregate fields of "project_revision" */
export type ProjectRevision_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_revision" */
export type ProjectRevision_Aggregate_Order_By = {
  avg?: InputMaybe<ProjectRevision_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectRevision_Max_Order_By>;
  min?: InputMaybe<ProjectRevision_Min_Order_By>;
  stddev?: InputMaybe<ProjectRevision_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProjectRevision_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProjectRevision_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProjectRevision_Sum_Order_By>;
  var_pop?: InputMaybe<ProjectRevision_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProjectRevision_Var_Samp_Order_By>;
  variance?: InputMaybe<ProjectRevision_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_revision" */
export type ProjectRevision_Arr_Rel_Insert_Input = {
  data: Array<ProjectRevision_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectRevision_On_Conflict>;
};

/** aggregate avg on columns */
export type ProjectRevision_Avg_Fields = {
  __typename?: 'projectRevision_avg_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  martenVersion?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_revision" */
export type ProjectRevision_Avg_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_revision". All fields are combined with a logical 'AND'. */
export type ProjectRevision_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectRevision_Bool_Exp>>;
  _not?: InputMaybe<ProjectRevision_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectRevision_Bool_Exp>>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  builderName?: InputMaybe<String_Comparison_Exp>;
  buildingAreas?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
  buildingAreas_aggregate?: InputMaybe<ProjectBuildingArea_Aggregate_Bool_Exp>;
  buildingType?: InputMaybe<BuildingType_Bool_Exp>;
  buildingTypeId?: InputMaybe<Int_Comparison_Exp>;
  calculation?: InputMaybe<ProjectCalculation_Bool_Exp>;
  clientName?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedBy?: InputMaybe<Uuid_Comparison_Exp>;
  emissionFactors?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
  emissionFactors_aggregate?: InputMaybe<ProjectEmissionFactor_Aggregate_Bool_Exp>;
  frozenAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installation?: InputMaybe<ProjectInstallation_Bool_Exp>;
  lcaResponsibleName?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<ProjectLocation_Bool_Exp>;
  martenVersion?: InputMaybe<Int_Comparison_Exp>;
  models?: InputMaybe<ProjectModel_Bool_Exp>;
  models_aggregate?: InputMaybe<ProjectModel_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfPeople?: InputMaybe<Numeric_Comparison_Exp>;
  operational?: InputMaybe<ProjectOperational_Bool_Exp>;
  parentRevisionId?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  projectName?: InputMaybe<String_Comparison_Exp>;
  projectNumber?: InputMaybe<String_Comparison_Exp>;
  projectStatus?: InputMaybe<ProjectStatus_Bool_Exp>;
  projectStatusId?: InputMaybe<Int_Comparison_Exp>;
  referenceAreas?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
  referenceAreas_aggregate?: InputMaybe<ProjectReferenceArea_Aggregate_Bool_Exp>;
  specialConditionConfig?: InputMaybe<ProjectSpecialConditionConfig_Bool_Exp>;
  specialConditionTypeMappings?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
  specialConditionTypeMappings_aggregate?: InputMaybe<ProjectSpecialConditionTypeMapping_Aggregate_Bool_Exp>;
  speckleStreamId?: InputMaybe<String_Comparison_Exp>;
  standardValueStages?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
  standardValueStages_aggregate?: InputMaybe<ProjectStandardValueStage_Aggregate_Bool_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  transportDefaults?: InputMaybe<Project_Transport_Default_Bool_Exp>;
  transportDefaults_aggregate?: InputMaybe<Project_Transport_Default_Aggregate_Bool_Exp>;
  transportMappings?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
  transportMappings_aggregate?: InputMaybe<Project_Transport_Mapping_Aggregate_Bool_Exp>;
  transports?: InputMaybe<Project_Transport_Bool_Exp>;
  transports_aggregate?: InputMaybe<Project_Transport_Aggregate_Bool_Exp>;
  versionNumber?: InputMaybe<Int_Comparison_Exp>;
  wasteMappings?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
  wasteMappings_aggregate?: InputMaybe<ProjectWasteMapping_Aggregate_Bool_Exp>;
  wasteTypeCustoms?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
  wasteTypeCustoms_aggregate?: InputMaybe<ProjectWasteTypeCustom_Aggregate_Bool_Exp>;
  yearOfCommissioning?: InputMaybe<Int_Comparison_Exp>;
  yearOfConstruction?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_revision" */
export enum ProjectRevision_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_revision_pkey = 'project_revision_pkey'
}

/** input type for incrementing numeric columns in table "project_revision" */
export type ProjectRevision_Inc_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  numberOfPeople?: InputMaybe<Scalars['numeric']['input']>;
  projectStatusId?: InputMaybe<Scalars['Int']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
  yearOfCommissioning?: InputMaybe<Scalars['Int']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_revision" */
export type ProjectRevision_Insert_Input = {
  builderName?: InputMaybe<Scalars['String']['input']>;
  buildingAreas?: InputMaybe<ProjectBuildingArea_Arr_Rel_Insert_Input>;
  buildingType?: InputMaybe<BuildingType_Obj_Rel_Insert_Input>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  calculation?: InputMaybe<ProjectCalculation_Obj_Rel_Insert_Input>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedBy?: InputMaybe<Scalars['uuid']['input']>;
  emissionFactors?: InputMaybe<ProjectEmissionFactor_Arr_Rel_Insert_Input>;
  frozenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation?: InputMaybe<ProjectInstallation_Obj_Rel_Insert_Input>;
  lcaResponsibleName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ProjectLocation_Obj_Rel_Insert_Input>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  models?: InputMaybe<ProjectModel_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfPeople?: InputMaybe<Scalars['numeric']['input']>;
  operational?: InputMaybe<ProjectOperational_Obj_Rel_Insert_Input>;
  parentRevisionId?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
  projectStatus?: InputMaybe<ProjectStatus_Obj_Rel_Insert_Input>;
  projectStatusId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreas?: InputMaybe<ProjectReferenceArea_Arr_Rel_Insert_Input>;
  specialConditionConfig?: InputMaybe<ProjectSpecialConditionConfig_Obj_Rel_Insert_Input>;
  specialConditionTypeMappings?: InputMaybe<ProjectSpecialConditionTypeMapping_Arr_Rel_Insert_Input>;
  speckleStreamId?: InputMaybe<Scalars['String']['input']>;
  standardValueStages?: InputMaybe<ProjectStandardValueStage_Arr_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  transportDefaults?: InputMaybe<Project_Transport_Default_Arr_Rel_Insert_Input>;
  transportMappings?: InputMaybe<Project_Transport_Mapping_Arr_Rel_Insert_Input>;
  transports?: InputMaybe<Project_Transport_Arr_Rel_Insert_Input>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
  wasteMappings?: InputMaybe<ProjectWasteMapping_Arr_Rel_Insert_Input>;
  wasteTypeCustoms?: InputMaybe<ProjectWasteTypeCustom_Arr_Rel_Insert_Input>;
  yearOfCommissioning?: InputMaybe<Scalars['Int']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ProjectRevision_Max_Fields = {
  __typename?: 'projectRevision_max_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  builderName?: Maybe<Scalars['String']['output']>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedBy?: Maybe<Scalars['uuid']['output']>;
  frozenAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lcaResponsibleName?: Maybe<Scalars['String']['output']>;
  martenVersion?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPeople?: Maybe<Scalars['numeric']['output']>;
  parentRevisionId?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  projectNumber?: Maybe<Scalars['String']['output']>;
  projectStatusId?: Maybe<Scalars['Int']['output']>;
  speckleStreamId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Int']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "project_revision" */
export type ProjectRevision_Max_Order_By = {
  builderName?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  clientName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  deletedBy?: InputMaybe<Order_By>;
  frozenAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lcaResponsibleName?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  parentRevisionId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectName?: InputMaybe<Order_By>;
  projectNumber?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  speckleStreamId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectRevision_Min_Fields = {
  __typename?: 'projectRevision_min_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  builderName?: Maybe<Scalars['String']['output']>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedBy?: Maybe<Scalars['uuid']['output']>;
  frozenAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lcaResponsibleName?: Maybe<Scalars['String']['output']>;
  martenVersion?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPeople?: Maybe<Scalars['numeric']['output']>;
  parentRevisionId?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  projectNumber?: Maybe<Scalars['String']['output']>;
  projectStatusId?: Maybe<Scalars['Int']['output']>;
  speckleStreamId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Int']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "project_revision" */
export type ProjectRevision_Min_Order_By = {
  builderName?: InputMaybe<Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  clientName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  deletedBy?: InputMaybe<Order_By>;
  frozenAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lcaResponsibleName?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  parentRevisionId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectName?: InputMaybe<Order_By>;
  projectNumber?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  speckleStreamId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_revision" */
export type ProjectRevision_Mutation_Response = {
  __typename?: 'projectRevision_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectRevision>;
};

/** input type for inserting object relation for remote table "project_revision" */
export type ProjectRevision_Obj_Rel_Insert_Input = {
  data: ProjectRevision_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectRevision_On_Conflict>;
};

/** on_conflict condition type for table "project_revision" */
export type ProjectRevision_On_Conflict = {
  constraint: ProjectRevision_Constraint;
  update_columns?: Array<ProjectRevision_Update_Column>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};

/** Ordering options when selecting data from "project_revision". */
export type ProjectRevision_Order_By = {
  area?: InputMaybe<Order_By>;
  builderName?: InputMaybe<Order_By>;
  buildingAreas_aggregate?: InputMaybe<ProjectBuildingArea_Aggregate_Order_By>;
  buildingType?: InputMaybe<BuildingType_Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  calculation?: InputMaybe<ProjectCalculation_Order_By>;
  clientName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  deletedBy?: InputMaybe<Order_By>;
  emissionFactors_aggregate?: InputMaybe<ProjectEmissionFactor_Aggregate_Order_By>;
  frozenAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation?: InputMaybe<ProjectInstallation_Order_By>;
  lcaResponsibleName?: InputMaybe<Order_By>;
  location?: InputMaybe<ProjectLocation_Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  models_aggregate?: InputMaybe<ProjectModel_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  operational?: InputMaybe<ProjectOperational_Order_By>;
  parentRevisionId?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectName?: InputMaybe<Order_By>;
  projectNumber?: InputMaybe<Order_By>;
  projectStatus?: InputMaybe<ProjectStatus_Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  referenceAreas_aggregate?: InputMaybe<ProjectReferenceArea_Aggregate_Order_By>;
  specialConditionConfig?: InputMaybe<ProjectSpecialConditionConfig_Order_By>;
  specialConditionTypeMappings_aggregate?: InputMaybe<ProjectSpecialConditionTypeMapping_Aggregate_Order_By>;
  speckleStreamId?: InputMaybe<Order_By>;
  standardValueStages_aggregate?: InputMaybe<ProjectStandardValueStage_Aggregate_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  transportDefaults_aggregate?: InputMaybe<Project_Transport_Default_Aggregate_Order_By>;
  transportMappings_aggregate?: InputMaybe<Project_Transport_Mapping_Aggregate_Order_By>;
  transports_aggregate?: InputMaybe<Project_Transport_Aggregate_Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  wasteMappings_aggregate?: InputMaybe<ProjectWasteMapping_Aggregate_Order_By>;
  wasteTypeCustoms_aggregate?: InputMaybe<ProjectWasteTypeCustom_Aggregate_Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_revision */
export type ProjectRevision_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_revision" */
export enum ProjectRevision_Select_Column {
  /** column name */
  builderName = 'builderName',
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  clientName = 'clientName',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  deletedBy = 'deletedBy',
  /** column name */
  frozenAt = 'frozenAt',
  /** column name */
  id = 'id',
  /** column name */
  lcaResponsibleName = 'lcaResponsibleName',
  /** column name */
  martenVersion = 'martenVersion',
  /** column name */
  name = 'name',
  /** column name */
  numberOfPeople = 'numberOfPeople',
  /** column name */
  parentRevisionId = 'parentRevisionId',
  /** column name */
  projectId = 'projectId',
  /** column name */
  projectName = 'projectName',
  /** column name */
  projectNumber = 'projectNumber',
  /** column name */
  projectStatusId = 'projectStatusId',
  /** column name */
  speckleStreamId = 'speckleStreamId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  versionNumber = 'versionNumber',
  /** column name */
  yearOfCommissioning = 'yearOfCommissioning',
  /** column name */
  yearOfConstruction = 'yearOfConstruction'
}

/** input type for updating data in table "project_revision" */
export type ProjectRevision_Set_Input = {
  builderName?: InputMaybe<Scalars['String']['input']>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedBy?: InputMaybe<Scalars['uuid']['input']>;
  frozenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lcaResponsibleName?: InputMaybe<Scalars['String']['input']>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfPeople?: InputMaybe<Scalars['numeric']['input']>;
  parentRevisionId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
  projectStatusId?: InputMaybe<Scalars['Int']['input']>;
  speckleStreamId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
  yearOfCommissioning?: InputMaybe<Scalars['Int']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ProjectRevision_Stddev_Fields = {
  __typename?: 'projectRevision_stddev_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  martenVersion?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_revision" */
export type ProjectRevision_Stddev_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProjectRevision_Stddev_Pop_Fields = {
  __typename?: 'projectRevision_stddev_pop_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  martenVersion?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_revision" */
export type ProjectRevision_Stddev_Pop_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProjectRevision_Stddev_Samp_Fields = {
  __typename?: 'projectRevision_stddev_samp_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  martenVersion?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_revision" */
export type ProjectRevision_Stddev_Samp_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projectRevision" */
export type ProjectRevision_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectRevision_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectRevision_Stream_Cursor_Value_Input = {
  builderName?: InputMaybe<Scalars['String']['input']>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedBy?: InputMaybe<Scalars['uuid']['input']>;
  frozenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lcaResponsibleName?: InputMaybe<Scalars['String']['input']>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfPeople?: InputMaybe<Scalars['numeric']['input']>;
  parentRevisionId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
  projectStatusId?: InputMaybe<Scalars['Int']['input']>;
  speckleStreamId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
  yearOfCommissioning?: InputMaybe<Scalars['Int']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ProjectRevision_Sum_Fields = {
  __typename?: 'projectRevision_sum_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  martenVersion?: Maybe<Scalars['Int']['output']>;
  numberOfPeople?: Maybe<Scalars['numeric']['output']>;
  projectStatusId?: Maybe<Scalars['Int']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Int']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "project_revision" */
export type ProjectRevision_Sum_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** update columns of table "project_revision" */
export enum ProjectRevision_Update_Column {
  /** column name */
  builderName = 'builderName',
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  clientName = 'clientName',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  deletedBy = 'deletedBy',
  /** column name */
  frozenAt = 'frozenAt',
  /** column name */
  id = 'id',
  /** column name */
  lcaResponsibleName = 'lcaResponsibleName',
  /** column name */
  martenVersion = 'martenVersion',
  /** column name */
  name = 'name',
  /** column name */
  numberOfPeople = 'numberOfPeople',
  /** column name */
  parentRevisionId = 'parentRevisionId',
  /** column name */
  projectId = 'projectId',
  /** column name */
  projectName = 'projectName',
  /** column name */
  projectNumber = 'projectNumber',
  /** column name */
  projectStatusId = 'projectStatusId',
  /** column name */
  speckleStreamId = 'speckleStreamId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  versionNumber = 'versionNumber',
  /** column name */
  yearOfCommissioning = 'yearOfCommissioning',
  /** column name */
  yearOfConstruction = 'yearOfConstruction'
}

export type ProjectRevision_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectRevision_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectRevision_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectRevision_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectRevision_Var_Pop_Fields = {
  __typename?: 'projectRevision_var_pop_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  martenVersion?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_revision" */
export type ProjectRevision_Var_Pop_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProjectRevision_Var_Samp_Fields = {
  __typename?: 'projectRevision_var_samp_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  martenVersion?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_revision" */
export type ProjectRevision_Var_Samp_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProjectRevision_Variance_Fields = {
  __typename?: 'projectRevision_variance_fields';
  /** project.area for this revision's row set — building/reference areas and calculation type scoped by revision_id, so the as-of read composes with the same figure the live head would report for the same rows (RTLCA-5246). */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  martenVersion?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_revision" */
export type ProjectRevision_Variance_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_special_condition_config" */
export type ProjectSpecialConditionConfig = {
  __typename?: 'projectSpecialConditionConfig';
  enabled: Scalars['Boolean']['output'];
  /** An object relationship */
  project?: Maybe<Project>;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_special_condition_config" */
export type ProjectSpecialConditionConfig_Aggregate = {
  __typename?: 'projectSpecialConditionConfig_aggregate';
  aggregate?: Maybe<ProjectSpecialConditionConfig_Aggregate_Fields>;
  nodes: Array<ProjectSpecialConditionConfig>;
};

/** aggregate fields of "project_special_condition_config" */
export type ProjectSpecialConditionConfig_Aggregate_Fields = {
  __typename?: 'projectSpecialConditionConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectSpecialConditionConfig_Max_Fields>;
  min?: Maybe<ProjectSpecialConditionConfig_Min_Fields>;
};


/** aggregate fields of "project_special_condition_config" */
export type ProjectSpecialConditionConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectSpecialConditionConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_special_condition_config". All fields are combined with a logical 'AND'. */
export type ProjectSpecialConditionConfig_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectSpecialConditionConfig_Bool_Exp>>;
  _not?: InputMaybe<ProjectSpecialConditionConfig_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectSpecialConditionConfig_Bool_Exp>>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_special_condition_config" */
export enum ProjectSpecialConditionConfig_Constraint {
  /** unique or primary key constraint on columns "revision_id", "project_id" */
  project_special_condition_config_pkey = 'project_special_condition_config_pkey'
}

/** input type for inserting data into table "project_special_condition_config" */
export type ProjectSpecialConditionConfig_Insert_Input = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectSpecialConditionConfig_Max_Fields = {
  __typename?: 'projectSpecialConditionConfig_max_fields';
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ProjectSpecialConditionConfig_Min_Fields = {
  __typename?: 'projectSpecialConditionConfig_min_fields';
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "project_special_condition_config" */
export type ProjectSpecialConditionConfig_Mutation_Response = {
  __typename?: 'projectSpecialConditionConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectSpecialConditionConfig>;
};

/** input type for inserting object relation for remote table "project_special_condition_config" */
export type ProjectSpecialConditionConfig_Obj_Rel_Insert_Input = {
  data: ProjectSpecialConditionConfig_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectSpecialConditionConfig_On_Conflict>;
};

/** on_conflict condition type for table "project_special_condition_config" */
export type ProjectSpecialConditionConfig_On_Conflict = {
  constraint: ProjectSpecialConditionConfig_Constraint;
  update_columns?: Array<ProjectSpecialConditionConfig_Update_Column>;
  where?: InputMaybe<ProjectSpecialConditionConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "project_special_condition_config". */
export type ProjectSpecialConditionConfig_Order_By = {
  enabled?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_special_condition_config */
export type ProjectSpecialConditionConfig_Pk_Columns_Input = {
  projectId: Scalars['uuid']['input'];
  revisionId: Scalars['uuid']['input'];
};

/** select columns of table "project_special_condition_config" */
export enum ProjectSpecialConditionConfig_Select_Column {
  /** column name */
  enabled = 'enabled',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId'
}

/** input type for updating data in table "project_special_condition_config" */
export type ProjectSpecialConditionConfig_Set_Input = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "projectSpecialConditionConfig" */
export type ProjectSpecialConditionConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectSpecialConditionConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectSpecialConditionConfig_Stream_Cursor_Value_Input = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_special_condition_config" */
export enum ProjectSpecialConditionConfig_Update_Column {
  /** column name */
  enabled = 'enabled',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId'
}

export type ProjectSpecialConditionConfig_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectSpecialConditionConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectSpecialConditionConfig_Bool_Exp;
};

/** columns and relationships of "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping = {
  __typename?: 'projectSpecialConditionTypeMapping';
  areaOfConstruction?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  length?: Maybe<Scalars['numeric']['output']>;
  model: Scalars['String']['output'];
  /** An object relationship */
  project?: Maybe<Project>;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  /** An object relationship */
  specialConditionType: SpecialConditionType;
  specialConditionTypeId: Scalars['uuid']['output'];
  tenantId: Scalars['uuid']['output'];
  typeIdentifier?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Aggregate = {
  __typename?: 'projectSpecialConditionTypeMapping_aggregate';
  aggregate?: Maybe<ProjectSpecialConditionTypeMapping_Aggregate_Fields>;
  nodes: Array<ProjectSpecialConditionTypeMapping>;
};

export type ProjectSpecialConditionTypeMapping_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectSpecialConditionTypeMapping_Aggregate_Bool_Exp_Count>;
};

export type ProjectSpecialConditionTypeMapping_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Aggregate_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_aggregate_fields';
  avg?: Maybe<ProjectSpecialConditionTypeMapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectSpecialConditionTypeMapping_Max_Fields>;
  min?: Maybe<ProjectSpecialConditionTypeMapping_Min_Fields>;
  stddev?: Maybe<ProjectSpecialConditionTypeMapping_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectSpecialConditionTypeMapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectSpecialConditionTypeMapping_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectSpecialConditionTypeMapping_Sum_Fields>;
  var_pop?: Maybe<ProjectSpecialConditionTypeMapping_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectSpecialConditionTypeMapping_Var_Samp_Fields>;
  variance?: Maybe<ProjectSpecialConditionTypeMapping_Variance_Fields>;
};


/** aggregate fields of "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Aggregate_Order_By = {
  avg?: InputMaybe<ProjectSpecialConditionTypeMapping_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectSpecialConditionTypeMapping_Max_Order_By>;
  min?: InputMaybe<ProjectSpecialConditionTypeMapping_Min_Order_By>;
  stddev?: InputMaybe<ProjectSpecialConditionTypeMapping_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProjectSpecialConditionTypeMapping_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProjectSpecialConditionTypeMapping_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProjectSpecialConditionTypeMapping_Sum_Order_By>;
  var_pop?: InputMaybe<ProjectSpecialConditionTypeMapping_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProjectSpecialConditionTypeMapping_Var_Samp_Order_By>;
  variance?: InputMaybe<ProjectSpecialConditionTypeMapping_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Arr_Rel_Insert_Input = {
  data: Array<ProjectSpecialConditionTypeMapping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectSpecialConditionTypeMapping_On_Conflict>;
};

/** aggregate avg on columns */
export type ProjectSpecialConditionTypeMapping_Avg_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_avg_fields';
  areaOfConstruction?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Avg_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_special_condition_type_mapping". All fields are combined with a logical 'AND'. */
export type ProjectSpecialConditionTypeMapping_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Bool_Exp>>;
  _not?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Bool_Exp>>;
  areaOfConstruction?: InputMaybe<Numeric_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  length?: InputMaybe<Numeric_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  specialConditionType?: InputMaybe<SpecialConditionType_Bool_Exp>;
  specialConditionTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  typeIdentifier?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_special_condition_type_mapping" */
export enum ProjectSpecialConditionTypeMapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_special_circumstance_type_pkey = 'project_special_circumstance_type_pkey',
  /** unique or primary key constraint on columns "revision_id", "project_id", "type_identifier", "model" */
  project_special_condition_type_mapping_model_project_id_type_id = 'project_special_condition_type_mapping_model_project_id_type_id'
}

/** input type for incrementing numeric columns in table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Inc_Input = {
  areaOfConstruction?: InputMaybe<Scalars['numeric']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Insert_Input = {
  areaOfConstruction?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  specialConditionType?: InputMaybe<SpecialConditionType_Obj_Rel_Insert_Input>;
  specialConditionTypeId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectSpecialConditionTypeMapping_Max_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_max_fields';
  areaOfConstruction?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  specialConditionTypeId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Max_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  specialConditionTypeId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  typeIdentifier?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectSpecialConditionTypeMapping_Min_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_min_fields';
  areaOfConstruction?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  specialConditionTypeId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Min_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  specialConditionTypeId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  typeIdentifier?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Mutation_Response = {
  __typename?: 'projectSpecialConditionTypeMapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectSpecialConditionTypeMapping>;
};

/** on_conflict condition type for table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_On_Conflict = {
  constraint: ProjectSpecialConditionTypeMapping_Constraint;
  update_columns?: Array<ProjectSpecialConditionTypeMapping_Update_Column>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};

/** Ordering options when selecting data from "project_special_condition_type_mapping". */
export type ProjectSpecialConditionTypeMapping_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  specialConditionType?: InputMaybe<SpecialConditionType_Order_By>;
  specialConditionTypeId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  typeIdentifier?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_special_condition_type_mapping */
export type ProjectSpecialConditionTypeMapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_special_condition_type_mapping" */
export enum ProjectSpecialConditionTypeMapping_Select_Column {
  /** column name */
  areaOfConstruction = 'areaOfConstruction',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  length = 'length',
  /** column name */
  model = 'model',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  specialConditionTypeId = 'specialConditionTypeId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  typeIdentifier = 'typeIdentifier'
}

/** input type for updating data in table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Set_Input = {
  areaOfConstruction?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  specialConditionTypeId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ProjectSpecialConditionTypeMapping_Stddev_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_stddev_fields';
  areaOfConstruction?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Stddev_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProjectSpecialConditionTypeMapping_Stddev_Pop_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_stddev_pop_fields';
  areaOfConstruction?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Stddev_Pop_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProjectSpecialConditionTypeMapping_Stddev_Samp_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_stddev_samp_fields';
  areaOfConstruction?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Stddev_Samp_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projectSpecialConditionTypeMapping" */
export type ProjectSpecialConditionTypeMapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectSpecialConditionTypeMapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectSpecialConditionTypeMapping_Stream_Cursor_Value_Input = {
  areaOfConstruction?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  specialConditionTypeId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ProjectSpecialConditionTypeMapping_Sum_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_sum_fields';
  areaOfConstruction?: Maybe<Scalars['numeric']['output']>;
  length?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Sum_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
};

/** update columns of table "project_special_condition_type_mapping" */
export enum ProjectSpecialConditionTypeMapping_Update_Column {
  /** column name */
  areaOfConstruction = 'areaOfConstruction',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  length = 'length',
  /** column name */
  model = 'model',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  specialConditionTypeId = 'specialConditionTypeId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  typeIdentifier = 'typeIdentifier'
}

export type ProjectSpecialConditionTypeMapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectSpecialConditionTypeMapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectSpecialConditionTypeMapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectSpecialConditionTypeMapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectSpecialConditionTypeMapping_Var_Pop_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_var_pop_fields';
  areaOfConstruction?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Var_Pop_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProjectSpecialConditionTypeMapping_Var_Samp_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_var_samp_fields';
  areaOfConstruction?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Var_Samp_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProjectSpecialConditionTypeMapping_Variance_Fields = {
  __typename?: 'projectSpecialConditionTypeMapping_variance_fields';
  areaOfConstruction?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_special_condition_type_mapping" */
export type ProjectSpecialConditionTypeMapping_Variance_Order_By = {
  areaOfConstruction?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_speckle_copy" */
export type ProjectSpeckleCopy = {
  __typename?: 'projectSpeckleCopy';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated: Scalars['timestamptz']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  state: Scalars['String']['output'];
};

/** columns and relationships of "project_speckle_copy_recent" */
export type ProjectSpeckleCopyRecent = {
  __typename?: 'projectSpeckleCopyRecent';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "project_speckle_copy_recent" */
export type ProjectSpeckleCopyRecent_Aggregate = {
  __typename?: 'projectSpeckleCopyRecent_aggregate';
  aggregate?: Maybe<ProjectSpeckleCopyRecent_Aggregate_Fields>;
  nodes: Array<ProjectSpeckleCopyRecent>;
};

/** aggregate fields of "project_speckle_copy_recent" */
export type ProjectSpeckleCopyRecent_Aggregate_Fields = {
  __typename?: 'projectSpeckleCopyRecent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectSpeckleCopyRecent_Max_Fields>;
  min?: Maybe<ProjectSpeckleCopyRecent_Min_Fields>;
};


/** aggregate fields of "project_speckle_copy_recent" */
export type ProjectSpeckleCopyRecent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectSpeckleCopyRecent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_speckle_copy_recent". All fields are combined with a logical 'AND'. */
export type ProjectSpeckleCopyRecent_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectSpeckleCopyRecent_Bool_Exp>>;
  _not?: InputMaybe<ProjectSpeckleCopyRecent_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectSpeckleCopyRecent_Bool_Exp>>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  lastUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "project_speckle_copy_recent" */
export type ProjectSpeckleCopyRecent_Insert_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectSpeckleCopyRecent_Max_Fields = {
  __typename?: 'projectSpeckleCopyRecent_max_fields';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectSpeckleCopyRecent_Min_Fields = {
  __typename?: 'projectSpeckleCopyRecent_min_fields';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_speckle_copy_recent" */
export type ProjectSpeckleCopyRecent_Mutation_Response = {
  __typename?: 'projectSpeckleCopyRecent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectSpeckleCopyRecent>;
};

/** Ordering options when selecting data from "project_speckle_copy_recent". */
export type ProjectSpeckleCopyRecent_Order_By = {
  errorMessage?: InputMaybe<Order_By>;
  lastUpdated?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** select columns of table "project_speckle_copy_recent" */
export enum ProjectSpeckleCopyRecent_Select_Column {
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  lastUpdated = 'lastUpdated',
  /** column name */
  projectId = 'projectId',
  /** column name */
  state = 'state'
}

/** input type for updating data in table "project_speckle_copy_recent" */
export type ProjectSpeckleCopyRecent_Set_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "projectSpeckleCopyRecent" */
export type ProjectSpeckleCopyRecent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectSpeckleCopyRecent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectSpeckleCopyRecent_Stream_Cursor_Value_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectSpeckleCopyRecent_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectSpeckleCopyRecent_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectSpeckleCopyRecent_Bool_Exp;
};

/** aggregated selection of "project_speckle_copy" */
export type ProjectSpeckleCopy_Aggregate = {
  __typename?: 'projectSpeckleCopy_aggregate';
  aggregate?: Maybe<ProjectSpeckleCopy_Aggregate_Fields>;
  nodes: Array<ProjectSpeckleCopy>;
};

/** aggregate fields of "project_speckle_copy" */
export type ProjectSpeckleCopy_Aggregate_Fields = {
  __typename?: 'projectSpeckleCopy_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectSpeckleCopy_Max_Fields>;
  min?: Maybe<ProjectSpeckleCopy_Min_Fields>;
};


/** aggregate fields of "project_speckle_copy" */
export type ProjectSpeckleCopy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectSpeckleCopy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_speckle_copy". All fields are combined with a logical 'AND'. */
export type ProjectSpeckleCopy_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectSpeckleCopy_Bool_Exp>>;
  _not?: InputMaybe<ProjectSpeckleCopy_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectSpeckleCopy_Bool_Exp>>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  lastUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_speckle_copy" */
export enum ProjectSpeckleCopy_Constraint {
  /** unique or primary key constraint on columns "project_id" */
  project_speckle_copy_pkey = 'project_speckle_copy_pkey'
}

/** input type for inserting data into table "project_speckle_copy" */
export type ProjectSpeckleCopy_Insert_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectSpeckleCopy_Max_Fields = {
  __typename?: 'projectSpeckleCopy_max_fields';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectSpeckleCopy_Min_Fields = {
  __typename?: 'projectSpeckleCopy_min_fields';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_speckle_copy" */
export type ProjectSpeckleCopy_Mutation_Response = {
  __typename?: 'projectSpeckleCopy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectSpeckleCopy>;
};

/** on_conflict condition type for table "project_speckle_copy" */
export type ProjectSpeckleCopy_On_Conflict = {
  constraint: ProjectSpeckleCopy_Constraint;
  update_columns?: Array<ProjectSpeckleCopy_Update_Column>;
  where?: InputMaybe<ProjectSpeckleCopy_Bool_Exp>;
};

/** Ordering options when selecting data from "project_speckle_copy". */
export type ProjectSpeckleCopy_Order_By = {
  errorMessage?: InputMaybe<Order_By>;
  lastUpdated?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_speckle_copy */
export type ProjectSpeckleCopy_Pk_Columns_Input = {
  projectId: Scalars['uuid']['input'];
};

/** select columns of table "project_speckle_copy" */
export enum ProjectSpeckleCopy_Select_Column {
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  lastUpdated = 'lastUpdated',
  /** column name */
  projectId = 'projectId',
  /** column name */
  state = 'state'
}

/** input type for updating data in table "project_speckle_copy" */
export type ProjectSpeckleCopy_Set_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "projectSpeckleCopy" */
export type ProjectSpeckleCopy_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectSpeckleCopy_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectSpeckleCopy_Stream_Cursor_Value_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_speckle_copy" */
export enum ProjectSpeckleCopy_Update_Column {
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  lastUpdated = 'lastUpdated',
  /** column name */
  projectId = 'projectId',
  /** column name */
  state = 'state'
}

export type ProjectSpeckleCopy_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectSpeckleCopy_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectSpeckleCopy_Bool_Exp;
};

/** columns and relationships of "project_speckle_model_sync" */
export type ProjectSpeckleModelSync = {
  __typename?: 'projectSpeckleModelSync';
  allowImport: Scalars['Boolean']['output'];
  attempts: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated: Scalars['timestamptz']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  requestedAt: Scalars['timestamptz']['output'];
  state: Scalars['String']['output'];
};

/** columns and relationships of "project_speckle_model_sync_recent" */
export type ProjectSpeckleModelSyncRecent = {
  __typename?: 'projectSpeckleModelSyncRecent';
  allowImport?: Maybe<Scalars['Boolean']['output']>;
  attempts?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  requestedAt?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "project_speckle_model_sync_recent" */
export type ProjectSpeckleModelSyncRecent_Aggregate = {
  __typename?: 'projectSpeckleModelSyncRecent_aggregate';
  aggregate?: Maybe<ProjectSpeckleModelSyncRecent_Aggregate_Fields>;
  nodes: Array<ProjectSpeckleModelSyncRecent>;
};

/** aggregate fields of "project_speckle_model_sync_recent" */
export type ProjectSpeckleModelSyncRecent_Aggregate_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_aggregate_fields';
  avg?: Maybe<ProjectSpeckleModelSyncRecent_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectSpeckleModelSyncRecent_Max_Fields>;
  min?: Maybe<ProjectSpeckleModelSyncRecent_Min_Fields>;
  stddev?: Maybe<ProjectSpeckleModelSyncRecent_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectSpeckleModelSyncRecent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectSpeckleModelSyncRecent_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectSpeckleModelSyncRecent_Sum_Fields>;
  var_pop?: Maybe<ProjectSpeckleModelSyncRecent_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectSpeckleModelSyncRecent_Var_Samp_Fields>;
  variance?: Maybe<ProjectSpeckleModelSyncRecent_Variance_Fields>;
};


/** aggregate fields of "project_speckle_model_sync_recent" */
export type ProjectSpeckleModelSyncRecent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ProjectSpeckleModelSyncRecent_Avg_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_avg_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_speckle_model_sync_recent". All fields are combined with a logical 'AND'. */
export type ProjectSpeckleModelSyncRecent_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Bool_Exp>>;
  _not?: InputMaybe<ProjectSpeckleModelSyncRecent_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Bool_Exp>>;
  allowImport?: InputMaybe<Boolean_Comparison_Exp>;
  attempts?: InputMaybe<Int_Comparison_Exp>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  lastUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  requestedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "project_speckle_model_sync_recent" */
export type ProjectSpeckleModelSyncRecent_Inc_Input = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_speckle_model_sync_recent" */
export type ProjectSpeckleModelSyncRecent_Insert_Input = {
  allowImport?: InputMaybe<Scalars['Boolean']['input']>;
  attempts?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  requestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectSpeckleModelSyncRecent_Max_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_max_fields';
  attempts?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  requestedAt?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectSpeckleModelSyncRecent_Min_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_min_fields';
  attempts?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  requestedAt?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_speckle_model_sync_recent" */
export type ProjectSpeckleModelSyncRecent_Mutation_Response = {
  __typename?: 'projectSpeckleModelSyncRecent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectSpeckleModelSyncRecent>;
};

/** Ordering options when selecting data from "project_speckle_model_sync_recent". */
export type ProjectSpeckleModelSyncRecent_Order_By = {
  allowImport?: InputMaybe<Order_By>;
  attempts?: InputMaybe<Order_By>;
  errorMessage?: InputMaybe<Order_By>;
  lastUpdated?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  requestedAt?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** select columns of table "project_speckle_model_sync_recent" */
export enum ProjectSpeckleModelSyncRecent_Select_Column {
  /** column name */
  allowImport = 'allowImport',
  /** column name */
  attempts = 'attempts',
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  lastUpdated = 'lastUpdated',
  /** column name */
  projectId = 'projectId',
  /** column name */
  requestedAt = 'requestedAt',
  /** column name */
  state = 'state'
}

/** input type for updating data in table "project_speckle_model_sync_recent" */
export type ProjectSpeckleModelSyncRecent_Set_Input = {
  allowImport?: InputMaybe<Scalars['Boolean']['input']>;
  attempts?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  requestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ProjectSpeckleModelSyncRecent_Stddev_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_stddev_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ProjectSpeckleModelSyncRecent_Stddev_Pop_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_stddev_pop_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ProjectSpeckleModelSyncRecent_Stddev_Samp_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_stddev_samp_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projectSpeckleModelSyncRecent" */
export type ProjectSpeckleModelSyncRecent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectSpeckleModelSyncRecent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectSpeckleModelSyncRecent_Stream_Cursor_Value_Input = {
  allowImport?: InputMaybe<Scalars['Boolean']['input']>;
  attempts?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  requestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ProjectSpeckleModelSyncRecent_Sum_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_sum_fields';
  attempts?: Maybe<Scalars['Int']['output']>;
};

export type ProjectSpeckleModelSyncRecent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectSpeckleModelSyncRecent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectSpeckleModelSyncRecent_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectSpeckleModelSyncRecent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectSpeckleModelSyncRecent_Var_Pop_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_var_pop_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ProjectSpeckleModelSyncRecent_Var_Samp_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_var_samp_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ProjectSpeckleModelSyncRecent_Variance_Fields = {
  __typename?: 'projectSpeckleModelSyncRecent_variance_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "project_speckle_model_sync" */
export type ProjectSpeckleModelSync_Aggregate = {
  __typename?: 'projectSpeckleModelSync_aggregate';
  aggregate?: Maybe<ProjectSpeckleModelSync_Aggregate_Fields>;
  nodes: Array<ProjectSpeckleModelSync>;
};

/** aggregate fields of "project_speckle_model_sync" */
export type ProjectSpeckleModelSync_Aggregate_Fields = {
  __typename?: 'projectSpeckleModelSync_aggregate_fields';
  avg?: Maybe<ProjectSpeckleModelSync_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectSpeckleModelSync_Max_Fields>;
  min?: Maybe<ProjectSpeckleModelSync_Min_Fields>;
  stddev?: Maybe<ProjectSpeckleModelSync_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectSpeckleModelSync_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectSpeckleModelSync_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectSpeckleModelSync_Sum_Fields>;
  var_pop?: Maybe<ProjectSpeckleModelSync_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectSpeckleModelSync_Var_Samp_Fields>;
  variance?: Maybe<ProjectSpeckleModelSync_Variance_Fields>;
};


/** aggregate fields of "project_speckle_model_sync" */
export type ProjectSpeckleModelSync_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectSpeckleModelSync_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ProjectSpeckleModelSync_Avg_Fields = {
  __typename?: 'projectSpeckleModelSync_avg_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_speckle_model_sync". All fields are combined with a logical 'AND'. */
export type ProjectSpeckleModelSync_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectSpeckleModelSync_Bool_Exp>>;
  _not?: InputMaybe<ProjectSpeckleModelSync_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectSpeckleModelSync_Bool_Exp>>;
  allowImport?: InputMaybe<Boolean_Comparison_Exp>;
  attempts?: InputMaybe<Int_Comparison_Exp>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  lastUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  requestedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_speckle_model_sync" */
export enum ProjectSpeckleModelSync_Constraint {
  /** unique or primary key constraint on columns "project_id" */
  project_speckle_model_sync_pkey = 'project_speckle_model_sync_pkey'
}

/** input type for incrementing numeric columns in table "project_speckle_model_sync" */
export type ProjectSpeckleModelSync_Inc_Input = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_speckle_model_sync" */
export type ProjectSpeckleModelSync_Insert_Input = {
  allowImport?: InputMaybe<Scalars['Boolean']['input']>;
  attempts?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  requestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectSpeckleModelSync_Max_Fields = {
  __typename?: 'projectSpeckleModelSync_max_fields';
  attempts?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  requestedAt?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectSpeckleModelSync_Min_Fields = {
  __typename?: 'projectSpeckleModelSync_min_fields';
  attempts?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  requestedAt?: Maybe<Scalars['timestamptz']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_speckle_model_sync" */
export type ProjectSpeckleModelSync_Mutation_Response = {
  __typename?: 'projectSpeckleModelSync_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectSpeckleModelSync>;
};

/** on_conflict condition type for table "project_speckle_model_sync" */
export type ProjectSpeckleModelSync_On_Conflict = {
  constraint: ProjectSpeckleModelSync_Constraint;
  update_columns?: Array<ProjectSpeckleModelSync_Update_Column>;
  where?: InputMaybe<ProjectSpeckleModelSync_Bool_Exp>;
};

/** Ordering options when selecting data from "project_speckle_model_sync". */
export type ProjectSpeckleModelSync_Order_By = {
  allowImport?: InputMaybe<Order_By>;
  attempts?: InputMaybe<Order_By>;
  errorMessage?: InputMaybe<Order_By>;
  lastUpdated?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  requestedAt?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_speckle_model_sync */
export type ProjectSpeckleModelSync_Pk_Columns_Input = {
  projectId: Scalars['uuid']['input'];
};

/** select columns of table "project_speckle_model_sync" */
export enum ProjectSpeckleModelSync_Select_Column {
  /** column name */
  allowImport = 'allowImport',
  /** column name */
  attempts = 'attempts',
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  lastUpdated = 'lastUpdated',
  /** column name */
  projectId = 'projectId',
  /** column name */
  requestedAt = 'requestedAt',
  /** column name */
  state = 'state'
}

/** input type for updating data in table "project_speckle_model_sync" */
export type ProjectSpeckleModelSync_Set_Input = {
  allowImport?: InputMaybe<Scalars['Boolean']['input']>;
  attempts?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  requestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ProjectSpeckleModelSync_Stddev_Fields = {
  __typename?: 'projectSpeckleModelSync_stddev_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ProjectSpeckleModelSync_Stddev_Pop_Fields = {
  __typename?: 'projectSpeckleModelSync_stddev_pop_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ProjectSpeckleModelSync_Stddev_Samp_Fields = {
  __typename?: 'projectSpeckleModelSync_stddev_samp_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projectSpeckleModelSync" */
export type ProjectSpeckleModelSync_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectSpeckleModelSync_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectSpeckleModelSync_Stream_Cursor_Value_Input = {
  allowImport?: InputMaybe<Scalars['Boolean']['input']>;
  attempts?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  requestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ProjectSpeckleModelSync_Sum_Fields = {
  __typename?: 'projectSpeckleModelSync_sum_fields';
  attempts?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "project_speckle_model_sync" */
export enum ProjectSpeckleModelSync_Update_Column {
  /** column name */
  allowImport = 'allowImport',
  /** column name */
  attempts = 'attempts',
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  lastUpdated = 'lastUpdated',
  /** column name */
  projectId = 'projectId',
  /** column name */
  requestedAt = 'requestedAt',
  /** column name */
  state = 'state'
}

export type ProjectSpeckleModelSync_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectSpeckleModelSync_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectSpeckleModelSync_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectSpeckleModelSync_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectSpeckleModelSync_Var_Pop_Fields = {
  __typename?: 'projectSpeckleModelSync_var_pop_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ProjectSpeckleModelSync_Var_Samp_Fields = {
  __typename?: 'projectSpeckleModelSync_var_samp_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ProjectSpeckleModelSync_Variance_Fields = {
  __typename?: 'projectSpeckleModelSync_variance_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "project_speckle_parameter_config" */
export type ProjectSpeckleParameterConfig = {
  __typename?: 'projectSpeckleParameterConfig';
  classificationCode: Scalars['String']['output'];
  /** An object relationship */
  classificationType?: Maybe<ClassificationType>;
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  project?: Maybe<Project>;
  projectId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_speckle_parameter_config" */
export type ProjectSpeckleParameterConfig_Aggregate = {
  __typename?: 'projectSpeckleParameterConfig_aggregate';
  aggregate?: Maybe<ProjectSpeckleParameterConfig_Aggregate_Fields>;
  nodes: Array<ProjectSpeckleParameterConfig>;
};

/** aggregate fields of "project_speckle_parameter_config" */
export type ProjectSpeckleParameterConfig_Aggregate_Fields = {
  __typename?: 'projectSpeckleParameterConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectSpeckleParameterConfig_Max_Fields>;
  min?: Maybe<ProjectSpeckleParameterConfig_Min_Fields>;
};


/** aggregate fields of "project_speckle_parameter_config" */
export type ProjectSpeckleParameterConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectSpeckleParameterConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_speckle_parameter_config". All fields are combined with a logical 'AND'. */
export type ProjectSpeckleParameterConfig_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectSpeckleParameterConfig_Bool_Exp>>;
  _not?: InputMaybe<ProjectSpeckleParameterConfig_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectSpeckleParameterConfig_Bool_Exp>>;
  classificationCode?: InputMaybe<String_Comparison_Exp>;
  classificationType?: InputMaybe<ClassificationType_Bool_Exp>;
  classificationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_speckle_parameter_config" */
export enum ProjectSpeckleParameterConfig_Constraint {
  /** unique or primary key constraint on columns "project_id" */
  project_speckle_parameter_config_pkey = 'project_speckle_parameter_config_pkey'
}

/** input type for inserting data into table "project_speckle_parameter_config" */
export type ProjectSpeckleParameterConfig_Insert_Input = {
  classificationCode?: InputMaybe<Scalars['String']['input']>;
  classificationType?: InputMaybe<ClassificationType_Obj_Rel_Insert_Input>;
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectSpeckleParameterConfig_Max_Fields = {
  __typename?: 'projectSpeckleParameterConfig_max_fields';
  classificationCode?: Maybe<Scalars['String']['output']>;
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ProjectSpeckleParameterConfig_Min_Fields = {
  __typename?: 'projectSpeckleParameterConfig_min_fields';
  classificationCode?: Maybe<Scalars['String']['output']>;
  classificationTypeId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "project_speckle_parameter_config" */
export type ProjectSpeckleParameterConfig_Mutation_Response = {
  __typename?: 'projectSpeckleParameterConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectSpeckleParameterConfig>;
};

/** on_conflict condition type for table "project_speckle_parameter_config" */
export type ProjectSpeckleParameterConfig_On_Conflict = {
  constraint: ProjectSpeckleParameterConfig_Constraint;
  update_columns?: Array<ProjectSpeckleParameterConfig_Update_Column>;
  where?: InputMaybe<ProjectSpeckleParameterConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "project_speckle_parameter_config". */
export type ProjectSpeckleParameterConfig_Order_By = {
  classificationCode?: InputMaybe<Order_By>;
  classificationType?: InputMaybe<ClassificationType_Order_By>;
  classificationTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_speckle_parameter_config */
export type ProjectSpeckleParameterConfig_Pk_Columns_Input = {
  projectId: Scalars['uuid']['input'];
};

/** select columns of table "project_speckle_parameter_config" */
export enum ProjectSpeckleParameterConfig_Select_Column {
  /** column name */
  classificationCode = 'classificationCode',
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  projectId = 'projectId'
}

/** input type for updating data in table "project_speckle_parameter_config" */
export type ProjectSpeckleParameterConfig_Set_Input = {
  classificationCode?: InputMaybe<Scalars['String']['input']>;
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "projectSpeckleParameterConfig" */
export type ProjectSpeckleParameterConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectSpeckleParameterConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectSpeckleParameterConfig_Stream_Cursor_Value_Input = {
  classificationCode?: InputMaybe<Scalars['String']['input']>;
  classificationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_speckle_parameter_config" */
export enum ProjectSpeckleParameterConfig_Update_Column {
  /** column name */
  classificationCode = 'classificationCode',
  /** column name */
  classificationTypeId = 'classificationTypeId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  projectId = 'projectId'
}

export type ProjectSpeckleParameterConfig_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectSpeckleParameterConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectSpeckleParameterConfig_Bool_Exp;
};

/** columns and relationships of "project_standard_value_stage" */
export type ProjectStandardValueStage = {
  __typename?: 'projectStandardValueStage';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  /** An object relationship */
  stage: StageDefaultEmission;
  stageId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_standard_value_stage" */
export type ProjectStandardValueStage_Aggregate = {
  __typename?: 'projectStandardValueStage_aggregate';
  aggregate?: Maybe<ProjectStandardValueStage_Aggregate_Fields>;
  nodes: Array<ProjectStandardValueStage>;
};

export type ProjectStandardValueStage_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectStandardValueStage_Aggregate_Bool_Exp_Count>;
};

export type ProjectStandardValueStage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_standard_value_stage" */
export type ProjectStandardValueStage_Aggregate_Fields = {
  __typename?: 'projectStandardValueStage_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectStandardValueStage_Max_Fields>;
  min?: Maybe<ProjectStandardValueStage_Min_Fields>;
};


/** aggregate fields of "project_standard_value_stage" */
export type ProjectStandardValueStage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_standard_value_stage" */
export type ProjectStandardValueStage_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectStandardValueStage_Max_Order_By>;
  min?: InputMaybe<ProjectStandardValueStage_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_standard_value_stage" */
export type ProjectStandardValueStage_Arr_Rel_Insert_Input = {
  data: Array<ProjectStandardValueStage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectStandardValueStage_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_standard_value_stage". All fields are combined with a logical 'AND'. */
export type ProjectStandardValueStage_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectStandardValueStage_Bool_Exp>>;
  _not?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectStandardValueStage_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  stage?: InputMaybe<StageDefaultEmission_Bool_Exp>;
  stageId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_standard_value_stage" */
export enum ProjectStandardValueStage_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_standard_value_stage_pkey = 'project_standard_value_stage_pkey',
  /** unique or primary key constraint on columns "stage_id", "revision_id", "project_id" */
  project_standard_value_stage_stage_id_project_id_key = 'project_standard_value_stage_stage_id_project_id_key'
}

/** input type for inserting data into table "project_standard_value_stage" */
export type ProjectStandardValueStage_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  stage?: InputMaybe<StageDefaultEmission_Obj_Rel_Insert_Input>;
  stageId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectStandardValueStage_Max_Fields = {
  __typename?: 'projectStandardValueStage_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  stageId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_standard_value_stage" */
export type ProjectStandardValueStage_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectStandardValueStage_Min_Fields = {
  __typename?: 'projectStandardValueStage_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  stageId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_standard_value_stage" */
export type ProjectStandardValueStage_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_standard_value_stage" */
export type ProjectStandardValueStage_Mutation_Response = {
  __typename?: 'projectStandardValueStage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectStandardValueStage>;
};

/** on_conflict condition type for table "project_standard_value_stage" */
export type ProjectStandardValueStage_On_Conflict = {
  constraint: ProjectStandardValueStage_Constraint;
  update_columns?: Array<ProjectStandardValueStage_Update_Column>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};

/** Ordering options when selecting data from "project_standard_value_stage". */
export type ProjectStandardValueStage_Order_By = {
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  stage?: InputMaybe<StageDefaultEmission_Order_By>;
  stageId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_standard_value_stage */
export type ProjectStandardValueStage_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_standard_value_stage" */
export enum ProjectStandardValueStage_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  stageId = 'stageId'
}

/** input type for updating data in table "project_standard_value_stage" */
export type ProjectStandardValueStage_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  stageId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "projectStandardValueStage" */
export type ProjectStandardValueStage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectStandardValueStage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectStandardValueStage_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  stageId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_standard_value_stage" */
export enum ProjectStandardValueStage_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  stageId = 'stageId'
}

export type ProjectStandardValueStage_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectStandardValueStage_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectStandardValueStage_Bool_Exp;
};

/** columns and relationships of "project_status" */
export type ProjectStatus = {
  __typename?: 'projectStatus';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** aggregated selection of "project_status" */
export type ProjectStatus_Aggregate = {
  __typename?: 'projectStatus_aggregate';
  aggregate?: Maybe<ProjectStatus_Aggregate_Fields>;
  nodes: Array<ProjectStatus>;
};

/** aggregate fields of "project_status" */
export type ProjectStatus_Aggregate_Fields = {
  __typename?: 'projectStatus_aggregate_fields';
  avg?: Maybe<ProjectStatus_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectStatus_Max_Fields>;
  min?: Maybe<ProjectStatus_Min_Fields>;
  stddev?: Maybe<ProjectStatus_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectStatus_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectStatus_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectStatus_Sum_Fields>;
  var_pop?: Maybe<ProjectStatus_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectStatus_Var_Samp_Fields>;
  variance?: Maybe<ProjectStatus_Variance_Fields>;
};


/** aggregate fields of "project_status" */
export type ProjectStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ProjectStatus_Avg_Fields = {
  __typename?: 'projectStatus_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_status". All fields are combined with a logical 'AND'. */
export type ProjectStatus_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectStatus_Bool_Exp>>;
  _not?: InputMaybe<ProjectStatus_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectStatus_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_status" */
export enum ProjectStatus_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_status_pkey = 'project_status_pkey'
}

/** input type for incrementing numeric columns in table "project_status" */
export type ProjectStatus_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_status" */
export type ProjectStatus_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProjectStatus_Max_Fields = {
  __typename?: 'projectStatus_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProjectStatus_Min_Fields = {
  __typename?: 'projectStatus_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_status" */
export type ProjectStatus_Mutation_Response = {
  __typename?: 'projectStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectStatus>;
};

/** input type for inserting object relation for remote table "project_status" */
export type ProjectStatus_Obj_Rel_Insert_Input = {
  data: ProjectStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectStatus_On_Conflict>;
};

/** on_conflict condition type for table "project_status" */
export type ProjectStatus_On_Conflict = {
  constraint: ProjectStatus_Constraint;
  update_columns?: Array<ProjectStatus_Update_Column>;
  where?: InputMaybe<ProjectStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "project_status". */
export type ProjectStatus_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_status */
export type ProjectStatus_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "project_status" */
export enum ProjectStatus_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

/** input type for updating data in table "project_status" */
export type ProjectStatus_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ProjectStatus_Stddev_Fields = {
  __typename?: 'projectStatus_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ProjectStatus_Stddev_Pop_Fields = {
  __typename?: 'projectStatus_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ProjectStatus_Stddev_Samp_Fields = {
  __typename?: 'projectStatus_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projectStatus" */
export type ProjectStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectStatus_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ProjectStatus_Sum_Fields = {
  __typename?: 'projectStatus_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "project_status" */
export enum ProjectStatus_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

export type ProjectStatus_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectStatus_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectStatus_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectStatus_Var_Pop_Fields = {
  __typename?: 'projectStatus_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ProjectStatus_Var_Samp_Fields = {
  __typename?: 'projectStatus_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ProjectStatus_Variance_Fields = {
  __typename?: 'projectStatus_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "project_tenant_status_area" */
export type ProjectTenantStatusArea = {
  __typename?: 'projectTenantStatusArea';
  projectStatus?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  totalArea?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "project_tenant_status_area" */
export type ProjectTenantStatusArea_Aggregate = {
  __typename?: 'projectTenantStatusArea_aggregate';
  aggregate?: Maybe<ProjectTenantStatusArea_Aggregate_Fields>;
  nodes: Array<ProjectTenantStatusArea>;
};

/** aggregate fields of "project_tenant_status_area" */
export type ProjectTenantStatusArea_Aggregate_Fields = {
  __typename?: 'projectTenantStatusArea_aggregate_fields';
  avg?: Maybe<ProjectTenantStatusArea_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectTenantStatusArea_Max_Fields>;
  min?: Maybe<ProjectTenantStatusArea_Min_Fields>;
  stddev?: Maybe<ProjectTenantStatusArea_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectTenantStatusArea_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectTenantStatusArea_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectTenantStatusArea_Sum_Fields>;
  var_pop?: Maybe<ProjectTenantStatusArea_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectTenantStatusArea_Var_Samp_Fields>;
  variance?: Maybe<ProjectTenantStatusArea_Variance_Fields>;
};


/** aggregate fields of "project_tenant_status_area" */
export type ProjectTenantStatusArea_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectTenantStatusArea_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ProjectTenantStatusArea_Avg_Fields = {
  __typename?: 'projectTenantStatusArea_avg_fields';
  totalArea?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_tenant_status_area". All fields are combined with a logical 'AND'. */
export type ProjectTenantStatusArea_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectTenantStatusArea_Bool_Exp>>;
  _not?: InputMaybe<ProjectTenantStatusArea_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectTenantStatusArea_Bool_Exp>>;
  projectStatus?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  totalArea?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type ProjectTenantStatusArea_Max_Fields = {
  __typename?: 'projectTenantStatusArea_max_fields';
  projectStatus?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  totalArea?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type ProjectTenantStatusArea_Min_Fields = {
  __typename?: 'projectTenantStatusArea_min_fields';
  projectStatus?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  totalArea?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "project_tenant_status_area". */
export type ProjectTenantStatusArea_Order_By = {
  projectStatus?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  totalArea?: InputMaybe<Order_By>;
};

/** select columns of table "project_tenant_status_area" */
export enum ProjectTenantStatusArea_Select_Column {
  /** column name */
  projectStatus = 'projectStatus',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  totalArea = 'totalArea'
}

/** aggregate stddev on columns */
export type ProjectTenantStatusArea_Stddev_Fields = {
  __typename?: 'projectTenantStatusArea_stddev_fields';
  totalArea?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ProjectTenantStatusArea_Stddev_Pop_Fields = {
  __typename?: 'projectTenantStatusArea_stddev_pop_fields';
  totalArea?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ProjectTenantStatusArea_Stddev_Samp_Fields = {
  __typename?: 'projectTenantStatusArea_stddev_samp_fields';
  totalArea?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projectTenantStatusArea" */
export type ProjectTenantStatusArea_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectTenantStatusArea_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectTenantStatusArea_Stream_Cursor_Value_Input = {
  projectStatus?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  totalArea?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type ProjectTenantStatusArea_Sum_Fields = {
  __typename?: 'projectTenantStatusArea_sum_fields';
  totalArea?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type ProjectTenantStatusArea_Var_Pop_Fields = {
  __typename?: 'projectTenantStatusArea_var_pop_fields';
  totalArea?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ProjectTenantStatusArea_Var_Samp_Fields = {
  __typename?: 'projectTenantStatusArea_var_samp_fields';
  totalArea?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ProjectTenantStatusArea_Variance_Fields = {
  __typename?: 'projectTenantStatusArea_variance_fields';
  totalArea?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor = {
  __typename?: 'projectTransportMappingEmissionFactor';
  /** An object relationship */
  emissionFactor: TransportEmissionFactor;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  projectTransportMapping: Project_Transport_Mapping;
  projectTransportMappingId: Scalars['uuid']['output'];
  transportEmissionFactorId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Aggregate = {
  __typename?: 'projectTransportMappingEmissionFactor_aggregate';
  aggregate?: Maybe<ProjectTransportMappingEmissionFactor_Aggregate_Fields>;
  nodes: Array<ProjectTransportMappingEmissionFactor>;
};

export type ProjectTransportMappingEmissionFactor_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectTransportMappingEmissionFactor_Aggregate_Bool_Exp_Count>;
};

export type ProjectTransportMappingEmissionFactor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Aggregate_Fields = {
  __typename?: 'projectTransportMappingEmissionFactor_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectTransportMappingEmissionFactor_Max_Fields>;
  min?: Maybe<ProjectTransportMappingEmissionFactor_Min_Fields>;
};


/** aggregate fields of "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectTransportMappingEmissionFactor_Max_Order_By>;
  min?: InputMaybe<ProjectTransportMappingEmissionFactor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Arr_Rel_Insert_Input = {
  data: Array<ProjectTransportMappingEmissionFactor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectTransportMappingEmissionFactor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_transport_mapping_emission_factor". All fields are combined with a logical 'AND'. */
export type ProjectTransportMappingEmissionFactor_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Bool_Exp>>;
  _not?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Bool_Exp>>;
  emissionFactor?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  projectTransportMapping?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
  projectTransportMappingId?: InputMaybe<Uuid_Comparison_Exp>;
  transportEmissionFactorId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_transport_mapping_emission_factor" */
export enum ProjectTransportMappingEmissionFactor_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_transport_mapping_emission_factor_pkey = 'project_transport_mapping_emission_factor_pkey'
}

/** input type for inserting data into table "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Insert_Input = {
  emissionFactor?: InputMaybe<TransportEmissionFactor_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectTransportMapping?: InputMaybe<Project_Transport_Mapping_Obj_Rel_Insert_Input>;
  projectTransportMappingId?: InputMaybe<Scalars['uuid']['input']>;
  transportEmissionFactorId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectTransportMappingEmissionFactor_Max_Fields = {
  __typename?: 'projectTransportMappingEmissionFactor_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  projectTransportMappingId?: Maybe<Scalars['uuid']['output']>;
  transportEmissionFactorId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  projectTransportMappingId?: InputMaybe<Order_By>;
  transportEmissionFactorId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectTransportMappingEmissionFactor_Min_Fields = {
  __typename?: 'projectTransportMappingEmissionFactor_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  projectTransportMappingId?: Maybe<Scalars['uuid']['output']>;
  transportEmissionFactorId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  projectTransportMappingId?: InputMaybe<Order_By>;
  transportEmissionFactorId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Mutation_Response = {
  __typename?: 'projectTransportMappingEmissionFactor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectTransportMappingEmissionFactor>;
};

/** on_conflict condition type for table "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_On_Conflict = {
  constraint: ProjectTransportMappingEmissionFactor_Constraint;
  update_columns?: Array<ProjectTransportMappingEmissionFactor_Update_Column>;
  where?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
};

/** Ordering options when selecting data from "project_transport_mapping_emission_factor". */
export type ProjectTransportMappingEmissionFactor_Order_By = {
  emissionFactor?: InputMaybe<TransportEmissionFactor_Order_By>;
  id?: InputMaybe<Order_By>;
  projectTransportMapping?: InputMaybe<Project_Transport_Mapping_Order_By>;
  projectTransportMappingId?: InputMaybe<Order_By>;
  transportEmissionFactorId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_transport_mapping_emission_factor */
export type ProjectTransportMappingEmissionFactor_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_transport_mapping_emission_factor" */
export enum ProjectTransportMappingEmissionFactor_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  projectTransportMappingId = 'projectTransportMappingId',
  /** column name */
  transportEmissionFactorId = 'transportEmissionFactorId'
}

/** input type for updating data in table "project_transport_mapping_emission_factor" */
export type ProjectTransportMappingEmissionFactor_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectTransportMappingId?: InputMaybe<Scalars['uuid']['input']>;
  transportEmissionFactorId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "projectTransportMappingEmissionFactor" */
export type ProjectTransportMappingEmissionFactor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectTransportMappingEmissionFactor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectTransportMappingEmissionFactor_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectTransportMappingId?: InputMaybe<Scalars['uuid']['input']>;
  transportEmissionFactorId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_transport_mapping_emission_factor" */
export enum ProjectTransportMappingEmissionFactor_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  projectTransportMappingId = 'projectTransportMappingId',
  /** column name */
  transportEmissionFactorId = 'transportEmissionFactorId'
}

export type ProjectTransportMappingEmissionFactor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectTransportMappingEmissionFactor_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectTransportMappingEmissionFactor_Bool_Exp;
};

/** columns and relationships of "project_version" */
export type ProjectVersion = {
  __typename?: 'projectVersion';
  changes: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['uuid']['output'];
  entityId?: Maybe<Scalars['uuid']['output']>;
  entityLabel?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  informational: Scalars['Boolean']['output'];
  martenVersion?: Maybe<Scalars['Int']['output']>;
  operation: Scalars['String']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision?: Maybe<ProjectRevision>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  source: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};


/** columns and relationships of "project_version" */
export type ProjectVersionChangesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "project_version_numbered" */
export type ProjectVersionNumbered = {
  __typename?: 'projectVersionNumbered';
  changes?: Maybe<Scalars['jsonb']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  entityLabel?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  informational?: Maybe<Scalars['Boolean']['output']>;
  martenVersion?: Maybe<Scalars['Int']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "project_version_numbered" */
export type ProjectVersionNumberedChangesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "project_version_numbered" */
export type ProjectVersionNumbered_Aggregate = {
  __typename?: 'projectVersionNumbered_aggregate';
  aggregate?: Maybe<ProjectVersionNumbered_Aggregate_Fields>;
  nodes: Array<ProjectVersionNumbered>;
};

/** aggregate fields of "project_version_numbered" */
export type ProjectVersionNumbered_Aggregate_Fields = {
  __typename?: 'projectVersionNumbered_aggregate_fields';
  avg?: Maybe<ProjectVersionNumbered_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectVersionNumbered_Max_Fields>;
  min?: Maybe<ProjectVersionNumbered_Min_Fields>;
  stddev?: Maybe<ProjectVersionNumbered_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectVersionNumbered_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectVersionNumbered_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectVersionNumbered_Sum_Fields>;
  var_pop?: Maybe<ProjectVersionNumbered_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectVersionNumbered_Var_Samp_Fields>;
  variance?: Maybe<ProjectVersionNumbered_Variance_Fields>;
};


/** aggregate fields of "project_version_numbered" */
export type ProjectVersionNumbered_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectVersionNumbered_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProjectVersionNumbered_Append_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type ProjectVersionNumbered_Avg_Fields = {
  __typename?: 'projectVersionNumbered_avg_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_version_numbered". All fields are combined with a logical 'AND'. */
export type ProjectVersionNumbered_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectVersionNumbered_Bool_Exp>>;
  _not?: InputMaybe<ProjectVersionNumbered_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectVersionNumbered_Bool_Exp>>;
  changes?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  entityId?: InputMaybe<Uuid_Comparison_Exp>;
  entityLabel?: InputMaybe<String_Comparison_Exp>;
  entityType?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  informational?: InputMaybe<Boolean_Comparison_Exp>;
  martenVersion?: InputMaybe<Int_Comparison_Exp>;
  operation?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  summary?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  versionNumber?: InputMaybe<Int_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProjectVersionNumbered_Delete_At_Path_Input = {
  changes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProjectVersionNumbered_Delete_Elem_Input = {
  changes?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProjectVersionNumbered_Delete_Key_Input = {
  changes?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "project_version_numbered" */
export type ProjectVersionNumbered_Inc_Input = {
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_version_numbered" */
export type ProjectVersionNumbered_Insert_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityLabel?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  informational?: InputMaybe<Scalars['Boolean']['input']>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ProjectVersionNumbered_Max_Fields = {
  __typename?: 'projectVersionNumbered_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  entityLabel?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  martenVersion?: Maybe<Scalars['Int']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type ProjectVersionNumbered_Min_Fields = {
  __typename?: 'projectVersionNumbered_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  entityLabel?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  martenVersion?: Maybe<Scalars['Int']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "project_version_numbered" */
export type ProjectVersionNumbered_Mutation_Response = {
  __typename?: 'projectVersionNumbered_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectVersionNumbered>;
};

/** Ordering options when selecting data from "project_version_numbered". */
export type ProjectVersionNumbered_Order_By = {
  changes?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  entityLabel?: InputMaybe<Order_By>;
  entityType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  informational?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProjectVersionNumbered_Prepend_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_version_numbered" */
export enum ProjectVersionNumbered_Select_Column {
  /** column name */
  changes = 'changes',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  entityId = 'entityId',
  /** column name */
  entityLabel = 'entityLabel',
  /** column name */
  entityType = 'entityType',
  /** column name */
  id = 'id',
  /** column name */
  informational = 'informational',
  /** column name */
  martenVersion = 'martenVersion',
  /** column name */
  operation = 'operation',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  source = 'source',
  /** column name */
  summary = 'summary',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  versionNumber = 'versionNumber'
}

/** input type for updating data in table "project_version_numbered" */
export type ProjectVersionNumbered_Set_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityLabel?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  informational?: InputMaybe<Scalars['Boolean']['input']>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ProjectVersionNumbered_Stddev_Fields = {
  __typename?: 'projectVersionNumbered_stddev_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ProjectVersionNumbered_Stddev_Pop_Fields = {
  __typename?: 'projectVersionNumbered_stddev_pop_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ProjectVersionNumbered_Stddev_Samp_Fields = {
  __typename?: 'projectVersionNumbered_stddev_samp_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projectVersionNumbered" */
export type ProjectVersionNumbered_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectVersionNumbered_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectVersionNumbered_Stream_Cursor_Value_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityLabel?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  informational?: InputMaybe<Scalars['Boolean']['input']>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ProjectVersionNumbered_Sum_Fields = {
  __typename?: 'projectVersionNumbered_sum_fields';
  martenVersion?: Maybe<Scalars['Int']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

export type ProjectVersionNumbered_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ProjectVersionNumbered_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ProjectVersionNumbered_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ProjectVersionNumbered_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ProjectVersionNumbered_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectVersionNumbered_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ProjectVersionNumbered_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectVersionNumbered_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectVersionNumbered_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectVersionNumbered_Var_Pop_Fields = {
  __typename?: 'projectVersionNumbered_var_pop_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ProjectVersionNumbered_Var_Samp_Fields = {
  __typename?: 'projectVersionNumbered_var_samp_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ProjectVersionNumbered_Variance_Fields = {
  __typename?: 'projectVersionNumbered_variance_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "project_version" */
export type ProjectVersion_Aggregate = {
  __typename?: 'projectVersion_aggregate';
  aggregate?: Maybe<ProjectVersion_Aggregate_Fields>;
  nodes: Array<ProjectVersion>;
};

export type ProjectVersion_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ProjectVersion_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ProjectVersion_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ProjectVersion_Aggregate_Bool_Exp_Count>;
};

export type ProjectVersion_Aggregate_Bool_Exp_Bool_And = {
  arguments: ProjectVersion_Select_Column_ProjectVersion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectVersion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProjectVersion_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ProjectVersion_Select_Column_ProjectVersion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectVersion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProjectVersion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectVersion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectVersion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_version" */
export type ProjectVersion_Aggregate_Fields = {
  __typename?: 'projectVersion_aggregate_fields';
  avg?: Maybe<ProjectVersion_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectVersion_Max_Fields>;
  min?: Maybe<ProjectVersion_Min_Fields>;
  stddev?: Maybe<ProjectVersion_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectVersion_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectVersion_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectVersion_Sum_Fields>;
  var_pop?: Maybe<ProjectVersion_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectVersion_Var_Samp_Fields>;
  variance?: Maybe<ProjectVersion_Variance_Fields>;
};


/** aggregate fields of "project_version" */
export type ProjectVersion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectVersion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_version" */
export type ProjectVersion_Aggregate_Order_By = {
  avg?: InputMaybe<ProjectVersion_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectVersion_Max_Order_By>;
  min?: InputMaybe<ProjectVersion_Min_Order_By>;
  stddev?: InputMaybe<ProjectVersion_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProjectVersion_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProjectVersion_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProjectVersion_Sum_Order_By>;
  var_pop?: InputMaybe<ProjectVersion_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProjectVersion_Var_Samp_Order_By>;
  variance?: InputMaybe<ProjectVersion_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProjectVersion_Append_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "project_version" */
export type ProjectVersion_Arr_Rel_Insert_Input = {
  data: Array<ProjectVersion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectVersion_On_Conflict>;
};

/** aggregate avg on columns */
export type ProjectVersion_Avg_Fields = {
  __typename?: 'projectVersion_avg_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_version" */
export type ProjectVersion_Avg_Order_By = {
  martenVersion?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_version". All fields are combined with a logical 'AND'. */
export type ProjectVersion_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectVersion_Bool_Exp>>;
  _not?: InputMaybe<ProjectVersion_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectVersion_Bool_Exp>>;
  changes?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  entityId?: InputMaybe<Uuid_Comparison_Exp>;
  entityLabel?: InputMaybe<String_Comparison_Exp>;
  entityType?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  informational?: InputMaybe<Boolean_Comparison_Exp>;
  martenVersion?: InputMaybe<Int_Comparison_Exp>;
  operation?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  summary?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  versionNumber?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_version" */
export enum ProjectVersion_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_version_pkey = 'project_version_pkey',
  /** unique or primary key constraint on columns "project_id", "marten_version" */
  project_version_project_id_marten_version_key = 'project_version_project_id_marten_version_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProjectVersion_Delete_At_Path_Input = {
  changes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProjectVersion_Delete_Elem_Input = {
  changes?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProjectVersion_Delete_Key_Input = {
  changes?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "project_version" */
export type ProjectVersion_Inc_Input = {
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_version" */
export type ProjectVersion_Insert_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityLabel?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  informational?: InputMaybe<Scalars['Boolean']['input']>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ProjectVersion_Max_Fields = {
  __typename?: 'projectVersion_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  entityLabel?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  martenVersion?: Maybe<Scalars['Int']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "project_version" */
export type ProjectVersion_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  entityLabel?: InputMaybe<Order_By>;
  entityType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectVersion_Min_Fields = {
  __typename?: 'projectVersion_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  entityLabel?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  martenVersion?: Maybe<Scalars['Int']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "project_version" */
export type ProjectVersion_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  entityLabel?: InputMaybe<Order_By>;
  entityType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_version" */
export type ProjectVersion_Mutation_Response = {
  __typename?: 'projectVersion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectVersion>;
};

/** on_conflict condition type for table "project_version" */
export type ProjectVersion_On_Conflict = {
  constraint: ProjectVersion_Constraint;
  update_columns?: Array<ProjectVersion_Update_Column>;
  where?: InputMaybe<ProjectVersion_Bool_Exp>;
};

/** Ordering options when selecting data from "project_version". */
export type ProjectVersion_Order_By = {
  changes?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  entityLabel?: InputMaybe<Order_By>;
  entityType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  informational?: InputMaybe<Order_By>;
  martenVersion?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_version */
export type ProjectVersion_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProjectVersion_Prepend_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_version" */
export enum ProjectVersion_Select_Column {
  /** column name */
  changes = 'changes',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  entityId = 'entityId',
  /** column name */
  entityLabel = 'entityLabel',
  /** column name */
  entityType = 'entityType',
  /** column name */
  id = 'id',
  /** column name */
  informational = 'informational',
  /** column name */
  martenVersion = 'martenVersion',
  /** column name */
  operation = 'operation',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  source = 'source',
  /** column name */
  summary = 'summary',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  versionNumber = 'versionNumber'
}

/** select "projectVersion_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_version" */
export enum ProjectVersion_Select_Column_ProjectVersion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  informational = 'informational'
}

/** select "projectVersion_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_version" */
export enum ProjectVersion_Select_Column_ProjectVersion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  informational = 'informational'
}

/** input type for updating data in table "project_version" */
export type ProjectVersion_Set_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityLabel?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  informational?: InputMaybe<Scalars['Boolean']['input']>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ProjectVersion_Stddev_Fields = {
  __typename?: 'projectVersion_stddev_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_version" */
export type ProjectVersion_Stddev_Order_By = {
  martenVersion?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProjectVersion_Stddev_Pop_Fields = {
  __typename?: 'projectVersion_stddev_pop_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_version" */
export type ProjectVersion_Stddev_Pop_Order_By = {
  martenVersion?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProjectVersion_Stddev_Samp_Fields = {
  __typename?: 'projectVersion_stddev_samp_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_version" */
export type ProjectVersion_Stddev_Samp_Order_By = {
  martenVersion?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projectVersion" */
export type ProjectVersion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectVersion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectVersion_Stream_Cursor_Value_Input = {
  changes?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityLabel?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  informational?: InputMaybe<Scalars['Boolean']['input']>;
  martenVersion?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ProjectVersion_Sum_Fields = {
  __typename?: 'projectVersion_sum_fields';
  martenVersion?: Maybe<Scalars['Int']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "project_version" */
export type ProjectVersion_Sum_Order_By = {
  martenVersion?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** update columns of table "project_version" */
export enum ProjectVersion_Update_Column {
  /** column name */
  changes = 'changes',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  entityId = 'entityId',
  /** column name */
  entityLabel = 'entityLabel',
  /** column name */
  entityType = 'entityType',
  /** column name */
  id = 'id',
  /** column name */
  informational = 'informational',
  /** column name */
  martenVersion = 'martenVersion',
  /** column name */
  operation = 'operation',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  source = 'source',
  /** column name */
  summary = 'summary',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  versionNumber = 'versionNumber'
}

export type ProjectVersion_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ProjectVersion_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ProjectVersion_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ProjectVersion_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ProjectVersion_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectVersion_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ProjectVersion_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectVersion_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectVersion_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectVersion_Var_Pop_Fields = {
  __typename?: 'projectVersion_var_pop_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_version" */
export type ProjectVersion_Var_Pop_Order_By = {
  martenVersion?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProjectVersion_Var_Samp_Fields = {
  __typename?: 'projectVersion_var_samp_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_version" */
export type ProjectVersion_Var_Samp_Order_By = {
  martenVersion?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProjectVersion_Variance_Fields = {
  __typename?: 'projectVersion_variance_fields';
  martenVersion?: Maybe<Scalars['Float']['output']>;
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_version" */
export type ProjectVersion_Variance_Order_By = {
  martenVersion?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_waste_mapping" */
export type ProjectWasteMapping = {
  __typename?: 'projectWasteMapping';
  createdAt: Scalars['timestamptz']['output'];
  createdBy?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customWasteType?: Maybe<ProjectWasteTypeCustom>;
  customWeight?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  label?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialWasteTypeId?: Maybe<Scalars['uuid']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['numeric']['output']>;
  pickupDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  projectWasteTypeCustomId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  /** An object relationship */
  wasteType?: Maybe<MaterialWasteType>;
};

/** aggregated selection of "project_waste_mapping" */
export type ProjectWasteMapping_Aggregate = {
  __typename?: 'projectWasteMapping_aggregate';
  aggregate?: Maybe<ProjectWasteMapping_Aggregate_Fields>;
  nodes: Array<ProjectWasteMapping>;
};

export type ProjectWasteMapping_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectWasteMapping_Aggregate_Bool_Exp_Count>;
};

export type ProjectWasteMapping_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectWasteMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_waste_mapping" */
export type ProjectWasteMapping_Aggregate_Fields = {
  __typename?: 'projectWasteMapping_aggregate_fields';
  avg?: Maybe<ProjectWasteMapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectWasteMapping_Max_Fields>;
  min?: Maybe<ProjectWasteMapping_Min_Fields>;
  stddev?: Maybe<ProjectWasteMapping_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectWasteMapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectWasteMapping_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectWasteMapping_Sum_Fields>;
  var_pop?: Maybe<ProjectWasteMapping_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectWasteMapping_Var_Samp_Fields>;
  variance?: Maybe<ProjectWasteMapping_Variance_Fields>;
};


/** aggregate fields of "project_waste_mapping" */
export type ProjectWasteMapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectWasteMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_waste_mapping" */
export type ProjectWasteMapping_Aggregate_Order_By = {
  avg?: InputMaybe<ProjectWasteMapping_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectWasteMapping_Max_Order_By>;
  min?: InputMaybe<ProjectWasteMapping_Min_Order_By>;
  stddev?: InputMaybe<ProjectWasteMapping_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProjectWasteMapping_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProjectWasteMapping_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProjectWasteMapping_Sum_Order_By>;
  var_pop?: InputMaybe<ProjectWasteMapping_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProjectWasteMapping_Var_Samp_Order_By>;
  variance?: InputMaybe<ProjectWasteMapping_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_waste_mapping" */
export type ProjectWasteMapping_Arr_Rel_Insert_Input = {
  data: Array<ProjectWasteMapping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectWasteMapping_On_Conflict>;
};

/** aggregate avg on columns */
export type ProjectWasteMapping_Avg_Fields = {
  __typename?: 'projectWasteMapping_avg_fields';
  customWeight?: Maybe<Scalars['Float']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Avg_Order_By = {
  customWeight?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_waste_mapping". All fields are combined with a logical 'AND'. */
export type ProjectWasteMapping_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectWasteMapping_Bool_Exp>>;
  _not?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectWasteMapping_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  customWasteType?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
  customWeight?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  materialWasteTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  materialWeightSnapshot?: InputMaybe<Numeric_Comparison_Exp>;
  pickupDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  projectWasteTypeCustomId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  wasteType?: InputMaybe<MaterialWasteType_Bool_Exp>;
};

/** unique or primary key constraints on table "project_waste_mapping" */
export enum ProjectWasteMapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_material_waste_mapping_pkey = 'project_material_waste_mapping_pkey'
}

/** input type for incrementing numeric columns in table "project_waste_mapping" */
export type ProjectWasteMapping_Inc_Input = {
  customWeight?: InputMaybe<Scalars['numeric']['input']>;
  materialWeightSnapshot?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_waste_mapping" */
export type ProjectWasteMapping_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  customWasteType?: InputMaybe<ProjectWasteTypeCustom_Obj_Rel_Insert_Input>;
  customWeight?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialWasteTypeId?: InputMaybe<Scalars['uuid']['input']>;
  materialWeightSnapshot?: InputMaybe<Scalars['numeric']['input']>;
  pickupDate?: InputMaybe<Scalars['timestamptz']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectWasteTypeCustomId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  wasteType?: InputMaybe<MaterialWasteType_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ProjectWasteMapping_Max_Fields = {
  __typename?: 'projectWasteMapping_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  customWeight?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialWasteTypeId?: Maybe<Scalars['uuid']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['numeric']['output']>;
  pickupDate?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  projectWasteTypeCustomId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customWeight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  materialWasteTypeId?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
  pickupDate?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectWasteTypeCustomId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectWasteMapping_Min_Fields = {
  __typename?: 'projectWasteMapping_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  customWeight?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialWasteTypeId?: Maybe<Scalars['uuid']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['numeric']['output']>;
  pickupDate?: Maybe<Scalars['timestamptz']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  projectWasteTypeCustomId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customWeight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  materialWasteTypeId?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
  pickupDate?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectWasteTypeCustomId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_waste_mapping" */
export type ProjectWasteMapping_Mutation_Response = {
  __typename?: 'projectWasteMapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectWasteMapping>;
};

/** on_conflict condition type for table "project_waste_mapping" */
export type ProjectWasteMapping_On_Conflict = {
  constraint: ProjectWasteMapping_Constraint;
  update_columns?: Array<ProjectWasteMapping_Update_Column>;
  where?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
};

/** Ordering options when selecting data from "project_waste_mapping". */
export type ProjectWasteMapping_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  customWasteType?: InputMaybe<ProjectWasteTypeCustom_Order_By>;
  customWeight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  materialWasteTypeId?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
  pickupDate?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectWasteTypeCustomId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  wasteType?: InputMaybe<MaterialWasteType_Order_By>;
};

/** primary key columns input for table: project_waste_mapping */
export type ProjectWasteMapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_waste_mapping" */
export enum ProjectWasteMapping_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  customWeight = 'customWeight',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  materialId = 'materialId',
  /** column name */
  materialWasteTypeId = 'materialWasteTypeId',
  /** column name */
  materialWeightSnapshot = 'materialWeightSnapshot',
  /** column name */
  pickupDate = 'pickupDate',
  /** column name */
  projectId = 'projectId',
  /** column name */
  projectWasteTypeCustomId = 'projectWasteTypeCustomId',
  /** column name */
  revisionId = 'revisionId'
}

/** input type for updating data in table "project_waste_mapping" */
export type ProjectWasteMapping_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  customWeight?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialWasteTypeId?: InputMaybe<Scalars['uuid']['input']>;
  materialWeightSnapshot?: InputMaybe<Scalars['numeric']['input']>;
  pickupDate?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectWasteTypeCustomId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type ProjectWasteMapping_Stddev_Fields = {
  __typename?: 'projectWasteMapping_stddev_fields';
  customWeight?: Maybe<Scalars['Float']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Stddev_Order_By = {
  customWeight?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProjectWasteMapping_Stddev_Pop_Fields = {
  __typename?: 'projectWasteMapping_stddev_pop_fields';
  customWeight?: Maybe<Scalars['Float']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Stddev_Pop_Order_By = {
  customWeight?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProjectWasteMapping_Stddev_Samp_Fields = {
  __typename?: 'projectWasteMapping_stddev_samp_fields';
  customWeight?: Maybe<Scalars['Float']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Stddev_Samp_Order_By = {
  customWeight?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projectWasteMapping" */
export type ProjectWasteMapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectWasteMapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectWasteMapping_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  customWeight?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialWasteTypeId?: InputMaybe<Scalars['uuid']['input']>;
  materialWeightSnapshot?: InputMaybe<Scalars['numeric']['input']>;
  pickupDate?: InputMaybe<Scalars['timestamptz']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectWasteTypeCustomId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ProjectWasteMapping_Sum_Fields = {
  __typename?: 'projectWasteMapping_sum_fields';
  customWeight?: Maybe<Scalars['numeric']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Sum_Order_By = {
  customWeight?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
};

/** update columns of table "project_waste_mapping" */
export enum ProjectWasteMapping_Update_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  customWeight = 'customWeight',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  materialId = 'materialId',
  /** column name */
  materialWasteTypeId = 'materialWasteTypeId',
  /** column name */
  materialWeightSnapshot = 'materialWeightSnapshot',
  /** column name */
  pickupDate = 'pickupDate',
  /** column name */
  projectId = 'projectId',
  /** column name */
  projectWasteTypeCustomId = 'projectWasteTypeCustomId',
  /** column name */
  revisionId = 'revisionId'
}

export type ProjectWasteMapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectWasteMapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectWasteMapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectWasteMapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectWasteMapping_Var_Pop_Fields = {
  __typename?: 'projectWasteMapping_var_pop_fields';
  customWeight?: Maybe<Scalars['Float']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Var_Pop_Order_By = {
  customWeight?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProjectWasteMapping_Var_Samp_Fields = {
  __typename?: 'projectWasteMapping_var_samp_fields';
  customWeight?: Maybe<Scalars['Float']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Var_Samp_Order_By = {
  customWeight?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProjectWasteMapping_Variance_Fields = {
  __typename?: 'projectWasteMapping_variance_fields';
  customWeight?: Maybe<Scalars['Float']['output']>;
  materialWeightSnapshot?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_waste_mapping" */
export type ProjectWasteMapping_Variance_Order_By = {
  customWeight?: InputMaybe<Order_By>;
  materialWeightSnapshot?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_waste_type_custom" */
export type ProjectWasteTypeCustom = {
  __typename?: 'projectWasteTypeCustom';
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Aggregate = {
  __typename?: 'projectWasteTypeCustom_aggregate';
  aggregate?: Maybe<ProjectWasteTypeCustom_Aggregate_Fields>;
  nodes: Array<ProjectWasteTypeCustom>;
};

export type ProjectWasteTypeCustom_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectWasteTypeCustom_Aggregate_Bool_Exp_Count>;
};

export type ProjectWasteTypeCustom_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectWasteTypeCustom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Aggregate_Fields = {
  __typename?: 'projectWasteTypeCustom_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProjectWasteTypeCustom_Max_Fields>;
  min?: Maybe<ProjectWasteTypeCustom_Min_Fields>;
};


/** aggregate fields of "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectWasteTypeCustom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectWasteTypeCustom_Max_Order_By>;
  min?: InputMaybe<ProjectWasteTypeCustom_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Arr_Rel_Insert_Input = {
  data: Array<ProjectWasteTypeCustom_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectWasteTypeCustom_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_waste_type_custom". All fields are combined with a logical 'AND'. */
export type ProjectWasteTypeCustom_Bool_Exp = {
  _and?: InputMaybe<Array<ProjectWasteTypeCustom_Bool_Exp>>;
  _not?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectWasteTypeCustom_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_waste_type_custom" */
export enum ProjectWasteTypeCustom_Constraint {
  /** unique or primary key constraint on columns "revision_id", "project_id", "label" */
  project_waste_types_custom_label_project_id_key = 'project_waste_types_custom_label_project_id_key',
  /** unique or primary key constraint on columns "id" */
  project_waste_types_custom_pkey = 'project_waste_types_custom_pkey'
}

/** input type for inserting data into table "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ProjectWasteTypeCustom_Max_Fields = {
  __typename?: 'projectWasteTypeCustom_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectWasteTypeCustom_Min_Fields = {
  __typename?: 'projectWasteTypeCustom_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Mutation_Response = {
  __typename?: 'projectWasteTypeCustom_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectWasteTypeCustom>;
};

/** input type for inserting object relation for remote table "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Obj_Rel_Insert_Input = {
  data: ProjectWasteTypeCustom_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectWasteTypeCustom_On_Conflict>;
};

/** on_conflict condition type for table "project_waste_type_custom" */
export type ProjectWasteTypeCustom_On_Conflict = {
  constraint: ProjectWasteTypeCustom_Constraint;
  update_columns?: Array<ProjectWasteTypeCustom_Update_Column>;
  where?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
};

/** Ordering options when selecting data from "project_waste_type_custom". */
export type ProjectWasteTypeCustom_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_waste_type_custom */
export type ProjectWasteTypeCustom_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_waste_type_custom" */
export enum ProjectWasteTypeCustom_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId'
}

/** input type for updating data in table "project_waste_type_custom" */
export type ProjectWasteTypeCustom_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "projectWasteTypeCustom" */
export type ProjectWasteTypeCustom_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectWasteTypeCustom_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectWasteTypeCustom_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_waste_type_custom" */
export enum ProjectWasteTypeCustom_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  projectId = 'projectId',
  /** column name */
  revisionId = 'revisionId'
}

export type ProjectWasteTypeCustom_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectWasteTypeCustom_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProjectWasteTypeCustom_Bool_Exp;
};

/** aggregated selection of "project" */
export type Project_Aggregate = {
  __typename?: 'project_aggregate';
  aggregate?: Maybe<Project_Aggregate_Fields>;
  nodes: Array<Project>;
};

/** aggregate fields of "project" */
export type Project_Aggregate_Fields = {
  __typename?: 'project_aggregate_fields';
  avg?: Maybe<Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Max_Fields>;
  min?: Maybe<Project_Min_Fields>;
  stddev?: Maybe<Project_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Sum_Fields>;
  var_pop?: Maybe<Project_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Var_Samp_Fields>;
  variance?: Maybe<Project_Variance_Fields>;
};


/** aggregate fields of "project" */
export type Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Project_Avg_Fields = {
  __typename?: 'project_avg_fields';
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project". All fields are combined with a logical 'AND'. */
export type Project_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bool_Exp>>;
  _not?: InputMaybe<Project_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bool_Exp>>;
  activeRevision?: InputMaybe<ProjectRevision_Bool_Exp>;
  activeRevisionId?: InputMaybe<Uuid_Comparison_Exp>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  builderName?: InputMaybe<String_Comparison_Exp>;
  buildingAreas?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
  buildingAreas_aggregate?: InputMaybe<ProjectBuildingArea_Aggregate_Bool_Exp>;
  buildingType?: InputMaybe<BuildingType_Bool_Exp>;
  buildingTypeId?: InputMaybe<Int_Comparison_Exp>;
  calculation?: InputMaybe<ProjectCalculation_Bool_Exp>;
  clientName?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedBy?: InputMaybe<Uuid_Comparison_Exp>;
  favorite?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installation?: InputMaybe<ProjectInstallation_Bool_Exp>;
  lcaResponsibleName?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<ProjectLocation_Bool_Exp>;
  memberships?: InputMaybe<ProjectMembership_Bool_Exp>;
  memberships_aggregate?: InputMaybe<ProjectMembership_Aggregate_Bool_Exp>;
  models?: InputMaybe<ProjectModel_Bool_Exp>;
  models_aggregate?: InputMaybe<ProjectModel_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfPeople?: InputMaybe<Numeric_Comparison_Exp>;
  operational?: InputMaybe<ProjectOperational_Bool_Exp>;
  projectNumber?: InputMaybe<String_Comparison_Exp>;
  projectStatus?: InputMaybe<ProjectStatus_Bool_Exp>;
  projectStatusId?: InputMaybe<Int_Comparison_Exp>;
  referenceAreas?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
  referenceAreas_aggregate?: InputMaybe<ProjectReferenceArea_Aggregate_Bool_Exp>;
  revisions?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisions_aggregate?: InputMaybe<ProjectRevision_Aggregate_Bool_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  sourceProject?: InputMaybe<Project_Bool_Exp>;
  sourceProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  sourceVersionId?: InputMaybe<Uuid_Comparison_Exp>;
  sourceVersionNumber?: InputMaybe<Int_Comparison_Exp>;
  specialConditionConfig?: InputMaybe<ProjectSpecialConditionConfig_Bool_Exp>;
  specialConditionTypeMappings?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
  specialConditionTypeMappings_aggregate?: InputMaybe<ProjectSpecialConditionTypeMapping_Aggregate_Bool_Exp>;
  speckleStream?: InputMaybe<Speckle_Stream_Bool_Exp>;
  speckleStreamId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  versions?: InputMaybe<ProjectVersion_Bool_Exp>;
  versions_aggregate?: InputMaybe<ProjectVersion_Aggregate_Bool_Exp>;
  yearOfCommissioning?: InputMaybe<Int_Comparison_Exp>;
  yearOfConstruction?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "project" */
export enum Project_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_pkey = 'project_pkey'
}

/** input type for incrementing numeric columns in table "project" */
export type Project_Inc_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  numberOfPeople?: InputMaybe<Scalars['numeric']['input']>;
  projectStatusId?: InputMaybe<Scalars['Int']['input']>;
  sourceVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  yearOfCommissioning?: InputMaybe<Scalars['Int']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project" */
export type Project_Insert_Input = {
  activeRevision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  activeRevisionId?: InputMaybe<Scalars['uuid']['input']>;
  builderName?: InputMaybe<Scalars['String']['input']>;
  buildingAreas?: InputMaybe<ProjectBuildingArea_Arr_Rel_Insert_Input>;
  buildingType?: InputMaybe<BuildingType_Obj_Rel_Insert_Input>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  calculation?: InputMaybe<ProjectCalculation_Obj_Rel_Insert_Input>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedBy?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation?: InputMaybe<ProjectInstallation_Obj_Rel_Insert_Input>;
  lcaResponsibleName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ProjectLocation_Obj_Rel_Insert_Input>;
  memberships?: InputMaybe<ProjectMembership_Arr_Rel_Insert_Input>;
  models?: InputMaybe<ProjectModel_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfPeople?: InputMaybe<Scalars['numeric']['input']>;
  operational?: InputMaybe<ProjectOperational_Obj_Rel_Insert_Input>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
  projectStatus?: InputMaybe<ProjectStatus_Obj_Rel_Insert_Input>;
  projectStatusId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreas?: InputMaybe<ProjectReferenceArea_Arr_Rel_Insert_Input>;
  revisions?: InputMaybe<ProjectRevision_Arr_Rel_Insert_Input>;
  sourceProject?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  sourceProjectId?: InputMaybe<Scalars['uuid']['input']>;
  sourceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  sourceVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  specialConditionConfig?: InputMaybe<ProjectSpecialConditionConfig_Obj_Rel_Insert_Input>;
  specialConditionTypeMappings?: InputMaybe<ProjectSpecialConditionTypeMapping_Arr_Rel_Insert_Input>;
  speckleStream?: InputMaybe<Speckle_Stream_Obj_Rel_Insert_Input>;
  speckleStreamId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  versions?: InputMaybe<ProjectVersion_Arr_Rel_Insert_Input>;
  yearOfCommissioning?: InputMaybe<Scalars['Int']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Project_Max_Fields = {
  __typename?: 'project_max_fields';
  activeRevisionId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  builderName?: Maybe<Scalars['String']['output']>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedBy?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lcaResponsibleName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPeople?: Maybe<Scalars['numeric']['output']>;
  projectNumber?: Maybe<Scalars['String']['output']>;
  projectStatusId?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "project_membership_role" */
  role?: Maybe<Scalars['String']['output']>;
  sourceProjectId?: Maybe<Scalars['uuid']['output']>;
  sourceVersionId?: Maybe<Scalars['uuid']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Int']['output']>;
  speckleStreamId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Int']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Project_Min_Fields = {
  __typename?: 'project_min_fields';
  activeRevisionId?: Maybe<Scalars['uuid']['output']>;
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  builderName?: Maybe<Scalars['String']['output']>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedBy?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lcaResponsibleName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPeople?: Maybe<Scalars['numeric']['output']>;
  projectNumber?: Maybe<Scalars['String']['output']>;
  projectStatusId?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "project_membership_role" */
  role?: Maybe<Scalars['String']['output']>;
  sourceProjectId?: Maybe<Scalars['uuid']['output']>;
  sourceVersionId?: Maybe<Scalars['uuid']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Int']['output']>;
  speckleStreamId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Int']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "project" */
export type Project_Mutation_Response = {
  __typename?: 'project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project>;
};

/** input type for inserting object relation for remote table "project" */
export type Project_Obj_Rel_Insert_Input = {
  data: Project_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** on_conflict condition type for table "project" */
export type Project_On_Conflict = {
  constraint: Project_Constraint;
  update_columns?: Array<Project_Update_Column>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** Ordering options when selecting data from "project". */
export type Project_Order_By = {
  activeRevision?: InputMaybe<ProjectRevision_Order_By>;
  activeRevisionId?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  builderName?: InputMaybe<Order_By>;
  buildingAreas_aggregate?: InputMaybe<ProjectBuildingArea_Aggregate_Order_By>;
  buildingType?: InputMaybe<BuildingType_Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  calculation?: InputMaybe<ProjectCalculation_Order_By>;
  clientName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  deletedBy?: InputMaybe<Order_By>;
  favorite?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation?: InputMaybe<ProjectInstallation_Order_By>;
  lcaResponsibleName?: InputMaybe<Order_By>;
  location?: InputMaybe<ProjectLocation_Order_By>;
  memberships_aggregate?: InputMaybe<ProjectMembership_Aggregate_Order_By>;
  models_aggregate?: InputMaybe<ProjectModel_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfPeople?: InputMaybe<Order_By>;
  operational?: InputMaybe<ProjectOperational_Order_By>;
  projectNumber?: InputMaybe<Order_By>;
  projectStatus?: InputMaybe<ProjectStatus_Order_By>;
  projectStatusId?: InputMaybe<Order_By>;
  referenceAreas_aggregate?: InputMaybe<ProjectReferenceArea_Aggregate_Order_By>;
  revisions_aggregate?: InputMaybe<ProjectRevision_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
  sourceProject?: InputMaybe<Project_Order_By>;
  sourceProjectId?: InputMaybe<Order_By>;
  sourceVersionId?: InputMaybe<Order_By>;
  sourceVersionNumber?: InputMaybe<Order_By>;
  specialConditionConfig?: InputMaybe<ProjectSpecialConditionConfig_Order_By>;
  specialConditionTypeMappings_aggregate?: InputMaybe<ProjectSpecialConditionTypeMapping_Aggregate_Order_By>;
  speckleStream?: InputMaybe<Speckle_Stream_Order_By>;
  speckleStreamId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  versions_aggregate?: InputMaybe<ProjectVersion_Aggregate_Order_By>;
  yearOfCommissioning?: InputMaybe<Order_By>;
  yearOfConstruction?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project */
export type Project_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

export type Project_Restore_Copy_Mappings_Args = {
  arg_as_of?: InputMaybe<Scalars['timestamptz']['input']>;
  arg_source_project_id?: InputMaybe<Scalars['uuid']['input']>;
  arg_source_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  arg_state_from_history?: InputMaybe<Scalars['Boolean']['input']>;
  arg_target_project_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Project_Revision_Save_Args = {
  arg_created_by?: InputMaybe<Scalars['uuid']['input']>;
  arg_marten_version?: InputMaybe<Scalars['Int']['input']>;
  arg_name?: InputMaybe<Scalars['String']['input']>;
  arg_project_id?: InputMaybe<Scalars['uuid']['input']>;
  arg_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  arg_tenant_id?: InputMaybe<Scalars['String']['input']>;
  arg_version_number?: InputMaybe<Scalars['Int']['input']>;
};

export type Project_Revision_Save_Frozen_Args = {
  arg_as_of?: InputMaybe<Scalars['timestamptz']['input']>;
  arg_builder_name?: InputMaybe<Scalars['String']['input']>;
  arg_building_type_id?: InputMaybe<Scalars['Int']['input']>;
  arg_client_name?: InputMaybe<Scalars['String']['input']>;
  arg_created_by?: InputMaybe<Scalars['uuid']['input']>;
  arg_lca_responsible_name?: InputMaybe<Scalars['String']['input']>;
  arg_marten_version?: InputMaybe<Scalars['Int']['input']>;
  arg_name?: InputMaybe<Scalars['String']['input']>;
  arg_number_of_people?: InputMaybe<Scalars['numeric']['input']>;
  arg_parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  arg_project_id?: InputMaybe<Scalars['uuid']['input']>;
  arg_project_name?: InputMaybe<Scalars['String']['input']>;
  arg_project_number?: InputMaybe<Scalars['String']['input']>;
  arg_project_status_id?: InputMaybe<Scalars['Int']['input']>;
  arg_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  arg_speckle_stream_id?: InputMaybe<Scalars['String']['input']>;
  arg_state_from_history?: InputMaybe<Scalars['Boolean']['input']>;
  arg_tenant_id?: InputMaybe<Scalars['String']['input']>;
  arg_version_number?: InputMaybe<Scalars['Int']['input']>;
  arg_year_of_commissioning?: InputMaybe<Scalars['Int']['input']>;
  arg_year_of_construction?: InputMaybe<Scalars['Int']['input']>;
};

export type Project_Revision_Switch_Args = {
  arg_incoming_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  arg_marten_version?: InputMaybe<Scalars['Int']['input']>;
  arg_project_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** select columns of table "project" */
export enum Project_Select_Column {
  /** column name */
  activeRevisionId = 'activeRevisionId',
  /** column name */
  builderName = 'builderName',
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  clientName = 'clientName',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  deletedBy = 'deletedBy',
  /** column name */
  id = 'id',
  /** column name */
  lcaResponsibleName = 'lcaResponsibleName',
  /** column name */
  name = 'name',
  /** column name */
  numberOfPeople = 'numberOfPeople',
  /** column name */
  projectNumber = 'projectNumber',
  /** column name */
  projectStatusId = 'projectStatusId',
  /** column name */
  sourceProjectId = 'sourceProjectId',
  /** column name */
  sourceVersionId = 'sourceVersionId',
  /** column name */
  sourceVersionNumber = 'sourceVersionNumber',
  /** column name */
  speckleStreamId = 'speckleStreamId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  yearOfCommissioning = 'yearOfCommissioning',
  /** column name */
  yearOfConstruction = 'yearOfConstruction'
}

/** input type for updating data in table "project" */
export type Project_Set_Input = {
  activeRevisionId?: InputMaybe<Scalars['uuid']['input']>;
  builderName?: InputMaybe<Scalars['String']['input']>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedBy?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lcaResponsibleName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfPeople?: InputMaybe<Scalars['numeric']['input']>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
  projectStatusId?: InputMaybe<Scalars['Int']['input']>;
  sourceProjectId?: InputMaybe<Scalars['uuid']['input']>;
  sourceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  sourceVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  speckleStreamId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  yearOfCommissioning?: InputMaybe<Scalars['Int']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

export type Project_Speckle_Stream_As_Of_Args = {
  arg_as_of?: InputMaybe<Scalars['timestamptz']['input']>;
  arg_project_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Project_Stddev_Fields = {
  __typename?: 'project_stddev_fields';
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Project_Stddev_Pop_Fields = {
  __typename?: 'project_stddev_pop_fields';
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Project_Stddev_Samp_Fields = {
  __typename?: 'project_stddev_samp_fields';
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "project" */
export type Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Stream_Cursor_Value_Input = {
  activeRevisionId?: InputMaybe<Scalars['uuid']['input']>;
  builderName?: InputMaybe<Scalars['String']['input']>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedBy?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lcaResponsibleName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfPeople?: InputMaybe<Scalars['numeric']['input']>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
  projectStatusId?: InputMaybe<Scalars['Int']['input']>;
  sourceProjectId?: InputMaybe<Scalars['uuid']['input']>;
  sourceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  sourceVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  speckleStreamId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  yearOfCommissioning?: InputMaybe<Scalars['Int']['input']>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Project_Sum_Fields = {
  __typename?: 'project_sum_fields';
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  numberOfPeople?: Maybe<Scalars['numeric']['output']>;
  projectStatusId?: Maybe<Scalars['Int']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Int']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Int']['output']>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "project_transport" */
export type Project_Transport = {
  __typename?: 'project_transport';
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['uuid']['output'];
  /** An array relationship */
  default: Array<Project_Transport_Default>;
  /** An aggregate relationship */
  default_aggregate: Project_Transport_Default_Aggregate;
  distance: Scalars['numeric']['output'];
  emission?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  project_id: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  tenant_id: Scalars['String']['output'];
  /** An object relationship */
  transport: Transport;
  transportId: Scalars['uuid']['output'];
  transport_type_name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "project_transport" */
export type Project_TransportDefaultArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Default_Order_By>>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};


/** columns and relationships of "project_transport" */
export type Project_TransportDefault_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Default_Order_By>>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};

/** aggregated selection of "project_transport" */
export type Project_Transport_Aggregate = {
  __typename?: 'project_transport_aggregate';
  aggregate?: Maybe<Project_Transport_Aggregate_Fields>;
  nodes: Array<Project_Transport>;
};

export type Project_Transport_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Transport_Aggregate_Bool_Exp_Count>;
};

export type Project_Transport_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Transport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Transport_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_transport" */
export type Project_Transport_Aggregate_Fields = {
  __typename?: 'project_transport_aggregate_fields';
  avg?: Maybe<Project_Transport_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Transport_Max_Fields>;
  min?: Maybe<Project_Transport_Min_Fields>;
  stddev?: Maybe<Project_Transport_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Transport_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Transport_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Transport_Sum_Fields>;
  var_pop?: Maybe<Project_Transport_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Transport_Var_Samp_Fields>;
  variance?: Maybe<Project_Transport_Variance_Fields>;
};


/** aggregate fields of "project_transport" */
export type Project_Transport_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Transport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_transport" */
export type Project_Transport_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Transport_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Transport_Max_Order_By>;
  min?: InputMaybe<Project_Transport_Min_Order_By>;
  stddev?: InputMaybe<Project_Transport_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Transport_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Transport_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Transport_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Transport_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Transport_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Transport_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_transport" */
export type Project_Transport_Arr_Rel_Insert_Input = {
  data: Array<Project_Transport_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Transport_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Transport_Avg_Fields = {
  __typename?: 'project_transport_avg_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_transport" */
export type Project_Transport_Avg_Order_By = {
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_transport". All fields are combined with a logical 'AND'. */
export type Project_Transport_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Transport_Bool_Exp>>;
  _not?: InputMaybe<Project_Transport_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Transport_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  default?: InputMaybe<Project_Transport_Default_Bool_Exp>;
  default_aggregate?: InputMaybe<Project_Transport_Default_Aggregate_Bool_Exp>;
  distance?: InputMaybe<Numeric_Comparison_Exp>;
  emission?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  transport?: InputMaybe<Transport_Bool_Exp>;
  transportId?: InputMaybe<Uuid_Comparison_Exp>;
  transport_type_name?: InputMaybe<String_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_transport" */
export enum Project_Transport_Constraint {
  /** unique or primary key constraint on columns "id", "project_id" */
  project_transport_id_project_id_key = 'project_transport_id_project_id_key',
  /** unique or primary key constraint on columns "id" */
  project_transport_pkey = 'project_transport_pkey'
}

/** columns and relationships of "project_transport_default" */
export type Project_Transport_Default = {
  __typename?: 'project_transport_default';
  project_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_transport: Project_Transport;
  project_transport_id: Scalars['uuid']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
};

/** aggregated selection of "project_transport_default" */
export type Project_Transport_Default_Aggregate = {
  __typename?: 'project_transport_default_aggregate';
  aggregate?: Maybe<Project_Transport_Default_Aggregate_Fields>;
  nodes: Array<Project_Transport_Default>;
};

export type Project_Transport_Default_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Transport_Default_Aggregate_Bool_Exp_Count>;
};

export type Project_Transport_Default_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Transport_Default_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_transport_default" */
export type Project_Transport_Default_Aggregate_Fields = {
  __typename?: 'project_transport_default_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Transport_Default_Max_Fields>;
  min?: Maybe<Project_Transport_Default_Min_Fields>;
};


/** aggregate fields of "project_transport_default" */
export type Project_Transport_Default_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_transport_default" */
export type Project_Transport_Default_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Transport_Default_Max_Order_By>;
  min?: InputMaybe<Project_Transport_Default_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_transport_default" */
export type Project_Transport_Default_Arr_Rel_Insert_Input = {
  data: Array<Project_Transport_Default_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Transport_Default_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_transport_default". All fields are combined with a logical 'AND'. */
export type Project_Transport_Default_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Transport_Default_Bool_Exp>>;
  _not?: InputMaybe<Project_Transport_Default_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Transport_Default_Bool_Exp>>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_transport?: InputMaybe<Project_Transport_Bool_Exp>;
  project_transport_id?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_transport_default" */
export enum Project_Transport_Default_Constraint {
  /** unique or primary key constraint on columns "project_transport_id" */
  project_transport_default_pkey = 'project_transport_default_pkey',
  /** unique or primary key constraint on columns "revision_id", "project_id" */
  project_transport_default_project_id_key = 'project_transport_default_project_id_key'
}

/** input type for inserting data into table "project_transport_default" */
export type Project_Transport_Default_Insert_Input = {
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_transport?: InputMaybe<Project_Transport_Obj_Rel_Insert_Input>;
  project_transport_id?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Project_Transport_Default_Max_Fields = {
  __typename?: 'project_transport_default_max_fields';
  project_id?: Maybe<Scalars['uuid']['output']>;
  project_transport_id?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_transport_default" */
export type Project_Transport_Default_Max_Order_By = {
  project_id?: InputMaybe<Order_By>;
  project_transport_id?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Transport_Default_Min_Fields = {
  __typename?: 'project_transport_default_min_fields';
  project_id?: Maybe<Scalars['uuid']['output']>;
  project_transport_id?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_transport_default" */
export type Project_Transport_Default_Min_Order_By = {
  project_id?: InputMaybe<Order_By>;
  project_transport_id?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_transport_default" */
export type Project_Transport_Default_Mutation_Response = {
  __typename?: 'project_transport_default_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Transport_Default>;
};

/** on_conflict condition type for table "project_transport_default" */
export type Project_Transport_Default_On_Conflict = {
  constraint: Project_Transport_Default_Constraint;
  update_columns?: Array<Project_Transport_Default_Update_Column>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};

/** Ordering options when selecting data from "project_transport_default". */
export type Project_Transport_Default_Order_By = {
  project_id?: InputMaybe<Order_By>;
  project_transport?: InputMaybe<Project_Transport_Order_By>;
  project_transport_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_transport_default */
export type Project_Transport_Default_Pk_Columns_Input = {
  project_transport_id: Scalars['uuid']['input'];
};

/** select columns of table "project_transport_default" */
export enum Project_Transport_Default_Select_Column {
  /** column name */
  project_id = 'project_id',
  /** column name */
  project_transport_id = 'project_transport_id',
  /** column name */
  revisionId = 'revisionId'
}

/** input type for updating data in table "project_transport_default" */
export type Project_Transport_Default_Set_Input = {
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_transport_id?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project_transport_default" */
export type Project_Transport_Default_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Transport_Default_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Transport_Default_Stream_Cursor_Value_Input = {
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_transport_id?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_transport_default" */
export enum Project_Transport_Default_Update_Column {
  /** column name */
  project_id = 'project_id',
  /** column name */
  project_transport_id = 'project_transport_id',
  /** column name */
  revisionId = 'revisionId'
}

export type Project_Transport_Default_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Transport_Default_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Transport_Default_Bool_Exp;
};

/** input type for incrementing numeric columns in table "project_transport" */
export type Project_Transport_Inc_Input = {
  distance?: InputMaybe<Scalars['numeric']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_transport" */
export type Project_Transport_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  default?: InputMaybe<Project_Transport_Default_Arr_Rel_Insert_Input>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  transport?: InputMaybe<Transport_Obj_Rel_Insert_Input>;
  transportId?: InputMaybe<Scalars['uuid']['input']>;
  transport_type_name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "project_transport_mapping" */
export type Project_Transport_Mapping = {
  __typename?: 'project_transport_mapping';
  created_at: Scalars['timestamptz']['output'];
  distance: Scalars['numeric']['output'];
  /** An array relationship */
  emissionFactors: Array<ProjectTransportMappingEmissionFactor>;
  /** An aggregate relationship */
  emissionFactors_aggregate: ProjectTransportMappingEmissionFactor_Aggregate;
  id: Scalars['uuid']['output'];
  material_id?: Maybe<Scalars['uuid']['output']>;
  project_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_transport?: Maybe<Project_Transport>;
  project_transport_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  transportEmissionFactorEmission?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  transportStandardValue?: Maybe<Transport_Standard_Value>;
  transportStandardValueId?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "project_transport_mapping" */
export type Project_Transport_MappingEmissionFactorsArgs = {
  distinct_on?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
};


/** columns and relationships of "project_transport_mapping" */
export type Project_Transport_MappingEmissionFactors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
};

/** aggregated selection of "project_transport_mapping" */
export type Project_Transport_Mapping_Aggregate = {
  __typename?: 'project_transport_mapping_aggregate';
  aggregate?: Maybe<Project_Transport_Mapping_Aggregate_Fields>;
  nodes: Array<Project_Transport_Mapping>;
};

export type Project_Transport_Mapping_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Transport_Mapping_Aggregate_Bool_Exp_Count>;
};

export type Project_Transport_Mapping_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Transport_Mapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_transport_mapping" */
export type Project_Transport_Mapping_Aggregate_Fields = {
  __typename?: 'project_transport_mapping_aggregate_fields';
  avg?: Maybe<Project_Transport_Mapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Transport_Mapping_Max_Fields>;
  min?: Maybe<Project_Transport_Mapping_Min_Fields>;
  stddev?: Maybe<Project_Transport_Mapping_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Transport_Mapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Transport_Mapping_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Transport_Mapping_Sum_Fields>;
  var_pop?: Maybe<Project_Transport_Mapping_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Transport_Mapping_Var_Samp_Fields>;
  variance?: Maybe<Project_Transport_Mapping_Variance_Fields>;
};


/** aggregate fields of "project_transport_mapping" */
export type Project_Transport_Mapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Transport_Mapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_transport_mapping" */
export type Project_Transport_Mapping_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Transport_Mapping_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Transport_Mapping_Max_Order_By>;
  min?: InputMaybe<Project_Transport_Mapping_Min_Order_By>;
  stddev?: InputMaybe<Project_Transport_Mapping_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Transport_Mapping_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Transport_Mapping_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Transport_Mapping_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Transport_Mapping_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Transport_Mapping_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Transport_Mapping_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_transport_mapping" */
export type Project_Transport_Mapping_Arr_Rel_Insert_Input = {
  data: Array<Project_Transport_Mapping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Transport_Mapping_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Transport_Mapping_Avg_Fields = {
  __typename?: 'project_transport_mapping_avg_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Avg_Order_By = {
  distance?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_transport_mapping". All fields are combined with a logical 'AND'. */
export type Project_Transport_Mapping_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Transport_Mapping_Bool_Exp>>;
  _not?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Transport_Mapping_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  distance?: InputMaybe<Numeric_Comparison_Exp>;
  emissionFactors?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
  emissionFactors_aggregate?: InputMaybe<ProjectTransportMappingEmissionFactor_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  material_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_transport?: InputMaybe<Project_Transport_Bool_Exp>;
  project_transport_id?: InputMaybe<Uuid_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  transportEmissionFactorEmission?: InputMaybe<Numeric_Comparison_Exp>;
  transportStandardValue?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
  transportStandardValueId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_transport_mapping" */
export enum Project_Transport_Mapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_transport_mapping_pkey = 'project_transport_mapping_pkey'
}

/** input type for incrementing numeric columns in table "project_transport_mapping" */
export type Project_Transport_Mapping_Inc_Input = {
  distance?: InputMaybe<Scalars['numeric']['input']>;
  transportEmissionFactorEmission?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_transport_mapping" */
export type Project_Transport_Mapping_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  emissionFactors?: InputMaybe<ProjectTransportMappingEmissionFactor_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  material_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_transport?: InputMaybe<Project_Transport_Obj_Rel_Insert_Input>;
  project_transport_id?: InputMaybe<Scalars['uuid']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  transportEmissionFactorEmission?: InputMaybe<Scalars['numeric']['input']>;
  transportStandardValue?: InputMaybe<Transport_Standard_Value_Obj_Rel_Insert_Input>;
  transportStandardValueId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Project_Transport_Mapping_Max_Fields = {
  __typename?: 'project_transport_mapping_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  distance?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  material_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  project_transport_id?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['numeric']['output']>;
  transportStandardValueId?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  material_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_transport_id?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
  transportStandardValueId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Transport_Mapping_Min_Fields = {
  __typename?: 'project_transport_mapping_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  distance?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  material_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  project_transport_id?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['numeric']['output']>;
  transportStandardValueId?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  material_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_transport_id?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
  transportStandardValueId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_transport_mapping" */
export type Project_Transport_Mapping_Mutation_Response = {
  __typename?: 'project_transport_mapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Transport_Mapping>;
};

/** input type for inserting object relation for remote table "project_transport_mapping" */
export type Project_Transport_Mapping_Obj_Rel_Insert_Input = {
  data: Project_Transport_Mapping_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Transport_Mapping_On_Conflict>;
};

/** on_conflict condition type for table "project_transport_mapping" */
export type Project_Transport_Mapping_On_Conflict = {
  constraint: Project_Transport_Mapping_Constraint;
  update_columns?: Array<Project_Transport_Mapping_Update_Column>;
  where?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
};

/** Ordering options when selecting data from "project_transport_mapping". */
export type Project_Transport_Mapping_Order_By = {
  created_at?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  emissionFactors_aggregate?: InputMaybe<ProjectTransportMappingEmissionFactor_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  material_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_transport?: InputMaybe<Project_Transport_Order_By>;
  project_transport_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
  transportStandardValue?: InputMaybe<Transport_Standard_Value_Order_By>;
  transportStandardValueId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_transport_mapping */
export type Project_Transport_Mapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_transport_mapping" */
export enum Project_Transport_Mapping_Select_Column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  distance = 'distance',
  /** column name */
  id = 'id',
  /** column name */
  material_id = 'material_id',
  /** column name */
  project_id = 'project_id',
  /** column name */
  project_transport_id = 'project_transport_id',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  transportEmissionFactorEmission = 'transportEmissionFactorEmission',
  /** column name */
  transportStandardValueId = 'transportStandardValueId',
  /** column name */
  updated_at = 'updated_at'
}

/** input type for updating data in table "project_transport_mapping" */
export type Project_Transport_Mapping_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  material_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_transport_id?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  transportEmissionFactorEmission?: InputMaybe<Scalars['numeric']['input']>;
  transportStandardValueId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Project_Transport_Mapping_Stddev_Fields = {
  __typename?: 'project_transport_mapping_stddev_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Stddev_Order_By = {
  distance?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Transport_Mapping_Stddev_Pop_Fields = {
  __typename?: 'project_transport_mapping_stddev_pop_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Stddev_Pop_Order_By = {
  distance?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Transport_Mapping_Stddev_Samp_Fields = {
  __typename?: 'project_transport_mapping_stddev_samp_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Stddev_Samp_Order_By = {
  distance?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_transport_mapping" */
export type Project_Transport_Mapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Transport_Mapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Transport_Mapping_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  material_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_transport_id?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  transportEmissionFactorEmission?: InputMaybe<Scalars['numeric']['input']>;
  transportStandardValueId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Project_Transport_Mapping_Sum_Fields = {
  __typename?: 'project_transport_mapping_sum_fields';
  distance?: Maybe<Scalars['numeric']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Sum_Order_By = {
  distance?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
};

/** update columns of table "project_transport_mapping" */
export enum Project_Transport_Mapping_Update_Column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  distance = 'distance',
  /** column name */
  id = 'id',
  /** column name */
  material_id = 'material_id',
  /** column name */
  project_id = 'project_id',
  /** column name */
  project_transport_id = 'project_transport_id',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  transportEmissionFactorEmission = 'transportEmissionFactorEmission',
  /** column name */
  transportStandardValueId = 'transportStandardValueId',
  /** column name */
  updated_at = 'updated_at'
}

export type Project_Transport_Mapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Transport_Mapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Transport_Mapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Transport_Mapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Transport_Mapping_Var_Pop_Fields = {
  __typename?: 'project_transport_mapping_var_pop_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Var_Pop_Order_By = {
  distance?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Transport_Mapping_Var_Samp_Fields = {
  __typename?: 'project_transport_mapping_var_samp_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Var_Samp_Order_By = {
  distance?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Transport_Mapping_Variance_Fields = {
  __typename?: 'project_transport_mapping_variance_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  transportEmissionFactorEmission?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_transport_mapping" */
export type Project_Transport_Mapping_Variance_Order_By = {
  distance?: InputMaybe<Order_By>;
  transportEmissionFactorEmission?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Project_Transport_Max_Fields = {
  __typename?: 'project_transport_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  distance?: Maybe<Scalars['numeric']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  transportId?: Maybe<Scalars['uuid']['output']>;
  transport_type_name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_transport" */
export type Project_Transport_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transportId?: InputMaybe<Order_By>;
  transport_type_name?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Transport_Min_Fields = {
  __typename?: 'project_transport_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  distance?: Maybe<Scalars['numeric']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  transportId?: Maybe<Scalars['uuid']['output']>;
  transport_type_name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_transport" */
export type Project_Transport_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  revisionId?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transportId?: InputMaybe<Order_By>;
  transport_type_name?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_transport" */
export type Project_Transport_Mutation_Response = {
  __typename?: 'project_transport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Transport>;
};

/** input type for inserting object relation for remote table "project_transport" */
export type Project_Transport_Obj_Rel_Insert_Input = {
  data: Project_Transport_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Transport_On_Conflict>;
};

/** on_conflict condition type for table "project_transport" */
export type Project_Transport_On_Conflict = {
  constraint: Project_Transport_Constraint;
  update_columns?: Array<Project_Transport_Update_Column>;
  where?: InputMaybe<Project_Transport_Bool_Exp>;
};

/** Ordering options when selecting data from "project_transport". */
export type Project_Transport_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  default_aggregate?: InputMaybe<Project_Transport_Default_Aggregate_Order_By>;
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transport?: InputMaybe<Transport_Order_By>;
  transportId?: InputMaybe<Order_By>;
  transport_type_name?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_transport */
export type Project_Transport_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_transport" */
export enum Project_Transport_Select_Column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  created_by = 'created_by',
  /** column name */
  distance = 'distance',
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  project_id = 'project_id',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  tenant_id = 'tenant_id',
  /** column name */
  transportId = 'transportId',
  /** column name */
  transport_type_name = 'transport_type_name',
  /** column name */
  updated_by = 'updated_by'
}

/** input type for updating data in table "project_transport" */
export type Project_Transport_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  transportId?: InputMaybe<Scalars['uuid']['input']>;
  transport_type_name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Project_Transport_Stddev_Fields = {
  __typename?: 'project_transport_stddev_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_transport" */
export type Project_Transport_Stddev_Order_By = {
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Transport_Stddev_Pop_Fields = {
  __typename?: 'project_transport_stddev_pop_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_transport" */
export type Project_Transport_Stddev_Pop_Order_By = {
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Transport_Stddev_Samp_Fields = {
  __typename?: 'project_transport_stddev_samp_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_transport" */
export type Project_Transport_Stddev_Samp_Order_By = {
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_transport" */
export type Project_Transport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Transport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Transport_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  transportId?: InputMaybe<Scalars['uuid']['input']>;
  transport_type_name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Project_Transport_Sum_Fields = {
  __typename?: 'project_transport_sum_fields';
  distance?: Maybe<Scalars['numeric']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_transport" */
export type Project_Transport_Sum_Order_By = {
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** update columns of table "project_transport" */
export enum Project_Transport_Update_Column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  created_by = 'created_by',
  /** column name */
  distance = 'distance',
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  project_id = 'project_id',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  tenant_id = 'tenant_id',
  /** column name */
  transportId = 'transportId',
  /** column name */
  transport_type_name = 'transport_type_name',
  /** column name */
  updated_by = 'updated_by'
}

export type Project_Transport_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Transport_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Transport_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Transport_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Transport_Var_Pop_Fields = {
  __typename?: 'project_transport_var_pop_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_transport" */
export type Project_Transport_Var_Pop_Order_By = {
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Transport_Var_Samp_Fields = {
  __typename?: 'project_transport_var_samp_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_transport" */
export type Project_Transport_Var_Samp_Order_By = {
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Transport_Variance_Fields = {
  __typename?: 'project_transport_variance_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_transport" */
export type Project_Transport_Variance_Order_By = {
  distance?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** update columns of table "project" */
export enum Project_Update_Column {
  /** column name */
  activeRevisionId = 'activeRevisionId',
  /** column name */
  builderName = 'builderName',
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  clientName = 'clientName',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  deletedBy = 'deletedBy',
  /** column name */
  id = 'id',
  /** column name */
  lcaResponsibleName = 'lcaResponsibleName',
  /** column name */
  name = 'name',
  /** column name */
  numberOfPeople = 'numberOfPeople',
  /** column name */
  projectNumber = 'projectNumber',
  /** column name */
  projectStatusId = 'projectStatusId',
  /** column name */
  sourceProjectId = 'sourceProjectId',
  /** column name */
  sourceVersionId = 'sourceVersionId',
  /** column name */
  sourceVersionNumber = 'sourceVersionNumber',
  /** column name */
  speckleStreamId = 'speckleStreamId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  yearOfCommissioning = 'yearOfCommissioning',
  /** column name */
  yearOfConstruction = 'yearOfConstruction'
}

export type Project_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Var_Pop_Fields = {
  __typename?: 'project_var_pop_fields';
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Project_Var_Samp_Fields = {
  __typename?: 'project_var_samp_fields';
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Project_Variance_Fields = {
  __typename?: 'project_variance_fields';
  /** A computed field - calculates total area depending on country and calculation type */
  area?: Maybe<Scalars['numeric']['output']>;
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
  numberOfPeople?: Maybe<Scalars['Float']['output']>;
  projectStatusId?: Maybe<Scalars['Float']['output']>;
  sourceVersionNumber?: Maybe<Scalars['Float']['output']>;
  yearOfCommissioning?: Maybe<Scalars['Float']['output']>;
  yearOfConstruction?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "agent_model_pricing" */
  agentModelPricing: Array<AgentModelPricing>;
  /** fetch aggregated fields from the table: "agent_model_pricing" */
  agentModelPricing_aggregate: AgentModelPricing_Aggregate;
  /** fetch data from the table: "agent_model_pricing" using primary key columns */
  agentModelPricing_by_pk?: Maybe<AgentModelPricing>;
  /** fetch data from the table: "agent_skills_tenant_user" */
  agentSkillsTenantUser: Array<AgentSkillsTenantUser>;
  /** fetch aggregated fields from the table: "agent_skills_tenant_user" */
  agentSkillsTenantUser_aggregate: AgentSkillsTenantUser_Aggregate;
  /** fetch data from the table: "agent_skills_tenant_user" using primary key columns */
  agentSkillsTenantUser_by_pk?: Maybe<AgentSkillsTenantUser>;
  /** fetch data from the table: "agent_usage_budget_status" */
  agentUsageBudgetStatus: Array<AgentUsageBudgetStatus>;
  /** fetch aggregated fields from the table: "agent_usage_budget_status" */
  agentUsageBudgetStatus_aggregate: AgentUsageBudgetStatus_Aggregate;
  /** fetch data from the table: "agent_usage_daily" */
  agentUsageDaily: Array<AgentUsageDaily>;
  /** fetch aggregated fields from the table: "agent_usage_daily" */
  agentUsageDaily_aggregate: AgentUsageDaily_Aggregate;
  /** fetch data from the table: "agent_usage_request" */
  agentUsageRequest: Array<AgentUsageRequest>;
  /** fetch aggregated fields from the table: "agent_usage_request" */
  agentUsageRequest_aggregate: AgentUsageRequest_Aggregate;
  /** fetch data from the table: "agent_usage_session" */
  agentUsageSession: Array<AgentUsageSession>;
  /** fetch aggregated fields from the table: "agent_usage_session" */
  agentUsageSession_aggregate: AgentUsageSession_Aggregate;
  /** fetch data from the table: "application_source" */
  applicationSource: Array<ApplicationSource>;
  /** fetch aggregated fields from the table: "application_source" */
  applicationSource_aggregate: ApplicationSource_Aggregate;
  /** fetch data from the table: "application_source" using primary key columns */
  applicationSource_by_pk?: Maybe<ApplicationSource>;
  /** fetch data from the table: "benchmark_grouping_verdict" */
  benchmarkGroupingVerdict: Array<BenchmarkGroupingVerdict>;
  /** fetch aggregated fields from the table: "benchmark_grouping_verdict" */
  benchmarkGroupingVerdict_aggregate: BenchmarkGroupingVerdict_Aggregate;
  /** fetch data from the table: "benchmark_grouping_verdict" using primary key columns */
  benchmarkGroupingVerdict_by_pk?: Maybe<BenchmarkGroupingVerdict>;
  /** fetch data from the table: "benchmark_inventory_material" */
  benchmarkInventoryMaterial: Array<BenchmarkInventoryMaterial>;
  /** fetch aggregated fields from the table: "benchmark_inventory_material" */
  benchmarkInventoryMaterial_aggregate: BenchmarkInventoryMaterial_Aggregate;
  /** fetch data from the table: "benchmark_inventory_material" using primary key columns */
  benchmarkInventoryMaterial_by_pk?: Maybe<BenchmarkInventoryMaterial>;
  /** fetch data from the table: "benchmark_material_mapping" */
  benchmarkMaterialMapping: Array<BenchmarkMaterialMapping>;
  /** fetch aggregated fields from the table: "benchmark_material_mapping" */
  benchmarkMaterialMapping_aggregate: BenchmarkMaterialMapping_Aggregate;
  /** fetch data from the table: "benchmark_material_mapping" using primary key columns */
  benchmarkMaterialMapping_by_pk?: Maybe<BenchmarkMaterialMapping>;
  /** fetch data from the table: "benchmark_project_state" */
  benchmarkProjectState: Array<BenchmarkProjectState>;
  /** fetch aggregated fields from the table: "benchmark_project_state" */
  benchmarkProjectState_aggregate: BenchmarkProjectState_Aggregate;
  /** fetch data from the table: "benchmark_project_state" using primary key columns */
  benchmarkProjectState_by_pk?: Maybe<BenchmarkProjectState>;
  /** fetch data from the table: "benchmark_snapshot" */
  benchmarkSnapshot: Array<BenchmarkSnapshot>;
  /** fetch aggregated fields from the table: "benchmark_snapshot" */
  benchmarkSnapshot_aggregate: BenchmarkSnapshot_Aggregate;
  /** fetch data from the table: "benchmark_snapshot" using primary key columns */
  benchmarkSnapshot_by_pk?: Maybe<BenchmarkSnapshot>;
  /** fetch data from the table: "building_area_type" */
  buildingAreaType: Array<BuildingAreaType>;
  /** fetch aggregated fields from the table: "building_area_type" */
  buildingAreaType_aggregate: BuildingAreaType_Aggregate;
  /** fetch data from the table: "building_area_type" using primary key columns */
  buildingAreaType_by_pk?: Maybe<BuildingAreaType>;
  /** fetch data from the table: "building_part" */
  buildingPart: Array<BuildingPart>;
  /** fetch data from the table: "building_part_lifetime_source" */
  buildingPartLifetimeSource: Array<BuildingPartLifetimeSource>;
  /** fetch aggregated fields from the table: "building_part_lifetime_source" */
  buildingPartLifetimeSource_aggregate: BuildingPartLifetimeSource_Aggregate;
  /** fetch data from the table: "building_part_lifetime_source" using primary key columns */
  buildingPartLifetimeSource_by_pk?: Maybe<BuildingPartLifetimeSource>;
  /** fetch data from the table: "building_part_maintenance_lifetime" */
  buildingPartMaintenanceLifetime: Array<BuildingPartMaintenanceLifetime>;
  /** fetch aggregated fields from the table: "building_part_maintenance_lifetime" */
  buildingPartMaintenanceLifetime_aggregate: BuildingPartMaintenanceLifetime_Aggregate;
  /** fetch data from the table: "building_part_maintenance_lifetime" using primary key columns */
  buildingPartMaintenanceLifetime_by_pk?: Maybe<BuildingPartMaintenanceLifetime>;
  /** fetch data from the table: "building_part_service_lifetime" */
  buildingPartServiceLifetime: Array<BuildingPartServiceLifetime>;
  /** fetch aggregated fields from the table: "building_part_service_lifetime" */
  buildingPartServiceLifetime_aggregate: BuildingPartServiceLifetime_Aggregate;
  /** fetch data from the table: "building_part_service_lifetime" using primary key columns */
  buildingPartServiceLifetime_by_pk?: Maybe<BuildingPartServiceLifetime>;
  /** fetch aggregated fields from the table: "building_part" */
  buildingPart_aggregate: BuildingPart_Aggregate;
  /** fetch data from the table: "building_part" using primary key columns */
  buildingPart_by_pk?: Maybe<BuildingPart>;
  /** fetch data from the table: "building_type" */
  buildingType: Array<BuildingType>;
  /** fetch aggregated fields from the table: "building_type" */
  buildingType_aggregate: BuildingType_Aggregate;
  /** fetch data from the table: "building_type" using primary key columns */
  buildingType_by_pk?: Maybe<BuildingType>;
  /** fetch data from the table: "building_element" */
  building_element: Array<Building_Element>;
  /** fetch aggregated fields from the table: "building_element" */
  building_element_aggregate: Building_Element_Aggregate;
  /** fetch data from the table: "building_element" using primary key columns */
  building_element_by_pk?: Maybe<Building_Element>;
  /** fetch data from the table: "building_element_classification_code_mapping" */
  building_element_classification_code_mapping: Array<Building_Element_Classification_Code_Mapping>;
  /** fetch aggregated fields from the table: "building_element_classification_code_mapping" */
  building_element_classification_code_mapping_aggregate: Building_Element_Classification_Code_Mapping_Aggregate;
  /** fetch data from the table: "building_element_classification_code_mapping" using primary key columns */
  building_element_classification_code_mapping_by_pk?: Maybe<Building_Element_Classification_Code_Mapping>;
  /** fetch data from the table: "building_element_material_category_mapping" */
  building_element_material_category_mapping: Array<Building_Element_Material_Category_Mapping>;
  /** fetch aggregated fields from the table: "building_element_material_category_mapping" */
  building_element_material_category_mapping_aggregate: Building_Element_Material_Category_Mapping_Aggregate;
  /** fetch data from the table: "building_element_material_category_mapping" using primary key columns */
  building_element_material_category_mapping_by_pk?: Maybe<Building_Element_Material_Category_Mapping>;
  /** An array relationship */
  calculationType: Array<CalculationType>;
  /** fetch data from the table: "calculation_type_epd_datasource" */
  calculationTypeEpdDatasource: Array<CalculationTypeEpdDatasource>;
  /** fetch aggregated fields from the table: "calculation_type_epd_datasource" */
  calculationTypeEpdDatasource_aggregate: CalculationTypeEpdDatasource_Aggregate;
  /** fetch data from the table: "calculation_type_epd_datasource" using primary key columns */
  calculationTypeEpdDatasource_by_pk?: Maybe<CalculationTypeEpdDatasource>;
  /** fetch data from the table: "calculation_type_threshold_by_building_type" */
  calculationTypeThresholdByBuildingType: Array<CalculationTypeThresholdByBuildingType>;
  /** fetch aggregated fields from the table: "calculation_type_threshold_by_building_type" */
  calculationTypeThresholdByBuildingType_aggregate: CalculationTypeThresholdByBuildingType_Aggregate;
  /** fetch data from the table: "calculation_type_threshold_by_building_type" using primary key columns */
  calculationTypeThresholdByBuildingType_by_pk?: Maybe<CalculationTypeThresholdByBuildingType>;
  /** fetch data from the table: "calculation_type_variant" */
  calculationTypeVariant: Array<CalculationTypeVariant>;
  /** fetch aggregated fields from the table: "calculation_type_variant" */
  calculationTypeVariant_aggregate: CalculationTypeVariant_Aggregate;
  /** fetch data from the table: "calculation_type_variant" using primary key columns */
  calculationTypeVariant_by_pk?: Maybe<CalculationTypeVariant>;
  /** An aggregate relationship */
  calculationType_aggregate: CalculationType_Aggregate;
  /** fetch data from the table: "calculation_type" using primary key columns */
  calculationType_by_pk?: Maybe<CalculationType>;
  /** fetch data from the table: "calculation_type_stage" */
  calculation_type_stage: Array<Calculation_Type_Stage>;
  /** fetch aggregated fields from the table: "calculation_type_stage" */
  calculation_type_stage_aggregate: Calculation_Type_Stage_Aggregate;
  /** fetch data from the table: "calculation_type_stage" using primary key columns */
  calculation_type_stage_by_pk?: Maybe<Calculation_Type_Stage>;
  /** fetch data from the table: "classification_code" */
  classificationCode: Array<ClassificationCode>;
  /** fetch data from the table: "classification_code_translation" */
  classificationCodeTranslation: Array<ClassificationCodeTranslation>;
  /** fetch aggregated fields from the table: "classification_code_translation" */
  classificationCodeTranslation_aggregate: ClassificationCodeTranslation_Aggregate;
  /** fetch data from the table: "classification_code_translation" using primary key columns */
  classificationCodeTranslation_by_pk?: Maybe<ClassificationCodeTranslation>;
  /** fetch data from the table: "classification_type_country" */
  classificationCodeTypeCountry: Array<ClassificationCodeTypeCountry>;
  /** fetch aggregated fields from the table: "classification_type_country" */
  classificationCodeTypeCountry_aggregate: ClassificationCodeTypeCountry_Aggregate;
  /** fetch data from the table: "classification_type_country" using primary key columns */
  classificationCodeTypeCountry_by_pk?: Maybe<ClassificationCodeTypeCountry>;
  /** fetch aggregated fields from the table: "classification_code" */
  classificationCode_aggregate: ClassificationCode_Aggregate;
  /** fetch data from the table: "classification_code" using primary key columns */
  classificationCode_by_pk?: Maybe<ClassificationCode>;
  /** fetch data from the table: "classification_object_class" */
  classificationObjectClass: Array<ClassificationObjectClass>;
  /** An array relationship */
  classificationObjectClassParameter: Array<ClassificationObjectClassParameter>;
  /** An aggregate relationship */
  classificationObjectClassParameter_aggregate: ClassificationObjectClassParameter_Aggregate;
  /** fetch data from the table: "classification_object_class_parameter" using primary key columns */
  classificationObjectClassParameter_by_pk?: Maybe<ClassificationObjectClassParameter>;
  /** fetch data from the table: "classification_object_class_translation" */
  classificationObjectClassTranslation: Array<ClassificationObjectClassTranslation>;
  /** fetch aggregated fields from the table: "classification_object_class_translation" */
  classificationObjectClassTranslation_aggregate: ClassificationObjectClassTranslation_Aggregate;
  /** fetch data from the table: "classification_object_class_translation" using primary key columns */
  classificationObjectClassTranslation_by_pk?: Maybe<ClassificationObjectClassTranslation>;
  /** fetch aggregated fields from the table: "classification_object_class" */
  classificationObjectClass_aggregate: ClassificationObjectClass_Aggregate;
  /** fetch data from the table: "classification_object_class" using primary key columns */
  classificationObjectClass_by_pk?: Maybe<ClassificationObjectClass>;
  /** fetch data from the table: "classification_type" */
  classificationType: Array<ClassificationType>;
  /** fetch data from the table: "classification_type_parameter" */
  classificationTypeAttribute: Array<ClassificationTypeAttribute>;
  /** fetch aggregated fields from the table: "classification_type_parameter" */
  classificationTypeAttribute_aggregate: ClassificationTypeAttribute_Aggregate;
  /** fetch data from the table: "classification_type_parameter" using primary key columns */
  classificationTypeAttribute_by_pk?: Maybe<ClassificationTypeAttribute>;
  /** fetch aggregated fields from the table: "classification_type" */
  classificationType_aggregate: ClassificationType_Aggregate;
  /** fetch data from the table: "classification_type" using primary key columns */
  classificationType_by_pk?: Maybe<ClassificationType>;
  /** fetch data from the table: "component_object_phase" */
  componentObjectPhase: Array<ComponentObjectPhase>;
  /** fetch aggregated fields from the table: "component_object_phase" */
  componentObjectPhase_aggregate: ComponentObjectPhase_Aggregate;
  /** fetch data from the table: "component_object_phase" using primary key columns */
  componentObjectPhase_by_pk?: Maybe<ComponentObjectPhase>;
  /** fetch data from the table: "construction" */
  construction: Array<Construction>;
  /** fetch data from the table: "construction_build_up_part" */
  constructionBuildUpPart: Array<ConstructionBuildUpPart>;
  /** fetch data from the table: "construction_build_up_part_material_category" */
  constructionBuildUpPartMaterialCategory: Array<ConstructionBuildUpPartMaterialCategory>;
  /** fetch aggregated fields from the table: "construction_build_up_part_material_category" */
  constructionBuildUpPartMaterialCategory_aggregate: ConstructionBuildUpPartMaterialCategory_Aggregate;
  /** fetch data from the table: "construction_build_up_part_material_category" using primary key columns */
  constructionBuildUpPartMaterialCategory_by_pk?: Maybe<ConstructionBuildUpPartMaterialCategory>;
  /** fetch data from the table: "construction_build_up_part_translation" */
  constructionBuildUpPartTranslation: Array<ConstructionBuildUpPartTranslation>;
  /** fetch aggregated fields from the table: "construction_build_up_part_translation" */
  constructionBuildUpPartTranslation_aggregate: ConstructionBuildUpPartTranslation_Aggregate;
  /** fetch data from the table: "construction_build_up_part_translation" using primary key columns */
  constructionBuildUpPartTranslation_by_pk?: Maybe<ConstructionBuildUpPartTranslation>;
  /** fetch aggregated fields from the table: "construction_build_up_part" */
  constructionBuildUpPart_aggregate: ConstructionBuildUpPart_Aggregate;
  /** fetch data from the table: "construction_build_up_part" using primary key columns */
  constructionBuildUpPart_by_pk?: Maybe<ConstructionBuildUpPart>;
  /** fetch data from the table: "construction_build_up_template" */
  constructionBuildUpTemplate: Array<ConstructionBuildUpTemplate>;
  /** fetch data from the table: "construction_build_up_template_translation" */
  constructionBuildUpTemplateTranslation: Array<ConstructionBuildUpTemplateTranslation>;
  /** fetch aggregated fields from the table: "construction_build_up_template_translation" */
  constructionBuildUpTemplateTranslation_aggregate: ConstructionBuildUpTemplateTranslation_Aggregate;
  /** fetch data from the table: "construction_build_up_template_translation" using primary key columns */
  constructionBuildUpTemplateTranslation_by_pk?: Maybe<ConstructionBuildUpTemplateTranslation>;
  /** fetch aggregated fields from the table: "construction_build_up_template" */
  constructionBuildUpTemplate_aggregate: ConstructionBuildUpTemplate_Aggregate;
  /** fetch data from the table: "construction_build_up_template" using primary key columns */
  constructionBuildUpTemplate_by_pk?: Maybe<ConstructionBuildUpTemplate>;
  /** fetch data from the table: "construction_category" */
  constructionCategory: Array<ConstructionCategory>;
  /** fetch data from the table: "construction_category_translation" */
  constructionCategoryTranslation: Array<ConstructionCategoryTranslation>;
  /** fetch aggregated fields from the table: "construction_category_translation" */
  constructionCategoryTranslation_aggregate: ConstructionCategoryTranslation_Aggregate;
  /** fetch data from the table: "construction_category_translation" using primary key columns */
  constructionCategoryTranslation_by_pk?: Maybe<ConstructionCategoryTranslation>;
  /** fetch data from the table: "construction_category_unit" */
  constructionCategoryUnit: Array<ConstructionCategoryUnit>;
  /** fetch aggregated fields from the table: "construction_category_unit" */
  constructionCategoryUnit_aggregate: ConstructionCategoryUnit_Aggregate;
  /** fetch data from the table: "construction_category_unit" using primary key columns */
  constructionCategoryUnit_by_pk?: Maybe<ConstructionCategoryUnit>;
  /** fetch aggregated fields from the table: "construction_category" */
  constructionCategory_aggregate: ConstructionCategory_Aggregate;
  /** fetch data from the table: "construction_category" using primary key columns */
  constructionCategory_by_pk?: Maybe<ConstructionCategory>;
  /** fetch data from the table: "construction_country" */
  constructionCountry: Array<ConstructionCountry>;
  /** fetch aggregated fields from the table: "construction_country" */
  constructionCountry_aggregate: ConstructionCountry_Aggregate;
  /** fetch data from the table: "construction_country" using primary key columns */
  constructionCountry_by_pk?: Maybe<ConstructionCountry>;
  /** fetch data from the table: "construction_description" */
  constructionDescription: Array<ConstructionDescription>;
  /** fetch aggregated fields from the table: "construction_description" */
  constructionDescription_aggregate: ConstructionDescription_Aggregate;
  /** fetch data from the table: "construction_description" using primary key columns */
  constructionDescription_by_pk?: Maybe<ConstructionDescription>;
  /** fetch data from the table: "construction_fork" */
  constructionFork: Array<ConstructionFork>;
  /** fetch aggregated fields from the table: "construction_fork" */
  constructionFork_aggregate: ConstructionFork_Aggregate;
  /** fetch data from the table: "construction_fork" using primary key columns */
  constructionFork_by_pk?: Maybe<ConstructionFork>;
  /** fetch data from the table: "construction_inhomogeneous_layer" */
  constructionInhomogeneousLayer: Array<ConstructionInhomogeneousLayer>;
  /** fetch data from the table: "construction_inhomogeneous_layer_material" */
  constructionInhomogeneousLayerMaterial: Array<ConstructionInhomogeneousLayerMaterial>;
  /** fetch aggregated fields from the table: "construction_inhomogeneous_layer_material" */
  constructionInhomogeneousLayerMaterial_aggregate: ConstructionInhomogeneousLayerMaterial_Aggregate;
  /** fetch data from the table: "construction_inhomogeneous_layer_material" using primary key columns */
  constructionInhomogeneousLayerMaterial_by_pk?: Maybe<ConstructionInhomogeneousLayerMaterial>;
  /** fetch aggregated fields from the table: "construction_inhomogeneous_layer" */
  constructionInhomogeneousLayer_aggregate: ConstructionInhomogeneousLayer_Aggregate;
  /** fetch data from the table: "construction_inhomogeneous_layer" using primary key columns */
  constructionInhomogeneousLayer_by_pk?: Maybe<ConstructionInhomogeneousLayer>;
  /** fetch data from the table: "construction_inhomogenous_layer_description" */
  constructionInhomogenousLayerDescription: Array<ConstructionInhomogenousLayerDescription>;
  /** fetch aggregated fields from the table: "construction_inhomogenous_layer_description" */
  constructionInhomogenousLayerDescription_aggregate: ConstructionInhomogenousLayerDescription_Aggregate;
  /** fetch data from the table: "construction_inhomogenous_layer_description" using primary key columns */
  constructionInhomogenousLayerDescription_by_pk?: Maybe<ConstructionInhomogenousLayerDescription>;
  /** fetch data from the table: "construction_inhomogenous_layer_name" */
  constructionInhomogenousLayerName: Array<ConstructionInhomogenousLayerName>;
  /** fetch aggregated fields from the table: "construction_inhomogenous_layer_name" */
  constructionInhomogenousLayerName_aggregate: ConstructionInhomogenousLayerName_Aggregate;
  /** fetch data from the table: "construction_inhomogenous_layer_name" using primary key columns */
  constructionInhomogenousLayerName_by_pk?: Maybe<ConstructionInhomogenousLayerName>;
  /** fetch data from the table: "construction_material" */
  constructionMaterial: Array<ConstructionMaterial>;
  /** fetch aggregated fields from the table: "construction_material" */
  constructionMaterial_aggregate: ConstructionMaterial_Aggregate;
  /** fetch data from the table: "construction_material" using primary key columns */
  constructionMaterial_by_pk?: Maybe<ConstructionMaterial>;
  /** fetch data from the table: "construction_name" */
  constructionName: Array<ConstructionName>;
  /** fetch aggregated fields from the table: "construction_name" */
  constructionName_aggregate: ConstructionName_Aggregate;
  /** fetch data from the table: "construction_name" using primary key columns */
  constructionName_by_pk?: Maybe<ConstructionName>;
  /** fetch data from the table: "construction_sorting" */
  constructionSorting: Array<ConstructionSorting>;
  /** fetch aggregated fields from the table: "construction_sorting" */
  constructionSorting_aggregate: ConstructionSorting_Aggregate;
  /** fetch data from the table: "construction_sorting" using primary key columns */
  constructionSorting_by_pk?: Maybe<ConstructionSorting>;
  /** fetch aggregated fields from the table: "construction" */
  construction_aggregate: Construction_Aggregate;
  /** fetch data from the table: "construction" using primary key columns */
  construction_by_pk?: Maybe<Construction>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch data from the table: "country_config" */
  countryConfig: Array<CountryConfig>;
  /** fetch aggregated fields from the table: "country_config" */
  countryConfig_aggregate: CountryConfig_Aggregate;
  /** fetch data from the table: "country_config" using primary key columns */
  countryConfig_by_pk?: Maybe<CountryConfig>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "declared_unit" */
  declaredUnit: Array<DeclaredUnit>;
  /** fetch aggregated fields from the table: "declared_unit" */
  declaredUnit_aggregate: DeclaredUnit_Aggregate;
  /** fetch data from the table: "declared_unit" using primary key columns */
  declaredUnit_by_pk?: Maybe<DeclaredUnit>;
  /** fetch data from the table: "denominator_unit" */
  denominatorUnit: Array<DenominatorUnit>;
  /** fetch aggregated fields from the table: "denominator_unit" */
  denominatorUnit_aggregate: DenominatorUnit_Aggregate;
  /** fetch data from the table: "denominator_unit" using primary key columns */
  denominatorUnit_by_pk?: Maybe<DenominatorUnit>;
  /** fetch data from the table: "distance_unit" */
  distance_unit: Array<Distance_Unit>;
  /** fetch aggregated fields from the table: "distance_unit" */
  distance_unit_aggregate: Distance_Unit_Aggregate;
  /** fetch data from the table: "distance_unit" using primary key columns */
  distance_unit_by_pk?: Maybe<Distance_Unit>;
  /** fetch data from the table: "emission_factor_source_type" */
  emissionFactorSourceType: Array<EmissionFactorSourceType>;
  /** fetch aggregated fields from the table: "emission_factor_source_type" */
  emissionFactorSourceType_aggregate: EmissionFactorSourceType_Aggregate;
  /** fetch data from the table: "emission_factor_source_type" using primary key columns */
  emissionFactorSourceType_by_pk?: Maybe<EmissionFactorSourceType>;
  /** fetch data from the table: "emission_factor" */
  emission_factor: Array<Emission_Factor>;
  /** fetch aggregated fields from the table: "emission_factor" */
  emission_factor_aggregate: Emission_Factor_Aggregate;
  /** fetch data from the table: "emission_factor" using primary key columns */
  emission_factor_by_pk?: Maybe<Emission_Factor>;
  /** fetch data from the table: "emission_factor_source" */
  emission_factor_source: Array<Emission_Factor_Source>;
  /** fetch aggregated fields from the table: "emission_factor_source" */
  emission_factor_source_aggregate: Emission_Factor_Source_Aggregate;
  /** fetch data from the table: "emission_factor_source" using primary key columns */
  emission_factor_source_by_pk?: Maybe<Emission_Factor_Source>;
  /** fetch data from the table: "emission_factor_type" */
  emission_factor_type: Array<Emission_Factor_Type>;
  /** fetch aggregated fields from the table: "emission_factor_type" */
  emission_factor_type_aggregate: Emission_Factor_Type_Aggregate;
  /** fetch data from the table: "emission_factor_type" using primary key columns */
  emission_factor_type_by_pk?: Maybe<Emission_Factor_Type>;
  /** fetch data from the table: "enum_collection_type" */
  enumCollectionType: Array<EnumCollectionType>;
  /** fetch aggregated fields from the table: "enum_collection_type" */
  enumCollectionType_aggregate: EnumCollectionType_Aggregate;
  /** fetch data from the table: "enum_collection_type" using primary key columns */
  enumCollectionType_by_pk?: Maybe<EnumCollectionType>;
  /** fetch data from the table: "epd_datasource" */
  epdDatasource: Array<EpdDatasource>;
  /** fetch aggregated fields from the table: "epd_datasource" */
  epdDatasource_aggregate: EpdDatasource_Aggregate;
  /** fetch data from the table: "epd_datasource" using primary key columns */
  epdDatasource_by_pk?: Maybe<EpdDatasource>;
  /** fetch data from the table: "epd_owner" */
  epdOwner: Array<EpdOwner>;
  /** fetch data from the table: "epd_owner_alias" */
  epdOwnerAlias: Array<EpdOwnerAlias>;
  /** fetch aggregated fields from the table: "epd_owner_alias" */
  epdOwnerAlias_aggregate: EpdOwnerAlias_Aggregate;
  /** fetch data from the table: "epd_owner_alias" using primary key columns */
  epdOwnerAlias_by_pk?: Maybe<EpdOwnerAlias>;
  /** fetch aggregated fields from the table: "epd_owner" */
  epdOwner_aggregate: EpdOwner_Aggregate;
  /** fetch data from the table: "epd_owner" using primary key columns */
  epdOwner_by_pk?: Maybe<EpdOwner>;
  /** fetch data from the table: "epd_product_industry" */
  epdProductIndustry: Array<EpdProductIndustry>;
  /** fetch aggregated fields from the table: "epd_product_industry" */
  epdProductIndustry_aggregate: EpdProductIndustry_Aggregate;
  /** fetch data from the table: "epd_product_industry" using primary key columns */
  epdProductIndustry_by_pk?: Maybe<EpdProductIndustry>;
  /** fetch data from the table: "epd_specification_form" */
  epdSpecificationForm: Array<EpdSpecificationForm>;
  /** fetch aggregated fields from the table: "epd_specification_form" */
  epdSpecificationForm_aggregate: EpdSpecificationForm_Aggregate;
  /** fetch data from the table: "epd_specification_form" using primary key columns */
  epdSpecificationForm_by_pk?: Maybe<EpdSpecificationForm>;
  /** fetch data from the table: "flow_guide" */
  flowGuide: Array<FlowGuide>;
  /** fetch data from the table: "flow_guide_views" */
  flowGuideViews: Array<FlowGuideViews>;
  /** fetch aggregated fields from the table: "flow_guide_views" */
  flowGuideViews_aggregate: FlowGuideViews_Aggregate;
  /** fetch data from the table: "flow_guide_views" using primary key columns */
  flowGuideViews_by_pk?: Maybe<FlowGuideViews>;
  /** fetch aggregated fields from the table: "flow_guide" */
  flowGuide_aggregate: FlowGuide_Aggregate;
  /** fetch data from the table: "flow_guide" using primary key columns */
  flowGuide_by_pk?: Maybe<FlowGuide>;
  /** fetch data from the table: "indicator_source" */
  indicatorSource: Array<IndicatorSource>;
  /** fetch aggregated fields from the table: "indicator_source" */
  indicatorSource_aggregate: IndicatorSource_Aggregate;
  /** fetch data from the table: "indicator_source" using primary key columns */
  indicatorSource_by_pk?: Maybe<IndicatorSource>;
  /** fetch data from the table: "indicator_type" */
  indicatorType: Array<IndicatorType>;
  /** fetch data from the table: "indicator_type_mapping" */
  indicatorTypeMapping: Array<IndicatorTypeMapping>;
  /** fetch aggregated fields from the table: "indicator_type_mapping" */
  indicatorTypeMapping_aggregate: IndicatorTypeMapping_Aggregate;
  /** fetch data from the table: "indicator_type_mapping" using primary key columns */
  indicatorTypeMapping_by_pk?: Maybe<IndicatorTypeMapping>;
  /** fetch data from the table: "indicator_type_multiplier" */
  indicatorTypeMultiplier: Array<IndicatorTypeMultiplier>;
  /** fetch aggregated fields from the table: "indicator_type_multiplier" */
  indicatorTypeMultiplier_aggregate: IndicatorTypeMultiplier_Aggregate;
  /** fetch data from the table: "indicator_type_multiplier" using primary key columns */
  indicatorTypeMultiplier_by_pk?: Maybe<IndicatorTypeMultiplier>;
  /** fetch aggregated fields from the table: "indicator_type" */
  indicatorType_aggregate: IndicatorType_Aggregate;
  /** fetch data from the table: "indicator_type" using primary key columns */
  indicatorType_by_pk?: Maybe<IndicatorType>;
  /** fetch data from the table: "installation_standard_value" */
  installation_standard_value: Array<Installation_Standard_Value>;
  /** fetch aggregated fields from the table: "installation_standard_value" */
  installation_standard_value_aggregate: Installation_Standard_Value_Aggregate;
  /** fetch data from the table: "installation_standard_value_building_type" */
  installation_standard_value_building_type: Array<Installation_Standard_Value_Building_Type>;
  /** fetch aggregated fields from the table: "installation_standard_value_building_type" */
  installation_standard_value_building_type_aggregate: Installation_Standard_Value_Building_Type_Aggregate;
  /** fetch data from the table: "installation_standard_value_building_type" using primary key columns */
  installation_standard_value_building_type_by_pk?: Maybe<Installation_Standard_Value_Building_Type>;
  /** fetch data from the table: "installation_standard_value" using primary key columns */
  installation_standard_value_by_pk?: Maybe<Installation_Standard_Value>;
  /** fetch data from the table: "installation_standard_value_classification_type" */
  installation_standard_value_classification_type: Array<Installation_Standard_Value_Classification_Type>;
  /** fetch aggregated fields from the table: "installation_standard_value_classification_type" */
  installation_standard_value_classification_type_aggregate: Installation_Standard_Value_Classification_Type_Aggregate;
  /** fetch data from the table: "installation_standard_value_classification_type" using primary key columns */
  installation_standard_value_classification_type_by_pk?: Maybe<Installation_Standard_Value_Classification_Type>;
  /** fetch data from the table: "installation_standard_value_datasource" */
  installation_standard_value_datasource: Array<Installation_Standard_Value_Datasource>;
  /** fetch aggregated fields from the table: "installation_standard_value_datasource" */
  installation_standard_value_datasource_aggregate: Installation_Standard_Value_Datasource_Aggregate;
  /** fetch data from the table: "installation_standard_value_datasource" using primary key columns */
  installation_standard_value_datasource_by_pk?: Maybe<Installation_Standard_Value_Datasource>;
  /** fetch data from the table: "installation_standard_value_emission" */
  installation_standard_value_emission: Array<Installation_Standard_Value_Emission>;
  /** fetch aggregated fields from the table: "installation_standard_value_emission" */
  installation_standard_value_emission_aggregate: Installation_Standard_Value_Emission_Aggregate;
  /** fetch data from the table: "installation_standard_value_emission" using primary key columns */
  installation_standard_value_emission_by_pk?: Maybe<Installation_Standard_Value_Emission>;
  /** fetch data from the table: "language" */
  language: Array<Language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: Language_Aggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<Language>;
  /** fetch data from the table: "lifetime_table" */
  lifetime_table: Array<Lifetime_Table>;
  /** fetch aggregated fields from the table: "lifetime_table" */
  lifetime_table_aggregate: Lifetime_Table_Aggregate;
  /** fetch data from the table: "lifetime_table" using primary key columns */
  lifetime_table_by_pk?: Maybe<Lifetime_Table>;
  /** fetch data from the table: "mapping_history" */
  mappingHistory: Array<MappingHistory>;
  /** fetch data from the table: "mapping_history_frequency" */
  mappingHistoryFrequency: Array<MappingHistoryFrequency>;
  /** fetch aggregated fields from the table: "mapping_history_frequency" */
  mappingHistoryFrequency_aggregate: MappingHistoryFrequency_Aggregate;
  /** fetch data from the table: "mapping_history_most_recent_lifetime" */
  mappingHistoryMostRecentLifetime: Array<MappingHistoryMostRecentLifetime>;
  /** fetch aggregated fields from the table: "mapping_history_most_recent_lifetime" */
  mappingHistoryMostRecentLifetime_aggregate: MappingHistoryMostRecentLifetime_Aggregate;
  /** fetch aggregated fields from the table: "mapping_history" */
  mappingHistory_aggregate: MappingHistory_Aggregate;
  /** fetch data from the table: "mapping_history" using primary key columns */
  mappingHistory_by_pk?: Maybe<MappingHistory>;
  /** fetch data from the table: "mapping_history_most_used_lifetime" */
  mapping_history_most_used_lifetime: Array<Mapping_History_Most_Used_Lifetime>;
  /** fetch aggregated fields from the table: "mapping_history_most_used_lifetime" */
  mapping_history_most_used_lifetime_aggregate: Mapping_History_Most_Used_Lifetime_Aggregate;
  /** fetch data from the table: "material" */
  material: Array<Material>;
  /** fetch data from the table: "material_biogenic_params" */
  materialBiogenicParams: Array<MaterialBiogenicParams>;
  /** fetch aggregated fields from the table: "material_biogenic_params" */
  materialBiogenicParams_aggregate: MaterialBiogenicParams_Aggregate;
  /** fetch data from the table: "material_biogenic_params" using primary key columns */
  materialBiogenicParams_by_pk?: Maybe<MaterialBiogenicParams>;
  /** fetch data from the table: "material_category" */
  materialCategory: Array<MaterialCategory>;
  /** fetch data from the table: "material_category_texture" */
  materialCategoryTexture: Array<MaterialCategoryTexture>;
  /** fetch aggregated fields from the table: "material_category_texture" */
  materialCategoryTexture_aggregate: MaterialCategoryTexture_Aggregate;
  /** fetch data from the table: "material_category_texture" using primary key columns */
  materialCategoryTexture_by_pk?: Maybe<MaterialCategoryTexture>;
  /** fetch aggregated fields from the table: "material_category" */
  materialCategory_aggregate: MaterialCategory_Aggregate;
  /** fetch data from the table: "material_category" using primary key columns */
  materialCategory_by_pk?: Maybe<MaterialCategory>;
  /** fetch data from the table: "material_description" */
  materialDescription: Array<MaterialDescription>;
  /** fetch aggregated fields from the table: "material_description" */
  materialDescription_aggregate: MaterialDescription_Aggregate;
  /** fetch data from the table: "material_description" using primary key columns */
  materialDescription_by_pk?: Maybe<MaterialDescription>;
  /** fetch data from the table: "material_emission_indicator" */
  materialEmissionIndicator: Array<MaterialEmissionIndicator>;
  /** fetch aggregated fields from the table: "material_emission_indicator" */
  materialEmissionIndicator_aggregate: MaterialEmissionIndicator_Aggregate;
  /** fetch data from the table: "material_emission_indicator" using primary key columns */
  materialEmissionIndicator_by_pk?: Maybe<MaterialEmissionIndicator>;
  /** fetch data from the table: "material_epd" */
  materialEpd: Array<MaterialEpd>;
  /** fetch data from the table: "material_epd_datasource" */
  materialEpdDatasource: Array<MaterialEpdDatasource>;
  /** fetch aggregated fields from the table: "material_epd_datasource" */
  materialEpdDatasource_aggregate: MaterialEpdDatasource_Aggregate;
  /** fetch data from the table: "material_epd_datasource" using primary key columns */
  materialEpdDatasource_by_pk?: Maybe<MaterialEpdDatasource>;
  /** fetch data from the table: "material_epd_url" */
  materialEpdUrl: Array<MaterialEpdUrl>;
  /** fetch aggregated fields from the table: "material_epd_url" */
  materialEpdUrl_aggregate: MaterialEpdUrl_Aggregate;
  /** fetch data from the table: "material_epd_url" using primary key columns */
  materialEpdUrl_by_pk?: Maybe<MaterialEpdUrl>;
  /** fetch aggregated fields from the table: "material_epd" */
  materialEpd_aggregate: MaterialEpd_Aggregate;
  /** fetch data from the table: "material_epd" using primary key columns */
  materialEpd_by_pk?: Maybe<MaterialEpd>;
  /** fetch data from the table: "material_fork" */
  materialFork: Array<MaterialFork>;
  /** fetch aggregated fields from the table: "material_fork" */
  materialFork_aggregate: MaterialFork_Aggregate;
  /** fetch data from the table: "material_fork" using primary key columns */
  materialFork_by_pk?: Maybe<MaterialFork>;
  /** fetch data from the table: "material_name" */
  materialName: Array<MaterialName>;
  /** fetch aggregated fields from the table: "material_name" */
  materialName_aggregate: MaterialName_Aggregate;
  /** fetch data from the table: "material_name" using primary key columns */
  materialName_by_pk?: Maybe<MaterialName>;
  /** fetch data from the table: "material_emission" */
  materialStage: Array<MaterialStage>;
  /** fetch aggregated fields from the table: "material_emission" */
  materialStage_aggregate: MaterialStage_Aggregate;
  /** fetch data from the table: "material_emission" using primary key columns */
  materialStage_by_pk?: Maybe<MaterialStage>;
  /** fetch data from the table: "material_type" */
  materialType: Array<MaterialType>;
  /** fetch aggregated fields from the table: "material_type" */
  materialType_aggregate: MaterialType_Aggregate;
  /** fetch data from the table: "material_type" using primary key columns */
  materialType_by_pk?: Maybe<MaterialType>;
  /** fetch data from the table: "material_waste_source" */
  materialWasteSource: Array<MaterialWasteSource>;
  /** fetch aggregated fields from the table: "material_waste_source" */
  materialWasteSource_aggregate: MaterialWasteSource_Aggregate;
  /** fetch data from the table: "material_waste_source" using primary key columns */
  materialWasteSource_by_pk?: Maybe<MaterialWasteSource>;
  /** fetch data from the table: "material_waste_type" */
  materialWasteType: Array<MaterialWasteType>;
  /** fetch aggregated fields from the table: "material_waste_type" */
  materialWasteType_aggregate: MaterialWasteType_Aggregate;
  /** fetch data from the table: "material_waste_type" using primary key columns */
  materialWasteType_by_pk?: Maybe<MaterialWasteType>;
  /** fetch aggregated fields from the table: "material" */
  material_aggregate: Material_Aggregate;
  /** fetch data from the table: "material" using primary key columns */
  material_by_pk?: Maybe<Material>;
  /** fetch data from the table: "mcp_connection" */
  mcpConnection: Array<McpConnection>;
  /** fetch aggregated fields from the table: "mcp_connection" */
  mcpConnection_aggregate: McpConnection_Aggregate;
  /** fetch data from the table: "mcp_connection" using primary key columns */
  mcpConnection_by_pk?: Maybe<McpConnection>;
  /** fetch data from the table: "mcp_tool_call" */
  mcpToolCall: Array<McpToolCall>;
  /** fetch aggregated fields from the table: "mcp_tool_call" */
  mcpToolCall_aggregate: McpToolCall_Aggregate;
  /** fetch data from the table: "mcp_tool_call" using primary key columns */
  mcpToolCall_by_pk?: Maybe<McpToolCall>;
  /** fetch data from the table: "model" */
  model: Array<Model>;
  /** fetch aggregated fields from the table: "model" */
  model_aggregate: Model_Aggregate;
  /** fetch data from the table: "model" using primary key columns */
  model_by_pk?: Maybe<Model>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch data from the table: "project_building_area" */
  projectBuildingArea: Array<ProjectBuildingArea>;
  /** fetch aggregated fields from the table: "project_building_area" */
  projectBuildingArea_aggregate: ProjectBuildingArea_Aggregate;
  /** fetch data from the table: "project_building_area" using primary key columns */
  projectBuildingArea_by_pk?: Maybe<ProjectBuildingArea>;
  /** fetch data from the table: "project_calculation" */
  projectCalculation: Array<ProjectCalculation>;
  /** fetch data from the table: "project_calculation_stage" */
  projectCalculationStage: Array<ProjectCalculationStage>;
  /** fetch aggregated fields from the table: "project_calculation_stage" */
  projectCalculationStage_aggregate: ProjectCalculationStage_Aggregate;
  /** fetch data from the table: "project_calculation_stage" using primary key columns */
  projectCalculationStage_by_pk?: Maybe<ProjectCalculationStage>;
  /** fetch aggregated fields from the table: "project_calculation" */
  projectCalculation_aggregate: ProjectCalculation_Aggregate;
  /** fetch data from the table: "project_calculation" using primary key columns */
  projectCalculation_by_pk?: Maybe<ProjectCalculation>;
  /** fetch data from the table: "project_component_mapping_type" */
  projectComponentMappingType: Array<ProjectComponentMappingType>;
  /** fetch aggregated fields from the table: "project_component_mapping_type" */
  projectComponentMappingType_aggregate: ProjectComponentMappingType_Aggregate;
  /** fetch data from the table: "project_component_mapping_type" using primary key columns */
  projectComponentMappingType_by_pk?: Maybe<ProjectComponentMappingType>;
  /** fetch data from the table: "project_dashboard_status" */
  projectDashboardStatus: Array<ProjectDashboardStatus>;
  /** fetch aggregated fields from the table: "project_dashboard_status" */
  projectDashboardStatus_aggregate: ProjectDashboardStatus_Aggregate;
  /** fetch data from the table: "project_dashboard_status" using primary key columns */
  projectDashboardStatus_by_pk?: Maybe<ProjectDashboardStatus>;
  /** fetch data from the table: "project_emission_factor" */
  projectEmissionFactor: Array<ProjectEmissionFactor>;
  /** fetch data from the table: "project_emission_factor_custom" */
  projectEmissionFactorCustom: Array<ProjectEmissionFactorCustom>;
  /** fetch aggregated fields from the table: "project_emission_factor_custom" */
  projectEmissionFactorCustom_aggregate: ProjectEmissionFactorCustom_Aggregate;
  /** fetch data from the table: "project_emission_factor_custom" using primary key columns */
  projectEmissionFactorCustom_by_pk?: Maybe<ProjectEmissionFactorCustom>;
  /** fetch aggregated fields from the table: "project_emission_factor" */
  projectEmissionFactor_aggregate: ProjectEmissionFactor_Aggregate;
  /** fetch data from the table: "project_emission_factor" using primary key columns */
  projectEmissionFactor_by_pk?: Maybe<ProjectEmissionFactor>;
  /** fetch data from the table: "project_installation" */
  projectInstallation: Array<ProjectInstallation>;
  /** fetch aggregated fields from the table: "project_installation" */
  projectInstallation_aggregate: ProjectInstallation_Aggregate;
  /** fetch data from the table: "project_installation" using primary key columns */
  projectInstallation_by_pk?: Maybe<ProjectInstallation>;
  /** fetch data from the table: "project_location" */
  projectLocation: Array<ProjectLocation>;
  /** fetch aggregated fields from the table: "project_location" */
  projectLocation_aggregate: ProjectLocation_Aggregate;
  /** fetch data from the table: "project_location" using primary key columns */
  projectLocation_by_pk?: Maybe<ProjectLocation>;
  /** fetch data from the table: "project_material_classification_feedback" */
  projectMaterialClassificationFeedback: Array<ProjectMaterialClassificationFeedback>;
  /** fetch aggregated fields from the table: "project_material_classification_feedback" */
  projectMaterialClassificationFeedback_aggregate: ProjectMaterialClassificationFeedback_Aggregate;
  /** fetch data from the table: "project_material_classification_feedback" using primary key columns */
  projectMaterialClassificationFeedback_by_pk?: Maybe<ProjectMaterialClassificationFeedback>;
  /** fetch data from the table: "project_material_classification_parameter" */
  projectMaterialClassificationParameter: Array<ProjectMaterialClassificationParameter>;
  /** fetch aggregated fields from the table: "project_material_classification_parameter" */
  projectMaterialClassificationParameter_aggregate: ProjectMaterialClassificationParameter_Aggregate;
  /** fetch data from the table: "project_material_classification_parameter" using primary key columns */
  projectMaterialClassificationParameter_by_pk?: Maybe<ProjectMaterialClassificationParameter>;
  /** fetch data from the table: "project_membership" */
  projectMembership: Array<ProjectMembership>;
  /** fetch aggregated fields from the table: "project_membership" */
  projectMembership_aggregate: ProjectMembership_Aggregate;
  /** fetch data from the table: "project_membership" using primary key columns */
  projectMembership_by_pk?: Maybe<ProjectMembership>;
  /** fetch data from the table: "project_model" */
  projectModel: Array<ProjectModel>;
  /** fetch data from the table: "project_model_speckle_pin" */
  projectModelSpecklePin: Array<ProjectModelSpecklePin>;
  /** fetch aggregated fields from the table: "project_model_speckle_pin" */
  projectModelSpecklePin_aggregate: ProjectModelSpecklePin_Aggregate;
  /** fetch data from the table: "project_model_speckle_pin" using primary key columns */
  projectModelSpecklePin_by_pk?: Maybe<ProjectModelSpecklePin>;
  /** fetch aggregated fields from the table: "project_model" */
  projectModel_aggregate: ProjectModel_Aggregate;
  /** fetch data from the table: "project_model" using primary key columns */
  projectModel_by_pk?: Maybe<ProjectModel>;
  /** fetch data from the table: "project_operational" */
  projectOperational: Array<ProjectOperational>;
  /** fetch aggregated fields from the table: "project_operational" */
  projectOperational_aggregate: ProjectOperational_Aggregate;
  /** fetch data from the table: "project_operational" using primary key columns */
  projectOperational_by_pk?: Maybe<ProjectOperational>;
  /** fetch data from the table: "project_reference_area" */
  projectReferenceArea: Array<ProjectReferenceArea>;
  /** fetch aggregated fields from the table: "project_reference_area" */
  projectReferenceArea_aggregate: ProjectReferenceArea_Aggregate;
  /** fetch data from the table: "project_reference_area" using primary key columns */
  projectReferenceArea_by_pk?: Maybe<ProjectReferenceArea>;
  /** fetch data from the table: "project_revision" */
  projectRevision: Array<ProjectRevision>;
  /** fetch aggregated fields from the table: "project_revision" */
  projectRevision_aggregate: ProjectRevision_Aggregate;
  /** fetch data from the table: "project_revision" using primary key columns */
  projectRevision_by_pk?: Maybe<ProjectRevision>;
  /** fetch data from the table: "project_special_condition_config" */
  projectSpecialConditionConfig: Array<ProjectSpecialConditionConfig>;
  /** fetch aggregated fields from the table: "project_special_condition_config" */
  projectSpecialConditionConfig_aggregate: ProjectSpecialConditionConfig_Aggregate;
  /** fetch data from the table: "project_special_condition_config" using primary key columns */
  projectSpecialConditionConfig_by_pk?: Maybe<ProjectSpecialConditionConfig>;
  /** fetch data from the table: "project_special_condition_type_mapping" */
  projectSpecialConditionTypeMapping: Array<ProjectSpecialConditionTypeMapping>;
  /** fetch aggregated fields from the table: "project_special_condition_type_mapping" */
  projectSpecialConditionTypeMapping_aggregate: ProjectSpecialConditionTypeMapping_Aggregate;
  /** fetch data from the table: "project_special_condition_type_mapping" using primary key columns */
  projectSpecialConditionTypeMapping_by_pk?: Maybe<ProjectSpecialConditionTypeMapping>;
  /** fetch data from the table: "project_speckle_copy" */
  projectSpeckleCopy: Array<ProjectSpeckleCopy>;
  /** fetch data from the table: "project_speckle_copy_recent" */
  projectSpeckleCopyRecent: Array<ProjectSpeckleCopyRecent>;
  /** fetch aggregated fields from the table: "project_speckle_copy_recent" */
  projectSpeckleCopyRecent_aggregate: ProjectSpeckleCopyRecent_Aggregate;
  /** fetch aggregated fields from the table: "project_speckle_copy" */
  projectSpeckleCopy_aggregate: ProjectSpeckleCopy_Aggregate;
  /** fetch data from the table: "project_speckle_copy" using primary key columns */
  projectSpeckleCopy_by_pk?: Maybe<ProjectSpeckleCopy>;
  /** fetch data from the table: "project_speckle_model_sync" */
  projectSpeckleModelSync: Array<ProjectSpeckleModelSync>;
  /** fetch data from the table: "project_speckle_model_sync_recent" */
  projectSpeckleModelSyncRecent: Array<ProjectSpeckleModelSyncRecent>;
  /** fetch aggregated fields from the table: "project_speckle_model_sync_recent" */
  projectSpeckleModelSyncRecent_aggregate: ProjectSpeckleModelSyncRecent_Aggregate;
  /** fetch aggregated fields from the table: "project_speckle_model_sync" */
  projectSpeckleModelSync_aggregate: ProjectSpeckleModelSync_Aggregate;
  /** fetch data from the table: "project_speckle_model_sync" using primary key columns */
  projectSpeckleModelSync_by_pk?: Maybe<ProjectSpeckleModelSync>;
  /** fetch data from the table: "project_speckle_parameter_config" */
  projectSpeckleParameterConfig: Array<ProjectSpeckleParameterConfig>;
  /** fetch aggregated fields from the table: "project_speckle_parameter_config" */
  projectSpeckleParameterConfig_aggregate: ProjectSpeckleParameterConfig_Aggregate;
  /** fetch data from the table: "project_speckle_parameter_config" using primary key columns */
  projectSpeckleParameterConfig_by_pk?: Maybe<ProjectSpeckleParameterConfig>;
  /** fetch data from the table: "project_standard_value_stage" */
  projectStandardValueStage: Array<ProjectStandardValueStage>;
  /** fetch aggregated fields from the table: "project_standard_value_stage" */
  projectStandardValueStage_aggregate: ProjectStandardValueStage_Aggregate;
  /** fetch data from the table: "project_standard_value_stage" using primary key columns */
  projectStandardValueStage_by_pk?: Maybe<ProjectStandardValueStage>;
  /** fetch data from the table: "project_status" */
  projectStatus: Array<ProjectStatus>;
  /** fetch aggregated fields from the table: "project_status" */
  projectStatus_aggregate: ProjectStatus_Aggregate;
  /** fetch data from the table: "project_status" using primary key columns */
  projectStatus_by_pk?: Maybe<ProjectStatus>;
  /** fetch data from the table: "project_tenant_status_area" */
  projectTenantStatusArea: Array<ProjectTenantStatusArea>;
  /** fetch aggregated fields from the table: "project_tenant_status_area" */
  projectTenantStatusArea_aggregate: ProjectTenantStatusArea_Aggregate;
  /** fetch data from the table: "project_transport_mapping_emission_factor" */
  projectTransportMappingEmissionFactor: Array<ProjectTransportMappingEmissionFactor>;
  /** fetch aggregated fields from the table: "project_transport_mapping_emission_factor" */
  projectTransportMappingEmissionFactor_aggregate: ProjectTransportMappingEmissionFactor_Aggregate;
  /** fetch data from the table: "project_transport_mapping_emission_factor" using primary key columns */
  projectTransportMappingEmissionFactor_by_pk?: Maybe<ProjectTransportMappingEmissionFactor>;
  /** fetch data from the table: "project_version" */
  projectVersion: Array<ProjectVersion>;
  /** fetch data from the table: "project_version_numbered" */
  projectVersionNumbered: Array<ProjectVersionNumbered>;
  /** fetch aggregated fields from the table: "project_version_numbered" */
  projectVersionNumbered_aggregate: ProjectVersionNumbered_Aggregate;
  /** fetch aggregated fields from the table: "project_version" */
  projectVersion_aggregate: ProjectVersion_Aggregate;
  /** fetch data from the table: "project_version" using primary key columns */
  projectVersion_by_pk?: Maybe<ProjectVersion>;
  /** fetch data from the table: "project_waste_mapping" */
  projectWasteMapping: Array<ProjectWasteMapping>;
  /** fetch aggregated fields from the table: "project_waste_mapping" */
  projectWasteMapping_aggregate: ProjectWasteMapping_Aggregate;
  /** fetch data from the table: "project_waste_mapping" using primary key columns */
  projectWasteMapping_by_pk?: Maybe<ProjectWasteMapping>;
  /** fetch data from the table: "project_waste_type_custom" */
  projectWasteTypeCustom: Array<ProjectWasteTypeCustom>;
  /** fetch aggregated fields from the table: "project_waste_type_custom" */
  projectWasteTypeCustom_aggregate: ProjectWasteTypeCustom_Aggregate;
  /** fetch data from the table: "project_waste_type_custom" using primary key columns */
  projectWasteTypeCustom_by_pk?: Maybe<ProjectWasteTypeCustom>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** execute function "project_speckle_stream_as_of" which returns "speckle_stream" */
  project_speckle_stream_as_of: Array<Speckle_Stream>;
  /** execute function "project_speckle_stream_as_of" and query aggregates on result of table type "speckle_stream" */
  project_speckle_stream_as_of_aggregate: Speckle_Stream_Aggregate;
  /** fetch data from the table: "project_transport" */
  project_transport: Array<Project_Transport>;
  /** fetch aggregated fields from the table: "project_transport" */
  project_transport_aggregate: Project_Transport_Aggregate;
  /** fetch data from the table: "project_transport" using primary key columns */
  project_transport_by_pk?: Maybe<Project_Transport>;
  /** fetch data from the table: "project_transport_default" */
  project_transport_default: Array<Project_Transport_Default>;
  /** fetch aggregated fields from the table: "project_transport_default" */
  project_transport_default_aggregate: Project_Transport_Default_Aggregate;
  /** fetch data from the table: "project_transport_default" using primary key columns */
  project_transport_default_by_pk?: Maybe<Project_Transport_Default>;
  /** fetch data from the table: "project_transport_mapping" */
  project_transport_mapping: Array<Project_Transport_Mapping>;
  /** fetch aggregated fields from the table: "project_transport_mapping" */
  project_transport_mapping_aggregate: Project_Transport_Mapping_Aggregate;
  /** fetch data from the table: "project_transport_mapping" using primary key columns */
  project_transport_mapping_by_pk?: Maybe<Project_Transport_Mapping>;
  /** fetch data from the table: "reference_area_type" */
  referenceAreaType: Array<ReferenceAreaType>;
  /** fetch data from the table: "reference_area_type_calculation_type_mapping" */
  referenceAreaTypeCalculationTypeMapping: Array<ReferenceAreaTypeCalculationTypeMapping>;
  /** fetch aggregated fields from the table: "reference_area_type_calculation_type_mapping" */
  referenceAreaTypeCalculationTypeMapping_aggregate: ReferenceAreaTypeCalculationTypeMapping_Aggregate;
  /** fetch data from the table: "reference_area_type_calculation_type_mapping" using primary key columns */
  referenceAreaTypeCalculationTypeMapping_by_pk?: Maybe<ReferenceAreaTypeCalculationTypeMapping>;
  /** fetch aggregated fields from the table: "reference_area_type" */
  referenceAreaType_aggregate: ReferenceAreaType_Aggregate;
  /** fetch data from the table: "reference_area_type" using primary key columns */
  referenceAreaType_by_pk?: Maybe<ReferenceAreaType>;
  /** fetch data from the table: "report_building_type_mapping" */
  reportBuildingTypeMapping: Array<ReportBuildingTypeMapping>;
  /** fetch aggregated fields from the table: "report_building_type_mapping" */
  reportBuildingTypeMapping_aggregate: ReportBuildingTypeMapping_Aggregate;
  /** fetch data from the table: "report_building_type_mapping" using primary key columns */
  reportBuildingTypeMapping_by_pk?: Maybe<ReportBuildingTypeMapping>;
  /** fetch data from the table: "report_classification_code_emission_mapping" */
  reportClassificationCodeEmissionMapping: Array<ReportClassificationCodeEmissionMapping>;
  /** fetch aggregated fields from the table: "report_classification_code_emission_mapping" */
  reportClassificationCodeEmissionMapping_aggregate: ReportClassificationCodeEmissionMapping_Aggregate;
  /** fetch data from the table: "report_classification_code_emission_mapping" using primary key columns */
  reportClassificationCodeEmissionMapping_by_pk?: Maybe<ReportClassificationCodeEmissionMapping>;
  /** fetch data from the table: "report_load_bearing_element_amount_mapping" */
  reportLoadBearingElementAmountMapping: Array<ReportLoadBearingElementAmountMapping>;
  /** fetch aggregated fields from the table: "report_load_bearing_element_amount_mapping" */
  reportLoadBearingElementAmountMapping_aggregate: ReportLoadBearingElementAmountMapping_Aggregate;
  /** fetch data from the table: "report_load_bearing_element_amount_mapping" using primary key columns */
  reportLoadBearingElementAmountMapping_by_pk?: Maybe<ReportLoadBearingElementAmountMapping>;
  /** fetch data from the table: "report_load_bearing_element_emission_mapping" */
  reportLoadBearingElementEmissionMapping: Array<ReportLoadBearingElementEmissionMapping>;
  /** fetch aggregated fields from the table: "report_load_bearing_element_emission_mapping" */
  reportLoadBearingElementEmissionMapping_aggregate: ReportLoadBearingElementEmissionMapping_Aggregate;
  /** fetch data from the table: "report_load_bearing_element_emission_mapping" using primary key columns */
  reportLoadBearingElementEmissionMapping_by_pk?: Maybe<ReportLoadBearingElementEmissionMapping>;
  /** fetch data from the table: "report_structure" */
  reportStructure: Array<ReportStructure>;
  /** fetch data from the table: "report_structure_calculation_types" */
  reportStructureCalculationTypes: Array<ReportStructureCalculationTypes>;
  /** fetch aggregated fields from the table: "report_structure_calculation_types" */
  reportStructureCalculationTypes_aggregate: ReportStructureCalculationTypes_Aggregate;
  /** fetch data from the table: "report_structure_calculation_types" using primary key columns */
  reportStructureCalculationTypes_by_pk?: Maybe<ReportStructureCalculationTypes>;
  /** fetch data from the table: "report_structure_classification_codes" */
  reportStructureClassificationCodes: Array<ReportStructureClassificationCodes>;
  /** fetch aggregated fields from the table: "report_structure_classification_codes" */
  reportStructureClassificationCodes_aggregate: ReportStructureClassificationCodes_Aggregate;
  /** fetch data from the table: "report_structure_classification_codes" using primary key columns */
  reportStructureClassificationCodes_by_pk?: Maybe<ReportStructureClassificationCodes>;
  /** fetch aggregated fields from the table: "report_structure" */
  reportStructure_aggregate: ReportStructure_Aggregate;
  /** fetch data from the table: "report_structure" using primary key columns */
  reportStructure_by_pk?: Maybe<ReportStructure>;
  /** fetch data from the table: "reportfilesmetadata" */
  reportfilesmetadata: Array<Reportfilesmetadata>;
  /** fetch aggregated fields from the table: "reportfilesmetadata" */
  reportfilesmetadata_aggregate: Reportfilesmetadata_Aggregate;
  /** fetch data from the table: "reportfilesmetadata" using primary key columns */
  reportfilesmetadata_by_pk?: Maybe<Reportfilesmetadata>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "special_condition_type" */
  specialConditionType: Array<SpecialConditionType>;
  /** fetch data from the table: "special_condition_type_calculation_type" */
  specialConditionTypeCalculationType: Array<SpecialConditionTypeCalculationType>;
  /** fetch aggregated fields from the table: "special_condition_type_calculation_type" */
  specialConditionTypeCalculationType_aggregate: SpecialConditionTypeCalculationType_Aggregate;
  /** fetch data from the table: "special_condition_type_calculation_type" using primary key columns */
  specialConditionTypeCalculationType_by_pk?: Maybe<SpecialConditionTypeCalculationType>;
  /** fetch data from the table: "special_condition_type_input_parameter" */
  specialConditionTypeInputParameter: Array<SpecialConditionTypeInputParameter>;
  /** fetch aggregated fields from the table: "special_condition_type_input_parameter" */
  specialConditionTypeInputParameter_aggregate: SpecialConditionTypeInputParameter_Aggregate;
  /** fetch data from the table: "special_condition_type_input_parameter" using primary key columns */
  specialConditionTypeInputParameter_by_pk?: Maybe<SpecialConditionTypeInputParameter>;
  /** fetch aggregated fields from the table: "special_condition_type" */
  specialConditionType_aggregate: SpecialConditionType_Aggregate;
  /** fetch data from the table: "special_condition_type" using primary key columns */
  specialConditionType_by_pk?: Maybe<SpecialConditionType>;
  /** fetch data from the table: "special_condition_type_category" */
  special_condition_type_category: Array<Special_Condition_Type_Category>;
  /** fetch aggregated fields from the table: "special_condition_type_category" */
  special_condition_type_category_aggregate: Special_Condition_Type_Category_Aggregate;
  /** fetch data from the table: "special_condition_type_category" using primary key columns */
  special_condition_type_category_by_pk?: Maybe<Special_Condition_Type_Category>;
  /** fetch data from the table: "speckle_stream_model_ifc_upload" */
  speckleStreamModelIfcUpload: Array<SpeckleStreamModelIfcUpload>;
  /** fetch data from the table: "speckle_stream_model_ifc_upload_recent" */
  speckleStreamModelIfcUploadRecent: Array<SpeckleStreamModelIfcUploadRecent>;
  /** fetch aggregated fields from the table: "speckle_stream_model_ifc_upload_recent" */
  speckleStreamModelIfcUploadRecent_aggregate: SpeckleStreamModelIfcUploadRecent_Aggregate;
  /** fetch aggregated fields from the table: "speckle_stream_model_ifc_upload" */
  speckleStreamModelIfcUpload_aggregate: SpeckleStreamModelIfcUpload_Aggregate;
  /** fetch data from the table: "speckle_stream_model_ifc_upload" using primary key columns */
  speckleStreamModelIfcUpload_by_pk?: Maybe<SpeckleStreamModelIfcUpload>;
  /** fetch data from the table: "speckle_user_data" */
  speckleUserData: Array<SpeckleUserData>;
  /** fetch aggregated fields from the table: "speckle_user_data" */
  speckleUserData_aggregate: SpeckleUserData_Aggregate;
  /** fetch data from the table: "speckle_user_data" using primary key columns */
  speckleUserData_by_pk?: Maybe<SpeckleUserData>;
  /** fetch data from the table: "speckle_stream" */
  speckle_stream: Array<Speckle_Stream>;
  /** fetch aggregated fields from the table: "speckle_stream" */
  speckle_stream_aggregate: Speckle_Stream_Aggregate;
  /** fetch data from the table: "speckle_stream" using primary key columns */
  speckle_stream_by_pk?: Maybe<Speckle_Stream>;
  /** fetch data from the table: "stage" */
  stage: Array<Stage>;
  /** fetch data from the table: "stage_default_emission" */
  stageDefaultEmission: Array<StageDefaultEmission>;
  /** fetch aggregated fields from the table: "stage_default_emission" */
  stageDefaultEmission_aggregate: StageDefaultEmission_Aggregate;
  /** fetch data from the table: "stage_default_emission" using primary key columns */
  stageDefaultEmission_by_pk?: Maybe<StageDefaultEmission>;
  /** fetch aggregated fields from the table: "stage" */
  stage_aggregate: Stage_Aggregate;
  /** fetch data from the table: "stage" using primary key columns */
  stage_by_pk?: Maybe<Stage>;
  /** fetch data from the table: "stage_default_emission_building_type" */
  stage_default_emission_building_type: Array<Stage_Default_Emission_Building_Type>;
  /** fetch aggregated fields from the table: "stage_default_emission_building_type" */
  stage_default_emission_building_type_aggregate: Stage_Default_Emission_Building_Type_Aggregate;
  /** fetch data from the table: "stage_default_emission_building_type" using primary key columns */
  stage_default_emission_building_type_by_pk?: Maybe<Stage_Default_Emission_Building_Type>;
  /** fetch data from the table: "tenant_ai_budget" */
  tenantAiBudget: Array<TenantAiBudget>;
  /** fetch aggregated fields from the table: "tenant_ai_budget" */
  tenantAiBudget_aggregate: TenantAiBudget_Aggregate;
  /** fetch data from the table: "tenant_ai_budget" using primary key columns */
  tenantAiBudget_by_pk?: Maybe<TenantAiBudget>;
  /** fetch data from the table: "tenant_ai_credit_purchase" */
  tenantAiCreditPurchase: Array<TenantAiCreditPurchase>;
  /** fetch aggregated fields from the table: "tenant_ai_credit_purchase" */
  tenantAiCreditPurchase_aggregate: TenantAiCreditPurchase_Aggregate;
  /** fetch data from the table: "tenant_ai_credit_purchase" using primary key columns */
  tenantAiCreditPurchase_by_pk?: Maybe<TenantAiCreditPurchase>;
  /** fetch data from the table: "tenant_ai_payment" */
  tenantAiPayment: Array<TenantAiPayment>;
  /** fetch aggregated fields from the table: "tenant_ai_payment" */
  tenantAiPayment_aggregate: TenantAiPayment_Aggregate;
  /** fetch data from the table: "tenant_ai_payment" using primary key columns */
  tenantAiPayment_by_pk?: Maybe<TenantAiPayment>;
  /** fetch data from the table: "tenant_collection" */
  tenantCollection: Array<TenantCollection>;
  /** fetch data from the table: "tenant_collection_item" */
  tenantCollectionItem: Array<TenantCollectionItem>;
  /** fetch aggregated fields from the table: "tenant_collection_item" */
  tenantCollectionItem_aggregate: TenantCollectionItem_Aggregate;
  /** fetch data from the table: "tenant_collection_item" using primary key columns */
  tenantCollectionItem_by_pk?: Maybe<TenantCollectionItem>;
  /** fetch aggregated fields from the table: "tenant_collection" */
  tenantCollection_aggregate: TenantCollection_Aggregate;
  /** fetch data from the table: "tenant_collection" using primary key columns */
  tenantCollection_by_pk?: Maybe<TenantCollection>;
  /** fetch data from the table: "tenant_invoice" */
  tenantInvoice: Array<TenantInvoice>;
  /** fetch aggregated fields from the table: "tenant_invoice" */
  tenantInvoice_aggregate: TenantInvoice_Aggregate;
  /** fetch data from the table: "tenant_invoice" using primary key columns */
  tenantInvoice_by_pk?: Maybe<TenantInvoice>;
  /** fetch data from the table: "tenant_user_request_ai_usage" */
  tenantUserRequestAiUsage: Array<TenantUserRequestAiUsage>;
  /** fetch aggregated fields from the table: "tenant_user_request_ai_usage" */
  tenantUserRequestAiUsage_aggregate: TenantUserRequestAiUsage_Aggregate;
  /** fetch data from the table: "tenant_user_request_ai_usage" using primary key columns */
  tenantUserRequestAiUsage_by_pk?: Maybe<TenantUserRequestAiUsage>;
  /** fetch data from the table: "translation_category" */
  translationCategory: Array<TranslationCategory>;
  /** fetch aggregated fields from the table: "translation_category" */
  translationCategory_aggregate: TranslationCategory_Aggregate;
  /** fetch data from the table: "translation_category" using primary key columns */
  translationCategory_by_pk?: Maybe<TranslationCategory>;
  /** fetch data from the table: "translation_source" */
  translationSource: Array<TranslationSource>;
  /** fetch aggregated fields from the table: "translation_source" */
  translationSource_aggregate: TranslationSource_Aggregate;
  /** fetch data from the table: "translation_source" using primary key columns */
  translationSource_by_pk?: Maybe<TranslationSource>;
  /** fetch data from the table: "transport" */
  transport: Array<Transport>;
  /** fetch data from the table: "transport_emission_factor" */
  transportEmissionFactor: Array<TransportEmissionFactor>;
  /** fetch aggregated fields from the table: "transport_emission_factor" */
  transportEmissionFactor_aggregate: TransportEmissionFactor_Aggregate;
  /** fetch data from the table: "transport_emission_factor" using primary key columns */
  transportEmissionFactor_by_pk?: Maybe<TransportEmissionFactor>;
  /** fetch data from the table: "transport_source" */
  transportSource: Array<TransportSource>;
  /** fetch data from the table: "transport_source_calculation_type" */
  transportSourceCalculationType: Array<TransportSourceCalculationType>;
  /** fetch aggregated fields from the table: "transport_source_calculation_type" */
  transportSourceCalculationType_aggregate: TransportSourceCalculationType_Aggregate;
  /** fetch data from the table: "transport_source_calculation_type" using primary key columns */
  transportSourceCalculationType_by_pk?: Maybe<TransportSourceCalculationType>;
  /** fetch aggregated fields from the table: "transport_source" */
  transportSource_aggregate: TransportSource_Aggregate;
  /** fetch data from the table: "transport_source" using primary key columns */
  transportSource_by_pk?: Maybe<TransportSource>;
  /** fetch aggregated fields from the table: "transport" */
  transport_aggregate: Transport_Aggregate;
  /** fetch data from the table: "transport" using primary key columns */
  transport_by_pk?: Maybe<Transport>;
  /** fetch data from the table: "transport_standard_value" */
  transport_standard_value: Array<Transport_Standard_Value>;
  /** fetch aggregated fields from the table: "transport_standard_value" */
  transport_standard_value_aggregate: Transport_Standard_Value_Aggregate;
  /** fetch data from the table: "transport_standard_value" using primary key columns */
  transport_standard_value_by_pk?: Maybe<Transport_Standard_Value>;
  /** fetch data from the table: "transport_type" */
  transport_type: Array<Transport_Type>;
  /** fetch aggregated fields from the table: "transport_type" */
  transport_type_aggregate: Transport_Type_Aggregate;
  /** fetch data from the table: "transport_type" using primary key columns */
  transport_type_by_pk?: Maybe<Transport_Type>;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table: "user_material_favorite" */
  userMaterialFavorite: Array<UserMaterialFavorite>;
  /** fetch aggregated fields from the table: "user_material_favorite" */
  userMaterialFavorite_aggregate: UserMaterialFavorite_Aggregate;
  /** fetch data from the table: "user_material_favorite" using primary key columns */
  userMaterialFavorite_by_pk?: Maybe<UserMaterialFavorite>;
  /** fetch data from the table: "user_platform_review" */
  userPlatformReview: Array<UserPlatformReview>;
  /** fetch aggregated fields from the table: "user_platform_review" */
  userPlatformReview_aggregate: UserPlatformReview_Aggregate;
  /** fetch data from the table: "user_platform_review" using primary key columns */
  userPlatformReview_by_pk?: Maybe<UserPlatformReview>;
  /** fetch data from the table: "user_project_view" */
  userProjectView: Array<UserProjectView>;
  /** fetch aggregated fields from the table: "user_project_view" */
  userProjectView_aggregate: UserProjectView_Aggregate;
  /** fetch data from the table: "user_project_view" using primary key columns */
  userProjectView_by_pk?: Maybe<UserProjectView>;
  /** fetch data from the table: "user_tutorial_view" */
  userTutorialView: Array<UserTutorialView>;
  /** fetch aggregated fields from the table: "user_tutorial_view" */
  userTutorialView_aggregate: UserTutorialView_Aggregate;
  /** fetch data from the table: "user_tutorial_view" using primary key columns */
  userTutorialView_by_pk?: Maybe<UserTutorialView>;
  /** fetch data from the table: "user_welcome_flow" */
  userWelcomeFlow: Array<UserWelcomeFlow>;
  /** fetch data from the table: "user_welcome_flow_event" */
  userWelcomeFlowEvent: Array<UserWelcomeFlowEvent>;
  /** fetch aggregated fields from the table: "user_welcome_flow_event" */
  userWelcomeFlowEvent_aggregate: UserWelcomeFlowEvent_Aggregate;
  /** fetch data from the table: "user_welcome_flow_event" using primary key columns */
  userWelcomeFlowEvent_by_pk?: Maybe<UserWelcomeFlowEvent>;
  /** fetch aggregated fields from the table: "user_welcome_flow" */
  userWelcomeFlow_aggregate: UserWelcomeFlow_Aggregate;
  /** fetch data from the table: "user_welcome_flow" using primary key columns */
  userWelcomeFlow_by_pk?: Maybe<UserWelcomeFlow>;
  /** fetch data from the table: "v_latest_snapshot" */
  vLatestSnapshot: Array<VLatestSnapshot>;
  /** fetch aggregated fields from the table: "v_latest_snapshot" */
  vLatestSnapshot_aggregate: VLatestSnapshot_Aggregate;
  /** fetch data from the table: "v_material_current" */
  vMaterialCurrent: Array<VMaterialCurrent>;
  /** fetch aggregated fields from the table: "v_material_current" */
  vMaterialCurrent_aggregate: VMaterialCurrent_Aggregate;
  /** fetch data from the table: "v_material_gwp" */
  vMaterialGwp: Array<VMaterialGwp>;
  /** fetch aggregated fields from the table: "v_material_gwp" */
  vMaterialGwp_aggregate: VMaterialGwp_Aggregate;
  /** fetch data from the table: "v_material_status" */
  vMaterialStatus: Array<VMaterialStatus>;
  /** fetch aggregated fields from the table: "v_material_status" */
  vMaterialStatus_aggregate: VMaterialStatus_Aggregate;
  /** fetch data from the table: "v_project_intensity" */
  vProjectIntensity: Array<VProjectIntensity>;
  /** fetch aggregated fields from the table: "v_project_intensity" */
  vProjectIntensity_aggregate: VProjectIntensity_Aggregate;
  /** fetch data from the table: "weight_per_declared_unit" */
  weightPerDeclaredUnit: Array<WeightPerDeclaredUnit>;
  /** fetch aggregated fields from the table: "weight_per_declared_unit" */
  weightPerDeclaredUnit_aggregate: WeightPerDeclaredUnit_Aggregate;
  /** fetch data from the table: "weight_per_declared_unit" using primary key columns */
  weightPerDeclaredUnit_by_pk?: Maybe<WeightPerDeclaredUnit>;
};


export type Query_RootAgentModelPricingArgs = {
  distinct_on?: InputMaybe<Array<AgentModelPricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentModelPricing_Order_By>>;
  where?: InputMaybe<AgentModelPricing_Bool_Exp>;
};


export type Query_RootAgentModelPricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentModelPricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentModelPricing_Order_By>>;
  where?: InputMaybe<AgentModelPricing_Bool_Exp>;
};


export type Query_RootAgentModelPricing_By_PkArgs = {
  model: Scalars['String']['input'];
};


export type Query_RootAgentSkillsTenantUserArgs = {
  distinct_on?: InputMaybe<Array<AgentSkillsTenantUser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentSkillsTenantUser_Order_By>>;
  where?: InputMaybe<AgentSkillsTenantUser_Bool_Exp>;
};


export type Query_RootAgentSkillsTenantUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentSkillsTenantUser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentSkillsTenantUser_Order_By>>;
  where?: InputMaybe<AgentSkillsTenantUser_Bool_Exp>;
};


export type Query_RootAgentSkillsTenantUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgentUsageBudgetStatusArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageBudgetStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageBudgetStatus_Order_By>>;
  where?: InputMaybe<AgentUsageBudgetStatus_Bool_Exp>;
};


export type Query_RootAgentUsageBudgetStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageBudgetStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageBudgetStatus_Order_By>>;
  where?: InputMaybe<AgentUsageBudgetStatus_Bool_Exp>;
};


export type Query_RootAgentUsageDailyArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageDaily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageDaily_Order_By>>;
  where?: InputMaybe<AgentUsageDaily_Bool_Exp>;
};


export type Query_RootAgentUsageDaily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageDaily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageDaily_Order_By>>;
  where?: InputMaybe<AgentUsageDaily_Bool_Exp>;
};


export type Query_RootAgentUsageRequestArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageRequest_Order_By>>;
  where?: InputMaybe<AgentUsageRequest_Bool_Exp>;
};


export type Query_RootAgentUsageRequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageRequest_Order_By>>;
  where?: InputMaybe<AgentUsageRequest_Bool_Exp>;
};


export type Query_RootAgentUsageSessionArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageSession_Order_By>>;
  where?: InputMaybe<AgentUsageSession_Bool_Exp>;
};


export type Query_RootAgentUsageSession_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageSession_Order_By>>;
  where?: InputMaybe<AgentUsageSession_Bool_Exp>;
};


export type Query_RootApplicationSourceArgs = {
  distinct_on?: InputMaybe<Array<ApplicationSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ApplicationSource_Order_By>>;
  where?: InputMaybe<ApplicationSource_Bool_Exp>;
};


export type Query_RootApplicationSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ApplicationSource_Order_By>>;
  where?: InputMaybe<ApplicationSource_Bool_Exp>;
};


export type Query_RootApplicationSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBenchmarkGroupingVerdictArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkGroupingVerdict_Order_By>>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};


export type Query_RootBenchmarkGroupingVerdict_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkGroupingVerdict_Order_By>>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};


export type Query_RootBenchmarkGroupingVerdict_By_PkArgs = {
  materialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
  source: Scalars['String']['input'];
};


export type Query_RootBenchmarkInventoryMaterialArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkInventoryMaterial_Order_By>>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};


export type Query_RootBenchmarkInventoryMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkInventoryMaterial_Order_By>>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};


export type Query_RootBenchmarkInventoryMaterial_By_PkArgs = {
  materialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};


export type Query_RootBenchmarkMaterialMappingArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkMaterialMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkMaterialMapping_Order_By>>;
  where?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
};


export type Query_RootBenchmarkMaterialMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkMaterialMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkMaterialMapping_Order_By>>;
  where?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
};


export type Query_RootBenchmarkMaterialMapping_By_PkArgs = {
  layerIndex: Scalars['Int']['input'];
  parentMaterialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};


export type Query_RootBenchmarkProjectStateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkProjectState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkProjectState_Order_By>>;
  where?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
};


export type Query_RootBenchmarkProjectState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkProjectState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkProjectState_Order_By>>;
  where?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
};


export type Query_RootBenchmarkProjectState_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};


export type Query_RootBenchmarkSnapshotArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkSnapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkSnapshot_Order_By>>;
  where?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
};


export type Query_RootBenchmarkSnapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkSnapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkSnapshot_Order_By>>;
  where?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
};


export type Query_RootBenchmarkSnapshot_By_PkArgs = {
  snapshotId: Scalars['bigint']['input'];
};


export type Query_RootBuildingAreaTypeArgs = {
  distinct_on?: InputMaybe<Array<BuildingAreaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingAreaType_Order_By>>;
  where?: InputMaybe<BuildingAreaType_Bool_Exp>;
};


export type Query_RootBuildingAreaType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingAreaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingAreaType_Order_By>>;
  where?: InputMaybe<BuildingAreaType_Bool_Exp>;
};


export type Query_RootBuildingAreaType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootBuildingPartArgs = {
  distinct_on?: InputMaybe<Array<BuildingPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPart_Order_By>>;
  where?: InputMaybe<BuildingPart_Bool_Exp>;
};


export type Query_RootBuildingPartLifetimeSourceArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartLifetimeSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartLifetimeSource_Order_By>>;
  where?: InputMaybe<BuildingPartLifetimeSource_Bool_Exp>;
};


export type Query_RootBuildingPartLifetimeSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartLifetimeSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartLifetimeSource_Order_By>>;
  where?: InputMaybe<BuildingPartLifetimeSource_Bool_Exp>;
};


export type Query_RootBuildingPartLifetimeSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuildingPartMaintenanceLifetimeArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartMaintenanceLifetime_Bool_Exp>;
};


export type Query_RootBuildingPartMaintenanceLifetime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartMaintenanceLifetime_Bool_Exp>;
};


export type Query_RootBuildingPartMaintenanceLifetime_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuildingPartServiceLifetimeArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartServiceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartServiceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
};


export type Query_RootBuildingPartServiceLifetime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartServiceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartServiceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
};


export type Query_RootBuildingPartServiceLifetime_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuildingPart_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPart_Order_By>>;
  where?: InputMaybe<BuildingPart_Bool_Exp>;
};


export type Query_RootBuildingPart_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuildingTypeArgs = {
  distinct_on?: InputMaybe<Array<BuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingType_Order_By>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Query_RootBuildingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingType_Order_By>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Query_RootBuildingType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootBuilding_ElementArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Order_By>>;
  where?: InputMaybe<Building_Element_Bool_Exp>;
};


export type Query_RootBuilding_Element_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Order_By>>;
  where?: InputMaybe<Building_Element_Bool_Exp>;
};


export type Query_RootBuilding_Element_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuilding_Element_Classification_Code_MappingArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Classification_Code_Mapping_Bool_Exp>;
};


export type Query_RootBuilding_Element_Classification_Code_Mapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Classification_Code_Mapping_Bool_Exp>;
};


export type Query_RootBuilding_Element_Classification_Code_Mapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuilding_Element_Material_Category_MappingArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};


export type Query_RootBuilding_Element_Material_Category_Mapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};


export type Query_RootBuilding_Element_Material_Category_Mapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCalculationTypeArgs = {
  distinct_on?: InputMaybe<Array<CalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationType_Order_By>>;
  where?: InputMaybe<CalculationType_Bool_Exp>;
};


export type Query_RootCalculationTypeEpdDatasourceArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeEpdDatasource_Order_By>>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};


export type Query_RootCalculationTypeEpdDatasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeEpdDatasource_Order_By>>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};


export type Query_RootCalculationTypeEpdDatasource_By_PkArgs = {
  calculationTypeId: Scalars['Int']['input'];
  epdDatasourceId: Scalars['uuid']['input'];
};


export type Query_RootCalculationTypeThresholdByBuildingTypeArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Order_By>>;
  where?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
};


export type Query_RootCalculationTypeThresholdByBuildingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Order_By>>;
  where?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
};


export type Query_RootCalculationTypeThresholdByBuildingType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCalculationTypeVariantArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeVariant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeVariant_Order_By>>;
  where?: InputMaybe<CalculationTypeVariant_Bool_Exp>;
};


export type Query_RootCalculationTypeVariant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeVariant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeVariant_Order_By>>;
  where?: InputMaybe<CalculationTypeVariant_Bool_Exp>;
};


export type Query_RootCalculationTypeVariant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCalculationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationType_Order_By>>;
  where?: InputMaybe<CalculationType_Bool_Exp>;
};


export type Query_RootCalculationType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCalculation_Type_StageArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Type_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Calculation_Type_Stage_Order_By>>;
  where?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
};


export type Query_RootCalculation_Type_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Type_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Calculation_Type_Stage_Order_By>>;
  where?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
};


export type Query_RootCalculation_Type_Stage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootClassificationCodeArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCode_Order_By>>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};


export type Query_RootClassificationCodeTranslationArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTranslation_Order_By>>;
  where?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
};


export type Query_RootClassificationCodeTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTranslation_Order_By>>;
  where?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
};


export type Query_RootClassificationCodeTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootClassificationCodeTypeCountryArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTypeCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTypeCountry_Order_By>>;
  where?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
};


export type Query_RootClassificationCodeTypeCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTypeCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTypeCountry_Order_By>>;
  where?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
};


export type Query_RootClassificationCodeTypeCountry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootClassificationCode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCode_Order_By>>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};


export type Query_RootClassificationCode_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootClassificationObjectClassArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClass_Order_By>>;
  where?: InputMaybe<ClassificationObjectClass_Bool_Exp>;
};


export type Query_RootClassificationObjectClassParameterArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassParameter_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
};


export type Query_RootClassificationObjectClassParameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassParameter_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
};


export type Query_RootClassificationObjectClassParameter_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootClassificationObjectClassTranslationArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassTranslation_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
};


export type Query_RootClassificationObjectClassTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassTranslation_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
};


export type Query_RootClassificationObjectClassTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootClassificationObjectClass_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClass_Order_By>>;
  where?: InputMaybe<ClassificationObjectClass_Bool_Exp>;
};


export type Query_RootClassificationObjectClass_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootClassificationTypeArgs = {
  distinct_on?: InputMaybe<Array<ClassificationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationType_Order_By>>;
  where?: InputMaybe<ClassificationType_Bool_Exp>;
};


export type Query_RootClassificationTypeAttributeArgs = {
  distinct_on?: InputMaybe<Array<ClassificationTypeAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationTypeAttribute_Order_By>>;
  where?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
};


export type Query_RootClassificationTypeAttribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationTypeAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationTypeAttribute_Order_By>>;
  where?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
};


export type Query_RootClassificationTypeAttribute_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootClassificationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationType_Order_By>>;
  where?: InputMaybe<ClassificationType_Bool_Exp>;
};


export type Query_RootClassificationType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootComponentObjectPhaseArgs = {
  distinct_on?: InputMaybe<Array<ComponentObjectPhase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ComponentObjectPhase_Order_By>>;
  where?: InputMaybe<ComponentObjectPhase_Bool_Exp>;
};


export type Query_RootComponentObjectPhase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ComponentObjectPhase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ComponentObjectPhase_Order_By>>;
  where?: InputMaybe<ComponentObjectPhase_Bool_Exp>;
};


export type Query_RootComponentObjectPhase_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootConstructionArgs = {
  distinct_on?: InputMaybe<Array<Construction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Order_By>>;
  where?: InputMaybe<Construction_Bool_Exp>;
};


export type Query_RootConstructionBuildUpPartArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPart_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
};


export type Query_RootConstructionBuildUpPartMaterialCategoryArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
};


export type Query_RootConstructionBuildUpPartMaterialCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
};


export type Query_RootConstructionBuildUpPartMaterialCategory_By_PkArgs = {
  materialCategoryId: Scalars['String']['input'];
  partKey: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type Query_RootConstructionBuildUpPartTranslationArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
};


export type Query_RootConstructionBuildUpPartTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
};


export type Query_RootConstructionBuildUpPartTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionBuildUpPart_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPart_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
};


export type Query_RootConstructionBuildUpPart_By_PkArgs = {
  key: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type Query_RootConstructionBuildUpTemplateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplate_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
};


export type Query_RootConstructionBuildUpTemplateTranslationArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
};


export type Query_RootConstructionBuildUpTemplateTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
};


export type Query_RootConstructionBuildUpTemplateTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionBuildUpTemplate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplate_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
};


export type Query_RootConstructionBuildUpTemplate_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootConstructionCategoryArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategory_Order_By>>;
  where?: InputMaybe<ConstructionCategory_Bool_Exp>;
};


export type Query_RootConstructionCategoryTranslationArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryTranslation_Order_By>>;
  where?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
};


export type Query_RootConstructionCategoryTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryTranslation_Order_By>>;
  where?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
};


export type Query_RootConstructionCategoryTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionCategoryUnitArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryUnit_Order_By>>;
  where?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
};


export type Query_RootConstructionCategoryUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryUnit_Order_By>>;
  where?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
};


export type Query_RootConstructionCategoryUnit_By_PkArgs = {
  constructionCategoryId: Scalars['String']['input'];
  unitId: Scalars['Int']['input'];
};


export type Query_RootConstructionCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategory_Order_By>>;
  where?: InputMaybe<ConstructionCategory_Bool_Exp>;
};


export type Query_RootConstructionCategory_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootConstructionCountryArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCountry_Order_By>>;
  where?: InputMaybe<ConstructionCountry_Bool_Exp>;
};


export type Query_RootConstructionCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCountry_Order_By>>;
  where?: InputMaybe<ConstructionCountry_Bool_Exp>;
};


export type Query_RootConstructionCountry_By_PkArgs = {
  constructionId: Scalars['uuid']['input'];
  country: Country_Enum;
};


export type Query_RootConstructionDescriptionArgs = {
  distinct_on?: InputMaybe<Array<ConstructionDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionDescription_Order_By>>;
  where?: InputMaybe<ConstructionDescription_Bool_Exp>;
};


export type Query_RootConstructionDescription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionDescription_Order_By>>;
  where?: InputMaybe<ConstructionDescription_Bool_Exp>;
};


export type Query_RootConstructionDescription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionForkArgs = {
  distinct_on?: InputMaybe<Array<ConstructionFork_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionFork_Order_By>>;
  where?: InputMaybe<ConstructionFork_Bool_Exp>;
};


export type Query_RootConstructionFork_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionFork_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionFork_Order_By>>;
  where?: InputMaybe<ConstructionFork_Bool_Exp>;
};


export type Query_RootConstructionFork_By_PkArgs = {
  constructionId: Scalars['uuid']['input'];
  parentConstructionId: Scalars['uuid']['input'];
};


export type Query_RootConstructionInhomogeneousLayerArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayer_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
};


export type Query_RootConstructionInhomogeneousLayerMaterialArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
};


export type Query_RootConstructionInhomogeneousLayerMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
};


export type Query_RootConstructionInhomogeneousLayerMaterial_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionInhomogeneousLayer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayer_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
};


export type Query_RootConstructionInhomogeneousLayer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionInhomogenousLayerDescriptionArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
};


export type Query_RootConstructionInhomogenousLayerDescription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
};


export type Query_RootConstructionInhomogenousLayerDescription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionInhomogenousLayerNameArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerName_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
};


export type Query_RootConstructionInhomogenousLayerName_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerName_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
};


export type Query_RootConstructionInhomogenousLayerName_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionMaterialArgs = {
  distinct_on?: InputMaybe<Array<ConstructionMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionMaterial_Order_By>>;
  where?: InputMaybe<ConstructionMaterial_Bool_Exp>;
};


export type Query_RootConstructionMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionMaterial_Order_By>>;
  where?: InputMaybe<ConstructionMaterial_Bool_Exp>;
};


export type Query_RootConstructionMaterial_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionNameArgs = {
  distinct_on?: InputMaybe<Array<ConstructionName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionName_Order_By>>;
  where?: InputMaybe<ConstructionName_Bool_Exp>;
};


export type Query_RootConstructionName_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionName_Order_By>>;
  where?: InputMaybe<ConstructionName_Bool_Exp>;
};


export type Query_RootConstructionName_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionSortingArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSorting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSorting_Order_By>>;
  where?: InputMaybe<ConstructionSorting_Bool_Exp>;
};


export type Query_RootConstructionSorting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSorting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSorting_Order_By>>;
  where?: InputMaybe<ConstructionSorting_Bool_Exp>;
};


export type Query_RootConstructionSorting_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstruction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Construction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Order_By>>;
  where?: InputMaybe<Construction_Bool_Exp>;
};


export type Query_RootConstruction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountryConfigArgs = {
  distinct_on?: InputMaybe<Array<CountryConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CountryConfig_Order_By>>;
  where?: InputMaybe<CountryConfig_Bool_Exp>;
};


export type Query_RootCountryConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CountryConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CountryConfig_Order_By>>;
  where?: InputMaybe<CountryConfig_Bool_Exp>;
};


export type Query_RootCountryConfig_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDeclaredUnitArgs = {
  distinct_on?: InputMaybe<Array<DeclaredUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DeclaredUnit_Order_By>>;
  where?: InputMaybe<DeclaredUnit_Bool_Exp>;
};


export type Query_RootDeclaredUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DeclaredUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DeclaredUnit_Order_By>>;
  where?: InputMaybe<DeclaredUnit_Bool_Exp>;
};


export type Query_RootDeclaredUnit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDenominatorUnitArgs = {
  distinct_on?: InputMaybe<Array<DenominatorUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DenominatorUnit_Order_By>>;
  where?: InputMaybe<DenominatorUnit_Bool_Exp>;
};


export type Query_RootDenominatorUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DenominatorUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DenominatorUnit_Order_By>>;
  where?: InputMaybe<DenominatorUnit_Bool_Exp>;
};


export type Query_RootDenominatorUnit_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDistance_UnitArgs = {
  distinct_on?: InputMaybe<Array<Distance_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Distance_Unit_Order_By>>;
  where?: InputMaybe<Distance_Unit_Bool_Exp>;
};


export type Query_RootDistance_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Distance_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Distance_Unit_Order_By>>;
  where?: InputMaybe<Distance_Unit_Bool_Exp>;
};


export type Query_RootDistance_Unit_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEmissionFactorSourceTypeArgs = {
  distinct_on?: InputMaybe<Array<EmissionFactorSourceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmissionFactorSourceType_Order_By>>;
  where?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
};


export type Query_RootEmissionFactorSourceType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EmissionFactorSourceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmissionFactorSourceType_Order_By>>;
  where?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
};


export type Query_RootEmissionFactorSourceType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmission_FactorArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Order_By>>;
  where?: InputMaybe<Emission_Factor_Bool_Exp>;
};


export type Query_RootEmission_Factor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Order_By>>;
  where?: InputMaybe<Emission_Factor_Bool_Exp>;
};


export type Query_RootEmission_Factor_By_PkArgs = {
  emission_factor_source_id: Scalars['uuid']['input'];
  emission_factor_type: Emission_Factor_Type_Enum;
  year: Scalars['Int']['input'];
};


export type Query_RootEmission_Factor_SourceArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Source_Order_By>>;
  where?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
};


export type Query_RootEmission_Factor_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Source_Order_By>>;
  where?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
};


export type Query_RootEmission_Factor_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmission_Factor_TypeArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Type_Order_By>>;
  where?: InputMaybe<Emission_Factor_Type_Bool_Exp>;
};


export type Query_RootEmission_Factor_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Type_Order_By>>;
  where?: InputMaybe<Emission_Factor_Type_Bool_Exp>;
};


export type Query_RootEmission_Factor_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnumCollectionTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumCollectionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EnumCollectionType_Order_By>>;
  where?: InputMaybe<EnumCollectionType_Bool_Exp>;
};


export type Query_RootEnumCollectionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCollectionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EnumCollectionType_Order_By>>;
  where?: InputMaybe<EnumCollectionType_Bool_Exp>;
};


export type Query_RootEnumCollectionType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEpdDatasourceArgs = {
  distinct_on?: InputMaybe<Array<EpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdDatasource_Order_By>>;
  where?: InputMaybe<EpdDatasource_Bool_Exp>;
};


export type Query_RootEpdDatasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdDatasource_Order_By>>;
  where?: InputMaybe<EpdDatasource_Bool_Exp>;
};


export type Query_RootEpdDatasource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEpdOwnerArgs = {
  distinct_on?: InputMaybe<Array<EpdOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwner_Order_By>>;
  where?: InputMaybe<EpdOwner_Bool_Exp>;
};


export type Query_RootEpdOwnerAliasArgs = {
  distinct_on?: InputMaybe<Array<EpdOwnerAlias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwnerAlias_Order_By>>;
  where?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
};


export type Query_RootEpdOwnerAlias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdOwnerAlias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwnerAlias_Order_By>>;
  where?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
};


export type Query_RootEpdOwnerAlias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEpdOwner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwner_Order_By>>;
  where?: InputMaybe<EpdOwner_Bool_Exp>;
};


export type Query_RootEpdOwner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEpdProductIndustryArgs = {
  distinct_on?: InputMaybe<Array<EpdProductIndustry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdProductIndustry_Order_By>>;
  where?: InputMaybe<EpdProductIndustry_Bool_Exp>;
};


export type Query_RootEpdProductIndustry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdProductIndustry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdProductIndustry_Order_By>>;
  where?: InputMaybe<EpdProductIndustry_Bool_Exp>;
};


export type Query_RootEpdProductIndustry_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEpdSpecificationFormArgs = {
  distinct_on?: InputMaybe<Array<EpdSpecificationForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdSpecificationForm_Order_By>>;
  where?: InputMaybe<EpdSpecificationForm_Bool_Exp>;
};


export type Query_RootEpdSpecificationForm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdSpecificationForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdSpecificationForm_Order_By>>;
  where?: InputMaybe<EpdSpecificationForm_Bool_Exp>;
};


export type Query_RootEpdSpecificationForm_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFlowGuideArgs = {
  distinct_on?: InputMaybe<Array<FlowGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuide_Order_By>>;
  where?: InputMaybe<FlowGuide_Bool_Exp>;
};


export type Query_RootFlowGuideViewsArgs = {
  distinct_on?: InputMaybe<Array<FlowGuideViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuideViews_Order_By>>;
  where?: InputMaybe<FlowGuideViews_Bool_Exp>;
};


export type Query_RootFlowGuideViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowGuideViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuideViews_Order_By>>;
  where?: InputMaybe<FlowGuideViews_Bool_Exp>;
};


export type Query_RootFlowGuideViews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFlowGuide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuide_Order_By>>;
  where?: InputMaybe<FlowGuide_Bool_Exp>;
};


export type Query_RootFlowGuide_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIndicatorSourceArgs = {
  distinct_on?: InputMaybe<Array<IndicatorSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorSource_Order_By>>;
  where?: InputMaybe<IndicatorSource_Bool_Exp>;
};


export type Query_RootIndicatorSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorSource_Order_By>>;
  where?: InputMaybe<IndicatorSource_Bool_Exp>;
};


export type Query_RootIndicatorSource_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootIndicatorTypeArgs = {
  distinct_on?: InputMaybe<Array<IndicatorType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorType_Order_By>>;
  where?: InputMaybe<IndicatorType_Bool_Exp>;
};


export type Query_RootIndicatorTypeMappingArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMapping_Order_By>>;
  where?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
};


export type Query_RootIndicatorTypeMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMapping_Order_By>>;
  where?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
};


export type Query_RootIndicatorTypeMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIndicatorTypeMultiplierArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMultiplier_Order_By>>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};


export type Query_RootIndicatorTypeMultiplier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMultiplier_Order_By>>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};


export type Query_RootIndicatorTypeMultiplier_By_PkArgs = {
  fromIndicatorTypeId: Scalars['Int']['input'];
};


export type Query_RootIndicatorType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorType_Order_By>>;
  where?: InputMaybe<IndicatorType_Bool_Exp>;
};


export type Query_RootIndicatorType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInstallation_Standard_ValueArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_Building_TypeArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Building_Type_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_Building_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Building_Type_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_Building_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInstallation_Standard_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInstallation_Standard_Value_Classification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Classification_Type_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_Classification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Classification_Type_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_Classification_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInstallation_Standard_Value_DatasourceArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Datasource_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Datasource_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_Datasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Datasource_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Datasource_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_Datasource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInstallation_Standard_Value_EmissionArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Emission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Emission_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Emission_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_Emission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Emission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Emission_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Emission_Bool_Exp>;
};


export type Query_RootInstallation_Standard_Value_Emission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLanguageArgs = {
  distinct_on?: InputMaybe<Array<Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Language_Order_By>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Query_RootLanguage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Language_Order_By>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Query_RootLanguage_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type Query_RootLifetime_TableArgs = {
  distinct_on?: InputMaybe<Array<Lifetime_Table_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lifetime_Table_Order_By>>;
  where?: InputMaybe<Lifetime_Table_Bool_Exp>;
};


export type Query_RootLifetime_Table_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lifetime_Table_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lifetime_Table_Order_By>>;
  where?: InputMaybe<Lifetime_Table_Bool_Exp>;
};


export type Query_RootLifetime_Table_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMappingHistoryArgs = {
  distinct_on?: InputMaybe<Array<MappingHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistory_Order_By>>;
  where?: InputMaybe<MappingHistory_Bool_Exp>;
};


export type Query_RootMappingHistoryFrequencyArgs = {
  distinct_on?: InputMaybe<Array<MappingHistoryFrequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistoryFrequency_Order_By>>;
  where?: InputMaybe<MappingHistoryFrequency_Bool_Exp>;
};


export type Query_RootMappingHistoryFrequency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MappingHistoryFrequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistoryFrequency_Order_By>>;
  where?: InputMaybe<MappingHistoryFrequency_Bool_Exp>;
};


export type Query_RootMappingHistoryMostRecentLifetimeArgs = {
  distinct_on?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Order_By>>;
  where?: InputMaybe<MappingHistoryMostRecentLifetime_Bool_Exp>;
};


export type Query_RootMappingHistoryMostRecentLifetime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Order_By>>;
  where?: InputMaybe<MappingHistoryMostRecentLifetime_Bool_Exp>;
};


export type Query_RootMappingHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MappingHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistory_Order_By>>;
  where?: InputMaybe<MappingHistory_Bool_Exp>;
};


export type Query_RootMappingHistory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMapping_History_Most_Used_LifetimeArgs = {
  distinct_on?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Order_By>>;
  where?: InputMaybe<Mapping_History_Most_Used_Lifetime_Bool_Exp>;
};


export type Query_RootMapping_History_Most_Used_Lifetime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Order_By>>;
  where?: InputMaybe<Mapping_History_Most_Used_Lifetime_Bool_Exp>;
};


export type Query_RootMaterialArgs = {
  distinct_on?: InputMaybe<Array<Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Material_Order_By>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Query_RootMaterialBiogenicParamsArgs = {
  distinct_on?: InputMaybe<Array<MaterialBiogenicParams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialBiogenicParams_Order_By>>;
  where?: InputMaybe<MaterialBiogenicParams_Bool_Exp>;
};


export type Query_RootMaterialBiogenicParams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialBiogenicParams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialBiogenicParams_Order_By>>;
  where?: InputMaybe<MaterialBiogenicParams_Bool_Exp>;
};


export type Query_RootMaterialBiogenicParams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterialCategoryArgs = {
  distinct_on?: InputMaybe<Array<MaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialCategory_Order_By>>;
  where?: InputMaybe<MaterialCategory_Bool_Exp>;
};


export type Query_RootMaterialCategoryTextureArgs = {
  distinct_on?: InputMaybe<Array<MaterialCategoryTexture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialCategoryTexture_Order_By>>;
  where?: InputMaybe<MaterialCategoryTexture_Bool_Exp>;
};


export type Query_RootMaterialCategoryTexture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialCategoryTexture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialCategoryTexture_Order_By>>;
  where?: InputMaybe<MaterialCategoryTexture_Bool_Exp>;
};


export type Query_RootMaterialCategoryTexture_By_PkArgs = {
  materialCategoryId: Scalars['String']['input'];
};


export type Query_RootMaterialCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialCategory_Order_By>>;
  where?: InputMaybe<MaterialCategory_Bool_Exp>;
};


export type Query_RootMaterialCategory_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootMaterialDescriptionArgs = {
  distinct_on?: InputMaybe<Array<MaterialDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialDescription_Order_By>>;
  where?: InputMaybe<MaterialDescription_Bool_Exp>;
};


export type Query_RootMaterialDescription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialDescription_Order_By>>;
  where?: InputMaybe<MaterialDescription_Bool_Exp>;
};


export type Query_RootMaterialDescription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterialEmissionIndicatorArgs = {
  distinct_on?: InputMaybe<Array<MaterialEmissionIndicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEmissionIndicator_Order_By>>;
  where?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
};


export type Query_RootMaterialEmissionIndicator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEmissionIndicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEmissionIndicator_Order_By>>;
  where?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
};


export type Query_RootMaterialEmissionIndicator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterialEpdArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpd_Order_By>>;
  where?: InputMaybe<MaterialEpd_Bool_Exp>;
};


export type Query_RootMaterialEpdDatasourceArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdDatasource_Order_By>>;
  where?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
};


export type Query_RootMaterialEpdDatasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdDatasource_Order_By>>;
  where?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
};


export type Query_RootMaterialEpdDatasource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterialEpdUrlArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdUrl_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdUrl_Order_By>>;
  where?: InputMaybe<MaterialEpdUrl_Bool_Exp>;
};


export type Query_RootMaterialEpdUrl_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdUrl_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdUrl_Order_By>>;
  where?: InputMaybe<MaterialEpdUrl_Bool_Exp>;
};


export type Query_RootMaterialEpdUrl_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterialEpd_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpd_Order_By>>;
  where?: InputMaybe<MaterialEpd_Bool_Exp>;
};


export type Query_RootMaterialEpd_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterialForkArgs = {
  distinct_on?: InputMaybe<Array<MaterialFork_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialFork_Order_By>>;
  where?: InputMaybe<MaterialFork_Bool_Exp>;
};


export type Query_RootMaterialFork_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialFork_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialFork_Order_By>>;
  where?: InputMaybe<MaterialFork_Bool_Exp>;
};


export type Query_RootMaterialFork_By_PkArgs = {
  materialId: Scalars['uuid']['input'];
  parentMaterialId: Scalars['uuid']['input'];
};


export type Query_RootMaterialNameArgs = {
  distinct_on?: InputMaybe<Array<MaterialName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialName_Order_By>>;
  where?: InputMaybe<MaterialName_Bool_Exp>;
};


export type Query_RootMaterialName_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialName_Order_By>>;
  where?: InputMaybe<MaterialName_Bool_Exp>;
};


export type Query_RootMaterialName_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterialStageArgs = {
  distinct_on?: InputMaybe<Array<MaterialStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStage_Order_By>>;
  where?: InputMaybe<MaterialStage_Bool_Exp>;
};


export type Query_RootMaterialStage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStage_Order_By>>;
  where?: InputMaybe<MaterialStage_Bool_Exp>;
};


export type Query_RootMaterialStage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterialTypeArgs = {
  distinct_on?: InputMaybe<Array<MaterialType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialType_Order_By>>;
  where?: InputMaybe<MaterialType_Bool_Exp>;
};


export type Query_RootMaterialType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialType_Order_By>>;
  where?: InputMaybe<MaterialType_Bool_Exp>;
};


export type Query_RootMaterialType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMaterialWasteSourceArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteSource_Order_By>>;
  where?: InputMaybe<MaterialWasteSource_Bool_Exp>;
};


export type Query_RootMaterialWasteSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteSource_Order_By>>;
  where?: InputMaybe<MaterialWasteSource_Bool_Exp>;
};


export type Query_RootMaterialWasteSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterialWasteTypeArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteType_Order_By>>;
  where?: InputMaybe<MaterialWasteType_Bool_Exp>;
};


export type Query_RootMaterialWasteType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteType_Order_By>>;
  where?: InputMaybe<MaterialWasteType_Bool_Exp>;
};


export type Query_RootMaterialWasteType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Material_Order_By>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Query_RootMaterial_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMcpConnectionArgs = {
  distinct_on?: InputMaybe<Array<McpConnection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<McpConnection_Order_By>>;
  where?: InputMaybe<McpConnection_Bool_Exp>;
};


export type Query_RootMcpConnection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<McpConnection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<McpConnection_Order_By>>;
  where?: InputMaybe<McpConnection_Bool_Exp>;
};


export type Query_RootMcpConnection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMcpToolCallArgs = {
  distinct_on?: InputMaybe<Array<McpToolCall_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<McpToolCall_Order_By>>;
  where?: InputMaybe<McpToolCall_Bool_Exp>;
};


export type Query_RootMcpToolCall_AggregateArgs = {
  distinct_on?: InputMaybe<Array<McpToolCall_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<McpToolCall_Order_By>>;
  where?: InputMaybe<McpToolCall_Bool_Exp>;
};


export type Query_RootMcpToolCall_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootModelArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Order_By>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Query_RootModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Order_By>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Query_RootModel_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProjectBuildingAreaArgs = {
  distinct_on?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectBuildingArea_Order_By>>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};


export type Query_RootProjectBuildingArea_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectBuildingArea_Order_By>>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};


export type Query_RootProjectBuildingArea_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectCalculationArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculation_Order_By>>;
  where?: InputMaybe<ProjectCalculation_Bool_Exp>;
};


export type Query_RootProjectCalculationStageArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculationStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculationStage_Order_By>>;
  where?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
};


export type Query_RootProjectCalculationStage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculationStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculationStage_Order_By>>;
  where?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
};


export type Query_RootProjectCalculationStage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectCalculation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculation_Order_By>>;
  where?: InputMaybe<ProjectCalculation_Bool_Exp>;
};


export type Query_RootProjectCalculation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectComponentMappingTypeArgs = {
  distinct_on?: InputMaybe<Array<ProjectComponentMappingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectComponentMappingType_Order_By>>;
  where?: InputMaybe<ProjectComponentMappingType_Bool_Exp>;
};


export type Query_RootProjectComponentMappingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectComponentMappingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectComponentMappingType_Order_By>>;
  where?: InputMaybe<ProjectComponentMappingType_Bool_Exp>;
};


export type Query_RootProjectComponentMappingType_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootProjectDashboardStatusArgs = {
  distinct_on?: InputMaybe<Array<ProjectDashboardStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectDashboardStatus_Order_By>>;
  where?: InputMaybe<ProjectDashboardStatus_Bool_Exp>;
};


export type Query_RootProjectDashboardStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectDashboardStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectDashboardStatus_Order_By>>;
  where?: InputMaybe<ProjectDashboardStatus_Bool_Exp>;
};


export type Query_RootProjectDashboardStatus_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


export type Query_RootProjectEmissionFactorArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};


export type Query_RootProjectEmissionFactorCustomArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactorCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactorCustom_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactorCustom_Bool_Exp>;
};


export type Query_RootProjectEmissionFactorCustom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactorCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactorCustom_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactorCustom_Bool_Exp>;
};


export type Query_RootProjectEmissionFactorCustom_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectEmissionFactor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};


export type Query_RootProjectEmissionFactor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectInstallationArgs = {
  distinct_on?: InputMaybe<Array<ProjectInstallation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectInstallation_Order_By>>;
  where?: InputMaybe<ProjectInstallation_Bool_Exp>;
};


export type Query_RootProjectInstallation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectInstallation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectInstallation_Order_By>>;
  where?: InputMaybe<ProjectInstallation_Bool_Exp>;
};


export type Query_RootProjectInstallation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectLocationArgs = {
  distinct_on?: InputMaybe<Array<ProjectLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectLocation_Order_By>>;
  where?: InputMaybe<ProjectLocation_Bool_Exp>;
};


export type Query_RootProjectLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectLocation_Order_By>>;
  where?: InputMaybe<ProjectLocation_Bool_Exp>;
};


export type Query_RootProjectLocation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectMaterialClassificationFeedbackArgs = {
  distinct_on?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Order_By>>;
  where?: InputMaybe<ProjectMaterialClassificationFeedback_Bool_Exp>;
};


export type Query_RootProjectMaterialClassificationFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Order_By>>;
  where?: InputMaybe<ProjectMaterialClassificationFeedback_Bool_Exp>;
};


export type Query_RootProjectMaterialClassificationFeedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectMaterialClassificationParameterArgs = {
  distinct_on?: InputMaybe<Array<ProjectMaterialClassificationParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMaterialClassificationParameter_Order_By>>;
  where?: InputMaybe<ProjectMaterialClassificationParameter_Bool_Exp>;
};


export type Query_RootProjectMaterialClassificationParameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectMaterialClassificationParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMaterialClassificationParameter_Order_By>>;
  where?: InputMaybe<ProjectMaterialClassificationParameter_Bool_Exp>;
};


export type Query_RootProjectMaterialClassificationParameter_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectMembershipArgs = {
  distinct_on?: InputMaybe<Array<ProjectMembership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMembership_Order_By>>;
  where?: InputMaybe<ProjectMembership_Bool_Exp>;
};


export type Query_RootProjectMembership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectMembership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMembership_Order_By>>;
  where?: InputMaybe<ProjectMembership_Bool_Exp>;
};


export type Query_RootProjectMembership_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectModelArgs = {
  distinct_on?: InputMaybe<Array<ProjectModel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModel_Order_By>>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};


export type Query_RootProjectModelSpecklePinArgs = {
  distinct_on?: InputMaybe<Array<ProjectModelSpecklePin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModelSpecklePin_Order_By>>;
  where?: InputMaybe<ProjectModelSpecklePin_Bool_Exp>;
};


export type Query_RootProjectModelSpecklePin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectModelSpecklePin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModelSpecklePin_Order_By>>;
  where?: InputMaybe<ProjectModelSpecklePin_Bool_Exp>;
};


export type Query_RootProjectModelSpecklePin_By_PkArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
};


export type Query_RootProjectModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectModel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModel_Order_By>>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};


export type Query_RootProjectModel_By_PkArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
  revisionId: Scalars['uuid']['input'];
};


export type Query_RootProjectOperationalArgs = {
  distinct_on?: InputMaybe<Array<ProjectOperational_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectOperational_Order_By>>;
  where?: InputMaybe<ProjectOperational_Bool_Exp>;
};


export type Query_RootProjectOperational_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectOperational_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectOperational_Order_By>>;
  where?: InputMaybe<ProjectOperational_Bool_Exp>;
};


export type Query_RootProjectOperational_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectReferenceAreaArgs = {
  distinct_on?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectReferenceArea_Order_By>>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};


export type Query_RootProjectReferenceArea_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectReferenceArea_Order_By>>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};


export type Query_RootProjectReferenceArea_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectRevisionArgs = {
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


export type Query_RootProjectRevision_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


export type Query_RootProjectRevision_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectSpecialConditionConfigArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionConfig_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionConfig_Bool_Exp>;
};


export type Query_RootProjectSpecialConditionConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionConfig_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionConfig_Bool_Exp>;
};


export type Query_RootProjectSpecialConditionConfig_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
  revisionId: Scalars['uuid']['input'];
};


export type Query_RootProjectSpecialConditionTypeMappingArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};


export type Query_RootProjectSpecialConditionTypeMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};


export type Query_RootProjectSpecialConditionTypeMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectSpeckleCopyArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleCopy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleCopy_Order_By>>;
  where?: InputMaybe<ProjectSpeckleCopy_Bool_Exp>;
};


export type Query_RootProjectSpeckleCopyRecentArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleCopyRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleCopyRecent_Order_By>>;
  where?: InputMaybe<ProjectSpeckleCopyRecent_Bool_Exp>;
};


export type Query_RootProjectSpeckleCopyRecent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleCopyRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleCopyRecent_Order_By>>;
  where?: InputMaybe<ProjectSpeckleCopyRecent_Bool_Exp>;
};


export type Query_RootProjectSpeckleCopy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleCopy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleCopy_Order_By>>;
  where?: InputMaybe<ProjectSpeckleCopy_Bool_Exp>;
};


export type Query_RootProjectSpeckleCopy_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


export type Query_RootProjectSpeckleModelSyncArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleModelSync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleModelSync_Order_By>>;
  where?: InputMaybe<ProjectSpeckleModelSync_Bool_Exp>;
};


export type Query_RootProjectSpeckleModelSyncRecentArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Order_By>>;
  where?: InputMaybe<ProjectSpeckleModelSyncRecent_Bool_Exp>;
};


export type Query_RootProjectSpeckleModelSyncRecent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Order_By>>;
  where?: InputMaybe<ProjectSpeckleModelSyncRecent_Bool_Exp>;
};


export type Query_RootProjectSpeckleModelSync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleModelSync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleModelSync_Order_By>>;
  where?: InputMaybe<ProjectSpeckleModelSync_Bool_Exp>;
};


export type Query_RootProjectSpeckleModelSync_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


export type Query_RootProjectSpeckleParameterConfigArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleParameterConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleParameterConfig_Order_By>>;
  where?: InputMaybe<ProjectSpeckleParameterConfig_Bool_Exp>;
};


export type Query_RootProjectSpeckleParameterConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleParameterConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleParameterConfig_Order_By>>;
  where?: InputMaybe<ProjectSpeckleParameterConfig_Bool_Exp>;
};


export type Query_RootProjectSpeckleParameterConfig_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


export type Query_RootProjectStandardValueStageArgs = {
  distinct_on?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStandardValueStage_Order_By>>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};


export type Query_RootProjectStandardValueStage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStandardValueStage_Order_By>>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};


export type Query_RootProjectStandardValueStage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectStatusArgs = {
  distinct_on?: InputMaybe<Array<ProjectStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStatus_Order_By>>;
  where?: InputMaybe<ProjectStatus_Bool_Exp>;
};


export type Query_RootProjectStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStatus_Order_By>>;
  where?: InputMaybe<ProjectStatus_Bool_Exp>;
};


export type Query_RootProjectStatus_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProjectTenantStatusAreaArgs = {
  distinct_on?: InputMaybe<Array<ProjectTenantStatusArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTenantStatusArea_Order_By>>;
  where?: InputMaybe<ProjectTenantStatusArea_Bool_Exp>;
};


export type Query_RootProjectTenantStatusArea_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectTenantStatusArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTenantStatusArea_Order_By>>;
  where?: InputMaybe<ProjectTenantStatusArea_Bool_Exp>;
};


export type Query_RootProjectTransportMappingEmissionFactorArgs = {
  distinct_on?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
};


export type Query_RootProjectTransportMappingEmissionFactor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
};


export type Query_RootProjectTransportMappingEmissionFactor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectVersionArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersion_Order_By>>;
  where?: InputMaybe<ProjectVersion_Bool_Exp>;
};


export type Query_RootProjectVersionNumberedArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersionNumbered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersionNumbered_Order_By>>;
  where?: InputMaybe<ProjectVersionNumbered_Bool_Exp>;
};


export type Query_RootProjectVersionNumbered_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersionNumbered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersionNumbered_Order_By>>;
  where?: InputMaybe<ProjectVersionNumbered_Bool_Exp>;
};


export type Query_RootProjectVersion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersion_Order_By>>;
  where?: InputMaybe<ProjectVersion_Bool_Exp>;
};


export type Query_RootProjectVersion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectWasteMappingArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteMapping_Order_By>>;
  where?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
};


export type Query_RootProjectWasteMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteMapping_Order_By>>;
  where?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
};


export type Query_RootProjectWasteMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectWasteTypeCustomArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteTypeCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteTypeCustom_Order_By>>;
  where?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
};


export type Query_RootProjectWasteTypeCustom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteTypeCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteTypeCustom_Order_By>>;
  where?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
};


export type Query_RootProjectWasteTypeCustom_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Speckle_Stream_As_OfArgs = {
  args: Project_Speckle_Stream_As_Of_Args;
  distinct_on?: InputMaybe<Array<Speckle_Stream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speckle_Stream_Order_By>>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};


export type Query_RootProject_Speckle_Stream_As_Of_AggregateArgs = {
  args: Project_Speckle_Stream_As_Of_Args;
  distinct_on?: InputMaybe<Array<Speckle_Stream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speckle_Stream_Order_By>>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};


export type Query_RootProject_TransportArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Order_By>>;
  where?: InputMaybe<Project_Transport_Bool_Exp>;
};


export type Query_RootProject_Transport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Order_By>>;
  where?: InputMaybe<Project_Transport_Bool_Exp>;
};


export type Query_RootProject_Transport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Transport_DefaultArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Default_Order_By>>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};


export type Query_RootProject_Transport_Default_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Default_Order_By>>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};


export type Query_RootProject_Transport_Default_By_PkArgs = {
  project_transport_id: Scalars['uuid']['input'];
};


export type Query_RootProject_Transport_MappingArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Mapping_Order_By>>;
  where?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
};


export type Query_RootProject_Transport_Mapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Mapping_Order_By>>;
  where?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
};


export type Query_RootProject_Transport_Mapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReferenceAreaTypeArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaType_Order_By>>;
  where?: InputMaybe<ReferenceAreaType_Bool_Exp>;
};


export type Query_RootReferenceAreaTypeCalculationTypeMappingArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Order_By>>;
  where?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
};


export type Query_RootReferenceAreaTypeCalculationTypeMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Order_By>>;
  where?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
};


export type Query_RootReferenceAreaTypeCalculationTypeMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReferenceAreaType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaType_Order_By>>;
  where?: InputMaybe<ReferenceAreaType_Bool_Exp>;
};


export type Query_RootReferenceAreaType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootReportBuildingTypeMappingArgs = {
  distinct_on?: InputMaybe<Array<ReportBuildingTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportBuildingTypeMapping_Order_By>>;
  where?: InputMaybe<ReportBuildingTypeMapping_Bool_Exp>;
};


export type Query_RootReportBuildingTypeMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportBuildingTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportBuildingTypeMapping_Order_By>>;
  where?: InputMaybe<ReportBuildingTypeMapping_Bool_Exp>;
};


export type Query_RootReportBuildingTypeMapping_By_PkArgs = {
  buildingTypeId: Scalars['Int']['input'];
};


export type Query_RootReportClassificationCodeEmissionMappingArgs = {
  distinct_on?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Order_By>>;
  where?: InputMaybe<ReportClassificationCodeEmissionMapping_Bool_Exp>;
};


export type Query_RootReportClassificationCodeEmissionMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Order_By>>;
  where?: InputMaybe<ReportClassificationCodeEmissionMapping_Bool_Exp>;
};


export type Query_RootReportClassificationCodeEmissionMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReportLoadBearingElementAmountMappingArgs = {
  distinct_on?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Order_By>>;
  where?: InputMaybe<ReportLoadBearingElementAmountMapping_Bool_Exp>;
};


export type Query_RootReportLoadBearingElementAmountMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Order_By>>;
  where?: InputMaybe<ReportLoadBearingElementAmountMapping_Bool_Exp>;
};


export type Query_RootReportLoadBearingElementAmountMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReportLoadBearingElementEmissionMappingArgs = {
  distinct_on?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Order_By>>;
  where?: InputMaybe<ReportLoadBearingElementEmissionMapping_Bool_Exp>;
};


export type Query_RootReportLoadBearingElementEmissionMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Order_By>>;
  where?: InputMaybe<ReportLoadBearingElementEmissionMapping_Bool_Exp>;
};


export type Query_RootReportLoadBearingElementEmissionMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReportStructureArgs = {
  distinct_on?: InputMaybe<Array<ReportStructure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructure_Order_By>>;
  where?: InputMaybe<ReportStructure_Bool_Exp>;
};


export type Query_RootReportStructureCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureCalculationTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureCalculationTypes_Order_By>>;
  where?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
};


export type Query_RootReportStructureCalculationTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureCalculationTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureCalculationTypes_Order_By>>;
  where?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
};


export type Query_RootReportStructureCalculationTypes_By_PkArgs = {
  calculationTypeId: Scalars['Int']['input'];
  reportStructureId: Scalars['uuid']['input'];
};


export type Query_RootReportStructureClassificationCodesArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureClassificationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureClassificationCodes_Order_By>>;
  where?: InputMaybe<ReportStructureClassificationCodes_Bool_Exp>;
};


export type Query_RootReportStructureClassificationCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureClassificationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureClassificationCodes_Order_By>>;
  where?: InputMaybe<ReportStructureClassificationCodes_Bool_Exp>;
};


export type Query_RootReportStructureClassificationCodes_By_PkArgs = {
  classificationCodeId: Scalars['Int']['input'];
  reportStructureId: Scalars['uuid']['input'];
};


export type Query_RootReportStructure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportStructure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructure_Order_By>>;
  where?: InputMaybe<ReportStructure_Bool_Exp>;
};


export type Query_RootReportStructure_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReportfilesmetadataArgs = {
  distinct_on?: InputMaybe<Array<Reportfilesmetadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reportfilesmetadata_Order_By>>;
  where?: InputMaybe<Reportfilesmetadata_Bool_Exp>;
};


export type Query_RootReportfilesmetadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reportfilesmetadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reportfilesmetadata_Order_By>>;
  where?: InputMaybe<Reportfilesmetadata_Bool_Exp>;
};


export type Query_RootReportfilesmetadata_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootSpecialConditionTypeArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionType_Order_By>>;
  where?: InputMaybe<SpecialConditionType_Bool_Exp>;
};


export type Query_RootSpecialConditionTypeCalculationTypeArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeCalculationType_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};


export type Query_RootSpecialConditionTypeCalculationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeCalculationType_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};


export type Query_RootSpecialConditionTypeCalculationType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSpecialConditionTypeInputParameterArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeInputParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeInputParameter_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeInputParameter_Bool_Exp>;
};


export type Query_RootSpecialConditionTypeInputParameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeInputParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeInputParameter_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeInputParameter_Bool_Exp>;
};


export type Query_RootSpecialConditionTypeInputParameter_By_PkArgs = {
  specialConditionTypeCategoryId: Scalars['uuid']['input'];
};


export type Query_RootSpecialConditionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionType_Order_By>>;
  where?: InputMaybe<SpecialConditionType_Bool_Exp>;
};


export type Query_RootSpecialConditionType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSpecial_Condition_Type_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Special_Condition_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Special_Condition_Type_Category_Order_By>>;
  where?: InputMaybe<Special_Condition_Type_Category_Bool_Exp>;
};


export type Query_RootSpecial_Condition_Type_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Special_Condition_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Special_Condition_Type_Category_Order_By>>;
  where?: InputMaybe<Special_Condition_Type_Category_Bool_Exp>;
};


export type Query_RootSpecial_Condition_Type_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSpeckleStreamModelIfcUploadArgs = {
  distinct_on?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Order_By>>;
  where?: InputMaybe<SpeckleStreamModelIfcUpload_Bool_Exp>;
};


export type Query_RootSpeckleStreamModelIfcUploadRecentArgs = {
  distinct_on?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Order_By>>;
  where?: InputMaybe<SpeckleStreamModelIfcUploadRecent_Bool_Exp>;
};


export type Query_RootSpeckleStreamModelIfcUploadRecent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Order_By>>;
  where?: InputMaybe<SpeckleStreamModelIfcUploadRecent_Bool_Exp>;
};


export type Query_RootSpeckleStreamModelIfcUpload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Order_By>>;
  where?: InputMaybe<SpeckleStreamModelIfcUpload_Bool_Exp>;
};


export type Query_RootSpeckleStreamModelIfcUpload_By_PkArgs = {
  speckleProjectId: Scalars['String']['input'];
};


export type Query_RootSpeckleUserDataArgs = {
  distinct_on?: InputMaybe<Array<SpeckleUserData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleUserData_Order_By>>;
  where?: InputMaybe<SpeckleUserData_Bool_Exp>;
};


export type Query_RootSpeckleUserData_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpeckleUserData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleUserData_Order_By>>;
  where?: InputMaybe<SpeckleUserData_Bool_Exp>;
};


export type Query_RootSpeckleUserData_By_PkArgs = {
  userId: Scalars['String']['input'];
};


export type Query_RootSpeckle_StreamArgs = {
  distinct_on?: InputMaybe<Array<Speckle_Stream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speckle_Stream_Order_By>>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};


export type Query_RootSpeckle_Stream_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speckle_Stream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speckle_Stream_Order_By>>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};


export type Query_RootSpeckle_Stream_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootStageArgs = {
  distinct_on?: InputMaybe<Array<Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Order_By>>;
  where?: InputMaybe<Stage_Bool_Exp>;
};


export type Query_RootStageDefaultEmissionArgs = {
  distinct_on?: InputMaybe<Array<StageDefaultEmission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StageDefaultEmission_Order_By>>;
  where?: InputMaybe<StageDefaultEmission_Bool_Exp>;
};


export type Query_RootStageDefaultEmission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StageDefaultEmission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StageDefaultEmission_Order_By>>;
  where?: InputMaybe<StageDefaultEmission_Bool_Exp>;
};


export type Query_RootStageDefaultEmission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Order_By>>;
  where?: InputMaybe<Stage_Bool_Exp>;
};


export type Query_RootStage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootStage_Default_Emission_Building_TypeArgs = {
  distinct_on?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Order_By>>;
  where?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
};


export type Query_RootStage_Default_Emission_Building_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Order_By>>;
  where?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
};


export type Query_RootStage_Default_Emission_Building_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTenantAiBudgetArgs = {
  distinct_on?: InputMaybe<Array<TenantAiBudget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiBudget_Order_By>>;
  where?: InputMaybe<TenantAiBudget_Bool_Exp>;
};


export type Query_RootTenantAiBudget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantAiBudget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiBudget_Order_By>>;
  where?: InputMaybe<TenantAiBudget_Bool_Exp>;
};


export type Query_RootTenantAiBudget_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTenantAiCreditPurchaseArgs = {
  distinct_on?: InputMaybe<Array<TenantAiCreditPurchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiCreditPurchase_Order_By>>;
  where?: InputMaybe<TenantAiCreditPurchase_Bool_Exp>;
};


export type Query_RootTenantAiCreditPurchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantAiCreditPurchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiCreditPurchase_Order_By>>;
  where?: InputMaybe<TenantAiCreditPurchase_Bool_Exp>;
};


export type Query_RootTenantAiCreditPurchase_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTenantAiPaymentArgs = {
  distinct_on?: InputMaybe<Array<TenantAiPayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiPayment_Order_By>>;
  where?: InputMaybe<TenantAiPayment_Bool_Exp>;
};


export type Query_RootTenantAiPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantAiPayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiPayment_Order_By>>;
  where?: InputMaybe<TenantAiPayment_Bool_Exp>;
};


export type Query_RootTenantAiPayment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTenantCollectionArgs = {
  distinct_on?: InputMaybe<Array<TenantCollection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollection_Order_By>>;
  where?: InputMaybe<TenantCollection_Bool_Exp>;
};


export type Query_RootTenantCollectionItemArgs = {
  distinct_on?: InputMaybe<Array<TenantCollectionItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollectionItem_Order_By>>;
  where?: InputMaybe<TenantCollectionItem_Bool_Exp>;
};


export type Query_RootTenantCollectionItem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantCollectionItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollectionItem_Order_By>>;
  where?: InputMaybe<TenantCollectionItem_Bool_Exp>;
};


export type Query_RootTenantCollectionItem_By_PkArgs = {
  materialInternalId: Scalars['String']['input'];
  tenantCollectionId: Scalars['uuid']['input'];
};


export type Query_RootTenantCollection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantCollection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollection_Order_By>>;
  where?: InputMaybe<TenantCollection_Bool_Exp>;
};


export type Query_RootTenantCollection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTenantInvoiceArgs = {
  distinct_on?: InputMaybe<Array<TenantInvoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantInvoice_Order_By>>;
  where?: InputMaybe<TenantInvoice_Bool_Exp>;
};


export type Query_RootTenantInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantInvoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantInvoice_Order_By>>;
  where?: InputMaybe<TenantInvoice_Bool_Exp>;
};


export type Query_RootTenantInvoice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTenantUserRequestAiUsageArgs = {
  distinct_on?: InputMaybe<Array<TenantUserRequestAiUsage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantUserRequestAiUsage_Order_By>>;
  where?: InputMaybe<TenantUserRequestAiUsage_Bool_Exp>;
};


export type Query_RootTenantUserRequestAiUsage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantUserRequestAiUsage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantUserRequestAiUsage_Order_By>>;
  where?: InputMaybe<TenantUserRequestAiUsage_Bool_Exp>;
};


export type Query_RootTenantUserRequestAiUsage_By_PkArgs = {
  requestId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootTranslationCategoryArgs = {
  distinct_on?: InputMaybe<Array<TranslationCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationCategory_Order_By>>;
  where?: InputMaybe<TranslationCategory_Bool_Exp>;
};


export type Query_RootTranslationCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TranslationCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationCategory_Order_By>>;
  where?: InputMaybe<TranslationCategory_Bool_Exp>;
};


export type Query_RootTranslationCategory_By_PkArgs = {
  id: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
};


export type Query_RootTranslationSourceArgs = {
  distinct_on?: InputMaybe<Array<TranslationSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationSource_Order_By>>;
  where?: InputMaybe<TranslationSource_Bool_Exp>;
};


export type Query_RootTranslationSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TranslationSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationSource_Order_By>>;
  where?: InputMaybe<TranslationSource_Bool_Exp>;
};


export type Query_RootTranslationSource_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTransportArgs = {
  distinct_on?: InputMaybe<Array<Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Order_By>>;
  where?: InputMaybe<Transport_Bool_Exp>;
};


export type Query_RootTransportEmissionFactorArgs = {
  distinct_on?: InputMaybe<Array<TransportEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportEmissionFactor_Order_By>>;
  where?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
};


export type Query_RootTransportEmissionFactor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransportEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportEmissionFactor_Order_By>>;
  where?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
};


export type Query_RootTransportEmissionFactor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTransportSourceArgs = {
  distinct_on?: InputMaybe<Array<TransportSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSource_Order_By>>;
  where?: InputMaybe<TransportSource_Bool_Exp>;
};


export type Query_RootTransportSourceCalculationTypeArgs = {
  distinct_on?: InputMaybe<Array<TransportSourceCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSourceCalculationType_Order_By>>;
  where?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
};


export type Query_RootTransportSourceCalculationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransportSourceCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSourceCalculationType_Order_By>>;
  where?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
};


export type Query_RootTransportSourceCalculationType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTransportSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransportSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSource_Order_By>>;
  where?: InputMaybe<TransportSource_Bool_Exp>;
};


export type Query_RootTransportSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTransport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Order_By>>;
  where?: InputMaybe<Transport_Bool_Exp>;
};


export type Query_RootTransport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTransport_Standard_ValueArgs = {
  distinct_on?: InputMaybe<Array<Transport_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Standard_Value_Order_By>>;
  where?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
};


export type Query_RootTransport_Standard_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transport_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Standard_Value_Order_By>>;
  where?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
};


export type Query_RootTransport_Standard_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTransport_TypeArgs = {
  distinct_on?: InputMaybe<Array<Transport_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Type_Order_By>>;
  where?: InputMaybe<Transport_Type_Bool_Exp>;
};


export type Query_RootTransport_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transport_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Type_Order_By>>;
  where?: InputMaybe<Transport_Type_Bool_Exp>;
};


export type Query_RootTransport_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnit_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUserMaterialFavoriteArgs = {
  distinct_on?: InputMaybe<Array<UserMaterialFavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserMaterialFavorite_Order_By>>;
  where?: InputMaybe<UserMaterialFavorite_Bool_Exp>;
};


export type Query_RootUserMaterialFavorite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserMaterialFavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserMaterialFavorite_Order_By>>;
  where?: InputMaybe<UserMaterialFavorite_Bool_Exp>;
};


export type Query_RootUserMaterialFavorite_By_PkArgs = {
  materialInternalId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootUserPlatformReviewArgs = {
  distinct_on?: InputMaybe<Array<UserPlatformReview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPlatformReview_Order_By>>;
  where?: InputMaybe<UserPlatformReview_Bool_Exp>;
};


export type Query_RootUserPlatformReview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPlatformReview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPlatformReview_Order_By>>;
  where?: InputMaybe<UserPlatformReview_Bool_Exp>;
};


export type Query_RootUserPlatformReview_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserProjectViewArgs = {
  distinct_on?: InputMaybe<Array<UserProjectView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserProjectView_Order_By>>;
  where?: InputMaybe<UserProjectView_Bool_Exp>;
};


export type Query_RootUserProjectView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserProjectView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserProjectView_Order_By>>;
  where?: InputMaybe<UserProjectView_Bool_Exp>;
};


export type Query_RootUserProjectView_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootUserTutorialViewArgs = {
  distinct_on?: InputMaybe<Array<UserTutorialView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserTutorialView_Order_By>>;
  where?: InputMaybe<UserTutorialView_Bool_Exp>;
};


export type Query_RootUserTutorialView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserTutorialView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserTutorialView_Order_By>>;
  where?: InputMaybe<UserTutorialView_Bool_Exp>;
};


export type Query_RootUserTutorialView_By_PkArgs = {
  externalId: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootUserWelcomeFlowArgs = {
  distinct_on?: InputMaybe<Array<UserWelcomeFlow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserWelcomeFlow_Order_By>>;
  where?: InputMaybe<UserWelcomeFlow_Bool_Exp>;
};


export type Query_RootUserWelcomeFlowEventArgs = {
  distinct_on?: InputMaybe<Array<UserWelcomeFlowEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserWelcomeFlowEvent_Order_By>>;
  where?: InputMaybe<UserWelcomeFlowEvent_Bool_Exp>;
};


export type Query_RootUserWelcomeFlowEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserWelcomeFlowEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserWelcomeFlowEvent_Order_By>>;
  where?: InputMaybe<UserWelcomeFlowEvent_Bool_Exp>;
};


export type Query_RootUserWelcomeFlowEvent_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserWelcomeFlow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserWelcomeFlow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserWelcomeFlow_Order_By>>;
  where?: InputMaybe<UserWelcomeFlow_Bool_Exp>;
};


export type Query_RootUserWelcomeFlow_By_PkArgs = {
  flowKey: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootVLatestSnapshotArgs = {
  distinct_on?: InputMaybe<Array<VLatestSnapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VLatestSnapshot_Order_By>>;
  where?: InputMaybe<VLatestSnapshot_Bool_Exp>;
};


export type Query_RootVLatestSnapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VLatestSnapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VLatestSnapshot_Order_By>>;
  where?: InputMaybe<VLatestSnapshot_Bool_Exp>;
};


export type Query_RootVMaterialCurrentArgs = {
  distinct_on?: InputMaybe<Array<VMaterialCurrent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialCurrent_Order_By>>;
  where?: InputMaybe<VMaterialCurrent_Bool_Exp>;
};


export type Query_RootVMaterialCurrent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VMaterialCurrent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialCurrent_Order_By>>;
  where?: InputMaybe<VMaterialCurrent_Bool_Exp>;
};


export type Query_RootVMaterialGwpArgs = {
  distinct_on?: InputMaybe<Array<VMaterialGwp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialGwp_Order_By>>;
  where?: InputMaybe<VMaterialGwp_Bool_Exp>;
};


export type Query_RootVMaterialGwp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VMaterialGwp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialGwp_Order_By>>;
  where?: InputMaybe<VMaterialGwp_Bool_Exp>;
};


export type Query_RootVMaterialStatusArgs = {
  distinct_on?: InputMaybe<Array<VMaterialStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialStatus_Order_By>>;
  where?: InputMaybe<VMaterialStatus_Bool_Exp>;
};


export type Query_RootVMaterialStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VMaterialStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialStatus_Order_By>>;
  where?: InputMaybe<VMaterialStatus_Bool_Exp>;
};


export type Query_RootVProjectIntensityArgs = {
  distinct_on?: InputMaybe<Array<VProjectIntensity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VProjectIntensity_Order_By>>;
  where?: InputMaybe<VProjectIntensity_Bool_Exp>;
};


export type Query_RootVProjectIntensity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VProjectIntensity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VProjectIntensity_Order_By>>;
  where?: InputMaybe<VProjectIntensity_Bool_Exp>;
};


export type Query_RootWeightPerDeclaredUnitArgs = {
  distinct_on?: InputMaybe<Array<WeightPerDeclaredUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<WeightPerDeclaredUnit_Order_By>>;
  where?: InputMaybe<WeightPerDeclaredUnit_Bool_Exp>;
};


export type Query_RootWeightPerDeclaredUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WeightPerDeclaredUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<WeightPerDeclaredUnit_Order_By>>;
  where?: InputMaybe<WeightPerDeclaredUnit_Bool_Exp>;
};


export type Query_RootWeightPerDeclaredUnit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "reference_area_type" */
export type ReferenceAreaType = {
  __typename?: 'referenceAreaType';
  /** An array relationship */
  calculationTypeMappings: Array<ReferenceAreaTypeCalculationTypeMapping>;
  /** An aggregate relationship */
  calculationTypeMappings_aggregate: ReferenceAreaTypeCalculationTypeMapping_Aggregate;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  multiplier?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "reference_area_type" */
export type ReferenceAreaTypeCalculationTypeMappingsArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Order_By>>;
  where?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
};


/** columns and relationships of "reference_area_type" */
export type ReferenceAreaTypeCalculationTypeMappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Order_By>>;
  where?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
};

/** columns and relationships of "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping';
  /** An object relationship */
  calculationType: CalculationType;
  calculationTypeId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  referenceAreaType: ReferenceAreaType;
  referenceAreaTypeId: Scalars['Int']['output'];
};

/** aggregated selection of "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Aggregate = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_aggregate';
  aggregate?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Aggregate_Fields>;
  nodes: Array<ReferenceAreaTypeCalculationTypeMapping>;
};

export type ReferenceAreaTypeCalculationTypeMapping_Aggregate_Bool_Exp = {
  count?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Aggregate_Bool_Exp_Count>;
};

export type ReferenceAreaTypeCalculationTypeMapping_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Aggregate_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_aggregate_fields';
  avg?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Max_Fields>;
  min?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Min_Fields>;
  stddev?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Stddev_Fields>;
  stddev_pop?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Stddev_Samp_Fields>;
  sum?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Sum_Fields>;
  var_pop?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Var_Pop_Fields>;
  var_samp?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Var_Samp_Fields>;
  variance?: Maybe<ReferenceAreaTypeCalculationTypeMapping_Variance_Fields>;
};


/** aggregate fields of "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Aggregate_Order_By = {
  avg?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Max_Order_By>;
  min?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Min_Order_By>;
  stddev?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Sum_Order_By>;
  var_pop?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Var_Samp_Order_By>;
  variance?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Arr_Rel_Insert_Input = {
  data: Array<ReferenceAreaTypeCalculationTypeMapping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_On_Conflict>;
};

/** aggregate avg on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Avg_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_avg_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Avg_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reference_area_type_calculation_type_mapping". All fields are combined with a logical 'AND'. */
export type ReferenceAreaTypeCalculationTypeMapping_Bool_Exp = {
  _and?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>>;
  _not?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
  _or?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>>;
  calculationType?: InputMaybe<CalculationType_Bool_Exp>;
  calculationTypeId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  referenceAreaType?: InputMaybe<ReferenceAreaType_Bool_Exp>;
  referenceAreaTypeId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "reference_area_type_calculation_type_mapping" */
export enum ReferenceAreaTypeCalculationTypeMapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  reference_area_type_calculation_type_mapping_pkey = 'reference_area_type_calculation_type_mapping_pkey'
}

/** input type for incrementing numeric columns in table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Inc_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Insert_Input = {
  calculationType?: InputMaybe<CalculationType_Obj_Rel_Insert_Input>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  referenceAreaType?: InputMaybe<ReferenceAreaType_Obj_Rel_Insert_Input>;
  referenceAreaTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Max_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_max_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Max_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Min_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_min_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Min_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Mutation_Response = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReferenceAreaTypeCalculationTypeMapping>;
};

/** on_conflict condition type for table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_On_Conflict = {
  constraint: ReferenceAreaTypeCalculationTypeMapping_Constraint;
  update_columns?: Array<ReferenceAreaTypeCalculationTypeMapping_Update_Column>;
  where?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
};

/** Ordering options when selecting data from "reference_area_type_calculation_type_mapping". */
export type ReferenceAreaTypeCalculationTypeMapping_Order_By = {
  calculationType?: InputMaybe<CalculationType_Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referenceAreaType?: InputMaybe<ReferenceAreaType_Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reference_area_type_calculation_type_mapping */
export type ReferenceAreaTypeCalculationTypeMapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reference_area_type_calculation_type_mapping" */
export enum ReferenceAreaTypeCalculationTypeMapping_Select_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  referenceAreaTypeId = 'referenceAreaTypeId'
}

/** input type for updating data in table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Set_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  referenceAreaTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Stddev_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_stddev_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Stddev_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Stddev_Pop_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_stddev_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Stddev_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Stddev_Samp_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_stddev_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Stddev_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "referenceAreaTypeCalculationTypeMapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReferenceAreaTypeCalculationTypeMapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReferenceAreaTypeCalculationTypeMapping_Stream_Cursor_Value_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  referenceAreaTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Sum_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_sum_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Sum_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "reference_area_type_calculation_type_mapping" */
export enum ReferenceAreaTypeCalculationTypeMapping_Update_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  referenceAreaTypeId = 'referenceAreaTypeId'
}

export type ReferenceAreaTypeCalculationTypeMapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReferenceAreaTypeCalculationTypeMapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Var_Pop_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_var_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Var_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Var_Samp_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_var_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Var_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ReferenceAreaTypeCalculationTypeMapping_Variance_Fields = {
  __typename?: 'referenceAreaTypeCalculationTypeMapping_variance_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
  referenceAreaTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reference_area_type_calculation_type_mapping" */
export type ReferenceAreaTypeCalculationTypeMapping_Variance_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  referenceAreaTypeId?: InputMaybe<Order_By>;
};

/** aggregated selection of "reference_area_type" */
export type ReferenceAreaType_Aggregate = {
  __typename?: 'referenceAreaType_aggregate';
  aggregate?: Maybe<ReferenceAreaType_Aggregate_Fields>;
  nodes: Array<ReferenceAreaType>;
};

/** aggregate fields of "reference_area_type" */
export type ReferenceAreaType_Aggregate_Fields = {
  __typename?: 'referenceAreaType_aggregate_fields';
  avg?: Maybe<ReferenceAreaType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReferenceAreaType_Max_Fields>;
  min?: Maybe<ReferenceAreaType_Min_Fields>;
  stddev?: Maybe<ReferenceAreaType_Stddev_Fields>;
  stddev_pop?: Maybe<ReferenceAreaType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReferenceAreaType_Stddev_Samp_Fields>;
  sum?: Maybe<ReferenceAreaType_Sum_Fields>;
  var_pop?: Maybe<ReferenceAreaType_Var_Pop_Fields>;
  var_samp?: Maybe<ReferenceAreaType_Var_Samp_Fields>;
  variance?: Maybe<ReferenceAreaType_Variance_Fields>;
};


/** aggregate fields of "reference_area_type" */
export type ReferenceAreaType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReferenceAreaType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ReferenceAreaType_Avg_Fields = {
  __typename?: 'referenceAreaType_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reference_area_type". All fields are combined with a logical 'AND'. */
export type ReferenceAreaType_Bool_Exp = {
  _and?: InputMaybe<Array<ReferenceAreaType_Bool_Exp>>;
  _not?: InputMaybe<ReferenceAreaType_Bool_Exp>;
  _or?: InputMaybe<Array<ReferenceAreaType_Bool_Exp>>;
  calculationTypeMappings?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
  calculationTypeMappings_aggregate?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  multiplier?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "reference_area_type" */
export enum ReferenceAreaType_Constraint {
  /** unique or primary key constraint on columns "id" */
  reference_area_pkey = 'reference_area_pkey',
  /** unique or primary key constraint on columns "key" */
  reference_area_type_unique_key = 'reference_area_type_unique_key'
}

/** input type for incrementing numeric columns in table "reference_area_type" */
export type ReferenceAreaType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "reference_area_type" */
export type ReferenceAreaType_Insert_Input = {
  calculationTypeMappings?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type ReferenceAreaType_Max_Fields = {
  __typename?: 'referenceAreaType_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type ReferenceAreaType_Min_Fields = {
  __typename?: 'referenceAreaType_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "reference_area_type" */
export type ReferenceAreaType_Mutation_Response = {
  __typename?: 'referenceAreaType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReferenceAreaType>;
};

/** input type for inserting object relation for remote table "reference_area_type" */
export type ReferenceAreaType_Obj_Rel_Insert_Input = {
  data: ReferenceAreaType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ReferenceAreaType_On_Conflict>;
};

/** on_conflict condition type for table "reference_area_type" */
export type ReferenceAreaType_On_Conflict = {
  constraint: ReferenceAreaType_Constraint;
  update_columns?: Array<ReferenceAreaType_Update_Column>;
  where?: InputMaybe<ReferenceAreaType_Bool_Exp>;
};

/** Ordering options when selecting data from "reference_area_type". */
export type ReferenceAreaType_Order_By = {
  calculationTypeMappings_aggregate?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reference_area_type */
export type ReferenceAreaType_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "reference_area_type" */
export enum ReferenceAreaType_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  key = 'key',
  /** column name */
  label = 'label',
  /** column name */
  multiplier = 'multiplier'
}

/** input type for updating data in table "reference_area_type" */
export type ReferenceAreaType_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type ReferenceAreaType_Stddev_Fields = {
  __typename?: 'referenceAreaType_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ReferenceAreaType_Stddev_Pop_Fields = {
  __typename?: 'referenceAreaType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ReferenceAreaType_Stddev_Samp_Fields = {
  __typename?: 'referenceAreaType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "referenceAreaType" */
export type ReferenceAreaType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReferenceAreaType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReferenceAreaType_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type ReferenceAreaType_Sum_Fields = {
  __typename?: 'referenceAreaType_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  multiplier?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "reference_area_type" */
export enum ReferenceAreaType_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  key = 'key',
  /** column name */
  label = 'label',
  /** column name */
  multiplier = 'multiplier'
}

export type ReferenceAreaType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReferenceAreaType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReferenceAreaType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReferenceAreaType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ReferenceAreaType_Var_Pop_Fields = {
  __typename?: 'referenceAreaType_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ReferenceAreaType_Var_Samp_Fields = {
  __typename?: 'referenceAreaType_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ReferenceAreaType_Variance_Fields = {
  __typename?: 'referenceAreaType_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "report_building_type_mapping" */
export type ReportBuildingTypeMapping = {
  __typename?: 'reportBuildingTypeMapping';
  /** An object relationship */
  buildingType: BuildingType;
  buildingTypeId: Scalars['Int']['output'];
  country: Country_Enum;
  id: Scalars['uuid']['output'];
  reportBuildingTypeLabel: Scalars['String']['output'];
};

/** aggregated selection of "report_building_type_mapping" */
export type ReportBuildingTypeMapping_Aggregate = {
  __typename?: 'reportBuildingTypeMapping_aggregate';
  aggregate?: Maybe<ReportBuildingTypeMapping_Aggregate_Fields>;
  nodes: Array<ReportBuildingTypeMapping>;
};

/** aggregate fields of "report_building_type_mapping" */
export type ReportBuildingTypeMapping_Aggregate_Fields = {
  __typename?: 'reportBuildingTypeMapping_aggregate_fields';
  avg?: Maybe<ReportBuildingTypeMapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReportBuildingTypeMapping_Max_Fields>;
  min?: Maybe<ReportBuildingTypeMapping_Min_Fields>;
  stddev?: Maybe<ReportBuildingTypeMapping_Stddev_Fields>;
  stddev_pop?: Maybe<ReportBuildingTypeMapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReportBuildingTypeMapping_Stddev_Samp_Fields>;
  sum?: Maybe<ReportBuildingTypeMapping_Sum_Fields>;
  var_pop?: Maybe<ReportBuildingTypeMapping_Var_Pop_Fields>;
  var_samp?: Maybe<ReportBuildingTypeMapping_Var_Samp_Fields>;
  variance?: Maybe<ReportBuildingTypeMapping_Variance_Fields>;
};


/** aggregate fields of "report_building_type_mapping" */
export type ReportBuildingTypeMapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReportBuildingTypeMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ReportBuildingTypeMapping_Avg_Fields = {
  __typename?: 'reportBuildingTypeMapping_avg_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "report_building_type_mapping". All fields are combined with a logical 'AND'. */
export type ReportBuildingTypeMapping_Bool_Exp = {
  _and?: InputMaybe<Array<ReportBuildingTypeMapping_Bool_Exp>>;
  _not?: InputMaybe<ReportBuildingTypeMapping_Bool_Exp>;
  _or?: InputMaybe<Array<ReportBuildingTypeMapping_Bool_Exp>>;
  buildingType?: InputMaybe<BuildingType_Bool_Exp>;
  buildingTypeId?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  reportBuildingTypeLabel?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_building_type_mapping" */
export enum ReportBuildingTypeMapping_Constraint {
  /** unique or primary key constraint on columns "report_building_type_label", "country", "building_type_id" */
  report_building_type_mapping_building_type_id_country_report_bu = 'report_building_type_mapping_building_type_id_country_report_bu',
  /** unique or primary key constraint on columns "id" */
  report_building_type_mapping_id_key = 'report_building_type_mapping_id_key',
  /** unique or primary key constraint on columns "building_type_id" */
  report_building_type_mapping_pkey = 'report_building_type_mapping_pkey'
}

/** input type for incrementing numeric columns in table "report_building_type_mapping" */
export type ReportBuildingTypeMapping_Inc_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "report_building_type_mapping" */
export type ReportBuildingTypeMapping_Insert_Input = {
  buildingType?: InputMaybe<BuildingType_Obj_Rel_Insert_Input>;
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reportBuildingTypeLabel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ReportBuildingTypeMapping_Max_Fields = {
  __typename?: 'reportBuildingTypeMapping_max_fields';
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  reportBuildingTypeLabel?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ReportBuildingTypeMapping_Min_Fields = {
  __typename?: 'reportBuildingTypeMapping_min_fields';
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  reportBuildingTypeLabel?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "report_building_type_mapping" */
export type ReportBuildingTypeMapping_Mutation_Response = {
  __typename?: 'reportBuildingTypeMapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportBuildingTypeMapping>;
};

/** on_conflict condition type for table "report_building_type_mapping" */
export type ReportBuildingTypeMapping_On_Conflict = {
  constraint: ReportBuildingTypeMapping_Constraint;
  update_columns?: Array<ReportBuildingTypeMapping_Update_Column>;
  where?: InputMaybe<ReportBuildingTypeMapping_Bool_Exp>;
};

/** Ordering options when selecting data from "report_building_type_mapping". */
export type ReportBuildingTypeMapping_Order_By = {
  buildingType?: InputMaybe<BuildingType_Order_By>;
  buildingTypeId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reportBuildingTypeLabel?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report_building_type_mapping */
export type ReportBuildingTypeMapping_Pk_Columns_Input = {
  buildingTypeId: Scalars['Int']['input'];
};

/** select columns of table "report_building_type_mapping" */
export enum ReportBuildingTypeMapping_Select_Column {
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  reportBuildingTypeLabel = 'reportBuildingTypeLabel'
}

/** input type for updating data in table "report_building_type_mapping" */
export type ReportBuildingTypeMapping_Set_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reportBuildingTypeLabel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ReportBuildingTypeMapping_Stddev_Fields = {
  __typename?: 'reportBuildingTypeMapping_stddev_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ReportBuildingTypeMapping_Stddev_Pop_Fields = {
  __typename?: 'reportBuildingTypeMapping_stddev_pop_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ReportBuildingTypeMapping_Stddev_Samp_Fields = {
  __typename?: 'reportBuildingTypeMapping_stddev_samp_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportBuildingTypeMapping" */
export type ReportBuildingTypeMapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReportBuildingTypeMapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportBuildingTypeMapping_Stream_Cursor_Value_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reportBuildingTypeLabel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ReportBuildingTypeMapping_Sum_Fields = {
  __typename?: 'reportBuildingTypeMapping_sum_fields';
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "report_building_type_mapping" */
export enum ReportBuildingTypeMapping_Update_Column {
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  reportBuildingTypeLabel = 'reportBuildingTypeLabel'
}

export type ReportBuildingTypeMapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReportBuildingTypeMapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportBuildingTypeMapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReportBuildingTypeMapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ReportBuildingTypeMapping_Var_Pop_Fields = {
  __typename?: 'reportBuildingTypeMapping_var_pop_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ReportBuildingTypeMapping_Var_Samp_Fields = {
  __typename?: 'reportBuildingTypeMapping_var_samp_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ReportBuildingTypeMapping_Variance_Fields = {
  __typename?: 'reportBuildingTypeMapping_variance_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "report_classification_code_emission_mapping" */
export type ReportClassificationCodeEmissionMapping = {
  __typename?: 'reportClassificationCodeEmissionMapping';
  classificationCodeId: Scalars['Int']['output'];
  country: Country_Enum;
  epdProductIndustryId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
};

/** aggregated selection of "report_classification_code_emission_mapping" */
export type ReportClassificationCodeEmissionMapping_Aggregate = {
  __typename?: 'reportClassificationCodeEmissionMapping_aggregate';
  aggregate?: Maybe<ReportClassificationCodeEmissionMapping_Aggregate_Fields>;
  nodes: Array<ReportClassificationCodeEmissionMapping>;
};

/** aggregate fields of "report_classification_code_emission_mapping" */
export type ReportClassificationCodeEmissionMapping_Aggregate_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_aggregate_fields';
  avg?: Maybe<ReportClassificationCodeEmissionMapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReportClassificationCodeEmissionMapping_Max_Fields>;
  min?: Maybe<ReportClassificationCodeEmissionMapping_Min_Fields>;
  stddev?: Maybe<ReportClassificationCodeEmissionMapping_Stddev_Fields>;
  stddev_pop?: Maybe<ReportClassificationCodeEmissionMapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReportClassificationCodeEmissionMapping_Stddev_Samp_Fields>;
  sum?: Maybe<ReportClassificationCodeEmissionMapping_Sum_Fields>;
  var_pop?: Maybe<ReportClassificationCodeEmissionMapping_Var_Pop_Fields>;
  var_samp?: Maybe<ReportClassificationCodeEmissionMapping_Var_Samp_Fields>;
  variance?: Maybe<ReportClassificationCodeEmissionMapping_Variance_Fields>;
};


/** aggregate fields of "report_classification_code_emission_mapping" */
export type ReportClassificationCodeEmissionMapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ReportClassificationCodeEmissionMapping_Avg_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_avg_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "report_classification_code_emission_mapping". All fields are combined with a logical 'AND'. */
export type ReportClassificationCodeEmissionMapping_Bool_Exp = {
  _and?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Bool_Exp>>;
  _not?: InputMaybe<ReportClassificationCodeEmissionMapping_Bool_Exp>;
  _or?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Bool_Exp>>;
  classificationCodeId?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  epdProductIndustryId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_classification_code_emission_mapping" */
export enum ReportClassificationCodeEmissionMapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  report_classification_code_emission_mapping_pkey = 'report_classification_code_emission_mapping_pkey'
}

/** input type for incrementing numeric columns in table "report_classification_code_emission_mapping" */
export type ReportClassificationCodeEmissionMapping_Inc_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "report_classification_code_emission_mapping" */
export type ReportClassificationCodeEmissionMapping_Insert_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ReportClassificationCodeEmissionMapping_Max_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_max_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ReportClassificationCodeEmissionMapping_Min_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_min_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "report_classification_code_emission_mapping" */
export type ReportClassificationCodeEmissionMapping_Mutation_Response = {
  __typename?: 'reportClassificationCodeEmissionMapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportClassificationCodeEmissionMapping>;
};

/** on_conflict condition type for table "report_classification_code_emission_mapping" */
export type ReportClassificationCodeEmissionMapping_On_Conflict = {
  constraint: ReportClassificationCodeEmissionMapping_Constraint;
  update_columns?: Array<ReportClassificationCodeEmissionMapping_Update_Column>;
  where?: InputMaybe<ReportClassificationCodeEmissionMapping_Bool_Exp>;
};

/** Ordering options when selecting data from "report_classification_code_emission_mapping". */
export type ReportClassificationCodeEmissionMapping_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  epdProductIndustryId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report_classification_code_emission_mapping */
export type ReportClassificationCodeEmissionMapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "report_classification_code_emission_mapping" */
export enum ReportClassificationCodeEmissionMapping_Select_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  country = 'country',
  /** column name */
  epdProductIndustryId = 'epdProductIndustryId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

/** input type for updating data in table "report_classification_code_emission_mapping" */
export type ReportClassificationCodeEmissionMapping_Set_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ReportClassificationCodeEmissionMapping_Stddev_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_stddev_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ReportClassificationCodeEmissionMapping_Stddev_Pop_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_stddev_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ReportClassificationCodeEmissionMapping_Stddev_Samp_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_stddev_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportClassificationCodeEmissionMapping" */
export type ReportClassificationCodeEmissionMapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReportClassificationCodeEmissionMapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportClassificationCodeEmissionMapping_Stream_Cursor_Value_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ReportClassificationCodeEmissionMapping_Sum_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_sum_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "report_classification_code_emission_mapping" */
export enum ReportClassificationCodeEmissionMapping_Update_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  country = 'country',
  /** column name */
  epdProductIndustryId = 'epdProductIndustryId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

export type ReportClassificationCodeEmissionMapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReportClassificationCodeEmissionMapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportClassificationCodeEmissionMapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReportClassificationCodeEmissionMapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ReportClassificationCodeEmissionMapping_Var_Pop_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_var_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ReportClassificationCodeEmissionMapping_Var_Samp_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_var_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ReportClassificationCodeEmissionMapping_Variance_Fields = {
  __typename?: 'reportClassificationCodeEmissionMapping_variance_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "report_load_bearing_element_amount_mapping" */
export type ReportLoadBearingElementAmountMapping = {
  __typename?: 'reportLoadBearingElementAmountMapping';
  categoryId?: Maybe<Scalars['String']['output']>;
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  country: Country_Enum;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
};

/** aggregated selection of "report_load_bearing_element_amount_mapping" */
export type ReportLoadBearingElementAmountMapping_Aggregate = {
  __typename?: 'reportLoadBearingElementAmountMapping_aggregate';
  aggregate?: Maybe<ReportLoadBearingElementAmountMapping_Aggregate_Fields>;
  nodes: Array<ReportLoadBearingElementAmountMapping>;
};

/** aggregate fields of "report_load_bearing_element_amount_mapping" */
export type ReportLoadBearingElementAmountMapping_Aggregate_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_aggregate_fields';
  avg?: Maybe<ReportLoadBearingElementAmountMapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReportLoadBearingElementAmountMapping_Max_Fields>;
  min?: Maybe<ReportLoadBearingElementAmountMapping_Min_Fields>;
  stddev?: Maybe<ReportLoadBearingElementAmountMapping_Stddev_Fields>;
  stddev_pop?: Maybe<ReportLoadBearingElementAmountMapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReportLoadBearingElementAmountMapping_Stddev_Samp_Fields>;
  sum?: Maybe<ReportLoadBearingElementAmountMapping_Sum_Fields>;
  var_pop?: Maybe<ReportLoadBearingElementAmountMapping_Var_Pop_Fields>;
  var_samp?: Maybe<ReportLoadBearingElementAmountMapping_Var_Samp_Fields>;
  variance?: Maybe<ReportLoadBearingElementAmountMapping_Variance_Fields>;
};


/** aggregate fields of "report_load_bearing_element_amount_mapping" */
export type ReportLoadBearingElementAmountMapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ReportLoadBearingElementAmountMapping_Avg_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_avg_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "report_load_bearing_element_amount_mapping". All fields are combined with a logical 'AND'. */
export type ReportLoadBearingElementAmountMapping_Bool_Exp = {
  _and?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Bool_Exp>>;
  _not?: InputMaybe<ReportLoadBearingElementAmountMapping_Bool_Exp>;
  _or?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  classificationCodeId?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_load_bearing_element_amount_mapping" */
export enum ReportLoadBearingElementAmountMapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  report_load_bearing_element_mapping_pkey = 'report_load_bearing_element_mapping_pkey'
}

/** input type for incrementing numeric columns in table "report_load_bearing_element_amount_mapping" */
export type ReportLoadBearingElementAmountMapping_Inc_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "report_load_bearing_element_amount_mapping" */
export type ReportLoadBearingElementAmountMapping_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ReportLoadBearingElementAmountMapping_Max_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_max_fields';
  categoryId?: Maybe<Scalars['String']['output']>;
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ReportLoadBearingElementAmountMapping_Min_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_min_fields';
  categoryId?: Maybe<Scalars['String']['output']>;
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "report_load_bearing_element_amount_mapping" */
export type ReportLoadBearingElementAmountMapping_Mutation_Response = {
  __typename?: 'reportLoadBearingElementAmountMapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportLoadBearingElementAmountMapping>;
};

/** on_conflict condition type for table "report_load_bearing_element_amount_mapping" */
export type ReportLoadBearingElementAmountMapping_On_Conflict = {
  constraint: ReportLoadBearingElementAmountMapping_Constraint;
  update_columns?: Array<ReportLoadBearingElementAmountMapping_Update_Column>;
  where?: InputMaybe<ReportLoadBearingElementAmountMapping_Bool_Exp>;
};

/** Ordering options when selecting data from "report_load_bearing_element_amount_mapping". */
export type ReportLoadBearingElementAmountMapping_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  classificationCodeId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report_load_bearing_element_amount_mapping */
export type ReportLoadBearingElementAmountMapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "report_load_bearing_element_amount_mapping" */
export enum ReportLoadBearingElementAmountMapping_Select_Column {
  /** column name */
  categoryId = 'categoryId',
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

/** input type for updating data in table "report_load_bearing_element_amount_mapping" */
export type ReportLoadBearingElementAmountMapping_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ReportLoadBearingElementAmountMapping_Stddev_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_stddev_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ReportLoadBearingElementAmountMapping_Stddev_Pop_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_stddev_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ReportLoadBearingElementAmountMapping_Stddev_Samp_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_stddev_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportLoadBearingElementAmountMapping" */
export type ReportLoadBearingElementAmountMapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReportLoadBearingElementAmountMapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportLoadBearingElementAmountMapping_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ReportLoadBearingElementAmountMapping_Sum_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_sum_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "report_load_bearing_element_amount_mapping" */
export enum ReportLoadBearingElementAmountMapping_Update_Column {
  /** column name */
  categoryId = 'categoryId',
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  country = 'country',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

export type ReportLoadBearingElementAmountMapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReportLoadBearingElementAmountMapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportLoadBearingElementAmountMapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReportLoadBearingElementAmountMapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ReportLoadBearingElementAmountMapping_Var_Pop_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_var_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ReportLoadBearingElementAmountMapping_Var_Samp_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_var_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ReportLoadBearingElementAmountMapping_Variance_Fields = {
  __typename?: 'reportLoadBearingElementAmountMapping_variance_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "report_load_bearing_element_emission_mapping" */
export type ReportLoadBearingElementEmissionMapping = {
  __typename?: 'reportLoadBearingElementEmissionMapping';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  country: Country_Enum;
  epdProductIndustryId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
};

/** aggregated selection of "report_load_bearing_element_emission_mapping" */
export type ReportLoadBearingElementEmissionMapping_Aggregate = {
  __typename?: 'reportLoadBearingElementEmissionMapping_aggregate';
  aggregate?: Maybe<ReportLoadBearingElementEmissionMapping_Aggregate_Fields>;
  nodes: Array<ReportLoadBearingElementEmissionMapping>;
};

/** aggregate fields of "report_load_bearing_element_emission_mapping" */
export type ReportLoadBearingElementEmissionMapping_Aggregate_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_aggregate_fields';
  avg?: Maybe<ReportLoadBearingElementEmissionMapping_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReportLoadBearingElementEmissionMapping_Max_Fields>;
  min?: Maybe<ReportLoadBearingElementEmissionMapping_Min_Fields>;
  stddev?: Maybe<ReportLoadBearingElementEmissionMapping_Stddev_Fields>;
  stddev_pop?: Maybe<ReportLoadBearingElementEmissionMapping_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReportLoadBearingElementEmissionMapping_Stddev_Samp_Fields>;
  sum?: Maybe<ReportLoadBearingElementEmissionMapping_Sum_Fields>;
  var_pop?: Maybe<ReportLoadBearingElementEmissionMapping_Var_Pop_Fields>;
  var_samp?: Maybe<ReportLoadBearingElementEmissionMapping_Var_Samp_Fields>;
  variance?: Maybe<ReportLoadBearingElementEmissionMapping_Variance_Fields>;
};


/** aggregate fields of "report_load_bearing_element_emission_mapping" */
export type ReportLoadBearingElementEmissionMapping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ReportLoadBearingElementEmissionMapping_Avg_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_avg_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "report_load_bearing_element_emission_mapping". All fields are combined with a logical 'AND'. */
export type ReportLoadBearingElementEmissionMapping_Bool_Exp = {
  _and?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Bool_Exp>>;
  _not?: InputMaybe<ReportLoadBearingElementEmissionMapping_Bool_Exp>;
  _or?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Bool_Exp>>;
  classificationCodeId?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  epdProductIndustryId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_load_bearing_element_emission_mapping" */
export enum ReportLoadBearingElementEmissionMapping_Constraint {
  /** unique or primary key constraint on columns "id" */
  report_load_bearing_element_emission_mapping_pkey = 'report_load_bearing_element_emission_mapping_pkey'
}

/** input type for incrementing numeric columns in table "report_load_bearing_element_emission_mapping" */
export type ReportLoadBearingElementEmissionMapping_Inc_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "report_load_bearing_element_emission_mapping" */
export type ReportLoadBearingElementEmissionMapping_Insert_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ReportLoadBearingElementEmissionMapping_Max_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_max_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ReportLoadBearingElementEmissionMapping_Min_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_min_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "report_load_bearing_element_emission_mapping" */
export type ReportLoadBearingElementEmissionMapping_Mutation_Response = {
  __typename?: 'reportLoadBearingElementEmissionMapping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportLoadBearingElementEmissionMapping>;
};

/** on_conflict condition type for table "report_load_bearing_element_emission_mapping" */
export type ReportLoadBearingElementEmissionMapping_On_Conflict = {
  constraint: ReportLoadBearingElementEmissionMapping_Constraint;
  update_columns?: Array<ReportLoadBearingElementEmissionMapping_Update_Column>;
  where?: InputMaybe<ReportLoadBearingElementEmissionMapping_Bool_Exp>;
};

/** Ordering options when selecting data from "report_load_bearing_element_emission_mapping". */
export type ReportLoadBearingElementEmissionMapping_Order_By = {
  classificationCodeId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  epdProductIndustryId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report_load_bearing_element_emission_mapping */
export type ReportLoadBearingElementEmissionMapping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "report_load_bearing_element_emission_mapping" */
export enum ReportLoadBearingElementEmissionMapping_Select_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  country = 'country',
  /** column name */
  epdProductIndustryId = 'epdProductIndustryId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

/** input type for updating data in table "report_load_bearing_element_emission_mapping" */
export type ReportLoadBearingElementEmissionMapping_Set_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ReportLoadBearingElementEmissionMapping_Stddev_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_stddev_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ReportLoadBearingElementEmissionMapping_Stddev_Pop_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_stddev_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ReportLoadBearingElementEmissionMapping_Stddev_Samp_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_stddev_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportLoadBearingElementEmissionMapping" */
export type ReportLoadBearingElementEmissionMapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReportLoadBearingElementEmissionMapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportLoadBearingElementEmissionMapping_Stream_Cursor_Value_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Country_Enum>;
  epdProductIndustryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ReportLoadBearingElementEmissionMapping_Sum_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_sum_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "report_load_bearing_element_emission_mapping" */
export enum ReportLoadBearingElementEmissionMapping_Update_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  country = 'country',
  /** column name */
  epdProductIndustryId = 'epdProductIndustryId',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

export type ReportLoadBearingElementEmissionMapping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReportLoadBearingElementEmissionMapping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportLoadBearingElementEmissionMapping_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReportLoadBearingElementEmissionMapping_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ReportLoadBearingElementEmissionMapping_Var_Pop_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_var_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ReportLoadBearingElementEmissionMapping_Var_Samp_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_var_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ReportLoadBearingElementEmissionMapping_Variance_Fields = {
  __typename?: 'reportLoadBearingElementEmissionMapping_variance_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
  epdProductIndustryId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "report_structure" */
export type ReportStructure = {
  __typename?: 'reportStructure';
  buildingElement: Scalars['String']['output'];
  buildingElementExamples?: Maybe<Scalars['String']['output']>;
  buildingElementMainGroup?: Maybe<Scalars['String']['output']>;
  buildingElementSubGroup?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  calculationTypes: Array<ReportStructureCalculationTypes>;
  /** An aggregate relationship */
  calculationTypes_aggregate: ReportStructureCalculationTypes_Aggregate;
  category: Scalars['String']['output'];
  detailLevel?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  sortIndex: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};


/** columns and relationships of "report_structure" */
export type ReportStructureCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureCalculationTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureCalculationTypes_Order_By>>;
  where?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
};


/** columns and relationships of "report_structure" */
export type ReportStructureCalculationTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureCalculationTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureCalculationTypes_Order_By>>;
  where?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
};

/** columns and relationships of "report_structure_calculation_types" */
export type ReportStructureCalculationTypes = {
  __typename?: 'reportStructureCalculationTypes';
  calculationTypeId: Scalars['Int']['output'];
  reportStructureId: Scalars['uuid']['output'];
};

/** aggregated selection of "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Aggregate = {
  __typename?: 'reportStructureCalculationTypes_aggregate';
  aggregate?: Maybe<ReportStructureCalculationTypes_Aggregate_Fields>;
  nodes: Array<ReportStructureCalculationTypes>;
};

export type ReportStructureCalculationTypes_Aggregate_Bool_Exp = {
  count?: InputMaybe<ReportStructureCalculationTypes_Aggregate_Bool_Exp_Count>;
};

export type ReportStructureCalculationTypes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ReportStructureCalculationTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Aggregate_Fields = {
  __typename?: 'reportStructureCalculationTypes_aggregate_fields';
  avg?: Maybe<ReportStructureCalculationTypes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReportStructureCalculationTypes_Max_Fields>;
  min?: Maybe<ReportStructureCalculationTypes_Min_Fields>;
  stddev?: Maybe<ReportStructureCalculationTypes_Stddev_Fields>;
  stddev_pop?: Maybe<ReportStructureCalculationTypes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReportStructureCalculationTypes_Stddev_Samp_Fields>;
  sum?: Maybe<ReportStructureCalculationTypes_Sum_Fields>;
  var_pop?: Maybe<ReportStructureCalculationTypes_Var_Pop_Fields>;
  var_samp?: Maybe<ReportStructureCalculationTypes_Var_Samp_Fields>;
  variance?: Maybe<ReportStructureCalculationTypes_Variance_Fields>;
};


/** aggregate fields of "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReportStructureCalculationTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Aggregate_Order_By = {
  avg?: InputMaybe<ReportStructureCalculationTypes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ReportStructureCalculationTypes_Max_Order_By>;
  min?: InputMaybe<ReportStructureCalculationTypes_Min_Order_By>;
  stddev?: InputMaybe<ReportStructureCalculationTypes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ReportStructureCalculationTypes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ReportStructureCalculationTypes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ReportStructureCalculationTypes_Sum_Order_By>;
  var_pop?: InputMaybe<ReportStructureCalculationTypes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ReportStructureCalculationTypes_Var_Samp_Order_By>;
  variance?: InputMaybe<ReportStructureCalculationTypes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Arr_Rel_Insert_Input = {
  data: Array<ReportStructureCalculationTypes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ReportStructureCalculationTypes_On_Conflict>;
};

/** aggregate avg on columns */
export type ReportStructureCalculationTypes_Avg_Fields = {
  __typename?: 'reportStructureCalculationTypes_avg_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Avg_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "report_structure_calculation_types". All fields are combined with a logical 'AND'. */
export type ReportStructureCalculationTypes_Bool_Exp = {
  _and?: InputMaybe<Array<ReportStructureCalculationTypes_Bool_Exp>>;
  _not?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
  _or?: InputMaybe<Array<ReportStructureCalculationTypes_Bool_Exp>>;
  calculationTypeId?: InputMaybe<Int_Comparison_Exp>;
  reportStructureId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_structure_calculation_types" */
export enum ReportStructureCalculationTypes_Constraint {
  /** unique or primary key constraint on columns "report_structure_id", "calculation_type_id" */
  report_structure_calculation_types_pkey = 'report_structure_calculation_types_pkey'
}

/** input type for incrementing numeric columns in table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Inc_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Insert_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  reportStructureId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ReportStructureCalculationTypes_Max_Fields = {
  __typename?: 'reportStructureCalculationTypes_max_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  reportStructureId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Max_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  reportStructureId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ReportStructureCalculationTypes_Min_Fields = {
  __typename?: 'reportStructureCalculationTypes_min_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  reportStructureId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Min_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  reportStructureId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Mutation_Response = {
  __typename?: 'reportStructureCalculationTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportStructureCalculationTypes>;
};

/** on_conflict condition type for table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_On_Conflict = {
  constraint: ReportStructureCalculationTypes_Constraint;
  update_columns?: Array<ReportStructureCalculationTypes_Update_Column>;
  where?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "report_structure_calculation_types". */
export type ReportStructureCalculationTypes_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  reportStructureId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report_structure_calculation_types */
export type ReportStructureCalculationTypes_Pk_Columns_Input = {
  calculationTypeId: Scalars['Int']['input'];
  reportStructureId: Scalars['uuid']['input'];
};

/** select columns of table "report_structure_calculation_types" */
export enum ReportStructureCalculationTypes_Select_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  reportStructureId = 'reportStructureId'
}

/** input type for updating data in table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Set_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  reportStructureId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type ReportStructureCalculationTypes_Stddev_Fields = {
  __typename?: 'reportStructureCalculationTypes_stddev_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Stddev_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ReportStructureCalculationTypes_Stddev_Pop_Fields = {
  __typename?: 'reportStructureCalculationTypes_stddev_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Stddev_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ReportStructureCalculationTypes_Stddev_Samp_Fields = {
  __typename?: 'reportStructureCalculationTypes_stddev_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Stddev_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reportStructureCalculationTypes" */
export type ReportStructureCalculationTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReportStructureCalculationTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportStructureCalculationTypes_Stream_Cursor_Value_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  reportStructureId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ReportStructureCalculationTypes_Sum_Fields = {
  __typename?: 'reportStructureCalculationTypes_sum_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Sum_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "report_structure_calculation_types" */
export enum ReportStructureCalculationTypes_Update_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  reportStructureId = 'reportStructureId'
}

export type ReportStructureCalculationTypes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReportStructureCalculationTypes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportStructureCalculationTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReportStructureCalculationTypes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ReportStructureCalculationTypes_Var_Pop_Fields = {
  __typename?: 'reportStructureCalculationTypes_var_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Var_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ReportStructureCalculationTypes_Var_Samp_Fields = {
  __typename?: 'reportStructureCalculationTypes_var_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Var_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ReportStructureCalculationTypes_Variance_Fields = {
  __typename?: 'reportStructureCalculationTypes_variance_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "report_structure_calculation_types" */
export type ReportStructureCalculationTypes_Variance_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "report_structure_classification_codes" */
export type ReportStructureClassificationCodes = {
  __typename?: 'reportStructureClassificationCodes';
  /** An object relationship */
  classificationCode: ClassificationCode;
  classificationCodeId: Scalars['Int']['output'];
  /** An object relationship */
  reportStructure: ReportStructure;
  reportStructureId: Scalars['uuid']['output'];
};

/** aggregated selection of "report_structure_classification_codes" */
export type ReportStructureClassificationCodes_Aggregate = {
  __typename?: 'reportStructureClassificationCodes_aggregate';
  aggregate?: Maybe<ReportStructureClassificationCodes_Aggregate_Fields>;
  nodes: Array<ReportStructureClassificationCodes>;
};

/** aggregate fields of "report_structure_classification_codes" */
export type ReportStructureClassificationCodes_Aggregate_Fields = {
  __typename?: 'reportStructureClassificationCodes_aggregate_fields';
  avg?: Maybe<ReportStructureClassificationCodes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReportStructureClassificationCodes_Max_Fields>;
  min?: Maybe<ReportStructureClassificationCodes_Min_Fields>;
  stddev?: Maybe<ReportStructureClassificationCodes_Stddev_Fields>;
  stddev_pop?: Maybe<ReportStructureClassificationCodes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReportStructureClassificationCodes_Stddev_Samp_Fields>;
  sum?: Maybe<ReportStructureClassificationCodes_Sum_Fields>;
  var_pop?: Maybe<ReportStructureClassificationCodes_Var_Pop_Fields>;
  var_samp?: Maybe<ReportStructureClassificationCodes_Var_Samp_Fields>;
  variance?: Maybe<ReportStructureClassificationCodes_Variance_Fields>;
};


/** aggregate fields of "report_structure_classification_codes" */
export type ReportStructureClassificationCodes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReportStructureClassificationCodes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ReportStructureClassificationCodes_Avg_Fields = {
  __typename?: 'reportStructureClassificationCodes_avg_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "report_structure_classification_codes". All fields are combined with a logical 'AND'. */
export type ReportStructureClassificationCodes_Bool_Exp = {
  _and?: InputMaybe<Array<ReportStructureClassificationCodes_Bool_Exp>>;
  _not?: InputMaybe<ReportStructureClassificationCodes_Bool_Exp>;
  _or?: InputMaybe<Array<ReportStructureClassificationCodes_Bool_Exp>>;
  classificationCode?: InputMaybe<ClassificationCode_Bool_Exp>;
  classificationCodeId?: InputMaybe<Int_Comparison_Exp>;
  reportStructure?: InputMaybe<ReportStructure_Bool_Exp>;
  reportStructureId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_structure_classification_codes" */
export enum ReportStructureClassificationCodes_Constraint {
  /** unique or primary key constraint on columns "report_structure_id", "classification_code_id" */
  report_structure_classification_codes_pkey = 'report_structure_classification_codes_pkey'
}

/** input type for incrementing numeric columns in table "report_structure_classification_codes" */
export type ReportStructureClassificationCodes_Inc_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "report_structure_classification_codes" */
export type ReportStructureClassificationCodes_Insert_Input = {
  classificationCode?: InputMaybe<ClassificationCode_Obj_Rel_Insert_Input>;
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  reportStructure?: InputMaybe<ReportStructure_Obj_Rel_Insert_Input>;
  reportStructureId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ReportStructureClassificationCodes_Max_Fields = {
  __typename?: 'reportStructureClassificationCodes_max_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  reportStructureId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ReportStructureClassificationCodes_Min_Fields = {
  __typename?: 'reportStructureClassificationCodes_min_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
  reportStructureId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "report_structure_classification_codes" */
export type ReportStructureClassificationCodes_Mutation_Response = {
  __typename?: 'reportStructureClassificationCodes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportStructureClassificationCodes>;
};

/** on_conflict condition type for table "report_structure_classification_codes" */
export type ReportStructureClassificationCodes_On_Conflict = {
  constraint: ReportStructureClassificationCodes_Constraint;
  update_columns?: Array<ReportStructureClassificationCodes_Update_Column>;
  where?: InputMaybe<ReportStructureClassificationCodes_Bool_Exp>;
};

/** Ordering options when selecting data from "report_structure_classification_codes". */
export type ReportStructureClassificationCodes_Order_By = {
  classificationCode?: InputMaybe<ClassificationCode_Order_By>;
  classificationCodeId?: InputMaybe<Order_By>;
  reportStructure?: InputMaybe<ReportStructure_Order_By>;
  reportStructureId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report_structure_classification_codes */
export type ReportStructureClassificationCodes_Pk_Columns_Input = {
  classificationCodeId: Scalars['Int']['input'];
  reportStructureId: Scalars['uuid']['input'];
};

/** select columns of table "report_structure_classification_codes" */
export enum ReportStructureClassificationCodes_Select_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  reportStructureId = 'reportStructureId'
}

/** input type for updating data in table "report_structure_classification_codes" */
export type ReportStructureClassificationCodes_Set_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  reportStructureId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type ReportStructureClassificationCodes_Stddev_Fields = {
  __typename?: 'reportStructureClassificationCodes_stddev_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ReportStructureClassificationCodes_Stddev_Pop_Fields = {
  __typename?: 'reportStructureClassificationCodes_stddev_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ReportStructureClassificationCodes_Stddev_Samp_Fields = {
  __typename?: 'reportStructureClassificationCodes_stddev_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportStructureClassificationCodes" */
export type ReportStructureClassificationCodes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReportStructureClassificationCodes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportStructureClassificationCodes_Stream_Cursor_Value_Input = {
  classificationCodeId?: InputMaybe<Scalars['Int']['input']>;
  reportStructureId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ReportStructureClassificationCodes_Sum_Fields = {
  __typename?: 'reportStructureClassificationCodes_sum_fields';
  classificationCodeId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "report_structure_classification_codes" */
export enum ReportStructureClassificationCodes_Update_Column {
  /** column name */
  classificationCodeId = 'classificationCodeId',
  /** column name */
  reportStructureId = 'reportStructureId'
}

export type ReportStructureClassificationCodes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReportStructureClassificationCodes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportStructureClassificationCodes_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReportStructureClassificationCodes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ReportStructureClassificationCodes_Var_Pop_Fields = {
  __typename?: 'reportStructureClassificationCodes_var_pop_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ReportStructureClassificationCodes_Var_Samp_Fields = {
  __typename?: 'reportStructureClassificationCodes_var_samp_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ReportStructureClassificationCodes_Variance_Fields = {
  __typename?: 'reportStructureClassificationCodes_variance_fields';
  classificationCodeId?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "report_structure" */
export type ReportStructure_Aggregate = {
  __typename?: 'reportStructure_aggregate';
  aggregate?: Maybe<ReportStructure_Aggregate_Fields>;
  nodes: Array<ReportStructure>;
};

/** aggregate fields of "report_structure" */
export type ReportStructure_Aggregate_Fields = {
  __typename?: 'reportStructure_aggregate_fields';
  avg?: Maybe<ReportStructure_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReportStructure_Max_Fields>;
  min?: Maybe<ReportStructure_Min_Fields>;
  stddev?: Maybe<ReportStructure_Stddev_Fields>;
  stddev_pop?: Maybe<ReportStructure_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReportStructure_Stddev_Samp_Fields>;
  sum?: Maybe<ReportStructure_Sum_Fields>;
  var_pop?: Maybe<ReportStructure_Var_Pop_Fields>;
  var_samp?: Maybe<ReportStructure_Var_Samp_Fields>;
  variance?: Maybe<ReportStructure_Variance_Fields>;
};


/** aggregate fields of "report_structure" */
export type ReportStructure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReportStructure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ReportStructure_Avg_Fields = {
  __typename?: 'reportStructure_avg_fields';
  sortIndex?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "report_structure". All fields are combined with a logical 'AND'. */
export type ReportStructure_Bool_Exp = {
  _and?: InputMaybe<Array<ReportStructure_Bool_Exp>>;
  _not?: InputMaybe<ReportStructure_Bool_Exp>;
  _or?: InputMaybe<Array<ReportStructure_Bool_Exp>>;
  buildingElement?: InputMaybe<String_Comparison_Exp>;
  buildingElementExamples?: InputMaybe<String_Comparison_Exp>;
  buildingElementMainGroup?: InputMaybe<String_Comparison_Exp>;
  buildingElementSubGroup?: InputMaybe<String_Comparison_Exp>;
  calculationTypes?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
  calculationTypes_aggregate?: InputMaybe<ReportStructureCalculationTypes_Aggregate_Bool_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  detailLevel?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sortIndex?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_structure" */
export enum ReportStructure_Constraint {
  /** unique or primary key constraint on columns "sort_index" */
  report_structure_sort_index_key = 'report_structure_sort_index_key',
  /** unique or primary key constraint on columns "id" */
  reporting_structure_pkey = 'reporting_structure_pkey'
}

/** input type for incrementing numeric columns in table "report_structure" */
export type ReportStructure_Inc_Input = {
  sortIndex?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "report_structure" */
export type ReportStructure_Insert_Input = {
  buildingElement?: InputMaybe<Scalars['String']['input']>;
  buildingElementExamples?: InputMaybe<Scalars['String']['input']>;
  buildingElementMainGroup?: InputMaybe<Scalars['String']['input']>;
  buildingElementSubGroup?: InputMaybe<Scalars['String']['input']>;
  calculationTypes?: InputMaybe<ReportStructureCalculationTypes_Arr_Rel_Insert_Input>;
  category?: InputMaybe<Scalars['String']['input']>;
  detailLevel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sortIndex?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ReportStructure_Max_Fields = {
  __typename?: 'reportStructure_max_fields';
  buildingElement?: Maybe<Scalars['String']['output']>;
  buildingElementExamples?: Maybe<Scalars['String']['output']>;
  buildingElementMainGroup?: Maybe<Scalars['String']['output']>;
  buildingElementSubGroup?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  detailLevel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sortIndex?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ReportStructure_Min_Fields = {
  __typename?: 'reportStructure_min_fields';
  buildingElement?: Maybe<Scalars['String']['output']>;
  buildingElementExamples?: Maybe<Scalars['String']['output']>;
  buildingElementMainGroup?: Maybe<Scalars['String']['output']>;
  buildingElementSubGroup?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  detailLevel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sortIndex?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "report_structure" */
export type ReportStructure_Mutation_Response = {
  __typename?: 'reportStructure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportStructure>;
};

/** input type for inserting object relation for remote table "report_structure" */
export type ReportStructure_Obj_Rel_Insert_Input = {
  data: ReportStructure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ReportStructure_On_Conflict>;
};

/** on_conflict condition type for table "report_structure" */
export type ReportStructure_On_Conflict = {
  constraint: ReportStructure_Constraint;
  update_columns?: Array<ReportStructure_Update_Column>;
  where?: InputMaybe<ReportStructure_Bool_Exp>;
};

/** Ordering options when selecting data from "report_structure". */
export type ReportStructure_Order_By = {
  buildingElement?: InputMaybe<Order_By>;
  buildingElementExamples?: InputMaybe<Order_By>;
  buildingElementMainGroup?: InputMaybe<Order_By>;
  buildingElementSubGroup?: InputMaybe<Order_By>;
  calculationTypes_aggregate?: InputMaybe<ReportStructureCalculationTypes_Aggregate_Order_By>;
  category?: InputMaybe<Order_By>;
  detailLevel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sortIndex?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report_structure */
export type ReportStructure_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "report_structure" */
export enum ReportStructure_Select_Column {
  /** column name */
  buildingElement = 'buildingElement',
  /** column name */
  buildingElementExamples = 'buildingElementExamples',
  /** column name */
  buildingElementMainGroup = 'buildingElementMainGroup',
  /** column name */
  buildingElementSubGroup = 'buildingElementSubGroup',
  /** column name */
  category = 'category',
  /** column name */
  detailLevel = 'detailLevel',
  /** column name */
  id = 'id',
  /** column name */
  sortIndex = 'sortIndex',
  /** column name */
  type = 'type'
}

/** input type for updating data in table "report_structure" */
export type ReportStructure_Set_Input = {
  buildingElement?: InputMaybe<Scalars['String']['input']>;
  buildingElementExamples?: InputMaybe<Scalars['String']['input']>;
  buildingElementMainGroup?: InputMaybe<Scalars['String']['input']>;
  buildingElementSubGroup?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  detailLevel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sortIndex?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ReportStructure_Stddev_Fields = {
  __typename?: 'reportStructure_stddev_fields';
  sortIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ReportStructure_Stddev_Pop_Fields = {
  __typename?: 'reportStructure_stddev_pop_fields';
  sortIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ReportStructure_Stddev_Samp_Fields = {
  __typename?: 'reportStructure_stddev_samp_fields';
  sortIndex?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportStructure" */
export type ReportStructure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReportStructure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportStructure_Stream_Cursor_Value_Input = {
  buildingElement?: InputMaybe<Scalars['String']['input']>;
  buildingElementExamples?: InputMaybe<Scalars['String']['input']>;
  buildingElementMainGroup?: InputMaybe<Scalars['String']['input']>;
  buildingElementSubGroup?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  detailLevel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sortIndex?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ReportStructure_Sum_Fields = {
  __typename?: 'reportStructure_sum_fields';
  sortIndex?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "report_structure" */
export enum ReportStructure_Update_Column {
  /** column name */
  buildingElement = 'buildingElement',
  /** column name */
  buildingElementExamples = 'buildingElementExamples',
  /** column name */
  buildingElementMainGroup = 'buildingElementMainGroup',
  /** column name */
  buildingElementSubGroup = 'buildingElementSubGroup',
  /** column name */
  category = 'category',
  /** column name */
  detailLevel = 'detailLevel',
  /** column name */
  id = 'id',
  /** column name */
  sortIndex = 'sortIndex',
  /** column name */
  type = 'type'
}

export type ReportStructure_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReportStructure_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportStructure_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReportStructure_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ReportStructure_Var_Pop_Fields = {
  __typename?: 'reportStructure_var_pop_fields';
  sortIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ReportStructure_Var_Samp_Fields = {
  __typename?: 'reportStructure_var_samp_fields';
  sortIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ReportStructure_Variance_Fields = {
  __typename?: 'reportStructure_variance_fields';
  sortIndex?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "reportfilesmetadata" */
export type Reportfilesmetadata = {
  __typename?: 'reportfilesmetadata';
  blobPath: Scalars['String']['output'];
  buildingProjectId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  fileExtension: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  magic: Scalars['String']['output'];
  /** An object relationship */
  revision: ProjectRevision;
  revisionId: Scalars['uuid']['output'];
  tenantId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

/** aggregated selection of "reportfilesmetadata" */
export type Reportfilesmetadata_Aggregate = {
  __typename?: 'reportfilesmetadata_aggregate';
  aggregate?: Maybe<Reportfilesmetadata_Aggregate_Fields>;
  nodes: Array<Reportfilesmetadata>;
};

/** aggregate fields of "reportfilesmetadata" */
export type Reportfilesmetadata_Aggregate_Fields = {
  __typename?: 'reportfilesmetadata_aggregate_fields';
  avg?: Maybe<Reportfilesmetadata_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reportfilesmetadata_Max_Fields>;
  min?: Maybe<Reportfilesmetadata_Min_Fields>;
  stddev?: Maybe<Reportfilesmetadata_Stddev_Fields>;
  stddev_pop?: Maybe<Reportfilesmetadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reportfilesmetadata_Stddev_Samp_Fields>;
  sum?: Maybe<Reportfilesmetadata_Sum_Fields>;
  var_pop?: Maybe<Reportfilesmetadata_Var_Pop_Fields>;
  var_samp?: Maybe<Reportfilesmetadata_Var_Samp_Fields>;
  variance?: Maybe<Reportfilesmetadata_Variance_Fields>;
};


/** aggregate fields of "reportfilesmetadata" */
export type Reportfilesmetadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reportfilesmetadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Reportfilesmetadata_Avg_Fields = {
  __typename?: 'reportfilesmetadata_avg_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reportfilesmetadata". All fields are combined with a logical 'AND'. */
export type Reportfilesmetadata_Bool_Exp = {
  _and?: InputMaybe<Array<Reportfilesmetadata_Bool_Exp>>;
  _not?: InputMaybe<Reportfilesmetadata_Bool_Exp>;
  _or?: InputMaybe<Array<Reportfilesmetadata_Bool_Exp>>;
  blobPath?: InputMaybe<String_Comparison_Exp>;
  buildingProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  fileExtension?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  magic?: InputMaybe<String_Comparison_Exp>;
  revision?: InputMaybe<ProjectRevision_Bool_Exp>;
  revisionId?: InputMaybe<Uuid_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  versionNumber?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "reportfilesmetadata" */
export enum Reportfilesmetadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  reportfilesmetadata_pkey = 'reportfilesmetadata_pkey'
}

/** input type for incrementing numeric columns in table "reportfilesmetadata" */
export type Reportfilesmetadata_Inc_Input = {
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reportfilesmetadata" */
export type Reportfilesmetadata_Insert_Input = {
  blobPath?: InputMaybe<Scalars['String']['input']>;
  buildingProjectId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  magic?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<ProjectRevision_Obj_Rel_Insert_Input>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Reportfilesmetadata_Max_Fields = {
  __typename?: 'reportfilesmetadata_max_fields';
  blobPath?: Maybe<Scalars['String']['output']>;
  buildingProjectId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  magic?: Maybe<Scalars['String']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Reportfilesmetadata_Min_Fields = {
  __typename?: 'reportfilesmetadata_min_fields';
  blobPath?: Maybe<Scalars['String']['output']>;
  buildingProjectId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  magic?: Maybe<Scalars['String']['output']>;
  revisionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "reportfilesmetadata" */
export type Reportfilesmetadata_Mutation_Response = {
  __typename?: 'reportfilesmetadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reportfilesmetadata>;
};

/** on_conflict condition type for table "reportfilesmetadata" */
export type Reportfilesmetadata_On_Conflict = {
  constraint: Reportfilesmetadata_Constraint;
  update_columns?: Array<Reportfilesmetadata_Update_Column>;
  where?: InputMaybe<Reportfilesmetadata_Bool_Exp>;
};

/** Ordering options when selecting data from "reportfilesmetadata". */
export type Reportfilesmetadata_Order_By = {
  blobPath?: InputMaybe<Order_By>;
  buildingProjectId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  fileExtension?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  magic?: InputMaybe<Order_By>;
  revision?: InputMaybe<ProjectRevision_Order_By>;
  revisionId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  versionNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reportfilesmetadata */
export type Reportfilesmetadata_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reportfilesmetadata" */
export enum Reportfilesmetadata_Select_Column {
  /** column name */
  blobPath = 'blobPath',
  /** column name */
  buildingProjectId = 'buildingProjectId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  fileExtension = 'fileExtension',
  /** column name */
  id = 'id',
  /** column name */
  magic = 'magic',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  versionNumber = 'versionNumber'
}

/** input type for updating data in table "reportfilesmetadata" */
export type Reportfilesmetadata_Set_Input = {
  blobPath?: InputMaybe<Scalars['String']['input']>;
  buildingProjectId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  magic?: InputMaybe<Scalars['String']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Reportfilesmetadata_Stddev_Fields = {
  __typename?: 'reportfilesmetadata_stddev_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Reportfilesmetadata_Stddev_Pop_Fields = {
  __typename?: 'reportfilesmetadata_stddev_pop_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Reportfilesmetadata_Stddev_Samp_Fields = {
  __typename?: 'reportfilesmetadata_stddev_samp_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportfilesmetadata" */
export type Reportfilesmetadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reportfilesmetadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reportfilesmetadata_Stream_Cursor_Value_Input = {
  blobPath?: InputMaybe<Scalars['String']['input']>;
  buildingProjectId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  magic?: InputMaybe<Scalars['String']['input']>;
  revisionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Reportfilesmetadata_Sum_Fields = {
  __typename?: 'reportfilesmetadata_sum_fields';
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "reportfilesmetadata" */
export enum Reportfilesmetadata_Update_Column {
  /** column name */
  blobPath = 'blobPath',
  /** column name */
  buildingProjectId = 'buildingProjectId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  fileExtension = 'fileExtension',
  /** column name */
  id = 'id',
  /** column name */
  magic = 'magic',
  /** column name */
  revisionId = 'revisionId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  versionNumber = 'versionNumber'
}

export type Reportfilesmetadata_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reportfilesmetadata_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reportfilesmetadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reportfilesmetadata_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reportfilesmetadata_Var_Pop_Fields = {
  __typename?: 'reportfilesmetadata_var_pop_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Reportfilesmetadata_Var_Samp_Fields = {
  __typename?: 'reportfilesmetadata_var_samp_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Reportfilesmetadata_Variance_Fields = {
  __typename?: 'reportfilesmetadata_variance_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  avg?: Maybe<Roles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
  stddev?: Maybe<Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Roles_Sum_Fields>;
  var_pop?: Maybe<Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Roles_Var_Samp_Fields>;
  variance?: Maybe<Roles_Variance_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Roles_Avg_Fields = {
  __typename?: 'roles_avg_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<String_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "level" */
  roles_level_key = 'roles_level_key',
  /** unique or primary key constraint on columns "name" */
  roles_name_key = 'roles_name_key',
  /** unique or primary key constraint on columns "id" */
  roles_pkey = 'roles_pkey'
}

/** input type for incrementing numeric columns in table "roles" */
export type Roles_Inc_Input = {
  level?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  level = 'level',
  /** column name */
  name = 'name',
  /** column name */
  permissions = 'permissions'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate stddev on columns */
export type Roles_Stddev_Fields = {
  __typename?: 'roles_stddev_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Roles_Stddev_Pop_Fields = {
  __typename?: 'roles_stddev_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Roles_Stddev_Samp_Fields = {
  __typename?: 'roles_stddev_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate sum on columns */
export type Roles_Sum_Fields = {
  __typename?: 'roles_sum_fields';
  level?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  level = 'level',
  /** column name */
  name = 'name',
  /** column name */
  permissions = 'permissions'
}

export type Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Roles_Var_Pop_Fields = {
  __typename?: 'roles_var_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Roles_Var_Samp_Fields = {
  __typename?: 'roles_var_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Roles_Variance_Fields = {
  __typename?: 'roles_variance_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "special_condition_type" */
export type SpecialConditionType = {
  __typename?: 'specialConditionType';
  /** An object relationship */
  buildingPart: BuildingPart;
  buildingPartId: Scalars['uuid']['output'];
  /** An array relationship */
  calculationTypes: Array<SpecialConditionTypeCalculationType>;
  /** An aggregate relationship */
  calculationTypes_aggregate: SpecialConditionTypeCalculationType_Aggregate;
  country: Country_Enum;
  datasource: Scalars['String']['output'];
  /** An object relationship */
  denominatorUnit?: Maybe<DenominatorUnit>;
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indicatorType: IndicatorType;
  indicatorTypeId: Scalars['Int']['output'];
  referenceValue: Scalars['numeric']['output'];
  /** An object relationship */
  specialConditionTypeCategory: Special_Condition_Type_Category;
  specialConditionTypeCategoryId: Scalars['uuid']['output'];
};


/** columns and relationships of "special_condition_type" */
export type SpecialConditionTypeCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeCalculationType_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};


/** columns and relationships of "special_condition_type" */
export type SpecialConditionTypeCalculationTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeCalculationType_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};

/** columns and relationships of "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType = {
  __typename?: 'specialConditionTypeCalculationType';
  /** An object relationship */
  calculationType: CalculationType;
  calculationTypeId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  specialConditionType: SpecialConditionType;
  specialConditionTypeId: Scalars['uuid']['output'];
};

/** aggregated selection of "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Aggregate = {
  __typename?: 'specialConditionTypeCalculationType_aggregate';
  aggregate?: Maybe<SpecialConditionTypeCalculationType_Aggregate_Fields>;
  nodes: Array<SpecialConditionTypeCalculationType>;
};

export type SpecialConditionTypeCalculationType_Aggregate_Bool_Exp = {
  count?: InputMaybe<SpecialConditionTypeCalculationType_Aggregate_Bool_Exp_Count>;
};

export type SpecialConditionTypeCalculationType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Aggregate_Fields = {
  __typename?: 'specialConditionTypeCalculationType_aggregate_fields';
  avg?: Maybe<SpecialConditionTypeCalculationType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<SpecialConditionTypeCalculationType_Max_Fields>;
  min?: Maybe<SpecialConditionTypeCalculationType_Min_Fields>;
  stddev?: Maybe<SpecialConditionTypeCalculationType_Stddev_Fields>;
  stddev_pop?: Maybe<SpecialConditionTypeCalculationType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SpecialConditionTypeCalculationType_Stddev_Samp_Fields>;
  sum?: Maybe<SpecialConditionTypeCalculationType_Sum_Fields>;
  var_pop?: Maybe<SpecialConditionTypeCalculationType_Var_Pop_Fields>;
  var_samp?: Maybe<SpecialConditionTypeCalculationType_Var_Samp_Fields>;
  variance?: Maybe<SpecialConditionTypeCalculationType_Variance_Fields>;
};


/** aggregate fields of "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Aggregate_Order_By = {
  avg?: InputMaybe<SpecialConditionTypeCalculationType_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SpecialConditionTypeCalculationType_Max_Order_By>;
  min?: InputMaybe<SpecialConditionTypeCalculationType_Min_Order_By>;
  stddev?: InputMaybe<SpecialConditionTypeCalculationType_Stddev_Order_By>;
  stddev_pop?: InputMaybe<SpecialConditionTypeCalculationType_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<SpecialConditionTypeCalculationType_Stddev_Samp_Order_By>;
  sum?: InputMaybe<SpecialConditionTypeCalculationType_Sum_Order_By>;
  var_pop?: InputMaybe<SpecialConditionTypeCalculationType_Var_Pop_Order_By>;
  var_samp?: InputMaybe<SpecialConditionTypeCalculationType_Var_Samp_Order_By>;
  variance?: InputMaybe<SpecialConditionTypeCalculationType_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Arr_Rel_Insert_Input = {
  data: Array<SpecialConditionTypeCalculationType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SpecialConditionTypeCalculationType_On_Conflict>;
};

/** aggregate avg on columns */
export type SpecialConditionTypeCalculationType_Avg_Fields = {
  __typename?: 'specialConditionTypeCalculationType_avg_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Avg_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "special_condition_type_calculation_type". All fields are combined with a logical 'AND'. */
export type SpecialConditionTypeCalculationType_Bool_Exp = {
  _and?: InputMaybe<Array<SpecialConditionTypeCalculationType_Bool_Exp>>;
  _not?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
  _or?: InputMaybe<Array<SpecialConditionTypeCalculationType_Bool_Exp>>;
  calculationType?: InputMaybe<CalculationType_Bool_Exp>;
  calculationTypeId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  specialConditionType?: InputMaybe<SpecialConditionType_Bool_Exp>;
  specialConditionTypeId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "special_condition_type_calculation_type" */
export enum SpecialConditionTypeCalculationType_Constraint {
  /** unique or primary key constraint on columns "special_condition_type_id", "calculation_type_id" */
  special_condition_type_calcul_special_condition_type_id_cal_key = 'special_condition_type_calcul_special_condition_type_id_cal_key',
  /** unique or primary key constraint on columns "id" */
  special_condition_type_calculation_type_pkey = 'special_condition_type_calculation_type_pkey'
}

/** input type for incrementing numeric columns in table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Inc_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Insert_Input = {
  calculationType?: InputMaybe<CalculationType_Obj_Rel_Insert_Input>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  specialConditionType?: InputMaybe<SpecialConditionType_Obj_Rel_Insert_Input>;
  specialConditionTypeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type SpecialConditionTypeCalculationType_Max_Fields = {
  __typename?: 'specialConditionTypeCalculationType_max_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  specialConditionTypeId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Max_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  specialConditionTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SpecialConditionTypeCalculationType_Min_Fields = {
  __typename?: 'specialConditionTypeCalculationType_min_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  specialConditionTypeId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Min_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  specialConditionTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Mutation_Response = {
  __typename?: 'specialConditionTypeCalculationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SpecialConditionTypeCalculationType>;
};

/** on_conflict condition type for table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_On_Conflict = {
  constraint: SpecialConditionTypeCalculationType_Constraint;
  update_columns?: Array<SpecialConditionTypeCalculationType_Update_Column>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};

/** Ordering options when selecting data from "special_condition_type_calculation_type". */
export type SpecialConditionTypeCalculationType_Order_By = {
  calculationType?: InputMaybe<CalculationType_Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  specialConditionType?: InputMaybe<SpecialConditionType_Order_By>;
  specialConditionTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: special_condition_type_calculation_type */
export type SpecialConditionTypeCalculationType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "special_condition_type_calculation_type" */
export enum SpecialConditionTypeCalculationType_Select_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  specialConditionTypeId = 'specialConditionTypeId'
}

/** input type for updating data in table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Set_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  specialConditionTypeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type SpecialConditionTypeCalculationType_Stddev_Fields = {
  __typename?: 'specialConditionTypeCalculationType_stddev_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Stddev_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type SpecialConditionTypeCalculationType_Stddev_Pop_Fields = {
  __typename?: 'specialConditionTypeCalculationType_stddev_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Stddev_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type SpecialConditionTypeCalculationType_Stddev_Samp_Fields = {
  __typename?: 'specialConditionTypeCalculationType_stddev_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Stddev_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "specialConditionTypeCalculationType" */
export type SpecialConditionTypeCalculationType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpecialConditionTypeCalculationType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpecialConditionTypeCalculationType_Stream_Cursor_Value_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  specialConditionTypeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type SpecialConditionTypeCalculationType_Sum_Fields = {
  __typename?: 'specialConditionTypeCalculationType_sum_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Sum_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "special_condition_type_calculation_type" */
export enum SpecialConditionTypeCalculationType_Update_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  specialConditionTypeId = 'specialConditionTypeId'
}

export type SpecialConditionTypeCalculationType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SpecialConditionTypeCalculationType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpecialConditionTypeCalculationType_Set_Input>;
  /** filter the rows which have to be updated */
  where: SpecialConditionTypeCalculationType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SpecialConditionTypeCalculationType_Var_Pop_Fields = {
  __typename?: 'specialConditionTypeCalculationType_var_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Var_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type SpecialConditionTypeCalculationType_Var_Samp_Fields = {
  __typename?: 'specialConditionTypeCalculationType_var_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Var_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type SpecialConditionTypeCalculationType_Variance_Fields = {
  __typename?: 'specialConditionTypeCalculationType_variance_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "special_condition_type_calculation_type" */
export type SpecialConditionTypeCalculationType_Variance_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "special_condition_type_input_parameter" */
export type SpecialConditionTypeInputParameter = {
  __typename?: 'specialConditionTypeInputParameter';
  parameter: Array<Scalars['String']['output']>;
  specialConditionTypeCategoryId: Scalars['uuid']['output'];
};

/** aggregated selection of "special_condition_type_input_parameter" */
export type SpecialConditionTypeInputParameter_Aggregate = {
  __typename?: 'specialConditionTypeInputParameter_aggregate';
  aggregate?: Maybe<SpecialConditionTypeInputParameter_Aggregate_Fields>;
  nodes: Array<SpecialConditionTypeInputParameter>;
};

/** aggregate fields of "special_condition_type_input_parameter" */
export type SpecialConditionTypeInputParameter_Aggregate_Fields = {
  __typename?: 'specialConditionTypeInputParameter_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<SpecialConditionTypeInputParameter_Max_Fields>;
  min?: Maybe<SpecialConditionTypeInputParameter_Min_Fields>;
};


/** aggregate fields of "special_condition_type_input_parameter" */
export type SpecialConditionTypeInputParameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpecialConditionTypeInputParameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "special_condition_type_input_parameter". All fields are combined with a logical 'AND'. */
export type SpecialConditionTypeInputParameter_Bool_Exp = {
  _and?: InputMaybe<Array<SpecialConditionTypeInputParameter_Bool_Exp>>;
  _not?: InputMaybe<SpecialConditionTypeInputParameter_Bool_Exp>;
  _or?: InputMaybe<Array<SpecialConditionTypeInputParameter_Bool_Exp>>;
  parameter?: InputMaybe<String_Array_Comparison_Exp>;
  specialConditionTypeCategoryId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "special_condition_type_input_parameter" */
export enum SpecialConditionTypeInputParameter_Constraint {
  /** unique or primary key constraint on columns "special_condition_type_category_id" */
  special_condition_type_input_parameter_pkey = 'special_condition_type_input_parameter_pkey',
  /** unique or primary key constraint on columns "special_condition_type_category_id" */
  special_condition_type_input_parameter_special_condition_type_c = 'special_condition_type_input_parameter_special_condition_type_c'
}

/** input type for inserting data into table "special_condition_type_input_parameter" */
export type SpecialConditionTypeInputParameter_Insert_Input = {
  parameter?: InputMaybe<Array<Scalars['String']['input']>>;
  specialConditionTypeCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type SpecialConditionTypeInputParameter_Max_Fields = {
  __typename?: 'specialConditionTypeInputParameter_max_fields';
  parameter?: Maybe<Array<Scalars['String']['output']>>;
  specialConditionTypeCategoryId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type SpecialConditionTypeInputParameter_Min_Fields = {
  __typename?: 'specialConditionTypeInputParameter_min_fields';
  parameter?: Maybe<Array<Scalars['String']['output']>>;
  specialConditionTypeCategoryId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "special_condition_type_input_parameter" */
export type SpecialConditionTypeInputParameter_Mutation_Response = {
  __typename?: 'specialConditionTypeInputParameter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SpecialConditionTypeInputParameter>;
};

/** input type for inserting object relation for remote table "special_condition_type_input_parameter" */
export type SpecialConditionTypeInputParameter_Obj_Rel_Insert_Input = {
  data: SpecialConditionTypeInputParameter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SpecialConditionTypeInputParameter_On_Conflict>;
};

/** on_conflict condition type for table "special_condition_type_input_parameter" */
export type SpecialConditionTypeInputParameter_On_Conflict = {
  constraint: SpecialConditionTypeInputParameter_Constraint;
  update_columns?: Array<SpecialConditionTypeInputParameter_Update_Column>;
  where?: InputMaybe<SpecialConditionTypeInputParameter_Bool_Exp>;
};

/** Ordering options when selecting data from "special_condition_type_input_parameter". */
export type SpecialConditionTypeInputParameter_Order_By = {
  parameter?: InputMaybe<Order_By>;
  specialConditionTypeCategoryId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: special_condition_type_input_parameter */
export type SpecialConditionTypeInputParameter_Pk_Columns_Input = {
  specialConditionTypeCategoryId: Scalars['uuid']['input'];
};

/** select columns of table "special_condition_type_input_parameter" */
export enum SpecialConditionTypeInputParameter_Select_Column {
  /** column name */
  parameter = 'parameter',
  /** column name */
  specialConditionTypeCategoryId = 'specialConditionTypeCategoryId'
}

/** input type for updating data in table "special_condition_type_input_parameter" */
export type SpecialConditionTypeInputParameter_Set_Input = {
  parameter?: InputMaybe<Array<Scalars['String']['input']>>;
  specialConditionTypeCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "specialConditionTypeInputParameter" */
export type SpecialConditionTypeInputParameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpecialConditionTypeInputParameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpecialConditionTypeInputParameter_Stream_Cursor_Value_Input = {
  parameter?: InputMaybe<Array<Scalars['String']['input']>>;
  specialConditionTypeCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "special_condition_type_input_parameter" */
export enum SpecialConditionTypeInputParameter_Update_Column {
  /** column name */
  parameter = 'parameter',
  /** column name */
  specialConditionTypeCategoryId = 'specialConditionTypeCategoryId'
}

export type SpecialConditionTypeInputParameter_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpecialConditionTypeInputParameter_Set_Input>;
  /** filter the rows which have to be updated */
  where: SpecialConditionTypeInputParameter_Bool_Exp;
};

/** aggregated selection of "special_condition_type" */
export type SpecialConditionType_Aggregate = {
  __typename?: 'specialConditionType_aggregate';
  aggregate?: Maybe<SpecialConditionType_Aggregate_Fields>;
  nodes: Array<SpecialConditionType>;
};

/** aggregate fields of "special_condition_type" */
export type SpecialConditionType_Aggregate_Fields = {
  __typename?: 'specialConditionType_aggregate_fields';
  avg?: Maybe<SpecialConditionType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<SpecialConditionType_Max_Fields>;
  min?: Maybe<SpecialConditionType_Min_Fields>;
  stddev?: Maybe<SpecialConditionType_Stddev_Fields>;
  stddev_pop?: Maybe<SpecialConditionType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SpecialConditionType_Stddev_Samp_Fields>;
  sum?: Maybe<SpecialConditionType_Sum_Fields>;
  var_pop?: Maybe<SpecialConditionType_Var_Pop_Fields>;
  var_samp?: Maybe<SpecialConditionType_Var_Samp_Fields>;
  variance?: Maybe<SpecialConditionType_Variance_Fields>;
};


/** aggregate fields of "special_condition_type" */
export type SpecialConditionType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpecialConditionType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type SpecialConditionType_Avg_Fields = {
  __typename?: 'specialConditionType_avg_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  referenceValue?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "special_condition_type". All fields are combined with a logical 'AND'. */
export type SpecialConditionType_Bool_Exp = {
  _and?: InputMaybe<Array<SpecialConditionType_Bool_Exp>>;
  _not?: InputMaybe<SpecialConditionType_Bool_Exp>;
  _or?: InputMaybe<Array<SpecialConditionType_Bool_Exp>>;
  buildingPart?: InputMaybe<BuildingPart_Bool_Exp>;
  buildingPartId?: InputMaybe<Uuid_Comparison_Exp>;
  calculationTypes?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
  calculationTypes_aggregate?: InputMaybe<SpecialConditionTypeCalculationType_Aggregate_Bool_Exp>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  datasource?: InputMaybe<String_Comparison_Exp>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Bool_Exp>;
  denominatorUnitId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  indicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
  referenceValue?: InputMaybe<Numeric_Comparison_Exp>;
  specialConditionTypeCategory?: InputMaybe<Special_Condition_Type_Category_Bool_Exp>;
  specialConditionTypeCategoryId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "special_condition_type" */
export enum SpecialConditionType_Constraint {
  /** unique or primary key constraint on columns "id" */
  special_circumstances_pkey = 'special_circumstances_pkey'
}

/** input type for incrementing numeric columns in table "special_condition_type" */
export type SpecialConditionType_Inc_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  referenceValue?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "special_condition_type" */
export type SpecialConditionType_Insert_Input = {
  buildingPart?: InputMaybe<BuildingPart_Obj_Rel_Insert_Input>;
  buildingPartId?: InputMaybe<Scalars['uuid']['input']>;
  calculationTypes?: InputMaybe<SpecialConditionTypeCalculationType_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Country_Enum>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Obj_Rel_Insert_Input>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  referenceValue?: InputMaybe<Scalars['numeric']['input']>;
  specialConditionTypeCategory?: InputMaybe<Special_Condition_Type_Category_Obj_Rel_Insert_Input>;
  specialConditionTypeCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type SpecialConditionType_Max_Fields = {
  __typename?: 'specialConditionType_max_fields';
  buildingPartId?: Maybe<Scalars['uuid']['output']>;
  datasource?: Maybe<Scalars['String']['output']>;
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  referenceValue?: Maybe<Scalars['numeric']['output']>;
  specialConditionTypeCategoryId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type SpecialConditionType_Min_Fields = {
  __typename?: 'specialConditionType_min_fields';
  buildingPartId?: Maybe<Scalars['uuid']['output']>;
  datasource?: Maybe<Scalars['String']['output']>;
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  referenceValue?: Maybe<Scalars['numeric']['output']>;
  specialConditionTypeCategoryId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "special_condition_type" */
export type SpecialConditionType_Mutation_Response = {
  __typename?: 'specialConditionType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SpecialConditionType>;
};

/** input type for inserting object relation for remote table "special_condition_type" */
export type SpecialConditionType_Obj_Rel_Insert_Input = {
  data: SpecialConditionType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SpecialConditionType_On_Conflict>;
};

/** on_conflict condition type for table "special_condition_type" */
export type SpecialConditionType_On_Conflict = {
  constraint: SpecialConditionType_Constraint;
  update_columns?: Array<SpecialConditionType_Update_Column>;
  where?: InputMaybe<SpecialConditionType_Bool_Exp>;
};

/** Ordering options when selecting data from "special_condition_type". */
export type SpecialConditionType_Order_By = {
  buildingPart?: InputMaybe<BuildingPart_Order_By>;
  buildingPartId?: InputMaybe<Order_By>;
  calculationTypes_aggregate?: InputMaybe<SpecialConditionTypeCalculationType_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  datasource?: InputMaybe<Order_By>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Order_By>;
  denominatorUnitId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicatorType?: InputMaybe<IndicatorType_Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  referenceValue?: InputMaybe<Order_By>;
  specialConditionTypeCategory?: InputMaybe<Special_Condition_Type_Category_Order_By>;
  specialConditionTypeCategoryId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: special_condition_type */
export type SpecialConditionType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "special_condition_type" */
export enum SpecialConditionType_Select_Column {
  /** column name */
  buildingPartId = 'buildingPartId',
  /** column name */
  country = 'country',
  /** column name */
  datasource = 'datasource',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  referenceValue = 'referenceValue',
  /** column name */
  specialConditionTypeCategoryId = 'specialConditionTypeCategoryId'
}

/** input type for updating data in table "special_condition_type" */
export type SpecialConditionType_Set_Input = {
  buildingPartId?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Country_Enum>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  referenceValue?: InputMaybe<Scalars['numeric']['input']>;
  specialConditionTypeCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type SpecialConditionType_Stddev_Fields = {
  __typename?: 'specialConditionType_stddev_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  referenceValue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type SpecialConditionType_Stddev_Pop_Fields = {
  __typename?: 'specialConditionType_stddev_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  referenceValue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type SpecialConditionType_Stddev_Samp_Fields = {
  __typename?: 'specialConditionType_stddev_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  referenceValue?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "specialConditionType" */
export type SpecialConditionType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpecialConditionType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpecialConditionType_Stream_Cursor_Value_Input = {
  buildingPartId?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Country_Enum>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  referenceValue?: InputMaybe<Scalars['numeric']['input']>;
  specialConditionTypeCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type SpecialConditionType_Sum_Fields = {
  __typename?: 'specialConditionType_sum_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  referenceValue?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "special_condition_type" */
export enum SpecialConditionType_Update_Column {
  /** column name */
  buildingPartId = 'buildingPartId',
  /** column name */
  country = 'country',
  /** column name */
  datasource = 'datasource',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  referenceValue = 'referenceValue',
  /** column name */
  specialConditionTypeCategoryId = 'specialConditionTypeCategoryId'
}

export type SpecialConditionType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SpecialConditionType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpecialConditionType_Set_Input>;
  /** filter the rows which have to be updated */
  where: SpecialConditionType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SpecialConditionType_Var_Pop_Fields = {
  __typename?: 'specialConditionType_var_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  referenceValue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type SpecialConditionType_Var_Samp_Fields = {
  __typename?: 'specialConditionType_var_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  referenceValue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type SpecialConditionType_Variance_Fields = {
  __typename?: 'specialConditionType_variance_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  referenceValue?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "special_condition_type_category" */
export type Special_Condition_Type_Category = {
  __typename?: 'special_condition_type_category';
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  specialConditionTypeInputParameter?: Maybe<SpecialConditionTypeInputParameter>;
};

/** aggregated selection of "special_condition_type_category" */
export type Special_Condition_Type_Category_Aggregate = {
  __typename?: 'special_condition_type_category_aggregate';
  aggregate?: Maybe<Special_Condition_Type_Category_Aggregate_Fields>;
  nodes: Array<Special_Condition_Type_Category>;
};

/** aggregate fields of "special_condition_type_category" */
export type Special_Condition_Type_Category_Aggregate_Fields = {
  __typename?: 'special_condition_type_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Special_Condition_Type_Category_Max_Fields>;
  min?: Maybe<Special_Condition_Type_Category_Min_Fields>;
};


/** aggregate fields of "special_condition_type_category" */
export type Special_Condition_Type_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Special_Condition_Type_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "special_condition_type_category". All fields are combined with a logical 'AND'. */
export type Special_Condition_Type_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Special_Condition_Type_Category_Bool_Exp>>;
  _not?: InputMaybe<Special_Condition_Type_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Special_Condition_Type_Category_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  specialConditionTypeInputParameter?: InputMaybe<SpecialConditionTypeInputParameter_Bool_Exp>;
};

/** unique or primary key constraints on table "special_condition_type_category" */
export enum Special_Condition_Type_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  special_condition_type_category_pkey = 'special_condition_type_category_pkey'
}

/** input type for inserting data into table "special_condition_type_category" */
export type Special_Condition_Type_Category_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  specialConditionTypeInputParameter?: InputMaybe<SpecialConditionTypeInputParameter_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Special_Condition_Type_Category_Max_Fields = {
  __typename?: 'special_condition_type_category_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Special_Condition_Type_Category_Min_Fields = {
  __typename?: 'special_condition_type_category_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "special_condition_type_category" */
export type Special_Condition_Type_Category_Mutation_Response = {
  __typename?: 'special_condition_type_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Special_Condition_Type_Category>;
};

/** input type for inserting object relation for remote table "special_condition_type_category" */
export type Special_Condition_Type_Category_Obj_Rel_Insert_Input = {
  data: Special_Condition_Type_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Special_Condition_Type_Category_On_Conflict>;
};

/** on_conflict condition type for table "special_condition_type_category" */
export type Special_Condition_Type_Category_On_Conflict = {
  constraint: Special_Condition_Type_Category_Constraint;
  update_columns?: Array<Special_Condition_Type_Category_Update_Column>;
  where?: InputMaybe<Special_Condition_Type_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "special_condition_type_category". */
export type Special_Condition_Type_Category_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  specialConditionTypeInputParameter?: InputMaybe<SpecialConditionTypeInputParameter_Order_By>;
};

/** primary key columns input for table: special_condition_type_category */
export type Special_Condition_Type_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "special_condition_type_category" */
export enum Special_Condition_Type_Category_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

/** input type for updating data in table "special_condition_type_category" */
export type Special_Condition_Type_Category_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "special_condition_type_category" */
export type Special_Condition_Type_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Special_Condition_Type_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Special_Condition_Type_Category_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "special_condition_type_category" */
export enum Special_Condition_Type_Category_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

export type Special_Condition_Type_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Special_Condition_Type_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Special_Condition_Type_Category_Bool_Exp;
};

/** columns and relationships of "speckle_stream_model_ifc_upload" */
export type SpeckleStreamModelIfcUpload = {
  __typename?: 'speckleStreamModelIfcUpload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated: Scalars['timestamptz']['output'];
  speckleProjectId: Scalars['String']['output'];
  tenantId: Scalars['uuid']['output'];
};

/** columns and relationships of "speckle_stream_model_ifc_upload_recent" */
export type SpeckleStreamModelIfcUploadRecent = {
  __typename?: 'speckleStreamModelIfcUploadRecent';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  speckleProjectId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "speckle_stream_model_ifc_upload_recent" */
export type SpeckleStreamModelIfcUploadRecent_Aggregate = {
  __typename?: 'speckleStreamModelIfcUploadRecent_aggregate';
  aggregate?: Maybe<SpeckleStreamModelIfcUploadRecent_Aggregate_Fields>;
  nodes: Array<SpeckleStreamModelIfcUploadRecent>;
};

/** aggregate fields of "speckle_stream_model_ifc_upload_recent" */
export type SpeckleStreamModelIfcUploadRecent_Aggregate_Fields = {
  __typename?: 'speckleStreamModelIfcUploadRecent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<SpeckleStreamModelIfcUploadRecent_Max_Fields>;
  min?: Maybe<SpeckleStreamModelIfcUploadRecent_Min_Fields>;
};


/** aggregate fields of "speckle_stream_model_ifc_upload_recent" */
export type SpeckleStreamModelIfcUploadRecent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "speckle_stream_model_ifc_upload_recent". All fields are combined with a logical 'AND'. */
export type SpeckleStreamModelIfcUploadRecent_Bool_Exp = {
  _and?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Bool_Exp>>;
  _not?: InputMaybe<SpeckleStreamModelIfcUploadRecent_Bool_Exp>;
  _or?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Bool_Exp>>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  lastUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  speckleProjectId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "speckle_stream_model_ifc_upload_recent" */
export type SpeckleStreamModelIfcUploadRecent_Insert_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  speckleProjectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type SpeckleStreamModelIfcUploadRecent_Max_Fields = {
  __typename?: 'speckleStreamModelIfcUploadRecent_max_fields';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  speckleProjectId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type SpeckleStreamModelIfcUploadRecent_Min_Fields = {
  __typename?: 'speckleStreamModelIfcUploadRecent_min_fields';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  speckleProjectId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "speckle_stream_model_ifc_upload_recent" */
export type SpeckleStreamModelIfcUploadRecent_Mutation_Response = {
  __typename?: 'speckleStreamModelIfcUploadRecent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SpeckleStreamModelIfcUploadRecent>;
};

/** Ordering options when selecting data from "speckle_stream_model_ifc_upload_recent". */
export type SpeckleStreamModelIfcUploadRecent_Order_By = {
  errorMessage?: InputMaybe<Order_By>;
  lastUpdated?: InputMaybe<Order_By>;
  speckleProjectId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
};

/** select columns of table "speckle_stream_model_ifc_upload_recent" */
export enum SpeckleStreamModelIfcUploadRecent_Select_Column {
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  lastUpdated = 'lastUpdated',
  /** column name */
  speckleProjectId = 'speckleProjectId',
  /** column name */
  tenantId = 'tenantId'
}

/** input type for updating data in table "speckle_stream_model_ifc_upload_recent" */
export type SpeckleStreamModelIfcUploadRecent_Set_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  speckleProjectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "speckleStreamModelIfcUploadRecent" */
export type SpeckleStreamModelIfcUploadRecent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpeckleStreamModelIfcUploadRecent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpeckleStreamModelIfcUploadRecent_Stream_Cursor_Value_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  speckleProjectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

export type SpeckleStreamModelIfcUploadRecent_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpeckleStreamModelIfcUploadRecent_Set_Input>;
  /** filter the rows which have to be updated */
  where: SpeckleStreamModelIfcUploadRecent_Bool_Exp;
};

/** aggregated selection of "speckle_stream_model_ifc_upload" */
export type SpeckleStreamModelIfcUpload_Aggregate = {
  __typename?: 'speckleStreamModelIfcUpload_aggregate';
  aggregate?: Maybe<SpeckleStreamModelIfcUpload_Aggregate_Fields>;
  nodes: Array<SpeckleStreamModelIfcUpload>;
};

/** aggregate fields of "speckle_stream_model_ifc_upload" */
export type SpeckleStreamModelIfcUpload_Aggregate_Fields = {
  __typename?: 'speckleStreamModelIfcUpload_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<SpeckleStreamModelIfcUpload_Max_Fields>;
  min?: Maybe<SpeckleStreamModelIfcUpload_Min_Fields>;
};


/** aggregate fields of "speckle_stream_model_ifc_upload" */
export type SpeckleStreamModelIfcUpload_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "speckle_stream_model_ifc_upload". All fields are combined with a logical 'AND'. */
export type SpeckleStreamModelIfcUpload_Bool_Exp = {
  _and?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Bool_Exp>>;
  _not?: InputMaybe<SpeckleStreamModelIfcUpload_Bool_Exp>;
  _or?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Bool_Exp>>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  lastUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  speckleProjectId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "speckle_stream_model_ifc_upload" */
export enum SpeckleStreamModelIfcUpload_Constraint {
  /** unique or primary key constraint on columns "speckle_project_id" */
  speckle_stream_model_ifc_upload_pkey = 'speckle_stream_model_ifc_upload_pkey'
}

/** input type for inserting data into table "speckle_stream_model_ifc_upload" */
export type SpeckleStreamModelIfcUpload_Insert_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  speckleProjectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type SpeckleStreamModelIfcUpload_Max_Fields = {
  __typename?: 'speckleStreamModelIfcUpload_max_fields';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  speckleProjectId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type SpeckleStreamModelIfcUpload_Min_Fields = {
  __typename?: 'speckleStreamModelIfcUpload_min_fields';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['timestamptz']['output']>;
  speckleProjectId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "speckle_stream_model_ifc_upload" */
export type SpeckleStreamModelIfcUpload_Mutation_Response = {
  __typename?: 'speckleStreamModelIfcUpload_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SpeckleStreamModelIfcUpload>;
};

/** on_conflict condition type for table "speckle_stream_model_ifc_upload" */
export type SpeckleStreamModelIfcUpload_On_Conflict = {
  constraint: SpeckleStreamModelIfcUpload_Constraint;
  update_columns?: Array<SpeckleStreamModelIfcUpload_Update_Column>;
  where?: InputMaybe<SpeckleStreamModelIfcUpload_Bool_Exp>;
};

/** Ordering options when selecting data from "speckle_stream_model_ifc_upload". */
export type SpeckleStreamModelIfcUpload_Order_By = {
  errorMessage?: InputMaybe<Order_By>;
  lastUpdated?: InputMaybe<Order_By>;
  speckleProjectId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: speckle_stream_model_ifc_upload */
export type SpeckleStreamModelIfcUpload_Pk_Columns_Input = {
  speckleProjectId: Scalars['String']['input'];
};

/** select columns of table "speckle_stream_model_ifc_upload" */
export enum SpeckleStreamModelIfcUpload_Select_Column {
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  lastUpdated = 'lastUpdated',
  /** column name */
  speckleProjectId = 'speckleProjectId',
  /** column name */
  tenantId = 'tenantId'
}

/** input type for updating data in table "speckle_stream_model_ifc_upload" */
export type SpeckleStreamModelIfcUpload_Set_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  speckleProjectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "speckleStreamModelIfcUpload" */
export type SpeckleStreamModelIfcUpload_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpeckleStreamModelIfcUpload_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpeckleStreamModelIfcUpload_Stream_Cursor_Value_Input = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  speckleProjectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "speckle_stream_model_ifc_upload" */
export enum SpeckleStreamModelIfcUpload_Update_Column {
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  lastUpdated = 'lastUpdated',
  /** column name */
  speckleProjectId = 'speckleProjectId',
  /** column name */
  tenantId = 'tenantId'
}

export type SpeckleStreamModelIfcUpload_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpeckleStreamModelIfcUpload_Set_Input>;
  /** filter the rows which have to be updated */
  where: SpeckleStreamModelIfcUpload_Bool_Exp;
};

/** columns and relationships of "speckle_user_data" */
export type SpeckleUserData = {
  __typename?: 'speckleUserData';
  accessToken: Scalars['String']['output'];
  email: Scalars['String']['output'];
  speckleId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** aggregated selection of "speckle_user_data" */
export type SpeckleUserData_Aggregate = {
  __typename?: 'speckleUserData_aggregate';
  aggregate?: Maybe<SpeckleUserData_Aggregate_Fields>;
  nodes: Array<SpeckleUserData>;
};

/** aggregate fields of "speckle_user_data" */
export type SpeckleUserData_Aggregate_Fields = {
  __typename?: 'speckleUserData_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<SpeckleUserData_Max_Fields>;
  min?: Maybe<SpeckleUserData_Min_Fields>;
};


/** aggregate fields of "speckle_user_data" */
export type SpeckleUserData_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SpeckleUserData_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "speckle_user_data". All fields are combined with a logical 'AND'. */
export type SpeckleUserData_Bool_Exp = {
  _and?: InputMaybe<Array<SpeckleUserData_Bool_Exp>>;
  _not?: InputMaybe<SpeckleUserData_Bool_Exp>;
  _or?: InputMaybe<Array<SpeckleUserData_Bool_Exp>>;
  accessToken?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  speckleId?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "speckle_user_data" */
export enum SpeckleUserData_Constraint {
  /** unique or primary key constraint on columns "email" */
  speckle_user_data_email_key = 'speckle_user_data_email_key',
  /** unique or primary key constraint on columns "user_id" */
  speckle_user_data_pkey = 'speckle_user_data_pkey',
  /** unique or primary key constraint on columns "speckle_id" */
  speckle_user_data_speckleId_key = 'speckle_user_data_speckleId_key'
}

/** input type for inserting data into table "speckle_user_data" */
export type SpeckleUserData_Insert_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  speckleId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type SpeckleUserData_Max_Fields = {
  __typename?: 'speckleUserData_max_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  speckleId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type SpeckleUserData_Min_Fields = {
  __typename?: 'speckleUserData_min_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  speckleId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "speckle_user_data" */
export type SpeckleUserData_Mutation_Response = {
  __typename?: 'speckleUserData_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SpeckleUserData>;
};

/** on_conflict condition type for table "speckle_user_data" */
export type SpeckleUserData_On_Conflict = {
  constraint: SpeckleUserData_Constraint;
  update_columns?: Array<SpeckleUserData_Update_Column>;
  where?: InputMaybe<SpeckleUserData_Bool_Exp>;
};

/** Ordering options when selecting data from "speckle_user_data". */
export type SpeckleUserData_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  speckleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: speckle_user_data */
export type SpeckleUserData_Pk_Columns_Input = {
  userId: Scalars['String']['input'];
};

/** select columns of table "speckle_user_data" */
export enum SpeckleUserData_Select_Column {
  /** column name */
  accessToken = 'accessToken',
  /** column name */
  email = 'email',
  /** column name */
  speckleId = 'speckleId',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "speckle_user_data" */
export type SpeckleUserData_Set_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  speckleId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "speckleUserData" */
export type SpeckleUserData_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SpeckleUserData_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SpeckleUserData_Stream_Cursor_Value_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  speckleId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "speckle_user_data" */
export enum SpeckleUserData_Update_Column {
  /** column name */
  accessToken = 'accessToken',
  /** column name */
  email = 'email',
  /** column name */
  speckleId = 'speckleId',
  /** column name */
  userId = 'userId'
}

export type SpeckleUserData_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpeckleUserData_Set_Input>;
  /** filter the rows which have to be updated */
  where: SpeckleUserData_Bool_Exp;
};

/** columns and relationships of "speckle_stream" */
export type Speckle_Stream = {
  __typename?: 'speckle_stream';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
};

export type Speckle_Stream_Aggregate = {
  __typename?: 'speckle_stream_aggregate';
  aggregate?: Maybe<Speckle_Stream_Aggregate_Fields>;
  nodes: Array<Speckle_Stream>;
};

/** aggregate fields of "speckle_stream" */
export type Speckle_Stream_Aggregate_Fields = {
  __typename?: 'speckle_stream_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Speckle_Stream_Max_Fields>;
  min?: Maybe<Speckle_Stream_Min_Fields>;
};


/** aggregate fields of "speckle_stream" */
export type Speckle_Stream_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Speckle_Stream_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "speckle_stream". All fields are combined with a logical 'AND'. */
export type Speckle_Stream_Bool_Exp = {
  _and?: InputMaybe<Array<Speckle_Stream_Bool_Exp>>;
  _not?: InputMaybe<Speckle_Stream_Bool_Exp>;
  _or?: InputMaybe<Array<Speckle_Stream_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "speckle_stream" */
export enum Speckle_Stream_Constraint {
  /** unique or primary key constraint on columns "id" */
  project_speckle_pkey = 'project_speckle_pkey'
}

/** input type for inserting data into table "speckle_stream" */
export type Speckle_Stream_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Speckle_Stream_Max_Fields = {
  __typename?: 'speckle_stream_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Speckle_Stream_Min_Fields = {
  __typename?: 'speckle_stream_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "speckle_stream" */
export type Speckle_Stream_Mutation_Response = {
  __typename?: 'speckle_stream_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Speckle_Stream>;
};

/** input type for inserting object relation for remote table "speckle_stream" */
export type Speckle_Stream_Obj_Rel_Insert_Input = {
  data: Speckle_Stream_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Speckle_Stream_On_Conflict>;
};

/** on_conflict condition type for table "speckle_stream" */
export type Speckle_Stream_On_Conflict = {
  constraint: Speckle_Stream_Constraint;
  update_columns?: Array<Speckle_Stream_Update_Column>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};

/** Ordering options when selecting data from "speckle_stream". */
export type Speckle_Stream_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: speckle_stream */
export type Speckle_Stream_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "speckle_stream" */
export enum Speckle_Stream_Select_Column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id'
}

/** input type for updating data in table "speckle_stream" */
export type Speckle_Stream_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "speckle_stream" */
export type Speckle_Stream_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Speckle_Stream_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Speckle_Stream_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "speckle_stream" */
export enum Speckle_Stream_Update_Column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id'
}

export type Speckle_Stream_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Speckle_Stream_Set_Input>;
  /** filter the rows which have to be updated */
  where: Speckle_Stream_Bool_Exp;
};

/** columns and relationships of "stage" */
export type Stage = {
  __typename?: 'stage';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** columns and relationships of "stage_default_emission" */
export type StageDefaultEmission = {
  __typename?: 'stageDefaultEmission';
  country: Country_Enum;
  /** An object relationship */
  countryConfig?: Maybe<CountryConfig>;
  /** An object relationship */
  denominatorUnit?: Maybe<DenominatorUnit>;
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indicatorType: IndicatorType;
  indicatorTypeId: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  /** An array relationship */
  projectStandardValueStages: Array<ProjectStandardValueStage>;
  /** An aggregate relationship */
  projectStandardValueStages_aggregate: ProjectStandardValueStage_Aggregate;
  /** An object relationship */
  stage: Stage;
  /** An array relationship */
  stageDefaultEmissionBuildingTypes: Array<Stage_Default_Emission_Building_Type>;
  /** An aggregate relationship */
  stageDefaultEmissionBuildingTypes_aggregate: Stage_Default_Emission_Building_Type_Aggregate;
  stageId: Scalars['Int']['output'];
  value: Scalars['numeric']['output'];
};


/** columns and relationships of "stage_default_emission" */
export type StageDefaultEmissionProjectStandardValueStagesArgs = {
  distinct_on?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStandardValueStage_Order_By>>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};


/** columns and relationships of "stage_default_emission" */
export type StageDefaultEmissionProjectStandardValueStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStandardValueStage_Order_By>>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};


/** columns and relationships of "stage_default_emission" */
export type StageDefaultEmissionStageDefaultEmissionBuildingTypesArgs = {
  distinct_on?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Order_By>>;
  where?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
};


/** columns and relationships of "stage_default_emission" */
export type StageDefaultEmissionStageDefaultEmissionBuildingTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Order_By>>;
  where?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
};

/** aggregated selection of "stage_default_emission" */
export type StageDefaultEmission_Aggregate = {
  __typename?: 'stageDefaultEmission_aggregate';
  aggregate?: Maybe<StageDefaultEmission_Aggregate_Fields>;
  nodes: Array<StageDefaultEmission>;
};

/** aggregate fields of "stage_default_emission" */
export type StageDefaultEmission_Aggregate_Fields = {
  __typename?: 'stageDefaultEmission_aggregate_fields';
  avg?: Maybe<StageDefaultEmission_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<StageDefaultEmission_Max_Fields>;
  min?: Maybe<StageDefaultEmission_Min_Fields>;
  stddev?: Maybe<StageDefaultEmission_Stddev_Fields>;
  stddev_pop?: Maybe<StageDefaultEmission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StageDefaultEmission_Stddev_Samp_Fields>;
  sum?: Maybe<StageDefaultEmission_Sum_Fields>;
  var_pop?: Maybe<StageDefaultEmission_Var_Pop_Fields>;
  var_samp?: Maybe<StageDefaultEmission_Var_Samp_Fields>;
  variance?: Maybe<StageDefaultEmission_Variance_Fields>;
};


/** aggregate fields of "stage_default_emission" */
export type StageDefaultEmission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StageDefaultEmission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type StageDefaultEmission_Avg_Fields = {
  __typename?: 'stageDefaultEmission_avg_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "stage_default_emission". All fields are combined with a logical 'AND'. */
export type StageDefaultEmission_Bool_Exp = {
  _and?: InputMaybe<Array<StageDefaultEmission_Bool_Exp>>;
  _not?: InputMaybe<StageDefaultEmission_Bool_Exp>;
  _or?: InputMaybe<Array<StageDefaultEmission_Bool_Exp>>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  countryConfig?: InputMaybe<CountryConfig_Bool_Exp>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Bool_Exp>;
  denominatorUnitId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  indicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  projectStandardValueStages?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
  projectStandardValueStages_aggregate?: InputMaybe<ProjectStandardValueStage_Aggregate_Bool_Exp>;
  stage?: InputMaybe<Stage_Bool_Exp>;
  stageDefaultEmissionBuildingTypes?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
  stageDefaultEmissionBuildingTypes_aggregate?: InputMaybe<Stage_Default_Emission_Building_Type_Aggregate_Bool_Exp>;
  stageId?: InputMaybe<Int_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "stage_default_emission" */
export enum StageDefaultEmission_Constraint {
  /** unique or primary key constraint on columns "id" */
  stage_default_emission_pkey = 'stage_default_emission_pkey'
}

/** input type for incrementing numeric columns in table "stage_default_emission" */
export type StageDefaultEmission_Inc_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "stage_default_emission" */
export type StageDefaultEmission_Insert_Input = {
  country?: InputMaybe<Country_Enum>;
  countryConfig?: InputMaybe<CountryConfig_Obj_Rel_Insert_Input>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Obj_Rel_Insert_Input>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectStandardValueStages?: InputMaybe<ProjectStandardValueStage_Arr_Rel_Insert_Input>;
  stage?: InputMaybe<Stage_Obj_Rel_Insert_Input>;
  stageDefaultEmissionBuildingTypes?: InputMaybe<Stage_Default_Emission_Building_Type_Arr_Rel_Insert_Input>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type StageDefaultEmission_Max_Fields = {
  __typename?: 'stageDefaultEmission_max_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type StageDefaultEmission_Min_Fields = {
  __typename?: 'stageDefaultEmission_min_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "stage_default_emission" */
export type StageDefaultEmission_Mutation_Response = {
  __typename?: 'stageDefaultEmission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<StageDefaultEmission>;
};

/** input type for inserting object relation for remote table "stage_default_emission" */
export type StageDefaultEmission_Obj_Rel_Insert_Input = {
  data: StageDefaultEmission_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<StageDefaultEmission_On_Conflict>;
};

/** on_conflict condition type for table "stage_default_emission" */
export type StageDefaultEmission_On_Conflict = {
  constraint: StageDefaultEmission_Constraint;
  update_columns?: Array<StageDefaultEmission_Update_Column>;
  where?: InputMaybe<StageDefaultEmission_Bool_Exp>;
};

/** Ordering options when selecting data from "stage_default_emission". */
export type StageDefaultEmission_Order_By = {
  country?: InputMaybe<Order_By>;
  countryConfig?: InputMaybe<CountryConfig_Order_By>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Order_By>;
  denominatorUnitId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicatorType?: InputMaybe<IndicatorType_Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  projectStandardValueStages_aggregate?: InputMaybe<ProjectStandardValueStage_Aggregate_Order_By>;
  stage?: InputMaybe<Stage_Order_By>;
  stageDefaultEmissionBuildingTypes_aggregate?: InputMaybe<Stage_Default_Emission_Building_Type_Aggregate_Order_By>;
  stageId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stage_default_emission */
export type StageDefaultEmission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "stage_default_emission" */
export enum StageDefaultEmission_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  label = 'label',
  /** column name */
  stageId = 'stageId',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "stage_default_emission" */
export type StageDefaultEmission_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type StageDefaultEmission_Stddev_Fields = {
  __typename?: 'stageDefaultEmission_stddev_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type StageDefaultEmission_Stddev_Pop_Fields = {
  __typename?: 'stageDefaultEmission_stddev_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type StageDefaultEmission_Stddev_Samp_Fields = {
  __typename?: 'stageDefaultEmission_stddev_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "stageDefaultEmission" */
export type StageDefaultEmission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StageDefaultEmission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StageDefaultEmission_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type StageDefaultEmission_Sum_Fields = {
  __typename?: 'stageDefaultEmission_sum_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "stage_default_emission" */
export enum StageDefaultEmission_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  label = 'label',
  /** column name */
  stageId = 'stageId',
  /** column name */
  value = 'value'
}

export type StageDefaultEmission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StageDefaultEmission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StageDefaultEmission_Set_Input>;
  /** filter the rows which have to be updated */
  where: StageDefaultEmission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StageDefaultEmission_Var_Pop_Fields = {
  __typename?: 'stageDefaultEmission_var_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type StageDefaultEmission_Var_Samp_Fields = {
  __typename?: 'stageDefaultEmission_var_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type StageDefaultEmission_Variance_Fields = {
  __typename?: 'stageDefaultEmission_variance_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
  stageId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "stage" */
export type Stage_Aggregate = {
  __typename?: 'stage_aggregate';
  aggregate?: Maybe<Stage_Aggregate_Fields>;
  nodes: Array<Stage>;
};

/** aggregate fields of "stage" */
export type Stage_Aggregate_Fields = {
  __typename?: 'stage_aggregate_fields';
  avg?: Maybe<Stage_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Stage_Max_Fields>;
  min?: Maybe<Stage_Min_Fields>;
  stddev?: Maybe<Stage_Stddev_Fields>;
  stddev_pop?: Maybe<Stage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stage_Stddev_Samp_Fields>;
  sum?: Maybe<Stage_Sum_Fields>;
  var_pop?: Maybe<Stage_Var_Pop_Fields>;
  var_samp?: Maybe<Stage_Var_Samp_Fields>;
  variance?: Maybe<Stage_Variance_Fields>;
};


/** aggregate fields of "stage" */
export type Stage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Stage_Avg_Fields = {
  __typename?: 'stage_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "stage". All fields are combined with a logical 'AND'. */
export type Stage_Bool_Exp = {
  _and?: InputMaybe<Array<Stage_Bool_Exp>>;
  _not?: InputMaybe<Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Stage_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "stage" */
export enum Stage_Constraint {
  /** unique or primary key constraint on columns "id" */
  stage_pkey = 'stage_pkey'
}

/** columns and relationships of "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type = {
  __typename?: 'stage_default_emission_building_type';
  buildingTypeId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  stageDefaultEmissionId: Scalars['uuid']['output'];
};

/** aggregated selection of "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Aggregate = {
  __typename?: 'stage_default_emission_building_type_aggregate';
  aggregate?: Maybe<Stage_Default_Emission_Building_Type_Aggregate_Fields>;
  nodes: Array<Stage_Default_Emission_Building_Type>;
};

export type Stage_Default_Emission_Building_Type_Aggregate_Bool_Exp = {
  count?: InputMaybe<Stage_Default_Emission_Building_Type_Aggregate_Bool_Exp_Count>;
};

export type Stage_Default_Emission_Building_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Aggregate_Fields = {
  __typename?: 'stage_default_emission_building_type_aggregate_fields';
  avg?: Maybe<Stage_Default_Emission_Building_Type_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Stage_Default_Emission_Building_Type_Max_Fields>;
  min?: Maybe<Stage_Default_Emission_Building_Type_Min_Fields>;
  stddev?: Maybe<Stage_Default_Emission_Building_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Stage_Default_Emission_Building_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stage_Default_Emission_Building_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Stage_Default_Emission_Building_Type_Sum_Fields>;
  var_pop?: Maybe<Stage_Default_Emission_Building_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Stage_Default_Emission_Building_Type_Var_Samp_Fields>;
  variance?: Maybe<Stage_Default_Emission_Building_Type_Variance_Fields>;
};


/** aggregate fields of "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Aggregate_Order_By = {
  avg?: InputMaybe<Stage_Default_Emission_Building_Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stage_Default_Emission_Building_Type_Max_Order_By>;
  min?: InputMaybe<Stage_Default_Emission_Building_Type_Min_Order_By>;
  stddev?: InputMaybe<Stage_Default_Emission_Building_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stage_Default_Emission_Building_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stage_Default_Emission_Building_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stage_Default_Emission_Building_Type_Sum_Order_By>;
  var_pop?: InputMaybe<Stage_Default_Emission_Building_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stage_Default_Emission_Building_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Stage_Default_Emission_Building_Type_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Arr_Rel_Insert_Input = {
  data: Array<Stage_Default_Emission_Building_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stage_Default_Emission_Building_Type_On_Conflict>;
};

/** aggregate avg on columns */
export type Stage_Default_Emission_Building_Type_Avg_Fields = {
  __typename?: 'stage_default_emission_building_type_avg_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Avg_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stage_default_emission_building_type". All fields are combined with a logical 'AND'. */
export type Stage_Default_Emission_Building_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Bool_Exp>>;
  _not?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Bool_Exp>>;
  buildingTypeId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  stageDefaultEmissionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "stage_default_emission_building_type" */
export enum Stage_Default_Emission_Building_Type_Constraint {
  /** unique or primary key constraint on columns "stage_default_emission_id", "building_type_id" */
  stage_default_emission_buildi_stage_default_emission_id_bui_key = 'stage_default_emission_buildi_stage_default_emission_id_bui_key',
  /** unique or primary key constraint on columns "id" */
  stage_default_emission_building_type_pkey = 'stage_default_emission_building_type_pkey'
}

/** input type for incrementing numeric columns in table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Inc_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Insert_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stageDefaultEmissionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Stage_Default_Emission_Building_Type_Max_Fields = {
  __typename?: 'stage_default_emission_building_type_max_fields';
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stageDefaultEmissionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Max_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stageDefaultEmissionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stage_Default_Emission_Building_Type_Min_Fields = {
  __typename?: 'stage_default_emission_building_type_min_fields';
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stageDefaultEmissionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Min_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stageDefaultEmissionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Mutation_Response = {
  __typename?: 'stage_default_emission_building_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Stage_Default_Emission_Building_Type>;
};

/** on_conflict condition type for table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_On_Conflict = {
  constraint: Stage_Default_Emission_Building_Type_Constraint;
  update_columns?: Array<Stage_Default_Emission_Building_Type_Update_Column>;
  where?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "stage_default_emission_building_type". */
export type Stage_Default_Emission_Building_Type_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stageDefaultEmissionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stage_default_emission_building_type */
export type Stage_Default_Emission_Building_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "stage_default_emission_building_type" */
export enum Stage_Default_Emission_Building_Type_Select_Column {
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  id = 'id',
  /** column name */
  stageDefaultEmissionId = 'stageDefaultEmissionId'
}

/** input type for updating data in table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Set_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stageDefaultEmissionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Stage_Default_Emission_Building_Type_Stddev_Fields = {
  __typename?: 'stage_default_emission_building_type_stddev_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Stddev_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stage_Default_Emission_Building_Type_Stddev_Pop_Fields = {
  __typename?: 'stage_default_emission_building_type_stddev_pop_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Stddev_Pop_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stage_Default_Emission_Building_Type_Stddev_Samp_Fields = {
  __typename?: 'stage_default_emission_building_type_stddev_samp_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Stddev_Samp_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stage_Default_Emission_Building_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stage_Default_Emission_Building_Type_Stream_Cursor_Value_Input = {
  buildingTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stageDefaultEmissionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Stage_Default_Emission_Building_Type_Sum_Fields = {
  __typename?: 'stage_default_emission_building_type_sum_fields';
  buildingTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Sum_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "stage_default_emission_building_type" */
export enum Stage_Default_Emission_Building_Type_Update_Column {
  /** column name */
  buildingTypeId = 'buildingTypeId',
  /** column name */
  id = 'id',
  /** column name */
  stageDefaultEmissionId = 'stageDefaultEmissionId'
}

export type Stage_Default_Emission_Building_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stage_Default_Emission_Building_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stage_Default_Emission_Building_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stage_Default_Emission_Building_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stage_Default_Emission_Building_Type_Var_Pop_Fields = {
  __typename?: 'stage_default_emission_building_type_var_pop_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Var_Pop_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stage_Default_Emission_Building_Type_Var_Samp_Fields = {
  __typename?: 'stage_default_emission_building_type_var_samp_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Var_Samp_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stage_Default_Emission_Building_Type_Variance_Fields = {
  __typename?: 'stage_default_emission_building_type_variance_fields';
  buildingTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "stage_default_emission_building_type" */
export type Stage_Default_Emission_Building_Type_Variance_Order_By = {
  buildingTypeId?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "stage" */
export type Stage_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "stage" */
export type Stage_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Stage_Max_Fields = {
  __typename?: 'stage_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Stage_Min_Fields = {
  __typename?: 'stage_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "stage" */
export type Stage_Mutation_Response = {
  __typename?: 'stage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Stage>;
};

/** input type for inserting object relation for remote table "stage" */
export type Stage_Obj_Rel_Insert_Input = {
  data: Stage_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Stage_On_Conflict>;
};

/** on_conflict condition type for table "stage" */
export type Stage_On_Conflict = {
  constraint: Stage_Constraint;
  update_columns?: Array<Stage_Update_Column>;
  where?: InputMaybe<Stage_Bool_Exp>;
};

/** Ordering options when selecting data from "stage". */
export type Stage_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stage */
export type Stage_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "stage" */
export enum Stage_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

/** input type for updating data in table "stage" */
export type Stage_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Stage_Stddev_Fields = {
  __typename?: 'stage_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Stage_Stddev_Pop_Fields = {
  __typename?: 'stage_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Stage_Stddev_Samp_Fields = {
  __typename?: 'stage_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "stage" */
export type Stage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stage_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Stage_Sum_Fields = {
  __typename?: 'stage_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "stage" */
export enum Stage_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  label = 'label'
}

export type Stage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stage_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stage_Var_Pop_Fields = {
  __typename?: 'stage_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Stage_Var_Samp_Fields = {
  __typename?: 'stage_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Stage_Variance_Fields = {
  __typename?: 'stage_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "agent_model_pricing" */
  agentModelPricing: Array<AgentModelPricing>;
  /** fetch aggregated fields from the table: "agent_model_pricing" */
  agentModelPricing_aggregate: AgentModelPricing_Aggregate;
  /** fetch data from the table: "agent_model_pricing" using primary key columns */
  agentModelPricing_by_pk?: Maybe<AgentModelPricing>;
  /** fetch data from the table in a streaming manner: "agent_model_pricing" */
  agentModelPricing_stream: Array<AgentModelPricing>;
  /** fetch data from the table: "agent_skills_tenant_user" */
  agentSkillsTenantUser: Array<AgentSkillsTenantUser>;
  /** fetch aggregated fields from the table: "agent_skills_tenant_user" */
  agentSkillsTenantUser_aggregate: AgentSkillsTenantUser_Aggregate;
  /** fetch data from the table: "agent_skills_tenant_user" using primary key columns */
  agentSkillsTenantUser_by_pk?: Maybe<AgentSkillsTenantUser>;
  /** fetch data from the table in a streaming manner: "agent_skills_tenant_user" */
  agentSkillsTenantUser_stream: Array<AgentSkillsTenantUser>;
  /** fetch data from the table: "agent_usage_budget_status" */
  agentUsageBudgetStatus: Array<AgentUsageBudgetStatus>;
  /** fetch aggregated fields from the table: "agent_usage_budget_status" */
  agentUsageBudgetStatus_aggregate: AgentUsageBudgetStatus_Aggregate;
  /** fetch data from the table in a streaming manner: "agent_usage_budget_status" */
  agentUsageBudgetStatus_stream: Array<AgentUsageBudgetStatus>;
  /** fetch data from the table: "agent_usage_daily" */
  agentUsageDaily: Array<AgentUsageDaily>;
  /** fetch aggregated fields from the table: "agent_usage_daily" */
  agentUsageDaily_aggregate: AgentUsageDaily_Aggregate;
  /** fetch data from the table in a streaming manner: "agent_usage_daily" */
  agentUsageDaily_stream: Array<AgentUsageDaily>;
  /** fetch data from the table: "agent_usage_request" */
  agentUsageRequest: Array<AgentUsageRequest>;
  /** fetch aggregated fields from the table: "agent_usage_request" */
  agentUsageRequest_aggregate: AgentUsageRequest_Aggregate;
  /** fetch data from the table in a streaming manner: "agent_usage_request" */
  agentUsageRequest_stream: Array<AgentUsageRequest>;
  /** fetch data from the table: "agent_usage_session" */
  agentUsageSession: Array<AgentUsageSession>;
  /** fetch aggregated fields from the table: "agent_usage_session" */
  agentUsageSession_aggregate: AgentUsageSession_Aggregate;
  /** fetch data from the table in a streaming manner: "agent_usage_session" */
  agentUsageSession_stream: Array<AgentUsageSession>;
  /** fetch data from the table: "application_source" */
  applicationSource: Array<ApplicationSource>;
  /** fetch aggregated fields from the table: "application_source" */
  applicationSource_aggregate: ApplicationSource_Aggregate;
  /** fetch data from the table: "application_source" using primary key columns */
  applicationSource_by_pk?: Maybe<ApplicationSource>;
  /** fetch data from the table in a streaming manner: "application_source" */
  applicationSource_stream: Array<ApplicationSource>;
  /** fetch data from the table: "benchmark_grouping_verdict" */
  benchmarkGroupingVerdict: Array<BenchmarkGroupingVerdict>;
  /** fetch aggregated fields from the table: "benchmark_grouping_verdict" */
  benchmarkGroupingVerdict_aggregate: BenchmarkGroupingVerdict_Aggregate;
  /** fetch data from the table: "benchmark_grouping_verdict" using primary key columns */
  benchmarkGroupingVerdict_by_pk?: Maybe<BenchmarkGroupingVerdict>;
  /** fetch data from the table in a streaming manner: "benchmark_grouping_verdict" */
  benchmarkGroupingVerdict_stream: Array<BenchmarkGroupingVerdict>;
  /** fetch data from the table: "benchmark_inventory_material" */
  benchmarkInventoryMaterial: Array<BenchmarkInventoryMaterial>;
  /** fetch aggregated fields from the table: "benchmark_inventory_material" */
  benchmarkInventoryMaterial_aggregate: BenchmarkInventoryMaterial_Aggregate;
  /** fetch data from the table: "benchmark_inventory_material" using primary key columns */
  benchmarkInventoryMaterial_by_pk?: Maybe<BenchmarkInventoryMaterial>;
  /** fetch data from the table in a streaming manner: "benchmark_inventory_material" */
  benchmarkInventoryMaterial_stream: Array<BenchmarkInventoryMaterial>;
  /** fetch data from the table: "benchmark_material_mapping" */
  benchmarkMaterialMapping: Array<BenchmarkMaterialMapping>;
  /** fetch aggregated fields from the table: "benchmark_material_mapping" */
  benchmarkMaterialMapping_aggregate: BenchmarkMaterialMapping_Aggregate;
  /** fetch data from the table: "benchmark_material_mapping" using primary key columns */
  benchmarkMaterialMapping_by_pk?: Maybe<BenchmarkMaterialMapping>;
  /** fetch data from the table in a streaming manner: "benchmark_material_mapping" */
  benchmarkMaterialMapping_stream: Array<BenchmarkMaterialMapping>;
  /** fetch data from the table: "benchmark_project_state" */
  benchmarkProjectState: Array<BenchmarkProjectState>;
  /** fetch aggregated fields from the table: "benchmark_project_state" */
  benchmarkProjectState_aggregate: BenchmarkProjectState_Aggregate;
  /** fetch data from the table: "benchmark_project_state" using primary key columns */
  benchmarkProjectState_by_pk?: Maybe<BenchmarkProjectState>;
  /** fetch data from the table in a streaming manner: "benchmark_project_state" */
  benchmarkProjectState_stream: Array<BenchmarkProjectState>;
  /** fetch data from the table: "benchmark_snapshot" */
  benchmarkSnapshot: Array<BenchmarkSnapshot>;
  /** fetch aggregated fields from the table: "benchmark_snapshot" */
  benchmarkSnapshot_aggregate: BenchmarkSnapshot_Aggregate;
  /** fetch data from the table: "benchmark_snapshot" using primary key columns */
  benchmarkSnapshot_by_pk?: Maybe<BenchmarkSnapshot>;
  /** fetch data from the table in a streaming manner: "benchmark_snapshot" */
  benchmarkSnapshot_stream: Array<BenchmarkSnapshot>;
  /** fetch data from the table: "building_area_type" */
  buildingAreaType: Array<BuildingAreaType>;
  /** fetch aggregated fields from the table: "building_area_type" */
  buildingAreaType_aggregate: BuildingAreaType_Aggregate;
  /** fetch data from the table: "building_area_type" using primary key columns */
  buildingAreaType_by_pk?: Maybe<BuildingAreaType>;
  /** fetch data from the table in a streaming manner: "building_area_type" */
  buildingAreaType_stream: Array<BuildingAreaType>;
  /** fetch data from the table: "building_part" */
  buildingPart: Array<BuildingPart>;
  /** fetch data from the table: "building_part_lifetime_source" */
  buildingPartLifetimeSource: Array<BuildingPartLifetimeSource>;
  /** fetch aggregated fields from the table: "building_part_lifetime_source" */
  buildingPartLifetimeSource_aggregate: BuildingPartLifetimeSource_Aggregate;
  /** fetch data from the table: "building_part_lifetime_source" using primary key columns */
  buildingPartLifetimeSource_by_pk?: Maybe<BuildingPartLifetimeSource>;
  /** fetch data from the table in a streaming manner: "building_part_lifetime_source" */
  buildingPartLifetimeSource_stream: Array<BuildingPartLifetimeSource>;
  /** fetch data from the table: "building_part_maintenance_lifetime" */
  buildingPartMaintenanceLifetime: Array<BuildingPartMaintenanceLifetime>;
  /** fetch aggregated fields from the table: "building_part_maintenance_lifetime" */
  buildingPartMaintenanceLifetime_aggregate: BuildingPartMaintenanceLifetime_Aggregate;
  /** fetch data from the table: "building_part_maintenance_lifetime" using primary key columns */
  buildingPartMaintenanceLifetime_by_pk?: Maybe<BuildingPartMaintenanceLifetime>;
  /** fetch data from the table in a streaming manner: "building_part_maintenance_lifetime" */
  buildingPartMaintenanceLifetime_stream: Array<BuildingPartMaintenanceLifetime>;
  /** fetch data from the table: "building_part_service_lifetime" */
  buildingPartServiceLifetime: Array<BuildingPartServiceLifetime>;
  /** fetch aggregated fields from the table: "building_part_service_lifetime" */
  buildingPartServiceLifetime_aggregate: BuildingPartServiceLifetime_Aggregate;
  /** fetch data from the table: "building_part_service_lifetime" using primary key columns */
  buildingPartServiceLifetime_by_pk?: Maybe<BuildingPartServiceLifetime>;
  /** fetch data from the table in a streaming manner: "building_part_service_lifetime" */
  buildingPartServiceLifetime_stream: Array<BuildingPartServiceLifetime>;
  /** fetch aggregated fields from the table: "building_part" */
  buildingPart_aggregate: BuildingPart_Aggregate;
  /** fetch data from the table: "building_part" using primary key columns */
  buildingPart_by_pk?: Maybe<BuildingPart>;
  /** fetch data from the table in a streaming manner: "building_part" */
  buildingPart_stream: Array<BuildingPart>;
  /** fetch data from the table: "building_type" */
  buildingType: Array<BuildingType>;
  /** fetch aggregated fields from the table: "building_type" */
  buildingType_aggregate: BuildingType_Aggregate;
  /** fetch data from the table: "building_type" using primary key columns */
  buildingType_by_pk?: Maybe<BuildingType>;
  /** fetch data from the table in a streaming manner: "building_type" */
  buildingType_stream: Array<BuildingType>;
  /** fetch data from the table: "building_element" */
  building_element: Array<Building_Element>;
  /** fetch aggregated fields from the table: "building_element" */
  building_element_aggregate: Building_Element_Aggregate;
  /** fetch data from the table: "building_element" using primary key columns */
  building_element_by_pk?: Maybe<Building_Element>;
  /** fetch data from the table: "building_element_classification_code_mapping" */
  building_element_classification_code_mapping: Array<Building_Element_Classification_Code_Mapping>;
  /** fetch aggregated fields from the table: "building_element_classification_code_mapping" */
  building_element_classification_code_mapping_aggregate: Building_Element_Classification_Code_Mapping_Aggregate;
  /** fetch data from the table: "building_element_classification_code_mapping" using primary key columns */
  building_element_classification_code_mapping_by_pk?: Maybe<Building_Element_Classification_Code_Mapping>;
  /** fetch data from the table in a streaming manner: "building_element_classification_code_mapping" */
  building_element_classification_code_mapping_stream: Array<Building_Element_Classification_Code_Mapping>;
  /** fetch data from the table: "building_element_material_category_mapping" */
  building_element_material_category_mapping: Array<Building_Element_Material_Category_Mapping>;
  /** fetch aggregated fields from the table: "building_element_material_category_mapping" */
  building_element_material_category_mapping_aggregate: Building_Element_Material_Category_Mapping_Aggregate;
  /** fetch data from the table: "building_element_material_category_mapping" using primary key columns */
  building_element_material_category_mapping_by_pk?: Maybe<Building_Element_Material_Category_Mapping>;
  /** fetch data from the table in a streaming manner: "building_element_material_category_mapping" */
  building_element_material_category_mapping_stream: Array<Building_Element_Material_Category_Mapping>;
  /** fetch data from the table in a streaming manner: "building_element" */
  building_element_stream: Array<Building_Element>;
  /** An array relationship */
  calculationType: Array<CalculationType>;
  /** fetch data from the table: "calculation_type_epd_datasource" */
  calculationTypeEpdDatasource: Array<CalculationTypeEpdDatasource>;
  /** fetch aggregated fields from the table: "calculation_type_epd_datasource" */
  calculationTypeEpdDatasource_aggregate: CalculationTypeEpdDatasource_Aggregate;
  /** fetch data from the table: "calculation_type_epd_datasource" using primary key columns */
  calculationTypeEpdDatasource_by_pk?: Maybe<CalculationTypeEpdDatasource>;
  /** fetch data from the table in a streaming manner: "calculation_type_epd_datasource" */
  calculationTypeEpdDatasource_stream: Array<CalculationTypeEpdDatasource>;
  /** fetch data from the table: "calculation_type_threshold_by_building_type" */
  calculationTypeThresholdByBuildingType: Array<CalculationTypeThresholdByBuildingType>;
  /** fetch aggregated fields from the table: "calculation_type_threshold_by_building_type" */
  calculationTypeThresholdByBuildingType_aggregate: CalculationTypeThresholdByBuildingType_Aggregate;
  /** fetch data from the table: "calculation_type_threshold_by_building_type" using primary key columns */
  calculationTypeThresholdByBuildingType_by_pk?: Maybe<CalculationTypeThresholdByBuildingType>;
  /** fetch data from the table in a streaming manner: "calculation_type_threshold_by_building_type" */
  calculationTypeThresholdByBuildingType_stream: Array<CalculationTypeThresholdByBuildingType>;
  /** fetch data from the table: "calculation_type_variant" */
  calculationTypeVariant: Array<CalculationTypeVariant>;
  /** fetch aggregated fields from the table: "calculation_type_variant" */
  calculationTypeVariant_aggregate: CalculationTypeVariant_Aggregate;
  /** fetch data from the table: "calculation_type_variant" using primary key columns */
  calculationTypeVariant_by_pk?: Maybe<CalculationTypeVariant>;
  /** fetch data from the table in a streaming manner: "calculation_type_variant" */
  calculationTypeVariant_stream: Array<CalculationTypeVariant>;
  /** An aggregate relationship */
  calculationType_aggregate: CalculationType_Aggregate;
  /** fetch data from the table: "calculation_type" using primary key columns */
  calculationType_by_pk?: Maybe<CalculationType>;
  /** fetch data from the table in a streaming manner: "calculation_type" */
  calculationType_stream: Array<CalculationType>;
  /** fetch data from the table: "calculation_type_stage" */
  calculation_type_stage: Array<Calculation_Type_Stage>;
  /** fetch aggregated fields from the table: "calculation_type_stage" */
  calculation_type_stage_aggregate: Calculation_Type_Stage_Aggregate;
  /** fetch data from the table: "calculation_type_stage" using primary key columns */
  calculation_type_stage_by_pk?: Maybe<Calculation_Type_Stage>;
  /** fetch data from the table in a streaming manner: "calculation_type_stage" */
  calculation_type_stage_stream: Array<Calculation_Type_Stage>;
  /** fetch data from the table: "classification_code" */
  classificationCode: Array<ClassificationCode>;
  /** fetch data from the table: "classification_code_translation" */
  classificationCodeTranslation: Array<ClassificationCodeTranslation>;
  /** fetch aggregated fields from the table: "classification_code_translation" */
  classificationCodeTranslation_aggregate: ClassificationCodeTranslation_Aggregate;
  /** fetch data from the table: "classification_code_translation" using primary key columns */
  classificationCodeTranslation_by_pk?: Maybe<ClassificationCodeTranslation>;
  /** fetch data from the table in a streaming manner: "classification_code_translation" */
  classificationCodeTranslation_stream: Array<ClassificationCodeTranslation>;
  /** fetch data from the table: "classification_type_country" */
  classificationCodeTypeCountry: Array<ClassificationCodeTypeCountry>;
  /** fetch aggregated fields from the table: "classification_type_country" */
  classificationCodeTypeCountry_aggregate: ClassificationCodeTypeCountry_Aggregate;
  /** fetch data from the table: "classification_type_country" using primary key columns */
  classificationCodeTypeCountry_by_pk?: Maybe<ClassificationCodeTypeCountry>;
  /** fetch data from the table in a streaming manner: "classification_type_country" */
  classificationCodeTypeCountry_stream: Array<ClassificationCodeTypeCountry>;
  /** fetch aggregated fields from the table: "classification_code" */
  classificationCode_aggregate: ClassificationCode_Aggregate;
  /** fetch data from the table: "classification_code" using primary key columns */
  classificationCode_by_pk?: Maybe<ClassificationCode>;
  /** fetch data from the table in a streaming manner: "classification_code" */
  classificationCode_stream: Array<ClassificationCode>;
  /** fetch data from the table: "classification_object_class" */
  classificationObjectClass: Array<ClassificationObjectClass>;
  /** An array relationship */
  classificationObjectClassParameter: Array<ClassificationObjectClassParameter>;
  /** An aggregate relationship */
  classificationObjectClassParameter_aggregate: ClassificationObjectClassParameter_Aggregate;
  /** fetch data from the table: "classification_object_class_parameter" using primary key columns */
  classificationObjectClassParameter_by_pk?: Maybe<ClassificationObjectClassParameter>;
  /** fetch data from the table in a streaming manner: "classification_object_class_parameter" */
  classificationObjectClassParameter_stream: Array<ClassificationObjectClassParameter>;
  /** fetch data from the table: "classification_object_class_translation" */
  classificationObjectClassTranslation: Array<ClassificationObjectClassTranslation>;
  /** fetch aggregated fields from the table: "classification_object_class_translation" */
  classificationObjectClassTranslation_aggregate: ClassificationObjectClassTranslation_Aggregate;
  /** fetch data from the table: "classification_object_class_translation" using primary key columns */
  classificationObjectClassTranslation_by_pk?: Maybe<ClassificationObjectClassTranslation>;
  /** fetch data from the table in a streaming manner: "classification_object_class_translation" */
  classificationObjectClassTranslation_stream: Array<ClassificationObjectClassTranslation>;
  /** fetch aggregated fields from the table: "classification_object_class" */
  classificationObjectClass_aggregate: ClassificationObjectClass_Aggregate;
  /** fetch data from the table: "classification_object_class" using primary key columns */
  classificationObjectClass_by_pk?: Maybe<ClassificationObjectClass>;
  /** fetch data from the table in a streaming manner: "classification_object_class" */
  classificationObjectClass_stream: Array<ClassificationObjectClass>;
  /** fetch data from the table: "classification_type" */
  classificationType: Array<ClassificationType>;
  /** fetch data from the table: "classification_type_parameter" */
  classificationTypeAttribute: Array<ClassificationTypeAttribute>;
  /** fetch aggregated fields from the table: "classification_type_parameter" */
  classificationTypeAttribute_aggregate: ClassificationTypeAttribute_Aggregate;
  /** fetch data from the table: "classification_type_parameter" using primary key columns */
  classificationTypeAttribute_by_pk?: Maybe<ClassificationTypeAttribute>;
  /** fetch data from the table in a streaming manner: "classification_type_parameter" */
  classificationTypeAttribute_stream: Array<ClassificationTypeAttribute>;
  /** fetch aggregated fields from the table: "classification_type" */
  classificationType_aggregate: ClassificationType_Aggregate;
  /** fetch data from the table: "classification_type" using primary key columns */
  classificationType_by_pk?: Maybe<ClassificationType>;
  /** fetch data from the table in a streaming manner: "classification_type" */
  classificationType_stream: Array<ClassificationType>;
  /** fetch data from the table: "component_object_phase" */
  componentObjectPhase: Array<ComponentObjectPhase>;
  /** fetch aggregated fields from the table: "component_object_phase" */
  componentObjectPhase_aggregate: ComponentObjectPhase_Aggregate;
  /** fetch data from the table: "component_object_phase" using primary key columns */
  componentObjectPhase_by_pk?: Maybe<ComponentObjectPhase>;
  /** fetch data from the table in a streaming manner: "component_object_phase" */
  componentObjectPhase_stream: Array<ComponentObjectPhase>;
  /** fetch data from the table: "construction" */
  construction: Array<Construction>;
  /** fetch data from the table: "construction_build_up_part" */
  constructionBuildUpPart: Array<ConstructionBuildUpPart>;
  /** fetch data from the table: "construction_build_up_part_material_category" */
  constructionBuildUpPartMaterialCategory: Array<ConstructionBuildUpPartMaterialCategory>;
  /** fetch aggregated fields from the table: "construction_build_up_part_material_category" */
  constructionBuildUpPartMaterialCategory_aggregate: ConstructionBuildUpPartMaterialCategory_Aggregate;
  /** fetch data from the table: "construction_build_up_part_material_category" using primary key columns */
  constructionBuildUpPartMaterialCategory_by_pk?: Maybe<ConstructionBuildUpPartMaterialCategory>;
  /** fetch data from the table in a streaming manner: "construction_build_up_part_material_category" */
  constructionBuildUpPartMaterialCategory_stream: Array<ConstructionBuildUpPartMaterialCategory>;
  /** fetch data from the table: "construction_build_up_part_translation" */
  constructionBuildUpPartTranslation: Array<ConstructionBuildUpPartTranslation>;
  /** fetch aggregated fields from the table: "construction_build_up_part_translation" */
  constructionBuildUpPartTranslation_aggregate: ConstructionBuildUpPartTranslation_Aggregate;
  /** fetch data from the table: "construction_build_up_part_translation" using primary key columns */
  constructionBuildUpPartTranslation_by_pk?: Maybe<ConstructionBuildUpPartTranslation>;
  /** fetch data from the table in a streaming manner: "construction_build_up_part_translation" */
  constructionBuildUpPartTranslation_stream: Array<ConstructionBuildUpPartTranslation>;
  /** fetch aggregated fields from the table: "construction_build_up_part" */
  constructionBuildUpPart_aggregate: ConstructionBuildUpPart_Aggregate;
  /** fetch data from the table: "construction_build_up_part" using primary key columns */
  constructionBuildUpPart_by_pk?: Maybe<ConstructionBuildUpPart>;
  /** fetch data from the table in a streaming manner: "construction_build_up_part" */
  constructionBuildUpPart_stream: Array<ConstructionBuildUpPart>;
  /** fetch data from the table: "construction_build_up_template" */
  constructionBuildUpTemplate: Array<ConstructionBuildUpTemplate>;
  /** fetch data from the table: "construction_build_up_template_translation" */
  constructionBuildUpTemplateTranslation: Array<ConstructionBuildUpTemplateTranslation>;
  /** fetch aggregated fields from the table: "construction_build_up_template_translation" */
  constructionBuildUpTemplateTranslation_aggregate: ConstructionBuildUpTemplateTranslation_Aggregate;
  /** fetch data from the table: "construction_build_up_template_translation" using primary key columns */
  constructionBuildUpTemplateTranslation_by_pk?: Maybe<ConstructionBuildUpTemplateTranslation>;
  /** fetch data from the table in a streaming manner: "construction_build_up_template_translation" */
  constructionBuildUpTemplateTranslation_stream: Array<ConstructionBuildUpTemplateTranslation>;
  /** fetch aggregated fields from the table: "construction_build_up_template" */
  constructionBuildUpTemplate_aggregate: ConstructionBuildUpTemplate_Aggregate;
  /** fetch data from the table: "construction_build_up_template" using primary key columns */
  constructionBuildUpTemplate_by_pk?: Maybe<ConstructionBuildUpTemplate>;
  /** fetch data from the table in a streaming manner: "construction_build_up_template" */
  constructionBuildUpTemplate_stream: Array<ConstructionBuildUpTemplate>;
  /** fetch data from the table: "construction_category" */
  constructionCategory: Array<ConstructionCategory>;
  /** fetch data from the table: "construction_category_translation" */
  constructionCategoryTranslation: Array<ConstructionCategoryTranslation>;
  /** fetch aggregated fields from the table: "construction_category_translation" */
  constructionCategoryTranslation_aggregate: ConstructionCategoryTranslation_Aggregate;
  /** fetch data from the table: "construction_category_translation" using primary key columns */
  constructionCategoryTranslation_by_pk?: Maybe<ConstructionCategoryTranslation>;
  /** fetch data from the table in a streaming manner: "construction_category_translation" */
  constructionCategoryTranslation_stream: Array<ConstructionCategoryTranslation>;
  /** fetch data from the table: "construction_category_unit" */
  constructionCategoryUnit: Array<ConstructionCategoryUnit>;
  /** fetch aggregated fields from the table: "construction_category_unit" */
  constructionCategoryUnit_aggregate: ConstructionCategoryUnit_Aggregate;
  /** fetch data from the table: "construction_category_unit" using primary key columns */
  constructionCategoryUnit_by_pk?: Maybe<ConstructionCategoryUnit>;
  /** fetch data from the table in a streaming manner: "construction_category_unit" */
  constructionCategoryUnit_stream: Array<ConstructionCategoryUnit>;
  /** fetch aggregated fields from the table: "construction_category" */
  constructionCategory_aggregate: ConstructionCategory_Aggregate;
  /** fetch data from the table: "construction_category" using primary key columns */
  constructionCategory_by_pk?: Maybe<ConstructionCategory>;
  /** fetch data from the table in a streaming manner: "construction_category" */
  constructionCategory_stream: Array<ConstructionCategory>;
  /** fetch data from the table: "construction_country" */
  constructionCountry: Array<ConstructionCountry>;
  /** fetch aggregated fields from the table: "construction_country" */
  constructionCountry_aggregate: ConstructionCountry_Aggregate;
  /** fetch data from the table: "construction_country" using primary key columns */
  constructionCountry_by_pk?: Maybe<ConstructionCountry>;
  /** fetch data from the table in a streaming manner: "construction_country" */
  constructionCountry_stream: Array<ConstructionCountry>;
  /** fetch data from the table: "construction_description" */
  constructionDescription: Array<ConstructionDescription>;
  /** fetch aggregated fields from the table: "construction_description" */
  constructionDescription_aggregate: ConstructionDescription_Aggregate;
  /** fetch data from the table: "construction_description" using primary key columns */
  constructionDescription_by_pk?: Maybe<ConstructionDescription>;
  /** fetch data from the table in a streaming manner: "construction_description" */
  constructionDescription_stream: Array<ConstructionDescription>;
  /** fetch data from the table: "construction_fork" */
  constructionFork: Array<ConstructionFork>;
  /** fetch aggregated fields from the table: "construction_fork" */
  constructionFork_aggregate: ConstructionFork_Aggregate;
  /** fetch data from the table: "construction_fork" using primary key columns */
  constructionFork_by_pk?: Maybe<ConstructionFork>;
  /** fetch data from the table in a streaming manner: "construction_fork" */
  constructionFork_stream: Array<ConstructionFork>;
  /** fetch data from the table: "construction_inhomogeneous_layer" */
  constructionInhomogeneousLayer: Array<ConstructionInhomogeneousLayer>;
  /** fetch data from the table: "construction_inhomogeneous_layer_material" */
  constructionInhomogeneousLayerMaterial: Array<ConstructionInhomogeneousLayerMaterial>;
  /** fetch aggregated fields from the table: "construction_inhomogeneous_layer_material" */
  constructionInhomogeneousLayerMaterial_aggregate: ConstructionInhomogeneousLayerMaterial_Aggregate;
  /** fetch data from the table: "construction_inhomogeneous_layer_material" using primary key columns */
  constructionInhomogeneousLayerMaterial_by_pk?: Maybe<ConstructionInhomogeneousLayerMaterial>;
  /** fetch data from the table in a streaming manner: "construction_inhomogeneous_layer_material" */
  constructionInhomogeneousLayerMaterial_stream: Array<ConstructionInhomogeneousLayerMaterial>;
  /** fetch aggregated fields from the table: "construction_inhomogeneous_layer" */
  constructionInhomogeneousLayer_aggregate: ConstructionInhomogeneousLayer_Aggregate;
  /** fetch data from the table: "construction_inhomogeneous_layer" using primary key columns */
  constructionInhomogeneousLayer_by_pk?: Maybe<ConstructionInhomogeneousLayer>;
  /** fetch data from the table in a streaming manner: "construction_inhomogeneous_layer" */
  constructionInhomogeneousLayer_stream: Array<ConstructionInhomogeneousLayer>;
  /** fetch data from the table: "construction_inhomogenous_layer_description" */
  constructionInhomogenousLayerDescription: Array<ConstructionInhomogenousLayerDescription>;
  /** fetch aggregated fields from the table: "construction_inhomogenous_layer_description" */
  constructionInhomogenousLayerDescription_aggregate: ConstructionInhomogenousLayerDescription_Aggregate;
  /** fetch data from the table: "construction_inhomogenous_layer_description" using primary key columns */
  constructionInhomogenousLayerDescription_by_pk?: Maybe<ConstructionInhomogenousLayerDescription>;
  /** fetch data from the table in a streaming manner: "construction_inhomogenous_layer_description" */
  constructionInhomogenousLayerDescription_stream: Array<ConstructionInhomogenousLayerDescription>;
  /** fetch data from the table: "construction_inhomogenous_layer_name" */
  constructionInhomogenousLayerName: Array<ConstructionInhomogenousLayerName>;
  /** fetch aggregated fields from the table: "construction_inhomogenous_layer_name" */
  constructionInhomogenousLayerName_aggregate: ConstructionInhomogenousLayerName_Aggregate;
  /** fetch data from the table: "construction_inhomogenous_layer_name" using primary key columns */
  constructionInhomogenousLayerName_by_pk?: Maybe<ConstructionInhomogenousLayerName>;
  /** fetch data from the table in a streaming manner: "construction_inhomogenous_layer_name" */
  constructionInhomogenousLayerName_stream: Array<ConstructionInhomogenousLayerName>;
  /** fetch data from the table: "construction_material" */
  constructionMaterial: Array<ConstructionMaterial>;
  /** fetch aggregated fields from the table: "construction_material" */
  constructionMaterial_aggregate: ConstructionMaterial_Aggregate;
  /** fetch data from the table: "construction_material" using primary key columns */
  constructionMaterial_by_pk?: Maybe<ConstructionMaterial>;
  /** fetch data from the table in a streaming manner: "construction_material" */
  constructionMaterial_stream: Array<ConstructionMaterial>;
  /** fetch data from the table: "construction_name" */
  constructionName: Array<ConstructionName>;
  /** fetch aggregated fields from the table: "construction_name" */
  constructionName_aggregate: ConstructionName_Aggregate;
  /** fetch data from the table: "construction_name" using primary key columns */
  constructionName_by_pk?: Maybe<ConstructionName>;
  /** fetch data from the table in a streaming manner: "construction_name" */
  constructionName_stream: Array<ConstructionName>;
  /** fetch data from the table: "construction_sorting" */
  constructionSorting: Array<ConstructionSorting>;
  /** fetch aggregated fields from the table: "construction_sorting" */
  constructionSorting_aggregate: ConstructionSorting_Aggregate;
  /** fetch data from the table: "construction_sorting" using primary key columns */
  constructionSorting_by_pk?: Maybe<ConstructionSorting>;
  /** fetch data from the table in a streaming manner: "construction_sorting" */
  constructionSorting_stream: Array<ConstructionSorting>;
  /** fetch aggregated fields from the table: "construction" */
  construction_aggregate: Construction_Aggregate;
  /** fetch data from the table: "construction" using primary key columns */
  construction_by_pk?: Maybe<Construction>;
  /** fetch data from the table in a streaming manner: "construction" */
  construction_stream: Array<Construction>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch data from the table: "country_config" */
  countryConfig: Array<CountryConfig>;
  /** fetch aggregated fields from the table: "country_config" */
  countryConfig_aggregate: CountryConfig_Aggregate;
  /** fetch data from the table: "country_config" using primary key columns */
  countryConfig_by_pk?: Maybe<CountryConfig>;
  /** fetch data from the table in a streaming manner: "country_config" */
  countryConfig_stream: Array<CountryConfig>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table in a streaming manner: "country" */
  country_stream: Array<Country>;
  /** fetch data from the table: "declared_unit" */
  declaredUnit: Array<DeclaredUnit>;
  /** fetch aggregated fields from the table: "declared_unit" */
  declaredUnit_aggregate: DeclaredUnit_Aggregate;
  /** fetch data from the table: "declared_unit" using primary key columns */
  declaredUnit_by_pk?: Maybe<DeclaredUnit>;
  /** fetch data from the table in a streaming manner: "declared_unit" */
  declaredUnit_stream: Array<DeclaredUnit>;
  /** fetch data from the table: "denominator_unit" */
  denominatorUnit: Array<DenominatorUnit>;
  /** fetch aggregated fields from the table: "denominator_unit" */
  denominatorUnit_aggregate: DenominatorUnit_Aggregate;
  /** fetch data from the table: "denominator_unit" using primary key columns */
  denominatorUnit_by_pk?: Maybe<DenominatorUnit>;
  /** fetch data from the table in a streaming manner: "denominator_unit" */
  denominatorUnit_stream: Array<DenominatorUnit>;
  /** fetch data from the table: "distance_unit" */
  distance_unit: Array<Distance_Unit>;
  /** fetch aggregated fields from the table: "distance_unit" */
  distance_unit_aggregate: Distance_Unit_Aggregate;
  /** fetch data from the table: "distance_unit" using primary key columns */
  distance_unit_by_pk?: Maybe<Distance_Unit>;
  /** fetch data from the table in a streaming manner: "distance_unit" */
  distance_unit_stream: Array<Distance_Unit>;
  /** fetch data from the table: "emission_factor_source_type" */
  emissionFactorSourceType: Array<EmissionFactorSourceType>;
  /** fetch aggregated fields from the table: "emission_factor_source_type" */
  emissionFactorSourceType_aggregate: EmissionFactorSourceType_Aggregate;
  /** fetch data from the table: "emission_factor_source_type" using primary key columns */
  emissionFactorSourceType_by_pk?: Maybe<EmissionFactorSourceType>;
  /** fetch data from the table in a streaming manner: "emission_factor_source_type" */
  emissionFactorSourceType_stream: Array<EmissionFactorSourceType>;
  /** fetch data from the table: "emission_factor" */
  emission_factor: Array<Emission_Factor>;
  /** fetch aggregated fields from the table: "emission_factor" */
  emission_factor_aggregate: Emission_Factor_Aggregate;
  /** fetch data from the table: "emission_factor" using primary key columns */
  emission_factor_by_pk?: Maybe<Emission_Factor>;
  /** fetch data from the table: "emission_factor_source" */
  emission_factor_source: Array<Emission_Factor_Source>;
  /** fetch aggregated fields from the table: "emission_factor_source" */
  emission_factor_source_aggregate: Emission_Factor_Source_Aggregate;
  /** fetch data from the table: "emission_factor_source" using primary key columns */
  emission_factor_source_by_pk?: Maybe<Emission_Factor_Source>;
  /** fetch data from the table in a streaming manner: "emission_factor_source" */
  emission_factor_source_stream: Array<Emission_Factor_Source>;
  /** fetch data from the table in a streaming manner: "emission_factor" */
  emission_factor_stream: Array<Emission_Factor>;
  /** fetch data from the table: "emission_factor_type" */
  emission_factor_type: Array<Emission_Factor_Type>;
  /** fetch aggregated fields from the table: "emission_factor_type" */
  emission_factor_type_aggregate: Emission_Factor_Type_Aggregate;
  /** fetch data from the table: "emission_factor_type" using primary key columns */
  emission_factor_type_by_pk?: Maybe<Emission_Factor_Type>;
  /** fetch data from the table in a streaming manner: "emission_factor_type" */
  emission_factor_type_stream: Array<Emission_Factor_Type>;
  /** fetch data from the table: "enum_collection_type" */
  enumCollectionType: Array<EnumCollectionType>;
  /** fetch aggregated fields from the table: "enum_collection_type" */
  enumCollectionType_aggregate: EnumCollectionType_Aggregate;
  /** fetch data from the table: "enum_collection_type" using primary key columns */
  enumCollectionType_by_pk?: Maybe<EnumCollectionType>;
  /** fetch data from the table in a streaming manner: "enum_collection_type" */
  enumCollectionType_stream: Array<EnumCollectionType>;
  /** fetch data from the table: "epd_datasource" */
  epdDatasource: Array<EpdDatasource>;
  /** fetch aggregated fields from the table: "epd_datasource" */
  epdDatasource_aggregate: EpdDatasource_Aggregate;
  /** fetch data from the table: "epd_datasource" using primary key columns */
  epdDatasource_by_pk?: Maybe<EpdDatasource>;
  /** fetch data from the table in a streaming manner: "epd_datasource" */
  epdDatasource_stream: Array<EpdDatasource>;
  /** fetch data from the table: "epd_owner" */
  epdOwner: Array<EpdOwner>;
  /** fetch data from the table: "epd_owner_alias" */
  epdOwnerAlias: Array<EpdOwnerAlias>;
  /** fetch aggregated fields from the table: "epd_owner_alias" */
  epdOwnerAlias_aggregate: EpdOwnerAlias_Aggregate;
  /** fetch data from the table: "epd_owner_alias" using primary key columns */
  epdOwnerAlias_by_pk?: Maybe<EpdOwnerAlias>;
  /** fetch data from the table in a streaming manner: "epd_owner_alias" */
  epdOwnerAlias_stream: Array<EpdOwnerAlias>;
  /** fetch aggregated fields from the table: "epd_owner" */
  epdOwner_aggregate: EpdOwner_Aggregate;
  /** fetch data from the table: "epd_owner" using primary key columns */
  epdOwner_by_pk?: Maybe<EpdOwner>;
  /** fetch data from the table in a streaming manner: "epd_owner" */
  epdOwner_stream: Array<EpdOwner>;
  /** fetch data from the table: "epd_product_industry" */
  epdProductIndustry: Array<EpdProductIndustry>;
  /** fetch aggregated fields from the table: "epd_product_industry" */
  epdProductIndustry_aggregate: EpdProductIndustry_Aggregate;
  /** fetch data from the table: "epd_product_industry" using primary key columns */
  epdProductIndustry_by_pk?: Maybe<EpdProductIndustry>;
  /** fetch data from the table in a streaming manner: "epd_product_industry" */
  epdProductIndustry_stream: Array<EpdProductIndustry>;
  /** fetch data from the table: "epd_specification_form" */
  epdSpecificationForm: Array<EpdSpecificationForm>;
  /** fetch aggregated fields from the table: "epd_specification_form" */
  epdSpecificationForm_aggregate: EpdSpecificationForm_Aggregate;
  /** fetch data from the table: "epd_specification_form" using primary key columns */
  epdSpecificationForm_by_pk?: Maybe<EpdSpecificationForm>;
  /** fetch data from the table in a streaming manner: "epd_specification_form" */
  epdSpecificationForm_stream: Array<EpdSpecificationForm>;
  /** fetch data from the table: "flow_guide" */
  flowGuide: Array<FlowGuide>;
  /** fetch data from the table: "flow_guide_views" */
  flowGuideViews: Array<FlowGuideViews>;
  /** fetch aggregated fields from the table: "flow_guide_views" */
  flowGuideViews_aggregate: FlowGuideViews_Aggregate;
  /** fetch data from the table: "flow_guide_views" using primary key columns */
  flowGuideViews_by_pk?: Maybe<FlowGuideViews>;
  /** fetch data from the table in a streaming manner: "flow_guide_views" */
  flowGuideViews_stream: Array<FlowGuideViews>;
  /** fetch aggregated fields from the table: "flow_guide" */
  flowGuide_aggregate: FlowGuide_Aggregate;
  /** fetch data from the table: "flow_guide" using primary key columns */
  flowGuide_by_pk?: Maybe<FlowGuide>;
  /** fetch data from the table in a streaming manner: "flow_guide" */
  flowGuide_stream: Array<FlowGuide>;
  /** fetch data from the table: "indicator_source" */
  indicatorSource: Array<IndicatorSource>;
  /** fetch aggregated fields from the table: "indicator_source" */
  indicatorSource_aggregate: IndicatorSource_Aggregate;
  /** fetch data from the table: "indicator_source" using primary key columns */
  indicatorSource_by_pk?: Maybe<IndicatorSource>;
  /** fetch data from the table in a streaming manner: "indicator_source" */
  indicatorSource_stream: Array<IndicatorSource>;
  /** fetch data from the table: "indicator_type" */
  indicatorType: Array<IndicatorType>;
  /** fetch data from the table: "indicator_type_mapping" */
  indicatorTypeMapping: Array<IndicatorTypeMapping>;
  /** fetch aggregated fields from the table: "indicator_type_mapping" */
  indicatorTypeMapping_aggregate: IndicatorTypeMapping_Aggregate;
  /** fetch data from the table: "indicator_type_mapping" using primary key columns */
  indicatorTypeMapping_by_pk?: Maybe<IndicatorTypeMapping>;
  /** fetch data from the table in a streaming manner: "indicator_type_mapping" */
  indicatorTypeMapping_stream: Array<IndicatorTypeMapping>;
  /** fetch data from the table: "indicator_type_multiplier" */
  indicatorTypeMultiplier: Array<IndicatorTypeMultiplier>;
  /** fetch aggregated fields from the table: "indicator_type_multiplier" */
  indicatorTypeMultiplier_aggregate: IndicatorTypeMultiplier_Aggregate;
  /** fetch data from the table: "indicator_type_multiplier" using primary key columns */
  indicatorTypeMultiplier_by_pk?: Maybe<IndicatorTypeMultiplier>;
  /** fetch data from the table in a streaming manner: "indicator_type_multiplier" */
  indicatorTypeMultiplier_stream: Array<IndicatorTypeMultiplier>;
  /** fetch aggregated fields from the table: "indicator_type" */
  indicatorType_aggregate: IndicatorType_Aggregate;
  /** fetch data from the table: "indicator_type" using primary key columns */
  indicatorType_by_pk?: Maybe<IndicatorType>;
  /** fetch data from the table in a streaming manner: "indicator_type" */
  indicatorType_stream: Array<IndicatorType>;
  /** fetch data from the table: "installation_standard_value" */
  installation_standard_value: Array<Installation_Standard_Value>;
  /** fetch aggregated fields from the table: "installation_standard_value" */
  installation_standard_value_aggregate: Installation_Standard_Value_Aggregate;
  /** fetch data from the table: "installation_standard_value_building_type" */
  installation_standard_value_building_type: Array<Installation_Standard_Value_Building_Type>;
  /** fetch aggregated fields from the table: "installation_standard_value_building_type" */
  installation_standard_value_building_type_aggregate: Installation_Standard_Value_Building_Type_Aggregate;
  /** fetch data from the table: "installation_standard_value_building_type" using primary key columns */
  installation_standard_value_building_type_by_pk?: Maybe<Installation_Standard_Value_Building_Type>;
  /** fetch data from the table in a streaming manner: "installation_standard_value_building_type" */
  installation_standard_value_building_type_stream: Array<Installation_Standard_Value_Building_Type>;
  /** fetch data from the table: "installation_standard_value" using primary key columns */
  installation_standard_value_by_pk?: Maybe<Installation_Standard_Value>;
  /** fetch data from the table: "installation_standard_value_classification_type" */
  installation_standard_value_classification_type: Array<Installation_Standard_Value_Classification_Type>;
  /** fetch aggregated fields from the table: "installation_standard_value_classification_type" */
  installation_standard_value_classification_type_aggregate: Installation_Standard_Value_Classification_Type_Aggregate;
  /** fetch data from the table: "installation_standard_value_classification_type" using primary key columns */
  installation_standard_value_classification_type_by_pk?: Maybe<Installation_Standard_Value_Classification_Type>;
  /** fetch data from the table in a streaming manner: "installation_standard_value_classification_type" */
  installation_standard_value_classification_type_stream: Array<Installation_Standard_Value_Classification_Type>;
  /** fetch data from the table: "installation_standard_value_datasource" */
  installation_standard_value_datasource: Array<Installation_Standard_Value_Datasource>;
  /** fetch aggregated fields from the table: "installation_standard_value_datasource" */
  installation_standard_value_datasource_aggregate: Installation_Standard_Value_Datasource_Aggregate;
  /** fetch data from the table: "installation_standard_value_datasource" using primary key columns */
  installation_standard_value_datasource_by_pk?: Maybe<Installation_Standard_Value_Datasource>;
  /** fetch data from the table in a streaming manner: "installation_standard_value_datasource" */
  installation_standard_value_datasource_stream: Array<Installation_Standard_Value_Datasource>;
  /** fetch data from the table: "installation_standard_value_emission" */
  installation_standard_value_emission: Array<Installation_Standard_Value_Emission>;
  /** fetch aggregated fields from the table: "installation_standard_value_emission" */
  installation_standard_value_emission_aggregate: Installation_Standard_Value_Emission_Aggregate;
  /** fetch data from the table: "installation_standard_value_emission" using primary key columns */
  installation_standard_value_emission_by_pk?: Maybe<Installation_Standard_Value_Emission>;
  /** fetch data from the table in a streaming manner: "installation_standard_value_emission" */
  installation_standard_value_emission_stream: Array<Installation_Standard_Value_Emission>;
  /** fetch data from the table in a streaming manner: "installation_standard_value" */
  installation_standard_value_stream: Array<Installation_Standard_Value>;
  /** fetch data from the table: "language" */
  language: Array<Language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: Language_Aggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<Language>;
  /** fetch data from the table in a streaming manner: "language" */
  language_stream: Array<Language>;
  /** fetch data from the table: "lifetime_table" */
  lifetime_table: Array<Lifetime_Table>;
  /** fetch aggregated fields from the table: "lifetime_table" */
  lifetime_table_aggregate: Lifetime_Table_Aggregate;
  /** fetch data from the table: "lifetime_table" using primary key columns */
  lifetime_table_by_pk?: Maybe<Lifetime_Table>;
  /** fetch data from the table in a streaming manner: "lifetime_table" */
  lifetime_table_stream: Array<Lifetime_Table>;
  /** fetch data from the table: "mapping_history" */
  mappingHistory: Array<MappingHistory>;
  /** fetch data from the table: "mapping_history_frequency" */
  mappingHistoryFrequency: Array<MappingHistoryFrequency>;
  /** fetch aggregated fields from the table: "mapping_history_frequency" */
  mappingHistoryFrequency_aggregate: MappingHistoryFrequency_Aggregate;
  /** fetch data from the table in a streaming manner: "mapping_history_frequency" */
  mappingHistoryFrequency_stream: Array<MappingHistoryFrequency>;
  /** fetch data from the table: "mapping_history_most_recent_lifetime" */
  mappingHistoryMostRecentLifetime: Array<MappingHistoryMostRecentLifetime>;
  /** fetch aggregated fields from the table: "mapping_history_most_recent_lifetime" */
  mappingHistoryMostRecentLifetime_aggregate: MappingHistoryMostRecentLifetime_Aggregate;
  /** fetch data from the table in a streaming manner: "mapping_history_most_recent_lifetime" */
  mappingHistoryMostRecentLifetime_stream: Array<MappingHistoryMostRecentLifetime>;
  /** fetch aggregated fields from the table: "mapping_history" */
  mappingHistory_aggregate: MappingHistory_Aggregate;
  /** fetch data from the table: "mapping_history" using primary key columns */
  mappingHistory_by_pk?: Maybe<MappingHistory>;
  /** fetch data from the table in a streaming manner: "mapping_history" */
  mappingHistory_stream: Array<MappingHistory>;
  /** fetch data from the table: "mapping_history_most_used_lifetime" */
  mapping_history_most_used_lifetime: Array<Mapping_History_Most_Used_Lifetime>;
  /** fetch aggregated fields from the table: "mapping_history_most_used_lifetime" */
  mapping_history_most_used_lifetime_aggregate: Mapping_History_Most_Used_Lifetime_Aggregate;
  /** fetch data from the table in a streaming manner: "mapping_history_most_used_lifetime" */
  mapping_history_most_used_lifetime_stream: Array<Mapping_History_Most_Used_Lifetime>;
  /** fetch data from the table: "material" */
  material: Array<Material>;
  /** fetch data from the table: "material_biogenic_params" */
  materialBiogenicParams: Array<MaterialBiogenicParams>;
  /** fetch aggregated fields from the table: "material_biogenic_params" */
  materialBiogenicParams_aggregate: MaterialBiogenicParams_Aggregate;
  /** fetch data from the table: "material_biogenic_params" using primary key columns */
  materialBiogenicParams_by_pk?: Maybe<MaterialBiogenicParams>;
  /** fetch data from the table in a streaming manner: "material_biogenic_params" */
  materialBiogenicParams_stream: Array<MaterialBiogenicParams>;
  /** fetch data from the table: "material_category" */
  materialCategory: Array<MaterialCategory>;
  /** fetch data from the table: "material_category_texture" */
  materialCategoryTexture: Array<MaterialCategoryTexture>;
  /** fetch aggregated fields from the table: "material_category_texture" */
  materialCategoryTexture_aggregate: MaterialCategoryTexture_Aggregate;
  /** fetch data from the table: "material_category_texture" using primary key columns */
  materialCategoryTexture_by_pk?: Maybe<MaterialCategoryTexture>;
  /** fetch data from the table in a streaming manner: "material_category_texture" */
  materialCategoryTexture_stream: Array<MaterialCategoryTexture>;
  /** fetch aggregated fields from the table: "material_category" */
  materialCategory_aggregate: MaterialCategory_Aggregate;
  /** fetch data from the table: "material_category" using primary key columns */
  materialCategory_by_pk?: Maybe<MaterialCategory>;
  /** fetch data from the table in a streaming manner: "material_category" */
  materialCategory_stream: Array<MaterialCategory>;
  /** fetch data from the table: "material_description" */
  materialDescription: Array<MaterialDescription>;
  /** fetch aggregated fields from the table: "material_description" */
  materialDescription_aggregate: MaterialDescription_Aggregate;
  /** fetch data from the table: "material_description" using primary key columns */
  materialDescription_by_pk?: Maybe<MaterialDescription>;
  /** fetch data from the table in a streaming manner: "material_description" */
  materialDescription_stream: Array<MaterialDescription>;
  /** fetch data from the table: "material_emission_indicator" */
  materialEmissionIndicator: Array<MaterialEmissionIndicator>;
  /** fetch aggregated fields from the table: "material_emission_indicator" */
  materialEmissionIndicator_aggregate: MaterialEmissionIndicator_Aggregate;
  /** fetch data from the table: "material_emission_indicator" using primary key columns */
  materialEmissionIndicator_by_pk?: Maybe<MaterialEmissionIndicator>;
  /** fetch data from the table in a streaming manner: "material_emission_indicator" */
  materialEmissionIndicator_stream: Array<MaterialEmissionIndicator>;
  /** fetch data from the table: "material_epd" */
  materialEpd: Array<MaterialEpd>;
  /** fetch data from the table: "material_epd_datasource" */
  materialEpdDatasource: Array<MaterialEpdDatasource>;
  /** fetch aggregated fields from the table: "material_epd_datasource" */
  materialEpdDatasource_aggregate: MaterialEpdDatasource_Aggregate;
  /** fetch data from the table: "material_epd_datasource" using primary key columns */
  materialEpdDatasource_by_pk?: Maybe<MaterialEpdDatasource>;
  /** fetch data from the table in a streaming manner: "material_epd_datasource" */
  materialEpdDatasource_stream: Array<MaterialEpdDatasource>;
  /** fetch data from the table: "material_epd_url" */
  materialEpdUrl: Array<MaterialEpdUrl>;
  /** fetch aggregated fields from the table: "material_epd_url" */
  materialEpdUrl_aggregate: MaterialEpdUrl_Aggregate;
  /** fetch data from the table: "material_epd_url" using primary key columns */
  materialEpdUrl_by_pk?: Maybe<MaterialEpdUrl>;
  /** fetch data from the table in a streaming manner: "material_epd_url" */
  materialEpdUrl_stream: Array<MaterialEpdUrl>;
  /** fetch aggregated fields from the table: "material_epd" */
  materialEpd_aggregate: MaterialEpd_Aggregate;
  /** fetch data from the table: "material_epd" using primary key columns */
  materialEpd_by_pk?: Maybe<MaterialEpd>;
  /** fetch data from the table in a streaming manner: "material_epd" */
  materialEpd_stream: Array<MaterialEpd>;
  /** fetch data from the table: "material_fork" */
  materialFork: Array<MaterialFork>;
  /** fetch aggregated fields from the table: "material_fork" */
  materialFork_aggregate: MaterialFork_Aggregate;
  /** fetch data from the table: "material_fork" using primary key columns */
  materialFork_by_pk?: Maybe<MaterialFork>;
  /** fetch data from the table in a streaming manner: "material_fork" */
  materialFork_stream: Array<MaterialFork>;
  /** fetch data from the table: "material_name" */
  materialName: Array<MaterialName>;
  /** fetch aggregated fields from the table: "material_name" */
  materialName_aggregate: MaterialName_Aggregate;
  /** fetch data from the table: "material_name" using primary key columns */
  materialName_by_pk?: Maybe<MaterialName>;
  /** fetch data from the table in a streaming manner: "material_name" */
  materialName_stream: Array<MaterialName>;
  /** fetch data from the table: "material_emission" */
  materialStage: Array<MaterialStage>;
  /** fetch aggregated fields from the table: "material_emission" */
  materialStage_aggregate: MaterialStage_Aggregate;
  /** fetch data from the table: "material_emission" using primary key columns */
  materialStage_by_pk?: Maybe<MaterialStage>;
  /** fetch data from the table in a streaming manner: "material_emission" */
  materialStage_stream: Array<MaterialStage>;
  /** fetch data from the table: "material_type" */
  materialType: Array<MaterialType>;
  /** fetch aggregated fields from the table: "material_type" */
  materialType_aggregate: MaterialType_Aggregate;
  /** fetch data from the table: "material_type" using primary key columns */
  materialType_by_pk?: Maybe<MaterialType>;
  /** fetch data from the table in a streaming manner: "material_type" */
  materialType_stream: Array<MaterialType>;
  /** fetch data from the table: "material_waste_source" */
  materialWasteSource: Array<MaterialWasteSource>;
  /** fetch aggregated fields from the table: "material_waste_source" */
  materialWasteSource_aggregate: MaterialWasteSource_Aggregate;
  /** fetch data from the table: "material_waste_source" using primary key columns */
  materialWasteSource_by_pk?: Maybe<MaterialWasteSource>;
  /** fetch data from the table in a streaming manner: "material_waste_source" */
  materialWasteSource_stream: Array<MaterialWasteSource>;
  /** fetch data from the table: "material_waste_type" */
  materialWasteType: Array<MaterialWasteType>;
  /** fetch aggregated fields from the table: "material_waste_type" */
  materialWasteType_aggregate: MaterialWasteType_Aggregate;
  /** fetch data from the table: "material_waste_type" using primary key columns */
  materialWasteType_by_pk?: Maybe<MaterialWasteType>;
  /** fetch data from the table in a streaming manner: "material_waste_type" */
  materialWasteType_stream: Array<MaterialWasteType>;
  /** fetch aggregated fields from the table: "material" */
  material_aggregate: Material_Aggregate;
  /** fetch data from the table: "material" using primary key columns */
  material_by_pk?: Maybe<Material>;
  /** fetch data from the table in a streaming manner: "material" */
  material_stream: Array<Material>;
  /** fetch data from the table: "mcp_connection" */
  mcpConnection: Array<McpConnection>;
  /** fetch aggregated fields from the table: "mcp_connection" */
  mcpConnection_aggregate: McpConnection_Aggregate;
  /** fetch data from the table: "mcp_connection" using primary key columns */
  mcpConnection_by_pk?: Maybe<McpConnection>;
  /** fetch data from the table in a streaming manner: "mcp_connection" */
  mcpConnection_stream: Array<McpConnection>;
  /** fetch data from the table: "mcp_tool_call" */
  mcpToolCall: Array<McpToolCall>;
  /** fetch aggregated fields from the table: "mcp_tool_call" */
  mcpToolCall_aggregate: McpToolCall_Aggregate;
  /** fetch data from the table: "mcp_tool_call" using primary key columns */
  mcpToolCall_by_pk?: Maybe<McpToolCall>;
  /** fetch data from the table in a streaming manner: "mcp_tool_call" */
  mcpToolCall_stream: Array<McpToolCall>;
  /** fetch data from the table: "model" */
  model: Array<Model>;
  /** fetch aggregated fields from the table: "model" */
  model_aggregate: Model_Aggregate;
  /** fetch data from the table: "model" using primary key columns */
  model_by_pk?: Maybe<Model>;
  /** fetch data from the table in a streaming manner: "model" */
  model_stream: Array<Model>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch data from the table: "project_building_area" */
  projectBuildingArea: Array<ProjectBuildingArea>;
  /** fetch aggregated fields from the table: "project_building_area" */
  projectBuildingArea_aggregate: ProjectBuildingArea_Aggregate;
  /** fetch data from the table: "project_building_area" using primary key columns */
  projectBuildingArea_by_pk?: Maybe<ProjectBuildingArea>;
  /** fetch data from the table in a streaming manner: "project_building_area" */
  projectBuildingArea_stream: Array<ProjectBuildingArea>;
  /** fetch data from the table: "project_calculation" */
  projectCalculation: Array<ProjectCalculation>;
  /** fetch data from the table: "project_calculation_stage" */
  projectCalculationStage: Array<ProjectCalculationStage>;
  /** fetch aggregated fields from the table: "project_calculation_stage" */
  projectCalculationStage_aggregate: ProjectCalculationStage_Aggregate;
  /** fetch data from the table: "project_calculation_stage" using primary key columns */
  projectCalculationStage_by_pk?: Maybe<ProjectCalculationStage>;
  /** fetch data from the table in a streaming manner: "project_calculation_stage" */
  projectCalculationStage_stream: Array<ProjectCalculationStage>;
  /** fetch aggregated fields from the table: "project_calculation" */
  projectCalculation_aggregate: ProjectCalculation_Aggregate;
  /** fetch data from the table: "project_calculation" using primary key columns */
  projectCalculation_by_pk?: Maybe<ProjectCalculation>;
  /** fetch data from the table in a streaming manner: "project_calculation" */
  projectCalculation_stream: Array<ProjectCalculation>;
  /** fetch data from the table: "project_component_mapping_type" */
  projectComponentMappingType: Array<ProjectComponentMappingType>;
  /** fetch aggregated fields from the table: "project_component_mapping_type" */
  projectComponentMappingType_aggregate: ProjectComponentMappingType_Aggregate;
  /** fetch data from the table: "project_component_mapping_type" using primary key columns */
  projectComponentMappingType_by_pk?: Maybe<ProjectComponentMappingType>;
  /** fetch data from the table in a streaming manner: "project_component_mapping_type" */
  projectComponentMappingType_stream: Array<ProjectComponentMappingType>;
  /** fetch data from the table: "project_dashboard_status" */
  projectDashboardStatus: Array<ProjectDashboardStatus>;
  /** fetch aggregated fields from the table: "project_dashboard_status" */
  projectDashboardStatus_aggregate: ProjectDashboardStatus_Aggregate;
  /** fetch data from the table: "project_dashboard_status" using primary key columns */
  projectDashboardStatus_by_pk?: Maybe<ProjectDashboardStatus>;
  /** fetch data from the table in a streaming manner: "project_dashboard_status" */
  projectDashboardStatus_stream: Array<ProjectDashboardStatus>;
  /** fetch data from the table: "project_emission_factor" */
  projectEmissionFactor: Array<ProjectEmissionFactor>;
  /** fetch data from the table: "project_emission_factor_custom" */
  projectEmissionFactorCustom: Array<ProjectEmissionFactorCustom>;
  /** fetch aggregated fields from the table: "project_emission_factor_custom" */
  projectEmissionFactorCustom_aggregate: ProjectEmissionFactorCustom_Aggregate;
  /** fetch data from the table: "project_emission_factor_custom" using primary key columns */
  projectEmissionFactorCustom_by_pk?: Maybe<ProjectEmissionFactorCustom>;
  /** fetch data from the table in a streaming manner: "project_emission_factor_custom" */
  projectEmissionFactorCustom_stream: Array<ProjectEmissionFactorCustom>;
  /** fetch aggregated fields from the table: "project_emission_factor" */
  projectEmissionFactor_aggregate: ProjectEmissionFactor_Aggregate;
  /** fetch data from the table: "project_emission_factor" using primary key columns */
  projectEmissionFactor_by_pk?: Maybe<ProjectEmissionFactor>;
  /** fetch data from the table in a streaming manner: "project_emission_factor" */
  projectEmissionFactor_stream: Array<ProjectEmissionFactor>;
  /** fetch data from the table: "project_installation" */
  projectInstallation: Array<ProjectInstallation>;
  /** fetch aggregated fields from the table: "project_installation" */
  projectInstallation_aggregate: ProjectInstallation_Aggregate;
  /** fetch data from the table: "project_installation" using primary key columns */
  projectInstallation_by_pk?: Maybe<ProjectInstallation>;
  /** fetch data from the table in a streaming manner: "project_installation" */
  projectInstallation_stream: Array<ProjectInstallation>;
  /** fetch data from the table: "project_location" */
  projectLocation: Array<ProjectLocation>;
  /** fetch aggregated fields from the table: "project_location" */
  projectLocation_aggregate: ProjectLocation_Aggregate;
  /** fetch data from the table: "project_location" using primary key columns */
  projectLocation_by_pk?: Maybe<ProjectLocation>;
  /** fetch data from the table in a streaming manner: "project_location" */
  projectLocation_stream: Array<ProjectLocation>;
  /** fetch data from the table: "project_material_classification_feedback" */
  projectMaterialClassificationFeedback: Array<ProjectMaterialClassificationFeedback>;
  /** fetch aggregated fields from the table: "project_material_classification_feedback" */
  projectMaterialClassificationFeedback_aggregate: ProjectMaterialClassificationFeedback_Aggregate;
  /** fetch data from the table: "project_material_classification_feedback" using primary key columns */
  projectMaterialClassificationFeedback_by_pk?: Maybe<ProjectMaterialClassificationFeedback>;
  /** fetch data from the table in a streaming manner: "project_material_classification_feedback" */
  projectMaterialClassificationFeedback_stream: Array<ProjectMaterialClassificationFeedback>;
  /** fetch data from the table: "project_material_classification_parameter" */
  projectMaterialClassificationParameter: Array<ProjectMaterialClassificationParameter>;
  /** fetch aggregated fields from the table: "project_material_classification_parameter" */
  projectMaterialClassificationParameter_aggregate: ProjectMaterialClassificationParameter_Aggregate;
  /** fetch data from the table: "project_material_classification_parameter" using primary key columns */
  projectMaterialClassificationParameter_by_pk?: Maybe<ProjectMaterialClassificationParameter>;
  /** fetch data from the table in a streaming manner: "project_material_classification_parameter" */
  projectMaterialClassificationParameter_stream: Array<ProjectMaterialClassificationParameter>;
  /** fetch data from the table: "project_membership" */
  projectMembership: Array<ProjectMembership>;
  /** fetch aggregated fields from the table: "project_membership" */
  projectMembership_aggregate: ProjectMembership_Aggregate;
  /** fetch data from the table: "project_membership" using primary key columns */
  projectMembership_by_pk?: Maybe<ProjectMembership>;
  /** fetch data from the table in a streaming manner: "project_membership" */
  projectMembership_stream: Array<ProjectMembership>;
  /** fetch data from the table: "project_model" */
  projectModel: Array<ProjectModel>;
  /** fetch data from the table: "project_model_speckle_pin" */
  projectModelSpecklePin: Array<ProjectModelSpecklePin>;
  /** fetch aggregated fields from the table: "project_model_speckle_pin" */
  projectModelSpecklePin_aggregate: ProjectModelSpecklePin_Aggregate;
  /** fetch data from the table: "project_model_speckle_pin" using primary key columns */
  projectModelSpecklePin_by_pk?: Maybe<ProjectModelSpecklePin>;
  /** fetch data from the table in a streaming manner: "project_model_speckle_pin" */
  projectModelSpecklePin_stream: Array<ProjectModelSpecklePin>;
  /** fetch aggregated fields from the table: "project_model" */
  projectModel_aggregate: ProjectModel_Aggregate;
  /** fetch data from the table: "project_model" using primary key columns */
  projectModel_by_pk?: Maybe<ProjectModel>;
  /** fetch data from the table in a streaming manner: "project_model" */
  projectModel_stream: Array<ProjectModel>;
  /** fetch data from the table: "project_operational" */
  projectOperational: Array<ProjectOperational>;
  /** fetch aggregated fields from the table: "project_operational" */
  projectOperational_aggregate: ProjectOperational_Aggregate;
  /** fetch data from the table: "project_operational" using primary key columns */
  projectOperational_by_pk?: Maybe<ProjectOperational>;
  /** fetch data from the table in a streaming manner: "project_operational" */
  projectOperational_stream: Array<ProjectOperational>;
  /** fetch data from the table: "project_reference_area" */
  projectReferenceArea: Array<ProjectReferenceArea>;
  /** fetch aggregated fields from the table: "project_reference_area" */
  projectReferenceArea_aggregate: ProjectReferenceArea_Aggregate;
  /** fetch data from the table: "project_reference_area" using primary key columns */
  projectReferenceArea_by_pk?: Maybe<ProjectReferenceArea>;
  /** fetch data from the table in a streaming manner: "project_reference_area" */
  projectReferenceArea_stream: Array<ProjectReferenceArea>;
  /** fetch data from the table: "project_revision" */
  projectRevision: Array<ProjectRevision>;
  /** fetch aggregated fields from the table: "project_revision" */
  projectRevision_aggregate: ProjectRevision_Aggregate;
  /** fetch data from the table: "project_revision" using primary key columns */
  projectRevision_by_pk?: Maybe<ProjectRevision>;
  /** fetch data from the table in a streaming manner: "project_revision" */
  projectRevision_stream: Array<ProjectRevision>;
  /** fetch data from the table: "project_special_condition_config" */
  projectSpecialConditionConfig: Array<ProjectSpecialConditionConfig>;
  /** fetch aggregated fields from the table: "project_special_condition_config" */
  projectSpecialConditionConfig_aggregate: ProjectSpecialConditionConfig_Aggregate;
  /** fetch data from the table: "project_special_condition_config" using primary key columns */
  projectSpecialConditionConfig_by_pk?: Maybe<ProjectSpecialConditionConfig>;
  /** fetch data from the table in a streaming manner: "project_special_condition_config" */
  projectSpecialConditionConfig_stream: Array<ProjectSpecialConditionConfig>;
  /** fetch data from the table: "project_special_condition_type_mapping" */
  projectSpecialConditionTypeMapping: Array<ProjectSpecialConditionTypeMapping>;
  /** fetch aggregated fields from the table: "project_special_condition_type_mapping" */
  projectSpecialConditionTypeMapping_aggregate: ProjectSpecialConditionTypeMapping_Aggregate;
  /** fetch data from the table: "project_special_condition_type_mapping" using primary key columns */
  projectSpecialConditionTypeMapping_by_pk?: Maybe<ProjectSpecialConditionTypeMapping>;
  /** fetch data from the table in a streaming manner: "project_special_condition_type_mapping" */
  projectSpecialConditionTypeMapping_stream: Array<ProjectSpecialConditionTypeMapping>;
  /** fetch data from the table: "project_speckle_copy" */
  projectSpeckleCopy: Array<ProjectSpeckleCopy>;
  /** fetch data from the table: "project_speckle_copy_recent" */
  projectSpeckleCopyRecent: Array<ProjectSpeckleCopyRecent>;
  /** fetch aggregated fields from the table: "project_speckle_copy_recent" */
  projectSpeckleCopyRecent_aggregate: ProjectSpeckleCopyRecent_Aggregate;
  /** fetch data from the table in a streaming manner: "project_speckle_copy_recent" */
  projectSpeckleCopyRecent_stream: Array<ProjectSpeckleCopyRecent>;
  /** fetch aggregated fields from the table: "project_speckle_copy" */
  projectSpeckleCopy_aggregate: ProjectSpeckleCopy_Aggregate;
  /** fetch data from the table: "project_speckle_copy" using primary key columns */
  projectSpeckleCopy_by_pk?: Maybe<ProjectSpeckleCopy>;
  /** fetch data from the table in a streaming manner: "project_speckle_copy" */
  projectSpeckleCopy_stream: Array<ProjectSpeckleCopy>;
  /** fetch data from the table: "project_speckle_model_sync" */
  projectSpeckleModelSync: Array<ProjectSpeckleModelSync>;
  /** fetch data from the table: "project_speckle_model_sync_recent" */
  projectSpeckleModelSyncRecent: Array<ProjectSpeckleModelSyncRecent>;
  /** fetch aggregated fields from the table: "project_speckle_model_sync_recent" */
  projectSpeckleModelSyncRecent_aggregate: ProjectSpeckleModelSyncRecent_Aggregate;
  /** fetch data from the table in a streaming manner: "project_speckle_model_sync_recent" */
  projectSpeckleModelSyncRecent_stream: Array<ProjectSpeckleModelSyncRecent>;
  /** fetch aggregated fields from the table: "project_speckle_model_sync" */
  projectSpeckleModelSync_aggregate: ProjectSpeckleModelSync_Aggregate;
  /** fetch data from the table: "project_speckle_model_sync" using primary key columns */
  projectSpeckleModelSync_by_pk?: Maybe<ProjectSpeckleModelSync>;
  /** fetch data from the table in a streaming manner: "project_speckle_model_sync" */
  projectSpeckleModelSync_stream: Array<ProjectSpeckleModelSync>;
  /** fetch data from the table: "project_speckle_parameter_config" */
  projectSpeckleParameterConfig: Array<ProjectSpeckleParameterConfig>;
  /** fetch aggregated fields from the table: "project_speckle_parameter_config" */
  projectSpeckleParameterConfig_aggregate: ProjectSpeckleParameterConfig_Aggregate;
  /** fetch data from the table: "project_speckle_parameter_config" using primary key columns */
  projectSpeckleParameterConfig_by_pk?: Maybe<ProjectSpeckleParameterConfig>;
  /** fetch data from the table in a streaming manner: "project_speckle_parameter_config" */
  projectSpeckleParameterConfig_stream: Array<ProjectSpeckleParameterConfig>;
  /** fetch data from the table: "project_standard_value_stage" */
  projectStandardValueStage: Array<ProjectStandardValueStage>;
  /** fetch aggregated fields from the table: "project_standard_value_stage" */
  projectStandardValueStage_aggregate: ProjectStandardValueStage_Aggregate;
  /** fetch data from the table: "project_standard_value_stage" using primary key columns */
  projectStandardValueStage_by_pk?: Maybe<ProjectStandardValueStage>;
  /** fetch data from the table in a streaming manner: "project_standard_value_stage" */
  projectStandardValueStage_stream: Array<ProjectStandardValueStage>;
  /** fetch data from the table: "project_status" */
  projectStatus: Array<ProjectStatus>;
  /** fetch aggregated fields from the table: "project_status" */
  projectStatus_aggregate: ProjectStatus_Aggregate;
  /** fetch data from the table: "project_status" using primary key columns */
  projectStatus_by_pk?: Maybe<ProjectStatus>;
  /** fetch data from the table in a streaming manner: "project_status" */
  projectStatus_stream: Array<ProjectStatus>;
  /** fetch data from the table: "project_tenant_status_area" */
  projectTenantStatusArea: Array<ProjectTenantStatusArea>;
  /** fetch aggregated fields from the table: "project_tenant_status_area" */
  projectTenantStatusArea_aggregate: ProjectTenantStatusArea_Aggregate;
  /** fetch data from the table in a streaming manner: "project_tenant_status_area" */
  projectTenantStatusArea_stream: Array<ProjectTenantStatusArea>;
  /** fetch data from the table: "project_transport_mapping_emission_factor" */
  projectTransportMappingEmissionFactor: Array<ProjectTransportMappingEmissionFactor>;
  /** fetch aggregated fields from the table: "project_transport_mapping_emission_factor" */
  projectTransportMappingEmissionFactor_aggregate: ProjectTransportMappingEmissionFactor_Aggregate;
  /** fetch data from the table: "project_transport_mapping_emission_factor" using primary key columns */
  projectTransportMappingEmissionFactor_by_pk?: Maybe<ProjectTransportMappingEmissionFactor>;
  /** fetch data from the table in a streaming manner: "project_transport_mapping_emission_factor" */
  projectTransportMappingEmissionFactor_stream: Array<ProjectTransportMappingEmissionFactor>;
  /** fetch data from the table: "project_version" */
  projectVersion: Array<ProjectVersion>;
  /** fetch data from the table: "project_version_numbered" */
  projectVersionNumbered: Array<ProjectVersionNumbered>;
  /** fetch aggregated fields from the table: "project_version_numbered" */
  projectVersionNumbered_aggregate: ProjectVersionNumbered_Aggregate;
  /** fetch data from the table in a streaming manner: "project_version_numbered" */
  projectVersionNumbered_stream: Array<ProjectVersionNumbered>;
  /** fetch aggregated fields from the table: "project_version" */
  projectVersion_aggregate: ProjectVersion_Aggregate;
  /** fetch data from the table: "project_version" using primary key columns */
  projectVersion_by_pk?: Maybe<ProjectVersion>;
  /** fetch data from the table in a streaming manner: "project_version" */
  projectVersion_stream: Array<ProjectVersion>;
  /** fetch data from the table: "project_waste_mapping" */
  projectWasteMapping: Array<ProjectWasteMapping>;
  /** fetch aggregated fields from the table: "project_waste_mapping" */
  projectWasteMapping_aggregate: ProjectWasteMapping_Aggregate;
  /** fetch data from the table: "project_waste_mapping" using primary key columns */
  projectWasteMapping_by_pk?: Maybe<ProjectWasteMapping>;
  /** fetch data from the table in a streaming manner: "project_waste_mapping" */
  projectWasteMapping_stream: Array<ProjectWasteMapping>;
  /** fetch data from the table: "project_waste_type_custom" */
  projectWasteTypeCustom: Array<ProjectWasteTypeCustom>;
  /** fetch aggregated fields from the table: "project_waste_type_custom" */
  projectWasteTypeCustom_aggregate: ProjectWasteTypeCustom_Aggregate;
  /** fetch data from the table: "project_waste_type_custom" using primary key columns */
  projectWasteTypeCustom_by_pk?: Maybe<ProjectWasteTypeCustom>;
  /** fetch data from the table in a streaming manner: "project_waste_type_custom" */
  projectWasteTypeCustom_stream: Array<ProjectWasteTypeCustom>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** execute function "project_speckle_stream_as_of" which returns "speckle_stream" */
  project_speckle_stream_as_of: Array<Speckle_Stream>;
  /** execute function "project_speckle_stream_as_of" and query aggregates on result of table type "speckle_stream" */
  project_speckle_stream_as_of_aggregate: Speckle_Stream_Aggregate;
  /** fetch data from the table in a streaming manner: "project" */
  project_stream: Array<Project>;
  /** fetch data from the table: "project_transport" */
  project_transport: Array<Project_Transport>;
  /** fetch aggregated fields from the table: "project_transport" */
  project_transport_aggregate: Project_Transport_Aggregate;
  /** fetch data from the table: "project_transport" using primary key columns */
  project_transport_by_pk?: Maybe<Project_Transport>;
  /** fetch data from the table: "project_transport_default" */
  project_transport_default: Array<Project_Transport_Default>;
  /** fetch aggregated fields from the table: "project_transport_default" */
  project_transport_default_aggregate: Project_Transport_Default_Aggregate;
  /** fetch data from the table: "project_transport_default" using primary key columns */
  project_transport_default_by_pk?: Maybe<Project_Transport_Default>;
  /** fetch data from the table in a streaming manner: "project_transport_default" */
  project_transport_default_stream: Array<Project_Transport_Default>;
  /** fetch data from the table: "project_transport_mapping" */
  project_transport_mapping: Array<Project_Transport_Mapping>;
  /** fetch aggregated fields from the table: "project_transport_mapping" */
  project_transport_mapping_aggregate: Project_Transport_Mapping_Aggregate;
  /** fetch data from the table: "project_transport_mapping" using primary key columns */
  project_transport_mapping_by_pk?: Maybe<Project_Transport_Mapping>;
  /** fetch data from the table in a streaming manner: "project_transport_mapping" */
  project_transport_mapping_stream: Array<Project_Transport_Mapping>;
  /** fetch data from the table in a streaming manner: "project_transport" */
  project_transport_stream: Array<Project_Transport>;
  /** fetch data from the table: "reference_area_type" */
  referenceAreaType: Array<ReferenceAreaType>;
  /** fetch data from the table: "reference_area_type_calculation_type_mapping" */
  referenceAreaTypeCalculationTypeMapping: Array<ReferenceAreaTypeCalculationTypeMapping>;
  /** fetch aggregated fields from the table: "reference_area_type_calculation_type_mapping" */
  referenceAreaTypeCalculationTypeMapping_aggregate: ReferenceAreaTypeCalculationTypeMapping_Aggregate;
  /** fetch data from the table: "reference_area_type_calculation_type_mapping" using primary key columns */
  referenceAreaTypeCalculationTypeMapping_by_pk?: Maybe<ReferenceAreaTypeCalculationTypeMapping>;
  /** fetch data from the table in a streaming manner: "reference_area_type_calculation_type_mapping" */
  referenceAreaTypeCalculationTypeMapping_stream: Array<ReferenceAreaTypeCalculationTypeMapping>;
  /** fetch aggregated fields from the table: "reference_area_type" */
  referenceAreaType_aggregate: ReferenceAreaType_Aggregate;
  /** fetch data from the table: "reference_area_type" using primary key columns */
  referenceAreaType_by_pk?: Maybe<ReferenceAreaType>;
  /** fetch data from the table in a streaming manner: "reference_area_type" */
  referenceAreaType_stream: Array<ReferenceAreaType>;
  /** fetch data from the table: "report_building_type_mapping" */
  reportBuildingTypeMapping: Array<ReportBuildingTypeMapping>;
  /** fetch aggregated fields from the table: "report_building_type_mapping" */
  reportBuildingTypeMapping_aggregate: ReportBuildingTypeMapping_Aggregate;
  /** fetch data from the table: "report_building_type_mapping" using primary key columns */
  reportBuildingTypeMapping_by_pk?: Maybe<ReportBuildingTypeMapping>;
  /** fetch data from the table in a streaming manner: "report_building_type_mapping" */
  reportBuildingTypeMapping_stream: Array<ReportBuildingTypeMapping>;
  /** fetch data from the table: "report_classification_code_emission_mapping" */
  reportClassificationCodeEmissionMapping: Array<ReportClassificationCodeEmissionMapping>;
  /** fetch aggregated fields from the table: "report_classification_code_emission_mapping" */
  reportClassificationCodeEmissionMapping_aggregate: ReportClassificationCodeEmissionMapping_Aggregate;
  /** fetch data from the table: "report_classification_code_emission_mapping" using primary key columns */
  reportClassificationCodeEmissionMapping_by_pk?: Maybe<ReportClassificationCodeEmissionMapping>;
  /** fetch data from the table in a streaming manner: "report_classification_code_emission_mapping" */
  reportClassificationCodeEmissionMapping_stream: Array<ReportClassificationCodeEmissionMapping>;
  /** fetch data from the table: "report_load_bearing_element_amount_mapping" */
  reportLoadBearingElementAmountMapping: Array<ReportLoadBearingElementAmountMapping>;
  /** fetch aggregated fields from the table: "report_load_bearing_element_amount_mapping" */
  reportLoadBearingElementAmountMapping_aggregate: ReportLoadBearingElementAmountMapping_Aggregate;
  /** fetch data from the table: "report_load_bearing_element_amount_mapping" using primary key columns */
  reportLoadBearingElementAmountMapping_by_pk?: Maybe<ReportLoadBearingElementAmountMapping>;
  /** fetch data from the table in a streaming manner: "report_load_bearing_element_amount_mapping" */
  reportLoadBearingElementAmountMapping_stream: Array<ReportLoadBearingElementAmountMapping>;
  /** fetch data from the table: "report_load_bearing_element_emission_mapping" */
  reportLoadBearingElementEmissionMapping: Array<ReportLoadBearingElementEmissionMapping>;
  /** fetch aggregated fields from the table: "report_load_bearing_element_emission_mapping" */
  reportLoadBearingElementEmissionMapping_aggregate: ReportLoadBearingElementEmissionMapping_Aggregate;
  /** fetch data from the table: "report_load_bearing_element_emission_mapping" using primary key columns */
  reportLoadBearingElementEmissionMapping_by_pk?: Maybe<ReportLoadBearingElementEmissionMapping>;
  /** fetch data from the table in a streaming manner: "report_load_bearing_element_emission_mapping" */
  reportLoadBearingElementEmissionMapping_stream: Array<ReportLoadBearingElementEmissionMapping>;
  /** fetch data from the table: "report_structure" */
  reportStructure: Array<ReportStructure>;
  /** fetch data from the table: "report_structure_calculation_types" */
  reportStructureCalculationTypes: Array<ReportStructureCalculationTypes>;
  /** fetch aggregated fields from the table: "report_structure_calculation_types" */
  reportStructureCalculationTypes_aggregate: ReportStructureCalculationTypes_Aggregate;
  /** fetch data from the table: "report_structure_calculation_types" using primary key columns */
  reportStructureCalculationTypes_by_pk?: Maybe<ReportStructureCalculationTypes>;
  /** fetch data from the table in a streaming manner: "report_structure_calculation_types" */
  reportStructureCalculationTypes_stream: Array<ReportStructureCalculationTypes>;
  /** fetch data from the table: "report_structure_classification_codes" */
  reportStructureClassificationCodes: Array<ReportStructureClassificationCodes>;
  /** fetch aggregated fields from the table: "report_structure_classification_codes" */
  reportStructureClassificationCodes_aggregate: ReportStructureClassificationCodes_Aggregate;
  /** fetch data from the table: "report_structure_classification_codes" using primary key columns */
  reportStructureClassificationCodes_by_pk?: Maybe<ReportStructureClassificationCodes>;
  /** fetch data from the table in a streaming manner: "report_structure_classification_codes" */
  reportStructureClassificationCodes_stream: Array<ReportStructureClassificationCodes>;
  /** fetch aggregated fields from the table: "report_structure" */
  reportStructure_aggregate: ReportStructure_Aggregate;
  /** fetch data from the table: "report_structure" using primary key columns */
  reportStructure_by_pk?: Maybe<ReportStructure>;
  /** fetch data from the table in a streaming manner: "report_structure" */
  reportStructure_stream: Array<ReportStructure>;
  /** fetch data from the table: "reportfilesmetadata" */
  reportfilesmetadata: Array<Reportfilesmetadata>;
  /** fetch aggregated fields from the table: "reportfilesmetadata" */
  reportfilesmetadata_aggregate: Reportfilesmetadata_Aggregate;
  /** fetch data from the table: "reportfilesmetadata" using primary key columns */
  reportfilesmetadata_by_pk?: Maybe<Reportfilesmetadata>;
  /** fetch data from the table in a streaming manner: "reportfilesmetadata" */
  reportfilesmetadata_stream: Array<Reportfilesmetadata>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  roles_stream: Array<Roles>;
  /** fetch data from the table: "special_condition_type" */
  specialConditionType: Array<SpecialConditionType>;
  /** fetch data from the table: "special_condition_type_calculation_type" */
  specialConditionTypeCalculationType: Array<SpecialConditionTypeCalculationType>;
  /** fetch aggregated fields from the table: "special_condition_type_calculation_type" */
  specialConditionTypeCalculationType_aggregate: SpecialConditionTypeCalculationType_Aggregate;
  /** fetch data from the table: "special_condition_type_calculation_type" using primary key columns */
  specialConditionTypeCalculationType_by_pk?: Maybe<SpecialConditionTypeCalculationType>;
  /** fetch data from the table in a streaming manner: "special_condition_type_calculation_type" */
  specialConditionTypeCalculationType_stream: Array<SpecialConditionTypeCalculationType>;
  /** fetch data from the table: "special_condition_type_input_parameter" */
  specialConditionTypeInputParameter: Array<SpecialConditionTypeInputParameter>;
  /** fetch aggregated fields from the table: "special_condition_type_input_parameter" */
  specialConditionTypeInputParameter_aggregate: SpecialConditionTypeInputParameter_Aggregate;
  /** fetch data from the table: "special_condition_type_input_parameter" using primary key columns */
  specialConditionTypeInputParameter_by_pk?: Maybe<SpecialConditionTypeInputParameter>;
  /** fetch data from the table in a streaming manner: "special_condition_type_input_parameter" */
  specialConditionTypeInputParameter_stream: Array<SpecialConditionTypeInputParameter>;
  /** fetch aggregated fields from the table: "special_condition_type" */
  specialConditionType_aggregate: SpecialConditionType_Aggregate;
  /** fetch data from the table: "special_condition_type" using primary key columns */
  specialConditionType_by_pk?: Maybe<SpecialConditionType>;
  /** fetch data from the table in a streaming manner: "special_condition_type" */
  specialConditionType_stream: Array<SpecialConditionType>;
  /** fetch data from the table: "special_condition_type_category" */
  special_condition_type_category: Array<Special_Condition_Type_Category>;
  /** fetch aggregated fields from the table: "special_condition_type_category" */
  special_condition_type_category_aggregate: Special_Condition_Type_Category_Aggregate;
  /** fetch data from the table: "special_condition_type_category" using primary key columns */
  special_condition_type_category_by_pk?: Maybe<Special_Condition_Type_Category>;
  /** fetch data from the table in a streaming manner: "special_condition_type_category" */
  special_condition_type_category_stream: Array<Special_Condition_Type_Category>;
  /** fetch data from the table: "speckle_stream_model_ifc_upload" */
  speckleStreamModelIfcUpload: Array<SpeckleStreamModelIfcUpload>;
  /** fetch data from the table: "speckle_stream_model_ifc_upload_recent" */
  speckleStreamModelIfcUploadRecent: Array<SpeckleStreamModelIfcUploadRecent>;
  /** fetch aggregated fields from the table: "speckle_stream_model_ifc_upload_recent" */
  speckleStreamModelIfcUploadRecent_aggregate: SpeckleStreamModelIfcUploadRecent_Aggregate;
  /** fetch data from the table in a streaming manner: "speckle_stream_model_ifc_upload_recent" */
  speckleStreamModelIfcUploadRecent_stream: Array<SpeckleStreamModelIfcUploadRecent>;
  /** fetch aggregated fields from the table: "speckle_stream_model_ifc_upload" */
  speckleStreamModelIfcUpload_aggregate: SpeckleStreamModelIfcUpload_Aggregate;
  /** fetch data from the table: "speckle_stream_model_ifc_upload" using primary key columns */
  speckleStreamModelIfcUpload_by_pk?: Maybe<SpeckleStreamModelIfcUpload>;
  /** fetch data from the table in a streaming manner: "speckle_stream_model_ifc_upload" */
  speckleStreamModelIfcUpload_stream: Array<SpeckleStreamModelIfcUpload>;
  /** fetch data from the table: "speckle_user_data" */
  speckleUserData: Array<SpeckleUserData>;
  /** fetch aggregated fields from the table: "speckle_user_data" */
  speckleUserData_aggregate: SpeckleUserData_Aggregate;
  /** fetch data from the table: "speckle_user_data" using primary key columns */
  speckleUserData_by_pk?: Maybe<SpeckleUserData>;
  /** fetch data from the table in a streaming manner: "speckle_user_data" */
  speckleUserData_stream: Array<SpeckleUserData>;
  /** fetch data from the table: "speckle_stream" */
  speckle_stream: Array<Speckle_Stream>;
  /** fetch aggregated fields from the table: "speckle_stream" */
  speckle_stream_aggregate: Speckle_Stream_Aggregate;
  /** fetch data from the table: "speckle_stream" using primary key columns */
  speckle_stream_by_pk?: Maybe<Speckle_Stream>;
  /** fetch data from the table in a streaming manner: "speckle_stream" */
  speckle_stream_stream: Array<Speckle_Stream>;
  /** fetch data from the table: "stage" */
  stage: Array<Stage>;
  /** fetch data from the table: "stage_default_emission" */
  stageDefaultEmission: Array<StageDefaultEmission>;
  /** fetch aggregated fields from the table: "stage_default_emission" */
  stageDefaultEmission_aggregate: StageDefaultEmission_Aggregate;
  /** fetch data from the table: "stage_default_emission" using primary key columns */
  stageDefaultEmission_by_pk?: Maybe<StageDefaultEmission>;
  /** fetch data from the table in a streaming manner: "stage_default_emission" */
  stageDefaultEmission_stream: Array<StageDefaultEmission>;
  /** fetch aggregated fields from the table: "stage" */
  stage_aggregate: Stage_Aggregate;
  /** fetch data from the table: "stage" using primary key columns */
  stage_by_pk?: Maybe<Stage>;
  /** fetch data from the table: "stage_default_emission_building_type" */
  stage_default_emission_building_type: Array<Stage_Default_Emission_Building_Type>;
  /** fetch aggregated fields from the table: "stage_default_emission_building_type" */
  stage_default_emission_building_type_aggregate: Stage_Default_Emission_Building_Type_Aggregate;
  /** fetch data from the table: "stage_default_emission_building_type" using primary key columns */
  stage_default_emission_building_type_by_pk?: Maybe<Stage_Default_Emission_Building_Type>;
  /** fetch data from the table in a streaming manner: "stage_default_emission_building_type" */
  stage_default_emission_building_type_stream: Array<Stage_Default_Emission_Building_Type>;
  /** fetch data from the table in a streaming manner: "stage" */
  stage_stream: Array<Stage>;
  /** fetch data from the table: "tenant_ai_budget" */
  tenantAiBudget: Array<TenantAiBudget>;
  /** fetch aggregated fields from the table: "tenant_ai_budget" */
  tenantAiBudget_aggregate: TenantAiBudget_Aggregate;
  /** fetch data from the table: "tenant_ai_budget" using primary key columns */
  tenantAiBudget_by_pk?: Maybe<TenantAiBudget>;
  /** fetch data from the table in a streaming manner: "tenant_ai_budget" */
  tenantAiBudget_stream: Array<TenantAiBudget>;
  /** fetch data from the table: "tenant_ai_credit_purchase" */
  tenantAiCreditPurchase: Array<TenantAiCreditPurchase>;
  /** fetch aggregated fields from the table: "tenant_ai_credit_purchase" */
  tenantAiCreditPurchase_aggregate: TenantAiCreditPurchase_Aggregate;
  /** fetch data from the table: "tenant_ai_credit_purchase" using primary key columns */
  tenantAiCreditPurchase_by_pk?: Maybe<TenantAiCreditPurchase>;
  /** fetch data from the table in a streaming manner: "tenant_ai_credit_purchase" */
  tenantAiCreditPurchase_stream: Array<TenantAiCreditPurchase>;
  /** fetch data from the table: "tenant_ai_payment" */
  tenantAiPayment: Array<TenantAiPayment>;
  /** fetch aggregated fields from the table: "tenant_ai_payment" */
  tenantAiPayment_aggregate: TenantAiPayment_Aggregate;
  /** fetch data from the table: "tenant_ai_payment" using primary key columns */
  tenantAiPayment_by_pk?: Maybe<TenantAiPayment>;
  /** fetch data from the table in a streaming manner: "tenant_ai_payment" */
  tenantAiPayment_stream: Array<TenantAiPayment>;
  /** fetch data from the table: "tenant_collection" */
  tenantCollection: Array<TenantCollection>;
  /** fetch data from the table: "tenant_collection_item" */
  tenantCollectionItem: Array<TenantCollectionItem>;
  /** fetch aggregated fields from the table: "tenant_collection_item" */
  tenantCollectionItem_aggregate: TenantCollectionItem_Aggregate;
  /** fetch data from the table: "tenant_collection_item" using primary key columns */
  tenantCollectionItem_by_pk?: Maybe<TenantCollectionItem>;
  /** fetch data from the table in a streaming manner: "tenant_collection_item" */
  tenantCollectionItem_stream: Array<TenantCollectionItem>;
  /** fetch aggregated fields from the table: "tenant_collection" */
  tenantCollection_aggregate: TenantCollection_Aggregate;
  /** fetch data from the table: "tenant_collection" using primary key columns */
  tenantCollection_by_pk?: Maybe<TenantCollection>;
  /** fetch data from the table in a streaming manner: "tenant_collection" */
  tenantCollection_stream: Array<TenantCollection>;
  /** fetch data from the table: "tenant_invoice" */
  tenantInvoice: Array<TenantInvoice>;
  /** fetch aggregated fields from the table: "tenant_invoice" */
  tenantInvoice_aggregate: TenantInvoice_Aggregate;
  /** fetch data from the table: "tenant_invoice" using primary key columns */
  tenantInvoice_by_pk?: Maybe<TenantInvoice>;
  /** fetch data from the table in a streaming manner: "tenant_invoice" */
  tenantInvoice_stream: Array<TenantInvoice>;
  /** fetch data from the table: "tenant_user_request_ai_usage" */
  tenantUserRequestAiUsage: Array<TenantUserRequestAiUsage>;
  /** fetch aggregated fields from the table: "tenant_user_request_ai_usage" */
  tenantUserRequestAiUsage_aggregate: TenantUserRequestAiUsage_Aggregate;
  /** fetch data from the table: "tenant_user_request_ai_usage" using primary key columns */
  tenantUserRequestAiUsage_by_pk?: Maybe<TenantUserRequestAiUsage>;
  /** fetch data from the table in a streaming manner: "tenant_user_request_ai_usage" */
  tenantUserRequestAiUsage_stream: Array<TenantUserRequestAiUsage>;
  /** fetch data from the table: "translation_category" */
  translationCategory: Array<TranslationCategory>;
  /** fetch aggregated fields from the table: "translation_category" */
  translationCategory_aggregate: TranslationCategory_Aggregate;
  /** fetch data from the table: "translation_category" using primary key columns */
  translationCategory_by_pk?: Maybe<TranslationCategory>;
  /** fetch data from the table in a streaming manner: "translation_category" */
  translationCategory_stream: Array<TranslationCategory>;
  /** fetch data from the table: "translation_source" */
  translationSource: Array<TranslationSource>;
  /** fetch aggregated fields from the table: "translation_source" */
  translationSource_aggregate: TranslationSource_Aggregate;
  /** fetch data from the table: "translation_source" using primary key columns */
  translationSource_by_pk?: Maybe<TranslationSource>;
  /** fetch data from the table in a streaming manner: "translation_source" */
  translationSource_stream: Array<TranslationSource>;
  /** fetch data from the table: "transport" */
  transport: Array<Transport>;
  /** fetch data from the table: "transport_emission_factor" */
  transportEmissionFactor: Array<TransportEmissionFactor>;
  /** fetch aggregated fields from the table: "transport_emission_factor" */
  transportEmissionFactor_aggregate: TransportEmissionFactor_Aggregate;
  /** fetch data from the table: "transport_emission_factor" using primary key columns */
  transportEmissionFactor_by_pk?: Maybe<TransportEmissionFactor>;
  /** fetch data from the table in a streaming manner: "transport_emission_factor" */
  transportEmissionFactor_stream: Array<TransportEmissionFactor>;
  /** fetch data from the table: "transport_source" */
  transportSource: Array<TransportSource>;
  /** fetch data from the table: "transport_source_calculation_type" */
  transportSourceCalculationType: Array<TransportSourceCalculationType>;
  /** fetch aggregated fields from the table: "transport_source_calculation_type" */
  transportSourceCalculationType_aggregate: TransportSourceCalculationType_Aggregate;
  /** fetch data from the table: "transport_source_calculation_type" using primary key columns */
  transportSourceCalculationType_by_pk?: Maybe<TransportSourceCalculationType>;
  /** fetch data from the table in a streaming manner: "transport_source_calculation_type" */
  transportSourceCalculationType_stream: Array<TransportSourceCalculationType>;
  /** fetch aggregated fields from the table: "transport_source" */
  transportSource_aggregate: TransportSource_Aggregate;
  /** fetch data from the table: "transport_source" using primary key columns */
  transportSource_by_pk?: Maybe<TransportSource>;
  /** fetch data from the table in a streaming manner: "transport_source" */
  transportSource_stream: Array<TransportSource>;
  /** fetch aggregated fields from the table: "transport" */
  transport_aggregate: Transport_Aggregate;
  /** fetch data from the table: "transport" using primary key columns */
  transport_by_pk?: Maybe<Transport>;
  /** fetch data from the table: "transport_standard_value" */
  transport_standard_value: Array<Transport_Standard_Value>;
  /** fetch aggregated fields from the table: "transport_standard_value" */
  transport_standard_value_aggregate: Transport_Standard_Value_Aggregate;
  /** fetch data from the table: "transport_standard_value" using primary key columns */
  transport_standard_value_by_pk?: Maybe<Transport_Standard_Value>;
  /** fetch data from the table in a streaming manner: "transport_standard_value" */
  transport_standard_value_stream: Array<Transport_Standard_Value>;
  /** fetch data from the table in a streaming manner: "transport" */
  transport_stream: Array<Transport>;
  /** fetch data from the table: "transport_type" */
  transport_type: Array<Transport_Type>;
  /** fetch aggregated fields from the table: "transport_type" */
  transport_type_aggregate: Transport_Type_Aggregate;
  /** fetch data from the table: "transport_type" using primary key columns */
  transport_type_by_pk?: Maybe<Transport_Type>;
  /** fetch data from the table in a streaming manner: "transport_type" */
  transport_type_stream: Array<Transport_Type>;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table in a streaming manner: "unit" */
  unit_stream: Array<Unit>;
  /** fetch data from the table: "user_material_favorite" */
  userMaterialFavorite: Array<UserMaterialFavorite>;
  /** fetch aggregated fields from the table: "user_material_favorite" */
  userMaterialFavorite_aggregate: UserMaterialFavorite_Aggregate;
  /** fetch data from the table: "user_material_favorite" using primary key columns */
  userMaterialFavorite_by_pk?: Maybe<UserMaterialFavorite>;
  /** fetch data from the table in a streaming manner: "user_material_favorite" */
  userMaterialFavorite_stream: Array<UserMaterialFavorite>;
  /** fetch data from the table: "user_platform_review" */
  userPlatformReview: Array<UserPlatformReview>;
  /** fetch aggregated fields from the table: "user_platform_review" */
  userPlatformReview_aggregate: UserPlatformReview_Aggregate;
  /** fetch data from the table: "user_platform_review" using primary key columns */
  userPlatformReview_by_pk?: Maybe<UserPlatformReview>;
  /** fetch data from the table in a streaming manner: "user_platform_review" */
  userPlatformReview_stream: Array<UserPlatformReview>;
  /** fetch data from the table: "user_project_view" */
  userProjectView: Array<UserProjectView>;
  /** fetch aggregated fields from the table: "user_project_view" */
  userProjectView_aggregate: UserProjectView_Aggregate;
  /** fetch data from the table: "user_project_view" using primary key columns */
  userProjectView_by_pk?: Maybe<UserProjectView>;
  /** fetch data from the table in a streaming manner: "user_project_view" */
  userProjectView_stream: Array<UserProjectView>;
  /** fetch data from the table: "user_tutorial_view" */
  userTutorialView: Array<UserTutorialView>;
  /** fetch aggregated fields from the table: "user_tutorial_view" */
  userTutorialView_aggregate: UserTutorialView_Aggregate;
  /** fetch data from the table: "user_tutorial_view" using primary key columns */
  userTutorialView_by_pk?: Maybe<UserTutorialView>;
  /** fetch data from the table in a streaming manner: "user_tutorial_view" */
  userTutorialView_stream: Array<UserTutorialView>;
  /** fetch data from the table: "user_welcome_flow" */
  userWelcomeFlow: Array<UserWelcomeFlow>;
  /** fetch data from the table: "user_welcome_flow_event" */
  userWelcomeFlowEvent: Array<UserWelcomeFlowEvent>;
  /** fetch aggregated fields from the table: "user_welcome_flow_event" */
  userWelcomeFlowEvent_aggregate: UserWelcomeFlowEvent_Aggregate;
  /** fetch data from the table: "user_welcome_flow_event" using primary key columns */
  userWelcomeFlowEvent_by_pk?: Maybe<UserWelcomeFlowEvent>;
  /** fetch data from the table in a streaming manner: "user_welcome_flow_event" */
  userWelcomeFlowEvent_stream: Array<UserWelcomeFlowEvent>;
  /** fetch aggregated fields from the table: "user_welcome_flow" */
  userWelcomeFlow_aggregate: UserWelcomeFlow_Aggregate;
  /** fetch data from the table: "user_welcome_flow" using primary key columns */
  userWelcomeFlow_by_pk?: Maybe<UserWelcomeFlow>;
  /** fetch data from the table in a streaming manner: "user_welcome_flow" */
  userWelcomeFlow_stream: Array<UserWelcomeFlow>;
  /** fetch data from the table: "v_latest_snapshot" */
  vLatestSnapshot: Array<VLatestSnapshot>;
  /** fetch aggregated fields from the table: "v_latest_snapshot" */
  vLatestSnapshot_aggregate: VLatestSnapshot_Aggregate;
  /** fetch data from the table in a streaming manner: "v_latest_snapshot" */
  vLatestSnapshot_stream: Array<VLatestSnapshot>;
  /** fetch data from the table: "v_material_current" */
  vMaterialCurrent: Array<VMaterialCurrent>;
  /** fetch aggregated fields from the table: "v_material_current" */
  vMaterialCurrent_aggregate: VMaterialCurrent_Aggregate;
  /** fetch data from the table in a streaming manner: "v_material_current" */
  vMaterialCurrent_stream: Array<VMaterialCurrent>;
  /** fetch data from the table: "v_material_gwp" */
  vMaterialGwp: Array<VMaterialGwp>;
  /** fetch aggregated fields from the table: "v_material_gwp" */
  vMaterialGwp_aggregate: VMaterialGwp_Aggregate;
  /** fetch data from the table in a streaming manner: "v_material_gwp" */
  vMaterialGwp_stream: Array<VMaterialGwp>;
  /** fetch data from the table: "v_material_status" */
  vMaterialStatus: Array<VMaterialStatus>;
  /** fetch aggregated fields from the table: "v_material_status" */
  vMaterialStatus_aggregate: VMaterialStatus_Aggregate;
  /** fetch data from the table in a streaming manner: "v_material_status" */
  vMaterialStatus_stream: Array<VMaterialStatus>;
  /** fetch data from the table: "v_project_intensity" */
  vProjectIntensity: Array<VProjectIntensity>;
  /** fetch aggregated fields from the table: "v_project_intensity" */
  vProjectIntensity_aggregate: VProjectIntensity_Aggregate;
  /** fetch data from the table in a streaming manner: "v_project_intensity" */
  vProjectIntensity_stream: Array<VProjectIntensity>;
  /** fetch data from the table: "weight_per_declared_unit" */
  weightPerDeclaredUnit: Array<WeightPerDeclaredUnit>;
  /** fetch aggregated fields from the table: "weight_per_declared_unit" */
  weightPerDeclaredUnit_aggregate: WeightPerDeclaredUnit_Aggregate;
  /** fetch data from the table: "weight_per_declared_unit" using primary key columns */
  weightPerDeclaredUnit_by_pk?: Maybe<WeightPerDeclaredUnit>;
  /** fetch data from the table in a streaming manner: "weight_per_declared_unit" */
  weightPerDeclaredUnit_stream: Array<WeightPerDeclaredUnit>;
};


export type Subscription_RootAgentModelPricingArgs = {
  distinct_on?: InputMaybe<Array<AgentModelPricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentModelPricing_Order_By>>;
  where?: InputMaybe<AgentModelPricing_Bool_Exp>;
};


export type Subscription_RootAgentModelPricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentModelPricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentModelPricing_Order_By>>;
  where?: InputMaybe<AgentModelPricing_Bool_Exp>;
};


export type Subscription_RootAgentModelPricing_By_PkArgs = {
  model: Scalars['String']['input'];
};


export type Subscription_RootAgentModelPricing_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgentModelPricing_Stream_Cursor_Input>>;
  where?: InputMaybe<AgentModelPricing_Bool_Exp>;
};


export type Subscription_RootAgentSkillsTenantUserArgs = {
  distinct_on?: InputMaybe<Array<AgentSkillsTenantUser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentSkillsTenantUser_Order_By>>;
  where?: InputMaybe<AgentSkillsTenantUser_Bool_Exp>;
};


export type Subscription_RootAgentSkillsTenantUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentSkillsTenantUser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentSkillsTenantUser_Order_By>>;
  where?: InputMaybe<AgentSkillsTenantUser_Bool_Exp>;
};


export type Subscription_RootAgentSkillsTenantUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgentSkillsTenantUser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgentSkillsTenantUser_Stream_Cursor_Input>>;
  where?: InputMaybe<AgentSkillsTenantUser_Bool_Exp>;
};


export type Subscription_RootAgentUsageBudgetStatusArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageBudgetStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageBudgetStatus_Order_By>>;
  where?: InputMaybe<AgentUsageBudgetStatus_Bool_Exp>;
};


export type Subscription_RootAgentUsageBudgetStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageBudgetStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageBudgetStatus_Order_By>>;
  where?: InputMaybe<AgentUsageBudgetStatus_Bool_Exp>;
};


export type Subscription_RootAgentUsageBudgetStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgentUsageBudgetStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<AgentUsageBudgetStatus_Bool_Exp>;
};


export type Subscription_RootAgentUsageDailyArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageDaily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageDaily_Order_By>>;
  where?: InputMaybe<AgentUsageDaily_Bool_Exp>;
};


export type Subscription_RootAgentUsageDaily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageDaily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageDaily_Order_By>>;
  where?: InputMaybe<AgentUsageDaily_Bool_Exp>;
};


export type Subscription_RootAgentUsageDaily_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgentUsageDaily_Stream_Cursor_Input>>;
  where?: InputMaybe<AgentUsageDaily_Bool_Exp>;
};


export type Subscription_RootAgentUsageRequestArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageRequest_Order_By>>;
  where?: InputMaybe<AgentUsageRequest_Bool_Exp>;
};


export type Subscription_RootAgentUsageRequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageRequest_Order_By>>;
  where?: InputMaybe<AgentUsageRequest_Bool_Exp>;
};


export type Subscription_RootAgentUsageRequest_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgentUsageRequest_Stream_Cursor_Input>>;
  where?: InputMaybe<AgentUsageRequest_Bool_Exp>;
};


export type Subscription_RootAgentUsageSessionArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageSession_Order_By>>;
  where?: InputMaybe<AgentUsageSession_Bool_Exp>;
};


export type Subscription_RootAgentUsageSession_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentUsageSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgentUsageSession_Order_By>>;
  where?: InputMaybe<AgentUsageSession_Bool_Exp>;
};


export type Subscription_RootAgentUsageSession_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgentUsageSession_Stream_Cursor_Input>>;
  where?: InputMaybe<AgentUsageSession_Bool_Exp>;
};


export type Subscription_RootApplicationSourceArgs = {
  distinct_on?: InputMaybe<Array<ApplicationSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ApplicationSource_Order_By>>;
  where?: InputMaybe<ApplicationSource_Bool_Exp>;
};


export type Subscription_RootApplicationSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ApplicationSource_Order_By>>;
  where?: InputMaybe<ApplicationSource_Bool_Exp>;
};


export type Subscription_RootApplicationSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplicationSource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ApplicationSource_Stream_Cursor_Input>>;
  where?: InputMaybe<ApplicationSource_Bool_Exp>;
};


export type Subscription_RootBenchmarkGroupingVerdictArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkGroupingVerdict_Order_By>>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};


export type Subscription_RootBenchmarkGroupingVerdict_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkGroupingVerdict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkGroupingVerdict_Order_By>>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};


export type Subscription_RootBenchmarkGroupingVerdict_By_PkArgs = {
  materialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
  source: Scalars['String']['input'];
};


export type Subscription_RootBenchmarkGroupingVerdict_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BenchmarkGroupingVerdict_Stream_Cursor_Input>>;
  where?: InputMaybe<BenchmarkGroupingVerdict_Bool_Exp>;
};


export type Subscription_RootBenchmarkInventoryMaterialArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkInventoryMaterial_Order_By>>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};


export type Subscription_RootBenchmarkInventoryMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkInventoryMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkInventoryMaterial_Order_By>>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};


export type Subscription_RootBenchmarkInventoryMaterial_By_PkArgs = {
  materialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};


export type Subscription_RootBenchmarkInventoryMaterial_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BenchmarkInventoryMaterial_Stream_Cursor_Input>>;
  where?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
};


export type Subscription_RootBenchmarkMaterialMappingArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkMaterialMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkMaterialMapping_Order_By>>;
  where?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
};


export type Subscription_RootBenchmarkMaterialMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkMaterialMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkMaterialMapping_Order_By>>;
  where?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
};


export type Subscription_RootBenchmarkMaterialMapping_By_PkArgs = {
  layerIndex: Scalars['Int']['input'];
  parentMaterialId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};


export type Subscription_RootBenchmarkMaterialMapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BenchmarkMaterialMapping_Stream_Cursor_Input>>;
  where?: InputMaybe<BenchmarkMaterialMapping_Bool_Exp>;
};


export type Subscription_RootBenchmarkProjectStateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkProjectState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkProjectState_Order_By>>;
  where?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
};


export type Subscription_RootBenchmarkProjectState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkProjectState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkProjectState_Order_By>>;
  where?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
};


export type Subscription_RootBenchmarkProjectState_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
  snapshotId: Scalars['bigint']['input'];
};


export type Subscription_RootBenchmarkProjectState_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BenchmarkProjectState_Stream_Cursor_Input>>;
  where?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
};


export type Subscription_RootBenchmarkSnapshotArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkSnapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkSnapshot_Order_By>>;
  where?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
};


export type Subscription_RootBenchmarkSnapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BenchmarkSnapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BenchmarkSnapshot_Order_By>>;
  where?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
};


export type Subscription_RootBenchmarkSnapshot_By_PkArgs = {
  snapshotId: Scalars['bigint']['input'];
};


export type Subscription_RootBenchmarkSnapshot_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BenchmarkSnapshot_Stream_Cursor_Input>>;
  where?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
};


export type Subscription_RootBuildingAreaTypeArgs = {
  distinct_on?: InputMaybe<Array<BuildingAreaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingAreaType_Order_By>>;
  where?: InputMaybe<BuildingAreaType_Bool_Exp>;
};


export type Subscription_RootBuildingAreaType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingAreaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingAreaType_Order_By>>;
  where?: InputMaybe<BuildingAreaType_Bool_Exp>;
};


export type Subscription_RootBuildingAreaType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBuildingAreaType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BuildingAreaType_Stream_Cursor_Input>>;
  where?: InputMaybe<BuildingAreaType_Bool_Exp>;
};


export type Subscription_RootBuildingPartArgs = {
  distinct_on?: InputMaybe<Array<BuildingPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPart_Order_By>>;
  where?: InputMaybe<BuildingPart_Bool_Exp>;
};


export type Subscription_RootBuildingPartLifetimeSourceArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartLifetimeSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartLifetimeSource_Order_By>>;
  where?: InputMaybe<BuildingPartLifetimeSource_Bool_Exp>;
};


export type Subscription_RootBuildingPartLifetimeSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartLifetimeSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartLifetimeSource_Order_By>>;
  where?: InputMaybe<BuildingPartLifetimeSource_Bool_Exp>;
};


export type Subscription_RootBuildingPartLifetimeSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuildingPartLifetimeSource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BuildingPartLifetimeSource_Stream_Cursor_Input>>;
  where?: InputMaybe<BuildingPartLifetimeSource_Bool_Exp>;
};


export type Subscription_RootBuildingPartMaintenanceLifetimeArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartMaintenanceLifetime_Bool_Exp>;
};


export type Subscription_RootBuildingPartMaintenanceLifetime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartMaintenanceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartMaintenanceLifetime_Bool_Exp>;
};


export type Subscription_RootBuildingPartMaintenanceLifetime_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuildingPartMaintenanceLifetime_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BuildingPartMaintenanceLifetime_Stream_Cursor_Input>>;
  where?: InputMaybe<BuildingPartMaintenanceLifetime_Bool_Exp>;
};


export type Subscription_RootBuildingPartServiceLifetimeArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartServiceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartServiceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
};


export type Subscription_RootBuildingPartServiceLifetime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingPartServiceLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPartServiceLifetime_Order_By>>;
  where?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
};


export type Subscription_RootBuildingPartServiceLifetime_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuildingPartServiceLifetime_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BuildingPartServiceLifetime_Stream_Cursor_Input>>;
  where?: InputMaybe<BuildingPartServiceLifetime_Bool_Exp>;
};


export type Subscription_RootBuildingPart_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingPart_Order_By>>;
  where?: InputMaybe<BuildingPart_Bool_Exp>;
};


export type Subscription_RootBuildingPart_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuildingPart_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BuildingPart_Stream_Cursor_Input>>;
  where?: InputMaybe<BuildingPart_Bool_Exp>;
};


export type Subscription_RootBuildingTypeArgs = {
  distinct_on?: InputMaybe<Array<BuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingType_Order_By>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Subscription_RootBuildingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingType_Order_By>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Subscription_RootBuildingType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootBuildingType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BuildingType_Stream_Cursor_Input>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Subscription_RootBuilding_ElementArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Order_By>>;
  where?: InputMaybe<Building_Element_Bool_Exp>;
};


export type Subscription_RootBuilding_Element_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Order_By>>;
  where?: InputMaybe<Building_Element_Bool_Exp>;
};


export type Subscription_RootBuilding_Element_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuilding_Element_Classification_Code_MappingArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Classification_Code_Mapping_Bool_Exp>;
};


export type Subscription_RootBuilding_Element_Classification_Code_Mapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Classification_Code_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Classification_Code_Mapping_Bool_Exp>;
};


export type Subscription_RootBuilding_Element_Classification_Code_Mapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuilding_Element_Classification_Code_Mapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Building_Element_Classification_Code_Mapping_Stream_Cursor_Input>>;
  where?: InputMaybe<Building_Element_Classification_Code_Mapping_Bool_Exp>;
};


export type Subscription_RootBuilding_Element_Material_Category_MappingArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};


export type Subscription_RootBuilding_Element_Material_Category_Mapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Building_Element_Material_Category_Mapping_Order_By>>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};


export type Subscription_RootBuilding_Element_Material_Category_Mapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuilding_Element_Material_Category_Mapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Building_Element_Material_Category_Mapping_Stream_Cursor_Input>>;
  where?: InputMaybe<Building_Element_Material_Category_Mapping_Bool_Exp>;
};


export type Subscription_RootBuilding_Element_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Building_Element_Stream_Cursor_Input>>;
  where?: InputMaybe<Building_Element_Bool_Exp>;
};


export type Subscription_RootCalculationTypeArgs = {
  distinct_on?: InputMaybe<Array<CalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationType_Order_By>>;
  where?: InputMaybe<CalculationType_Bool_Exp>;
};


export type Subscription_RootCalculationTypeEpdDatasourceArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeEpdDatasource_Order_By>>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};


export type Subscription_RootCalculationTypeEpdDatasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeEpdDatasource_Order_By>>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};


export type Subscription_RootCalculationTypeEpdDatasource_By_PkArgs = {
  calculationTypeId: Scalars['Int']['input'];
  epdDatasourceId: Scalars['uuid']['input'];
};


export type Subscription_RootCalculationTypeEpdDatasource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CalculationTypeEpdDatasource_Stream_Cursor_Input>>;
  where?: InputMaybe<CalculationTypeEpdDatasource_Bool_Exp>;
};


export type Subscription_RootCalculationTypeThresholdByBuildingTypeArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Order_By>>;
  where?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
};


export type Subscription_RootCalculationTypeThresholdByBuildingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeThresholdByBuildingType_Order_By>>;
  where?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
};


export type Subscription_RootCalculationTypeThresholdByBuildingType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCalculationTypeThresholdByBuildingType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CalculationTypeThresholdByBuildingType_Stream_Cursor_Input>>;
  where?: InputMaybe<CalculationTypeThresholdByBuildingType_Bool_Exp>;
};


export type Subscription_RootCalculationTypeVariantArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeVariant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeVariant_Order_By>>;
  where?: InputMaybe<CalculationTypeVariant_Bool_Exp>;
};


export type Subscription_RootCalculationTypeVariant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationTypeVariant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationTypeVariant_Order_By>>;
  where?: InputMaybe<CalculationTypeVariant_Bool_Exp>;
};


export type Subscription_RootCalculationTypeVariant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCalculationTypeVariant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CalculationTypeVariant_Stream_Cursor_Input>>;
  where?: InputMaybe<CalculationTypeVariant_Bool_Exp>;
};


export type Subscription_RootCalculationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CalculationType_Order_By>>;
  where?: InputMaybe<CalculationType_Bool_Exp>;
};


export type Subscription_RootCalculationType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCalculationType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CalculationType_Stream_Cursor_Input>>;
  where?: InputMaybe<CalculationType_Bool_Exp>;
};


export type Subscription_RootCalculation_Type_StageArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Type_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Calculation_Type_Stage_Order_By>>;
  where?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
};


export type Subscription_RootCalculation_Type_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Type_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Calculation_Type_Stage_Order_By>>;
  where?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
};


export type Subscription_RootCalculation_Type_Stage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCalculation_Type_Stage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Calculation_Type_Stage_Stream_Cursor_Input>>;
  where?: InputMaybe<Calculation_Type_Stage_Bool_Exp>;
};


export type Subscription_RootClassificationCodeArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCode_Order_By>>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};


export type Subscription_RootClassificationCodeTranslationArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTranslation_Order_By>>;
  where?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
};


export type Subscription_RootClassificationCodeTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTranslation_Order_By>>;
  where?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
};


export type Subscription_RootClassificationCodeTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootClassificationCodeTranslation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ClassificationCodeTranslation_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassificationCodeTranslation_Bool_Exp>;
};


export type Subscription_RootClassificationCodeTypeCountryArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTypeCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTypeCountry_Order_By>>;
  where?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
};


export type Subscription_RootClassificationCodeTypeCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCodeTypeCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCodeTypeCountry_Order_By>>;
  where?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
};


export type Subscription_RootClassificationCodeTypeCountry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootClassificationCodeTypeCountry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ClassificationCodeTypeCountry_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassificationCodeTypeCountry_Bool_Exp>;
};


export type Subscription_RootClassificationCode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationCode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationCode_Order_By>>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};


export type Subscription_RootClassificationCode_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootClassificationCode_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ClassificationCode_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassificationCode_Bool_Exp>;
};


export type Subscription_RootClassificationObjectClassArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClass_Order_By>>;
  where?: InputMaybe<ClassificationObjectClass_Bool_Exp>;
};


export type Subscription_RootClassificationObjectClassParameterArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassParameter_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
};


export type Subscription_RootClassificationObjectClassParameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassParameter_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
};


export type Subscription_RootClassificationObjectClassParameter_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootClassificationObjectClassParameter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ClassificationObjectClassParameter_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassificationObjectClassParameter_Bool_Exp>;
};


export type Subscription_RootClassificationObjectClassTranslationArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassTranslation_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
};


export type Subscription_RootClassificationObjectClassTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClassTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClassTranslation_Order_By>>;
  where?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
};


export type Subscription_RootClassificationObjectClassTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootClassificationObjectClassTranslation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ClassificationObjectClassTranslation_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassificationObjectClassTranslation_Bool_Exp>;
};


export type Subscription_RootClassificationObjectClass_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationObjectClass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationObjectClass_Order_By>>;
  where?: InputMaybe<ClassificationObjectClass_Bool_Exp>;
};


export type Subscription_RootClassificationObjectClass_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootClassificationObjectClass_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ClassificationObjectClass_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassificationObjectClass_Bool_Exp>;
};


export type Subscription_RootClassificationTypeArgs = {
  distinct_on?: InputMaybe<Array<ClassificationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationType_Order_By>>;
  where?: InputMaybe<ClassificationType_Bool_Exp>;
};


export type Subscription_RootClassificationTypeAttributeArgs = {
  distinct_on?: InputMaybe<Array<ClassificationTypeAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationTypeAttribute_Order_By>>;
  where?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
};


export type Subscription_RootClassificationTypeAttribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationTypeAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationTypeAttribute_Order_By>>;
  where?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
};


export type Subscription_RootClassificationTypeAttribute_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootClassificationTypeAttribute_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ClassificationTypeAttribute_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassificationTypeAttribute_Bool_Exp>;
};


export type Subscription_RootClassificationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassificationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ClassificationType_Order_By>>;
  where?: InputMaybe<ClassificationType_Bool_Exp>;
};


export type Subscription_RootClassificationType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootClassificationType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ClassificationType_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassificationType_Bool_Exp>;
};


export type Subscription_RootComponentObjectPhaseArgs = {
  distinct_on?: InputMaybe<Array<ComponentObjectPhase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ComponentObjectPhase_Order_By>>;
  where?: InputMaybe<ComponentObjectPhase_Bool_Exp>;
};


export type Subscription_RootComponentObjectPhase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ComponentObjectPhase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ComponentObjectPhase_Order_By>>;
  where?: InputMaybe<ComponentObjectPhase_Bool_Exp>;
};


export type Subscription_RootComponentObjectPhase_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootComponentObjectPhase_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ComponentObjectPhase_Stream_Cursor_Input>>;
  where?: InputMaybe<ComponentObjectPhase_Bool_Exp>;
};


export type Subscription_RootConstructionArgs = {
  distinct_on?: InputMaybe<Array<Construction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Order_By>>;
  where?: InputMaybe<Construction_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpPartArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPart_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpPartMaterialCategoryArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpPartMaterialCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartMaterialCategory_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpPartMaterialCategory_By_PkArgs = {
  materialCategoryId: Scalars['String']['input'];
  partKey: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type Subscription_RootConstructionBuildUpPartMaterialCategory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionBuildUpPartMaterialCategory_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionBuildUpPartMaterialCategory_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpPartTranslationArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpPartTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPartTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpPartTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionBuildUpPartTranslation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionBuildUpPartTranslation_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionBuildUpPartTranslation_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpPart_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpPart_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpPart_By_PkArgs = {
  key: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type Subscription_RootConstructionBuildUpPart_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionBuildUpPart_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionBuildUpPart_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpTemplateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplate_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpTemplateTranslationArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpTemplateTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplateTranslation_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpTemplateTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionBuildUpTemplateTranslation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionBuildUpTemplateTranslation_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionBuildUpTemplateTranslation_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpTemplate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionBuildUpTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionBuildUpTemplate_Order_By>>;
  where?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
};


export type Subscription_RootConstructionBuildUpTemplate_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootConstructionBuildUpTemplate_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionBuildUpTemplate_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionBuildUpTemplate_Bool_Exp>;
};


export type Subscription_RootConstructionCategoryArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategory_Order_By>>;
  where?: InputMaybe<ConstructionCategory_Bool_Exp>;
};


export type Subscription_RootConstructionCategoryTranslationArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryTranslation_Order_By>>;
  where?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
};


export type Subscription_RootConstructionCategoryTranslation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryTranslation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryTranslation_Order_By>>;
  where?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
};


export type Subscription_RootConstructionCategoryTranslation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionCategoryTranslation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionCategoryTranslation_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionCategoryTranslation_Bool_Exp>;
};


export type Subscription_RootConstructionCategoryUnitArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryUnit_Order_By>>;
  where?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
};


export type Subscription_RootConstructionCategoryUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategoryUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategoryUnit_Order_By>>;
  where?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
};


export type Subscription_RootConstructionCategoryUnit_By_PkArgs = {
  constructionCategoryId: Scalars['String']['input'];
  unitId: Scalars['Int']['input'];
};


export type Subscription_RootConstructionCategoryUnit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionCategoryUnit_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionCategoryUnit_Bool_Exp>;
};


export type Subscription_RootConstructionCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCategory_Order_By>>;
  where?: InputMaybe<ConstructionCategory_Bool_Exp>;
};


export type Subscription_RootConstructionCategory_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootConstructionCategory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionCategory_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionCategory_Bool_Exp>;
};


export type Subscription_RootConstructionCountryArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCountry_Order_By>>;
  where?: InputMaybe<ConstructionCountry_Bool_Exp>;
};


export type Subscription_RootConstructionCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionCountry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionCountry_Order_By>>;
  where?: InputMaybe<ConstructionCountry_Bool_Exp>;
};


export type Subscription_RootConstructionCountry_By_PkArgs = {
  constructionId: Scalars['uuid']['input'];
  country: Country_Enum;
};


export type Subscription_RootConstructionCountry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionCountry_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionCountry_Bool_Exp>;
};


export type Subscription_RootConstructionDescriptionArgs = {
  distinct_on?: InputMaybe<Array<ConstructionDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionDescription_Order_By>>;
  where?: InputMaybe<ConstructionDescription_Bool_Exp>;
};


export type Subscription_RootConstructionDescription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionDescription_Order_By>>;
  where?: InputMaybe<ConstructionDescription_Bool_Exp>;
};


export type Subscription_RootConstructionDescription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionDescription_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionDescription_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionDescription_Bool_Exp>;
};


export type Subscription_RootConstructionForkArgs = {
  distinct_on?: InputMaybe<Array<ConstructionFork_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionFork_Order_By>>;
  where?: InputMaybe<ConstructionFork_Bool_Exp>;
};


export type Subscription_RootConstructionFork_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionFork_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionFork_Order_By>>;
  where?: InputMaybe<ConstructionFork_Bool_Exp>;
};


export type Subscription_RootConstructionFork_By_PkArgs = {
  constructionId: Scalars['uuid']['input'];
  parentConstructionId: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionFork_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionFork_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionFork_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogeneousLayerArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayer_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogeneousLayerMaterialArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogeneousLayerMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayerMaterial_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogeneousLayerMaterial_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionInhomogeneousLayerMaterial_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionInhomogeneousLayerMaterial_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionInhomogeneousLayerMaterial_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogeneousLayer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogeneousLayer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogeneousLayer_Order_By>>;
  where?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogeneousLayer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionInhomogeneousLayer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionInhomogeneousLayer_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionInhomogeneousLayer_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogenousLayerDescriptionArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogenousLayerDescription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerDescription_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogenousLayerDescription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionInhomogenousLayerDescription_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionInhomogenousLayerDescription_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionInhomogenousLayerDescription_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogenousLayerNameArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerName_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogenousLayerName_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionInhomogenousLayerName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionInhomogenousLayerName_Order_By>>;
  where?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
};


export type Subscription_RootConstructionInhomogenousLayerName_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionInhomogenousLayerName_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionInhomogenousLayerName_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionInhomogenousLayerName_Bool_Exp>;
};


export type Subscription_RootConstructionMaterialArgs = {
  distinct_on?: InputMaybe<Array<ConstructionMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionMaterial_Order_By>>;
  where?: InputMaybe<ConstructionMaterial_Bool_Exp>;
};


export type Subscription_RootConstructionMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionMaterial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionMaterial_Order_By>>;
  where?: InputMaybe<ConstructionMaterial_Bool_Exp>;
};


export type Subscription_RootConstructionMaterial_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionMaterial_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionMaterial_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionMaterial_Bool_Exp>;
};


export type Subscription_RootConstructionNameArgs = {
  distinct_on?: InputMaybe<Array<ConstructionName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionName_Order_By>>;
  where?: InputMaybe<ConstructionName_Bool_Exp>;
};


export type Subscription_RootConstructionName_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionName_Order_By>>;
  where?: InputMaybe<ConstructionName_Bool_Exp>;
};


export type Subscription_RootConstructionName_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionName_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionName_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionName_Bool_Exp>;
};


export type Subscription_RootConstructionSortingArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSorting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSorting_Order_By>>;
  where?: InputMaybe<ConstructionSorting_Bool_Exp>;
};


export type Subscription_RootConstructionSorting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSorting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSorting_Order_By>>;
  where?: InputMaybe<ConstructionSorting_Bool_Exp>;
};


export type Subscription_RootConstructionSorting_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionSorting_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionSorting_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionSorting_Bool_Exp>;
};


export type Subscription_RootConstruction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Construction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Construction_Order_By>>;
  where?: InputMaybe<Construction_Bool_Exp>;
};


export type Subscription_RootConstruction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstruction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Construction_Stream_Cursor_Input>>;
  where?: InputMaybe<Construction_Bool_Exp>;
};


export type Subscription_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountryConfigArgs = {
  distinct_on?: InputMaybe<Array<CountryConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CountryConfig_Order_By>>;
  where?: InputMaybe<CountryConfig_Bool_Exp>;
};


export type Subscription_RootCountryConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CountryConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CountryConfig_Order_By>>;
  where?: InputMaybe<CountryConfig_Bool_Exp>;
};


export type Subscription_RootCountryConfig_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCountryConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CountryConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<CountryConfig_Bool_Exp>;
};


export type Subscription_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCountry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootDeclaredUnitArgs = {
  distinct_on?: InputMaybe<Array<DeclaredUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DeclaredUnit_Order_By>>;
  where?: InputMaybe<DeclaredUnit_Bool_Exp>;
};


export type Subscription_RootDeclaredUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DeclaredUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DeclaredUnit_Order_By>>;
  where?: InputMaybe<DeclaredUnit_Bool_Exp>;
};


export type Subscription_RootDeclaredUnit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDeclaredUnit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DeclaredUnit_Stream_Cursor_Input>>;
  where?: InputMaybe<DeclaredUnit_Bool_Exp>;
};


export type Subscription_RootDenominatorUnitArgs = {
  distinct_on?: InputMaybe<Array<DenominatorUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DenominatorUnit_Order_By>>;
  where?: InputMaybe<DenominatorUnit_Bool_Exp>;
};


export type Subscription_RootDenominatorUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DenominatorUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DenominatorUnit_Order_By>>;
  where?: InputMaybe<DenominatorUnit_Bool_Exp>;
};


export type Subscription_RootDenominatorUnit_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDenominatorUnit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DenominatorUnit_Stream_Cursor_Input>>;
  where?: InputMaybe<DenominatorUnit_Bool_Exp>;
};


export type Subscription_RootDistance_UnitArgs = {
  distinct_on?: InputMaybe<Array<Distance_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Distance_Unit_Order_By>>;
  where?: InputMaybe<Distance_Unit_Bool_Exp>;
};


export type Subscription_RootDistance_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Distance_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Distance_Unit_Order_By>>;
  where?: InputMaybe<Distance_Unit_Bool_Exp>;
};


export type Subscription_RootDistance_Unit_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDistance_Unit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Distance_Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Distance_Unit_Bool_Exp>;
};


export type Subscription_RootEmissionFactorSourceTypeArgs = {
  distinct_on?: InputMaybe<Array<EmissionFactorSourceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmissionFactorSourceType_Order_By>>;
  where?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
};


export type Subscription_RootEmissionFactorSourceType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EmissionFactorSourceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmissionFactorSourceType_Order_By>>;
  where?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
};


export type Subscription_RootEmissionFactorSourceType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmissionFactorSourceType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EmissionFactorSourceType_Stream_Cursor_Input>>;
  where?: InputMaybe<EmissionFactorSourceType_Bool_Exp>;
};


export type Subscription_RootEmission_FactorArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Order_By>>;
  where?: InputMaybe<Emission_Factor_Bool_Exp>;
};


export type Subscription_RootEmission_Factor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Order_By>>;
  where?: InputMaybe<Emission_Factor_Bool_Exp>;
};


export type Subscription_RootEmission_Factor_By_PkArgs = {
  emission_factor_source_id: Scalars['uuid']['input'];
  emission_factor_type: Emission_Factor_Type_Enum;
  year: Scalars['Int']['input'];
};


export type Subscription_RootEmission_Factor_SourceArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Source_Order_By>>;
  where?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
};


export type Subscription_RootEmission_Factor_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Source_Order_By>>;
  where?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
};


export type Subscription_RootEmission_Factor_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmission_Factor_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emission_Factor_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Emission_Factor_Source_Bool_Exp>;
};


export type Subscription_RootEmission_Factor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emission_Factor_Stream_Cursor_Input>>;
  where?: InputMaybe<Emission_Factor_Bool_Exp>;
};


export type Subscription_RootEmission_Factor_TypeArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Type_Order_By>>;
  where?: InputMaybe<Emission_Factor_Type_Bool_Exp>;
};


export type Subscription_RootEmission_Factor_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emission_Factor_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emission_Factor_Type_Order_By>>;
  where?: InputMaybe<Emission_Factor_Type_Bool_Exp>;
};


export type Subscription_RootEmission_Factor_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEmission_Factor_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emission_Factor_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Emission_Factor_Type_Bool_Exp>;
};


export type Subscription_RootEnumCollectionTypeArgs = {
  distinct_on?: InputMaybe<Array<EnumCollectionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EnumCollectionType_Order_By>>;
  where?: InputMaybe<EnumCollectionType_Bool_Exp>;
};


export type Subscription_RootEnumCollectionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EnumCollectionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EnumCollectionType_Order_By>>;
  where?: InputMaybe<EnumCollectionType_Bool_Exp>;
};


export type Subscription_RootEnumCollectionType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnumCollectionType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EnumCollectionType_Stream_Cursor_Input>>;
  where?: InputMaybe<EnumCollectionType_Bool_Exp>;
};


export type Subscription_RootEpdDatasourceArgs = {
  distinct_on?: InputMaybe<Array<EpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdDatasource_Order_By>>;
  where?: InputMaybe<EpdDatasource_Bool_Exp>;
};


export type Subscription_RootEpdDatasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdDatasource_Order_By>>;
  where?: InputMaybe<EpdDatasource_Bool_Exp>;
};


export type Subscription_RootEpdDatasource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEpdDatasource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EpdDatasource_Stream_Cursor_Input>>;
  where?: InputMaybe<EpdDatasource_Bool_Exp>;
};


export type Subscription_RootEpdOwnerArgs = {
  distinct_on?: InputMaybe<Array<EpdOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwner_Order_By>>;
  where?: InputMaybe<EpdOwner_Bool_Exp>;
};


export type Subscription_RootEpdOwnerAliasArgs = {
  distinct_on?: InputMaybe<Array<EpdOwnerAlias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwnerAlias_Order_By>>;
  where?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
};


export type Subscription_RootEpdOwnerAlias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdOwnerAlias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwnerAlias_Order_By>>;
  where?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
};


export type Subscription_RootEpdOwnerAlias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEpdOwnerAlias_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EpdOwnerAlias_Stream_Cursor_Input>>;
  where?: InputMaybe<EpdOwnerAlias_Bool_Exp>;
};


export type Subscription_RootEpdOwner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdOwner_Order_By>>;
  where?: InputMaybe<EpdOwner_Bool_Exp>;
};


export type Subscription_RootEpdOwner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEpdOwner_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EpdOwner_Stream_Cursor_Input>>;
  where?: InputMaybe<EpdOwner_Bool_Exp>;
};


export type Subscription_RootEpdProductIndustryArgs = {
  distinct_on?: InputMaybe<Array<EpdProductIndustry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdProductIndustry_Order_By>>;
  where?: InputMaybe<EpdProductIndustry_Bool_Exp>;
};


export type Subscription_RootEpdProductIndustry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdProductIndustry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdProductIndustry_Order_By>>;
  where?: InputMaybe<EpdProductIndustry_Bool_Exp>;
};


export type Subscription_RootEpdProductIndustry_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEpdProductIndustry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EpdProductIndustry_Stream_Cursor_Input>>;
  where?: InputMaybe<EpdProductIndustry_Bool_Exp>;
};


export type Subscription_RootEpdSpecificationFormArgs = {
  distinct_on?: InputMaybe<Array<EpdSpecificationForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdSpecificationForm_Order_By>>;
  where?: InputMaybe<EpdSpecificationForm_Bool_Exp>;
};


export type Subscription_RootEpdSpecificationForm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EpdSpecificationForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EpdSpecificationForm_Order_By>>;
  where?: InputMaybe<EpdSpecificationForm_Bool_Exp>;
};


export type Subscription_RootEpdSpecificationForm_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEpdSpecificationForm_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EpdSpecificationForm_Stream_Cursor_Input>>;
  where?: InputMaybe<EpdSpecificationForm_Bool_Exp>;
};


export type Subscription_RootFlowGuideArgs = {
  distinct_on?: InputMaybe<Array<FlowGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuide_Order_By>>;
  where?: InputMaybe<FlowGuide_Bool_Exp>;
};


export type Subscription_RootFlowGuideViewsArgs = {
  distinct_on?: InputMaybe<Array<FlowGuideViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuideViews_Order_By>>;
  where?: InputMaybe<FlowGuideViews_Bool_Exp>;
};


export type Subscription_RootFlowGuideViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowGuideViews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuideViews_Order_By>>;
  where?: InputMaybe<FlowGuideViews_Bool_Exp>;
};


export type Subscription_RootFlowGuideViews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFlowGuideViews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FlowGuideViews_Stream_Cursor_Input>>;
  where?: InputMaybe<FlowGuideViews_Bool_Exp>;
};


export type Subscription_RootFlowGuide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FlowGuide_Order_By>>;
  where?: InputMaybe<FlowGuide_Bool_Exp>;
};


export type Subscription_RootFlowGuide_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFlowGuide_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FlowGuide_Stream_Cursor_Input>>;
  where?: InputMaybe<FlowGuide_Bool_Exp>;
};


export type Subscription_RootIndicatorSourceArgs = {
  distinct_on?: InputMaybe<Array<IndicatorSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorSource_Order_By>>;
  where?: InputMaybe<IndicatorSource_Bool_Exp>;
};


export type Subscription_RootIndicatorSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorSource_Order_By>>;
  where?: InputMaybe<IndicatorSource_Bool_Exp>;
};


export type Subscription_RootIndicatorSource_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootIndicatorSource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IndicatorSource_Stream_Cursor_Input>>;
  where?: InputMaybe<IndicatorSource_Bool_Exp>;
};


export type Subscription_RootIndicatorTypeArgs = {
  distinct_on?: InputMaybe<Array<IndicatorType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorType_Order_By>>;
  where?: InputMaybe<IndicatorType_Bool_Exp>;
};


export type Subscription_RootIndicatorTypeMappingArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMapping_Order_By>>;
  where?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
};


export type Subscription_RootIndicatorTypeMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMapping_Order_By>>;
  where?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
};


export type Subscription_RootIndicatorTypeMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIndicatorTypeMapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IndicatorTypeMapping_Stream_Cursor_Input>>;
  where?: InputMaybe<IndicatorTypeMapping_Bool_Exp>;
};


export type Subscription_RootIndicatorTypeMultiplierArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMultiplier_Order_By>>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};


export type Subscription_RootIndicatorTypeMultiplier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorTypeMultiplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorTypeMultiplier_Order_By>>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};


export type Subscription_RootIndicatorTypeMultiplier_By_PkArgs = {
  fromIndicatorTypeId: Scalars['Int']['input'];
};


export type Subscription_RootIndicatorTypeMultiplier_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IndicatorTypeMultiplier_Stream_Cursor_Input>>;
  where?: InputMaybe<IndicatorTypeMultiplier_Bool_Exp>;
};


export type Subscription_RootIndicatorType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IndicatorType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorType_Order_By>>;
  where?: InputMaybe<IndicatorType_Bool_Exp>;
};


export type Subscription_RootIndicatorType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootIndicatorType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IndicatorType_Stream_Cursor_Input>>;
  where?: InputMaybe<IndicatorType_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_ValueArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_Building_TypeArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Building_Type_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_Building_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Building_Type_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Building_Type_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_Building_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInstallation_Standard_Value_Building_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Installation_Standard_Value_Building_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Installation_Standard_Value_Building_Type_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInstallation_Standard_Value_Classification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Classification_Type_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_Classification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Classification_Type_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Classification_Type_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_Classification_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInstallation_Standard_Value_Classification_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Installation_Standard_Value_Classification_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Installation_Standard_Value_Classification_Type_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_DatasourceArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Datasource_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Datasource_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_Datasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Datasource_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Datasource_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_Datasource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInstallation_Standard_Value_Datasource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Installation_Standard_Value_Datasource_Stream_Cursor_Input>>;
  where?: InputMaybe<Installation_Standard_Value_Datasource_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_EmissionArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Emission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Emission_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Emission_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_Emission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installation_Standard_Value_Emission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installation_Standard_Value_Emission_Order_By>>;
  where?: InputMaybe<Installation_Standard_Value_Emission_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_Emission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInstallation_Standard_Value_Emission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Installation_Standard_Value_Emission_Stream_Cursor_Input>>;
  where?: InputMaybe<Installation_Standard_Value_Emission_Bool_Exp>;
};


export type Subscription_RootInstallation_Standard_Value_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Installation_Standard_Value_Stream_Cursor_Input>>;
  where?: InputMaybe<Installation_Standard_Value_Bool_Exp>;
};


export type Subscription_RootLanguageArgs = {
  distinct_on?: InputMaybe<Array<Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Language_Order_By>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Subscription_RootLanguage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Language_Order_By>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Subscription_RootLanguage_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type Subscription_RootLanguage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Language_Stream_Cursor_Input>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Subscription_RootLifetime_TableArgs = {
  distinct_on?: InputMaybe<Array<Lifetime_Table_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lifetime_Table_Order_By>>;
  where?: InputMaybe<Lifetime_Table_Bool_Exp>;
};


export type Subscription_RootLifetime_Table_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lifetime_Table_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lifetime_Table_Order_By>>;
  where?: InputMaybe<Lifetime_Table_Bool_Exp>;
};


export type Subscription_RootLifetime_Table_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLifetime_Table_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lifetime_Table_Stream_Cursor_Input>>;
  where?: InputMaybe<Lifetime_Table_Bool_Exp>;
};


export type Subscription_RootMappingHistoryArgs = {
  distinct_on?: InputMaybe<Array<MappingHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistory_Order_By>>;
  where?: InputMaybe<MappingHistory_Bool_Exp>;
};


export type Subscription_RootMappingHistoryFrequencyArgs = {
  distinct_on?: InputMaybe<Array<MappingHistoryFrequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistoryFrequency_Order_By>>;
  where?: InputMaybe<MappingHistoryFrequency_Bool_Exp>;
};


export type Subscription_RootMappingHistoryFrequency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MappingHistoryFrequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistoryFrequency_Order_By>>;
  where?: InputMaybe<MappingHistoryFrequency_Bool_Exp>;
};


export type Subscription_RootMappingHistoryFrequency_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MappingHistoryFrequency_Stream_Cursor_Input>>;
  where?: InputMaybe<MappingHistoryFrequency_Bool_Exp>;
};


export type Subscription_RootMappingHistoryMostRecentLifetimeArgs = {
  distinct_on?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Order_By>>;
  where?: InputMaybe<MappingHistoryMostRecentLifetime_Bool_Exp>;
};


export type Subscription_RootMappingHistoryMostRecentLifetime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistoryMostRecentLifetime_Order_By>>;
  where?: InputMaybe<MappingHistoryMostRecentLifetime_Bool_Exp>;
};


export type Subscription_RootMappingHistoryMostRecentLifetime_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MappingHistoryMostRecentLifetime_Stream_Cursor_Input>>;
  where?: InputMaybe<MappingHistoryMostRecentLifetime_Bool_Exp>;
};


export type Subscription_RootMappingHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MappingHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MappingHistory_Order_By>>;
  where?: InputMaybe<MappingHistory_Bool_Exp>;
};


export type Subscription_RootMappingHistory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMappingHistory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MappingHistory_Stream_Cursor_Input>>;
  where?: InputMaybe<MappingHistory_Bool_Exp>;
};


export type Subscription_RootMapping_History_Most_Used_LifetimeArgs = {
  distinct_on?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Order_By>>;
  where?: InputMaybe<Mapping_History_Most_Used_Lifetime_Bool_Exp>;
};


export type Subscription_RootMapping_History_Most_Used_Lifetime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mapping_History_Most_Used_Lifetime_Order_By>>;
  where?: InputMaybe<Mapping_History_Most_Used_Lifetime_Bool_Exp>;
};


export type Subscription_RootMapping_History_Most_Used_Lifetime_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mapping_History_Most_Used_Lifetime_Stream_Cursor_Input>>;
  where?: InputMaybe<Mapping_History_Most_Used_Lifetime_Bool_Exp>;
};


export type Subscription_RootMaterialArgs = {
  distinct_on?: InputMaybe<Array<Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Material_Order_By>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Subscription_RootMaterialBiogenicParamsArgs = {
  distinct_on?: InputMaybe<Array<MaterialBiogenicParams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialBiogenicParams_Order_By>>;
  where?: InputMaybe<MaterialBiogenicParams_Bool_Exp>;
};


export type Subscription_RootMaterialBiogenicParams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialBiogenicParams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialBiogenicParams_Order_By>>;
  where?: InputMaybe<MaterialBiogenicParams_Bool_Exp>;
};


export type Subscription_RootMaterialBiogenicParams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialBiogenicParams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialBiogenicParams_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialBiogenicParams_Bool_Exp>;
};


export type Subscription_RootMaterialCategoryArgs = {
  distinct_on?: InputMaybe<Array<MaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialCategory_Order_By>>;
  where?: InputMaybe<MaterialCategory_Bool_Exp>;
};


export type Subscription_RootMaterialCategoryTextureArgs = {
  distinct_on?: InputMaybe<Array<MaterialCategoryTexture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialCategoryTexture_Order_By>>;
  where?: InputMaybe<MaterialCategoryTexture_Bool_Exp>;
};


export type Subscription_RootMaterialCategoryTexture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialCategoryTexture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialCategoryTexture_Order_By>>;
  where?: InputMaybe<MaterialCategoryTexture_Bool_Exp>;
};


export type Subscription_RootMaterialCategoryTexture_By_PkArgs = {
  materialCategoryId: Scalars['String']['input'];
};


export type Subscription_RootMaterialCategoryTexture_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialCategoryTexture_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialCategoryTexture_Bool_Exp>;
};


export type Subscription_RootMaterialCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialCategory_Order_By>>;
  where?: InputMaybe<MaterialCategory_Bool_Exp>;
};


export type Subscription_RootMaterialCategory_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootMaterialCategory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialCategory_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialCategory_Bool_Exp>;
};


export type Subscription_RootMaterialDescriptionArgs = {
  distinct_on?: InputMaybe<Array<MaterialDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialDescription_Order_By>>;
  where?: InputMaybe<MaterialDescription_Bool_Exp>;
};


export type Subscription_RootMaterialDescription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialDescription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialDescription_Order_By>>;
  where?: InputMaybe<MaterialDescription_Bool_Exp>;
};


export type Subscription_RootMaterialDescription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialDescription_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialDescription_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialDescription_Bool_Exp>;
};


export type Subscription_RootMaterialEmissionIndicatorArgs = {
  distinct_on?: InputMaybe<Array<MaterialEmissionIndicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEmissionIndicator_Order_By>>;
  where?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
};


export type Subscription_RootMaterialEmissionIndicator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEmissionIndicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEmissionIndicator_Order_By>>;
  where?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
};


export type Subscription_RootMaterialEmissionIndicator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialEmissionIndicator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialEmissionIndicator_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialEmissionIndicator_Bool_Exp>;
};


export type Subscription_RootMaterialEpdArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpd_Order_By>>;
  where?: InputMaybe<MaterialEpd_Bool_Exp>;
};


export type Subscription_RootMaterialEpdDatasourceArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdDatasource_Order_By>>;
  where?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
};


export type Subscription_RootMaterialEpdDatasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdDatasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdDatasource_Order_By>>;
  where?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
};


export type Subscription_RootMaterialEpdDatasource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialEpdDatasource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialEpdDatasource_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialEpdDatasource_Bool_Exp>;
};


export type Subscription_RootMaterialEpdUrlArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdUrl_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdUrl_Order_By>>;
  where?: InputMaybe<MaterialEpdUrl_Bool_Exp>;
};


export type Subscription_RootMaterialEpdUrl_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpdUrl_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpdUrl_Order_By>>;
  where?: InputMaybe<MaterialEpdUrl_Bool_Exp>;
};


export type Subscription_RootMaterialEpdUrl_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialEpdUrl_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialEpdUrl_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialEpdUrl_Bool_Exp>;
};


export type Subscription_RootMaterialEpd_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialEpd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialEpd_Order_By>>;
  where?: InputMaybe<MaterialEpd_Bool_Exp>;
};


export type Subscription_RootMaterialEpd_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialEpd_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialEpd_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialEpd_Bool_Exp>;
};


export type Subscription_RootMaterialForkArgs = {
  distinct_on?: InputMaybe<Array<MaterialFork_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialFork_Order_By>>;
  where?: InputMaybe<MaterialFork_Bool_Exp>;
};


export type Subscription_RootMaterialFork_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialFork_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialFork_Order_By>>;
  where?: InputMaybe<MaterialFork_Bool_Exp>;
};


export type Subscription_RootMaterialFork_By_PkArgs = {
  materialId: Scalars['uuid']['input'];
  parentMaterialId: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialFork_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialFork_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialFork_Bool_Exp>;
};


export type Subscription_RootMaterialNameArgs = {
  distinct_on?: InputMaybe<Array<MaterialName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialName_Order_By>>;
  where?: InputMaybe<MaterialName_Bool_Exp>;
};


export type Subscription_RootMaterialName_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialName_Order_By>>;
  where?: InputMaybe<MaterialName_Bool_Exp>;
};


export type Subscription_RootMaterialName_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialName_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialName_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialName_Bool_Exp>;
};


export type Subscription_RootMaterialStageArgs = {
  distinct_on?: InputMaybe<Array<MaterialStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStage_Order_By>>;
  where?: InputMaybe<MaterialStage_Bool_Exp>;
};


export type Subscription_RootMaterialStage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStage_Order_By>>;
  where?: InputMaybe<MaterialStage_Bool_Exp>;
};


export type Subscription_RootMaterialStage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialStage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialStage_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialStage_Bool_Exp>;
};


export type Subscription_RootMaterialTypeArgs = {
  distinct_on?: InputMaybe<Array<MaterialType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialType_Order_By>>;
  where?: InputMaybe<MaterialType_Bool_Exp>;
};


export type Subscription_RootMaterialType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialType_Order_By>>;
  where?: InputMaybe<MaterialType_Bool_Exp>;
};


export type Subscription_RootMaterialType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMaterialType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialType_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialType_Bool_Exp>;
};


export type Subscription_RootMaterialWasteSourceArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteSource_Order_By>>;
  where?: InputMaybe<MaterialWasteSource_Bool_Exp>;
};


export type Subscription_RootMaterialWasteSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteSource_Order_By>>;
  where?: InputMaybe<MaterialWasteSource_Bool_Exp>;
};


export type Subscription_RootMaterialWasteSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialWasteSource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialWasteSource_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialWasteSource_Bool_Exp>;
};


export type Subscription_RootMaterialWasteTypeArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteType_Order_By>>;
  where?: InputMaybe<MaterialWasteType_Bool_Exp>;
};


export type Subscription_RootMaterialWasteType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MaterialWasteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialWasteType_Order_By>>;
  where?: InputMaybe<MaterialWasteType_Bool_Exp>;
};


export type Subscription_RootMaterialWasteType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialWasteType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialWasteType_Stream_Cursor_Input>>;
  where?: InputMaybe<MaterialWasteType_Bool_Exp>;
};


export type Subscription_RootMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Material_Order_By>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Subscription_RootMaterial_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterial_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Material_Stream_Cursor_Input>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Subscription_RootMcpConnectionArgs = {
  distinct_on?: InputMaybe<Array<McpConnection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<McpConnection_Order_By>>;
  where?: InputMaybe<McpConnection_Bool_Exp>;
};


export type Subscription_RootMcpConnection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<McpConnection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<McpConnection_Order_By>>;
  where?: InputMaybe<McpConnection_Bool_Exp>;
};


export type Subscription_RootMcpConnection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMcpConnection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<McpConnection_Stream_Cursor_Input>>;
  where?: InputMaybe<McpConnection_Bool_Exp>;
};


export type Subscription_RootMcpToolCallArgs = {
  distinct_on?: InputMaybe<Array<McpToolCall_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<McpToolCall_Order_By>>;
  where?: InputMaybe<McpToolCall_Bool_Exp>;
};


export type Subscription_RootMcpToolCall_AggregateArgs = {
  distinct_on?: InputMaybe<Array<McpToolCall_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<McpToolCall_Order_By>>;
  where?: InputMaybe<McpToolCall_Bool_Exp>;
};


export type Subscription_RootMcpToolCall_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMcpToolCall_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<McpToolCall_Stream_Cursor_Input>>;
  where?: InputMaybe<McpToolCall_Bool_Exp>;
};


export type Subscription_RootModelArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Order_By>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Subscription_RootModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Order_By>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Subscription_RootModel_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootModel_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Model_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Subscription_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProjectBuildingAreaArgs = {
  distinct_on?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectBuildingArea_Order_By>>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};


export type Subscription_RootProjectBuildingArea_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectBuildingArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectBuildingArea_Order_By>>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};


export type Subscription_RootProjectBuildingArea_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectBuildingArea_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectBuildingArea_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectBuildingArea_Bool_Exp>;
};


export type Subscription_RootProjectCalculationArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculation_Order_By>>;
  where?: InputMaybe<ProjectCalculation_Bool_Exp>;
};


export type Subscription_RootProjectCalculationStageArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculationStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculationStage_Order_By>>;
  where?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
};


export type Subscription_RootProjectCalculationStage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculationStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculationStage_Order_By>>;
  where?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
};


export type Subscription_RootProjectCalculationStage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectCalculationStage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectCalculationStage_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectCalculationStage_Bool_Exp>;
};


export type Subscription_RootProjectCalculation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectCalculation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectCalculation_Order_By>>;
  where?: InputMaybe<ProjectCalculation_Bool_Exp>;
};


export type Subscription_RootProjectCalculation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectCalculation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectCalculation_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectCalculation_Bool_Exp>;
};


export type Subscription_RootProjectComponentMappingTypeArgs = {
  distinct_on?: InputMaybe<Array<ProjectComponentMappingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectComponentMappingType_Order_By>>;
  where?: InputMaybe<ProjectComponentMappingType_Bool_Exp>;
};


export type Subscription_RootProjectComponentMappingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectComponentMappingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectComponentMappingType_Order_By>>;
  where?: InputMaybe<ProjectComponentMappingType_Bool_Exp>;
};


export type Subscription_RootProjectComponentMappingType_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootProjectComponentMappingType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectComponentMappingType_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectComponentMappingType_Bool_Exp>;
};


export type Subscription_RootProjectDashboardStatusArgs = {
  distinct_on?: InputMaybe<Array<ProjectDashboardStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectDashboardStatus_Order_By>>;
  where?: InputMaybe<ProjectDashboardStatus_Bool_Exp>;
};


export type Subscription_RootProjectDashboardStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectDashboardStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectDashboardStatus_Order_By>>;
  where?: InputMaybe<ProjectDashboardStatus_Bool_Exp>;
};


export type Subscription_RootProjectDashboardStatus_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


export type Subscription_RootProjectDashboardStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectDashboardStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectDashboardStatus_Bool_Exp>;
};


export type Subscription_RootProjectEmissionFactorArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};


export type Subscription_RootProjectEmissionFactorCustomArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactorCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactorCustom_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactorCustom_Bool_Exp>;
};


export type Subscription_RootProjectEmissionFactorCustom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactorCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactorCustom_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactorCustom_Bool_Exp>;
};


export type Subscription_RootProjectEmissionFactorCustom_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectEmissionFactorCustom_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectEmissionFactorCustom_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectEmissionFactorCustom_Bool_Exp>;
};


export type Subscription_RootProjectEmissionFactor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};


export type Subscription_RootProjectEmissionFactor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectEmissionFactor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectEmissionFactor_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectEmissionFactor_Bool_Exp>;
};


export type Subscription_RootProjectInstallationArgs = {
  distinct_on?: InputMaybe<Array<ProjectInstallation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectInstallation_Order_By>>;
  where?: InputMaybe<ProjectInstallation_Bool_Exp>;
};


export type Subscription_RootProjectInstallation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectInstallation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectInstallation_Order_By>>;
  where?: InputMaybe<ProjectInstallation_Bool_Exp>;
};


export type Subscription_RootProjectInstallation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectInstallation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectInstallation_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectInstallation_Bool_Exp>;
};


export type Subscription_RootProjectLocationArgs = {
  distinct_on?: InputMaybe<Array<ProjectLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectLocation_Order_By>>;
  where?: InputMaybe<ProjectLocation_Bool_Exp>;
};


export type Subscription_RootProjectLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectLocation_Order_By>>;
  where?: InputMaybe<ProjectLocation_Bool_Exp>;
};


export type Subscription_RootProjectLocation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectLocation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectLocation_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectLocation_Bool_Exp>;
};


export type Subscription_RootProjectMaterialClassificationFeedbackArgs = {
  distinct_on?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Order_By>>;
  where?: InputMaybe<ProjectMaterialClassificationFeedback_Bool_Exp>;
};


export type Subscription_RootProjectMaterialClassificationFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMaterialClassificationFeedback_Order_By>>;
  where?: InputMaybe<ProjectMaterialClassificationFeedback_Bool_Exp>;
};


export type Subscription_RootProjectMaterialClassificationFeedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectMaterialClassificationFeedback_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectMaterialClassificationFeedback_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectMaterialClassificationFeedback_Bool_Exp>;
};


export type Subscription_RootProjectMaterialClassificationParameterArgs = {
  distinct_on?: InputMaybe<Array<ProjectMaterialClassificationParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMaterialClassificationParameter_Order_By>>;
  where?: InputMaybe<ProjectMaterialClassificationParameter_Bool_Exp>;
};


export type Subscription_RootProjectMaterialClassificationParameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectMaterialClassificationParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMaterialClassificationParameter_Order_By>>;
  where?: InputMaybe<ProjectMaterialClassificationParameter_Bool_Exp>;
};


export type Subscription_RootProjectMaterialClassificationParameter_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectMaterialClassificationParameter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectMaterialClassificationParameter_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectMaterialClassificationParameter_Bool_Exp>;
};


export type Subscription_RootProjectMembershipArgs = {
  distinct_on?: InputMaybe<Array<ProjectMembership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMembership_Order_By>>;
  where?: InputMaybe<ProjectMembership_Bool_Exp>;
};


export type Subscription_RootProjectMembership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectMembership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectMembership_Order_By>>;
  where?: InputMaybe<ProjectMembership_Bool_Exp>;
};


export type Subscription_RootProjectMembership_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectMembership_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectMembership_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectMembership_Bool_Exp>;
};


export type Subscription_RootProjectModelArgs = {
  distinct_on?: InputMaybe<Array<ProjectModel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModel_Order_By>>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};


export type Subscription_RootProjectModelSpecklePinArgs = {
  distinct_on?: InputMaybe<Array<ProjectModelSpecklePin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModelSpecklePin_Order_By>>;
  where?: InputMaybe<ProjectModelSpecklePin_Bool_Exp>;
};


export type Subscription_RootProjectModelSpecklePin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectModelSpecklePin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModelSpecklePin_Order_By>>;
  where?: InputMaybe<ProjectModelSpecklePin_Bool_Exp>;
};


export type Subscription_RootProjectModelSpecklePin_By_PkArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
};


export type Subscription_RootProjectModelSpecklePin_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectModelSpecklePin_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectModelSpecklePin_Bool_Exp>;
};


export type Subscription_RootProjectModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectModel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectModel_Order_By>>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};


export type Subscription_RootProjectModel_By_PkArgs = {
  id: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
  revisionId: Scalars['uuid']['input'];
};


export type Subscription_RootProjectModel_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectModel_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectModel_Bool_Exp>;
};


export type Subscription_RootProjectOperationalArgs = {
  distinct_on?: InputMaybe<Array<ProjectOperational_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectOperational_Order_By>>;
  where?: InputMaybe<ProjectOperational_Bool_Exp>;
};


export type Subscription_RootProjectOperational_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectOperational_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectOperational_Order_By>>;
  where?: InputMaybe<ProjectOperational_Bool_Exp>;
};


export type Subscription_RootProjectOperational_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectOperational_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectOperational_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectOperational_Bool_Exp>;
};


export type Subscription_RootProjectReferenceAreaArgs = {
  distinct_on?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectReferenceArea_Order_By>>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};


export type Subscription_RootProjectReferenceArea_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectReferenceArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectReferenceArea_Order_By>>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};


export type Subscription_RootProjectReferenceArea_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectReferenceArea_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectReferenceArea_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectReferenceArea_Bool_Exp>;
};


export type Subscription_RootProjectRevisionArgs = {
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


export type Subscription_RootProjectRevision_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectRevision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectRevision_Order_By>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


export type Subscription_RootProjectRevision_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectRevision_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectRevision_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectRevision_Bool_Exp>;
};


export type Subscription_RootProjectSpecialConditionConfigArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionConfig_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionConfig_Bool_Exp>;
};


export type Subscription_RootProjectSpecialConditionConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionConfig_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionConfig_Bool_Exp>;
};


export type Subscription_RootProjectSpecialConditionConfig_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
  revisionId: Scalars['uuid']['input'];
};


export type Subscription_RootProjectSpecialConditionConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectSpecialConditionConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectSpecialConditionConfig_Bool_Exp>;
};


export type Subscription_RootProjectSpecialConditionTypeMappingArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};


export type Subscription_RootProjectSpecialConditionTypeMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpecialConditionTypeMapping_Order_By>>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};


export type Subscription_RootProjectSpecialConditionTypeMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectSpecialConditionTypeMapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectSpecialConditionTypeMapping_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleCopyArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleCopy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleCopy_Order_By>>;
  where?: InputMaybe<ProjectSpeckleCopy_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleCopyRecentArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleCopyRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleCopyRecent_Order_By>>;
  where?: InputMaybe<ProjectSpeckleCopyRecent_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleCopyRecent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleCopyRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleCopyRecent_Order_By>>;
  where?: InputMaybe<ProjectSpeckleCopyRecent_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleCopyRecent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectSpeckleCopyRecent_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectSpeckleCopyRecent_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleCopy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleCopy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleCopy_Order_By>>;
  where?: InputMaybe<ProjectSpeckleCopy_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleCopy_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


export type Subscription_RootProjectSpeckleCopy_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectSpeckleCopy_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectSpeckleCopy_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleModelSyncArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleModelSync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleModelSync_Order_By>>;
  where?: InputMaybe<ProjectSpeckleModelSync_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleModelSyncRecentArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Order_By>>;
  where?: InputMaybe<ProjectSpeckleModelSyncRecent_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleModelSyncRecent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleModelSyncRecent_Order_By>>;
  where?: InputMaybe<ProjectSpeckleModelSyncRecent_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleModelSyncRecent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectSpeckleModelSyncRecent_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectSpeckleModelSyncRecent_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleModelSync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleModelSync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleModelSync_Order_By>>;
  where?: InputMaybe<ProjectSpeckleModelSync_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleModelSync_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


export type Subscription_RootProjectSpeckleModelSync_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectSpeckleModelSync_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectSpeckleModelSync_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleParameterConfigArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleParameterConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleParameterConfig_Order_By>>;
  where?: InputMaybe<ProjectSpeckleParameterConfig_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleParameterConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectSpeckleParameterConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectSpeckleParameterConfig_Order_By>>;
  where?: InputMaybe<ProjectSpeckleParameterConfig_Bool_Exp>;
};


export type Subscription_RootProjectSpeckleParameterConfig_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
};


export type Subscription_RootProjectSpeckleParameterConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectSpeckleParameterConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectSpeckleParameterConfig_Bool_Exp>;
};


export type Subscription_RootProjectStandardValueStageArgs = {
  distinct_on?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStandardValueStage_Order_By>>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};


export type Subscription_RootProjectStandardValueStage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectStandardValueStage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStandardValueStage_Order_By>>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};


export type Subscription_RootProjectStandardValueStage_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectStandardValueStage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectStandardValueStage_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
};


export type Subscription_RootProjectStatusArgs = {
  distinct_on?: InputMaybe<Array<ProjectStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStatus_Order_By>>;
  where?: InputMaybe<ProjectStatus_Bool_Exp>;
};


export type Subscription_RootProjectStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectStatus_Order_By>>;
  where?: InputMaybe<ProjectStatus_Bool_Exp>;
};


export type Subscription_RootProjectStatus_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProjectStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectStatus_Bool_Exp>;
};


export type Subscription_RootProjectTenantStatusAreaArgs = {
  distinct_on?: InputMaybe<Array<ProjectTenantStatusArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTenantStatusArea_Order_By>>;
  where?: InputMaybe<ProjectTenantStatusArea_Bool_Exp>;
};


export type Subscription_RootProjectTenantStatusArea_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectTenantStatusArea_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTenantStatusArea_Order_By>>;
  where?: InputMaybe<ProjectTenantStatusArea_Bool_Exp>;
};


export type Subscription_RootProjectTenantStatusArea_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectTenantStatusArea_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectTenantStatusArea_Bool_Exp>;
};


export type Subscription_RootProjectTransportMappingEmissionFactorArgs = {
  distinct_on?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
};


export type Subscription_RootProjectTransportMappingEmissionFactor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectTransportMappingEmissionFactor_Order_By>>;
  where?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
};


export type Subscription_RootProjectTransportMappingEmissionFactor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectTransportMappingEmissionFactor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectTransportMappingEmissionFactor_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectTransportMappingEmissionFactor_Bool_Exp>;
};


export type Subscription_RootProjectVersionArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersion_Order_By>>;
  where?: InputMaybe<ProjectVersion_Bool_Exp>;
};


export type Subscription_RootProjectVersionNumberedArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersionNumbered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersionNumbered_Order_By>>;
  where?: InputMaybe<ProjectVersionNumbered_Bool_Exp>;
};


export type Subscription_RootProjectVersionNumbered_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersionNumbered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersionNumbered_Order_By>>;
  where?: InputMaybe<ProjectVersionNumbered_Bool_Exp>;
};


export type Subscription_RootProjectVersionNumbered_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectVersionNumbered_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectVersionNumbered_Bool_Exp>;
};


export type Subscription_RootProjectVersion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectVersion_Order_By>>;
  where?: InputMaybe<ProjectVersion_Bool_Exp>;
};


export type Subscription_RootProjectVersion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectVersion_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectVersion_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectVersion_Bool_Exp>;
};


export type Subscription_RootProjectWasteMappingArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteMapping_Order_By>>;
  where?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
};


export type Subscription_RootProjectWasteMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteMapping_Order_By>>;
  where?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
};


export type Subscription_RootProjectWasteMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectWasteMapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectWasteMapping_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
};


export type Subscription_RootProjectWasteTypeCustomArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteTypeCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteTypeCustom_Order_By>>;
  where?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
};


export type Subscription_RootProjectWasteTypeCustom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectWasteTypeCustom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProjectWasteTypeCustom_Order_By>>;
  where?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
};


export type Subscription_RootProjectWasteTypeCustom_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjectWasteTypeCustom_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProjectWasteTypeCustom_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
};


export type Subscription_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Speckle_Stream_As_OfArgs = {
  args: Project_Speckle_Stream_As_Of_Args;
  distinct_on?: InputMaybe<Array<Speckle_Stream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speckle_Stream_Order_By>>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};


export type Subscription_RootProject_Speckle_Stream_As_Of_AggregateArgs = {
  args: Project_Speckle_Stream_As_Of_Args;
  distinct_on?: InputMaybe<Array<Speckle_Stream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speckle_Stream_Order_By>>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};


export type Subscription_RootProject_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_TransportArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Order_By>>;
  where?: InputMaybe<Project_Transport_Bool_Exp>;
};


export type Subscription_RootProject_Transport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Order_By>>;
  where?: InputMaybe<Project_Transport_Bool_Exp>;
};


export type Subscription_RootProject_Transport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Transport_DefaultArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Default_Order_By>>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};


export type Subscription_RootProject_Transport_Default_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Default_Order_By>>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};


export type Subscription_RootProject_Transport_Default_By_PkArgs = {
  project_transport_id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Transport_Default_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Transport_Default_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Transport_Default_Bool_Exp>;
};


export type Subscription_RootProject_Transport_MappingArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Mapping_Order_By>>;
  where?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
};


export type Subscription_RootProject_Transport_Mapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Transport_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Transport_Mapping_Order_By>>;
  where?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
};


export type Subscription_RootProject_Transport_Mapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Transport_Mapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Transport_Mapping_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
};


export type Subscription_RootProject_Transport_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Transport_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Transport_Bool_Exp>;
};


export type Subscription_RootReferenceAreaTypeArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaType_Order_By>>;
  where?: InputMaybe<ReferenceAreaType_Bool_Exp>;
};


export type Subscription_RootReferenceAreaTypeCalculationTypeMappingArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Order_By>>;
  where?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
};


export type Subscription_RootReferenceAreaTypeCalculationTypeMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaTypeCalculationTypeMapping_Order_By>>;
  where?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
};


export type Subscription_RootReferenceAreaTypeCalculationTypeMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReferenceAreaTypeCalculationTypeMapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Stream_Cursor_Input>>;
  where?: InputMaybe<ReferenceAreaTypeCalculationTypeMapping_Bool_Exp>;
};


export type Subscription_RootReferenceAreaType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReferenceAreaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReferenceAreaType_Order_By>>;
  where?: InputMaybe<ReferenceAreaType_Bool_Exp>;
};


export type Subscription_RootReferenceAreaType_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootReferenceAreaType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReferenceAreaType_Stream_Cursor_Input>>;
  where?: InputMaybe<ReferenceAreaType_Bool_Exp>;
};


export type Subscription_RootReportBuildingTypeMappingArgs = {
  distinct_on?: InputMaybe<Array<ReportBuildingTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportBuildingTypeMapping_Order_By>>;
  where?: InputMaybe<ReportBuildingTypeMapping_Bool_Exp>;
};


export type Subscription_RootReportBuildingTypeMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportBuildingTypeMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportBuildingTypeMapping_Order_By>>;
  where?: InputMaybe<ReportBuildingTypeMapping_Bool_Exp>;
};


export type Subscription_RootReportBuildingTypeMapping_By_PkArgs = {
  buildingTypeId: Scalars['Int']['input'];
};


export type Subscription_RootReportBuildingTypeMapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReportBuildingTypeMapping_Stream_Cursor_Input>>;
  where?: InputMaybe<ReportBuildingTypeMapping_Bool_Exp>;
};


export type Subscription_RootReportClassificationCodeEmissionMappingArgs = {
  distinct_on?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Order_By>>;
  where?: InputMaybe<ReportClassificationCodeEmissionMapping_Bool_Exp>;
};


export type Subscription_RootReportClassificationCodeEmissionMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportClassificationCodeEmissionMapping_Order_By>>;
  where?: InputMaybe<ReportClassificationCodeEmissionMapping_Bool_Exp>;
};


export type Subscription_RootReportClassificationCodeEmissionMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReportClassificationCodeEmissionMapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReportClassificationCodeEmissionMapping_Stream_Cursor_Input>>;
  where?: InputMaybe<ReportClassificationCodeEmissionMapping_Bool_Exp>;
};


export type Subscription_RootReportLoadBearingElementAmountMappingArgs = {
  distinct_on?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Order_By>>;
  where?: InputMaybe<ReportLoadBearingElementAmountMapping_Bool_Exp>;
};


export type Subscription_RootReportLoadBearingElementAmountMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportLoadBearingElementAmountMapping_Order_By>>;
  where?: InputMaybe<ReportLoadBearingElementAmountMapping_Bool_Exp>;
};


export type Subscription_RootReportLoadBearingElementAmountMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReportLoadBearingElementAmountMapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReportLoadBearingElementAmountMapping_Stream_Cursor_Input>>;
  where?: InputMaybe<ReportLoadBearingElementAmountMapping_Bool_Exp>;
};


export type Subscription_RootReportLoadBearingElementEmissionMappingArgs = {
  distinct_on?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Order_By>>;
  where?: InputMaybe<ReportLoadBearingElementEmissionMapping_Bool_Exp>;
};


export type Subscription_RootReportLoadBearingElementEmissionMapping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportLoadBearingElementEmissionMapping_Order_By>>;
  where?: InputMaybe<ReportLoadBearingElementEmissionMapping_Bool_Exp>;
};


export type Subscription_RootReportLoadBearingElementEmissionMapping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReportLoadBearingElementEmissionMapping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReportLoadBearingElementEmissionMapping_Stream_Cursor_Input>>;
  where?: InputMaybe<ReportLoadBearingElementEmissionMapping_Bool_Exp>;
};


export type Subscription_RootReportStructureArgs = {
  distinct_on?: InputMaybe<Array<ReportStructure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructure_Order_By>>;
  where?: InputMaybe<ReportStructure_Bool_Exp>;
};


export type Subscription_RootReportStructureCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureCalculationTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureCalculationTypes_Order_By>>;
  where?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
};


export type Subscription_RootReportStructureCalculationTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureCalculationTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureCalculationTypes_Order_By>>;
  where?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
};


export type Subscription_RootReportStructureCalculationTypes_By_PkArgs = {
  calculationTypeId: Scalars['Int']['input'];
  reportStructureId: Scalars['uuid']['input'];
};


export type Subscription_RootReportStructureCalculationTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReportStructureCalculationTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<ReportStructureCalculationTypes_Bool_Exp>;
};


export type Subscription_RootReportStructureClassificationCodesArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureClassificationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureClassificationCodes_Order_By>>;
  where?: InputMaybe<ReportStructureClassificationCodes_Bool_Exp>;
};


export type Subscription_RootReportStructureClassificationCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportStructureClassificationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructureClassificationCodes_Order_By>>;
  where?: InputMaybe<ReportStructureClassificationCodes_Bool_Exp>;
};


export type Subscription_RootReportStructureClassificationCodes_By_PkArgs = {
  classificationCodeId: Scalars['Int']['input'];
  reportStructureId: Scalars['uuid']['input'];
};


export type Subscription_RootReportStructureClassificationCodes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReportStructureClassificationCodes_Stream_Cursor_Input>>;
  where?: InputMaybe<ReportStructureClassificationCodes_Bool_Exp>;
};


export type Subscription_RootReportStructure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportStructure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportStructure_Order_By>>;
  where?: InputMaybe<ReportStructure_Bool_Exp>;
};


export type Subscription_RootReportStructure_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReportStructure_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReportStructure_Stream_Cursor_Input>>;
  where?: InputMaybe<ReportStructure_Bool_Exp>;
};


export type Subscription_RootReportfilesmetadataArgs = {
  distinct_on?: InputMaybe<Array<Reportfilesmetadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reportfilesmetadata_Order_By>>;
  where?: InputMaybe<Reportfilesmetadata_Bool_Exp>;
};


export type Subscription_RootReportfilesmetadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reportfilesmetadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reportfilesmetadata_Order_By>>;
  where?: InputMaybe<Reportfilesmetadata_Bool_Exp>;
};


export type Subscription_RootReportfilesmetadata_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReportfilesmetadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reportfilesmetadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Reportfilesmetadata_Bool_Exp>;
};


export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootSpecialConditionTypeArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionType_Order_By>>;
  where?: InputMaybe<SpecialConditionType_Bool_Exp>;
};


export type Subscription_RootSpecialConditionTypeCalculationTypeArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeCalculationType_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};


export type Subscription_RootSpecialConditionTypeCalculationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeCalculationType_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};


export type Subscription_RootSpecialConditionTypeCalculationType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSpecialConditionTypeCalculationType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpecialConditionTypeCalculationType_Stream_Cursor_Input>>;
  where?: InputMaybe<SpecialConditionTypeCalculationType_Bool_Exp>;
};


export type Subscription_RootSpecialConditionTypeInputParameterArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeInputParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeInputParameter_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeInputParameter_Bool_Exp>;
};


export type Subscription_RootSpecialConditionTypeInputParameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionTypeInputParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionTypeInputParameter_Order_By>>;
  where?: InputMaybe<SpecialConditionTypeInputParameter_Bool_Exp>;
};


export type Subscription_RootSpecialConditionTypeInputParameter_By_PkArgs = {
  specialConditionTypeCategoryId: Scalars['uuid']['input'];
};


export type Subscription_RootSpecialConditionTypeInputParameter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpecialConditionTypeInputParameter_Stream_Cursor_Input>>;
  where?: InputMaybe<SpecialConditionTypeInputParameter_Bool_Exp>;
};


export type Subscription_RootSpecialConditionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpecialConditionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpecialConditionType_Order_By>>;
  where?: InputMaybe<SpecialConditionType_Bool_Exp>;
};


export type Subscription_RootSpecialConditionType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSpecialConditionType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpecialConditionType_Stream_Cursor_Input>>;
  where?: InputMaybe<SpecialConditionType_Bool_Exp>;
};


export type Subscription_RootSpecial_Condition_Type_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Special_Condition_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Special_Condition_Type_Category_Order_By>>;
  where?: InputMaybe<Special_Condition_Type_Category_Bool_Exp>;
};


export type Subscription_RootSpecial_Condition_Type_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Special_Condition_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Special_Condition_Type_Category_Order_By>>;
  where?: InputMaybe<Special_Condition_Type_Category_Bool_Exp>;
};


export type Subscription_RootSpecial_Condition_Type_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSpecial_Condition_Type_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Special_Condition_Type_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Special_Condition_Type_Category_Bool_Exp>;
};


export type Subscription_RootSpeckleStreamModelIfcUploadArgs = {
  distinct_on?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Order_By>>;
  where?: InputMaybe<SpeckleStreamModelIfcUpload_Bool_Exp>;
};


export type Subscription_RootSpeckleStreamModelIfcUploadRecentArgs = {
  distinct_on?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Order_By>>;
  where?: InputMaybe<SpeckleStreamModelIfcUploadRecent_Bool_Exp>;
};


export type Subscription_RootSpeckleStreamModelIfcUploadRecent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleStreamModelIfcUploadRecent_Order_By>>;
  where?: InputMaybe<SpeckleStreamModelIfcUploadRecent_Bool_Exp>;
};


export type Subscription_RootSpeckleStreamModelIfcUploadRecent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpeckleStreamModelIfcUploadRecent_Stream_Cursor_Input>>;
  where?: InputMaybe<SpeckleStreamModelIfcUploadRecent_Bool_Exp>;
};


export type Subscription_RootSpeckleStreamModelIfcUpload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleStreamModelIfcUpload_Order_By>>;
  where?: InputMaybe<SpeckleStreamModelIfcUpload_Bool_Exp>;
};


export type Subscription_RootSpeckleStreamModelIfcUpload_By_PkArgs = {
  speckleProjectId: Scalars['String']['input'];
};


export type Subscription_RootSpeckleStreamModelIfcUpload_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpeckleStreamModelIfcUpload_Stream_Cursor_Input>>;
  where?: InputMaybe<SpeckleStreamModelIfcUpload_Bool_Exp>;
};


export type Subscription_RootSpeckleUserDataArgs = {
  distinct_on?: InputMaybe<Array<SpeckleUserData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleUserData_Order_By>>;
  where?: InputMaybe<SpeckleUserData_Bool_Exp>;
};


export type Subscription_RootSpeckleUserData_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SpeckleUserData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SpeckleUserData_Order_By>>;
  where?: InputMaybe<SpeckleUserData_Bool_Exp>;
};


export type Subscription_RootSpeckleUserData_By_PkArgs = {
  userId: Scalars['String']['input'];
};


export type Subscription_RootSpeckleUserData_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SpeckleUserData_Stream_Cursor_Input>>;
  where?: InputMaybe<SpeckleUserData_Bool_Exp>;
};


export type Subscription_RootSpeckle_StreamArgs = {
  distinct_on?: InputMaybe<Array<Speckle_Stream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speckle_Stream_Order_By>>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};


export type Subscription_RootSpeckle_Stream_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speckle_Stream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Speckle_Stream_Order_By>>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};


export type Subscription_RootSpeckle_Stream_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootSpeckle_Stream_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Speckle_Stream_Stream_Cursor_Input>>;
  where?: InputMaybe<Speckle_Stream_Bool_Exp>;
};


export type Subscription_RootStageArgs = {
  distinct_on?: InputMaybe<Array<Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Order_By>>;
  where?: InputMaybe<Stage_Bool_Exp>;
};


export type Subscription_RootStageDefaultEmissionArgs = {
  distinct_on?: InputMaybe<Array<StageDefaultEmission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StageDefaultEmission_Order_By>>;
  where?: InputMaybe<StageDefaultEmission_Bool_Exp>;
};


export type Subscription_RootStageDefaultEmission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StageDefaultEmission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<StageDefaultEmission_Order_By>>;
  where?: InputMaybe<StageDefaultEmission_Bool_Exp>;
};


export type Subscription_RootStageDefaultEmission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStageDefaultEmission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<StageDefaultEmission_Stream_Cursor_Input>>;
  where?: InputMaybe<StageDefaultEmission_Bool_Exp>;
};


export type Subscription_RootStage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Order_By>>;
  where?: InputMaybe<Stage_Bool_Exp>;
};


export type Subscription_RootStage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootStage_Default_Emission_Building_TypeArgs = {
  distinct_on?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Order_By>>;
  where?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
};


export type Subscription_RootStage_Default_Emission_Building_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stage_Default_Emission_Building_Type_Order_By>>;
  where?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
};


export type Subscription_RootStage_Default_Emission_Building_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStage_Default_Emission_Building_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Stage_Default_Emission_Building_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Stage_Default_Emission_Building_Type_Bool_Exp>;
};


export type Subscription_RootStage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Stage_Stream_Cursor_Input>>;
  where?: InputMaybe<Stage_Bool_Exp>;
};


export type Subscription_RootTenantAiBudgetArgs = {
  distinct_on?: InputMaybe<Array<TenantAiBudget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiBudget_Order_By>>;
  where?: InputMaybe<TenantAiBudget_Bool_Exp>;
};


export type Subscription_RootTenantAiBudget_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantAiBudget_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiBudget_Order_By>>;
  where?: InputMaybe<TenantAiBudget_Bool_Exp>;
};


export type Subscription_RootTenantAiBudget_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenantAiBudget_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantAiBudget_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantAiBudget_Bool_Exp>;
};


export type Subscription_RootTenantAiCreditPurchaseArgs = {
  distinct_on?: InputMaybe<Array<TenantAiCreditPurchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiCreditPurchase_Order_By>>;
  where?: InputMaybe<TenantAiCreditPurchase_Bool_Exp>;
};


export type Subscription_RootTenantAiCreditPurchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantAiCreditPurchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiCreditPurchase_Order_By>>;
  where?: InputMaybe<TenantAiCreditPurchase_Bool_Exp>;
};


export type Subscription_RootTenantAiCreditPurchase_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenantAiCreditPurchase_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantAiCreditPurchase_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantAiCreditPurchase_Bool_Exp>;
};


export type Subscription_RootTenantAiPaymentArgs = {
  distinct_on?: InputMaybe<Array<TenantAiPayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiPayment_Order_By>>;
  where?: InputMaybe<TenantAiPayment_Bool_Exp>;
};


export type Subscription_RootTenantAiPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantAiPayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantAiPayment_Order_By>>;
  where?: InputMaybe<TenantAiPayment_Bool_Exp>;
};


export type Subscription_RootTenantAiPayment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenantAiPayment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantAiPayment_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantAiPayment_Bool_Exp>;
};


export type Subscription_RootTenantCollectionArgs = {
  distinct_on?: InputMaybe<Array<TenantCollection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollection_Order_By>>;
  where?: InputMaybe<TenantCollection_Bool_Exp>;
};


export type Subscription_RootTenantCollectionItemArgs = {
  distinct_on?: InputMaybe<Array<TenantCollectionItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollectionItem_Order_By>>;
  where?: InputMaybe<TenantCollectionItem_Bool_Exp>;
};


export type Subscription_RootTenantCollectionItem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantCollectionItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollectionItem_Order_By>>;
  where?: InputMaybe<TenantCollectionItem_Bool_Exp>;
};


export type Subscription_RootTenantCollectionItem_By_PkArgs = {
  materialInternalId: Scalars['String']['input'];
  tenantCollectionId: Scalars['uuid']['input'];
};


export type Subscription_RootTenantCollectionItem_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantCollectionItem_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantCollectionItem_Bool_Exp>;
};


export type Subscription_RootTenantCollection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantCollection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollection_Order_By>>;
  where?: InputMaybe<TenantCollection_Bool_Exp>;
};


export type Subscription_RootTenantCollection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenantCollection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantCollection_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantCollection_Bool_Exp>;
};


export type Subscription_RootTenantInvoiceArgs = {
  distinct_on?: InputMaybe<Array<TenantInvoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantInvoice_Order_By>>;
  where?: InputMaybe<TenantInvoice_Bool_Exp>;
};


export type Subscription_RootTenantInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantInvoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantInvoice_Order_By>>;
  where?: InputMaybe<TenantInvoice_Bool_Exp>;
};


export type Subscription_RootTenantInvoice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenantInvoice_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantInvoice_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantInvoice_Bool_Exp>;
};


export type Subscription_RootTenantUserRequestAiUsageArgs = {
  distinct_on?: InputMaybe<Array<TenantUserRequestAiUsage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantUserRequestAiUsage_Order_By>>;
  where?: InputMaybe<TenantUserRequestAiUsage_Bool_Exp>;
};


export type Subscription_RootTenantUserRequestAiUsage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantUserRequestAiUsage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantUserRequestAiUsage_Order_By>>;
  where?: InputMaybe<TenantUserRequestAiUsage_Bool_Exp>;
};


export type Subscription_RootTenantUserRequestAiUsage_By_PkArgs = {
  requestId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootTenantUserRequestAiUsage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantUserRequestAiUsage_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantUserRequestAiUsage_Bool_Exp>;
};


export type Subscription_RootTranslationCategoryArgs = {
  distinct_on?: InputMaybe<Array<TranslationCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationCategory_Order_By>>;
  where?: InputMaybe<TranslationCategory_Bool_Exp>;
};


export type Subscription_RootTranslationCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TranslationCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationCategory_Order_By>>;
  where?: InputMaybe<TranslationCategory_Bool_Exp>;
};


export type Subscription_RootTranslationCategory_By_PkArgs = {
  id: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
};


export type Subscription_RootTranslationCategory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TranslationCategory_Stream_Cursor_Input>>;
  where?: InputMaybe<TranslationCategory_Bool_Exp>;
};


export type Subscription_RootTranslationSourceArgs = {
  distinct_on?: InputMaybe<Array<TranslationSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationSource_Order_By>>;
  where?: InputMaybe<TranslationSource_Bool_Exp>;
};


export type Subscription_RootTranslationSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TranslationSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TranslationSource_Order_By>>;
  where?: InputMaybe<TranslationSource_Bool_Exp>;
};


export type Subscription_RootTranslationSource_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTranslationSource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TranslationSource_Stream_Cursor_Input>>;
  where?: InputMaybe<TranslationSource_Bool_Exp>;
};


export type Subscription_RootTransportArgs = {
  distinct_on?: InputMaybe<Array<Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Order_By>>;
  where?: InputMaybe<Transport_Bool_Exp>;
};


export type Subscription_RootTransportEmissionFactorArgs = {
  distinct_on?: InputMaybe<Array<TransportEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportEmissionFactor_Order_By>>;
  where?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
};


export type Subscription_RootTransportEmissionFactor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransportEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportEmissionFactor_Order_By>>;
  where?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
};


export type Subscription_RootTransportEmissionFactor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTransportEmissionFactor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TransportEmissionFactor_Stream_Cursor_Input>>;
  where?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
};


export type Subscription_RootTransportSourceArgs = {
  distinct_on?: InputMaybe<Array<TransportSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSource_Order_By>>;
  where?: InputMaybe<TransportSource_Bool_Exp>;
};


export type Subscription_RootTransportSourceCalculationTypeArgs = {
  distinct_on?: InputMaybe<Array<TransportSourceCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSourceCalculationType_Order_By>>;
  where?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
};


export type Subscription_RootTransportSourceCalculationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransportSourceCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSourceCalculationType_Order_By>>;
  where?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
};


export type Subscription_RootTransportSourceCalculationType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTransportSourceCalculationType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TransportSourceCalculationType_Stream_Cursor_Input>>;
  where?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
};


export type Subscription_RootTransportSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransportSource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSource_Order_By>>;
  where?: InputMaybe<TransportSource_Bool_Exp>;
};


export type Subscription_RootTransportSource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTransportSource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TransportSource_Stream_Cursor_Input>>;
  where?: InputMaybe<TransportSource_Bool_Exp>;
};


export type Subscription_RootTransport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Order_By>>;
  where?: InputMaybe<Transport_Bool_Exp>;
};


export type Subscription_RootTransport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTransport_Standard_ValueArgs = {
  distinct_on?: InputMaybe<Array<Transport_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Standard_Value_Order_By>>;
  where?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
};


export type Subscription_RootTransport_Standard_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transport_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Standard_Value_Order_By>>;
  where?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
};


export type Subscription_RootTransport_Standard_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTransport_Standard_Value_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transport_Standard_Value_Stream_Cursor_Input>>;
  where?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
};


export type Subscription_RootTransport_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transport_Stream_Cursor_Input>>;
  where?: InputMaybe<Transport_Bool_Exp>;
};


export type Subscription_RootTransport_TypeArgs = {
  distinct_on?: InputMaybe<Array<Transport_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Type_Order_By>>;
  where?: InputMaybe<Transport_Type_Bool_Exp>;
};


export type Subscription_RootTransport_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transport_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Type_Order_By>>;
  where?: InputMaybe<Transport_Type_Bool_Exp>;
};


export type Subscription_RootTransport_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTransport_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transport_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Transport_Type_Bool_Exp>;
};


export type Subscription_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUnit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUserMaterialFavoriteArgs = {
  distinct_on?: InputMaybe<Array<UserMaterialFavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserMaterialFavorite_Order_By>>;
  where?: InputMaybe<UserMaterialFavorite_Bool_Exp>;
};


export type Subscription_RootUserMaterialFavorite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserMaterialFavorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserMaterialFavorite_Order_By>>;
  where?: InputMaybe<UserMaterialFavorite_Bool_Exp>;
};


export type Subscription_RootUserMaterialFavorite_By_PkArgs = {
  materialInternalId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootUserMaterialFavorite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserMaterialFavorite_Stream_Cursor_Input>>;
  where?: InputMaybe<UserMaterialFavorite_Bool_Exp>;
};


export type Subscription_RootUserPlatformReviewArgs = {
  distinct_on?: InputMaybe<Array<UserPlatformReview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPlatformReview_Order_By>>;
  where?: InputMaybe<UserPlatformReview_Bool_Exp>;
};


export type Subscription_RootUserPlatformReview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPlatformReview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPlatformReview_Order_By>>;
  where?: InputMaybe<UserPlatformReview_Bool_Exp>;
};


export type Subscription_RootUserPlatformReview_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUserPlatformReview_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserPlatformReview_Stream_Cursor_Input>>;
  where?: InputMaybe<UserPlatformReview_Bool_Exp>;
};


export type Subscription_RootUserProjectViewArgs = {
  distinct_on?: InputMaybe<Array<UserProjectView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserProjectView_Order_By>>;
  where?: InputMaybe<UserProjectView_Bool_Exp>;
};


export type Subscription_RootUserProjectView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserProjectView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserProjectView_Order_By>>;
  where?: InputMaybe<UserProjectView_Bool_Exp>;
};


export type Subscription_RootUserProjectView_By_PkArgs = {
  projectId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootUserProjectView_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserProjectView_Stream_Cursor_Input>>;
  where?: InputMaybe<UserProjectView_Bool_Exp>;
};


export type Subscription_RootUserTutorialViewArgs = {
  distinct_on?: InputMaybe<Array<UserTutorialView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserTutorialView_Order_By>>;
  where?: InputMaybe<UserTutorialView_Bool_Exp>;
};


export type Subscription_RootUserTutorialView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserTutorialView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserTutorialView_Order_By>>;
  where?: InputMaybe<UserTutorialView_Bool_Exp>;
};


export type Subscription_RootUserTutorialView_By_PkArgs = {
  externalId: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootUserTutorialView_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserTutorialView_Stream_Cursor_Input>>;
  where?: InputMaybe<UserTutorialView_Bool_Exp>;
};


export type Subscription_RootUserWelcomeFlowArgs = {
  distinct_on?: InputMaybe<Array<UserWelcomeFlow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserWelcomeFlow_Order_By>>;
  where?: InputMaybe<UserWelcomeFlow_Bool_Exp>;
};


export type Subscription_RootUserWelcomeFlowEventArgs = {
  distinct_on?: InputMaybe<Array<UserWelcomeFlowEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserWelcomeFlowEvent_Order_By>>;
  where?: InputMaybe<UserWelcomeFlowEvent_Bool_Exp>;
};


export type Subscription_RootUserWelcomeFlowEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserWelcomeFlowEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserWelcomeFlowEvent_Order_By>>;
  where?: InputMaybe<UserWelcomeFlowEvent_Bool_Exp>;
};


export type Subscription_RootUserWelcomeFlowEvent_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUserWelcomeFlowEvent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserWelcomeFlowEvent_Stream_Cursor_Input>>;
  where?: InputMaybe<UserWelcomeFlowEvent_Bool_Exp>;
};


export type Subscription_RootUserWelcomeFlow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserWelcomeFlow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserWelcomeFlow_Order_By>>;
  where?: InputMaybe<UserWelcomeFlow_Bool_Exp>;
};


export type Subscription_RootUserWelcomeFlow_By_PkArgs = {
  flowKey: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootUserWelcomeFlow_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserWelcomeFlow_Stream_Cursor_Input>>;
  where?: InputMaybe<UserWelcomeFlow_Bool_Exp>;
};


export type Subscription_RootVLatestSnapshotArgs = {
  distinct_on?: InputMaybe<Array<VLatestSnapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VLatestSnapshot_Order_By>>;
  where?: InputMaybe<VLatestSnapshot_Bool_Exp>;
};


export type Subscription_RootVLatestSnapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VLatestSnapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VLatestSnapshot_Order_By>>;
  where?: InputMaybe<VLatestSnapshot_Bool_Exp>;
};


export type Subscription_RootVLatestSnapshot_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VLatestSnapshot_Stream_Cursor_Input>>;
  where?: InputMaybe<VLatestSnapshot_Bool_Exp>;
};


export type Subscription_RootVMaterialCurrentArgs = {
  distinct_on?: InputMaybe<Array<VMaterialCurrent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialCurrent_Order_By>>;
  where?: InputMaybe<VMaterialCurrent_Bool_Exp>;
};


export type Subscription_RootVMaterialCurrent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VMaterialCurrent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialCurrent_Order_By>>;
  where?: InputMaybe<VMaterialCurrent_Bool_Exp>;
};


export type Subscription_RootVMaterialCurrent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VMaterialCurrent_Stream_Cursor_Input>>;
  where?: InputMaybe<VMaterialCurrent_Bool_Exp>;
};


export type Subscription_RootVMaterialGwpArgs = {
  distinct_on?: InputMaybe<Array<VMaterialGwp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialGwp_Order_By>>;
  where?: InputMaybe<VMaterialGwp_Bool_Exp>;
};


export type Subscription_RootVMaterialGwp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VMaterialGwp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialGwp_Order_By>>;
  where?: InputMaybe<VMaterialGwp_Bool_Exp>;
};


export type Subscription_RootVMaterialGwp_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VMaterialGwp_Stream_Cursor_Input>>;
  where?: InputMaybe<VMaterialGwp_Bool_Exp>;
};


export type Subscription_RootVMaterialStatusArgs = {
  distinct_on?: InputMaybe<Array<VMaterialStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialStatus_Order_By>>;
  where?: InputMaybe<VMaterialStatus_Bool_Exp>;
};


export type Subscription_RootVMaterialStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VMaterialStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VMaterialStatus_Order_By>>;
  where?: InputMaybe<VMaterialStatus_Bool_Exp>;
};


export type Subscription_RootVMaterialStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VMaterialStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<VMaterialStatus_Bool_Exp>;
};


export type Subscription_RootVProjectIntensityArgs = {
  distinct_on?: InputMaybe<Array<VProjectIntensity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VProjectIntensity_Order_By>>;
  where?: InputMaybe<VProjectIntensity_Bool_Exp>;
};


export type Subscription_RootVProjectIntensity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VProjectIntensity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VProjectIntensity_Order_By>>;
  where?: InputMaybe<VProjectIntensity_Bool_Exp>;
};


export type Subscription_RootVProjectIntensity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VProjectIntensity_Stream_Cursor_Input>>;
  where?: InputMaybe<VProjectIntensity_Bool_Exp>;
};


export type Subscription_RootWeightPerDeclaredUnitArgs = {
  distinct_on?: InputMaybe<Array<WeightPerDeclaredUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<WeightPerDeclaredUnit_Order_By>>;
  where?: InputMaybe<WeightPerDeclaredUnit_Bool_Exp>;
};


export type Subscription_RootWeightPerDeclaredUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WeightPerDeclaredUnit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<WeightPerDeclaredUnit_Order_By>>;
  where?: InputMaybe<WeightPerDeclaredUnit_Bool_Exp>;
};


export type Subscription_RootWeightPerDeclaredUnit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWeightPerDeclaredUnit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<WeightPerDeclaredUnit_Stream_Cursor_Input>>;
  where?: InputMaybe<WeightPerDeclaredUnit_Bool_Exp>;
};

/** columns and relationships of "tenant_ai_budget" */
export type TenantAiBudget = {
  __typename?: 'tenantAiBudget';
  capAmount: Scalars['numeric']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy?: Maybe<Scalars['uuid']['output']>;
  currency: Scalars['String']['output'];
  effectiveFrom: Scalars['date']['output'];
  effectiveTo?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  period: Scalars['String']['output'];
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "tenant_ai_budget" */
export type TenantAiBudget_Aggregate = {
  __typename?: 'tenantAiBudget_aggregate';
  aggregate?: Maybe<TenantAiBudget_Aggregate_Fields>;
  nodes: Array<TenantAiBudget>;
};

/** aggregate fields of "tenant_ai_budget" */
export type TenantAiBudget_Aggregate_Fields = {
  __typename?: 'tenantAiBudget_aggregate_fields';
  avg?: Maybe<TenantAiBudget_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TenantAiBudget_Max_Fields>;
  min?: Maybe<TenantAiBudget_Min_Fields>;
  stddev?: Maybe<TenantAiBudget_Stddev_Fields>;
  stddev_pop?: Maybe<TenantAiBudget_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TenantAiBudget_Stddev_Samp_Fields>;
  sum?: Maybe<TenantAiBudget_Sum_Fields>;
  var_pop?: Maybe<TenantAiBudget_Var_Pop_Fields>;
  var_samp?: Maybe<TenantAiBudget_Var_Samp_Fields>;
  variance?: Maybe<TenantAiBudget_Variance_Fields>;
};


/** aggregate fields of "tenant_ai_budget" */
export type TenantAiBudget_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantAiBudget_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TenantAiBudget_Avg_Fields = {
  __typename?: 'tenantAiBudget_avg_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tenant_ai_budget". All fields are combined with a logical 'AND'. */
export type TenantAiBudget_Bool_Exp = {
  _and?: InputMaybe<Array<TenantAiBudget_Bool_Exp>>;
  _not?: InputMaybe<TenantAiBudget_Bool_Exp>;
  _or?: InputMaybe<Array<TenantAiBudget_Bool_Exp>>;
  capAmount?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  effectiveFrom?: InputMaybe<Date_Comparison_Exp>;
  effectiveTo?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  period?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_ai_budget" */
export enum TenantAiBudget_Constraint {
  /** unique or primary key constraint on columns "id" */
  tenant_ai_budget_pkey = 'tenant_ai_budget_pkey',
  /** unique or primary key constraint on columns "effective_from", "tenant_id" */
  tenant_ai_budget_tenant_effective_from_key = 'tenant_ai_budget_tenant_effective_from_key'
}

/** input type for incrementing numeric columns in table "tenant_ai_budget" */
export type TenantAiBudget_Inc_Input = {
  capAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "tenant_ai_budget" */
export type TenantAiBudget_Insert_Input = {
  capAmount?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['date']['input']>;
  effectiveTo?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type TenantAiBudget_Max_Fields = {
  __typename?: 'tenantAiBudget_max_fields';
  capAmount?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['date']['output']>;
  effectiveTo?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type TenantAiBudget_Min_Fields = {
  __typename?: 'tenantAiBudget_min_fields';
  capAmount?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['date']['output']>;
  effectiveTo?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "tenant_ai_budget" */
export type TenantAiBudget_Mutation_Response = {
  __typename?: 'tenantAiBudget_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantAiBudget>;
};

/** on_conflict condition type for table "tenant_ai_budget" */
export type TenantAiBudget_On_Conflict = {
  constraint: TenantAiBudget_Constraint;
  update_columns?: Array<TenantAiBudget_Update_Column>;
  where?: InputMaybe<TenantAiBudget_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_ai_budget". */
export type TenantAiBudget_Order_By = {
  capAmount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  effectiveFrom?: InputMaybe<Order_By>;
  effectiveTo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  period?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant_ai_budget */
export type TenantAiBudget_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tenant_ai_budget" */
export enum TenantAiBudget_Select_Column {
  /** column name */
  capAmount = 'capAmount',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  currency = 'currency',
  /** column name */
  effectiveFrom = 'effectiveFrom',
  /** column name */
  effectiveTo = 'effectiveTo',
  /** column name */
  id = 'id',
  /** column name */
  period = 'period',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "tenant_ai_budget" */
export type TenantAiBudget_Set_Input = {
  capAmount?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['date']['input']>;
  effectiveTo?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type TenantAiBudget_Stddev_Fields = {
  __typename?: 'tenantAiBudget_stddev_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TenantAiBudget_Stddev_Pop_Fields = {
  __typename?: 'tenantAiBudget_stddev_pop_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TenantAiBudget_Stddev_Samp_Fields = {
  __typename?: 'tenantAiBudget_stddev_samp_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tenantAiBudget" */
export type TenantAiBudget_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantAiBudget_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantAiBudget_Stream_Cursor_Value_Input = {
  capAmount?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['date']['input']>;
  effectiveTo?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type TenantAiBudget_Sum_Fields = {
  __typename?: 'tenantAiBudget_sum_fields';
  capAmount?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "tenant_ai_budget" */
export enum TenantAiBudget_Update_Column {
  /** column name */
  capAmount = 'capAmount',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  currency = 'currency',
  /** column name */
  effectiveFrom = 'effectiveFrom',
  /** column name */
  effectiveTo = 'effectiveTo',
  /** column name */
  id = 'id',
  /** column name */
  period = 'period',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  updatedAt = 'updatedAt'
}

export type TenantAiBudget_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TenantAiBudget_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantAiBudget_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantAiBudget_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TenantAiBudget_Var_Pop_Fields = {
  __typename?: 'tenantAiBudget_var_pop_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TenantAiBudget_Var_Samp_Fields = {
  __typename?: 'tenantAiBudget_var_samp_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TenantAiBudget_Variance_Fields = {
  __typename?: 'tenantAiBudget_variance_fields';
  capAmount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tenant_ai_credit_purchase" */
export type TenantAiCreditPurchase = {
  __typename?: 'tenantAiCreditPurchase';
  createdAt: Scalars['timestamptz']['output'];
  grantedBy?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  note?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  tenantId: Scalars['uuid']['output'];
  tokens: Scalars['Int']['output'];
};

/** aggregated selection of "tenant_ai_credit_purchase" */
export type TenantAiCreditPurchase_Aggregate = {
  __typename?: 'tenantAiCreditPurchase_aggregate';
  aggregate?: Maybe<TenantAiCreditPurchase_Aggregate_Fields>;
  nodes: Array<TenantAiCreditPurchase>;
};

/** aggregate fields of "tenant_ai_credit_purchase" */
export type TenantAiCreditPurchase_Aggregate_Fields = {
  __typename?: 'tenantAiCreditPurchase_aggregate_fields';
  avg?: Maybe<TenantAiCreditPurchase_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TenantAiCreditPurchase_Max_Fields>;
  min?: Maybe<TenantAiCreditPurchase_Min_Fields>;
  stddev?: Maybe<TenantAiCreditPurchase_Stddev_Fields>;
  stddev_pop?: Maybe<TenantAiCreditPurchase_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TenantAiCreditPurchase_Stddev_Samp_Fields>;
  sum?: Maybe<TenantAiCreditPurchase_Sum_Fields>;
  var_pop?: Maybe<TenantAiCreditPurchase_Var_Pop_Fields>;
  var_samp?: Maybe<TenantAiCreditPurchase_Var_Samp_Fields>;
  variance?: Maybe<TenantAiCreditPurchase_Variance_Fields>;
};


/** aggregate fields of "tenant_ai_credit_purchase" */
export type TenantAiCreditPurchase_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantAiCreditPurchase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TenantAiCreditPurchase_Avg_Fields = {
  __typename?: 'tenantAiCreditPurchase_avg_fields';
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tenant_ai_credit_purchase". All fields are combined with a logical 'AND'. */
export type TenantAiCreditPurchase_Bool_Exp = {
  _and?: InputMaybe<Array<TenantAiCreditPurchase_Bool_Exp>>;
  _not?: InputMaybe<TenantAiCreditPurchase_Bool_Exp>;
  _or?: InputMaybe<Array<TenantAiCreditPurchase_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  grantedBy?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  tokens?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_ai_credit_purchase" */
export enum TenantAiCreditPurchase_Constraint {
  /** unique or primary key constraint on columns "id" */
  tenant_ai_credit_purchase_pkey = 'tenant_ai_credit_purchase_pkey'
}

/** input type for incrementing numeric columns in table "tenant_ai_credit_purchase" */
export type TenantAiCreditPurchase_Inc_Input = {
  tokens?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenant_ai_credit_purchase" */
export type TenantAiCreditPurchase_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  grantedBy?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type TenantAiCreditPurchase_Max_Fields = {
  __typename?: 'tenantAiCreditPurchase_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  grantedBy?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type TenantAiCreditPurchase_Min_Fields = {
  __typename?: 'tenantAiCreditPurchase_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  grantedBy?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "tenant_ai_credit_purchase" */
export type TenantAiCreditPurchase_Mutation_Response = {
  __typename?: 'tenantAiCreditPurchase_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantAiCreditPurchase>;
};

/** on_conflict condition type for table "tenant_ai_credit_purchase" */
export type TenantAiCreditPurchase_On_Conflict = {
  constraint: TenantAiCreditPurchase_Constraint;
  update_columns?: Array<TenantAiCreditPurchase_Update_Column>;
  where?: InputMaybe<TenantAiCreditPurchase_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_ai_credit_purchase". */
export type TenantAiCreditPurchase_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  grantedBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tokens?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant_ai_credit_purchase */
export type TenantAiCreditPurchase_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tenant_ai_credit_purchase" */
export enum TenantAiCreditPurchase_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  grantedBy = 'grantedBy',
  /** column name */
  id = 'id',
  /** column name */
  note = 'note',
  /** column name */
  source = 'source',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  tokens = 'tokens'
}

/** input type for updating data in table "tenant_ai_credit_purchase" */
export type TenantAiCreditPurchase_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  grantedBy?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type TenantAiCreditPurchase_Stddev_Fields = {
  __typename?: 'tenantAiCreditPurchase_stddev_fields';
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TenantAiCreditPurchase_Stddev_Pop_Fields = {
  __typename?: 'tenantAiCreditPurchase_stddev_pop_fields';
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TenantAiCreditPurchase_Stddev_Samp_Fields = {
  __typename?: 'tenantAiCreditPurchase_stddev_samp_fields';
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tenantAiCreditPurchase" */
export type TenantAiCreditPurchase_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantAiCreditPurchase_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantAiCreditPurchase_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  grantedBy?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type TenantAiCreditPurchase_Sum_Fields = {
  __typename?: 'tenantAiCreditPurchase_sum_fields';
  tokens?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "tenant_ai_credit_purchase" */
export enum TenantAiCreditPurchase_Update_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  grantedBy = 'grantedBy',
  /** column name */
  id = 'id',
  /** column name */
  note = 'note',
  /** column name */
  source = 'source',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  tokens = 'tokens'
}

export type TenantAiCreditPurchase_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TenantAiCreditPurchase_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantAiCreditPurchase_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantAiCreditPurchase_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TenantAiCreditPurchase_Var_Pop_Fields = {
  __typename?: 'tenantAiCreditPurchase_var_pop_fields';
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TenantAiCreditPurchase_Var_Samp_Fields = {
  __typename?: 'tenantAiCreditPurchase_var_samp_fields';
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TenantAiCreditPurchase_Variance_Fields = {
  __typename?: 'tenantAiCreditPurchase_variance_fields';
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tenant_ai_payment" */
export type TenantAiPayment = {
  __typename?: 'tenantAiPayment';
  amountEur: Scalars['numeric']['output'];
  billingDetails?: Maybe<Scalars['jsonb']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  fulfilledAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  molliePaymentId: Scalars['String']['output'];
  planDurationDays?: Maybe<Scalars['Int']['output']>;
  planExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['uuid']['output'];
  tokens?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "tenant_ai_payment" */
export type TenantAiPaymentBillingDetailsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "tenant_ai_payment" */
export type TenantAiPayment_Aggregate = {
  __typename?: 'tenantAiPayment_aggregate';
  aggregate?: Maybe<TenantAiPayment_Aggregate_Fields>;
  nodes: Array<TenantAiPayment>;
};

/** aggregate fields of "tenant_ai_payment" */
export type TenantAiPayment_Aggregate_Fields = {
  __typename?: 'tenantAiPayment_aggregate_fields';
  avg?: Maybe<TenantAiPayment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TenantAiPayment_Max_Fields>;
  min?: Maybe<TenantAiPayment_Min_Fields>;
  stddev?: Maybe<TenantAiPayment_Stddev_Fields>;
  stddev_pop?: Maybe<TenantAiPayment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TenantAiPayment_Stddev_Samp_Fields>;
  sum?: Maybe<TenantAiPayment_Sum_Fields>;
  var_pop?: Maybe<TenantAiPayment_Var_Pop_Fields>;
  var_samp?: Maybe<TenantAiPayment_Var_Samp_Fields>;
  variance?: Maybe<TenantAiPayment_Variance_Fields>;
};


/** aggregate fields of "tenant_ai_payment" */
export type TenantAiPayment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantAiPayment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TenantAiPayment_Append_Input = {
  billingDetails?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type TenantAiPayment_Avg_Fields = {
  __typename?: 'tenantAiPayment_avg_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  planDurationDays?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tenant_ai_payment". All fields are combined with a logical 'AND'. */
export type TenantAiPayment_Bool_Exp = {
  _and?: InputMaybe<Array<TenantAiPayment_Bool_Exp>>;
  _not?: InputMaybe<TenantAiPayment_Bool_Exp>;
  _or?: InputMaybe<Array<TenantAiPayment_Bool_Exp>>;
  amountEur?: InputMaybe<Numeric_Comparison_Exp>;
  billingDetails?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fulfilledAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  molliePaymentId?: InputMaybe<String_Comparison_Exp>;
  planDurationDays?: InputMaybe<Int_Comparison_Exp>;
  planExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  planName?: InputMaybe<String_Comparison_Exp>;
  productId?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  tokens?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_ai_payment" */
export enum TenantAiPayment_Constraint {
  /** unique or primary key constraint on columns "mollie_payment_id" */
  tenant_ai_payment_mollie_payment_id_key = 'tenant_ai_payment_mollie_payment_id_key',
  /** unique or primary key constraint on columns "id" */
  tenant_ai_payment_pkey = 'tenant_ai_payment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TenantAiPayment_Delete_At_Path_Input = {
  billingDetails?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TenantAiPayment_Delete_Elem_Input = {
  billingDetails?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TenantAiPayment_Delete_Key_Input = {
  billingDetails?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "tenant_ai_payment" */
export type TenantAiPayment_Inc_Input = {
  amountEur?: InputMaybe<Scalars['numeric']['input']>;
  planDurationDays?: InputMaybe<Scalars['Int']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenant_ai_payment" */
export type TenantAiPayment_Insert_Input = {
  amountEur?: InputMaybe<Scalars['numeric']['input']>;
  billingDetails?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fulfilledAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  molliePaymentId?: InputMaybe<Scalars['String']['input']>;
  planDurationDays?: InputMaybe<Scalars['Int']['input']>;
  planExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type TenantAiPayment_Max_Fields = {
  __typename?: 'tenantAiPayment_max_fields';
  amountEur?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fulfilledAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  molliePaymentId?: Maybe<Scalars['String']['output']>;
  planDurationDays?: Maybe<Scalars['Int']['output']>;
  planExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type TenantAiPayment_Min_Fields = {
  __typename?: 'tenantAiPayment_min_fields';
  amountEur?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fulfilledAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  molliePaymentId?: Maybe<Scalars['String']['output']>;
  planDurationDays?: Maybe<Scalars['Int']['output']>;
  planExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "tenant_ai_payment" */
export type TenantAiPayment_Mutation_Response = {
  __typename?: 'tenantAiPayment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantAiPayment>;
};

/** on_conflict condition type for table "tenant_ai_payment" */
export type TenantAiPayment_On_Conflict = {
  constraint: TenantAiPayment_Constraint;
  update_columns?: Array<TenantAiPayment_Update_Column>;
  where?: InputMaybe<TenantAiPayment_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_ai_payment". */
export type TenantAiPayment_Order_By = {
  amountEur?: InputMaybe<Order_By>;
  billingDetails?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fulfilledAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  molliePaymentId?: InputMaybe<Order_By>;
  planDurationDays?: InputMaybe<Order_By>;
  planExpiresAt?: InputMaybe<Order_By>;
  planName?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tokens?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant_ai_payment */
export type TenantAiPayment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TenantAiPayment_Prepend_Input = {
  billingDetails?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tenant_ai_payment" */
export enum TenantAiPayment_Select_Column {
  /** column name */
  amountEur = 'amountEur',
  /** column name */
  billingDetails = 'billingDetails',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  fulfilledAt = 'fulfilledAt',
  /** column name */
  id = 'id',
  /** column name */
  molliePaymentId = 'molliePaymentId',
  /** column name */
  planDurationDays = 'planDurationDays',
  /** column name */
  planExpiresAt = 'planExpiresAt',
  /** column name */
  planName = 'planName',
  /** column name */
  productId = 'productId',
  /** column name */
  status = 'status',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  tokens = 'tokens',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "tenant_ai_payment" */
export type TenantAiPayment_Set_Input = {
  amountEur?: InputMaybe<Scalars['numeric']['input']>;
  billingDetails?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fulfilledAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  molliePaymentId?: InputMaybe<Scalars['String']['input']>;
  planDurationDays?: InputMaybe<Scalars['Int']['input']>;
  planExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type TenantAiPayment_Stddev_Fields = {
  __typename?: 'tenantAiPayment_stddev_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  planDurationDays?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TenantAiPayment_Stddev_Pop_Fields = {
  __typename?: 'tenantAiPayment_stddev_pop_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  planDurationDays?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TenantAiPayment_Stddev_Samp_Fields = {
  __typename?: 'tenantAiPayment_stddev_samp_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  planDurationDays?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tenantAiPayment" */
export type TenantAiPayment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantAiPayment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantAiPayment_Stream_Cursor_Value_Input = {
  amountEur?: InputMaybe<Scalars['numeric']['input']>;
  billingDetails?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fulfilledAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  molliePaymentId?: InputMaybe<Scalars['String']['input']>;
  planDurationDays?: InputMaybe<Scalars['Int']['input']>;
  planExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type TenantAiPayment_Sum_Fields = {
  __typename?: 'tenantAiPayment_sum_fields';
  amountEur?: Maybe<Scalars['numeric']['output']>;
  planDurationDays?: Maybe<Scalars['Int']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "tenant_ai_payment" */
export enum TenantAiPayment_Update_Column {
  /** column name */
  amountEur = 'amountEur',
  /** column name */
  billingDetails = 'billingDetails',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  fulfilledAt = 'fulfilledAt',
  /** column name */
  id = 'id',
  /** column name */
  molliePaymentId = 'molliePaymentId',
  /** column name */
  planDurationDays = 'planDurationDays',
  /** column name */
  planExpiresAt = 'planExpiresAt',
  /** column name */
  planName = 'planName',
  /** column name */
  productId = 'productId',
  /** column name */
  status = 'status',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  tokens = 'tokens',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

export type TenantAiPayment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TenantAiPayment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TenantAiPayment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<TenantAiPayment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TenantAiPayment_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TenantAiPayment_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TenantAiPayment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantAiPayment_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantAiPayment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TenantAiPayment_Var_Pop_Fields = {
  __typename?: 'tenantAiPayment_var_pop_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  planDurationDays?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TenantAiPayment_Var_Samp_Fields = {
  __typename?: 'tenantAiPayment_var_samp_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  planDurationDays?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TenantAiPayment_Variance_Fields = {
  __typename?: 'tenantAiPayment_variance_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  planDurationDays?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tenant_collection" */
export type TenantCollection = {
  __typename?: 'tenantCollection';
  collectionType: Scalars['String']['output'];
  /** An object relationship */
  collectionTypeRef: EnumCollectionType;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  tenantCollectionItems: Array<TenantCollectionItem>;
  /** An aggregate relationship */
  tenantCollectionItems_aggregate: TenantCollectionItem_Aggregate;
  tenantId: Scalars['uuid']['output'];
};


/** columns and relationships of "tenant_collection" */
export type TenantCollectionTenantCollectionItemsArgs = {
  distinct_on?: InputMaybe<Array<TenantCollectionItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollectionItem_Order_By>>;
  where?: InputMaybe<TenantCollectionItem_Bool_Exp>;
};


/** columns and relationships of "tenant_collection" */
export type TenantCollectionTenantCollectionItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantCollectionItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TenantCollectionItem_Order_By>>;
  where?: InputMaybe<TenantCollectionItem_Bool_Exp>;
};

/** columns and relationships of "tenant_collection_item" */
export type TenantCollectionItem = {
  __typename?: 'tenantCollectionItem';
  materialInternalId: Scalars['String']['output'];
  /** An object relationship */
  tenantCollection: TenantCollection;
  tenantCollectionId: Scalars['uuid']['output'];
};

/** aggregated selection of "tenant_collection_item" */
export type TenantCollectionItem_Aggregate = {
  __typename?: 'tenantCollectionItem_aggregate';
  aggregate?: Maybe<TenantCollectionItem_Aggregate_Fields>;
  nodes: Array<TenantCollectionItem>;
};

export type TenantCollectionItem_Aggregate_Bool_Exp = {
  count?: InputMaybe<TenantCollectionItem_Aggregate_Bool_Exp_Count>;
};

export type TenantCollectionItem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<TenantCollectionItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TenantCollectionItem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenant_collection_item" */
export type TenantCollectionItem_Aggregate_Fields = {
  __typename?: 'tenantCollectionItem_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TenantCollectionItem_Max_Fields>;
  min?: Maybe<TenantCollectionItem_Min_Fields>;
};


/** aggregate fields of "tenant_collection_item" */
export type TenantCollectionItem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantCollectionItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenant_collection_item" */
export type TenantCollectionItem_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TenantCollectionItem_Max_Order_By>;
  min?: InputMaybe<TenantCollectionItem_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tenant_collection_item" */
export type TenantCollectionItem_Arr_Rel_Insert_Input = {
  data: Array<TenantCollectionItem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TenantCollectionItem_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tenant_collection_item". All fields are combined with a logical 'AND'. */
export type TenantCollectionItem_Bool_Exp = {
  _and?: InputMaybe<Array<TenantCollectionItem_Bool_Exp>>;
  _not?: InputMaybe<TenantCollectionItem_Bool_Exp>;
  _or?: InputMaybe<Array<TenantCollectionItem_Bool_Exp>>;
  materialInternalId?: InputMaybe<String_Comparison_Exp>;
  tenantCollection?: InputMaybe<TenantCollection_Bool_Exp>;
  tenantCollectionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_collection_item" */
export enum TenantCollectionItem_Constraint {
  /** unique or primary key constraint on columns "tenant_collection_id", "material_internal_id" */
  tenant_collection_item_pkey = 'tenant_collection_item_pkey'
}

/** input type for inserting data into table "tenant_collection_item" */
export type TenantCollectionItem_Insert_Input = {
  materialInternalId?: InputMaybe<Scalars['String']['input']>;
  tenantCollection?: InputMaybe<TenantCollection_Obj_Rel_Insert_Input>;
  tenantCollectionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type TenantCollectionItem_Max_Fields = {
  __typename?: 'tenantCollectionItem_max_fields';
  materialInternalId?: Maybe<Scalars['String']['output']>;
  tenantCollectionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "tenant_collection_item" */
export type TenantCollectionItem_Max_Order_By = {
  materialInternalId?: InputMaybe<Order_By>;
  tenantCollectionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TenantCollectionItem_Min_Fields = {
  __typename?: 'tenantCollectionItem_min_fields';
  materialInternalId?: Maybe<Scalars['String']['output']>;
  tenantCollectionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "tenant_collection_item" */
export type TenantCollectionItem_Min_Order_By = {
  materialInternalId?: InputMaybe<Order_By>;
  tenantCollectionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenant_collection_item" */
export type TenantCollectionItem_Mutation_Response = {
  __typename?: 'tenantCollectionItem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantCollectionItem>;
};

/** on_conflict condition type for table "tenant_collection_item" */
export type TenantCollectionItem_On_Conflict = {
  constraint: TenantCollectionItem_Constraint;
  update_columns?: Array<TenantCollectionItem_Update_Column>;
  where?: InputMaybe<TenantCollectionItem_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_collection_item". */
export type TenantCollectionItem_Order_By = {
  materialInternalId?: InputMaybe<Order_By>;
  tenantCollection?: InputMaybe<TenantCollection_Order_By>;
  tenantCollectionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant_collection_item */
export type TenantCollectionItem_Pk_Columns_Input = {
  materialInternalId: Scalars['String']['input'];
  tenantCollectionId: Scalars['uuid']['input'];
};

/** select columns of table "tenant_collection_item" */
export enum TenantCollectionItem_Select_Column {
  /** column name */
  materialInternalId = 'materialInternalId',
  /** column name */
  tenantCollectionId = 'tenantCollectionId'
}

/** input type for updating data in table "tenant_collection_item" */
export type TenantCollectionItem_Set_Input = {
  materialInternalId?: InputMaybe<Scalars['String']['input']>;
  tenantCollectionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "tenantCollectionItem" */
export type TenantCollectionItem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantCollectionItem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantCollectionItem_Stream_Cursor_Value_Input = {
  materialInternalId?: InputMaybe<Scalars['String']['input']>;
  tenantCollectionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "tenant_collection_item" */
export enum TenantCollectionItem_Update_Column {
  /** column name */
  materialInternalId = 'materialInternalId',
  /** column name */
  tenantCollectionId = 'tenantCollectionId'
}

export type TenantCollectionItem_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantCollectionItem_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantCollectionItem_Bool_Exp;
};

/** aggregated selection of "tenant_collection" */
export type TenantCollection_Aggregate = {
  __typename?: 'tenantCollection_aggregate';
  aggregate?: Maybe<TenantCollection_Aggregate_Fields>;
  nodes: Array<TenantCollection>;
};

/** aggregate fields of "tenant_collection" */
export type TenantCollection_Aggregate_Fields = {
  __typename?: 'tenantCollection_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TenantCollection_Max_Fields>;
  min?: Maybe<TenantCollection_Min_Fields>;
};


/** aggregate fields of "tenant_collection" */
export type TenantCollection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantCollection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tenant_collection". All fields are combined with a logical 'AND'. */
export type TenantCollection_Bool_Exp = {
  _and?: InputMaybe<Array<TenantCollection_Bool_Exp>>;
  _not?: InputMaybe<TenantCollection_Bool_Exp>;
  _or?: InputMaybe<Array<TenantCollection_Bool_Exp>>;
  collectionType?: InputMaybe<String_Comparison_Exp>;
  collectionTypeRef?: InputMaybe<EnumCollectionType_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tenantCollectionItems?: InputMaybe<TenantCollectionItem_Bool_Exp>;
  tenantCollectionItems_aggregate?: InputMaybe<TenantCollectionItem_Aggregate_Bool_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_collection" */
export enum TenantCollection_Constraint {
  /** unique or primary key constraint on columns "name", "tenant_id" */
  tenant_collection_name_tenant_id_key = 'tenant_collection_name_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  tenant_collection_pkey = 'tenant_collection_pkey'
}

/** input type for inserting data into table "tenant_collection" */
export type TenantCollection_Insert_Input = {
  collectionType?: InputMaybe<Scalars['String']['input']>;
  collectionTypeRef?: InputMaybe<EnumCollectionType_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantCollectionItems?: InputMaybe<TenantCollectionItem_Arr_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type TenantCollection_Max_Fields = {
  __typename?: 'tenantCollection_max_fields';
  collectionType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type TenantCollection_Min_Fields = {
  __typename?: 'tenantCollection_min_fields';
  collectionType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "tenant_collection" */
export type TenantCollection_Mutation_Response = {
  __typename?: 'tenantCollection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantCollection>;
};

/** input type for inserting object relation for remote table "tenant_collection" */
export type TenantCollection_Obj_Rel_Insert_Input = {
  data: TenantCollection_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<TenantCollection_On_Conflict>;
};

/** on_conflict condition type for table "tenant_collection" */
export type TenantCollection_On_Conflict = {
  constraint: TenantCollection_Constraint;
  update_columns?: Array<TenantCollection_Update_Column>;
  where?: InputMaybe<TenantCollection_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_collection". */
export type TenantCollection_Order_By = {
  collectionType?: InputMaybe<Order_By>;
  collectionTypeRef?: InputMaybe<EnumCollectionType_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenantCollectionItems_aggregate?: InputMaybe<TenantCollectionItem_Aggregate_Order_By>;
  tenantId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant_collection */
export type TenantCollection_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tenant_collection" */
export enum TenantCollection_Select_Column {
  /** column name */
  collectionType = 'collectionType',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  tenantId = 'tenantId'
}

/** input type for updating data in table "tenant_collection" */
export type TenantCollection_Set_Input = {
  collectionType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "tenantCollection" */
export type TenantCollection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantCollection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantCollection_Stream_Cursor_Value_Input = {
  collectionType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "tenant_collection" */
export enum TenantCollection_Update_Column {
  /** column name */
  collectionType = 'collectionType',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  tenantId = 'tenantId'
}

export type TenantCollection_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantCollection_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantCollection_Bool_Exp;
};

/** columns and relationships of "tenant_invoice" */
export type TenantInvoice = {
  __typename?: 'tenantInvoice';
  amountEur: Scalars['numeric']['output'];
  blobPath?: Maybe<Scalars['String']['output']>;
  buyerAccountName: Scalars['String']['output'];
  buyerCountry?: Maybe<Scalars['String']['output']>;
  buyerEmail?: Maybe<Scalars['String']['output']>;
  buyerPostcodeAndCity?: Maybe<Scalars['String']['output']>;
  buyerStreetAndNumber?: Maybe<Scalars['String']['output']>;
  buyerUserName?: Maybe<Scalars['String']['output']>;
  buyerVatId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  invoiceNo: Scalars['bigint']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  issuedAt: Scalars['timestamptz']['output'];
  paymentId: Scalars['uuid']['output'];
  productId: Scalars['String']['output'];
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "tenant_invoice" */
export type TenantInvoice_Aggregate = {
  __typename?: 'tenantInvoice_aggregate';
  aggregate?: Maybe<TenantInvoice_Aggregate_Fields>;
  nodes: Array<TenantInvoice>;
};

/** aggregate fields of "tenant_invoice" */
export type TenantInvoice_Aggregate_Fields = {
  __typename?: 'tenantInvoice_aggregate_fields';
  avg?: Maybe<TenantInvoice_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TenantInvoice_Max_Fields>;
  min?: Maybe<TenantInvoice_Min_Fields>;
  stddev?: Maybe<TenantInvoice_Stddev_Fields>;
  stddev_pop?: Maybe<TenantInvoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TenantInvoice_Stddev_Samp_Fields>;
  sum?: Maybe<TenantInvoice_Sum_Fields>;
  var_pop?: Maybe<TenantInvoice_Var_Pop_Fields>;
  var_samp?: Maybe<TenantInvoice_Var_Samp_Fields>;
  variance?: Maybe<TenantInvoice_Variance_Fields>;
};


/** aggregate fields of "tenant_invoice" */
export type TenantInvoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantInvoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TenantInvoice_Avg_Fields = {
  __typename?: 'tenantInvoice_avg_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  invoiceNo?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tenant_invoice". All fields are combined with a logical 'AND'. */
export type TenantInvoice_Bool_Exp = {
  _and?: InputMaybe<Array<TenantInvoice_Bool_Exp>>;
  _not?: InputMaybe<TenantInvoice_Bool_Exp>;
  _or?: InputMaybe<Array<TenantInvoice_Bool_Exp>>;
  amountEur?: InputMaybe<Numeric_Comparison_Exp>;
  blobPath?: InputMaybe<String_Comparison_Exp>;
  buyerAccountName?: InputMaybe<String_Comparison_Exp>;
  buyerCountry?: InputMaybe<String_Comparison_Exp>;
  buyerEmail?: InputMaybe<String_Comparison_Exp>;
  buyerPostcodeAndCity?: InputMaybe<String_Comparison_Exp>;
  buyerStreetAndNumber?: InputMaybe<String_Comparison_Exp>;
  buyerUserName?: InputMaybe<String_Comparison_Exp>;
  buyerVatId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiceNo?: InputMaybe<Bigint_Comparison_Exp>;
  invoiceNumber?: InputMaybe<String_Comparison_Exp>;
  issuedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  paymentId?: InputMaybe<Uuid_Comparison_Exp>;
  productId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_invoice" */
export enum TenantInvoice_Constraint {
  /** unique or primary key constraint on columns "invoice_no" */
  tenant_invoice_invoice_no_key = 'tenant_invoice_invoice_no_key',
  /** unique or primary key constraint on columns "invoice_number" */
  tenant_invoice_invoice_number_key = 'tenant_invoice_invoice_number_key',
  /** unique or primary key constraint on columns "payment_id" */
  tenant_invoice_payment_id_key = 'tenant_invoice_payment_id_key',
  /** unique or primary key constraint on columns "id" */
  tenant_invoice_pkey = 'tenant_invoice_pkey'
}

/** input type for incrementing numeric columns in table "tenant_invoice" */
export type TenantInvoice_Inc_Input = {
  amountEur?: InputMaybe<Scalars['numeric']['input']>;
  invoiceNo?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "tenant_invoice" */
export type TenantInvoice_Insert_Input = {
  amountEur?: InputMaybe<Scalars['numeric']['input']>;
  blobPath?: InputMaybe<Scalars['String']['input']>;
  buyerAccountName?: InputMaybe<Scalars['String']['input']>;
  buyerCountry?: InputMaybe<Scalars['String']['input']>;
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  buyerPostcodeAndCity?: InputMaybe<Scalars['String']['input']>;
  buyerStreetAndNumber?: InputMaybe<Scalars['String']['input']>;
  buyerUserName?: InputMaybe<Scalars['String']['input']>;
  buyerVatId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiceNo?: InputMaybe<Scalars['bigint']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  paymentId?: InputMaybe<Scalars['uuid']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type TenantInvoice_Max_Fields = {
  __typename?: 'tenantInvoice_max_fields';
  amountEur?: Maybe<Scalars['numeric']['output']>;
  blobPath?: Maybe<Scalars['String']['output']>;
  buyerAccountName?: Maybe<Scalars['String']['output']>;
  buyerCountry?: Maybe<Scalars['String']['output']>;
  buyerEmail?: Maybe<Scalars['String']['output']>;
  buyerPostcodeAndCity?: Maybe<Scalars['String']['output']>;
  buyerStreetAndNumber?: Maybe<Scalars['String']['output']>;
  buyerUserName?: Maybe<Scalars['String']['output']>;
  buyerVatId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoiceNo?: Maybe<Scalars['bigint']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  issuedAt?: Maybe<Scalars['timestamptz']['output']>;
  paymentId?: Maybe<Scalars['uuid']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type TenantInvoice_Min_Fields = {
  __typename?: 'tenantInvoice_min_fields';
  amountEur?: Maybe<Scalars['numeric']['output']>;
  blobPath?: Maybe<Scalars['String']['output']>;
  buyerAccountName?: Maybe<Scalars['String']['output']>;
  buyerCountry?: Maybe<Scalars['String']['output']>;
  buyerEmail?: Maybe<Scalars['String']['output']>;
  buyerPostcodeAndCity?: Maybe<Scalars['String']['output']>;
  buyerStreetAndNumber?: Maybe<Scalars['String']['output']>;
  buyerUserName?: Maybe<Scalars['String']['output']>;
  buyerVatId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoiceNo?: Maybe<Scalars['bigint']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  issuedAt?: Maybe<Scalars['timestamptz']['output']>;
  paymentId?: Maybe<Scalars['uuid']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "tenant_invoice" */
export type TenantInvoice_Mutation_Response = {
  __typename?: 'tenantInvoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantInvoice>;
};

/** on_conflict condition type for table "tenant_invoice" */
export type TenantInvoice_On_Conflict = {
  constraint: TenantInvoice_Constraint;
  update_columns?: Array<TenantInvoice_Update_Column>;
  where?: InputMaybe<TenantInvoice_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_invoice". */
export type TenantInvoice_Order_By = {
  amountEur?: InputMaybe<Order_By>;
  blobPath?: InputMaybe<Order_By>;
  buyerAccountName?: InputMaybe<Order_By>;
  buyerCountry?: InputMaybe<Order_By>;
  buyerEmail?: InputMaybe<Order_By>;
  buyerPostcodeAndCity?: InputMaybe<Order_By>;
  buyerStreetAndNumber?: InputMaybe<Order_By>;
  buyerUserName?: InputMaybe<Order_By>;
  buyerVatId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceNo?: InputMaybe<Order_By>;
  invoiceNumber?: InputMaybe<Order_By>;
  issuedAt?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant_invoice */
export type TenantInvoice_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tenant_invoice" */
export enum TenantInvoice_Select_Column {
  /** column name */
  amountEur = 'amountEur',
  /** column name */
  blobPath = 'blobPath',
  /** column name */
  buyerAccountName = 'buyerAccountName',
  /** column name */
  buyerCountry = 'buyerCountry',
  /** column name */
  buyerEmail = 'buyerEmail',
  /** column name */
  buyerPostcodeAndCity = 'buyerPostcodeAndCity',
  /** column name */
  buyerStreetAndNumber = 'buyerStreetAndNumber',
  /** column name */
  buyerUserName = 'buyerUserName',
  /** column name */
  buyerVatId = 'buyerVatId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  invoiceNo = 'invoiceNo',
  /** column name */
  invoiceNumber = 'invoiceNumber',
  /** column name */
  issuedAt = 'issuedAt',
  /** column name */
  paymentId = 'paymentId',
  /** column name */
  productId = 'productId',
  /** column name */
  tenantId = 'tenantId'
}

/** input type for updating data in table "tenant_invoice" */
export type TenantInvoice_Set_Input = {
  amountEur?: InputMaybe<Scalars['numeric']['input']>;
  blobPath?: InputMaybe<Scalars['String']['input']>;
  buyerAccountName?: InputMaybe<Scalars['String']['input']>;
  buyerCountry?: InputMaybe<Scalars['String']['input']>;
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  buyerPostcodeAndCity?: InputMaybe<Scalars['String']['input']>;
  buyerStreetAndNumber?: InputMaybe<Scalars['String']['input']>;
  buyerUserName?: InputMaybe<Scalars['String']['input']>;
  buyerVatId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiceNo?: InputMaybe<Scalars['bigint']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  paymentId?: InputMaybe<Scalars['uuid']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type TenantInvoice_Stddev_Fields = {
  __typename?: 'tenantInvoice_stddev_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  invoiceNo?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TenantInvoice_Stddev_Pop_Fields = {
  __typename?: 'tenantInvoice_stddev_pop_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  invoiceNo?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TenantInvoice_Stddev_Samp_Fields = {
  __typename?: 'tenantInvoice_stddev_samp_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  invoiceNo?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tenantInvoice" */
export type TenantInvoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantInvoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantInvoice_Stream_Cursor_Value_Input = {
  amountEur?: InputMaybe<Scalars['numeric']['input']>;
  blobPath?: InputMaybe<Scalars['String']['input']>;
  buyerAccountName?: InputMaybe<Scalars['String']['input']>;
  buyerCountry?: InputMaybe<Scalars['String']['input']>;
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  buyerPostcodeAndCity?: InputMaybe<Scalars['String']['input']>;
  buyerStreetAndNumber?: InputMaybe<Scalars['String']['input']>;
  buyerUserName?: InputMaybe<Scalars['String']['input']>;
  buyerVatId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiceNo?: InputMaybe<Scalars['bigint']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  paymentId?: InputMaybe<Scalars['uuid']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type TenantInvoice_Sum_Fields = {
  __typename?: 'tenantInvoice_sum_fields';
  amountEur?: Maybe<Scalars['numeric']['output']>;
  invoiceNo?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "tenant_invoice" */
export enum TenantInvoice_Update_Column {
  /** column name */
  amountEur = 'amountEur',
  /** column name */
  blobPath = 'blobPath',
  /** column name */
  buyerAccountName = 'buyerAccountName',
  /** column name */
  buyerCountry = 'buyerCountry',
  /** column name */
  buyerEmail = 'buyerEmail',
  /** column name */
  buyerPostcodeAndCity = 'buyerPostcodeAndCity',
  /** column name */
  buyerStreetAndNumber = 'buyerStreetAndNumber',
  /** column name */
  buyerUserName = 'buyerUserName',
  /** column name */
  buyerVatId = 'buyerVatId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  invoiceNo = 'invoiceNo',
  /** column name */
  invoiceNumber = 'invoiceNumber',
  /** column name */
  issuedAt = 'issuedAt',
  /** column name */
  paymentId = 'paymentId',
  /** column name */
  productId = 'productId',
  /** column name */
  tenantId = 'tenantId'
}

export type TenantInvoice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TenantInvoice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantInvoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantInvoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TenantInvoice_Var_Pop_Fields = {
  __typename?: 'tenantInvoice_var_pop_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  invoiceNo?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TenantInvoice_Var_Samp_Fields = {
  __typename?: 'tenantInvoice_var_samp_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  invoiceNo?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TenantInvoice_Variance_Fields = {
  __typename?: 'tenantInvoice_variance_fields';
  amountEur?: Maybe<Scalars['Float']['output']>;
  invoiceNo?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tenant_user_request_ai_usage" */
export type TenantUserRequestAiUsage = {
  __typename?: 'tenantUserRequestAiUsage';
  budgetSource: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  clientVersion?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  contentPurgedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  endpoint?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedGwp?: Maybe<Scalars['float8']['output']>;
  estimatedTokens: Scalars['Int']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  inputTokensCached?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  promptInput?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['uuid']['output'];
  response?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  tenantId: Scalars['uuid']['output'];
  totalTokens: Scalars['Int']['output'];
  userId: Scalars['uuid']['output'];
  userResponseRating?: Maybe<Scalars['Int']['output']>;
  userResponseRatingComment?: Maybe<Scalars['String']['output']>;
  userResponseRatingCreatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "tenant_user_request_ai_usage" */
export type TenantUserRequestAiUsage_Aggregate = {
  __typename?: 'tenantUserRequestAiUsage_aggregate';
  aggregate?: Maybe<TenantUserRequestAiUsage_Aggregate_Fields>;
  nodes: Array<TenantUserRequestAiUsage>;
};

/** aggregate fields of "tenant_user_request_ai_usage" */
export type TenantUserRequestAiUsage_Aggregate_Fields = {
  __typename?: 'tenantUserRequestAiUsage_aggregate_fields';
  avg?: Maybe<TenantUserRequestAiUsage_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TenantUserRequestAiUsage_Max_Fields>;
  min?: Maybe<TenantUserRequestAiUsage_Min_Fields>;
  stddev?: Maybe<TenantUserRequestAiUsage_Stddev_Fields>;
  stddev_pop?: Maybe<TenantUserRequestAiUsage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TenantUserRequestAiUsage_Stddev_Samp_Fields>;
  sum?: Maybe<TenantUserRequestAiUsage_Sum_Fields>;
  var_pop?: Maybe<TenantUserRequestAiUsage_Var_Pop_Fields>;
  var_samp?: Maybe<TenantUserRequestAiUsage_Var_Samp_Fields>;
  variance?: Maybe<TenantUserRequestAiUsage_Variance_Fields>;
};


/** aggregate fields of "tenant_user_request_ai_usage" */
export type TenantUserRequestAiUsage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantUserRequestAiUsage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TenantUserRequestAiUsage_Avg_Fields = {
  __typename?: 'tenantUserRequestAiUsage_avg_fields';
  estimatedGwp?: Maybe<Scalars['Float']['output']>;
  estimatedTokens?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tenant_user_request_ai_usage". All fields are combined with a logical 'AND'. */
export type TenantUserRequestAiUsage_Bool_Exp = {
  _and?: InputMaybe<Array<TenantUserRequestAiUsage_Bool_Exp>>;
  _not?: InputMaybe<TenantUserRequestAiUsage_Bool_Exp>;
  _or?: InputMaybe<Array<TenantUserRequestAiUsage_Bool_Exp>>;
  budgetSource?: InputMaybe<String_Comparison_Exp>;
  clientName?: InputMaybe<String_Comparison_Exp>;
  clientVersion?: InputMaybe<String_Comparison_Exp>;
  completedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  contentPurgedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endpoint?: InputMaybe<String_Comparison_Exp>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  estimatedGwp?: InputMaybe<Float8_Comparison_Exp>;
  estimatedTokens?: InputMaybe<Int_Comparison_Exp>;
  inputTokens?: InputMaybe<Int_Comparison_Exp>;
  inputTokensCached?: InputMaybe<Int_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  outputTokens?: InputMaybe<Int_Comparison_Exp>;
  promptInput?: InputMaybe<String_Comparison_Exp>;
  requestId?: InputMaybe<Uuid_Comparison_Exp>;
  response?: InputMaybe<String_Comparison_Exp>;
  sessionId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  totalTokens?: InputMaybe<Int_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  userResponseRating?: InputMaybe<Int_Comparison_Exp>;
  userResponseRatingComment?: InputMaybe<String_Comparison_Exp>;
  userResponseRatingCreatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_user_request_ai_usage" */
export enum TenantUserRequestAiUsage_Constraint {
  /** unique or primary key constraint on columns "user_id", "request_id", "tenant_id" */
  tenant_user_request_tokenusage_pkey = 'tenant_user_request_tokenusage_pkey'
}

/** input type for incrementing numeric columns in table "tenant_user_request_ai_usage" */
export type TenantUserRequestAiUsage_Inc_Input = {
  estimatedGwp?: InputMaybe<Scalars['float8']['input']>;
  estimatedTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokensCached?: InputMaybe<Scalars['Int']['input']>;
  outputTokens?: InputMaybe<Scalars['Int']['input']>;
  totalTokens?: InputMaybe<Scalars['Int']['input']>;
  userResponseRating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tenant_user_request_ai_usage" */
export type TenantUserRequestAiUsage_Insert_Input = {
  budgetSource?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  contentPurgedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  estimatedGwp?: InputMaybe<Scalars['float8']['input']>;
  estimatedTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokensCached?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outputTokens?: InputMaybe<Scalars['Int']['input']>;
  promptInput?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  totalTokens?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userResponseRating?: InputMaybe<Scalars['Int']['input']>;
  userResponseRatingComment?: InputMaybe<Scalars['String']['input']>;
  userResponseRatingCreatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type TenantUserRequestAiUsage_Max_Fields = {
  __typename?: 'tenantUserRequestAiUsage_max_fields';
  budgetSource?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientVersion?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  contentPurgedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedGwp?: Maybe<Scalars['float8']['output']>;
  estimatedTokens?: Maybe<Scalars['Int']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  inputTokensCached?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  promptInput?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['uuid']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userResponseRating?: Maybe<Scalars['Int']['output']>;
  userResponseRatingComment?: Maybe<Scalars['String']['output']>;
  userResponseRatingCreatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type TenantUserRequestAiUsage_Min_Fields = {
  __typename?: 'tenantUserRequestAiUsage_min_fields';
  budgetSource?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientVersion?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  contentPurgedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedGwp?: Maybe<Scalars['float8']['output']>;
  estimatedTokens?: Maybe<Scalars['Int']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  inputTokensCached?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  promptInput?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['uuid']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userResponseRating?: Maybe<Scalars['Int']['output']>;
  userResponseRatingComment?: Maybe<Scalars['String']['output']>;
  userResponseRatingCreatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "tenant_user_request_ai_usage" */
export type TenantUserRequestAiUsage_Mutation_Response = {
  __typename?: 'tenantUserRequestAiUsage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantUserRequestAiUsage>;
};

/** on_conflict condition type for table "tenant_user_request_ai_usage" */
export type TenantUserRequestAiUsage_On_Conflict = {
  constraint: TenantUserRequestAiUsage_Constraint;
  update_columns?: Array<TenantUserRequestAiUsage_Update_Column>;
  where?: InputMaybe<TenantUserRequestAiUsage_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_user_request_ai_usage". */
export type TenantUserRequestAiUsage_Order_By = {
  budgetSource?: InputMaybe<Order_By>;
  clientName?: InputMaybe<Order_By>;
  clientVersion?: InputMaybe<Order_By>;
  completedAt?: InputMaybe<Order_By>;
  contentPurgedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endpoint?: InputMaybe<Order_By>;
  errorMessage?: InputMaybe<Order_By>;
  estimatedGwp?: InputMaybe<Order_By>;
  estimatedTokens?: InputMaybe<Order_By>;
  inputTokens?: InputMaybe<Order_By>;
  inputTokensCached?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  outputTokens?: InputMaybe<Order_By>;
  promptInput?: InputMaybe<Order_By>;
  requestId?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  sessionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  totalTokens?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  userResponseRating?: InputMaybe<Order_By>;
  userResponseRatingComment?: InputMaybe<Order_By>;
  userResponseRatingCreatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant_user_request_ai_usage */
export type TenantUserRequestAiUsage_Pk_Columns_Input = {
  requestId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "tenant_user_request_ai_usage" */
export enum TenantUserRequestAiUsage_Select_Column {
  /** column name */
  budgetSource = 'budgetSource',
  /** column name */
  clientName = 'clientName',
  /** column name */
  clientVersion = 'clientVersion',
  /** column name */
  completedAt = 'completedAt',
  /** column name */
  contentPurgedAt = 'contentPurgedAt',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  endpoint = 'endpoint',
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  estimatedGwp = 'estimatedGwp',
  /** column name */
  estimatedTokens = 'estimatedTokens',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  inputTokensCached = 'inputTokensCached',
  /** column name */
  model = 'model',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  promptInput = 'promptInput',
  /** column name */
  requestId = 'requestId',
  /** column name */
  response = 'response',
  /** column name */
  sessionId = 'sessionId',
  /** column name */
  status = 'status',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  totalTokens = 'totalTokens',
  /** column name */
  userId = 'userId',
  /** column name */
  userResponseRating = 'userResponseRating',
  /** column name */
  userResponseRatingComment = 'userResponseRatingComment',
  /** column name */
  userResponseRatingCreatedAt = 'userResponseRatingCreatedAt'
}

/** input type for updating data in table "tenant_user_request_ai_usage" */
export type TenantUserRequestAiUsage_Set_Input = {
  budgetSource?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  contentPurgedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  estimatedGwp?: InputMaybe<Scalars['float8']['input']>;
  estimatedTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokensCached?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outputTokens?: InputMaybe<Scalars['Int']['input']>;
  promptInput?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  totalTokens?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userResponseRating?: InputMaybe<Scalars['Int']['input']>;
  userResponseRatingComment?: InputMaybe<Scalars['String']['input']>;
  userResponseRatingCreatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type TenantUserRequestAiUsage_Stddev_Fields = {
  __typename?: 'tenantUserRequestAiUsage_stddev_fields';
  estimatedGwp?: Maybe<Scalars['Float']['output']>;
  estimatedTokens?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TenantUserRequestAiUsage_Stddev_Pop_Fields = {
  __typename?: 'tenantUserRequestAiUsage_stddev_pop_fields';
  estimatedGwp?: Maybe<Scalars['Float']['output']>;
  estimatedTokens?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TenantUserRequestAiUsage_Stddev_Samp_Fields = {
  __typename?: 'tenantUserRequestAiUsage_stddev_samp_fields';
  estimatedGwp?: Maybe<Scalars['Float']['output']>;
  estimatedTokens?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tenantUserRequestAiUsage" */
export type TenantUserRequestAiUsage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantUserRequestAiUsage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantUserRequestAiUsage_Stream_Cursor_Value_Input = {
  budgetSource?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  contentPurgedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  estimatedGwp?: InputMaybe<Scalars['float8']['input']>;
  estimatedTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokensCached?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outputTokens?: InputMaybe<Scalars['Int']['input']>;
  promptInput?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  totalTokens?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userResponseRating?: InputMaybe<Scalars['Int']['input']>;
  userResponseRatingComment?: InputMaybe<Scalars['String']['input']>;
  userResponseRatingCreatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type TenantUserRequestAiUsage_Sum_Fields = {
  __typename?: 'tenantUserRequestAiUsage_sum_fields';
  estimatedGwp?: Maybe<Scalars['float8']['output']>;
  estimatedTokens?: Maybe<Scalars['Int']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  inputTokensCached?: Maybe<Scalars['Int']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  userResponseRating?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "tenant_user_request_ai_usage" */
export enum TenantUserRequestAiUsage_Update_Column {
  /** column name */
  budgetSource = 'budgetSource',
  /** column name */
  clientName = 'clientName',
  /** column name */
  clientVersion = 'clientVersion',
  /** column name */
  completedAt = 'completedAt',
  /** column name */
  contentPurgedAt = 'contentPurgedAt',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  endpoint = 'endpoint',
  /** column name */
  errorMessage = 'errorMessage',
  /** column name */
  estimatedGwp = 'estimatedGwp',
  /** column name */
  estimatedTokens = 'estimatedTokens',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  inputTokensCached = 'inputTokensCached',
  /** column name */
  model = 'model',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  promptInput = 'promptInput',
  /** column name */
  requestId = 'requestId',
  /** column name */
  response = 'response',
  /** column name */
  sessionId = 'sessionId',
  /** column name */
  status = 'status',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  totalTokens = 'totalTokens',
  /** column name */
  userId = 'userId',
  /** column name */
  userResponseRating = 'userResponseRating',
  /** column name */
  userResponseRatingComment = 'userResponseRatingComment',
  /** column name */
  userResponseRatingCreatedAt = 'userResponseRatingCreatedAt'
}

export type TenantUserRequestAiUsage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TenantUserRequestAiUsage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantUserRequestAiUsage_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantUserRequestAiUsage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TenantUserRequestAiUsage_Var_Pop_Fields = {
  __typename?: 'tenantUserRequestAiUsage_var_pop_fields';
  estimatedGwp?: Maybe<Scalars['Float']['output']>;
  estimatedTokens?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TenantUserRequestAiUsage_Var_Samp_Fields = {
  __typename?: 'tenantUserRequestAiUsage_var_samp_fields';
  estimatedGwp?: Maybe<Scalars['Float']['output']>;
  estimatedTokens?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TenantUserRequestAiUsage_Variance_Fields = {
  __typename?: 'tenantUserRequestAiUsage_variance_fields';
  estimatedGwp?: Maybe<Scalars['Float']['output']>;
  estimatedTokens?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Float']['output']>;
  inputTokensCached?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Float']['output']>;
  userResponseRating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "translation_category" */
export type TranslationCategory = {
  __typename?: 'translationCategory';
  id: Scalars['String']['output'];
  /** An object relationship */
  language: Language;
  languageCode: Scalars['String']['output'];
  original: Scalars['String']['output'];
  translation: Scalars['String']['output'];
  translationSource: Scalars['String']['output'];
};

/** aggregated selection of "translation_category" */
export type TranslationCategory_Aggregate = {
  __typename?: 'translationCategory_aggregate';
  aggregate?: Maybe<TranslationCategory_Aggregate_Fields>;
  nodes: Array<TranslationCategory>;
};

export type TranslationCategory_Aggregate_Bool_Exp = {
  count?: InputMaybe<TranslationCategory_Aggregate_Bool_Exp_Count>;
};

export type TranslationCategory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<TranslationCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TranslationCategory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "translation_category" */
export type TranslationCategory_Aggregate_Fields = {
  __typename?: 'translationCategory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TranslationCategory_Max_Fields>;
  min?: Maybe<TranslationCategory_Min_Fields>;
};


/** aggregate fields of "translation_category" */
export type TranslationCategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TranslationCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "translation_category" */
export type TranslationCategory_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TranslationCategory_Max_Order_By>;
  min?: InputMaybe<TranslationCategory_Min_Order_By>;
};

/** input type for inserting array relation for remote table "translation_category" */
export type TranslationCategory_Arr_Rel_Insert_Input = {
  data: Array<TranslationCategory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TranslationCategory_On_Conflict>;
};

/** Boolean expression to filter rows from the table "translation_category". All fields are combined with a logical 'AND'. */
export type TranslationCategory_Bool_Exp = {
  _and?: InputMaybe<Array<TranslationCategory_Bool_Exp>>;
  _not?: InputMaybe<TranslationCategory_Bool_Exp>;
  _or?: InputMaybe<Array<TranslationCategory_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<Language_Bool_Exp>;
  languageCode?: InputMaybe<String_Comparison_Exp>;
  original?: InputMaybe<String_Comparison_Exp>;
  translation?: InputMaybe<String_Comparison_Exp>;
  translationSource?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "translation_category" */
export enum TranslationCategory_Constraint {
  /** unique or primary key constraint on columns "id", "language_code" */
  translation_category_pkey = 'translation_category_pkey'
}

/** input type for inserting data into table "translation_category" */
export type TranslationCategory_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language_Obj_Rel_Insert_Input>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  original?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TranslationCategory_Max_Fields = {
  __typename?: 'translationCategory_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "translation_category" */
export type TranslationCategory_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  original?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TranslationCategory_Min_Fields = {
  __typename?: 'translationCategory_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationSource?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "translation_category" */
export type TranslationCategory_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  languageCode?: InputMaybe<Order_By>;
  original?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "translation_category" */
export type TranslationCategory_Mutation_Response = {
  __typename?: 'translationCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TranslationCategory>;
};

/** on_conflict condition type for table "translation_category" */
export type TranslationCategory_On_Conflict = {
  constraint: TranslationCategory_Constraint;
  update_columns?: Array<TranslationCategory_Update_Column>;
  where?: InputMaybe<TranslationCategory_Bool_Exp>;
};

/** Ordering options when selecting data from "translation_category". */
export type TranslationCategory_Order_By = {
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Language_Order_By>;
  languageCode?: InputMaybe<Order_By>;
  original?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
  translationSource?: InputMaybe<Order_By>;
};

/** primary key columns input for table: translation_category */
export type TranslationCategory_Pk_Columns_Input = {
  id: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
};

/** select columns of table "translation_category" */
export enum TranslationCategory_Select_Column {
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  original = 'original',
  /** column name */
  translation = 'translation',
  /** column name */
  translationSource = 'translationSource'
}

/** input type for updating data in table "translation_category" */
export type TranslationCategory_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  original?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "translationCategory" */
export type TranslationCategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TranslationCategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TranslationCategory_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  original?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "translation_category" */
export enum TranslationCategory_Update_Column {
  /** column name */
  id = 'id',
  /** column name */
  languageCode = 'languageCode',
  /** column name */
  original = 'original',
  /** column name */
  translation = 'translation',
  /** column name */
  translationSource = 'translationSource'
}

export type TranslationCategory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TranslationCategory_Set_Input>;
  /** filter the rows which have to be updated */
  where: TranslationCategory_Bool_Exp;
};

/** columns and relationships of "translation_source" */
export type TranslationSource = {
  __typename?: 'translationSource';
  value: Scalars['String']['output'];
};

/** aggregated selection of "translation_source" */
export type TranslationSource_Aggregate = {
  __typename?: 'translationSource_aggregate';
  aggregate?: Maybe<TranslationSource_Aggregate_Fields>;
  nodes: Array<TranslationSource>;
};

/** aggregate fields of "translation_source" */
export type TranslationSource_Aggregate_Fields = {
  __typename?: 'translationSource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TranslationSource_Max_Fields>;
  min?: Maybe<TranslationSource_Min_Fields>;
};


/** aggregate fields of "translation_source" */
export type TranslationSource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TranslationSource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "translation_source". All fields are combined with a logical 'AND'. */
export type TranslationSource_Bool_Exp = {
  _and?: InputMaybe<Array<TranslationSource_Bool_Exp>>;
  _not?: InputMaybe<TranslationSource_Bool_Exp>;
  _or?: InputMaybe<Array<TranslationSource_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "translation_source" */
export enum TranslationSource_Constraint {
  /** unique or primary key constraint on columns "value" */
  translation_source_pkey = 'translation_source_pkey'
}

/** input type for inserting data into table "translation_source" */
export type TranslationSource_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TranslationSource_Max_Fields = {
  __typename?: 'translationSource_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TranslationSource_Min_Fields = {
  __typename?: 'translationSource_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "translation_source" */
export type TranslationSource_Mutation_Response = {
  __typename?: 'translationSource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TranslationSource>;
};

/** on_conflict condition type for table "translation_source" */
export type TranslationSource_On_Conflict = {
  constraint: TranslationSource_Constraint;
  update_columns?: Array<TranslationSource_Update_Column>;
  where?: InputMaybe<TranslationSource_Bool_Exp>;
};

/** Ordering options when selecting data from "translation_source". */
export type TranslationSource_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: translation_source */
export type TranslationSource_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "translation_source" */
export enum TranslationSource_Select_Column {
  /** column name */
  value = 'value'
}

/** input type for updating data in table "translation_source" */
export type TranslationSource_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "translationSource" */
export type TranslationSource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TranslationSource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TranslationSource_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "translation_source" */
export enum TranslationSource_Update_Column {
  /** column name */
  value = 'value'
}

export type TranslationSource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TranslationSource_Set_Input>;
  /** filter the rows which have to be updated */
  where: TranslationSource_Bool_Exp;
};

/** columns and relationships of "transport" */
export type Transport = {
  __typename?: 'transport';
  country: Country_Enum;
  datasource?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  denominatorUnit: DenominatorUnit;
  denominator_unit_id: Scalars['Int']['output'];
  distance: Scalars['numeric']['output'];
  distance_unit: Distance_Unit_Enum;
  emission: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indicatorType: IndicatorType;
  indicator_type_id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  totalDenominatorUnit: DenominatorUnit;
  /** An object relationship */
  totalIndicatorType: IndicatorType;
  total_denominator_unit_id: Scalars['Int']['output'];
  total_indicator_type_id: Scalars['Int']['output'];
  transportType: Transport_Type_Enum;
};

/** columns and relationships of "transport_emission_factor" */
export type TransportEmissionFactor = {
  __typename?: 'transportEmissionFactor';
  country: Country_Enum;
  datasource?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  denominatorUnit: DenominatorUnit;
  denominatorUnitId: Scalars['Int']['output'];
  emission: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indicatorType: IndicatorType;
  indicatorTypeId: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  transportSource?: Maybe<TransportSource>;
  transportSourceId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "transport_emission_factor" */
export type TransportEmissionFactor_Aggregate = {
  __typename?: 'transportEmissionFactor_aggregate';
  aggregate?: Maybe<TransportEmissionFactor_Aggregate_Fields>;
  nodes: Array<TransportEmissionFactor>;
};

export type TransportEmissionFactor_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<TransportEmissionFactor_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<TransportEmissionFactor_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<TransportEmissionFactor_Aggregate_Bool_Exp_Count>;
};

export type TransportEmissionFactor_Aggregate_Bool_Exp_Bool_And = {
  arguments: TransportEmissionFactor_Select_Column_TransportEmissionFactor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type TransportEmissionFactor_Aggregate_Bool_Exp_Bool_Or = {
  arguments: TransportEmissionFactor_Select_Column_TransportEmissionFactor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type TransportEmissionFactor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<TransportEmissionFactor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "transport_emission_factor" */
export type TransportEmissionFactor_Aggregate_Fields = {
  __typename?: 'transportEmissionFactor_aggregate_fields';
  avg?: Maybe<TransportEmissionFactor_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TransportEmissionFactor_Max_Fields>;
  min?: Maybe<TransportEmissionFactor_Min_Fields>;
  stddev?: Maybe<TransportEmissionFactor_Stddev_Fields>;
  stddev_pop?: Maybe<TransportEmissionFactor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TransportEmissionFactor_Stddev_Samp_Fields>;
  sum?: Maybe<TransportEmissionFactor_Sum_Fields>;
  var_pop?: Maybe<TransportEmissionFactor_Var_Pop_Fields>;
  var_samp?: Maybe<TransportEmissionFactor_Var_Samp_Fields>;
  variance?: Maybe<TransportEmissionFactor_Variance_Fields>;
};


/** aggregate fields of "transport_emission_factor" */
export type TransportEmissionFactor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TransportEmissionFactor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "transport_emission_factor" */
export type TransportEmissionFactor_Aggregate_Order_By = {
  avg?: InputMaybe<TransportEmissionFactor_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TransportEmissionFactor_Max_Order_By>;
  min?: InputMaybe<TransportEmissionFactor_Min_Order_By>;
  stddev?: InputMaybe<TransportEmissionFactor_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TransportEmissionFactor_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TransportEmissionFactor_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TransportEmissionFactor_Sum_Order_By>;
  var_pop?: InputMaybe<TransportEmissionFactor_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TransportEmissionFactor_Var_Samp_Order_By>;
  variance?: InputMaybe<TransportEmissionFactor_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transport_emission_factor" */
export type TransportEmissionFactor_Arr_Rel_Insert_Input = {
  data: Array<TransportEmissionFactor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TransportEmissionFactor_On_Conflict>;
};

/** aggregate avg on columns */
export type TransportEmissionFactor_Avg_Fields = {
  __typename?: 'transportEmissionFactor_avg_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Avg_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transport_emission_factor". All fields are combined with a logical 'AND'. */
export type TransportEmissionFactor_Bool_Exp = {
  _and?: InputMaybe<Array<TransportEmissionFactor_Bool_Exp>>;
  _not?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
  _or?: InputMaybe<Array<TransportEmissionFactor_Bool_Exp>>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  datasource?: InputMaybe<String_Comparison_Exp>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Bool_Exp>;
  denominatorUnitId?: InputMaybe<Int_Comparison_Exp>;
  emission?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  indicatorTypeId?: InputMaybe<Int_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  transportSource?: InputMaybe<TransportSource_Bool_Exp>;
  transportSourceId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "transport_emission_factor" */
export enum TransportEmissionFactor_Constraint {
  /** unique or primary key constraint on columns "id" */
  transport_emission_factor_pkey = 'transport_emission_factor_pkey'
}

/** input type for incrementing numeric columns in table "transport_emission_factor" */
export type TransportEmissionFactor_Inc_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "transport_emission_factor" */
export type TransportEmissionFactor_Insert_Input = {
  country?: InputMaybe<Country_Enum>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Obj_Rel_Insert_Input>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  transportSource?: InputMaybe<TransportSource_Obj_Rel_Insert_Input>;
  transportSourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type TransportEmissionFactor_Max_Fields = {
  __typename?: 'transportEmissionFactor_max_fields';
  datasource?: Maybe<Scalars['String']['output']>;
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  transportSourceId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Max_Order_By = {
  datasource?: InputMaybe<Order_By>;
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  transportSourceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TransportEmissionFactor_Min_Fields = {
  __typename?: 'transportEmissionFactor_min_fields';
  datasource?: Maybe<Scalars['String']['output']>;
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  transportSourceId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Min_Order_By = {
  datasource?: InputMaybe<Order_By>;
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  transportSourceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transport_emission_factor" */
export type TransportEmissionFactor_Mutation_Response = {
  __typename?: 'transportEmissionFactor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TransportEmissionFactor>;
};

/** input type for inserting object relation for remote table "transport_emission_factor" */
export type TransportEmissionFactor_Obj_Rel_Insert_Input = {
  data: TransportEmissionFactor_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<TransportEmissionFactor_On_Conflict>;
};

/** on_conflict condition type for table "transport_emission_factor" */
export type TransportEmissionFactor_On_Conflict = {
  constraint: TransportEmissionFactor_Constraint;
  update_columns?: Array<TransportEmissionFactor_Update_Column>;
  where?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
};

/** Ordering options when selecting data from "transport_emission_factor". */
export type TransportEmissionFactor_Order_By = {
  country?: InputMaybe<Order_By>;
  datasource?: InputMaybe<Order_By>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Order_By>;
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicatorType?: InputMaybe<IndicatorType_Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  transportSource?: InputMaybe<TransportSource_Order_By>;
  transportSourceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transport_emission_factor */
export type TransportEmissionFactor_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "transport_emission_factor" */
export enum TransportEmissionFactor_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  datasource = 'datasource',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  label = 'label',
  /** column name */
  transportSourceId = 'transportSourceId'
}

/** select "transportEmissionFactor_aggregate_bool_exp_bool_and_arguments_columns" columns of table "transport_emission_factor" */
export enum TransportEmissionFactor_Select_Column_TransportEmissionFactor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** select "transportEmissionFactor_aggregate_bool_exp_bool_or_arguments_columns" columns of table "transport_emission_factor" */
export enum TransportEmissionFactor_Select_Column_TransportEmissionFactor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  isDefault = 'isDefault'
}

/** input type for updating data in table "transport_emission_factor" */
export type TransportEmissionFactor_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  transportSourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type TransportEmissionFactor_Stddev_Fields = {
  __typename?: 'transportEmissionFactor_stddev_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Stddev_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type TransportEmissionFactor_Stddev_Pop_Fields = {
  __typename?: 'transportEmissionFactor_stddev_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Stddev_Pop_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type TransportEmissionFactor_Stddev_Samp_Fields = {
  __typename?: 'transportEmissionFactor_stddev_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Stddev_Samp_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transportEmissionFactor" */
export type TransportEmissionFactor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TransportEmissionFactor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TransportEmissionFactor_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorTypeId?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  transportSourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type TransportEmissionFactor_Sum_Fields = {
  __typename?: 'transportEmissionFactor_sum_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  indicatorTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Sum_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "transport_emission_factor" */
export enum TransportEmissionFactor_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  datasource = 'datasource',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  indicatorTypeId = 'indicatorTypeId',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  label = 'label',
  /** column name */
  transportSourceId = 'transportSourceId'
}

export type TransportEmissionFactor_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TransportEmissionFactor_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TransportEmissionFactor_Set_Input>;
  /** filter the rows which have to be updated */
  where: TransportEmissionFactor_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TransportEmissionFactor_Var_Pop_Fields = {
  __typename?: 'transportEmissionFactor_var_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Var_Pop_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type TransportEmissionFactor_Var_Samp_Fields = {
  __typename?: 'transportEmissionFactor_var_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Var_Samp_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type TransportEmissionFactor_Variance_Fields = {
  __typename?: 'transportEmissionFactor_variance_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicatorTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "transport_emission_factor" */
export type TransportEmissionFactor_Variance_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  indicatorTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "transport_source" */
export type TransportSource = {
  __typename?: 'transportSource';
  /** An array relationship */
  calculationTypes: Array<TransportSourceCalculationType>;
  /** An aggregate relationship */
  calculationTypes_aggregate: TransportSourceCalculationType_Aggregate;
  datasource: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  shortLabel: Scalars['String']['output'];
  /** An array relationship */
  transportEmissionFactors: Array<TransportEmissionFactor>;
  /** An aggregate relationship */
  transportEmissionFactors_aggregate: TransportEmissionFactor_Aggregate;
  /** An array relationship */
  transportStandardValues: Array<Transport_Standard_Value>;
  /** An aggregate relationship */
  transportStandardValues_aggregate: Transport_Standard_Value_Aggregate;
};


/** columns and relationships of "transport_source" */
export type TransportSourceCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<TransportSourceCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSourceCalculationType_Order_By>>;
  where?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
};


/** columns and relationships of "transport_source" */
export type TransportSourceCalculationTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransportSourceCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportSourceCalculationType_Order_By>>;
  where?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
};


/** columns and relationships of "transport_source" */
export type TransportSourceTransportEmissionFactorsArgs = {
  distinct_on?: InputMaybe<Array<TransportEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportEmissionFactor_Order_By>>;
  where?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
};


/** columns and relationships of "transport_source" */
export type TransportSourceTransportEmissionFactors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransportEmissionFactor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransportEmissionFactor_Order_By>>;
  where?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
};


/** columns and relationships of "transport_source" */
export type TransportSourceTransportStandardValuesArgs = {
  distinct_on?: InputMaybe<Array<Transport_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Standard_Value_Order_By>>;
  where?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
};


/** columns and relationships of "transport_source" */
export type TransportSourceTransportStandardValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transport_Standard_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transport_Standard_Value_Order_By>>;
  where?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
};

/** columns and relationships of "transport_source_calculation_type" */
export type TransportSourceCalculationType = {
  __typename?: 'transportSourceCalculationType';
  /** An object relationship */
  calculationType: CalculationType;
  calculationTypeId: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  transportSourceId: Scalars['uuid']['output'];
};

/** aggregated selection of "transport_source_calculation_type" */
export type TransportSourceCalculationType_Aggregate = {
  __typename?: 'transportSourceCalculationType_aggregate';
  aggregate?: Maybe<TransportSourceCalculationType_Aggregate_Fields>;
  nodes: Array<TransportSourceCalculationType>;
};

export type TransportSourceCalculationType_Aggregate_Bool_Exp = {
  count?: InputMaybe<TransportSourceCalculationType_Aggregate_Bool_Exp_Count>;
};

export type TransportSourceCalculationType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<TransportSourceCalculationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "transport_source_calculation_type" */
export type TransportSourceCalculationType_Aggregate_Fields = {
  __typename?: 'transportSourceCalculationType_aggregate_fields';
  avg?: Maybe<TransportSourceCalculationType_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TransportSourceCalculationType_Max_Fields>;
  min?: Maybe<TransportSourceCalculationType_Min_Fields>;
  stddev?: Maybe<TransportSourceCalculationType_Stddev_Fields>;
  stddev_pop?: Maybe<TransportSourceCalculationType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TransportSourceCalculationType_Stddev_Samp_Fields>;
  sum?: Maybe<TransportSourceCalculationType_Sum_Fields>;
  var_pop?: Maybe<TransportSourceCalculationType_Var_Pop_Fields>;
  var_samp?: Maybe<TransportSourceCalculationType_Var_Samp_Fields>;
  variance?: Maybe<TransportSourceCalculationType_Variance_Fields>;
};


/** aggregate fields of "transport_source_calculation_type" */
export type TransportSourceCalculationType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TransportSourceCalculationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Aggregate_Order_By = {
  avg?: InputMaybe<TransportSourceCalculationType_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TransportSourceCalculationType_Max_Order_By>;
  min?: InputMaybe<TransportSourceCalculationType_Min_Order_By>;
  stddev?: InputMaybe<TransportSourceCalculationType_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TransportSourceCalculationType_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TransportSourceCalculationType_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TransportSourceCalculationType_Sum_Order_By>;
  var_pop?: InputMaybe<TransportSourceCalculationType_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TransportSourceCalculationType_Var_Samp_Order_By>;
  variance?: InputMaybe<TransportSourceCalculationType_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Arr_Rel_Insert_Input = {
  data: Array<TransportSourceCalculationType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TransportSourceCalculationType_On_Conflict>;
};

/** aggregate avg on columns */
export type TransportSourceCalculationType_Avg_Fields = {
  __typename?: 'transportSourceCalculationType_avg_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Avg_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transport_source_calculation_type". All fields are combined with a logical 'AND'. */
export type TransportSourceCalculationType_Bool_Exp = {
  _and?: InputMaybe<Array<TransportSourceCalculationType_Bool_Exp>>;
  _not?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
  _or?: InputMaybe<Array<TransportSourceCalculationType_Bool_Exp>>;
  calculationType?: InputMaybe<CalculationType_Bool_Exp>;
  calculationTypeId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  transportSourceId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "transport_source_calculation_type" */
export enum TransportSourceCalculationType_Constraint {
  /** unique or primary key constraint on columns "transport_source_id", "calculation_type_id" */
  transport_source_calculation__transport_source_id_calculati_key = 'transport_source_calculation__transport_source_id_calculati_key',
  /** unique or primary key constraint on columns "id" */
  transport_source_calculation_type_pkey = 'transport_source_calculation_type_pkey'
}

/** input type for incrementing numeric columns in table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Inc_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Insert_Input = {
  calculationType?: InputMaybe<CalculationType_Obj_Rel_Insert_Input>;
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  transportSourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type TransportSourceCalculationType_Max_Fields = {
  __typename?: 'transportSourceCalculationType_max_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  transportSourceId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Max_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transportSourceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TransportSourceCalculationType_Min_Fields = {
  __typename?: 'transportSourceCalculationType_min_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  transportSourceId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Min_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transportSourceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Mutation_Response = {
  __typename?: 'transportSourceCalculationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TransportSourceCalculationType>;
};

/** on_conflict condition type for table "transport_source_calculation_type" */
export type TransportSourceCalculationType_On_Conflict = {
  constraint: TransportSourceCalculationType_Constraint;
  update_columns?: Array<TransportSourceCalculationType_Update_Column>;
  where?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
};

/** Ordering options when selecting data from "transport_source_calculation_type". */
export type TransportSourceCalculationType_Order_By = {
  calculationType?: InputMaybe<CalculationType_Order_By>;
  calculationTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transportSourceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transport_source_calculation_type */
export type TransportSourceCalculationType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "transport_source_calculation_type" */
export enum TransportSourceCalculationType_Select_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  transportSourceId = 'transportSourceId'
}

/** input type for updating data in table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Set_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  transportSourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type TransportSourceCalculationType_Stddev_Fields = {
  __typename?: 'transportSourceCalculationType_stddev_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Stddev_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type TransportSourceCalculationType_Stddev_Pop_Fields = {
  __typename?: 'transportSourceCalculationType_stddev_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Stddev_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type TransportSourceCalculationType_Stddev_Samp_Fields = {
  __typename?: 'transportSourceCalculationType_stddev_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Stddev_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transportSourceCalculationType" */
export type TransportSourceCalculationType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TransportSourceCalculationType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TransportSourceCalculationType_Stream_Cursor_Value_Input = {
  calculationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  transportSourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type TransportSourceCalculationType_Sum_Fields = {
  __typename?: 'transportSourceCalculationType_sum_fields';
  calculationTypeId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Sum_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "transport_source_calculation_type" */
export enum TransportSourceCalculationType_Update_Column {
  /** column name */
  calculationTypeId = 'calculationTypeId',
  /** column name */
  id = 'id',
  /** column name */
  transportSourceId = 'transportSourceId'
}

export type TransportSourceCalculationType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TransportSourceCalculationType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TransportSourceCalculationType_Set_Input>;
  /** filter the rows which have to be updated */
  where: TransportSourceCalculationType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TransportSourceCalculationType_Var_Pop_Fields = {
  __typename?: 'transportSourceCalculationType_var_pop_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Var_Pop_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type TransportSourceCalculationType_Var_Samp_Fields = {
  __typename?: 'transportSourceCalculationType_var_samp_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Var_Samp_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type TransportSourceCalculationType_Variance_Fields = {
  __typename?: 'transportSourceCalculationType_variance_fields';
  calculationTypeId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "transport_source_calculation_type" */
export type TransportSourceCalculationType_Variance_Order_By = {
  calculationTypeId?: InputMaybe<Order_By>;
};

/** aggregated selection of "transport_source" */
export type TransportSource_Aggregate = {
  __typename?: 'transportSource_aggregate';
  aggregate?: Maybe<TransportSource_Aggregate_Fields>;
  nodes: Array<TransportSource>;
};

/** aggregate fields of "transport_source" */
export type TransportSource_Aggregate_Fields = {
  __typename?: 'transportSource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TransportSource_Max_Fields>;
  min?: Maybe<TransportSource_Min_Fields>;
};


/** aggregate fields of "transport_source" */
export type TransportSource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TransportSource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "transport_source". All fields are combined with a logical 'AND'. */
export type TransportSource_Bool_Exp = {
  _and?: InputMaybe<Array<TransportSource_Bool_Exp>>;
  _not?: InputMaybe<TransportSource_Bool_Exp>;
  _or?: InputMaybe<Array<TransportSource_Bool_Exp>>;
  calculationTypes?: InputMaybe<TransportSourceCalculationType_Bool_Exp>;
  calculationTypes_aggregate?: InputMaybe<TransportSourceCalculationType_Aggregate_Bool_Exp>;
  datasource?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  shortLabel?: InputMaybe<String_Comparison_Exp>;
  transportEmissionFactors?: InputMaybe<TransportEmissionFactor_Bool_Exp>;
  transportEmissionFactors_aggregate?: InputMaybe<TransportEmissionFactor_Aggregate_Bool_Exp>;
  transportStandardValues?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
  transportStandardValues_aggregate?: InputMaybe<Transport_Standard_Value_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "transport_source" */
export enum TransportSource_Constraint {
  /** unique or primary key constraint on columns "id" */
  transport_source_pkey = 'transport_source_pkey'
}

/** input type for inserting data into table "transport_source" */
export type TransportSource_Insert_Input = {
  calculationTypes?: InputMaybe<TransportSourceCalculationType_Arr_Rel_Insert_Input>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  shortLabel?: InputMaybe<Scalars['String']['input']>;
  transportEmissionFactors?: InputMaybe<TransportEmissionFactor_Arr_Rel_Insert_Input>;
  transportStandardValues?: InputMaybe<Transport_Standard_Value_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type TransportSource_Max_Fields = {
  __typename?: 'transportSource_max_fields';
  datasource?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  shortLabel?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TransportSource_Min_Fields = {
  __typename?: 'transportSource_min_fields';
  datasource?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  shortLabel?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "transport_source" */
export type TransportSource_Mutation_Response = {
  __typename?: 'transportSource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TransportSource>;
};

/** input type for inserting object relation for remote table "transport_source" */
export type TransportSource_Obj_Rel_Insert_Input = {
  data: TransportSource_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<TransportSource_On_Conflict>;
};

/** on_conflict condition type for table "transport_source" */
export type TransportSource_On_Conflict = {
  constraint: TransportSource_Constraint;
  update_columns?: Array<TransportSource_Update_Column>;
  where?: InputMaybe<TransportSource_Bool_Exp>;
};

/** Ordering options when selecting data from "transport_source". */
export type TransportSource_Order_By = {
  calculationTypes_aggregate?: InputMaybe<TransportSourceCalculationType_Aggregate_Order_By>;
  datasource?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  shortLabel?: InputMaybe<Order_By>;
  transportEmissionFactors_aggregate?: InputMaybe<TransportEmissionFactor_Aggregate_Order_By>;
  transportStandardValues_aggregate?: InputMaybe<Transport_Standard_Value_Aggregate_Order_By>;
};

/** primary key columns input for table: transport_source */
export type TransportSource_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "transport_source" */
export enum TransportSource_Select_Column {
  /** column name */
  datasource = 'datasource',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  shortLabel = 'shortLabel'
}

/** input type for updating data in table "transport_source" */
export type TransportSource_Set_Input = {
  datasource?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  shortLabel?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "transportSource" */
export type TransportSource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TransportSource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TransportSource_Stream_Cursor_Value_Input = {
  datasource?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  shortLabel?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "transport_source" */
export enum TransportSource_Update_Column {
  /** column name */
  datasource = 'datasource',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  shortLabel = 'shortLabel'
}

export type TransportSource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TransportSource_Set_Input>;
  /** filter the rows which have to be updated */
  where: TransportSource_Bool_Exp;
};

/** aggregated selection of "transport" */
export type Transport_Aggregate = {
  __typename?: 'transport_aggregate';
  aggregate?: Maybe<Transport_Aggregate_Fields>;
  nodes: Array<Transport>;
};

/** aggregate fields of "transport" */
export type Transport_Aggregate_Fields = {
  __typename?: 'transport_aggregate_fields';
  avg?: Maybe<Transport_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Transport_Max_Fields>;
  min?: Maybe<Transport_Min_Fields>;
  stddev?: Maybe<Transport_Stddev_Fields>;
  stddev_pop?: Maybe<Transport_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transport_Stddev_Samp_Fields>;
  sum?: Maybe<Transport_Sum_Fields>;
  var_pop?: Maybe<Transport_Var_Pop_Fields>;
  var_samp?: Maybe<Transport_Var_Samp_Fields>;
  variance?: Maybe<Transport_Variance_Fields>;
};


/** aggregate fields of "transport" */
export type Transport_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Transport_Avg_Fields = {
  __typename?: 'transport_avg_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "transport". All fields are combined with a logical 'AND'. */
export type Transport_Bool_Exp = {
  _and?: InputMaybe<Array<Transport_Bool_Exp>>;
  _not?: InputMaybe<Transport_Bool_Exp>;
  _or?: InputMaybe<Array<Transport_Bool_Exp>>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  datasource?: InputMaybe<String_Comparison_Exp>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Bool_Exp>;
  denominator_unit_id?: InputMaybe<Int_Comparison_Exp>;
  distance?: InputMaybe<Numeric_Comparison_Exp>;
  distance_unit?: InputMaybe<Distance_Unit_Enum_Comparison_Exp>;
  emission?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  indicator_type_id?: InputMaybe<Int_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  totalDenominatorUnit?: InputMaybe<DenominatorUnit_Bool_Exp>;
  totalIndicatorType?: InputMaybe<IndicatorType_Bool_Exp>;
  total_denominator_unit_id?: InputMaybe<Int_Comparison_Exp>;
  total_indicator_type_id?: InputMaybe<Int_Comparison_Exp>;
  transportType?: InputMaybe<Transport_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "transport" */
export enum Transport_Constraint {
  /** unique or primary key constraint on columns "id" */
  transport_type_pkey1 = 'transport_type_pkey1'
}

/** input type for incrementing numeric columns in table "transport" */
export type Transport_Inc_Input = {
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
  total_denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  total_indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "transport" */
export type Transport_Insert_Input = {
  country?: InputMaybe<Country_Enum>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Obj_Rel_Insert_Input>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  distance_unit?: InputMaybe<Distance_Unit_Enum>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  totalDenominatorUnit?: InputMaybe<DenominatorUnit_Obj_Rel_Insert_Input>;
  totalIndicatorType?: InputMaybe<IndicatorType_Obj_Rel_Insert_Input>;
  total_denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  total_indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
  transportType?: InputMaybe<Transport_Type_Enum>;
};

/** aggregate max on columns */
export type Transport_Max_Fields = {
  __typename?: 'transport_max_fields';
  datasource?: Maybe<Scalars['String']['output']>;
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['numeric']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicator_type_id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Transport_Min_Fields = {
  __typename?: 'transport_min_fields';
  datasource?: Maybe<Scalars['String']['output']>;
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['numeric']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicator_type_id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "transport" */
export type Transport_Mutation_Response = {
  __typename?: 'transport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transport>;
};

/** input type for inserting object relation for remote table "transport" */
export type Transport_Obj_Rel_Insert_Input = {
  data: Transport_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transport_On_Conflict>;
};

/** on_conflict condition type for table "transport" */
export type Transport_On_Conflict = {
  constraint: Transport_Constraint;
  update_columns?: Array<Transport_Update_Column>;
  where?: InputMaybe<Transport_Bool_Exp>;
};

/** Ordering options when selecting data from "transport". */
export type Transport_Order_By = {
  country?: InputMaybe<Order_By>;
  datasource?: InputMaybe<Order_By>;
  denominatorUnit?: InputMaybe<DenominatorUnit_Order_By>;
  denominator_unit_id?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  distance_unit?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicatorType?: InputMaybe<IndicatorType_Order_By>;
  indicator_type_id?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  totalDenominatorUnit?: InputMaybe<DenominatorUnit_Order_By>;
  totalIndicatorType?: InputMaybe<IndicatorType_Order_By>;
  total_denominator_unit_id?: InputMaybe<Order_By>;
  total_indicator_type_id?: InputMaybe<Order_By>;
  transportType?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transport */
export type Transport_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "transport" */
export enum Transport_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  datasource = 'datasource',
  /** column name */
  denominator_unit_id = 'denominator_unit_id',
  /** column name */
  distance = 'distance',
  /** column name */
  distance_unit = 'distance_unit',
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  indicator_type_id = 'indicator_type_id',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  label = 'label',
  /** column name */
  total_denominator_unit_id = 'total_denominator_unit_id',
  /** column name */
  total_indicator_type_id = 'total_indicator_type_id',
  /** column name */
  transportType = 'transportType'
}

/** input type for updating data in table "transport" */
export type Transport_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  distance_unit?: InputMaybe<Distance_Unit_Enum>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  total_denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  total_indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
  transportType?: InputMaybe<Transport_Type_Enum>;
};

/** columns and relationships of "transport_standard_value" */
export type Transport_Standard_Value = {
  __typename?: 'transport_standard_value';
  country?: Maybe<Country_Enum>;
  /** An object relationship */
  denominatorUnit?: Maybe<Unit>;
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  emission: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  mainGroup: Scalars['String']['output'];
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  subGroup: Scalars['String']['output'];
  /** An object relationship */
  transportSource?: Maybe<TransportSource>;
  transportSourceId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "transport_standard_value" */
export type Transport_Standard_Value_Aggregate = {
  __typename?: 'transport_standard_value_aggregate';
  aggregate?: Maybe<Transport_Standard_Value_Aggregate_Fields>;
  nodes: Array<Transport_Standard_Value>;
};

export type Transport_Standard_Value_Aggregate_Bool_Exp = {
  count?: InputMaybe<Transport_Standard_Value_Aggregate_Bool_Exp_Count>;
};

export type Transport_Standard_Value_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Transport_Standard_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "transport_standard_value" */
export type Transport_Standard_Value_Aggregate_Fields = {
  __typename?: 'transport_standard_value_aggregate_fields';
  avg?: Maybe<Transport_Standard_Value_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Transport_Standard_Value_Max_Fields>;
  min?: Maybe<Transport_Standard_Value_Min_Fields>;
  stddev?: Maybe<Transport_Standard_Value_Stddev_Fields>;
  stddev_pop?: Maybe<Transport_Standard_Value_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transport_Standard_Value_Stddev_Samp_Fields>;
  sum?: Maybe<Transport_Standard_Value_Sum_Fields>;
  var_pop?: Maybe<Transport_Standard_Value_Var_Pop_Fields>;
  var_samp?: Maybe<Transport_Standard_Value_Var_Samp_Fields>;
  variance?: Maybe<Transport_Standard_Value_Variance_Fields>;
};


/** aggregate fields of "transport_standard_value" */
export type Transport_Standard_Value_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transport_Standard_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "transport_standard_value" */
export type Transport_Standard_Value_Aggregate_Order_By = {
  avg?: InputMaybe<Transport_Standard_Value_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transport_Standard_Value_Max_Order_By>;
  min?: InputMaybe<Transport_Standard_Value_Min_Order_By>;
  stddev?: InputMaybe<Transport_Standard_Value_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transport_Standard_Value_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transport_Standard_Value_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transport_Standard_Value_Sum_Order_By>;
  var_pop?: InputMaybe<Transport_Standard_Value_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transport_Standard_Value_Var_Samp_Order_By>;
  variance?: InputMaybe<Transport_Standard_Value_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transport_standard_value" */
export type Transport_Standard_Value_Arr_Rel_Insert_Input = {
  data: Array<Transport_Standard_Value_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transport_Standard_Value_On_Conflict>;
};

/** aggregate avg on columns */
export type Transport_Standard_Value_Avg_Fields = {
  __typename?: 'transport_standard_value_avg_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Avg_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transport_standard_value". All fields are combined with a logical 'AND'. */
export type Transport_Standard_Value_Bool_Exp = {
  _and?: InputMaybe<Array<Transport_Standard_Value_Bool_Exp>>;
  _not?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
  _or?: InputMaybe<Array<Transport_Standard_Value_Bool_Exp>>;
  country?: InputMaybe<Country_Enum_Comparison_Exp>;
  denominatorUnit?: InputMaybe<Unit_Bool_Exp>;
  denominatorUnitId?: InputMaybe<Int_Comparison_Exp>;
  emission?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mainGroup?: InputMaybe<String_Comparison_Exp>;
  materialCategoryId?: InputMaybe<String_Comparison_Exp>;
  subGroup?: InputMaybe<String_Comparison_Exp>;
  transportSource?: InputMaybe<TransportSource_Bool_Exp>;
  transportSourceId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "transport_standard_value" */
export enum Transport_Standard_Value_Constraint {
  /** unique or primary key constraint on columns "id" */
  transport_standard_value_pkey = 'transport_standard_value_pkey'
}

/** input type for incrementing numeric columns in table "transport_standard_value" */
export type Transport_Standard_Value_Inc_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "transport_standard_value" */
export type Transport_Standard_Value_Insert_Input = {
  country?: InputMaybe<Country_Enum>;
  denominatorUnit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mainGroup?: InputMaybe<Scalars['String']['input']>;
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  subGroup?: InputMaybe<Scalars['String']['input']>;
  transportSource?: InputMaybe<TransportSource_Obj_Rel_Insert_Input>;
  transportSourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Transport_Standard_Value_Max_Fields = {
  __typename?: 'transport_standard_value_max_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mainGroup?: Maybe<Scalars['String']['output']>;
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  subGroup?: Maybe<Scalars['String']['output']>;
  transportSourceId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Max_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mainGroup?: InputMaybe<Order_By>;
  materialCategoryId?: InputMaybe<Order_By>;
  subGroup?: InputMaybe<Order_By>;
  transportSourceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transport_Standard_Value_Min_Fields = {
  __typename?: 'transport_standard_value_min_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mainGroup?: Maybe<Scalars['String']['output']>;
  materialCategoryId?: Maybe<Scalars['String']['output']>;
  subGroup?: Maybe<Scalars['String']['output']>;
  transportSourceId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Min_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mainGroup?: InputMaybe<Order_By>;
  materialCategoryId?: InputMaybe<Order_By>;
  subGroup?: InputMaybe<Order_By>;
  transportSourceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transport_standard_value" */
export type Transport_Standard_Value_Mutation_Response = {
  __typename?: 'transport_standard_value_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transport_Standard_Value>;
};

/** input type for inserting object relation for remote table "transport_standard_value" */
export type Transport_Standard_Value_Obj_Rel_Insert_Input = {
  data: Transport_Standard_Value_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transport_Standard_Value_On_Conflict>;
};

/** on_conflict condition type for table "transport_standard_value" */
export type Transport_Standard_Value_On_Conflict = {
  constraint: Transport_Standard_Value_Constraint;
  update_columns?: Array<Transport_Standard_Value_Update_Column>;
  where?: InputMaybe<Transport_Standard_Value_Bool_Exp>;
};

/** Ordering options when selecting data from "transport_standard_value". */
export type Transport_Standard_Value_Order_By = {
  country?: InputMaybe<Order_By>;
  denominatorUnit?: InputMaybe<Unit_Order_By>;
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mainGroup?: InputMaybe<Order_By>;
  materialCategoryId?: InputMaybe<Order_By>;
  subGroup?: InputMaybe<Order_By>;
  transportSource?: InputMaybe<TransportSource_Order_By>;
  transportSourceId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transport_standard_value */
export type Transport_Standard_Value_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "transport_standard_value" */
export enum Transport_Standard_Value_Select_Column {
  /** column name */
  country = 'country',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  mainGroup = 'mainGroup',
  /** column name */
  materialCategoryId = 'materialCategoryId',
  /** column name */
  subGroup = 'subGroup',
  /** column name */
  transportSourceId = 'transportSourceId'
}

/** input type for updating data in table "transport_standard_value" */
export type Transport_Standard_Value_Set_Input = {
  country?: InputMaybe<Country_Enum>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mainGroup?: InputMaybe<Scalars['String']['input']>;
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  subGroup?: InputMaybe<Scalars['String']['input']>;
  transportSourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Transport_Standard_Value_Stddev_Fields = {
  __typename?: 'transport_standard_value_stddev_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Stddev_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transport_Standard_Value_Stddev_Pop_Fields = {
  __typename?: 'transport_standard_value_stddev_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Stddev_Pop_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transport_Standard_Value_Stddev_Samp_Fields = {
  __typename?: 'transport_standard_value_stddev_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Stddev_Samp_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transport_standard_value" */
export type Transport_Standard_Value_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transport_Standard_Value_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transport_Standard_Value_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mainGroup?: InputMaybe<Scalars['String']['input']>;
  materialCategoryId?: InputMaybe<Scalars['String']['input']>;
  subGroup?: InputMaybe<Scalars['String']['input']>;
  transportSourceId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Transport_Standard_Value_Sum_Fields = {
  __typename?: 'transport_standard_value_sum_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Sum_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** update columns of table "transport_standard_value" */
export enum Transport_Standard_Value_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  mainGroup = 'mainGroup',
  /** column name */
  materialCategoryId = 'materialCategoryId',
  /** column name */
  subGroup = 'subGroup',
  /** column name */
  transportSourceId = 'transportSourceId'
}

export type Transport_Standard_Value_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transport_Standard_Value_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transport_Standard_Value_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transport_Standard_Value_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transport_Standard_Value_Var_Pop_Fields = {
  __typename?: 'transport_standard_value_var_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Var_Pop_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transport_Standard_Value_Var_Samp_Fields = {
  __typename?: 'transport_standard_value_var_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Var_Samp_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transport_Standard_Value_Variance_Fields = {
  __typename?: 'transport_standard_value_variance_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "transport_standard_value" */
export type Transport_Standard_Value_Variance_Order_By = {
  denominatorUnitId?: InputMaybe<Order_By>;
  emission?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Transport_Stddev_Fields = {
  __typename?: 'transport_stddev_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Transport_Stddev_Pop_Fields = {
  __typename?: 'transport_stddev_pop_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Transport_Stddev_Samp_Fields = {
  __typename?: 'transport_stddev_samp_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "transport" */
export type Transport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transport_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Country_Enum>;
  datasource?: InputMaybe<Scalars['String']['input']>;
  denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['numeric']['input']>;
  distance_unit?: InputMaybe<Distance_Unit_Enum>;
  emission?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  total_denominator_unit_id?: InputMaybe<Scalars['Int']['input']>;
  total_indicator_type_id?: InputMaybe<Scalars['Int']['input']>;
  transportType?: InputMaybe<Transport_Type_Enum>;
};

/** aggregate sum on columns */
export type Transport_Sum_Fields = {
  __typename?: 'transport_sum_fields';
  denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['numeric']['output']>;
  emission?: Maybe<Scalars['numeric']['output']>;
  indicator_type_id?: Maybe<Scalars['Int']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Int']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "transport_type" */
export type Transport_Type = {
  __typename?: 'transport_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "transport_type" */
export type Transport_Type_Aggregate = {
  __typename?: 'transport_type_aggregate';
  aggregate?: Maybe<Transport_Type_Aggregate_Fields>;
  nodes: Array<Transport_Type>;
};

/** aggregate fields of "transport_type" */
export type Transport_Type_Aggregate_Fields = {
  __typename?: 'transport_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Transport_Type_Max_Fields>;
  min?: Maybe<Transport_Type_Min_Fields>;
};


/** aggregate fields of "transport_type" */
export type Transport_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transport_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "transport_type". All fields are combined with a logical 'AND'. */
export type Transport_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Transport_Type_Bool_Exp>>;
  _not?: InputMaybe<Transport_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Transport_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "transport_type" */
export enum Transport_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  transport_type_pkey = 'transport_type_pkey'
}

export enum Transport_Type_Enum {
  Barge = 'Barge',
  BulkCargoShip = 'BulkCargoShip',
  CargoShip = 'CargoShip',
  CoastalShip = 'CoastalShip',
  Custom = 'Custom',
  Train = 'Train',
  Truck = 'Truck',
  Truck1 = 'Truck1',
  Truck2 = 'Truck2',
  Truck3 = 'Truck3',
  TruckTrailer = 'TruckTrailer'
}

/** Boolean expression to compare columns of type "transport_type_enum". All fields are combined with logical 'AND'. */
export type Transport_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Transport_Type_Enum>;
  _in?: InputMaybe<Array<Transport_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Transport_Type_Enum>;
  _nin?: InputMaybe<Array<Transport_Type_Enum>>;
};

/** input type for inserting data into table "transport_type" */
export type Transport_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Transport_Type_Max_Fields = {
  __typename?: 'transport_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Transport_Type_Min_Fields = {
  __typename?: 'transport_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "transport_type" */
export type Transport_Type_Mutation_Response = {
  __typename?: 'transport_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transport_Type>;
};

/** on_conflict condition type for table "transport_type" */
export type Transport_Type_On_Conflict = {
  constraint: Transport_Type_Constraint;
  update_columns?: Array<Transport_Type_Update_Column>;
  where?: InputMaybe<Transport_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "transport_type". */
export type Transport_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transport_type */
export type Transport_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "transport_type" */
export enum Transport_Type_Select_Column {
  /** column name */
  value = 'value'
}

/** input type for updating data in table "transport_type" */
export type Transport_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "transport_type" */
export type Transport_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transport_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transport_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "transport_type" */
export enum Transport_Type_Update_Column {
  /** column name */
  value = 'value'
}

export type Transport_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transport_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transport_Type_Bool_Exp;
};

/** update columns of table "transport" */
export enum Transport_Update_Column {
  /** column name */
  country = 'country',
  /** column name */
  datasource = 'datasource',
  /** column name */
  denominator_unit_id = 'denominator_unit_id',
  /** column name */
  distance = 'distance',
  /** column name */
  distance_unit = 'distance_unit',
  /** column name */
  emission = 'emission',
  /** column name */
  id = 'id',
  /** column name */
  indicator_type_id = 'indicator_type_id',
  /** column name */
  isDefault = 'isDefault',
  /** column name */
  label = 'label',
  /** column name */
  total_denominator_unit_id = 'total_denominator_unit_id',
  /** column name */
  total_indicator_type_id = 'total_indicator_type_id',
  /** column name */
  transportType = 'transportType'
}

export type Transport_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transport_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transport_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transport_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transport_Var_Pop_Fields = {
  __typename?: 'transport_var_pop_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Transport_Var_Samp_Fields = {
  __typename?: 'transport_var_samp_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Transport_Variance_Fields = {
  __typename?: 'transport_variance_fields';
  denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  indicator_type_id?: Maybe<Scalars['Float']['output']>;
  total_denominator_unit_id?: Maybe<Scalars['Float']['output']>;
  total_indicator_type_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "unit" */
export type Unit = {
  __typename?: 'unit';
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  pluralFullName: Scalars['String']['output'];
};

/** aggregated selection of "unit" */
export type Unit_Aggregate = {
  __typename?: 'unit_aggregate';
  aggregate?: Maybe<Unit_Aggregate_Fields>;
  nodes: Array<Unit>;
};

/** aggregate fields of "unit" */
export type Unit_Aggregate_Fields = {
  __typename?: 'unit_aggregate_fields';
  avg?: Maybe<Unit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Unit_Max_Fields>;
  min?: Maybe<Unit_Min_Fields>;
  stddev?: Maybe<Unit_Stddev_Fields>;
  stddev_pop?: Maybe<Unit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unit_Stddev_Samp_Fields>;
  sum?: Maybe<Unit_Sum_Fields>;
  var_pop?: Maybe<Unit_Var_Pop_Fields>;
  var_samp?: Maybe<Unit_Var_Samp_Fields>;
  variance?: Maybe<Unit_Variance_Fields>;
};


/** aggregate fields of "unit" */
export type Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Unit_Avg_Fields = {
  __typename?: 'unit_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "unit". All fields are combined with a logical 'AND'. */
export type Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Bool_Exp>>;
  _not?: InputMaybe<Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Bool_Exp>>;
  fullName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  pluralFullName?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit" */
export enum Unit_Constraint {
  /** unique or primary key constraint on columns "label" */
  unit_label_key = 'unit_label_key',
  /** unique or primary key constraint on columns "id" */
  unit_pkey = 'unit_pkey'
}

/** input type for incrementing numeric columns in table "unit" */
export type Unit_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "unit" */
export type Unit_Insert_Input = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  pluralFullName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Unit_Max_Fields = {
  __typename?: 'unit_max_fields';
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  pluralFullName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Unit_Min_Fields = {
  __typename?: 'unit_min_fields';
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  pluralFullName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "unit" */
export type Unit_Mutation_Response = {
  __typename?: 'unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit>;
};

/** input type for inserting object relation for remote table "unit" */
export type Unit_Obj_Rel_Insert_Input = {
  data: Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};

/** on_conflict condition type for table "unit" */
export type Unit_On_Conflict = {
  constraint: Unit_Constraint;
  update_columns?: Array<Unit_Update_Column>;
  where?: InputMaybe<Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "unit". */
export type Unit_Order_By = {
  fullName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  pluralFullName?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit */
export type Unit_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "unit" */
export enum Unit_Select_Column {
  /** column name */
  fullName = 'fullName',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  pluralFullName = 'pluralFullName'
}

/** input type for updating data in table "unit" */
export type Unit_Set_Input = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  pluralFullName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Unit_Stddev_Fields = {
  __typename?: 'unit_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Unit_Stddev_Pop_Fields = {
  __typename?: 'unit_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Unit_Stddev_Samp_Fields = {
  __typename?: 'unit_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "unit" */
export type Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Stream_Cursor_Value_Input = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  pluralFullName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Unit_Sum_Fields = {
  __typename?: 'unit_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "unit" */
export enum Unit_Update_Column {
  /** column name */
  fullName = 'fullName',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  pluralFullName = 'pluralFullName'
}

export type Unit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unit_Var_Pop_Fields = {
  __typename?: 'unit_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Unit_Var_Samp_Fields = {
  __typename?: 'unit_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Unit_Variance_Fields = {
  __typename?: 'unit_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_material_favorite" */
export type UserMaterialFavorite = {
  __typename?: 'userMaterialFavorite';
  createdAt: Scalars['timestamptz']['output'];
  isConstruction: Scalars['Boolean']['output'];
  materialInternalId: Scalars['uuid']['output'];
  tenantId: Scalars['String']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "user_material_favorite" */
export type UserMaterialFavorite_Aggregate = {
  __typename?: 'userMaterialFavorite_aggregate';
  aggregate?: Maybe<UserMaterialFavorite_Aggregate_Fields>;
  nodes: Array<UserMaterialFavorite>;
};

/** aggregate fields of "user_material_favorite" */
export type UserMaterialFavorite_Aggregate_Fields = {
  __typename?: 'userMaterialFavorite_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserMaterialFavorite_Max_Fields>;
  min?: Maybe<UserMaterialFavorite_Min_Fields>;
};


/** aggregate fields of "user_material_favorite" */
export type UserMaterialFavorite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserMaterialFavorite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_material_favorite". All fields are combined with a logical 'AND'. */
export type UserMaterialFavorite_Bool_Exp = {
  _and?: InputMaybe<Array<UserMaterialFavorite_Bool_Exp>>;
  _not?: InputMaybe<UserMaterialFavorite_Bool_Exp>;
  _or?: InputMaybe<Array<UserMaterialFavorite_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  isConstruction?: InputMaybe<Boolean_Comparison_Exp>;
  materialInternalId?: InputMaybe<Uuid_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_material_favorite" */
export enum UserMaterialFavorite_Constraint {
  /** unique or primary key constraint on columns "user_id", "material_internal_id" */
  user_material_favorite_pkey = 'user_material_favorite_pkey'
}

/** input type for inserting data into table "user_material_favorite" */
export type UserMaterialFavorite_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  isConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  materialInternalId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type UserMaterialFavorite_Max_Fields = {
  __typename?: 'userMaterialFavorite_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  materialInternalId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type UserMaterialFavorite_Min_Fields = {
  __typename?: 'userMaterialFavorite_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  materialInternalId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_material_favorite" */
export type UserMaterialFavorite_Mutation_Response = {
  __typename?: 'userMaterialFavorite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserMaterialFavorite>;
};

/** on_conflict condition type for table "user_material_favorite" */
export type UserMaterialFavorite_On_Conflict = {
  constraint: UserMaterialFavorite_Constraint;
  update_columns?: Array<UserMaterialFavorite_Update_Column>;
  where?: InputMaybe<UserMaterialFavorite_Bool_Exp>;
};

/** Ordering options when selecting data from "user_material_favorite". */
export type UserMaterialFavorite_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  isConstruction?: InputMaybe<Order_By>;
  materialInternalId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_material_favorite */
export type UserMaterialFavorite_Pk_Columns_Input = {
  materialInternalId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "user_material_favorite" */
export enum UserMaterialFavorite_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  isConstruction = 'isConstruction',
  /** column name */
  materialInternalId = 'materialInternalId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "user_material_favorite" */
export type UserMaterialFavorite_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  isConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  materialInternalId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "userMaterialFavorite" */
export type UserMaterialFavorite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserMaterialFavorite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserMaterialFavorite_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  isConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  materialInternalId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_material_favorite" */
export enum UserMaterialFavorite_Update_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  isConstruction = 'isConstruction',
  /** column name */
  materialInternalId = 'materialInternalId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId'
}

export type UserMaterialFavorite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserMaterialFavorite_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserMaterialFavorite_Bool_Exp;
};

/** columns and relationships of "user_platform_review" */
export type UserPlatformReview = {
  __typename?: 'userPlatformReview';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  flowKey: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  score: Scalars['Int']['output'];
  tenantId: Scalars['uuid']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "user_platform_review" */
export type UserPlatformReview_Aggregate = {
  __typename?: 'userPlatformReview_aggregate';
  aggregate?: Maybe<UserPlatformReview_Aggregate_Fields>;
  nodes: Array<UserPlatformReview>;
};

/** aggregate fields of "user_platform_review" */
export type UserPlatformReview_Aggregate_Fields = {
  __typename?: 'userPlatformReview_aggregate_fields';
  avg?: Maybe<UserPlatformReview_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UserPlatformReview_Max_Fields>;
  min?: Maybe<UserPlatformReview_Min_Fields>;
  stddev?: Maybe<UserPlatformReview_Stddev_Fields>;
  stddev_pop?: Maybe<UserPlatformReview_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserPlatformReview_Stddev_Samp_Fields>;
  sum?: Maybe<UserPlatformReview_Sum_Fields>;
  var_pop?: Maybe<UserPlatformReview_Var_Pop_Fields>;
  var_samp?: Maybe<UserPlatformReview_Var_Samp_Fields>;
  variance?: Maybe<UserPlatformReview_Variance_Fields>;
};


/** aggregate fields of "user_platform_review" */
export type UserPlatformReview_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserPlatformReview_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type UserPlatformReview_Avg_Fields = {
  __typename?: 'userPlatformReview_avg_fields';
  score?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_platform_review". All fields are combined with a logical 'AND'. */
export type UserPlatformReview_Bool_Exp = {
  _and?: InputMaybe<Array<UserPlatformReview_Bool_Exp>>;
  _not?: InputMaybe<UserPlatformReview_Bool_Exp>;
  _or?: InputMaybe<Array<UserPlatformReview_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  flowKey?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  score?: InputMaybe<Int_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_platform_review" */
export enum UserPlatformReview_Constraint {
  /** unique or primary key constraint on columns "id" */
  user_platform_review_pkey = 'user_platform_review_pkey'
}

/** input type for incrementing numeric columns in table "user_platform_review" */
export type UserPlatformReview_Inc_Input = {
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_platform_review" */
export type UserPlatformReview_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  flowKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type UserPlatformReview_Max_Fields = {
  __typename?: 'userPlatformReview_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  flowKey?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type UserPlatformReview_Min_Fields = {
  __typename?: 'userPlatformReview_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  flowKey?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_platform_review" */
export type UserPlatformReview_Mutation_Response = {
  __typename?: 'userPlatformReview_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPlatformReview>;
};

/** on_conflict condition type for table "user_platform_review" */
export type UserPlatformReview_On_Conflict = {
  constraint: UserPlatformReview_Constraint;
  update_columns?: Array<UserPlatformReview_Update_Column>;
  where?: InputMaybe<UserPlatformReview_Bool_Exp>;
};

/** Ordering options when selecting data from "user_platform_review". */
export type UserPlatformReview_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  flowKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_platform_review */
export type UserPlatformReview_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_platform_review" */
export enum UserPlatformReview_Select_Column {
  /** column name */
  comment = 'comment',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  flowKey = 'flowKey',
  /** column name */
  id = 'id',
  /** column name */
  score = 'score',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "user_platform_review" */
export type UserPlatformReview_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  flowKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type UserPlatformReview_Stddev_Fields = {
  __typename?: 'userPlatformReview_stddev_fields';
  score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type UserPlatformReview_Stddev_Pop_Fields = {
  __typename?: 'userPlatformReview_stddev_pop_fields';
  score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type UserPlatformReview_Stddev_Samp_Fields = {
  __typename?: 'userPlatformReview_stddev_samp_fields';
  score?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "userPlatformReview" */
export type UserPlatformReview_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserPlatformReview_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlatformReview_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  flowKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type UserPlatformReview_Sum_Fields = {
  __typename?: 'userPlatformReview_sum_fields';
  score?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "user_platform_review" */
export enum UserPlatformReview_Update_Column {
  /** column name */
  comment = 'comment',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  flowKey = 'flowKey',
  /** column name */
  id = 'id',
  /** column name */
  score = 'score',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId'
}

export type UserPlatformReview_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserPlatformReview_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPlatformReview_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserPlatformReview_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserPlatformReview_Var_Pop_Fields = {
  __typename?: 'userPlatformReview_var_pop_fields';
  score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type UserPlatformReview_Var_Samp_Fields = {
  __typename?: 'userPlatformReview_var_samp_fields';
  score?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type UserPlatformReview_Variance_Fields = {
  __typename?: 'userPlatformReview_variance_fields';
  score?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_project_view" */
export type UserProjectView = {
  __typename?: 'userProjectView';
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  tenantId: Scalars['uuid']['output'];
  userId: Scalars['uuid']['output'];
  viewedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "user_project_view" */
export type UserProjectView_Aggregate = {
  __typename?: 'userProjectView_aggregate';
  aggregate?: Maybe<UserProjectView_Aggregate_Fields>;
  nodes: Array<UserProjectView>;
};

/** aggregate fields of "user_project_view" */
export type UserProjectView_Aggregate_Fields = {
  __typename?: 'userProjectView_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserProjectView_Max_Fields>;
  min?: Maybe<UserProjectView_Min_Fields>;
};


/** aggregate fields of "user_project_view" */
export type UserProjectView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserProjectView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_project_view". All fields are combined with a logical 'AND'. */
export type UserProjectView_Bool_Exp = {
  _and?: InputMaybe<Array<UserProjectView_Bool_Exp>>;
  _not?: InputMaybe<UserProjectView_Bool_Exp>;
  _or?: InputMaybe<Array<UserProjectView_Bool_Exp>>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  viewedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_project_view" */
export enum UserProjectView_Constraint {
  /** unique or primary key constraint on columns "user_id", "project_id", "tenant_id" */
  user_project_view_pkey = 'user_project_view_pkey'
}

/** input type for inserting data into table "user_project_view" */
export type UserProjectView_Insert_Input = {
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type UserProjectView_Max_Fields = {
  __typename?: 'userProjectView_max_fields';
  projectId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  viewedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type UserProjectView_Min_Fields = {
  __typename?: 'userProjectView_min_fields';
  projectId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  viewedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "user_project_view" */
export type UserProjectView_Mutation_Response = {
  __typename?: 'userProjectView_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserProjectView>;
};

/** on_conflict condition type for table "user_project_view" */
export type UserProjectView_On_Conflict = {
  constraint: UserProjectView_Constraint;
  update_columns?: Array<UserProjectView_Update_Column>;
  where?: InputMaybe<UserProjectView_Bool_Exp>;
};

/** Ordering options when selecting data from "user_project_view". */
export type UserProjectView_Order_By = {
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_project_view */
export type UserProjectView_Pk_Columns_Input = {
  projectId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "user_project_view" */
export enum UserProjectView_Select_Column {
  /** column name */
  projectId = 'projectId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId',
  /** column name */
  viewedAt = 'viewedAt'
}

/** input type for updating data in table "user_project_view" */
export type UserProjectView_Set_Input = {
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "userProjectView" */
export type UserProjectView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserProjectView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserProjectView_Stream_Cursor_Value_Input = {
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "user_project_view" */
export enum UserProjectView_Update_Column {
  /** column name */
  projectId = 'projectId',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId',
  /** column name */
  viewedAt = 'viewedAt'
}

export type UserProjectView_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserProjectView_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserProjectView_Bool_Exp;
};

/** columns and relationships of "user_tutorial_view" */
export type UserTutorialView = {
  __typename?: 'userTutorialView';
  externalId: Scalars['String']['output'];
  userId: Scalars['uuid']['output'];
  viewedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "user_tutorial_view" */
export type UserTutorialView_Aggregate = {
  __typename?: 'userTutorialView_aggregate';
  aggregate?: Maybe<UserTutorialView_Aggregate_Fields>;
  nodes: Array<UserTutorialView>;
};

/** aggregate fields of "user_tutorial_view" */
export type UserTutorialView_Aggregate_Fields = {
  __typename?: 'userTutorialView_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserTutorialView_Max_Fields>;
  min?: Maybe<UserTutorialView_Min_Fields>;
};


/** aggregate fields of "user_tutorial_view" */
export type UserTutorialView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserTutorialView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_tutorial_view". All fields are combined with a logical 'AND'. */
export type UserTutorialView_Bool_Exp = {
  _and?: InputMaybe<Array<UserTutorialView_Bool_Exp>>;
  _not?: InputMaybe<UserTutorialView_Bool_Exp>;
  _or?: InputMaybe<Array<UserTutorialView_Bool_Exp>>;
  externalId?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  viewedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_tutorial_view" */
export enum UserTutorialView_Constraint {
  /** unique or primary key constraint on columns "user_id", "external_id" */
  user_tutorial_view_pkey = 'user_tutorial_view_pkey'
}

/** input type for inserting data into table "user_tutorial_view" */
export type UserTutorialView_Insert_Input = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type UserTutorialView_Max_Fields = {
  __typename?: 'userTutorialView_max_fields';
  externalId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  viewedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type UserTutorialView_Min_Fields = {
  __typename?: 'userTutorialView_min_fields';
  externalId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  viewedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "user_tutorial_view" */
export type UserTutorialView_Mutation_Response = {
  __typename?: 'userTutorialView_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserTutorialView>;
};

/** on_conflict condition type for table "user_tutorial_view" */
export type UserTutorialView_On_Conflict = {
  constraint: UserTutorialView_Constraint;
  update_columns?: Array<UserTutorialView_Update_Column>;
  where?: InputMaybe<UserTutorialView_Bool_Exp>;
};

/** Ordering options when selecting data from "user_tutorial_view". */
export type UserTutorialView_Order_By = {
  externalId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_tutorial_view */
export type UserTutorialView_Pk_Columns_Input = {
  externalId: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "user_tutorial_view" */
export enum UserTutorialView_Select_Column {
  /** column name */
  externalId = 'externalId',
  /** column name */
  userId = 'userId',
  /** column name */
  viewedAt = 'viewedAt'
}

/** input type for updating data in table "user_tutorial_view" */
export type UserTutorialView_Set_Input = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "userTutorialView" */
export type UserTutorialView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserTutorialView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserTutorialView_Stream_Cursor_Value_Input = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "user_tutorial_view" */
export enum UserTutorialView_Update_Column {
  /** column name */
  externalId = 'externalId',
  /** column name */
  userId = 'userId',
  /** column name */
  viewedAt = 'viewedAt'
}

export type UserTutorialView_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserTutorialView_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserTutorialView_Bool_Exp;
};

/** columns and relationships of "user_welcome_flow" */
export type UserWelcomeFlow = {
  __typename?: 'userWelcomeFlow';
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  flowKey: Scalars['String']['output'];
  seenAt: Scalars['timestamptz']['output'];
  tenantId: Scalars['uuid']['output'];
  userId: Scalars['uuid']['output'];
  variant: Scalars['String']['output'];
};

/** columns and relationships of "user_welcome_flow_event" */
export type UserWelcomeFlowEvent = {
  __typename?: 'userWelcomeFlowEvent';
  createdAt: Scalars['timestamptz']['output'];
  event: Scalars['String']['output'];
  flowKey: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  stepIndex?: Maybe<Scalars['Int']['output']>;
  stepKey?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['uuid']['output'];
  userId: Scalars['uuid']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_welcome_flow_event" */
export type UserWelcomeFlowEvent_Aggregate = {
  __typename?: 'userWelcomeFlowEvent_aggregate';
  aggregate?: Maybe<UserWelcomeFlowEvent_Aggregate_Fields>;
  nodes: Array<UserWelcomeFlowEvent>;
};

/** aggregate fields of "user_welcome_flow_event" */
export type UserWelcomeFlowEvent_Aggregate_Fields = {
  __typename?: 'userWelcomeFlowEvent_aggregate_fields';
  avg?: Maybe<UserWelcomeFlowEvent_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UserWelcomeFlowEvent_Max_Fields>;
  min?: Maybe<UserWelcomeFlowEvent_Min_Fields>;
  stddev?: Maybe<UserWelcomeFlowEvent_Stddev_Fields>;
  stddev_pop?: Maybe<UserWelcomeFlowEvent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserWelcomeFlowEvent_Stddev_Samp_Fields>;
  sum?: Maybe<UserWelcomeFlowEvent_Sum_Fields>;
  var_pop?: Maybe<UserWelcomeFlowEvent_Var_Pop_Fields>;
  var_samp?: Maybe<UserWelcomeFlowEvent_Var_Samp_Fields>;
  variance?: Maybe<UserWelcomeFlowEvent_Variance_Fields>;
};


/** aggregate fields of "user_welcome_flow_event" */
export type UserWelcomeFlowEvent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserWelcomeFlowEvent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type UserWelcomeFlowEvent_Avg_Fields = {
  __typename?: 'userWelcomeFlowEvent_avg_fields';
  stepIndex?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_welcome_flow_event". All fields are combined with a logical 'AND'. */
export type UserWelcomeFlowEvent_Bool_Exp = {
  _and?: InputMaybe<Array<UserWelcomeFlowEvent_Bool_Exp>>;
  _not?: InputMaybe<UserWelcomeFlowEvent_Bool_Exp>;
  _or?: InputMaybe<Array<UserWelcomeFlowEvent_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<String_Comparison_Exp>;
  flowKey?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  stepIndex?: InputMaybe<Int_Comparison_Exp>;
  stepKey?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  variant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_welcome_flow_event" */
export enum UserWelcomeFlowEvent_Constraint {
  /** unique or primary key constraint on columns "id" */
  user_welcome_flow_event_pkey = 'user_welcome_flow_event_pkey'
}

/** input type for incrementing numeric columns in table "user_welcome_flow_event" */
export type UserWelcomeFlowEvent_Inc_Input = {
  stepIndex?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_welcome_flow_event" */
export type UserWelcomeFlowEvent_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  flowKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stepIndex?: InputMaybe<Scalars['Int']['input']>;
  stepKey?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type UserWelcomeFlowEvent_Max_Fields = {
  __typename?: 'userWelcomeFlowEvent_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  flowKey?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stepIndex?: Maybe<Scalars['Int']['output']>;
  stepKey?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserWelcomeFlowEvent_Min_Fields = {
  __typename?: 'userWelcomeFlowEvent_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  flowKey?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stepIndex?: Maybe<Scalars['Int']['output']>;
  stepKey?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_welcome_flow_event" */
export type UserWelcomeFlowEvent_Mutation_Response = {
  __typename?: 'userWelcomeFlowEvent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserWelcomeFlowEvent>;
};

/** on_conflict condition type for table "user_welcome_flow_event" */
export type UserWelcomeFlowEvent_On_Conflict = {
  constraint: UserWelcomeFlowEvent_Constraint;
  update_columns?: Array<UserWelcomeFlowEvent_Update_Column>;
  where?: InputMaybe<UserWelcomeFlowEvent_Bool_Exp>;
};

/** Ordering options when selecting data from "user_welcome_flow_event". */
export type UserWelcomeFlowEvent_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  event?: InputMaybe<Order_By>;
  flowKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stepIndex?: InputMaybe<Order_By>;
  stepKey?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  variant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_welcome_flow_event */
export type UserWelcomeFlowEvent_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_welcome_flow_event" */
export enum UserWelcomeFlowEvent_Select_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  event = 'event',
  /** column name */
  flowKey = 'flowKey',
  /** column name */
  id = 'id',
  /** column name */
  stepIndex = 'stepIndex',
  /** column name */
  stepKey = 'stepKey',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId',
  /** column name */
  variant = 'variant'
}

/** input type for updating data in table "user_welcome_flow_event" */
export type UserWelcomeFlowEvent_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  flowKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stepIndex?: InputMaybe<Scalars['Int']['input']>;
  stepKey?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type UserWelcomeFlowEvent_Stddev_Fields = {
  __typename?: 'userWelcomeFlowEvent_stddev_fields';
  stepIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type UserWelcomeFlowEvent_Stddev_Pop_Fields = {
  __typename?: 'userWelcomeFlowEvent_stddev_pop_fields';
  stepIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type UserWelcomeFlowEvent_Stddev_Samp_Fields = {
  __typename?: 'userWelcomeFlowEvent_stddev_samp_fields';
  stepIndex?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "userWelcomeFlowEvent" */
export type UserWelcomeFlowEvent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserWelcomeFlowEvent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserWelcomeFlowEvent_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  flowKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stepIndex?: InputMaybe<Scalars['Int']['input']>;
  stepKey?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type UserWelcomeFlowEvent_Sum_Fields = {
  __typename?: 'userWelcomeFlowEvent_sum_fields';
  stepIndex?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "user_welcome_flow_event" */
export enum UserWelcomeFlowEvent_Update_Column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  event = 'event',
  /** column name */
  flowKey = 'flowKey',
  /** column name */
  id = 'id',
  /** column name */
  stepIndex = 'stepIndex',
  /** column name */
  stepKey = 'stepKey',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId',
  /** column name */
  variant = 'variant'
}

export type UserWelcomeFlowEvent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserWelcomeFlowEvent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserWelcomeFlowEvent_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserWelcomeFlowEvent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserWelcomeFlowEvent_Var_Pop_Fields = {
  __typename?: 'userWelcomeFlowEvent_var_pop_fields';
  stepIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type UserWelcomeFlowEvent_Var_Samp_Fields = {
  __typename?: 'userWelcomeFlowEvent_var_samp_fields';
  stepIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type UserWelcomeFlowEvent_Variance_Fields = {
  __typename?: 'userWelcomeFlowEvent_variance_fields';
  stepIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "user_welcome_flow" */
export type UserWelcomeFlow_Aggregate = {
  __typename?: 'userWelcomeFlow_aggregate';
  aggregate?: Maybe<UserWelcomeFlow_Aggregate_Fields>;
  nodes: Array<UserWelcomeFlow>;
};

/** aggregate fields of "user_welcome_flow" */
export type UserWelcomeFlow_Aggregate_Fields = {
  __typename?: 'userWelcomeFlow_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserWelcomeFlow_Max_Fields>;
  min?: Maybe<UserWelcomeFlow_Min_Fields>;
};


/** aggregate fields of "user_welcome_flow" */
export type UserWelcomeFlow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserWelcomeFlow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_welcome_flow". All fields are combined with a logical 'AND'. */
export type UserWelcomeFlow_Bool_Exp = {
  _and?: InputMaybe<Array<UserWelcomeFlow_Bool_Exp>>;
  _not?: InputMaybe<UserWelcomeFlow_Bool_Exp>;
  _or?: InputMaybe<Array<UserWelcomeFlow_Bool_Exp>>;
  completedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  flowKey?: InputMaybe<String_Comparison_Exp>;
  seenAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  variant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_welcome_flow" */
export enum UserWelcomeFlow_Constraint {
  /** unique or primary key constraint on columns "user_id", "flow_key" */
  user_welcome_flow_pkey = 'user_welcome_flow_pkey'
}

/** input type for inserting data into table "user_welcome_flow" */
export type UserWelcomeFlow_Insert_Input = {
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  flowKey?: InputMaybe<Scalars['String']['input']>;
  seenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type UserWelcomeFlow_Max_Fields = {
  __typename?: 'userWelcomeFlow_max_fields';
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  flowKey?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['timestamptz']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserWelcomeFlow_Min_Fields = {
  __typename?: 'userWelcomeFlow_min_fields';
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  flowKey?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['timestamptz']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_welcome_flow" */
export type UserWelcomeFlow_Mutation_Response = {
  __typename?: 'userWelcomeFlow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserWelcomeFlow>;
};

/** on_conflict condition type for table "user_welcome_flow" */
export type UserWelcomeFlow_On_Conflict = {
  constraint: UserWelcomeFlow_Constraint;
  update_columns?: Array<UserWelcomeFlow_Update_Column>;
  where?: InputMaybe<UserWelcomeFlow_Bool_Exp>;
};

/** Ordering options when selecting data from "user_welcome_flow". */
export type UserWelcomeFlow_Order_By = {
  completedAt?: InputMaybe<Order_By>;
  flowKey?: InputMaybe<Order_By>;
  seenAt?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  variant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_welcome_flow */
export type UserWelcomeFlow_Pk_Columns_Input = {
  flowKey: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "user_welcome_flow" */
export enum UserWelcomeFlow_Select_Column {
  /** column name */
  completedAt = 'completedAt',
  /** column name */
  flowKey = 'flowKey',
  /** column name */
  seenAt = 'seenAt',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId',
  /** column name */
  variant = 'variant'
}

/** input type for updating data in table "user_welcome_flow" */
export type UserWelcomeFlow_Set_Input = {
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  flowKey?: InputMaybe<Scalars['String']['input']>;
  seenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "userWelcomeFlow" */
export type UserWelcomeFlow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserWelcomeFlow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserWelcomeFlow_Stream_Cursor_Value_Input = {
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  flowKey?: InputMaybe<Scalars['String']['input']>;
  seenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_welcome_flow" */
export enum UserWelcomeFlow_Update_Column {
  /** column name */
  completedAt = 'completedAt',
  /** column name */
  flowKey = 'flowKey',
  /** column name */
  seenAt = 'seenAt',
  /** column name */
  tenantId = 'tenantId',
  /** column name */
  userId = 'userId',
  /** column name */
  variant = 'variant'
}

export type UserWelcomeFlow_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserWelcomeFlow_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserWelcomeFlow_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "v_latest_snapshot" */
export type VLatestSnapshot = {
  __typename?: 'vLatestSnapshot';
  /** An object relationship */
  snapshot?: Maybe<BenchmarkSnapshot>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "v_latest_snapshot" */
export type VLatestSnapshot_Aggregate = {
  __typename?: 'vLatestSnapshot_aggregate';
  aggregate?: Maybe<VLatestSnapshot_Aggregate_Fields>;
  nodes: Array<VLatestSnapshot>;
};

/** aggregate fields of "v_latest_snapshot" */
export type VLatestSnapshot_Aggregate_Fields = {
  __typename?: 'vLatestSnapshot_aggregate_fields';
  avg?: Maybe<VLatestSnapshot_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<VLatestSnapshot_Max_Fields>;
  min?: Maybe<VLatestSnapshot_Min_Fields>;
  stddev?: Maybe<VLatestSnapshot_Stddev_Fields>;
  stddev_pop?: Maybe<VLatestSnapshot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VLatestSnapshot_Stddev_Samp_Fields>;
  sum?: Maybe<VLatestSnapshot_Sum_Fields>;
  var_pop?: Maybe<VLatestSnapshot_Var_Pop_Fields>;
  var_samp?: Maybe<VLatestSnapshot_Var_Samp_Fields>;
  variance?: Maybe<VLatestSnapshot_Variance_Fields>;
};


/** aggregate fields of "v_latest_snapshot" */
export type VLatestSnapshot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<VLatestSnapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type VLatestSnapshot_Avg_Fields = {
  __typename?: 'vLatestSnapshot_avg_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "v_latest_snapshot". All fields are combined with a logical 'AND'. */
export type VLatestSnapshot_Bool_Exp = {
  _and?: InputMaybe<Array<VLatestSnapshot_Bool_Exp>>;
  _not?: InputMaybe<VLatestSnapshot_Bool_Exp>;
  _or?: InputMaybe<Array<VLatestSnapshot_Bool_Exp>>;
  snapshot?: InputMaybe<BenchmarkSnapshot_Bool_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type VLatestSnapshot_Max_Fields = {
  __typename?: 'vLatestSnapshot_max_fields';
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type VLatestSnapshot_Min_Fields = {
  __typename?: 'vLatestSnapshot_min_fields';
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "v_latest_snapshot". */
export type VLatestSnapshot_Order_By = {
  snapshot?: InputMaybe<BenchmarkSnapshot_Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** select columns of table "v_latest_snapshot" */
export enum VLatestSnapshot_Select_Column {
  /** column name */
  snapshotId = 'snapshotId'
}

/** aggregate stddev on columns */
export type VLatestSnapshot_Stddev_Fields = {
  __typename?: 'vLatestSnapshot_stddev_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type VLatestSnapshot_Stddev_Pop_Fields = {
  __typename?: 'vLatestSnapshot_stddev_pop_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type VLatestSnapshot_Stddev_Samp_Fields = {
  __typename?: 'vLatestSnapshot_stddev_samp_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vLatestSnapshot" */
export type VLatestSnapshot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: VLatestSnapshot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type VLatestSnapshot_Stream_Cursor_Value_Input = {
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type VLatestSnapshot_Sum_Fields = {
  __typename?: 'vLatestSnapshot_sum_fields';
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type VLatestSnapshot_Var_Pop_Fields = {
  __typename?: 'vLatestSnapshot_var_pop_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type VLatestSnapshot_Var_Samp_Fields = {
  __typename?: 'vLatestSnapshot_var_samp_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type VLatestSnapshot_Variance_Fields = {
  __typename?: 'vLatestSnapshot_variance_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "v_material_current" */
export type VMaterialCurrent = {
  __typename?: 'vMaterialCurrent';
  bimFamily?: Maybe<Scalars['String']['output']>;
  bimProperties?: Maybe<Scalars['jsonb']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  classBuildingPart?: Maybe<Scalars['String']['output']>;
  classCode?: Maybe<Scalars['String']['output']>;
  classCodeId?: Maybe<Scalars['Int']['output']>;
  classLabel?: Maybe<Scalars['String']['output']>;
  classLevel1Code?: Maybe<Scalars['String']['output']>;
  classPath?: Maybe<Array<Scalars['String']['output']>>;
  classSystem?: Maybe<Scalars['String']['output']>;
  classificationConflicts?: Maybe<Scalars['jsonb']['output']>;
  classifications?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doubleCountRisk?: Maybe<Scalars['Boolean']['output']>;
  epdDatasources?: Maybe<Array<Scalars['String']['output']>>;
  epdDeclarationOwner?: Maybe<Scalars['String']['output']>;
  epdDeclaredUnit?: Maybe<Scalars['String']['output']>;
  epdDeclaredValue?: Maybe<Scalars['float8']['output']>;
  epdDeprecated?: Maybe<Scalars['Boolean']['output']>;
  epdExpectedLife?: Maybe<Scalars['Int']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Int']['output']>;
  epdFaulty?: Maybe<Scalars['Boolean']['output']>;
  epdId?: Maybe<Scalars['uuid']['output']>;
  epdInternalId?: Maybe<Scalars['uuid']['output']>;
  epdIsConstruction?: Maybe<Scalars['Boolean']['output']>;
  epdIsCustom?: Maybe<Scalars['Boolean']['output']>;
  epdMass?: Maybe<Scalars['float8']['output']>;
  epdMassUnit?: Maybe<Scalars['String']['output']>;
  epdMaterialCategory?: Maybe<Scalars['String']['output']>;
  epdName?: Maybe<Scalars['String']['output']>;
  epdNewestVersion?: Maybe<Scalars['Boolean']['output']>;
  epdStandard?: Maybe<Scalars['String']['output']>;
  epdType?: Maybe<Scalars['String']['output']>;
  epdVersion?: Maybe<Scalars['String']['output']>;
  epdVersionNumber?: Maybe<Scalars['Int']['output']>;
  excludedReason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  gwp?: Maybe<VMaterialGwp>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  includeMapping?: Maybe<Scalars['Boolean']['output']>;
  isAutoMapping?: Maybe<Scalars['Boolean']['output']>;
  isMapped?: Maybe<Scalars['Boolean']['output']>;
  isRecycled?: Maybe<Scalars['Boolean']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  lifetimeYears?: Maybe<Scalars['Int']['output']>;
  mappingFactor?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  material?: Maybe<BenchmarkInventoryMaterial>;
  materialCount?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialIdentifier?: Maybe<Scalars['String']['output']>;
  materialSource?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  moduleStatus?: Maybe<Scalars['jsonb']['output']>;
  normArea?: Maybe<Scalars['float8']['output']>;
  normPeriod?: Maybe<Scalars['Int']['output']>;
  numberOfReplacements?: Maybe<Scalars['Int']['output']>;
  originalCaptured?: Maybe<Scalars['Boolean']['output']>;
  originalQuantities?: Maybe<Scalars['jsonb']['output']>;
  preferredUnit?: Maybe<Scalars['String']['output']>;
  preferredValue?: Maybe<Scalars['float8']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  projectState?: Maybe<BenchmarkProjectState>;
  provenanceChanges?: Maybe<Scalars['jsonb']['output']>;
  quantities?: Maybe<Scalars['jsonb']['output']>;
  rowKind?: Maybe<Scalars['String']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  sourceChanged?: Maybe<Scalars['Boolean']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  status?: Maybe<VMaterialStatus>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  transportSources?: Maybe<Array<Scalars['String']['output']>>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
  typeMappedKinds?: Maybe<Array<Scalars['String']['output']>>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
  unrecognisedParams?: Maybe<Scalars['jsonb']['output']>;
  valueChanged?: Maybe<Scalars['Boolean']['output']>;
  wastePercentage?: Maybe<Scalars['float8']['output']>;
  weightKg?: Maybe<Scalars['float8']['output']>;
};


/** columns and relationships of "v_material_current" */
export type VMaterialCurrentBimPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "v_material_current" */
export type VMaterialCurrentClassificationConflictsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "v_material_current" */
export type VMaterialCurrentClassificationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "v_material_current" */
export type VMaterialCurrentModuleStatusArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "v_material_current" */
export type VMaterialCurrentOriginalQuantitiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "v_material_current" */
export type VMaterialCurrentProvenanceChangesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "v_material_current" */
export type VMaterialCurrentQuantitiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "v_material_current" */
export type VMaterialCurrentUnrecognisedParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "v_material_current" */
export type VMaterialCurrent_Aggregate = {
  __typename?: 'vMaterialCurrent_aggregate';
  aggregate?: Maybe<VMaterialCurrent_Aggregate_Fields>;
  nodes: Array<VMaterialCurrent>;
};

/** aggregate fields of "v_material_current" */
export type VMaterialCurrent_Aggregate_Fields = {
  __typename?: 'vMaterialCurrent_aggregate_fields';
  avg?: Maybe<VMaterialCurrent_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<VMaterialCurrent_Max_Fields>;
  min?: Maybe<VMaterialCurrent_Min_Fields>;
  stddev?: Maybe<VMaterialCurrent_Stddev_Fields>;
  stddev_pop?: Maybe<VMaterialCurrent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VMaterialCurrent_Stddev_Samp_Fields>;
  sum?: Maybe<VMaterialCurrent_Sum_Fields>;
  var_pop?: Maybe<VMaterialCurrent_Var_Pop_Fields>;
  var_samp?: Maybe<VMaterialCurrent_Var_Samp_Fields>;
  variance?: Maybe<VMaterialCurrent_Variance_Fields>;
};


/** aggregate fields of "v_material_current" */
export type VMaterialCurrent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<VMaterialCurrent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type VMaterialCurrent_Avg_Fields = {
  __typename?: 'vMaterialCurrent_avg_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "v_material_current". All fields are combined with a logical 'AND'. */
export type VMaterialCurrent_Bool_Exp = {
  _and?: InputMaybe<Array<VMaterialCurrent_Bool_Exp>>;
  _not?: InputMaybe<VMaterialCurrent_Bool_Exp>;
  _or?: InputMaybe<Array<VMaterialCurrent_Bool_Exp>>;
  bimFamily?: InputMaybe<String_Comparison_Exp>;
  bimProperties?: InputMaybe<Jsonb_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  classBuildingPart?: InputMaybe<String_Comparison_Exp>;
  classCode?: InputMaybe<String_Comparison_Exp>;
  classCodeId?: InputMaybe<Int_Comparison_Exp>;
  classLabel?: InputMaybe<String_Comparison_Exp>;
  classLevel1Code?: InputMaybe<String_Comparison_Exp>;
  classPath?: InputMaybe<String_Array_Comparison_Exp>;
  classSystem?: InputMaybe<String_Comparison_Exp>;
  classificationConflicts?: InputMaybe<Jsonb_Comparison_Exp>;
  classifications?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  doubleCountRisk?: InputMaybe<Boolean_Comparison_Exp>;
  epdDatasources?: InputMaybe<String_Array_Comparison_Exp>;
  epdDeclarationOwner?: InputMaybe<String_Comparison_Exp>;
  epdDeclaredUnit?: InputMaybe<String_Comparison_Exp>;
  epdDeclaredValue?: InputMaybe<Float8_Comparison_Exp>;
  epdDeprecated?: InputMaybe<Boolean_Comparison_Exp>;
  epdExpectedLife?: InputMaybe<Int_Comparison_Exp>;
  epdExpectedLifespan?: InputMaybe<Int_Comparison_Exp>;
  epdFaulty?: InputMaybe<Boolean_Comparison_Exp>;
  epdId?: InputMaybe<Uuid_Comparison_Exp>;
  epdInternalId?: InputMaybe<Uuid_Comparison_Exp>;
  epdIsConstruction?: InputMaybe<Boolean_Comparison_Exp>;
  epdIsCustom?: InputMaybe<Boolean_Comparison_Exp>;
  epdMass?: InputMaybe<Float8_Comparison_Exp>;
  epdMassUnit?: InputMaybe<String_Comparison_Exp>;
  epdMaterialCategory?: InputMaybe<String_Comparison_Exp>;
  epdName?: InputMaybe<String_Comparison_Exp>;
  epdNewestVersion?: InputMaybe<Boolean_Comparison_Exp>;
  epdStandard?: InputMaybe<String_Comparison_Exp>;
  epdType?: InputMaybe<String_Comparison_Exp>;
  epdVersion?: InputMaybe<String_Comparison_Exp>;
  epdVersionNumber?: InputMaybe<Int_Comparison_Exp>;
  excludedReason?: InputMaybe<String_Comparison_Exp>;
  gwp?: InputMaybe<VMaterialGwp_Bool_Exp>;
  gwpA1a3?: InputMaybe<Float8_Comparison_Exp>;
  gwpA4?: InputMaybe<Float8_Comparison_Exp>;
  gwpA5?: InputMaybe<Float8_Comparison_Exp>;
  gwpB1?: InputMaybe<Float8_Comparison_Exp>;
  gwpB2?: InputMaybe<Float8_Comparison_Exp>;
  gwpB3?: InputMaybe<Float8_Comparison_Exp>;
  gwpB4?: InputMaybe<Float8_Comparison_Exp>;
  gwpB5?: InputMaybe<Float8_Comparison_Exp>;
  gwpB6?: InputMaybe<Float8_Comparison_Exp>;
  gwpB7?: InputMaybe<Float8_Comparison_Exp>;
  gwpC1?: InputMaybe<Float8_Comparison_Exp>;
  gwpC2?: InputMaybe<Float8_Comparison_Exp>;
  gwpC3?: InputMaybe<Float8_Comparison_Exp>;
  gwpC4?: InputMaybe<Float8_Comparison_Exp>;
  gwpD?: InputMaybe<Float8_Comparison_Exp>;
  includeMapping?: InputMaybe<Boolean_Comparison_Exp>;
  isAutoMapping?: InputMaybe<Boolean_Comparison_Exp>;
  isMapped?: InputMaybe<Boolean_Comparison_Exp>;
  isRecycled?: InputMaybe<Boolean_Comparison_Exp>;
  lifetimeOffset?: InputMaybe<Int_Comparison_Exp>;
  lifetimeYears?: InputMaybe<Int_Comparison_Exp>;
  mappingFactor?: InputMaybe<Float8_Comparison_Exp>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  materialCount?: InputMaybe<Int_Comparison_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  materialIdentifier?: InputMaybe<String_Comparison_Exp>;
  materialSource?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  moduleStatus?: InputMaybe<Jsonb_Comparison_Exp>;
  normArea?: InputMaybe<Float8_Comparison_Exp>;
  normPeriod?: InputMaybe<Int_Comparison_Exp>;
  numberOfReplacements?: InputMaybe<Int_Comparison_Exp>;
  originalCaptured?: InputMaybe<Boolean_Comparison_Exp>;
  originalQuantities?: InputMaybe<Jsonb_Comparison_Exp>;
  preferredUnit?: InputMaybe<String_Comparison_Exp>;
  preferredValue?: InputMaybe<Float8_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  projectState?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  provenanceChanges?: InputMaybe<Jsonb_Comparison_Exp>;
  quantities?: InputMaybe<Jsonb_Comparison_Exp>;
  rowKind?: InputMaybe<String_Comparison_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
  sourceChanged?: InputMaybe<Boolean_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<VMaterialStatus_Bool_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  transportSources?: InputMaybe<String_Array_Comparison_Exp>;
  typeIdentifier?: InputMaybe<String_Comparison_Exp>;
  typeMappedKinds?: InputMaybe<String_Array_Comparison_Exp>;
  typeMaterialIdentifier?: InputMaybe<String_Comparison_Exp>;
  unrecognisedParams?: InputMaybe<Jsonb_Comparison_Exp>;
  valueChanged?: InputMaybe<Boolean_Comparison_Exp>;
  wastePercentage?: InputMaybe<Float8_Comparison_Exp>;
  weightKg?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type VMaterialCurrent_Max_Fields = {
  __typename?: 'vMaterialCurrent_max_fields';
  bimFamily?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  classBuildingPart?: Maybe<Scalars['String']['output']>;
  classCode?: Maybe<Scalars['String']['output']>;
  classCodeId?: Maybe<Scalars['Int']['output']>;
  classLabel?: Maybe<Scalars['String']['output']>;
  classLevel1Code?: Maybe<Scalars['String']['output']>;
  classPath?: Maybe<Array<Scalars['String']['output']>>;
  classSystem?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  epdDatasources?: Maybe<Array<Scalars['String']['output']>>;
  epdDeclarationOwner?: Maybe<Scalars['String']['output']>;
  epdDeclaredUnit?: Maybe<Scalars['String']['output']>;
  epdDeclaredValue?: Maybe<Scalars['float8']['output']>;
  epdExpectedLife?: Maybe<Scalars['Int']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Int']['output']>;
  epdId?: Maybe<Scalars['uuid']['output']>;
  epdInternalId?: Maybe<Scalars['uuid']['output']>;
  epdMass?: Maybe<Scalars['float8']['output']>;
  epdMassUnit?: Maybe<Scalars['String']['output']>;
  epdMaterialCategory?: Maybe<Scalars['String']['output']>;
  epdName?: Maybe<Scalars['String']['output']>;
  epdStandard?: Maybe<Scalars['String']['output']>;
  epdType?: Maybe<Scalars['String']['output']>;
  epdVersion?: Maybe<Scalars['String']['output']>;
  epdVersionNumber?: Maybe<Scalars['Int']['output']>;
  excludedReason?: Maybe<Scalars['String']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  lifetimeYears?: Maybe<Scalars['Int']['output']>;
  mappingFactor?: Maybe<Scalars['float8']['output']>;
  materialCount?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialIdentifier?: Maybe<Scalars['String']['output']>;
  materialSource?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  normArea?: Maybe<Scalars['float8']['output']>;
  normPeriod?: Maybe<Scalars['Int']['output']>;
  numberOfReplacements?: Maybe<Scalars['Int']['output']>;
  preferredUnit?: Maybe<Scalars['String']['output']>;
  preferredValue?: Maybe<Scalars['float8']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  rowKind?: Maybe<Scalars['String']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  transportSources?: Maybe<Array<Scalars['String']['output']>>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
  typeMappedKinds?: Maybe<Array<Scalars['String']['output']>>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
  wastePercentage?: Maybe<Scalars['float8']['output']>;
  weightKg?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type VMaterialCurrent_Min_Fields = {
  __typename?: 'vMaterialCurrent_min_fields';
  bimFamily?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  classBuildingPart?: Maybe<Scalars['String']['output']>;
  classCode?: Maybe<Scalars['String']['output']>;
  classCodeId?: Maybe<Scalars['Int']['output']>;
  classLabel?: Maybe<Scalars['String']['output']>;
  classLevel1Code?: Maybe<Scalars['String']['output']>;
  classPath?: Maybe<Array<Scalars['String']['output']>>;
  classSystem?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  epdDatasources?: Maybe<Array<Scalars['String']['output']>>;
  epdDeclarationOwner?: Maybe<Scalars['String']['output']>;
  epdDeclaredUnit?: Maybe<Scalars['String']['output']>;
  epdDeclaredValue?: Maybe<Scalars['float8']['output']>;
  epdExpectedLife?: Maybe<Scalars['Int']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Int']['output']>;
  epdId?: Maybe<Scalars['uuid']['output']>;
  epdInternalId?: Maybe<Scalars['uuid']['output']>;
  epdMass?: Maybe<Scalars['float8']['output']>;
  epdMassUnit?: Maybe<Scalars['String']['output']>;
  epdMaterialCategory?: Maybe<Scalars['String']['output']>;
  epdName?: Maybe<Scalars['String']['output']>;
  epdStandard?: Maybe<Scalars['String']['output']>;
  epdType?: Maybe<Scalars['String']['output']>;
  epdVersion?: Maybe<Scalars['String']['output']>;
  epdVersionNumber?: Maybe<Scalars['Int']['output']>;
  excludedReason?: Maybe<Scalars['String']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  lifetimeYears?: Maybe<Scalars['Int']['output']>;
  mappingFactor?: Maybe<Scalars['float8']['output']>;
  materialCount?: Maybe<Scalars['Int']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  materialIdentifier?: Maybe<Scalars['String']['output']>;
  materialSource?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  normArea?: Maybe<Scalars['float8']['output']>;
  normPeriod?: Maybe<Scalars['Int']['output']>;
  numberOfReplacements?: Maybe<Scalars['Int']['output']>;
  preferredUnit?: Maybe<Scalars['String']['output']>;
  preferredValue?: Maybe<Scalars['float8']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  rowKind?: Maybe<Scalars['String']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  transportSources?: Maybe<Array<Scalars['String']['output']>>;
  typeIdentifier?: Maybe<Scalars['String']['output']>;
  typeMappedKinds?: Maybe<Array<Scalars['String']['output']>>;
  typeMaterialIdentifier?: Maybe<Scalars['String']['output']>;
  wastePercentage?: Maybe<Scalars['float8']['output']>;
  weightKg?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "v_material_current". */
export type VMaterialCurrent_Order_By = {
  bimFamily?: InputMaybe<Order_By>;
  bimProperties?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  classBuildingPart?: InputMaybe<Order_By>;
  classCode?: InputMaybe<Order_By>;
  classCodeId?: InputMaybe<Order_By>;
  classLabel?: InputMaybe<Order_By>;
  classLevel1Code?: InputMaybe<Order_By>;
  classPath?: InputMaybe<Order_By>;
  classSystem?: InputMaybe<Order_By>;
  classificationConflicts?: InputMaybe<Order_By>;
  classifications?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doubleCountRisk?: InputMaybe<Order_By>;
  epdDatasources?: InputMaybe<Order_By>;
  epdDeclarationOwner?: InputMaybe<Order_By>;
  epdDeclaredUnit?: InputMaybe<Order_By>;
  epdDeclaredValue?: InputMaybe<Order_By>;
  epdDeprecated?: InputMaybe<Order_By>;
  epdExpectedLife?: InputMaybe<Order_By>;
  epdExpectedLifespan?: InputMaybe<Order_By>;
  epdFaulty?: InputMaybe<Order_By>;
  epdId?: InputMaybe<Order_By>;
  epdInternalId?: InputMaybe<Order_By>;
  epdIsConstruction?: InputMaybe<Order_By>;
  epdIsCustom?: InputMaybe<Order_By>;
  epdMass?: InputMaybe<Order_By>;
  epdMassUnit?: InputMaybe<Order_By>;
  epdMaterialCategory?: InputMaybe<Order_By>;
  epdName?: InputMaybe<Order_By>;
  epdNewestVersion?: InputMaybe<Order_By>;
  epdStandard?: InputMaybe<Order_By>;
  epdType?: InputMaybe<Order_By>;
  epdVersion?: InputMaybe<Order_By>;
  epdVersionNumber?: InputMaybe<Order_By>;
  excludedReason?: InputMaybe<Order_By>;
  gwp?: InputMaybe<VMaterialGwp_Order_By>;
  gwpA1a3?: InputMaybe<Order_By>;
  gwpA4?: InputMaybe<Order_By>;
  gwpA5?: InputMaybe<Order_By>;
  gwpB1?: InputMaybe<Order_By>;
  gwpB2?: InputMaybe<Order_By>;
  gwpB3?: InputMaybe<Order_By>;
  gwpB4?: InputMaybe<Order_By>;
  gwpB5?: InputMaybe<Order_By>;
  gwpB6?: InputMaybe<Order_By>;
  gwpB7?: InputMaybe<Order_By>;
  gwpC1?: InputMaybe<Order_By>;
  gwpC2?: InputMaybe<Order_By>;
  gwpC3?: InputMaybe<Order_By>;
  gwpC4?: InputMaybe<Order_By>;
  gwpD?: InputMaybe<Order_By>;
  includeMapping?: InputMaybe<Order_By>;
  isAutoMapping?: InputMaybe<Order_By>;
  isMapped?: InputMaybe<Order_By>;
  isRecycled?: InputMaybe<Order_By>;
  lifetimeOffset?: InputMaybe<Order_By>;
  lifetimeYears?: InputMaybe<Order_By>;
  mappingFactor?: InputMaybe<Order_By>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Order_By>;
  materialCount?: InputMaybe<Order_By>;
  materialId?: InputMaybe<Order_By>;
  materialIdentifier?: InputMaybe<Order_By>;
  materialSource?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  moduleStatus?: InputMaybe<Order_By>;
  normArea?: InputMaybe<Order_By>;
  normPeriod?: InputMaybe<Order_By>;
  numberOfReplacements?: InputMaybe<Order_By>;
  originalCaptured?: InputMaybe<Order_By>;
  originalQuantities?: InputMaybe<Order_By>;
  preferredUnit?: InputMaybe<Order_By>;
  preferredValue?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectState?: InputMaybe<BenchmarkProjectState_Order_By>;
  provenanceChanges?: InputMaybe<Order_By>;
  quantities?: InputMaybe<Order_By>;
  rowKind?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  sourceChanged?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  status?: InputMaybe<VMaterialStatus_Order_By>;
  tags?: InputMaybe<Order_By>;
  transportSources?: InputMaybe<Order_By>;
  typeIdentifier?: InputMaybe<Order_By>;
  typeMappedKinds?: InputMaybe<Order_By>;
  typeMaterialIdentifier?: InputMaybe<Order_By>;
  unrecognisedParams?: InputMaybe<Order_By>;
  valueChanged?: InputMaybe<Order_By>;
  wastePercentage?: InputMaybe<Order_By>;
  weightKg?: InputMaybe<Order_By>;
};

/** select columns of table "v_material_current" */
export enum VMaterialCurrent_Select_Column {
  /** column name */
  bimFamily = 'bimFamily',
  /** column name */
  bimProperties = 'bimProperties',
  /** column name */
  category = 'category',
  /** column name */
  classBuildingPart = 'classBuildingPart',
  /** column name */
  classCode = 'classCode',
  /** column name */
  classCodeId = 'classCodeId',
  /** column name */
  classLabel = 'classLabel',
  /** column name */
  classLevel1Code = 'classLevel1Code',
  /** column name */
  classPath = 'classPath',
  /** column name */
  classSystem = 'classSystem',
  /** column name */
  classificationConflicts = 'classificationConflicts',
  /** column name */
  classifications = 'classifications',
  /** column name */
  description = 'description',
  /** column name */
  doubleCountRisk = 'doubleCountRisk',
  /** column name */
  epdDatasources = 'epdDatasources',
  /** column name */
  epdDeclarationOwner = 'epdDeclarationOwner',
  /** column name */
  epdDeclaredUnit = 'epdDeclaredUnit',
  /** column name */
  epdDeclaredValue = 'epdDeclaredValue',
  /** column name */
  epdDeprecated = 'epdDeprecated',
  /** column name */
  epdExpectedLife = 'epdExpectedLife',
  /** column name */
  epdExpectedLifespan = 'epdExpectedLifespan',
  /** column name */
  epdFaulty = 'epdFaulty',
  /** column name */
  epdId = 'epdId',
  /** column name */
  epdInternalId = 'epdInternalId',
  /** column name */
  epdIsConstruction = 'epdIsConstruction',
  /** column name */
  epdIsCustom = 'epdIsCustom',
  /** column name */
  epdMass = 'epdMass',
  /** column name */
  epdMassUnit = 'epdMassUnit',
  /** column name */
  epdMaterialCategory = 'epdMaterialCategory',
  /** column name */
  epdName = 'epdName',
  /** column name */
  epdNewestVersion = 'epdNewestVersion',
  /** column name */
  epdStandard = 'epdStandard',
  /** column name */
  epdType = 'epdType',
  /** column name */
  epdVersion = 'epdVersion',
  /** column name */
  epdVersionNumber = 'epdVersionNumber',
  /** column name */
  excludedReason = 'excludedReason',
  /** column name */
  gwpA1a3 = 'gwpA1a3',
  /** column name */
  gwpA4 = 'gwpA4',
  /** column name */
  gwpA5 = 'gwpA5',
  /** column name */
  gwpB1 = 'gwpB1',
  /** column name */
  gwpB2 = 'gwpB2',
  /** column name */
  gwpB3 = 'gwpB3',
  /** column name */
  gwpB4 = 'gwpB4',
  /** column name */
  gwpB5 = 'gwpB5',
  /** column name */
  gwpB6 = 'gwpB6',
  /** column name */
  gwpB7 = 'gwpB7',
  /** column name */
  gwpC1 = 'gwpC1',
  /** column name */
  gwpC2 = 'gwpC2',
  /** column name */
  gwpC3 = 'gwpC3',
  /** column name */
  gwpC4 = 'gwpC4',
  /** column name */
  gwpD = 'gwpD',
  /** column name */
  includeMapping = 'includeMapping',
  /** column name */
  isAutoMapping = 'isAutoMapping',
  /** column name */
  isMapped = 'isMapped',
  /** column name */
  isRecycled = 'isRecycled',
  /** column name */
  lifetimeOffset = 'lifetimeOffset',
  /** column name */
  lifetimeYears = 'lifetimeYears',
  /** column name */
  mappingFactor = 'mappingFactor',
  /** column name */
  materialCount = 'materialCount',
  /** column name */
  materialId = 'materialId',
  /** column name */
  materialIdentifier = 'materialIdentifier',
  /** column name */
  materialSource = 'materialSource',
  /** column name */
  model = 'model',
  /** column name */
  moduleStatus = 'moduleStatus',
  /** column name */
  normArea = 'normArea',
  /** column name */
  normPeriod = 'normPeriod',
  /** column name */
  numberOfReplacements = 'numberOfReplacements',
  /** column name */
  originalCaptured = 'originalCaptured',
  /** column name */
  originalQuantities = 'originalQuantities',
  /** column name */
  preferredUnit = 'preferredUnit',
  /** column name */
  preferredValue = 'preferredValue',
  /** column name */
  projectId = 'projectId',
  /** column name */
  provenanceChanges = 'provenanceChanges',
  /** column name */
  quantities = 'quantities',
  /** column name */
  rowKind = 'rowKind',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  sourceChanged = 'sourceChanged',
  /** column name */
  stage = 'stage',
  /** column name */
  tags = 'tags',
  /** column name */
  transportSources = 'transportSources',
  /** column name */
  typeIdentifier = 'typeIdentifier',
  /** column name */
  typeMappedKinds = 'typeMappedKinds',
  /** column name */
  typeMaterialIdentifier = 'typeMaterialIdentifier',
  /** column name */
  unrecognisedParams = 'unrecognisedParams',
  /** column name */
  valueChanged = 'valueChanged',
  /** column name */
  wastePercentage = 'wastePercentage',
  /** column name */
  weightKg = 'weightKg'
}

/** aggregate stddev on columns */
export type VMaterialCurrent_Stddev_Fields = {
  __typename?: 'vMaterialCurrent_stddev_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type VMaterialCurrent_Stddev_Pop_Fields = {
  __typename?: 'vMaterialCurrent_stddev_pop_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type VMaterialCurrent_Stddev_Samp_Fields = {
  __typename?: 'vMaterialCurrent_stddev_samp_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vMaterialCurrent" */
export type VMaterialCurrent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: VMaterialCurrent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type VMaterialCurrent_Stream_Cursor_Value_Input = {
  bimFamily?: InputMaybe<Scalars['String']['input']>;
  bimProperties?: InputMaybe<Scalars['jsonb']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  classBuildingPart?: InputMaybe<Scalars['String']['input']>;
  classCode?: InputMaybe<Scalars['String']['input']>;
  classCodeId?: InputMaybe<Scalars['Int']['input']>;
  classLabel?: InputMaybe<Scalars['String']['input']>;
  classLevel1Code?: InputMaybe<Scalars['String']['input']>;
  classPath?: InputMaybe<Array<Scalars['String']['input']>>;
  classSystem?: InputMaybe<Scalars['String']['input']>;
  classificationConflicts?: InputMaybe<Scalars['jsonb']['input']>;
  classifications?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  doubleCountRisk?: InputMaybe<Scalars['Boolean']['input']>;
  epdDatasources?: InputMaybe<Array<Scalars['String']['input']>>;
  epdDeclarationOwner?: InputMaybe<Scalars['String']['input']>;
  epdDeclaredUnit?: InputMaybe<Scalars['String']['input']>;
  epdDeclaredValue?: InputMaybe<Scalars['float8']['input']>;
  epdDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  epdExpectedLife?: InputMaybe<Scalars['Int']['input']>;
  epdExpectedLifespan?: InputMaybe<Scalars['Int']['input']>;
  epdFaulty?: InputMaybe<Scalars['Boolean']['input']>;
  epdId?: InputMaybe<Scalars['uuid']['input']>;
  epdInternalId?: InputMaybe<Scalars['uuid']['input']>;
  epdIsConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  epdIsCustom?: InputMaybe<Scalars['Boolean']['input']>;
  epdMass?: InputMaybe<Scalars['float8']['input']>;
  epdMassUnit?: InputMaybe<Scalars['String']['input']>;
  epdMaterialCategory?: InputMaybe<Scalars['String']['input']>;
  epdName?: InputMaybe<Scalars['String']['input']>;
  epdNewestVersion?: InputMaybe<Scalars['Boolean']['input']>;
  epdStandard?: InputMaybe<Scalars['String']['input']>;
  epdType?: InputMaybe<Scalars['String']['input']>;
  epdVersion?: InputMaybe<Scalars['String']['input']>;
  epdVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  excludedReason?: InputMaybe<Scalars['String']['input']>;
  gwpA1a3?: InputMaybe<Scalars['float8']['input']>;
  gwpA4?: InputMaybe<Scalars['float8']['input']>;
  gwpA5?: InputMaybe<Scalars['float8']['input']>;
  gwpB1?: InputMaybe<Scalars['float8']['input']>;
  gwpB2?: InputMaybe<Scalars['float8']['input']>;
  gwpB3?: InputMaybe<Scalars['float8']['input']>;
  gwpB4?: InputMaybe<Scalars['float8']['input']>;
  gwpB5?: InputMaybe<Scalars['float8']['input']>;
  gwpB6?: InputMaybe<Scalars['float8']['input']>;
  gwpB7?: InputMaybe<Scalars['float8']['input']>;
  gwpC1?: InputMaybe<Scalars['float8']['input']>;
  gwpC2?: InputMaybe<Scalars['float8']['input']>;
  gwpC3?: InputMaybe<Scalars['float8']['input']>;
  gwpC4?: InputMaybe<Scalars['float8']['input']>;
  gwpD?: InputMaybe<Scalars['float8']['input']>;
  includeMapping?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoMapping?: InputMaybe<Scalars['Boolean']['input']>;
  isMapped?: InputMaybe<Scalars['Boolean']['input']>;
  isRecycled?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeOffset?: InputMaybe<Scalars['Int']['input']>;
  lifetimeYears?: InputMaybe<Scalars['Int']['input']>;
  mappingFactor?: InputMaybe<Scalars['float8']['input']>;
  materialCount?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  materialIdentifier?: InputMaybe<Scalars['String']['input']>;
  materialSource?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  moduleStatus?: InputMaybe<Scalars['jsonb']['input']>;
  normArea?: InputMaybe<Scalars['float8']['input']>;
  normPeriod?: InputMaybe<Scalars['Int']['input']>;
  numberOfReplacements?: InputMaybe<Scalars['Int']['input']>;
  originalCaptured?: InputMaybe<Scalars['Boolean']['input']>;
  originalQuantities?: InputMaybe<Scalars['jsonb']['input']>;
  preferredUnit?: InputMaybe<Scalars['String']['input']>;
  preferredValue?: InputMaybe<Scalars['float8']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  provenanceChanges?: InputMaybe<Scalars['jsonb']['input']>;
  quantities?: InputMaybe<Scalars['jsonb']['input']>;
  rowKind?: InputMaybe<Scalars['String']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  sourceChanged?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  transportSources?: InputMaybe<Array<Scalars['String']['input']>>;
  typeIdentifier?: InputMaybe<Scalars['String']['input']>;
  typeMappedKinds?: InputMaybe<Array<Scalars['String']['input']>>;
  typeMaterialIdentifier?: InputMaybe<Scalars['String']['input']>;
  unrecognisedParams?: InputMaybe<Scalars['jsonb']['input']>;
  valueChanged?: InputMaybe<Scalars['Boolean']['input']>;
  wastePercentage?: InputMaybe<Scalars['float8']['input']>;
  weightKg?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type VMaterialCurrent_Sum_Fields = {
  __typename?: 'vMaterialCurrent_sum_fields';
  classCodeId?: Maybe<Scalars['Int']['output']>;
  epdDeclaredValue?: Maybe<Scalars['float8']['output']>;
  epdExpectedLife?: Maybe<Scalars['Int']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Int']['output']>;
  epdMass?: Maybe<Scalars['float8']['output']>;
  epdVersionNumber?: Maybe<Scalars['Int']['output']>;
  gwpA1a3?: Maybe<Scalars['float8']['output']>;
  gwpA4?: Maybe<Scalars['float8']['output']>;
  gwpA5?: Maybe<Scalars['float8']['output']>;
  gwpB1?: Maybe<Scalars['float8']['output']>;
  gwpB2?: Maybe<Scalars['float8']['output']>;
  gwpB3?: Maybe<Scalars['float8']['output']>;
  gwpB4?: Maybe<Scalars['float8']['output']>;
  gwpB5?: Maybe<Scalars['float8']['output']>;
  gwpB6?: Maybe<Scalars['float8']['output']>;
  gwpB7?: Maybe<Scalars['float8']['output']>;
  gwpC1?: Maybe<Scalars['float8']['output']>;
  gwpC2?: Maybe<Scalars['float8']['output']>;
  gwpC3?: Maybe<Scalars['float8']['output']>;
  gwpC4?: Maybe<Scalars['float8']['output']>;
  gwpD?: Maybe<Scalars['float8']['output']>;
  lifetimeOffset?: Maybe<Scalars['Int']['output']>;
  lifetimeYears?: Maybe<Scalars['Int']['output']>;
  mappingFactor?: Maybe<Scalars['float8']['output']>;
  materialCount?: Maybe<Scalars['Int']['output']>;
  normArea?: Maybe<Scalars['float8']['output']>;
  normPeriod?: Maybe<Scalars['Int']['output']>;
  numberOfReplacements?: Maybe<Scalars['Int']['output']>;
  preferredValue?: Maybe<Scalars['float8']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  wastePercentage?: Maybe<Scalars['float8']['output']>;
  weightKg?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type VMaterialCurrent_Var_Pop_Fields = {
  __typename?: 'vMaterialCurrent_var_pop_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type VMaterialCurrent_Var_Samp_Fields = {
  __typename?: 'vMaterialCurrent_var_samp_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type VMaterialCurrent_Variance_Fields = {
  __typename?: 'vMaterialCurrent_variance_fields';
  classCodeId?: Maybe<Scalars['Float']['output']>;
  epdDeclaredValue?: Maybe<Scalars['Float']['output']>;
  epdExpectedLife?: Maybe<Scalars['Float']['output']>;
  epdExpectedLifespan?: Maybe<Scalars['Float']['output']>;
  epdMass?: Maybe<Scalars['Float']['output']>;
  epdVersionNumber?: Maybe<Scalars['Float']['output']>;
  gwpA1a3?: Maybe<Scalars['Float']['output']>;
  gwpA4?: Maybe<Scalars['Float']['output']>;
  gwpA5?: Maybe<Scalars['Float']['output']>;
  gwpB1?: Maybe<Scalars['Float']['output']>;
  gwpB2?: Maybe<Scalars['Float']['output']>;
  gwpB3?: Maybe<Scalars['Float']['output']>;
  gwpB4?: Maybe<Scalars['Float']['output']>;
  gwpB5?: Maybe<Scalars['Float']['output']>;
  gwpB6?: Maybe<Scalars['Float']['output']>;
  gwpB7?: Maybe<Scalars['Float']['output']>;
  gwpC1?: Maybe<Scalars['Float']['output']>;
  gwpC2?: Maybe<Scalars['Float']['output']>;
  gwpC3?: Maybe<Scalars['Float']['output']>;
  gwpC4?: Maybe<Scalars['Float']['output']>;
  gwpD?: Maybe<Scalars['Float']['output']>;
  lifetimeOffset?: Maybe<Scalars['Float']['output']>;
  lifetimeYears?: Maybe<Scalars['Float']['output']>;
  mappingFactor?: Maybe<Scalars['Float']['output']>;
  materialCount?: Maybe<Scalars['Float']['output']>;
  normArea?: Maybe<Scalars['Float']['output']>;
  normPeriod?: Maybe<Scalars['Float']['output']>;
  numberOfReplacements?: Maybe<Scalars['Float']['output']>;
  preferredValue?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  wastePercentage?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "v_material_gwp" */
export type VMaterialGwp = {
  __typename?: 'vMaterialGwp';
  gwpCommon?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  material?: Maybe<BenchmarkInventoryMaterial>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  projectState?: Maybe<BenchmarkProjectState>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "v_material_gwp" */
export type VMaterialGwp_Aggregate = {
  __typename?: 'vMaterialGwp_aggregate';
  aggregate?: Maybe<VMaterialGwp_Aggregate_Fields>;
  nodes: Array<VMaterialGwp>;
};

/** aggregate fields of "v_material_gwp" */
export type VMaterialGwp_Aggregate_Fields = {
  __typename?: 'vMaterialGwp_aggregate_fields';
  avg?: Maybe<VMaterialGwp_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<VMaterialGwp_Max_Fields>;
  min?: Maybe<VMaterialGwp_Min_Fields>;
  stddev?: Maybe<VMaterialGwp_Stddev_Fields>;
  stddev_pop?: Maybe<VMaterialGwp_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VMaterialGwp_Stddev_Samp_Fields>;
  sum?: Maybe<VMaterialGwp_Sum_Fields>;
  var_pop?: Maybe<VMaterialGwp_Var_Pop_Fields>;
  var_samp?: Maybe<VMaterialGwp_Var_Samp_Fields>;
  variance?: Maybe<VMaterialGwp_Variance_Fields>;
};


/** aggregate fields of "v_material_gwp" */
export type VMaterialGwp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<VMaterialGwp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type VMaterialGwp_Avg_Fields = {
  __typename?: 'vMaterialGwp_avg_fields';
  gwpCommon?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "v_material_gwp". All fields are combined with a logical 'AND'. */
export type VMaterialGwp_Bool_Exp = {
  _and?: InputMaybe<Array<VMaterialGwp_Bool_Exp>>;
  _not?: InputMaybe<VMaterialGwp_Bool_Exp>;
  _or?: InputMaybe<Array<VMaterialGwp_Bool_Exp>>;
  gwpCommon?: InputMaybe<Float8_Comparison_Exp>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  projectState?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "v_material_gwp" */
export type VMaterialGwp_Inc_Input = {
  gwpCommon?: InputMaybe<Scalars['float8']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "v_material_gwp" */
export type VMaterialGwp_Insert_Input = {
  gwpCommon?: InputMaybe<Scalars['float8']['input']>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Obj_Rel_Insert_Input>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectState?: InputMaybe<BenchmarkProjectState_Obj_Rel_Insert_Input>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type VMaterialGwp_Max_Fields = {
  __typename?: 'vMaterialGwp_max_fields';
  gwpCommon?: Maybe<Scalars['float8']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type VMaterialGwp_Min_Fields = {
  __typename?: 'vMaterialGwp_min_fields';
  gwpCommon?: Maybe<Scalars['float8']['output']>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "v_material_gwp" */
export type VMaterialGwp_Mutation_Response = {
  __typename?: 'vMaterialGwp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<VMaterialGwp>;
};

/** input type for inserting object relation for remote table "v_material_gwp" */
export type VMaterialGwp_Obj_Rel_Insert_Input = {
  data: VMaterialGwp_Insert_Input;
};

/** Ordering options when selecting data from "v_material_gwp". */
export type VMaterialGwp_Order_By = {
  gwpCommon?: InputMaybe<Order_By>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Order_By>;
  materialId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectState?: InputMaybe<BenchmarkProjectState_Order_By>;
  snapshotId?: InputMaybe<Order_By>;
};

/** select columns of table "v_material_gwp" */
export enum VMaterialGwp_Select_Column {
  /** column name */
  gwpCommon = 'gwpCommon',
  /** column name */
  materialId = 'materialId',
  /** column name */
  projectId = 'projectId',
  /** column name */
  snapshotId = 'snapshotId'
}

/** input type for updating data in table "v_material_gwp" */
export type VMaterialGwp_Set_Input = {
  gwpCommon?: InputMaybe<Scalars['float8']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type VMaterialGwp_Stddev_Fields = {
  __typename?: 'vMaterialGwp_stddev_fields';
  gwpCommon?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type VMaterialGwp_Stddev_Pop_Fields = {
  __typename?: 'vMaterialGwp_stddev_pop_fields';
  gwpCommon?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type VMaterialGwp_Stddev_Samp_Fields = {
  __typename?: 'vMaterialGwp_stddev_samp_fields';
  gwpCommon?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vMaterialGwp" */
export type VMaterialGwp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: VMaterialGwp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type VMaterialGwp_Stream_Cursor_Value_Input = {
  gwpCommon?: InputMaybe<Scalars['float8']['input']>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type VMaterialGwp_Sum_Fields = {
  __typename?: 'vMaterialGwp_sum_fields';
  gwpCommon?: Maybe<Scalars['float8']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

export type VMaterialGwp_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VMaterialGwp_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VMaterialGwp_Set_Input>;
  /** filter the rows which have to be updated */
  where: VMaterialGwp_Bool_Exp;
};

/** aggregate var_pop on columns */
export type VMaterialGwp_Var_Pop_Fields = {
  __typename?: 'vMaterialGwp_var_pop_fields';
  gwpCommon?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type VMaterialGwp_Var_Samp_Fields = {
  __typename?: 'vMaterialGwp_var_samp_fields';
  gwpCommon?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type VMaterialGwp_Variance_Fields = {
  __typename?: 'vMaterialGwp_variance_fields';
  gwpCommon?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "v_material_status" */
export type VMaterialStatus = {
  __typename?: 'vMaterialStatus';
  /** An object relationship */
  material?: Maybe<BenchmarkInventoryMaterial>;
  materialId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "v_material_status" */
export type VMaterialStatus_Aggregate = {
  __typename?: 'vMaterialStatus_aggregate';
  aggregate?: Maybe<VMaterialStatus_Aggregate_Fields>;
  nodes: Array<VMaterialStatus>;
};

/** aggregate fields of "v_material_status" */
export type VMaterialStatus_Aggregate_Fields = {
  __typename?: 'vMaterialStatus_aggregate_fields';
  avg?: Maybe<VMaterialStatus_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<VMaterialStatus_Max_Fields>;
  min?: Maybe<VMaterialStatus_Min_Fields>;
  stddev?: Maybe<VMaterialStatus_Stddev_Fields>;
  stddev_pop?: Maybe<VMaterialStatus_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VMaterialStatus_Stddev_Samp_Fields>;
  sum?: Maybe<VMaterialStatus_Sum_Fields>;
  var_pop?: Maybe<VMaterialStatus_Var_Pop_Fields>;
  var_samp?: Maybe<VMaterialStatus_Var_Samp_Fields>;
  variance?: Maybe<VMaterialStatus_Variance_Fields>;
};


/** aggregate fields of "v_material_status" */
export type VMaterialStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<VMaterialStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type VMaterialStatus_Avg_Fields = {
  __typename?: 'vMaterialStatus_avg_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "v_material_status". All fields are combined with a logical 'AND'. */
export type VMaterialStatus_Bool_Exp = {
  _and?: InputMaybe<Array<VMaterialStatus_Bool_Exp>>;
  _not?: InputMaybe<VMaterialStatus_Bool_Exp>;
  _or?: InputMaybe<Array<VMaterialStatus_Bool_Exp>>;
  material?: InputMaybe<BenchmarkInventoryMaterial_Bool_Exp>;
  materialId?: InputMaybe<Uuid_Comparison_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "v_material_status" */
export type VMaterialStatus_Inc_Input = {
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "v_material_status" */
export type VMaterialStatus_Insert_Input = {
  material?: InputMaybe<BenchmarkInventoryMaterial_Obj_Rel_Insert_Input>;
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type VMaterialStatus_Max_Fields = {
  __typename?: 'vMaterialStatus_max_fields';
  materialId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type VMaterialStatus_Min_Fields = {
  __typename?: 'vMaterialStatus_min_fields';
  materialId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "v_material_status" */
export type VMaterialStatus_Mutation_Response = {
  __typename?: 'vMaterialStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<VMaterialStatus>;
};

/** input type for inserting object relation for remote table "v_material_status" */
export type VMaterialStatus_Obj_Rel_Insert_Input = {
  data: VMaterialStatus_Insert_Input;
};

/** Ordering options when selecting data from "v_material_status". */
export type VMaterialStatus_Order_By = {
  material?: InputMaybe<BenchmarkInventoryMaterial_Order_By>;
  materialId?: InputMaybe<Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "v_material_status" */
export enum VMaterialStatus_Select_Column {
  /** column name */
  materialId = 'materialId',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  status = 'status'
}

/** input type for updating data in table "v_material_status" */
export type VMaterialStatus_Set_Input = {
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type VMaterialStatus_Stddev_Fields = {
  __typename?: 'vMaterialStatus_stddev_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type VMaterialStatus_Stddev_Pop_Fields = {
  __typename?: 'vMaterialStatus_stddev_pop_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type VMaterialStatus_Stddev_Samp_Fields = {
  __typename?: 'vMaterialStatus_stddev_samp_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vMaterialStatus" */
export type VMaterialStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: VMaterialStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type VMaterialStatus_Stream_Cursor_Value_Input = {
  materialId?: InputMaybe<Scalars['uuid']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type VMaterialStatus_Sum_Fields = {
  __typename?: 'vMaterialStatus_sum_fields';
  snapshotId?: Maybe<Scalars['bigint']['output']>;
};

export type VMaterialStatus_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VMaterialStatus_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VMaterialStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: VMaterialStatus_Bool_Exp;
};

/** aggregate var_pop on columns */
export type VMaterialStatus_Var_Pop_Fields = {
  __typename?: 'vMaterialStatus_var_pop_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type VMaterialStatus_Var_Samp_Fields = {
  __typename?: 'vMaterialStatus_var_samp_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type VMaterialStatus_Variance_Fields = {
  __typename?: 'vMaterialStatus_variance_fields';
  snapshotId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "v_project_intensity" */
export type VProjectIntensity = {
  __typename?: 'vProjectIntensity';
  intensity?: Maybe<Scalars['float8']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  projectState?: Maybe<BenchmarkProjectState>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  totalAbs?: Maybe<Scalars['float8']['output']>;
};

/** aggregated selection of "v_project_intensity" */
export type VProjectIntensity_Aggregate = {
  __typename?: 'vProjectIntensity_aggregate';
  aggregate?: Maybe<VProjectIntensity_Aggregate_Fields>;
  nodes: Array<VProjectIntensity>;
};

/** aggregate fields of "v_project_intensity" */
export type VProjectIntensity_Aggregate_Fields = {
  __typename?: 'vProjectIntensity_aggregate_fields';
  avg?: Maybe<VProjectIntensity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<VProjectIntensity_Max_Fields>;
  min?: Maybe<VProjectIntensity_Min_Fields>;
  stddev?: Maybe<VProjectIntensity_Stddev_Fields>;
  stddev_pop?: Maybe<VProjectIntensity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VProjectIntensity_Stddev_Samp_Fields>;
  sum?: Maybe<VProjectIntensity_Sum_Fields>;
  var_pop?: Maybe<VProjectIntensity_Var_Pop_Fields>;
  var_samp?: Maybe<VProjectIntensity_Var_Samp_Fields>;
  variance?: Maybe<VProjectIntensity_Variance_Fields>;
};


/** aggregate fields of "v_project_intensity" */
export type VProjectIntensity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<VProjectIntensity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type VProjectIntensity_Avg_Fields = {
  __typename?: 'vProjectIntensity_avg_fields';
  intensity?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalAbs?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "v_project_intensity". All fields are combined with a logical 'AND'. */
export type VProjectIntensity_Bool_Exp = {
  _and?: InputMaybe<Array<VProjectIntensity_Bool_Exp>>;
  _not?: InputMaybe<VProjectIntensity_Bool_Exp>;
  _or?: InputMaybe<Array<VProjectIntensity_Bool_Exp>>;
  intensity?: InputMaybe<Float8_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  projectState?: InputMaybe<BenchmarkProjectState_Bool_Exp>;
  snapshotId?: InputMaybe<Bigint_Comparison_Exp>;
  totalAbs?: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for inserting data into table "v_project_intensity" */
export type VProjectIntensity_Insert_Input = {
  intensity?: InputMaybe<Scalars['float8']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  projectState?: InputMaybe<BenchmarkProjectState_Obj_Rel_Insert_Input>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  totalAbs?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type VProjectIntensity_Max_Fields = {
  __typename?: 'vProjectIntensity_max_fields';
  intensity?: Maybe<Scalars['float8']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  totalAbs?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type VProjectIntensity_Min_Fields = {
  __typename?: 'vProjectIntensity_min_fields';
  intensity?: Maybe<Scalars['float8']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  totalAbs?: Maybe<Scalars['float8']['output']>;
};

/** input type for inserting object relation for remote table "v_project_intensity" */
export type VProjectIntensity_Obj_Rel_Insert_Input = {
  data: VProjectIntensity_Insert_Input;
};

/** Ordering options when selecting data from "v_project_intensity". */
export type VProjectIntensity_Order_By = {
  intensity?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  projectState?: InputMaybe<BenchmarkProjectState_Order_By>;
  snapshotId?: InputMaybe<Order_By>;
  totalAbs?: InputMaybe<Order_By>;
};

/** select columns of table "v_project_intensity" */
export enum VProjectIntensity_Select_Column {
  /** column name */
  intensity = 'intensity',
  /** column name */
  projectId = 'projectId',
  /** column name */
  snapshotId = 'snapshotId',
  /** column name */
  totalAbs = 'totalAbs'
}

/** aggregate stddev on columns */
export type VProjectIntensity_Stddev_Fields = {
  __typename?: 'vProjectIntensity_stddev_fields';
  intensity?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalAbs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type VProjectIntensity_Stddev_Pop_Fields = {
  __typename?: 'vProjectIntensity_stddev_pop_fields';
  intensity?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalAbs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type VProjectIntensity_Stddev_Samp_Fields = {
  __typename?: 'vProjectIntensity_stddev_samp_fields';
  intensity?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalAbs?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vProjectIntensity" */
export type VProjectIntensity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: VProjectIntensity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type VProjectIntensity_Stream_Cursor_Value_Input = {
  intensity?: InputMaybe<Scalars['float8']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  snapshotId?: InputMaybe<Scalars['bigint']['input']>;
  totalAbs?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type VProjectIntensity_Sum_Fields = {
  __typename?: 'vProjectIntensity_sum_fields';
  intensity?: Maybe<Scalars['float8']['output']>;
  snapshotId?: Maybe<Scalars['bigint']['output']>;
  totalAbs?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type VProjectIntensity_Var_Pop_Fields = {
  __typename?: 'vProjectIntensity_var_pop_fields';
  intensity?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalAbs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type VProjectIntensity_Var_Samp_Fields = {
  __typename?: 'vProjectIntensity_var_samp_fields';
  intensity?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalAbs?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type VProjectIntensity_Variance_Fields = {
  __typename?: 'vProjectIntensity_variance_fields';
  intensity?: Maybe<Scalars['Float']['output']>;
  snapshotId?: Maybe<Scalars['Float']['output']>;
  totalAbs?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "weight_per_declared_unit" */
export type WeightPerDeclaredUnit = {
  __typename?: 'weightPerDeclaredUnit';
  /** An object relationship */
  denominatorUnit?: Maybe<Unit>;
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  unit: Unit;
  unitId: Scalars['Int']['output'];
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "weight_per_declared_unit" */
export type WeightPerDeclaredUnit_Aggregate = {
  __typename?: 'weightPerDeclaredUnit_aggregate';
  aggregate?: Maybe<WeightPerDeclaredUnit_Aggregate_Fields>;
  nodes: Array<WeightPerDeclaredUnit>;
};

/** aggregate fields of "weight_per_declared_unit" */
export type WeightPerDeclaredUnit_Aggregate_Fields = {
  __typename?: 'weightPerDeclaredUnit_aggregate_fields';
  avg?: Maybe<WeightPerDeclaredUnit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<WeightPerDeclaredUnit_Max_Fields>;
  min?: Maybe<WeightPerDeclaredUnit_Min_Fields>;
  stddev?: Maybe<WeightPerDeclaredUnit_Stddev_Fields>;
  stddev_pop?: Maybe<WeightPerDeclaredUnit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<WeightPerDeclaredUnit_Stddev_Samp_Fields>;
  sum?: Maybe<WeightPerDeclaredUnit_Sum_Fields>;
  var_pop?: Maybe<WeightPerDeclaredUnit_Var_Pop_Fields>;
  var_samp?: Maybe<WeightPerDeclaredUnit_Var_Samp_Fields>;
  variance?: Maybe<WeightPerDeclaredUnit_Variance_Fields>;
};


/** aggregate fields of "weight_per_declared_unit" */
export type WeightPerDeclaredUnit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<WeightPerDeclaredUnit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type WeightPerDeclaredUnit_Avg_Fields = {
  __typename?: 'weightPerDeclaredUnit_avg_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "weight_per_declared_unit". All fields are combined with a logical 'AND'. */
export type WeightPerDeclaredUnit_Bool_Exp = {
  _and?: InputMaybe<Array<WeightPerDeclaredUnit_Bool_Exp>>;
  _not?: InputMaybe<WeightPerDeclaredUnit_Bool_Exp>;
  _or?: InputMaybe<Array<WeightPerDeclaredUnit_Bool_Exp>>;
  denominatorUnit?: InputMaybe<Unit_Bool_Exp>;
  denominatorUnitId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unitId?: InputMaybe<Int_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "weight_per_declared_unit" */
export enum WeightPerDeclaredUnit_Constraint {
  /** unique or primary key constraint on columns "id" */
  material_mass_unit_pkey = 'material_mass_unit_pkey',
  /** unique or primary key constraint on columns "unit_id", "denominator_unit_id" */
  material_mass_unit_unit_id_denominator_unit_id_key = 'material_mass_unit_unit_id_denominator_unit_id_key'
}

/** input type for incrementing numeric columns in table "weight_per_declared_unit" */
export type WeightPerDeclaredUnit_Inc_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "weight_per_declared_unit" */
export type WeightPerDeclaredUnit_Insert_Input = {
  denominatorUnit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type WeightPerDeclaredUnit_Max_Fields = {
  __typename?: 'weightPerDeclaredUnit_max_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type WeightPerDeclaredUnit_Min_Fields = {
  __typename?: 'weightPerDeclaredUnit_min_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "weight_per_declared_unit" */
export type WeightPerDeclaredUnit_Mutation_Response = {
  __typename?: 'weightPerDeclaredUnit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<WeightPerDeclaredUnit>;
};

/** input type for inserting object relation for remote table "weight_per_declared_unit" */
export type WeightPerDeclaredUnit_Obj_Rel_Insert_Input = {
  data: WeightPerDeclaredUnit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<WeightPerDeclaredUnit_On_Conflict>;
};

/** on_conflict condition type for table "weight_per_declared_unit" */
export type WeightPerDeclaredUnit_On_Conflict = {
  constraint: WeightPerDeclaredUnit_Constraint;
  update_columns?: Array<WeightPerDeclaredUnit_Update_Column>;
  where?: InputMaybe<WeightPerDeclaredUnit_Bool_Exp>;
};

/** Ordering options when selecting data from "weight_per_declared_unit". */
export type WeightPerDeclaredUnit_Order_By = {
  denominatorUnit?: InputMaybe<Unit_Order_By>;
  denominatorUnitId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unitId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: weight_per_declared_unit */
export type WeightPerDeclaredUnit_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "weight_per_declared_unit" */
export enum WeightPerDeclaredUnit_Select_Column {
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  unitId = 'unitId',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "weight_per_declared_unit" */
export type WeightPerDeclaredUnit_Set_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type WeightPerDeclaredUnit_Stddev_Fields = {
  __typename?: 'weightPerDeclaredUnit_stddev_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type WeightPerDeclaredUnit_Stddev_Pop_Fields = {
  __typename?: 'weightPerDeclaredUnit_stddev_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type WeightPerDeclaredUnit_Stddev_Samp_Fields = {
  __typename?: 'weightPerDeclaredUnit_stddev_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "weightPerDeclaredUnit" */
export type WeightPerDeclaredUnit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: WeightPerDeclaredUnit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type WeightPerDeclaredUnit_Stream_Cursor_Value_Input = {
  denominatorUnitId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  unitId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type WeightPerDeclaredUnit_Sum_Fields = {
  __typename?: 'weightPerDeclaredUnit_sum_fields';
  denominatorUnitId?: Maybe<Scalars['Int']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "weight_per_declared_unit" */
export enum WeightPerDeclaredUnit_Update_Column {
  /** column name */
  denominatorUnitId = 'denominatorUnitId',
  /** column name */
  id = 'id',
  /** column name */
  unitId = 'unitId',
  /** column name */
  value = 'value'
}

export type WeightPerDeclaredUnit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WeightPerDeclaredUnit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WeightPerDeclaredUnit_Set_Input>;
  /** filter the rows which have to be updated */
  where: WeightPerDeclaredUnit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type WeightPerDeclaredUnit_Var_Pop_Fields = {
  __typename?: 'weightPerDeclaredUnit_var_pop_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type WeightPerDeclaredUnit_Var_Samp_Fields = {
  __typename?: 'weightPerDeclaredUnit_var_samp_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type WeightPerDeclaredUnit_Variance_Fields = {
  __typename?: 'weightPerDeclaredUnit_variance_fields';
  denominatorUnitId?: Maybe<Scalars['Float']['output']>;
  unitId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CalculationTypeFragmentFragment = { __typename?: 'calculationType', considerationPeriod?: number | null, country: Country_Enum, id: number, label: string, threshold?: any | null, specialConditionTypes_aggregate: { __typename?: 'specialConditionTypeCalculationType_aggregate', aggregate?: { __typename?: 'specialConditionTypeCalculationType_aggregate_fields', count: number } | null }, stages: Array<{ __typename?: 'calculation_type_stage', stage: { __typename?: 'stage', id: number, label: string } }>, thresholdIndicator: { __typename?: 'indicatorTypeMapping', id: any, denominatorUnit?: { __typename?: 'denominatorUnit', id: number, label: string, unit: string } | null, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } }, thresholdByBuildingType: Array<{ __typename?: 'calculationTypeThresholdByBuildingType', buildingTypeId: number, id: any, maxTotalArea?: any | null, installationThreshold?: any | null, threshold?: any | null }>, variant?: { __typename?: 'calculationTypeVariant', id: any, variant: string } | null };

export type MaterialWasteSourceFragment = { __typename?: 'materialWasteSource', id: any, denominatorUnitId?: number | null, source: string, sourceName?: string | null, indicatorType?: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null } | null, denominatorUnit?: { __typename?: 'denominatorUnit', id: number, unit: string } | null, unit?: { __typename?: 'unit', id: number, fullName: string, label: string, pluralFullName: string } | null };

export type MaterialWasteTypeFragment = { __typename?: 'materialWasteType', id: any, materialCategoryId?: string | null, label: string, value: any };

export type ProjectBaseFragment = { __typename?: 'project', id: any, name: string, role?: string | null, speckleStreamId?: string | null };

export type ProjectListFragment = { __typename?: 'project', area?: any | null, createdAt: any, favorite?: boolean | null, updatedAt?: any | null, id: any, name: string, role?: string | null, speckleStreamId?: string | null, activeRevision: { __typename?: 'projectRevision', id: any, name: string }, revisions: Array<{ __typename?: 'projectRevision', id: any }>, buildingType: { __typename?: 'buildingType', id: number, label: string }, calculation?: { __typename?: 'projectCalculation', calculationType: { __typename?: 'calculationType', id: number, label: string } } | null, location?: { __typename?: 'projectLocation', city: string, country: string, postalCode: string, id: any, street: string, streetNumber: string } | null, memberships: Array<{ __typename?: 'projectMembership', role: string, userId: string }>, models: Array<{ __typename?: 'projectModel', id: string, name: string }>, projectStatus?: { __typename?: 'projectStatus', id: number, label: string } | null, specialConditionConfig?: { __typename?: 'projectSpecialConditionConfig', enabled: boolean } | null };

export type ProjectTransportMappingFragmentFragment = { __typename?: 'project_transport_mapping', distance: any, id: any, created_at: any, material_id?: any | null, project_id: any, project_transport_id?: any | null, updated_at: any, transportEmissionFactorEmission?: any | null, emissionFactors: Array<{ __typename?: 'projectTransportMappingEmissionFactor', id: any, emissionFactor: { __typename?: 'transportEmissionFactor', id: any, label: string, emission: any, transportSource?: { __typename?: 'transportSource', id: any, label: string, datasource: string } | null } }>, transportStandardValue?: { __typename?: 'transport_standard_value', id: any, mainGroup: string, subGroup: string, emission: any, transportSource?: { __typename?: 'transportSource', id: any, label: string, datasource: string } | null } | null };

export type ProjectTransportRowFragment = { __typename?: 'project_transport', distance: any, emission?: any | null, transport_type_name?: string | null, id: any, project_id: any, tenant_id: string, transport: { __typename?: 'transport', id: any, isDefault: boolean, emission: any, label: string, transportType: Transport_Type_Enum, indicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null, identifier_label?: string | null } } };

export type ProjectWasteMappingFragment = { __typename?: 'projectWasteMapping', id: any, label?: string | null, materialId?: any | null, materialWasteTypeId?: any | null, pickupDate?: any | null, customWeight?: any | null, materialWeightSnapshot?: any | null, customWasteType?: { __typename?: 'projectWasteTypeCustom', id: any, label: string } | null };

export type ProjectWasteTypeCustomFragment = { __typename?: 'projectWasteTypeCustom', id: any, label: string };

export type SpecialConditionTypeFragmentFragment = { __typename?: 'specialConditionType', id: any, country: Country_Enum, buildingPart: { __typename?: 'buildingPart', label: string }, specialConditionTypeCategory: { __typename?: 'special_condition_type_category', id: any, label: string, specialConditionTypeInputParameter?: { __typename?: 'specialConditionTypeInputParameter', parameter: Array<string>, specialConditionTypeCategoryId: any } | null } };

export type TransportSourceFragmentFragment = { __typename?: 'transportSource', id: any, datasource: string, label: string, calculationTypes: Array<{ __typename?: 'transportSourceCalculationType', calculationType: { __typename?: 'calculationType', id: number, thresholdIndicator: { __typename?: 'indicatorTypeMapping', id: any, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } } } }>, transportEmissionFactors: Array<{ __typename?: 'transportEmissionFactor', id: any, label: string, emission: any, isDefault: boolean, transportSourceId?: any | null, denominatorUnit: { __typename?: 'denominatorUnit', id: number, label: string, unit: string }, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } }>, transportStandardValues: Array<{ __typename?: 'transport_standard_value', id: any, emission: any, mainGroup: string, subGroup: string, denominatorUnit?: { __typename?: 'unit', id: number, label: string } | null }> };

export type DeleteMaterialFavoriteMutationVariables = Exact<{
  materialInternalId: Scalars['uuid']['input'];
}>;


export type DeleteMaterialFavoriteMutation = { __typename?: 'mutation_root', delete_userMaterialFavorite?: { __typename?: 'userMaterialFavorite_mutation_response', returning: Array<{ __typename?: 'userMaterialFavorite', materialInternalId: any, createdAt: any }> } | null };

export type DeleteProjectEmissionFactorCustomMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  deletedAt: Scalars['timestamptz']['input'];
}>;


export type DeleteProjectEmissionFactorCustomMutation = { __typename?: 'mutation_root', update_projectEmissionFactorCustom_by_pk?: { __typename?: 'projectEmissionFactorCustom', id: any, deletedAt?: any | null } | null };

export type DeleteProjectSpecialConditionTypeMappingMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  model: Scalars['String']['input'];
  typeIdentifier: Scalars['String']['input'];
}>;


export type DeleteProjectSpecialConditionTypeMappingMutation = { __typename?: 'mutation_root', delete_projectSpecialConditionTypeMapping?: { __typename?: 'projectSpecialConditionTypeMapping_mutation_response', affected_rows: number } | null };

export type DeleteProjectSpecialConditionTypeMappingWithVersionMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  model: Scalars['String']['input'];
  typeIdentifier: Scalars['String']['input'];
  version: ProjectVersion_Insert_Input;
}>;


export type DeleteProjectSpecialConditionTypeMappingWithVersionMutation = { __typename?: 'mutation_root', delete_projectSpecialConditionTypeMapping?: { __typename?: 'projectSpecialConditionTypeMapping_mutation_response', affected_rows: number } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type DeleteProjectStandardValueStagesMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  stageIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteProjectStandardValueStagesMutation = { __typename?: 'mutation_root', delete_projectStandardValueStage?: { __typename?: 'projectStandardValueStage_mutation_response', affected_rows: number } | null };

export type DeleteProjectTransportMappingEmissionFactorsMutationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type DeleteProjectTransportMappingEmissionFactorsMutationMutation = { __typename?: 'mutation_root', delete_projectTransportMappingEmissionFactor?: { __typename?: 'projectTransportMappingEmissionFactor_mutation_response', affected_rows: number } | null };

export type DeleteProjectTransportMappingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type DeleteProjectTransportMappingMutation = { __typename?: 'mutation_root', delete_project_transport_mapping?: { __typename?: 'project_transport_mapping_mutation_response', affected_rows: number } | null };

export type DeleteProjectTransportMappingWithVersionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
  version: ProjectVersion_Insert_Input;
}>;


export type DeleteProjectTransportMappingWithVersionMutation = { __typename?: 'mutation_root', delete_projectTransportMappingEmissionFactor?: { __typename?: 'projectTransportMappingEmissionFactor_mutation_response', affected_rows: number } | null, delete_project_transport_mapping?: { __typename?: 'project_transport_mapping_mutation_response', affected_rows: number } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type DeleteProjectTransportMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type DeleteProjectTransportMutation = { __typename?: 'mutation_root', delete_project_transport?: { __typename?: 'project_transport_mutation_response', affected_rows: number } | null };

export type DeleteProjectWasteMappingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteProjectWasteMappingMutation = { __typename?: 'mutation_root', delete_projectWasteMapping_by_pk?: { __typename?: 'projectWasteMapping', id: any } | null };

export type DeleteProjectWasteMappingWithVersionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  version: ProjectVersion_Insert_Input;
}>;


export type DeleteProjectWasteMappingWithVersionMutation = { __typename?: 'mutation_root', delete_projectWasteMapping_by_pk?: { __typename?: 'projectWasteMapping', id: any } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type DeleteProjectWasteTypeCustomMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteProjectWasteTypeCustomMutation = { __typename?: 'mutation_root', delete_projectWasteTypeCustom_by_pk?: { __typename?: 'projectWasteTypeCustom', id: any } | null };

export type DeleteProjectWasteTypeCustomWithVersionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  version: ProjectVersion_Insert_Input;
}>;


export type DeleteProjectWasteTypeCustomWithVersionMutation = { __typename?: 'mutation_root', delete_projectWasteTypeCustom_by_pk?: { __typename?: 'projectWasteTypeCustom', id: any } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type DeleteTenantCollectionItemMutationVariables = Exact<{
  tenantCollectionId: Scalars['uuid']['input'];
  materialInternalId: Scalars['String']['input'];
}>;


export type DeleteTenantCollectionItemMutation = { __typename?: 'mutation_root', delete_tenantCollectionItem?: { __typename?: 'tenantCollectionItem_mutation_response', returning: Array<{ __typename?: 'tenantCollectionItem', materialInternalId: string, tenantCollectionId: any }> } | null };

export type DeleteTenantCollectionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTenantCollectionMutation = { __typename?: 'mutation_root', delete_tenantCollection?: { __typename?: 'tenantCollection_mutation_response', returning: Array<{ __typename?: 'tenantCollection', id: any, name: string }> } | null };

export type DeleteUserTutorialViewMutationVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type DeleteUserTutorialViewMutation = { __typename?: 'mutation_root', delete_userTutorialView?: { __typename?: 'userTutorialView_mutation_response', affected_rows: number } | null };

export type InsertConstructionForkMutationVariables = Exact<{
  constructionId: Scalars['uuid']['input'];
  parentConstructionId: Scalars['uuid']['input'];
  constructionInternalId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  createdBy: Scalars['uuid']['input'];
}>;


export type InsertConstructionForkMutation = { __typename?: 'mutation_root', insert_constructionFork_one?: { __typename?: 'constructionFork', constructionId: any, parentConstructionId: any } | null };

export type InsertMaterialFavoriteMutationVariables = Exact<{
  materialInternalId: Scalars['uuid']['input'];
}>;


export type InsertMaterialFavoriteMutation = { __typename?: 'mutation_root', insert_userMaterialFavorite?: { __typename?: 'userMaterialFavorite_mutation_response', returning: Array<{ __typename?: 'userMaterialFavorite', materialInternalId: any }> } | null };

export type InsertMaterialForkMutationVariables = Exact<{
  materialId: Scalars['uuid']['input'];
  parentMaterialId: Scalars['uuid']['input'];
  materialInternalId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  createdBy: Scalars['uuid']['input'];
}>;


export type InsertMaterialForkMutation = { __typename?: 'mutation_root', insert_materialFork_one?: { __typename?: 'materialFork', materialId: any, parentMaterialId: any } | null };

export type InsertProjectEmissionFactorCustomMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emissionFactorType: Emission_Factor_Type_Enum;
  emissionValue: Scalars['numeric']['input'];
}>;


export type InsertProjectEmissionFactorCustomMutation = { __typename?: 'mutation_root', insert_projectEmissionFactorCustom_one?: { __typename?: 'projectEmissionFactorCustom', id: any, name: string, description?: string | null, emissionValue: any, createdAt: any, emissionFactorType: Emission_Factor_Type_Enum, projectEmissionFactors_aggregate: { __typename?: 'projectEmissionFactor_aggregate', aggregate?: { __typename?: 'projectEmissionFactor_aggregate_fields', count: number } | null } } | null };

export type UpsertProjectMaterialWasteMappingMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  customWeight?: InputMaybe<Scalars['numeric']['input']>;
  materialId: Scalars['uuid']['input'];
  materialWasteTypeId?: InputMaybe<Scalars['uuid']['input']>;
  projectId: Scalars['uuid']['input'];
  materialWeightSnapshot?: InputMaybe<Scalars['numeric']['input']>;
}>;


export type UpsertProjectMaterialWasteMappingMutation = { __typename?: 'mutation_root', insert_projectWasteMapping?: { __typename?: 'projectWasteMapping_mutation_response', affected_rows: number } | null };

export type InsertProjectModelMutationVariables = Exact<{
  object: ProjectModel_Insert_Input;
}>;


export type InsertProjectModelMutation = { __typename?: 'mutation_root', model?: { __typename?: 'projectModel', id: string, name: string, active: boolean } | null };

export type InsertProjectSpecialConditionTypeMappingMutationVariables = Exact<{
  areaOfConstruction?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  model: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
  specialConditionTypeId: Scalars['uuid']['input'];
  typeIdentifier: Scalars['String']['input'];
}>;


export type InsertProjectSpecialConditionTypeMappingMutation = { __typename?: 'mutation_root', insert_projectSpecialConditionTypeMapping?: { __typename?: 'projectSpecialConditionTypeMapping_mutation_response', returning: Array<{ __typename?: 'projectSpecialConditionTypeMapping', typeIdentifier?: string | null, specialConditionTypeId: any, projectId: any, model: string, length?: any | null, id: any, description?: string | null, areaOfConstruction?: any | null }> } | null };

export type InsertProjectSpecialConditionTypeMappingWithVersionMutationVariables = Exact<{
  areaOfConstruction?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['numeric']['input']>;
  model: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
  specialConditionTypeId: Scalars['uuid']['input'];
  typeIdentifier: Scalars['String']['input'];
  version: ProjectVersion_Insert_Input;
}>;


export type InsertProjectSpecialConditionTypeMappingWithVersionMutation = { __typename?: 'mutation_root', insert_projectSpecialConditionTypeMapping?: { __typename?: 'projectSpecialConditionTypeMapping_mutation_response', returning: Array<{ __typename?: 'projectSpecialConditionTypeMapping', typeIdentifier?: string | null, specialConditionTypeId: any, projectId: any, model: string, length?: any | null, id: any, description?: string | null, areaOfConstruction?: any | null }> } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type InsertProjectStandardValueStagesMutationVariables = Exact<{
  objects: Array<ProjectStandardValueStage_Insert_Input> | ProjectStandardValueStage_Insert_Input;
}>;


export type InsertProjectStandardValueStagesMutation = { __typename?: 'mutation_root', insert_projectStandardValueStage?: { __typename?: 'projectStandardValueStage_mutation_response', returning: Array<{ __typename?: 'projectStandardValueStage', id: any, projectId: any, stageId: any }> } | null };

export type InsertProjectTransportMappingMutationVariables = Exact<{
  distance: Scalars['numeric']['input'];
  material_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id: Scalars['uuid']['input'];
  project_transport_id?: InputMaybe<Scalars['uuid']['input']>;
  transportStandardValueId?: InputMaybe<Scalars['uuid']['input']>;
  transportEmissionFactorEmission?: InputMaybe<Scalars['numeric']['input']>;
  emissionFactors?: InputMaybe<ProjectTransportMappingEmissionFactor_Arr_Rel_Insert_Input>;
}>;


export type InsertProjectTransportMappingMutation = { __typename?: 'mutation_root', insert_project_transport_mapping_one?: { __typename?: 'project_transport_mapping', distance: any, id: any, created_at: any, material_id?: any | null, project_id: any, project_transport_id?: any | null, updated_at: any, transportEmissionFactorEmission?: any | null, emissionFactors: Array<{ __typename?: 'projectTransportMappingEmissionFactor', id: any, emissionFactor: { __typename?: 'transportEmissionFactor', id: any, label: string, emission: any, transportSource?: { __typename?: 'transportSource', id: any, label: string, datasource: string } | null } }>, transportStandardValue?: { __typename?: 'transport_standard_value', id: any, mainGroup: string, subGroup: string, emission: any, transportSource?: { __typename?: 'transportSource', id: any, label: string, datasource: string } | null } | null } | null };

export type InsertProjectTransportMappingsMutationVariables = Exact<{
  objects: Array<Project_Transport_Mapping_Insert_Input> | Project_Transport_Mapping_Insert_Input;
  materialIdIsNull: Scalars['Boolean']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type InsertProjectTransportMappingsMutation = { __typename?: 'mutation_root', delete_projectTransportMappingEmissionFactor?: { __typename?: 'projectTransportMappingEmissionFactor_mutation_response', returning: Array<{ __typename?: 'projectTransportMappingEmissionFactor', id: any }> } | null, delete_project_transport_mapping?: { __typename?: 'project_transport_mapping_mutation_response', returning: Array<{ __typename?: 'project_transport_mapping', id: any }> } | null, insert_project_transport_mapping?: { __typename?: 'project_transport_mapping_mutation_response', returning: Array<{ __typename?: 'project_transport_mapping', distance: any, id: any, created_at: any, material_id?: any | null, project_id: any, project_transport_id?: any | null, updated_at: any, transportEmissionFactorEmission?: any | null, emissionFactors: Array<{ __typename?: 'projectTransportMappingEmissionFactor', id: any, emissionFactor: { __typename?: 'transportEmissionFactor', id: any, label: string, emission: any, transportSource?: { __typename?: 'transportSource', id: any, label: string, datasource: string } | null } }>, transportStandardValue?: { __typename?: 'transport_standard_value', id: any, mainGroup: string, subGroup: string, emission: any, transportSource?: { __typename?: 'transportSource', id: any, label: string, datasource: string } | null } | null }> } | null };

export type InsertProjectTransportMutationVariables = Exact<{
  objects: Array<Project_Transport_Insert_Input> | Project_Transport_Insert_Input;
}>;


export type InsertProjectTransportMutation = { __typename?: 'mutation_root', insert_project_transport?: { __typename?: 'project_transport_mutation_response', returning: Array<{ __typename?: 'project_transport', id: any }> } | null };

export type InsertProjectTransportWithVersionMutationVariables = Exact<{
  objects: Array<Project_Transport_Insert_Input> | Project_Transport_Insert_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type InsertProjectTransportWithVersionMutation = { __typename?: 'mutation_root', insert_project_transport?: { __typename?: 'project_transport_mutation_response', returning: Array<{ __typename?: 'project_transport', id: any }> } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type InsertProjectVersionMutationVariables = Exact<{
  version: ProjectVersion_Insert_Input;
}>;


export type InsertProjectVersionMutation = { __typename?: 'mutation_root', insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type InsertTenantCollectionItemMutationVariables = Exact<{
  tenantCollectionId: Scalars['uuid']['input'];
  materialInternalId: Scalars['String']['input'];
}>;


export type InsertTenantCollectionItemMutation = { __typename?: 'mutation_root', insert_tenantCollectionItem_one?: { __typename?: 'tenantCollectionItem', materialInternalId: string, tenantCollectionId: any } | null };

export type InsertUserPlatformReviewMutationVariables = Exact<{
  flowKey: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertUserPlatformReviewMutation = { __typename?: 'mutation_root', insert_userPlatformReview?: { __typename?: 'userPlatformReview_mutation_response', affected_rows: number } | null };

export type InsertUserTutorialViewMutationVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type InsertUserTutorialViewMutation = { __typename?: 'mutation_root', insert_userTutorialView_one?: { __typename?: 'userTutorialView', externalId: string, viewedAt: any } | null };

export type InsertUserWelcomeFlowEventMutationVariables = Exact<{
  flowKey: Scalars['String']['input'];
  event: Scalars['String']['input'];
  variant?: InputMaybe<Scalars['String']['input']>;
  stepIndex?: InputMaybe<Scalars['Int']['input']>;
  stepKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertUserWelcomeFlowEventMutation = { __typename?: 'mutation_root', insert_userWelcomeFlowEvent?: { __typename?: 'userWelcomeFlowEvent_mutation_response', affected_rows: number } | null };

export type InsertUserWelcomeFlowMutationVariables = Exact<{
  flowKey: Scalars['String']['input'];
  variant: Scalars['String']['input'];
}>;


export type InsertUserWelcomeFlowMutation = { __typename?: 'mutation_root', insert_userWelcomeFlow_one?: { __typename?: 'userWelcomeFlow', userId: any, flowKey: string } | null };

export type ReplaceProjectBuildingAreasMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  areas: Array<ProjectBuildingArea_Insert_Input> | ProjectBuildingArea_Insert_Input;
}>;


export type ReplaceProjectBuildingAreasMutation = { __typename?: 'mutation_root', deleted?: { __typename?: 'projectBuildingArea_mutation_response', affected_rows: number } | null, inserted?: { __typename?: 'projectBuildingArea_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'projectBuildingArea', id: any, revisionId: any, buildingTypeId: number, buildingAreaType: BuildingAreaType_Enum, area: any, floors: number, heatedArea: any }> } | null };

export type ReplaceProjectBuildingAreasWithVersionMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  areas: Array<ProjectBuildingArea_Insert_Input> | ProjectBuildingArea_Insert_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type ReplaceProjectBuildingAreasWithVersionMutation = { __typename?: 'mutation_root', deleted?: { __typename?: 'projectBuildingArea_mutation_response', affected_rows: number } | null, inserted?: { __typename?: 'projectBuildingArea_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'projectBuildingArea', id: any, revisionId: any, buildingTypeId: number, buildingAreaType: BuildingAreaType_Enum, area: any, floors: number, heatedArea: any }> } | null, version?: { __typename?: 'projectVersion', id: any } | null };

export type ReplaceProjectModelsMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  models: Array<ProjectModel_Insert_Input> | ProjectModel_Insert_Input;
}>;


export type ReplaceProjectModelsMutation = { __typename?: 'mutation_root', removed?: { __typename?: 'projectModel_mutation_response', affected_rows: number } | null, inserted?: { __typename?: 'projectModel_mutation_response', affected_rows: number } | null };

export type ReplaceProjectModelsWithVersionMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  models: Array<ProjectModel_Insert_Input> | ProjectModel_Insert_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type ReplaceProjectModelsWithVersionMutation = { __typename?: 'mutation_root', removed?: { __typename?: 'projectModel_mutation_response', affected_rows: number } | null, inserted?: { __typename?: 'projectModel_mutation_response', affected_rows: number } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type ReplaceProjectReferenceAreasMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  areas: Array<ProjectReferenceArea_Insert_Input> | ProjectReferenceArea_Insert_Input;
}>;


export type ReplaceProjectReferenceAreasMutation = { __typename?: 'mutation_root', deleted?: { __typename?: 'projectReferenceArea_mutation_response', affected_rows: number } | null, inserted?: { __typename?: 'projectReferenceArea_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'projectReferenceArea', id: any, revisionId: any, referenceAreaTypeKey: string, area: any, description?: string | null }> } | null };

export type ReplaceProjectReferenceAreasWithVersionMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  areas: Array<ProjectReferenceArea_Insert_Input> | ProjectReferenceArea_Insert_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type ReplaceProjectReferenceAreasWithVersionMutation = { __typename?: 'mutation_root', deleted?: { __typename?: 'projectReferenceArea_mutation_response', affected_rows: number } | null, inserted?: { __typename?: 'projectReferenceArea_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'projectReferenceArea', id: any, revisionId: any, referenceAreaTypeKey: string, area: any, description?: string | null }> } | null, version?: { __typename?: 'projectVersion', id: any } | null };

export type SaveProjectStandardValueStagesWithVersionMutationVariables = Exact<{
  objects: Array<ProjectStandardValueStage_Insert_Input> | ProjectStandardValueStage_Insert_Input;
  projectId: Scalars['uuid']['input'];
  stageIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  version: ProjectVersion_Insert_Input;
}>;


export type SaveProjectStandardValueStagesWithVersionMutation = { __typename?: 'mutation_root', insert_projectStandardValueStage?: { __typename?: 'projectStandardValueStage_mutation_response', affected_rows: number } | null, delete_projectStandardValueStage?: { __typename?: 'projectStandardValueStage_mutation_response', affected_rows: number } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type UpdateProjectEmissionFactorCustomMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emissionFactorType: Emission_Factor_Type_Enum;
  emissionValue: Scalars['numeric']['input'];
}>;


export type UpdateProjectEmissionFactorCustomMutation = { __typename?: 'mutation_root', update_projectEmissionFactorCustom_by_pk?: { __typename?: 'projectEmissionFactorCustom', id: any, name: string, description?: string | null, emissionValue: any, createdAt: any, emissionFactorType: Emission_Factor_Type_Enum, projectEmissionFactors_aggregate: { __typename?: 'projectEmissionFactor_aggregate', aggregate?: { __typename?: 'projectEmissionFactor_aggregate_fields', count: number } | null } } | null };

export type UpdateProjectRevisionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: ProjectRevision_Set_Input;
}>;


export type UpdateProjectRevisionMutation = { __typename?: 'mutation_root', update_projectRevision?: { __typename?: 'projectRevision_mutation_response', affected_rows: number } | null };

export type UpdateProjectRevisionWithVersionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: ProjectRevision_Set_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type UpdateProjectRevisionWithVersionMutation = { __typename?: 'mutation_root', update_projectRevision?: { __typename?: 'projectRevision_mutation_response', affected_rows: number } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type UpdateProjectStatusWithVersionMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  projectStatusId: Scalars['Int']['input'];
  version: ProjectVersion_Insert_Input;
}>;


export type UpdateProjectStatusWithVersionMutation = { __typename?: 'mutation_root', project?: { __typename?: 'project', id: any, projectStatusId?: number | null } | null, version?: { __typename?: 'projectVersion', id: any } | null };

export type UpdateProjectStatusMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  projectStatusId: Scalars['Int']['input'];
}>;


export type UpdateProjectStatusMutation = { __typename?: 'mutation_root', project?: { __typename?: 'project', id: any, projectStatusId?: number | null } | null };

export type UpdateProjectWasteTypeCustomMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  label: Scalars['String']['input'];
}>;


export type UpdateProjectWasteTypeCustomMutation = { __typename?: 'mutation_root', update_projectWasteTypeCustom_by_pk?: { __typename?: 'projectWasteTypeCustom', id: any, label: string } | null };

export type UpdateProjectWasteTypeCustomWithVersionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  label: Scalars['String']['input'];
  version: ProjectVersion_Insert_Input;
}>;


export type UpdateProjectWasteTypeCustomWithVersionMutation = { __typename?: 'mutation_root', update_projectWasteTypeCustom_by_pk?: { __typename?: 'projectWasteTypeCustom', id: any, label: string } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type UpdateUserWelcomeFlowCompletedMutationVariables = Exact<{
  flowKey: Scalars['String']['input'];
}>;


export type UpdateUserWelcomeFlowCompletedMutation = { __typename?: 'mutation_root', update_userWelcomeFlow?: { __typename?: 'userWelcomeFlow_mutation_response', affected_rows: number } | null };

export type UpsertProjectCalculationMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  calculation: ProjectCalculation_Insert_Input;
}>;


export type UpsertProjectCalculationMutation = { __typename?: 'mutation_root', deletedStages?: { __typename?: 'projectCalculationStage_mutation_response', affected_rows: number } | null, calculation?: { __typename?: 'projectCalculation', id: any, revisionId: any, createdAt: any, calculationTypeId: number, considerationPeriod: number, thresholdLimit: any, installationThresholdLimit?: any | null, useDefaultEmissions: boolean, stages: Array<{ __typename?: 'projectCalculationStage', id: any, stageId: number }> } | null };

export type UpsertProjectCalculationWithVersionMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  calculation: ProjectCalculation_Insert_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type UpsertProjectCalculationWithVersionMutation = { __typename?: 'mutation_root', deletedStages?: { __typename?: 'projectCalculationStage_mutation_response', affected_rows: number } | null, calculation?: { __typename?: 'projectCalculation', id: any, revisionId: any, createdAt: any, calculationTypeId: number, considerationPeriod: number, thresholdLimit: any, installationThresholdLimit?: any | null, useDefaultEmissions: boolean, stages: Array<{ __typename?: 'projectCalculationStage', id: any, stageId: number }> } | null, version?: { __typename?: 'projectVersion', id: any } | null };

export type UpsertProjectLocationMutationVariables = Exact<{
  location: ProjectLocation_Insert_Input;
}>;


export type UpsertProjectLocationMutation = { __typename?: 'mutation_root', location?: { __typename?: 'projectLocation', id: any, revisionId: any, createdAt: any, street: string, streetNumber: string, postalCode: string, city: string, country: string } | null };

export type UpsertProjectLocationWithVersionMutationVariables = Exact<{
  location: ProjectLocation_Insert_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type UpsertProjectLocationWithVersionMutation = { __typename?: 'mutation_root', location?: { __typename?: 'projectLocation', id: any, revisionId: any, createdAt: any, street: string, streetNumber: string, postalCode: string, city: string, country: string } | null, version?: { __typename?: 'projectVersion', id: any } | null };

export type UpsertProjectSpecialConditionConfigWithVersionMutationVariables = Exact<{
  config: ProjectSpecialConditionConfig_Insert_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type UpsertProjectSpecialConditionConfigWithVersionMutation = { __typename?: 'mutation_root', config?: { __typename?: 'projectSpecialConditionConfig', projectId: any, revisionId: any, enabled: boolean } | null, version?: { __typename?: 'projectVersion', id: any } | null };

export type UpsertProjectSpecialConditionConfigMutationVariables = Exact<{
  config: ProjectSpecialConditionConfig_Insert_Input;
}>;


export type UpsertProjectSpecialConditionConfigMutation = { __typename?: 'mutation_root', config?: { __typename?: 'projectSpecialConditionConfig', projectId: any, revisionId: any, enabled: boolean } | null };

export type UpsertProjectSpeckleParameterConfigWithVersionMutationVariables = Exact<{
  config: ProjectSpeckleParameterConfig_Insert_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type UpsertProjectSpeckleParameterConfigWithVersionMutation = { __typename?: 'mutation_root', config?: { __typename?: 'projectSpeckleParameterConfig', projectId: any, classificationTypeId?: any | null, classificationCode: string } | null, version?: { __typename?: 'projectVersion', id: any } | null };

export type UpsertProjectSpeckleParameterConfigMutationVariables = Exact<{
  config: ProjectSpeckleParameterConfig_Insert_Input;
}>;


export type UpsertProjectSpeckleParameterConfigMutation = { __typename?: 'mutation_root', config?: { __typename?: 'projectSpeckleParameterConfig', projectId: any, classificationTypeId?: any | null, classificationCode: string } | null };

export type UpsertProjectWasteMappingMutationVariables = Exact<{
  objects: Array<ProjectWasteMapping_Insert_Input> | ProjectWasteMapping_Insert_Input;
}>;


export type UpsertProjectWasteMappingMutation = { __typename?: 'mutation_root', insert_projectWasteMapping?: { __typename?: 'projectWasteMapping_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'projectWasteMapping', id: any, label?: string | null, materialId?: any | null, materialWasteTypeId?: any | null, pickupDate?: any | null, customWeight?: any | null, materialWeightSnapshot?: any | null, customWasteType?: { __typename?: 'projectWasteTypeCustom', id: any, label: string } | null }> } | null };

export type UpsertProjectWasteMappingWithVersionMutationVariables = Exact<{
  objects: Array<ProjectWasteMapping_Insert_Input> | ProjectWasteMapping_Insert_Input;
  version: ProjectVersion_Insert_Input;
}>;


export type UpsertProjectWasteMappingWithVersionMutation = { __typename?: 'mutation_root', insert_projectWasteMapping?: { __typename?: 'projectWasteMapping_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'projectWasteMapping', id: any, label?: string | null, materialId?: any | null, materialWasteTypeId?: any | null, pickupDate?: any | null, customWeight?: any | null, materialWeightSnapshot?: any | null, customWasteType?: { __typename?: 'projectWasteTypeCustom', id: any, label: string } | null }> } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type UpsertProjectWasteTypeCustomMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  label: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type UpsertProjectWasteTypeCustomMutation = { __typename?: 'mutation_root', insert_projectWasteTypeCustom_one?: { __typename?: 'projectWasteTypeCustom', id: any, label: string } | null };

export type UpsertProjectWasteTypeCustomWithVersionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  label: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
  version: ProjectVersion_Insert_Input;
}>;


export type UpsertProjectWasteTypeCustomWithVersionMutation = { __typename?: 'mutation_root', insert_projectWasteTypeCustom_one?: { __typename?: 'projectWasteTypeCustom', id: any, label: string } | null, insert_projectVersion_one?: { __typename?: 'projectVersion', id: any } | null };

export type UpsertTenantCollectionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  collectionType: Scalars['String']['input'];
}>;


export type UpsertTenantCollectionMutation = { __typename?: 'mutation_root', insert_tenantCollection?: { __typename?: 'tenantCollection_mutation_response', returning: Array<{ __typename?: 'tenantCollection', name: string, id: any, collectionType: string }> } | null };

export type UpsertUserProjectViewMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type UpsertUserProjectViewMutation = { __typename?: 'mutation_root', insert_userProjectView_one?: { __typename?: 'userProjectView', projectId: any, viewedAt: any } | null };

export type GetAdminProjectStatusCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminProjectStatusCountsQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', tenantId: string, projectStatus?: { __typename?: 'projectStatus', label: string } | null }> };

export type GetAgentUsageBudgetStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentUsageBudgetStatusQuery = { __typename?: 'query_root', agentUsageBudgetStatus: Array<{ __typename?: 'agentUsageBudgetStatus', tenantId?: any | null, capAmount?: any | null, currency?: string | null, spendCurrentMonth?: any | null, pctUsed?: any | null }> };

export type GetAgentUsageDailyQueryVariables = Exact<{
  from: Scalars['date']['input'];
  to: Scalars['date']['input'];
}>;


export type GetAgentUsageDailyQuery = { __typename?: 'query_root', agentUsageDaily: Array<{ __typename?: 'agentUsageDaily', usageDate?: any | null, feature?: string | null, userId?: any | null, sessionCount?: any | null, requestCount?: any | null, totalTokens?: any | null }> };

export type GetAgentUsageSessionSummaryQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  to: Scalars['timestamptz']['input'];
}>;


export type GetAgentUsageSessionSummaryQuery = { __typename?: 'query_root', agentUsageSession_aggregate: { __typename?: 'agentUsageSession_aggregate', aggregate?: { __typename?: 'agentUsageSession_aggregate_fields', count: number, sum?: { __typename?: 'agentUsageSession_sum_fields', totalTokens?: any | null } | null } | null } };

export type GetAgentUsageSessionsQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  to: Scalars['timestamptz']['input'];
}>;


export type GetAgentUsageSessionsQuery = { __typename?: 'query_root', agentUsageSession: Array<{ __typename?: 'agentUsageSession', sessionId?: any | null, userId?: any | null, feature?: string | null, startedAt?: any | null, lastActivityAt?: any | null, requestCount?: any | null, totalTokens?: any | null }> };

export type GetAllTenantCollectionItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTenantCollectionItemsQuery = { __typename?: 'query_root', tenantCollectionItem: Array<{ __typename?: 'tenantCollectionItem', materialInternalId: string, tenantCollectionId: any }> };

export type GetBasicProjectListQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<Project_Order_By> | Project_Order_By>;
  where?: InputMaybe<Project_Bool_Exp>;
}>;


export type GetBasicProjectListQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', favorite?: boolean | null, id: any, name: string, role?: string | null, speckleStreamId?: string | null, models: Array<{ __typename?: 'projectModel', id: string, name: string }> }> };

export type GetBuildingPartServiceLifetimesQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetBuildingPartServiceLifetimesQuery = { __typename?: 'query_root', buildingPartLifetimeSource: Array<{ __typename?: 'buildingPartLifetimeSource', id: any, source?: string | null, label: string, serviceLifetimes: Array<{ __typename?: 'buildingPartServiceLifetime', id: any, lifetimeAverage: number, lifetimeLow?: number | null, lifetimeHigh?: number | null, buildingElementClassificationCodeMapping?: { __typename?: 'building_element_classification_code_mapping', classificationCode: { __typename?: 'classificationCode', id: number, code: string, label?: string | null, parent?: { __typename?: 'classificationCode', id: number, code: string, label?: string | null } | null }, buildingElement?: { __typename?: 'building_element', id: any, label: string, materialCategoryMappings: Array<{ __typename?: 'building_element_material_category_mapping', materialCategory: { __typename?: 'materialCategory', id: string, label?: string | null } }> } | null } | null }> }> };

export type GetBuildingTypesQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetBuildingTypesQuery = { __typename?: 'query_root', buildingType: Array<{ __typename?: 'buildingType', id: number, label: string, code?: string | null, parent?: { __typename?: 'buildingType', id: number, label: string, code?: string | null } | null }> };

export type GetCalculationTypeByIdQueryVariables = Exact<{
  calculationTypeId: Scalars['Int']['input'];
}>;


export type GetCalculationTypeByIdQuery = { __typename?: 'query_root', calculationType_by_pk?: { __typename?: 'calculationType', considerationPeriod?: number | null, country: Country_Enum, id: number, label: string, threshold?: any | null, specialConditionTypes_aggregate: { __typename?: 'specialConditionTypeCalculationType_aggregate', aggregate?: { __typename?: 'specialConditionTypeCalculationType_aggregate_fields', count: number } | null }, stages: Array<{ __typename?: 'calculation_type_stage', stage: { __typename?: 'stage', id: number, label: string } }>, thresholdIndicator: { __typename?: 'indicatorTypeMapping', id: any, denominatorUnit?: { __typename?: 'denominatorUnit', id: number, label: string, unit: string } | null, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } }, thresholdByBuildingType: Array<{ __typename?: 'calculationTypeThresholdByBuildingType', buildingTypeId: number, id: any, maxTotalArea?: any | null, installationThreshold?: any | null, threshold?: any | null }>, variant?: { __typename?: 'calculationTypeVariant', id: any, variant: string } | null } | null };

export type GetCalculationTypeQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetCalculationTypeQuery = { __typename?: 'query_root', calculationType: Array<{ __typename?: 'calculationType', considerationPeriod?: number | null, country: Country_Enum, id: number, label: string, threshold?: any | null, specialConditionTypes_aggregate: { __typename?: 'specialConditionTypeCalculationType_aggregate', aggregate?: { __typename?: 'specialConditionTypeCalculationType_aggregate_fields', count: number } | null }, stages: Array<{ __typename?: 'calculation_type_stage', stage: { __typename?: 'stage', id: number, label: string } }>, thresholdIndicator: { __typename?: 'indicatorTypeMapping', id: any, denominatorUnit?: { __typename?: 'denominatorUnit', id: number, label: string, unit: string } | null, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } }, thresholdByBuildingType: Array<{ __typename?: 'calculationTypeThresholdByBuildingType', buildingTypeId: number, id: any, maxTotalArea?: any | null, installationThreshold?: any | null, threshold?: any | null }>, variant?: { __typename?: 'calculationTypeVariant', id: any, variant: string } | null }> };

export type GetCategoryTranslationsQueryVariables = Exact<{
  languageCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetCategoryTranslationsQuery = { __typename?: 'query_root', translationCategory: Array<{ __typename?: 'translationCategory', id: string, original: string, translation: string, languageCode: string, language: { __typename?: 'language', code: string, country?: Country_Enum | null } }>, fallbackTranslations: Array<{ __typename?: 'translationCategory', id: string, original: string, translation: string, languageCode: string, language: { __typename?: 'language', code: string, country?: Country_Enum | null } }> };

export type GetClassificationCodesQueryVariables = Exact<{
  classificationTypeId: Scalars['uuid']['input'];
  country: Country_Enum;
}>;


export type GetClassificationCodesQuery = { __typename?: 'query_root', classificationCode: Array<{ __typename?: 'classificationCode', code: string, id: number, label?: string | null, englishLabel: string, parentId?: number | null, type: { __typename?: 'classificationType', typeByCountry: Array<{ __typename?: 'classificationCodeTypeCountry', country: Country_Enum }> }, translation: Array<{ __typename?: 'classificationCodeTranslation', languageCode: string, label: string }>, objectClass?: { __typename?: 'classificationObjectClass', id: any, code: string, name: string } | null }>, classificationObjectClass: Array<{ __typename?: 'classificationObjectClass', id: any, code: string, name: string }> };

export type GetClassificationTypesQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetClassificationTypesQuery = { __typename?: 'query_root', classificationCodeTypeCountry: Array<{ __typename?: 'classificationCodeTypeCountry', id: any, isDefault: boolean, classificationType: { __typename?: 'classificationType', id: any, longName?: string | null, shortName: string, parameters: Array<{ __typename?: 'classificationTypeAttribute', id: any, isDefault: boolean, value: string }> } }> };

export type GetConfigQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetConfigQuery = { __typename?: 'query_root', countryConfig: Array<{ __typename?: 'countryConfig', calculationTypeId?: number | null, installationFields: Array<string>, useStageDefaultEmissionByStage: boolean, wasteSortingMaterialListDefaultExpand: boolean }> };

export type GetConstructionByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetConstructionByIdQuery = { __typename?: 'query_root', construction_by_pk?: { __typename?: 'construction', id: any, internalId: string, isCustom: boolean, isPublic: boolean, inhomogeneousLayers: Array<{ __typename?: 'constructionInhomogeneousLayer', id: any, amount: any, height?: any | null, length?: any | null, percentage: any, thickness?: any | null, descriptions: Array<{ __typename?: 'constructionInhomogenousLayerDescription', id: any, label: string, languageCode: string, translationSource: string }>, names: Array<{ __typename?: 'constructionInhomogenousLayerName', id: any, label: string, languageCode: string, translationSource: string }>, materials: Array<{ __typename?: 'constructionInhomogeneousLayerMaterial', id: any, amount: any, height?: any | null, length?: any | null, material?: { __typename?: 'material', createdAt?: any | null, createdBy: any, biogenicParams?: { __typename?: 'materialBiogenicParams', id: any, packaging: any, product: any } | null, category: { __typename?: 'materialCategory', id: string, label?: string | null }, declaredUnit: { __typename?: 'declaredUnit', id: any, value: any, unit: { __typename?: 'unit', id: number, label: string, fullName: string, pluralFullName: string } }, descriptions: Array<{ __typename?: 'materialDescription', id: any, label: string, languageCode: string, translationSource?: string | null }>, names: Array<{ __typename?: 'materialName', id: any, label: string, languageCode: string, translationSource: string }>, emissions: Array<{ __typename?: 'materialStage', id: any, indicators: Array<{ __typename?: 'materialEmissionIndicator', id: any, source: IndicatorSource_Enum, value: any, indicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, identifier_label?: string | null, label: string, unit?: string | null } }>, stage: { __typename?: 'stage', id: number, label: string } }>, epd: { __typename?: 'materialEpd', declarationNumber?: string | null, publicationDate: any, version: string, datasources: Array<{ __typename?: 'materialEpdDatasource', datasource: { __typename?: 'epdDatasource', id: any, name: string, url: string } }>, owner: { __typename?: 'epdOwner', id: any, name: string, email?: string | null, vatNumber?: string | null, phoneNumber?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, country?: Country_Enum | null }, productIndustry: { __typename?: 'epdProductIndustry', id: number, label: string }, specificationForm: { __typename?: 'epdSpecificationForm', id: number, label: string }, urls?: { __typename?: 'materialEpdUrl', documentation?: string | null, source?: string | null } | null } } | null, sorting: { __typename?: 'constructionSorting', index: number } }>, sorting: { __typename?: 'constructionSorting', index: number } }>, category: { __typename?: 'materialCategory', id: string, label?: string | null }, descriptions: Array<{ __typename?: 'constructionDescription', id: any, label: string, languageCode: string, translationSource: string }>, materials: Array<{ __typename?: 'constructionMaterial', id: any, amount: any, height?: any | null, length?: any | null, material?: { __typename?: 'material', createdAt?: any | null, createdBy: any, biogenicParams?: { __typename?: 'materialBiogenicParams', id: any, packaging: any, product: any } | null, category: { __typename?: 'materialCategory', id: string, label?: string | null }, declaredUnit: { __typename?: 'declaredUnit', id: any, value: any, unit: { __typename?: 'unit', id: number, label: string, fullName: string, pluralFullName: string } }, descriptions: Array<{ __typename?: 'materialDescription', id: any, label: string, languageCode: string, translationSource?: string | null }>, names: Array<{ __typename?: 'materialName', id: any, label: string, languageCode: string, translationSource: string }>, emissions: Array<{ __typename?: 'materialStage', id: any, indicators: Array<{ __typename?: 'materialEmissionIndicator', id: any, source: IndicatorSource_Enum, value: any, indicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, identifier_label?: string | null, label: string, unit?: string | null } }>, stage: { __typename?: 'stage', id: number, label: string } }>, epd: { __typename?: 'materialEpd', declarationNumber?: string | null, publicationDate: any, version: string, datasources: Array<{ __typename?: 'materialEpdDatasource', datasource: { __typename?: 'epdDatasource', id: any, name: string, url: string } }>, owner: { __typename?: 'epdOwner', id: any, name: string, email?: string | null, vatNumber?: string | null, phoneNumber?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, country?: Country_Enum | null }, productIndustry: { __typename?: 'epdProductIndustry', id: number, label: string }, specificationForm: { __typename?: 'epdSpecificationForm', id: number, label: string }, urls?: { __typename?: 'materialEpdUrl', documentation?: string | null, source?: string | null } | null } } | null, sorting: { __typename?: 'constructionSorting', index: number } }>, names: Array<{ __typename?: 'constructionName', id: any, label: string, languageCode: string, translationSource: string }> } | null };

export type ConstructionFieldsFragment = { __typename?: 'construction', id: any, internalId: string, isCustom: boolean, isPublic: boolean, category: { __typename?: 'materialCategory', id: string, label?: string | null }, descriptions: Array<{ __typename?: 'constructionDescription', id: any, label: string, languageCode: string, translationSource: string }>, materials: Array<{ __typename?: 'constructionMaterial', id: any, amount: any, height?: any | null, length?: any | null, material?: { __typename?: 'material', createdAt?: any | null, createdBy: any, biogenicParams?: { __typename?: 'materialBiogenicParams', id: any, packaging: any, product: any } | null, category: { __typename?: 'materialCategory', id: string, label?: string | null }, declaredUnit: { __typename?: 'declaredUnit', id: any, value: any, unit: { __typename?: 'unit', id: number, label: string, fullName: string, pluralFullName: string } }, descriptions: Array<{ __typename?: 'materialDescription', id: any, label: string, languageCode: string, translationSource?: string | null }>, names: Array<{ __typename?: 'materialName', id: any, label: string, languageCode: string, translationSource: string }>, emissions: Array<{ __typename?: 'materialStage', id: any, indicators: Array<{ __typename?: 'materialEmissionIndicator', id: any, source: IndicatorSource_Enum, value: any, indicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, identifier_label?: string | null, label: string, unit?: string | null } }>, stage: { __typename?: 'stage', id: number, label: string } }>, epd: { __typename?: 'materialEpd', declarationNumber?: string | null, publicationDate: any, version: string, datasources: Array<{ __typename?: 'materialEpdDatasource', datasource: { __typename?: 'epdDatasource', id: any, name: string, url: string } }>, owner: { __typename?: 'epdOwner', id: any, name: string, email?: string | null, vatNumber?: string | null, phoneNumber?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, country?: Country_Enum | null }, productIndustry: { __typename?: 'epdProductIndustry', id: number, label: string }, specificationForm: { __typename?: 'epdSpecificationForm', id: number, label: string }, urls?: { __typename?: 'materialEpdUrl', documentation?: string | null, source?: string | null } | null } } | null, sorting: { __typename?: 'constructionSorting', index: number } }>, names: Array<{ __typename?: 'constructionName', id: any, label: string, languageCode: string, translationSource: string }> };

export type MaterialFieldsFragment = { __typename?: 'material', createdAt?: any | null, createdBy: any, biogenicParams?: { __typename?: 'materialBiogenicParams', id: any, packaging: any, product: any } | null, category: { __typename?: 'materialCategory', id: string, label?: string | null }, declaredUnit: { __typename?: 'declaredUnit', id: any, value: any, unit: { __typename?: 'unit', id: number, label: string, fullName: string, pluralFullName: string } }, descriptions: Array<{ __typename?: 'materialDescription', id: any, label: string, languageCode: string, translationSource?: string | null }>, names: Array<{ __typename?: 'materialName', id: any, label: string, languageCode: string, translationSource: string }>, emissions: Array<{ __typename?: 'materialStage', id: any, indicators: Array<{ __typename?: 'materialEmissionIndicator', id: any, source: IndicatorSource_Enum, value: any, indicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, identifier_label?: string | null, label: string, unit?: string | null } }>, stage: { __typename?: 'stage', id: number, label: string } }>, epd: { __typename?: 'materialEpd', declarationNumber?: string | null, publicationDate: any, version: string, datasources: Array<{ __typename?: 'materialEpdDatasource', datasource: { __typename?: 'epdDatasource', id: any, name: string, url: string } }>, owner: { __typename?: 'epdOwner', id: any, name: string, email?: string | null, vatNumber?: string | null, phoneNumber?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, country?: Country_Enum | null }, productIndustry: { __typename?: 'epdProductIndustry', id: number, label: string }, specificationForm: { __typename?: 'epdSpecificationForm', id: number, label: string }, urls?: { __typename?: 'materialEpdUrl', documentation?: string | null, source?: string | null } | null } };

export type SortingFieldsFragment = { __typename?: 'constructionSorting', index: number };

export type GetDenominatorUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDenominatorUnitsQuery = { __typename?: 'query_root', denominatorUnit: Array<{ __typename?: 'denominatorUnit', label: string, id: number, unit: string }> };

export type GetEmissionFactorSourcesQueryVariables = Exact<{
  country: Country_Enum;
  year: Scalars['Int']['input'];
}>;


export type GetEmissionFactorSourcesQuery = { __typename?: 'query_root', emission_factor_source: Array<{ __typename?: 'emission_factor_source', id: any, name: string, url: string, emissionFactorTypes: Array<{ __typename?: 'emissionFactorSourceType', emissionFactorType: Emission_Factor_Type_Enum, emissionFactorSourceId: any, label: string, installationInputDenominatorUnit?: { __typename?: 'denominatorUnit', unit: string } | null, installationInputIndicatorType?: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null, identifier_label?: string | null } | null, operationalInputDenominatorUnit?: { __typename?: 'denominatorUnit', unit: string } | null, operationalInputIndicatorType?: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null, identifier_label?: string | null } | null }>, emissionFactors: Array<{ __typename?: 'emission_factor', emission_factor_type: Emission_Factor_Type_Enum, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } }>, emissionFactors_aggregate: { __typename?: 'emission_factor_aggregate', nodes: Array<{ __typename?: 'emission_factor', emission_factor_type: Emission_Factor_Type_Enum }> } }> };

export type GetEmissionFactorSumQueryVariables = Exact<{
  emissionFactorSourceId: Scalars['uuid']['input'];
  emissionFactorType: Emission_Factor_Type_Enum;
  minYear: Scalars['Int']['input'];
  maxYear: Scalars['Int']['input'];
}>;


export type GetEmissionFactorSumQuery = { __typename?: 'query_root', emission_factor_aggregate: { __typename?: 'emission_factor_aggregate', aggregate?: { __typename?: 'emission_factor_aggregate_fields', sum?: { __typename?: 'emission_factor_sum_fields', emission?: any | null } | null } | null } };

export type GetEpdDatasourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEpdDatasourcesQuery = { __typename?: 'query_root', epdDatasource: Array<{ __typename?: 'epdDatasource', id: any, name: string, url: string }> };

export type GetIndicatorTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndicatorTypesQuery = { __typename?: 'query_root', indicatorType: Array<{ __typename?: 'indicatorType', identifier?: string | null, label: string, id: number, unit?: string | null }> };

export type GetIndicatorTypeMappingsQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetIndicatorTypeMappingsQuery = { __typename?: 'query_root', indicatorTypeMapping: Array<{ __typename?: 'indicatorTypeMapping', id: any, country: Country_Enum, denominatorUnit?: { __typename?: 'denominatorUnit', label: string, id: number, unit: string } | null, indicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null, identifier_label?: string | null }, calculationType: Array<{ __typename?: 'calculationType', id: number }> }> };

export type GetLevelsLifetimesQueryVariables = Exact<{
  sourceId: Scalars['uuid']['input'];
}>;


export type GetLevelsLifetimesQuery = { __typename?: 'query_root', buildingPartLifetimeSource: Array<{ __typename?: 'buildingPartLifetimeSource', id: any, label: string, source?: string | null, serviceLifetimes: Array<{ __typename?: 'buildingPartServiceLifetime', id: any, lifetimeAverage: number, lifetimeLow?: number | null, lifetimeHigh?: number | null, buildingElementId?: any | null, buildingPart?: { __typename?: 'buildingPart', id: any, label: string, parent_id?: any | null } | null }> }>, buildingPart: Array<{ __typename?: 'buildingPart', id: any, label: string }>, building_element: Array<{ __typename?: 'building_element', id: any, label: string }> };

export type GetLibraryCountryDatasourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLibraryCountryDatasourcesQuery = { __typename?: 'query_root', calculationType: Array<{ __typename?: 'calculationType', id: number, country: Country_Enum, label: string }>, calculationTypeEpdDatasource: Array<{ __typename?: 'calculationTypeEpdDatasource', calculationTypeId: number, epdDatasourceId: any }> };

export type GetMaterialCategoryTextureByIdQueryVariables = Exact<{
  categoryIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMaterialCategoryTextureByIdQuery = { __typename?: 'query_root', materialCategoryTexture: Array<{ __typename?: 'materialCategoryTexture', materialCategoryId: string, url: string }> };

export type GetMaterialFavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaterialFavoritesQuery = { __typename?: 'query_root', userMaterialFavorite: Array<{ __typename?: 'userMaterialFavorite', materialInternalId: any }> };

export type GetMaterialQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetMaterialQuery = { __typename?: 'query_root', material?: { __typename?: 'material', id: any, isPublic: boolean, lifetime: number, description?: string | null, name?: string | null, type: MaterialType_Enum, validTo: any, createdAt?: any | null, createdBy: any, updatedAt?: any | null, updatedBy?: any | null, categoryId: string, deprecated: boolean, faulty: boolean, category: { __typename?: 'materialCategory', id: string, label?: string | null }, declaredUnit: { __typename?: 'declaredUnit', id: any, value: any, unit: { __typename?: 'unit', id: number, label: string, fullName: string, pluralFullName: string } }, epd: { __typename?: 'materialEpd', id: any, declarationNumber?: string | null, publicationDate: any, version: string, datasources: Array<{ __typename?: 'materialEpdDatasource', datasource: { __typename?: 'epdDatasource', id: any, name: string, url: string } }>, owner: { __typename?: 'epdOwner', id: any, name: string, vatNumber?: string | null, street?: string | null, streetNumber?: string | null, country?: Country_Enum | null, city?: string | null }, productIndustry: { __typename?: 'epdProductIndustry', id: number, label: string }, specificationForm: { __typename?: 'epdSpecificationForm', id: number, label: string }, urls?: { __typename?: 'materialEpdUrl', id: any, documentation?: string | null, source?: string | null } | null }, emissions: Array<{ __typename?: 'materialStage', indicators: Array<{ __typename?: 'materialEmissionIndicator', id: any, value: any, source: IndicatorSource_Enum, indicatorType: { __typename?: 'indicatorType', id: number, label: string, identifier_label?: string | null, unit?: string | null } }>, stage: { __typename?: 'stage', id: number, label: string } }>, weightPerDeclaredUnit: { __typename?: 'weightPerDeclaredUnit', id: any, value?: any | null, denominatorUnit?: { __typename?: 'unit', id: number, label: string } | null, unit: { __typename?: 'unit', id: number, label: string, fullName: string, pluralFullName: string } } } | null };

export type GetMaterialTenantCollectionItemsQueryVariables = Exact<{
  materialInternalId: Scalars['String']['input'];
}>;


export type GetMaterialTenantCollectionItemsQuery = { __typename?: 'query_root', tenantCollectionItem: Array<{ __typename?: 'tenantCollectionItem', tenantCollectionId: any, materialInternalId: string }> };

export type GetMaterialWasteTypesByCountryQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetMaterialWasteTypesByCountryQuery = { __typename?: 'query_root', materialWasteType: Array<{ __typename?: 'materialWasteType', id: any, materialCategoryId?: string | null, label: string, value: any, wasteSource: { __typename?: 'materialWasteSource', id: any, denominatorUnitId?: number | null, source: string, sourceName?: string | null, indicatorType?: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null } | null, denominatorUnit?: { __typename?: 'denominatorUnit', id: number, unit: string } | null, unit?: { __typename?: 'unit', id: number, fullName: string, label: string, pluralFullName: string } | null } }> };

export type GetModelsQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetModelsQuery = { __typename?: 'query_root', model: Array<{ __typename?: 'model', id: any, name: string }> };

export type GetProjectByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetProjectByIdQuery = { __typename?: 'query_root', project_by_pk?: { __typename?: 'project', id: any, name: string, projectNumber?: string | null, role?: string | null, speckleStreamId?: string | null, area?: any | null, yearOfCommissioning: number, yearOfConstruction: number, lcaResponsibleName?: string | null, numberOfPeople?: any | null, buildingAreas: Array<{ __typename?: 'projectBuildingArea', id: any, buildingTypeId: number, buildingAreaType: BuildingAreaType_Enum, area: any, floors: number, heatedArea: any }>, buildingType: { __typename?: 'buildingType', id: number, label: string }, projectStatus?: { __typename?: 'projectStatus', id: number, label: string } | null, calculation?: { __typename?: 'projectCalculation', id: any, considerationPeriod: number, useDefaultEmissions: boolean, calculationType: { __typename?: 'calculationType', id: number, label: string, variant?: { __typename?: 'calculationTypeVariant', id: any, variant: string } | null, thresholdIndicator: { __typename?: 'indicatorTypeMapping', id: any, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null }, denominatorUnit?: { __typename?: 'denominatorUnit', id: number, unit: string } | null } }, stages: Array<{ __typename?: 'projectCalculationStage', id: any, stage: { __typename?: 'stage', id: number, label: string } }> } | null, installation?: { __typename?: 'projectInstallation', wastagePercentage?: { __typename?: 'projectEmissionFactor', id: any, value: any } | null } | null, location?: { __typename?: 'projectLocation', city: string, country: string } | null, specialConditionConfig?: { __typename?: 'projectSpecialConditionConfig', enabled: boolean } | null } | null };

export type GetProjectEmissionFactorCustomSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectEmissionFactorCustomSourcesQuery = { __typename?: 'query_root', projectEmissionFactorCustom: Array<{ __typename?: 'projectEmissionFactorCustom', id: any, name: string, description?: string | null, emissionValue: any, createdAt: any, deletedAt?: any | null, emissionFactorType: Emission_Factor_Type_Enum, projectEmissionFactors_aggregate: { __typename?: 'projectEmissionFactor_aggregate', aggregate?: { __typename?: 'projectEmissionFactor_aggregate_fields', count: number } | null } }> };

export type GetProjectListFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectListFiltersQuery = { __typename?: 'query_root', buildingType: Array<{ __typename?: 'project', buildingType: { __typename?: 'buildingType', id: number, label: string } }>, projectCalculation: Array<{ __typename?: 'projectCalculation', calculationType: { __typename?: 'calculationType', id: number, label: string } }>, projectLocation: Array<{ __typename?: 'projectLocation', id: any, country: string }>, projectMembership: Array<{ __typename?: 'projectMembership', role: string, membershipRole: { __typename?: 'roles', id: string, level: number } }>, projectStatus: Array<{ __typename?: 'project', projectStatus?: { __typename?: 'projectStatus', id: number, label: string } | null }> };

export type GetProjectListQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<Project_Order_By> | Project_Order_By>;
  where?: InputMaybe<Project_Bool_Exp>;
}>;


export type GetProjectListQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', area?: any | null, createdAt: any, favorite?: boolean | null, updatedAt?: any | null, id: any, name: string, role?: string | null, speckleStreamId?: string | null, activeRevision: { __typename?: 'projectRevision', id: any, name: string }, revisions: Array<{ __typename?: 'projectRevision', id: any }>, buildingType: { __typename?: 'buildingType', id: number, label: string }, calculation?: { __typename?: 'projectCalculation', calculationType: { __typename?: 'calculationType', id: number, label: string } } | null, location?: { __typename?: 'projectLocation', city: string, country: string, postalCode: string, id: any, street: string, streetNumber: string } | null, memberships: Array<{ __typename?: 'projectMembership', role: string, userId: string }>, models: Array<{ __typename?: 'projectModel', id: string, name: string }>, projectStatus?: { __typename?: 'projectStatus', id: number, label: string } | null, specialConditionConfig?: { __typename?: 'projectSpecialConditionConfig', enabled: boolean } | null }> };

export type GetProjectOperationalQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectOperationalQuery = { __typename?: 'query_root', projectOperational: Array<{ __typename?: 'projectOperational', id: any, heatSupply?: { __typename?: 'projectEmissionFactor', id: any, type: Emission_Factor_Type_Enum, value: any, sourceId?: any | null, customSourceId?: any | null, emissionFactorSource?: { __typename?: 'emission_factor_source', id: any, name: string } | null, customEmissionFactor?: { __typename?: 'projectEmissionFactorCustom', id: any, name: string } | null } | null, electricitySupply?: { __typename?: 'projectEmissionFactor', id: any, type: Emission_Factor_Type_Enum, value: any, sourceId?: any | null, customSourceId?: any | null, emissionFactorSource?: { __typename?: 'emission_factor_source', id: any, name: string } | null, customEmissionFactor?: { __typename?: 'projectEmissionFactorCustom', id: any, name: string } | null } | null }> };

export type GetProjectPermissionsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectPermissionsQuery = { __typename?: 'query_root', project_by_pk?: { __typename?: 'project', id: any, role?: string | null } | null, roles: Array<{ __typename?: 'roles', id: string, permissions: Array<string> }> };

export type GetProjectQueryVariables = Exact<{
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  revisionFilter?: InputMaybe<Project_Transport_Bool_Exp>;
  defaultRevisionFilter?: InputMaybe<Project_Transport_Default_Bool_Exp>;
}>;


export type GetProjectQuery = { __typename?: 'query_root', project_transport: Array<{ __typename?: 'project_transport', distance: any, emission?: any | null, transport_type_name?: string | null, id: any, project_id: any, tenant_id: string, transport: { __typename?: 'transport', id: any, isDefault: boolean, emission: any, label: string, transportType: Transport_Type_Enum, indicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null, identifier_label?: string | null } } }>, project_transport_default: Array<{ __typename?: 'project_transport_default', project_transport_id: any }> };

export type GetProjectRevisionsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectRevisionsQuery = { __typename?: 'query_root', projectRevision: Array<{ __typename?: 'projectRevision', id: any, name: string, projectName?: string | null, projectNumber?: string | null, clientName?: string | null, builderName?: string | null, lcaResponsibleName?: string | null, numberOfPeople?: any | null, buildingTypeId?: number | null, projectStatusId?: number | null, yearOfConstruction?: number | null, yearOfCommissioning?: number | null, versionNumber: number, parentRevisionId?: any | null, deletedAt?: any | null, martenVersion: number, createdBy: any, createdAt: any, frozenAt?: any | null, location?: { __typename?: 'projectLocation', street: string, streetNumber: string, postalCode: string, city: string, country: string } | null, calculation?: { __typename?: 'projectCalculation', stages: Array<{ __typename?: 'projectCalculationStage', stage: { __typename?: 'stage', label: string } }> } | null, models: Array<{ __typename?: 'projectModel', name: string, referencedObjectId?: string | null, commitId?: string | null, speckleModelId?: string | null }>, transports: Array<{ __typename?: 'project_transport', distance: any, emission?: any | null, transport_type_name?: string | null, id: any, project_id: any, tenant_id: string, transport: { __typename?: 'transport', id: any, isDefault: boolean, emission: any, label: string, transportType: Transport_Type_Enum, indicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null, identifier_label?: string | null } } }>, transportDefaults: Array<{ __typename?: 'project_transport_default', project_transport_id: any }>, operational?: { __typename?: 'projectOperational', validatedAt?: any | null, validatedBy?: string | null, heatSupply?: { __typename?: 'projectEmissionFactor', id: any, type: Emission_Factor_Type_Enum, value: any, sourceId?: any | null, customSourceId?: any | null, description?: string | null, customEmissionFactor?: { __typename?: 'projectEmissionFactorCustom', description?: string | null } | null } | null, electricitySupply?: { __typename?: 'projectEmissionFactor', id: any, type: Emission_Factor_Type_Enum, value: any, sourceId?: any | null, customSourceId?: any | null, description?: string | null, customEmissionFactor?: { __typename?: 'projectEmissionFactorCustom', description?: string | null } | null } | null, exportedElectricity?: { __typename?: 'projectEmissionFactor', id: any, type: Emission_Factor_Type_Enum, value: any, sourceId?: any | null, customSourceId?: any | null, description?: string | null, customEmissionFactor?: { __typename?: 'projectEmissionFactorCustom', description?: string | null } | null } | null } | null }> };

export type RevisionEmissionFactorFragment = { __typename?: 'projectEmissionFactor', id: any, type: Emission_Factor_Type_Enum, value: any, sourceId?: any | null, customSourceId?: any | null, description?: string | null, customEmissionFactor?: { __typename?: 'projectEmissionFactorCustom', description?: string | null } | null };

export type GetProjectSettingsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectSettingsQuery = { __typename?: 'query_root', project?: { __typename?: 'project', id: any, name: string, projectNumber?: string | null, clientName?: string | null, builderName?: string | null, lcaResponsibleName?: string | null, numberOfPeople?: any | null, buildingTypeId: number, projectStatusId?: number | null, yearOfConstruction: number, yearOfCommissioning: number, speckleStreamId?: string | null, location?: { __typename?: 'projectLocation', street: string, streetNumber: string, postalCode: string, city: string, country: string } | null, calculation?: { __typename?: 'projectCalculation', calculationTypeId: number, considerationPeriod: number, thresholdLimit: any, installationThresholdLimit?: any | null, useDefaultEmissions: boolean, stages: Array<{ __typename?: 'projectCalculationStage', stageId: number }>, calculationType: { __typename?: 'calculationType', thresholdIndicator: { __typename?: 'indicatorTypeMapping', indicatorType: { __typename?: 'indicatorType', id: number } } } } | null, buildingAreas: Array<{ __typename?: 'projectBuildingArea', buildingTypeId: number, buildingAreaType: BuildingAreaType_Enum, area: any, floors: number, heatedArea: any }>, referenceAreas: Array<{ __typename?: 'projectReferenceArea', referenceAreaTypeKey: string, area: any, description?: string | null }>, installation?: { __typename?: 'projectInstallation', wastagePercentage?: { __typename?: 'projectEmissionFactor', value: any } | null, earthMovedByMachinery?: { __typename?: 'projectEmissionFactor', sourceId?: any | null, customSourceId?: any | null, description?: string | null, type: Emission_Factor_Type_Enum, value: any } | null, electricitySupply?: { __typename?: 'projectEmissionFactor', sourceId?: any | null, customSourceId?: any | null, description?: string | null, type: Emission_Factor_Type_Enum, value: any } | null, heatSupply?: { __typename?: 'projectEmissionFactor', sourceId?: any | null, customSourceId?: any | null, description?: string | null, type: Emission_Factor_Type_Enum, value: any } | null, machineryFuel?: { __typename?: 'projectEmissionFactor', sourceId?: any | null, customSourceId?: any | null, description?: string | null, type: Emission_Factor_Type_Enum, value: any } | null } | null, operational?: { __typename?: 'projectOperational', validatedBy?: string | null, validatedAt?: any | null, exportedElectricity?: { __typename?: 'projectEmissionFactor', value: any } | null, electricitySupply?: { __typename?: 'projectEmissionFactor', sourceId?: any | null, customSourceId?: any | null, description?: string | null, type: Emission_Factor_Type_Enum, value: any } | null, heatSupply?: { __typename?: 'projectEmissionFactor', sourceId?: any | null, customSourceId?: any | null, description?: string | null, type: Emission_Factor_Type_Enum, value: any } | null } | null, models: Array<{ __typename?: 'projectModel', id: string, name: string, active: boolean, commitId?: string | null, pulledAt?: any | null, referencedObjectId?: string | null, speckleModelId?: string | null }>, specialConditionConfig?: { __typename?: 'projectSpecialConditionConfig', enabled: boolean } | null } | null, speckleParameterConfig?: { __typename?: 'projectSpeckleParameterConfig', classificationTypeId?: any | null, classificationCode: string } | null };

export type SettingsEmissionFactorFragment = { __typename?: 'projectEmissionFactor', sourceId?: any | null, customSourceId?: any | null, description?: string | null, type: Emission_Factor_Type_Enum, value: any };

export type GetProjectSpecialConditionTypeMappingQueryVariables = Exact<{
  buildingProjectId: Scalars['uuid']['input'];
  model: Scalars['String']['input'];
  typeIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  revisionFilter?: InputMaybe<ProjectSpecialConditionTypeMapping_Bool_Exp>;
}>;


export type GetProjectSpecialConditionTypeMappingQuery = { __typename?: 'query_root', projectSpecialConditionTypeMapping: Array<{ __typename?: 'projectSpecialConditionTypeMapping', areaOfConstruction?: any | null, description?: string | null, id: any, length?: any | null, model: string, typeIdentifier?: string | null, specialConditionType: { __typename?: 'specialConditionType', id: any, country: Country_Enum, buildingPart: { __typename?: 'buildingPart', label: string }, specialConditionTypeCategory: { __typename?: 'special_condition_type_category', id: any, label: string, specialConditionTypeInputParameter?: { __typename?: 'specialConditionTypeInputParameter', parameter: Array<string>, specialConditionTypeCategoryId: any } | null } } }> };

export type GetProjectSpeckleStreamIdQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectSpeckleStreamIdQuery = { __typename?: 'query_root', project?: { __typename?: 'project', id: any, speckleStreamId?: string | null } | null };

export type GetProjectStandardValueStagesQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  revisionFilter?: InputMaybe<ProjectStandardValueStage_Bool_Exp>;
}>;


export type GetProjectStandardValueStagesQuery = { __typename?: 'query_root', projectStandardValueStage: Array<{ __typename?: 'projectStandardValueStage', id: any, projectId: any, stageId: any, stage: { __typename?: 'stageDefaultEmission', id: any, label: string } }> };

export type GetProjectSwitcherListQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type GetProjectSwitcherListQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', id: any, name: string, projectStatus?: { __typename?: 'projectStatus', id: number } | null }> };

export type GetProjectTransportMappingQueryVariables = Exact<{
  project_id: Scalars['uuid']['input'];
  materialIdIsNull: Scalars['Boolean']['input'];
  revisionFilter?: InputMaybe<Project_Transport_Mapping_Bool_Exp>;
}>;


export type GetProjectTransportMappingQuery = { __typename?: 'query_root', project_transport_mapping: Array<{ __typename?: 'project_transport_mapping', distance: any, id: any, created_at: any, material_id?: any | null, project_id: any, project_transport_id?: any | null, updated_at: any, transportEmissionFactorEmission?: any | null, emissionFactors: Array<{ __typename?: 'projectTransportMappingEmissionFactor', id: any, transportEmissionFactorId: any, emissionFactor: { __typename?: 'transportEmissionFactor', id: any, label: string, emission: any, denominatorUnit: { __typename?: 'denominatorUnit', id: number }, transportSource?: { __typename?: 'transportSource', id: any, label: string, datasource: string } | null } }>, transportStandardValue?: { __typename?: 'transport_standard_value', id: any, mainGroup: string, emission: any, subGroup: string, transportSource?: { __typename?: 'transportSource', id: any, label: string, datasource: string } | null } | null }> };

export type GetProjectVersionsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectVersionsQuery = { __typename?: 'query_root', projectVersionNumbered: Array<{ __typename?: 'projectVersionNumbered', id?: any | null, versionNumber?: number | null, revisionId?: any | null, entityType?: string | null, entityId?: any | null, entityLabel?: string | null, operation?: string | null, summary?: string | null, changes?: any | null, source?: string | null, informational?: boolean | null, martenVersion?: number | null, createdBy?: any | null, createdAt?: any | null }>, project_by_pk?: { __typename?: 'project', id: any, sourceProjectId?: any | null, sourceVersionId?: any | null, sourceVersionNumber?: number | null, sourceProject?: { __typename?: 'project', id: any, name: string, deletedAt?: any | null, sourceProjectId?: any | null, sourceVersionId?: any | null, sourceVersionNumber?: number | null, sourceProject?: { __typename?: 'project', id: any, name: string, deletedAt?: any | null, sourceProjectId?: any | null, sourceVersionId?: any | null, sourceVersionNumber?: number | null, sourceProject?: { __typename?: 'project', id: any, name: string, deletedAt?: any | null, sourceProjectId?: any | null, sourceVersionId?: any | null, sourceVersionNumber?: number | null, sourceProject?: { __typename?: 'project', id: any, name: string, deletedAt?: any | null, sourceProjectId?: any | null, sourceVersionId?: any | null, sourceVersionNumber?: number | null, sourceProject?: { __typename?: 'project', id: any, name: string, deletedAt?: any | null, sourceProjectId?: any | null } | null } | null } | null } | null } | null } | null };

export type GetProjectWasteMappingsQueryVariables = Exact<{
  country?: InputMaybe<Country_Enum>;
  projectId: Scalars['uuid']['input'];
  mappingRevisionFilter?: InputMaybe<ProjectWasteMapping_Bool_Exp>;
  customTypeRevisionFilter?: InputMaybe<ProjectWasteTypeCustom_Bool_Exp>;
}>;


export type GetProjectWasteMappingsQuery = { __typename?: 'query_root', materialWasteSource: Array<{ __typename?: 'materialWasteSource', id: any, denominatorUnitId?: number | null, source: string, sourceName?: string | null, materialWasteTypes: Array<{ __typename?: 'materialWasteType', id: any, materialCategoryId?: string | null, label: string, value: any }>, indicatorType?: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null } | null, denominatorUnit?: { __typename?: 'denominatorUnit', id: number, unit: string } | null, unit?: { __typename?: 'unit', id: number, fullName: string, label: string, pluralFullName: string } | null }>, projectWasteMapping: Array<{ __typename?: 'projectWasteMapping', id: any, label?: string | null, materialId?: any | null, materialWasteTypeId?: any | null, pickupDate?: any | null, customWeight?: any | null, materialWeightSnapshot?: any | null, customWasteType?: { __typename?: 'projectWasteTypeCustom', id: any, label: string } | null }>, projectWasteTypeCustom: Array<{ __typename?: 'projectWasteTypeCustom', id: any, label: string }> };

export type GetRecentProjectsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
}>;


export type GetRecentProjectsQuery = { __typename?: 'query_root', userProjectView: Array<{ __typename?: 'userProjectView', projectId: any, viewedAt: any, project: { __typename?: 'project', id: any, name: string, projectStatus?: { __typename?: 'projectStatus', id: number } | null } }> };

export type GetReferenceAreaTypesQueryVariables = Exact<{
  calculationType: Scalars['Int']['input'];
}>;


export type GetReferenceAreaTypesQuery = { __typename?: 'query_root', referenceAreaTypeCalculationTypeMapping: Array<{ __typename?: 'referenceAreaTypeCalculationTypeMapping', referenceAreaType: { __typename?: 'referenceAreaType', id: number, label: string, multiplier?: any | null, key: string } }> };

export type GetSpecialConditionTypesQueryVariables = Exact<{
  calculationTypeId: Scalars['Int']['input'];
}>;


export type GetSpecialConditionTypesQuery = { __typename?: 'query_root', specialConditionType: Array<{ __typename?: 'specialConditionType', id: any, country: Country_Enum, buildingPart: { __typename?: 'buildingPart', label: string }, specialConditionTypeCategory: { __typename?: 'special_condition_type_category', id: any, label: string, specialConditionTypeInputParameter?: { __typename?: 'specialConditionTypeInputParameter', parameter: Array<string>, specialConditionTypeCategoryId: any } | null } }> };

export type GetStageDefaultEmissionQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetStageDefaultEmissionQuery = { __typename?: 'query_root', stageDefaultEmission: Array<{ __typename?: 'stageDefaultEmission', id: any, value: any, country: Country_Enum, label: string, denominatorUnit?: { __typename?: 'denominatorUnit', unit: string, id: number } | null, indicatorType: { __typename?: 'indicatorType', unit?: string | null, id: number }, stage: { __typename?: 'stage', id: number, label: string }, stageDefaultEmissionBuildingTypes: Array<{ __typename?: 'stage_default_emission_building_type', id: any, buildingTypeId: number }>, countryConfig?: { __typename?: 'countryConfig', useStageDefaultEmission: boolean } | null }> };

export type GetTenantCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantCollectionQuery = { __typename?: 'query_root', tenantCollection: Array<{ __typename?: 'tenantCollection', id: any, name: string, tenantId: any, collectionType: string }> };

export type GetTenantProjectsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type GetTenantProjectsQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', id: any, name: string, createdAt: any, updatedAt?: any | null, area?: any | null, projectStatus?: { __typename?: 'projectStatus', label: string } | null, buildingType: { __typename?: 'buildingType', label: string }, calculation?: { __typename?: 'projectCalculation', calculationType: { __typename?: 'calculationType', label: string } } | null, buildingAreas: Array<{ __typename?: 'projectBuildingArea', area: any }> }> };

export type GetTenantUsageByStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantUsageByStatusQuery = { __typename?: 'query_root', projectTenantStatusArea: Array<{ __typename?: 'projectTenantStatusArea', tenantId?: string | null, projectStatus?: string | null, totalArea?: any | null }> };

export type GetTransportSourcesProjectInstallationQueryVariables = Exact<{
  calculationTypeId: Scalars['Int']['input'];
}>;


export type GetTransportSourcesProjectInstallationQuery = { __typename?: 'query_root', transportSource: Array<{ __typename?: 'transportSource', id: any, datasource: string, label: string, calculationTypes: Array<{ __typename?: 'transportSourceCalculationType', calculationType: { __typename?: 'calculationType', id: number, thresholdIndicator: { __typename?: 'indicatorTypeMapping', id: any, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } } } }>, transportEmissionFactors: Array<{ __typename?: 'transportEmissionFactor', id: any, label: string, emission: any, isDefault: boolean, transportSourceId?: any | null, denominatorUnit: { __typename?: 'denominatorUnit', id: number, label: string, unit: string }, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } }>, transportStandardValues: Array<{ __typename?: 'transport_standard_value', id: any, emission: any, mainGroup: string, subGroup: string, denominatorUnit?: { __typename?: 'unit', id: number, label: string } | null }> }> };

export type GetTransportSourcesQueryVariables = Exact<{
  calculationTypeId: Scalars['Int']['input'];
}>;


export type GetTransportSourcesQuery = { __typename?: 'query_root', transportSource: Array<{ __typename?: 'transportSource', id: any, datasource: string, label: string, calculationTypes: Array<{ __typename?: 'transportSourceCalculationType', calculationType: { __typename?: 'calculationType', id: number, thresholdIndicator: { __typename?: 'indicatorTypeMapping', id: any, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } } } }>, transportEmissionFactors: Array<{ __typename?: 'transportEmissionFactor', id: any, label: string, emission: any, isDefault: boolean, transportSourceId?: any | null, denominatorUnit: { __typename?: 'denominatorUnit', id: number, label: string, unit: string }, indicatorType: { __typename?: 'indicatorType', id: number, unit?: string | null } }>, transportStandardValues: Array<{ __typename?: 'transport_standard_value', id: any, emission: any, mainGroup: string, subGroup: string, denominatorUnit?: { __typename?: 'unit', id: number, label: string } | null }> }> };

export type GetTransportTypeOptionsQueryVariables = Exact<{
  country: Country_Enum;
}>;


export type GetTransportTypeOptionsQuery = { __typename?: 'query_root', transport: Array<{ __typename?: 'transport', id: any, isDefault: boolean, label: string, country: Country_Enum, datasource?: string | null, distance: any, distance_unit: Distance_Unit_Enum, emission: any, transportType: Transport_Type_Enum, denominatorUnit: { __typename?: 'denominatorUnit', id: number, label: string, unit: string }, indicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null }, totalDenominatorUnit: { __typename?: 'denominatorUnit', id: number, label: string, unit: string }, totalIndicatorType: { __typename?: 'indicatorType', id: number, identifier?: string | null, label: string, unit?: string | null } }> };

export type GetUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitsQuery = { __typename?: 'query_root', unit: Array<{ __typename?: 'unit', fullName: string, id: number, label: string, pluralFullName: string }> };

export type GetUserTutorialViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTutorialViewQuery = { __typename?: 'query_root', userTutorialView: Array<{ __typename?: 'userTutorialView', externalId: string, userId: any, viewedAt: any }> };

export type GetUserWelcomeFlowQueryVariables = Exact<{
  flowKey: Scalars['String']['input'];
}>;


export type GetUserWelcomeFlowQuery = { __typename?: 'query_root', userWelcomeFlow: Array<{ __typename?: 'userWelcomeFlow', userId: any, flowKey: string, variant: string, seenAt: any, completedAt?: any | null }> };

export type GetUserWelcomeFlowRowsQueryVariables = Exact<{
  flowKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetUserWelcomeFlowRowsQuery = { __typename?: 'query_root', userWelcomeFlow: Array<{ __typename?: 'userWelcomeFlow', userId: any, flowKey: string, variant: string, seenAt: any, completedAt?: any | null }> };

export type GetProjectModelsSubscriptionVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectModelsSubscription = { __typename?: 'subscription_root', projectModel: Array<{ __typename?: 'projectModel', id: string, name: string, active: boolean, commitId?: string | null, pulledAt?: any | null, referencedObjectId?: string | null, speckleModelId?: string | null }> };

export type GetProjectSpeckleCopySubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetProjectSpeckleCopySubscription = { __typename?: 'subscription_root', projectSpeckleCopyRecent: Array<{ __typename?: 'projectSpeckleCopyRecent', projectId?: any | null, state?: string | null, errorMessage?: string | null, project?: { __typename?: 'project', name: string } | null }> };

export type GetProjectSpeckleModelSyncSubscriptionVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectSpeckleModelSyncSubscription = { __typename?: 'subscription_root', projectSpeckleModelSyncRecent: Array<{ __typename?: 'projectSpeckleModelSyncRecent', projectId?: any | null, state?: string | null, attempts?: number | null, errorMessage?: string | null, requestedAt?: any | null, lastUpdated?: any | null }> };

export type GetSpeckleStreamModelIfcUploadSubscriptionVariables = Exact<{
  speckleProjectId: Scalars['String']['input'];
}>;


export type GetSpeckleStreamModelIfcUploadSubscription = { __typename?: 'subscription_root', speckleStreamModelIfcUploadRecent: Array<{ __typename?: 'speckleStreamModelIfcUploadRecent', speckleProjectId?: string | null, errorMessage?: string | null }> };

export type ProjectActiveRevisionSubscriptionVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectActiveRevisionSubscription = { __typename?: 'subscription_root', project_by_pk?: { __typename?: 'project', id: any, activeRevisionId: any, activeRevision: { __typename?: 'projectRevision', id: any, name: string } } | null };

export type ProjectListUpdatedSubscriptionVariables = Exact<{
  where?: InputMaybe<Project_Bool_Exp>;
}>;


export type ProjectListUpdatedSubscription = { __typename?: 'subscription_root', project: Array<{ __typename?: 'project', tenantId: string, area?: any | null, createdAt: any, favorite?: boolean | null, updatedAt?: any | null, id: any, name: string, role?: string | null, speckleStreamId?: string | null, activeRevision: { __typename?: 'projectRevision', id: any, name: string }, revisions: Array<{ __typename?: 'projectRevision', id: any }>, buildingType: { __typename?: 'buildingType', id: number, label: string }, calculation?: { __typename?: 'projectCalculation', calculationType: { __typename?: 'calculationType', id: number, label: string } } | null, location?: { __typename?: 'projectLocation', city: string, country: string, postalCode: string, id: any, street: string, streetNumber: string } | null, memberships: Array<{ __typename?: 'projectMembership', role: string, userId: string }>, models: Array<{ __typename?: 'projectModel', id: string, name: string }>, projectStatus?: { __typename?: 'projectStatus', id: number, label: string } | null, specialConditionConfig?: { __typename?: 'projectSpecialConditionConfig', enabled: boolean } | null }> };

export const CalculationTypeFragmentFragmentDoc = gql`
    fragment calculationTypeFragment on calculationType {
  considerationPeriod
  country
  id
  label
  specialConditionTypes_aggregate(distinct_on: [calculationTypeId]) {
    aggregate {
      count
    }
  }
  stages {
    stage {
      id
      label
    }
  }
  threshold
  thresholdIndicator {
    id
    denominatorUnit {
      id
      label
      unit
    }
    indicatorType {
      id
      unit
    }
  }
  thresholdByBuildingType(order_by: {maxTotalArea: desc_nulls_last}) {
    buildingTypeId
    id
    maxTotalArea
    installationThreshold
    threshold
  }
  variant {
    id
    variant
  }
}
    `;
export const MaterialWasteSourceFragmentDoc = gql`
    fragment materialWasteSource on materialWasteSource {
  id
  indicatorType {
    id
    identifier
    label
    unit
  }
  denominatorUnitId
  denominatorUnit {
    id
    unit
  }
  source
  sourceName
  unit {
    id
    fullName
    label
    pluralFullName
  }
}
    `;
export const MaterialWasteTypeFragmentDoc = gql`
    fragment materialWasteType on materialWasteType {
  id
  materialCategoryId
  label
  value
}
    `;
export const ProjectBaseFragmentDoc = gql`
    fragment projectBase on project {
  id
  name
  role
  speckleStreamId
}
    `;
export const ProjectListFragmentDoc = gql`
    fragment projectList on project {
  ...projectBase
  activeRevision {
    id
    name
  }
  revisions(limit: 2) {
    id
  }
  area
  buildingType {
    id
    label
  }
  calculation {
    calculationType {
      id
      label
    }
  }
  createdAt
  favorite
  location {
    city
    country
    postalCode
    id
    street
    streetNumber
  }
  memberships {
    role
    userId
  }
  models {
    id
    name
  }
  projectStatus {
    id
    label
  }
  specialConditionConfig {
    enabled
  }
  updatedAt
}
    ${ProjectBaseFragmentDoc}`;
export const ProjectTransportMappingFragmentFragmentDoc = gql`
    fragment projectTransportMappingFragment on project_transport_mapping {
  distance
  id
  created_at
  material_id
  project_id
  project_transport_id
  updated_at
  transportEmissionFactorEmission
  emissionFactors {
    id
    emissionFactor {
      id
      label
      emission
      transportSource {
        id
        label
        datasource
      }
    }
  }
  transportStandardValue {
    id
    mainGroup
    subGroup
    emission
    transportSource {
      id
      label
      datasource
    }
  }
}
    `;
export const ProjectTransportRowFragmentDoc = gql`
    fragment projectTransportRow on project_transport {
  distance
  emission
  transport_type_name
  id
  project_id
  tenant_id
  transport {
    id
    isDefault
    emission
    label
    transportType
    indicatorType {
      id
      identifier
      label
      unit
      identifier_label
    }
  }
}
    `;
export const ProjectWasteMappingFragmentDoc = gql`
    fragment projectWasteMapping on projectWasteMapping {
  id
  label
  materialId
  materialWasteTypeId
  pickupDate
  customWeight
  materialWeightSnapshot
  customWasteType {
    id
    label
  }
}
    `;
export const ProjectWasteTypeCustomFragmentDoc = gql`
    fragment projectWasteTypeCustom on projectWasteTypeCustom {
  id
  label
}
    `;
export const SpecialConditionTypeFragmentFragmentDoc = gql`
    fragment specialConditionTypeFragment on specialConditionType {
  id
  buildingPart {
    label
  }
  country
  specialConditionTypeCategory {
    id
    label
    specialConditionTypeInputParameter {
      parameter
      specialConditionTypeCategoryId
    }
  }
}
    `;
export const TransportSourceFragmentFragmentDoc = gql`
    fragment transportSourceFragment on transportSource {
  id
  datasource
  label
  calculationTypes(where: {calculationType: {id: {_eq: $calculationTypeId}}}) {
    calculationType {
      id
      thresholdIndicator {
        id
        indicatorType {
          id
          unit
        }
      }
    }
  }
  transportEmissionFactors(order_by: {label: asc, isDefault: desc}) {
    id
    label
    emission
    isDefault
    transportSourceId
    denominatorUnit {
      id
      label
      unit
    }
    indicatorType {
      id
      unit
    }
  }
  transportStandardValues {
    id
    emission
    denominatorUnit {
      id
      label
    }
    mainGroup
    subGroup
  }
}
    `;
export const MaterialFieldsFragmentDoc = gql`
    fragment materialFields on material {
  biogenicParams {
    id
    packaging
    product
  }
  category {
    id
    label
  }
  createdAt
  createdBy
  declaredUnit {
    id
    unit {
      id
      label
      fullName
      pluralFullName
    }
    value
  }
  descriptions {
    id
    label
    languageCode
    translationSource
  }
  names {
    id
    label
    languageCode
    translationSource
  }
  emissions {
    id
    indicators {
      id
      indicatorType {
        id
        identifier
        identifier_label
        label
        unit
      }
      source
      value
    }
    stage {
      id
      label
    }
  }
  epd {
    datasources {
      datasource {
        id
        name
        url
      }
    }
    declarationNumber
    owner {
      id
      name
      email
      vatNumber
      phoneNumber
      street
      streetNumber
      city
      country
    }
    productIndustry {
      id
      label
    }
    publicationDate
    specificationForm {
      id
      label
    }
    urls {
      documentation
      source
    }
    version
  }
}
    `;
export const SortingFieldsFragmentDoc = gql`
    fragment sortingFields on constructionSorting {
  index
}
    `;
export const ConstructionFieldsFragmentDoc = gql`
    fragment constructionFields on construction {
  id
  internalId
  category {
    id
    label
  }
  descriptions {
    id
    label
    languageCode
    translationSource
  }
  isCustom
  isPublic
  materials {
    id
    amount
    height
    length
    material {
      ...materialFields
    }
    sorting {
      ...sortingFields
    }
  }
  names {
    id
    label
    languageCode
    translationSource
  }
}
    ${MaterialFieldsFragmentDoc}
${SortingFieldsFragmentDoc}`;
export const RevisionEmissionFactorFragmentDoc = gql`
    fragment revisionEmissionFactor on projectEmissionFactor {
  id
  type
  value
  sourceId
  customSourceId
  description
  customEmissionFactor {
    description
  }
}
    `;
export const SettingsEmissionFactorFragmentDoc = gql`
    fragment settingsEmissionFactor on projectEmissionFactor {
  sourceId
  customSourceId
  description
  type
  value
}
    `;
export const DeleteMaterialFavoriteDocument = gql`
    mutation DeleteMaterialFavorite($materialInternalId: uuid!) {
  delete_userMaterialFavorite(
    where: {materialInternalId: {_eq: $materialInternalId}}
  ) {
    returning {
      materialInternalId
      createdAt
    }
  }
}
    `;

/**
 * __useDeleteMaterialFavoriteMutation__
 *
 * To run a mutation, you first call `useDeleteMaterialFavoriteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaterialFavoriteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMaterialFavoriteMutation({
 *   variables: {
 *     materialInternalId: // value for 'materialInternalId'
 *   },
 * });
 */
export function useDeleteMaterialFavoriteMutation(options: VueApolloComposable.UseMutationOptions<DeleteMaterialFavoriteMutation, DeleteMaterialFavoriteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMaterialFavoriteMutation, DeleteMaterialFavoriteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMaterialFavoriteMutation, DeleteMaterialFavoriteMutationVariables>(DeleteMaterialFavoriteDocument, options);
}
export type DeleteMaterialFavoriteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMaterialFavoriteMutation, DeleteMaterialFavoriteMutationVariables>;
export const DeleteProjectEmissionFactorCustomDocument = gql`
    mutation DeleteProjectEmissionFactorCustom($id: uuid!, $deletedAt: timestamptz!) {
  update_projectEmissionFactorCustom_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: $deletedAt}
  ) {
    id
    deletedAt
  }
}
    `;

/**
 * __useDeleteProjectEmissionFactorCustomMutation__
 *
 * To run a mutation, you first call `useDeleteProjectEmissionFactorCustomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectEmissionFactorCustomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectEmissionFactorCustomMutation({
 *   variables: {
 *     id: // value for 'id'
 *     deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useDeleteProjectEmissionFactorCustomMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectEmissionFactorCustomMutation, DeleteProjectEmissionFactorCustomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectEmissionFactorCustomMutation, DeleteProjectEmissionFactorCustomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectEmissionFactorCustomMutation, DeleteProjectEmissionFactorCustomMutationVariables>(DeleteProjectEmissionFactorCustomDocument, options);
}
export type DeleteProjectEmissionFactorCustomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectEmissionFactorCustomMutation, DeleteProjectEmissionFactorCustomMutationVariables>;
export const DeleteProjectSpecialConditionTypeMappingDocument = gql`
    mutation deleteProjectSpecialConditionTypeMapping($projectId: uuid!, $model: String!, $typeIdentifier: String!) {
  delete_projectSpecialConditionTypeMapping(
    where: {projectId: {_eq: $projectId}, model: {_eq: $model}, typeIdentifier: {_eq: $typeIdentifier}}
  ) {
    affected_rows
  }
}
    `;

/**
 * __useDeleteProjectSpecialConditionTypeMappingMutation__
 *
 * To run a mutation, you first call `useDeleteProjectSpecialConditionTypeMappingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectSpecialConditionTypeMappingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectSpecialConditionTypeMappingMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     model: // value for 'model'
 *     typeIdentifier: // value for 'typeIdentifier'
 *   },
 * });
 */
export function useDeleteProjectSpecialConditionTypeMappingMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectSpecialConditionTypeMappingMutation, DeleteProjectSpecialConditionTypeMappingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectSpecialConditionTypeMappingMutation, DeleteProjectSpecialConditionTypeMappingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectSpecialConditionTypeMappingMutation, DeleteProjectSpecialConditionTypeMappingMutationVariables>(DeleteProjectSpecialConditionTypeMappingDocument, options);
}
export type DeleteProjectSpecialConditionTypeMappingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectSpecialConditionTypeMappingMutation, DeleteProjectSpecialConditionTypeMappingMutationVariables>;
export const DeleteProjectSpecialConditionTypeMappingWithVersionDocument = gql`
    mutation DeleteProjectSpecialConditionTypeMappingWithVersion($projectId: uuid!, $model: String!, $typeIdentifier: String!, $version: projectVersion_insert_input!) {
  delete_projectSpecialConditionTypeMapping(
    where: {projectId: {_eq: $projectId}, model: {_eq: $model}, typeIdentifier: {_eq: $typeIdentifier}}
  ) {
    affected_rows
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useDeleteProjectSpecialConditionTypeMappingWithVersionMutation__
 *
 * To run a mutation, you first call `useDeleteProjectSpecialConditionTypeMappingWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectSpecialConditionTypeMappingWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectSpecialConditionTypeMappingWithVersionMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     model: // value for 'model'
 *     typeIdentifier: // value for 'typeIdentifier'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useDeleteProjectSpecialConditionTypeMappingWithVersionMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectSpecialConditionTypeMappingWithVersionMutation, DeleteProjectSpecialConditionTypeMappingWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectSpecialConditionTypeMappingWithVersionMutation, DeleteProjectSpecialConditionTypeMappingWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectSpecialConditionTypeMappingWithVersionMutation, DeleteProjectSpecialConditionTypeMappingWithVersionMutationVariables>(DeleteProjectSpecialConditionTypeMappingWithVersionDocument, options);
}
export type DeleteProjectSpecialConditionTypeMappingWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectSpecialConditionTypeMappingWithVersionMutation, DeleteProjectSpecialConditionTypeMappingWithVersionMutationVariables>;
export const DeleteProjectStandardValueStagesDocument = gql`
    mutation DeleteProjectStandardValueStages($projectId: uuid!, $stageIds: [uuid!]!) {
  delete_projectStandardValueStage(
    where: {projectId: {_eq: $projectId}, stageId: {_in: $stageIds}}
  ) {
    affected_rows
  }
}
    `;

/**
 * __useDeleteProjectStandardValueStagesMutation__
 *
 * To run a mutation, you first call `useDeleteProjectStandardValueStagesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectStandardValueStagesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectStandardValueStagesMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     stageIds: // value for 'stageIds'
 *   },
 * });
 */
export function useDeleteProjectStandardValueStagesMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectStandardValueStagesMutation, DeleteProjectStandardValueStagesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectStandardValueStagesMutation, DeleteProjectStandardValueStagesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectStandardValueStagesMutation, DeleteProjectStandardValueStagesMutationVariables>(DeleteProjectStandardValueStagesDocument, options);
}
export type DeleteProjectStandardValueStagesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectStandardValueStagesMutation, DeleteProjectStandardValueStagesMutationVariables>;
export const DeleteProjectTransportMappingEmissionFactorsMutationDocument = gql`
    mutation DeleteProjectTransportMappingEmissionFactorsMutation($id: uuid!, $projectId: uuid!) {
  delete_projectTransportMappingEmissionFactor(
    where: {projectTransportMapping: {id: {_eq: $id}, project_id: {_eq: $projectId}}}
  ) {
    affected_rows
  }
}
    `;

/**
 * __useDeleteProjectTransportMappingEmissionFactorsMutationMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTransportMappingEmissionFactorsMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTransportMappingEmissionFactorsMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectTransportMappingEmissionFactorsMutationMutation({
 *   variables: {
 *     id: // value for 'id'
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectTransportMappingEmissionFactorsMutationMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectTransportMappingEmissionFactorsMutationMutation, DeleteProjectTransportMappingEmissionFactorsMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectTransportMappingEmissionFactorsMutationMutation, DeleteProjectTransportMappingEmissionFactorsMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectTransportMappingEmissionFactorsMutationMutation, DeleteProjectTransportMappingEmissionFactorsMutationMutationVariables>(DeleteProjectTransportMappingEmissionFactorsMutationDocument, options);
}
export type DeleteProjectTransportMappingEmissionFactorsMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectTransportMappingEmissionFactorsMutationMutation, DeleteProjectTransportMappingEmissionFactorsMutationMutationVariables>;
export const DeleteProjectTransportMappingDocument = gql`
    mutation DeleteProjectTransportMapping($id: uuid!, $projectId: uuid!) {
  delete_project_transport_mapping(
    where: {id: {_eq: $id}, project_id: {_eq: $projectId}}
  ) {
    affected_rows
  }
}
    `;

/**
 * __useDeleteProjectTransportMappingMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTransportMappingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTransportMappingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectTransportMappingMutation({
 *   variables: {
 *     id: // value for 'id'
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectTransportMappingMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectTransportMappingMutation, DeleteProjectTransportMappingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectTransportMappingMutation, DeleteProjectTransportMappingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectTransportMappingMutation, DeleteProjectTransportMappingMutationVariables>(DeleteProjectTransportMappingDocument, options);
}
export type DeleteProjectTransportMappingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectTransportMappingMutation, DeleteProjectTransportMappingMutationVariables>;
export const DeleteProjectTransportMappingWithVersionDocument = gql`
    mutation DeleteProjectTransportMappingWithVersion($id: uuid!, $projectId: uuid!, $version: projectVersion_insert_input!) {
  delete_projectTransportMappingEmissionFactor(
    where: {projectTransportMapping: {id: {_eq: $id}, project_id: {_eq: $projectId}}}
  ) {
    affected_rows
  }
  delete_project_transport_mapping(
    where: {id: {_eq: $id}, project_id: {_eq: $projectId}}
  ) {
    affected_rows
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useDeleteProjectTransportMappingWithVersionMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTransportMappingWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTransportMappingWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectTransportMappingWithVersionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     projectId: // value for 'projectId'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useDeleteProjectTransportMappingWithVersionMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectTransportMappingWithVersionMutation, DeleteProjectTransportMappingWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectTransportMappingWithVersionMutation, DeleteProjectTransportMappingWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectTransportMappingWithVersionMutation, DeleteProjectTransportMappingWithVersionMutationVariables>(DeleteProjectTransportMappingWithVersionDocument, options);
}
export type DeleteProjectTransportMappingWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectTransportMappingWithVersionMutation, DeleteProjectTransportMappingWithVersionMutationVariables>;
export const DeleteProjectTransportDocument = gql`
    mutation DeleteProjectTransport($projectId: uuid!) {
  delete_project_transport(where: {project_id: {_eq: $projectId}}) {
    affected_rows
  }
}
    `;

/**
 * __useDeleteProjectTransportMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTransportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTransportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectTransportMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectTransportMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectTransportMutation, DeleteProjectTransportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectTransportMutation, DeleteProjectTransportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectTransportMutation, DeleteProjectTransportMutationVariables>(DeleteProjectTransportDocument, options);
}
export type DeleteProjectTransportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectTransportMutation, DeleteProjectTransportMutationVariables>;
export const DeleteProjectWasteMappingDocument = gql`
    mutation DeleteProjectWasteMapping($id: uuid!) {
  delete_projectWasteMapping_by_pk(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteProjectWasteMappingMutation__
 *
 * To run a mutation, you first call `useDeleteProjectWasteMappingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectWasteMappingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectWasteMappingMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectWasteMappingMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectWasteMappingMutation, DeleteProjectWasteMappingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectWasteMappingMutation, DeleteProjectWasteMappingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectWasteMappingMutation, DeleteProjectWasteMappingMutationVariables>(DeleteProjectWasteMappingDocument, options);
}
export type DeleteProjectWasteMappingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectWasteMappingMutation, DeleteProjectWasteMappingMutationVariables>;
export const DeleteProjectWasteMappingWithVersionDocument = gql`
    mutation DeleteProjectWasteMappingWithVersion($id: uuid!, $version: projectVersion_insert_input!) {
  delete_projectWasteMapping_by_pk(id: $id) {
    id
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useDeleteProjectWasteMappingWithVersionMutation__
 *
 * To run a mutation, you first call `useDeleteProjectWasteMappingWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectWasteMappingWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectWasteMappingWithVersionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useDeleteProjectWasteMappingWithVersionMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectWasteMappingWithVersionMutation, DeleteProjectWasteMappingWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectWasteMappingWithVersionMutation, DeleteProjectWasteMappingWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectWasteMappingWithVersionMutation, DeleteProjectWasteMappingWithVersionMutationVariables>(DeleteProjectWasteMappingWithVersionDocument, options);
}
export type DeleteProjectWasteMappingWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectWasteMappingWithVersionMutation, DeleteProjectWasteMappingWithVersionMutationVariables>;
export const DeleteProjectWasteTypeCustomDocument = gql`
    mutation DeleteProjectWasteTypeCustom($id: uuid!) {
  delete_projectWasteTypeCustom_by_pk(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteProjectWasteTypeCustomMutation__
 *
 * To run a mutation, you first call `useDeleteProjectWasteTypeCustomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectWasteTypeCustomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectWasteTypeCustomMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectWasteTypeCustomMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectWasteTypeCustomMutation, DeleteProjectWasteTypeCustomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectWasteTypeCustomMutation, DeleteProjectWasteTypeCustomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectWasteTypeCustomMutation, DeleteProjectWasteTypeCustomMutationVariables>(DeleteProjectWasteTypeCustomDocument, options);
}
export type DeleteProjectWasteTypeCustomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectWasteTypeCustomMutation, DeleteProjectWasteTypeCustomMutationVariables>;
export const DeleteProjectWasteTypeCustomWithVersionDocument = gql`
    mutation DeleteProjectWasteTypeCustomWithVersion($id: uuid!, $version: projectVersion_insert_input!) {
  delete_projectWasteTypeCustom_by_pk(id: $id) {
    id
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useDeleteProjectWasteTypeCustomWithVersionMutation__
 *
 * To run a mutation, you first call `useDeleteProjectWasteTypeCustomWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectWasteTypeCustomWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectWasteTypeCustomWithVersionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useDeleteProjectWasteTypeCustomWithVersionMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectWasteTypeCustomWithVersionMutation, DeleteProjectWasteTypeCustomWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectWasteTypeCustomWithVersionMutation, DeleteProjectWasteTypeCustomWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectWasteTypeCustomWithVersionMutation, DeleteProjectWasteTypeCustomWithVersionMutationVariables>(DeleteProjectWasteTypeCustomWithVersionDocument, options);
}
export type DeleteProjectWasteTypeCustomWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectWasteTypeCustomWithVersionMutation, DeleteProjectWasteTypeCustomWithVersionMutationVariables>;
export const DeleteTenantCollectionItemDocument = gql`
    mutation DeleteTenantCollectionItem($tenantCollectionId: uuid!, $materialInternalId: String!) {
  delete_tenantCollectionItem(
    where: {tenantCollectionId: {_eq: $tenantCollectionId}, materialInternalId: {_eq: $materialInternalId}}
  ) {
    returning {
      materialInternalId
      tenantCollectionId
    }
  }
}
    `;

/**
 * __useDeleteTenantCollectionItemMutation__
 *
 * To run a mutation, you first call `useDeleteTenantCollectionItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantCollectionItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTenantCollectionItemMutation({
 *   variables: {
 *     tenantCollectionId: // value for 'tenantCollectionId'
 *     materialInternalId: // value for 'materialInternalId'
 *   },
 * });
 */
export function useDeleteTenantCollectionItemMutation(options: VueApolloComposable.UseMutationOptions<DeleteTenantCollectionItemMutation, DeleteTenantCollectionItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteTenantCollectionItemMutation, DeleteTenantCollectionItemMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteTenantCollectionItemMutation, DeleteTenantCollectionItemMutationVariables>(DeleteTenantCollectionItemDocument, options);
}
export type DeleteTenantCollectionItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteTenantCollectionItemMutation, DeleteTenantCollectionItemMutationVariables>;
export const DeleteTenantCollectionDocument = gql`
    mutation DeleteTenantCollection($id: uuid!) {
  delete_tenantCollection(where: {id: {_eq: $id}}) {
    returning {
      id
      name
    }
  }
}
    `;

/**
 * __useDeleteTenantCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteTenantCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTenantCollectionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTenantCollectionMutation(options: VueApolloComposable.UseMutationOptions<DeleteTenantCollectionMutation, DeleteTenantCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteTenantCollectionMutation, DeleteTenantCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteTenantCollectionMutation, DeleteTenantCollectionMutationVariables>(DeleteTenantCollectionDocument, options);
}
export type DeleteTenantCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteTenantCollectionMutation, DeleteTenantCollectionMutationVariables>;
export const DeleteUserTutorialViewDocument = gql`
    mutation DeleteUserTutorialView($externalId: String!) {
  delete_userTutorialView(where: {externalId: {_eq: $externalId}}) {
    affected_rows
  }
}
    `;

/**
 * __useDeleteUserTutorialViewMutation__
 *
 * To run a mutation, you first call `useDeleteUserTutorialViewMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTutorialViewMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserTutorialViewMutation({
 *   variables: {
 *     externalId: // value for 'externalId'
 *   },
 * });
 */
export function useDeleteUserTutorialViewMutation(options: VueApolloComposable.UseMutationOptions<DeleteUserTutorialViewMutation, DeleteUserTutorialViewMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteUserTutorialViewMutation, DeleteUserTutorialViewMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteUserTutorialViewMutation, DeleteUserTutorialViewMutationVariables>(DeleteUserTutorialViewDocument, options);
}
export type DeleteUserTutorialViewMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteUserTutorialViewMutation, DeleteUserTutorialViewMutationVariables>;
export const InsertConstructionForkDocument = gql`
    mutation InsertConstructionFork($constructionId: uuid!, $parentConstructionId: uuid!, $constructionInternalId: String!, $tenantId: String!, $createdBy: uuid!) {
  insert_constructionFork_one(
    object: {constructionId: $constructionId, parentConstructionId: $parentConstructionId, constructionInternalId: $constructionInternalId, tenantId: $tenantId, createdBy: $createdBy}
  ) {
    constructionId
    parentConstructionId
  }
}
    `;

/**
 * __useInsertConstructionForkMutation__
 *
 * To run a mutation, you first call `useInsertConstructionForkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertConstructionForkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertConstructionForkMutation({
 *   variables: {
 *     constructionId: // value for 'constructionId'
 *     parentConstructionId: // value for 'parentConstructionId'
 *     constructionInternalId: // value for 'constructionInternalId'
 *     tenantId: // value for 'tenantId'
 *     createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useInsertConstructionForkMutation(options: VueApolloComposable.UseMutationOptions<InsertConstructionForkMutation, InsertConstructionForkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertConstructionForkMutation, InsertConstructionForkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertConstructionForkMutation, InsertConstructionForkMutationVariables>(InsertConstructionForkDocument, options);
}
export type InsertConstructionForkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertConstructionForkMutation, InsertConstructionForkMutationVariables>;
export const InsertMaterialFavoriteDocument = gql`
    mutation InsertMaterialFavorite($materialInternalId: uuid!) {
  insert_userMaterialFavorite(objects: {materialInternalId: $materialInternalId}) {
    returning {
      materialInternalId
    }
  }
}
    `;

/**
 * __useInsertMaterialFavoriteMutation__
 *
 * To run a mutation, you first call `useInsertMaterialFavoriteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertMaterialFavoriteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertMaterialFavoriteMutation({
 *   variables: {
 *     materialInternalId: // value for 'materialInternalId'
 *   },
 * });
 */
export function useInsertMaterialFavoriteMutation(options: VueApolloComposable.UseMutationOptions<InsertMaterialFavoriteMutation, InsertMaterialFavoriteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertMaterialFavoriteMutation, InsertMaterialFavoriteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertMaterialFavoriteMutation, InsertMaterialFavoriteMutationVariables>(InsertMaterialFavoriteDocument, options);
}
export type InsertMaterialFavoriteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertMaterialFavoriteMutation, InsertMaterialFavoriteMutationVariables>;
export const InsertMaterialForkDocument = gql`
    mutation InsertMaterialFork($materialId: uuid!, $parentMaterialId: uuid!, $materialInternalId: String!, $tenantId: String!, $createdBy: uuid!) {
  insert_materialFork_one(
    object: {materialId: $materialId, parentMaterialId: $parentMaterialId, materialInternalId: $materialInternalId, tenantId: $tenantId, createdBy: $createdBy}
  ) {
    materialId
    parentMaterialId
  }
}
    `;

/**
 * __useInsertMaterialForkMutation__
 *
 * To run a mutation, you first call `useInsertMaterialForkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertMaterialForkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertMaterialForkMutation({
 *   variables: {
 *     materialId: // value for 'materialId'
 *     parentMaterialId: // value for 'parentMaterialId'
 *     materialInternalId: // value for 'materialInternalId'
 *     tenantId: // value for 'tenantId'
 *     createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useInsertMaterialForkMutation(options: VueApolloComposable.UseMutationOptions<InsertMaterialForkMutation, InsertMaterialForkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertMaterialForkMutation, InsertMaterialForkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertMaterialForkMutation, InsertMaterialForkMutationVariables>(InsertMaterialForkDocument, options);
}
export type InsertMaterialForkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertMaterialForkMutation, InsertMaterialForkMutationVariables>;
export const InsertProjectEmissionFactorCustomDocument = gql`
    mutation InsertProjectEmissionFactorCustom($name: String!, $description: String, $emissionFactorType: emission_factor_type_enum!, $emissionValue: numeric!) {
  insert_projectEmissionFactorCustom_one(
    object: {name: $name, description: $description, type: $emissionFactorType, emissionValue: $emissionValue}
  ) {
    id
    name
    description
    emissionFactorType: type
    emissionValue
    createdAt
    projectEmissionFactors_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useInsertProjectEmissionFactorCustomMutation__
 *
 * To run a mutation, you first call `useInsertProjectEmissionFactorCustomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectEmissionFactorCustomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectEmissionFactorCustomMutation({
 *   variables: {
 *     name: // value for 'name'
 *     description: // value for 'description'
 *     emissionFactorType: // value for 'emissionFactorType'
 *     emissionValue: // value for 'emissionValue'
 *   },
 * });
 */
export function useInsertProjectEmissionFactorCustomMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectEmissionFactorCustomMutation, InsertProjectEmissionFactorCustomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectEmissionFactorCustomMutation, InsertProjectEmissionFactorCustomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectEmissionFactorCustomMutation, InsertProjectEmissionFactorCustomMutationVariables>(InsertProjectEmissionFactorCustomDocument, options);
}
export type InsertProjectEmissionFactorCustomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectEmissionFactorCustomMutation, InsertProjectEmissionFactorCustomMutationVariables>;
export const UpsertProjectMaterialWasteMappingDocument = gql`
    mutation UpsertProjectMaterialWasteMapping($id: uuid, $customWeight: numeric, $materialId: uuid!, $materialWasteTypeId: uuid, $projectId: uuid!, $materialWeightSnapshot: numeric) {
  insert_projectWasteMapping(
    objects: [{id: $id, customWeight: $customWeight, materialId: $materialId, materialWasteTypeId: $materialWasteTypeId, projectId: $projectId, materialWeightSnapshot: $materialWeightSnapshot}]
    on_conflict: {constraint: project_material_waste_mapping_pkey, update_columns: [customWeight, materialWasteTypeId, materialWeightSnapshot]}
  ) {
    affected_rows
  }
}
    `;

/**
 * __useUpsertProjectMaterialWasteMappingMutation__
 *
 * To run a mutation, you first call `useUpsertProjectMaterialWasteMappingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectMaterialWasteMappingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectMaterialWasteMappingMutation({
 *   variables: {
 *     id: // value for 'id'
 *     customWeight: // value for 'customWeight'
 *     materialId: // value for 'materialId'
 *     materialWasteTypeId: // value for 'materialWasteTypeId'
 *     projectId: // value for 'projectId'
 *     materialWeightSnapshot: // value for 'materialWeightSnapshot'
 *   },
 * });
 */
export function useUpsertProjectMaterialWasteMappingMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectMaterialWasteMappingMutation, UpsertProjectMaterialWasteMappingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectMaterialWasteMappingMutation, UpsertProjectMaterialWasteMappingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectMaterialWasteMappingMutation, UpsertProjectMaterialWasteMappingMutationVariables>(UpsertProjectMaterialWasteMappingDocument, options);
}
export type UpsertProjectMaterialWasteMappingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectMaterialWasteMappingMutation, UpsertProjectMaterialWasteMappingMutationVariables>;
export const InsertProjectModelDocument = gql`
    mutation InsertProjectModel($object: projectModel_insert_input!) {
  model: insert_projectModel_one(object: $object) {
    id
    name
    active
  }
}
    `;

/**
 * __useInsertProjectModelMutation__
 *
 * To run a mutation, you first call `useInsertProjectModelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectModelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectModelMutation({
 *   variables: {
 *     object: // value for 'object'
 *   },
 * });
 */
export function useInsertProjectModelMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectModelMutation, InsertProjectModelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectModelMutation, InsertProjectModelMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectModelMutation, InsertProjectModelMutationVariables>(InsertProjectModelDocument, options);
}
export type InsertProjectModelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectModelMutation, InsertProjectModelMutationVariables>;
export const InsertProjectSpecialConditionTypeMappingDocument = gql`
    mutation insertProjectSpecialConditionTypeMapping($areaOfConstruction: numeric, $description: String, $length: numeric, $model: String!, $projectId: uuid!, $specialConditionTypeId: uuid!, $typeIdentifier: String!) {
  insert_projectSpecialConditionTypeMapping(
    objects: {areaOfConstruction: $areaOfConstruction, description: $description, length: $length, model: $model, projectId: $projectId, specialConditionTypeId: $specialConditionTypeId, typeIdentifier: $typeIdentifier}
    on_conflict: {constraint: project_special_condition_type_mapping_model_project_id_type_id, update_columns: [areaOfConstruction, description, length, model, specialConditionTypeId]}
  ) {
    returning {
      typeIdentifier
      specialConditionTypeId
      projectId
      model
      length
      id
      description
      areaOfConstruction
    }
  }
}
    `;

/**
 * __useInsertProjectSpecialConditionTypeMappingMutation__
 *
 * To run a mutation, you first call `useInsertProjectSpecialConditionTypeMappingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectSpecialConditionTypeMappingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectSpecialConditionTypeMappingMutation({
 *   variables: {
 *     areaOfConstruction: // value for 'areaOfConstruction'
 *     description: // value for 'description'
 *     length: // value for 'length'
 *     model: // value for 'model'
 *     projectId: // value for 'projectId'
 *     specialConditionTypeId: // value for 'specialConditionTypeId'
 *     typeIdentifier: // value for 'typeIdentifier'
 *   },
 * });
 */
export function useInsertProjectSpecialConditionTypeMappingMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectSpecialConditionTypeMappingMutation, InsertProjectSpecialConditionTypeMappingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectSpecialConditionTypeMappingMutation, InsertProjectSpecialConditionTypeMappingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectSpecialConditionTypeMappingMutation, InsertProjectSpecialConditionTypeMappingMutationVariables>(InsertProjectSpecialConditionTypeMappingDocument, options);
}
export type InsertProjectSpecialConditionTypeMappingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectSpecialConditionTypeMappingMutation, InsertProjectSpecialConditionTypeMappingMutationVariables>;
export const InsertProjectSpecialConditionTypeMappingWithVersionDocument = gql`
    mutation InsertProjectSpecialConditionTypeMappingWithVersion($areaOfConstruction: numeric, $description: String, $length: numeric, $model: String!, $projectId: uuid!, $specialConditionTypeId: uuid!, $typeIdentifier: String!, $version: projectVersion_insert_input!) {
  insert_projectSpecialConditionTypeMapping(
    objects: {areaOfConstruction: $areaOfConstruction, description: $description, length: $length, model: $model, projectId: $projectId, specialConditionTypeId: $specialConditionTypeId, typeIdentifier: $typeIdentifier}
    on_conflict: {constraint: project_special_condition_type_mapping_model_project_id_type_id, update_columns: [areaOfConstruction, description, length, model, specialConditionTypeId]}
  ) {
    returning {
      typeIdentifier
      specialConditionTypeId
      projectId
      model
      length
      id
      description
      areaOfConstruction
    }
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useInsertProjectSpecialConditionTypeMappingWithVersionMutation__
 *
 * To run a mutation, you first call `useInsertProjectSpecialConditionTypeMappingWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectSpecialConditionTypeMappingWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectSpecialConditionTypeMappingWithVersionMutation({
 *   variables: {
 *     areaOfConstruction: // value for 'areaOfConstruction'
 *     description: // value for 'description'
 *     length: // value for 'length'
 *     model: // value for 'model'
 *     projectId: // value for 'projectId'
 *     specialConditionTypeId: // value for 'specialConditionTypeId'
 *     typeIdentifier: // value for 'typeIdentifier'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useInsertProjectSpecialConditionTypeMappingWithVersionMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectSpecialConditionTypeMappingWithVersionMutation, InsertProjectSpecialConditionTypeMappingWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectSpecialConditionTypeMappingWithVersionMutation, InsertProjectSpecialConditionTypeMappingWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectSpecialConditionTypeMappingWithVersionMutation, InsertProjectSpecialConditionTypeMappingWithVersionMutationVariables>(InsertProjectSpecialConditionTypeMappingWithVersionDocument, options);
}
export type InsertProjectSpecialConditionTypeMappingWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectSpecialConditionTypeMappingWithVersionMutation, InsertProjectSpecialConditionTypeMappingWithVersionMutationVariables>;
export const InsertProjectStandardValueStagesDocument = gql`
    mutation InsertProjectStandardValueStages($objects: [projectStandardValueStage_insert_input!]!) {
  insert_projectStandardValueStage(
    objects: $objects
    on_conflict: {constraint: project_standard_value_stage_stage_id_project_id_key, update_columns: []}
  ) {
    returning {
      id
      projectId
      stageId
    }
  }
}
    `;

/**
 * __useInsertProjectStandardValueStagesMutation__
 *
 * To run a mutation, you first call `useInsertProjectStandardValueStagesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectStandardValueStagesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectStandardValueStagesMutation({
 *   variables: {
 *     objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertProjectStandardValueStagesMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectStandardValueStagesMutation, InsertProjectStandardValueStagesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectStandardValueStagesMutation, InsertProjectStandardValueStagesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectStandardValueStagesMutation, InsertProjectStandardValueStagesMutationVariables>(InsertProjectStandardValueStagesDocument, options);
}
export type InsertProjectStandardValueStagesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectStandardValueStagesMutation, InsertProjectStandardValueStagesMutationVariables>;
export const InsertProjectTransportMappingDocument = gql`
    mutation InsertProjectTransportMapping($distance: numeric!, $material_id: uuid, $project_id: uuid!, $project_transport_id: uuid, $transportStandardValueId: uuid, $transportEmissionFactorEmission: numeric, $emissionFactors: projectTransportMappingEmissionFactor_arr_rel_insert_input) {
  insert_project_transport_mapping_one(
    object: {material_id: $material_id, project_id: $project_id, project_transport_id: $project_transport_id, distance: $distance, transportStandardValueId: $transportStandardValueId, transportEmissionFactorEmission: $transportEmissionFactorEmission, emissionFactors: $emissionFactors}
  ) {
    ...projectTransportMappingFragment
  }
}
    ${ProjectTransportMappingFragmentFragmentDoc}`;

/**
 * __useInsertProjectTransportMappingMutation__
 *
 * To run a mutation, you first call `useInsertProjectTransportMappingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectTransportMappingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectTransportMappingMutation({
 *   variables: {
 *     distance: // value for 'distance'
 *     material_id: // value for 'material_id'
 *     project_id: // value for 'project_id'
 *     project_transport_id: // value for 'project_transport_id'
 *     transportStandardValueId: // value for 'transportStandardValueId'
 *     transportEmissionFactorEmission: // value for 'transportEmissionFactorEmission'
 *     emissionFactors: // value for 'emissionFactors'
 *   },
 * });
 */
export function useInsertProjectTransportMappingMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectTransportMappingMutation, InsertProjectTransportMappingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectTransportMappingMutation, InsertProjectTransportMappingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectTransportMappingMutation, InsertProjectTransportMappingMutationVariables>(InsertProjectTransportMappingDocument, options);
}
export type InsertProjectTransportMappingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectTransportMappingMutation, InsertProjectTransportMappingMutationVariables>;
export const InsertProjectTransportMappingsDocument = gql`
    mutation InsertProjectTransportMappings($objects: [project_transport_mapping_insert_input!]!, $materialIdIsNull: Boolean!, $projectId: uuid!) {
  delete_projectTransportMappingEmissionFactor(
    where: {projectTransportMapping: {material_id: {_is_null: $materialIdIsNull}, project_id: {_eq: $projectId}}}
  ) {
    returning {
      id
    }
  }
  delete_project_transport_mapping(
    where: {material_id: {_is_null: $materialIdIsNull}, project_id: {_eq: $projectId}}
  ) {
    returning {
      id
    }
  }
  insert_project_transport_mapping(objects: $objects) {
    returning {
      ...projectTransportMappingFragment
    }
  }
}
    ${ProjectTransportMappingFragmentFragmentDoc}`;

/**
 * __useInsertProjectTransportMappingsMutation__
 *
 * To run a mutation, you first call `useInsertProjectTransportMappingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectTransportMappingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectTransportMappingsMutation({
 *   variables: {
 *     objects: // value for 'objects'
 *     materialIdIsNull: // value for 'materialIdIsNull'
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useInsertProjectTransportMappingsMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectTransportMappingsMutation, InsertProjectTransportMappingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectTransportMappingsMutation, InsertProjectTransportMappingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectTransportMappingsMutation, InsertProjectTransportMappingsMutationVariables>(InsertProjectTransportMappingsDocument, options);
}
export type InsertProjectTransportMappingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectTransportMappingsMutation, InsertProjectTransportMappingsMutationVariables>;
export const InsertProjectTransportDocument = gql`
    mutation InsertProjectTransport($objects: [project_transport_insert_input!]!) {
  insert_project_transport(
    objects: $objects
    on_conflict: {constraint: project_transport_id_project_id_key, update_columns: [distance, emission, transport_type_name, transportId]}
  ) {
    returning {
      id
    }
  }
}
    `;

/**
 * __useInsertProjectTransportMutation__
 *
 * To run a mutation, you first call `useInsertProjectTransportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectTransportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectTransportMutation({
 *   variables: {
 *     objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertProjectTransportMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectTransportMutation, InsertProjectTransportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectTransportMutation, InsertProjectTransportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectTransportMutation, InsertProjectTransportMutationVariables>(InsertProjectTransportDocument, options);
}
export type InsertProjectTransportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectTransportMutation, InsertProjectTransportMutationVariables>;
export const InsertProjectTransportWithVersionDocument = gql`
    mutation InsertProjectTransportWithVersion($objects: [project_transport_insert_input!]!, $version: projectVersion_insert_input!) {
  insert_project_transport(
    objects: $objects
    on_conflict: {constraint: project_transport_id_project_id_key, update_columns: [distance, emission, transport_type_name, transportId]}
  ) {
    returning {
      id
    }
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useInsertProjectTransportWithVersionMutation__
 *
 * To run a mutation, you first call `useInsertProjectTransportWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectTransportWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectTransportWithVersionMutation({
 *   variables: {
 *     objects: // value for 'objects'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useInsertProjectTransportWithVersionMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectTransportWithVersionMutation, InsertProjectTransportWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectTransportWithVersionMutation, InsertProjectTransportWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectTransportWithVersionMutation, InsertProjectTransportWithVersionMutationVariables>(InsertProjectTransportWithVersionDocument, options);
}
export type InsertProjectTransportWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectTransportWithVersionMutation, InsertProjectTransportWithVersionMutationVariables>;
export const InsertProjectVersionDocument = gql`
    mutation InsertProjectVersion($version: projectVersion_insert_input!) {
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useInsertProjectVersionMutation__
 *
 * To run a mutation, you first call `useInsertProjectVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertProjectVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertProjectVersionMutation({
 *   variables: {
 *     version: // value for 'version'
 *   },
 * });
 */
export function useInsertProjectVersionMutation(options: VueApolloComposable.UseMutationOptions<InsertProjectVersionMutation, InsertProjectVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertProjectVersionMutation, InsertProjectVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertProjectVersionMutation, InsertProjectVersionMutationVariables>(InsertProjectVersionDocument, options);
}
export type InsertProjectVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertProjectVersionMutation, InsertProjectVersionMutationVariables>;
export const InsertTenantCollectionItemDocument = gql`
    mutation InsertTenantCollectionItem($tenantCollectionId: uuid!, $materialInternalId: String!) {
  insert_tenantCollectionItem_one(
    object: {materialInternalId: $materialInternalId, tenantCollectionId: $tenantCollectionId}
  ) {
    materialInternalId
    tenantCollectionId
  }
}
    `;

/**
 * __useInsertTenantCollectionItemMutation__
 *
 * To run a mutation, you first call `useInsertTenantCollectionItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertTenantCollectionItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertTenantCollectionItemMutation({
 *   variables: {
 *     tenantCollectionId: // value for 'tenantCollectionId'
 *     materialInternalId: // value for 'materialInternalId'
 *   },
 * });
 */
export function useInsertTenantCollectionItemMutation(options: VueApolloComposable.UseMutationOptions<InsertTenantCollectionItemMutation, InsertTenantCollectionItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertTenantCollectionItemMutation, InsertTenantCollectionItemMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertTenantCollectionItemMutation, InsertTenantCollectionItemMutationVariables>(InsertTenantCollectionItemDocument, options);
}
export type InsertTenantCollectionItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertTenantCollectionItemMutation, InsertTenantCollectionItemMutationVariables>;
export const InsertUserPlatformReviewDocument = gql`
    mutation InsertUserPlatformReview($flowKey: String!, $score: Int!, $comment: String) {
  insert_userPlatformReview(
    objects: [{flowKey: $flowKey, score: $score, comment: $comment}]
  ) {
    affected_rows
  }
}
    `;

/**
 * __useInsertUserPlatformReviewMutation__
 *
 * To run a mutation, you first call `useInsertUserPlatformReviewMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserPlatformReviewMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertUserPlatformReviewMutation({
 *   variables: {
 *     flowKey: // value for 'flowKey'
 *     score: // value for 'score'
 *     comment: // value for 'comment'
 *   },
 * });
 */
export function useInsertUserPlatformReviewMutation(options: VueApolloComposable.UseMutationOptions<InsertUserPlatformReviewMutation, InsertUserPlatformReviewMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertUserPlatformReviewMutation, InsertUserPlatformReviewMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertUserPlatformReviewMutation, InsertUserPlatformReviewMutationVariables>(InsertUserPlatformReviewDocument, options);
}
export type InsertUserPlatformReviewMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertUserPlatformReviewMutation, InsertUserPlatformReviewMutationVariables>;
export const InsertUserTutorialViewDocument = gql`
    mutation InsertUserTutorialView($externalId: String!) {
  insert_userTutorialView_one(
    object: {externalId: $externalId}
    on_conflict: {constraint: user_tutorial_view_pkey, update_columns: [viewedAt]}
  ) {
    externalId
    viewedAt
  }
}
    `;

/**
 * __useInsertUserTutorialViewMutation__
 *
 * To run a mutation, you first call `useInsertUserTutorialViewMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserTutorialViewMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertUserTutorialViewMutation({
 *   variables: {
 *     externalId: // value for 'externalId'
 *   },
 * });
 */
export function useInsertUserTutorialViewMutation(options: VueApolloComposable.UseMutationOptions<InsertUserTutorialViewMutation, InsertUserTutorialViewMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertUserTutorialViewMutation, InsertUserTutorialViewMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertUserTutorialViewMutation, InsertUserTutorialViewMutationVariables>(InsertUserTutorialViewDocument, options);
}
export type InsertUserTutorialViewMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertUserTutorialViewMutation, InsertUserTutorialViewMutationVariables>;
export const InsertUserWelcomeFlowEventDocument = gql`
    mutation InsertUserWelcomeFlowEvent($flowKey: String!, $event: String!, $variant: String, $stepIndex: Int, $stepKey: String) {
  insert_userWelcomeFlowEvent(
    objects: [{flowKey: $flowKey, event: $event, variant: $variant, stepIndex: $stepIndex, stepKey: $stepKey}]
  ) {
    affected_rows
  }
}
    `;

/**
 * __useInsertUserWelcomeFlowEventMutation__
 *
 * To run a mutation, you first call `useInsertUserWelcomeFlowEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserWelcomeFlowEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertUserWelcomeFlowEventMutation({
 *   variables: {
 *     flowKey: // value for 'flowKey'
 *     event: // value for 'event'
 *     variant: // value for 'variant'
 *     stepIndex: // value for 'stepIndex'
 *     stepKey: // value for 'stepKey'
 *   },
 * });
 */
export function useInsertUserWelcomeFlowEventMutation(options: VueApolloComposable.UseMutationOptions<InsertUserWelcomeFlowEventMutation, InsertUserWelcomeFlowEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertUserWelcomeFlowEventMutation, InsertUserWelcomeFlowEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertUserWelcomeFlowEventMutation, InsertUserWelcomeFlowEventMutationVariables>(InsertUserWelcomeFlowEventDocument, options);
}
export type InsertUserWelcomeFlowEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertUserWelcomeFlowEventMutation, InsertUserWelcomeFlowEventMutationVariables>;
export const InsertUserWelcomeFlowDocument = gql`
    mutation InsertUserWelcomeFlow($flowKey: String!, $variant: String!) {
  insert_userWelcomeFlow_one(
    object: {flowKey: $flowKey, variant: $variant}
    on_conflict: {constraint: user_welcome_flow_pkey, update_columns: []}
  ) {
    userId
    flowKey
  }
}
    `;

/**
 * __useInsertUserWelcomeFlowMutation__
 *
 * To run a mutation, you first call `useInsertUserWelcomeFlowMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserWelcomeFlowMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertUserWelcomeFlowMutation({
 *   variables: {
 *     flowKey: // value for 'flowKey'
 *     variant: // value for 'variant'
 *   },
 * });
 */
export function useInsertUserWelcomeFlowMutation(options: VueApolloComposable.UseMutationOptions<InsertUserWelcomeFlowMutation, InsertUserWelcomeFlowMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertUserWelcomeFlowMutation, InsertUserWelcomeFlowMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertUserWelcomeFlowMutation, InsertUserWelcomeFlowMutationVariables>(InsertUserWelcomeFlowDocument, options);
}
export type InsertUserWelcomeFlowMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertUserWelcomeFlowMutation, InsertUserWelcomeFlowMutationVariables>;
export const ReplaceProjectBuildingAreasDocument = gql`
    mutation ReplaceProjectBuildingAreas($projectId: uuid!, $areas: [projectBuildingArea_insert_input!]!) {
  deleted: delete_projectBuildingArea(
    where: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}
  ) {
    affected_rows
  }
  inserted: insert_projectBuildingArea(objects: $areas) {
    affected_rows
    returning {
      id
      revisionId
      buildingTypeId
      buildingAreaType
      area
      floors
      heatedArea
    }
  }
}
    `;

/**
 * __useReplaceProjectBuildingAreasMutation__
 *
 * To run a mutation, you first call `useReplaceProjectBuildingAreasMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplaceProjectBuildingAreasMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplaceProjectBuildingAreasMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     areas: // value for 'areas'
 *   },
 * });
 */
export function useReplaceProjectBuildingAreasMutation(options: VueApolloComposable.UseMutationOptions<ReplaceProjectBuildingAreasMutation, ReplaceProjectBuildingAreasMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplaceProjectBuildingAreasMutation, ReplaceProjectBuildingAreasMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReplaceProjectBuildingAreasMutation, ReplaceProjectBuildingAreasMutationVariables>(ReplaceProjectBuildingAreasDocument, options);
}
export type ReplaceProjectBuildingAreasMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplaceProjectBuildingAreasMutation, ReplaceProjectBuildingAreasMutationVariables>;
export const ReplaceProjectBuildingAreasWithVersionDocument = gql`
    mutation ReplaceProjectBuildingAreasWithVersion($projectId: uuid!, $areas: [projectBuildingArea_insert_input!]!, $version: projectVersion_insert_input!) {
  deleted: delete_projectBuildingArea(
    where: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}
  ) {
    affected_rows
  }
  inserted: insert_projectBuildingArea(objects: $areas) {
    affected_rows
    returning {
      id
      revisionId
      buildingTypeId
      buildingAreaType
      area
      floors
      heatedArea
    }
  }
  version: insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useReplaceProjectBuildingAreasWithVersionMutation__
 *
 * To run a mutation, you first call `useReplaceProjectBuildingAreasWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplaceProjectBuildingAreasWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplaceProjectBuildingAreasWithVersionMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     areas: // value for 'areas'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useReplaceProjectBuildingAreasWithVersionMutation(options: VueApolloComposable.UseMutationOptions<ReplaceProjectBuildingAreasWithVersionMutation, ReplaceProjectBuildingAreasWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplaceProjectBuildingAreasWithVersionMutation, ReplaceProjectBuildingAreasWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReplaceProjectBuildingAreasWithVersionMutation, ReplaceProjectBuildingAreasWithVersionMutationVariables>(ReplaceProjectBuildingAreasWithVersionDocument, options);
}
export type ReplaceProjectBuildingAreasWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplaceProjectBuildingAreasWithVersionMutation, ReplaceProjectBuildingAreasWithVersionMutationVariables>;
export const ReplaceProjectModelsDocument = gql`
    mutation ReplaceProjectModels($projectId: uuid!, $models: [projectModel_insert_input!]!) {
  removed: delete_projectModel(
    where: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}
  ) {
    affected_rows
  }
  inserted: insert_projectModel(objects: $models) {
    affected_rows
  }
}
    `;

/**
 * __useReplaceProjectModelsMutation__
 *
 * To run a mutation, you first call `useReplaceProjectModelsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplaceProjectModelsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplaceProjectModelsMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     models: // value for 'models'
 *   },
 * });
 */
export function useReplaceProjectModelsMutation(options: VueApolloComposable.UseMutationOptions<ReplaceProjectModelsMutation, ReplaceProjectModelsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplaceProjectModelsMutation, ReplaceProjectModelsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReplaceProjectModelsMutation, ReplaceProjectModelsMutationVariables>(ReplaceProjectModelsDocument, options);
}
export type ReplaceProjectModelsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplaceProjectModelsMutation, ReplaceProjectModelsMutationVariables>;
export const ReplaceProjectModelsWithVersionDocument = gql`
    mutation ReplaceProjectModelsWithVersion($projectId: uuid!, $models: [projectModel_insert_input!]!, $version: projectVersion_insert_input!) {
  removed: delete_projectModel(
    where: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}
  ) {
    affected_rows
  }
  inserted: insert_projectModel(objects: $models) {
    affected_rows
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useReplaceProjectModelsWithVersionMutation__
 *
 * To run a mutation, you first call `useReplaceProjectModelsWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplaceProjectModelsWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplaceProjectModelsWithVersionMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     models: // value for 'models'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useReplaceProjectModelsWithVersionMutation(options: VueApolloComposable.UseMutationOptions<ReplaceProjectModelsWithVersionMutation, ReplaceProjectModelsWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplaceProjectModelsWithVersionMutation, ReplaceProjectModelsWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReplaceProjectModelsWithVersionMutation, ReplaceProjectModelsWithVersionMutationVariables>(ReplaceProjectModelsWithVersionDocument, options);
}
export type ReplaceProjectModelsWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplaceProjectModelsWithVersionMutation, ReplaceProjectModelsWithVersionMutationVariables>;
export const ReplaceProjectReferenceAreasDocument = gql`
    mutation ReplaceProjectReferenceAreas($projectId: uuid!, $areas: [projectReferenceArea_insert_input!]!) {
  deleted: delete_projectReferenceArea(
    where: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}
  ) {
    affected_rows
  }
  inserted: insert_projectReferenceArea(objects: $areas) {
    affected_rows
    returning {
      id
      revisionId
      referenceAreaTypeKey
      area
      description
    }
  }
}
    `;

/**
 * __useReplaceProjectReferenceAreasMutation__
 *
 * To run a mutation, you first call `useReplaceProjectReferenceAreasMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplaceProjectReferenceAreasMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplaceProjectReferenceAreasMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     areas: // value for 'areas'
 *   },
 * });
 */
export function useReplaceProjectReferenceAreasMutation(options: VueApolloComposable.UseMutationOptions<ReplaceProjectReferenceAreasMutation, ReplaceProjectReferenceAreasMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplaceProjectReferenceAreasMutation, ReplaceProjectReferenceAreasMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReplaceProjectReferenceAreasMutation, ReplaceProjectReferenceAreasMutationVariables>(ReplaceProjectReferenceAreasDocument, options);
}
export type ReplaceProjectReferenceAreasMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplaceProjectReferenceAreasMutation, ReplaceProjectReferenceAreasMutationVariables>;
export const ReplaceProjectReferenceAreasWithVersionDocument = gql`
    mutation ReplaceProjectReferenceAreasWithVersion($projectId: uuid!, $areas: [projectReferenceArea_insert_input!]!, $version: projectVersion_insert_input!) {
  deleted: delete_projectReferenceArea(
    where: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}
  ) {
    affected_rows
  }
  inserted: insert_projectReferenceArea(objects: $areas) {
    affected_rows
    returning {
      id
      revisionId
      referenceAreaTypeKey
      area
      description
    }
  }
  version: insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useReplaceProjectReferenceAreasWithVersionMutation__
 *
 * To run a mutation, you first call `useReplaceProjectReferenceAreasWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplaceProjectReferenceAreasWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplaceProjectReferenceAreasWithVersionMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     areas: // value for 'areas'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useReplaceProjectReferenceAreasWithVersionMutation(options: VueApolloComposable.UseMutationOptions<ReplaceProjectReferenceAreasWithVersionMutation, ReplaceProjectReferenceAreasWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplaceProjectReferenceAreasWithVersionMutation, ReplaceProjectReferenceAreasWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReplaceProjectReferenceAreasWithVersionMutation, ReplaceProjectReferenceAreasWithVersionMutationVariables>(ReplaceProjectReferenceAreasWithVersionDocument, options);
}
export type ReplaceProjectReferenceAreasWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplaceProjectReferenceAreasWithVersionMutation, ReplaceProjectReferenceAreasWithVersionMutationVariables>;
export const SaveProjectStandardValueStagesWithVersionDocument = gql`
    mutation SaveProjectStandardValueStagesWithVersion($objects: [projectStandardValueStage_insert_input!]!, $projectId: uuid!, $stageIds: [uuid!]!, $version: projectVersion_insert_input!) {
  insert_projectStandardValueStage(
    objects: $objects
    on_conflict: {constraint: project_standard_value_stage_stage_id_project_id_key, update_columns: []}
  ) {
    affected_rows
  }
  delete_projectStandardValueStage(
    where: {projectId: {_eq: $projectId}, stageId: {_in: $stageIds}}
  ) {
    affected_rows
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useSaveProjectStandardValueStagesWithVersionMutation__
 *
 * To run a mutation, you first call `useSaveProjectStandardValueStagesWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectStandardValueStagesWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveProjectStandardValueStagesWithVersionMutation({
 *   variables: {
 *     objects: // value for 'objects'
 *     projectId: // value for 'projectId'
 *     stageIds: // value for 'stageIds'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useSaveProjectStandardValueStagesWithVersionMutation(options: VueApolloComposable.UseMutationOptions<SaveProjectStandardValueStagesWithVersionMutation, SaveProjectStandardValueStagesWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveProjectStandardValueStagesWithVersionMutation, SaveProjectStandardValueStagesWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveProjectStandardValueStagesWithVersionMutation, SaveProjectStandardValueStagesWithVersionMutationVariables>(SaveProjectStandardValueStagesWithVersionDocument, options);
}
export type SaveProjectStandardValueStagesWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveProjectStandardValueStagesWithVersionMutation, SaveProjectStandardValueStagesWithVersionMutationVariables>;
export const UpdateProjectEmissionFactorCustomDocument = gql`
    mutation UpdateProjectEmissionFactorCustom($id: uuid!, $name: String!, $description: String, $emissionFactorType: emission_factor_type_enum!, $emissionValue: numeric!) {
  update_projectEmissionFactorCustom_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, description: $description, type: $emissionFactorType, emissionValue: $emissionValue}
  ) {
    id
    name
    description
    emissionFactorType: type
    emissionValue
    createdAt
    projectEmissionFactors_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useUpdateProjectEmissionFactorCustomMutation__
 *
 * To run a mutation, you first call `useUpdateProjectEmissionFactorCustomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectEmissionFactorCustomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProjectEmissionFactorCustomMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *     description: // value for 'description'
 *     emissionFactorType: // value for 'emissionFactorType'
 *     emissionValue: // value for 'emissionValue'
 *   },
 * });
 */
export function useUpdateProjectEmissionFactorCustomMutation(options: VueApolloComposable.UseMutationOptions<UpdateProjectEmissionFactorCustomMutation, UpdateProjectEmissionFactorCustomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProjectEmissionFactorCustomMutation, UpdateProjectEmissionFactorCustomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateProjectEmissionFactorCustomMutation, UpdateProjectEmissionFactorCustomMutationVariables>(UpdateProjectEmissionFactorCustomDocument, options);
}
export type UpdateProjectEmissionFactorCustomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProjectEmissionFactorCustomMutation, UpdateProjectEmissionFactorCustomMutationVariables>;
export const UpdateProjectRevisionDocument = gql`
    mutation UpdateProjectRevision($id: uuid!, $set: projectRevision_set_input!) {
  update_projectRevision(where: {id: {_eq: $id}}, _set: $set) {
    affected_rows
  }
}
    `;

/**
 * __useUpdateProjectRevisionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRevisionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRevisionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProjectRevisionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     set: // value for 'set'
 *   },
 * });
 */
export function useUpdateProjectRevisionMutation(options: VueApolloComposable.UseMutationOptions<UpdateProjectRevisionMutation, UpdateProjectRevisionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProjectRevisionMutation, UpdateProjectRevisionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateProjectRevisionMutation, UpdateProjectRevisionMutationVariables>(UpdateProjectRevisionDocument, options);
}
export type UpdateProjectRevisionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProjectRevisionMutation, UpdateProjectRevisionMutationVariables>;
export const UpdateProjectRevisionWithVersionDocument = gql`
    mutation UpdateProjectRevisionWithVersion($id: uuid!, $set: projectRevision_set_input!, $version: projectVersion_insert_input!) {
  update_projectRevision(where: {id: {_eq: $id}}, _set: $set) {
    affected_rows
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useUpdateProjectRevisionWithVersionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRevisionWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRevisionWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProjectRevisionWithVersionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     set: // value for 'set'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useUpdateProjectRevisionWithVersionMutation(options: VueApolloComposable.UseMutationOptions<UpdateProjectRevisionWithVersionMutation, UpdateProjectRevisionWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProjectRevisionWithVersionMutation, UpdateProjectRevisionWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateProjectRevisionWithVersionMutation, UpdateProjectRevisionWithVersionMutationVariables>(UpdateProjectRevisionWithVersionDocument, options);
}
export type UpdateProjectRevisionWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProjectRevisionWithVersionMutation, UpdateProjectRevisionWithVersionMutationVariables>;
export const UpdateProjectStatusWithVersionDocument = gql`
    mutation UpdateProjectStatusWithVersion($projectId: uuid!, $projectStatusId: Int!, $version: projectVersion_insert_input!) {
  project: update_project_by_pk(
    pk_columns: {id: $projectId}
    _set: {projectStatusId: $projectStatusId}
  ) {
    id
    projectStatusId
  }
  version: insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useUpdateProjectStatusWithVersionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStatusWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStatusWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProjectStatusWithVersionMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     projectStatusId: // value for 'projectStatusId'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useUpdateProjectStatusWithVersionMutation(options: VueApolloComposable.UseMutationOptions<UpdateProjectStatusWithVersionMutation, UpdateProjectStatusWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProjectStatusWithVersionMutation, UpdateProjectStatusWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateProjectStatusWithVersionMutation, UpdateProjectStatusWithVersionMutationVariables>(UpdateProjectStatusWithVersionDocument, options);
}
export type UpdateProjectStatusWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProjectStatusWithVersionMutation, UpdateProjectStatusWithVersionMutationVariables>;
export const UpdateProjectStatusDocument = gql`
    mutation UpdateProjectStatus($projectId: uuid!, $projectStatusId: Int!) {
  project: update_project_by_pk(
    pk_columns: {id: $projectId}
    _set: {projectStatusId: $projectStatusId}
  ) {
    id
    projectStatusId
  }
}
    `;

/**
 * __useUpdateProjectStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProjectStatusMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     projectStatusId: // value for 'projectStatusId'
 *   },
 * });
 */
export function useUpdateProjectStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>(UpdateProjectStatusDocument, options);
}
export type UpdateProjectStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;
export const UpdateProjectWasteTypeCustomDocument = gql`
    mutation UpdateProjectWasteTypeCustom($id: uuid!, $label: String!) {
  update_projectWasteTypeCustom_by_pk(
    _set: {label: $label}
    pk_columns: {id: $id}
  ) {
    ...projectWasteTypeCustom
  }
}
    ${ProjectWasteTypeCustomFragmentDoc}`;

/**
 * __useUpdateProjectWasteTypeCustomMutation__
 *
 * To run a mutation, you first call `useUpdateProjectWasteTypeCustomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectWasteTypeCustomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProjectWasteTypeCustomMutation({
 *   variables: {
 *     id: // value for 'id'
 *     label: // value for 'label'
 *   },
 * });
 */
export function useUpdateProjectWasteTypeCustomMutation(options: VueApolloComposable.UseMutationOptions<UpdateProjectWasteTypeCustomMutation, UpdateProjectWasteTypeCustomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProjectWasteTypeCustomMutation, UpdateProjectWasteTypeCustomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateProjectWasteTypeCustomMutation, UpdateProjectWasteTypeCustomMutationVariables>(UpdateProjectWasteTypeCustomDocument, options);
}
export type UpdateProjectWasteTypeCustomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProjectWasteTypeCustomMutation, UpdateProjectWasteTypeCustomMutationVariables>;
export const UpdateProjectWasteTypeCustomWithVersionDocument = gql`
    mutation UpdateProjectWasteTypeCustomWithVersion($id: uuid!, $label: String!, $version: projectVersion_insert_input!) {
  update_projectWasteTypeCustom_by_pk(
    _set: {label: $label}
    pk_columns: {id: $id}
  ) {
    ...projectWasteTypeCustom
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    ${ProjectWasteTypeCustomFragmentDoc}`;

/**
 * __useUpdateProjectWasteTypeCustomWithVersionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectWasteTypeCustomWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectWasteTypeCustomWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProjectWasteTypeCustomWithVersionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     label: // value for 'label'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useUpdateProjectWasteTypeCustomWithVersionMutation(options: VueApolloComposable.UseMutationOptions<UpdateProjectWasteTypeCustomWithVersionMutation, UpdateProjectWasteTypeCustomWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProjectWasteTypeCustomWithVersionMutation, UpdateProjectWasteTypeCustomWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateProjectWasteTypeCustomWithVersionMutation, UpdateProjectWasteTypeCustomWithVersionMutationVariables>(UpdateProjectWasteTypeCustomWithVersionDocument, options);
}
export type UpdateProjectWasteTypeCustomWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProjectWasteTypeCustomWithVersionMutation, UpdateProjectWasteTypeCustomWithVersionMutationVariables>;
export const UpdateUserWelcomeFlowCompletedDocument = gql`
    mutation UpdateUserWelcomeFlowCompleted($flowKey: String!) {
  update_userWelcomeFlow(
    where: {flowKey: {_eq: $flowKey}}
    _set: {completedAt: "now()"}
  ) {
    affected_rows
  }
}
    `;

/**
 * __useUpdateUserWelcomeFlowCompletedMutation__
 *
 * To run a mutation, you first call `useUpdateUserWelcomeFlowCompletedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserWelcomeFlowCompletedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserWelcomeFlowCompletedMutation({
 *   variables: {
 *     flowKey: // value for 'flowKey'
 *   },
 * });
 */
export function useUpdateUserWelcomeFlowCompletedMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserWelcomeFlowCompletedMutation, UpdateUserWelcomeFlowCompletedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserWelcomeFlowCompletedMutation, UpdateUserWelcomeFlowCompletedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserWelcomeFlowCompletedMutation, UpdateUserWelcomeFlowCompletedMutationVariables>(UpdateUserWelcomeFlowCompletedDocument, options);
}
export type UpdateUserWelcomeFlowCompletedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserWelcomeFlowCompletedMutation, UpdateUserWelcomeFlowCompletedMutationVariables>;
export const UpsertProjectCalculationDocument = gql`
    mutation UpsertProjectCalculation($projectId: uuid!, $calculation: projectCalculation_insert_input!) {
  deletedStages: delete_projectCalculationStage(
    where: {projectCalculation: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}}
  ) {
    affected_rows
  }
  calculation: insert_projectCalculation_one(
    object: $calculation
    on_conflict: {constraint: project_calculation_project_id_key, update_columns: [calculationTypeId, considerationPeriod, thresholdLimit, installationThresholdLimit, useDefaultEmissions]}
  ) {
    id
    revisionId
    createdAt
    calculationTypeId
    considerationPeriod
    thresholdLimit
    installationThresholdLimit
    useDefaultEmissions
    stages(order_by: {stageId: asc}) {
      id
      stageId
    }
  }
}
    `;

/**
 * __useUpsertProjectCalculationMutation__
 *
 * To run a mutation, you first call `useUpsertProjectCalculationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectCalculationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectCalculationMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     calculation: // value for 'calculation'
 *   },
 * });
 */
export function useUpsertProjectCalculationMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectCalculationMutation, UpsertProjectCalculationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectCalculationMutation, UpsertProjectCalculationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectCalculationMutation, UpsertProjectCalculationMutationVariables>(UpsertProjectCalculationDocument, options);
}
export type UpsertProjectCalculationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectCalculationMutation, UpsertProjectCalculationMutationVariables>;
export const UpsertProjectCalculationWithVersionDocument = gql`
    mutation UpsertProjectCalculationWithVersion($projectId: uuid!, $calculation: projectCalculation_insert_input!, $version: projectVersion_insert_input!) {
  deletedStages: delete_projectCalculationStage(
    where: {projectCalculation: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}}
  ) {
    affected_rows
  }
  calculation: insert_projectCalculation_one(
    object: $calculation
    on_conflict: {constraint: project_calculation_project_id_key, update_columns: [calculationTypeId, considerationPeriod, thresholdLimit, installationThresholdLimit, useDefaultEmissions]}
  ) {
    id
    revisionId
    createdAt
    calculationTypeId
    considerationPeriod
    thresholdLimit
    installationThresholdLimit
    useDefaultEmissions
    stages(order_by: {stageId: asc}) {
      id
      stageId
    }
  }
  version: insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useUpsertProjectCalculationWithVersionMutation__
 *
 * To run a mutation, you first call `useUpsertProjectCalculationWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectCalculationWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectCalculationWithVersionMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     calculation: // value for 'calculation'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useUpsertProjectCalculationWithVersionMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectCalculationWithVersionMutation, UpsertProjectCalculationWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectCalculationWithVersionMutation, UpsertProjectCalculationWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectCalculationWithVersionMutation, UpsertProjectCalculationWithVersionMutationVariables>(UpsertProjectCalculationWithVersionDocument, options);
}
export type UpsertProjectCalculationWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectCalculationWithVersionMutation, UpsertProjectCalculationWithVersionMutationVariables>;
export const UpsertProjectLocationDocument = gql`
    mutation UpsertProjectLocation($location: projectLocation_insert_input!) {
  location: insert_projectLocation_one(
    object: $location
    on_conflict: {constraint: project_location_project_id_key, update_columns: [street, streetNumber, postalCode, city, country]}
  ) {
    id
    revisionId
    createdAt
    street
    streetNumber
    postalCode
    city
    country
  }
}
    `;

/**
 * __useUpsertProjectLocationMutation__
 *
 * To run a mutation, you first call `useUpsertProjectLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectLocationMutation({
 *   variables: {
 *     location: // value for 'location'
 *   },
 * });
 */
export function useUpsertProjectLocationMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectLocationMutation, UpsertProjectLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectLocationMutation, UpsertProjectLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectLocationMutation, UpsertProjectLocationMutationVariables>(UpsertProjectLocationDocument, options);
}
export type UpsertProjectLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectLocationMutation, UpsertProjectLocationMutationVariables>;
export const UpsertProjectLocationWithVersionDocument = gql`
    mutation UpsertProjectLocationWithVersion($location: projectLocation_insert_input!, $version: projectVersion_insert_input!) {
  location: insert_projectLocation_one(
    object: $location
    on_conflict: {constraint: project_location_project_id_key, update_columns: [street, streetNumber, postalCode, city, country]}
  ) {
    id
    revisionId
    createdAt
    street
    streetNumber
    postalCode
    city
    country
  }
  version: insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useUpsertProjectLocationWithVersionMutation__
 *
 * To run a mutation, you first call `useUpsertProjectLocationWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectLocationWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectLocationWithVersionMutation({
 *   variables: {
 *     location: // value for 'location'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useUpsertProjectLocationWithVersionMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectLocationWithVersionMutation, UpsertProjectLocationWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectLocationWithVersionMutation, UpsertProjectLocationWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectLocationWithVersionMutation, UpsertProjectLocationWithVersionMutationVariables>(UpsertProjectLocationWithVersionDocument, options);
}
export type UpsertProjectLocationWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectLocationWithVersionMutation, UpsertProjectLocationWithVersionMutationVariables>;
export const UpsertProjectSpecialConditionConfigWithVersionDocument = gql`
    mutation UpsertProjectSpecialConditionConfigWithVersion($config: projectSpecialConditionConfig_insert_input!, $version: projectVersion_insert_input!) {
  config: insert_projectSpecialConditionConfig_one(
    object: $config
    on_conflict: {constraint: project_special_condition_config_pkey, update_columns: [enabled]}
  ) {
    projectId
    revisionId
    enabled
  }
  version: insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useUpsertProjectSpecialConditionConfigWithVersionMutation__
 *
 * To run a mutation, you first call `useUpsertProjectSpecialConditionConfigWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectSpecialConditionConfigWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectSpecialConditionConfigWithVersionMutation({
 *   variables: {
 *     config: // value for 'config'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useUpsertProjectSpecialConditionConfigWithVersionMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectSpecialConditionConfigWithVersionMutation, UpsertProjectSpecialConditionConfigWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectSpecialConditionConfigWithVersionMutation, UpsertProjectSpecialConditionConfigWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectSpecialConditionConfigWithVersionMutation, UpsertProjectSpecialConditionConfigWithVersionMutationVariables>(UpsertProjectSpecialConditionConfigWithVersionDocument, options);
}
export type UpsertProjectSpecialConditionConfigWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectSpecialConditionConfigWithVersionMutation, UpsertProjectSpecialConditionConfigWithVersionMutationVariables>;
export const UpsertProjectSpecialConditionConfigDocument = gql`
    mutation UpsertProjectSpecialConditionConfig($config: projectSpecialConditionConfig_insert_input!) {
  config: insert_projectSpecialConditionConfig_one(
    object: $config
    on_conflict: {constraint: project_special_condition_config_pkey, update_columns: [enabled]}
  ) {
    projectId
    revisionId
    enabled
  }
}
    `;

/**
 * __useUpsertProjectSpecialConditionConfigMutation__
 *
 * To run a mutation, you first call `useUpsertProjectSpecialConditionConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectSpecialConditionConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectSpecialConditionConfigMutation({
 *   variables: {
 *     config: // value for 'config'
 *   },
 * });
 */
export function useUpsertProjectSpecialConditionConfigMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectSpecialConditionConfigMutation, UpsertProjectSpecialConditionConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectSpecialConditionConfigMutation, UpsertProjectSpecialConditionConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectSpecialConditionConfigMutation, UpsertProjectSpecialConditionConfigMutationVariables>(UpsertProjectSpecialConditionConfigDocument, options);
}
export type UpsertProjectSpecialConditionConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectSpecialConditionConfigMutation, UpsertProjectSpecialConditionConfigMutationVariables>;
export const UpsertProjectSpeckleParameterConfigWithVersionDocument = gql`
    mutation UpsertProjectSpeckleParameterConfigWithVersion($config: projectSpeckleParameterConfig_insert_input!, $version: projectVersion_insert_input!) {
  config: insert_projectSpeckleParameterConfig_one(
    object: $config
    on_conflict: {constraint: project_speckle_parameter_config_pkey, update_columns: [classificationCode, classificationTypeId]}
  ) {
    projectId
    classificationTypeId
    classificationCode
  }
  version: insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useUpsertProjectSpeckleParameterConfigWithVersionMutation__
 *
 * To run a mutation, you first call `useUpsertProjectSpeckleParameterConfigWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectSpeckleParameterConfigWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectSpeckleParameterConfigWithVersionMutation({
 *   variables: {
 *     config: // value for 'config'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useUpsertProjectSpeckleParameterConfigWithVersionMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectSpeckleParameterConfigWithVersionMutation, UpsertProjectSpeckleParameterConfigWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectSpeckleParameterConfigWithVersionMutation, UpsertProjectSpeckleParameterConfigWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectSpeckleParameterConfigWithVersionMutation, UpsertProjectSpeckleParameterConfigWithVersionMutationVariables>(UpsertProjectSpeckleParameterConfigWithVersionDocument, options);
}
export type UpsertProjectSpeckleParameterConfigWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectSpeckleParameterConfigWithVersionMutation, UpsertProjectSpeckleParameterConfigWithVersionMutationVariables>;
export const UpsertProjectSpeckleParameterConfigDocument = gql`
    mutation UpsertProjectSpeckleParameterConfig($config: projectSpeckleParameterConfig_insert_input!) {
  config: insert_projectSpeckleParameterConfig_one(
    object: $config
    on_conflict: {constraint: project_speckle_parameter_config_pkey, update_columns: [classificationCode, classificationTypeId]}
  ) {
    projectId
    classificationTypeId
    classificationCode
  }
}
    `;

/**
 * __useUpsertProjectSpeckleParameterConfigMutation__
 *
 * To run a mutation, you first call `useUpsertProjectSpeckleParameterConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectSpeckleParameterConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectSpeckleParameterConfigMutation({
 *   variables: {
 *     config: // value for 'config'
 *   },
 * });
 */
export function useUpsertProjectSpeckleParameterConfigMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectSpeckleParameterConfigMutation, UpsertProjectSpeckleParameterConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectSpeckleParameterConfigMutation, UpsertProjectSpeckleParameterConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectSpeckleParameterConfigMutation, UpsertProjectSpeckleParameterConfigMutationVariables>(UpsertProjectSpeckleParameterConfigDocument, options);
}
export type UpsertProjectSpeckleParameterConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectSpeckleParameterConfigMutation, UpsertProjectSpeckleParameterConfigMutationVariables>;
export const UpsertProjectWasteMappingDocument = gql`
    mutation UpsertProjectWasteMapping($objects: [projectWasteMapping_insert_input!]!) {
  insert_projectWasteMapping(
    objects: $objects
    on_conflict: {constraint: project_material_waste_mapping_pkey, update_columns: [label, materialId, materialWasteTypeId, pickupDate, projectId, customWeight, projectWasteTypeCustomId, materialWeightSnapshot]}
  ) {
    affected_rows
    returning {
      ...projectWasteMapping
    }
  }
}
    ${ProjectWasteMappingFragmentDoc}`;

/**
 * __useUpsertProjectWasteMappingMutation__
 *
 * To run a mutation, you first call `useUpsertProjectWasteMappingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectWasteMappingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectWasteMappingMutation({
 *   variables: {
 *     objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertProjectWasteMappingMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectWasteMappingMutation, UpsertProjectWasteMappingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectWasteMappingMutation, UpsertProjectWasteMappingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectWasteMappingMutation, UpsertProjectWasteMappingMutationVariables>(UpsertProjectWasteMappingDocument, options);
}
export type UpsertProjectWasteMappingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectWasteMappingMutation, UpsertProjectWasteMappingMutationVariables>;
export const UpsertProjectWasteMappingWithVersionDocument = gql`
    mutation UpsertProjectWasteMappingWithVersion($objects: [projectWasteMapping_insert_input!]!, $version: projectVersion_insert_input!) {
  insert_projectWasteMapping(
    objects: $objects
    on_conflict: {constraint: project_material_waste_mapping_pkey, update_columns: [label, materialId, materialWasteTypeId, pickupDate, projectId, customWeight, projectWasteTypeCustomId, materialWeightSnapshot]}
  ) {
    affected_rows
    returning {
      ...projectWasteMapping
    }
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    ${ProjectWasteMappingFragmentDoc}`;

/**
 * __useUpsertProjectWasteMappingWithVersionMutation__
 *
 * To run a mutation, you first call `useUpsertProjectWasteMappingWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectWasteMappingWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectWasteMappingWithVersionMutation({
 *   variables: {
 *     objects: // value for 'objects'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useUpsertProjectWasteMappingWithVersionMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectWasteMappingWithVersionMutation, UpsertProjectWasteMappingWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectWasteMappingWithVersionMutation, UpsertProjectWasteMappingWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectWasteMappingWithVersionMutation, UpsertProjectWasteMappingWithVersionMutationVariables>(UpsertProjectWasteMappingWithVersionDocument, options);
}
export type UpsertProjectWasteMappingWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectWasteMappingWithVersionMutation, UpsertProjectWasteMappingWithVersionMutationVariables>;
export const UpsertProjectWasteTypeCustomDocument = gql`
    mutation UpsertProjectWasteTypeCustom($id: uuid!, $label: String!, $projectId: uuid!) {
  insert_projectWasteTypeCustom_one(
    object: {id: $id, label: $label, projectId: $projectId}
    on_conflict: {constraint: project_waste_types_custom_pkey, update_columns: [label, projectId]}
  ) {
    id
    label
  }
}
    `;

/**
 * __useUpsertProjectWasteTypeCustomMutation__
 *
 * To run a mutation, you first call `useUpsertProjectWasteTypeCustomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectWasteTypeCustomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectWasteTypeCustomMutation({
 *   variables: {
 *     id: // value for 'id'
 *     label: // value for 'label'
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpsertProjectWasteTypeCustomMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectWasteTypeCustomMutation, UpsertProjectWasteTypeCustomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectWasteTypeCustomMutation, UpsertProjectWasteTypeCustomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectWasteTypeCustomMutation, UpsertProjectWasteTypeCustomMutationVariables>(UpsertProjectWasteTypeCustomDocument, options);
}
export type UpsertProjectWasteTypeCustomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectWasteTypeCustomMutation, UpsertProjectWasteTypeCustomMutationVariables>;
export const UpsertProjectWasteTypeCustomWithVersionDocument = gql`
    mutation UpsertProjectWasteTypeCustomWithVersion($id: uuid!, $label: String!, $projectId: uuid!, $version: projectVersion_insert_input!) {
  insert_projectWasteTypeCustom_one(
    object: {id: $id, label: $label, projectId: $projectId}
    on_conflict: {constraint: project_waste_types_custom_pkey, update_columns: [label, projectId]}
  ) {
    id
    label
  }
  insert_projectVersion_one(object: $version) {
    id
  }
}
    `;

/**
 * __useUpsertProjectWasteTypeCustomWithVersionMutation__
 *
 * To run a mutation, you first call `useUpsertProjectWasteTypeCustomWithVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectWasteTypeCustomWithVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectWasteTypeCustomWithVersionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     label: // value for 'label'
 *     projectId: // value for 'projectId'
 *     version: // value for 'version'
 *   },
 * });
 */
export function useUpsertProjectWasteTypeCustomWithVersionMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectWasteTypeCustomWithVersionMutation, UpsertProjectWasteTypeCustomWithVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectWasteTypeCustomWithVersionMutation, UpsertProjectWasteTypeCustomWithVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectWasteTypeCustomWithVersionMutation, UpsertProjectWasteTypeCustomWithVersionMutationVariables>(UpsertProjectWasteTypeCustomWithVersionDocument, options);
}
export type UpsertProjectWasteTypeCustomWithVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectWasteTypeCustomWithVersionMutation, UpsertProjectWasteTypeCustomWithVersionMutationVariables>;
export const UpsertTenantCollectionDocument = gql`
    mutation UpsertTenantCollection($id: uuid!, $name: String!, $collectionType: String!) {
  insert_tenantCollection(
    objects: {id: $id, name: $name, collectionType: $collectionType}
    on_conflict: {constraint: tenant_collection_pkey, update_columns: name}
  ) {
    returning {
      name
      id
      collectionType
    }
  }
}
    `;

/**
 * __useUpsertTenantCollectionMutation__
 *
 * To run a mutation, you first call `useUpsertTenantCollectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTenantCollectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertTenantCollectionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *     collectionType: // value for 'collectionType'
 *   },
 * });
 */
export function useUpsertTenantCollectionMutation(options: VueApolloComposable.UseMutationOptions<UpsertTenantCollectionMutation, UpsertTenantCollectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertTenantCollectionMutation, UpsertTenantCollectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertTenantCollectionMutation, UpsertTenantCollectionMutationVariables>(UpsertTenantCollectionDocument, options);
}
export type UpsertTenantCollectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertTenantCollectionMutation, UpsertTenantCollectionMutationVariables>;
export const UpsertUserProjectViewDocument = gql`
    mutation UpsertUserProjectView($projectId: uuid!) {
  insert_userProjectView_one(
    object: {projectId: $projectId, viewedAt: "now()"}
    on_conflict: {constraint: user_project_view_pkey, update_columns: [viewedAt]}
  ) {
    projectId
    viewedAt
  }
}
    `;

/**
 * __useUpsertUserProjectViewMutation__
 *
 * To run a mutation, you first call `useUpsertUserProjectViewMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserProjectViewMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertUserProjectViewMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpsertUserProjectViewMutation(options: VueApolloComposable.UseMutationOptions<UpsertUserProjectViewMutation, UpsertUserProjectViewMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertUserProjectViewMutation, UpsertUserProjectViewMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertUserProjectViewMutation, UpsertUserProjectViewMutationVariables>(UpsertUserProjectViewDocument, options);
}
export type UpsertUserProjectViewMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertUserProjectViewMutation, UpsertUserProjectViewMutationVariables>;
export const GetAdminProjectStatusCountsDocument = gql`
    query GetAdminProjectStatusCounts {
  project(where: {deletedAt: {_is_null: true}}) {
    tenantId
    projectStatus {
      label
    }
  }
}
    `;

/**
 * __useGetAdminProjectStatusCountsQuery__
 *
 * To run a query within a Vue component, call `useGetAdminProjectStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminProjectStatusCountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAdminProjectStatusCountsQuery();
 */
export function useGetAdminProjectStatusCountsQuery(options: VueApolloComposable.UseQueryOptions<GetAdminProjectStatusCountsQuery, GetAdminProjectStatusCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAdminProjectStatusCountsQuery, GetAdminProjectStatusCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAdminProjectStatusCountsQuery, GetAdminProjectStatusCountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAdminProjectStatusCountsQuery, GetAdminProjectStatusCountsQueryVariables>(GetAdminProjectStatusCountsDocument, {}, options);
}
export function useGetAdminProjectStatusCountsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAdminProjectStatusCountsQuery, GetAdminProjectStatusCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAdminProjectStatusCountsQuery, GetAdminProjectStatusCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAdminProjectStatusCountsQuery, GetAdminProjectStatusCountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAdminProjectStatusCountsQuery, GetAdminProjectStatusCountsQueryVariables>(GetAdminProjectStatusCountsDocument, {}, options);
}
export type GetAdminProjectStatusCountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAdminProjectStatusCountsQuery, GetAdminProjectStatusCountsQueryVariables>;
export const GetAgentUsageBudgetStatusDocument = gql`
    query GetAgentUsageBudgetStatus {
  agentUsageBudgetStatus(limit: 1) {
    tenantId
    capAmount
    currency
    spendCurrentMonth
    pctUsed
  }
}
    `;

/**
 * __useGetAgentUsageBudgetStatusQuery__
 *
 * To run a query within a Vue component, call `useGetAgentUsageBudgetStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentUsageBudgetStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAgentUsageBudgetStatusQuery();
 */
export function useGetAgentUsageBudgetStatusQuery(options: VueApolloComposable.UseQueryOptions<GetAgentUsageBudgetStatusQuery, GetAgentUsageBudgetStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAgentUsageBudgetStatusQuery, GetAgentUsageBudgetStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAgentUsageBudgetStatusQuery, GetAgentUsageBudgetStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAgentUsageBudgetStatusQuery, GetAgentUsageBudgetStatusQueryVariables>(GetAgentUsageBudgetStatusDocument, {}, options);
}
export function useGetAgentUsageBudgetStatusLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAgentUsageBudgetStatusQuery, GetAgentUsageBudgetStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAgentUsageBudgetStatusQuery, GetAgentUsageBudgetStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAgentUsageBudgetStatusQuery, GetAgentUsageBudgetStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAgentUsageBudgetStatusQuery, GetAgentUsageBudgetStatusQueryVariables>(GetAgentUsageBudgetStatusDocument, {}, options);
}
export type GetAgentUsageBudgetStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAgentUsageBudgetStatusQuery, GetAgentUsageBudgetStatusQueryVariables>;
export const GetAgentUsageDailyDocument = gql`
    query GetAgentUsageDaily($from: date!, $to: date!) {
  agentUsageDaily(
    where: {usageDate: {_gte: $from, _lte: $to}}
    order_by: {usageDate: asc}
  ) {
    usageDate
    feature
    userId
    sessionCount
    requestCount
    totalTokens
  }
}
    `;

/**
 * __useGetAgentUsageDailyQuery__
 *
 * To run a query within a Vue component, call `useGetAgentUsageDailyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentUsageDailyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAgentUsageDailyQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetAgentUsageDailyQuery(variables: GetAgentUsageDailyQueryVariables | VueCompositionApi.Ref<GetAgentUsageDailyQueryVariables> | ReactiveFunction<GetAgentUsageDailyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAgentUsageDailyQuery, GetAgentUsageDailyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAgentUsageDailyQuery, GetAgentUsageDailyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAgentUsageDailyQuery, GetAgentUsageDailyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAgentUsageDailyQuery, GetAgentUsageDailyQueryVariables>(GetAgentUsageDailyDocument, variables, options);
}
export function useGetAgentUsageDailyLazyQuery(variables?: GetAgentUsageDailyQueryVariables | VueCompositionApi.Ref<GetAgentUsageDailyQueryVariables> | ReactiveFunction<GetAgentUsageDailyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAgentUsageDailyQuery, GetAgentUsageDailyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAgentUsageDailyQuery, GetAgentUsageDailyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAgentUsageDailyQuery, GetAgentUsageDailyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAgentUsageDailyQuery, GetAgentUsageDailyQueryVariables>(GetAgentUsageDailyDocument, variables, options);
}
export type GetAgentUsageDailyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAgentUsageDailyQuery, GetAgentUsageDailyQueryVariables>;
export const GetAgentUsageSessionSummaryDocument = gql`
    query GetAgentUsageSessionSummary($from: timestamptz!, $to: timestamptz!) {
  agentUsageSession_aggregate(where: {startedAt: {_gte: $from, _lt: $to}}) {
    aggregate {
      count
      sum {
        totalTokens
      }
    }
  }
}
    `;

/**
 * __useGetAgentUsageSessionSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetAgentUsageSessionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentUsageSessionSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAgentUsageSessionSummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetAgentUsageSessionSummaryQuery(variables: GetAgentUsageSessionSummaryQueryVariables | VueCompositionApi.Ref<GetAgentUsageSessionSummaryQueryVariables> | ReactiveFunction<GetAgentUsageSessionSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAgentUsageSessionSummaryQuery, GetAgentUsageSessionSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAgentUsageSessionSummaryQuery, GetAgentUsageSessionSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAgentUsageSessionSummaryQuery, GetAgentUsageSessionSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAgentUsageSessionSummaryQuery, GetAgentUsageSessionSummaryQueryVariables>(GetAgentUsageSessionSummaryDocument, variables, options);
}
export function useGetAgentUsageSessionSummaryLazyQuery(variables?: GetAgentUsageSessionSummaryQueryVariables | VueCompositionApi.Ref<GetAgentUsageSessionSummaryQueryVariables> | ReactiveFunction<GetAgentUsageSessionSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAgentUsageSessionSummaryQuery, GetAgentUsageSessionSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAgentUsageSessionSummaryQuery, GetAgentUsageSessionSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAgentUsageSessionSummaryQuery, GetAgentUsageSessionSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAgentUsageSessionSummaryQuery, GetAgentUsageSessionSummaryQueryVariables>(GetAgentUsageSessionSummaryDocument, variables, options);
}
export type GetAgentUsageSessionSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAgentUsageSessionSummaryQuery, GetAgentUsageSessionSummaryQueryVariables>;
export const GetAgentUsageSessionsDocument = gql`
    query GetAgentUsageSessions($from: timestamptz!, $to: timestamptz!) {
  agentUsageSession(
    where: {startedAt: {_gte: $from, _lt: $to}}
    order_by: {startedAt: desc}
  ) {
    sessionId
    userId
    feature
    startedAt
    lastActivityAt
    requestCount
    totalTokens
  }
}
    `;

/**
 * __useGetAgentUsageSessionsQuery__
 *
 * To run a query within a Vue component, call `useGetAgentUsageSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentUsageSessionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAgentUsageSessionsQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetAgentUsageSessionsQuery(variables: GetAgentUsageSessionsQueryVariables | VueCompositionApi.Ref<GetAgentUsageSessionsQueryVariables> | ReactiveFunction<GetAgentUsageSessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAgentUsageSessionsQuery, GetAgentUsageSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAgentUsageSessionsQuery, GetAgentUsageSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAgentUsageSessionsQuery, GetAgentUsageSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAgentUsageSessionsQuery, GetAgentUsageSessionsQueryVariables>(GetAgentUsageSessionsDocument, variables, options);
}
export function useGetAgentUsageSessionsLazyQuery(variables?: GetAgentUsageSessionsQueryVariables | VueCompositionApi.Ref<GetAgentUsageSessionsQueryVariables> | ReactiveFunction<GetAgentUsageSessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAgentUsageSessionsQuery, GetAgentUsageSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAgentUsageSessionsQuery, GetAgentUsageSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAgentUsageSessionsQuery, GetAgentUsageSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAgentUsageSessionsQuery, GetAgentUsageSessionsQueryVariables>(GetAgentUsageSessionsDocument, variables, options);
}
export type GetAgentUsageSessionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAgentUsageSessionsQuery, GetAgentUsageSessionsQueryVariables>;
export const GetAllTenantCollectionItemsDocument = gql`
    query GetAllTenantCollectionItems {
  tenantCollectionItem {
    materialInternalId
    tenantCollectionId
  }
}
    `;

/**
 * __useGetAllTenantCollectionItemsQuery__
 *
 * To run a query within a Vue component, call `useGetAllTenantCollectionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTenantCollectionItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllTenantCollectionItemsQuery();
 */
export function useGetAllTenantCollectionItemsQuery(options: VueApolloComposable.UseQueryOptions<GetAllTenantCollectionItemsQuery, GetAllTenantCollectionItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllTenantCollectionItemsQuery, GetAllTenantCollectionItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllTenantCollectionItemsQuery, GetAllTenantCollectionItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllTenantCollectionItemsQuery, GetAllTenantCollectionItemsQueryVariables>(GetAllTenantCollectionItemsDocument, {}, options);
}
export function useGetAllTenantCollectionItemsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAllTenantCollectionItemsQuery, GetAllTenantCollectionItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllTenantCollectionItemsQuery, GetAllTenantCollectionItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllTenantCollectionItemsQuery, GetAllTenantCollectionItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllTenantCollectionItemsQuery, GetAllTenantCollectionItemsQueryVariables>(GetAllTenantCollectionItemsDocument, {}, options);
}
export type GetAllTenantCollectionItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllTenantCollectionItemsQuery, GetAllTenantCollectionItemsQueryVariables>;
export const GetBasicProjectListDocument = gql`
    query GetBasicProjectList($orderBy: [project_order_by!], $where: project_bool_exp) {
  project(order_by: $orderBy, where: $where) {
    ...projectBase
    favorite
    models {
      id
      name
    }
  }
}
    ${ProjectBaseFragmentDoc}`;

/**
 * __useGetBasicProjectListQuery__
 *
 * To run a query within a Vue component, call `useGetBasicProjectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicProjectListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBasicProjectListQuery({
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useGetBasicProjectListQuery(variables: GetBasicProjectListQueryVariables | VueCompositionApi.Ref<GetBasicProjectListQueryVariables> | ReactiveFunction<GetBasicProjectListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetBasicProjectListQuery, GetBasicProjectListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBasicProjectListQuery, GetBasicProjectListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBasicProjectListQuery, GetBasicProjectListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBasicProjectListQuery, GetBasicProjectListQueryVariables>(GetBasicProjectListDocument, variables, options);
}
export function useGetBasicProjectListLazyQuery(variables: GetBasicProjectListQueryVariables | VueCompositionApi.Ref<GetBasicProjectListQueryVariables> | ReactiveFunction<GetBasicProjectListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetBasicProjectListQuery, GetBasicProjectListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBasicProjectListQuery, GetBasicProjectListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBasicProjectListQuery, GetBasicProjectListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBasicProjectListQuery, GetBasicProjectListQueryVariables>(GetBasicProjectListDocument, variables, options);
}
export type GetBasicProjectListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBasicProjectListQuery, GetBasicProjectListQueryVariables>;
export const GetBuildingPartServiceLifetimesDocument = gql`
    query GetBuildingPartServiceLifetimes($country: country_enum!) @cached {
  buildingPartLifetimeSource(
    where: {country: {_eq: $country}, serviceLifetimes: {buildingElementClassificationCodeMappingId: {_is_null: false}}}
  ) {
    id
    source
    label
    serviceLifetimes(
      order_by: {classificationCode: {code: asc}, buildingElementClassificationCodeMapping: {buildingElement: {label: asc}}}
    ) {
      id
      lifetimeAverage
      lifetimeLow
      lifetimeHigh
      buildingElementClassificationCodeMapping {
        classificationCode {
          id
          code
          label
          parent {
            id
            code
            label
          }
        }
        buildingElement {
          materialCategoryMappings(order_by: [{materialCategory: {label: asc}}]) {
            materialCategory {
              id
              label
            }
          }
          id
          label
        }
      }
    }
  }
}
    `;

/**
 * __useGetBuildingPartServiceLifetimesQuery__
 *
 * To run a query within a Vue component, call `useGetBuildingPartServiceLifetimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingPartServiceLifetimesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBuildingPartServiceLifetimesQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetBuildingPartServiceLifetimesQuery(variables: GetBuildingPartServiceLifetimesQueryVariables | VueCompositionApi.Ref<GetBuildingPartServiceLifetimesQueryVariables> | ReactiveFunction<GetBuildingPartServiceLifetimesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBuildingPartServiceLifetimesQuery, GetBuildingPartServiceLifetimesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBuildingPartServiceLifetimesQuery, GetBuildingPartServiceLifetimesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBuildingPartServiceLifetimesQuery, GetBuildingPartServiceLifetimesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBuildingPartServiceLifetimesQuery, GetBuildingPartServiceLifetimesQueryVariables>(GetBuildingPartServiceLifetimesDocument, variables, options);
}
export function useGetBuildingPartServiceLifetimesLazyQuery(variables?: GetBuildingPartServiceLifetimesQueryVariables | VueCompositionApi.Ref<GetBuildingPartServiceLifetimesQueryVariables> | ReactiveFunction<GetBuildingPartServiceLifetimesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBuildingPartServiceLifetimesQuery, GetBuildingPartServiceLifetimesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBuildingPartServiceLifetimesQuery, GetBuildingPartServiceLifetimesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBuildingPartServiceLifetimesQuery, GetBuildingPartServiceLifetimesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBuildingPartServiceLifetimesQuery, GetBuildingPartServiceLifetimesQueryVariables>(GetBuildingPartServiceLifetimesDocument, variables, options);
}
export type GetBuildingPartServiceLifetimesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBuildingPartServiceLifetimesQuery, GetBuildingPartServiceLifetimesQueryVariables>;
export const GetBuildingTypesDocument = gql`
    query GetBuildingTypes($country: country_enum!) @cached {
  buildingType(where: {country: {_eq: $country}}, order_by: {code: asc}) {
    id
    label
    code
    parent {
      id
      label
      code
    }
  }
}
    `;

/**
 * __useGetBuildingTypesQuery__
 *
 * To run a query within a Vue component, call `useGetBuildingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBuildingTypesQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetBuildingTypesQuery(variables: GetBuildingTypesQueryVariables | VueCompositionApi.Ref<GetBuildingTypesQueryVariables> | ReactiveFunction<GetBuildingTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBuildingTypesQuery, GetBuildingTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBuildingTypesQuery, GetBuildingTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBuildingTypesQuery, GetBuildingTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBuildingTypesQuery, GetBuildingTypesQueryVariables>(GetBuildingTypesDocument, variables, options);
}
export function useGetBuildingTypesLazyQuery(variables?: GetBuildingTypesQueryVariables | VueCompositionApi.Ref<GetBuildingTypesQueryVariables> | ReactiveFunction<GetBuildingTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBuildingTypesQuery, GetBuildingTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBuildingTypesQuery, GetBuildingTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBuildingTypesQuery, GetBuildingTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBuildingTypesQuery, GetBuildingTypesQueryVariables>(GetBuildingTypesDocument, variables, options);
}
export type GetBuildingTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBuildingTypesQuery, GetBuildingTypesQueryVariables>;
export const GetCalculationTypeByIdDocument = gql`
    query GetCalculationTypeById($calculationTypeId: Int!) @cached {
  calculationType_by_pk(id: $calculationTypeId) {
    ...calculationTypeFragment
  }
}
    ${CalculationTypeFragmentFragmentDoc}`;

/**
 * __useGetCalculationTypeByIdQuery__
 *
 * To run a query within a Vue component, call `useGetCalculationTypeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculationTypeByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCalculationTypeByIdQuery({
 *   calculationTypeId: // value for 'calculationTypeId'
 * });
 */
export function useGetCalculationTypeByIdQuery(variables: GetCalculationTypeByIdQueryVariables | VueCompositionApi.Ref<GetCalculationTypeByIdQueryVariables> | ReactiveFunction<GetCalculationTypeByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCalculationTypeByIdQuery, GetCalculationTypeByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCalculationTypeByIdQuery, GetCalculationTypeByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCalculationTypeByIdQuery, GetCalculationTypeByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCalculationTypeByIdQuery, GetCalculationTypeByIdQueryVariables>(GetCalculationTypeByIdDocument, variables, options);
}
export function useGetCalculationTypeByIdLazyQuery(variables?: GetCalculationTypeByIdQueryVariables | VueCompositionApi.Ref<GetCalculationTypeByIdQueryVariables> | ReactiveFunction<GetCalculationTypeByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCalculationTypeByIdQuery, GetCalculationTypeByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCalculationTypeByIdQuery, GetCalculationTypeByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCalculationTypeByIdQuery, GetCalculationTypeByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCalculationTypeByIdQuery, GetCalculationTypeByIdQueryVariables>(GetCalculationTypeByIdDocument, variables, options);
}
export type GetCalculationTypeByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCalculationTypeByIdQuery, GetCalculationTypeByIdQueryVariables>;
export const GetCalculationTypeDocument = gql`
    query GetCalculationType($country: country_enum!) @cached {
  calculationType(where: {country: {_eq: $country}}) {
    ...calculationTypeFragment
  }
}
    ${CalculationTypeFragmentFragmentDoc}`;

/**
 * __useGetCalculationTypeQuery__
 *
 * To run a query within a Vue component, call `useGetCalculationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculationTypeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCalculationTypeQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetCalculationTypeQuery(variables: GetCalculationTypeQueryVariables | VueCompositionApi.Ref<GetCalculationTypeQueryVariables> | ReactiveFunction<GetCalculationTypeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCalculationTypeQuery, GetCalculationTypeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCalculationTypeQuery, GetCalculationTypeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCalculationTypeQuery, GetCalculationTypeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCalculationTypeQuery, GetCalculationTypeQueryVariables>(GetCalculationTypeDocument, variables, options);
}
export function useGetCalculationTypeLazyQuery(variables?: GetCalculationTypeQueryVariables | VueCompositionApi.Ref<GetCalculationTypeQueryVariables> | ReactiveFunction<GetCalculationTypeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCalculationTypeQuery, GetCalculationTypeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCalculationTypeQuery, GetCalculationTypeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCalculationTypeQuery, GetCalculationTypeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCalculationTypeQuery, GetCalculationTypeQueryVariables>(GetCalculationTypeDocument, variables, options);
}
export type GetCalculationTypeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCalculationTypeQuery, GetCalculationTypeQueryVariables>;
export const GetCategoryTranslationsDocument = gql`
    query GetCategoryTranslations($languageCodes: [String!]!) @cached {
  translationCategory(
    where: {languageCode: {_in: $languageCodes}}
    order_by: {translation: asc}
  ) {
    id
    original
    translation
    languageCode
    language {
      code
      country
    }
  }
  fallbackTranslations: translationCategory(
    where: {languageCode: {_eq: "EN"}}
    order_by: {translation: asc}
  ) {
    id
    original
    translation
    languageCode
    language {
      code
      country
    }
  }
}
    `;

/**
 * __useGetCategoryTranslationsQuery__
 *
 * To run a query within a Vue component, call `useGetCategoryTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryTranslationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCategoryTranslationsQuery({
 *   languageCodes: // value for 'languageCodes'
 * });
 */
export function useGetCategoryTranslationsQuery(variables: GetCategoryTranslationsQueryVariables | VueCompositionApi.Ref<GetCategoryTranslationsQueryVariables> | ReactiveFunction<GetCategoryTranslationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCategoryTranslationsQuery, GetCategoryTranslationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCategoryTranslationsQuery, GetCategoryTranslationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCategoryTranslationsQuery, GetCategoryTranslationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCategoryTranslationsQuery, GetCategoryTranslationsQueryVariables>(GetCategoryTranslationsDocument, variables, options);
}
export function useGetCategoryTranslationsLazyQuery(variables?: GetCategoryTranslationsQueryVariables | VueCompositionApi.Ref<GetCategoryTranslationsQueryVariables> | ReactiveFunction<GetCategoryTranslationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCategoryTranslationsQuery, GetCategoryTranslationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCategoryTranslationsQuery, GetCategoryTranslationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCategoryTranslationsQuery, GetCategoryTranslationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCategoryTranslationsQuery, GetCategoryTranslationsQueryVariables>(GetCategoryTranslationsDocument, variables, options);
}
export type GetCategoryTranslationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCategoryTranslationsQuery, GetCategoryTranslationsQueryVariables>;
export const GetClassificationCodesDocument = gql`
    query GetClassificationCodes($classificationTypeId: uuid!, $country: country_enum!) @cached {
  classificationCode(
    where: {type: {typeByCountry: {country: {_eq: $country}, classificationTypeId: {_eq: $classificationTypeId}}}}
    order_by: {code: asc}
  ) {
    code
    type {
      typeByCountry {
        country
      }
    }
    id
    label
    englishLabel
    translation {
      languageCode
      label
    }
    objectClass {
      id
      code
      name
    }
    parentId
  }
  classificationObjectClass(
    where: {classificationCodes: {classificationTypeId: {_eq: $classificationTypeId}}}
  ) {
    id
    code
    name
  }
}
    `;

/**
 * __useGetClassificationCodesQuery__
 *
 * To run a query within a Vue component, call `useGetClassificationCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationCodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClassificationCodesQuery({
 *   classificationTypeId: // value for 'classificationTypeId'
 *   country: // value for 'country'
 * });
 */
export function useGetClassificationCodesQuery(variables: GetClassificationCodesQueryVariables | VueCompositionApi.Ref<GetClassificationCodesQueryVariables> | ReactiveFunction<GetClassificationCodesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClassificationCodesQuery, GetClassificationCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClassificationCodesQuery, GetClassificationCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClassificationCodesQuery, GetClassificationCodesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClassificationCodesQuery, GetClassificationCodesQueryVariables>(GetClassificationCodesDocument, variables, options);
}
export function useGetClassificationCodesLazyQuery(variables?: GetClassificationCodesQueryVariables | VueCompositionApi.Ref<GetClassificationCodesQueryVariables> | ReactiveFunction<GetClassificationCodesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClassificationCodesQuery, GetClassificationCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClassificationCodesQuery, GetClassificationCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClassificationCodesQuery, GetClassificationCodesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClassificationCodesQuery, GetClassificationCodesQueryVariables>(GetClassificationCodesDocument, variables, options);
}
export type GetClassificationCodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClassificationCodesQuery, GetClassificationCodesQueryVariables>;
export const GetClassificationTypesDocument = gql`
    query GetClassificationTypes($country: country_enum!) @cached {
  classificationCodeTypeCountry(where: {country: {_eq: $country}}) {
    id
    isDefault
    classificationType {
      id
      longName
      shortName
      parameters {
        id
        isDefault
        value
      }
    }
  }
}
    `;

/**
 * __useGetClassificationTypesQuery__
 *
 * To run a query within a Vue component, call `useGetClassificationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClassificationTypesQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetClassificationTypesQuery(variables: GetClassificationTypesQueryVariables | VueCompositionApi.Ref<GetClassificationTypesQueryVariables> | ReactiveFunction<GetClassificationTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClassificationTypesQuery, GetClassificationTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClassificationTypesQuery, GetClassificationTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClassificationTypesQuery, GetClassificationTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClassificationTypesQuery, GetClassificationTypesQueryVariables>(GetClassificationTypesDocument, variables, options);
}
export function useGetClassificationTypesLazyQuery(variables?: GetClassificationTypesQueryVariables | VueCompositionApi.Ref<GetClassificationTypesQueryVariables> | ReactiveFunction<GetClassificationTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClassificationTypesQuery, GetClassificationTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClassificationTypesQuery, GetClassificationTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClassificationTypesQuery, GetClassificationTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClassificationTypesQuery, GetClassificationTypesQueryVariables>(GetClassificationTypesDocument, variables, options);
}
export type GetClassificationTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClassificationTypesQuery, GetClassificationTypesQueryVariables>;
export const GetConfigDocument = gql`
    query GetConfig($country: country_enum!) @cached {
  countryConfig(where: {country: {_eq: $country}}) {
    calculationTypeId
    installationFields
    useStageDefaultEmissionByStage
    wasteSortingMaterialListDefaultExpand
  }
}
    `;

/**
 * __useGetConfigQuery__
 *
 * To run a query within a Vue component, call `useGetConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConfigQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetConfigQuery(variables: GetConfigQueryVariables | VueCompositionApi.Ref<GetConfigQueryVariables> | ReactiveFunction<GetConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConfigQuery, GetConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfigQuery, GetConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfigQuery, GetConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConfigQuery, GetConfigQueryVariables>(GetConfigDocument, variables, options);
}
export function useGetConfigLazyQuery(variables?: GetConfigQueryVariables | VueCompositionApi.Ref<GetConfigQueryVariables> | ReactiveFunction<GetConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConfigQuery, GetConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfigQuery, GetConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfigQuery, GetConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConfigQuery, GetConfigQueryVariables>(GetConfigDocument, variables, options);
}
export type GetConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConfigQuery, GetConfigQueryVariables>;
export const GetConstructionByIdDocument = gql`
    query GetConstructionById($id: uuid!) {
  construction_by_pk(id: $id) {
    ...constructionFields
    inhomogeneousLayers {
      id
      amount
      descriptions {
        id
        label
        languageCode
        translationSource
      }
      names {
        id
        label
        languageCode
        translationSource
      }
      materials {
        id
        amount
        height
        length
        material {
          ...materialFields
        }
        sorting {
          ...sortingFields
        }
      }
      height
      length
      percentage
      sorting {
        ...sortingFields
      }
      thickness
    }
  }
}
    ${ConstructionFieldsFragmentDoc}
${MaterialFieldsFragmentDoc}
${SortingFieldsFragmentDoc}`;

/**
 * __useGetConstructionByIdQuery__
 *
 * To run a query within a Vue component, call `useGetConstructionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConstructionByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConstructionByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetConstructionByIdQuery(variables: GetConstructionByIdQueryVariables | VueCompositionApi.Ref<GetConstructionByIdQueryVariables> | ReactiveFunction<GetConstructionByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConstructionByIdQuery, GetConstructionByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConstructionByIdQuery, GetConstructionByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConstructionByIdQuery, GetConstructionByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConstructionByIdQuery, GetConstructionByIdQueryVariables>(GetConstructionByIdDocument, variables, options);
}
export function useGetConstructionByIdLazyQuery(variables?: GetConstructionByIdQueryVariables | VueCompositionApi.Ref<GetConstructionByIdQueryVariables> | ReactiveFunction<GetConstructionByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConstructionByIdQuery, GetConstructionByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConstructionByIdQuery, GetConstructionByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConstructionByIdQuery, GetConstructionByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConstructionByIdQuery, GetConstructionByIdQueryVariables>(GetConstructionByIdDocument, variables, options);
}
export type GetConstructionByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConstructionByIdQuery, GetConstructionByIdQueryVariables>;
export const GetDenominatorUnitsDocument = gql`
    query GetDenominatorUnits @cached {
  denominatorUnit {
    label
    id
    unit
  }
}
    `;

/**
 * __useGetDenominatorUnitsQuery__
 *
 * To run a query within a Vue component, call `useGetDenominatorUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDenominatorUnitsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDenominatorUnitsQuery();
 */
export function useGetDenominatorUnitsQuery(options: VueApolloComposable.UseQueryOptions<GetDenominatorUnitsQuery, GetDenominatorUnitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDenominatorUnitsQuery, GetDenominatorUnitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDenominatorUnitsQuery, GetDenominatorUnitsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetDenominatorUnitsQuery, GetDenominatorUnitsQueryVariables>(GetDenominatorUnitsDocument, {}, options);
}
export function useGetDenominatorUnitsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetDenominatorUnitsQuery, GetDenominatorUnitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDenominatorUnitsQuery, GetDenominatorUnitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDenominatorUnitsQuery, GetDenominatorUnitsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetDenominatorUnitsQuery, GetDenominatorUnitsQueryVariables>(GetDenominatorUnitsDocument, {}, options);
}
export type GetDenominatorUnitsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetDenominatorUnitsQuery, GetDenominatorUnitsQueryVariables>;
export const GetEmissionFactorSourcesDocument = gql`
    query GetEmissionFactorSources($country: country_enum!, $year: Int!) @cached {
  emission_factor_source(
    where: {country: {_eq: $country}, emissionFactors: {_or: [{emission_factor_type: {_in: [DIESEL, EARTH_MOVED]}, year: {_eq: 0}}, {emission_factor_type: {_nin: [DIESEL, EARTH_MOVED]}, year: {_eq: $year}}]}}
  ) {
    emissionFactorTypes {
      emissionFactorType
      emissionFactorSourceId
      installationInputDenominatorUnit {
        unit
      }
      label
      installationInputIndicatorType {
        id
        identifier
        label
        unit
        identifier_label
      }
      operationalInputDenominatorUnit {
        unit
      }
      operationalInputIndicatorType {
        id
        identifier
        label
        unit
        identifier_label
      }
    }
    id
    name
    url
    emissionFactors(distinct_on: emission_factor_type) {
      emission_factor_type
      indicatorType {
        id
        unit
      }
    }
    emissionFactors_aggregate(distinct_on: emission_factor_type) {
      nodes {
        emission_factor_type
      }
    }
  }
}
    `;

/**
 * __useGetEmissionFactorSourcesQuery__
 *
 * To run a query within a Vue component, call `useGetEmissionFactorSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmissionFactorSourcesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmissionFactorSourcesQuery({
 *   country: // value for 'country'
 *   year: // value for 'year'
 * });
 */
export function useGetEmissionFactorSourcesQuery(variables: GetEmissionFactorSourcesQueryVariables | VueCompositionApi.Ref<GetEmissionFactorSourcesQueryVariables> | ReactiveFunction<GetEmissionFactorSourcesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmissionFactorSourcesQuery, GetEmissionFactorSourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmissionFactorSourcesQuery, GetEmissionFactorSourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmissionFactorSourcesQuery, GetEmissionFactorSourcesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmissionFactorSourcesQuery, GetEmissionFactorSourcesQueryVariables>(GetEmissionFactorSourcesDocument, variables, options);
}
export function useGetEmissionFactorSourcesLazyQuery(variables?: GetEmissionFactorSourcesQueryVariables | VueCompositionApi.Ref<GetEmissionFactorSourcesQueryVariables> | ReactiveFunction<GetEmissionFactorSourcesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmissionFactorSourcesQuery, GetEmissionFactorSourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmissionFactorSourcesQuery, GetEmissionFactorSourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmissionFactorSourcesQuery, GetEmissionFactorSourcesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEmissionFactorSourcesQuery, GetEmissionFactorSourcesQueryVariables>(GetEmissionFactorSourcesDocument, variables, options);
}
export type GetEmissionFactorSourcesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmissionFactorSourcesQuery, GetEmissionFactorSourcesQueryVariables>;
export const GetEmissionFactorSumDocument = gql`
    query GetEmissionFactorSum($emissionFactorSourceId: uuid!, $emissionFactorType: emission_factor_type_enum!, $minYear: Int!, $maxYear: Int!) {
  emission_factor_aggregate(
    where: {emission_factor_source_id: {_eq: $emissionFactorSourceId}, emission_factor_type: {_eq: $emissionFactorType}, year: {_gte: $minYear, _lte: $maxYear}}
  ) {
    aggregate {
      sum {
        emission
      }
    }
  }
}
    `;

/**
 * __useGetEmissionFactorSumQuery__
 *
 * To run a query within a Vue component, call `useGetEmissionFactorSumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmissionFactorSumQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmissionFactorSumQuery({
 *   emissionFactorSourceId: // value for 'emissionFactorSourceId'
 *   emissionFactorType: // value for 'emissionFactorType'
 *   minYear: // value for 'minYear'
 *   maxYear: // value for 'maxYear'
 * });
 */
export function useGetEmissionFactorSumQuery(variables: GetEmissionFactorSumQueryVariables | VueCompositionApi.Ref<GetEmissionFactorSumQueryVariables> | ReactiveFunction<GetEmissionFactorSumQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmissionFactorSumQuery, GetEmissionFactorSumQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmissionFactorSumQuery, GetEmissionFactorSumQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmissionFactorSumQuery, GetEmissionFactorSumQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmissionFactorSumQuery, GetEmissionFactorSumQueryVariables>(GetEmissionFactorSumDocument, variables, options);
}
export function useGetEmissionFactorSumLazyQuery(variables?: GetEmissionFactorSumQueryVariables | VueCompositionApi.Ref<GetEmissionFactorSumQueryVariables> | ReactiveFunction<GetEmissionFactorSumQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmissionFactorSumQuery, GetEmissionFactorSumQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmissionFactorSumQuery, GetEmissionFactorSumQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmissionFactorSumQuery, GetEmissionFactorSumQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEmissionFactorSumQuery, GetEmissionFactorSumQueryVariables>(GetEmissionFactorSumDocument, variables, options);
}
export type GetEmissionFactorSumQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmissionFactorSumQuery, GetEmissionFactorSumQueryVariables>;
export const GetEpdDatasourcesDocument = gql`
    query GetEpdDatasources @cached {
  epdDatasource {
    id
    name
    url
  }
}
    `;

/**
 * __useGetEpdDatasourcesQuery__
 *
 * To run a query within a Vue component, call `useGetEpdDatasourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpdDatasourcesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEpdDatasourcesQuery();
 */
export function useGetEpdDatasourcesQuery(options: VueApolloComposable.UseQueryOptions<GetEpdDatasourcesQuery, GetEpdDatasourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEpdDatasourcesQuery, GetEpdDatasourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEpdDatasourcesQuery, GetEpdDatasourcesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEpdDatasourcesQuery, GetEpdDatasourcesQueryVariables>(GetEpdDatasourcesDocument, {}, options);
}
export function useGetEpdDatasourcesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetEpdDatasourcesQuery, GetEpdDatasourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEpdDatasourcesQuery, GetEpdDatasourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEpdDatasourcesQuery, GetEpdDatasourcesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEpdDatasourcesQuery, GetEpdDatasourcesQueryVariables>(GetEpdDatasourcesDocument, {}, options);
}
export type GetEpdDatasourcesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEpdDatasourcesQuery, GetEpdDatasourcesQueryVariables>;
export const GetIndicatorTypesDocument = gql`
    query GetIndicatorTypes @cached {
  indicatorType {
    identifier
    label
    id
    unit
  }
}
    `;

/**
 * __useGetIndicatorTypesQuery__
 *
 * To run a query within a Vue component, call `useGetIndicatorTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIndicatorTypesQuery();
 */
export function useGetIndicatorTypesQuery(options: VueApolloComposable.UseQueryOptions<GetIndicatorTypesQuery, GetIndicatorTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIndicatorTypesQuery, GetIndicatorTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIndicatorTypesQuery, GetIndicatorTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetIndicatorTypesQuery, GetIndicatorTypesQueryVariables>(GetIndicatorTypesDocument, {}, options);
}
export function useGetIndicatorTypesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetIndicatorTypesQuery, GetIndicatorTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIndicatorTypesQuery, GetIndicatorTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIndicatorTypesQuery, GetIndicatorTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetIndicatorTypesQuery, GetIndicatorTypesQueryVariables>(GetIndicatorTypesDocument, {}, options);
}
export type GetIndicatorTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetIndicatorTypesQuery, GetIndicatorTypesQueryVariables>;
export const GetIndicatorTypeMappingsDocument = gql`
    query GetIndicatorTypeMappings($country: country_enum!) {
  indicatorTypeMapping(
    order_by: {indicatorType: {identifier: asc}}
    where: {country: {_eq: $country}}
  ) {
    id
    country
    denominatorUnit {
      label
      id
      unit
    }
    indicatorType {
      id
      identifier
      label
      unit
      identifier_label
    }
    calculationType {
      id
    }
  }
}
    `;

/**
 * __useGetIndicatorTypeMappingsQuery__
 *
 * To run a query within a Vue component, call `useGetIndicatorTypeMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorTypeMappingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIndicatorTypeMappingsQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetIndicatorTypeMappingsQuery(variables: GetIndicatorTypeMappingsQueryVariables | VueCompositionApi.Ref<GetIndicatorTypeMappingsQueryVariables> | ReactiveFunction<GetIndicatorTypeMappingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIndicatorTypeMappingsQuery, GetIndicatorTypeMappingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIndicatorTypeMappingsQuery, GetIndicatorTypeMappingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIndicatorTypeMappingsQuery, GetIndicatorTypeMappingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetIndicatorTypeMappingsQuery, GetIndicatorTypeMappingsQueryVariables>(GetIndicatorTypeMappingsDocument, variables, options);
}
export function useGetIndicatorTypeMappingsLazyQuery(variables?: GetIndicatorTypeMappingsQueryVariables | VueCompositionApi.Ref<GetIndicatorTypeMappingsQueryVariables> | ReactiveFunction<GetIndicatorTypeMappingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIndicatorTypeMappingsQuery, GetIndicatorTypeMappingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIndicatorTypeMappingsQuery, GetIndicatorTypeMappingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIndicatorTypeMappingsQuery, GetIndicatorTypeMappingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetIndicatorTypeMappingsQuery, GetIndicatorTypeMappingsQueryVariables>(GetIndicatorTypeMappingsDocument, variables, options);
}
export type GetIndicatorTypeMappingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetIndicatorTypeMappingsQuery, GetIndicatorTypeMappingsQueryVariables>;
export const GetLevelsLifetimesDocument = gql`
    query GetLevelsLifetimes($sourceId: uuid!) @cached {
  buildingPartLifetimeSource(where: {id: {_eq: $sourceId}}) {
    id
    label
    source
    serviceLifetimes(order_by: {buildingPart: {label: asc}}) {
      id
      lifetimeAverage
      lifetimeLow
      lifetimeHigh
      buildingElementId
      buildingPart {
        id
        label
        parent_id
      }
    }
  }
  buildingPart {
    id
    label
  }
  building_element {
    id
    label
  }
}
    `;

/**
 * __useGetLevelsLifetimesQuery__
 *
 * To run a query within a Vue component, call `useGetLevelsLifetimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLevelsLifetimesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLevelsLifetimesQuery({
 *   sourceId: // value for 'sourceId'
 * });
 */
export function useGetLevelsLifetimesQuery(variables: GetLevelsLifetimesQueryVariables | VueCompositionApi.Ref<GetLevelsLifetimesQueryVariables> | ReactiveFunction<GetLevelsLifetimesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLevelsLifetimesQuery, GetLevelsLifetimesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLevelsLifetimesQuery, GetLevelsLifetimesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLevelsLifetimesQuery, GetLevelsLifetimesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLevelsLifetimesQuery, GetLevelsLifetimesQueryVariables>(GetLevelsLifetimesDocument, variables, options);
}
export function useGetLevelsLifetimesLazyQuery(variables?: GetLevelsLifetimesQueryVariables | VueCompositionApi.Ref<GetLevelsLifetimesQueryVariables> | ReactiveFunction<GetLevelsLifetimesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLevelsLifetimesQuery, GetLevelsLifetimesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLevelsLifetimesQuery, GetLevelsLifetimesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLevelsLifetimesQuery, GetLevelsLifetimesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetLevelsLifetimesQuery, GetLevelsLifetimesQueryVariables>(GetLevelsLifetimesDocument, variables, options);
}
export type GetLevelsLifetimesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLevelsLifetimesQuery, GetLevelsLifetimesQueryVariables>;
export const GetLibraryCountryDatasourcesDocument = gql`
    query GetLibraryCountryDatasources @cached {
  calculationType {
    id
    country
    label
  }
  calculationTypeEpdDatasource {
    calculationTypeId
    epdDatasourceId
  }
}
    `;

/**
 * __useGetLibraryCountryDatasourcesQuery__
 *
 * To run a query within a Vue component, call `useGetLibraryCountryDatasourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryCountryDatasourcesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLibraryCountryDatasourcesQuery();
 */
export function useGetLibraryCountryDatasourcesQuery(options: VueApolloComposable.UseQueryOptions<GetLibraryCountryDatasourcesQuery, GetLibraryCountryDatasourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLibraryCountryDatasourcesQuery, GetLibraryCountryDatasourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLibraryCountryDatasourcesQuery, GetLibraryCountryDatasourcesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLibraryCountryDatasourcesQuery, GetLibraryCountryDatasourcesQueryVariables>(GetLibraryCountryDatasourcesDocument, {}, options);
}
export function useGetLibraryCountryDatasourcesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetLibraryCountryDatasourcesQuery, GetLibraryCountryDatasourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLibraryCountryDatasourcesQuery, GetLibraryCountryDatasourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLibraryCountryDatasourcesQuery, GetLibraryCountryDatasourcesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetLibraryCountryDatasourcesQuery, GetLibraryCountryDatasourcesQueryVariables>(GetLibraryCountryDatasourcesDocument, {}, options);
}
export type GetLibraryCountryDatasourcesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLibraryCountryDatasourcesQuery, GetLibraryCountryDatasourcesQueryVariables>;
export const GetMaterialCategoryTextureByIdDocument = gql`
    query GetMaterialCategoryTextureById($categoryIds: [String!]!) @cached {
  materialCategoryTexture(where: {materialCategoryId: {_in: $categoryIds}}) {
    materialCategoryId
    url
  }
}
    `;

/**
 * __useGetMaterialCategoryTextureByIdQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialCategoryTextureByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialCategoryTextureByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialCategoryTextureByIdQuery({
 *   categoryIds: // value for 'categoryIds'
 * });
 */
export function useGetMaterialCategoryTextureByIdQuery(variables: GetMaterialCategoryTextureByIdQueryVariables | VueCompositionApi.Ref<GetMaterialCategoryTextureByIdQueryVariables> | ReactiveFunction<GetMaterialCategoryTextureByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMaterialCategoryTextureByIdQuery, GetMaterialCategoryTextureByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialCategoryTextureByIdQuery, GetMaterialCategoryTextureByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialCategoryTextureByIdQuery, GetMaterialCategoryTextureByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMaterialCategoryTextureByIdQuery, GetMaterialCategoryTextureByIdQueryVariables>(GetMaterialCategoryTextureByIdDocument, variables, options);
}
export function useGetMaterialCategoryTextureByIdLazyQuery(variables?: GetMaterialCategoryTextureByIdQueryVariables | VueCompositionApi.Ref<GetMaterialCategoryTextureByIdQueryVariables> | ReactiveFunction<GetMaterialCategoryTextureByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMaterialCategoryTextureByIdQuery, GetMaterialCategoryTextureByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialCategoryTextureByIdQuery, GetMaterialCategoryTextureByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialCategoryTextureByIdQuery, GetMaterialCategoryTextureByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMaterialCategoryTextureByIdQuery, GetMaterialCategoryTextureByIdQueryVariables>(GetMaterialCategoryTextureByIdDocument, variables, options);
}
export type GetMaterialCategoryTextureByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMaterialCategoryTextureByIdQuery, GetMaterialCategoryTextureByIdQueryVariables>;
export const GetMaterialFavoritesDocument = gql`
    query GetMaterialFavorites {
  userMaterialFavorite {
    materialInternalId
  }
}
    `;

/**
 * __useGetMaterialFavoritesQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialFavoritesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialFavoritesQuery();
 */
export function useGetMaterialFavoritesQuery(options: VueApolloComposable.UseQueryOptions<GetMaterialFavoritesQuery, GetMaterialFavoritesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialFavoritesQuery, GetMaterialFavoritesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialFavoritesQuery, GetMaterialFavoritesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMaterialFavoritesQuery, GetMaterialFavoritesQueryVariables>(GetMaterialFavoritesDocument, {}, options);
}
export function useGetMaterialFavoritesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMaterialFavoritesQuery, GetMaterialFavoritesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialFavoritesQuery, GetMaterialFavoritesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialFavoritesQuery, GetMaterialFavoritesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMaterialFavoritesQuery, GetMaterialFavoritesQueryVariables>(GetMaterialFavoritesDocument, {}, options);
}
export type GetMaterialFavoritesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMaterialFavoritesQuery, GetMaterialFavoritesQueryVariables>;
export const GetMaterialDocument = gql`
    query GetMaterial($id: uuid!) {
  material: material_by_pk(id: $id) {
    id
    isPublic
    lifetime
    description
    name
    type
    validTo
    createdAt
    createdBy
    updatedAt
    updatedBy
    categoryId
    category {
      id
      label
    }
    declaredUnit {
      id
      unit {
        id
        label
        fullName
        pluralFullName
      }
      value
    }
    deprecated
    epd {
      id
      declarationNumber
      publicationDate
      version
      datasources {
        datasource {
          id
          name
          url
        }
      }
      owner {
        id
        name
        vatNumber
        street
        streetNumber
        country
        city
      }
      productIndustry {
        id
        label
      }
      specificationForm {
        id
        label
      }
      urls {
        id
        documentation
        source
      }
    }
    emissions {
      indicators {
        id
        indicatorType {
          id
          label
          identifier_label
          unit
        }
        value
        source
      }
      stage {
        id
        label
      }
    }
    faulty
    weightPerDeclaredUnit {
      id
      denominatorUnit {
        id
        label
      }
      unit {
        id
        label
        fullName
        pluralFullName
      }
      value
    }
  }
}
    `;

/**
 * __useGetMaterialQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMaterialQuery(variables: GetMaterialQueryVariables | VueCompositionApi.Ref<GetMaterialQueryVariables> | ReactiveFunction<GetMaterialQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMaterialQuery, GetMaterialQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialQuery, GetMaterialQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialQuery, GetMaterialQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMaterialQuery, GetMaterialQueryVariables>(GetMaterialDocument, variables, options);
}
export function useGetMaterialLazyQuery(variables?: GetMaterialQueryVariables | VueCompositionApi.Ref<GetMaterialQueryVariables> | ReactiveFunction<GetMaterialQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMaterialQuery, GetMaterialQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialQuery, GetMaterialQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialQuery, GetMaterialQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMaterialQuery, GetMaterialQueryVariables>(GetMaterialDocument, variables, options);
}
export type GetMaterialQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMaterialQuery, GetMaterialQueryVariables>;
export const GetMaterialTenantCollectionItemsDocument = gql`
    query GetMaterialTenantCollectionItems($materialInternalId: String!) {
  tenantCollectionItem(where: {materialInternalId: {_eq: $materialInternalId}}) {
    tenantCollectionId
    materialInternalId
  }
}
    `;

/**
 * __useGetMaterialTenantCollectionItemsQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialTenantCollectionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialTenantCollectionItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialTenantCollectionItemsQuery({
 *   materialInternalId: // value for 'materialInternalId'
 * });
 */
export function useGetMaterialTenantCollectionItemsQuery(variables: GetMaterialTenantCollectionItemsQueryVariables | VueCompositionApi.Ref<GetMaterialTenantCollectionItemsQueryVariables> | ReactiveFunction<GetMaterialTenantCollectionItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMaterialTenantCollectionItemsQuery, GetMaterialTenantCollectionItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialTenantCollectionItemsQuery, GetMaterialTenantCollectionItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialTenantCollectionItemsQuery, GetMaterialTenantCollectionItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMaterialTenantCollectionItemsQuery, GetMaterialTenantCollectionItemsQueryVariables>(GetMaterialTenantCollectionItemsDocument, variables, options);
}
export function useGetMaterialTenantCollectionItemsLazyQuery(variables?: GetMaterialTenantCollectionItemsQueryVariables | VueCompositionApi.Ref<GetMaterialTenantCollectionItemsQueryVariables> | ReactiveFunction<GetMaterialTenantCollectionItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMaterialTenantCollectionItemsQuery, GetMaterialTenantCollectionItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialTenantCollectionItemsQuery, GetMaterialTenantCollectionItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialTenantCollectionItemsQuery, GetMaterialTenantCollectionItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMaterialTenantCollectionItemsQuery, GetMaterialTenantCollectionItemsQueryVariables>(GetMaterialTenantCollectionItemsDocument, variables, options);
}
export type GetMaterialTenantCollectionItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMaterialTenantCollectionItemsQuery, GetMaterialTenantCollectionItemsQueryVariables>;
export const GetMaterialWasteTypesByCountryDocument = gql`
    query GetMaterialWasteTypesByCountry($country: country_enum!) @cached {
  materialWasteType(where: {wasteSource: {country: {_eq: $country}}}) {
    ...materialWasteType
    wasteSource {
      ...materialWasteSource
    }
  }
}
    ${MaterialWasteTypeFragmentDoc}
${MaterialWasteSourceFragmentDoc}`;

/**
 * __useGetMaterialWasteTypesByCountryQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialWasteTypesByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialWasteTypesByCountryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialWasteTypesByCountryQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetMaterialWasteTypesByCountryQuery(variables: GetMaterialWasteTypesByCountryQueryVariables | VueCompositionApi.Ref<GetMaterialWasteTypesByCountryQueryVariables> | ReactiveFunction<GetMaterialWasteTypesByCountryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMaterialWasteTypesByCountryQuery, GetMaterialWasteTypesByCountryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialWasteTypesByCountryQuery, GetMaterialWasteTypesByCountryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialWasteTypesByCountryQuery, GetMaterialWasteTypesByCountryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMaterialWasteTypesByCountryQuery, GetMaterialWasteTypesByCountryQueryVariables>(GetMaterialWasteTypesByCountryDocument, variables, options);
}
export function useGetMaterialWasteTypesByCountryLazyQuery(variables?: GetMaterialWasteTypesByCountryQueryVariables | VueCompositionApi.Ref<GetMaterialWasteTypesByCountryQueryVariables> | ReactiveFunction<GetMaterialWasteTypesByCountryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMaterialWasteTypesByCountryQuery, GetMaterialWasteTypesByCountryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMaterialWasteTypesByCountryQuery, GetMaterialWasteTypesByCountryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMaterialWasteTypesByCountryQuery, GetMaterialWasteTypesByCountryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMaterialWasteTypesByCountryQuery, GetMaterialWasteTypesByCountryQueryVariables>(GetMaterialWasteTypesByCountryDocument, variables, options);
}
export type GetMaterialWasteTypesByCountryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMaterialWasteTypesByCountryQuery, GetMaterialWasteTypesByCountryQueryVariables>;
export const GetModelsDocument = gql`
    query GetModels($country: country_enum!) @cached {
  model(where: {country: {_eq: $country}}) {
    id
    name
  }
}
    `;

/**
 * __useGetModelsQuery__
 *
 * To run a query within a Vue component, call `useGetModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetModelsQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetModelsQuery(variables: GetModelsQueryVariables | VueCompositionApi.Ref<GetModelsQueryVariables> | ReactiveFunction<GetModelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetModelsQuery, GetModelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetModelsQuery, GetModelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetModelsQuery, GetModelsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetModelsQuery, GetModelsQueryVariables>(GetModelsDocument, variables, options);
}
export function useGetModelsLazyQuery(variables?: GetModelsQueryVariables | VueCompositionApi.Ref<GetModelsQueryVariables> | ReactiveFunction<GetModelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetModelsQuery, GetModelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetModelsQuery, GetModelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetModelsQuery, GetModelsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetModelsQuery, GetModelsQueryVariables>(GetModelsDocument, variables, options);
}
export type GetModelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetModelsQuery, GetModelsQueryVariables>;
export const GetProjectByIdDocument = gql`
    query GetProjectById($id: uuid!) {
  project_by_pk(id: $id) {
    id
    name
    projectNumber
    role
    speckleStreamId
    area
    yearOfCommissioning
    yearOfConstruction
    lcaResponsibleName
    buildingAreas {
      id
      buildingTypeId
      buildingAreaType
      area
      floors
      heatedArea
    }
    buildingType {
      id
      label
    }
    projectStatus {
      id
      label
    }
    calculation {
      id
      calculationType {
        id
        label
        variant {
          id
          variant
        }
        thresholdIndicator {
          id
          indicatorType {
            id
            unit
          }
          denominatorUnit {
            id
            unit
          }
        }
      }
      considerationPeriod
      stages {
        id
        stage {
          id
          label
        }
      }
      useDefaultEmissions
    }
    installation {
      wastagePercentage {
        id
        value
      }
    }
    location {
      city
      country
    }
    numberOfPeople
    specialConditionConfig {
      enabled
    }
  }
}
    `;

/**
 * __useGetProjectByIdQuery__
 *
 * To run a query within a Vue component, call `useGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetProjectByIdQuery(variables: GetProjectByIdQueryVariables | VueCompositionApi.Ref<GetProjectByIdQueryVariables> | ReactiveFunction<GetProjectByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, variables, options);
}
export function useGetProjectByIdLazyQuery(variables?: GetProjectByIdQueryVariables | VueCompositionApi.Ref<GetProjectByIdQueryVariables> | ReactiveFunction<GetProjectByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, variables, options);
}
export type GetProjectByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectByIdQuery, GetProjectByIdQueryVariables>;
export const GetProjectEmissionFactorCustomSourcesDocument = gql`
    query GetProjectEmissionFactorCustomSources {
  projectEmissionFactorCustom {
    id
    name
    description
    emissionFactorType: type
    emissionValue
    createdAt
    deletedAt
    projectEmissionFactors_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetProjectEmissionFactorCustomSourcesQuery__
 *
 * To run a query within a Vue component, call `useGetProjectEmissionFactorCustomSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectEmissionFactorCustomSourcesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectEmissionFactorCustomSourcesQuery();
 */
export function useGetProjectEmissionFactorCustomSourcesQuery(options: VueApolloComposable.UseQueryOptions<GetProjectEmissionFactorCustomSourcesQuery, GetProjectEmissionFactorCustomSourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectEmissionFactorCustomSourcesQuery, GetProjectEmissionFactorCustomSourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectEmissionFactorCustomSourcesQuery, GetProjectEmissionFactorCustomSourcesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectEmissionFactorCustomSourcesQuery, GetProjectEmissionFactorCustomSourcesQueryVariables>(GetProjectEmissionFactorCustomSourcesDocument, {}, options);
}
export function useGetProjectEmissionFactorCustomSourcesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetProjectEmissionFactorCustomSourcesQuery, GetProjectEmissionFactorCustomSourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectEmissionFactorCustomSourcesQuery, GetProjectEmissionFactorCustomSourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectEmissionFactorCustomSourcesQuery, GetProjectEmissionFactorCustomSourcesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectEmissionFactorCustomSourcesQuery, GetProjectEmissionFactorCustomSourcesQueryVariables>(GetProjectEmissionFactorCustomSourcesDocument, {}, options);
}
export type GetProjectEmissionFactorCustomSourcesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectEmissionFactorCustomSourcesQuery, GetProjectEmissionFactorCustomSourcesQueryVariables>;
export const GetProjectListFiltersDocument = gql`
    query GetProjectListFilters @cached {
  buildingType: project(
    distinct_on: [buildingTypeId]
    order_by: [{buildingTypeId: asc}, {buildingType: {label: asc}}]
  ) {
    buildingType {
      id
      label
    }
  }
  projectCalculation(
    distinct_on: calculationTypeId
    order_by: [{calculationTypeId: asc}, {calculationType: {label: asc}}]
  ) {
    calculationType {
      id
      label
    }
  }
  projectLocation(
    distinct_on: [country]
    order_by: {country: asc}
    where: {revision: {frozenAt: {_is_null: true}}}
  ) {
    id
    country
  }
  projectMembership(distinct_on: [role]) {
    role
    membershipRole {
      id
      level
    }
  }
  projectStatus: project(
    distinct_on: [projectStatusId]
    order_by: [{projectStatusId: asc}, {projectStatus: {label: asc}}]
  ) {
    projectStatus {
      id
      label
    }
  }
}
    `;

/**
 * __useGetProjectListFiltersQuery__
 *
 * To run a query within a Vue component, call `useGetProjectListFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectListFiltersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectListFiltersQuery();
 */
export function useGetProjectListFiltersQuery(options: VueApolloComposable.UseQueryOptions<GetProjectListFiltersQuery, GetProjectListFiltersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectListFiltersQuery, GetProjectListFiltersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectListFiltersQuery, GetProjectListFiltersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectListFiltersQuery, GetProjectListFiltersQueryVariables>(GetProjectListFiltersDocument, {}, options);
}
export function useGetProjectListFiltersLazyQuery(options: VueApolloComposable.UseQueryOptions<GetProjectListFiltersQuery, GetProjectListFiltersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectListFiltersQuery, GetProjectListFiltersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectListFiltersQuery, GetProjectListFiltersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectListFiltersQuery, GetProjectListFiltersQueryVariables>(GetProjectListFiltersDocument, {}, options);
}
export type GetProjectListFiltersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectListFiltersQuery, GetProjectListFiltersQueryVariables>;
export const GetProjectListDocument = gql`
    query GetProjectList($orderBy: [project_order_by!], $where: project_bool_exp) {
  project(order_by: $orderBy, where: $where) {
    ...projectList
  }
}
    ${ProjectListFragmentDoc}`;

/**
 * __useGetProjectListQuery__
 *
 * To run a query within a Vue component, call `useGetProjectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectListQuery({
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useGetProjectListQuery(variables: GetProjectListQueryVariables | VueCompositionApi.Ref<GetProjectListQueryVariables> | ReactiveFunction<GetProjectListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetProjectListQuery, GetProjectListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectListQuery, GetProjectListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectListQuery, GetProjectListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectListQuery, GetProjectListQueryVariables>(GetProjectListDocument, variables, options);
}
export function useGetProjectListLazyQuery(variables: GetProjectListQueryVariables | VueCompositionApi.Ref<GetProjectListQueryVariables> | ReactiveFunction<GetProjectListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetProjectListQuery, GetProjectListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectListQuery, GetProjectListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectListQuery, GetProjectListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectListQuery, GetProjectListQueryVariables>(GetProjectListDocument, variables, options);
}
export type GetProjectListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectListQuery, GetProjectListQueryVariables>;
export const GetProjectOperationalDocument = gql`
    query GetProjectOperational($projectId: uuid!) {
  projectOperational(
    where: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}
  ) {
    id
    heatSupply {
      id
      type
      value
      sourceId
      customSourceId
      emissionFactorSource {
        id
        name
      }
      customEmissionFactor {
        id
        name
      }
    }
    electricitySupply {
      id
      type
      value
      sourceId
      customSourceId
      emissionFactorSource {
        id
        name
      }
      customEmissionFactor {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetProjectOperationalQuery__
 *
 * To run a query within a Vue component, call `useGetProjectOperationalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectOperationalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectOperationalQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectOperationalQuery(variables: GetProjectOperationalQueryVariables | VueCompositionApi.Ref<GetProjectOperationalQueryVariables> | ReactiveFunction<GetProjectOperationalQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectOperationalQuery, GetProjectOperationalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectOperationalQuery, GetProjectOperationalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectOperationalQuery, GetProjectOperationalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectOperationalQuery, GetProjectOperationalQueryVariables>(GetProjectOperationalDocument, variables, options);
}
export function useGetProjectOperationalLazyQuery(variables?: GetProjectOperationalQueryVariables | VueCompositionApi.Ref<GetProjectOperationalQueryVariables> | ReactiveFunction<GetProjectOperationalQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectOperationalQuery, GetProjectOperationalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectOperationalQuery, GetProjectOperationalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectOperationalQuery, GetProjectOperationalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectOperationalQuery, GetProjectOperationalQueryVariables>(GetProjectOperationalDocument, variables, options);
}
export type GetProjectOperationalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectOperationalQuery, GetProjectOperationalQueryVariables>;
export const GetProjectPermissionsDocument = gql`
    query GetProjectPermissions($projectId: uuid!) {
  project_by_pk(id: $projectId) {
    id
    role
  }
  roles {
    id
    permissions
  }
}
    `;

/**
 * __useGetProjectPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetProjectPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectPermissionsQuery(variables: GetProjectPermissionsQueryVariables | VueCompositionApi.Ref<GetProjectPermissionsQueryVariables> | ReactiveFunction<GetProjectPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>(GetProjectPermissionsDocument, variables, options);
}
export function useGetProjectPermissionsLazyQuery(variables?: GetProjectPermissionsQueryVariables | VueCompositionApi.Ref<GetProjectPermissionsQueryVariables> | ReactiveFunction<GetProjectPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>(GetProjectPermissionsDocument, variables, options);
}
export type GetProjectPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($project_id: uuid, $revisionFilter: project_transport_bool_exp = {revision: {frozenAt: {_is_null: true}}}, $defaultRevisionFilter: project_transport_default_bool_exp = {revision: {frozenAt: {_is_null: true}}}) {
  project_transport(
    where: {project_id: {_eq: $project_id}, _and: [$revisionFilter]}
    order_by: [{created_at: asc}]
  ) {
    ...projectTransportRow
  }
  project_transport_default(
    where: {project_id: {_eq: $project_id}, _and: [$defaultRevisionFilter]}
  ) {
    project_transport_id
  }
}
    ${ProjectTransportRowFragmentDoc}`;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a Vue component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectQuery({
 *   project_id: // value for 'project_id'
 *   revisionFilter: // value for 'revisionFilter'
 *   defaultRevisionFilter: // value for 'defaultRevisionFilter'
 * });
 */
export function useGetProjectQuery(variables: GetProjectQueryVariables | VueCompositionApi.Ref<GetProjectQueryVariables> | ReactiveFunction<GetProjectQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetProjectQuery, GetProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectQuery, GetProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectQuery, GetProjectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, variables, options);
}
export function useGetProjectLazyQuery(variables: GetProjectQueryVariables | VueCompositionApi.Ref<GetProjectQueryVariables> | ReactiveFunction<GetProjectQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetProjectQuery, GetProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectQuery, GetProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectQuery, GetProjectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, variables, options);
}
export type GetProjectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectRevisionsDocument = gql`
    query GetProjectRevisions($projectId: uuid!) {
  projectRevision(
    where: {projectId: {_eq: $projectId}}
    order_by: [{createdAt: desc}]
  ) {
    id
    name
    projectName
    projectNumber
    clientName
    builderName
    lcaResponsibleName
    numberOfPeople
    buildingTypeId
    projectStatusId
    yearOfConstruction
    yearOfCommissioning
    versionNumber
    parentRevisionId
    deletedAt
    martenVersion
    createdBy
    createdAt
    frozenAt
    location {
      street
      streetNumber
      postalCode
      city
      country
    }
    calculation {
      stages {
        stage {
          label
        }
      }
    }
    models {
      name
      referencedObjectId
      commitId
      speckleModelId
    }
    transports(order_by: [{created_at: asc}]) {
      ...projectTransportRow
    }
    transportDefaults {
      project_transport_id
    }
    operational {
      heatSupply {
        ...revisionEmissionFactor
      }
      electricitySupply {
        ...revisionEmissionFactor
      }
      exportedElectricity {
        ...revisionEmissionFactor
      }
      validatedAt
      validatedBy
    }
  }
}
    ${ProjectTransportRowFragmentDoc}
${RevisionEmissionFactorFragmentDoc}`;

/**
 * __useGetProjectRevisionsQuery__
 *
 * To run a query within a Vue component, call `useGetProjectRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectRevisionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectRevisionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectRevisionsQuery(variables: GetProjectRevisionsQueryVariables | VueCompositionApi.Ref<GetProjectRevisionsQueryVariables> | ReactiveFunction<GetProjectRevisionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectRevisionsQuery, GetProjectRevisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectRevisionsQuery, GetProjectRevisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectRevisionsQuery, GetProjectRevisionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectRevisionsQuery, GetProjectRevisionsQueryVariables>(GetProjectRevisionsDocument, variables, options);
}
export function useGetProjectRevisionsLazyQuery(variables?: GetProjectRevisionsQueryVariables | VueCompositionApi.Ref<GetProjectRevisionsQueryVariables> | ReactiveFunction<GetProjectRevisionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectRevisionsQuery, GetProjectRevisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectRevisionsQuery, GetProjectRevisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectRevisionsQuery, GetProjectRevisionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectRevisionsQuery, GetProjectRevisionsQueryVariables>(GetProjectRevisionsDocument, variables, options);
}
export type GetProjectRevisionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectRevisionsQuery, GetProjectRevisionsQueryVariables>;
export const GetProjectSettingsDocument = gql`
    query GetProjectSettings($projectId: uuid!) {
  project: project_by_pk(id: $projectId) {
    id
    name
    projectNumber
    clientName
    builderName
    lcaResponsibleName
    numberOfPeople
    buildingTypeId
    projectStatusId
    yearOfConstruction
    yearOfCommissioning
    speckleStreamId
    location {
      street
      streetNumber
      postalCode
      city
      country
    }
    calculation {
      calculationTypeId
      considerationPeriod
      thresholdLimit
      installationThresholdLimit
      useDefaultEmissions
      stages {
        stageId
      }
      calculationType {
        thresholdIndicator {
          indicatorType {
            id
          }
        }
      }
    }
    buildingAreas {
      buildingTypeId
      buildingAreaType
      area
      floors
      heatedArea
    }
    referenceAreas {
      referenceAreaTypeKey
      area
      description
    }
    installation {
      wastagePercentage {
        value
      }
      earthMovedByMachinery {
        ...settingsEmissionFactor
      }
      electricitySupply {
        ...settingsEmissionFactor
      }
      heatSupply {
        ...settingsEmissionFactor
      }
      machineryFuel {
        ...settingsEmissionFactor
      }
    }
    operational {
      validatedBy
      validatedAt
      exportedElectricity {
        value
      }
      electricitySupply {
        ...settingsEmissionFactor
      }
      heatSupply {
        ...settingsEmissionFactor
      }
    }
    models {
      id
      name
      active
      commitId
      pulledAt
      referencedObjectId
      speckleModelId
    }
    specialConditionConfig {
      enabled
    }
  }
  speckleParameterConfig: projectSpeckleParameterConfig_by_pk(
    projectId: $projectId
  ) {
    classificationTypeId
    classificationCode
  }
}
    ${SettingsEmissionFactorFragmentDoc}`;

/**
 * __useGetProjectSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetProjectSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectSettingsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectSettingsQuery(variables: GetProjectSettingsQueryVariables | VueCompositionApi.Ref<GetProjectSettingsQueryVariables> | ReactiveFunction<GetProjectSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, variables, options);
}
export function useGetProjectSettingsLazyQuery(variables?: GetProjectSettingsQueryVariables | VueCompositionApi.Ref<GetProjectSettingsQueryVariables> | ReactiveFunction<GetProjectSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, variables, options);
}
export type GetProjectSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>;
export const GetProjectSpecialConditionTypeMappingDocument = gql`
    query GetProjectSpecialConditionTypeMapping($buildingProjectId: uuid!, $model: String!, $typeIdentifiers: [String!]!, $revisionFilter: projectSpecialConditionTypeMapping_bool_exp = {revision: {frozenAt: {_is_null: true}}}) {
  projectSpecialConditionTypeMapping(
    where: {projectId: {_eq: $buildingProjectId}, model: {_eq: $model}, typeIdentifier: {_in: $typeIdentifiers}, _and: [$revisionFilter]}
  ) {
    areaOfConstruction
    description
    id
    length
    model
    specialConditionType {
      ...specialConditionTypeFragment
    }
    typeIdentifier
  }
}
    ${SpecialConditionTypeFragmentFragmentDoc}`;

/**
 * __useGetProjectSpecialConditionTypeMappingQuery__
 *
 * To run a query within a Vue component, call `useGetProjectSpecialConditionTypeMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSpecialConditionTypeMappingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectSpecialConditionTypeMappingQuery({
 *   buildingProjectId: // value for 'buildingProjectId'
 *   model: // value for 'model'
 *   typeIdentifiers: // value for 'typeIdentifiers'
 *   revisionFilter: // value for 'revisionFilter'
 * });
 */
export function useGetProjectSpecialConditionTypeMappingQuery(variables: GetProjectSpecialConditionTypeMappingQueryVariables | VueCompositionApi.Ref<GetProjectSpecialConditionTypeMappingQueryVariables> | ReactiveFunction<GetProjectSpecialConditionTypeMappingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectSpecialConditionTypeMappingQuery, GetProjectSpecialConditionTypeMappingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectSpecialConditionTypeMappingQuery, GetProjectSpecialConditionTypeMappingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectSpecialConditionTypeMappingQuery, GetProjectSpecialConditionTypeMappingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectSpecialConditionTypeMappingQuery, GetProjectSpecialConditionTypeMappingQueryVariables>(GetProjectSpecialConditionTypeMappingDocument, variables, options);
}
export function useGetProjectSpecialConditionTypeMappingLazyQuery(variables?: GetProjectSpecialConditionTypeMappingQueryVariables | VueCompositionApi.Ref<GetProjectSpecialConditionTypeMappingQueryVariables> | ReactiveFunction<GetProjectSpecialConditionTypeMappingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectSpecialConditionTypeMappingQuery, GetProjectSpecialConditionTypeMappingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectSpecialConditionTypeMappingQuery, GetProjectSpecialConditionTypeMappingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectSpecialConditionTypeMappingQuery, GetProjectSpecialConditionTypeMappingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectSpecialConditionTypeMappingQuery, GetProjectSpecialConditionTypeMappingQueryVariables>(GetProjectSpecialConditionTypeMappingDocument, variables, options);
}
export type GetProjectSpecialConditionTypeMappingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectSpecialConditionTypeMappingQuery, GetProjectSpecialConditionTypeMappingQueryVariables>;
export const GetProjectSpeckleStreamIdDocument = gql`
    query GetProjectSpeckleStreamId($projectId: uuid!) {
  project: project_by_pk(id: $projectId) {
    id
    speckleStreamId
  }
}
    `;

/**
 * __useGetProjectSpeckleStreamIdQuery__
 *
 * To run a query within a Vue component, call `useGetProjectSpeckleStreamIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSpeckleStreamIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectSpeckleStreamIdQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectSpeckleStreamIdQuery(variables: GetProjectSpeckleStreamIdQueryVariables | VueCompositionApi.Ref<GetProjectSpeckleStreamIdQueryVariables> | ReactiveFunction<GetProjectSpeckleStreamIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables>(GetProjectSpeckleStreamIdDocument, variables, options);
}
export function useGetProjectSpeckleStreamIdLazyQuery(variables?: GetProjectSpeckleStreamIdQueryVariables | VueCompositionApi.Ref<GetProjectSpeckleStreamIdQueryVariables> | ReactiveFunction<GetProjectSpeckleStreamIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables>(GetProjectSpeckleStreamIdDocument, variables, options);
}
export type GetProjectSpeckleStreamIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables>;
export const GetProjectStandardValueStagesDocument = gql`
    query GetProjectStandardValueStages($projectId: uuid!, $revisionFilter: projectStandardValueStage_bool_exp = {revision: {frozenAt: {_is_null: true}}}) {
  projectStandardValueStage(
    where: {projectId: {_eq: $projectId}, _and: [$revisionFilter]}
  ) {
    id
    projectId
    stageId
    stage {
      id
      label
    }
  }
}
    `;

/**
 * __useGetProjectStandardValueStagesQuery__
 *
 * To run a query within a Vue component, call `useGetProjectStandardValueStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectStandardValueStagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectStandardValueStagesQuery({
 *   projectId: // value for 'projectId'
 *   revisionFilter: // value for 'revisionFilter'
 * });
 */
export function useGetProjectStandardValueStagesQuery(variables: GetProjectStandardValueStagesQueryVariables | VueCompositionApi.Ref<GetProjectStandardValueStagesQueryVariables> | ReactiveFunction<GetProjectStandardValueStagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectStandardValueStagesQuery, GetProjectStandardValueStagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectStandardValueStagesQuery, GetProjectStandardValueStagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectStandardValueStagesQuery, GetProjectStandardValueStagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectStandardValueStagesQuery, GetProjectStandardValueStagesQueryVariables>(GetProjectStandardValueStagesDocument, variables, options);
}
export function useGetProjectStandardValueStagesLazyQuery(variables?: GetProjectStandardValueStagesQueryVariables | VueCompositionApi.Ref<GetProjectStandardValueStagesQueryVariables> | ReactiveFunction<GetProjectStandardValueStagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectStandardValueStagesQuery, GetProjectStandardValueStagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectStandardValueStagesQuery, GetProjectStandardValueStagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectStandardValueStagesQuery, GetProjectStandardValueStagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectStandardValueStagesQuery, GetProjectStandardValueStagesQueryVariables>(GetProjectStandardValueStagesDocument, variables, options);
}
export type GetProjectStandardValueStagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectStandardValueStagesQuery, GetProjectStandardValueStagesQueryVariables>;
export const GetProjectSwitcherListDocument = gql`
    query GetProjectSwitcherList($tenantId: String!) {
  project(
    where: {deletedBy: {_is_null: true}, tenantId: {_eq: $tenantId}}
    order_by: {name: asc}
  ) {
    id
    name
    projectStatus {
      id
    }
  }
}
    `;

/**
 * __useGetProjectSwitcherListQuery__
 *
 * To run a query within a Vue component, call `useGetProjectSwitcherListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSwitcherListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectSwitcherListQuery({
 *   tenantId: // value for 'tenantId'
 * });
 */
export function useGetProjectSwitcherListQuery(variables: GetProjectSwitcherListQueryVariables | VueCompositionApi.Ref<GetProjectSwitcherListQueryVariables> | ReactiveFunction<GetProjectSwitcherListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectSwitcherListQuery, GetProjectSwitcherListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectSwitcherListQuery, GetProjectSwitcherListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectSwitcherListQuery, GetProjectSwitcherListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectSwitcherListQuery, GetProjectSwitcherListQueryVariables>(GetProjectSwitcherListDocument, variables, options);
}
export function useGetProjectSwitcherListLazyQuery(variables?: GetProjectSwitcherListQueryVariables | VueCompositionApi.Ref<GetProjectSwitcherListQueryVariables> | ReactiveFunction<GetProjectSwitcherListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectSwitcherListQuery, GetProjectSwitcherListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectSwitcherListQuery, GetProjectSwitcherListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectSwitcherListQuery, GetProjectSwitcherListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectSwitcherListQuery, GetProjectSwitcherListQueryVariables>(GetProjectSwitcherListDocument, variables, options);
}
export type GetProjectSwitcherListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectSwitcherListQuery, GetProjectSwitcherListQueryVariables>;
export const GetProjectTransportMappingDocument = gql`
    query GetProjectTransportMapping($project_id: uuid!, $materialIdIsNull: Boolean!, $revisionFilter: project_transport_mapping_bool_exp = {revision: {frozenAt: {_is_null: true}}}) {
  project_transport_mapping(
    where: {project_id: {_eq: $project_id}, material_id: {_is_null: $materialIdIsNull}, _and: [$revisionFilter]}
  ) {
    distance
    id
    created_at
    material_id
    project_id
    project_transport_id
    updated_at
    transportEmissionFactorEmission
    emissionFactors {
      id
      transportEmissionFactorId
      emissionFactor {
        id
        label
        emission
        denominatorUnit {
          id
        }
        transportSource {
          id
          label
          datasource
        }
      }
    }
    transportStandardValue {
      id
      mainGroup
      emission
      subGroup
      transportSource {
        id
        label
        datasource
      }
    }
  }
}
    `;

/**
 * __useGetProjectTransportMappingQuery__
 *
 * To run a query within a Vue component, call `useGetProjectTransportMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTransportMappingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectTransportMappingQuery({
 *   project_id: // value for 'project_id'
 *   materialIdIsNull: // value for 'materialIdIsNull'
 *   revisionFilter: // value for 'revisionFilter'
 * });
 */
export function useGetProjectTransportMappingQuery(variables: GetProjectTransportMappingQueryVariables | VueCompositionApi.Ref<GetProjectTransportMappingQueryVariables> | ReactiveFunction<GetProjectTransportMappingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectTransportMappingQuery, GetProjectTransportMappingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectTransportMappingQuery, GetProjectTransportMappingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectTransportMappingQuery, GetProjectTransportMappingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectTransportMappingQuery, GetProjectTransportMappingQueryVariables>(GetProjectTransportMappingDocument, variables, options);
}
export function useGetProjectTransportMappingLazyQuery(variables?: GetProjectTransportMappingQueryVariables | VueCompositionApi.Ref<GetProjectTransportMappingQueryVariables> | ReactiveFunction<GetProjectTransportMappingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectTransportMappingQuery, GetProjectTransportMappingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectTransportMappingQuery, GetProjectTransportMappingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectTransportMappingQuery, GetProjectTransportMappingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectTransportMappingQuery, GetProjectTransportMappingQueryVariables>(GetProjectTransportMappingDocument, variables, options);
}
export type GetProjectTransportMappingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectTransportMappingQuery, GetProjectTransportMappingQueryVariables>;
export const GetProjectVersionsDocument = gql`
    query GetProjectVersions($projectId: uuid!) {
  projectVersionNumbered(
    where: {projectId: {_eq: $projectId}}
    order_by: [{createdAt: desc}, {id: desc}]
  ) {
    id
    versionNumber
    revisionId
    entityType
    entityId
    entityLabel
    operation
    summary
    changes
    source
    informational
    martenVersion
    createdBy
    createdAt
  }
  project_by_pk(id: $projectId) {
    id
    sourceProjectId
    sourceVersionId
    sourceVersionNumber
    sourceProject {
      id
      name
      deletedAt
      sourceProjectId
      sourceVersionId
      sourceVersionNumber
      sourceProject {
        id
        name
        deletedAt
        sourceProjectId
        sourceVersionId
        sourceVersionNumber
        sourceProject {
          id
          name
          deletedAt
          sourceProjectId
          sourceVersionId
          sourceVersionNumber
          sourceProject {
            id
            name
            deletedAt
            sourceProjectId
            sourceVersionId
            sourceVersionNumber
            sourceProject {
              id
              name
              deletedAt
              sourceProjectId
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectVersionsQuery__
 *
 * To run a query within a Vue component, call `useGetProjectVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectVersionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectVersionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectVersionsQuery(variables: GetProjectVersionsQueryVariables | VueCompositionApi.Ref<GetProjectVersionsQueryVariables> | ReactiveFunction<GetProjectVersionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectVersionsQuery, GetProjectVersionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectVersionsQuery, GetProjectVersionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectVersionsQuery, GetProjectVersionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectVersionsQuery, GetProjectVersionsQueryVariables>(GetProjectVersionsDocument, variables, options);
}
export function useGetProjectVersionsLazyQuery(variables?: GetProjectVersionsQueryVariables | VueCompositionApi.Ref<GetProjectVersionsQueryVariables> | ReactiveFunction<GetProjectVersionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectVersionsQuery, GetProjectVersionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectVersionsQuery, GetProjectVersionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectVersionsQuery, GetProjectVersionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectVersionsQuery, GetProjectVersionsQueryVariables>(GetProjectVersionsDocument, variables, options);
}
export type GetProjectVersionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectVersionsQuery, GetProjectVersionsQueryVariables>;
export const GetProjectWasteMappingsDocument = gql`
    query GetProjectWasteMappings($country: country_enum, $projectId: uuid!, $mappingRevisionFilter: projectWasteMapping_bool_exp = {revision: {frozenAt: {_is_null: true}}}, $customTypeRevisionFilter: projectWasteTypeCustom_bool_exp = {revision: {frozenAt: {_is_null: true}}}) {
  materialWasteSource(where: {country: {_eq: $country}}) {
    ...materialWasteSource
    materialWasteTypes(order_by: {label: asc}) {
      ...materialWasteType
    }
  }
  projectWasteMapping(
    where: {_or: [{materialWasteTypeId: {_is_null: true}}, {wasteType: {wasteSource: {country: {_eq: $country}}}}], projectId: {_eq: $projectId}, _and: [$mappingRevisionFilter]}
    order_by: [{pickupDate: desc_nulls_last}, {label: asc_nulls_last}]
  ) {
    ...projectWasteMapping
  }
  projectWasteTypeCustom(
    where: {projectId: {_eq: $projectId}, _and: [$customTypeRevisionFilter]}
    order_by: {label: asc}
  ) {
    ...projectWasteTypeCustom
  }
}
    ${MaterialWasteSourceFragmentDoc}
${MaterialWasteTypeFragmentDoc}
${ProjectWasteMappingFragmentDoc}
${ProjectWasteTypeCustomFragmentDoc}`;

/**
 * __useGetProjectWasteMappingsQuery__
 *
 * To run a query within a Vue component, call `useGetProjectWasteMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectWasteMappingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectWasteMappingsQuery({
 *   country: // value for 'country'
 *   projectId: // value for 'projectId'
 *   mappingRevisionFilter: // value for 'mappingRevisionFilter'
 *   customTypeRevisionFilter: // value for 'customTypeRevisionFilter'
 * });
 */
export function useGetProjectWasteMappingsQuery(variables: GetProjectWasteMappingsQueryVariables | VueCompositionApi.Ref<GetProjectWasteMappingsQueryVariables> | ReactiveFunction<GetProjectWasteMappingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectWasteMappingsQuery, GetProjectWasteMappingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectWasteMappingsQuery, GetProjectWasteMappingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectWasteMappingsQuery, GetProjectWasteMappingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectWasteMappingsQuery, GetProjectWasteMappingsQueryVariables>(GetProjectWasteMappingsDocument, variables, options);
}
export function useGetProjectWasteMappingsLazyQuery(variables?: GetProjectWasteMappingsQueryVariables | VueCompositionApi.Ref<GetProjectWasteMappingsQueryVariables> | ReactiveFunction<GetProjectWasteMappingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectWasteMappingsQuery, GetProjectWasteMappingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectWasteMappingsQuery, GetProjectWasteMappingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectWasteMappingsQuery, GetProjectWasteMappingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectWasteMappingsQuery, GetProjectWasteMappingsQueryVariables>(GetProjectWasteMappingsDocument, variables, options);
}
export type GetProjectWasteMappingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectWasteMappingsQuery, GetProjectWasteMappingsQueryVariables>;
export const GetRecentProjectsDocument = gql`
    query GetRecentProjects($limit: Int = 5, $tenantId: String!) {
  userProjectView(
    where: {project: {tenantId: {_eq: $tenantId}, deletedBy: {_is_null: true}}}
    order_by: {viewedAt: desc}
    limit: $limit
  ) {
    projectId
    viewedAt
    project {
      id
      name
      projectStatus {
        id
      }
    }
  }
}
    `;

/**
 * __useGetRecentProjectsQuery__
 *
 * To run a query within a Vue component, call `useGetRecentProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentProjectsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRecentProjectsQuery({
 *   limit: // value for 'limit'
 *   tenantId: // value for 'tenantId'
 * });
 */
export function useGetRecentProjectsQuery(variables: GetRecentProjectsQueryVariables | VueCompositionApi.Ref<GetRecentProjectsQueryVariables> | ReactiveFunction<GetRecentProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRecentProjectsQuery, GetRecentProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRecentProjectsQuery, GetRecentProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRecentProjectsQuery, GetRecentProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRecentProjectsQuery, GetRecentProjectsQueryVariables>(GetRecentProjectsDocument, variables, options);
}
export function useGetRecentProjectsLazyQuery(variables?: GetRecentProjectsQueryVariables | VueCompositionApi.Ref<GetRecentProjectsQueryVariables> | ReactiveFunction<GetRecentProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRecentProjectsQuery, GetRecentProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRecentProjectsQuery, GetRecentProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRecentProjectsQuery, GetRecentProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRecentProjectsQuery, GetRecentProjectsQueryVariables>(GetRecentProjectsDocument, variables, options);
}
export type GetRecentProjectsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRecentProjectsQuery, GetRecentProjectsQueryVariables>;
export const GetReferenceAreaTypesDocument = gql`
    query GetReferenceAreaTypes($calculationType: Int!) {
  referenceAreaTypeCalculationTypeMapping(
    where: {calculationType: {id: {_eq: $calculationType}}}
  ) {
    referenceAreaType {
      id
      label
      multiplier
      key
    }
  }
}
    `;

/**
 * __useGetReferenceAreaTypesQuery__
 *
 * To run a query within a Vue component, call `useGetReferenceAreaTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferenceAreaTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReferenceAreaTypesQuery({
 *   calculationType: // value for 'calculationType'
 * });
 */
export function useGetReferenceAreaTypesQuery(variables: GetReferenceAreaTypesQueryVariables | VueCompositionApi.Ref<GetReferenceAreaTypesQueryVariables> | ReactiveFunction<GetReferenceAreaTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReferenceAreaTypesQuery, GetReferenceAreaTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReferenceAreaTypesQuery, GetReferenceAreaTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReferenceAreaTypesQuery, GetReferenceAreaTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetReferenceAreaTypesQuery, GetReferenceAreaTypesQueryVariables>(GetReferenceAreaTypesDocument, variables, options);
}
export function useGetReferenceAreaTypesLazyQuery(variables?: GetReferenceAreaTypesQueryVariables | VueCompositionApi.Ref<GetReferenceAreaTypesQueryVariables> | ReactiveFunction<GetReferenceAreaTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReferenceAreaTypesQuery, GetReferenceAreaTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReferenceAreaTypesQuery, GetReferenceAreaTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReferenceAreaTypesQuery, GetReferenceAreaTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetReferenceAreaTypesQuery, GetReferenceAreaTypesQueryVariables>(GetReferenceAreaTypesDocument, variables, options);
}
export type GetReferenceAreaTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetReferenceAreaTypesQuery, GetReferenceAreaTypesQueryVariables>;
export const GetSpecialConditionTypesDocument = gql`
    query GetSpecialConditionTypes($calculationTypeId: Int!) @cached {
  specialConditionType(
    order_by: {buildingPart: {label: asc}}
    where: {specialConditionTypeCategory: {label: {_neq: "Installationer"}}, calculationTypes: {calculationTypeId: {_eq: $calculationTypeId}}}
  ) {
    ...specialConditionTypeFragment
  }
}
    ${SpecialConditionTypeFragmentFragmentDoc}`;

/**
 * __useGetSpecialConditionTypesQuery__
 *
 * To run a query within a Vue component, call `useGetSpecialConditionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialConditionTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSpecialConditionTypesQuery({
 *   calculationTypeId: // value for 'calculationTypeId'
 * });
 */
export function useGetSpecialConditionTypesQuery(variables: GetSpecialConditionTypesQueryVariables | VueCompositionApi.Ref<GetSpecialConditionTypesQueryVariables> | ReactiveFunction<GetSpecialConditionTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSpecialConditionTypesQuery, GetSpecialConditionTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSpecialConditionTypesQuery, GetSpecialConditionTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSpecialConditionTypesQuery, GetSpecialConditionTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSpecialConditionTypesQuery, GetSpecialConditionTypesQueryVariables>(GetSpecialConditionTypesDocument, variables, options);
}
export function useGetSpecialConditionTypesLazyQuery(variables?: GetSpecialConditionTypesQueryVariables | VueCompositionApi.Ref<GetSpecialConditionTypesQueryVariables> | ReactiveFunction<GetSpecialConditionTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSpecialConditionTypesQuery, GetSpecialConditionTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSpecialConditionTypesQuery, GetSpecialConditionTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSpecialConditionTypesQuery, GetSpecialConditionTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSpecialConditionTypesQuery, GetSpecialConditionTypesQueryVariables>(GetSpecialConditionTypesDocument, variables, options);
}
export type GetSpecialConditionTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSpecialConditionTypesQuery, GetSpecialConditionTypesQueryVariables>;
export const GetStageDefaultEmissionDocument = gql`
    query GetStageDefaultEmission($country: country_enum!) @cached {
  stageDefaultEmission(
    where: {country: {_eq: $country}}
    order_by: {stage: {label: asc}}
  ) {
    id
    denominatorUnit {
      unit
      id
    }
    indicatorType {
      unit
      id
    }
    stage {
      id
      label
    }
    value
    stageDefaultEmissionBuildingTypes {
      id
      buildingTypeId
    }
    countryConfig {
      useStageDefaultEmission
    }
    country
    label
  }
}
    `;

/**
 * __useGetStageDefaultEmissionQuery__
 *
 * To run a query within a Vue component, call `useGetStageDefaultEmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStageDefaultEmissionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStageDefaultEmissionQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetStageDefaultEmissionQuery(variables: GetStageDefaultEmissionQueryVariables | VueCompositionApi.Ref<GetStageDefaultEmissionQueryVariables> | ReactiveFunction<GetStageDefaultEmissionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStageDefaultEmissionQuery, GetStageDefaultEmissionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStageDefaultEmissionQuery, GetStageDefaultEmissionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStageDefaultEmissionQuery, GetStageDefaultEmissionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStageDefaultEmissionQuery, GetStageDefaultEmissionQueryVariables>(GetStageDefaultEmissionDocument, variables, options);
}
export function useGetStageDefaultEmissionLazyQuery(variables?: GetStageDefaultEmissionQueryVariables | VueCompositionApi.Ref<GetStageDefaultEmissionQueryVariables> | ReactiveFunction<GetStageDefaultEmissionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStageDefaultEmissionQuery, GetStageDefaultEmissionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStageDefaultEmissionQuery, GetStageDefaultEmissionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStageDefaultEmissionQuery, GetStageDefaultEmissionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetStageDefaultEmissionQuery, GetStageDefaultEmissionQueryVariables>(GetStageDefaultEmissionDocument, variables, options);
}
export type GetStageDefaultEmissionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStageDefaultEmissionQuery, GetStageDefaultEmissionQueryVariables>;
export const GetTenantCollectionDocument = gql`
    query GetTenantCollection {
  tenantCollection(order_by: {name: asc}) {
    id
    name
    tenantId
    collectionType
  }
}
    `;

/**
 * __useGetTenantCollectionQuery__
 *
 * To run a query within a Vue component, call `useGetTenantCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantCollectionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTenantCollectionQuery();
 */
export function useGetTenantCollectionQuery(options: VueApolloComposable.UseQueryOptions<GetTenantCollectionQuery, GetTenantCollectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTenantCollectionQuery, GetTenantCollectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTenantCollectionQuery, GetTenantCollectionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTenantCollectionQuery, GetTenantCollectionQueryVariables>(GetTenantCollectionDocument, {}, options);
}
export function useGetTenantCollectionLazyQuery(options: VueApolloComposable.UseQueryOptions<GetTenantCollectionQuery, GetTenantCollectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTenantCollectionQuery, GetTenantCollectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTenantCollectionQuery, GetTenantCollectionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTenantCollectionQuery, GetTenantCollectionQueryVariables>(GetTenantCollectionDocument, {}, options);
}
export type GetTenantCollectionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTenantCollectionQuery, GetTenantCollectionQueryVariables>;
export const GetTenantProjectsDocument = gql`
    query GetTenantProjects($tenantId: String!) {
  project(where: {tenantId: {_eq: $tenantId}, deletedAt: {_is_null: true}}) {
    id
    name
    createdAt
    updatedAt
    area
    projectStatus {
      label
    }
    buildingType {
      label
    }
    calculation {
      calculationType {
        label
      }
    }
    buildingAreas {
      area
    }
  }
}
    `;

/**
 * __useGetTenantProjectsQuery__
 *
 * To run a query within a Vue component, call `useGetTenantProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantProjectsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTenantProjectsQuery({
 *   tenantId: // value for 'tenantId'
 * });
 */
export function useGetTenantProjectsQuery(variables: GetTenantProjectsQueryVariables | VueCompositionApi.Ref<GetTenantProjectsQueryVariables> | ReactiveFunction<GetTenantProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTenantProjectsQuery, GetTenantProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTenantProjectsQuery, GetTenantProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTenantProjectsQuery, GetTenantProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTenantProjectsQuery, GetTenantProjectsQueryVariables>(GetTenantProjectsDocument, variables, options);
}
export function useGetTenantProjectsLazyQuery(variables?: GetTenantProjectsQueryVariables | VueCompositionApi.Ref<GetTenantProjectsQueryVariables> | ReactiveFunction<GetTenantProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTenantProjectsQuery, GetTenantProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTenantProjectsQuery, GetTenantProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTenantProjectsQuery, GetTenantProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTenantProjectsQuery, GetTenantProjectsQueryVariables>(GetTenantProjectsDocument, variables, options);
}
export type GetTenantProjectsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTenantProjectsQuery, GetTenantProjectsQueryVariables>;
export const GetTenantUsageByStatusDocument = gql`
    query GetTenantUsageByStatus {
  projectTenantStatusArea {
    tenantId
    projectStatus
    totalArea
  }
}
    `;

/**
 * __useGetTenantUsageByStatusQuery__
 *
 * To run a query within a Vue component, call `useGetTenantUsageByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantUsageByStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTenantUsageByStatusQuery();
 */
export function useGetTenantUsageByStatusQuery(options: VueApolloComposable.UseQueryOptions<GetTenantUsageByStatusQuery, GetTenantUsageByStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTenantUsageByStatusQuery, GetTenantUsageByStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTenantUsageByStatusQuery, GetTenantUsageByStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTenantUsageByStatusQuery, GetTenantUsageByStatusQueryVariables>(GetTenantUsageByStatusDocument, {}, options);
}
export function useGetTenantUsageByStatusLazyQuery(options: VueApolloComposable.UseQueryOptions<GetTenantUsageByStatusQuery, GetTenantUsageByStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTenantUsageByStatusQuery, GetTenantUsageByStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTenantUsageByStatusQuery, GetTenantUsageByStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTenantUsageByStatusQuery, GetTenantUsageByStatusQueryVariables>(GetTenantUsageByStatusDocument, {}, options);
}
export type GetTenantUsageByStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTenantUsageByStatusQuery, GetTenantUsageByStatusQueryVariables>;
export const GetTransportSourcesProjectInstallationDocument = gql`
    query GetTransportSourcesProjectInstallation($calculationTypeId: Int!) @cached {
  transportSource(
    where: {calculationTypes: {calculationTypeId: {_eq: $calculationTypeId}}, transportEmissionFactors: {id: {_is_null: false}}}
    order_by: {label: asc}
  ) {
    ...transportSourceFragment
  }
}
    ${TransportSourceFragmentFragmentDoc}`;

/**
 * __useGetTransportSourcesProjectInstallationQuery__
 *
 * To run a query within a Vue component, call `useGetTransportSourcesProjectInstallationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransportSourcesProjectInstallationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTransportSourcesProjectInstallationQuery({
 *   calculationTypeId: // value for 'calculationTypeId'
 * });
 */
export function useGetTransportSourcesProjectInstallationQuery(variables: GetTransportSourcesProjectInstallationQueryVariables | VueCompositionApi.Ref<GetTransportSourcesProjectInstallationQueryVariables> | ReactiveFunction<GetTransportSourcesProjectInstallationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTransportSourcesProjectInstallationQuery, GetTransportSourcesProjectInstallationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTransportSourcesProjectInstallationQuery, GetTransportSourcesProjectInstallationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTransportSourcesProjectInstallationQuery, GetTransportSourcesProjectInstallationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTransportSourcesProjectInstallationQuery, GetTransportSourcesProjectInstallationQueryVariables>(GetTransportSourcesProjectInstallationDocument, variables, options);
}
export function useGetTransportSourcesProjectInstallationLazyQuery(variables?: GetTransportSourcesProjectInstallationQueryVariables | VueCompositionApi.Ref<GetTransportSourcesProjectInstallationQueryVariables> | ReactiveFunction<GetTransportSourcesProjectInstallationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTransportSourcesProjectInstallationQuery, GetTransportSourcesProjectInstallationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTransportSourcesProjectInstallationQuery, GetTransportSourcesProjectInstallationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTransportSourcesProjectInstallationQuery, GetTransportSourcesProjectInstallationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTransportSourcesProjectInstallationQuery, GetTransportSourcesProjectInstallationQueryVariables>(GetTransportSourcesProjectInstallationDocument, variables, options);
}
export type GetTransportSourcesProjectInstallationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTransportSourcesProjectInstallationQuery, GetTransportSourcesProjectInstallationQueryVariables>;
export const GetTransportSourcesDocument = gql`
    query GetTransportSources($calculationTypeId: Int!) @cached {
  transportSource(
    where: {calculationTypes: {calculationTypeId: {_eq: $calculationTypeId}}}
    order_by: {label: asc}
  ) {
    ...transportSourceFragment
  }
}
    ${TransportSourceFragmentFragmentDoc}`;

/**
 * __useGetTransportSourcesQuery__
 *
 * To run a query within a Vue component, call `useGetTransportSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransportSourcesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTransportSourcesQuery({
 *   calculationTypeId: // value for 'calculationTypeId'
 * });
 */
export function useGetTransportSourcesQuery(variables: GetTransportSourcesQueryVariables | VueCompositionApi.Ref<GetTransportSourcesQueryVariables> | ReactiveFunction<GetTransportSourcesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTransportSourcesQuery, GetTransportSourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTransportSourcesQuery, GetTransportSourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTransportSourcesQuery, GetTransportSourcesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTransportSourcesQuery, GetTransportSourcesQueryVariables>(GetTransportSourcesDocument, variables, options);
}
export function useGetTransportSourcesLazyQuery(variables?: GetTransportSourcesQueryVariables | VueCompositionApi.Ref<GetTransportSourcesQueryVariables> | ReactiveFunction<GetTransportSourcesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTransportSourcesQuery, GetTransportSourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTransportSourcesQuery, GetTransportSourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTransportSourcesQuery, GetTransportSourcesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTransportSourcesQuery, GetTransportSourcesQueryVariables>(GetTransportSourcesDocument, variables, options);
}
export type GetTransportSourcesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTransportSourcesQuery, GetTransportSourcesQueryVariables>;
export const GetTransportTypeOptionsDocument = gql`
    query GetTransportTypeOptions($country: country_enum!) @cached {
  transport(where: {country: {_eq: $country}}, order_by: {label: asc}) {
    id
    isDefault
    label
    country
    datasource
    denominatorUnit {
      id
      label
      unit
    }
    distance
    distance_unit
    emission
    indicatorType {
      id
      identifier
      label
      unit
    }
    totalDenominatorUnit {
      id
      label
      unit
    }
    totalIndicatorType {
      id
      identifier
      label
      unit
    }
    transportType
  }
}
    `;

/**
 * __useGetTransportTypeOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetTransportTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransportTypeOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTransportTypeOptionsQuery({
 *   country: // value for 'country'
 * });
 */
export function useGetTransportTypeOptionsQuery(variables: GetTransportTypeOptionsQueryVariables | VueCompositionApi.Ref<GetTransportTypeOptionsQueryVariables> | ReactiveFunction<GetTransportTypeOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTransportTypeOptionsQuery, GetTransportTypeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTransportTypeOptionsQuery, GetTransportTypeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTransportTypeOptionsQuery, GetTransportTypeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTransportTypeOptionsQuery, GetTransportTypeOptionsQueryVariables>(GetTransportTypeOptionsDocument, variables, options);
}
export function useGetTransportTypeOptionsLazyQuery(variables?: GetTransportTypeOptionsQueryVariables | VueCompositionApi.Ref<GetTransportTypeOptionsQueryVariables> | ReactiveFunction<GetTransportTypeOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTransportTypeOptionsQuery, GetTransportTypeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTransportTypeOptionsQuery, GetTransportTypeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTransportTypeOptionsQuery, GetTransportTypeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTransportTypeOptionsQuery, GetTransportTypeOptionsQueryVariables>(GetTransportTypeOptionsDocument, variables, options);
}
export type GetTransportTypeOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTransportTypeOptionsQuery, GetTransportTypeOptionsQueryVariables>;
export const GetUnitsDocument = gql`
    query GetUnits @cached {
  unit {
    fullName
    id
    label
    pluralFullName
  }
}
    `;

/**
 * __useGetUnitsQuery__
 *
 * To run a query within a Vue component, call `useGetUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUnitsQuery();
 */
export function useGetUnitsQuery(options: VueApolloComposable.UseQueryOptions<GetUnitsQuery, GetUnitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUnitsQuery, GetUnitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUnitsQuery, GetUnitsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, {}, options);
}
export function useGetUnitsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetUnitsQuery, GetUnitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUnitsQuery, GetUnitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUnitsQuery, GetUnitsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, {}, options);
}
export type GetUnitsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUnitsQuery, GetUnitsQueryVariables>;
export const GetUserTutorialViewDocument = gql`
    query GetUserTutorialView {
  userTutorialView {
    externalId
    userId
    viewedAt
  }
}
    `;

/**
 * __useGetUserTutorialViewQuery__
 *
 * To run a query within a Vue component, call `useGetUserTutorialViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTutorialViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserTutorialViewQuery();
 */
export function useGetUserTutorialViewQuery(options: VueApolloComposable.UseQueryOptions<GetUserTutorialViewQuery, GetUserTutorialViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserTutorialViewQuery, GetUserTutorialViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserTutorialViewQuery, GetUserTutorialViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserTutorialViewQuery, GetUserTutorialViewQueryVariables>(GetUserTutorialViewDocument, {}, options);
}
export function useGetUserTutorialViewLazyQuery(options: VueApolloComposable.UseQueryOptions<GetUserTutorialViewQuery, GetUserTutorialViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserTutorialViewQuery, GetUserTutorialViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserTutorialViewQuery, GetUserTutorialViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserTutorialViewQuery, GetUserTutorialViewQueryVariables>(GetUserTutorialViewDocument, {}, options);
}
export type GetUserTutorialViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserTutorialViewQuery, GetUserTutorialViewQueryVariables>;
export const GetUserWelcomeFlowDocument = gql`
    query GetUserWelcomeFlow($flowKey: String!) {
  userWelcomeFlow(where: {flowKey: {_eq: $flowKey}}) {
    userId
    flowKey
    variant
    seenAt
    completedAt
  }
}
    `;

/**
 * __useGetUserWelcomeFlowQuery__
 *
 * To run a query within a Vue component, call `useGetUserWelcomeFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWelcomeFlowQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserWelcomeFlowQuery({
 *   flowKey: // value for 'flowKey'
 * });
 */
export function useGetUserWelcomeFlowQuery(variables: GetUserWelcomeFlowQueryVariables | VueCompositionApi.Ref<GetUserWelcomeFlowQueryVariables> | ReactiveFunction<GetUserWelcomeFlowQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowQuery, GetUserWelcomeFlowQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowQuery, GetUserWelcomeFlowQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowQuery, GetUserWelcomeFlowQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserWelcomeFlowQuery, GetUserWelcomeFlowQueryVariables>(GetUserWelcomeFlowDocument, variables, options);
}
export function useGetUserWelcomeFlowLazyQuery(variables?: GetUserWelcomeFlowQueryVariables | VueCompositionApi.Ref<GetUserWelcomeFlowQueryVariables> | ReactiveFunction<GetUserWelcomeFlowQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowQuery, GetUserWelcomeFlowQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowQuery, GetUserWelcomeFlowQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowQuery, GetUserWelcomeFlowQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserWelcomeFlowQuery, GetUserWelcomeFlowQueryVariables>(GetUserWelcomeFlowDocument, variables, options);
}
export type GetUserWelcomeFlowQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserWelcomeFlowQuery, GetUserWelcomeFlowQueryVariables>;
export const GetUserWelcomeFlowRowsDocument = gql`
    query GetUserWelcomeFlowRows($flowKeys: [String!]!) {
  userWelcomeFlow(where: {flowKey: {_in: $flowKeys}}) {
    userId
    flowKey
    variant
    seenAt
    completedAt
  }
}
    `;

/**
 * __useGetUserWelcomeFlowRowsQuery__
 *
 * To run a query within a Vue component, call `useGetUserWelcomeFlowRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWelcomeFlowRowsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserWelcomeFlowRowsQuery({
 *   flowKeys: // value for 'flowKeys'
 * });
 */
export function useGetUserWelcomeFlowRowsQuery(variables: GetUserWelcomeFlowRowsQueryVariables | VueCompositionApi.Ref<GetUserWelcomeFlowRowsQueryVariables> | ReactiveFunction<GetUserWelcomeFlowRowsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowRowsQuery, GetUserWelcomeFlowRowsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowRowsQuery, GetUserWelcomeFlowRowsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowRowsQuery, GetUserWelcomeFlowRowsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserWelcomeFlowRowsQuery, GetUserWelcomeFlowRowsQueryVariables>(GetUserWelcomeFlowRowsDocument, variables, options);
}
export function useGetUserWelcomeFlowRowsLazyQuery(variables?: GetUserWelcomeFlowRowsQueryVariables | VueCompositionApi.Ref<GetUserWelcomeFlowRowsQueryVariables> | ReactiveFunction<GetUserWelcomeFlowRowsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowRowsQuery, GetUserWelcomeFlowRowsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowRowsQuery, GetUserWelcomeFlowRowsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserWelcomeFlowRowsQuery, GetUserWelcomeFlowRowsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserWelcomeFlowRowsQuery, GetUserWelcomeFlowRowsQueryVariables>(GetUserWelcomeFlowRowsDocument, variables, options);
}
export type GetUserWelcomeFlowRowsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserWelcomeFlowRowsQuery, GetUserWelcomeFlowRowsQueryVariables>;
export const GetProjectModelsDocument = gql`
    subscription GetProjectModels($projectId: uuid!) {
  projectModel(
    where: {projectId: {_eq: $projectId}, revision: {frozenAt: {_is_null: true}}}
    order_by: {name: asc}
  ) {
    id
    name
    active
    commitId
    pulledAt
    referencedObjectId
    speckleModelId
  }
}
    `;

/**
 * __useGetProjectModelsSubscription__
 *
 * To run a query within a Vue component, call `useGetProjectModelsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectModelsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectModelsSubscription({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectModelsSubscription(variables: GetProjectModelsSubscriptionVariables | VueCompositionApi.Ref<GetProjectModelsSubscriptionVariables> | ReactiveFunction<GetProjectModelsSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<GetProjectModelsSubscription, GetProjectModelsSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<GetProjectModelsSubscription, GetProjectModelsSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<GetProjectModelsSubscription, GetProjectModelsSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<GetProjectModelsSubscription, GetProjectModelsSubscriptionVariables>(GetProjectModelsDocument, variables, options);
}
export type GetProjectModelsSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<GetProjectModelsSubscription, GetProjectModelsSubscriptionVariables>;
export const GetProjectSpeckleCopyDocument = gql`
    subscription GetProjectSpeckleCopy {
  projectSpeckleCopyRecent {
    projectId
    state
    errorMessage
    project {
      name
    }
  }
}
    `;

/**
 * __useGetProjectSpeckleCopySubscription__
 *
 * To run a query within a Vue component, call `useGetProjectSpeckleCopySubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSpeckleCopySubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectSpeckleCopySubscription();
 */
export function useGetProjectSpeckleCopySubscription(options: VueApolloComposable.UseSubscriptionOptions<GetProjectSpeckleCopySubscription, GetProjectSpeckleCopySubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<GetProjectSpeckleCopySubscription, GetProjectSpeckleCopySubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<GetProjectSpeckleCopySubscription, GetProjectSpeckleCopySubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<GetProjectSpeckleCopySubscription, GetProjectSpeckleCopySubscriptionVariables>(GetProjectSpeckleCopyDocument, {}, options);
}
export type GetProjectSpeckleCopySubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<GetProjectSpeckleCopySubscription, GetProjectSpeckleCopySubscriptionVariables>;
export const GetProjectSpeckleModelSyncDocument = gql`
    subscription GetProjectSpeckleModelSync($projectId: uuid!) {
  projectSpeckleModelSyncRecent(where: {projectId: {_eq: $projectId}}) {
    projectId
    state
    attempts
    errorMessage
    requestedAt
    lastUpdated
  }
}
    `;

/**
 * __useGetProjectSpeckleModelSyncSubscription__
 *
 * To run a query within a Vue component, call `useGetProjectSpeckleModelSyncSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSpeckleModelSyncSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectSpeckleModelSyncSubscription({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectSpeckleModelSyncSubscription(variables: GetProjectSpeckleModelSyncSubscriptionVariables | VueCompositionApi.Ref<GetProjectSpeckleModelSyncSubscriptionVariables> | ReactiveFunction<GetProjectSpeckleModelSyncSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<GetProjectSpeckleModelSyncSubscription, GetProjectSpeckleModelSyncSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<GetProjectSpeckleModelSyncSubscription, GetProjectSpeckleModelSyncSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<GetProjectSpeckleModelSyncSubscription, GetProjectSpeckleModelSyncSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<GetProjectSpeckleModelSyncSubscription, GetProjectSpeckleModelSyncSubscriptionVariables>(GetProjectSpeckleModelSyncDocument, variables, options);
}
export type GetProjectSpeckleModelSyncSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<GetProjectSpeckleModelSyncSubscription, GetProjectSpeckleModelSyncSubscriptionVariables>;
export const GetSpeckleStreamModelIfcUploadDocument = gql`
    subscription GetSpeckleStreamModelIfcUpload($speckleProjectId: String!) {
  speckleStreamModelIfcUploadRecent(
    where: {speckleProjectId: {_eq: $speckleProjectId}}
  ) {
    speckleProjectId
    errorMessage
  }
}
    `;

/**
 * __useGetSpeckleStreamModelIfcUploadSubscription__
 *
 * To run a query within a Vue component, call `useGetSpeckleStreamModelIfcUploadSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeckleStreamModelIfcUploadSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSpeckleStreamModelIfcUploadSubscription({
 *   speckleProjectId: // value for 'speckleProjectId'
 * });
 */
export function useGetSpeckleStreamModelIfcUploadSubscription(variables: GetSpeckleStreamModelIfcUploadSubscriptionVariables | VueCompositionApi.Ref<GetSpeckleStreamModelIfcUploadSubscriptionVariables> | ReactiveFunction<GetSpeckleStreamModelIfcUploadSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<GetSpeckleStreamModelIfcUploadSubscription, GetSpeckleStreamModelIfcUploadSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<GetSpeckleStreamModelIfcUploadSubscription, GetSpeckleStreamModelIfcUploadSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<GetSpeckleStreamModelIfcUploadSubscription, GetSpeckleStreamModelIfcUploadSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<GetSpeckleStreamModelIfcUploadSubscription, GetSpeckleStreamModelIfcUploadSubscriptionVariables>(GetSpeckleStreamModelIfcUploadDocument, variables, options);
}
export type GetSpeckleStreamModelIfcUploadSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<GetSpeckleStreamModelIfcUploadSubscription, GetSpeckleStreamModelIfcUploadSubscriptionVariables>;
export const ProjectActiveRevisionDocument = gql`
    subscription ProjectActiveRevision($projectId: uuid!) {
  project_by_pk(id: $projectId) {
    id
    activeRevisionId
    activeRevision {
      id
      name
    }
  }
}
    `;

/**
 * __useProjectActiveRevisionSubscription__
 *
 * To run a query within a Vue component, call `useProjectActiveRevisionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectActiveRevisionSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectActiveRevisionSubscription({
 *   projectId: // value for 'projectId'
 * });
 */
export function useProjectActiveRevisionSubscription(variables: ProjectActiveRevisionSubscriptionVariables | VueCompositionApi.Ref<ProjectActiveRevisionSubscriptionVariables> | ReactiveFunction<ProjectActiveRevisionSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<ProjectActiveRevisionSubscription, ProjectActiveRevisionSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<ProjectActiveRevisionSubscription, ProjectActiveRevisionSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<ProjectActiveRevisionSubscription, ProjectActiveRevisionSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<ProjectActiveRevisionSubscription, ProjectActiveRevisionSubscriptionVariables>(ProjectActiveRevisionDocument, variables, options);
}
export type ProjectActiveRevisionSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<ProjectActiveRevisionSubscription, ProjectActiveRevisionSubscriptionVariables>;
export const ProjectListUpdatedDocument = gql`
    subscription ProjectListUpdated($where: project_bool_exp) {
  project(limit: 1, order_by: [{updatedAt: desc_nulls_last}], where: $where) {
    tenantId
    ...projectList
  }
}
    ${ProjectListFragmentDoc}`;

/**
 * __useProjectListUpdatedSubscription__
 *
 * To run a query within a Vue component, call `useProjectListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectListUpdatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectListUpdatedSubscription({
 *   where: // value for 'where'
 * });
 */
export function useProjectListUpdatedSubscription(variables: ProjectListUpdatedSubscriptionVariables | VueCompositionApi.Ref<ProjectListUpdatedSubscriptionVariables> | ReactiveFunction<ProjectListUpdatedSubscriptionVariables> = {}, options: VueApolloComposable.UseSubscriptionOptions<ProjectListUpdatedSubscription, ProjectListUpdatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<ProjectListUpdatedSubscription, ProjectListUpdatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<ProjectListUpdatedSubscription, ProjectListUpdatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<ProjectListUpdatedSubscription, ProjectListUpdatedSubscriptionVariables>(ProjectListUpdatedDocument, variables, options);
}
export type ProjectListUpdatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<ProjectListUpdatedSubscription, ProjectListUpdatedSubscriptionVariables>;